var ID = Object.defineProperty;
var qD = (e, t, n) => t in e ? ID(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ut = (e, t, n) => qD(e, typeof t != "symbol" ? t + "" : t, n);
import { ref as Sr, readonly as DD, computed as Ye, unref as Nt, watch as In, shallowRef as di, createElementBlock as vt, openBlock as Re, defineComponent as xr, normalizeClass as Bn, toDisplayString as pn, inject as Qa, createElementVNode as Gt, withModifiers as $f, createBlock as Bt, createCommentVNode as Kt, resolveDynamicComponent as An, normalizeStyle as $n, withCtx as _r, createVNode as Br, createTextVNode as Rn, Transition as Wd, withDirectives as rs, Fragment as Wn, renderList as hi, vShow as yf, nextTick as sc, onMounted as R0, toValue as Zn, shallowReadonly as pu, getCurrentScope as lC, onScopeDispose as fC, isRef as bf, getCurrentInstance as f2, hasInjectionContext as pC, reactive as Kd, watchEffect as LD, toRaw as ND, provide as Oa, renderSlot as Fn, h as dC, vModelText as p2, createSlots as hC, useAttrs as j0, onBeforeUnmount as $D, mergeProps as Li, mergeModels as Xa, useModel as bc, toHandlers as MD, useTemplateRef as Dy, resolveComponent as FD, toRefs as BD, setBlockTracking as Ly, withKeys as Ny, normalizeProps as I0, guardReactiveProps as UD, vModelSelect as HD, onBeforeMount as mC, useCssVars as zD, onUnmounted as GD, Teleport as VD, defineCustomElement as Wp } from "vue";
var $y;
(function(e) {
  e.None = "none", e.Declared = "declared", e.InheritedFromService = "inheritedFromService";
})($y || ($y = {}));
var My;
(function(e) {
  e.Unspecified = "unspecified", e.Simple = "simple", e.Matrix = "matrix", e.Label = "label", e.Form = "form", e.CommaDelimited = "commaDelimited", e.SpaceDelimited = "spaceDelimited", e.PipeDelimited = "pipeDelimited", e.DeepObject = "deepObject", e.TabDelimited = "tabDelimited";
})(My || (My = {}));
var Fy;
(function(e) {
  e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Information = 2] = "Information", e[e.Hint = 3] = "Hint";
})(Fy || (Fy = {}));
var ji;
(function(e) {
  e.Article = "article", e.HttpService = "http_service", e.HttpServer = "http_server", e.HttpOperation = "http_operation", e.HttpCallback = "http_callback", e.HttpWebhook = "http_webhook", e.Model = "model", e.Generic = "generic", e.Unknown = "unknown", e.TableOfContents = "table_of_contents", e.SpectralRuleset = "spectral_ruleset", e.Styleguide = "styleguide", e.Image = "image", e.StoplightResolutions = "stoplight_resolutions", e.StoplightOverride = "stoplight_override";
})(ji || (ji = {}));
var By;
(function(e) {
  e.Json = "json", e.Markdown = "markdown", e.Yaml = "yaml", e.Javascript = "javascript", e.Apng = "apng", e.Avif = "avif", e.Bmp = "bmp", e.Gif = "gif", e.Jpeg = "jpeg", e.Png = "png", e.Svg = "svg", e.Webp = "webp";
})(By || (By = {}));
const Kp = globalThis || void 0 || self;
var gC = typeof Kp == "object" && Kp && Kp.Object === Object && Kp, WD = typeof self == "object" && self && self.Object === Object && self, qa = gC || WD || Function("return this")(), uc = qa.Symbol, vC = Object.prototype, KD = vC.hasOwnProperty, ZD = vC.toString, Kc = uc ? uc.toStringTag : void 0;
function YD(e) {
  var t = KD.call(e, Kc), n = e[Kc];
  try {
    e[Kc] = void 0;
    var r = !0;
  } catch {
  }
  var i = ZD.call(e);
  return r && (t ? e[Kc] = n : delete e[Kc]), i;
}
var JD = Object.prototype, QD = JD.toString;
function XD(e) {
  return QD.call(e);
}
var eL = "[object Null]", tL = "[object Undefined]", Uy = uc ? uc.toStringTag : void 0;
function xc(e) {
  return e == null ? e === void 0 ? tL : eL : Uy && Uy in Object(e) ? YD(e) : XD(e);
}
function Mf(e) {
  return e != null && typeof e == "object";
}
var rL = "[object Symbol]";
function q0(e) {
  return typeof e == "symbol" || Mf(e) && xc(e) == rL;
}
function yC(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Ff = Array.isArray, Hy = uc ? uc.prototype : void 0, zy = Hy ? Hy.toString : void 0;
function bC(e) {
  if (typeof e == "string")
    return e;
  if (Ff(e))
    return yC(e, bC) + "";
  if (q0(e))
    return zy ? zy.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var nL = /\s/;
function iL(e) {
  for (var t = e.length; t-- && nL.test(e.charAt(t)); )
    ;
  return t;
}
var aL = /^\s+/;
function oL(e) {
  return e && e.slice(0, iL(e) + 1).replace(aL, "");
}
function ea(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Gy = NaN, sL = /^[-+]0x[0-9a-f]+$/i, uL = /^0b[01]+$/i, cL = /^0o[0-7]+$/i, lL = parseInt;
function fL(e) {
  if (typeof e == "number")
    return e;
  if (q0(e))
    return Gy;
  if (ea(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ea(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = oL(e);
  var n = uL.test(e);
  return n || cL.test(e) ? lL(e.slice(2), n ? 2 : 8) : sL.test(e) ? Gy : +e;
}
var pL = 1 / 0, dL = 17976931348623157e292;
function hL(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = fL(e), e === pL || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * dL;
  }
  return e === e ? e : 0;
}
function Vy(e) {
  var t = hL(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function xC(e) {
  return e;
}
var mL = "[object AsyncFunction]", gL = "[object Function]", vL = "[object GeneratorFunction]", yL = "[object Proxy]";
function _C(e) {
  if (!ea(e))
    return !1;
  var t = xc(e);
  return t == gL || t == vL || t == mL || t == yL;
}
var bh = qa["__core-js_shared__"], Wy = function() {
  var e = /[^.]+$/.exec(bh && bh.keys && bh.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function bL(e) {
  return !!Wy && Wy in e;
}
var xL = Function.prototype, _L = xL.toString;
function Cu(e) {
  if (e != null) {
    try {
      return _L.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var wL = /[\\^$.*+?()[\]{}|]/g, SL = /^\[object .+?Constructor\]$/, CL = Function.prototype, AL = Object.prototype, kL = CL.toString, EL = AL.hasOwnProperty, OL = RegExp(
  "^" + kL.call(EL).replace(wL, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function TL(e) {
  if (!ea(e) || bL(e))
    return !1;
  var t = _C(e) ? OL : SL;
  return t.test(Cu(e));
}
function PL(e, t) {
  return e == null ? void 0 : e[t];
}
function Au(e, t) {
  var n = PL(e, t);
  return TL(n) ? n : void 0;
}
var xf = Au(qa, "WeakMap"), Zd = xf && new xf(), wC = Zd ? function(e, t) {
  return Zd.set(e, t), e;
} : xC, Ky = Object.create, d2 = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!ea(t))
      return {};
    if (Ky)
      return Ky(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function _f(e) {
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
      case 5:
        return new e(t[0], t[1], t[2], t[3], t[4]);
      case 6:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
      case 7:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
    }
    var n = d2(e.prototype), r = e.apply(n, t);
    return ea(r) ? r : n;
  };
}
var RL = 1;
function jL(e, t, n) {
  var r = t & RL, i = _f(e);
  function a() {
    var o = this && this !== qa && this instanceof a ? i : e;
    return o.apply(r ? n : this, arguments);
  }
  return a;
}
function SC(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var IL = Math.max;
function CC(e, t, n, r) {
  for (var i = -1, a = e.length, o = n.length, c = -1, u = t.length, s = IL(a - o, 0), f = Array(u + s), d = !r; ++c < u; )
    f[c] = t[c];
  for (; ++i < o; )
    (d || i < a) && (f[n[i]] = e[i]);
  for (; s--; )
    f[c++] = e[i++];
  return f;
}
var qL = Math.max;
function AC(e, t, n, r) {
  for (var i = -1, a = e.length, o = -1, c = n.length, u = -1, s = t.length, f = qL(a - c, 0), d = Array(f + s), l = !r; ++i < f; )
    d[i] = e[i];
  for (var p = i; ++u < s; )
    d[p + u] = t[u];
  for (; ++o < c; )
    (l || i < a) && (d[p + n[o]] = e[i++]);
  return d;
}
function DL(e, t) {
  for (var n = e.length, r = 0; n--; )
    e[n] === t && ++r;
  return r;
}
function h2() {
}
var LL = 4294967295;
function cc(e) {
  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = LL, this.__views__ = [];
}
cc.prototype = d2(h2.prototype);
cc.prototype.constructor = cc;
function NL() {
}
var kC = Zd ? function(e) {
  return Zd.get(e);
} : NL, Zy = {}, $L = Object.prototype, ML = $L.hasOwnProperty;
function FL(e) {
  for (var t = e.name + "", n = Zy[t], r = ML.call(Zy, t) ? n.length : 0; r--; ) {
    var i = n[r], a = i.func;
    if (a == null || a == e)
      return i.name;
  }
  return t;
}
function lc(e, t) {
  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
lc.prototype = d2(h2.prototype);
lc.prototype.constructor = lc;
function EC(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
function BL(e) {
  if (e instanceof cc)
    return e.clone();
  var t = new lc(e.__wrapped__, e.__chain__);
  return t.__actions__ = EC(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
var UL = Object.prototype, HL = UL.hasOwnProperty;
function Yd(e) {
  if (Mf(e) && !Ff(e) && !(e instanceof cc)) {
    if (e instanceof lc)
      return e;
    if (HL.call(e, "__wrapped__"))
      return BL(e);
  }
  return new lc(e);
}
Yd.prototype = h2.prototype;
Yd.prototype.constructor = Yd;
function zL(e) {
  var t = FL(e), n = Yd[t];
  if (typeof n != "function" || !(t in cc.prototype))
    return !1;
  if (e === n)
    return !0;
  var r = kC(n);
  return !!r && e === r[0];
}
var GL = 800, VL = 16, WL = Date.now;
function OC(e) {
  var t = 0, n = 0;
  return function() {
    var r = WL(), i = VL - (r - n);
    if (n = r, i > 0) {
      if (++t >= GL)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var TC = OC(wC), KL = /\{\n\/\* \[wrapped with (.+)\] \*/, ZL = /,? & /;
function YL(e) {
  var t = e.match(KL);
  return t ? t[1].split(ZL) : [];
}
var JL = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function QL(e, t) {
  var n = t.length;
  if (!n)
    return e;
  var r = n - 1;
  return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(JL, `{
/* [wrapped with ` + t + `] */
`);
}
function XL(e) {
  return function() {
    return e;
  };
}
var Yy = function() {
  try {
    var e = Au(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), eN = Yy ? function(e, t) {
  return Yy(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: XL(t),
    writable: !0
  });
} : xC, tN = OC(eN);
function rN(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function nN(e, t, n, r) {
  for (var i = e.length, a = n + -1; ++a < i; )
    if (t(e[a], a, e))
      return a;
  return -1;
}
function iN(e) {
  return e !== e;
}
function aN(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
function oN(e, t, n) {
  return t === t ? aN(e, t, n) : nN(e, iN, n);
}
function sN(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && oN(e, t, 0) > -1;
}
var uN = 1, cN = 2, lN = 8, fN = 16, pN = 32, dN = 64, hN = 128, mN = 256, gN = 512, vN = [
  ["ary", hN],
  ["bind", uN],
  ["bindKey", cN],
  ["curry", lN],
  ["curryRight", fN],
  ["flip", gN],
  ["partial", pN],
  ["partialRight", dN],
  ["rearg", mN]
];
function yN(e, t) {
  return rN(vN, function(n) {
    var r = "_." + n[0];
    t & n[1] && !sN(e, r) && e.push(r);
  }), e.sort();
}
function PC(e, t, n) {
  var r = t + "";
  return tN(e, QL(r, yN(YL(r), n)));
}
var bN = 4, xN = 8, Jy = 32, Qy = 64;
function RC(e, t, n, r, i, a, o, c, u, s) {
  var f = t & xN, d = f ? o : void 0, l = f ? void 0 : o, p = f ? a : void 0, g = f ? void 0 : a;
  t |= f ? Jy : Qy, t &= ~(f ? Qy : Jy), t & bN || (t &= -4);
  var v = [
    e,
    t,
    i,
    p,
    d,
    g,
    l,
    c,
    u,
    s
  ], b = n.apply(void 0, v);
  return zL(e) && TC(b, v), b.placeholder = r, PC(b, e, t);
}
function jC(e) {
  var t = e;
  return t.placeholder;
}
var _N = 9007199254740991, wN = /^(?:0|[1-9]\d*)$/;
function IC(e, t) {
  var n = typeof e;
  return t = t ?? _N, !!t && (n == "number" || n != "symbol" && wN.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var SN = Math.min;
function CN(e, t) {
  for (var n = e.length, r = SN(t.length, n), i = EC(e); r--; ) {
    var a = t[r];
    e[r] = IC(a, n) ? i[a] : void 0;
  }
  return e;
}
var Xy = "__lodash_placeholder__";
function Jd(e, t) {
  for (var n = -1, r = e.length, i = 0, a = []; ++n < r; ) {
    var o = e[n];
    (o === t || o === Xy) && (e[n] = Xy, a[i++] = n);
  }
  return a;
}
var AN = 1, kN = 2, EN = 8, ON = 16, TN = 128, PN = 512;
function m2(e, t, n, r, i, a, o, c, u, s) {
  var f = t & TN, d = t & AN, l = t & kN, p = t & (EN | ON), g = t & PN, v = l ? void 0 : _f(e);
  function b() {
    for (var y = arguments.length, w = Array(y), C = y; C--; )
      w[C] = arguments[C];
    if (p)
      var T = jC(b), E = DL(w, T);
    if (r && (w = CC(w, r, i, p)), a && (w = AC(w, a, o, p)), y -= E, p && y < s) {
      var D = Jd(w, T);
      return RC(
        e,
        t,
        m2,
        b.placeholder,
        n,
        w,
        D,
        c,
        u,
        s - y
      );
    }
    var $ = d ? n : this, Z = l ? $[e] : e;
    return y = w.length, c ? w = CN(w, c) : g && y > 1 && w.reverse(), f && u < y && (w.length = u), this && this !== qa && this instanceof b && (Z = v || _f(Z)), Z.apply($, w);
  }
  return b;
}
function RN(e, t, n) {
  var r = _f(e);
  function i() {
    for (var a = arguments.length, o = Array(a), c = a, u = jC(i); c--; )
      o[c] = arguments[c];
    var s = a < 3 && o[0] !== u && o[a - 1] !== u ? [] : Jd(o, u);
    if (a -= s.length, a < n)
      return RC(
        e,
        t,
        m2,
        i.placeholder,
        void 0,
        o,
        s,
        void 0,
        void 0,
        n - a
      );
    var f = this && this !== qa && this instanceof i ? r : e;
    return SC(f, this, o);
  }
  return i;
}
var jN = 1;
function IN(e, t, n, r) {
  var i = t & jN, a = _f(e);
  function o() {
    for (var c = -1, u = arguments.length, s = -1, f = r.length, d = Array(f + u), l = this && this !== qa && this instanceof o ? a : e; ++s < f; )
      d[s] = r[s];
    for (; u--; )
      d[s++] = arguments[++c];
    return SC(l, i ? n : this, d);
  }
  return o;
}
var eb = "__lodash_placeholder__", xh = 1, qN = 2, DN = 4, tb = 8, Zc = 128, rb = 256, LN = Math.min;
function NN(e, t) {
  var n = e[1], r = t[1], i = n | r, a = i < (xh | qN | Zc), o = r == Zc && n == tb || r == Zc && n == rb && e[7].length <= t[8] || r == (Zc | rb) && t[7].length <= t[8] && n == tb;
  if (!(a || o))
    return e;
  r & xh && (e[2] = t[2], i |= n & xh ? 0 : DN);
  var c = t[3];
  if (c) {
    var u = e[3];
    e[3] = u ? CC(u, c, t[4]) : c, e[4] = u ? Jd(e[3], eb) : t[4];
  }
  return c = t[5], c && (u = e[5], e[5] = u ? AC(u, c, t[6]) : c, e[6] = u ? Jd(e[5], eb) : t[6]), c = t[7], c && (e[7] = c), r & Zc && (e[8] = e[8] == null ? t[8] : LN(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = i, e;
}
var $N = "Expected a function", nb = 1, MN = 2, ib = 8, ab = 16, ob = 32, FN = 64, sb = Math.max;
function BN(e, t, n, r, i, a, o, c) {
  var u = t & MN;
  if (!u && typeof e != "function")
    throw new TypeError($N);
  var s = r ? r.length : 0;
  if (s || (t &= -97, r = i = void 0), o = o === void 0 ? o : sb(Vy(o), 0), c = c === void 0 ? c : Vy(c), s -= i ? i.length : 0, t & FN) {
    var f = r, d = i;
    r = i = void 0;
  }
  var l = u ? void 0 : kC(e), p = [
    e,
    t,
    n,
    r,
    i,
    f,
    d,
    a,
    o,
    c
  ];
  if (l && NN(p, l), e = p[0], t = p[1], n = p[2], r = p[3], i = p[4], c = p[9] = p[9] === void 0 ? u ? 0 : e.length : sb(p[9] - s, 0), !c && t & (ib | ab) && (t &= -25), !t || t == nb)
    var g = jL(e, t, n);
  else t == ib || t == ab ? g = RN(e, t, c) : (t == ob || t == (nb | ob)) && !i.length ? g = IN(e, t, n, r) : g = m2.apply(void 0, p);
  var v = l ? wC : TC;
  return PC(v(g, p), e, t);
}
function UN(e, t) {
  return e === t || e !== e && t !== t;
}
var HN = 9007199254740991;
function qC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= HN;
}
function zN(e) {
  return e != null && qC(e.length) && !_C(e);
}
var GN = Object.prototype;
function VN(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || GN;
  return e === n;
}
function WN(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var KN = "[object Arguments]";
function ub(e) {
  return Mf(e) && xc(e) == KN;
}
var DC = Object.prototype, ZN = DC.hasOwnProperty, YN = DC.propertyIsEnumerable, JN = ub(/* @__PURE__ */ function() {
  return arguments;
}()) ? ub : function(e) {
  return Mf(e) && ZN.call(e, "callee") && !YN.call(e, "callee");
}, Ya = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function g2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Bf(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
function QN() {
  return !1;
}
var LC = typeof exports == "object" && exports && !exports.nodeType && exports, cb = LC && typeof module == "object" && module && !module.nodeType && module, XN = cb && cb.exports === LC, lb = XN ? qa.Buffer : void 0, e$ = lb ? lb.isBuffer : void 0, t$ = e$ || QN, r$ = "[object Arguments]", n$ = "[object Array]", i$ = "[object Boolean]", a$ = "[object Date]", o$ = "[object Error]", s$ = "[object Function]", u$ = "[object Map]", c$ = "[object Number]", l$ = "[object Object]", f$ = "[object RegExp]", p$ = "[object Set]", d$ = "[object String]", h$ = "[object WeakMap]", m$ = "[object ArrayBuffer]", g$ = "[object DataView]", v$ = "[object Float32Array]", y$ = "[object Float64Array]", b$ = "[object Int8Array]", x$ = "[object Int16Array]", _$ = "[object Int32Array]", w$ = "[object Uint8Array]", S$ = "[object Uint8ClampedArray]", C$ = "[object Uint16Array]", A$ = "[object Uint32Array]", Kn = {};
Kn[v$] = Kn[y$] = Kn[b$] = Kn[x$] = Kn[_$] = Kn[w$] = Kn[S$] = Kn[C$] = Kn[A$] = !0;
Kn[r$] = Kn[n$] = Kn[m$] = Kn[i$] = Kn[g$] = Kn[a$] = Kn[o$] = Kn[s$] = Kn[u$] = Kn[c$] = Kn[l$] = Kn[f$] = Kn[p$] = Kn[d$] = Kn[h$] = !1;
function k$(e) {
  return Mf(e) && qC(e.length) && !!Kn[xc(e)];
}
function E$(e) {
  return function(t) {
    return e(t);
  };
}
var NC = typeof exports == "object" && exports && !exports.nodeType && exports, ff = NC && typeof module == "object" && module && !module.nodeType && module, O$ = ff && ff.exports === NC, _h = O$ && gC.process, fb = function() {
  try {
    var e = ff && ff.require && ff.require("util").types;
    return e || _h && _h.binding && _h.binding("util");
  } catch {
  }
}(), pb = fb && fb.isTypedArray, T$ = pb ? E$(pb) : k$, P$ = Object.prototype, R$ = P$.hasOwnProperty;
function j$(e, t) {
  var n = Ff(e), r = !n && JN(e), i = !n && !r && t$(e), a = !n && !r && !i && T$(e), o = n || r || i || a, c = o ? WN(e.length, String) : [], u = c.length;
  for (var s in e)
    R$.call(e, s) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    IC(s, u))) && c.push(s);
  return c;
}
function I$(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var q$ = I$(Object.keys, Object), D$ = Object.prototype, L$ = D$.hasOwnProperty;
function N$(e) {
  if (!VN(e))
    return q$(e);
  var t = [];
  for (var n in Object(e))
    L$.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function $C(e) {
  return zN(e) ? j$(e) : N$(e);
}
var $$ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, M$ = /^\w*$/;
function F$(e, t) {
  if (Ff(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || q0(e) ? !0 : M$.test(e) || !$$.test(e) || t != null && e in Object(t);
}
var wf = Au(Object, "create");
function B$() {
  this.__data__ = wf ? wf(null) : {}, this.size = 0;
}
function U$(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var H$ = "__lodash_hash_undefined__", z$ = Object.prototype, G$ = z$.hasOwnProperty;
function V$(e) {
  var t = this.__data__;
  if (wf) {
    var n = t[e];
    return n === H$ ? void 0 : n;
  }
  return G$.call(t, e) ? t[e] : void 0;
}
var W$ = Object.prototype, K$ = W$.hasOwnProperty;
function Z$(e) {
  var t = this.__data__;
  return wf ? t[e] !== void 0 : K$.call(t, e);
}
var Y$ = "__lodash_hash_undefined__";
function J$(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = wf && t === void 0 ? Y$ : t, this;
}
function xu(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xu.prototype.clear = B$;
xu.prototype.delete = U$;
xu.prototype.get = V$;
xu.prototype.has = Z$;
xu.prototype.set = J$;
function Q$() {
  this.__data__ = [], this.size = 0;
}
function D0(e, t) {
  for (var n = e.length; n--; )
    if (UN(e[n][0], t))
      return n;
  return -1;
}
var X$ = Array.prototype, eM = X$.splice;
function tM(e) {
  var t = this.__data__, n = D0(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : eM.call(t, n, 1), --this.size, !0;
}
function rM(e) {
  var t = this.__data__, n = D0(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function nM(e) {
  return D0(this.__data__, e) > -1;
}
function iM(e, t) {
  var n = this.__data__, r = D0(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function _c(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
_c.prototype.clear = Q$;
_c.prototype.delete = tM;
_c.prototype.get = rM;
_c.prototype.has = nM;
_c.prototype.set = iM;
var Qd = Au(qa, "Map");
function aM() {
  this.size = 0, this.__data__ = {
    hash: new xu(),
    map: new (Qd || _c)(),
    string: new xu()
  };
}
function oM(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function L0(e, t) {
  var n = e.__data__;
  return oM(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function sM(e) {
  var t = L0(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function uM(e) {
  return L0(this, e).get(e);
}
function cM(e) {
  return L0(this, e).has(e);
}
function lM(e, t) {
  var n = L0(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function ku(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ku.prototype.clear = aM;
ku.prototype.delete = sM;
ku.prototype.get = uM;
ku.prototype.has = cM;
ku.prototype.set = lM;
var fM = "Expected a function";
function v2(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(fM);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, r);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (v2.Cache || ku)(), n;
}
v2.Cache = ku;
var pM = 500;
function dM(e) {
  var t = v2(e, function(r) {
    return n.size === pM && n.clear(), r;
  }), n = t.cache;
  return t;
}
var hM = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, mM = /\\(\\)?/g, gM = dM(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(hM, function(n, r, i, a) {
    t.push(i ? a.replace(mM, "$1") : r || n);
  }), t;
});
function vM(e) {
  return e == null ? "" : bC(e);
}
function yM(e, t) {
  return Ff(e) ? e : F$(e, t) ? [e] : gM(vM(e));
}
function bM(e) {
  if (typeof e == "string" || q0(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function xM(e, t) {
  t = yM(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[bM(t[n++])];
  return n && n == r ? e : void 0;
}
function _M(e, t, n) {
  var r = e == null ? void 0 : xM(e, t);
  return r === void 0 ? n : r;
}
var O6 = Au(qa, "DataView"), T6 = Au(qa, "Promise"), P6 = Au(qa, "Set"), db = "[object Map]", wM = "[object Object]", hb = "[object Promise]", mb = "[object Set]", gb = "[object WeakMap]", vb = "[object DataView]", SM = Cu(O6), CM = Cu(Qd), AM = Cu(T6), kM = Cu(P6), EM = Cu(xf), du = xc;
(O6 && du(new O6(new ArrayBuffer(1))) != vb || Qd && du(new Qd()) != db || T6 && du(T6.resolve()) != hb || P6 && du(new P6()) != mb || xf && du(new xf()) != gb) && (du = function(e) {
  var t = xc(e), n = t == wM ? e.constructor : void 0, r = n ? Cu(n) : "";
  if (r)
    switch (r) {
      case SM:
        return vb;
      case CM:
        return db;
      case AM:
        return hb;
      case kM:
        return mb;
      case EM:
        return gb;
    }
  return t;
});
function OM(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var TM = 8;
function y2(e, t, n) {
  t = n ? void 0 : t;
  var r = BN(e, TM, void 0, void 0, void 0, void 0, void 0, t);
  return r.placeholder = y2.placeholder, r;
}
y2.placeholder = {};
function PM(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function RM(e, t) {
  return yC(t, function(n) {
    return [n, e[n]];
  });
}
function jM(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = [r, r];
  }), n;
}
var IM = "[object Map]", qM = "[object Set]";
function DM(e) {
  return function(t) {
    var n = du(t);
    return n == IM ? OM(t) : n == qM ? jM(t) : RM(t, e(t));
  };
}
var LM = DM($C);
function b2(e) {
  return ea(e) && "id" in e;
}
function NM(e) {
  return b2(e) && "name" in e && "version" in e;
}
function Xd(e) {
  return b2(e) && "method" in e && "path" in e;
}
function e0(e) {
  return b2(e) && "method" in e && "name" in e;
}
y2((e, t) => e.toUpperCase() === t.toUpperCase());
function t0(e) {
  return e.replace(/\/|{|}|\s/g, "-").replace(/-{2,}/, "-").replace(/^-/, "").replace(/-$/, "");
}
const $M = (...e) => e.reverse().reduce((t, n) => ({ ...t, ...n }), {});
function wh(e, t, n) {
  const r = {}, i = [], a = e.tags.map((u) => u.toLowerCase()), o = e.children.filter((u) => u.type === t);
  for (const u of o)
    if (u.tags.length > 0)
      for (let s = 0; s < u.tags.length; s++) {
        const f = u.tags[s], d = s === 0 ? u.uri : u.uri.split("/").toSpliced(2, 0, t0(f).toLowerCase()).join("/"), l = f.toLowerCase();
        if (r[l])
          r[l].items.push({ ...u, uri: d }), r[l].initiallyExpanded = r[l].initiallyExpanded ? !0 : d === n;
        else {
          const p = a.findIndex((v) => v === l), g = e.tags[p];
          r[l] = {
            title: g || f,
            items: [{ ...u, uri: d }],
            initiallyExpanded: d === n
          };
        }
      }
    else
      i.push(u);
  return { groups: Object.entries(r).sort(([u], [s]) => {
    const f = u.toLowerCase(), d = s.toLowerCase(), l = a.findIndex((g) => g === f), p = a.findIndex((g) => g === d);
    return l < 0 && p < 0 ? 0 : l < 0 ? 1 : p < 0 ? -1 : l - p;
  }).map(([, u]) => u), ungrouped: i };
}
const MM = {
  hideSchemas: !1,
  hideInternal: !1,
  hideDeprecated: !1,
  currentPath: ""
}, FM = (e, t = {}) => {
  const n = $M(t, MM), r = [];
  if (r.push({
    id: "/",
    slug: "/",
    title: "Overview",
    type: "overview",
    meta: ""
  }), e.children.some((s) => s.type === ji.HttpOperation)) {
    const { groups: s, ungrouped: f } = wh(
      e,
      ji.HttpOperation,
      n.currentPath
    );
    r.push({
      title: "Endpoints",
      items: [],
      hideTitle: n.hideSchemas,
      initiallyExpanded: !0
      // Endpoints are always expanded by default
    }), Sh({
      groups: s,
      ungrouped: f,
      tree: r.at(-1).items,
      itemsType: ji.HttpOperation,
      hideInternal: n.hideInternal,
      hideDeprecated: n.hideDeprecated
    });
  }
  const a = e.children.some((s) => s.type === ji.HttpWebhook), { groups: o, ungrouped: c } = wh(
    e,
    ji.HttpWebhook,
    n.currentPath
  );
  a && (r.push({
    title: "Webhooks",
    items: [],
    initiallyExpanded: o.some((s) => s.initiallyExpanded) || c.some((s) => s.uri === n.currentPath)
  }), Sh({
    groups: o,
    ungrouped: c,
    tree: r.at(-1).items,
    itemsType: ji.HttpWebhook,
    hideInternal: n.hideInternal,
    hideDeprecated: n.hideDeprecated
  }));
  let u = e.children.filter((s) => s.type === ji.Model);
  if (n.hideInternal && (u = u.filter((s) => !R6(s))), !n.hideSchemas && u.length) {
    const { groups: s, ungrouped: f } = wh(e, ji.Model, n.currentPath);
    r.push({
      title: "Schemas",
      items: [],
      initiallyExpanded: s.some((d) => d.initiallyExpanded) || f.some((d) => d.uri === n.currentPath)
    }), Sh({
      groups: s,
      ungrouped: f,
      tree: r.at(-1).items,
      itemsType: ji.Model,
      hideInternal: n.hideInternal
    });
  }
  return r;
}, R6 = (e) => {
  const t = e.data;
  return Xd(t) || e0(t) ? !!t.internal : NM(t) ? !1 : !!t["x-internal"];
}, Zp = (e) => {
  const t = e.data;
  return Xd(t) || e0(t) ? t.deprecated ?? !1 : !1;
}, Sh = ({
  groups: e,
  ungrouped: t,
  tree: n,
  itemsType: r,
  hideInternal: i,
  hideDeprecated: a
}) => {
  t.forEach((o) => {
    i && R6(o) || a && Zp(o) || n.push({
      id: o.uri,
      slug: o.uri,
      title: o.name,
      type: o.type,
      meta: Xd(o.data) || e0(o.data) ? o.data.method : "",
      ...Zp(o) ? { deprecated: !0 } : {}
    });
  }), e.forEach((o) => {
    const c = o.items.flatMap((u) => i && R6(u) || a && Zp(u) ? [] : {
      id: u.uri,
      slug: u.uri,
      title: u.name,
      type: u.type,
      meta: Xd(u.data) || e0(u.data) ? u.data.method : "",
      ...Zp(u) ? { deprecated: !0 } : {}
    });
    c.length && n.push({
      title: o.title,
      items: c,
      itemsType: r,
      initiallyExpanded: o.initiallyExpanded
    });
  });
};
var uf = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var BM = uf.exports, yb;
function ti() {
  return yb || (yb = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", c = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", s = 500, f = "__lodash_placeholder__", d = 1, l = 2, p = 4, g = 1, v = 2, b = 1, y = 2, w = 4, C = 8, T = 16, E = 32, D = 64, $ = 128, Z = 256, te = 512, se = 30, ee = "...", K = 800, re = 16, de = 1, ie = 2, me = 3, $e = 1 / 0, Pe = 9007199254740991, Le = 17976931348623157e292, Ae = NaN, He = 4294967295, Te = He - 1, we = He >>> 1, qe = [
        ["ary", $],
        ["bind", b],
        ["bindKey", y],
        ["curry", C],
        ["curryRight", T],
        ["flip", te],
        ["partial", E],
        ["partialRight", D],
        ["rearg", Z]
      ], Ge = "[object Arguments]", It = "[object Array]", Qe = "[object AsyncFunction]", jt = "[object Boolean]", We = "[object Date]", Lt = "[object DOMException]", Fe = "[object Error]", Ze = "[object Function]", Ue = "[object GeneratorFunction]", Rt = "[object Map]", Vr = "[object Number]", ye = "[object Null]", G = "[object Object]", Y = "[object Promise]", ae = "[object Proxy]", Ee = "[object RegExp]", N = "[object Set]", Se = "[object String]", Me = "[object Symbol]", Xe = "[object Undefined]", Ke = "[object WeakMap]", $t = "[object WeakSet]", Be = "[object ArrayBuffer]", P = "[object DataView]", M = "[object Float32Array]", F = "[object Float64Array]", O = "[object Int8Array]", S = "[object Int16Array]", _ = "[object Int32Array]", h = "[object Uint8Array]", A = "[object Uint8ClampedArray]", R = "[object Uint16Array]", I = "[object Uint32Array]", k = /\b__p \+= '';/g, j = /\b(__p \+=) '' \+/g, z = /(__e\(.*?\)|\b__t\)) \+\n'';/g, H = /&(?:amp|lt|gt|quot|#39);/g, J = /[&<>"']/g, U = RegExp(H.source), L = RegExp(J.source), B = /<%-([\s\S]+?)%>/g, Q = /<%([\s\S]+?)%>/g, V = /<%=([\s\S]+?)%>/g, X = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ue = /^\w*$/, ve = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pe = /[\\^$.*+?()[\]{}|]/g, oe = RegExp(pe.source), ce = /^\s+/, ke = /\s/, fe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, be = /\{\n\/\* \[wrapped with (.+)\] \*/, ge = /,? & /, Ie = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, le = /[()=,{}\[\]\/\s]/, he = /\\(\\)?/g, xe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, je = /\w*$/, Oe = /^[-+]0x[0-9a-f]+$/i, De = /^0b[01]+$/i, ze = /^\[object .+?Constructor\]$/, yt = /^0o[0-7]+$/i, pt = /^(?:0|[1-9]\d*)$/, bt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, lt = /($^)/, xt = /['\n\r\u2028\u2029\\]/g, ft = "\\ud800-\\udfff", _t = "\\u0300-\\u036f", dt = "\\ufe20-\\ufe2f", mt = "\\u20d0-\\u20ff", Je = _t + dt + mt, ht = "\\u2700-\\u27bf", rt = "a-z\\xdf-\\xf6\\xf8-\\xff", kt = "\\xac\\xb1\\xd7\\xf7", st = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Et = "\\u2000-\\u206f", ut = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", St = "A-Z\\xc0-\\xd6\\xd8-\\xde", nt = "\\ufe0e\\ufe0f", Ct = kt + st + Et + ut, et = "['’]", Ot = "[" + ft + "]", it = "[" + Ct + "]", wt = "[" + Je + "]", at = "\\d+", Tt = "[" + ht + "]", ot = "[" + rt + "]", At = "[^" + ft + Ct + at + ht + rt + St + "]", tt = "\\ud83c[\\udffb-\\udfff]", qt = "(?:" + wt + "|" + tt + ")", Pt = "[^" + ft + "]", Vt = "(?:\\ud83c[\\udde6-\\uddff]){2}", qr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qr = "[" + St + "]", Ur = "\\u200d", en = "(?:" + ot + "|" + At + ")", Wr = "(?:" + Qr + "|" + At + ")", tn = "(?:" + et + "(?:d|ll|m|re|s|t|ve))?", Hr = "(?:" + et + "(?:D|LL|M|RE|S|T|VE))?", rn = qt + "?", zr = "[" + nt + "]?", nn = "(?:" + Ur + "(?:" + [Pt, Vt, qr].join("|") + ")" + zr + rn + ")*", Kr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", an = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Gr = zr + rn + nn, on = "(?:" + [Tt, Vt, qr].join("|") + ")" + Gr, Zr = "(?:" + [Pt + wt + "?", wt, Vt, qr, Ot].join("|") + ")", sn = RegExp(et, "g"), Yr = RegExp(wt, "g"), Xr = RegExp(tt + "(?=" + tt + ")|" + Zr + Gr, "g"), Jr = RegExp([
        Qr + "?" + ot + "+" + tn + "(?=" + [it, Qr, "$"].join("|") + ")",
        Wr + "+" + Hr + "(?=" + [it, Qr + en, "$"].join("|") + ")",
        Qr + "?" + en + "+" + tn,
        Qr + "+" + Hr,
        an,
        Kr,
        at,
        on
      ].join("|"), "g"), Dr = RegExp("[" + Ur + ft + Je + nt + "]"), sr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Lr = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], ur = -1, Wt = {};
      Wt[M] = Wt[F] = Wt[O] = Wt[S] = Wt[_] = Wt[h] = Wt[A] = Wt[R] = Wt[I] = !0, Wt[Ge] = Wt[It] = Wt[Be] = Wt[jt] = Wt[P] = Wt[We] = Wt[Fe] = Wt[Ze] = Wt[Rt] = Wt[Vr] = Wt[G] = Wt[Ee] = Wt[N] = Wt[Se] = Wt[Ke] = !1;
      var Mt = {};
      Mt[Ge] = Mt[It] = Mt[Be] = Mt[P] = Mt[jt] = Mt[We] = Mt[M] = Mt[F] = Mt[O] = Mt[S] = Mt[_] = Mt[Rt] = Mt[Vr] = Mt[G] = Mt[Ee] = Mt[N] = Mt[Se] = Mt[Me] = Mt[h] = Mt[A] = Mt[R] = Mt[I] = !0, Mt[Fe] = Mt[Ze] = Mt[Ke] = !1;
      var Nr = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, cr = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, $r = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, lr = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Mr = parseFloat, fr = parseInt, Tr = typeof Ya == "object" && Ya && Ya.Object === Object && Ya, pr = typeof self == "object" && self && self.Object === Object && self, Xt = Tr || pr || Function("return this")(), tr = t && !t.nodeType && t, wr = tr && !0 && e && !e.nodeType && e, nr = wr && wr.exports === tr, kr = nr && Tr.process, Zt = function() {
        try {
          var ct = wr && wr.require && wr.require("util").types;
          return ct || kr && kr.binding && kr.binding("util");
        } catch {
        }
      }(), Pr = Zt && Zt.isArrayBuffer, ir = Zt && Zt.isDate, Rr = Zt && Zt.isMap, ar = Zt && Zt.isRegExp, jr = Zt && Zt.isSet, or = Zt && Zt.isTypedArray;
      function dr(ct, Ft, Dt) {
        switch (Dt.length) {
          case 0:
            return ct.call(Ft);
          case 1:
            return ct.call(Ft, Dt[0]);
          case 2:
            return ct.call(Ft, Dt[0], Dt[1]);
          case 3:
            return ct.call(Ft, Dt[0], Dt[1], Dt[2]);
        }
        return ct.apply(Ft, Dt);
      }
      function hr(ct, Ft, Dt, fn) {
        for (var xn = -1, Ln = ct == null ? 0 : ct.length; ++xn < Ln; ) {
          var ui = ct[xn];
          Ft(fn, ui, Dt(ui), ct);
        }
        return fn;
      }
      function br(ct, Ft) {
        for (var Dt = -1, fn = ct == null ? 0 : ct.length; ++Dt < fn && Ft(ct[Dt], Dt, ct) !== !1; )
          ;
        return ct;
      }
      function mr(ct, Ft) {
        for (var Dt = ct == null ? 0 : ct.length; Dt-- && Ft(ct[Dt], Dt, ct) !== !1; )
          ;
        return ct;
      }
      function Ir(ct, Ft) {
        for (var Dt = -1, fn = ct == null ? 0 : ct.length; ++Dt < fn; )
          if (!Ft(ct[Dt], Dt, ct))
            return !1;
        return !0;
      }
      function Jt(ct, Ft) {
        for (var Dt = -1, fn = ct == null ? 0 : ct.length, xn = 0, Ln = []; ++Dt < fn; ) {
          var ui = ct[Dt];
          Ft(ui, Dt, ct) && (Ln[xn++] = ui);
        }
        return Ln;
      }
      function Ar(ct, Ft) {
        var Dt = ct == null ? 0 : ct.length;
        return !!Dt && kn(ct, Ft, 0) > -1;
      }
      function rr(ct, Ft, Dt) {
        for (var fn = -1, xn = ct == null ? 0 : ct.length; ++fn < xn; )
          if (Dt(Ft, ct[fn]))
            return !0;
        return !1;
      }
      function Yt(ct, Ft) {
        for (var Dt = -1, fn = ct == null ? 0 : ct.length, xn = Array(fn); ++Dt < fn; )
          xn[Dt] = Ft(ct[Dt], Dt, ct);
        return xn;
      }
      function Qt(ct, Ft) {
        for (var Dt = -1, fn = Ft.length, xn = ct.length; ++Dt < fn; )
          ct[xn + Dt] = Ft[Dt];
        return ct;
      }
      function Er(ct, Ft, Dt, fn) {
        var xn = -1, Ln = ct == null ? 0 : ct.length;
        for (fn && Ln && (Dt = ct[++xn]); ++xn < Ln; )
          Dt = Ft(Dt, ct[xn], xn, ct);
        return Dt;
      }
      function gr(ct, Ft, Dt, fn) {
        var xn = ct == null ? 0 : ct.length;
        for (fn && xn && (Dt = ct[--xn]); xn--; )
          Dt = Ft(Dt, ct[xn], xn, ct);
        return Dt;
      }
      function Or(ct, Ft) {
        for (var Dt = -1, fn = ct == null ? 0 : ct.length; ++Dt < fn; )
          if (Ft(ct[Dt], Dt, ct))
            return !0;
        return !1;
      }
      var vr = b1("length");
      function Fr(ct) {
        return ct.split("");
      }
      function yr(ct) {
        return ct.match(Ie) || [];
      }
      function ln(ct, Ft, Dt) {
        var fn;
        return Dt(ct, function(xn, Ln, ui) {
          if (Ft(xn, Ln, ui))
            return fn = Ln, !1;
        }), fn;
      }
      function cn(ct, Ft, Dt, fn) {
        for (var xn = ct.length, Ln = Dt + (fn ? 1 : -1); fn ? Ln-- : ++Ln < xn; )
          if (Ft(ct[Ln], Ln, ct))
            return Ln;
        return -1;
      }
      function kn(ct, Ft, Dt) {
        return Ft === Ft ? bT(ct, Ft, Dt) : cn(ct, $g, Dt);
      }
      function uT(ct, Ft, Dt, fn) {
        for (var xn = Dt - 1, Ln = ct.length; ++xn < Ln; )
          if (fn(ct[xn], Ft))
            return xn;
        return -1;
      }
      function $g(ct) {
        return ct !== ct;
      }
      function Mg(ct, Ft) {
        var Dt = ct == null ? 0 : ct.length;
        return Dt ? _1(ct, Ft) / Dt : Ae;
      }
      function b1(ct) {
        return function(Ft) {
          return Ft == null ? n : Ft[ct];
        };
      }
      function x1(ct) {
        return function(Ft) {
          return ct == null ? n : ct[Ft];
        };
      }
      function Fg(ct, Ft, Dt, fn, xn) {
        return xn(ct, function(Ln, ui, Un) {
          Dt = fn ? (fn = !1, Ln) : Ft(Dt, Ln, ui, Un);
        }), Dt;
      }
      function cT(ct, Ft) {
        var Dt = ct.length;
        for (ct.sort(Ft); Dt--; )
          ct[Dt] = ct[Dt].value;
        return ct;
      }
      function _1(ct, Ft) {
        for (var Dt, fn = -1, xn = ct.length; ++fn < xn; ) {
          var Ln = Ft(ct[fn]);
          Ln !== n && (Dt = Dt === n ? Ln : Dt + Ln);
        }
        return Dt;
      }
      function w1(ct, Ft) {
        for (var Dt = -1, fn = Array(ct); ++Dt < ct; )
          fn[Dt] = Ft(Dt);
        return fn;
      }
      function lT(ct, Ft) {
        return Yt(Ft, function(Dt) {
          return [Dt, ct[Dt]];
        });
      }
      function Bg(ct) {
        return ct && ct.slice(0, Gg(ct) + 1).replace(ce, "");
      }
      function na(ct) {
        return function(Ft) {
          return ct(Ft);
        };
      }
      function S1(ct, Ft) {
        return Yt(Ft, function(Dt) {
          return ct[Dt];
        });
      }
      function Ic(ct, Ft) {
        return ct.has(Ft);
      }
      function Ug(ct, Ft) {
        for (var Dt = -1, fn = ct.length; ++Dt < fn && kn(Ft, ct[Dt], 0) > -1; )
          ;
        return Dt;
      }
      function Hg(ct, Ft) {
        for (var Dt = ct.length; Dt-- && kn(Ft, ct[Dt], 0) > -1; )
          ;
        return Dt;
      }
      function fT(ct, Ft) {
        for (var Dt = ct.length, fn = 0; Dt--; )
          ct[Dt] === Ft && ++fn;
        return fn;
      }
      var pT = x1(Nr), dT = x1(cr);
      function hT(ct) {
        return "\\" + lr[ct];
      }
      function mT(ct, Ft) {
        return ct == null ? n : ct[Ft];
      }
      function Iu(ct) {
        return Dr.test(ct);
      }
      function gT(ct) {
        return sr.test(ct);
      }
      function vT(ct) {
        for (var Ft, Dt = []; !(Ft = ct.next()).done; )
          Dt.push(Ft.value);
        return Dt;
      }
      function C1(ct) {
        var Ft = -1, Dt = Array(ct.size);
        return ct.forEach(function(fn, xn) {
          Dt[++Ft] = [xn, fn];
        }), Dt;
      }
      function zg(ct, Ft) {
        return function(Dt) {
          return ct(Ft(Dt));
        };
      }
      function us(ct, Ft) {
        for (var Dt = -1, fn = ct.length, xn = 0, Ln = []; ++Dt < fn; ) {
          var ui = ct[Dt];
          (ui === Ft || ui === f) && (ct[Dt] = f, Ln[xn++] = Dt);
        }
        return Ln;
      }
      function lp(ct) {
        var Ft = -1, Dt = Array(ct.size);
        return ct.forEach(function(fn) {
          Dt[++Ft] = fn;
        }), Dt;
      }
      function yT(ct) {
        var Ft = -1, Dt = Array(ct.size);
        return ct.forEach(function(fn) {
          Dt[++Ft] = [fn, fn];
        }), Dt;
      }
      function bT(ct, Ft, Dt) {
        for (var fn = Dt - 1, xn = ct.length; ++fn < xn; )
          if (ct[fn] === Ft)
            return fn;
        return -1;
      }
      function xT(ct, Ft, Dt) {
        for (var fn = Dt + 1; fn--; )
          if (ct[fn] === Ft)
            return fn;
        return fn;
      }
      function qu(ct) {
        return Iu(ct) ? wT(ct) : vr(ct);
      }
      function Da(ct) {
        return Iu(ct) ? ST(ct) : Fr(ct);
      }
      function Gg(ct) {
        for (var Ft = ct.length; Ft-- && ke.test(ct.charAt(Ft)); )
          ;
        return Ft;
      }
      var _T = x1($r);
      function wT(ct) {
        for (var Ft = Xr.lastIndex = 0; Xr.test(ct); )
          ++Ft;
        return Ft;
      }
      function ST(ct) {
        return ct.match(Xr) || [];
      }
      function CT(ct) {
        return ct.match(Jr) || [];
      }
      var AT = function ct(Ft) {
        Ft = Ft == null ? Xt : Du.defaults(Xt.Object(), Ft, Du.pick(Xt, Lr));
        var Dt = Ft.Array, fn = Ft.Date, xn = Ft.Error, Ln = Ft.Function, ui = Ft.Math, Un = Ft.Object, A1 = Ft.RegExp, kT = Ft.String, ma = Ft.TypeError, fp = Dt.prototype, ET = Ln.prototype, Lu = Un.prototype, pp = Ft["__core-js_shared__"], dp = ET.toString, Mn = Lu.hasOwnProperty, OT = 0, Vg = function() {
          var m = /[^.]+$/.exec(pp && pp.keys && pp.keys.IE_PROTO || "");
          return m ? "Symbol(src)_1." + m : "";
        }(), hp = Lu.toString, TT = dp.call(Un), PT = Xt._, RT = A1(
          "^" + dp.call(Mn).replace(pe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), mp = nr ? Ft.Buffer : n, cs = Ft.Symbol, gp = Ft.Uint8Array, Wg = mp ? mp.allocUnsafe : n, vp = zg(Un.getPrototypeOf, Un), Kg = Un.create, Zg = Lu.propertyIsEnumerable, yp = fp.splice, Yg = cs ? cs.isConcatSpreadable : n, qc = cs ? cs.iterator : n, Rs = cs ? cs.toStringTag : n, bp = function() {
          try {
            var m = Ls(Un, "defineProperty");
            return m({}, "", {}), m;
          } catch {
          }
        }(), jT = Ft.clearTimeout !== Xt.clearTimeout && Ft.clearTimeout, IT = fn && fn.now !== Xt.Date.now && fn.now, qT = Ft.setTimeout !== Xt.setTimeout && Ft.setTimeout, xp = ui.ceil, _p = ui.floor, k1 = Un.getOwnPropertySymbols, DT = mp ? mp.isBuffer : n, Jg = Ft.isFinite, LT = fp.join, NT = zg(Un.keys, Un), ci = ui.max, Oi = ui.min, $T = fn.now, MT = Ft.parseInt, Qg = ui.random, FT = fp.reverse, E1 = Ls(Ft, "DataView"), Dc = Ls(Ft, "Map"), O1 = Ls(Ft, "Promise"), Nu = Ls(Ft, "Set"), Lc = Ls(Ft, "WeakMap"), Nc = Ls(Un, "create"), wp = Lc && new Lc(), $u = {}, BT = Ns(E1), UT = Ns(Dc), HT = Ns(O1), zT = Ns(Nu), GT = Ns(Lc), Sp = cs ? cs.prototype : n, $c = Sp ? Sp.valueOf : n, Xg = Sp ? Sp.toString : n;
        function _e(m) {
          if (ei(m) && !_n(m) && !(m instanceof jn)) {
            if (m instanceof ga)
              return m;
            if (Mn.call(m, "__wrapped__"))
              return ey(m);
          }
          return new ga(m);
        }
        var Mu = /* @__PURE__ */ function() {
          function m() {
          }
          return function(x) {
            if (!Jn(x))
              return {};
            if (Kg)
              return Kg(x);
            m.prototype = x;
            var q = new m();
            return m.prototype = n, q;
          };
        }();
        function Cp() {
        }
        function ga(m, x) {
          this.__wrapped__ = m, this.__actions__ = [], this.__chain__ = !!x, this.__index__ = 0, this.__values__ = n;
        }
        _e.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: B,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Q,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: V,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: _e
          }
        }, _e.prototype = Cp.prototype, _e.prototype.constructor = _e, ga.prototype = Mu(Cp.prototype), ga.prototype.constructor = ga;
        function jn(m) {
          this.__wrapped__ = m, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = He, this.__views__ = [];
        }
        function VT() {
          var m = new jn(this.__wrapped__);
          return m.__actions__ = Ki(this.__actions__), m.__dir__ = this.__dir__, m.__filtered__ = this.__filtered__, m.__iteratees__ = Ki(this.__iteratees__), m.__takeCount__ = this.__takeCount__, m.__views__ = Ki(this.__views__), m;
        }
        function WT() {
          if (this.__filtered__) {
            var m = new jn(this);
            m.__dir__ = -1, m.__filtered__ = !0;
          } else
            m = this.clone(), m.__dir__ *= -1;
          return m;
        }
        function KT() {
          var m = this.__wrapped__.value(), x = this.__dir__, q = _n(m), W = x < 0, ne = q ? m.length : 0, Ce = oR(0, ne, this.__views__), Ne = Ce.start, Ve = Ce.end, gt = Ve - Ne, Ht = W ? Ve : Ne - 1, zt = this.__iteratees__, er = zt.length, un = 0, hn = Oi(gt, this.__takeCount__);
          if (!q || !W && ne == gt && hn == gt)
            return Sv(m, this.__actions__);
          var vn = [];
          e:
            for (; gt-- && un < hn; ) {
              Ht += x;
              for (var En = -1, yn = m[Ht]; ++En < er; ) {
                var Pn = zt[En], qn = Pn.iteratee, oa = Pn.type, Fi = qn(yn);
                if (oa == ie)
                  yn = Fi;
                else if (!Fi) {
                  if (oa == de)
                    continue e;
                  break e;
                }
              }
              vn[un++] = yn;
            }
          return vn;
        }
        jn.prototype = Mu(Cp.prototype), jn.prototype.constructor = jn;
        function js(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.clear(); ++x < q; ) {
            var W = m[x];
            this.set(W[0], W[1]);
          }
        }
        function ZT() {
          this.__data__ = Nc ? Nc(null) : {}, this.size = 0;
        }
        function YT(m) {
          var x = this.has(m) && delete this.__data__[m];
          return this.size -= x ? 1 : 0, x;
        }
        function JT(m) {
          var x = this.__data__;
          if (Nc) {
            var q = x[m];
            return q === u ? n : q;
          }
          return Mn.call(x, m) ? x[m] : n;
        }
        function QT(m) {
          var x = this.__data__;
          return Nc ? x[m] !== n : Mn.call(x, m);
        }
        function XT(m, x) {
          var q = this.__data__;
          return this.size += this.has(m) ? 0 : 1, q[m] = Nc && x === n ? u : x, this;
        }
        js.prototype.clear = ZT, js.prototype.delete = YT, js.prototype.get = JT, js.prototype.has = QT, js.prototype.set = XT;
        function ko(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.clear(); ++x < q; ) {
            var W = m[x];
            this.set(W[0], W[1]);
          }
        }
        function eP() {
          this.__data__ = [], this.size = 0;
        }
        function tP(m) {
          var x = this.__data__, q = Ap(x, m);
          if (q < 0)
            return !1;
          var W = x.length - 1;
          return q == W ? x.pop() : yp.call(x, q, 1), --this.size, !0;
        }
        function rP(m) {
          var x = this.__data__, q = Ap(x, m);
          return q < 0 ? n : x[q][1];
        }
        function nP(m) {
          return Ap(this.__data__, m) > -1;
        }
        function iP(m, x) {
          var q = this.__data__, W = Ap(q, m);
          return W < 0 ? (++this.size, q.push([m, x])) : q[W][1] = x, this;
        }
        ko.prototype.clear = eP, ko.prototype.delete = tP, ko.prototype.get = rP, ko.prototype.has = nP, ko.prototype.set = iP;
        function Eo(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.clear(); ++x < q; ) {
            var W = m[x];
            this.set(W[0], W[1]);
          }
        }
        function aP() {
          this.size = 0, this.__data__ = {
            hash: new js(),
            map: new (Dc || ko)(),
            string: new js()
          };
        }
        function oP(m) {
          var x = Np(this, m).delete(m);
          return this.size -= x ? 1 : 0, x;
        }
        function sP(m) {
          return Np(this, m).get(m);
        }
        function uP(m) {
          return Np(this, m).has(m);
        }
        function cP(m, x) {
          var q = Np(this, m), W = q.size;
          return q.set(m, x), this.size += q.size == W ? 0 : 1, this;
        }
        Eo.prototype.clear = aP, Eo.prototype.delete = oP, Eo.prototype.get = sP, Eo.prototype.has = uP, Eo.prototype.set = cP;
        function Is(m) {
          var x = -1, q = m == null ? 0 : m.length;
          for (this.__data__ = new Eo(); ++x < q; )
            this.add(m[x]);
        }
        function lP(m) {
          return this.__data__.set(m, u), this;
        }
        function fP(m) {
          return this.__data__.has(m);
        }
        Is.prototype.add = Is.prototype.push = lP, Is.prototype.has = fP;
        function La(m) {
          var x = this.__data__ = new ko(m);
          this.size = x.size;
        }
        function pP() {
          this.__data__ = new ko(), this.size = 0;
        }
        function dP(m) {
          var x = this.__data__, q = x.delete(m);
          return this.size = x.size, q;
        }
        function hP(m) {
          return this.__data__.get(m);
        }
        function mP(m) {
          return this.__data__.has(m);
        }
        function gP(m, x) {
          var q = this.__data__;
          if (q instanceof ko) {
            var W = q.__data__;
            if (!Dc || W.length < i - 1)
              return W.push([m, x]), this.size = ++q.size, this;
            q = this.__data__ = new Eo(W);
          }
          return q.set(m, x), this.size = q.size, this;
        }
        La.prototype.clear = pP, La.prototype.delete = dP, La.prototype.get = hP, La.prototype.has = mP, La.prototype.set = gP;
        function ev(m, x) {
          var q = _n(m), W = !q && $s(m), ne = !q && !W && hs(m), Ce = !q && !W && !ne && Hu(m), Ne = q || W || ne || Ce, Ve = Ne ? w1(m.length, kT) : [], gt = Ve.length;
          for (var Ht in m)
            (x || Mn.call(m, Ht)) && !(Ne && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Ht == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            ne && (Ht == "offset" || Ht == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            Ce && (Ht == "buffer" || Ht == "byteLength" || Ht == "byteOffset") || // Skip index properties.
            Ro(Ht, gt))) && Ve.push(Ht);
          return Ve;
        }
        function tv(m) {
          var x = m.length;
          return x ? m[M1(0, x - 1)] : n;
        }
        function vP(m, x) {
          return $p(Ki(m), qs(x, 0, m.length));
        }
        function yP(m) {
          return $p(Ki(m));
        }
        function T1(m, x, q) {
          (q !== n && !Na(m[x], q) || q === n && !(x in m)) && Oo(m, x, q);
        }
        function Mc(m, x, q) {
          var W = m[x];
          (!(Mn.call(m, x) && Na(W, q)) || q === n && !(x in m)) && Oo(m, x, q);
        }
        function Ap(m, x) {
          for (var q = m.length; q--; )
            if (Na(m[q][0], x))
              return q;
          return -1;
        }
        function bP(m, x, q, W) {
          return ls(m, function(ne, Ce, Ne) {
            x(W, ne, q(ne), Ne);
          }), W;
        }
        function rv(m, x) {
          return m && oo(x, gi(x), m);
        }
        function xP(m, x) {
          return m && oo(x, Yi(x), m);
        }
        function Oo(m, x, q) {
          x == "__proto__" && bp ? bp(m, x, {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          }) : m[x] = q;
        }
        function P1(m, x) {
          for (var q = -1, W = x.length, ne = Dt(W), Ce = m == null; ++q < W; )
            ne[q] = Ce ? n : lh(m, x[q]);
          return ne;
        }
        function qs(m, x, q) {
          return m === m && (q !== n && (m = m <= q ? m : q), x !== n && (m = m >= x ? m : x)), m;
        }
        function va(m, x, q, W, ne, Ce) {
          var Ne, Ve = x & d, gt = x & l, Ht = x & p;
          if (q && (Ne = ne ? q(m, W, ne, Ce) : q(m)), Ne !== n)
            return Ne;
          if (!Jn(m))
            return m;
          var zt = _n(m);
          if (zt) {
            if (Ne = uR(m), !Ve)
              return Ki(m, Ne);
          } else {
            var er = Ti(m), un = er == Ze || er == Ue;
            if (hs(m))
              return kv(m, Ve);
            if (er == G || er == Ge || un && !ne) {
              if (Ne = gt || un ? {} : Gv(m), !Ve)
                return gt ? JP(m, xP(Ne, m)) : YP(m, rv(Ne, m));
            } else {
              if (!Mt[er])
                return ne ? m : {};
              Ne = cR(m, er, Ve);
            }
          }
          Ce || (Ce = new La());
          var hn = Ce.get(m);
          if (hn)
            return hn;
          Ce.set(m, Ne), xy(m) ? m.forEach(function(yn) {
            Ne.add(va(yn, x, q, yn, m, Ce));
          }) : yy(m) && m.forEach(function(yn, Pn) {
            Ne.set(Pn, va(yn, x, q, Pn, m, Ce));
          });
          var vn = Ht ? gt ? Y1 : Z1 : gt ? Yi : gi, En = zt ? n : vn(m);
          return br(En || m, function(yn, Pn) {
            En && (Pn = yn, yn = m[Pn]), Mc(Ne, Pn, va(yn, x, q, Pn, m, Ce));
          }), Ne;
        }
        function _P(m) {
          var x = gi(m);
          return function(q) {
            return nv(q, m, x);
          };
        }
        function nv(m, x, q) {
          var W = q.length;
          if (m == null)
            return !W;
          for (m = Un(m); W--; ) {
            var ne = q[W], Ce = x[ne], Ne = m[ne];
            if (Ne === n && !(ne in m) || !Ce(Ne))
              return !1;
          }
          return !0;
        }
        function iv(m, x, q) {
          if (typeof m != "function")
            throw new ma(o);
          return Vc(function() {
            m.apply(n, q);
          }, x);
        }
        function Fc(m, x, q, W) {
          var ne = -1, Ce = Ar, Ne = !0, Ve = m.length, gt = [], Ht = x.length;
          if (!Ve)
            return gt;
          q && (x = Yt(x, na(q))), W ? (Ce = rr, Ne = !1) : x.length >= i && (Ce = Ic, Ne = !1, x = new Is(x));
          e:
            for (; ++ne < Ve; ) {
              var zt = m[ne], er = q == null ? zt : q(zt);
              if (zt = W || zt !== 0 ? zt : 0, Ne && er === er) {
                for (var un = Ht; un--; )
                  if (x[un] === er)
                    continue e;
                gt.push(zt);
              } else Ce(x, er, W) || gt.push(zt);
            }
          return gt;
        }
        var ls = Rv(ao), av = Rv(j1, !0);
        function wP(m, x) {
          var q = !0;
          return ls(m, function(W, ne, Ce) {
            return q = !!x(W, ne, Ce), q;
          }), q;
        }
        function kp(m, x, q) {
          for (var W = -1, ne = m.length; ++W < ne; ) {
            var Ce = m[W], Ne = x(Ce);
            if (Ne != null && (Ve === n ? Ne === Ne && !aa(Ne) : q(Ne, Ve)))
              var Ve = Ne, gt = Ce;
          }
          return gt;
        }
        function SP(m, x, q, W) {
          var ne = m.length;
          for (q = Sn(q), q < 0 && (q = -q > ne ? 0 : ne + q), W = W === n || W > ne ? ne : Sn(W), W < 0 && (W += ne), W = q > W ? 0 : wy(W); q < W; )
            m[q++] = x;
          return m;
        }
        function ov(m, x) {
          var q = [];
          return ls(m, function(W, ne, Ce) {
            x(W, ne, Ce) && q.push(W);
          }), q;
        }
        function ki(m, x, q, W, ne) {
          var Ce = -1, Ne = m.length;
          for (q || (q = fR), ne || (ne = []); ++Ce < Ne; ) {
            var Ve = m[Ce];
            x > 0 && q(Ve) ? x > 1 ? ki(Ve, x - 1, q, W, ne) : Qt(ne, Ve) : W || (ne[ne.length] = Ve);
          }
          return ne;
        }
        var R1 = jv(), sv = jv(!0);
        function ao(m, x) {
          return m && R1(m, x, gi);
        }
        function j1(m, x) {
          return m && sv(m, x, gi);
        }
        function Ep(m, x) {
          return Jt(x, function(q) {
            return jo(m[q]);
          });
        }
        function Ds(m, x) {
          x = ps(x, m);
          for (var q = 0, W = x.length; m != null && q < W; )
            m = m[so(x[q++])];
          return q && q == W ? m : n;
        }
        function uv(m, x, q) {
          var W = x(m);
          return _n(m) ? W : Qt(W, q(m));
        }
        function $i(m) {
          return m == null ? m === n ? Xe : ye : Rs && Rs in Un(m) ? aR(m) : yR(m);
        }
        function I1(m, x) {
          return m > x;
        }
        function CP(m, x) {
          return m != null && Mn.call(m, x);
        }
        function AP(m, x) {
          return m != null && x in Un(m);
        }
        function kP(m, x, q) {
          return m >= Oi(x, q) && m < ci(x, q);
        }
        function q1(m, x, q) {
          for (var W = q ? rr : Ar, ne = m[0].length, Ce = m.length, Ne = Ce, Ve = Dt(Ce), gt = 1 / 0, Ht = []; Ne--; ) {
            var zt = m[Ne];
            Ne && x && (zt = Yt(zt, na(x))), gt = Oi(zt.length, gt), Ve[Ne] = !q && (x || ne >= 120 && zt.length >= 120) ? new Is(Ne && zt) : n;
          }
          zt = m[0];
          var er = -1, un = Ve[0];
          e:
            for (; ++er < ne && Ht.length < gt; ) {
              var hn = zt[er], vn = x ? x(hn) : hn;
              if (hn = q || hn !== 0 ? hn : 0, !(un ? Ic(un, vn) : W(Ht, vn, q))) {
                for (Ne = Ce; --Ne; ) {
                  var En = Ve[Ne];
                  if (!(En ? Ic(En, vn) : W(m[Ne], vn, q)))
                    continue e;
                }
                un && un.push(vn), Ht.push(hn);
              }
            }
          return Ht;
        }
        function EP(m, x, q, W) {
          return ao(m, function(ne, Ce, Ne) {
            x(W, q(ne), Ce, Ne);
          }), W;
        }
        function Bc(m, x, q) {
          x = ps(x, m), m = Zv(m, x);
          var W = m == null ? m : m[so(ba(x))];
          return W == null ? n : dr(W, m, q);
        }
        function cv(m) {
          return ei(m) && $i(m) == Ge;
        }
        function OP(m) {
          return ei(m) && $i(m) == Be;
        }
        function TP(m) {
          return ei(m) && $i(m) == We;
        }
        function Uc(m, x, q, W, ne) {
          return m === x ? !0 : m == null || x == null || !ei(m) && !ei(x) ? m !== m && x !== x : PP(m, x, q, W, Uc, ne);
        }
        function PP(m, x, q, W, ne, Ce) {
          var Ne = _n(m), Ve = _n(x), gt = Ne ? It : Ti(m), Ht = Ve ? It : Ti(x);
          gt = gt == Ge ? G : gt, Ht = Ht == Ge ? G : Ht;
          var zt = gt == G, er = Ht == G, un = gt == Ht;
          if (un && hs(m)) {
            if (!hs(x))
              return !1;
            Ne = !0, zt = !1;
          }
          if (un && !zt)
            return Ce || (Ce = new La()), Ne || Hu(m) ? Uv(m, x, q, W, ne, Ce) : nR(m, x, gt, q, W, ne, Ce);
          if (!(q & g)) {
            var hn = zt && Mn.call(m, "__wrapped__"), vn = er && Mn.call(x, "__wrapped__");
            if (hn || vn) {
              var En = hn ? m.value() : m, yn = vn ? x.value() : x;
              return Ce || (Ce = new La()), ne(En, yn, q, W, Ce);
            }
          }
          return un ? (Ce || (Ce = new La()), iR(m, x, q, W, ne, Ce)) : !1;
        }
        function RP(m) {
          return ei(m) && Ti(m) == Rt;
        }
        function D1(m, x, q, W) {
          var ne = q.length, Ce = ne, Ne = !W;
          if (m == null)
            return !Ce;
          for (m = Un(m); ne--; ) {
            var Ve = q[ne];
            if (Ne && Ve[2] ? Ve[1] !== m[Ve[0]] : !(Ve[0] in m))
              return !1;
          }
          for (; ++ne < Ce; ) {
            Ve = q[ne];
            var gt = Ve[0], Ht = m[gt], zt = Ve[1];
            if (Ne && Ve[2]) {
              if (Ht === n && !(gt in m))
                return !1;
            } else {
              var er = new La();
              if (W)
                var un = W(Ht, zt, gt, m, x, er);
              if (!(un === n ? Uc(zt, Ht, g | v, W, er) : un))
                return !1;
            }
          }
          return !0;
        }
        function lv(m) {
          if (!Jn(m) || dR(m))
            return !1;
          var x = jo(m) ? RT : ze;
          return x.test(Ns(m));
        }
        function jP(m) {
          return ei(m) && $i(m) == Ee;
        }
        function IP(m) {
          return ei(m) && Ti(m) == N;
        }
        function qP(m) {
          return ei(m) && zp(m.length) && !!Wt[$i(m)];
        }
        function fv(m) {
          return typeof m == "function" ? m : m == null ? Ji : typeof m == "object" ? _n(m) ? hv(m[0], m[1]) : dv(m) : Iy(m);
        }
        function L1(m) {
          if (!Gc(m))
            return NT(m);
          var x = [];
          for (var q in Un(m))
            Mn.call(m, q) && q != "constructor" && x.push(q);
          return x;
        }
        function DP(m) {
          if (!Jn(m))
            return vR(m);
          var x = Gc(m), q = [];
          for (var W in m)
            W == "constructor" && (x || !Mn.call(m, W)) || q.push(W);
          return q;
        }
        function N1(m, x) {
          return m < x;
        }
        function pv(m, x) {
          var q = -1, W = Zi(m) ? Dt(m.length) : [];
          return ls(m, function(ne, Ce, Ne) {
            W[++q] = x(ne, Ce, Ne);
          }), W;
        }
        function dv(m) {
          var x = Q1(m);
          return x.length == 1 && x[0][2] ? Wv(x[0][0], x[0][1]) : function(q) {
            return q === m || D1(q, m, x);
          };
        }
        function hv(m, x) {
          return eh(m) && Vv(x) ? Wv(so(m), x) : function(q) {
            var W = lh(q, m);
            return W === n && W === x ? fh(q, m) : Uc(x, W, g | v);
          };
        }
        function Op(m, x, q, W, ne) {
          m !== x && R1(x, function(Ce, Ne) {
            if (ne || (ne = new La()), Jn(Ce))
              LP(m, x, Ne, q, Op, W, ne);
            else {
              var Ve = W ? W(rh(m, Ne), Ce, Ne + "", m, x, ne) : n;
              Ve === n && (Ve = Ce), T1(m, Ne, Ve);
            }
          }, Yi);
        }
        function LP(m, x, q, W, ne, Ce, Ne) {
          var Ve = rh(m, q), gt = rh(x, q), Ht = Ne.get(gt);
          if (Ht) {
            T1(m, q, Ht);
            return;
          }
          var zt = Ce ? Ce(Ve, gt, q + "", m, x, Ne) : n, er = zt === n;
          if (er) {
            var un = _n(gt), hn = !un && hs(gt), vn = !un && !hn && Hu(gt);
            zt = gt, un || hn || vn ? _n(Ve) ? zt = Ve : ni(Ve) ? zt = Ki(Ve) : hn ? (er = !1, zt = kv(gt, !0)) : vn ? (er = !1, zt = Ev(gt, !0)) : zt = [] : Wc(gt) || $s(gt) ? (zt = Ve, $s(Ve) ? zt = Sy(Ve) : (!Jn(Ve) || jo(Ve)) && (zt = Gv(gt))) : er = !1;
          }
          er && (Ne.set(gt, zt), ne(zt, gt, W, Ce, Ne), Ne.delete(gt)), T1(m, q, zt);
        }
        function mv(m, x) {
          var q = m.length;
          if (q)
            return x += x < 0 ? q : 0, Ro(x, q) ? m[x] : n;
        }
        function gv(m, x, q) {
          x.length ? x = Yt(x, function(Ce) {
            return _n(Ce) ? function(Ne) {
              return Ds(Ne, Ce.length === 1 ? Ce[0] : Ce);
            } : Ce;
          }) : x = [Ji];
          var W = -1;
          x = Yt(x, na(gn()));
          var ne = pv(m, function(Ce, Ne, Ve) {
            var gt = Yt(x, function(Ht) {
              return Ht(Ce);
            });
            return { criteria: gt, index: ++W, value: Ce };
          });
          return cT(ne, function(Ce, Ne) {
            return ZP(Ce, Ne, q);
          });
        }
        function NP(m, x) {
          return vv(m, x, function(q, W) {
            return fh(m, W);
          });
        }
        function vv(m, x, q) {
          for (var W = -1, ne = x.length, Ce = {}; ++W < ne; ) {
            var Ne = x[W], Ve = Ds(m, Ne);
            q(Ve, Ne) && Hc(Ce, ps(Ne, m), Ve);
          }
          return Ce;
        }
        function $P(m) {
          return function(x) {
            return Ds(x, m);
          };
        }
        function $1(m, x, q, W) {
          var ne = W ? uT : kn, Ce = -1, Ne = x.length, Ve = m;
          for (m === x && (x = Ki(x)), q && (Ve = Yt(m, na(q))); ++Ce < Ne; )
            for (var gt = 0, Ht = x[Ce], zt = q ? q(Ht) : Ht; (gt = ne(Ve, zt, gt, W)) > -1; )
              Ve !== m && yp.call(Ve, gt, 1), yp.call(m, gt, 1);
          return m;
        }
        function yv(m, x) {
          for (var q = m ? x.length : 0, W = q - 1; q--; ) {
            var ne = x[q];
            if (q == W || ne !== Ce) {
              var Ce = ne;
              Ro(ne) ? yp.call(m, ne, 1) : U1(m, ne);
            }
          }
          return m;
        }
        function M1(m, x) {
          return m + _p(Qg() * (x - m + 1));
        }
        function MP(m, x, q, W) {
          for (var ne = -1, Ce = ci(xp((x - m) / (q || 1)), 0), Ne = Dt(Ce); Ce--; )
            Ne[W ? Ce : ++ne] = m, m += q;
          return Ne;
        }
        function F1(m, x) {
          var q = "";
          if (!m || x < 1 || x > Pe)
            return q;
          do
            x % 2 && (q += m), x = _p(x / 2), x && (m += m);
          while (x);
          return q;
        }
        function On(m, x) {
          return nh(Kv(m, x, Ji), m + "");
        }
        function FP(m) {
          return tv(zu(m));
        }
        function BP(m, x) {
          var q = zu(m);
          return $p(q, qs(x, 0, q.length));
        }
        function Hc(m, x, q, W) {
          if (!Jn(m))
            return m;
          x = ps(x, m);
          for (var ne = -1, Ce = x.length, Ne = Ce - 1, Ve = m; Ve != null && ++ne < Ce; ) {
            var gt = so(x[ne]), Ht = q;
            if (gt === "__proto__" || gt === "constructor" || gt === "prototype")
              return m;
            if (ne != Ne) {
              var zt = Ve[gt];
              Ht = W ? W(zt, gt, Ve) : n, Ht === n && (Ht = Jn(zt) ? zt : Ro(x[ne + 1]) ? [] : {});
            }
            Mc(Ve, gt, Ht), Ve = Ve[gt];
          }
          return m;
        }
        var bv = wp ? function(m, x) {
          return wp.set(m, x), m;
        } : Ji, UP = bp ? function(m, x) {
          return bp(m, "toString", {
            configurable: !0,
            enumerable: !1,
            value: dh(x),
            writable: !0
          });
        } : Ji;
        function HP(m) {
          return $p(zu(m));
        }
        function ya(m, x, q) {
          var W = -1, ne = m.length;
          x < 0 && (x = -x > ne ? 0 : ne + x), q = q > ne ? ne : q, q < 0 && (q += ne), ne = x > q ? 0 : q - x >>> 0, x >>>= 0;
          for (var Ce = Dt(ne); ++W < ne; )
            Ce[W] = m[W + x];
          return Ce;
        }
        function zP(m, x) {
          var q;
          return ls(m, function(W, ne, Ce) {
            return q = x(W, ne, Ce), !q;
          }), !!q;
        }
        function Tp(m, x, q) {
          var W = 0, ne = m == null ? W : m.length;
          if (typeof x == "number" && x === x && ne <= we) {
            for (; W < ne; ) {
              var Ce = W + ne >>> 1, Ne = m[Ce];
              Ne !== null && !aa(Ne) && (q ? Ne <= x : Ne < x) ? W = Ce + 1 : ne = Ce;
            }
            return ne;
          }
          return B1(m, x, Ji, q);
        }
        function B1(m, x, q, W) {
          var ne = 0, Ce = m == null ? 0 : m.length;
          if (Ce === 0)
            return 0;
          x = q(x);
          for (var Ne = x !== x, Ve = x === null, gt = aa(x), Ht = x === n; ne < Ce; ) {
            var zt = _p((ne + Ce) / 2), er = q(m[zt]), un = er !== n, hn = er === null, vn = er === er, En = aa(er);
            if (Ne)
              var yn = W || vn;
            else Ht ? yn = vn && (W || un) : Ve ? yn = vn && un && (W || !hn) : gt ? yn = vn && un && !hn && (W || !En) : hn || En ? yn = !1 : yn = W ? er <= x : er < x;
            yn ? ne = zt + 1 : Ce = zt;
          }
          return Oi(Ce, Te);
        }
        function xv(m, x) {
          for (var q = -1, W = m.length, ne = 0, Ce = []; ++q < W; ) {
            var Ne = m[q], Ve = x ? x(Ne) : Ne;
            if (!q || !Na(Ve, gt)) {
              var gt = Ve;
              Ce[ne++] = Ne === 0 ? 0 : Ne;
            }
          }
          return Ce;
        }
        function _v(m) {
          return typeof m == "number" ? m : aa(m) ? Ae : +m;
        }
        function ia(m) {
          if (typeof m == "string")
            return m;
          if (_n(m))
            return Yt(m, ia) + "";
          if (aa(m))
            return Xg ? Xg.call(m) : "";
          var x = m + "";
          return x == "0" && 1 / m == -1 / 0 ? "-0" : x;
        }
        function fs(m, x, q) {
          var W = -1, ne = Ar, Ce = m.length, Ne = !0, Ve = [], gt = Ve;
          if (q)
            Ne = !1, ne = rr;
          else if (Ce >= i) {
            var Ht = x ? null : tR(m);
            if (Ht)
              return lp(Ht);
            Ne = !1, ne = Ic, gt = new Is();
          } else
            gt = x ? [] : Ve;
          e:
            for (; ++W < Ce; ) {
              var zt = m[W], er = x ? x(zt) : zt;
              if (zt = q || zt !== 0 ? zt : 0, Ne && er === er) {
                for (var un = gt.length; un--; )
                  if (gt[un] === er)
                    continue e;
                x && gt.push(er), Ve.push(zt);
              } else ne(gt, er, q) || (gt !== Ve && gt.push(er), Ve.push(zt));
            }
          return Ve;
        }
        function U1(m, x) {
          return x = ps(x, m), m = Zv(m, x), m == null || delete m[so(ba(x))];
        }
        function wv(m, x, q, W) {
          return Hc(m, x, q(Ds(m, x)), W);
        }
        function Pp(m, x, q, W) {
          for (var ne = m.length, Ce = W ? ne : -1; (W ? Ce-- : ++Ce < ne) && x(m[Ce], Ce, m); )
            ;
          return q ? ya(m, W ? 0 : Ce, W ? Ce + 1 : ne) : ya(m, W ? Ce + 1 : 0, W ? ne : Ce);
        }
        function Sv(m, x) {
          var q = m;
          return q instanceof jn && (q = q.value()), Er(x, function(W, ne) {
            return ne.func.apply(ne.thisArg, Qt([W], ne.args));
          }, q);
        }
        function H1(m, x, q) {
          var W = m.length;
          if (W < 2)
            return W ? fs(m[0]) : [];
          for (var ne = -1, Ce = Dt(W); ++ne < W; )
            for (var Ne = m[ne], Ve = -1; ++Ve < W; )
              Ve != ne && (Ce[ne] = Fc(Ce[ne] || Ne, m[Ve], x, q));
          return fs(ki(Ce, 1), x, q);
        }
        function Cv(m, x, q) {
          for (var W = -1, ne = m.length, Ce = x.length, Ne = {}; ++W < ne; ) {
            var Ve = W < Ce ? x[W] : n;
            q(Ne, m[W], Ve);
          }
          return Ne;
        }
        function z1(m) {
          return ni(m) ? m : [];
        }
        function G1(m) {
          return typeof m == "function" ? m : Ji;
        }
        function ps(m, x) {
          return _n(m) ? m : eh(m, x) ? [m] : Xv(Nn(m));
        }
        var GP = On;
        function ds(m, x, q) {
          var W = m.length;
          return q = q === n ? W : q, !x && q >= W ? m : ya(m, x, q);
        }
        var Av = jT || function(m) {
          return Xt.clearTimeout(m);
        };
        function kv(m, x) {
          if (x)
            return m.slice();
          var q = m.length, W = Wg ? Wg(q) : new m.constructor(q);
          return m.copy(W), W;
        }
        function V1(m) {
          var x = new m.constructor(m.byteLength);
          return new gp(x).set(new gp(m)), x;
        }
        function VP(m, x) {
          var q = x ? V1(m.buffer) : m.buffer;
          return new m.constructor(q, m.byteOffset, m.byteLength);
        }
        function WP(m) {
          var x = new m.constructor(m.source, je.exec(m));
          return x.lastIndex = m.lastIndex, x;
        }
        function KP(m) {
          return $c ? Un($c.call(m)) : {};
        }
        function Ev(m, x) {
          var q = x ? V1(m.buffer) : m.buffer;
          return new m.constructor(q, m.byteOffset, m.length);
        }
        function Ov(m, x) {
          if (m !== x) {
            var q = m !== n, W = m === null, ne = m === m, Ce = aa(m), Ne = x !== n, Ve = x === null, gt = x === x, Ht = aa(x);
            if (!Ve && !Ht && !Ce && m > x || Ce && Ne && gt && !Ve && !Ht || W && Ne && gt || !q && gt || !ne)
              return 1;
            if (!W && !Ce && !Ht && m < x || Ht && q && ne && !W && !Ce || Ve && q && ne || !Ne && ne || !gt)
              return -1;
          }
          return 0;
        }
        function ZP(m, x, q) {
          for (var W = -1, ne = m.criteria, Ce = x.criteria, Ne = ne.length, Ve = q.length; ++W < Ne; ) {
            var gt = Ov(ne[W], Ce[W]);
            if (gt) {
              if (W >= Ve)
                return gt;
              var Ht = q[W];
              return gt * (Ht == "desc" ? -1 : 1);
            }
          }
          return m.index - x.index;
        }
        function Tv(m, x, q, W) {
          for (var ne = -1, Ce = m.length, Ne = q.length, Ve = -1, gt = x.length, Ht = ci(Ce - Ne, 0), zt = Dt(gt + Ht), er = !W; ++Ve < gt; )
            zt[Ve] = x[Ve];
          for (; ++ne < Ne; )
            (er || ne < Ce) && (zt[q[ne]] = m[ne]);
          for (; Ht--; )
            zt[Ve++] = m[ne++];
          return zt;
        }
        function Pv(m, x, q, W) {
          for (var ne = -1, Ce = m.length, Ne = -1, Ve = q.length, gt = -1, Ht = x.length, zt = ci(Ce - Ve, 0), er = Dt(zt + Ht), un = !W; ++ne < zt; )
            er[ne] = m[ne];
          for (var hn = ne; ++gt < Ht; )
            er[hn + gt] = x[gt];
          for (; ++Ne < Ve; )
            (un || ne < Ce) && (er[hn + q[Ne]] = m[ne++]);
          return er;
        }
        function Ki(m, x) {
          var q = -1, W = m.length;
          for (x || (x = Dt(W)); ++q < W; )
            x[q] = m[q];
          return x;
        }
        function oo(m, x, q, W) {
          var ne = !q;
          q || (q = {});
          for (var Ce = -1, Ne = x.length; ++Ce < Ne; ) {
            var Ve = x[Ce], gt = W ? W(q[Ve], m[Ve], Ve, q, m) : n;
            gt === n && (gt = m[Ve]), ne ? Oo(q, Ve, gt) : Mc(q, Ve, gt);
          }
          return q;
        }
        function YP(m, x) {
          return oo(m, X1(m), x);
        }
        function JP(m, x) {
          return oo(m, Hv(m), x);
        }
        function Rp(m, x) {
          return function(q, W) {
            var ne = _n(q) ? hr : bP, Ce = x ? x() : {};
            return ne(q, m, gn(W, 2), Ce);
          };
        }
        function Fu(m) {
          return On(function(x, q) {
            var W = -1, ne = q.length, Ce = ne > 1 ? q[ne - 1] : n, Ne = ne > 2 ? q[2] : n;
            for (Ce = m.length > 3 && typeof Ce == "function" ? (ne--, Ce) : n, Ne && Mi(q[0], q[1], Ne) && (Ce = ne < 3 ? n : Ce, ne = 1), x = Un(x); ++W < ne; ) {
              var Ve = q[W];
              Ve && m(x, Ve, W, Ce);
            }
            return x;
          });
        }
        function Rv(m, x) {
          return function(q, W) {
            if (q == null)
              return q;
            if (!Zi(q))
              return m(q, W);
            for (var ne = q.length, Ce = x ? ne : -1, Ne = Un(q); (x ? Ce-- : ++Ce < ne) && W(Ne[Ce], Ce, Ne) !== !1; )
              ;
            return q;
          };
        }
        function jv(m) {
          return function(x, q, W) {
            for (var ne = -1, Ce = Un(x), Ne = W(x), Ve = Ne.length; Ve--; ) {
              var gt = Ne[m ? Ve : ++ne];
              if (q(Ce[gt], gt, Ce) === !1)
                break;
            }
            return x;
          };
        }
        function QP(m, x, q) {
          var W = x & b, ne = zc(m);
          function Ce() {
            var Ne = this && this !== Xt && this instanceof Ce ? ne : m;
            return Ne.apply(W ? q : this, arguments);
          }
          return Ce;
        }
        function Iv(m) {
          return function(x) {
            x = Nn(x);
            var q = Iu(x) ? Da(x) : n, W = q ? q[0] : x.charAt(0), ne = q ? ds(q, 1).join("") : x.slice(1);
            return W[m]() + ne;
          };
        }
        function Bu(m) {
          return function(x) {
            return Er(Ry(Py(x).replace(sn, "")), m, "");
          };
        }
        function zc(m) {
          return function() {
            var x = arguments;
            switch (x.length) {
              case 0:
                return new m();
              case 1:
                return new m(x[0]);
              case 2:
                return new m(x[0], x[1]);
              case 3:
                return new m(x[0], x[1], x[2]);
              case 4:
                return new m(x[0], x[1], x[2], x[3]);
              case 5:
                return new m(x[0], x[1], x[2], x[3], x[4]);
              case 6:
                return new m(x[0], x[1], x[2], x[3], x[4], x[5]);
              case 7:
                return new m(x[0], x[1], x[2], x[3], x[4], x[5], x[6]);
            }
            var q = Mu(m.prototype), W = m.apply(q, x);
            return Jn(W) ? W : q;
          };
        }
        function XP(m, x, q) {
          var W = zc(m);
          function ne() {
            for (var Ce = arguments.length, Ne = Dt(Ce), Ve = Ce, gt = Uu(ne); Ve--; )
              Ne[Ve] = arguments[Ve];
            var Ht = Ce < 3 && Ne[0] !== gt && Ne[Ce - 1] !== gt ? [] : us(Ne, gt);
            if (Ce -= Ht.length, Ce < q)
              return $v(
                m,
                x,
                jp,
                ne.placeholder,
                n,
                Ne,
                Ht,
                n,
                n,
                q - Ce
              );
            var zt = this && this !== Xt && this instanceof ne ? W : m;
            return dr(zt, this, Ne);
          }
          return ne;
        }
        function qv(m) {
          return function(x, q, W) {
            var ne = Un(x);
            if (!Zi(x)) {
              var Ce = gn(q, 3);
              x = gi(x), q = function(Ve) {
                return Ce(ne[Ve], Ve, ne);
              };
            }
            var Ne = m(x, q, W);
            return Ne > -1 ? ne[Ce ? x[Ne] : Ne] : n;
          };
        }
        function Dv(m) {
          return Po(function(x) {
            var q = x.length, W = q, ne = ga.prototype.thru;
            for (m && x.reverse(); W--; ) {
              var Ce = x[W];
              if (typeof Ce != "function")
                throw new ma(o);
              if (ne && !Ne && Lp(Ce) == "wrapper")
                var Ne = new ga([], !0);
            }
            for (W = Ne ? W : q; ++W < q; ) {
              Ce = x[W];
              var Ve = Lp(Ce), gt = Ve == "wrapper" ? J1(Ce) : n;
              gt && th(gt[0]) && gt[1] == ($ | C | E | Z) && !gt[4].length && gt[9] == 1 ? Ne = Ne[Lp(gt[0])].apply(Ne, gt[3]) : Ne = Ce.length == 1 && th(Ce) ? Ne[Ve]() : Ne.thru(Ce);
            }
            return function() {
              var Ht = arguments, zt = Ht[0];
              if (Ne && Ht.length == 1 && _n(zt))
                return Ne.plant(zt).value();
              for (var er = 0, un = q ? x[er].apply(this, Ht) : zt; ++er < q; )
                un = x[er].call(this, un);
              return un;
            };
          });
        }
        function jp(m, x, q, W, ne, Ce, Ne, Ve, gt, Ht) {
          var zt = x & $, er = x & b, un = x & y, hn = x & (C | T), vn = x & te, En = un ? n : zc(m);
          function yn() {
            for (var Pn = arguments.length, qn = Dt(Pn), oa = Pn; oa--; )
              qn[oa] = arguments[oa];
            if (hn)
              var Fi = Uu(yn), sa = fT(qn, Fi);
            if (W && (qn = Tv(qn, W, ne, hn)), Ce && (qn = Pv(qn, Ce, Ne, hn)), Pn -= sa, hn && Pn < Ht) {
              var ii = us(qn, Fi);
              return $v(
                m,
                x,
                jp,
                yn.placeholder,
                q,
                qn,
                ii,
                Ve,
                gt,
                Ht - Pn
              );
            }
            var $a = er ? q : this, qo = un ? $a[m] : m;
            return Pn = qn.length, Ve ? qn = bR(qn, Ve) : vn && Pn > 1 && qn.reverse(), zt && gt < Pn && (qn.length = gt), this && this !== Xt && this instanceof yn && (qo = En || zc(qo)), qo.apply($a, qn);
          }
          return yn;
        }
        function Lv(m, x) {
          return function(q, W) {
            return EP(q, m, x(W), {});
          };
        }
        function Ip(m, x) {
          return function(q, W) {
            var ne;
            if (q === n && W === n)
              return x;
            if (q !== n && (ne = q), W !== n) {
              if (ne === n)
                return W;
              typeof q == "string" || typeof W == "string" ? (q = ia(q), W = ia(W)) : (q = _v(q), W = _v(W)), ne = m(q, W);
            }
            return ne;
          };
        }
        function W1(m) {
          return Po(function(x) {
            return x = Yt(x, na(gn())), On(function(q) {
              var W = this;
              return m(x, function(ne) {
                return dr(ne, W, q);
              });
            });
          });
        }
        function qp(m, x) {
          x = x === n ? " " : ia(x);
          var q = x.length;
          if (q < 2)
            return q ? F1(x, m) : x;
          var W = F1(x, xp(m / qu(x)));
          return Iu(x) ? ds(Da(W), 0, m).join("") : W.slice(0, m);
        }
        function eR(m, x, q, W) {
          var ne = x & b, Ce = zc(m);
          function Ne() {
            for (var Ve = -1, gt = arguments.length, Ht = -1, zt = W.length, er = Dt(zt + gt), un = this && this !== Xt && this instanceof Ne ? Ce : m; ++Ht < zt; )
              er[Ht] = W[Ht];
            for (; gt--; )
              er[Ht++] = arguments[++Ve];
            return dr(un, ne ? q : this, er);
          }
          return Ne;
        }
        function Nv(m) {
          return function(x, q, W) {
            return W && typeof W != "number" && Mi(x, q, W) && (q = W = n), x = Io(x), q === n ? (q = x, x = 0) : q = Io(q), W = W === n ? x < q ? 1 : -1 : Io(W), MP(x, q, W, m);
          };
        }
        function Dp(m) {
          return function(x, q) {
            return typeof x == "string" && typeof q == "string" || (x = xa(x), q = xa(q)), m(x, q);
          };
        }
        function $v(m, x, q, W, ne, Ce, Ne, Ve, gt, Ht) {
          var zt = x & C, er = zt ? Ne : n, un = zt ? n : Ne, hn = zt ? Ce : n, vn = zt ? n : Ce;
          x |= zt ? E : D, x &= ~(zt ? D : E), x & w || (x &= -4);
          var En = [
            m,
            x,
            ne,
            hn,
            er,
            vn,
            un,
            Ve,
            gt,
            Ht
          ], yn = q.apply(n, En);
          return th(m) && Yv(yn, En), yn.placeholder = W, Jv(yn, m, x);
        }
        function K1(m) {
          var x = ui[m];
          return function(q, W) {
            if (q = xa(q), W = W == null ? 0 : Oi(Sn(W), 292), W && Jg(q)) {
              var ne = (Nn(q) + "e").split("e"), Ce = x(ne[0] + "e" + (+ne[1] + W));
              return ne = (Nn(Ce) + "e").split("e"), +(ne[0] + "e" + (+ne[1] - W));
            }
            return x(q);
          };
        }
        var tR = Nu && 1 / lp(new Nu([, -0]))[1] == $e ? function(m) {
          return new Nu(m);
        } : gh;
        function Mv(m) {
          return function(x) {
            var q = Ti(x);
            return q == Rt ? C1(x) : q == N ? yT(x) : lT(x, m(x));
          };
        }
        function To(m, x, q, W, ne, Ce, Ne, Ve) {
          var gt = x & y;
          if (!gt && typeof m != "function")
            throw new ma(o);
          var Ht = W ? W.length : 0;
          if (Ht || (x &= -97, W = ne = n), Ne = Ne === n ? Ne : ci(Sn(Ne), 0), Ve = Ve === n ? Ve : Sn(Ve), Ht -= ne ? ne.length : 0, x & D) {
            var zt = W, er = ne;
            W = ne = n;
          }
          var un = gt ? n : J1(m), hn = [
            m,
            x,
            q,
            W,
            ne,
            zt,
            er,
            Ce,
            Ne,
            Ve
          ];
          if (un && gR(hn, un), m = hn[0], x = hn[1], q = hn[2], W = hn[3], ne = hn[4], Ve = hn[9] = hn[9] === n ? gt ? 0 : m.length : ci(hn[9] - Ht, 0), !Ve && x & (C | T) && (x &= -25), !x || x == b)
            var vn = QP(m, x, q);
          else x == C || x == T ? vn = XP(m, x, Ve) : (x == E || x == (b | E)) && !ne.length ? vn = eR(m, x, q, W) : vn = jp.apply(n, hn);
          var En = un ? bv : Yv;
          return Jv(En(vn, hn), m, x);
        }
        function Fv(m, x, q, W) {
          return m === n || Na(m, Lu[q]) && !Mn.call(W, q) ? x : m;
        }
        function Bv(m, x, q, W, ne, Ce) {
          return Jn(m) && Jn(x) && (Ce.set(x, m), Op(m, x, n, Bv, Ce), Ce.delete(x)), m;
        }
        function rR(m) {
          return Wc(m) ? n : m;
        }
        function Uv(m, x, q, W, ne, Ce) {
          var Ne = q & g, Ve = m.length, gt = x.length;
          if (Ve != gt && !(Ne && gt > Ve))
            return !1;
          var Ht = Ce.get(m), zt = Ce.get(x);
          if (Ht && zt)
            return Ht == x && zt == m;
          var er = -1, un = !0, hn = q & v ? new Is() : n;
          for (Ce.set(m, x), Ce.set(x, m); ++er < Ve; ) {
            var vn = m[er], En = x[er];
            if (W)
              var yn = Ne ? W(En, vn, er, x, m, Ce) : W(vn, En, er, m, x, Ce);
            if (yn !== n) {
              if (yn)
                continue;
              un = !1;
              break;
            }
            if (hn) {
              if (!Or(x, function(Pn, qn) {
                if (!Ic(hn, qn) && (vn === Pn || ne(vn, Pn, q, W, Ce)))
                  return hn.push(qn);
              })) {
                un = !1;
                break;
              }
            } else if (!(vn === En || ne(vn, En, q, W, Ce))) {
              un = !1;
              break;
            }
          }
          return Ce.delete(m), Ce.delete(x), un;
        }
        function nR(m, x, q, W, ne, Ce, Ne) {
          switch (q) {
            case P:
              if (m.byteLength != x.byteLength || m.byteOffset != x.byteOffset)
                return !1;
              m = m.buffer, x = x.buffer;
            case Be:
              return !(m.byteLength != x.byteLength || !Ce(new gp(m), new gp(x)));
            case jt:
            case We:
            case Vr:
              return Na(+m, +x);
            case Fe:
              return m.name == x.name && m.message == x.message;
            case Ee:
            case Se:
              return m == x + "";
            case Rt:
              var Ve = C1;
            case N:
              var gt = W & g;
              if (Ve || (Ve = lp), m.size != x.size && !gt)
                return !1;
              var Ht = Ne.get(m);
              if (Ht)
                return Ht == x;
              W |= v, Ne.set(m, x);
              var zt = Uv(Ve(m), Ve(x), W, ne, Ce, Ne);
              return Ne.delete(m), zt;
            case Me:
              if ($c)
                return $c.call(m) == $c.call(x);
          }
          return !1;
        }
        function iR(m, x, q, W, ne, Ce) {
          var Ne = q & g, Ve = Z1(m), gt = Ve.length, Ht = Z1(x), zt = Ht.length;
          if (gt != zt && !Ne)
            return !1;
          for (var er = gt; er--; ) {
            var un = Ve[er];
            if (!(Ne ? un in x : Mn.call(x, un)))
              return !1;
          }
          var hn = Ce.get(m), vn = Ce.get(x);
          if (hn && vn)
            return hn == x && vn == m;
          var En = !0;
          Ce.set(m, x), Ce.set(x, m);
          for (var yn = Ne; ++er < gt; ) {
            un = Ve[er];
            var Pn = m[un], qn = x[un];
            if (W)
              var oa = Ne ? W(qn, Pn, un, x, m, Ce) : W(Pn, qn, un, m, x, Ce);
            if (!(oa === n ? Pn === qn || ne(Pn, qn, q, W, Ce) : oa)) {
              En = !1;
              break;
            }
            yn || (yn = un == "constructor");
          }
          if (En && !yn) {
            var Fi = m.constructor, sa = x.constructor;
            Fi != sa && "constructor" in m && "constructor" in x && !(typeof Fi == "function" && Fi instanceof Fi && typeof sa == "function" && sa instanceof sa) && (En = !1);
          }
          return Ce.delete(m), Ce.delete(x), En;
        }
        function Po(m) {
          return nh(Kv(m, n, ny), m + "");
        }
        function Z1(m) {
          return uv(m, gi, X1);
        }
        function Y1(m) {
          return uv(m, Yi, Hv);
        }
        var J1 = wp ? function(m) {
          return wp.get(m);
        } : gh;
        function Lp(m) {
          for (var x = m.name + "", q = $u[x], W = Mn.call($u, x) ? q.length : 0; W--; ) {
            var ne = q[W], Ce = ne.func;
            if (Ce == null || Ce == m)
              return ne.name;
          }
          return x;
        }
        function Uu(m) {
          var x = Mn.call(_e, "placeholder") ? _e : m;
          return x.placeholder;
        }
        function gn() {
          var m = _e.iteratee || hh;
          return m = m === hh ? fv : m, arguments.length ? m(arguments[0], arguments[1]) : m;
        }
        function Np(m, x) {
          var q = m.__data__;
          return pR(x) ? q[typeof x == "string" ? "string" : "hash"] : q.map;
        }
        function Q1(m) {
          for (var x = gi(m), q = x.length; q--; ) {
            var W = x[q], ne = m[W];
            x[q] = [W, ne, Vv(ne)];
          }
          return x;
        }
        function Ls(m, x) {
          var q = mT(m, x);
          return lv(q) ? q : n;
        }
        function aR(m) {
          var x = Mn.call(m, Rs), q = m[Rs];
          try {
            m[Rs] = n;
            var W = !0;
          } catch {
          }
          var ne = hp.call(m);
          return W && (x ? m[Rs] = q : delete m[Rs]), ne;
        }
        var X1 = k1 ? function(m) {
          return m == null ? [] : (m = Un(m), Jt(k1(m), function(x) {
            return Zg.call(m, x);
          }));
        } : vh, Hv = k1 ? function(m) {
          for (var x = []; m; )
            Qt(x, X1(m)), m = vp(m);
          return x;
        } : vh, Ti = $i;
        (E1 && Ti(new E1(new ArrayBuffer(1))) != P || Dc && Ti(new Dc()) != Rt || O1 && Ti(O1.resolve()) != Y || Nu && Ti(new Nu()) != N || Lc && Ti(new Lc()) != Ke) && (Ti = function(m) {
          var x = $i(m), q = x == G ? m.constructor : n, W = q ? Ns(q) : "";
          if (W)
            switch (W) {
              case BT:
                return P;
              case UT:
                return Rt;
              case HT:
                return Y;
              case zT:
                return N;
              case GT:
                return Ke;
            }
          return x;
        });
        function oR(m, x, q) {
          for (var W = -1, ne = q.length; ++W < ne; ) {
            var Ce = q[W], Ne = Ce.size;
            switch (Ce.type) {
              case "drop":
                m += Ne;
                break;
              case "dropRight":
                x -= Ne;
                break;
              case "take":
                x = Oi(x, m + Ne);
                break;
              case "takeRight":
                m = ci(m, x - Ne);
                break;
            }
          }
          return { start: m, end: x };
        }
        function sR(m) {
          var x = m.match(be);
          return x ? x[1].split(ge) : [];
        }
        function zv(m, x, q) {
          x = ps(x, m);
          for (var W = -1, ne = x.length, Ce = !1; ++W < ne; ) {
            var Ne = so(x[W]);
            if (!(Ce = m != null && q(m, Ne)))
              break;
            m = m[Ne];
          }
          return Ce || ++W != ne ? Ce : (ne = m == null ? 0 : m.length, !!ne && zp(ne) && Ro(Ne, ne) && (_n(m) || $s(m)));
        }
        function uR(m) {
          var x = m.length, q = new m.constructor(x);
          return x && typeof m[0] == "string" && Mn.call(m, "index") && (q.index = m.index, q.input = m.input), q;
        }
        function Gv(m) {
          return typeof m.constructor == "function" && !Gc(m) ? Mu(vp(m)) : {};
        }
        function cR(m, x, q) {
          var W = m.constructor;
          switch (x) {
            case Be:
              return V1(m);
            case jt:
            case We:
              return new W(+m);
            case P:
              return VP(m, q);
            case M:
            case F:
            case O:
            case S:
            case _:
            case h:
            case A:
            case R:
            case I:
              return Ev(m, q);
            case Rt:
              return new W();
            case Vr:
            case Se:
              return new W(m);
            case Ee:
              return WP(m);
            case N:
              return new W();
            case Me:
              return KP(m);
          }
        }
        function lR(m, x) {
          var q = x.length;
          if (!q)
            return m;
          var W = q - 1;
          return x[W] = (q > 1 ? "& " : "") + x[W], x = x.join(q > 2 ? ", " : " "), m.replace(fe, `{
/* [wrapped with ` + x + `] */
`);
        }
        function fR(m) {
          return _n(m) || $s(m) || !!(Yg && m && m[Yg]);
        }
        function Ro(m, x) {
          var q = typeof m;
          return x = x ?? Pe, !!x && (q == "number" || q != "symbol" && pt.test(m)) && m > -1 && m % 1 == 0 && m < x;
        }
        function Mi(m, x, q) {
          if (!Jn(q))
            return !1;
          var W = typeof x;
          return (W == "number" ? Zi(q) && Ro(x, q.length) : W == "string" && x in q) ? Na(q[x], m) : !1;
        }
        function eh(m, x) {
          if (_n(m))
            return !1;
          var q = typeof m;
          return q == "number" || q == "symbol" || q == "boolean" || m == null || aa(m) ? !0 : ue.test(m) || !X.test(m) || x != null && m in Un(x);
        }
        function pR(m) {
          var x = typeof m;
          return x == "string" || x == "number" || x == "symbol" || x == "boolean" ? m !== "__proto__" : m === null;
        }
        function th(m) {
          var x = Lp(m), q = _e[x];
          if (typeof q != "function" || !(x in jn.prototype))
            return !1;
          if (m === q)
            return !0;
          var W = J1(q);
          return !!W && m === W[0];
        }
        function dR(m) {
          return !!Vg && Vg in m;
        }
        var hR = pp ? jo : yh;
        function Gc(m) {
          var x = m && m.constructor, q = typeof x == "function" && x.prototype || Lu;
          return m === q;
        }
        function Vv(m) {
          return m === m && !Jn(m);
        }
        function Wv(m, x) {
          return function(q) {
            return q == null ? !1 : q[m] === x && (x !== n || m in Un(q));
          };
        }
        function mR(m) {
          var x = Up(m, function(W) {
            return q.size === s && q.clear(), W;
          }), q = x.cache;
          return x;
        }
        function gR(m, x) {
          var q = m[1], W = x[1], ne = q | W, Ce = ne < (b | y | $), Ne = W == $ && q == C || W == $ && q == Z && m[7].length <= x[8] || W == ($ | Z) && x[7].length <= x[8] && q == C;
          if (!(Ce || Ne))
            return m;
          W & b && (m[2] = x[2], ne |= q & b ? 0 : w);
          var Ve = x[3];
          if (Ve) {
            var gt = m[3];
            m[3] = gt ? Tv(gt, Ve, x[4]) : Ve, m[4] = gt ? us(m[3], f) : x[4];
          }
          return Ve = x[5], Ve && (gt = m[5], m[5] = gt ? Pv(gt, Ve, x[6]) : Ve, m[6] = gt ? us(m[5], f) : x[6]), Ve = x[7], Ve && (m[7] = Ve), W & $ && (m[8] = m[8] == null ? x[8] : Oi(m[8], x[8])), m[9] == null && (m[9] = x[9]), m[0] = x[0], m[1] = ne, m;
        }
        function vR(m) {
          var x = [];
          if (m != null)
            for (var q in Un(m))
              x.push(q);
          return x;
        }
        function yR(m) {
          return hp.call(m);
        }
        function Kv(m, x, q) {
          return x = ci(x === n ? m.length - 1 : x, 0), function() {
            for (var W = arguments, ne = -1, Ce = ci(W.length - x, 0), Ne = Dt(Ce); ++ne < Ce; )
              Ne[ne] = W[x + ne];
            ne = -1;
            for (var Ve = Dt(x + 1); ++ne < x; )
              Ve[ne] = W[ne];
            return Ve[x] = q(Ne), dr(m, this, Ve);
          };
        }
        function Zv(m, x) {
          return x.length < 2 ? m : Ds(m, ya(x, 0, -1));
        }
        function bR(m, x) {
          for (var q = m.length, W = Oi(x.length, q), ne = Ki(m); W--; ) {
            var Ce = x[W];
            m[W] = Ro(Ce, q) ? ne[Ce] : n;
          }
          return m;
        }
        function rh(m, x) {
          if (!(x === "constructor" && typeof m[x] == "function") && x != "__proto__")
            return m[x];
        }
        var Yv = Qv(bv), Vc = qT || function(m, x) {
          return Xt.setTimeout(m, x);
        }, nh = Qv(UP);
        function Jv(m, x, q) {
          var W = x + "";
          return nh(m, lR(W, xR(sR(W), q)));
        }
        function Qv(m) {
          var x = 0, q = 0;
          return function() {
            var W = $T(), ne = re - (W - q);
            if (q = W, ne > 0) {
              if (++x >= K)
                return arguments[0];
            } else
              x = 0;
            return m.apply(n, arguments);
          };
        }
        function $p(m, x) {
          var q = -1, W = m.length, ne = W - 1;
          for (x = x === n ? W : x; ++q < x; ) {
            var Ce = M1(q, ne), Ne = m[Ce];
            m[Ce] = m[q], m[q] = Ne;
          }
          return m.length = x, m;
        }
        var Xv = mR(function(m) {
          var x = [];
          return m.charCodeAt(0) === 46 && x.push(""), m.replace(ve, function(q, W, ne, Ce) {
            x.push(ne ? Ce.replace(he, "$1") : W || q);
          }), x;
        });
        function so(m) {
          if (typeof m == "string" || aa(m))
            return m;
          var x = m + "";
          return x == "0" && 1 / m == -1 / 0 ? "-0" : x;
        }
        function Ns(m) {
          if (m != null) {
            try {
              return dp.call(m);
            } catch {
            }
            try {
              return m + "";
            } catch {
            }
          }
          return "";
        }
        function xR(m, x) {
          return br(qe, function(q) {
            var W = "_." + q[0];
            x & q[1] && !Ar(m, W) && m.push(W);
          }), m.sort();
        }
        function ey(m) {
          if (m instanceof jn)
            return m.clone();
          var x = new ga(m.__wrapped__, m.__chain__);
          return x.__actions__ = Ki(m.__actions__), x.__index__ = m.__index__, x.__values__ = m.__values__, x;
        }
        function _R(m, x, q) {
          (q ? Mi(m, x, q) : x === n) ? x = 1 : x = ci(Sn(x), 0);
          var W = m == null ? 0 : m.length;
          if (!W || x < 1)
            return [];
          for (var ne = 0, Ce = 0, Ne = Dt(xp(W / x)); ne < W; )
            Ne[Ce++] = ya(m, ne, ne += x);
          return Ne;
        }
        function wR(m) {
          for (var x = -1, q = m == null ? 0 : m.length, W = 0, ne = []; ++x < q; ) {
            var Ce = m[x];
            Ce && (ne[W++] = Ce);
          }
          return ne;
        }
        function SR() {
          var m = arguments.length;
          if (!m)
            return [];
          for (var x = Dt(m - 1), q = arguments[0], W = m; W--; )
            x[W - 1] = arguments[W];
          return Qt(_n(q) ? Ki(q) : [q], ki(x, 1));
        }
        var CR = On(function(m, x) {
          return ni(m) ? Fc(m, ki(x, 1, ni, !0)) : [];
        }), AR = On(function(m, x) {
          var q = ba(x);
          return ni(q) && (q = n), ni(m) ? Fc(m, ki(x, 1, ni, !0), gn(q, 2)) : [];
        }), kR = On(function(m, x) {
          var q = ba(x);
          return ni(q) && (q = n), ni(m) ? Fc(m, ki(x, 1, ni, !0), n, q) : [];
        });
        function ER(m, x, q) {
          var W = m == null ? 0 : m.length;
          return W ? (x = q || x === n ? 1 : Sn(x), ya(m, x < 0 ? 0 : x, W)) : [];
        }
        function OR(m, x, q) {
          var W = m == null ? 0 : m.length;
          return W ? (x = q || x === n ? 1 : Sn(x), x = W - x, ya(m, 0, x < 0 ? 0 : x)) : [];
        }
        function TR(m, x) {
          return m && m.length ? Pp(m, gn(x, 3), !0, !0) : [];
        }
        function PR(m, x) {
          return m && m.length ? Pp(m, gn(x, 3), !0) : [];
        }
        function RR(m, x, q, W) {
          var ne = m == null ? 0 : m.length;
          return ne ? (q && typeof q != "number" && Mi(m, x, q) && (q = 0, W = ne), SP(m, x, q, W)) : [];
        }
        function ty(m, x, q) {
          var W = m == null ? 0 : m.length;
          if (!W)
            return -1;
          var ne = q == null ? 0 : Sn(q);
          return ne < 0 && (ne = ci(W + ne, 0)), cn(m, gn(x, 3), ne);
        }
        function ry(m, x, q) {
          var W = m == null ? 0 : m.length;
          if (!W)
            return -1;
          var ne = W - 1;
          return q !== n && (ne = Sn(q), ne = q < 0 ? ci(W + ne, 0) : Oi(ne, W - 1)), cn(m, gn(x, 3), ne, !0);
        }
        function ny(m) {
          var x = m == null ? 0 : m.length;
          return x ? ki(m, 1) : [];
        }
        function jR(m) {
          var x = m == null ? 0 : m.length;
          return x ? ki(m, $e) : [];
        }
        function IR(m, x) {
          var q = m == null ? 0 : m.length;
          return q ? (x = x === n ? 1 : Sn(x), ki(m, x)) : [];
        }
        function qR(m) {
          for (var x = -1, q = m == null ? 0 : m.length, W = {}; ++x < q; ) {
            var ne = m[x];
            W[ne[0]] = ne[1];
          }
          return W;
        }
        function iy(m) {
          return m && m.length ? m[0] : n;
        }
        function DR(m, x, q) {
          var W = m == null ? 0 : m.length;
          if (!W)
            return -1;
          var ne = q == null ? 0 : Sn(q);
          return ne < 0 && (ne = ci(W + ne, 0)), kn(m, x, ne);
        }
        function LR(m) {
          var x = m == null ? 0 : m.length;
          return x ? ya(m, 0, -1) : [];
        }
        var NR = On(function(m) {
          var x = Yt(m, z1);
          return x.length && x[0] === m[0] ? q1(x) : [];
        }), $R = On(function(m) {
          var x = ba(m), q = Yt(m, z1);
          return x === ba(q) ? x = n : q.pop(), q.length && q[0] === m[0] ? q1(q, gn(x, 2)) : [];
        }), MR = On(function(m) {
          var x = ba(m), q = Yt(m, z1);
          return x = typeof x == "function" ? x : n, x && q.pop(), q.length && q[0] === m[0] ? q1(q, n, x) : [];
        });
        function FR(m, x) {
          return m == null ? "" : LT.call(m, x);
        }
        function ba(m) {
          var x = m == null ? 0 : m.length;
          return x ? m[x - 1] : n;
        }
        function BR(m, x, q) {
          var W = m == null ? 0 : m.length;
          if (!W)
            return -1;
          var ne = W;
          return q !== n && (ne = Sn(q), ne = ne < 0 ? ci(W + ne, 0) : Oi(ne, W - 1)), x === x ? xT(m, x, ne) : cn(m, $g, ne, !0);
        }
        function UR(m, x) {
          return m && m.length ? mv(m, Sn(x)) : n;
        }
        var HR = On(ay);
        function ay(m, x) {
          return m && m.length && x && x.length ? $1(m, x) : m;
        }
        function zR(m, x, q) {
          return m && m.length && x && x.length ? $1(m, x, gn(q, 2)) : m;
        }
        function GR(m, x, q) {
          return m && m.length && x && x.length ? $1(m, x, n, q) : m;
        }
        var VR = Po(function(m, x) {
          var q = m == null ? 0 : m.length, W = P1(m, x);
          return yv(m, Yt(x, function(ne) {
            return Ro(ne, q) ? +ne : ne;
          }).sort(Ov)), W;
        });
        function WR(m, x) {
          var q = [];
          if (!(m && m.length))
            return q;
          var W = -1, ne = [], Ce = m.length;
          for (x = gn(x, 3); ++W < Ce; ) {
            var Ne = m[W];
            x(Ne, W, m) && (q.push(Ne), ne.push(W));
          }
          return yv(m, ne), q;
        }
        function ih(m) {
          return m == null ? m : FT.call(m);
        }
        function KR(m, x, q) {
          var W = m == null ? 0 : m.length;
          return W ? (q && typeof q != "number" && Mi(m, x, q) ? (x = 0, q = W) : (x = x == null ? 0 : Sn(x), q = q === n ? W : Sn(q)), ya(m, x, q)) : [];
        }
        function ZR(m, x) {
          return Tp(m, x);
        }
        function YR(m, x, q) {
          return B1(m, x, gn(q, 2));
        }
        function JR(m, x) {
          var q = m == null ? 0 : m.length;
          if (q) {
            var W = Tp(m, x);
            if (W < q && Na(m[W], x))
              return W;
          }
          return -1;
        }
        function QR(m, x) {
          return Tp(m, x, !0);
        }
        function XR(m, x, q) {
          return B1(m, x, gn(q, 2), !0);
        }
        function ej(m, x) {
          var q = m == null ? 0 : m.length;
          if (q) {
            var W = Tp(m, x, !0) - 1;
            if (Na(m[W], x))
              return W;
          }
          return -1;
        }
        function tj(m) {
          return m && m.length ? xv(m) : [];
        }
        function rj(m, x) {
          return m && m.length ? xv(m, gn(x, 2)) : [];
        }
        function nj(m) {
          var x = m == null ? 0 : m.length;
          return x ? ya(m, 1, x) : [];
        }
        function ij(m, x, q) {
          return m && m.length ? (x = q || x === n ? 1 : Sn(x), ya(m, 0, x < 0 ? 0 : x)) : [];
        }
        function aj(m, x, q) {
          var W = m == null ? 0 : m.length;
          return W ? (x = q || x === n ? 1 : Sn(x), x = W - x, ya(m, x < 0 ? 0 : x, W)) : [];
        }
        function oj(m, x) {
          return m && m.length ? Pp(m, gn(x, 3), !1, !0) : [];
        }
        function sj(m, x) {
          return m && m.length ? Pp(m, gn(x, 3)) : [];
        }
        var uj = On(function(m) {
          return fs(ki(m, 1, ni, !0));
        }), cj = On(function(m) {
          var x = ba(m);
          return ni(x) && (x = n), fs(ki(m, 1, ni, !0), gn(x, 2));
        }), lj = On(function(m) {
          var x = ba(m);
          return x = typeof x == "function" ? x : n, fs(ki(m, 1, ni, !0), n, x);
        });
        function fj(m) {
          return m && m.length ? fs(m) : [];
        }
        function pj(m, x) {
          return m && m.length ? fs(m, gn(x, 2)) : [];
        }
        function dj(m, x) {
          return x = typeof x == "function" ? x : n, m && m.length ? fs(m, n, x) : [];
        }
        function ah(m) {
          if (!(m && m.length))
            return [];
          var x = 0;
          return m = Jt(m, function(q) {
            if (ni(q))
              return x = ci(q.length, x), !0;
          }), w1(x, function(q) {
            return Yt(m, b1(q));
          });
        }
        function oy(m, x) {
          if (!(m && m.length))
            return [];
          var q = ah(m);
          return x == null ? q : Yt(q, function(W) {
            return dr(x, n, W);
          });
        }
        var hj = On(function(m, x) {
          return ni(m) ? Fc(m, x) : [];
        }), mj = On(function(m) {
          return H1(Jt(m, ni));
        }), gj = On(function(m) {
          var x = ba(m);
          return ni(x) && (x = n), H1(Jt(m, ni), gn(x, 2));
        }), vj = On(function(m) {
          var x = ba(m);
          return x = typeof x == "function" ? x : n, H1(Jt(m, ni), n, x);
        }), yj = On(ah);
        function bj(m, x) {
          return Cv(m || [], x || [], Mc);
        }
        function xj(m, x) {
          return Cv(m || [], x || [], Hc);
        }
        var _j = On(function(m) {
          var x = m.length, q = x > 1 ? m[x - 1] : n;
          return q = typeof q == "function" ? (m.pop(), q) : n, oy(m, q);
        });
        function sy(m) {
          var x = _e(m);
          return x.__chain__ = !0, x;
        }
        function wj(m, x) {
          return x(m), m;
        }
        function Mp(m, x) {
          return x(m);
        }
        var Sj = Po(function(m) {
          var x = m.length, q = x ? m[0] : 0, W = this.__wrapped__, ne = function(Ce) {
            return P1(Ce, m);
          };
          return x > 1 || this.__actions__.length || !(W instanceof jn) || !Ro(q) ? this.thru(ne) : (W = W.slice(q, +q + (x ? 1 : 0)), W.__actions__.push({
            func: Mp,
            args: [ne],
            thisArg: n
          }), new ga(W, this.__chain__).thru(function(Ce) {
            return x && !Ce.length && Ce.push(n), Ce;
          }));
        });
        function Cj() {
          return sy(this);
        }
        function Aj() {
          return new ga(this.value(), this.__chain__);
        }
        function kj() {
          this.__values__ === n && (this.__values__ = _y(this.value()));
          var m = this.__index__ >= this.__values__.length, x = m ? n : this.__values__[this.__index__++];
          return { done: m, value: x };
        }
        function Ej() {
          return this;
        }
        function Oj(m) {
          for (var x, q = this; q instanceof Cp; ) {
            var W = ey(q);
            W.__index__ = 0, W.__values__ = n, x ? ne.__wrapped__ = W : x = W;
            var ne = W;
            q = q.__wrapped__;
          }
          return ne.__wrapped__ = m, x;
        }
        function Tj() {
          var m = this.__wrapped__;
          if (m instanceof jn) {
            var x = m;
            return this.__actions__.length && (x = new jn(this)), x = x.reverse(), x.__actions__.push({
              func: Mp,
              args: [ih],
              thisArg: n
            }), new ga(x, this.__chain__);
          }
          return this.thru(ih);
        }
        function Pj() {
          return Sv(this.__wrapped__, this.__actions__);
        }
        var Rj = Rp(function(m, x, q) {
          Mn.call(m, q) ? ++m[q] : Oo(m, q, 1);
        });
        function jj(m, x, q) {
          var W = _n(m) ? Ir : wP;
          return q && Mi(m, x, q) && (x = n), W(m, gn(x, 3));
        }
        function Ij(m, x) {
          var q = _n(m) ? Jt : ov;
          return q(m, gn(x, 3));
        }
        var qj = qv(ty), Dj = qv(ry);
        function Lj(m, x) {
          return ki(Fp(m, x), 1);
        }
        function Nj(m, x) {
          return ki(Fp(m, x), $e);
        }
        function $j(m, x, q) {
          return q = q === n ? 1 : Sn(q), ki(Fp(m, x), q);
        }
        function uy(m, x) {
          var q = _n(m) ? br : ls;
          return q(m, gn(x, 3));
        }
        function cy(m, x) {
          var q = _n(m) ? mr : av;
          return q(m, gn(x, 3));
        }
        var Mj = Rp(function(m, x, q) {
          Mn.call(m, q) ? m[q].push(x) : Oo(m, q, [x]);
        });
        function Fj(m, x, q, W) {
          m = Zi(m) ? m : zu(m), q = q && !W ? Sn(q) : 0;
          var ne = m.length;
          return q < 0 && (q = ci(ne + q, 0)), Gp(m) ? q <= ne && m.indexOf(x, q) > -1 : !!ne && kn(m, x, q) > -1;
        }
        var Bj = On(function(m, x, q) {
          var W = -1, ne = typeof x == "function", Ce = Zi(m) ? Dt(m.length) : [];
          return ls(m, function(Ne) {
            Ce[++W] = ne ? dr(x, Ne, q) : Bc(Ne, x, q);
          }), Ce;
        }), Uj = Rp(function(m, x, q) {
          Oo(m, q, x);
        });
        function Fp(m, x) {
          var q = _n(m) ? Yt : pv;
          return q(m, gn(x, 3));
        }
        function Hj(m, x, q, W) {
          return m == null ? [] : (_n(x) || (x = x == null ? [] : [x]), q = W ? n : q, _n(q) || (q = q == null ? [] : [q]), gv(m, x, q));
        }
        var zj = Rp(function(m, x, q) {
          m[q ? 0 : 1].push(x);
        }, function() {
          return [[], []];
        });
        function Gj(m, x, q) {
          var W = _n(m) ? Er : Fg, ne = arguments.length < 3;
          return W(m, gn(x, 4), q, ne, ls);
        }
        function Vj(m, x, q) {
          var W = _n(m) ? gr : Fg, ne = arguments.length < 3;
          return W(m, gn(x, 4), q, ne, av);
        }
        function Wj(m, x) {
          var q = _n(m) ? Jt : ov;
          return q(m, Hp(gn(x, 3)));
        }
        function Kj(m) {
          var x = _n(m) ? tv : FP;
          return x(m);
        }
        function Zj(m, x, q) {
          (q ? Mi(m, x, q) : x === n) ? x = 1 : x = Sn(x);
          var W = _n(m) ? vP : BP;
          return W(m, x);
        }
        function Yj(m) {
          var x = _n(m) ? yP : HP;
          return x(m);
        }
        function Jj(m) {
          if (m == null)
            return 0;
          if (Zi(m))
            return Gp(m) ? qu(m) : m.length;
          var x = Ti(m);
          return x == Rt || x == N ? m.size : L1(m).length;
        }
        function Qj(m, x, q) {
          var W = _n(m) ? Or : zP;
          return q && Mi(m, x, q) && (x = n), W(m, gn(x, 3));
        }
        var Xj = On(function(m, x) {
          if (m == null)
            return [];
          var q = x.length;
          return q > 1 && Mi(m, x[0], x[1]) ? x = [] : q > 2 && Mi(x[0], x[1], x[2]) && (x = [x[0]]), gv(m, ki(x, 1), []);
        }), Bp = IT || function() {
          return Xt.Date.now();
        };
        function eI(m, x) {
          if (typeof x != "function")
            throw new ma(o);
          return m = Sn(m), function() {
            if (--m < 1)
              return x.apply(this, arguments);
          };
        }
        function ly(m, x, q) {
          return x = q ? n : x, x = m && x == null ? m.length : x, To(m, $, n, n, n, n, x);
        }
        function fy(m, x) {
          var q;
          if (typeof x != "function")
            throw new ma(o);
          return m = Sn(m), function() {
            return --m > 0 && (q = x.apply(this, arguments)), m <= 1 && (x = n), q;
          };
        }
        var oh = On(function(m, x, q) {
          var W = b;
          if (q.length) {
            var ne = us(q, Uu(oh));
            W |= E;
          }
          return To(m, W, x, q, ne);
        }), py = On(function(m, x, q) {
          var W = b | y;
          if (q.length) {
            var ne = us(q, Uu(py));
            W |= E;
          }
          return To(x, W, m, q, ne);
        });
        function dy(m, x, q) {
          x = q ? n : x;
          var W = To(m, C, n, n, n, n, n, x);
          return W.placeholder = dy.placeholder, W;
        }
        function hy(m, x, q) {
          x = q ? n : x;
          var W = To(m, T, n, n, n, n, n, x);
          return W.placeholder = hy.placeholder, W;
        }
        function my(m, x, q) {
          var W, ne, Ce, Ne, Ve, gt, Ht = 0, zt = !1, er = !1, un = !0;
          if (typeof m != "function")
            throw new ma(o);
          x = xa(x) || 0, Jn(q) && (zt = !!q.leading, er = "maxWait" in q, Ce = er ? ci(xa(q.maxWait) || 0, x) : Ce, un = "trailing" in q ? !!q.trailing : un);
          function hn(ii) {
            var $a = W, qo = ne;
            return W = ne = n, Ht = ii, Ne = m.apply(qo, $a), Ne;
          }
          function vn(ii) {
            return Ht = ii, Ve = Vc(Pn, x), zt ? hn(ii) : Ne;
          }
          function En(ii) {
            var $a = ii - gt, qo = ii - Ht, qy = x - $a;
            return er ? Oi(qy, Ce - qo) : qy;
          }
          function yn(ii) {
            var $a = ii - gt, qo = ii - Ht;
            return gt === n || $a >= x || $a < 0 || er && qo >= Ce;
          }
          function Pn() {
            var ii = Bp();
            if (yn(ii))
              return qn(ii);
            Ve = Vc(Pn, En(ii));
          }
          function qn(ii) {
            return Ve = n, un && W ? hn(ii) : (W = ne = n, Ne);
          }
          function oa() {
            Ve !== n && Av(Ve), Ht = 0, W = gt = ne = Ve = n;
          }
          function Fi() {
            return Ve === n ? Ne : qn(Bp());
          }
          function sa() {
            var ii = Bp(), $a = yn(ii);
            if (W = arguments, ne = this, gt = ii, $a) {
              if (Ve === n)
                return vn(gt);
              if (er)
                return Av(Ve), Ve = Vc(Pn, x), hn(gt);
            }
            return Ve === n && (Ve = Vc(Pn, x)), Ne;
          }
          return sa.cancel = oa, sa.flush = Fi, sa;
        }
        var tI = On(function(m, x) {
          return iv(m, 1, x);
        }), rI = On(function(m, x, q) {
          return iv(m, xa(x) || 0, q);
        });
        function nI(m) {
          return To(m, te);
        }
        function Up(m, x) {
          if (typeof m != "function" || x != null && typeof x != "function")
            throw new ma(o);
          var q = function() {
            var W = arguments, ne = x ? x.apply(this, W) : W[0], Ce = q.cache;
            if (Ce.has(ne))
              return Ce.get(ne);
            var Ne = m.apply(this, W);
            return q.cache = Ce.set(ne, Ne) || Ce, Ne;
          };
          return q.cache = new (Up.Cache || Eo)(), q;
        }
        Up.Cache = Eo;
        function Hp(m) {
          if (typeof m != "function")
            throw new ma(o);
          return function() {
            var x = arguments;
            switch (x.length) {
              case 0:
                return !m.call(this);
              case 1:
                return !m.call(this, x[0]);
              case 2:
                return !m.call(this, x[0], x[1]);
              case 3:
                return !m.call(this, x[0], x[1], x[2]);
            }
            return !m.apply(this, x);
          };
        }
        function iI(m) {
          return fy(2, m);
        }
        var aI = GP(function(m, x) {
          x = x.length == 1 && _n(x[0]) ? Yt(x[0], na(gn())) : Yt(ki(x, 1), na(gn()));
          var q = x.length;
          return On(function(W) {
            for (var ne = -1, Ce = Oi(W.length, q); ++ne < Ce; )
              W[ne] = x[ne].call(this, W[ne]);
            return dr(m, this, W);
          });
        }), sh = On(function(m, x) {
          var q = us(x, Uu(sh));
          return To(m, E, n, x, q);
        }), gy = On(function(m, x) {
          var q = us(x, Uu(gy));
          return To(m, D, n, x, q);
        }), oI = Po(function(m, x) {
          return To(m, Z, n, n, n, x);
        });
        function sI(m, x) {
          if (typeof m != "function")
            throw new ma(o);
          return x = x === n ? x : Sn(x), On(m, x);
        }
        function uI(m, x) {
          if (typeof m != "function")
            throw new ma(o);
          return x = x == null ? 0 : ci(Sn(x), 0), On(function(q) {
            var W = q[x], ne = ds(q, 0, x);
            return W && Qt(ne, W), dr(m, this, ne);
          });
        }
        function cI(m, x, q) {
          var W = !0, ne = !0;
          if (typeof m != "function")
            throw new ma(o);
          return Jn(q) && (W = "leading" in q ? !!q.leading : W, ne = "trailing" in q ? !!q.trailing : ne), my(m, x, {
            leading: W,
            maxWait: x,
            trailing: ne
          });
        }
        function lI(m) {
          return ly(m, 1);
        }
        function fI(m, x) {
          return sh(G1(x), m);
        }
        function pI() {
          if (!arguments.length)
            return [];
          var m = arguments[0];
          return _n(m) ? m : [m];
        }
        function dI(m) {
          return va(m, p);
        }
        function hI(m, x) {
          return x = typeof x == "function" ? x : n, va(m, p, x);
        }
        function mI(m) {
          return va(m, d | p);
        }
        function gI(m, x) {
          return x = typeof x == "function" ? x : n, va(m, d | p, x);
        }
        function vI(m, x) {
          return x == null || nv(m, x, gi(x));
        }
        function Na(m, x) {
          return m === x || m !== m && x !== x;
        }
        var yI = Dp(I1), bI = Dp(function(m, x) {
          return m >= x;
        }), $s = cv(/* @__PURE__ */ function() {
          return arguments;
        }()) ? cv : function(m) {
          return ei(m) && Mn.call(m, "callee") && !Zg.call(m, "callee");
        }, _n = Dt.isArray, xI = Pr ? na(Pr) : OP;
        function Zi(m) {
          return m != null && zp(m.length) && !jo(m);
        }
        function ni(m) {
          return ei(m) && Zi(m);
        }
        function _I(m) {
          return m === !0 || m === !1 || ei(m) && $i(m) == jt;
        }
        var hs = DT || yh, wI = ir ? na(ir) : TP;
        function SI(m) {
          return ei(m) && m.nodeType === 1 && !Wc(m);
        }
        function CI(m) {
          if (m == null)
            return !0;
          if (Zi(m) && (_n(m) || typeof m == "string" || typeof m.splice == "function" || hs(m) || Hu(m) || $s(m)))
            return !m.length;
          var x = Ti(m);
          if (x == Rt || x == N)
            return !m.size;
          if (Gc(m))
            return !L1(m).length;
          for (var q in m)
            if (Mn.call(m, q))
              return !1;
          return !0;
        }
        function AI(m, x) {
          return Uc(m, x);
        }
        function kI(m, x, q) {
          q = typeof q == "function" ? q : n;
          var W = q ? q(m, x) : n;
          return W === n ? Uc(m, x, n, q) : !!W;
        }
        function uh(m) {
          if (!ei(m))
            return !1;
          var x = $i(m);
          return x == Fe || x == Lt || typeof m.message == "string" && typeof m.name == "string" && !Wc(m);
        }
        function EI(m) {
          return typeof m == "number" && Jg(m);
        }
        function jo(m) {
          if (!Jn(m))
            return !1;
          var x = $i(m);
          return x == Ze || x == Ue || x == Qe || x == ae;
        }
        function vy(m) {
          return typeof m == "number" && m == Sn(m);
        }
        function zp(m) {
          return typeof m == "number" && m > -1 && m % 1 == 0 && m <= Pe;
        }
        function Jn(m) {
          var x = typeof m;
          return m != null && (x == "object" || x == "function");
        }
        function ei(m) {
          return m != null && typeof m == "object";
        }
        var yy = Rr ? na(Rr) : RP;
        function OI(m, x) {
          return m === x || D1(m, x, Q1(x));
        }
        function TI(m, x, q) {
          return q = typeof q == "function" ? q : n, D1(m, x, Q1(x), q);
        }
        function PI(m) {
          return by(m) && m != +m;
        }
        function RI(m) {
          if (hR(m))
            throw new xn(a);
          return lv(m);
        }
        function jI(m) {
          return m === null;
        }
        function II(m) {
          return m == null;
        }
        function by(m) {
          return typeof m == "number" || ei(m) && $i(m) == Vr;
        }
        function Wc(m) {
          if (!ei(m) || $i(m) != G)
            return !1;
          var x = vp(m);
          if (x === null)
            return !0;
          var q = Mn.call(x, "constructor") && x.constructor;
          return typeof q == "function" && q instanceof q && dp.call(q) == TT;
        }
        var ch = ar ? na(ar) : jP;
        function qI(m) {
          return vy(m) && m >= -9007199254740991 && m <= Pe;
        }
        var xy = jr ? na(jr) : IP;
        function Gp(m) {
          return typeof m == "string" || !_n(m) && ei(m) && $i(m) == Se;
        }
        function aa(m) {
          return typeof m == "symbol" || ei(m) && $i(m) == Me;
        }
        var Hu = or ? na(or) : qP;
        function DI(m) {
          return m === n;
        }
        function LI(m) {
          return ei(m) && Ti(m) == Ke;
        }
        function NI(m) {
          return ei(m) && $i(m) == $t;
        }
        var $I = Dp(N1), MI = Dp(function(m, x) {
          return m <= x;
        });
        function _y(m) {
          if (!m)
            return [];
          if (Zi(m))
            return Gp(m) ? Da(m) : Ki(m);
          if (qc && m[qc])
            return vT(m[qc]());
          var x = Ti(m), q = x == Rt ? C1 : x == N ? lp : zu;
          return q(m);
        }
        function Io(m) {
          if (!m)
            return m === 0 ? m : 0;
          if (m = xa(m), m === $e || m === -1 / 0) {
            var x = m < 0 ? -1 : 1;
            return x * Le;
          }
          return m === m ? m : 0;
        }
        function Sn(m) {
          var x = Io(m), q = x % 1;
          return x === x ? q ? x - q : x : 0;
        }
        function wy(m) {
          return m ? qs(Sn(m), 0, He) : 0;
        }
        function xa(m) {
          if (typeof m == "number")
            return m;
          if (aa(m))
            return Ae;
          if (Jn(m)) {
            var x = typeof m.valueOf == "function" ? m.valueOf() : m;
            m = Jn(x) ? x + "" : x;
          }
          if (typeof m != "string")
            return m === 0 ? m : +m;
          m = Bg(m);
          var q = De.test(m);
          return q || yt.test(m) ? fr(m.slice(2), q ? 2 : 8) : Oe.test(m) ? Ae : +m;
        }
        function Sy(m) {
          return oo(m, Yi(m));
        }
        function FI(m) {
          return m ? qs(Sn(m), -9007199254740991, Pe) : m === 0 ? m : 0;
        }
        function Nn(m) {
          return m == null ? "" : ia(m);
        }
        var BI = Fu(function(m, x) {
          if (Gc(x) || Zi(x)) {
            oo(x, gi(x), m);
            return;
          }
          for (var q in x)
            Mn.call(x, q) && Mc(m, q, x[q]);
        }), Cy = Fu(function(m, x) {
          oo(x, Yi(x), m);
        }), Vp = Fu(function(m, x, q, W) {
          oo(x, Yi(x), m, W);
        }), UI = Fu(function(m, x, q, W) {
          oo(x, gi(x), m, W);
        }), HI = Po(P1);
        function zI(m, x) {
          var q = Mu(m);
          return x == null ? q : rv(q, x);
        }
        var GI = On(function(m, x) {
          m = Un(m);
          var q = -1, W = x.length, ne = W > 2 ? x[2] : n;
          for (ne && Mi(x[0], x[1], ne) && (W = 1); ++q < W; )
            for (var Ce = x[q], Ne = Yi(Ce), Ve = -1, gt = Ne.length; ++Ve < gt; ) {
              var Ht = Ne[Ve], zt = m[Ht];
              (zt === n || Na(zt, Lu[Ht]) && !Mn.call(m, Ht)) && (m[Ht] = Ce[Ht]);
            }
          return m;
        }), VI = On(function(m) {
          return m.push(n, Bv), dr(Ay, n, m);
        });
        function WI(m, x) {
          return ln(m, gn(x, 3), ao);
        }
        function KI(m, x) {
          return ln(m, gn(x, 3), j1);
        }
        function ZI(m, x) {
          return m == null ? m : R1(m, gn(x, 3), Yi);
        }
        function YI(m, x) {
          return m == null ? m : sv(m, gn(x, 3), Yi);
        }
        function JI(m, x) {
          return m && ao(m, gn(x, 3));
        }
        function QI(m, x) {
          return m && j1(m, gn(x, 3));
        }
        function XI(m) {
          return m == null ? [] : Ep(m, gi(m));
        }
        function eq(m) {
          return m == null ? [] : Ep(m, Yi(m));
        }
        function lh(m, x, q) {
          var W = m == null ? n : Ds(m, x);
          return W === n ? q : W;
        }
        function tq(m, x) {
          return m != null && zv(m, x, CP);
        }
        function fh(m, x) {
          return m != null && zv(m, x, AP);
        }
        var rq = Lv(function(m, x, q) {
          x != null && typeof x.toString != "function" && (x = hp.call(x)), m[x] = q;
        }, dh(Ji)), nq = Lv(function(m, x, q) {
          x != null && typeof x.toString != "function" && (x = hp.call(x)), Mn.call(m, x) ? m[x].push(q) : m[x] = [q];
        }, gn), iq = On(Bc);
        function gi(m) {
          return Zi(m) ? ev(m) : L1(m);
        }
        function Yi(m) {
          return Zi(m) ? ev(m, !0) : DP(m);
        }
        function aq(m, x) {
          var q = {};
          return x = gn(x, 3), ao(m, function(W, ne, Ce) {
            Oo(q, x(W, ne, Ce), W);
          }), q;
        }
        function oq(m, x) {
          var q = {};
          return x = gn(x, 3), ao(m, function(W, ne, Ce) {
            Oo(q, ne, x(W, ne, Ce));
          }), q;
        }
        var sq = Fu(function(m, x, q) {
          Op(m, x, q);
        }), Ay = Fu(function(m, x, q, W) {
          Op(m, x, q, W);
        }), uq = Po(function(m, x) {
          var q = {};
          if (m == null)
            return q;
          var W = !1;
          x = Yt(x, function(Ce) {
            return Ce = ps(Ce, m), W || (W = Ce.length > 1), Ce;
          }), oo(m, Y1(m), q), W && (q = va(q, d | l | p, rR));
          for (var ne = x.length; ne--; )
            U1(q, x[ne]);
          return q;
        });
        function cq(m, x) {
          return ky(m, Hp(gn(x)));
        }
        var lq = Po(function(m, x) {
          return m == null ? {} : NP(m, x);
        });
        function ky(m, x) {
          if (m == null)
            return {};
          var q = Yt(Y1(m), function(W) {
            return [W];
          });
          return x = gn(x), vv(m, q, function(W, ne) {
            return x(W, ne[0]);
          });
        }
        function fq(m, x, q) {
          x = ps(x, m);
          var W = -1, ne = x.length;
          for (ne || (ne = 1, m = n); ++W < ne; ) {
            var Ce = m == null ? n : m[so(x[W])];
            Ce === n && (W = ne, Ce = q), m = jo(Ce) ? Ce.call(m) : Ce;
          }
          return m;
        }
        function pq(m, x, q) {
          return m == null ? m : Hc(m, x, q);
        }
        function dq(m, x, q, W) {
          return W = typeof W == "function" ? W : n, m == null ? m : Hc(m, x, q, W);
        }
        var Ey = Mv(gi), Oy = Mv(Yi);
        function hq(m, x, q) {
          var W = _n(m), ne = W || hs(m) || Hu(m);
          if (x = gn(x, 4), q == null) {
            var Ce = m && m.constructor;
            ne ? q = W ? new Ce() : [] : Jn(m) ? q = jo(Ce) ? Mu(vp(m)) : {} : q = {};
          }
          return (ne ? br : ao)(m, function(Ne, Ve, gt) {
            return x(q, Ne, Ve, gt);
          }), q;
        }
        function mq(m, x) {
          return m == null ? !0 : U1(m, x);
        }
        function gq(m, x, q) {
          return m == null ? m : wv(m, x, G1(q));
        }
        function vq(m, x, q, W) {
          return W = typeof W == "function" ? W : n, m == null ? m : wv(m, x, G1(q), W);
        }
        function zu(m) {
          return m == null ? [] : S1(m, gi(m));
        }
        function yq(m) {
          return m == null ? [] : S1(m, Yi(m));
        }
        function bq(m, x, q) {
          return q === n && (q = x, x = n), q !== n && (q = xa(q), q = q === q ? q : 0), x !== n && (x = xa(x), x = x === x ? x : 0), qs(xa(m), x, q);
        }
        function xq(m, x, q) {
          return x = Io(x), q === n ? (q = x, x = 0) : q = Io(q), m = xa(m), kP(m, x, q);
        }
        function _q(m, x, q) {
          if (q && typeof q != "boolean" && Mi(m, x, q) && (x = q = n), q === n && (typeof x == "boolean" ? (q = x, x = n) : typeof m == "boolean" && (q = m, m = n)), m === n && x === n ? (m = 0, x = 1) : (m = Io(m), x === n ? (x = m, m = 0) : x = Io(x)), m > x) {
            var W = m;
            m = x, x = W;
          }
          if (q || m % 1 || x % 1) {
            var ne = Qg();
            return Oi(m + ne * (x - m + Mr("1e-" + ((ne + "").length - 1))), x);
          }
          return M1(m, x);
        }
        var wq = Bu(function(m, x, q) {
          return x = x.toLowerCase(), m + (q ? Ty(x) : x);
        });
        function Ty(m) {
          return ph(Nn(m).toLowerCase());
        }
        function Py(m) {
          return m = Nn(m), m && m.replace(bt, pT).replace(Yr, "");
        }
        function Sq(m, x, q) {
          m = Nn(m), x = ia(x);
          var W = m.length;
          q = q === n ? W : qs(Sn(q), 0, W);
          var ne = q;
          return q -= x.length, q >= 0 && m.slice(q, ne) == x;
        }
        function Cq(m) {
          return m = Nn(m), m && L.test(m) ? m.replace(J, dT) : m;
        }
        function Aq(m) {
          return m = Nn(m), m && oe.test(m) ? m.replace(pe, "\\$&") : m;
        }
        var kq = Bu(function(m, x, q) {
          return m + (q ? "-" : "") + x.toLowerCase();
        }), Eq = Bu(function(m, x, q) {
          return m + (q ? " " : "") + x.toLowerCase();
        }), Oq = Iv("toLowerCase");
        function Tq(m, x, q) {
          m = Nn(m), x = Sn(x);
          var W = x ? qu(m) : 0;
          if (!x || W >= x)
            return m;
          var ne = (x - W) / 2;
          return qp(_p(ne), q) + m + qp(xp(ne), q);
        }
        function Pq(m, x, q) {
          m = Nn(m), x = Sn(x);
          var W = x ? qu(m) : 0;
          return x && W < x ? m + qp(x - W, q) : m;
        }
        function Rq(m, x, q) {
          m = Nn(m), x = Sn(x);
          var W = x ? qu(m) : 0;
          return x && W < x ? qp(x - W, q) + m : m;
        }
        function jq(m, x, q) {
          return q || x == null ? x = 0 : x && (x = +x), MT(Nn(m).replace(ce, ""), x || 0);
        }
        function Iq(m, x, q) {
          return (q ? Mi(m, x, q) : x === n) ? x = 1 : x = Sn(x), F1(Nn(m), x);
        }
        function qq() {
          var m = arguments, x = Nn(m[0]);
          return m.length < 3 ? x : x.replace(m[1], m[2]);
        }
        var Dq = Bu(function(m, x, q) {
          return m + (q ? "_" : "") + x.toLowerCase();
        });
        function Lq(m, x, q) {
          return q && typeof q != "number" && Mi(m, x, q) && (x = q = n), q = q === n ? He : q >>> 0, q ? (m = Nn(m), m && (typeof x == "string" || x != null && !ch(x)) && (x = ia(x), !x && Iu(m)) ? ds(Da(m), 0, q) : m.split(x, q)) : [];
        }
        var Nq = Bu(function(m, x, q) {
          return m + (q ? " " : "") + ph(x);
        });
        function $q(m, x, q) {
          return m = Nn(m), q = q == null ? 0 : qs(Sn(q), 0, m.length), x = ia(x), m.slice(q, q + x.length) == x;
        }
        function Mq(m, x, q) {
          var W = _e.templateSettings;
          q && Mi(m, x, q) && (x = n), m = Nn(m), x = Vp({}, x, W, Fv);
          var ne = Vp({}, x.imports, W.imports, Fv), Ce = gi(ne), Ne = S1(ne, Ce), Ve, gt, Ht = 0, zt = x.interpolate || lt, er = "__p += '", un = A1(
            (x.escape || lt).source + "|" + zt.source + "|" + (zt === V ? xe : lt).source + "|" + (x.evaluate || lt).source + "|$",
            "g"
          ), hn = "//# sourceURL=" + (Mn.call(x, "sourceURL") ? (x.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ur + "]") + `
`;
          m.replace(un, function(yn, Pn, qn, oa, Fi, sa) {
            return qn || (qn = oa), er += m.slice(Ht, sa).replace(xt, hT), Pn && (Ve = !0, er += `' +
__e(` + Pn + `) +
'`), Fi && (gt = !0, er += `';
` + Fi + `;
__p += '`), qn && (er += `' +
((__t = (` + qn + `)) == null ? '' : __t) +
'`), Ht = sa + yn.length, yn;
          }), er += `';
`;
          var vn = Mn.call(x, "variable") && x.variable;
          if (!vn)
            er = `with (obj) {
` + er + `
}
`;
          else if (le.test(vn))
            throw new xn(c);
          er = (gt ? er.replace(k, "") : er).replace(j, "$1").replace(z, "$1;"), er = "function(" + (vn || "obj") + `) {
` + (vn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Ve ? ", __e = _.escape" : "") + (gt ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + er + `return __p
}`;
          var En = jy(function() {
            return Ln(Ce, hn + "return " + er).apply(n, Ne);
          });
          if (En.source = er, uh(En))
            throw En;
          return En;
        }
        function Fq(m) {
          return Nn(m).toLowerCase();
        }
        function Bq(m) {
          return Nn(m).toUpperCase();
        }
        function Uq(m, x, q) {
          if (m = Nn(m), m && (q || x === n))
            return Bg(m);
          if (!m || !(x = ia(x)))
            return m;
          var W = Da(m), ne = Da(x), Ce = Ug(W, ne), Ne = Hg(W, ne) + 1;
          return ds(W, Ce, Ne).join("");
        }
        function Hq(m, x, q) {
          if (m = Nn(m), m && (q || x === n))
            return m.slice(0, Gg(m) + 1);
          if (!m || !(x = ia(x)))
            return m;
          var W = Da(m), ne = Hg(W, Da(x)) + 1;
          return ds(W, 0, ne).join("");
        }
        function zq(m, x, q) {
          if (m = Nn(m), m && (q || x === n))
            return m.replace(ce, "");
          if (!m || !(x = ia(x)))
            return m;
          var W = Da(m), ne = Ug(W, Da(x));
          return ds(W, ne).join("");
        }
        function Gq(m, x) {
          var q = se, W = ee;
          if (Jn(x)) {
            var ne = "separator" in x ? x.separator : ne;
            q = "length" in x ? Sn(x.length) : q, W = "omission" in x ? ia(x.omission) : W;
          }
          m = Nn(m);
          var Ce = m.length;
          if (Iu(m)) {
            var Ne = Da(m);
            Ce = Ne.length;
          }
          if (q >= Ce)
            return m;
          var Ve = q - qu(W);
          if (Ve < 1)
            return W;
          var gt = Ne ? ds(Ne, 0, Ve).join("") : m.slice(0, Ve);
          if (ne === n)
            return gt + W;
          if (Ne && (Ve += gt.length - Ve), ch(ne)) {
            if (m.slice(Ve).search(ne)) {
              var Ht, zt = gt;
              for (ne.global || (ne = A1(ne.source, Nn(je.exec(ne)) + "g")), ne.lastIndex = 0; Ht = ne.exec(zt); )
                var er = Ht.index;
              gt = gt.slice(0, er === n ? Ve : er);
            }
          } else if (m.indexOf(ia(ne), Ve) != Ve) {
            var un = gt.lastIndexOf(ne);
            un > -1 && (gt = gt.slice(0, un));
          }
          return gt + W;
        }
        function Vq(m) {
          return m = Nn(m), m && U.test(m) ? m.replace(H, _T) : m;
        }
        var Wq = Bu(function(m, x, q) {
          return m + (q ? " " : "") + x.toUpperCase();
        }), ph = Iv("toUpperCase");
        function Ry(m, x, q) {
          return m = Nn(m), x = q ? n : x, x === n ? gT(m) ? CT(m) : yr(m) : m.match(x) || [];
        }
        var jy = On(function(m, x) {
          try {
            return dr(m, n, x);
          } catch (q) {
            return uh(q) ? q : new xn(q);
          }
        }), Kq = Po(function(m, x) {
          return br(x, function(q) {
            q = so(q), Oo(m, q, oh(m[q], m));
          }), m;
        });
        function Zq(m) {
          var x = m == null ? 0 : m.length, q = gn();
          return m = x ? Yt(m, function(W) {
            if (typeof W[1] != "function")
              throw new ma(o);
            return [q(W[0]), W[1]];
          }) : [], On(function(W) {
            for (var ne = -1; ++ne < x; ) {
              var Ce = m[ne];
              if (dr(Ce[0], this, W))
                return dr(Ce[1], this, W);
            }
          });
        }
        function Yq(m) {
          return _P(va(m, d));
        }
        function dh(m) {
          return function() {
            return m;
          };
        }
        function Jq(m, x) {
          return m == null || m !== m ? x : m;
        }
        var Qq = Dv(), Xq = Dv(!0);
        function Ji(m) {
          return m;
        }
        function hh(m) {
          return fv(typeof m == "function" ? m : va(m, d));
        }
        function eD(m) {
          return dv(va(m, d));
        }
        function tD(m, x) {
          return hv(m, va(x, d));
        }
        var rD = On(function(m, x) {
          return function(q) {
            return Bc(q, m, x);
          };
        }), nD = On(function(m, x) {
          return function(q) {
            return Bc(m, q, x);
          };
        });
        function mh(m, x, q) {
          var W = gi(x), ne = Ep(x, W);
          q == null && !(Jn(x) && (ne.length || !W.length)) && (q = x, x = m, m = this, ne = Ep(x, gi(x)));
          var Ce = !(Jn(q) && "chain" in q) || !!q.chain, Ne = jo(m);
          return br(ne, function(Ve) {
            var gt = x[Ve];
            m[Ve] = gt, Ne && (m.prototype[Ve] = function() {
              var Ht = this.__chain__;
              if (Ce || Ht) {
                var zt = m(this.__wrapped__), er = zt.__actions__ = Ki(this.__actions__);
                return er.push({ func: gt, args: arguments, thisArg: m }), zt.__chain__ = Ht, zt;
              }
              return gt.apply(m, Qt([this.value()], arguments));
            });
          }), m;
        }
        function iD() {
          return Xt._ === this && (Xt._ = PT), this;
        }
        function gh() {
        }
        function aD(m) {
          return m = Sn(m), On(function(x) {
            return mv(x, m);
          });
        }
        var oD = W1(Yt), sD = W1(Ir), uD = W1(Or);
        function Iy(m) {
          return eh(m) ? b1(so(m)) : $P(m);
        }
        function cD(m) {
          return function(x) {
            return m == null ? n : Ds(m, x);
          };
        }
        var lD = Nv(), fD = Nv(!0);
        function vh() {
          return [];
        }
        function yh() {
          return !1;
        }
        function pD() {
          return {};
        }
        function dD() {
          return "";
        }
        function hD() {
          return !0;
        }
        function mD(m, x) {
          if (m = Sn(m), m < 1 || m > Pe)
            return [];
          var q = He, W = Oi(m, He);
          x = gn(x), m -= He;
          for (var ne = w1(W, x); ++q < m; )
            x(q);
          return ne;
        }
        function gD(m) {
          return _n(m) ? Yt(m, so) : aa(m) ? [m] : Ki(Xv(Nn(m)));
        }
        function vD(m) {
          var x = ++OT;
          return Nn(m) + x;
        }
        var yD = Ip(function(m, x) {
          return m + x;
        }, 0), bD = K1("ceil"), xD = Ip(function(m, x) {
          return m / x;
        }, 1), _D = K1("floor");
        function wD(m) {
          return m && m.length ? kp(m, Ji, I1) : n;
        }
        function SD(m, x) {
          return m && m.length ? kp(m, gn(x, 2), I1) : n;
        }
        function CD(m) {
          return Mg(m, Ji);
        }
        function AD(m, x) {
          return Mg(m, gn(x, 2));
        }
        function kD(m) {
          return m && m.length ? kp(m, Ji, N1) : n;
        }
        function ED(m, x) {
          return m && m.length ? kp(m, gn(x, 2), N1) : n;
        }
        var OD = Ip(function(m, x) {
          return m * x;
        }, 1), TD = K1("round"), PD = Ip(function(m, x) {
          return m - x;
        }, 0);
        function RD(m) {
          return m && m.length ? _1(m, Ji) : 0;
        }
        function jD(m, x) {
          return m && m.length ? _1(m, gn(x, 2)) : 0;
        }
        return _e.after = eI, _e.ary = ly, _e.assign = BI, _e.assignIn = Cy, _e.assignInWith = Vp, _e.assignWith = UI, _e.at = HI, _e.before = fy, _e.bind = oh, _e.bindAll = Kq, _e.bindKey = py, _e.castArray = pI, _e.chain = sy, _e.chunk = _R, _e.compact = wR, _e.concat = SR, _e.cond = Zq, _e.conforms = Yq, _e.constant = dh, _e.countBy = Rj, _e.create = zI, _e.curry = dy, _e.curryRight = hy, _e.debounce = my, _e.defaults = GI, _e.defaultsDeep = VI, _e.defer = tI, _e.delay = rI, _e.difference = CR, _e.differenceBy = AR, _e.differenceWith = kR, _e.drop = ER, _e.dropRight = OR, _e.dropRightWhile = TR, _e.dropWhile = PR, _e.fill = RR, _e.filter = Ij, _e.flatMap = Lj, _e.flatMapDeep = Nj, _e.flatMapDepth = $j, _e.flatten = ny, _e.flattenDeep = jR, _e.flattenDepth = IR, _e.flip = nI, _e.flow = Qq, _e.flowRight = Xq, _e.fromPairs = qR, _e.functions = XI, _e.functionsIn = eq, _e.groupBy = Mj, _e.initial = LR, _e.intersection = NR, _e.intersectionBy = $R, _e.intersectionWith = MR, _e.invert = rq, _e.invertBy = nq, _e.invokeMap = Bj, _e.iteratee = hh, _e.keyBy = Uj, _e.keys = gi, _e.keysIn = Yi, _e.map = Fp, _e.mapKeys = aq, _e.mapValues = oq, _e.matches = eD, _e.matchesProperty = tD, _e.memoize = Up, _e.merge = sq, _e.mergeWith = Ay, _e.method = rD, _e.methodOf = nD, _e.mixin = mh, _e.negate = Hp, _e.nthArg = aD, _e.omit = uq, _e.omitBy = cq, _e.once = iI, _e.orderBy = Hj, _e.over = oD, _e.overArgs = aI, _e.overEvery = sD, _e.overSome = uD, _e.partial = sh, _e.partialRight = gy, _e.partition = zj, _e.pick = lq, _e.pickBy = ky, _e.property = Iy, _e.propertyOf = cD, _e.pull = HR, _e.pullAll = ay, _e.pullAllBy = zR, _e.pullAllWith = GR, _e.pullAt = VR, _e.range = lD, _e.rangeRight = fD, _e.rearg = oI, _e.reject = Wj, _e.remove = WR, _e.rest = sI, _e.reverse = ih, _e.sampleSize = Zj, _e.set = pq, _e.setWith = dq, _e.shuffle = Yj, _e.slice = KR, _e.sortBy = Xj, _e.sortedUniq = tj, _e.sortedUniqBy = rj, _e.split = Lq, _e.spread = uI, _e.tail = nj, _e.take = ij, _e.takeRight = aj, _e.takeRightWhile = oj, _e.takeWhile = sj, _e.tap = wj, _e.throttle = cI, _e.thru = Mp, _e.toArray = _y, _e.toPairs = Ey, _e.toPairsIn = Oy, _e.toPath = gD, _e.toPlainObject = Sy, _e.transform = hq, _e.unary = lI, _e.union = uj, _e.unionBy = cj, _e.unionWith = lj, _e.uniq = fj, _e.uniqBy = pj, _e.uniqWith = dj, _e.unset = mq, _e.unzip = ah, _e.unzipWith = oy, _e.update = gq, _e.updateWith = vq, _e.values = zu, _e.valuesIn = yq, _e.without = hj, _e.words = Ry, _e.wrap = fI, _e.xor = mj, _e.xorBy = gj, _e.xorWith = vj, _e.zip = yj, _e.zipObject = bj, _e.zipObjectDeep = xj, _e.zipWith = _j, _e.entries = Ey, _e.entriesIn = Oy, _e.extend = Cy, _e.extendWith = Vp, mh(_e, _e), _e.add = yD, _e.attempt = jy, _e.camelCase = wq, _e.capitalize = Ty, _e.ceil = bD, _e.clamp = bq, _e.clone = dI, _e.cloneDeep = mI, _e.cloneDeepWith = gI, _e.cloneWith = hI, _e.conformsTo = vI, _e.deburr = Py, _e.defaultTo = Jq, _e.divide = xD, _e.endsWith = Sq, _e.eq = Na, _e.escape = Cq, _e.escapeRegExp = Aq, _e.every = jj, _e.find = qj, _e.findIndex = ty, _e.findKey = WI, _e.findLast = Dj, _e.findLastIndex = ry, _e.findLastKey = KI, _e.floor = _D, _e.forEach = uy, _e.forEachRight = cy, _e.forIn = ZI, _e.forInRight = YI, _e.forOwn = JI, _e.forOwnRight = QI, _e.get = lh, _e.gt = yI, _e.gte = bI, _e.has = tq, _e.hasIn = fh, _e.head = iy, _e.identity = Ji, _e.includes = Fj, _e.indexOf = DR, _e.inRange = xq, _e.invoke = iq, _e.isArguments = $s, _e.isArray = _n, _e.isArrayBuffer = xI, _e.isArrayLike = Zi, _e.isArrayLikeObject = ni, _e.isBoolean = _I, _e.isBuffer = hs, _e.isDate = wI, _e.isElement = SI, _e.isEmpty = CI, _e.isEqual = AI, _e.isEqualWith = kI, _e.isError = uh, _e.isFinite = EI, _e.isFunction = jo, _e.isInteger = vy, _e.isLength = zp, _e.isMap = yy, _e.isMatch = OI, _e.isMatchWith = TI, _e.isNaN = PI, _e.isNative = RI, _e.isNil = II, _e.isNull = jI, _e.isNumber = by, _e.isObject = Jn, _e.isObjectLike = ei, _e.isPlainObject = Wc, _e.isRegExp = ch, _e.isSafeInteger = qI, _e.isSet = xy, _e.isString = Gp, _e.isSymbol = aa, _e.isTypedArray = Hu, _e.isUndefined = DI, _e.isWeakMap = LI, _e.isWeakSet = NI, _e.join = FR, _e.kebabCase = kq, _e.last = ba, _e.lastIndexOf = BR, _e.lowerCase = Eq, _e.lowerFirst = Oq, _e.lt = $I, _e.lte = MI, _e.max = wD, _e.maxBy = SD, _e.mean = CD, _e.meanBy = AD, _e.min = kD, _e.minBy = ED, _e.stubArray = vh, _e.stubFalse = yh, _e.stubObject = pD, _e.stubString = dD, _e.stubTrue = hD, _e.multiply = OD, _e.nth = UR, _e.noConflict = iD, _e.noop = gh, _e.now = Bp, _e.pad = Tq, _e.padEnd = Pq, _e.padStart = Rq, _e.parseInt = jq, _e.random = _q, _e.reduce = Gj, _e.reduceRight = Vj, _e.repeat = Iq, _e.replace = qq, _e.result = fq, _e.round = TD, _e.runInContext = ct, _e.sample = Kj, _e.size = Jj, _e.snakeCase = Dq, _e.some = Qj, _e.sortedIndex = ZR, _e.sortedIndexBy = YR, _e.sortedIndexOf = JR, _e.sortedLastIndex = QR, _e.sortedLastIndexBy = XR, _e.sortedLastIndexOf = ej, _e.startCase = Nq, _e.startsWith = $q, _e.subtract = PD, _e.sum = RD, _e.sumBy = jD, _e.template = Mq, _e.times = mD, _e.toFinite = Io, _e.toInteger = Sn, _e.toLength = wy, _e.toLower = Fq, _e.toNumber = xa, _e.toSafeInteger = FI, _e.toString = Nn, _e.toUpper = Bq, _e.trim = Uq, _e.trimEnd = Hq, _e.trimStart = zq, _e.truncate = Gq, _e.unescape = Vq, _e.uniqueId = vD, _e.upperCase = Wq, _e.upperFirst = ph, _e.each = uy, _e.eachRight = cy, _e.first = iy, mh(_e, function() {
          var m = {};
          return ao(_e, function(x, q) {
            Mn.call(_e.prototype, q) || (m[q] = x);
          }), m;
        }(), { chain: !1 }), _e.VERSION = r, br(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(m) {
          _e[m].placeholder = _e;
        }), br(["drop", "take"], function(m, x) {
          jn.prototype[m] = function(q) {
            q = q === n ? 1 : ci(Sn(q), 0);
            var W = this.__filtered__ && !x ? new jn(this) : this.clone();
            return W.__filtered__ ? W.__takeCount__ = Oi(q, W.__takeCount__) : W.__views__.push({
              size: Oi(q, He),
              type: m + (W.__dir__ < 0 ? "Right" : "")
            }), W;
          }, jn.prototype[m + "Right"] = function(q) {
            return this.reverse()[m](q).reverse();
          };
        }), br(["filter", "map", "takeWhile"], function(m, x) {
          var q = x + 1, W = q == de || q == me;
          jn.prototype[m] = function(ne) {
            var Ce = this.clone();
            return Ce.__iteratees__.push({
              iteratee: gn(ne, 3),
              type: q
            }), Ce.__filtered__ = Ce.__filtered__ || W, Ce;
          };
        }), br(["head", "last"], function(m, x) {
          var q = "take" + (x ? "Right" : "");
          jn.prototype[m] = function() {
            return this[q](1).value()[0];
          };
        }), br(["initial", "tail"], function(m, x) {
          var q = "drop" + (x ? "" : "Right");
          jn.prototype[m] = function() {
            return this.__filtered__ ? new jn(this) : this[q](1);
          };
        }), jn.prototype.compact = function() {
          return this.filter(Ji);
        }, jn.prototype.find = function(m) {
          return this.filter(m).head();
        }, jn.prototype.findLast = function(m) {
          return this.reverse().find(m);
        }, jn.prototype.invokeMap = On(function(m, x) {
          return typeof m == "function" ? new jn(this) : this.map(function(q) {
            return Bc(q, m, x);
          });
        }), jn.prototype.reject = function(m) {
          return this.filter(Hp(gn(m)));
        }, jn.prototype.slice = function(m, x) {
          m = Sn(m);
          var q = this;
          return q.__filtered__ && (m > 0 || x < 0) ? new jn(q) : (m < 0 ? q = q.takeRight(-m) : m && (q = q.drop(m)), x !== n && (x = Sn(x), q = x < 0 ? q.dropRight(-x) : q.take(x - m)), q);
        }, jn.prototype.takeRightWhile = function(m) {
          return this.reverse().takeWhile(m).reverse();
        }, jn.prototype.toArray = function() {
          return this.take(He);
        }, ao(jn.prototype, function(m, x) {
          var q = /^(?:filter|find|map|reject)|While$/.test(x), W = /^(?:head|last)$/.test(x), ne = _e[W ? "take" + (x == "last" ? "Right" : "") : x], Ce = W || /^find/.test(x);
          ne && (_e.prototype[x] = function() {
            var Ne = this.__wrapped__, Ve = W ? [1] : arguments, gt = Ne instanceof jn, Ht = Ve[0], zt = gt || _n(Ne), er = function(Pn) {
              var qn = ne.apply(_e, Qt([Pn], Ve));
              return W && un ? qn[0] : qn;
            };
            zt && q && typeof Ht == "function" && Ht.length != 1 && (gt = zt = !1);
            var un = this.__chain__, hn = !!this.__actions__.length, vn = Ce && !un, En = gt && !hn;
            if (!Ce && zt) {
              Ne = En ? Ne : new jn(this);
              var yn = m.apply(Ne, Ve);
              return yn.__actions__.push({ func: Mp, args: [er], thisArg: n }), new ga(yn, un);
            }
            return vn && En ? m.apply(this, Ve) : (yn = this.thru(er), vn ? W ? yn.value()[0] : yn.value() : yn);
          });
        }), br(["pop", "push", "shift", "sort", "splice", "unshift"], function(m) {
          var x = fp[m], q = /^(?:push|sort|unshift)$/.test(m) ? "tap" : "thru", W = /^(?:pop|shift)$/.test(m);
          _e.prototype[m] = function() {
            var ne = arguments;
            if (W && !this.__chain__) {
              var Ce = this.value();
              return x.apply(_n(Ce) ? Ce : [], ne);
            }
            return this[q](function(Ne) {
              return x.apply(_n(Ne) ? Ne : [], ne);
            });
          };
        }), ao(jn.prototype, function(m, x) {
          var q = _e[x];
          if (q) {
            var W = q.name + "";
            Mn.call($u, W) || ($u[W] = []), $u[W].push({ name: x, func: q });
          }
        }), $u[jp(n, y).name] = [{
          name: "wrapper",
          func: n
        }], jn.prototype.clone = VT, jn.prototype.reverse = WT, jn.prototype.value = KT, _e.prototype.at = Sj, _e.prototype.chain = Cj, _e.prototype.commit = Aj, _e.prototype.next = kj, _e.prototype.plant = Oj, _e.prototype.reverse = Tj, _e.prototype.toJSON = _e.prototype.valueOf = _e.prototype.value = Pj, _e.prototype.first = _e.prototype.head, qc && (_e.prototype[qc] = Ej), _e;
      }, Du = AT();
      wr ? ((wr.exports = Du)._ = Du, tr._ = Du) : Xt._ = Du;
    }).call(BM);
  }(uf, uf.exports)), uf.exports;
}
var vi = ti();
function MC(e) {
  let t = "";
  return e.absolute && (e.protocol === "file" ? (e.drive && (t += e.drive), t += "/") : (t += e.protocol + "://", e.origin && (t += e.origin + "/"))), (t += e.path.join("/")) === "" && (t = "."), t;
}
function Sf(e, t, n, r) {
  this.message = e, this.expected = t, this.found = n, this.location = r, this.name = "SyntaxError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Sf);
}
(function(e, t) {
  function n() {
    this.constructor = e;
  }
  n.prototype = t.prototype, e.prototype = new n();
})(Sf, Error), Sf.buildMessage = function(e, t) {
  var n = { literal: function(o) {
    return '"' + i(o.text) + '"';
  }, class: function(o) {
    var c, u = "";
    for (c = 0; c < o.parts.length; c++) u += o.parts[c] instanceof Array ? a(o.parts[c][0]) + "-" + a(o.parts[c][1]) : a(o.parts[c]);
    return "[" + (o.inverted ? "^" : "") + u + "]";
  }, any: function(o) {
    return "any character";
  }, end: function(o) {
    return "end of input";
  }, other: function(o) {
    return o.description;
  } };
  function r(o) {
    return o.charCodeAt(0).toString(16).toUpperCase();
  }
  function i(o) {
    return o.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(c) {
      return "\\x0" + r(c);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(c) {
      return "\\x" + r(c);
    });
  }
  function a(o) {
    return o.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(c) {
      return "\\x0" + r(c);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(c) {
      return "\\x" + r(c);
    });
  }
  return "Expected " + function(o) {
    var c, u, s, f = new Array(o.length);
    for (c = 0; c < o.length; c++) f[c] = (s = o[c], n[s.type](s));
    if (f.sort(), f.length > 0) {
      for (c = 1, u = 1; c < f.length; c++) f[c - 1] !== f[c] && (f[u] = f[c], u++);
      f.length = u;
    }
    switch (f.length) {
      case 1:
        return f[0];
      case 2:
        return f[0] + " or " + f[1];
      default:
        return f.slice(0, -1).join(", ") + ", or " + f[f.length - 1];
    }
  }(e) + " but " + function(o) {
    return o ? '"' + i(o) + '"' : "end of input";
  }(t) + " found.";
};
var UM = function(e, t) {
  t = t !== void 0 ? t : {};
  var n, r, i, a, o = {}, c = { Path: Y }, u = Y, s = function(Be, P, M, F) {
    return { protocol: Be, origin: P, absolute: !0, ...M, ...F };
  }, f = function(Be, P, M) {
    return { protocol: Be, origin: P, absolute: !0, ...M, path: [] };
  }, d = "http://", l = Ue("http://", !0), p = function(Be) {
    return "http";
  }, g = "https://", v = Ue("https://", !0), b = function(Be) {
    return "https";
  }, y = "", w = function() {
    return null;
  }, C = function(Be, P, M) {
    return { protocol: Be, origin: null, absolute: !0, ...P, ...M };
  }, T = "file://", E = Ue("file://", !0), D = "file:", $ = Ue("file:", !0), Z = function(Be) {
    return "file";
  }, te = function(Be, P) {
    return { protocol: "file", origin: null, absolute: !0, ...Be, ...P };
  }, se = /^[A-Za-z]/, ee = Rt([["A", "Z"], ["a", "z"]], !1, !1), K = ":", re = Ue(":", !1), de = function(Be) {
    return { drive: Be.toLowerCase() + ":" };
  }, ie = function() {
    return { drive: null };
  }, me = function() {
    return { drive: null };
  }, $e = function(Be) {
    return { protocol: null, origin: null, absolute: !1, drive: null, ...Be };
  }, Pe = function(Be) {
    return { path: Be };
  }, Le = function(Be, P) {
    return [Be, ...P];
  }, Ae = function(Be) {
    return [Be];
  }, He = ".", Te = Ue(".", !1), we = "/", qe = Ue("/", !1), Ge = "\\", It = Ue("\\", !1), Qe = /^[^\/\\]/, jt = Rt(["/", "\\"], !0, !1), We = 0, Lt = [{ line: 1, column: 1 }], Fe = 0, Ze = [];
  if ("startRule" in t) {
    if (!(t.startRule in c)) throw new Error(`Can't start parsing from rule "` + t.startRule + '".');
    u = c[t.startRule];
  }
  function Ue(Be, P) {
    return { type: "literal", text: Be, ignoreCase: P };
  }
  function Rt(Be, P, M) {
    return { type: "class", parts: Be, inverted: P, ignoreCase: M };
  }
  function Vr(Be) {
    var P, M = Lt[Be];
    if (M) return M;
    for (P = Be - 1; !Lt[P]; ) P--;
    for (M = { line: (M = Lt[P]).line, column: M.column }; P < Be; ) e.charCodeAt(P) === 10 ? (M.line++, M.column = 1) : M.column++, P++;
    return Lt[Be] = M, M;
  }
  function ye(Be, P) {
    var M = Vr(Be), F = Vr(P);
    return { start: { offset: Be, line: M.line, column: M.column }, end: { offset: P, line: F.line, column: F.column } };
  }
  function G(Be) {
    We < Fe || (We > Fe && (Fe = We, Ze = []), Ze.push(Be));
  }
  function Y() {
    var Be;
    return (Be = function() {
      var P, M, F, O, S;
      return P = We, (M = ae()) !== o && (F = Ee()) !== o && (O = Se()) !== o && (S = Me()) !== o ? (M = s(M, F, O, S), P = M) : (We = P, P = o), P === o && (P = We, (M = ae()) !== o && (F = Ee()) !== o && (O = function() {
        var _;
        return (_ = y) !== o && (_ = me()), _;
      }()) !== o ? (M = f(M, F, O), P = M) : (We = P, P = o)), P;
    }()) === o && (Be = function() {
      var P, M, F, O;
      return P = We, (M = function() {
        var S;
        return e.substr(We, 7).toLowerCase() === T ? (S = e.substr(We, 7), We += 7) : (S = o, G(E)), S === o && (e.substr(We, 5).toLowerCase() === D ? (S = e.substr(We, 5), We += 5) : (S = o, G($))), S !== o && (S = Z()), S;
      }()) !== o && (F = N()) !== o && (O = Me()) !== o ? (M = C(M, F, O), P = M) : (We = P, P = o), P;
    }()) === o && (Be = function() {
      var P, M, F;
      return P = We, (M = N()) !== o && (F = Me()) !== o ? (M = te(M, F), P = M) : (We = P, P = o), P;
    }()) === o && (Be = function() {
      var P, M, F;
      return P = We, (M = function() {
        var O;
        return (O = function() {
          var S, _, h;
          return S = We, e.charCodeAt(We) === 46 ? (_ = He, We++) : (_ = o, G(Te)), _ !== o && (h = Ke()) !== o ? S = _ = [_, h] : (We = S, S = o), S;
        }()) === o && (O = y), O;
      }()) !== o && (F = Me()) !== o ? (M = $e(F), P = M) : (We = P, P = o), P;
    }()), Be;
  }
  function ae() {
    var Be, P;
    return e.substr(We, 7).toLowerCase() === d ? (P = e.substr(We, 7), We += 7) : (P = o, G(l)), P !== o && (P = p()), (Be = P) === o && (Be = function() {
      var M;
      return e.substr(We, 8).toLowerCase() === g ? (M = e.substr(We, 8), We += 8) : (M = o, G(v)), M !== o && (M = b()), M;
    }()), Be;
  }
  function Ee() {
    var Be, P, M;
    if (Be = We, P = [], (M = $t()) !== o) for (; M !== o; ) P.push(M), M = $t();
    else P = o;
    return (Be = P !== o ? e.substring(Be, We) : P) === o && (Be = We, (P = y) !== o && (P = w()), Be = P), Be;
  }
  function N() {
    var Be;
    return (Be = function() {
      var P, M, F, O;
      return P = We, (M = Ke()) === o && (M = null), M !== o ? (se.test(e.charAt(We)) ? (F = e.charAt(We), We++) : (F = o, G(ee)), F !== o ? (e.charCodeAt(We) === 58 ? (O = K, We++) : (O = o, G(re)), O !== o && Ke() !== o ? (M = de(F), P = M) : (We = P, P = o)) : (We = P, P = o)) : (We = P, P = o), P;
    }()) === o && (Be = Se()), Be;
  }
  function Se() {
    var Be;
    return (Be = Ke()) !== o && (Be = ie()), Be;
  }
  function Me() {
    var Be;
    return (Be = function P() {
      var M, F, O;
      return M = We, (F = Xe()) !== o && Ke() !== o && (O = P()) !== o ? (F = Le(F, O), M = F) : (We = M, M = o), M === o && (M = We, (F = Xe()) !== o && (F = Ae(F)), M = F), M;
    }()) !== o && (Be = Pe(Be)), Be;
  }
  function Xe() {
    var Be, P, M;
    if (Be = We, P = [], (M = $t()) !== o) for (; M !== o; ) P.push(M), M = $t();
    else P = o;
    return (Be = P !== o ? e.substring(Be, We) : P) === o && (Be = y), Be;
  }
  function Ke() {
    var Be;
    return e.charCodeAt(We) === 47 ? (Be = we, We++) : (Be = o, G(qe)), Be === o && (e.charCodeAt(We) === 92 ? (Be = Ge, We++) : (Be = o, G(It))), Be;
  }
  function $t() {
    var Be;
    return Qe.test(e.charAt(We)) ? (Be = e.charAt(We), We++) : (Be = o, G(jt)), Be;
  }
  if ((n = u()) !== o && We === e.length) return n;
  throw n !== o && We < e.length && G({ type: "end" }), r = Ze, i = Fe < e.length ? e.charAt(Fe) : null, a = Fe < e.length ? ye(Fe, Fe + 1) : ye(Fe, Fe), new Sf(Sf.buildMessage(r, i), r, i, a);
};
function x2(e) {
  if (typeof e != "string") throw new Error(`@stoplight/path: Cannot parse ${e} because it is not a string`);
  return UM(e, {});
}
function j6(e) {
  let t = e.path;
  t = t.filter((r) => r !== "" && r !== ".");
  const n = [];
  for (const r of t) r === ".." && n.length && n[n.length - 1] !== ".." ? n.pop() : r === ".." && e.absolute || n.push(r);
  return e.path = n, e;
}
const HM = (e) => {
  const t = j6(x2(e));
  return t.path.pop(), MC(j6(t));
};
function zM(e) {
  return x2(e).absolute;
}
const GM = (...e) => {
  if (e.length === 0) return ".";
  const t = e.map(x2), n = Object.assign({}, t[0]);
  for (let r = 1; r < t.length; r++) {
    const i = t[r];
    if (i.absolute) throw new Error('Cannot join an absolute path "' + e[r] + '" in the middle of other paths.');
    for (const a of i.path) n.path.push(a);
  }
  return MC(j6(n));
};
function FC(e, t) {
  t === void 0 && (t = !1);
  var n = e.length, r = 0, i = "", a = 0, o = 16, c = 0, u = 0, s = 0, f = 0, d = 0;
  function l(C, T) {
    for (var E = 0, D = 0; E < C; ) {
      var $ = e.charCodeAt(r);
      if ($ >= 48 && $ <= 57)
        D = D * 16 + $ - 48;
      else if ($ >= 65 && $ <= 70)
        D = D * 16 + $ - 65 + 10;
      else if ($ >= 97 && $ <= 102)
        D = D * 16 + $ - 97 + 10;
      else
        break;
      r++, E++;
    }
    return E < C && (D = -1), D;
  }
  function p(C) {
    r = C, i = "", a = 0, o = 16, d = 0;
  }
  function g() {
    var C = r;
    if (e.charCodeAt(r) === 48)
      r++;
    else
      for (r++; r < e.length && Gu(e.charCodeAt(r)); )
        r++;
    if (r < e.length && e.charCodeAt(r) === 46)
      if (r++, r < e.length && Gu(e.charCodeAt(r)))
        for (r++; r < e.length && Gu(e.charCodeAt(r)); )
          r++;
      else
        return d = 3, e.substring(C, r);
    var T = r;
    if (r < e.length && (e.charCodeAt(r) === 69 || e.charCodeAt(r) === 101))
      if (r++, (r < e.length && e.charCodeAt(r) === 43 || e.charCodeAt(r) === 45) && r++, r < e.length && Gu(e.charCodeAt(r))) {
        for (r++; r < e.length && Gu(e.charCodeAt(r)); )
          r++;
        T = r;
      } else
        d = 3;
    return e.substring(C, T);
  }
  function v() {
    for (var C = "", T = r; ; ) {
      if (r >= n) {
        C += e.substring(T, r), d = 2;
        break;
      }
      var E = e.charCodeAt(r);
      if (E === 34) {
        C += e.substring(T, r), r++;
        break;
      }
      if (E === 92) {
        if (C += e.substring(T, r), r++, r >= n) {
          d = 2;
          break;
        }
        var D = e.charCodeAt(r++);
        switch (D) {
          case 34:
            C += '"';
            break;
          case 92:
            C += "\\";
            break;
          case 47:
            C += "/";
            break;
          case 98:
            C += "\b";
            break;
          case 102:
            C += "\f";
            break;
          case 110:
            C += `
`;
            break;
          case 114:
            C += "\r";
            break;
          case 116:
            C += "	";
            break;
          case 117:
            var $ = l(4);
            $ >= 0 ? C += String.fromCharCode($) : d = 4;
            break;
          default:
            d = 5;
        }
        T = r;
        continue;
      }
      if (E >= 0 && E <= 31)
        if (Yc(E)) {
          C += e.substring(T, r), d = 2;
          break;
        } else
          d = 6;
      r++;
    }
    return C;
  }
  function b() {
    if (i = "", d = 0, a = r, u = c, f = s, r >= n)
      return a = n, o = 17;
    var C = e.charCodeAt(r);
    if (Ch(C)) {
      do
        r++, i += String.fromCharCode(C), C = e.charCodeAt(r);
      while (Ch(C));
      return o = 15;
    }
    if (Yc(C))
      return r++, i += String.fromCharCode(C), C === 13 && e.charCodeAt(r) === 10 && (r++, i += `
`), c++, s = r, o = 14;
    switch (C) {
      // tokens: []{}:,
      case 123:
        return r++, o = 1;
      case 125:
        return r++, o = 2;
      case 91:
        return r++, o = 3;
      case 93:
        return r++, o = 4;
      case 58:
        return r++, o = 6;
      case 44:
        return r++, o = 5;
      // strings
      case 34:
        return r++, i = v(), o = 10;
      // comments
      case 47:
        var T = r - 1;
        if (e.charCodeAt(r + 1) === 47) {
          for (r += 2; r < n && !Yc(e.charCodeAt(r)); )
            r++;
          return i = e.substring(T, r), o = 12;
        }
        if (e.charCodeAt(r + 1) === 42) {
          r += 2;
          for (var E = n - 1, D = !1; r < E; ) {
            var $ = e.charCodeAt(r);
            if ($ === 42 && e.charCodeAt(r + 1) === 47) {
              r += 2, D = !0;
              break;
            }
            r++, Yc($) && ($ === 13 && e.charCodeAt(r) === 10 && r++, c++, s = r);
          }
          return D || (r++, d = 1), i = e.substring(T, r), o = 13;
        }
        return i += String.fromCharCode(C), r++, o = 16;
      // numbers
      case 45:
        if (i += String.fromCharCode(C), r++, r === n || !Gu(e.charCodeAt(r)))
          return o = 16;
      // found a minus, followed by a number so
      // we fall through to proceed with scanning
      // numbers
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
        return i += g(), o = 11;
      // literals and unknown symbols
      default:
        for (; r < n && y(C); )
          r++, C = e.charCodeAt(r);
        if (a !== r) {
          switch (i = e.substring(a, r), i) {
            case "true":
              return o = 8;
            case "false":
              return o = 9;
            case "null":
              return o = 7;
          }
          return o = 16;
        }
        return i += String.fromCharCode(C), r++, o = 16;
    }
  }
  function y(C) {
    if (Ch(C) || Yc(C))
      return !1;
    switch (C) {
      case 125:
      case 93:
      case 123:
      case 91:
      case 34:
      case 58:
      case 44:
      case 47:
        return !1;
    }
    return !0;
  }
  function w() {
    var C;
    do
      C = b();
    while (C >= 12 && C <= 15);
    return C;
  }
  return {
    setPosition: p,
    getPosition: function() {
      return r;
    },
    scan: t ? w : b,
    getToken: function() {
      return o;
    },
    getTokenValue: function() {
      return i;
    },
    getTokenOffset: function() {
      return a;
    },
    getTokenLength: function() {
      return r - a;
    },
    getTokenStartLine: function() {
      return u;
    },
    getTokenStartCharacter: function() {
      return a - f;
    },
    getTokenError: function() {
      return d;
    }
  };
}
function Ch(e) {
  return e === 32 || e === 9 || e === 11 || e === 12 || e === 160 || e === 5760 || e >= 8192 && e <= 8203 || e === 8239 || e === 8287 || e === 12288 || e === 65279;
}
function Yc(e) {
  return e === 10 || e === 13 || e === 8232 || e === 8233;
}
function Gu(e) {
  return e >= 48 && e <= 57;
}
var I6;
(function(e) {
  e.DEFAULT = {
    allowTrailingComma: !1
  };
})(I6 || (I6 = {}));
function BC(e) {
  if (!e.parent || !e.parent.children)
    return [];
  var t = BC(e.parent);
  if (e.parent.type === "property") {
    var n = e.parent.children[0].value;
    t.push(n);
  } else if (e.parent.type === "array") {
    var r = e.parent.children.indexOf(e);
    r !== -1 && t.push(r);
  }
  return t;
}
function VM(e, t, n) {
  return n === void 0 && (n = !1), t >= e.offset && t < e.offset + e.length || n && t === e.offset + e.length;
}
function UC(e, t, n) {
  if (n === void 0 && (n = !1), VM(e, t, n)) {
    var r = e.children;
    if (Array.isArray(r))
      for (var i = 0; i < r.length && r[i].offset <= t; i++) {
        var a = UC(r[i], t, n);
        if (a)
          return a;
      }
    return e;
  }
}
function WM(e, t, n) {
  n === void 0 && (n = I6.DEFAULT);
  var r = FC(e, !1);
  function i(te) {
    return te ? function() {
      return te(r.getTokenOffset(), r.getTokenLength(), r.getTokenStartLine(), r.getTokenStartCharacter());
    } : function() {
      return !0;
    };
  }
  function a(te) {
    return te ? function(se) {
      return te(se, r.getTokenOffset(), r.getTokenLength(), r.getTokenStartLine(), r.getTokenStartCharacter());
    } : function() {
      return !0;
    };
  }
  var o = i(t.onObjectBegin), c = a(t.onObjectProperty), u = i(t.onObjectEnd), s = i(t.onArrayBegin), f = i(t.onArrayEnd), d = a(t.onLiteralValue), l = a(t.onSeparator), p = i(t.onComment), g = a(t.onError), v = n && n.disallowComments, b = n && n.allowTrailingComma;
  function y() {
    for (; ; ) {
      var te = r.scan();
      switch (r.getTokenError()) {
        case 4:
          w(
            14
            /* InvalidUnicode */
          );
          break;
        case 5:
          w(
            15
            /* InvalidEscapeCharacter */
          );
          break;
        case 3:
          w(
            13
            /* UnexpectedEndOfNumber */
          );
          break;
        case 1:
          v || w(
            11
            /* UnexpectedEndOfComment */
          );
          break;
        case 2:
          w(
            12
            /* UnexpectedEndOfString */
          );
          break;
        case 6:
          w(
            16
            /* InvalidCharacter */
          );
          break;
      }
      switch (te) {
        case 12:
        case 13:
          v ? w(
            10
            /* InvalidCommentToken */
          ) : p();
          break;
        case 16:
          w(
            1
            /* InvalidSymbol */
          );
          break;
        case 15:
        case 14:
          break;
        default:
          return te;
      }
    }
  }
  function w(te, se, ee) {
    if (se === void 0 && (se = []), ee === void 0 && (ee = []), g(te), se.length + ee.length > 0)
      for (var K = r.getToken(); K !== 17; ) {
        if (se.indexOf(K) !== -1) {
          y();
          break;
        } else if (ee.indexOf(K) !== -1)
          break;
        K = y();
      }
  }
  function C(te) {
    var se = r.getTokenValue();
    return te ? d(se) : c(se), y(), !0;
  }
  function T() {
    switch (r.getToken()) {
      case 11:
        var te = 0;
        try {
          te = JSON.parse(r.getTokenValue()), typeof te != "number" && (w(
            2
            /* InvalidNumberFormat */
          ), te = 0);
        } catch {
          w(
            2
            /* InvalidNumberFormat */
          );
        }
        d(te);
        break;
      case 7:
        d(null);
        break;
      case 8:
        d(!0);
        break;
      case 9:
        d(!1);
        break;
      default:
        return !1;
    }
    return y(), !0;
  }
  function E() {
    return r.getToken() !== 10 ? (w(3, [], [
      2,
      5
      /* CommaToken */
    ]), !1) : (C(!1), r.getToken() === 6 ? (l(":"), y(), Z() || w(4, [], [
      2,
      5
      /* CommaToken */
    ])) : w(5, [], [
      2,
      5
      /* CommaToken */
    ]), !0);
  }
  function D() {
    o(), y();
    for (var te = !1; r.getToken() !== 2 && r.getToken() !== 17; ) {
      if (r.getToken() === 5) {
        if (te || w(4, [], []), l(","), y(), r.getToken() === 2 && b)
          break;
      } else te && w(6, [], []);
      E() || w(4, [], [
        2,
        5
        /* CommaToken */
      ]), te = !0;
    }
    return u(), r.getToken() !== 2 ? w(7, [
      2
      /* CloseBraceToken */
    ], []) : y(), !0;
  }
  function $() {
    s(), y();
    for (var te = !1; r.getToken() !== 4 && r.getToken() !== 17; ) {
      if (r.getToken() === 5) {
        if (te || w(4, [], []), l(","), y(), r.getToken() === 4 && b)
          break;
      } else te && w(6, [], []);
      Z() || w(4, [], [
        4,
        5
        /* CommaToken */
      ]), te = !0;
    }
    return f(), r.getToken() !== 4 ? w(8, [
      4
      /* CloseBracketToken */
    ], []) : y(), !0;
  }
  function Z() {
    switch (r.getToken()) {
      case 3:
        return $();
      case 1:
        return D();
      case 10:
        return C(!0);
      default:
        return T();
    }
  }
  return y(), r.getToken() === 17 ? n.allowEmptyContent ? !0 : (w(4, [], []), !1) : Z() ? (r.getToken() !== 17 && w(9, [], []), !0) : (w(4, [], []), !1);
}
var KM = FC, ZM = UC, YM = BC, JM = WM;
function QM(e) {
  switch (e) {
    case 1:
      return "InvalidSymbol";
    case 2:
      return "InvalidNumberFormat";
    case 3:
      return "PropertyNameExpected";
    case 4:
      return "ValueExpected";
    case 5:
      return "ColonExpected";
    case 6:
      return "CommaExpected";
    case 7:
      return "CloseBraceExpected";
    case 8:
      return "CloseBracketExpected";
    case 9:
      return "EndOfFileExpected";
    case 10:
      return "InvalidCommentToken";
    case 11:
      return "UnexpectedEndOfComment";
    case 12:
      return "UnexpectedEndOfString";
    case 13:
      return "UnexpectedEndOfNumber";
    case 14:
      return "InvalidUnicode";
    case 15:
      return "InvalidEscapeCharacter";
    case 16:
      return "InvalidCharacter";
  }
  return "<unknown ParseErrorCode>";
}
function XM(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var HC = { exports: {} }, oi = HC.exports = {}, mo, go;
function q6() {
  throw new Error("setTimeout has not been defined");
}
function D6() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? mo = setTimeout : mo = q6;
  } catch {
    mo = q6;
  }
  try {
    typeof clearTimeout == "function" ? go = clearTimeout : go = D6;
  } catch {
    go = D6;
  }
})();
function zC(e) {
  if (mo === setTimeout)
    return setTimeout(e, 0);
  if ((mo === q6 || !mo) && setTimeout)
    return mo = setTimeout, setTimeout(e, 0);
  try {
    return mo(e, 0);
  } catch {
    try {
      return mo.call(null, e, 0);
    } catch {
      return mo.call(this, e, 0);
    }
  }
}
function eF(e) {
  if (go === clearTimeout)
    return clearTimeout(e);
  if ((go === D6 || !go) && clearTimeout)
    return go = clearTimeout, clearTimeout(e);
  try {
    return go(e);
  } catch {
    try {
      return go.call(null, e);
    } catch {
      return go.call(this, e);
    }
  }
}
var Xo = [], tc = !1, gu, $d = -1;
function tF() {
  !tc || !gu || (tc = !1, gu.length ? Xo = gu.concat(Xo) : $d = -1, Xo.length && GC());
}
function GC() {
  if (!tc) {
    var e = zC(tF);
    tc = !0;
    for (var t = Xo.length; t; ) {
      for (gu = Xo, Xo = []; ++$d < t; )
        gu && gu[$d].run();
      $d = -1, t = Xo.length;
    }
    gu = null, tc = !1, eF(e);
  }
}
oi.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  Xo.push(new VC(e, t)), Xo.length === 1 && !tc && zC(GC);
};
function VC(e, t) {
  this.fun = e, this.array = t;
}
VC.prototype.run = function() {
  this.fun.apply(null, this.array);
};
oi.title = "browser";
oi.browser = !0;
oi.env = {};
oi.argv = [];
oi.version = "";
oi.versions = {};
function as() {
}
oi.on = as;
oi.addListener = as;
oi.once = as;
oi.off = as;
oi.removeListener = as;
oi.removeAllListeners = as;
oi.emit = as;
oi.prependListener = as;
oi.prependOnceListener = as;
oi.listeners = function(e) {
  return [];
};
oi.binding = function(e) {
  throw new Error("process.binding is not supported");
};
oi.cwd = function() {
  return "/";
};
oi.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
oi.umask = function() {
  return 0;
};
var rF = HC.exports;
const bn = /* @__PURE__ */ XM(rF), nF = Math.floor(Date.now() / 36e5), WC = `__object_order_${nF}__`, Ei = Symbol.for(WC), iF = {
  defineProperty(e, t, n) {
    return !Object.prototype.hasOwnProperty.call(e, t) && Ei in e ? e[Ei].push(t) : "value" in n && t === Ei && n.value.lastIndexOf(Ei) === -1 && n.value.push(Ei), Reflect.defineProperty(e, t, n);
  },
  deleteProperty(e, t) {
    const n = Object.prototype.hasOwnProperty.call(e, t), r = Reflect.deleteProperty(e, t);
    if (r && n && Ei in e) {
      const i = e[Ei].indexOf(t);
      i !== -1 && e[Ei].splice(i, 1);
    }
    return r;
  },
  ownKeys(e) {
    return Ei in e ? e[Ei] : Reflect.ownKeys(e);
  },
  set(e, t, n) {
    const r = Object.prototype.hasOwnProperty.call(e, t), i = Reflect.set(e, t, n);
    return i && !r && Ei in e && e[Ei].push(t), i;
  }
};
function aF(e, t = Reflect.ownKeys(e)) {
  lF(e);
  const n = new Proxy(e, iF);
  return oF(n, t), n;
}
function oF(e, t) {
  return Ei in e ? (e[Ei].length = 0, e[Ei].push(...t), !0) : Reflect.defineProperty(e, Ei, {
    configurable: !0,
    value: t
  });
}
function sF(e) {
  return e[Ei];
}
function L6(e) {
  return e !== null && typeof e == "object";
}
function uF(e) {
  if (!L6(e)) return !1;
  if (e[Symbol.toStringTag] !== void 0) {
    const t = Object.getPrototypeOf(e);
    return t === null || t === Object.prototype;
  }
  return cF(e) === "Object";
}
function cF(e) {
  const t = e[Symbol.toStringTag];
  if (typeof t == "string")
    return t;
  const n = Reflect.apply(Object.prototype.toString, e, []);
  return n.slice(8, n.length - 1);
}
function lF(e, t) {
  if (fF() && !uF(e))
    throw new TypeError(t);
}
function fF() {
  return typeof bn > "u" || !L6(bn) || !L6(bn.env) ? !1 : bn.env.NODE_ENV === "development" || bn.env.NODE_ENV === "test";
}
var bb;
(function(e) {
  e.None = "none", e.Declared = "declared", e.InheritedFromService = "inheritedFromService";
})(bb || (bb = {}));
var xb;
(function(e) {
  e.Unspecified = "unspecified", e.Simple = "simple", e.Matrix = "matrix", e.Label = "label", e.Form = "form", e.CommaDelimited = "commaDelimited", e.SpaceDelimited = "spaceDelimited", e.PipeDelimited = "pipeDelimited", e.DeepObject = "deepObject", e.TabDelimited = "tabDelimited";
})(xb || (xb = {}));
var r0;
(function(e) {
  e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Information = 2] = "Information", e[e.Hint = 3] = "Hint";
})(r0 || (r0 = {}));
var _b;
(function(e) {
  e.Article = "article", e.HttpService = "http_service", e.HttpServer = "http_server", e.HttpOperation = "http_operation", e.HttpCallback = "http_callback", e.Model = "model", e.Generic = "generic", e.Unknown = "unknown", e.TableOfContents = "table_of_contents", e.SpectralRuleset = "spectral_ruleset", e.Styleguide = "styleguide", e.Image = "image", e.StoplightResolutions = "stoplight_resolutions", e.StoplightOverride = "stoplight_override";
})(_b || (_b = {}));
var wb;
(function(e) {
  e.Json = "json", e.Markdown = "markdown", e.Yaml = "yaml", e.Javascript = "javascript", e.Apng = "apng", e.Avif = "avif", e.Bmp = "bmp", e.Gif = "gif", e.Jpeg = "jpeg", e.Png = "png", e.Svg = "svg", e.Webp = "webp";
})(wb || (wb = {}));
var Ah, Sb;
function pF() {
  if (Sb) return Ah;
  Sb = 1, Ah = p;
  var e = "";
  const t = /[\x00-\x1f\x22\x5c]/, n = /[\x00-\x1f\x22\x5c]/g, r = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000b",
    "\\f",
    "\\r",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\"
  ];
  function i(g) {
    return r[g.charCodeAt(0)];
  }
  function a(g) {
    if (g.length < 5e3 && !t.test(g))
      return g;
    if (g.length > 100)
      return g.replace(n, i);
    for (var v = "", b = 0, y = 0; y < g.length; y++) {
      const w = g.charCodeAt(y);
      (w === 34 || w === 92 || w < 32) && (b === y ? v += r[w] : v += `${g.slice(b, y)}${r[w]}`, b = y + 1);
    }
    return b === 0 ? v = g : b !== y && (v += g.slice(b)), v;
  }
  function o(g, v, b, y, w) {
    var C, T, E;
    const D = e;
    var $ = v[g];
    switch (typeof $ == "object" && $ !== null && typeof $.toJSON == "function" && ($ = $.toJSON(g)), $ = y.call(v, g, $), typeof $) {
      case "object":
        if ($ === null)
          return "null";
        for (C = 0; C < b.length; C++)
          if (b[C] === $)
            return '"[Circular]"';
        if (Array.isArray($)) {
          if ($.length === 0)
            return "[]";
          for (b.push($), T = "[", e += w, T += `
${e}`, E = `,
${e}`, C = 0; C < $.length - 1; C++) {
            const ee = o(C, $, b, y, w);
            T += ee !== void 0 ? ee : "null", T += E;
          }
          const se = o(C, $, b, y, w);
          return T += se !== void 0 ? se : "null", e !== "" && (T += `
${D}`), T += "]", b.pop(), e = D, T;
        }
        var Z = l(Object.keys($));
        if (Z.length === 0)
          return "{}";
        b.push($), T = "{", e += w, T += `
${e}`, E = `,
${e}`;
        var te = "";
        for (C = 0; C < Z.length; C++) {
          g = Z[C];
          const se = o(g, $, b, y, w);
          se !== void 0 && (T += `${te}"${a(g)}": ${se}`, te = E);
        }
        return te !== "" ? T += `
${D}` : T = "{", T += "}", b.pop(), e = D, T;
      case "string":
        return `"${a($)}"`;
      case "number":
        return isFinite($) ? String($) : "null";
      case "boolean":
        return $ === !0 ? "true" : "false";
    }
  }
  function c(g, v, b, y, w) {
    var C, T, E;
    const D = e;
    switch (typeof v == "object" && v !== null && typeof v.toJSON == "function" && (v = v.toJSON(g)), typeof v) {
      case "object":
        if (v === null)
          return "null";
        for (C = 0; C < b.length; C++)
          if (b[C] === v)
            return '"[Circular]"';
        if (Array.isArray(v)) {
          if (v.length === 0)
            return "[]";
          for (b.push(v), T = "[", e += w, T += `
${e}`, E = `,
${e}`, C = 0; C < v.length - 1; C++) {
            const te = c(C, v[C], b, y, w);
            T += te !== void 0 ? te : "null", T += E;
          }
          const Z = c(C, v[C], b, y, w);
          return T += Z !== void 0 ? Z : "null", e !== "" && (T += `
${D}`), T += "]", b.pop(), e = D, T;
        }
        if (y.length === 0)
          return "{}";
        b.push(v), T = "{", e += w, T += `
${e}`, E = `,
${e}`;
        var $ = "";
        for (C = 0; C < y.length; C++)
          if (typeof y[C] == "string" || typeof y[C] == "number") {
            g = y[C];
            const Z = c(g, v[g], b, y, w);
            Z !== void 0 && (T += `${$}"${a(g)}": ${Z}`, $ = E);
          }
        return $ !== "" ? T += `
${D}` : T = "{", T += "}", b.pop(), e = D, T;
      case "string":
        return `"${a(v)}"`;
      case "number":
        return isFinite(v) ? String(v) : "null";
      case "boolean":
        return v === !0 ? "true" : "false";
    }
  }
  function u(g, v, b, y) {
    var w, C, T;
    const E = e;
    switch (typeof v) {
      case "object":
        if (v === null)
          return "null";
        if (typeof v.toJSON == "function") {
          if (v = v.toJSON(g), typeof v != "object")
            return u(g, v, b, y);
          if (v === null)
            return "null";
        }
        for (w = 0; w < b.length; w++)
          if (b[w] === v)
            return '"[Circular]"';
        if (Array.isArray(v)) {
          if (v.length === 0)
            return "[]";
          for (b.push(v), C = "[", e += y, C += `
${e}`, T = `,
${e}`, w = 0; w < v.length - 1; w++) {
            const te = u(w, v[w], b, y);
            C += te !== void 0 ? te : "null", C += T;
          }
          const Z = u(w, v[w], b, y);
          return C += Z !== void 0 ? Z : "null", e !== "" && (C += `
${E}`), C += "]", b.pop(), e = E, C;
        }
        var D = l(Object.keys(v));
        if (D.length === 0)
          return "{}";
        b.push(v), C = "{", e += y, C += `
${e}`, T = `,
${e}`;
        var $ = "";
        for (w = 0; w < D.length; w++) {
          g = D[w];
          const Z = u(g, v[g], b, y);
          Z !== void 0 && (C += `${$}"${a(g)}": ${Z}`, $ = T);
        }
        return $ !== "" ? C += `
${E}` : C = "{", C += "}", b.pop(), e = E, C;
      case "string":
        return `"${a(v)}"`;
      case "number":
        return isFinite(v) ? String(v) : "null";
      case "boolean":
        return v === !0 ? "true" : "false";
    }
  }
  function s(g, v, b, y) {
    var w, C;
    switch (typeof v == "object" && v !== null && typeof v.toJSON == "function" && (v = v.toJSON(g)), typeof v) {
      case "object":
        if (v === null)
          return "null";
        for (w = 0; w < b.length; w++)
          if (b[w] === v)
            return '"[Circular]"';
        if (Array.isArray(v)) {
          if (v.length === 0)
            return "[]";
          for (b.push(v), C = "[", w = 0; w < v.length - 1; w++) {
            const D = s(w, v[w], b, y);
            C += D !== void 0 ? D : "null", C += ",";
          }
          const E = s(w, v[w], b, y);
          return C += E !== void 0 ? E : "null", C += "]", b.pop(), C;
        }
        if (y.length === 0)
          return "{}";
        b.push(v), C = "{";
        var T = "";
        for (w = 0; w < y.length; w++)
          if (typeof y[w] == "string" || typeof y[w] == "number") {
            g = y[w];
            const E = s(g, v[g], b, y);
            E !== void 0 && (C += `${T}"${a(g)}":${E}`, T = ",");
          }
        return C += "}", b.pop(), C;
      case "string":
        return `"${a(v)}"`;
      case "number":
        return isFinite(v) ? String(v) : "null";
      case "boolean":
        return v === !0 ? "true" : "false";
    }
  }
  function f(g, v, b, y) {
    var w, C, T = v[g];
    switch (typeof T == "object" && T !== null && typeof T.toJSON == "function" && (T = T.toJSON(g)), T = y.call(v, g, T), typeof T) {
      case "object":
        if (T === null)
          return "null";
        for (w = 0; w < b.length; w++)
          if (b[w] === T)
            return '"[Circular]"';
        if (Array.isArray(T)) {
          if (T.length === 0)
            return "[]";
          for (b.push(T), C = "[", w = 0; w < T.length - 1; w++) {
            const Z = f(w, T, b, y);
            C += Z !== void 0 ? Z : "null", C += ",";
          }
          const $ = f(w, T, b, y);
          return C += $ !== void 0 ? $ : "null", C += "]", b.pop(), C;
        }
        var E = l(Object.keys(T));
        if (E.length === 0)
          return "{}";
        b.push(T), C = "{";
        var D = "";
        for (w = 0; w < E.length; w++) {
          g = E[w];
          const $ = f(g, T, b, y);
          $ !== void 0 && (C += `${D}"${a(g)}":${$}`, D = ",");
        }
        return C += "}", b.pop(), C;
      case "string":
        return `"${a(T)}"`;
      case "number":
        return isFinite(T) ? String(T) : "null";
      case "boolean":
        return T === !0 ? "true" : "false";
    }
  }
  function d(g, v, b) {
    var y, w;
    switch (typeof v) {
      case "object":
        if (v === null)
          return "null";
        if (typeof v.toJSON == "function") {
          if (v = v.toJSON(g), typeof v != "object")
            return d(g, v, b);
          if (v === null)
            return "null";
        }
        for (y = 0; y < b.length; y++)
          if (b[y] === v)
            return '"[Circular]"';
        if (Array.isArray(v)) {
          if (v.length === 0)
            return "[]";
          for (b.push(v), w = "[", y = 0; y < v.length - 1; y++) {
            const D = d(y, v[y], b);
            w += D !== void 0 ? D : "null", w += ",";
          }
          const E = d(y, v[y], b);
          return w += E !== void 0 ? E : "null", w += "]", b.pop(), w;
        }
        var C = l(Object.keys(v));
        if (C.length === 0)
          return "{}";
        b.push(v);
        var T = "";
        for (w = "{", y = 0; y < C.length; y++) {
          g = C[y];
          const E = d(g, v[g], b);
          E !== void 0 && (w += `${T}"${a(g)}":${E}`, T = ",");
        }
        return w += "}", b.pop(), w;
      case "string":
        return `"${a(v)}"`;
      case "number":
        return isFinite(v) ? String(v) : "null";
      case "boolean":
        return v === !0 ? "true" : "false";
    }
  }
  function l(g) {
    for (var v = 1; v < g.length; v++) {
      const y = g[v];
      for (var b = v; b !== 0 && g[b - 1] > y; )
        g[b] = g[b - 1], b--;
      g[b] = y;
    }
    return g;
  }
  function p(g, v, b) {
    var y, w = "";
    if (e = "", arguments.length > 1) {
      if (typeof b == "number")
        for (y = 0; y < b; y += 1)
          w += " ";
      else typeof b == "string" && (w = b);
      if (w !== "") {
        if (v != null) {
          if (typeof v == "function")
            return o("", { "": g }, [], v, w);
          if (Array.isArray(v))
            return c("", g, [], v, w);
        }
        return u("", g, [], w);
      }
      if (typeof v == "function")
        return f("", { "": g }, [], v);
      if (Array.isArray(v))
        return s("", g, [], v);
    }
    return d("", g, []);
  }
  return Ah;
}
var kh, Cb;
function dF() {
  if (Cb) return kh;
  Cb = 1;
  const e = pF();
  return kh = e, e.default = e, kh;
}
var hF = dF();
const mF = /* @__PURE__ */ g2(hF);
function _u(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype || typeof e.constructor == "function" && Function.toString.call(Object) === Function.toString.call(e.constructor);
}
function gF(e, t, n) {
  if (!_u(e) && !Array.isArray(e) || !(t in e)) throw new ReferenceError(`Could not resolve '${n}'`);
}
function N6(e) {
  if (typeof e.$ref != "string") throw new TypeError("$ref should be a string");
}
const n0 = (e) => _u(e) && "$ref" in e, KC = (e) => n0(e) && typeof e.$ref == "string", N0 = (e) => e.length > 0 && (e === "#" || /^#\S*$/.test(e)), ws = (e, t, n) => {
  const r = e.toString();
  let i = "", a = r, o = 0, c = a.indexOf(t);
  for (; c > -1; ) i += r.substring(o, o + c) + n, a = a.substring(c + t.length, a.length), o += c + t.length, c = a.indexOf(t);
  return a.length > 0 && (i += r.substring(r.length - a.length, r.length)), i;
}, pf = (e) => typeof e == "number" ? e : ws(ws(e, "~", "~0"), "/", "~1"), vF = /[^a-zA–Z0–9_.!~*'()\/\-\u{D800}-\u{DFFF}]/gu;
function ZC(e) {
  return e.replace(vF, encodeURIComponent);
}
const YC = (e) => {
  const t = pf(e);
  return typeof t == "number" ? t : ZC(t);
}, i0 = (e) => yF(e), yF = (e) => {
  if (e && typeof e != "object") throw new TypeError("Invalid type: path must be an array of segments.");
  return e.length === 0 ? "#" : `#/${e.map(YC).join("/")}`;
};
function bF(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}
const xF = /%[0-9a-f]+/gi, $6 = (e) => {
  let t;
  try {
    t = decodeURIComponent(e);
  } catch {
    t = e.replace(xF, bF);
  }
  return ws(ws(t, "~1", "/"), "~0", "~");
}, Ra = (e) => _F(e), _F = (e) => {
  if (typeof e != "string") throw new TypeError("Invalid type: JSON Pointers are represented as strings.");
  if (e.length === 0 || e[0] !== "#") throw new URIError("Invalid JSON Pointer syntax; URI fragment identifiers must begin with a hash.");
  if (e.length === 1) return [];
  if (e[1] !== "/") throw new URIError("Invalid JSON Pointer syntax.");
  return ((t) => {
    const n = t.length, r = [];
    let i = -1;
    for (; ++i < n; ) r.push($6(t[i]));
    return r;
  })(e.substring(2).split("/"));
}, JC = (e, t, n) => {
  const r = { value: e, path: n };
  t.onEnter && t.onEnter(r);
  for (const i of Object.keys(e)) {
    const a = e[i];
    t.onProperty && t.onProperty({ parent: e, parentPath: n, property: i, propertyValue: a }), typeof a == "object" && a !== null && JC(a, t, n.concat(i));
  }
  t.onLeave && t.onLeave(r);
}, _2 = (e, t) => {
  typeof e == "object" && e !== null && JC(e, typeof t == "function" ? { onProperty: t } : t, []);
};
function QC(e, t, n) {
  _2(e, { onProperty({ property: r, propertyValue: i, parent: a }) {
    r === "$ref" && typeof i == "string" && i.startsWith(t) && (a.$ref = `${n}${i.slice(t.length)}`);
  } });
}
const XC = (e) => e.length > 0 && e[0] !== "#", w2 = (e) => {
  if (typeof e != "string" || e.length === 0 || !XC(e)) return null;
  const t = e.indexOf("#");
  return t === -1 ? e : e.slice(0, t);
};
function eA(e, t) {
  return _u(t) && _u(e) && ("summary" in e || "description" in e) ? Object.assign(Object.assign(Object.assign({}, t), "description" in e ? { description: e.description } : null), "summary" in e ? { summary: e.summary } : null) : t;
}
function* tA(e, t, n) {
  n0(e.value) && (N6(e.value), yield [-1, e.value]);
  for (const [r, i] of t.entries()) gF(e.value, i, n), e.value = e.value[i], n0(e.value) && (N6(e.value), yield [r, e.value]);
}
function rA(e, t) {
  return nA(e, t).value;
}
function nA(e, t) {
  return function n(r, i, a, o) {
    if (w2(i) !== null) throw new ReferenceError("Cannot resolve external references");
    const c = Ra(i);
    let u = [...c];
    i === "#" && n0(r) && (N6(r), c.unshift(...Ra(r.$ref)));
    const s = { value: r };
    for (const [f, d] of tA(s, c, i)) {
      if (a.includes(d)) return { source: null, location: o ?? u, value: a[a.length - 1] };
      a.push(d);
      const l = n(r, d.$ref, a, u);
      s.value = l.value, (u = l.location).push(...c.slice(f + 1));
    }
    return { source: null, location: u, value: a.length > 0 ? eA(a[a.length - 1], s.value) : s.value };
  }(e, t, []);
}
const wF = "#/__bundled__", SF = "#/__errors__", CF = ({ document: e, path: t, bundleRoot: n = "#/__bundled__", errorsRoot: r = "#/__errors__", cloneDocument: i = !0, keyProvider: a }, o) => {
  if (t === n || t === r) throw new Error("Roots do not make any sense");
  const c = i ? vi.cloneDeep(e) : e;
  return AF(c, Ra(n), Ra(r), t, a)(t, { [t]: !0 }, o);
}, AF = (e, t, n, r, i) => {
  const a = /* @__PURE__ */ new Set(), o = (c, u, s, f = {}, d = {}, l = {}) => {
    const p = Ra(c), g = vi.get(e, p);
    _2(s || g, { onEnter: ({ value: b }) => {
      if (KC(b) && N0(b.$ref)) {
        const y = b.$ref;
        if (l[y]) return;
        if (y === c && (f[y] = "#"), f[y]) return void (b.$ref = f[y]);
        let w, C, T, E, D;
        try {
          let $;
          w = Ra(y), i && ($ = i({ document: e, path: w })), $ || ($ = (({ document: te, path: se }) => se.length === 0 ? "root" : Array.isArray(vi.get(te, se.slice(0, -1))) ? `${se[se.length - 2]}_${se[se.length - 1]}` : String(se[se.length - 1]))({ document: e, path: w })), T = $;
          let Z = 1;
          for (; a.has(T); ) if (T = `${$}_${++Z}`, Z > 20) throw new Error(`Keys ${$}_2 through ${$}_20 already taken.`);
          a.add(T), C = [...t, T], E = i0(C);
        } catch ($) {
          l[y] = $ instanceof Error ? $.message : String($);
        }
        if (!w || !C || !E) return;
        if (typeof e == "object" && e !== null && !(D = vi.get(e, w))) try {
          D = rA(Object(e), y);
        } catch {
        }
        D !== void 0 && (f[y] = E, b.$ref = E, vi.has(d, C) || (Array.isArray(D) ? vi.set(d, C, new Array(D.length).fill(null)) : typeof D == "object" && vi.setWith(d, C, {}, Object), vi.set(d, C, D), y === "#" ? function($, Z, te, se) {
          const ee = te.map((de) => `[${JSON.stringify(de)}]`).join(""), K = JSON.parse(JSON.stringify(vi.omit(Object($), ee))), re = {};
          vi.set(Z, se, K), vi.set(K, te, re), QC(K, "#", i0(se)), re.$ref = "#";
        }(e, d, Ra(r), C) : u[y] || (u[y] = !0, o(c, u, D, f, d, l), u[y] = !1)));
      }
    } });
    const v = vi.get(d, t);
    return v && Object.keys(v).length && vi.set(g, t, v), (Object.keys(l).length || vi.has(e, n)) && vi.set(g, n, vi.has(e, n) ? vi.get(e, n) : l), g;
  };
  return o;
}, S2 = (e) => ws(ws(e, "~1", "/"), "~0", "~"), kF = (e, t) => {
  const n = /* @__PURE__ */ new WeakMap();
  return function r(i, a) {
    let o;
    if (t && (i = t(i)), _u(i) || Array.isArray(i)) {
      const c = n.get(i);
      return c ? { $ref: c } : (n.set(i, i0(a)), Array.isArray(i) ? o = i.map((u, s) => r(u, [...a, String(s)])) : (o = {}, Object.keys(i).forEach((u) => {
        o[u] = r(i[u], [...a, u]);
      })), n.delete(i), o);
    }
    return i;
  }(e, []);
}, EF = (e) => ws(ws(e, "~", "~0"), "//", "/~1"), iA = (e) => {
  if (typeof e != "string" || e.length === 0) return null;
  const t = e.indexOf("#");
  return t === -1 ? null : e.slice(t);
}, OF = (e) => {
  const t = KM(e, !0);
  if (t.scan(), t.getToken() !== 1 || (t.scan(), t.getToken() === 2)) return;
  if (t.getToken() !== 10) throw new SyntaxError("Unexpected character");
  const n = t.getTokenValue();
  if (t.scan(), t.getToken() !== 6) throw new SyntaxError("Colon expected");
  switch (t.scan(), t.getToken()) {
    case 10:
      return [n, t.getTokenValue()];
    case 11:
      return [n, Number(t.getTokenValue())];
    case 8:
      return [n, !0];
    case 9:
      return [n, !1];
    case 7:
      return [n, null];
    case 16:
      throw new SyntaxError("Unexpected character");
    case 17:
      throw new SyntaxError("Unexpected end of file");
    default:
      return;
  }
}, TF = ({ lineMap: e, ast: t }, n) => {
  const r = e[n.line], i = e[n.line + 1];
  if (r === void 0) return;
  const a = ZM(t, i === void 0 ? r + n.character : Math.min(i, r + n.character), !0);
  if (a === void 0) return;
  const o = YM(a);
  return o.length !== 0 ? o : void 0;
};
function PF(e) {
  return S2(e.split("/").pop() || "");
}
const RF = ({ ast: e }, t, n = !1) => {
  const r = function(i, a, o) {
    e: for (const c of a) {
      const u = Number.isInteger(Number(c)) ? Number(c) : c;
      if (typeof u == "string" || typeof u == "number" && i.type !== "array") {
        if (i.type !== "object" || !Array.isArray(i.children)) return o ? i : void 0;
        for (const s of i.children) if (Array.isArray(s.children) && s.children[0].value === String(u) && s.children.length === 2) {
          i = s.children[1];
          continue e;
        }
        return o ? i : void 0;
      }
      if (i.type !== "array" || u < 0 || !Array.isArray(i.children) || u >= i.children.length) return o ? i : void 0;
      i = i.children[u];
    }
    return i;
  }(e, t, n);
  if (r !== void 0 && r.range !== void 0) return { range: r.range };
}, jF = (e, t = { disallowComments: !0 }) => {
  const n = [], { ast: r, data: i, lineMap: a } = aA(e, n, t);
  return { data: i, diagnostics: n, ast: r, lineMap: a };
};
function aA(e, t = [], n) {
  const r = qF(e);
  let i = { type: "array", offset: -1, length: -1, children: [], parent: void 0 }, a = null, o = [];
  const c = /* @__PURE__ */ new WeakMap(), u = [];
  function s(b) {
    i.type === "property" && (i.length = b - i.offset, i = i.parent);
  }
  function f(b, y, w) {
    return { start: { line: b, character: y }, end: { line: b, character: y + w } };
  }
  function d(b) {
    return i.children.push(b), b;
  }
  function l(b) {
    Array.isArray(o) ? o.push(b) : a !== null && (o[a] = b);
  }
  function p(b) {
    l(b), u.push(o), o = b, a = null;
  }
  function g() {
    o = u.pop();
  }
  JM(e, { onObjectBegin: (b, y, w, C) => {
    i = d({ type: "object", offset: b, length: -1, parent: i, children: [], range: f(w, C, y) }), n.ignoreDuplicateKeys === !1 && c.set(i, []), p(function(T) {
      return T ? aF({}) : {};
    }(n.preserveKeyOrder === !0));
  }, onObjectProperty: (b, y, w, C, T) => {
    if ((i = d({ type: "property", offset: y, length: -1, parent: i, children: [] })).children.push({ type: "string", value: b, offset: y, length: w, parent: i }), n.ignoreDuplicateKeys === !1) {
      const E = c.get(i.parent);
      E && (E.length !== 0 && E.includes(b) ? t.push({ range: f(C, T, w), message: "DuplicateKey", severity: r0.Error, path: oA(i), code: 20 }) : E.push(b));
    }
    n.preserveKeyOrder === !0 && function(E, D) {
      if (!(D in E)) return;
      const $ = sF(E), Z = $.indexOf(D);
      Z !== -1 && ($.splice(Z, 1), $.push(D));
    }(o, b), a = b;
  }, onObjectEnd: (b, y, w, C) => {
    n.ignoreDuplicateKeys === !1 && c.delete(i), i.length = b + y - i.offset, i.range && (i.range.end.line = w, i.range.end.character = C + y), i = i.parent, s(b + y), g();
  }, onArrayBegin: (b, y, w, C) => {
    i = d({ type: "array", offset: b, length: -1, parent: i, children: [], range: f(w, C, y) }), p([]);
  }, onArrayEnd: (b, y, w, C) => {
    i.length = b + y - i.offset, i.range && (i.range.end.line = w, i.range.end.character = C + y), i = i.parent, s(b + y), g();
  }, onLiteralValue: (b, y, w, C, T) => {
    d({ type: IF(b), offset: y, length: w, parent: i, value: b, range: f(C, T, w) }), s(y + w), l(b);
  }, onSeparator: (b, y) => {
    i.type === "property" && (b === ":" ? i.colonOffset = y : b === "," && s(y));
  }, onError: (b, y, w, C, T) => {
    t.push({ range: f(C, T, w), message: QM(b), severity: r0.Error, code: b });
  } }, n);
  const v = i.children[0];
  return v && delete v.parent, { ast: v, data: o[0], lineMap: r };
}
function IF(e) {
  switch (typeof e) {
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    default:
      return "null";
  }
}
const qF = (e) => {
  const t = [0];
  let n = 0;
  for (; n < e.length; n++) e[n] === `
` && t.push(n + 1);
  return t.push(n + 1), t;
};
function oA(e, t = []) {
  return e.type === "property" && t.unshift(e.children[0].value), e.parent !== void 0 ? (e.parent.type === "array" && e.parent.parent !== void 0 && t.unshift(e.parent.children.indexOf(e)), oA(e.parent, t)) : t;
}
const DF = (e, t, n) => {
  if (!e || !Object.hasOwnProperty.call(e, t) || t === n) return e;
  const r = {};
  for (const [i, a] of Object.entries(e)) i === t ? r[n] = a : i in r || (r[i] = a);
  return r;
};
function Yp(e) {
  return _u(e) || Array.isArray(e);
}
function LF(e, t, n) {
  if (n.length <= 1 || t.length <= 1) throw Error("Source/target path must not be empty and point at root");
  if (t.indexOf(n) === 0) throw Error("Target path cannot be contained within source");
  const r = Ra(t);
  let i = e;
  for (const c of r) {
    if (!Yp(i)) return;
    i = i[c];
  }
  if (!Yp(i)) return;
  const a = Ra(n);
  let o = e;
  for (const [c, u] of a.entries()) {
    if (!Yp(o) || u in o) return;
    const s = c === a.length - 1 ? i : {};
    o[u] = s, o = s;
  }
  delete e[r[0]], function c(u, s, f) {
    for (const d of Object.keys(u)) {
      const l = u[d];
      if (d !== "$ref") Yp(l) && c(l, s, f);
      else {
        if (typeof l != "string" || !N0(l)) continue;
        l.indexOf(s) === 0 && (u[d] = l.replace(s, f));
      }
    }
  }(e, t, n);
}
async function sA(e, t, n, r, i) {
  let a = function(d, l) {
    const p = w2(l);
    return p === null ? d : zM(p) ? p : GM(HM(d), p);
  }(t, n);
  const o = iA(n) || "#", c = await e[a], u = Ra(o);
  let s = [...u];
  const f = { value: c };
  for (const [d, l] of tA(f, u, o)) {
    if (r.includes(l)) return { source: t, location: i ?? s, value: r[r.length - 1] };
    r.push(l);
    const p = await sA(e, a, l.$ref, r, s);
    ({ source: a, location: s } = p), f.value = p.value, s.push(...u.slice(d + 1));
  }
  return { source: a, location: s, value: r.length > 0 ? eA(r[r.length - 1], f.value) : f.value };
}
async function NF(e, t, n) {
  return (await uA(e, t, n)).value;
}
function uA(e, t, n) {
  return sA(e, t, n, []);
}
const $F = (e, t) => {
  if (typeof e != "string") return e;
  try {
    const n = MF(e);
    return typeof n == "string" ? n : JSON.parse(e, t);
  } catch {
    return;
  }
}, MF = (e) => {
  const t = Number(e);
  return Number.isFinite(t) ? String(t) === e ? t : e : NaN;
}, cA = (e, t, n) => {
  if (typeof e == "string") return e;
  try {
    return JSON.stringify(e, t, n);
  } catch {
    return mF(e, t, n);
  }
}, FF = (e, t) => {
  if (e instanceof Array) {
    if (t instanceof Array) {
      if (t.length > e.length) return !1;
      for (const n in t) {
        if (!t.hasOwnProperty(n)) continue;
        const r = parseInt(e[n]), i = parseInt(t[n]);
        if (isNaN(r) && isNaN(i)) {
          if (e[n] !== t[n]) return !1;
        } else if (r !== i) return !1;
      }
    }
  } else {
    if (typeof e != "string") return !1;
    if (typeof t == "string") return e.startsWith(t);
  }
  return !0;
}, BF = (e, t, n) => {
  const r = cA(e, t, n);
  if (r === void 0) throw new Error("The value could not be stringified");
  return r;
};
function UF(e) {
  return e.replace(/^(\/|#\/)/, "").split("/").map(S2).map(HF).join(".");
}
function HF(e) {
  return e.includes(".") ? `["${e.replace(/"/g, '\\"')}"]` : e;
}
const M6 = Symbol.for(WC), zF = { ownKeys: (e) => M6 in e ? e[M6] : Reflect.ownKeys(e) }, GF = (e) => new Proxy(e, zF);
function VF(e, t) {
  if (typeof e == "string" && typeof t == "string") return vi.trimStart(e, t);
  if (!(e && Array.isArray(e) && e.length && t && Array.isArray(t) && t.length)) return e;
  let n = 0;
  for (const r in e) if (e.hasOwnProperty(r)) {
    if (e[r] !== t[r]) break;
    n++;
  }
  return e.slice(n);
}
const WF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BUNDLE_ROOT: wF,
  ERRORS_ROOT: SF,
  KEYS: M6,
  bundleTarget: CF,
  decodePointer: $6,
  decodePointerFragment: S2,
  decodePointerUriFragment: $6,
  decycle: kF,
  encodePointer: EF,
  encodePointerFragment: pf,
  encodePointerUriFragment: YC,
  encodeUriPointer: ZC,
  extractPointerFromRef: iA,
  extractSourceFromRef: w2,
  getFirstPrimitiveProperty: OF,
  getJsonPathForPosition: TF,
  getLastPathSegment: PF,
  getLocationForJsonPath: RF,
  hasRef: KC,
  isExternalRef: XC,
  isLocalRef: N0,
  isPlainObject: _u,
  parseTree: aA,
  parseWithPointers: jF,
  pathToPointer: i0,
  pointerToPath: Ra,
  remapRefs: QC,
  renameObjectKey: DF,
  reparentBundleTarget: LF,
  resolveExternalRef: NF,
  resolveExternalRefWithLocation: uA,
  resolveInlineRef: rA,
  resolveInlineRefWithLocation: nA,
  safeParse: $F,
  safeStringify: cA,
  startsWith: FF,
  stringify: BF,
  toPropertyPath: UF,
  trapAccess: GF,
  traverse: _2,
  trimStart: VF
}, Symbol.toStringTag, { value: "Module" }));
var Eh = {}, F6 = function(e, t) {
  return F6 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, F6(e, t);
};
function lA(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  F6(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var a0 = function() {
  return a0 = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, a0.apply(this, arguments);
};
function fA(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function pA(e, t, n, r) {
  var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
  else for (var c = e.length - 1; c >= 0; c--) (o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
  return i > 3 && a && Object.defineProperty(t, n, a), a;
}
function dA(e, t) {
  return function(n, r) {
    t(n, r, e);
  };
}
function hA(e, t, n, r, i, a) {
  function o(y) {
    if (y !== void 0 && typeof y != "function") throw new TypeError("Function expected");
    return y;
  }
  for (var c = r.kind, u = c === "getter" ? "get" : c === "setter" ? "set" : "value", s = !t && e ? r.static ? e : e.prototype : null, f = t || (s ? Object.getOwnPropertyDescriptor(s, r.name) : {}), d, l = !1, p = n.length - 1; p >= 0; p--) {
    var g = {};
    for (var v in r) g[v] = v === "access" ? {} : r[v];
    for (var v in r.access) g.access[v] = r.access[v];
    g.addInitializer = function(y) {
      if (l) throw new TypeError("Cannot add initializers after decoration has completed");
      a.push(o(y || null));
    };
    var b = (0, n[p])(c === "accessor" ? { get: f.get, set: f.set } : f[u], g);
    if (c === "accessor") {
      if (b === void 0) continue;
      if (b === null || typeof b != "object") throw new TypeError("Object expected");
      (d = o(b.get)) && (f.get = d), (d = o(b.set)) && (f.set = d), (d = o(b.init)) && i.unshift(d);
    } else (d = o(b)) && (c === "field" ? i.unshift(d) : f[u] = d);
  }
  s && Object.defineProperty(s, r.name, f), l = !0;
}
function mA(e, t, n) {
  for (var r = arguments.length > 2, i = 0; i < t.length; i++)
    n = r ? t[i].call(e, n) : t[i].call(e);
  return r ? n : void 0;
}
function gA(e) {
  return typeof e == "symbol" ? e : "".concat(e);
}
function vA(e, t, n) {
  return typeof t == "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", { configurable: !0, value: n ? "".concat(n, " ", t) : t });
}
function yA(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function bA(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function c(f) {
      try {
        s(r.next(f));
      } catch (d) {
        o(d);
      }
    }
    function u(f) {
      try {
        s(r.throw(f));
      } catch (d) {
        o(d);
      }
    }
    function s(f) {
      f.done ? a(f.value) : i(f.value).then(c, u);
    }
    s((r = r.apply(e, t || [])).next());
  });
}
function xA(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = c(0), o.throw = c(1), o.return = c(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function c(s) {
    return function(f) {
      return u([s, f]);
    };
  }
  function u(s) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (n = 0)), n; ) try {
      if (r = 1, i && (a = s[0] & 2 ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
      switch (i = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
        case 0:
        case 1:
          a = s;
          break;
        case 4:
          return n.label++, { value: s[1], done: !1 };
        case 5:
          n.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            n = 0;
            continue;
          }
          if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
            n.label = s[1];
            break;
          }
          if (s[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = s;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(s);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      s = t.call(e, n);
    } catch (f) {
      s = [6, f], i = 0;
    } finally {
      r = a = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}
var $0 = Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
};
function _A(e, t) {
  for (var n in e) n !== "default" && !Object.prototype.hasOwnProperty.call(t, n) && $0(t, e, n);
}
function o0(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function C2(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) a.push(i.value);
  } catch (c) {
    o = { error: c };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function wA() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(C2(arguments[t]));
  return e;
}
function SA() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var a = arguments[t], o = 0, c = a.length; o < c; o++, i++)
      r[i] = a[o];
  return r;
}
function CA(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function fc(e) {
  return this instanceof fc ? (this.v = e, this) : new fc(e);
}
function AA(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, a = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), c("next"), c("throw"), c("return", o), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(p) {
    return function(g) {
      return Promise.resolve(g).then(p, d);
    };
  }
  function c(p, g) {
    r[p] && (i[p] = function(v) {
      return new Promise(function(b, y) {
        a.push([p, v, b, y]) > 1 || u(p, v);
      });
    }, g && (i[p] = g(i[p])));
  }
  function u(p, g) {
    try {
      s(r[p](g));
    } catch (v) {
      l(a[0][3], v);
    }
  }
  function s(p) {
    p.value instanceof fc ? Promise.resolve(p.value.v).then(f, d) : l(a[0][2], p);
  }
  function f(p) {
    u("next", p);
  }
  function d(p) {
    u("throw", p);
  }
  function l(p, g) {
    p(g), a.shift(), a.length && u(a[0][0], a[0][1]);
  }
}
function kA(e) {
  var t, n;
  return t = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function r(i, a) {
    t[i] = e[i] ? function(o) {
      return (n = !n) ? { value: fc(e[i](o)), done: !1 } : a ? a(o) : o;
    } : a;
  }
}
function EA(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof o0 == "function" ? o0(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(a) {
    n[a] = e[a] && function(o) {
      return new Promise(function(c, u) {
        o = e[a](o), i(c, u, o.done, o.value);
      });
    };
  }
  function i(a, o, c, u) {
    Promise.resolve(u).then(function(s) {
      a({ value: s, done: c });
    }, o);
  }
}
function OA(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
var KF = Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}, B6 = function(e) {
  return B6 = Object.getOwnPropertyNames || function(t) {
    var n = [];
    for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[n.length] = r);
    return n;
  }, B6(e);
};
function TA(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n = B6(e), r = 0; r < n.length; r++) n[r] !== "default" && $0(t, e, n[r]);
  return KF(t, e), t;
}
function PA(e) {
  return e && e.__esModule ? e : { default: e };
}
function RA(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function jA(e, t, n, r, i) {
  if (r === "m") throw new TypeError("Private method is not writable");
  if (r === "a" && !i) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function IA(e, t) {
  if (t === null || typeof t != "object" && typeof t != "function") throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof e == "function" ? t === e : e.has(t);
}
function qA(e, t, n) {
  if (t != null) {
    if (typeof t != "object" && typeof t != "function") throw new TypeError("Object expected.");
    var r, i;
    if (n) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      r = t[Symbol.asyncDispose];
    }
    if (r === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      r = t[Symbol.dispose], n && (i = r);
    }
    if (typeof r != "function") throw new TypeError("Object not disposable.");
    i && (r = function() {
      try {
        i.call(this);
      } catch (a) {
        return Promise.reject(a);
      }
    }), e.stack.push({ value: t, dispose: r, async: n });
  } else n && e.stack.push({ async: !0 });
  return t;
}
var ZF = typeof SuppressedError == "function" ? SuppressedError : function(e, t, n) {
  var r = new Error(n);
  return r.name = "SuppressedError", r.error = e, r.suppressed = t, r;
};
function DA(e) {
  function t(a) {
    e.error = e.hasError ? new ZF(a, e.error, "An error was suppressed during disposal.") : a, e.hasError = !0;
  }
  var n, r = 0;
  function i() {
    for (; n = e.stack.pop(); )
      try {
        if (!n.async && r === 1) return r = 0, e.stack.push(n), Promise.resolve().then(i);
        if (n.dispose) {
          var a = n.dispose.call(n.value);
          if (n.async) return r |= 2, Promise.resolve(a).then(i, function(o) {
            return t(o), i();
          });
        } else r |= 1;
      } catch (o) {
        t(o);
      }
    if (r === 1) return e.hasError ? Promise.reject(e.error) : Promise.resolve();
    if (e.hasError) throw e.error;
  }
  return i();
}
function LA(e, t) {
  return typeof e == "string" && /^\.\.?\//.test(e) ? e.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(n, r, i, a, o) {
    return r ? t ? ".jsx" : ".js" : i && (!a || !o) ? n : i + a + "." + o.toLowerCase() + "js";
  }) : e;
}
const YF = {
  __extends: lA,
  __assign: a0,
  __rest: fA,
  __decorate: pA,
  __param: dA,
  __esDecorate: hA,
  __runInitializers: mA,
  __propKey: gA,
  __setFunctionName: vA,
  __metadata: yA,
  __awaiter: bA,
  __generator: xA,
  __createBinding: $0,
  __exportStar: _A,
  __values: o0,
  __read: C2,
  __spread: wA,
  __spreadArrays: SA,
  __spreadArray: CA,
  __await: fc,
  __asyncGenerator: AA,
  __asyncDelegator: kA,
  __asyncValues: EA,
  __makeTemplateObject: OA,
  __importStar: TA,
  __importDefault: PA,
  __classPrivateFieldGet: RA,
  __classPrivateFieldSet: jA,
  __classPrivateFieldIn: IA,
  __addDisposableResource: qA,
  __disposeResources: DA,
  __rewriteRelativeImportExtension: LA
}, JF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __addDisposableResource: qA,
  get __assign() {
    return a0;
  },
  __asyncDelegator: kA,
  __asyncGenerator: AA,
  __asyncValues: EA,
  __await: fc,
  __awaiter: bA,
  __classPrivateFieldGet: RA,
  __classPrivateFieldIn: IA,
  __classPrivateFieldSet: jA,
  __createBinding: $0,
  __decorate: pA,
  __disposeResources: DA,
  __esDecorate: hA,
  __exportStar: _A,
  __extends: lA,
  __generator: xA,
  __importDefault: PA,
  __importStar: TA,
  __makeTemplateObject: OA,
  __metadata: yA,
  __param: dA,
  __propKey: gA,
  __read: C2,
  __rest: fA,
  __rewriteRelativeImportExtension: LA,
  __runInitializers: mA,
  __setFunctionName: vA,
  __spread: wA,
  __spreadArray: CA,
  __spreadArrays: SA,
  __values: o0,
  default: YF
}, Symbol.toStringTag, { value: "Module" })), M0 = /* @__PURE__ */ Bf(JF);
var Ma = {};
const Yn = /* @__PURE__ */ Bf(WF);
var Fa = {}, Ab;
function Xn() {
  if (Ab) return Fa;
  Ab = 1, Object.defineProperty(Fa, "__esModule", { value: !0 }), Fa.isSerializablePrimitive = Fa.isString = Fa.isBoolean = Fa.isNonNullable = void 0;
  function e(i) {
    return i != null;
  }
  Fa.isNonNullable = e;
  function t(i) {
    return typeof i == "boolean";
  }
  Fa.isBoolean = t;
  function n(i) {
    return typeof i == "string";
  }
  Fa.isString = n;
  function r(i) {
    return t(i) || n(i) || typeof i == "number" || i === null;
  }
  return Fa.isSerializablePrimitive = r, Fa;
}
var Ba = {}, kb;
function Ci() {
  if (kb) return Ba;
  kb = 1, Object.defineProperty(Ba, "__esModule", { value: !0 }), Ba.extractId = Ba.collectExplicitProperties = Ba.isEqual = Ba.entries = void 0;
  const e = Yn, t = ti();
  function n(o) {
    return (0, e.isPlainObject)(o) ? Object.entries(o) : [];
  }
  Ba.entries = n;
  function r(o, c) {
    return (0, t.isEqualWith)(o, c, (u, s, f) => {
      if (f === "id")
        return !0;
    });
  }
  Ba.isEqual = r;
  function i(o) {
    return (0, e.isPlainObject)(o) ? Object.keys(o).filter((c) => c !== "x-stoplight") : [];
  }
  Ba.collectExplicitProperties = i;
  function a(o) {
    if ((0, e.isPlainObject)(o) && (0, e.isPlainObject)(o["x-stoplight"]) && typeof o["x-stoplight"].id == "string")
      return o["x-stoplight"].id;
  }
  return Ba.extractId = a, Ba;
}
var Ms = {}, Oh = {}, Th = {}, Eb;
function wc() {
  return Eb || (Eb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.HttpOperationSecurityDeclarationTypes = void 0, function(t) {
      t.None = "none", t.Declared = "declared", t.InheritedFromService = "inheritedFromService";
    }(e.HttpOperationSecurityDeclarationTypes || (e.HttpOperationSecurityDeclarationTypes = {})), e.HttpParamStyles = void 0, function(t) {
      t.Unspecified = "unspecified", t.Simple = "simple", t.Matrix = "matrix", t.Label = "label", t.Form = "form", t.CommaDelimited = "commaDelimited", t.SpaceDelimited = "spaceDelimited", t.PipeDelimited = "pipeDelimited", t.DeepObject = "deepObject", t.TabDelimited = "tabDelimited";
    }(e.HttpParamStyles || (e.HttpParamStyles = {})), e.DiagnosticSeverity = void 0, function(t) {
      t[t.Error = 0] = "Error", t[t.Warning = 1] = "Warning", t[t.Information = 2] = "Information", t[t.Hint = 3] = "Hint";
    }(e.DiagnosticSeverity || (e.DiagnosticSeverity = {})), e.NodeType = void 0, function(t) {
      t.Article = "article", t.HttpService = "http_service", t.HttpServer = "http_server", t.HttpOperation = "http_operation", t.HttpCallback = "http_callback", t.Model = "model", t.Generic = "generic", t.Unknown = "unknown", t.TableOfContents = "table_of_contents", t.SpectralRuleset = "spectral_ruleset", t.Styleguide = "styleguide", t.Image = "image", t.StoplightResolutions = "stoplight_resolutions", t.StoplightOverride = "stoplight_override";
    }(e.NodeType || (e.NodeType = {})), e.NodeFormat = void 0, function(t) {
      t.Json = "json", t.Markdown = "markdown", t.Yaml = "yaml", t.Javascript = "javascript", t.Apng = "apng", t.Avif = "avif", t.Bmp = "bmp", t.Gif = "gif", t.Jpeg = "jpeg", t.Png = "png", t.Svg = "svg", t.Webp = "webp";
    }(e.NodeFormat || (e.NodeFormat = {}));
  }(Th)), Th;
}
var Ob;
function Gi() {
  return Ob || (Ob = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isReferenceObject = e.isValidOas3ParamStyle = e.isValidOas3ParameterObject = e.isValidOas2ParameterObject = e.isValidParameterObject = e.hasXLogo = void 0;
    const t = Yn, n = /* @__PURE__ */ wc();
    function r(l) {
      return (0, t.isPlainObject)(l["x-logo"]);
    }
    e.hasXLogo = r;
    const i = ["query", "header", "path", "cookie"], a = ["query", "header", "path", "body", "formData"], o = Object.values(n.HttpParamStyles).filter((l) => ![n.HttpParamStyles.CommaDelimited, n.HttpParamStyles.TabDelimited].includes(l)), c = (l) => (0, t.isPlainObject)(l) && typeof l.name == "string" && typeof l.in == "string";
    e.isValidParameterObject = c;
    const u = (l) => (0, e.isValidParameterObject)(l) && a.includes(l.in);
    e.isValidOas2ParameterObject = u;
    const s = (l) => (0, e.isValidParameterObject)(l) && i.includes(l.in);
    e.isValidOas3ParameterObject = s;
    const f = (l) => o.includes(l);
    e.isValidOas3ParamStyle = f;
    function d(l) {
      return (0, t.hasRef)(l);
    }
    e.isReferenceObject = d;
  }(Oh)), Oh;
}
var Ph = {}, Tb;
function Uf() {
  return Tb || (Tb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.OasVersion = void 0, function(t) {
      t[t.OAS2 = 2] = "OAS2", t[t.OAS3 = 3] = "OAS3";
    }(e.OasVersion || (e.OasVersion = {}));
  }(Ph)), Ph;
}
var Pb;
function Os() {
  if (Pb) return Ms;
  Pb = 1, Object.defineProperty(Ms, "__esModule", { value: !0 }), Ms.getExtensions = Ms.createOasParamsIterator = void 0;
  const e = /* @__PURE__ */ Ci(), t = /* @__PURE__ */ Gi(), n = /* @__PURE__ */ Uf(), r = ["x-internal"], i = (c) => `${c.name}-${c.in}`;
  function a(c) {
    return function* (u, s) {
      var f;
      const d = /* @__PURE__ */ new Set(), { parentId: l, context: p } = this, g = Array.isArray(s.parameters) ? s.parameters : [], v = Array.isArray(u.parameters) ? u.parameters : [], b = [...g, ...v];
      for (let y = 0; y < b.length; y++) {
        this.context = y < g.length ? "operation" : "path", this.parentId = this.ids[this.context];
        const w = (f = this.maybeResolveLocalRef(b[y])) !== null && f !== void 0 ? f : b[y];
        if ((0, t.isReferenceObject)(w)) {
          yield b[y], this.context = p, this.parentId = l;
          continue;
        }
        if (!(c === n.OasVersion.OAS2 ? t.isValidOas2ParameterObject : t.isValidOas3ParameterObject)(w)) {
          this.context = p, this.parentId = l;
          continue;
        }
        const C = i(w);
        if (d.has(C)) {
          this.context = p, this.parentId = l;
          continue;
        }
        d.add(C), yield w;
      }
      this.context = p, this.parentId = l;
    };
  }
  Ms.createOasParamsIterator = a;
  function o(c) {
    return Object.fromEntries((0, e.entries)(c).filter(([u]) => u.startsWith("x-") && !r.includes(u)));
  }
  return Ms.getExtensions = o, Ms;
}
var Jc = {}, Rb;
function A2() {
  if (Rb) return Jc;
  Rb = 1, Object.defineProperty(Jc, "__esModule", { value: !0 }), Jc.toExternalDocs = void 0;
  function e(i) {
    if (!i || typeof i != "object")
      return {};
    const a = n(i);
    if (a === void 0)
      return {};
    const o = r(i);
    return {
      externalDocs: {
        url: a,
        ...o ? { description: o } : {}
      }
    };
  }
  Jc.toExternalDocs = e;
  const t = /^\s*$/;
  function n(i) {
    const a = i == null ? void 0 : i.url;
    if (!(!a || typeof a != "string" || t.test(a)))
      return a;
  }
  function r(i) {
    const a = i.description;
    if (!(!a || typeof a != "string" || t.test(a)))
      return a;
  }
  return Jc;
}
var Fs = {}, Bs = {}, Qc = {}, jb;
function QF() {
  if (jb) return Qc;
  jb = 1, Object.defineProperty(Qc, "__esModule", { value: !0 }), Qc.idGenerators = void 0;
  const e = /* @__PURE__ */ Xn();
  function t(i) {
    return i.join("-");
  }
  function n(i) {
    return i.slice().sort((a, o) => a.localeCompare(o));
  }
  function r(i) {
    return i.replace(/({)[^}]+(?=})/g, "$1");
  }
  return Qc.idGenerators = {
    tag: (i) => t(["tag", i.name]),
    schema: (i) => t(["schema", i.parentId, i.key]),
    schemaProperty: (i) => t(["schema_property", i.parentId, String(i.key)]),
    example: (i) => t(["example", i.parentId, i.keyOrName]),
    httpPath: (i) => t(["http_path", i.parentId, r(i.path)]),
    httpWebhookName: (i) => t(["http_webhook_name", i.parentId, r(i.name)]),
    httpOperation: (i) => t(["http_operation", i.parentId, i.method, r(i.path)]),
    httpWebhookOperation: (i) => t(["http_webhook_operation", i.parentId, i.method, r(i.name)]),
    httpCallbackOperation: (i) => t(["http_callback", i.parentId, i.key, i.method, i.path]),
    httpPathParam: (i) => t(["http_path_param", i.parentId, i.keyOrName]),
    httpQuery: (i) => t(["http_query", i.parentId, i.keyOrName]),
    httpCookie: (i) => t(["http_cookie", i.parentId, i.keyOrName]),
    httpHeader: (i) => t(["http_header", i.parentId, i.componentType, i.keyOrName]),
    httpRequestBody: (i) => {
      const a = [
        "http_request_body",
        i.parentId,
        ...Array.isArray(i.consumes) ? n(i.consumes) : []
      ];
      return (0, e.isNonNullable)(i.key) && a.push(i.key), t(a);
    },
    httpMedia: (i) => t(["http_media", i.parentId, i.mediaType]),
    httpSecurity: (i) => {
      var a, o, c;
      return t([
        "http_security",
        i.parentId,
        i.kind,
        i.keyOrName,
        ...i.kind === "requirement" ? [String((a = i.index) !== null && a !== void 0 ? a : ""), (c = (o = i.scopeKeys) === null || o === void 0 ? void 0 : o.join("|")) !== null && c !== void 0 ? c : ""] : []
      ]);
    },
    httpServer: (i) => t(["http_server", i.parentId, i.url]),
    httpResponse: (i) => t([
      "http_response",
      i.parentId,
      i.codeOrKey,
      ...Array.isArray(i.produces) ? n(i.produces) : []
    ])
  }, Qc;
}
var Ib;
function Ai() {
  if (Ib) return Bs;
  Ib = 1, Object.defineProperty(Bs, "__esModule", { value: !0 }), Bs.withContext = Bs.createContext = void 0;
  const e = Yn, t = /* @__PURE__ */ QF();
  function n(a) {
    const o = (c) => (this.parentId = a(c), this.parentId);
    for (const [c, u] of Object.entries(t.idGenerators))
      o[c] = (s) => o(u(Object.assign({ parentId: this.parentId }, s)));
    return o;
  }
  function r(a, o, c) {
    let u = "service", s;
    return {
      document: a,
      get context() {
        return u;
      },
      set context(f) {
        u = f, f !== "operation" && (this.parentId = this.ids[f]);
      },
      maybeResolveLocalRef(f) {
        if ((0, e.hasRef)(f) && (0, e.isLocalRef)(f.$ref))
          try {
            return o.call(this, f);
          } catch {
            return;
          } finally {
            this.parentId = this.ids[u];
          }
        return f;
      },
      get generateId() {
        return s ?? (s = n.call(this, c));
      },
      ids: {
        service: "",
        path: "",
        operation: "",
        webhookName: "",
        webhook: ""
      },
      references: {},
      parentId: ""
    };
  }
  Bs.createContext = r;
  function i(a) {
    return function(...o) {
      const { context: c, parentId: u } = this, s = a.apply(this, o);
      return this.context = c, this.parentId = u, s;
    };
  }
  return Bs.withContext = i, Bs;
}
var qb;
function NA() {
  if (qb) return Fs;
  qb = 1, Object.defineProperty(Fs, "__esModule", { value: !0 }), Fs.translateToTags = Fs.translateTagDefinition = void 0;
  const e = Yn, t = ti(), n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Xn(), i = /* @__PURE__ */ Os(), a = /* @__PURE__ */ A2(), o = (0, n.withContext)(function(s) {
    if (s === null || !(0, r.isSerializablePrimitive)(s))
      return;
    const f = String(s);
    return {
      id: this.generateId.tag({ name: f }),
      name: f
    };
  }), c = function(s, ...f) {
    if (!(0, e.isPlainObject)(s))
      return;
    const d = o.call(this, s.name, ...f);
    if (!d)
      return;
    const l = (0, i.getExtensions)(s);
    return {
      ...d,
      ...(0, t.pickBy)({
        description: s.description
      }, r.isString),
      ...(0, a.toExternalDocs)(s.externalDocs),
      ...l
    };
  };
  Fs.translateTagDefinition = c;
  const u = function(s) {
    return Array.isArray(s) ? s.map(o, this).filter(r.isNonNullable) : [];
  };
  return Fs.translateToTags = u, Fs;
}
var Rh = {}, jh = {}, Ih = {}, Db;
function ha() {
  return Db || (Db = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.syncReferenceObject = e.bundleResolveRef = e.resolveRef = e.getComponentName = e.setSharedKey = e.getSharedKey = e.inferContext = void 0;
    const t = Yn;
    function n(l) {
      return l.length < 2 || l[0] !== "paths" ? "service" : l.length === 2 || l[3] === "parameters" || l[3] === "servers" ? "path" : "operation";
    }
    e.inferContext = n;
    const r = /* @__PURE__ */ new WeakMap();
    function i(l, p) {
      var g;
      return (g = r.get(l)) !== null && g !== void 0 ? g : p;
    }
    e.getSharedKey = i;
    function a(l, p) {
      return typeof l == "object" && l !== null ? r.set(l, p) : !1;
    }
    e.setSharedKey = a;
    const o = /#\/components\/(?<section>[A-Za-z0-9_-]+)\//;
    function c(l, p) {
      var g;
      const b = f(l, p).match(o);
      return (g = b == null ? void 0 : b.groups) === null || g === void 0 ? void 0 : g.section;
    }
    e.getComponentName = c;
    const u = function(l) {
      const { value: p, location: g } = (0, t.resolveInlineRefWithLocation)(this.document, l.$ref), v = n(g);
      return v !== null && this.context !== v && (this.context = v), typeof p == "object" && p !== null && v === "service" && r.set(p, g[0] === "components" ? g[2] : g[1]), p;
    };
    e.resolveRef = u;
    const s = function(l) {
      return e.resolveRef.call(this, l), d(l, this.references);
    };
    e.bundleResolveRef = s;
    function f(l, p) {
      const g = /* @__PURE__ */ new Set();
      let v = p;
      for (; v in l; ) {
        if (g.has(v))
          return v;
        g.add(v);
        const b = l[v];
        if (v = b.value, b.resolved)
          return v;
      }
      return v;
    }
    function d(l, p) {
      const { $ref: g } = l;
      return Object.defineProperty({ ...l }, "$ref", {
        enumerable: !0,
        get() {
          return f(p, g);
        },
        set(v) {
          p[g] = { value: v, resolved: !0 };
        }
      });
    }
    e.syncReferenceObject = d;
  }(Ih)), Ih;
}
var Jp = {}, Qp = {}, Lb;
function XF() {
  if (Lb) return Qp;
  Lb = 1, Object.defineProperty(Qp, "__esModule", { value: !0 });
  const e = (t) => (n) => {
    t in n && (n.examples = [n[t]], delete n[t]);
  };
  return Qp.default = {
    "x-example": e("x-example"),
    example: e("example")
  }, Qp;
}
var Xp = {}, Nb;
function eB() {
  if (Nb) return Xp;
  Nb = 1, Object.defineProperty(Xp, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ Ci(), t = {
    MIN_INT_32: 0 - 2 ** 31,
    MAX_INT_32: 2 ** 31 - 1,
    MIN_INT_64: Number.MIN_SAFE_INTEGER,
    MAX_INT_64: Number.MAX_SAFE_INTEGER,
    MIN_FLOAT: 0 - 2 ** 128,
    MAX_FLOAT: 2 ** 128 - 1,
    MIN_DOUBLE: 0 - Number.MAX_VALUE,
    MAX_DOUBLE: Number.MAX_VALUE
  }, n = (p, g) => (v) => {
    const b = (0, e.collectExplicitProperties)(v);
    v["x-stoplight"] = { ...v["x-stoplight"], explicitProperties: b }, v.minimum = Math.max(f(v.minimum, p), p), v.maximum = Math.min(f(v.maximum, g), g);
  }, r = n(t.MIN_INT_32, t.MAX_INT_32), i = n(t.MIN_INT_64, t.MAX_INT_64), a = n(t.MIN_FLOAT, t.MAX_FLOAT), o = n(t.MIN_DOUBLE, t.MAX_DOUBLE), c = (p) => {
    const g = (0, e.collectExplicitProperties)(p);
    p["x-stoplight"] = { ...p["x-stoplight"], explicitProperties: g }, p.pattern = "^[\\w\\d+\\/=]*$";
  }, u = (p) => {
    p.contentEncoding = "base64", delete p.format;
  }, s = (p) => {
    p.contentMediaType = "application/octet-stream", delete p.format;
  };
  function f(p, g) {
    const v = Number(p);
    return Number.isNaN(v) ? g : v;
  }
  const d = {
    int32: r,
    int64: i,
    float: a,
    double: o,
    byte: c,
    base64: u,
    binary: s
  }, l = (p) => {
    typeof p.format == "string" && p.format in d && d[p.format](p);
  };
  return Xp.default = { format: l }, Xp;
}
var ed = {}, $b;
function tB() {
  if ($b) return ed;
  $b = 1, Object.defineProperty(ed, "__esModule", { value: !0 });
  const e = (t) => {
    if (!("id" in t))
      return;
    const { id: n } = t;
    delete t.id, typeof n == "string" && (t.$id = n);
  };
  return ed.default = { id: e }, ed;
}
var td = {}, Mb;
function rB() {
  if (Mb) return td;
  Mb = 1, Object.defineProperty(td, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ Ci(), t = [
    "string",
    "number",
    "integer",
    "boolean",
    "object",
    "array",
    "null"
  ];
  function n(i) {
    return t.includes(i);
  }
  const r = (i) => (a) => {
    if (!(typeof a.type != "string" || !n(a.type) || !(i in a))) {
      if (a[i] === !0)
        a.type = [a.type, "null"], Array.isArray(a.enum) && (a.enum = [...a.enum, null]);
      else if (i === "nullable") {
        const o = (0, e.collectExplicitProperties)(a);
        a["x-stoplight"] = { ...a["x-stoplight"], explicitProperties: o };
      }
      delete a[i];
    }
  };
  return td.default = {
    "x-nullable": r("x-nullable"),
    nullable: r("nullable")
  }, td;
}
var rd = {}, Fb;
function nB() {
  if (Fb) return rd;
  Fb = 1, Object.defineProperty(rd, "__esModule", { value: !0 });
  function e(t, n) {
    return (r) => {
      if (!(t in r))
        return;
      const { [t]: i } = r;
      typeof i != "number" && (i !== !0 || typeof r[n] != "number" ? delete r[t] : (r[t] = r[n], delete r[n]));
    };
  }
  return rd.default = {
    exclusiveMinimum: e("exclusiveMinimum", "minimum"),
    exclusiveMaximum: e("exclusiveMaximum", "maximum")
  }, rd;
}
var Bb;
function iB() {
  if (Bb) return Jp;
  Bb = 1, Object.defineProperty(Jp, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ XF(), t = /* @__PURE__ */ eB(), n = /* @__PURE__ */ tB(), r = /* @__PURE__ */ rB(), i = /* @__PURE__ */ nB();
  return Jp.default = {
    ...e.default,
    ...n.default,
    ...t.default,
    ...r.default,
    ...i.default
  }, Jp;
}
var Ub;
function Eu() {
  return Ub || (Ub = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.convertSchema = e.translateSchemaObjectFromPair = e.translateSchemaObject = void 0;
    const t = Yn, n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Gi(), a = /* @__PURE__ */ ha(), o = /* @__PURE__ */ iB(), c = Object.keys(o.default), u = /* @__PURE__ */ new WeakMap();
    e.translateSchemaObject = (0, n.withContext)(function(l) {
      const p = this.maybeResolveLocalRef(l);
      if ((0, i.isReferenceObject)(p))
        return p;
      const g = this.context === "service" ? (0, a.getSharedKey)(Object(p), "") : "";
      return e.translateSchemaObjectFromPair.call(this, [g, l]);
    }), e.translateSchemaObjectFromPair = (0, n.withContext)(function([l, p]) {
      var g, v;
      const b = this.maybeResolveLocalRef(p);
      if (!(0, t.isPlainObject)(b)) {
        if (!(0, i.isReferenceObject)(p))
          return {};
        const C = s(this.document, p, this.references), T = (g = (0, r.extractId)(C)) !== null && g !== void 0 ? g : this.generateId.schema({ key: l ?? "" });
        return C["x-stoplight"] = {
          ...(0, t.isPlainObject)(C["x-stoplight"]) && C["x-stoplight"],
          id: T
        }, C;
      }
      if ((0, i.isReferenceObject)(b))
        return b;
      let y = u.get(b);
      if (y)
        return y;
      y = s(this.document, b, this.references);
      const w = (v = (0, r.extractId)(y)) !== null && v !== void 0 ? v : this.generateId.schema({ key: l ?? "" });
      return y["x-stoplight"] = {
        ...(0, t.isPlainObject)(y["x-stoplight"]) && y["x-stoplight"],
        id: w
      }, u.set(b, y), y;
    });
    function s(l, p, g = {}) {
      const v = (0, t.isPlainObject)(p) ? p : {};
      if ("jsonSchemaDialect" in l && typeof l.jsonSchemaDialect == "string")
        return {
          $schema: l.jsonSchemaDialect,
          ...v
        };
      const b = f(v, {
        structs: ["allOf", "anyOf", "oneOf", "not", "items", "additionalProperties", "additionalItems"],
        references: g
      });
      return b.$schema = "http://json-schema.org/draft-07/schema#", b;
    }
    e.convertSchema = s;
    function f(l, p) {
      if ((0, i.isReferenceObject)(l))
        return (0, a.syncReferenceObject)(l, p.references);
      let g = u.get(l);
      if (g)
        return g;
      const v = { ...l };
      u.set(l, v);
      for (const b of p.structs)
        if (Array.isArray(v[b])) {
          v[b] = v[b].slice();
          for (let y = 0; y < v[b].length; y++)
            typeof v[b][y] == "object" && v[b][y] !== null ? v[b][y] = f(v[b][y], p) : (v[b].splice(y, 1), y--);
        } else v[b] !== null && typeof v[b] == "object" && (v[b] = f(v[b], p));
      "properties" in v && (0, t.isPlainObject)(v.properties) && d(v, p);
      for (const b of c)
        b in v && o.default[b](v);
      return v;
    }
    function d(l, p) {
      const g = { ...l.properties };
      l.properties = g;
      for (const v of Object.keys(g)) {
        const b = g[v];
        (0, t.isPlainObject)(b) && (g[v] = f(b, p));
      }
    }
  }(jh)), jh;
}
var Xc = {}, Hb;
function aB() {
  if (Hb) return Xc;
  Hb = 1, Object.defineProperty(Xc, "__esModule", { value: !0 }), Xc.translateToSecurityDeclarationType = void 0;
  const e = /* @__PURE__ */ wc();
  function t({ security: n }) {
    let r = e.HttpOperationSecurityDeclarationTypes.InheritedFromService;
    return Array.isArray(n) && (r = n.length === 0 ? e.HttpOperationSecurityDeclarationTypes.None : e.HttpOperationSecurityDeclarationTypes.Declared), r;
  }
  return Xc.translateToSecurityDeclarationType = t, Xc;
}
var el = {}, zb;
function $A() {
  if (zb) return el;
  zb = 1, Object.defineProperty(el, "__esModule", { value: !0 }), el.translateLogo = void 0;
  const e = ti();
  function t({ "x-logo": n, contact: r }) {
    return {
      altText: "logo",
      href: r == null ? void 0 : r.url,
      ...(0, e.pickBy)(n, (i, a) => typeof i == "string" && ["altText", "href", "backgroundColor", "url"].includes(a))
    };
  }
  return el.translateLogo = t, el;
}
var Gb;
function k2() {
  return Gb || (Gb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateLogo = e.translateToSecurityDeclarationType = e.translateSchemaObject = e.convertSchema = void 0;
    var t = /* @__PURE__ */ Eu();
    Object.defineProperty(e, "convertSchema", { enumerable: !0, get: function() {
      return t.convertSchema;
    } }), Object.defineProperty(e, "translateSchemaObject", { enumerable: !0, get: function() {
      return t.translateSchemaObject;
    } });
    var n = /* @__PURE__ */ aB();
    Object.defineProperty(e, "translateToSecurityDeclarationType", { enumerable: !0, get: function() {
      return n.translateToSecurityDeclarationType;
    } });
    var r = /* @__PURE__ */ $A();
    Object.defineProperty(e, "translateLogo", { enumerable: !0, get: function() {
      return r.translateLogo;
    } });
  }(Rh)), Rh;
}
var Vb;
function E2() {
  if (Vb) return Ma;
  Vb = 1, Object.defineProperty(Ma, "__esModule", { value: !0 }), Ma.transformOasEndpointOperation = Ma.transformOasEndpointOperations = Ma.WEBHOOK_CONFIG = Ma.OPERATION_CONFIG = void 0;
  const e = Yn, t = ti(), n = /* @__PURE__ */ Xn(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ Os(), a = /* @__PURE__ */ A2(), o = /* @__PURE__ */ NA(), c = /* @__PURE__ */ k2(), u = ["get", "post", "put", "delete", "options", "head", "patch", "trace"];
  Ma.OPERATION_CONFIG = {
    type: "operation",
    documentProp: "paths",
    nameProp: "path"
  }, Ma.WEBHOOK_CONFIG = {
    type: "webhook",
    documentProp: "webhooks",
    nameProp: "name"
  };
  function s(d, l, p, g = u, v) {
    return ((0, e.isPlainObject)(d[p.documentProp]) ? Object.entries(d[p.documentProp]) : []).flatMap(([y, w]) => {
      if (!(0, e.isPlainObject)(w))
        return [];
      let C = Object.keys(w);
      return g !== null && (C = C.filter((T) => g.includes(T))), C.map((T) => l({
        document: d,
        name: y,
        method: T,
        config: p,
        ctx: v
      }));
    });
  }
  Ma.transformOasEndpointOperations = s;
  const f = function({ type: d, documentProp: l, nameProp: p }, g, v, b) {
    var y, w, C, T, E, D;
    const $ = this.maybeResolveLocalRef((w = (y = this.document) === null || y === void 0 ? void 0 : y[l]) === null || w === void 0 ? void 0 : w[g]);
    if (typeof $ != "object" || $ === null)
      throw new Error(`Could not find ${[l, g].join("/")} in the provided spec.`);
    const Z = this.maybeResolveLocalRef($[v]);
    if (!Z)
      throw new Error(`Could not find ${[l, g, v].join("/")} in the provided spec.`);
    const te = this.ids.service = String((C = this.document["x-stoplight"]) === null || C === void 0 ? void 0 : C.id);
    d === "operation" ? this.ids.path = this.generateId.httpPath({ parentId: te, path: g }) : this.ids.webhookName = this.generateId.httpWebhookName({ parentId: te, name: g });
    let se;
    return this.context === "callback" ? se = this.ids.operation = (T = (0, r.extractId)(Z)) !== null && T !== void 0 ? T : this.generateId.httpCallbackOperation({
      parentId: te,
      method: v,
      path: g,
      key: b ?? ""
    }) : d === "operation" ? se = this.ids.operation = (E = (0, r.extractId)(Z)) !== null && E !== void 0 ? E : this.generateId.httpOperation({ parentId: te, method: v, path: g }) : se = this.ids.webhook = (D = (0, r.extractId)(Z)) !== null && D !== void 0 ? D : this.generateId.httpWebhookOperation({ parentId: te, method: v, name: g }), this.parentId = se, this.context = d, {
      id: se,
      method: v,
      [p]: g,
      tags: o.translateToTags.call(this, Z.tags),
      extensions: (0, i.getExtensions)(Z),
      ...(0, t.pickBy)({
        deprecated: Z.deprecated,
        internal: Z["x-internal"]
      }, n.isBoolean),
      ...(0, t.pickBy)({
        iid: Z.operationId,
        description: Z.description,
        summary: Z.summary
      }, n.isString),
      securityDeclarationType: (0, c.translateToSecurityDeclarationType)(Z),
      ...(0, a.toExternalDocs)(Z.externalDocs)
    };
  };
  return Ma.transformOasEndpointOperation = f, Ma;
}
var Wb;
function F0() {
  return Wb || (Wb = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.OasVersion = e.convertToJsonSchema = e.defaultRefResolver = void 0, M0.__exportStar(/* @__PURE__ */ E2(), e);
    var n = /* @__PURE__ */ ha();
    Object.defineProperty(e, "defaultRefResolver", { enumerable: !0, get: function() {
      return n.resolveRef;
    } });
    var r = /* @__PURE__ */ k2();
    Object.defineProperty(e, "convertToJsonSchema", { enumerable: !0, get: function() {
      return r.convertSchema;
    } });
    var i = /* @__PURE__ */ Uf();
    Object.defineProperty(e, "OasVersion", { enumerable: !0, get: function() {
      return i.OasVersion;
    } });
  }(Eh)), Eh;
}
var Kb = /* @__PURE__ */ F0(), qh = {}, Dh = {}, tl = {}, Us = {}, Lh = { exports: {} }, Zb;
function oB() {
  return Zb || (Zb = 1, function(e) {
    var t = function() {
      var n, r = [], i = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"], a = "1a", o = !1, c, u, s, f, d, l, p, g = "chongo <Landon Curt Noll> /\\../\\", v = 52, b = {
        32: { offset: 0 },
        64: { offset: [0, 0, 0, 0] },
        128: { offset: [0, 0, 0, 0, 0, 0, 0, 0] },
        256: { offset: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
        512: { offset: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
        1024: { offset: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
      };
      for (n = 0; n < 256; n++)
        r[n] = (n >> 4 & 15).toString(16) + (n & 15).toString(16);
      function y(P, M) {
        var F = "0123456789abcdefghijklmnopqrstuvwxyz", O = [0], S, _, h, A = "";
        for (_ = 0; _ < P.length; _ += 2) {
          for (S = parseInt(P.substr(_, 2), 16), h = 0; h < O.length; h++)
            S += O[h] << 8, O[h] = S % M, S = S / M | 0;
          for (; S > 0; )
            O.push(S % M), S = S / M | 0;
        }
        for (_ = O.length - 1; _ >= 0; --_)
          A += F[O[_]];
        return A;
      }
      function w(P, M) {
        return {
          bits: M,
          value: P,
          dec: function() {
            return y(P, 10);
          },
          hex: function() {
            return P;
          },
          str: function() {
            return y(P, 36);
          }
        };
      }
      function C(P, M) {
        return {
          bits: M,
          value: P,
          dec: function() {
            return P.toString();
          },
          hex: function() {
            return r[P >>> 24] + r[P >>> 16 & 255] + r[P >>> 8 & 255] + r[P & 255];
          },
          str: function() {
            return P.toString(36);
          }
        };
      }
      function T(P, M) {
        return {
          bits: M,
          value: P,
          dec: function() {
            return P.toString();
          },
          hex: function() {
            return ("0000000000000000" + P.toString(16)).substr(-13);
          },
          str: function() {
            return P.toString(36);
          }
        };
      }
      function E(P, M) {
        var F = typeof P == "object" ? JSON.stringify(P) : P;
        switch (M || v) {
          case 32:
            return c(F);
          case 64:
            return s(F);
          case 128:
            return f(F);
          case 256:
            return d(F);
          case 512:
            return l(F);
          case 1024:
            return p(F);
          default:
            return u(F);
        }
      }
      function D(P) {
        if (P === 52 || b[P])
          v = P;
        else
          throw new Error("Supported FNV keyspacs: 32, 52, 64, 128, 256, 512, and 1024 bit");
      }
      function $(P) {
        if (P === "1a")
          a = P, c = o ? Te : Ae, u = o ? It : qe, s = o ? Lt : jt, f = o ? Rt : Ze, d = o ? Y : ye, l = o ? Se : Ee, p = o ? $t : Xe;
        else if (P === "1")
          a = P, c = o ? we : He, u = o ? Qe : Ge, s = o ? Fe : We, f = o ? Vr : Ue, d = o ? ae : G, l = o ? Me : N, p = o ? Be : Ke;
        else
          throw new Error("Supported FNV versions: 1, 1a");
      }
      function Z(P) {
        P ? (o = !0, c = a == "1a" ? Te : we, u = a == "1a" ? It : Qe, s = a == "1a" ? Lt : Fe, f = a == "1a" ? Rt : Vr, d = a == "1a" ? Y : ae, l = a == "1a" ? Se : Me, p = a == "1a" ? $t : Be) : (o = !1, c = a == "1a" ? Ae : He, u = a == "1a" ? qe : Ge, s = a == "1a" ? jt : We, f = a == "1a" ? Ze : Ue, d = a == "1a" ? ye : G, l = a == "1a" ? Ee : N, p = a == "1a" ? Xe : Ke);
      }
      function te(P) {
        var M = a, F, O;
        P = P || P === 0 ? P : g, P === g && $("1");
        for (var S in b) {
          for (b[S].offset = [], O = 0; O < S / 16; O++)
            b[S].offset[O] = 0;
          for (F = E(P, parseInt(S, 10)).hex(), O = 0; O < S / 16; O++)
            b[S].offset[O] = parseInt(F.substr(O * 4, 4), 16);
        }
        $(M);
      }
      function se(P) {
        var M, F = P.length - 3, O = 0, S = 40389, _ = 0, h = 33052;
        for (M = 0; M < F; )
          S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535, S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535, S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535, S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535;
        for (; M < F + 3; )
          S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535;
        return (h << 16 >>> 0) + S;
      }
      function ee(P) {
        var M, F = P.length - 3, O = 0, S = 40389, _ = 0, h = 33052;
        for (M = 0; M < F; )
          S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535, S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535, S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535, S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535;
        for (; M < F + 3; )
          S ^= P.charCodeAt(M++), O = S * 403, _ = h * 403, _ += S << 8, h = _ + (O >>> 16) & 65535, S = O & 65535;
        return r[h >>> 8 & 255] + r[h & 255] + r[S >>> 8 & 255] + r[S & 255];
      }
      function K(P) {
        var M, F = P.length - 3, O = 0, S = 8997, _ = 0, h = 33826, A = 0, R = 40164, I = 0, k = 52210;
        for (M = 0; M < F; )
          S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535;
        for (; M < F + 3; )
          S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535;
        return (k & 15) * 281474976710656 + R * 4294967296 + h * 65536 + (S ^ k >> 4);
      }
      function re(P) {
        var M, F = P.length - 3, O = 0, S = 8997, _ = 0, h = 33826, A = 0, R = 40164, I = 0, k = 52210;
        for (M = 0; M < F; )
          S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535;
        for (; M < F + 3; )
          S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535;
        return i[k & 15] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255] + r[S >> 8 ^ k >> 12] + r[(S ^ k >> 4) & 255];
      }
      function de(P) {
        var M, F = P.length - 3, O = 0, S = 8997, _ = 0, h = 33826, A = 0, R = 40164, I = 0, k = 52210;
        for (M = 0; M < F; )
          S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535, S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535;
        for (; M < F + 3; )
          S ^= P.charCodeAt(M++), O = S * 435, _ = h * 435, A = R * 435, I = k * 435, A += S << 8, I += h << 8, _ += O >>> 16, S = O & 65535, A += _ >>> 16, h = _ & 65535, k = I + (A >>> 16) & 65535, R = A & 65535;
        return r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255] + r[S >> 8] + r[S & 255];
      }
      function ie(P) {
        var M, F, O = P.length, S = 0, _ = 40389, h = 0, A = 33052;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? _ ^= M : M < 2048 ? (_ ^= M >> 6 | 192, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), _ ^= M >> 18 | 240, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M >> 12 & 63 | 128, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M & 63 | 128) : (_ ^= M >> 12 | 224, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M & 63 | 128), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535;
        return (A << 16 >>> 0) + _;
      }
      function me(P) {
        var M, F, O = P.length, S = 0, _ = 40389, h = 0, A = 33052;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? _ ^= M : M < 2048 ? (_ ^= M >> 6 | 192, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), _ ^= M >> 18 | 240, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M >> 12 & 63 | 128, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M & 63 | 128) : (_ ^= M >> 12 | 224, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= M & 63 | 128), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535;
        return r[A >>> 8 & 255] + r[A & 255] + r[_ >>> 8 & 255] + r[_ & 255];
      }
      function $e(P) {
        var M, F, O = P.length, S = 0, _ = 8997, h = 0, A = 33826, R = 0, I = 40164, k = 0, j = 52210;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? _ ^= M : M < 2048 ? (_ ^= M >> 6 | 192, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), _ ^= M >> 18 | 240, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 12 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128) : (_ ^= M >> 12 | 224, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        return (j & 15) * 281474976710656 + I * 4294967296 + A * 65536 + (_ ^ j >> 4);
      }
      function Pe(P) {
        var M, F, O = P.length, S = 0, _ = 8997, h = 0, A = 33826, R = 0, I = 40164, k = 0, j = 52210;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? _ ^= M : M < 2048 ? (_ ^= M >> 6 | 192, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), _ ^= M >> 18 | 240, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 12 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128) : (_ ^= M >> 12 | 224, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        return i[j & 15] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8 ^ j >> 12] + r[(_ ^ j >> 4) & 255];
      }
      function Le(P) {
        var M, F, O = P.length, S = 0, _ = 8997, h = 0, A = 33826, R = 0, I = 40164, k = 0, j = 52210;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? _ ^= M : M < 2048 ? (_ ^= M >> 6 | 192, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), _ ^= M >> 18 | 240, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 12 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128) : (_ ^= M >> 12 | 224, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M >> 6 & 63 | 128, S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= M & 63 | 128), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        return r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255];
      }
      function Ae(P) {
        var M, F = P.length - 3, O = b[32].offset, S = 0, _ = O[1] | 0, h = 0, A = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535;
        return C((A << 16 >>> 0) + _, 32);
      }
      function He(P) {
        var M, F = P.length - 3, O = b[32].offset, S = 0, _ = O[1] | 0, h = 0, A = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++), S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 403, h = A * 403, h += _ << 8, A = h + (S >>> 16) & 65535, _ = S & 65535, _ ^= P.charCodeAt(M++);
        return C((A << 16 >>> 0) + _, 32);
      }
      function Te(P) {
        var M, F, O = P.length, S = b[32].offset, _ = 0, h = S[1] | 0, A = 0, R = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M >> 12 & 63 | 128, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M >> 6 & 63 | 128, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M >> 6 & 63 | 128, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M & 63 | 128), _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535;
        return C((R << 16 >>> 0) + h, 32);
      }
      function we(P) {
        var M, F, O = P.length, S = b[32].offset, _ = 0, h = S[1] | 0, A = 0, R = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M >> 12 & 63 | 128, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M >> 6 & 63 | 128, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M >> 6 & 63 | 128, _ = h * 403, A = R * 403, A += h << 8, R = A + (_ >>> 16) & 65535, h = _ & 65535, h ^= M & 63 | 128);
        return C((R << 16 >>> 0) + h, 32);
      }
      c = Ae;
      function qe(P) {
        var M, F = P.length - 3, O = b[64].offset, S = 0, _ = O[3] | 0, h = 0, A = O[2] | 0, R = 0, I = O[1] | 0, k = 0, j = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        return T((j & 15) * 281474976710656 + I * 4294967296 + A * 65536 + (_ ^ j >> 4), 52);
      }
      function Ge(P) {
        var M, F = P.length - 3, O = b[64].offset, S = 0, _ = O[3] | 0, h = 0, A = O[2] | 0, R = 0, I = O[1] | 0, k = 0, j = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++);
        return T((j & 15) * 281474976710656 + I * 4294967296 + A * 65536 + (_ ^ j >> 4), 52);
      }
      function It(P) {
        var M, F, O = P.length, S = b[64].offset, _ = 0, h = S[3] | 0, A = 0, R = S[2] | 0, I = 0, k = S[1] | 0, j = 0, z = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 12 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128), _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535;
        return T((z & 15) * 281474976710656 + k * 4294967296 + R * 65536 + (h ^ z >> 4), 52);
      }
      function Qe(P) {
        var M, F, O = P.length, S = b[64].offset, _ = 0, h = S[3] | 0, A = 0, R = S[2] | 0, I = 0, k = S[1] | 0, j = 0, z = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 12 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128);
        return T((z & 15) * 281474976710656 + k * 4294967296 + R * 65536 + (h ^ z >> 4), 52);
      }
      u = qe;
      function jt(P) {
        var M, F = P.length - 3, O = b[64].offset, S = 0, _ = O[3] | 0, h = 0, A = O[2] | 0, R = 0, I = O[1] | 0, k = 0, j = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535;
        return w(r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 64);
      }
      function We(P) {
        var M, F = P.length - 3, O = b[64].offset, S = 0, _ = O[3] | 0, h = 0, A = O[2] | 0, R = 0, I = O[1] | 0, k = 0, j = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++), S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 435, h = A * 435, R = I * 435, k = j * 435, R += _ << 8, k += A << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, j = k + (R >>> 16) & 65535, I = R & 65535, _ ^= P.charCodeAt(M++);
        return w(r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 64);
      }
      function Lt(P) {
        var M, F, O = P.length, S = b[64].offset, _ = 0, h = S[3] | 0, A = 0, R = S[2] | 0, I = 0, k = S[1] | 0, j = 0, z = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 12 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128), _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535;
        return w(r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 64);
      }
      function Fe(P) {
        var M, F, O = P.length, S = b[64].offset, _ = 0, h = S[3] | 0, A = 0, R = S[2] | 0, I = 0, k = S[1] | 0, j = 0, z = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 12 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M >> 6 & 63 | 128, _ = h * 435, A = R * 435, I = k * 435, j = z * 435, I += h << 8, j += R << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, z = j + (I >>> 16) & 65535, k = I & 65535, h ^= M & 63 | 128);
        return w(r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 64);
      }
      s = jt;
      function Ze(P) {
        var M, F = P.length - 3, O = b[128].offset, S = 0, _ = O[7] | 0, h = 0, A = O[6] | 0, R = 0, I = O[5] | 0, k = 0, j = O[4] | 0, z = 0, H = O[3] | 0, J = 0, U = O[2] | 0, L = 0, B = O[1] | 0, Q = 0, V = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535;
        return w(r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 128);
      }
      function Ue(P) {
        var M, F = P.length - 3, O = b[128].offset, S = 0, _ = O[7] | 0, h = 0, A = O[6] | 0, R = 0, I = O[5] | 0, k = 0, j = O[4] | 0, z = 0, H = O[3] | 0, J = 0, U = O[2] | 0, L = 0, B = O[1] | 0, Q = 0, V = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++), S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 315, h = A * 315, R = I * 315, k = j * 315, z = H * 315, J = U * 315, L = B * 315, Q = V * 315, J += _ << 8, L += A << 8, Q += I << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, V = Q + (L >>> 16) & 65535, B = L & 65535, _ ^= P.charCodeAt(M++);
        return w(r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 128);
      }
      function Rt(P) {
        var M, F, O = P.length, S = b[128].offset, _ = 0, h = S[7] | 0, A = 0, R = S[6] | 0, I = 0, k = S[5] | 0, j = 0, z = S[4] | 0, H = 0, J = S[3] | 0, U = 0, L = S[2] | 0, B = 0, Q = S[1] | 0, V = 0, X = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M >> 12 & 63 | 128, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M >> 6 & 63 | 128, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M >> 6 & 63 | 128, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M & 63 | 128), _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535;
        return w(r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 128);
      }
      function Vr(P) {
        var M, F, O = P.length, S = b[128].offset, _ = 0, h = S[7] | 0, A = 0, R = S[6] | 0, I = 0, k = S[5] | 0, j = 0, z = S[4] | 0, H = 0, J = S[3] | 0, U = 0, L = S[2] | 0, B = 0, Q = S[1] | 0, V = 0, X = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M >> 12 & 63 | 128, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M >> 6 & 63 | 128, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M >> 6 & 63 | 128, _ = h * 315, A = R * 315, I = k * 315, j = z * 315, H = J * 315, U = L * 315, B = Q * 315, V = X * 315, U += h << 8, B += R << 8, V += k << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, X = V + (B >>> 16) & 65535, Q = B & 65535, h ^= M & 63 | 128);
        return w(r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 128);
      }
      f = Ze;
      function ye(P) {
        var M, F = P.length - 3, O = b[256].offset, S = 0, _ = O[15] | 0, h = 0, A = O[14] | 0, R = 0, I = O[13] | 0, k = 0, j = O[12] | 0, z = 0, H = O[11] | 0, J = 0, U = O[10] | 0, L = 0, B = O[9] | 0, Q = 0, V = O[8] | 0, X = 0, ue = O[7] | 0, ve = 0, pe = O[6] | 0, oe = 0, ce = O[5] | 0, ke = 0, fe = O[4] | 0, be = 0, ge = O[3] | 0, Ie = 0, le = O[2] | 0, he = 0, xe = O[1] | 0, je = 0, Oe = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535;
        return w(r[Oe >> 8] + r[Oe & 255] + r[xe >> 8] + r[xe & 255] + r[le >> 8] + r[le & 255] + r[ge >> 8] + r[ge & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 256);
      }
      function G(P) {
        var M, F = P.length - 3, O = b[256].offset, S = 0, _ = O[15] | 0, h = 0, A = O[14] | 0, R = 0, I = O[13] | 0, k = 0, j = O[12] | 0, z = 0, H = O[11] | 0, J = 0, U = O[10] | 0, L = 0, B = O[9] | 0, Q = 0, V = O[8] | 0, X = 0, ue = O[7] | 0, ve = 0, pe = O[6] | 0, oe = 0, ce = O[5] | 0, ke = 0, fe = O[4] | 0, be = 0, ge = O[3] | 0, Ie = 0, le = O[2] | 0, he = 0, xe = O[1] | 0, je = 0, Oe = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++), S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 355, h = A * 355, R = I * 355, k = j * 355, z = H * 355, J = U * 355, L = B * 355, Q = V * 355, X = ue * 355, ve = pe * 355, oe = ce * 355, ke = fe * 355, be = ge * 355, Ie = le * 355, he = xe * 355, je = Oe * 355, oe += _ << 8, ke += A << 8, be += I << 8, Ie += j << 8, he += H << 8, je += U << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, Oe = je + (he >>> 16) & 65535, xe = he & 65535, _ ^= P.charCodeAt(M++);
        return w(r[Oe >> 8] + r[Oe & 255] + r[xe >> 8] + r[xe & 255] + r[le >> 8] + r[le & 255] + r[ge >> 8] + r[ge & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 256);
      }
      function Y(P) {
        var M, F, O = P.length, S = b[256].offset, _ = 0, h = S[15] | 0, A = 0, R = S[14] | 0, I = 0, k = S[13] | 0, j = 0, z = S[12] | 0, H = 0, J = S[11] | 0, U = 0, L = S[10] | 0, B = 0, Q = S[9] | 0, V = 0, X = S[8] | 0, ue = 0, ve = S[7] | 0, pe = 0, oe = S[6] | 0, ce = 0, ke = S[5] | 0, fe = 0, be = S[4] | 0, ge = 0, Ie = S[3] | 0, le = 0, he = S[2] | 0, xe = 0, je = S[1] | 0, Oe = 0, De = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M >> 12 & 63 | 128, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M >> 6 & 63 | 128, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M >> 6 & 63 | 128, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M & 63 | 128), _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535;
        return w(r[De >> 8] + r[De & 255] + r[je >> 8] + r[je & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[ke >> 8] + r[ke & 255] + r[oe >> 8] + r[oe & 255] + r[ve >> 8] + r[ve & 255] + r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 256);
      }
      function ae(P) {
        var M, F, O = P.length, S = b[256].offset, _ = 0, h = S[15] | 0, A = 0, R = S[14] | 0, I = 0, k = S[13] | 0, j = 0, z = S[12] | 0, H = 0, J = S[11] | 0, U = 0, L = S[10] | 0, B = 0, Q = S[9] | 0, V = 0, X = S[8] | 0, ue = 0, ve = S[7] | 0, pe = 0, oe = S[6] | 0, ce = 0, ke = S[5] | 0, fe = 0, be = S[4] | 0, ge = 0, Ie = S[3] | 0, le = 0, he = S[2] | 0, xe = 0, je = S[1] | 0, Oe = 0, De = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M >> 12 & 63 | 128, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M >> 6 & 63 | 128, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M >> 6 & 63 | 128, _ = h * 355, A = R * 355, I = k * 355, j = z * 355, H = J * 355, U = L * 355, B = Q * 355, V = X * 355, ue = ve * 355, pe = oe * 355, ce = ke * 355, fe = be * 355, ge = Ie * 355, le = he * 355, xe = je * 355, Oe = De * 355, ce += h << 8, fe += R << 8, ge += k << 8, le += z << 8, xe += J << 8, Oe += L << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, De = Oe + (xe >>> 16) & 65535, je = xe & 65535, h ^= M & 63 | 128);
        return w(r[De >> 8] + r[De & 255] + r[je >> 8] + r[je & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[ke >> 8] + r[ke & 255] + r[oe >> 8] + r[oe & 255] + r[ve >> 8] + r[ve & 255] + r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 256);
      }
      d = ye;
      function Ee(P) {
        var M, F = P.length - 3, O = b[512].offset, S = 0, _ = O[31] | 0, h = 0, A = O[30] | 0, R = 0, I = O[29] | 0, k = 0, j = O[28] | 0, z = 0, H = O[27] | 0, J = 0, U = O[26] | 0, L = 0, B = O[25] | 0, Q = 0, V = O[24] | 0, X = 0, ue = O[23] | 0, ve = 0, pe = O[22] | 0, oe = 0, ce = O[21] | 0, ke = 0, fe = O[20] | 0, be = 0, ge = O[19] | 0, Ie = 0, le = O[18] | 0, he = 0, xe = O[17] | 0, je = 0, Oe = O[16] | 0, De = 0, ze = O[15] | 0, yt = 0, pt = O[14] | 0, bt = 0, lt = O[13] | 0, xt = 0, ft = O[12] | 0, _t = 0, dt = O[11] | 0, mt = 0, Je = O[10] | 0, ht = 0, rt = O[9] | 0, kt = 0, st = O[8] | 0, Et = 0, ut = O[7] | 0, St = 0, nt = O[6] | 0, Ct = 0, et = O[5] | 0, Ot = 0, it = O[4] | 0, wt = 0, at = O[3] | 0, Tt = 0, ot = O[2] | 0, At = 0, tt = O[1] | 0, qt = 0, Pt = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535;
        return w(r[Pt >> 8] + r[Pt & 255] + r[tt >> 8] + r[tt & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[it >> 8] + r[it & 255] + r[et >> 8] + r[et & 255] + r[nt >> 8] + r[nt & 255] + r[ut >> 8] + r[ut & 255] + r[st >> 8] + r[st & 255] + r[rt >> 8] + r[rt & 255] + r[Je >> 8] + r[Je & 255] + r[dt >> 8] + r[dt & 255] + r[ft >> 8] + r[ft & 255] + r[lt >> 8] + r[lt & 255] + r[pt >> 8] + r[pt & 255] + r[ze >> 8] + r[ze & 255] + r[Oe >> 8] + r[Oe & 255] + r[xe >> 8] + r[xe & 255] + r[le >> 8] + r[le & 255] + r[ge >> 8] + r[ge & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 512);
      }
      function N(P) {
        var M, F = P.length - 3, O = b[512].offset, S = 0, _ = O[31] | 0, h = 0, A = O[30] | 0, R = 0, I = O[29] | 0, k = 0, j = O[28] | 0, z = 0, H = O[27] | 0, J = 0, U = O[26] | 0, L = 0, B = O[25] | 0, Q = 0, V = O[24] | 0, X = 0, ue = O[23] | 0, ve = 0, pe = O[22] | 0, oe = 0, ce = O[21] | 0, ke = 0, fe = O[20] | 0, be = 0, ge = O[19] | 0, Ie = 0, le = O[18] | 0, he = 0, xe = O[17] | 0, je = 0, Oe = O[16] | 0, De = 0, ze = O[15] | 0, yt = 0, pt = O[14] | 0, bt = 0, lt = O[13] | 0, xt = 0, ft = O[12] | 0, _t = 0, dt = O[11] | 0, mt = 0, Je = O[10] | 0, ht = 0, rt = O[9] | 0, kt = 0, st = O[8] | 0, Et = 0, ut = O[7] | 0, St = 0, nt = O[6] | 0, Ct = 0, et = O[5] | 0, Ot = 0, it = O[4] | 0, wt = 0, at = O[3] | 0, Tt = 0, ot = O[2] | 0, At = 0, tt = O[1] | 0, qt = 0, Pt = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++), S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 343, h = A * 343, R = I * 343, k = j * 343, z = H * 343, J = U * 343, L = B * 343, Q = V * 343, X = ue * 343, ve = pe * 343, oe = ce * 343, ke = fe * 343, be = ge * 343, Ie = le * 343, he = xe * 343, je = Oe * 343, De = ze * 343, yt = pt * 343, bt = lt * 343, xt = ft * 343, _t = dt * 343, mt = Je * 343, ht = rt * 343, kt = st * 343, Et = ut * 343, St = nt * 343, Ct = et * 343, Ot = it * 343, wt = at * 343, Tt = ot * 343, At = tt * 343, qt = Pt * 343, mt += _ << 8, ht += A << 8, kt += I << 8, Et += j << 8, St += H << 8, Ct += U << 8, Ot += B << 8, wt += V << 8, Tt += ue << 8, At += pe << 8, qt += ce << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, Pt = qt + (At >>> 16) & 65535, tt = At & 65535, _ ^= P.charCodeAt(M++);
        return w(r[Pt >> 8] + r[Pt & 255] + r[tt >> 8] + r[tt & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[it >> 8] + r[it & 255] + r[et >> 8] + r[et & 255] + r[nt >> 8] + r[nt & 255] + r[ut >> 8] + r[ut & 255] + r[st >> 8] + r[st & 255] + r[rt >> 8] + r[rt & 255] + r[Je >> 8] + r[Je & 255] + r[dt >> 8] + r[dt & 255] + r[ft >> 8] + r[ft & 255] + r[lt >> 8] + r[lt & 255] + r[pt >> 8] + r[pt & 255] + r[ze >> 8] + r[ze & 255] + r[Oe >> 8] + r[Oe & 255] + r[xe >> 8] + r[xe & 255] + r[le >> 8] + r[le & 255] + r[ge >> 8] + r[ge & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 512);
      }
      function Se(P) {
        var M, F, O = P.length, S = b[512].offset, _ = 0, h = S[31] | 0, A = 0, R = S[30] | 0, I = 0, k = S[29] | 0, j = 0, z = S[28] | 0, H = 0, J = S[27] | 0, U = 0, L = S[26] | 0, B = 0, Q = S[25] | 0, V = 0, X = S[24] | 0, ue = 0, ve = S[23] | 0, pe = 0, oe = S[22] | 0, ce = 0, ke = S[21] | 0, fe = 0, be = S[20] | 0, ge = 0, Ie = S[19] | 0, le = 0, he = S[18] | 0, xe = 0, je = S[17] | 0, Oe = 0, De = S[16] | 0, ze = 0, yt = S[15] | 0, pt = 0, bt = S[14] | 0, lt = 0, xt = S[13] | 0, ft = 0, _t = S[12] | 0, dt = 0, mt = S[11] | 0, Je = 0, ht = S[10] | 0, rt = 0, kt = S[9] | 0, st = 0, Et = S[8] | 0, ut = 0, St = S[7] | 0, nt = 0, Ct = S[6] | 0, et = 0, Ot = S[5] | 0, it = 0, wt = S[4] | 0, at = 0, Tt = S[3] | 0, ot = 0, At = S[2] | 0, tt = 0, qt = S[1] | 0, Pt = 0, Vt = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M >> 12 & 63 | 128, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M >> 6 & 63 | 128, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M >> 6 & 63 | 128, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M & 63 | 128), _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535;
        return w(r[Vt >> 8] + r[Vt & 255] + r[qt >> 8] + r[qt & 255] + r[At >> 8] + r[At & 255] + r[Tt >> 8] + r[Tt & 255] + r[wt >> 8] + r[wt & 255] + r[Ot >> 8] + r[Ot & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Et >> 8] + r[Et & 255] + r[kt >> 8] + r[kt & 255] + r[ht >> 8] + r[ht & 255] + r[mt >> 8] + r[mt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[De >> 8] + r[De & 255] + r[je >> 8] + r[je & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[ke >> 8] + r[ke & 255] + r[oe >> 8] + r[oe & 255] + r[ve >> 8] + r[ve & 255] + r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 512);
      }
      function Me(P) {
        var M, F, O = P.length, S = b[512].offset, _ = 0, h = S[31] | 0, A = 0, R = S[30] | 0, I = 0, k = S[29] | 0, j = 0, z = S[28] | 0, H = 0, J = S[27] | 0, U = 0, L = S[26] | 0, B = 0, Q = S[25] | 0, V = 0, X = S[24] | 0, ue = 0, ve = S[23] | 0, pe = 0, oe = S[22] | 0, ce = 0, ke = S[21] | 0, fe = 0, be = S[20] | 0, ge = 0, Ie = S[19] | 0, le = 0, he = S[18] | 0, xe = 0, je = S[17] | 0, Oe = 0, De = S[16] | 0, ze = 0, yt = S[15] | 0, pt = 0, bt = S[14] | 0, lt = 0, xt = S[13] | 0, ft = 0, _t = S[12] | 0, dt = 0, mt = S[11] | 0, Je = 0, ht = S[10] | 0, rt = 0, kt = S[9] | 0, st = 0, Et = S[8] | 0, ut = 0, St = S[7] | 0, nt = 0, Ct = S[6] | 0, et = 0, Ot = S[5] | 0, it = 0, wt = S[4] | 0, at = 0, Tt = S[3] | 0, ot = 0, At = S[2] | 0, tt = 0, qt = S[1] | 0, Pt = 0, Vt = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M >> 12 & 63 | 128, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M >> 6 & 63 | 128, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M >> 6 & 63 | 128, _ = h * 343, A = R * 343, I = k * 343, j = z * 343, H = J * 343, U = L * 343, B = Q * 343, V = X * 343, ue = ve * 343, pe = oe * 343, ce = ke * 343, fe = be * 343, ge = Ie * 343, le = he * 343, xe = je * 343, Oe = De * 343, ze = yt * 343, pt = bt * 343, lt = xt * 343, ft = _t * 343, dt = mt * 343, Je = ht * 343, rt = kt * 343, st = Et * 343, ut = St * 343, nt = Ct * 343, et = Ot * 343, it = wt * 343, at = Tt * 343, ot = At * 343, tt = qt * 343, Pt = Vt * 343, Je += h << 8, rt += R << 8, st += k << 8, ut += z << 8, nt += J << 8, et += L << 8, it += Q << 8, at += X << 8, ot += ve << 8, tt += oe << 8, Pt += ke << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Vt = Pt + (tt >>> 16) & 65535, qt = tt & 65535, h ^= M & 63 | 128);
        return w(r[Vt >> 8] + r[Vt & 255] + r[qt >> 8] + r[qt & 255] + r[At >> 8] + r[At & 255] + r[Tt >> 8] + r[Tt & 255] + r[wt >> 8] + r[wt & 255] + r[Ot >> 8] + r[Ot & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Et >> 8] + r[Et & 255] + r[kt >> 8] + r[kt & 255] + r[ht >> 8] + r[ht & 255] + r[mt >> 8] + r[mt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[De >> 8] + r[De & 255] + r[je >> 8] + r[je & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[ke >> 8] + r[ke & 255] + r[oe >> 8] + r[oe & 255] + r[ve >> 8] + r[ve & 255] + r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 512);
      }
      l = Ee;
      function Xe(P) {
        var M, F = P.length - 3, O = b[1024].offset, S = 0, _ = O[63] | 0, h = 0, A = O[62] | 0, R = 0, I = O[61] | 0, k = 0, j = O[60] | 0, z = 0, H = O[59] | 0, J = 0, U = O[58] | 0, L = 0, B = O[57] | 0, Q = 0, V = O[56] | 0, X = 0, ue = O[55] | 0, ve = 0, pe = O[54] | 0, oe = 0, ce = O[53] | 0, ke = 0, fe = O[52] | 0, be = 0, ge = O[51] | 0, Ie = 0, le = O[50] | 0, he = 0, xe = O[49] | 0, je = 0, Oe = O[48] | 0, De = 0, ze = O[47] | 0, yt = 0, pt = O[46] | 0, bt = 0, lt = O[45] | 0, xt = 0, ft = O[44] | 0, _t = 0, dt = O[43] | 0, mt = 0, Je = O[42] | 0, ht = 0, rt = O[41] | 0, kt = 0, st = O[40] | 0, Et = 0, ut = O[39] | 0, St = 0, nt = O[38] | 0, Ct = 0, et = O[37] | 0, Ot = 0, it = O[36] | 0, wt = 0, at = O[35] | 0, Tt = 0, ot = O[34] | 0, At = 0, tt = O[33] | 0, qt = 0, Pt = O[32] | 0, Vt = 0, qr = O[31] | 0, Qr = 0, Ur = O[30] | 0, en = 0, Wr = O[29] | 0, tn = 0, Hr = O[28] | 0, rn = 0, zr = O[27] | 0, nn = 0, Kr = O[26] | 0, an = 0, Gr = O[25] | 0, on = 0, Zr = O[24] | 0, sn = 0, Yr = O[23] | 0, Xr = 0, Jr = O[22] | 0, Dr = 0, sr = O[21] | 0, Lr = 0, ur = O[20] | 0, Wt = 0, Mt = O[19] | 0, Nr = 0, cr = O[18] | 0, $r = 0, lr = O[17] | 0, Mr = 0, fr = O[16] | 0, Tr = 0, pr = O[15] | 0, Xt = 0, tr = O[14] | 0, wr = 0, nr = O[13] | 0, kr = 0, Zt = O[12] | 0, Pr = 0, ir = O[11] | 0, Rr = 0, ar = O[10] | 0, jr = 0, or = O[9] | 0, dr = 0, hr = O[8] | 0, br = 0, mr = O[7] | 0, Ir = 0, Jt = O[6] | 0, Ar = 0, rr = O[5] | 0, Yt = 0, Qt = O[4] | 0, Er = 0, gr = O[3] | 0, Or = 0, vr = O[2] | 0, Fr = 0, yr = O[1] | 0, ln = 0, cn = O[0] | 0;
        for (M = 0; M < F; )
          _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535;
        for (; M < F + 3; )
          _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535;
        return w(r[cn >> 8] + r[cn & 255] + r[yr >> 8] + r[yr & 255] + r[vr >> 8] + r[vr & 255] + r[gr >> 8] + r[gr & 255] + r[Qt >> 8] + r[Qt & 255] + r[rr >> 8] + r[rr & 255] + r[Jt >> 8] + r[Jt & 255] + r[mr >> 8] + r[mr & 255] + r[hr >> 8] + r[hr & 255] + r[or >> 8] + r[or & 255] + r[ar >> 8] + r[ar & 255] + r[ir >> 8] + r[ir & 255] + r[Zt >> 8] + r[Zt & 255] + r[nr >> 8] + r[nr & 255] + r[tr >> 8] + r[tr & 255] + r[pr >> 8] + r[pr & 255] + r[fr >> 8] + r[fr & 255] + r[lr >> 8] + r[lr & 255] + r[cr >> 8] + r[cr & 255] + r[Mt >> 8] + r[Mt & 255] + r[ur >> 8] + r[ur & 255] + r[sr >> 8] + r[sr & 255] + r[Jr >> 8] + r[Jr & 255] + r[Yr >> 8] + r[Yr & 255] + r[Zr >> 8] + r[Zr & 255] + r[Gr >> 8] + r[Gr & 255] + r[Kr >> 8] + r[Kr & 255] + r[zr >> 8] + r[zr & 255] + r[Hr >> 8] + r[Hr & 255] + r[Wr >> 8] + r[Wr & 255] + r[Ur >> 8] + r[Ur & 255] + r[qr >> 8] + r[qr & 255] + r[Pt >> 8] + r[Pt & 255] + r[tt >> 8] + r[tt & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[it >> 8] + r[it & 255] + r[et >> 8] + r[et & 255] + r[nt >> 8] + r[nt & 255] + r[ut >> 8] + r[ut & 255] + r[st >> 8] + r[st & 255] + r[rt >> 8] + r[rt & 255] + r[Je >> 8] + r[Je & 255] + r[dt >> 8] + r[dt & 255] + r[ft >> 8] + r[ft & 255] + r[lt >> 8] + r[lt & 255] + r[pt >> 8] + r[pt & 255] + r[ze >> 8] + r[ze & 255] + r[Oe >> 8] + r[Oe & 255] + r[xe >> 8] + r[xe & 255] + r[le >> 8] + r[le & 255] + r[ge >> 8] + r[ge & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 1024);
      }
      function Ke(P) {
        var M, F = P.length - 3, O = b[1024].offset, S = 0, _ = O[63] | 0, h = 0, A = O[62] | 0, R = 0, I = O[61] | 0, k = 0, j = O[60] | 0, z = 0, H = O[59] | 0, J = 0, U = O[58] | 0, L = 0, B = O[57] | 0, Q = 0, V = O[56] | 0, X = 0, ue = O[55] | 0, ve = 0, pe = O[54] | 0, oe = 0, ce = O[53] | 0, ke = 0, fe = O[52] | 0, be = 0, ge = O[51] | 0, Ie = 0, le = O[50] | 0, he = 0, xe = O[49] | 0, je = 0, Oe = O[48] | 0, De = 0, ze = O[47] | 0, yt = 0, pt = O[46] | 0, bt = 0, lt = O[45] | 0, xt = 0, ft = O[44] | 0, _t = 0, dt = O[43] | 0, mt = 0, Je = O[42] | 0, ht = 0, rt = O[41] | 0, kt = 0, st = O[40] | 0, Et = 0, ut = O[39] | 0, St = 0, nt = O[38] | 0, Ct = 0, et = O[37] | 0, Ot = 0, it = O[36] | 0, wt = 0, at = O[35] | 0, Tt = 0, ot = O[34] | 0, At = 0, tt = O[33] | 0, qt = 0, Pt = O[32] | 0, Vt = 0, qr = O[31] | 0, Qr = 0, Ur = O[30] | 0, en = 0, Wr = O[29] | 0, tn = 0, Hr = O[28] | 0, rn = 0, zr = O[27] | 0, nn = 0, Kr = O[26] | 0, an = 0, Gr = O[25] | 0, on = 0, Zr = O[24] | 0, sn = 0, Yr = O[23] | 0, Xr = 0, Jr = O[22] | 0, Dr = 0, sr = O[21] | 0, Lr = 0, ur = O[20] | 0, Wt = 0, Mt = O[19] | 0, Nr = 0, cr = O[18] | 0, $r = 0, lr = O[17] | 0, Mr = 0, fr = O[16] | 0, Tr = 0, pr = O[15] | 0, Xt = 0, tr = O[14] | 0, wr = 0, nr = O[13] | 0, kr = 0, Zt = O[12] | 0, Pr = 0, ir = O[11] | 0, Rr = 0, ar = O[10] | 0, jr = 0, or = O[9] | 0, dr = 0, hr = O[8] | 0, br = 0, mr = O[7] | 0, Ir = 0, Jt = O[6] | 0, Ar = 0, rr = O[5] | 0, Yt = 0, Qt = O[4] | 0, Er = 0, gr = O[3] | 0, Or = 0, vr = O[2] | 0, Fr = 0, yr = O[1] | 0, ln = 0, cn = O[0] | 0;
        for (M = 0; M < F; )
          S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++), S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++);
        for (; M < F + 3; )
          S = _ * 397, h = A * 397, R = I * 397, k = j * 397, z = H * 397, J = U * 397, L = B * 397, Q = V * 397, X = ue * 397, ve = pe * 397, oe = ce * 397, ke = fe * 397, be = ge * 397, Ie = le * 397, he = xe * 397, je = Oe * 397, De = ze * 397, yt = pt * 397, bt = lt * 397, xt = ft * 397, _t = dt * 397, mt = Je * 397, ht = rt * 397, kt = st * 397, Et = ut * 397, St = nt * 397, Ct = et * 397, Ot = it * 397, wt = at * 397, Tt = ot * 397, At = tt * 397, qt = Pt * 397, Vt = qr * 397, Qr = Ur * 397, en = Wr * 397, tn = Hr * 397, rn = zr * 397, nn = Kr * 397, an = Gr * 397, on = Zr * 397, sn = Yr * 397, Xr = Jr * 397, Dr = sr * 397, Lr = ur * 397, Wt = Mt * 397, Nr = cr * 397, $r = lr * 397, Mr = fr * 397, Tr = pr * 397, Xt = tr * 397, wr = nr * 397, kr = Zt * 397, Pr = ir * 397, Rr = ar * 397, jr = or * 397, dr = hr * 397, br = mr * 397, Ir = Jt * 397, Ar = rr * 397, Yt = Qt * 397, Er = gr * 397, Or = vr * 397, Fr = yr * 397, ln = cn * 397, Dr += _ << 8, Lr += A << 8, Wt += I << 8, Nr += j << 8, $r += H << 8, Mr += U << 8, Tr += B << 8, Xt += V << 8, wr += ue << 8, kr += pe << 8, Pr += ce << 8, Rr += fe << 8, jr += ge << 8, dr += le << 8, br += xe << 8, Ir += Oe << 8, Ar += ze << 8, Yt += pt << 8, Er += lt << 8, Or += ft << 8, Fr += dt << 8, ln += Je << 8, h += S >>> 16, _ = S & 65535, R += h >>> 16, A = h & 65535, k += R >>> 16, I = R & 65535, z += k >>> 16, j = k & 65535, J += z >>> 16, H = z & 65535, L += J >>> 16, U = J & 65535, Q += L >>> 16, B = L & 65535, X += Q >>> 16, V = Q & 65535, ve += X >>> 16, ue = X & 65535, oe += ve >>> 16, pe = ve & 65535, ke += oe >>> 16, ce = oe & 65535, be += ke >>> 16, fe = ke & 65535, Ie += be >>> 16, ge = be & 65535, he += Ie >>> 16, le = Ie & 65535, je += he >>> 16, xe = he & 65535, De += je >>> 16, Oe = je & 65535, yt += De >>> 16, ze = De & 65535, bt += yt >>> 16, pt = yt & 65535, xt += bt >>> 16, lt = bt & 65535, _t += xt >>> 16, ft = xt & 65535, mt += _t >>> 16, dt = _t & 65535, ht += mt >>> 16, Je = mt & 65535, kt += ht >>> 16, rt = ht & 65535, Et += kt >>> 16, st = kt & 65535, St += Et >>> 16, ut = Et & 65535, Ct += St >>> 16, nt = St & 65535, Ot += Ct >>> 16, et = Ct & 65535, wt += Ot >>> 16, it = Ot & 65535, Tt += wt >>> 16, at = wt & 65535, At += Tt >>> 16, ot = Tt & 65535, qt += At >>> 16, tt = At & 65535, Vt += qt >>> 16, Pt = qt & 65535, Qr += Vt >>> 16, qr = Vt & 65535, en += Qr >>> 16, Ur = Qr & 65535, tn += en >>> 16, Wr = en & 65535, rn += tn >>> 16, Hr = tn & 65535, nn += rn >>> 16, zr = rn & 65535, an += nn >>> 16, Kr = nn & 65535, on += an >>> 16, Gr = an & 65535, sn += on >>> 16, Zr = on & 65535, Xr += sn >>> 16, Yr = sn & 65535, Dr += Xr >>> 16, Jr = Xr & 65535, Lr += Dr >>> 16, sr = Dr & 65535, Wt += Lr >>> 16, ur = Lr & 65535, Nr += Wt >>> 16, Mt = Wt & 65535, $r += Nr >>> 16, cr = Nr & 65535, Mr += $r >>> 16, lr = $r & 65535, Tr += Mr >>> 16, fr = Mr & 65535, Xt += Tr >>> 16, pr = Tr & 65535, wr += Xt >>> 16, tr = Xt & 65535, kr += wr >>> 16, nr = wr & 65535, Pr += kr >>> 16, Zt = kr & 65535, Rr += Pr >>> 16, ir = Pr & 65535, jr += Rr >>> 16, ar = Rr & 65535, dr += jr >>> 16, or = jr & 65535, br += dr >>> 16, hr = dr & 65535, Ir += br >>> 16, mr = br & 65535, Ar += Ir >>> 16, Jt = Ir & 65535, Yt += Ar >>> 16, rr = Ar & 65535, Er += Yt >>> 16, Qt = Yt & 65535, Or += Er >>> 16, gr = Er & 65535, Fr += Or >>> 16, vr = Or & 65535, cn = ln + (Fr >>> 16) & 65535, yr = Fr & 65535, _ ^= P.charCodeAt(M++);
        return w(r[cn >> 8] + r[cn & 255] + r[yr >> 8] + r[yr & 255] + r[vr >> 8] + r[vr & 255] + r[gr >> 8] + r[gr & 255] + r[Qt >> 8] + r[Qt & 255] + r[rr >> 8] + r[rr & 255] + r[Jt >> 8] + r[Jt & 255] + r[mr >> 8] + r[mr & 255] + r[hr >> 8] + r[hr & 255] + r[or >> 8] + r[or & 255] + r[ar >> 8] + r[ar & 255] + r[ir >> 8] + r[ir & 255] + r[Zt >> 8] + r[Zt & 255] + r[nr >> 8] + r[nr & 255] + r[tr >> 8] + r[tr & 255] + r[pr >> 8] + r[pr & 255] + r[fr >> 8] + r[fr & 255] + r[lr >> 8] + r[lr & 255] + r[cr >> 8] + r[cr & 255] + r[Mt >> 8] + r[Mt & 255] + r[ur >> 8] + r[ur & 255] + r[sr >> 8] + r[sr & 255] + r[Jr >> 8] + r[Jr & 255] + r[Yr >> 8] + r[Yr & 255] + r[Zr >> 8] + r[Zr & 255] + r[Gr >> 8] + r[Gr & 255] + r[Kr >> 8] + r[Kr & 255] + r[zr >> 8] + r[zr & 255] + r[Hr >> 8] + r[Hr & 255] + r[Wr >> 8] + r[Wr & 255] + r[Ur >> 8] + r[Ur & 255] + r[qr >> 8] + r[qr & 255] + r[Pt >> 8] + r[Pt & 255] + r[tt >> 8] + r[tt & 255] + r[ot >> 8] + r[ot & 255] + r[at >> 8] + r[at & 255] + r[it >> 8] + r[it & 255] + r[et >> 8] + r[et & 255] + r[nt >> 8] + r[nt & 255] + r[ut >> 8] + r[ut & 255] + r[st >> 8] + r[st & 255] + r[rt >> 8] + r[rt & 255] + r[Je >> 8] + r[Je & 255] + r[dt >> 8] + r[dt & 255] + r[ft >> 8] + r[ft & 255] + r[lt >> 8] + r[lt & 255] + r[pt >> 8] + r[pt & 255] + r[ze >> 8] + r[ze & 255] + r[Oe >> 8] + r[Oe & 255] + r[xe >> 8] + r[xe & 255] + r[le >> 8] + r[le & 255] + r[ge >> 8] + r[ge & 255] + r[fe >> 8] + r[fe & 255] + r[ce >> 8] + r[ce & 255] + r[pe >> 8] + r[pe & 255] + r[ue >> 8] + r[ue & 255] + r[V >> 8] + r[V & 255] + r[B >> 8] + r[B & 255] + r[U >> 8] + r[U & 255] + r[H >> 8] + r[H & 255] + r[j >> 8] + r[j & 255] + r[I >> 8] + r[I & 255] + r[A >> 8] + r[A & 255] + r[_ >> 8] + r[_ & 255], 1024);
      }
      function $t(P) {
        var M, F, O = P.length, S = b[1024].offset, _ = 0, h = S[63] | 0, A = 0, R = S[62] | 0, I = 0, k = S[61] | 0, j = 0, z = S[60] | 0, H = 0, J = S[59] | 0, U = 0, L = S[58] | 0, B = 0, Q = S[57] | 0, V = 0, X = S[56] | 0, ue = 0, ve = S[55] | 0, pe = 0, oe = S[54] | 0, ce = 0, ke = S[53] | 0, fe = 0, be = S[52] | 0, ge = 0, Ie = S[51] | 0, le = 0, he = S[50] | 0, xe = 0, je = S[49] | 0, Oe = 0, De = S[48] | 0, ze = 0, yt = S[47] | 0, pt = 0, bt = S[46] | 0, lt = 0, xt = S[45] | 0, ft = 0, _t = S[44] | 0, dt = 0, mt = S[43] | 0, Je = 0, ht = S[42] | 0, rt = 0, kt = S[41] | 0, st = 0, Et = S[40] | 0, ut = 0, St = S[39] | 0, nt = 0, Ct = S[38] | 0, et = 0, Ot = S[37] | 0, it = 0, wt = S[36] | 0, at = 0, Tt = S[35] | 0, ot = 0, At = S[34] | 0, tt = 0, qt = S[33] | 0, Pt = 0, Vt = S[32] | 0, qr = 0, Qr = S[31] | 0, Ur = 0, en = S[30] | 0, Wr = 0, tn = S[29] | 0, Hr = 0, rn = S[28] | 0, zr = 0, nn = S[27] | 0, Kr = 0, an = S[26] | 0, Gr = 0, on = S[25] | 0, Zr = 0, sn = S[24] | 0, Yr = 0, Xr = S[23] | 0, Jr = 0, Dr = S[22] | 0, sr = 0, Lr = S[21] | 0, ur = 0, Wt = S[20] | 0, Mt = 0, Nr = S[19] | 0, cr = 0, $r = S[18] | 0, lr = 0, Mr = S[17] | 0, fr = 0, Tr = S[16] | 0, pr = 0, Xt = S[15] | 0, tr = 0, wr = S[14] | 0, nr = 0, kr = S[13] | 0, Zt = 0, Pr = S[12] | 0, ir = 0, Rr = S[11] | 0, ar = 0, jr = S[10] | 0, or = 0, dr = S[9] | 0, hr = 0, br = S[8] | 0, mr = 0, Ir = S[7] | 0, Jt = 0, Ar = S[6] | 0, rr = 0, Yt = S[5] | 0, Qt = 0, Er = S[4] | 0, gr = 0, Or = S[3] | 0, vr = 0, Fr = S[2] | 0, yr = 0, ln = S[1] | 0, cn = 0, kn = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M >> 12 & 63 | 128, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M >> 6 & 63 | 128, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M >> 6 & 63 | 128, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M & 63 | 128), _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535;
        return w(r[kn >> 8] + r[kn & 255] + r[ln >> 8] + r[ln & 255] + r[Fr >> 8] + r[Fr & 255] + r[Or >> 8] + r[Or & 255] + r[Er >> 8] + r[Er & 255] + r[Yt >> 8] + r[Yt & 255] + r[Ar >> 8] + r[Ar & 255] + r[Ir >> 8] + r[Ir & 255] + r[br >> 8] + r[br & 255] + r[dr >> 8] + r[dr & 255] + r[jr >> 8] + r[jr & 255] + r[Rr >> 8] + r[Rr & 255] + r[Pr >> 8] + r[Pr & 255] + r[kr >> 8] + r[kr & 255] + r[wr >> 8] + r[wr & 255] + r[Xt >> 8] + r[Xt & 255] + r[Tr >> 8] + r[Tr & 255] + r[Mr >> 8] + r[Mr & 255] + r[$r >> 8] + r[$r & 255] + r[Nr >> 8] + r[Nr & 255] + r[Wt >> 8] + r[Wt & 255] + r[Lr >> 8] + r[Lr & 255] + r[Dr >> 8] + r[Dr & 255] + r[Xr >> 8] + r[Xr & 255] + r[sn >> 8] + r[sn & 255] + r[on >> 8] + r[on & 255] + r[an >> 8] + r[an & 255] + r[nn >> 8] + r[nn & 255] + r[rn >> 8] + r[rn & 255] + r[tn >> 8] + r[tn & 255] + r[en >> 8] + r[en & 255] + r[Qr >> 8] + r[Qr & 255] + r[Vt >> 8] + r[Vt & 255] + r[qt >> 8] + r[qt & 255] + r[At >> 8] + r[At & 255] + r[Tt >> 8] + r[Tt & 255] + r[wt >> 8] + r[wt & 255] + r[Ot >> 8] + r[Ot & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Et >> 8] + r[Et & 255] + r[kt >> 8] + r[kt & 255] + r[ht >> 8] + r[ht & 255] + r[mt >> 8] + r[mt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[De >> 8] + r[De & 255] + r[je >> 8] + r[je & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[ke >> 8] + r[ke & 255] + r[oe >> 8] + r[oe & 255] + r[ve >> 8] + r[ve & 255] + r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 1024);
      }
      function Be(P) {
        var M, F, O = P.length, S = b[1024].offset, _ = 0, h = S[63] | 0, A = 0, R = S[62] | 0, I = 0, k = S[61] | 0, j = 0, z = S[60] | 0, H = 0, J = S[59] | 0, U = 0, L = S[58] | 0, B = 0, Q = S[57] | 0, V = 0, X = S[56] | 0, ue = 0, ve = S[55] | 0, pe = 0, oe = S[54] | 0, ce = 0, ke = S[53] | 0, fe = 0, be = S[52] | 0, ge = 0, Ie = S[51] | 0, le = 0, he = S[50] | 0, xe = 0, je = S[49] | 0, Oe = 0, De = S[48] | 0, ze = 0, yt = S[47] | 0, pt = 0, bt = S[46] | 0, lt = 0, xt = S[45] | 0, ft = 0, _t = S[44] | 0, dt = 0, mt = S[43] | 0, Je = 0, ht = S[42] | 0, rt = 0, kt = S[41] | 0, st = 0, Et = S[40] | 0, ut = 0, St = S[39] | 0, nt = 0, Ct = S[38] | 0, et = 0, Ot = S[37] | 0, it = 0, wt = S[36] | 0, at = 0, Tt = S[35] | 0, ot = 0, At = S[34] | 0, tt = 0, qt = S[33] | 0, Pt = 0, Vt = S[32] | 0, qr = 0, Qr = S[31] | 0, Ur = 0, en = S[30] | 0, Wr = 0, tn = S[29] | 0, Hr = 0, rn = S[28] | 0, zr = 0, nn = S[27] | 0, Kr = 0, an = S[26] | 0, Gr = 0, on = S[25] | 0, Zr = 0, sn = S[24] | 0, Yr = 0, Xr = S[23] | 0, Jr = 0, Dr = S[22] | 0, sr = 0, Lr = S[21] | 0, ur = 0, Wt = S[20] | 0, Mt = 0, Nr = S[19] | 0, cr = 0, $r = S[18] | 0, lr = 0, Mr = S[17] | 0, fr = 0, Tr = S[16] | 0, pr = 0, Xt = S[15] | 0, tr = 0, wr = S[14] | 0, nr = 0, kr = S[13] | 0, Zt = 0, Pr = S[12] | 0, ir = 0, Rr = S[11] | 0, ar = 0, jr = S[10] | 0, or = 0, dr = S[9] | 0, hr = 0, br = S[8] | 0, mr = 0, Ir = S[7] | 0, Jt = 0, Ar = S[6] | 0, rr = 0, Yt = S[5] | 0, Qt = 0, Er = S[4] | 0, gr = 0, Or = S[3] | 0, vr = 0, Fr = S[2] | 0, yr = 0, ln = S[1] | 0, cn = 0, kn = S[0] | 0;
        for (F = 0; F < O; F++)
          M = P.charCodeAt(F), _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, M < 128 ? h ^= M : M < 2048 ? (h ^= M >> 6 | 192, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M & 63 | 128) : (M & 64512) == 55296 && F + 1 < O && (P.charCodeAt(F + 1) & 64512) == 56320 ? (M = 65536 + ((M & 1023) << 10) + (P.charCodeAt(++F) & 1023), h ^= M >> 18 | 240, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M >> 12 & 63 | 128, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M >> 6 & 63 | 128, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M & 63 | 128) : (h ^= M >> 12 | 224, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M >> 6 & 63 | 128, _ = h * 397, A = R * 397, I = k * 397, j = z * 397, H = J * 397, U = L * 397, B = Q * 397, V = X * 397, ue = ve * 397, pe = oe * 397, ce = ke * 397, fe = be * 397, ge = Ie * 397, le = he * 397, xe = je * 397, Oe = De * 397, ze = yt * 397, pt = bt * 397, lt = xt * 397, ft = _t * 397, dt = mt * 397, Je = ht * 397, rt = kt * 397, st = Et * 397, ut = St * 397, nt = Ct * 397, et = Ot * 397, it = wt * 397, at = Tt * 397, ot = At * 397, tt = qt * 397, Pt = Vt * 397, qr = Qr * 397, Ur = en * 397, Wr = tn * 397, Hr = rn * 397, zr = nn * 397, Kr = an * 397, Gr = on * 397, Zr = sn * 397, Yr = Xr * 397, Jr = Dr * 397, sr = Lr * 397, ur = Wt * 397, Mt = Nr * 397, cr = $r * 397, lr = Mr * 397, fr = Tr * 397, pr = Xt * 397, tr = wr * 397, nr = kr * 397, Zt = Pr * 397, ir = Rr * 397, ar = jr * 397, or = dr * 397, hr = br * 397, mr = Ir * 397, Jt = Ar * 397, rr = Yt * 397, Qt = Er * 397, gr = Or * 397, vr = Fr * 397, yr = ln * 397, cn = kn * 397, sr += h << 8, ur += R << 8, Mt += k << 8, cr += z << 8, lr += J << 8, fr += L << 8, pr += Q << 8, tr += X << 8, nr += ve << 8, Zt += oe << 8, ir += ke << 8, ar += be << 8, or += Ie << 8, hr += he << 8, mr += je << 8, Jt += De << 8, rr += yt << 8, Qt += bt << 8, gr += xt << 8, vr += _t << 8, yr += mt << 8, cn += ht << 8, A += _ >>> 16, h = _ & 65535, I += A >>> 16, R = A & 65535, j += I >>> 16, k = I & 65535, H += j >>> 16, z = j & 65535, U += H >>> 16, J = H & 65535, B += U >>> 16, L = U & 65535, V += B >>> 16, Q = B & 65535, ue += V >>> 16, X = V & 65535, pe += ue >>> 16, ve = ue & 65535, ce += pe >>> 16, oe = pe & 65535, fe += ce >>> 16, ke = ce & 65535, ge += fe >>> 16, be = fe & 65535, le += ge >>> 16, Ie = ge & 65535, xe += le >>> 16, he = le & 65535, Oe += xe >>> 16, je = xe & 65535, ze += Oe >>> 16, De = Oe & 65535, pt += ze >>> 16, yt = ze & 65535, lt += pt >>> 16, bt = pt & 65535, ft += lt >>> 16, xt = lt & 65535, dt += ft >>> 16, _t = ft & 65535, Je += dt >>> 16, mt = dt & 65535, rt += Je >>> 16, ht = Je & 65535, st += rt >>> 16, kt = rt & 65535, ut += st >>> 16, Et = st & 65535, nt += ut >>> 16, St = ut & 65535, et += nt >>> 16, Ct = nt & 65535, it += et >>> 16, Ot = et & 65535, at += it >>> 16, wt = it & 65535, ot += at >>> 16, Tt = at & 65535, tt += ot >>> 16, At = ot & 65535, Pt += tt >>> 16, qt = tt & 65535, qr += Pt >>> 16, Vt = Pt & 65535, Ur += qr >>> 16, Qr = qr & 65535, Wr += Ur >>> 16, en = Ur & 65535, Hr += Wr >>> 16, tn = Wr & 65535, zr += Hr >>> 16, rn = Hr & 65535, Kr += zr >>> 16, nn = zr & 65535, Gr += Kr >>> 16, an = Kr & 65535, Zr += Gr >>> 16, on = Gr & 65535, Yr += Zr >>> 16, sn = Zr & 65535, Jr += Yr >>> 16, Xr = Yr & 65535, sr += Jr >>> 16, Dr = Jr & 65535, ur += sr >>> 16, Lr = sr & 65535, Mt += ur >>> 16, Wt = ur & 65535, cr += Mt >>> 16, Nr = Mt & 65535, lr += cr >>> 16, $r = cr & 65535, fr += lr >>> 16, Mr = lr & 65535, pr += fr >>> 16, Tr = fr & 65535, tr += pr >>> 16, Xt = pr & 65535, nr += tr >>> 16, wr = tr & 65535, Zt += nr >>> 16, kr = nr & 65535, ir += Zt >>> 16, Pr = Zt & 65535, ar += ir >>> 16, Rr = ir & 65535, or += ar >>> 16, jr = ar & 65535, hr += or >>> 16, dr = or & 65535, mr += hr >>> 16, br = hr & 65535, Jt += mr >>> 16, Ir = mr & 65535, rr += Jt >>> 16, Ar = Jt & 65535, Qt += rr >>> 16, Yt = rr & 65535, gr += Qt >>> 16, Er = Qt & 65535, vr += gr >>> 16, Or = gr & 65535, yr += vr >>> 16, Fr = vr & 65535, kn = cn + (yr >>> 16) & 65535, ln = yr & 65535, h ^= M & 63 | 128);
        return w(r[kn >> 8] + r[kn & 255] + r[ln >> 8] + r[ln & 255] + r[Fr >> 8] + r[Fr & 255] + r[Or >> 8] + r[Or & 255] + r[Er >> 8] + r[Er & 255] + r[Yt >> 8] + r[Yt & 255] + r[Ar >> 8] + r[Ar & 255] + r[Ir >> 8] + r[Ir & 255] + r[br >> 8] + r[br & 255] + r[dr >> 8] + r[dr & 255] + r[jr >> 8] + r[jr & 255] + r[Rr >> 8] + r[Rr & 255] + r[Pr >> 8] + r[Pr & 255] + r[kr >> 8] + r[kr & 255] + r[wr >> 8] + r[wr & 255] + r[Xt >> 8] + r[Xt & 255] + r[Tr >> 8] + r[Tr & 255] + r[Mr >> 8] + r[Mr & 255] + r[$r >> 8] + r[$r & 255] + r[Nr >> 8] + r[Nr & 255] + r[Wt >> 8] + r[Wt & 255] + r[Lr >> 8] + r[Lr & 255] + r[Dr >> 8] + r[Dr & 255] + r[Xr >> 8] + r[Xr & 255] + r[sn >> 8] + r[sn & 255] + r[on >> 8] + r[on & 255] + r[an >> 8] + r[an & 255] + r[nn >> 8] + r[nn & 255] + r[rn >> 8] + r[rn & 255] + r[tn >> 8] + r[tn & 255] + r[en >> 8] + r[en & 255] + r[Qr >> 8] + r[Qr & 255] + r[Vt >> 8] + r[Vt & 255] + r[qt >> 8] + r[qt & 255] + r[At >> 8] + r[At & 255] + r[Tt >> 8] + r[Tt & 255] + r[wt >> 8] + r[wt & 255] + r[Ot >> 8] + r[Ot & 255] + r[Ct >> 8] + r[Ct & 255] + r[St >> 8] + r[St & 255] + r[Et >> 8] + r[Et & 255] + r[kt >> 8] + r[kt & 255] + r[ht >> 8] + r[ht & 255] + r[mt >> 8] + r[mt & 255] + r[_t >> 8] + r[_t & 255] + r[xt >> 8] + r[xt & 255] + r[bt >> 8] + r[bt & 255] + r[yt >> 8] + r[yt & 255] + r[De >> 8] + r[De & 255] + r[je >> 8] + r[je & 255] + r[he >> 8] + r[he & 255] + r[Ie >> 8] + r[Ie & 255] + r[be >> 8] + r[be & 255] + r[ke >> 8] + r[ke & 255] + r[oe >> 8] + r[oe & 255] + r[ve >> 8] + r[ve & 255] + r[X >> 8] + r[X & 255] + r[Q >> 8] + r[Q & 255] + r[L >> 8] + r[L & 255] + r[J >> 8] + r[J & 255] + r[z >> 8] + r[z & 255] + r[k >> 8] + r[k & 255] + r[R >> 8] + r[R & 255] + r[h >> 8] + r[h & 255], 1024);
      }
      return p = Xe, $("1a"), Z(!1), te(), {
        hash: E,
        setKeyspace: D,
        version: $,
        useUTF8: Z,
        seed: te,
        fast1a32: se,
        fast1a32hex: ee,
        fast1a52: K,
        fast1a52hex: re,
        fast1a64: de,
        fast1a32utf: ie,
        fast1a32hexutf: me,
        fast1a52utf: $e,
        fast1a52hexutf: Pe,
        fast1a64utf: Le
      };
    }();
    e.exports = t;
  }(Lh)), Lh.exports;
}
var Yb;
function sB() {
  if (Yb) return Us;
  Yb = 1, Object.defineProperty(Us, "__esModule", { value: !0 }), Us.hash = Us.setSkipHashing = void 0;
  const e = oB();
  let t = !1;
  const n = (i) => {
    t = i;
  };
  Us.setSkipHashing = n;
  const r = (i, a = t) => a ? i : e.fast1a52hex(i);
  return Us.hash = r, Us;
}
var Jb;
function Hf() {
  if (Jb) return tl;
  Jb = 1, Object.defineProperty(tl, "__esModule", { value: !0 }), tl.createContext = void 0;
  const e = /* @__PURE__ */ Ai(), t = /* @__PURE__ */ sB(), n = /* @__PURE__ */ ha();
  function r(i, a = n.resolveRef) {
    return (0, e.createContext)(i, a, t.hash);
  }
  return tl.createContext = r, tl;
}
var rl = {}, ua = {}, li = {}, Qb;
function Sc() {
  if (Qb) return li;
  Qb = 1, Object.defineProperty(li, "__esModule", { value: !0 }), li.isFormDataParam = li.isBodyParam = li.isHeaderParam = li.isPathParam = li.isQueryParam = li.isValidScheme = li.isResponseObject = li.isSecurityScheme = void 0;
  const e = Yn, t = /* @__PURE__ */ Gi();
  function n(f) {
    return (0, e.isPlainObject)(f) && typeof f.type == "string";
  }
  li.isSecurityScheme = n;
  const r = (f) => (0, e.isPlainObject)(f) && ("description" in f || "schema" in f || "headers" in f || "examples" in f);
  li.isResponseObject = r;
  function i(f) {
    return typeof f == "string" && ["http", "https", "ws", "wss"].includes(f);
  }
  li.isValidScheme = i;
  function a(f) {
    return (0, t.isValidOas2ParameterObject)(f) && f.in === "query";
  }
  li.isQueryParam = a;
  function o(f) {
    return (0, t.isValidOas2ParameterObject)(f) && f.in === "path";
  }
  li.isPathParam = o;
  function c(f) {
    return (0, t.isValidOas2ParameterObject)(f) && f.in === "header";
  }
  li.isHeaderParam = c;
  function u(f) {
    return (0, t.isValidOas2ParameterObject)(f) && f.in === "body";
  }
  li.isBodyParam = u;
  function s(f) {
    return (0, t.isValidOas2ParameterObject)(f) && f.in === "formData";
  }
  return li.isFormDataParam = s, li;
}
var Xb;
function B0() {
  if (Xb) return ua;
  Xb = 1, Object.defineProperty(ua, "__esModule", { value: !0 }), ua.getExamplesFromSchema = ua.normalizeProducesOrConsumes = ua.getConsumes = ua.getProduces = ua.getSecurities = void 0;
  const e = Yn, t = ti(), n = /* @__PURE__ */ Xn(), r = /* @__PURE__ */ Sc();
  function i(l, p) {
    if (!(0, n.isNonNullable)(l.securityDefinitions) || (0, t.isEmpty)(l.securityDefinitions))
      return [];
    const g = p || l.security, v = c(g, l.securityDefinitions);
    return d(g) && v.push([]), v;
  }
  ua.getSecurities = i;
  function a(l, p) {
    return s("produces", l, p);
  }
  ua.getProduces = a;
  function o(l, p) {
    return s("consumes", l, p);
  }
  ua.getConsumes = o;
  function c(l, p) {
    return !Array.isArray(l) || !p ? [] : l.map((g) => (0, e.isPlainObject)(g) ? Object.keys(g).map((v) => {
      const b = p[v];
      if ((0, r.isSecurityScheme)(b)) {
        const y = { ...b, key: v }, w = g[v], C = Array.isArray(w) ? w : [];
        return y.type === "oauth2" && C.length && (y.scopes = (0, t.pickBy)(y.scopes, (T, E) => C.includes(E))), y;
      }
      return null;
    }).filter(n.isNonNullable) : []).filter((g) => !(0, t.isEmpty)(g));
  }
  function u(l) {
    return Array.isArray(l) ? l.flat().filter(n.isString) : [];
  }
  ua.normalizeProducesOrConsumes = u;
  function s(l, p, g) {
    return u((g == null ? void 0 : g[l]) || (p == null ? void 0 : p[l]));
  }
  function f(l) {
    return (0, e.isPlainObject)(l) ? {
      ...(0, e.isPlainObject)(l["x-examples"]) && { ...l["x-examples"] },
      ..."example" in l && { default: l.example }
    } : {};
  }
  ua.getExamplesFromSchema = f;
  function d(l) {
    return Array.isArray(l) && l.length > 1 && l.some((p) => (0, t.isEmpty)(p));
  }
  return ua;
}
var Nh = {}, nl = {}, e8;
function zf() {
  if (e8) return nl;
  e8 = 1, Object.defineProperty(nl, "__esModule", { value: !0 }), nl.translateToDefaultExample = void 0;
  const e = /* @__PURE__ */ Ai();
  return nl.translateToDefaultExample = (0, e.withContext)(function(t, n) {
    const r = this.maybeResolveLocalRef(n);
    return {
      id: this.generateId.example({ keyOrName: t }),
      value: r,
      key: t
    };
  }), nl;
}
var t8;
function O2() {
  return t8 || (t8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSharedParameters = e.translateToPathParameter = e.translateToQueryParameter = e.translateFromFormDataParameters = e.translateToBodyParameter = e.translateToHeaderParams = e.translateToHeaderParam = void 0;
    const t = Yn, n = /* @__PURE__ */ wc(), r = ti(), i = /* @__PURE__ */ Ai(), a = /* @__PURE__ */ Xn(), o = /* @__PURE__ */ Gi(), c = /* @__PURE__ */ ha(), u = /* @__PURE__ */ zf(), s = /* @__PURE__ */ Eu(), f = /* @__PURE__ */ Ci(), d = /* @__PURE__ */ B0(), l = /* @__PURE__ */ Sc(), p = ["application/x-www-form-urlencoded", "multipart/form-data"];
    function g(C) {
      if (C.type !== "array")
        return { style: n.HttpParamStyles.Unspecified };
      switch (C.collectionFormat) {
        case "csv":
          return { style: n.HttpParamStyles.CommaDelimited };
        case "ssv":
          return { style: n.HttpParamStyles.SpaceDelimited };
        case "tsv":
          return { style: n.HttpParamStyles.TabDelimited };
        case "pipes":
          return { style: n.HttpParamStyles.PipeDelimited };
        case "multi":
          return { style: n.HttpParamStyles.Form, explode: !0 };
        default:
          return { style: n.HttpParamStyles.CommaDelimited };
      }
    }
    e.translateToHeaderParam = (0, i.withContext)(function(C) {
      const T = C.name, E = (0, c.getSharedKey)(C, T);
      return {
        id: this.generateId.httpHeader({ keyOrName: E, componentType: "parameter" }),
        name: T,
        style: n.HttpParamStyles.Simple,
        ...w.call(this, C),
        ...(0, r.pickBy)({
          required: C.required
        }, a.isBoolean)
      };
    });
    const v = function([C, T]) {
      if ((0, o.isReferenceObject)(T))
        return T.name = C, T;
      if (!(0, t.isPlainObject)(T))
        return;
      const E = { name: C, in: "header", ...T };
      if ((0, l.isHeaderParam)(E))
        return e.translateToHeaderParam.call(this, E);
    }, b = function(C) {
      return (0, f.entries)(C).map(v, this).filter(a.isNonNullable);
    };
    e.translateToHeaderParams = b, e.translateToBodyParameter = (0, i.withContext)(function(C, T) {
      const E = this.generateId.httpRequestBody({}), D = (0, f.entries)(C["x-examples"] || (0, d.getExamplesFromSchema)(C.schema)).map(([Z, te]) => u.translateToDefaultExample.call(this, Z, te)), $ = T.filter((Z) => !p.includes(Z));
      return {
        id: E,
        contents: $.map((0, i.withContext)((Z) => ({
          id: this.generateId.httpMedia({ mediaType: Z }),
          mediaType: Z,
          examples: D,
          ...(0, r.pickBy)({
            schema: (0, t.isPlainObject)(C.schema) ? s.translateSchemaObject.call(this, C.schema) : void 0
          }, a.isNonNullable)
        })), this),
        ...(0, r.pickBy)({
          required: C.required
        }, a.isBoolean),
        ...(0, r.pickBy)({
          description: C.description
        }, a.isString),
        ...(0, r.pickBy)({
          name: C.name
        }, a.isString)
      };
    }), e.translateFromFormDataParameters = (0, i.withContext)(function(C, T) {
      const E = T.filter(($) => p.includes($)), D = {
        id: this.generateId.httpRequestBody({ consumes: E }),
        contents: E.map((0, i.withContext)(($) => ({
          id: this.generateId.httpMedia({ mediaType: $ }),
          mediaType: $,
          ...(0, r.pickBy)({
            schema: C.length > 0 ? s.translateSchemaObject.call(this, { type: "object", properties: {} }) : void 0
          }, a.isNonNullable)
        })), this)
      };
      return C.reduce(($, Z) => {
        var te, se, ee;
        const { schema: K = {}, description: re } = w.call(this, Z);
        delete K.$schema, delete K["x-stoplight"];
        for (const de of $.contents) {
          typeof re == "string" && re.length > 0 && (K.description = re), de.schema.properties[Z.name] = K, Z.required && ((te = (ee = de.schema).required) !== null && te !== void 0 ? te : ee.required = []).push(Z.name);
          const ie = y(Z);
          ie && ((se = de.encodings) !== null && se !== void 0 ? se : de.encodings = []).push(ie);
        }
        return $;
      }, D);
    });
    function y(C) {
      switch (C.collectionFormat) {
        case "csv":
          return {
            property: C.name,
            style: n.HttpParamStyles.CommaDelimited,
            explode: !1
          };
        case "pipes":
          return {
            property: C.name,
            style: n.HttpParamStyles.PipeDelimited,
            explode: !1
          };
        case "multi":
          return {
            property: C.name,
            style: n.HttpParamStyles.Form,
            explode: !0
          };
        case "ssv":
          return {
            property: C.name,
            style: n.HttpParamStyles.SpaceDelimited,
            explode: !1
          };
      }
      return null;
    }
    e.translateToQueryParameter = (0, i.withContext)(function(C) {
      const T = C.name, E = (0, c.getSharedKey)(C, T);
      return {
        id: this.generateId.httpQuery({ keyOrName: E }),
        name: T,
        ...g(C),
        ...w.call(this, C),
        ...(0, r.pickBy)({
          allowEmptyValue: C.allowEmptyValue,
          required: C.required
        }, a.isBoolean)
      };
    }), e.translateToPathParameter = (0, i.withContext)(function(C) {
      const T = C.name, E = (0, c.getSharedKey)(C, T);
      return {
        id: this.generateId.httpPathParam({ keyOrName: E }),
        name: T,
        style: n.HttpParamStyles.Simple,
        ...w.call(this, C),
        ...(0, r.pickBy)({
          required: C.required
        }, a.isBoolean)
      };
    });
    const w = function(C) {
      const T = (0, r.pick)(C, "type", "format", "default", "enum", "exclusiveMaximum", "exclusiveMinimum", "maxItems", "maxLength", "maximum", "minItems", "minimum", "minLength", "title", "items", "pattern", "uniqueItems", "multipleOf");
      return "allowEmptyValue" in C && C.allowEmptyValue === !1 && (T.minLength = 1), {
        ...(0, r.pickBy)({
          schema: Object.keys(T).length > 0 ? s.translateSchemaObject.call(this, T) : void 0
        }, a.isNonNullable),
        ...(0, r.pickBy)({
          deprecated: C["x-deprecated"]
        }, a.isBoolean),
        ...(0, r.pickBy)({
          description: C.description
        }, a.isString)
      };
    };
    e.translateToSharedParameters = (0, i.withContext)(function(C) {
      const T = {
        header: [],
        query: [],
        cookie: [],
        path: [],
        unknownParameters: []
      };
      for (const [E, D] of (0, f.entries)(C.parameters))
        (0, c.setSharedKey)(D, E), !(!(0, o.isValidOas2ParameterObject)(D) || D.in === "formData" || D.in === "body") && (this.references[`#/parameters/${E}`] = {
          resolved: !0,
          value: `#/components/${D.in}/${T[D.in].length}`
        }, (0, l.isQueryParam)(D) ? T.query.push({
          key: E,
          ...e.translateToQueryParameter.call(this, D)
        }) : (0, l.isPathParam)(D) ? T.path.push({
          key: E,
          ...e.translateToPathParameter.call(this, D)
        }) : (0, l.isHeaderParam)(D) && T.header.push({
          key: E,
          ...e.translateToHeaderParam.call(this, D)
        }));
      return T;
    });
  }(Nh)), Nh;
}
var r8;
function uB() {
  if (r8) return rl;
  r8 = 1, Object.defineProperty(rl, "__esModule", { value: !0 }), rl.translateToRequest = void 0;
  const e = ti(), t = /* @__PURE__ */ Xn(), n = /* @__PURE__ */ F0(), r = /* @__PURE__ */ Os(), i = /* @__PURE__ */ Gi(), a = /* @__PURE__ */ ha(), o = /* @__PURE__ */ B0(), c = /* @__PURE__ */ Sc(), u = /* @__PURE__ */ O2(), s = (0, r.createOasParamsIterator)(n.OasVersion.OAS2), f = function(d, l) {
    var p;
    const g = (0, o.getConsumes)(this.document, l), v = s.call(this, d, l), b = {
      headers: [],
      query: [],
      cookie: [],
      path: [],
      unknown: []
    };
    let y;
    const w = [];
    for (const T of v) {
      if ((0, i.isReferenceObject)(T)) {
        const E = (p = (0, a.getComponentName)(this.references, T.$ref)) !== null && p !== void 0 ? p : "", D = b[E === "header" ? "headers" : E || "unknown"];
        Array.isArray(D) && D.push((0, a.syncReferenceObject)(T, this.references));
        continue;
      }
      (0, c.isQueryParam)(T) ? b.query.push(u.translateToQueryParameter.call(this, T)) : (0, c.isPathParam)(T) ? b.path.push(u.translateToPathParameter.call(this, T)) : (0, c.isHeaderParam)(T) ? b.headers.push(u.translateToHeaderParam.call(this, T)) : (0, c.isBodyParam)(T) ? y = u.translateToBodyParameter.call(this, T, g) : (0, c.isFormDataParam)(T) && w.push(T);
    }
    let C;
    return y ? C = y : w.length && (C = u.translateFromFormDataParameters.call(this, w, g)), b.unknown && !b.unknown.length && delete b.unknown, {
      ...b,
      ...(0, e.pickBy)({
        body: C
      }, t.isNonNullable)
    };
  };
  return rl.translateToRequest = f, rl;
}
var $h = {}, n8;
function MA() {
  return n8 || (n8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSharedResponses = e.translateToResponses = e.translateToResponse = void 0;
    const t = Yn, n = ti(), r = /* @__PURE__ */ Ai(), i = /* @__PURE__ */ Xn(), a = /* @__PURE__ */ Gi(), o = /* @__PURE__ */ ha(), c = /* @__PURE__ */ zf(), u = /* @__PURE__ */ Eu(), s = /* @__PURE__ */ Ci(), f = /* @__PURE__ */ B0(), d = /* @__PURE__ */ Sc(), l = /* @__PURE__ */ O2();
    e.translateToResponse = (0, r.withContext)(function(v, b, y) {
      var w;
      const C = (w = this.maybeResolveLocalRef(y)) !== null && w !== void 0 ? w : y;
      if ((0, a.isReferenceObject)(C))
        return C.code = b, C;
      if (!(0, d.isResponseObject)(C))
        return;
      const T = this.context === "service" ? (0, o.getSharedKey)(C, b) : b, E = this.generateId.httpResponse({ codeOrKey: T, produces: v }), D = l.translateToHeaderParams.call(this, C.headers), $ = (0, s.entries)(C.examples || (0, f.getExamplesFromSchema)(C.schema)).map(([ee, K]) => c.translateToDefaultExample.call(this, ee, K)), Z = v.map((0, r.withContext)((ee) => ({
        id: this.generateId.httpMedia({ mediaType: ee }),
        mediaType: ee,
        examples: $.filter((K) => K.key === ee),
        ...(0, n.pickBy)({
          schema: (0, t.isPlainObject)(C.schema) ? u.translateSchemaObject.call(this, C.schema) : void 0
        }, i.isNonNullable)
      })), this).filter(({ schema: ee, examples: K }) => !!ee || K.length > 0), te = {
        id: E,
        code: b,
        description: C.description,
        headers: D,
        contents: Z
      }, se = $.filter((ee) => !v.includes(ee.key));
      return se.length > 0 && (te.contents.length === 0 && (te.contents[0] = {
        id: this.generateId.httpMedia({ mediaType: "" }),
        mediaType: "",
        schema: {},
        examples: []
      }), te.contents[0].examples.push(...se)), te;
    });
    const p = function(v) {
      const b = (0, f.getProduces)(this.document, v);
      return (0, s.entries)(v.responses).map(([y, w]) => e.translateToResponse.call(this, b, y, w)).filter(i.isNonNullable);
    };
    e.translateToResponses = p;
    const g = function(v) {
      const b = {
        responses: []
      };
      for (const [y, w] of (0, s.entries)(v.responses))
        (0, o.setSharedKey)(w, y), b.responses.push({
          key: y,
          ...e.translateToResponse.call(this, ["application/x-stoplight-placeholder"], y, w)
        });
      return b;
    };
    e.translateToSharedResponses = g;
  }($h)), $h;
}
var Mh = {}, i8;
function FA() {
  return i8 || (i8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSecurities = e.translateToSingleSecurity = e.translateToOauth2SecurityScheme = e.translateToApiKeySecurityScheme = e.translateToBasicSecurityScheme = e.translateToFlows = void 0;
    const t = Yn, n = ti(), r = /* @__PURE__ */ Ai(), i = /* @__PURE__ */ Xn(), a = /* @__PURE__ */ Os(), o = /* @__PURE__ */ B0(), c = /* @__PURE__ */ Sc(), u = function(l) {
      const p = {}, g = (0, t.isPlainObject)(l.scopes) ? (0, n.pickBy)(l.scopes, i.isString) : {}, v = "authorizationUrl" in l && typeof l.authorizationUrl == "string" ? l.authorizationUrl : "", b = "tokenUrl" in l && typeof l.tokenUrl == "string" ? l.tokenUrl : "";
      return l.flow === "implicit" ? p.implicit = {
        authorizationUrl: v,
        scopes: g
      } : l.flow === "password" ? p.password = {
        tokenUrl: b,
        scopes: g
      } : l.flow === "application" ? p.clientCredentials = {
        tokenUrl: b,
        scopes: g
      } : l.flow === "accessCode" && (p.authorizationCode = {
        authorizationUrl: v,
        tokenUrl: b,
        scopes: g
      }), p;
    };
    e.translateToFlows = u, e.translateToBasicSecurityScheme = (0, r.withContext)(function(l, p, g) {
      const v = l.key;
      return {
        id: this.generateId.httpSecurity({
          keyOrName: v,
          kind: p,
          ...p === "requirement" ? {
            index: g
          } : {}
        }),
        type: "http",
        scheme: "basic",
        key: v,
        ...(0, n.pickBy)({
          description: l.description
        }, i.isString),
        extensions: (0, a.getExtensions)(l)
      };
    });
    const s = ["query", "header"];
    e.translateToApiKeySecurityScheme = (0, r.withContext)(function(l, p, g) {
      if ("in" in l && l.in && s.includes(l.in)) {
        const v = l.key;
        return {
          id: this.generateId.httpSecurity({
            keyOrName: v,
            kind: p,
            ...p === "requirement" ? {
              index: g
            } : {}
          }),
          type: "apiKey",
          in: l.in,
          name: (0, i.isString)(l.name) ? l.name : "",
          key: v,
          ...(0, n.pickBy)({
            description: l.description
          }, i.isString),
          extensions: (0, a.getExtensions)(l)
        };
      }
    });
    const f = ["implicit", "password", "application", "accessCode"];
    e.translateToOauth2SecurityScheme = (0, r.withContext)(function(l, p, g) {
      if (!l.flow || !f.includes(l.flow))
        return;
      const v = l.key;
      return {
        id: this.generateId.httpSecurity({
          keyOrName: v,
          kind: p,
          ...p === "requirement" ? {
            index: g
          } : {}
        }),
        type: "oauth2",
        flows: e.translateToFlows.call(this, l),
        key: v,
        ...(0, n.pickBy)({
          description: l.description
        }, i.isString),
        extensions: (0, a.getExtensions)(l)
      };
    });
    const d = function(l, p, g) {
      if ((0, c.isSecurityScheme)(p))
        switch (p.type) {
          case "basic":
            return e.translateToBasicSecurityScheme.call(this, p, l, g);
          case "apiKey":
            return e.translateToApiKeySecurityScheme.call(this, p, l, g);
          case "oauth2":
            return e.translateToOauth2SecurityScheme.call(this, p, l, g);
        }
    };
    e.translateToSingleSecurity = d, e.translateToSecurities = (0, r.withContext)(function(l, p) {
      return this.context = "service", (0, o.getSecurities)(this.document, l).map((v) => v.map(e.translateToSingleSecurity.bind(this, p)).filter(i.isNonNullable));
    });
  }(Mh)), Mh;
}
var Fh = {}, a8;
function BA() {
  return a8 || (a8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToServer = e.translateToServers = void 0;
    const t = ti(), n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Xn(), i = /* @__PURE__ */ Sc();
    e.translateToServers = (0, n.withContext)(function(a) {
      let o;
      if (Array.isArray(a.schemes))
        o = a.schemes, this.context = "operation";
      else if (Array.isArray(this.document.schemes))
        o = this.document.schemes, this.context = "service";
      else
        return [];
      return o.map(e.translateToServer, this).filter(r.isNonNullable);
    }), e.translateToServer = (0, n.withContext)(function(a) {
      var o;
      const { host: c } = this.document;
      if (typeof c != "string" || c.length === 0 || !(0, r.isString)(a) || !(0, i.isValidScheme)(a))
        return;
      const u = typeof this.document.basePath == "string" && this.document.basePath.length > 0 ? this.document.basePath : null, s = new URL("https://localhost");
      s.protocol = `${a}:`, s.host = c, u !== null && (s.pathname = u);
      const f = s.toString().replace(/\/$/, "");
      return {
        id: this.generateId.httpServer({ url: f }),
        url: f,
        ...(0, t.pickBy)({
          name: (o = this.document.info) === null || o === void 0 ? void 0 : o.title
        }, r.isString)
      };
    });
  }(Fh)), Fh;
}
var o8;
function UA() {
  return o8 || (o8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas2Operation = e.transformOas2Operations = void 0;
    const t = /* @__PURE__ */ Hf(), n = /* @__PURE__ */ E2(), r = /* @__PURE__ */ uB(), i = /* @__PURE__ */ MA(), a = /* @__PURE__ */ FA(), o = /* @__PURE__ */ BA();
    function c(s, f) {
      return (0, n.transformOasEndpointOperations)(s, e.transformOas2Operation, n.OPERATION_CONFIG, void 0, f);
    }
    e.transformOas2Operations = c;
    const u = ({ document: s, name: f, method: d, config: l, ctx: p = (0, t.createContext)(s) }) => {
      const g = n.transformOasEndpointOperation.call(p, l, f, d), v = p.maybeResolveLocalRef(p.document[l.documentProp][f]), b = p.maybeResolveLocalRef(v[d]);
      return {
        ...g,
        responses: i.translateToResponses.call(p, b),
        servers: o.translateToServers.call(p, b),
        request: r.translateToRequest.call(p, v, b),
        security: a.translateToSecurities.call(p, b.security, "requirement")
      };
    };
    e.transformOas2Operation = u;
  }(Dh)), Dh;
}
var Bh = {}, il = {}, s8;
function HA() {
  if (s8) return il;
  s8 = 1, Object.defineProperty(il, "__esModule", { value: !0 }), il.transformOasService = void 0;
  const e = Yn, t = ti(), n = /* @__PURE__ */ Xn(), r = /* @__PURE__ */ Os(), i = /* @__PURE__ */ A2(), a = /* @__PURE__ */ Gi(), o = /* @__PURE__ */ NA(), c = /* @__PURE__ */ $A(), u = function() {
    var s, f, d, l, p, g, v, b;
    const y = this.document, w = String((s = y["x-stoplight"]) === null || s === void 0 ? void 0 : s.id);
    this.ids.service = w, this.parentId = w;
    const C = {
      id: w,
      version: (d = (f = y.info) === null || f === void 0 ? void 0 : f.version) !== null && d !== void 0 ? d : "",
      name: (p = (l = y.info) === null || l === void 0 ? void 0 : l.title) !== null && p !== void 0 ? p : "no-title",
      ...(0, t.pickBy)({
        description: (g = y.info) === null || g === void 0 ? void 0 : g.description,
        termsOfService: (v = y.info) === null || v === void 0 ? void 0 : v.termsOfService
      }, n.isString),
      ...(0, t.pickBy)({
        contact: (b = y.info) === null || b === void 0 ? void 0 : b.contact
      }, e.isPlainObject),
      ...(0, t.pickBy)({
        internal: y["x-internal"]
      }, n.isBoolean),
      ...(0, i.toExternalDocs)(y.externalDocs),
      extensions: (0, r.getExtensions)(y),
      infoExtensions: (0, r.getExtensions)(y.info)
    };
    (0, e.isPlainObject)(y.info) && (0, a.hasXLogo)(y.info) && (C.logo = (0, c.translateLogo)(y.info));
    const T = Array.isArray(y.tags) ? y.tags.map(o.translateTagDefinition, this).filter(n.isNonNullable) : [];
    return T.length > 0 && (C.tags = T), C;
  };
  return il.transformOasService = u, il;
}
var al = {}, u8;
function zA() {
  if (u8) return al;
  u8 = 1, Object.defineProperty(al, "__esModule", { value: !0 }), al.translateToComponents = void 0;
  const e = Yn, t = /* @__PURE__ */ Xn(), n = /* @__PURE__ */ Ci(), r = /* @__PURE__ */ Gi(), i = /* @__PURE__ */ ha(), a = /* @__PURE__ */ Uf();
  function o(u, s) {
    const f = u === "#/components" ? this.document.components : this.document;
    return (d, l) => {
      const p = s[d];
      if (p === void 0 || !(0, e.isPlainObject)(f))
        return [];
      const g = [], v = (0, n.entries)(f[d]);
      for (let b = 0; b < v.length; b++) {
        const y = v[b], [w, C] = y;
        if ((0, i.setSharedKey)(C, w), (0, r.isReferenceObject)(C)) {
          this.references[`${u}/${d}/${w}`] = {
            resolved: !0,
            value: `#/components/${l}/${g.length}`
          };
          const E = {
            ...C,
            key: w
          };
          g.push((0, i.syncReferenceObject)(E, this.references));
          continue;
        }
        const T = p.call(this, v[b], b, v);
        (0, t.isNonNullable)(T) && (this.references[`${u}/${d}/${w}`] = {
          resolved: !0,
          value: `#/components/${l}/${g.length}`
        }, T.key = w, g.push(T));
      }
      return g;
    };
  }
  const c = function(u, s) {
    const f = u === a.OasVersion.OAS3 ? "#/components" : "#", d = o.call(this, f, s);
    return {
      responses: d("responses", "responses"),
      schemas: d(u === a.OasVersion.OAS3 ? "schemas" : "definitions", "schemas"),
      requestBodies: d("requestBodies", "requestBodies"),
      examples: d("examples", "examples"),
      securitySchemes: d(u === a.OasVersion.OAS3 ? "securitySchemes" : "securityDefinitions", "securitySchemes")
    };
  };
  return al.translateToComponents = c, al;
}
var c8;
function cB() {
  return c8 || (c8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas2Service = e.bundleOas2Service = void 0;
    const t = Yn, n = ti(), r = /* @__PURE__ */ Ai(), i = /* @__PURE__ */ Xn(), a = /* @__PURE__ */ Hf(), o = /* @__PURE__ */ Gi(), c = /* @__PURE__ */ ha(), u = /* @__PURE__ */ HA(), s = /* @__PURE__ */ zA(), f = /* @__PURE__ */ Eu(), d = /* @__PURE__ */ Uf(), l = /* @__PURE__ */ Ci(), p = /* @__PURE__ */ UA(), g = /* @__PURE__ */ O2(), v = /* @__PURE__ */ MA(), b = /* @__PURE__ */ FA(), y = /* @__PURE__ */ BA(), w = function(D) {
      const $ = c.resolveRef.call(this, D);
      return D.$ref.startsWith("#/responses/") || (0, o.isValidOas2ParameterObject)($) && ($.in === "formData" || $.in === "body") ? $ : (0, c.syncReferenceObject)(D, this.references);
    }, C = ({ document: D }) => {
      const $ = (0, a.createContext)(D, w), { document: Z } = $, { securitySchemes: te, ...se } = (0, e.transformOas2Service)({ document: Z, ctx: $ }), ee = {
        ...s.translateToComponents.call($, d.OasVersion.OAS2, {
          definitions: f.translateSchemaObjectFromPair,
          securityDefinitions: E
        }),
        ...v.translateToSharedResponses.call($, Z),
        ...g.translateToSharedParameters.call($, Z),
        callbacks: []
      }, K = (0, p.transformOas2Operations)(Z, $);
      return {
        ...se,
        operations: K,
        webhooks: [],
        components: ee
      };
    };
    e.bundleOas2Service = C;
    const T = ({ document: D, ctx: $ = (0, a.createContext)(D) }) => {
      var Z;
      const te = u.transformOasService.call($);
      !((Z = D.info) === null || Z === void 0) && Z.license && (te.license = {
        ...D.info.license,
        name: D.info.license.name || ""
      });
      const ee = (Array.isArray(D.schemes) ? D.schemes.filter(i.isString) : []).map(y.translateToServer, $).filter(i.isNonNullable);
      ee.length && (te.servers = ee);
      const K = (0, l.entries)(D.securityDefinitions).map(E, $).filter(i.isNonNullable);
      K.length && (te.securitySchemes = K);
      const re = Array.isArray(D.security) ? D.security.map((de) => (0, t.isPlainObject)(de) ? Object.keys(de).map((ie) => {
        const me = K.find(($e) => $e.key === ie);
        if ((me == null ? void 0 : me.type) === "oauth2") {
          const $e = {};
          for (const Pe in me.flows) {
            const Le = me.flows[Pe];
            $e[Pe] = {
              ...Le,
              scopes: (0, n.pickBy)(Le.scopes, (Ae, He) => {
                const Te = de[ie];
                if (Te)
                  return Te.includes(He);
              })
            };
          }
          return {
            ...me,
            flows: $e
          };
        }
        return me;
      }).filter(i.isNonNullable) : null).filter(i.isNonNullable) : [];
      return re.length && (te.security = re), te;
    };
    e.transformOas2Service = T;
    const E = (0, r.withContext)(function([D, $], Z) {
      if ((0, t.isPlainObject)($))
        return b.translateToSingleSecurity.call(this, "scheme", { ...$, key: D }, Z, []);
    });
  }(Bh)), Bh;
}
var l8;
function lB() {
  return l8 || (l8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = M0;
    t.__exportStar(/* @__PURE__ */ UA(), e), t.__exportStar(/* @__PURE__ */ cB(), e);
  }(qh)), qh;
}
var f8 = /* @__PURE__ */ lB(), Uh = {}, Hh = {}, ol = {}, p8;
function GA() {
  if (p8) return ol;
  p8 = 1, Object.defineProperty(ol, "__esModule", { value: !0 }), ol.translateToCallbacks = void 0;
  const e = /* @__PURE__ */ Hf(), t = /* @__PURE__ */ Gi(), n = /* @__PURE__ */ E2(), r = /* @__PURE__ */ Ci(), i = /* @__PURE__ */ R2(), a = function(o) {
    const c = (0, r.entries)(o);
    if (c.length)
      return c.reduce((u, [s, f]) => {
        (0, t.isReferenceObject)(f) && u.push({ key: s, ...f });
        for (const [d, l] of (0, r.entries)(f))
          for (const [p, g] of (0, r.entries)(l)) {
            const v = {
              openapi: "3",
              info: { title: "", version: "1" },
              paths: { [d]: { [p]: g } }
            }, b = (0, e.createContext)(v);
            b.context = "callback", Object.assign(b.ids, this.ids), b.ids.operation = this.generateId.httpCallbackOperation({
              parentId: this.ids.service,
              method: p,
              path: d,
              key: s
            }), u.push({
              ...(0, i.transformOas3Operation)({
                document: v,
                method: p,
                name: d,
                key: s,
                config: n.OPERATION_CONFIG,
                ctx: b
              }),
              key: s
            });
          }
        return u;
      }, []);
  };
  return ol.translateToCallbacks = a, ol;
}
var zh = {}, Gh = {}, d8;
function Ou() {
  return d8 || (d8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isRequestBodyObject = e.isOAuthFlowObject = e.isResponseObject = e.isServerVariableObject = e.isServerObject = e.isHeaderObject = e.isBaseParameterObject = e.isSecurityScheme = void 0;
    const t = Yn, n = (f) => (0, t.isPlainObject)(f) && typeof f.type == "string";
    e.isSecurityScheme = n;
    const r = (f) => (0, t.isPlainObject)(f) && ("description" in f || "required" in f || "content" in f || "style" in f || "examples" in f || "example" in f || "schema" in f || "name" in f);
    e.isBaseParameterObject = r;
    const i = (f) => (0, e.isBaseParameterObject)(f);
    e.isHeaderObject = i;
    const a = (f) => (0, t.isPlainObject)(f) && typeof f.url == "string";
    e.isServerObject = a;
    const o = (f) => {
      if (!(0, t.isPlainObject)(f))
        return !1;
      const d = typeof f.default;
      return d === "string" || d === "boolean" || d === "number";
    };
    e.isServerVariableObject = o;
    const c = (f) => (0, t.isPlainObject)(f) && ("description" in f || "headers" in f || "content" in f || "links" in f);
    e.isResponseObject = c;
    const u = (f) => (0, t.isPlainObject)(f) && (0, t.isPlainObject)(f.scopes);
    e.isOAuthFlowObject = u;
    const s = (f) => (0, t.isPlainObject)(f) && (0, t.isPlainObject)(f.content);
    e.isRequestBodyObject = s;
  }(Gh)), Gh;
}
var sl = {}, ul = {}, h8;
function U0() {
  if (h8) return ul;
  h8 = 1, Object.defineProperty(ul, "__esModule", { value: !0 }), ul.translateToExample = void 0;
  const e = Yn, t = ti(), n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Xn(), i = /* @__PURE__ */ Gi(), a = /* @__PURE__ */ ha();
  return ul.translateToExample = (0, n.withContext)(function([o, c]) {
    var u;
    const s = (u = this.maybeResolveLocalRef(c)) !== null && u !== void 0 ? u : c;
    if (!(0, e.isPlainObject)(s))
      return;
    if ((0, i.isReferenceObject)(s))
      return s.key = o, s;
    const f = this.context === "service" ? (0, a.getSharedKey)(s, o) : o;
    return {
      id: this.generateId.example({ keyOrName: f }),
      key: o,
      ...typeof s.externalValue == "string" ? { externalValue: s.externalValue } : { value: s.value },
      ...(0, t.pickBy)({
        summary: s.summary,
        description: s.description
      }, r.isString)
    };
  }), ul;
}
var cl = {}, m8;
function T2() {
  if (m8) return cl;
  m8 = 1, Object.defineProperty(cl, "__esModule", { value: !0 }), cl.translateHeaderObject = void 0;
  const e = Yn, t = /* @__PURE__ */ wc(), n = ti(), r = /* @__PURE__ */ Ai(), i = /* @__PURE__ */ Xn(), a = /* @__PURE__ */ Gi(), o = /* @__PURE__ */ k2(), c = /* @__PURE__ */ zf(), u = /* @__PURE__ */ Ci(), s = /* @__PURE__ */ Ou(), f = /* @__PURE__ */ U0();
  return cl.translateHeaderObject = (0, r.withContext)(function([d, l]) {
    var p;
    const g = (p = this.maybeResolveLocalRef(l)) !== null && p !== void 0 ? p : l;
    if ((0, a.isReferenceObject)(g))
      return g.name = d, g;
    if (!(0, e.isPlainObject)(g))
      return;
    const v = this.generateId.httpHeader({ keyOrName: d, componentType: "header" });
    if (!(0, s.isHeaderObject)(g))
      return {
        id: v,
        encodings: [],
        examples: [],
        name: d,
        style: t.HttpParamStyles.Simple
      };
    const { content: b } = g, y = (0, e.isPlainObject)(b) ? Object.values(b)[0] : null, w = {
      id: v,
      name: d,
      style: t.HttpParamStyles.Simple,
      ...(0, n.pickBy)({
        schema: (0, e.isPlainObject)(g.schema) ? o.translateSchemaObject.call(this, g.schema) : null,
        content: g.content
      }, i.isNonNullable),
      ...(0, n.pickBy)({
        description: g.description
      }, i.isString),
      ...(0, n.pickBy)({
        allowEmptyValue: g.allowEmptyValue,
        allowReserved: g.allowReserved,
        explode: g.explode,
        required: g.required,
        deprecated: g.deprecated
      }, i.isBoolean)
    }, C = [], T = [];
    return (0, e.isPlainObject)(y) && (C.push(...(0, u.entries)(y.examples).map(f.translateToExample, this).filter(i.isNonNullable)), (0, e.isPlainObject)(y.encoding) && T.push(...Object.values(y.encoding)), "example" in y && C.push(c.translateToDefaultExample.call(this, "__default_content", y.example))), C.push(...(0, u.entries)(g.examples).map(f.translateToExample, this).filter(i.isNonNullable)), "example" in g && C.push(c.translateToDefaultExample.call(this, "__default", g.example)), {
      ...w,
      encodings: T,
      examples: C
    };
  }), cl;
}
var g8;
function VA() {
  if (g8) return sl;
  g8 = 1, Object.defineProperty(sl, "__esModule", { value: !0 }), sl.translateMediaTypeObject = void 0;
  const e = Yn, t = /* @__PURE__ */ wc(), n = ti(), r = /* @__PURE__ */ Ai(), i = /* @__PURE__ */ Xn(), a = /* @__PURE__ */ zf(), o = /* @__PURE__ */ Eu(), c = /* @__PURE__ */ Ci(), u = /* @__PURE__ */ U0(), s = /* @__PURE__ */ T2(), f = [
    t.HttpParamStyles.Form,
    t.HttpParamStyles.SpaceDelimited,
    t.HttpParamStyles.PipeDelimited,
    t.HttpParamStyles.DeepObject
  ];
  function d(g) {
    return typeof g.style == "string" && f.includes(g.style);
  }
  const l = (0, r.withContext)(function([g, v]) {
    if ((0, e.isPlainObject)(v) && d(v))
      return {
        property: g,
        style: v.style,
        headers: (0, c.entries)(v.headers).map(s.translateHeaderObject, this).filter(i.isNonNullable),
        ...(0, n.pickBy)({
          allowReserved: v.allowReserved,
          explode: v.explode
        }, i.isBoolean),
        ...(0, n.pickBy)({
          mediaType: v.contentType
        }, i.isString)
      };
  }), p = (0, r.withContext)(function(g) {
    if ((0, e.isPlainObject)(g))
      return o.translateSchemaObject.call(this, g);
  });
  return sl.translateMediaTypeObject = (0, r.withContext)(function([g, v]) {
    var b;
    if (!(0, e.isPlainObject)(v))
      return;
    const y = this.generateId.httpMedia({ mediaType: g }), { schema: w, encoding: C, examples: T } = v, E = p.call(this, w), D = "example" in v ? v.example : (b = E == null ? void 0 : E.examples) === null || b === void 0 ? void 0 : b[0];
    return {
      id: y,
      mediaType: g,
      examples: [
        D !== void 0 ? a.translateToDefaultExample.call(this, "default", D) : void 0,
        ...(0, c.entries)(T).map(u.translateToExample, this)
      ].filter(i.isNonNullable),
      encodings: (0, c.entries)(C).map(l, this).filter(i.isNonNullable),
      ...(0, n.pickBy)({
        schema: E
      }, i.isNonNullable)
    };
  }), sl;
}
var v8;
function P2() {
  return v8 || (v8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToRequest = e.translateParameterObject = e.translateRequestBody = e.translateToSharedRequestBody = void 0;
    const t = Yn, n = /* @__PURE__ */ wc(), r = ti(), i = /* @__PURE__ */ Ai(), a = /* @__PURE__ */ Xn(), o = /* @__PURE__ */ F0(), c = /* @__PURE__ */ Os(), u = /* @__PURE__ */ Gi(), s = /* @__PURE__ */ ha(), f = /* @__PURE__ */ zf(), d = /* @__PURE__ */ Eu(), l = /* @__PURE__ */ Ci(), p = /* @__PURE__ */ Ou(), g = /* @__PURE__ */ VA(), v = /* @__PURE__ */ U0();
    e.translateToSharedRequestBody = (0, i.withContext)(function([w, C]) {
      const T = this.maybeResolveLocalRef(C);
      return (0, u.isReferenceObject)(T) ? (T.key = w, T) : e.translateRequestBody.call(this, w, T);
    }), e.translateRequestBody = (0, i.withContext)(function(w, C) {
      var T;
      const E = (T = this.maybeResolveLocalRef(C)) !== null && T !== void 0 ? T : C;
      return (0, u.isReferenceObject)(E) ? E : (0, p.isRequestBodyObject)(E) ? {
        id: this.generateId.httpRequestBody({
          key: this.context === "service" ? (0, s.getSharedKey)(E, w) : w
        }),
        contents: (0, l.entries)(E.content).map(g.translateMediaTypeObject, this).filter(a.isNonNullable),
        ...(0, r.pickBy)({
          required: E.required
        }, a.isBoolean),
        ...(0, r.pickBy)({
          description: E.description
        }, a.isString)
      } : void 0;
    });
    const b = (0, i.withContext)(function(w) {
      if ((0, t.isPlainObject)(w.schema))
        return d.translateSchemaObject.call(this, {
          ...w.schema,
          ..."example" in w ? { example: w.example } : null
        });
    });
    e.translateParameterObject = (0, i.withContext)(function(w) {
      this.context === "path" && (this.context = "operation", this.parentId = this.ids.operation);
      const C = w.in === "path" ? "pathParam" : w.in, T = w.name, E = (0, s.getSharedKey)(w, T), D = this.generateId[`http${C[0].toUpperCase()}${C.slice(1)}`]({ keyOrName: E, componentType: "parameter" }), $ = b.call(this, w), Z = (0, l.entries)(w.examples).map(v.translateToExample, this).filter(a.isNonNullable), te = Z.some((se) => !(0, u.isReferenceObject)(se) && se.key.includes("default"));
      return {
        id: D,
        name: T,
        style: (0, u.isValidOas3ParamStyle)(w.style) ? w.style : w.in === "query" || w.in === "cookie" ? n.HttpParamStyles.Form : n.HttpParamStyles.Simple,
        examples: [
          !te && w.example !== void 0 ? f.translateToDefaultExample.call(this, "default", w.example) : void 0,
          ...Z
        ].filter(a.isNonNullable),
        ...(0, r.pickBy)({
          description: w.description
        }, a.isString),
        ...(0, r.pickBy)({
          deprecated: w.deprecated,
          required: w.required,
          explode: w.explode,
          allowEmptyValue: w.allowEmptyValue,
          allowReserved: w.allowReserved
        }, a.isBoolean),
        ...(0, r.pickBy)({
          schema: $,
          content: w.content
        }, t.isPlainObject),
        explicitProperties: (0, l.collectExplicitProperties)(w)
      };
    });
    const y = (0, c.createOasParamsIterator)(o.OasVersion.OAS3);
    e.translateToRequest = (0, i.withContext)(function(w, C) {
      var T;
      const E = {
        header: [],
        query: [],
        cookie: [],
        path: [],
        unknown: []
      };
      for (const $ of y.call(this, w, C)) {
        let Z;
        (0, u.isReferenceObject)($) ? Z = (T = (0, s.getComponentName)(this.references, $.$ref)) !== null && T !== void 0 ? T : "" : Z = $.in, ["parameters", "unknownParameters"].includes(Z) && (Z = "unknown");
        const te = E[Z || "unknown"];
        Array.isArray(te) && ((0, u.isReferenceObject)($) ? te.push((0, s.syncReferenceObject)($, this.references)) : te.push(e.translateParameterObject.call(this, $)));
      }
      const D = {
        ...(0, r.pickBy)({
          body: e.translateRequestBody.call(this, void 0, C == null ? void 0 : C.requestBody)
        }, a.isNonNullable),
        headers: E.header,
        query: E.query,
        cookie: E.cookie,
        path: E.path,
        unknown: E.unknown
      };
      return D.unknown && !D.unknown.length && delete D.unknown, D;
    });
  }(zh)), zh;
}
var Vh = {}, y8;
function WA() {
  return y8 || (y8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToResponses = e.translateToResponse = void 0;
    const t = ti(), n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Xn(), i = /* @__PURE__ */ Gi(), a = /* @__PURE__ */ ha(), o = /* @__PURE__ */ Ci(), c = /* @__PURE__ */ Ou(), u = /* @__PURE__ */ VA(), s = /* @__PURE__ */ T2();
    e.translateToResponse = (0, n.withContext)(function([d, l]) {
      var p;
      const g = (p = this.maybeResolveLocalRef(l)) !== null && p !== void 0 ? p : l;
      if ((0, i.isReferenceObject)(g))
        return g.code = d, g;
      if (!(0, c.isResponseObject)(g))
        return;
      const v = this.context === "service" ? (0, a.getSharedKey)(g, d) : d;
      return {
        id: this.generateId.httpResponse({ codeOrKey: v }),
        code: d,
        headers: (0, o.entries)(g.headers).map(s.translateHeaderObject, this).filter(r.isNonNullable),
        contents: (0, o.entries)(g.content).map(u.translateMediaTypeObject, this).filter(r.isNonNullable),
        ...(0, t.pickBy)({
          description: g.description
        }, r.isString)
      };
    });
    const f = function(d) {
      return (0, o.entries)(d).map(e.translateToResponse, this).filter(r.isNonNullable);
    };
    e.translateToResponses = f;
  }(Vh)), Vh;
}
var Wh = {}, Hs = {}, b8;
function fB() {
  if (b8) return Hs;
  b8 = 1, Object.defineProperty(Hs, "__esModule", { value: !0 }), Hs.getScopeKeys = Hs.getSecurities = void 0;
  const e = Yn, t = ti(), n = /* @__PURE__ */ Xn(), r = /* @__PURE__ */ Os(), i = /* @__PURE__ */ Ci(), a = /* @__PURE__ */ Ou();
  function o(u, s) {
    var f;
    const d = (f = u.components) === null || f === void 0 ? void 0 : f.securitySchemes;
    return (0, e.isPlainObject)(d) ? (Array.isArray(s) ? s : u.security || []).map((l) => (0, i.entries)(l).map(([p, g]) => {
      const v = d[p];
      if (!(0, a.isSecurityScheme)(v))
        return;
      if (v.type === "oauth2")
        return [
          p,
          {
            ...v,
            flows: Object.fromEntries((0, i.entries)(v.flows).map(([y, w]) => [
              y,
              {
                ...w,
                scopes: (0, t.pickBy)(w == null ? void 0 : w.scopes, (C, T) => g == null ? void 0 : g.includes(T))
              }
            ])),
            extensions: (0, r.getExtensions)(v)
          }
        ];
      const b = g != null && g.length ? { "x-scopes": g } : {};
      return [
        p,
        {
          ...v,
          ...b,
          extensions: (0, r.getExtensions)({ ...v, ...b })
        }
      ];
    }).filter(n.isNonNullable)) : [];
  }
  Hs.getSecurities = o;
  function c(u) {
    if (!u.flows)
      return;
    const s = [];
    function f(d, l) {
      var p;
      for (const g of Object.keys((p = l == null ? void 0 : l.scopes) !== null && p !== void 0 ? p : {}))
        s.push(`${d}::${g}`);
    }
    return f("implicit", u.flows.implicit), f("password", u.flows.password), f("clientCredentials", u.flows.clientCredentials), f("authorizationCode", u.flows.authorizationCode), s;
  }
  return Hs.getScopeKeys = c, Hs;
}
var x8;
function KA() {
  return x8 || (x8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateToSingleSecurity = e.translateToSecurities = void 0;
    const t = Yn, n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Xn(), i = /* @__PURE__ */ Os(), a = /* @__PURE__ */ fB(), o = /* @__PURE__ */ Ou(), c = function(s, f) {
      return this.context = "service", (0, a.getSecurities)(this.document, s).map((l) => l.map(e.translateToSingleSecurity.bind(this, f)).filter(r.isNonNullable));
    };
    e.translateToSecurities = c, e.translateToSingleSecurity = (0, n.withContext)(function(s, [f, d], l) {
      var p, g;
      const v = {
        id: this.generateId.httpSecurity({
          keyOrName: f,
          kind: s,
          ...s === "requirement" ? {
            index: l,
            scopeKeys: (0, a.getScopeKeys)(d)
          } : {}
        }),
        key: f,
        extensions: (0, i.getExtensions)(d)
      };
      if (d.description && (v.description = d.description), d.type === "apiKey")
        return {
          ...v,
          type: "apiKey",
          name: d.name,
          in: d.in
        };
      if (d.type === "http")
        return ((p = d.scheme) === null || p === void 0 ? void 0 : p.toLowerCase()) === "bearer" ? {
          ...v,
          type: "http",
          scheme: "bearer",
          bearerFormat: d.bearerFormat
        } : {
          ...v,
          type: "http",
          scheme: (g = d.scheme) === null || g === void 0 ? void 0 : g.toLowerCase()
        };
      if (d.type === "oauth2")
        return {
          ...v,
          type: "oauth2",
          flows: u(d.flows)
        };
      if (d.type === "openIdConnect")
        return {
          ...v,
          type: "openIdConnect",
          openIdConnectUrl: d.openIdConnectUrl
        };
      if (d.type === "mutualTLS")
        return {
          ...v,
          type: "mutualTLS"
        };
    });
    function u(s) {
      const f = {};
      return (0, t.isPlainObject)(s) && ((0, o.isOAuthFlowObject)(s.password) && typeof s.password.tokenUrl == "string" && (f.password = {
        ...typeof s.password.refreshUrl == "string" && { refreshUrl: s.password.refreshUrl },
        tokenUrl: s.password.tokenUrl,
        scopes: s.password.scopes
      }), (0, o.isOAuthFlowObject)(s.implicit) && typeof s.implicit.authorizationUrl == "string" && (f.implicit = {
        ...typeof s.implicit.refreshUrl == "string" && { refreshUrl: s.implicit.refreshUrl },
        authorizationUrl: s.implicit.authorizationUrl,
        scopes: s.implicit.scopes
      }), (0, o.isOAuthFlowObject)(s.authorizationCode) && typeof s.authorizationCode.authorizationUrl == "string" && typeof s.authorizationCode.tokenUrl == "string" && (f.authorizationCode = {
        ...typeof s.authorizationCode.refreshUrl == "string" && { refreshUrl: s.authorizationCode.refreshUrl },
        authorizationUrl: s.authorizationCode.authorizationUrl,
        scopes: s.authorizationCode.scopes,
        tokenUrl: s.authorizationCode.tokenUrl
      }), (0, o.isOAuthFlowObject)(s.clientCredentials) && typeof s.clientCredentials.tokenUrl == "string" && (f.clientCredentials = {
        ...typeof s.clientCredentials.refreshUrl == "string" && { refreshUrl: s.clientCredentials.refreshUrl },
        scopes: s.clientCredentials.scopes,
        tokenUrl: s.clientCredentials.tokenUrl
      })), f;
    }
  }(Wh)), Wh;
}
var Kh = {}, _8;
function ZA() {
  return _8 || (_8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.translateServerVariables = e.translateToServer = e.translateToServers = void 0;
    const t = ti(), n = /* @__PURE__ */ Ai(), r = /* @__PURE__ */ Xn(), i = /* @__PURE__ */ Ci(), a = /* @__PURE__ */ Ou();
    e.translateToServers = (0, n.withContext)(function(u, s) {
      let f;
      if (Array.isArray(s.servers))
        f = s.servers;
      else if (Array.isArray(u.servers))
        f = u.servers, this.context = "path";
      else if (Array.isArray(this.document.servers))
        f = this.document.servers, this.context = "service";
      else
        return [];
      return f.map(e.translateToServer, this).filter(r.isNonNullable);
    }), e.translateToServer = (0, n.withContext)(function(u) {
      var s;
      if (!(0, a.isServerObject)(u))
        return;
      const f = e.translateServerVariables.call(this, u.variables);
      return {
        id: this.generateId.httpServer({ url: u.url }),
        url: u.url,
        ...(0, t.pickBy)({
          name: (s = this.document.info) === null || s === void 0 ? void 0 : s.title,
          description: u.description
        }, r.isString),
        ...(0, t.pickBy)({
          variables: f
        }, r.isNonNullable)
      };
    });
    const o = (u) => {
      const s = (0, i.entries)(u).map(c).filter(r.isNonNullable);
      return s.length > 0 ? Object.fromEntries(s) : void 0;
    };
    e.translateServerVariables = o;
    const c = function([u, s]) {
      if ((0, a.isServerVariableObject)(s))
        return [
          u,
          {
            default: String(s.default),
            ...(0, t.pickBy)({
              description: s.description
            }, r.isString),
            ...(0, t.pickBy)({
              enum: Array.isArray(s.enum) ? s.enum.map(String) : void 0
            }, r.isNonNullable)
          }
        ];
    };
  }(Kh)), Kh;
}
var w8;
function R2() {
  return w8 || (w8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas3Operation = e.transformOas3WebhookOperations = e.transformOas3Operations = void 0;
    const t = ti(), n = /* @__PURE__ */ Xn(), r = /* @__PURE__ */ F0(), i = /* @__PURE__ */ Hf(), a = /* @__PURE__ */ GA(), o = /* @__PURE__ */ P2(), c = /* @__PURE__ */ WA(), u = /* @__PURE__ */ KA(), s = /* @__PURE__ */ ZA();
    function f(p, g) {
      return (0, r.transformOasEndpointOperations)(p, e.transformOas3Operation, r.OPERATION_CONFIG, void 0, g);
    }
    e.transformOas3Operations = f;
    function d(p, g) {
      return (0, r.transformOasEndpointOperations)(p, e.transformOas3Operation, r.WEBHOOK_CONFIG, void 0, g);
    }
    e.transformOas3WebhookOperations = d;
    const l = ({ document: p, name: g, method: v, config: b, key: y, ctx: w = (0, i.createContext)(p) }) => {
      const C = r.transformOasEndpointOperation.call(w, b, g, v, y), T = w.maybeResolveLocalRef(w.document[b.documentProp][g]), E = w.maybeResolveLocalRef(T[v]);
      return {
        ...C,
        responses: c.translateToResponses.call(w, E.responses),
        request: o.translateToRequest.call(w, T, E),
        security: u.translateToSecurities.call(w, E.security, "requirement"),
        servers: s.translateToServers.call(w, T, E),
        ...(0, t.pickBy)({
          callbacks: a.translateToCallbacks.call(w, E.callbacks)
        }, n.isNonNullable)
      };
    };
    e.transformOas3Operation = l;
  }(Hh)), Hh;
}
var Zh = {}, ll = {}, S8;
function pB() {
  if (S8) return ll;
  S8 = 1, Object.defineProperty(ll, "__esModule", { value: !0 }), ll.translateToSharedParameters = void 0;
  const e = Yn, t = /* @__PURE__ */ Ai(), n = /* @__PURE__ */ Xn(), r = /* @__PURE__ */ Gi(), i = /* @__PURE__ */ ha(), a = /* @__PURE__ */ Ci(), o = /* @__PURE__ */ T2(), c = /* @__PURE__ */ P2();
  return ll.translateToSharedParameters = (0, t.withContext)(function(u) {
    const s = {
      header: [],
      query: [],
      cookie: [],
      path: [],
      unknownParameters: []
    };
    if (!(0, e.isPlainObject)(u))
      return s;
    for (const [d, l] of (0, a.entries)(u.headers)) {
      (0, i.setSharedKey)(l, d), this.references[`#/components/headers/${d}`] = {
        resolved: !0,
        value: `#/components/header/${s.header.length}`
      };
      const p = o.translateHeaderObject.call(this, [d, l]);
      (0, n.isNonNullable)(p) && s.header.push({
        ...p,
        key: d
      });
    }
    const f = [];
    for (const [d, l] of (0, a.entries)(u.parameters)) {
      if ((0, i.setSharedKey)(l, d), (0, r.isReferenceObject)(l)) {
        (0, e.isLocalRef)(l.$ref) ? this.references[`#/components/parameters/${d}`] = {
          resolved: !1,
          value: l.$ref
        } : (this.references[`#/components/parameters/${d}`] = {
          resolved: !0,
          value: `#/components/unknownParameters/${s.unknownParameters.length}`
        }, s.unknownParameters.push({
          ...l,
          key: d
        })), f.push((0, i.syncReferenceObject)({
          ...l,
          key: d
        }, this.references));
        continue;
      }
      if (!(0, r.isValidOas3ParameterObject)(l))
        continue;
      const p = c.translateParameterObject.call(this, l);
      this.references[`#/components/parameters/${d}`] = {
        resolved: !0,
        value: `#/components/${l.in}/${s[l.in].length}`
      }, s[l.in].push({
        ...p,
        key: d
      });
    }
    for (const d of f) {
      const l = (0, i.getComponentName)(this.references, d.$ref);
      l && l !== "unknownParameters" && l in s && s[l].push(d);
    }
    return s;
  }), ll;
}
var C8;
function dB() {
  return C8 || (C8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.transformOas3Service = e.bundleOas3Service = void 0;
    const t = Yn, n = ti(), r = /* @__PURE__ */ Ai(), i = /* @__PURE__ */ Xn(), a = /* @__PURE__ */ Hf(), o = /* @__PURE__ */ ha(), c = /* @__PURE__ */ HA(), u = /* @__PURE__ */ zA(), s = /* @__PURE__ */ Eu(), f = /* @__PURE__ */ Uf(), d = /* @__PURE__ */ Ci(), l = /* @__PURE__ */ Ou(), p = /* @__PURE__ */ R2(), g = /* @__PURE__ */ GA(), v = /* @__PURE__ */ U0(), b = /* @__PURE__ */ pB(), y = /* @__PURE__ */ P2(), w = /* @__PURE__ */ WA(), C = /* @__PURE__ */ KA(), T = /* @__PURE__ */ ZA(), E = ({ document: Z }) => {
      var te;
      const se = (0, a.createContext)(Z, o.bundleResolveRef), { document: ee } = se, { securitySchemes: K, ...re } = (0, e.transformOas3Service)({ document: ee, ctx: se }), de = {
        ...u.translateToComponents.call(se, f.OasVersion.OAS3, {
          responses: w.translateToResponse,
          requestBodies: y.translateToSharedRequestBody,
          examples: v.translateToExample,
          schemas: s.translateSchemaObjectFromPair,
          securitySchemes: $
        }),
        callbacks: (te = g.translateToCallbacks.call(se, ee.components ? ee.components.callbacks : [])) !== null && te !== void 0 ? te : [],
        ...b.translateToSharedParameters.call(se, ee.components)
      }, ie = (0, p.transformOas3Operations)(ee, se), me = (0, p.transformOas3WebhookOperations)(ee, se);
      return {
        ...re,
        operations: ie,
        webhooks: me,
        components: de
      };
    };
    e.bundleOas3Service = E;
    const D = ({ document: Z, ctx: te = (0, a.createContext)(Z) }) => {
      var se, ee, K;
      const { document: re } = te, de = c.transformOasService.call(te);
      if (typeof ((se = re.info) === null || se === void 0 ? void 0 : se.summary) == "string" && (de.summary = re.info.summary), !((ee = re.info) === null || ee === void 0) && ee.license) {
        const { name: Pe, identifier: Le, ...Ae } = re.info.license;
        de.license = {
          ...Ae,
          name: typeof Pe == "string" ? Pe : "",
          ...typeof Le == "string" && { identifier: Le }
        };
      }
      const ie = Array.isArray(re.servers) ? re.servers.map(T.translateToServer, te).filter(i.isNonNullable) : [];
      ie.length && (de.servers = ie);
      const me = (0, d.entries)((K = re.components) === null || K === void 0 ? void 0 : K.securitySchemes).map($, te).filter(i.isNonNullable);
      me.length && (de.securitySchemes = me);
      const $e = (Array.isArray(re.security) ? re.security : []).map((Pe) => (0, t.isPlainObject)(Pe) ? Object.keys(Pe).map((Le) => {
        const Ae = me.find((He) => He.key === Le);
        if ((Ae == null ? void 0 : Ae.type) === "oauth2") {
          const He = {};
          for (const Te in Ae.flows) {
            const we = Ae.flows[Te];
            He[Te] = {
              ...we,
              scopes: (0, n.pickBy)(we.scopes, (qe, Ge) => {
                const It = Pe[Le];
                return It ? It.includes(Ge) : !1;
              })
            };
          }
          return {
            ...Ae,
            flows: He
          };
        }
        return Ae;
      }).filter(i.isNonNullable) : null).filter(i.isNonNullable);
      return $e.length && (de.security = $e), de;
    };
    e.transformOas3Service = D;
    const $ = (0, r.withContext)(function([Z, te], se) {
      if ((0, l.isSecurityScheme)(te))
        return C.translateToSingleSecurity.call(this, "scheme", [Z, te], se, []);
    });
  }(Zh)), Zh;
}
var A8;
function hB() {
  return A8 || (A8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = M0;
    t.__exportStar(/* @__PURE__ */ R2(), e), t.__exportStar(/* @__PURE__ */ dB(), e);
  }(Uh)), Uh;
}
var nd = /* @__PURE__ */ hB(), _i = /* @__PURE__ */ ((e) => (e.Paths = "paths", e.Path = "path", e.Operation = "operation", e.Webhooks = "webhooks", e.Webhook = "webhook", e.Components = "components", e.Models = "models", e.Model = "model", e))(_i || {}), df = /* @__PURE__ */ ((e) => (e.OAS2 = "OAS 2.0", e.OAS3 = "OAS 3.0", e.OAS31 = "OAS 3.1", e.ASYNC = "ASYNC", e))(df || {});
const mB = [
  {
    match: "paths",
    type: _i.Paths,
    children: [
      {
        notMatch: "^x-",
        type: _i.Path,
        children: [
          {
            match: "get|post|put|delete|options|head|patch|trace",
            type: _i.Operation
          }
        ]
      }
    ]
  },
  {
    match: "definitions",
    type: _i.Models,
    children: [
      {
        notMatch: "^x-",
        type: _i.Model
      }
    ]
  }
], k8 = [
  {
    match: "paths",
    type: _i.Paths,
    children: [
      {
        notMatch: "^x-",
        type: _i.Path,
        children: [
          {
            match: "get|post|put|delete|options|head|patch|trace",
            type: _i.Operation
          }
        ]
      }
    ]
  },
  {
    match: "webhooks",
    type: _i.Webhooks,
    children: [
      {
        notMatch: "^x-",
        type: _i.Webhook,
        children: [
          {
            match: "get|post|put|delete|options|head|patch|trace",
            type: _i.Webhook
          }
        ]
      }
    ]
  },
  {
    match: "components",
    type: _i.Components,
    children: [
      {
        match: "schemas",
        type: _i.Models,
        children: [
          {
            notMatch: "^x-",
            type: _i.Model
          }
        ]
      }
    ]
  }
], gB = (e) => ea(e) && "swagger" in e && Number.parseInt(String(e.swagger)) === 2, vB = (e) => ea(e) && "openapi" in e && Number.parseFloat(String(e.openapi)) >= 3, yB = (e) => ea(e) && "openapi" in e && Number.parseFloat(String(e.openapi)) === 3.1, bB = /((definitions|components)\/?(schemas)?)\//;
function xB(e) {
  if (yB(e))
    return Yh(
      { ...e, jsonSchemaDialect: "http://json-schema.org/draft-07/schema#" },
      k8,
      nd.transformOas3Service,
      nd.transformOas3Operation,
      df.OAS31
    );
  if (vB(e))
    return Yh(
      e,
      k8,
      nd.transformOas3Service,
      nd.transformOas3Operation,
      df.OAS3
    );
  if (gB(e))
    return Yh(
      e,
      mB,
      f8.transformOas2Service,
      f8.transformOas2Operation,
      df.OAS2
    );
}
function Yh(e, t, n, r, i) {
  var c;
  const a = n({ document: e });
  return {
    type: ji.HttpService,
    uri: "/",
    name: a.name,
    data: a,
    tags: ((c = a.tags) == null ? void 0 : c.map((u) => u.name)) || [],
    children: YA(e, e, t, r),
    specVersion: i
  };
}
function YA(e, t, n, r, i = "") {
  var o, c;
  const a = [];
  if (!ea(t)) return a;
  for (const u of Object.keys(t)) {
    const s = pf(u), f = _B(s, n);
    if (f) {
      const d = `${i}/${s}`, l = Ra(`#${d}`);
      if (f.type === _i.Operation && l.length === 3) {
        const p = String(l[1]), g = String(l[2]), v = r({
          document: e,
          name: p,
          method: g,
          config: Kb.OPERATION_CONFIG
        });
        let b;
        const y = String(pf(p));
        v.iid ? b = `/operations/${v.iid}` : b = d.replace(y, t0(p)), a.push({
          type: ji.HttpOperation,
          uri: b,
          data: v,
          name: v.summary || v.iid || v.path,
          tags: ((o = v.tags) == null ? void 0 : o.map((w) => w.name)) || []
        });
      } else if (f.type === _i.Webhook && l.length === 3) {
        const p = String(l[1]), g = String(l[2]), v = r({
          document: e,
          name: p,
          method: g,
          config: Kb.WEBHOOK_CONFIG
        });
        let b;
        const y = String(pf(p));
        v.iid ? b = `/webhooks/${v.iid}` : b = d.replace(y, t0(p)), a.push({
          type: ji.HttpWebhook,
          uri: b,
          data: v,
          name: v.summary || v.name,
          tags: ((c = v.tags) == null ? void 0 : c.map((w) => w.name)) || []
        });
      } else if (f.type === _i.Model) {
        const p = _M(e, l), g = d.replace(bB, "schemas/");
        a.push({
          type: ji.Model,
          uri: g,
          data: p,
          name: p.title || PM(d.split("/")) || "",
          tags: p["x-tags"] || []
        });
      }
      f.children && a.push(...YA(e, t[u], f.children, r, d));
    }
  }
  return a;
}
function _B(e, t) {
  var n;
  if (typeof e != "number")
    for (const r of t) {
      const i = e.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
      if ((n = r.match) != null && n.match(i) || r.notMatch !== void 0 && !r.notMatch.match(i))
        return r;
    }
}
var Jh = {}, id = {}, fl = {}, Qh = {}, Ua = {}, Xh = {}, E8;
function H0() {
  return E8 || (E8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    var t;
    (function(u) {
      u[u.SCALAR = 0] = "SCALAR", u[u.MAPPING = 1] = "MAPPING", u[u.MAP = 2] = "MAP", u[u.SEQ = 3] = "SEQ", u[u.ANCHOR_REF = 4] = "ANCHOR_REF", u[u.INCLUDE_REF = 5] = "INCLUDE_REF";
    })(t = e.Kind || (e.Kind = {}));
    function n(u, s) {
      var f = s ? s.endPosition : u.endPosition + 1, d = {
        key: u,
        value: s,
        startPosition: u.startPosition,
        endPosition: f,
        kind: t.MAPPING,
        parent: null,
        errors: []
      };
      return d;
    }
    e.newMapping = n;
    function r(u, s, f, d) {
      return {
        errors: [],
        referencesAnchor: u,
        value: d,
        startPosition: s,
        endPosition: f,
        kind: t.ANCHOR_REF,
        parent: null
      };
    }
    e.newAnchorRef = r;
    function i(u = "") {
      const s = {
        errors: [],
        startPosition: -1,
        endPosition: -1,
        value: "" + u,
        kind: t.SCALAR,
        parent: null,
        doubleQuoted: !1,
        rawValue: "" + u
      };
      return typeof u != "string" && (s.valueObject = u), s;
    }
    e.newScalar = i;
    function a() {
      return {
        errors: [],
        startPosition: -1,
        endPosition: -1,
        items: [],
        kind: t.SEQ,
        parent: null
      };
    }
    e.newItems = a;
    function o() {
      return a();
    }
    e.newSeq = o;
    function c(u) {
      return {
        errors: [],
        startPosition: -1,
        endPosition: -1,
        mappings: u || [],
        kind: t.MAP,
        parent: null
      };
    }
    e.newMap = c;
  }(Xh)), Xh;
}
var Do = {}, O8;
function Cc() {
  if (O8) return Do;
  O8 = 1, Object.defineProperty(Do, "__esModule", { value: !0 });
  function e(o) {
    return typeof o > "u" || o === null;
  }
  Do.isNothing = e;
  function t(o) {
    return typeof o == "object" && o !== null;
  }
  Do.isObject = t;
  function n(o) {
    return Array.isArray(o) ? o : e(o) ? [] : [o];
  }
  Do.toArray = n;
  function r(o, c) {
    var u, s, f, d;
    if (c)
      for (d = Object.keys(c), u = 0, s = d.length; u < s; u += 1)
        f = d[u], o[f] = c[f];
    return o;
  }
  Do.extend = r;
  function i(o, c) {
    var u = "", s;
    for (s = 0; s < c; s += 1)
      u += o;
    return u;
  }
  Do.repeat = i;
  function a(o) {
    return o === 0 && Number.NEGATIVE_INFINITY === 1 / o;
  }
  return Do.isNegativeZero = a, Do;
}
var e5, T8;
function Gf() {
  if (T8) return e5;
  T8 = 1;
  class e {
    constructor(n, r = null, i = !1) {
      this.name = "YAMLException", this.reason = n, this.mark = r, this.message = this.toString(!1), this.isWarning = i;
    }
    static isInstance(n) {
      if (n != null && n.getClassIdentifier && typeof n.getClassIdentifier == "function") {
        for (let r of n.getClassIdentifier())
          if (r == e.CLASS_IDENTIFIER)
            return !0;
      }
      return !1;
    }
    getClassIdentifier() {
      var n = [];
      return n.concat(e.CLASS_IDENTIFIER);
    }
    toString(n = !1) {
      var r;
      return r = "JS-YAML: " + (this.reason || "(unknown reason)"), !n && this.mark && (r += " " + this.mark.toString()), r;
    }
  }
  return e.CLASS_IDENTIFIER = "yaml-ast-parser.YAMLException", e5 = e, e5;
}
var t5, P8;
function wB() {
  if (P8) return t5;
  P8 = 1;
  const e = Cc();
  class t {
    constructor(r, i, a, o, c) {
      this.name = r, this.buffer = i, this.position = a, this.line = o, this.column = c;
    }
    getSnippet(r = 0, i = 75) {
      var a, o, c, u, s;
      if (!this.buffer)
        return null;
      for (r = r || 4, i = i || 75, a = "", o = this.position; o > 0 && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(o - 1)) === -1; )
        if (o -= 1, this.position - o > i / 2 - 1) {
          a = " ... ", o += 5;
          break;
        }
      for (c = "", u = this.position; u < this.buffer.length && `\0\r
\u2028\u2029`.indexOf(this.buffer.charAt(u)) === -1; )
        if (u += 1, u - this.position > i / 2 - 1) {
          c = " ... ", u -= 5;
          break;
        }
      return s = this.buffer.slice(o, u), e.repeat(" ", r) + a + s + c + `
` + e.repeat(" ", r + this.position - o + a.length) + "^";
    }
    toString(r = !0) {
      var i, a = "";
      return this.name && (a += 'in "' + this.name + '" '), a += "at line " + (this.line + 1) + ", column " + (this.column + 1), r || (i = this.getSnippet(), i && (a += `:
` + i)), a;
    }
  }
  return t5 = t, t5;
}
var ad = {}, od = {}, R8;
function Ni() {
  if (R8) return od;
  R8 = 1, Object.defineProperty(od, "__esModule", { value: !0 });
  const e = Gf();
  var t = [
    "kind",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "defaultStyle",
    "styleAliases"
  ], n = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function r(a) {
    var o = {};
    return a !== null && Object.keys(a).forEach(function(c) {
      a[c].forEach(function(u) {
        o[String(u)] = c;
      });
    }), o;
  }
  class i {
    constructor(o, c) {
      if (c = c || {}, Object.keys(c).forEach(function(u) {
        if (t.indexOf(u) === -1)
          throw new e('Unknown option "' + u + '" is met in definition of "' + o + '" YAML type.');
      }), this.tag = o, this.kind = c.kind || null, this.resolve = c.resolve || function() {
        return !0;
      }, this.construct = c.construct || function(u) {
        return u;
      }, this.instanceOf = c.instanceOf || null, this.predicate = c.predicate || null, this.represent = c.represent || null, this.defaultStyle = c.defaultStyle || null, this.styleAliases = r(c.styleAliases || null), n.indexOf(this.kind) === -1)
        throw new e('Unknown kind "' + this.kind + '" is specified for "' + o + '" YAML type.');
    }
  }
  return od.Type = i, od;
}
var j8;
function Vf() {
  if (j8) return ad;
  j8 = 1, Object.defineProperty(ad, "__esModule", { value: !0 });
  const e = Cc(), t = Gf(), n = Ni();
  function r(o, c, u) {
    var s = [];
    return o.include.forEach(function(f) {
      u = r(f, c, u);
    }), o[c].forEach(function(f) {
      u.forEach(function(d, l) {
        d.tag === f.tag && s.push(l);
      }), u.push(f);
    }), u.filter(function(f, d) {
      return s.indexOf(d) === -1;
    });
  }
  function i() {
    var o = {}, c, u;
    function s(f) {
      o[f.tag] = f;
    }
    for (c = 0, u = arguments.length; c < u; c += 1)
      arguments[c].forEach(s);
    return o;
  }
  class a {
    constructor(c) {
      this.include = c.include || [], this.implicit = c.implicit || [], this.explicit = c.explicit || [], this.implicit.forEach(function(u) {
        if (u.loadKind && u.loadKind !== "scalar")
          throw new t("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
      }), this.compiledImplicit = r(this, "implicit", []), this.compiledExplicit = r(this, "explicit", []), this.compiledTypeMap = i(this.compiledImplicit, this.compiledExplicit);
    }
  }
  return ad.Schema = a, a.DEFAULT = null, a.create = function() {
    var c, u;
    switch (arguments.length) {
      case 1:
        c = a.DEFAULT, u = arguments[0];
        break;
      case 2:
        c = arguments[0], u = arguments[1];
        break;
      default:
        throw new t("Wrong number of arguments for Schema.create function");
    }
    if (c = e.toArray(c), u = e.toArray(u), !c.every(function(s) {
      return s instanceof a;
    }))
      throw new t("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
    if (!u.every(function(s) {
      return s instanceof n.Type;
    }))
      throw new t("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    return new a({
      include: c,
      explicit: u
    });
  }, ad;
}
var r5, I8;
function SB() {
  if (I8) return r5;
  I8 = 1;
  const e = Ni();
  return r5 = new e.Type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(t) {
      return t !== null ? t : "";
    }
  }), r5;
}
var n5, q8;
function CB() {
  if (q8) return n5;
  q8 = 1;
  const e = Ni();
  return n5 = new e.Type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(t) {
      return t !== null ? t : [];
    }
  }), n5;
}
var i5, D8;
function AB() {
  if (D8) return i5;
  D8 = 1;
  const e = Ni();
  return i5 = new e.Type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(t) {
      return t !== null ? t : {};
    }
  }), i5;
}
var a5, L8;
function kB() {
  if (L8) return a5;
  L8 = 1;
  const e = Vf();
  return a5 = new e.Schema({
    explicit: [
      SB(),
      CB(),
      AB()
    ]
  }), a5;
}
var o5, N8;
function EB() {
  if (N8) return o5;
  N8 = 1;
  const e = Ni();
  function t(i) {
    if (i === null)
      return !0;
    var a = i.length;
    return a === 1 && i === "~" || a === 4 && (i === "null" || i === "Null" || i === "NULL");
  }
  function n() {
    return null;
  }
  function r(i) {
    return i === null;
  }
  return o5 = new e.Type("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      }
    },
    defaultStyle: "lowercase"
  }), o5;
}
var s5, $8;
function OB() {
  if ($8) return s5;
  $8 = 1;
  const e = Ni();
  function t(i) {
    if (i === null)
      return !1;
    var a = i.length;
    return a === 4 && (i === "true" || i === "True" || i === "TRUE") || a === 5 && (i === "false" || i === "False" || i === "FALSE");
  }
  function n(i) {
    return i === "true" || i === "True" || i === "TRUE";
  }
  function r(i) {
    return Object.prototype.toString.call(i) === "[object Boolean]";
  }
  return s5 = new e.Type("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      lowercase: function(i) {
        return i ? "true" : "false";
      },
      uppercase: function(i) {
        return i ? "TRUE" : "FALSE";
      },
      camelcase: function(i) {
        return i ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  }), s5;
}
var u5, M8;
function TB() {
  if (M8) return u5;
  M8 = 1;
  const e = Cc(), t = Ni();
  function n(u) {
    return 48 <= u && u <= 57 || 65 <= u && u <= 70 || 97 <= u && u <= 102;
  }
  function r(u) {
    return 48 <= u && u <= 55;
  }
  function i(u) {
    return 48 <= u && u <= 57;
  }
  function a(u) {
    if (u === null)
      return !1;
    var s = u.length, f = 0, d = !1, l;
    if (!s)
      return !1;
    if (l = u[f], (l === "-" || l === "+") && (l = u[++f]), l === "0") {
      if (f + 1 === s)
        return !0;
      if (l = u[++f], l === "b") {
        for (f++; f < s; f++)
          if (l = u[f], l !== "_") {
            if (l !== "0" && l !== "1")
              return !1;
            d = !0;
          }
        return d;
      }
      if (l === "x") {
        for (f++; f < s; f++)
          if (l = u[f], l !== "_") {
            if (!n(u.charCodeAt(f)))
              return !1;
            d = !0;
          }
        return d;
      }
      for (; f < s; f++)
        if (l = u[f], l !== "_") {
          if (!r(u.charCodeAt(f))) {
            d = !1;
            break;
          }
          d = !0;
        }
      if (d)
        return d;
    }
    for (; f < s; f++)
      if (l = u[f], l !== "_") {
        if (l === ":")
          break;
        if (!i(u.charCodeAt(f)))
          return !1;
        d = !0;
      }
    return d ? l !== ":" ? !0 : /^(:[0-5]?[0-9])+$/.test(u.slice(f)) : !1;
  }
  function o(u) {
    var s = u, f = 1, d, l, p = [];
    return s.indexOf("_") !== -1 && (s = s.replace(/_/g, "")), d = s[0], (d === "-" || d === "+") && (d === "-" && (f = -1), s = s.slice(1), d = s[0]), s === "0" ? 0 : d === "0" ? s[1] === "b" ? f * parseInt(s.slice(2), 2) : s[1] === "x" ? f * parseInt(s, 16) : f * parseInt(s, 8) : s.indexOf(":") !== -1 ? (s.split(":").forEach(function(g) {
      p.unshift(parseInt(g, 10));
    }), s = 0, l = 1, p.forEach(function(g) {
      s += g * l, l *= 60;
    }), f * s) : f * parseInt(s, 10);
  }
  function c(u) {
    const s = Object.prototype.toString.call(u);
    return s === "[object Number]" && u % 1 === 0 && !e.isNegativeZero(u) || s === "[object BigInt]";
  }
  return u5 = new t.Type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: a,
    construct: o,
    predicate: c,
    represent: {
      binary: function(u) {
        return "0b" + u.toString(2);
      },
      octal: function(u) {
        return "0" + u.toString(8);
      },
      decimal: function(u) {
        return u.toString(10);
      },
      hexadecimal: function(u) {
        return "0x" + u.toString(16).toUpperCase();
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }), u5;
}
var c5, F8;
function PB() {
  if (F8) return c5;
  F8 = 1;
  const e = Cc(), t = Ni();
  var n = new RegExp("^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
  function r(c) {
    return !(c === null || !n.test(c));
  }
  function i(c) {
    var u, s, f, d;
    return u = c.replace(/_/g, "").toLowerCase(), s = u[0] === "-" ? -1 : 1, d = [], 0 <= "+-".indexOf(u[0]) && (u = u.slice(1)), u === ".inf" ? s === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : u === ".nan" ? NaN : 0 <= u.indexOf(":") ? (u.split(":").forEach(function(l) {
      d.unshift(parseFloat(l, 10));
    }), u = 0, f = 1, d.forEach(function(l) {
      u += l * f, f *= 60;
    }), s * u) : s * parseFloat(u, 10);
  }
  function a(c, u) {
    if (isNaN(c))
      switch (u) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    else if (Number.POSITIVE_INFINITY === c)
      switch (u) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    else if (Number.NEGATIVE_INFINITY === c)
      switch (u) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    else if (e.isNegativeZero(c))
      return "-0.0";
    return c.toString(10);
  }
  function o(c) {
    return Object.prototype.toString.call(c) === "[object Number]" && (c % 1 !== 0 || e.isNegativeZero(c));
  }
  return c5 = new t.Type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: r,
    construct: i,
    predicate: o,
    represent: a,
    defaultStyle: "lowercase"
  }), c5;
}
var l5, B8;
function RB() {
  if (B8) return l5;
  B8 = 1;
  const e = Vf();
  return l5 = new e.Schema({
    include: [
      kB()
    ],
    implicit: [
      EB(),
      OB(),
      TB(),
      PB()
    ]
  }), l5;
}
var f5, U8;
function jB() {
  if (U8) return f5;
  U8 = 1;
  const e = Vf();
  return f5 = new e.Schema({
    include: [
      RB()
    ]
  }), f5;
}
var p5, H8;
function IB() {
  if (H8) return p5;
  H8 = 1;
  const e = Ni();
  var t = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?)?$");
  function n(a) {
    if (a === null)
      return !1;
    var o;
    return o = t.exec(a), o !== null;
  }
  function r(a) {
    var o, c, u, s, f, d, l, p = 0, g = null, v, b, y;
    if (o = t.exec(a), o === null)
      throw new Error("Date resolve error");
    if (c = +o[1], u = +o[2] - 1, s = +o[3], !o[4])
      return new Date(Date.UTC(c, u, s));
    if (f = +o[4], d = +o[5], l = +o[6], o[7]) {
      for (p = o[7].slice(0, 3); p.length < 3; )
        p = p + "0";
      p = +p;
    }
    return o[9] && (v = +o[10], b = +(o[11] || 0), g = (v * 60 + b) * 6e4, o[9] === "-" && (g = -g)), y = new Date(Date.UTC(c, u, s, f, d, l, p)), g && y.setTime(y.getTime() - g), y;
  }
  function i(a) {
    return a.toISOString();
  }
  return p5 = new e.Type("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: n,
    construct: r,
    instanceOf: Date,
    represent: i
  }), p5;
}
var d5, z8;
function qB() {
  if (z8) return d5;
  z8 = 1;
  const e = Ni();
  function t(n) {
    return n === "<<" || n === null;
  }
  return d5 = new e.Type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: t
  }), d5;
}
var h5 = {}, pl = {}, G8;
function DB() {
  if (G8) return pl;
  G8 = 1, pl.byteLength = c, pl.toByteArray = s, pl.fromByteArray = l;
  for (var e = [], t = [], n = typeof Uint8Array < "u" ? Uint8Array : Array, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, a = r.length; i < a; ++i)
    e[i] = r[i], t[r.charCodeAt(i)] = i;
  t[45] = 62, t[95] = 63;
  function o(p) {
    var g = p.length;
    if (g % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var v = p.indexOf("=");
    v === -1 && (v = g);
    var b = v === g ? 0 : 4 - v % 4;
    return [v, b];
  }
  function c(p) {
    var g = o(p), v = g[0], b = g[1];
    return (v + b) * 3 / 4 - b;
  }
  function u(p, g, v) {
    return (g + v) * 3 / 4 - v;
  }
  function s(p) {
    var g, v = o(p), b = v[0], y = v[1], w = new n(u(p, b, y)), C = 0, T = y > 0 ? b - 4 : b, E;
    for (E = 0; E < T; E += 4)
      g = t[p.charCodeAt(E)] << 18 | t[p.charCodeAt(E + 1)] << 12 | t[p.charCodeAt(E + 2)] << 6 | t[p.charCodeAt(E + 3)], w[C++] = g >> 16 & 255, w[C++] = g >> 8 & 255, w[C++] = g & 255;
    return y === 2 && (g = t[p.charCodeAt(E)] << 2 | t[p.charCodeAt(E + 1)] >> 4, w[C++] = g & 255), y === 1 && (g = t[p.charCodeAt(E)] << 10 | t[p.charCodeAt(E + 1)] << 4 | t[p.charCodeAt(E + 2)] >> 2, w[C++] = g >> 8 & 255, w[C++] = g & 255), w;
  }
  function f(p) {
    return e[p >> 18 & 63] + e[p >> 12 & 63] + e[p >> 6 & 63] + e[p & 63];
  }
  function d(p, g, v) {
    for (var b, y = [], w = g; w < v; w += 3)
      b = (p[w] << 16 & 16711680) + (p[w + 1] << 8 & 65280) + (p[w + 2] & 255), y.push(f(b));
    return y.join("");
  }
  function l(p) {
    for (var g, v = p.length, b = v % 3, y = [], w = 16383, C = 0, T = v - b; C < T; C += w)
      y.push(d(p, C, C + w > T ? T : C + w));
    return b === 1 ? (g = p[v - 1], y.push(
      e[g >> 2] + e[g << 4 & 63] + "=="
    )) : b === 2 && (g = (p[v - 2] << 8) + p[v - 1], y.push(
      e[g >> 10] + e[g >> 4 & 63] + e[g << 2 & 63] + "="
    )), y.join("");
  }
  return pl;
}
var sd = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var V8;
function LB() {
  return V8 || (V8 = 1, sd.read = function(e, t, n, r, i) {
    var a, o, c = i * 8 - r - 1, u = (1 << c) - 1, s = u >> 1, f = -7, d = n ? i - 1 : 0, l = n ? -1 : 1, p = e[t + d];
    for (d += l, a = p & (1 << -f) - 1, p >>= -f, f += c; f > 0; a = a * 256 + e[t + d], d += l, f -= 8)
      ;
    for (o = a & (1 << -f) - 1, a >>= -f, f += r; f > 0; o = o * 256 + e[t + d], d += l, f -= 8)
      ;
    if (a === 0)
      a = 1 - s;
    else {
      if (a === u)
        return o ? NaN : (p ? -1 : 1) * (1 / 0);
      o = o + Math.pow(2, r), a = a - s;
    }
    return (p ? -1 : 1) * o * Math.pow(2, a - r);
  }, sd.write = function(e, t, n, r, i, a) {
    var o, c, u, s = a * 8 - i - 1, f = (1 << s) - 1, d = f >> 1, l = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : a - 1, g = r ? 1 : -1, v = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (c = isNaN(t) ? 1 : 0, o = f) : (o = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), o + d >= 1 ? t += l / u : t += l * Math.pow(2, 1 - d), t * u >= 2 && (o++, u /= 2), o + d >= f ? (c = 0, o = f) : o + d >= 1 ? (c = (t * u - 1) * Math.pow(2, i), o = o + d) : (c = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + p] = c & 255, p += g, c /= 256, i -= 8)
      ;
    for (o = o << i | c, s += i; s > 0; e[n + p] = o & 255, p += g, o /= 256, s -= 8)
      ;
    e[n + p - g] |= v * 128;
  }), sd;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var W8;
function j2() {
  return W8 || (W8 = 1, function(e) {
    var t = DB(), n = LB(), r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = c, e.SlowBuffer = w, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, c.TYPED_ARRAY_SUPPORT = a(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function a() {
      try {
        var ye = new Uint8Array(1), G = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(G, Uint8Array.prototype), Object.setPrototypeOf(ye, G), ye.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(c.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(c.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (c.isBuffer(this))
          return this.byteOffset;
      }
    });
    function o(ye) {
      if (ye > i)
        throw new RangeError('The value "' + ye + '" is invalid for option "size"');
      var G = new Uint8Array(ye);
      return Object.setPrototypeOf(G, c.prototype), G;
    }
    function c(ye, G, Y) {
      if (typeof ye == "number") {
        if (typeof G == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return d(ye);
      }
      return u(ye, G, Y);
    }
    c.poolSize = 8192;
    function u(ye, G, Y) {
      if (typeof ye == "string")
        return l(ye, G);
      if (ArrayBuffer.isView(ye))
        return g(ye);
      if (ye == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ye
        );
      if (Ue(ye, ArrayBuffer) || ye && Ue(ye.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ue(ye, SharedArrayBuffer) || ye && Ue(ye.buffer, SharedArrayBuffer)))
        return v(ye, G, Y);
      if (typeof ye == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var ae = ye.valueOf && ye.valueOf();
      if (ae != null && ae !== ye)
        return c.from(ae, G, Y);
      var Ee = b(ye);
      if (Ee) return Ee;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ye[Symbol.toPrimitive] == "function")
        return c.from(
          ye[Symbol.toPrimitive]("string"),
          G,
          Y
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ye
      );
    }
    c.from = function(ye, G, Y) {
      return u(ye, G, Y);
    }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
    function s(ye) {
      if (typeof ye != "number")
        throw new TypeError('"size" argument must be of type number');
      if (ye < 0)
        throw new RangeError('The value "' + ye + '" is invalid for option "size"');
    }
    function f(ye, G, Y) {
      return s(ye), ye <= 0 ? o(ye) : G !== void 0 ? typeof Y == "string" ? o(ye).fill(G, Y) : o(ye).fill(G) : o(ye);
    }
    c.alloc = function(ye, G, Y) {
      return f(ye, G, Y);
    };
    function d(ye) {
      return s(ye), o(ye < 0 ? 0 : y(ye) | 0);
    }
    c.allocUnsafe = function(ye) {
      return d(ye);
    }, c.allocUnsafeSlow = function(ye) {
      return d(ye);
    };
    function l(ye, G) {
      if ((typeof G != "string" || G === "") && (G = "utf8"), !c.isEncoding(G))
        throw new TypeError("Unknown encoding: " + G);
      var Y = C(ye, G) | 0, ae = o(Y), Ee = ae.write(ye, G);
      return Ee !== Y && (ae = ae.slice(0, Ee)), ae;
    }
    function p(ye) {
      for (var G = ye.length < 0 ? 0 : y(ye.length) | 0, Y = o(G), ae = 0; ae < G; ae += 1)
        Y[ae] = ye[ae] & 255;
      return Y;
    }
    function g(ye) {
      if (Ue(ye, Uint8Array)) {
        var G = new Uint8Array(ye);
        return v(G.buffer, G.byteOffset, G.byteLength);
      }
      return p(ye);
    }
    function v(ye, G, Y) {
      if (G < 0 || ye.byteLength < G)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (ye.byteLength < G + (Y || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var ae;
      return G === void 0 && Y === void 0 ? ae = new Uint8Array(ye) : Y === void 0 ? ae = new Uint8Array(ye, G) : ae = new Uint8Array(ye, G, Y), Object.setPrototypeOf(ae, c.prototype), ae;
    }
    function b(ye) {
      if (c.isBuffer(ye)) {
        var G = y(ye.length) | 0, Y = o(G);
        return Y.length === 0 || ye.copy(Y, 0, 0, G), Y;
      }
      if (ye.length !== void 0)
        return typeof ye.length != "number" || Rt(ye.length) ? o(0) : p(ye);
      if (ye.type === "Buffer" && Array.isArray(ye.data))
        return p(ye.data);
    }
    function y(ye) {
      if (ye >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return ye | 0;
    }
    function w(ye) {
      return +ye != ye && (ye = 0), c.alloc(+ye);
    }
    c.isBuffer = function(G) {
      return G != null && G._isBuffer === !0 && G !== c.prototype;
    }, c.compare = function(G, Y) {
      if (Ue(G, Uint8Array) && (G = c.from(G, G.offset, G.byteLength)), Ue(Y, Uint8Array) && (Y = c.from(Y, Y.offset, Y.byteLength)), !c.isBuffer(G) || !c.isBuffer(Y))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (G === Y) return 0;
      for (var ae = G.length, Ee = Y.length, N = 0, Se = Math.min(ae, Ee); N < Se; ++N)
        if (G[N] !== Y[N]) {
          ae = G[N], Ee = Y[N];
          break;
        }
      return ae < Ee ? -1 : Ee < ae ? 1 : 0;
    }, c.isEncoding = function(G) {
      switch (String(G).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, c.concat = function(G, Y) {
      if (!Array.isArray(G))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (G.length === 0)
        return c.alloc(0);
      var ae;
      if (Y === void 0)
        for (Y = 0, ae = 0; ae < G.length; ++ae)
          Y += G[ae].length;
      var Ee = c.allocUnsafe(Y), N = 0;
      for (ae = 0; ae < G.length; ++ae) {
        var Se = G[ae];
        if (Ue(Se, Uint8Array))
          N + Se.length > Ee.length ? c.from(Se).copy(Ee, N) : Uint8Array.prototype.set.call(
            Ee,
            Se,
            N
          );
        else if (c.isBuffer(Se))
          Se.copy(Ee, N);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        N += Se.length;
      }
      return Ee;
    };
    function C(ye, G) {
      if (c.isBuffer(ye))
        return ye.length;
      if (ArrayBuffer.isView(ye) || Ue(ye, ArrayBuffer))
        return ye.byteLength;
      if (typeof ye != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ye
        );
      var Y = ye.length, ae = arguments.length > 2 && arguments[2] === !0;
      if (!ae && Y === 0) return 0;
      for (var Ee = !1; ; )
        switch (G) {
          case "ascii":
          case "latin1":
          case "binary":
            return Y;
          case "utf8":
          case "utf-8":
            return jt(ye).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Y * 2;
          case "hex":
            return Y >>> 1;
          case "base64":
            return Fe(ye).length;
          default:
            if (Ee)
              return ae ? -1 : jt(ye).length;
            G = ("" + G).toLowerCase(), Ee = !0;
        }
    }
    c.byteLength = C;
    function T(ye, G, Y) {
      var ae = !1;
      if ((G === void 0 || G < 0) && (G = 0), G > this.length || ((Y === void 0 || Y > this.length) && (Y = this.length), Y <= 0) || (Y >>>= 0, G >>>= 0, Y <= G))
        return "";
      for (ye || (ye = "utf8"); ; )
        switch (ye) {
          case "hex":
            return Le(this, G, Y);
          case "utf8":
          case "utf-8":
            return de(this, G, Y);
          case "ascii":
            return $e(this, G, Y);
          case "latin1":
          case "binary":
            return Pe(this, G, Y);
          case "base64":
            return re(this, G, Y);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Ae(this, G, Y);
          default:
            if (ae) throw new TypeError("Unknown encoding: " + ye);
            ye = (ye + "").toLowerCase(), ae = !0;
        }
    }
    c.prototype._isBuffer = !0;
    function E(ye, G, Y) {
      var ae = ye[G];
      ye[G] = ye[Y], ye[Y] = ae;
    }
    c.prototype.swap16 = function() {
      var G = this.length;
      if (G % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var Y = 0; Y < G; Y += 2)
        E(this, Y, Y + 1);
      return this;
    }, c.prototype.swap32 = function() {
      var G = this.length;
      if (G % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var Y = 0; Y < G; Y += 4)
        E(this, Y, Y + 3), E(this, Y + 1, Y + 2);
      return this;
    }, c.prototype.swap64 = function() {
      var G = this.length;
      if (G % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var Y = 0; Y < G; Y += 8)
        E(this, Y, Y + 7), E(this, Y + 1, Y + 6), E(this, Y + 2, Y + 5), E(this, Y + 3, Y + 4);
      return this;
    }, c.prototype.toString = function() {
      var G = this.length;
      return G === 0 ? "" : arguments.length === 0 ? de(this, 0, G) : T.apply(this, arguments);
    }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(G) {
      if (!c.isBuffer(G)) throw new TypeError("Argument must be a Buffer");
      return this === G ? !0 : c.compare(this, G) === 0;
    }, c.prototype.inspect = function() {
      var G = "", Y = e.INSPECT_MAX_BYTES;
      return G = this.toString("hex", 0, Y).replace(/(.{2})/g, "$1 ").trim(), this.length > Y && (G += " ... "), "<Buffer " + G + ">";
    }, r && (c.prototype[r] = c.prototype.inspect), c.prototype.compare = function(G, Y, ae, Ee, N) {
      if (Ue(G, Uint8Array) && (G = c.from(G, G.offset, G.byteLength)), !c.isBuffer(G))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof G
        );
      if (Y === void 0 && (Y = 0), ae === void 0 && (ae = G ? G.length : 0), Ee === void 0 && (Ee = 0), N === void 0 && (N = this.length), Y < 0 || ae > G.length || Ee < 0 || N > this.length)
        throw new RangeError("out of range index");
      if (Ee >= N && Y >= ae)
        return 0;
      if (Ee >= N)
        return -1;
      if (Y >= ae)
        return 1;
      if (Y >>>= 0, ae >>>= 0, Ee >>>= 0, N >>>= 0, this === G) return 0;
      for (var Se = N - Ee, Me = ae - Y, Xe = Math.min(Se, Me), Ke = this.slice(Ee, N), $t = G.slice(Y, ae), Be = 0; Be < Xe; ++Be)
        if (Ke[Be] !== $t[Be]) {
          Se = Ke[Be], Me = $t[Be];
          break;
        }
      return Se < Me ? -1 : Me < Se ? 1 : 0;
    };
    function D(ye, G, Y, ae, Ee) {
      if (ye.length === 0) return -1;
      if (typeof Y == "string" ? (ae = Y, Y = 0) : Y > 2147483647 ? Y = 2147483647 : Y < -2147483648 && (Y = -2147483648), Y = +Y, Rt(Y) && (Y = Ee ? 0 : ye.length - 1), Y < 0 && (Y = ye.length + Y), Y >= ye.length) {
        if (Ee) return -1;
        Y = ye.length - 1;
      } else if (Y < 0)
        if (Ee) Y = 0;
        else return -1;
      if (typeof G == "string" && (G = c.from(G, ae)), c.isBuffer(G))
        return G.length === 0 ? -1 : $(ye, G, Y, ae, Ee);
      if (typeof G == "number")
        return G = G & 255, typeof Uint8Array.prototype.indexOf == "function" ? Ee ? Uint8Array.prototype.indexOf.call(ye, G, Y) : Uint8Array.prototype.lastIndexOf.call(ye, G, Y) : $(ye, [G], Y, ae, Ee);
      throw new TypeError("val must be string, number or Buffer");
    }
    function $(ye, G, Y, ae, Ee) {
      var N = 1, Se = ye.length, Me = G.length;
      if (ae !== void 0 && (ae = String(ae).toLowerCase(), ae === "ucs2" || ae === "ucs-2" || ae === "utf16le" || ae === "utf-16le")) {
        if (ye.length < 2 || G.length < 2)
          return -1;
        N = 2, Se /= 2, Me /= 2, Y /= 2;
      }
      function Xe(M, F) {
        return N === 1 ? M[F] : M.readUInt16BE(F * N);
      }
      var Ke;
      if (Ee) {
        var $t = -1;
        for (Ke = Y; Ke < Se; Ke++)
          if (Xe(ye, Ke) === Xe(G, $t === -1 ? 0 : Ke - $t)) {
            if ($t === -1 && ($t = Ke), Ke - $t + 1 === Me) return $t * N;
          } else
            $t !== -1 && (Ke -= Ke - $t), $t = -1;
      } else
        for (Y + Me > Se && (Y = Se - Me), Ke = Y; Ke >= 0; Ke--) {
          for (var Be = !0, P = 0; P < Me; P++)
            if (Xe(ye, Ke + P) !== Xe(G, P)) {
              Be = !1;
              break;
            }
          if (Be) return Ke;
        }
      return -1;
    }
    c.prototype.includes = function(G, Y, ae) {
      return this.indexOf(G, Y, ae) !== -1;
    }, c.prototype.indexOf = function(G, Y, ae) {
      return D(this, G, Y, ae, !0);
    }, c.prototype.lastIndexOf = function(G, Y, ae) {
      return D(this, G, Y, ae, !1);
    };
    function Z(ye, G, Y, ae) {
      Y = Number(Y) || 0;
      var Ee = ye.length - Y;
      ae ? (ae = Number(ae), ae > Ee && (ae = Ee)) : ae = Ee;
      var N = G.length;
      ae > N / 2 && (ae = N / 2);
      for (var Se = 0; Se < ae; ++Se) {
        var Me = parseInt(G.substr(Se * 2, 2), 16);
        if (Rt(Me)) return Se;
        ye[Y + Se] = Me;
      }
      return Se;
    }
    function te(ye, G, Y, ae) {
      return Ze(jt(G, ye.length - Y), ye, Y, ae);
    }
    function se(ye, G, Y, ae) {
      return Ze(We(G), ye, Y, ae);
    }
    function ee(ye, G, Y, ae) {
      return Ze(Fe(G), ye, Y, ae);
    }
    function K(ye, G, Y, ae) {
      return Ze(Lt(G, ye.length - Y), ye, Y, ae);
    }
    c.prototype.write = function(G, Y, ae, Ee) {
      if (Y === void 0)
        Ee = "utf8", ae = this.length, Y = 0;
      else if (ae === void 0 && typeof Y == "string")
        Ee = Y, ae = this.length, Y = 0;
      else if (isFinite(Y))
        Y = Y >>> 0, isFinite(ae) ? (ae = ae >>> 0, Ee === void 0 && (Ee = "utf8")) : (Ee = ae, ae = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var N = this.length - Y;
      if ((ae === void 0 || ae > N) && (ae = N), G.length > 0 && (ae < 0 || Y < 0) || Y > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      Ee || (Ee = "utf8");
      for (var Se = !1; ; )
        switch (Ee) {
          case "hex":
            return Z(this, G, Y, ae);
          case "utf8":
          case "utf-8":
            return te(this, G, Y, ae);
          case "ascii":
          case "latin1":
          case "binary":
            return se(this, G, Y, ae);
          case "base64":
            return ee(this, G, Y, ae);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return K(this, G, Y, ae);
          default:
            if (Se) throw new TypeError("Unknown encoding: " + Ee);
            Ee = ("" + Ee).toLowerCase(), Se = !0;
        }
    }, c.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function re(ye, G, Y) {
      return G === 0 && Y === ye.length ? t.fromByteArray(ye) : t.fromByteArray(ye.slice(G, Y));
    }
    function de(ye, G, Y) {
      Y = Math.min(ye.length, Y);
      for (var ae = [], Ee = G; Ee < Y; ) {
        var N = ye[Ee], Se = null, Me = N > 239 ? 4 : N > 223 ? 3 : N > 191 ? 2 : 1;
        if (Ee + Me <= Y) {
          var Xe, Ke, $t, Be;
          switch (Me) {
            case 1:
              N < 128 && (Se = N);
              break;
            case 2:
              Xe = ye[Ee + 1], (Xe & 192) === 128 && (Be = (N & 31) << 6 | Xe & 63, Be > 127 && (Se = Be));
              break;
            case 3:
              Xe = ye[Ee + 1], Ke = ye[Ee + 2], (Xe & 192) === 128 && (Ke & 192) === 128 && (Be = (N & 15) << 12 | (Xe & 63) << 6 | Ke & 63, Be > 2047 && (Be < 55296 || Be > 57343) && (Se = Be));
              break;
            case 4:
              Xe = ye[Ee + 1], Ke = ye[Ee + 2], $t = ye[Ee + 3], (Xe & 192) === 128 && (Ke & 192) === 128 && ($t & 192) === 128 && (Be = (N & 15) << 18 | (Xe & 63) << 12 | (Ke & 63) << 6 | $t & 63, Be > 65535 && Be < 1114112 && (Se = Be));
          }
        }
        Se === null ? (Se = 65533, Me = 1) : Se > 65535 && (Se -= 65536, ae.push(Se >>> 10 & 1023 | 55296), Se = 56320 | Se & 1023), ae.push(Se), Ee += Me;
      }
      return me(ae);
    }
    var ie = 4096;
    function me(ye) {
      var G = ye.length;
      if (G <= ie)
        return String.fromCharCode.apply(String, ye);
      for (var Y = "", ae = 0; ae < G; )
        Y += String.fromCharCode.apply(
          String,
          ye.slice(ae, ae += ie)
        );
      return Y;
    }
    function $e(ye, G, Y) {
      var ae = "";
      Y = Math.min(ye.length, Y);
      for (var Ee = G; Ee < Y; ++Ee)
        ae += String.fromCharCode(ye[Ee] & 127);
      return ae;
    }
    function Pe(ye, G, Y) {
      var ae = "";
      Y = Math.min(ye.length, Y);
      for (var Ee = G; Ee < Y; ++Ee)
        ae += String.fromCharCode(ye[Ee]);
      return ae;
    }
    function Le(ye, G, Y) {
      var ae = ye.length;
      (!G || G < 0) && (G = 0), (!Y || Y < 0 || Y > ae) && (Y = ae);
      for (var Ee = "", N = G; N < Y; ++N)
        Ee += Vr[ye[N]];
      return Ee;
    }
    function Ae(ye, G, Y) {
      for (var ae = ye.slice(G, Y), Ee = "", N = 0; N < ae.length - 1; N += 2)
        Ee += String.fromCharCode(ae[N] + ae[N + 1] * 256);
      return Ee;
    }
    c.prototype.slice = function(G, Y) {
      var ae = this.length;
      G = ~~G, Y = Y === void 0 ? ae : ~~Y, G < 0 ? (G += ae, G < 0 && (G = 0)) : G > ae && (G = ae), Y < 0 ? (Y += ae, Y < 0 && (Y = 0)) : Y > ae && (Y = ae), Y < G && (Y = G);
      var Ee = this.subarray(G, Y);
      return Object.setPrototypeOf(Ee, c.prototype), Ee;
    };
    function He(ye, G, Y) {
      if (ye % 1 !== 0 || ye < 0) throw new RangeError("offset is not uint");
      if (ye + G > Y) throw new RangeError("Trying to access beyond buffer length");
    }
    c.prototype.readUintLE = c.prototype.readUIntLE = function(G, Y, ae) {
      G = G >>> 0, Y = Y >>> 0, ae || He(G, Y, this.length);
      for (var Ee = this[G], N = 1, Se = 0; ++Se < Y && (N *= 256); )
        Ee += this[G + Se] * N;
      return Ee;
    }, c.prototype.readUintBE = c.prototype.readUIntBE = function(G, Y, ae) {
      G = G >>> 0, Y = Y >>> 0, ae || He(G, Y, this.length);
      for (var Ee = this[G + --Y], N = 1; Y > 0 && (N *= 256); )
        Ee += this[G + --Y] * N;
      return Ee;
    }, c.prototype.readUint8 = c.prototype.readUInt8 = function(G, Y) {
      return G = G >>> 0, Y || He(G, 1, this.length), this[G];
    }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 2, this.length), this[G] | this[G + 1] << 8;
    }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 2, this.length), this[G] << 8 | this[G + 1];
    }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 4, this.length), (this[G] | this[G + 1] << 8 | this[G + 2] << 16) + this[G + 3] * 16777216;
    }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 4, this.length), this[G] * 16777216 + (this[G + 1] << 16 | this[G + 2] << 8 | this[G + 3]);
    }, c.prototype.readIntLE = function(G, Y, ae) {
      G = G >>> 0, Y = Y >>> 0, ae || He(G, Y, this.length);
      for (var Ee = this[G], N = 1, Se = 0; ++Se < Y && (N *= 256); )
        Ee += this[G + Se] * N;
      return N *= 128, Ee >= N && (Ee -= Math.pow(2, 8 * Y)), Ee;
    }, c.prototype.readIntBE = function(G, Y, ae) {
      G = G >>> 0, Y = Y >>> 0, ae || He(G, Y, this.length);
      for (var Ee = Y, N = 1, Se = this[G + --Ee]; Ee > 0 && (N *= 256); )
        Se += this[G + --Ee] * N;
      return N *= 128, Se >= N && (Se -= Math.pow(2, 8 * Y)), Se;
    }, c.prototype.readInt8 = function(G, Y) {
      return G = G >>> 0, Y || He(G, 1, this.length), this[G] & 128 ? (255 - this[G] + 1) * -1 : this[G];
    }, c.prototype.readInt16LE = function(G, Y) {
      G = G >>> 0, Y || He(G, 2, this.length);
      var ae = this[G] | this[G + 1] << 8;
      return ae & 32768 ? ae | 4294901760 : ae;
    }, c.prototype.readInt16BE = function(G, Y) {
      G = G >>> 0, Y || He(G, 2, this.length);
      var ae = this[G + 1] | this[G] << 8;
      return ae & 32768 ? ae | 4294901760 : ae;
    }, c.prototype.readInt32LE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 4, this.length), this[G] | this[G + 1] << 8 | this[G + 2] << 16 | this[G + 3] << 24;
    }, c.prototype.readInt32BE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 4, this.length), this[G] << 24 | this[G + 1] << 16 | this[G + 2] << 8 | this[G + 3];
    }, c.prototype.readFloatLE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 4, this.length), n.read(this, G, !0, 23, 4);
    }, c.prototype.readFloatBE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 4, this.length), n.read(this, G, !1, 23, 4);
    }, c.prototype.readDoubleLE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 8, this.length), n.read(this, G, !0, 52, 8);
    }, c.prototype.readDoubleBE = function(G, Y) {
      return G = G >>> 0, Y || He(G, 8, this.length), n.read(this, G, !1, 52, 8);
    };
    function Te(ye, G, Y, ae, Ee, N) {
      if (!c.isBuffer(ye)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (G > Ee || G < N) throw new RangeError('"value" argument is out of bounds');
      if (Y + ae > ye.length) throw new RangeError("Index out of range");
    }
    c.prototype.writeUintLE = c.prototype.writeUIntLE = function(G, Y, ae, Ee) {
      if (G = +G, Y = Y >>> 0, ae = ae >>> 0, !Ee) {
        var N = Math.pow(2, 8 * ae) - 1;
        Te(this, G, Y, ae, N, 0);
      }
      var Se = 1, Me = 0;
      for (this[Y] = G & 255; ++Me < ae && (Se *= 256); )
        this[Y + Me] = G / Se & 255;
      return Y + ae;
    }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(G, Y, ae, Ee) {
      if (G = +G, Y = Y >>> 0, ae = ae >>> 0, !Ee) {
        var N = Math.pow(2, 8 * ae) - 1;
        Te(this, G, Y, ae, N, 0);
      }
      var Se = ae - 1, Me = 1;
      for (this[Y + Se] = G & 255; --Se >= 0 && (Me *= 256); )
        this[Y + Se] = G / Me & 255;
      return Y + ae;
    }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 1, 255, 0), this[Y] = G & 255, Y + 1;
    }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 2, 65535, 0), this[Y] = G & 255, this[Y + 1] = G >>> 8, Y + 2;
    }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 2, 65535, 0), this[Y] = G >>> 8, this[Y + 1] = G & 255, Y + 2;
    }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 4, 4294967295, 0), this[Y + 3] = G >>> 24, this[Y + 2] = G >>> 16, this[Y + 1] = G >>> 8, this[Y] = G & 255, Y + 4;
    }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 4, 4294967295, 0), this[Y] = G >>> 24, this[Y + 1] = G >>> 16, this[Y + 2] = G >>> 8, this[Y + 3] = G & 255, Y + 4;
    }, c.prototype.writeIntLE = function(G, Y, ae, Ee) {
      if (G = +G, Y = Y >>> 0, !Ee) {
        var N = Math.pow(2, 8 * ae - 1);
        Te(this, G, Y, ae, N - 1, -N);
      }
      var Se = 0, Me = 1, Xe = 0;
      for (this[Y] = G & 255; ++Se < ae && (Me *= 256); )
        G < 0 && Xe === 0 && this[Y + Se - 1] !== 0 && (Xe = 1), this[Y + Se] = (G / Me >> 0) - Xe & 255;
      return Y + ae;
    }, c.prototype.writeIntBE = function(G, Y, ae, Ee) {
      if (G = +G, Y = Y >>> 0, !Ee) {
        var N = Math.pow(2, 8 * ae - 1);
        Te(this, G, Y, ae, N - 1, -N);
      }
      var Se = ae - 1, Me = 1, Xe = 0;
      for (this[Y + Se] = G & 255; --Se >= 0 && (Me *= 256); )
        G < 0 && Xe === 0 && this[Y + Se + 1] !== 0 && (Xe = 1), this[Y + Se] = (G / Me >> 0) - Xe & 255;
      return Y + ae;
    }, c.prototype.writeInt8 = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 1, 127, -128), G < 0 && (G = 255 + G + 1), this[Y] = G & 255, Y + 1;
    }, c.prototype.writeInt16LE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 2, 32767, -32768), this[Y] = G & 255, this[Y + 1] = G >>> 8, Y + 2;
    }, c.prototype.writeInt16BE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 2, 32767, -32768), this[Y] = G >>> 8, this[Y + 1] = G & 255, Y + 2;
    }, c.prototype.writeInt32LE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 4, 2147483647, -2147483648), this[Y] = G & 255, this[Y + 1] = G >>> 8, this[Y + 2] = G >>> 16, this[Y + 3] = G >>> 24, Y + 4;
    }, c.prototype.writeInt32BE = function(G, Y, ae) {
      return G = +G, Y = Y >>> 0, ae || Te(this, G, Y, 4, 2147483647, -2147483648), G < 0 && (G = 4294967295 + G + 1), this[Y] = G >>> 24, this[Y + 1] = G >>> 16, this[Y + 2] = G >>> 8, this[Y + 3] = G & 255, Y + 4;
    };
    function we(ye, G, Y, ae, Ee, N) {
      if (Y + ae > ye.length) throw new RangeError("Index out of range");
      if (Y < 0) throw new RangeError("Index out of range");
    }
    function qe(ye, G, Y, ae, Ee) {
      return G = +G, Y = Y >>> 0, Ee || we(ye, G, Y, 4), n.write(ye, G, Y, ae, 23, 4), Y + 4;
    }
    c.prototype.writeFloatLE = function(G, Y, ae) {
      return qe(this, G, Y, !0, ae);
    }, c.prototype.writeFloatBE = function(G, Y, ae) {
      return qe(this, G, Y, !1, ae);
    };
    function Ge(ye, G, Y, ae, Ee) {
      return G = +G, Y = Y >>> 0, Ee || we(ye, G, Y, 8), n.write(ye, G, Y, ae, 52, 8), Y + 8;
    }
    c.prototype.writeDoubleLE = function(G, Y, ae) {
      return Ge(this, G, Y, !0, ae);
    }, c.prototype.writeDoubleBE = function(G, Y, ae) {
      return Ge(this, G, Y, !1, ae);
    }, c.prototype.copy = function(G, Y, ae, Ee) {
      if (!c.isBuffer(G)) throw new TypeError("argument should be a Buffer");
      if (ae || (ae = 0), !Ee && Ee !== 0 && (Ee = this.length), Y >= G.length && (Y = G.length), Y || (Y = 0), Ee > 0 && Ee < ae && (Ee = ae), Ee === ae || G.length === 0 || this.length === 0) return 0;
      if (Y < 0)
        throw new RangeError("targetStart out of bounds");
      if (ae < 0 || ae >= this.length) throw new RangeError("Index out of range");
      if (Ee < 0) throw new RangeError("sourceEnd out of bounds");
      Ee > this.length && (Ee = this.length), G.length - Y < Ee - ae && (Ee = G.length - Y + ae);
      var N = Ee - ae;
      return this === G && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Y, ae, Ee) : Uint8Array.prototype.set.call(
        G,
        this.subarray(ae, Ee),
        Y
      ), N;
    }, c.prototype.fill = function(G, Y, ae, Ee) {
      if (typeof G == "string") {
        if (typeof Y == "string" ? (Ee = Y, Y = 0, ae = this.length) : typeof ae == "string" && (Ee = ae, ae = this.length), Ee !== void 0 && typeof Ee != "string")
          throw new TypeError("encoding must be a string");
        if (typeof Ee == "string" && !c.isEncoding(Ee))
          throw new TypeError("Unknown encoding: " + Ee);
        if (G.length === 1) {
          var N = G.charCodeAt(0);
          (Ee === "utf8" && N < 128 || Ee === "latin1") && (G = N);
        }
      } else typeof G == "number" ? G = G & 255 : typeof G == "boolean" && (G = Number(G));
      if (Y < 0 || this.length < Y || this.length < ae)
        throw new RangeError("Out of range index");
      if (ae <= Y)
        return this;
      Y = Y >>> 0, ae = ae === void 0 ? this.length : ae >>> 0, G || (G = 0);
      var Se;
      if (typeof G == "number")
        for (Se = Y; Se < ae; ++Se)
          this[Se] = G;
      else {
        var Me = c.isBuffer(G) ? G : c.from(G, Ee), Xe = Me.length;
        if (Xe === 0)
          throw new TypeError('The value "' + G + '" is invalid for argument "value"');
        for (Se = 0; Se < ae - Y; ++Se)
          this[Se + Y] = Me[Se % Xe];
      }
      return this;
    };
    var It = /[^+/0-9A-Za-z-_]/g;
    function Qe(ye) {
      if (ye = ye.split("=")[0], ye = ye.trim().replace(It, ""), ye.length < 2) return "";
      for (; ye.length % 4 !== 0; )
        ye = ye + "=";
      return ye;
    }
    function jt(ye, G) {
      G = G || 1 / 0;
      for (var Y, ae = ye.length, Ee = null, N = [], Se = 0; Se < ae; ++Se) {
        if (Y = ye.charCodeAt(Se), Y > 55295 && Y < 57344) {
          if (!Ee) {
            if (Y > 56319) {
              (G -= 3) > -1 && N.push(239, 191, 189);
              continue;
            } else if (Se + 1 === ae) {
              (G -= 3) > -1 && N.push(239, 191, 189);
              continue;
            }
            Ee = Y;
            continue;
          }
          if (Y < 56320) {
            (G -= 3) > -1 && N.push(239, 191, 189), Ee = Y;
            continue;
          }
          Y = (Ee - 55296 << 10 | Y - 56320) + 65536;
        } else Ee && (G -= 3) > -1 && N.push(239, 191, 189);
        if (Ee = null, Y < 128) {
          if ((G -= 1) < 0) break;
          N.push(Y);
        } else if (Y < 2048) {
          if ((G -= 2) < 0) break;
          N.push(
            Y >> 6 | 192,
            Y & 63 | 128
          );
        } else if (Y < 65536) {
          if ((G -= 3) < 0) break;
          N.push(
            Y >> 12 | 224,
            Y >> 6 & 63 | 128,
            Y & 63 | 128
          );
        } else if (Y < 1114112) {
          if ((G -= 4) < 0) break;
          N.push(
            Y >> 18 | 240,
            Y >> 12 & 63 | 128,
            Y >> 6 & 63 | 128,
            Y & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return N;
    }
    function We(ye) {
      for (var G = [], Y = 0; Y < ye.length; ++Y)
        G.push(ye.charCodeAt(Y) & 255);
      return G;
    }
    function Lt(ye, G) {
      for (var Y, ae, Ee, N = [], Se = 0; Se < ye.length && !((G -= 2) < 0); ++Se)
        Y = ye.charCodeAt(Se), ae = Y >> 8, Ee = Y % 256, N.push(Ee), N.push(ae);
      return N;
    }
    function Fe(ye) {
      return t.toByteArray(Qe(ye));
    }
    function Ze(ye, G, Y, ae) {
      for (var Ee = 0; Ee < ae && !(Ee + Y >= G.length || Ee >= ye.length); ++Ee)
        G[Ee + Y] = ye[Ee];
      return Ee;
    }
    function Ue(ye, G) {
      return ye instanceof G || ye != null && ye.constructor != null && ye.constructor.name != null && ye.constructor.name === G.name;
    }
    function Rt(ye) {
      return ye !== ye;
    }
    var Vr = function() {
      for (var ye = "0123456789abcdef", G = new Array(256), Y = 0; Y < 16; ++Y)
        for (var ae = Y * 16, Ee = 0; Ee < 16; ++Ee)
          G[ae + Ee] = ye[Y] + ye[Ee];
      return G;
    }();
  }(h5)), h5;
}
var m5, K8;
function NB() {
  if (K8) return m5;
  K8 = 1;
  var e = j2().Buffer;
  const t = Ni();
  var n = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function r(c) {
    if (c === null)
      return !1;
    var u, s, f = 0, d = c.length, l = n;
    for (s = 0; s < d; s++)
      if (u = l.indexOf(c.charAt(s)), !(u > 64)) {
        if (u < 0)
          return !1;
        f += 6;
      }
    return f % 8 === 0;
  }
  function i(c) {
    var u, s, f = c.replace(/[\r\n=]/g, ""), d = f.length, l = n, p = 0, g = [];
    for (u = 0; u < d; u++)
      u % 4 === 0 && u && (g.push(p >> 16 & 255), g.push(p >> 8 & 255), g.push(p & 255)), p = p << 6 | l.indexOf(f.charAt(u));
    return s = d % 4 * 6, s === 0 ? (g.push(p >> 16 & 255), g.push(p >> 8 & 255), g.push(p & 255)) : s === 18 ? (g.push(p >> 10 & 255), g.push(p >> 2 & 255)) : s === 12 && g.push(p >> 4 & 255), e ? new e(g) : g;
  }
  function a(c) {
    var u = "", s = 0, f, d, l = c.length, p = n;
    for (f = 0; f < l; f++)
      f % 3 === 0 && f && (u += p[s >> 18 & 63], u += p[s >> 12 & 63], u += p[s >> 6 & 63], u += p[s & 63]), s = (s << 8) + c[f];
    return d = l % 3, d === 0 ? (u += p[s >> 18 & 63], u += p[s >> 12 & 63], u += p[s >> 6 & 63], u += p[s & 63]) : d === 2 ? (u += p[s >> 10 & 63], u += p[s >> 4 & 63], u += p[s << 2 & 63], u += p[64]) : d === 1 && (u += p[s >> 2 & 63], u += p[s << 4 & 63], u += p[64], u += p[64]), u;
  }
  function o(c) {
    return e && e.isBuffer(c);
  }
  return m5 = new t.Type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: r,
    construct: i,
    predicate: o,
    represent: a
  }), m5;
}
var g5, Z8;
function $B() {
  if (Z8) return g5;
  Z8 = 1;
  const e = Ni();
  var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  function r(a) {
    if (a === null)
      return !0;
    var o = [], c, u, s, f, d, l = a;
    for (c = 0, u = l.length; c < u; c += 1) {
      if (s = l[c], d = !1, n.call(s) !== "[object Object]")
        return !1;
      for (f in s)
        if (t.call(s, f))
          if (!d)
            d = !0;
          else
            return !1;
      if (!d)
        return !1;
      if (o.indexOf(f) === -1)
        o.push(f);
      else
        return !1;
    }
    return !0;
  }
  function i(a) {
    return a !== null ? a : [];
  }
  return g5 = new e.Type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: r,
    construct: i
  }), g5;
}
var v5, Y8;
function MB() {
  if (Y8) return v5;
  Y8 = 1;
  const e = Ni(), t = H0();
  var n = Object.prototype.toString;
  function r(a) {
    if (a === null)
      return !0;
    if (a.kind != t.Kind.SEQ)
      return !1;
    var o, c, u, s = a.items;
    for (o = 0, c = s.length; o < c; o += 1)
      if (u = s[o], n.call(u) !== "[object Object]" || !Array.isArray(u.mappings) || u.mappings.length !== 1)
        return !1;
    return !0;
  }
  function i(a) {
    if (a === null || !Array.isArray(a.items))
      return [];
    let o, c, u, s = a.items;
    for (u = t.newItems(), u.parent = a.parent, u.startPosition = a.startPosition, u.endPosition = a.endPosition, o = 0, c = s.length; o < c; o += 1) {
      let d = s[o].mappings[0], l = t.newItems();
      l.parent = u, l.startPosition = d.key.startPosition, l.endPosition = d.value.startPosition, d.key.parent = l, d.value.parent = l, l.items = [d.key, d.value], u.items.push(l);
    }
    return u;
  }
  return v5 = new e.Type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: r,
    construct: i
  }), v5;
}
var y5, J8;
function FB() {
  if (J8) return y5;
  J8 = 1;
  const e = Ni(), t = H0();
  function n(i) {
    return i === null ? !0 : i.kind == t.Kind.MAP;
  }
  function r(i) {
    return i !== null ? i : {};
  }
  return y5 = new e.Type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: n,
    construct: r
  }), y5;
}
var b5, Q8;
function I2() {
  if (Q8) return b5;
  Q8 = 1;
  const e = Vf();
  var t = new e.Schema({
    include: [
      jB()
    ],
    implicit: [
      IB(),
      qB()
    ],
    explicit: [
      NB(),
      $B(),
      MB(),
      FB()
    ]
  });
  return b5 = t, b5;
}
var x5, X8;
function BB() {
  if (X8) return x5;
  X8 = 1;
  const e = Ni();
  function t() {
    return !0;
  }
  function n() {
  }
  function r() {
    return "";
  }
  function i(a) {
    return typeof a > "u";
  }
  return x5 = new e.Type("tag:yaml.org,2002:js/undefined", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: i,
    represent: r
  }), x5;
}
var _5, e4;
function UB() {
  if (e4) return _5;
  e4 = 1;
  const e = Ni();
  function t(a) {
    if (a === null || a.length === 0)
      return !1;
    var o = a, c = /\/([gim]*)$/.exec(a), u = "";
    if (o[0] === "/") {
      if (c && (u = c[1]), u.length > 3 || o[o.length - u.length - 1] !== "/")
        return !1;
      o = o.slice(1, o.length - u.length - 1);
    }
    try {
      var s = new RegExp(o, u);
      return !0;
    } catch {
      return !1;
    }
  }
  function n(a) {
    var o = a, c = /\/([gim]*)$/.exec(a), u = "";
    return o[0] === "/" && (c && (u = c[1]), o = o.slice(1, o.length - u.length - 1)), new RegExp(o, u);
  }
  function r(a) {
    var o = "/" + a.source + "/";
    return a.global && (o += "g"), a.multiline && (o += "m"), a.ignoreCase && (o += "i"), o;
  }
  function i(a) {
    return Object.prototype.toString.call(a) === "[object RegExp]";
  }
  return _5 = new e.Type("tag:yaml.org,2002:js/regexp", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: i,
    represent: r
  }), _5;
}
var w5, t4;
function JA() {
  if (t4) return w5;
  t4 = 1;
  const e = Vf();
  var t = new e.Schema({
    include: [
      I2()
    ],
    explicit: [
      BB(),
      UB()
    ]
  });
  return e.Schema.DEFAULT = t, w5 = t, w5;
}
var r4;
function HB() {
  if (r4) return Ua;
  r4 = 1, Object.defineProperty(Ua, "__esModule", { value: !0 });
  const e = H0(), t = Cc(), n = Gf(), r = wB(), i = I2(), a = JA();
  var o = Object.prototype.hasOwnProperty, c = 1, u = 2, s = 3, f = 4, d = 1, l = 2, p = 3, g = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, v = /[\x85\u2028\u2029]/, b = /[,\[\]\{\}]/, y = /^(?:!|!!|![a-z\-]+!)$/i, w = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
  function C(P) {
    return P === 10 || P === 13;
  }
  function T(P) {
    return P === 9 || P === 32;
  }
  function E(P) {
    return P === 9 || P === 32 || P === 10 || P === 13;
  }
  function D(P) {
    return P === 44 || P === 91 || P === 93 || P === 123 || P === 125;
  }
  function $(P) {
    var M;
    return 48 <= P && P <= 57 ? P - 48 : (M = P | 32, 97 <= M && M <= 102 ? M - 97 + 10 : -1);
  }
  function Z(P) {
    return P === 120 ? 2 : P === 117 ? 4 : P === 85 ? 8 : 0;
  }
  function te(P) {
    return 48 <= P && P <= 57 ? P - 48 : -1;
  }
  function se(P) {
    return P === 48 ? "\0" : P === 97 ? "\x07" : P === 98 ? "\b" : P === 116 || P === 9 ? "	" : P === 110 ? `
` : P === 118 ? "\v" : P === 102 ? "\f" : P === 114 ? "\r" : P === 101 ? "\x1B" : P === 32 ? " " : P === 34 ? '"' : P === 47 ? "/" : P === 92 ? "\\" : P === 78 ? "" : P === 95 ? " " : P === 76 ? "\u2028" : P === 80 ? "\u2029" : "";
  }
  function ee(P) {
    return P <= 65535 ? String.fromCharCode(P) : String.fromCharCode((P - 65536 >> 10) + 55296, (P - 65536 & 1023) + 56320);
  }
  for (var K = new Array(256), re = new Array(256), de = new Array(256), ie = new Array(256), me = 0; me < 256; me++)
    ie[me] = re[me] = se(me), K[me] = re[me] ? 1 : 0, de[me] = 1, K[me] || (ie[me] = "\\" + String.fromCharCode(me));
  class $e {
    constructor(M, F) {
      this.errorMap = {}, this.errors = [], this.lines = [], this.input = M, this.filename = F.filename || null, this.schema = F.schema || a, this.onWarning = F.onWarning || null, this.legacy = F.legacy || !1, this.allowAnyEscape = F.allowAnyEscape || !1, this.ignoreDuplicateKeys = F.ignoreDuplicateKeys || !1, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = M.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.documents = [];
    }
  }
  function Pe(P, M, F = !1) {
    return new n(M, new r(P.filename, P.input, P.position, P.line, P.position - P.lineStart), F);
  }
  function Le(P, M, F, O = !1, S = !1) {
    var _ = It(P, M);
    if (_) {
      var h = F + M;
      if (!P.errorMap[h]) {
        var A = new r(P.filename, P.input, M, _.line, M - _.start);
        S && (A.toLineEnd = !0);
        var R = new n(F, A, O);
        P.errors.push(R);
      }
    }
  }
  function Ae(P, M) {
    var F = Pe(P, M), O = F.message + F.mark.position;
    if (!P.errorMap[O]) {
      P.errors.push(F), P.errorMap[O] = 1;
      for (var S = P.position; ; ) {
        if (P.position >= P.input.length - 1)
          return;
        var _ = P.input.charAt(P.position);
        if (_ == `
`) {
          P.position--, P.position == S && (P.position += 1);
          return;
        }
        if (_ == "\r") {
          P.position--, P.position == S && (P.position += 1);
          return;
        }
        P.position++;
      }
    }
  }
  function He(P, M) {
    var F = Pe(P, M);
    P.onWarning && P.onWarning.call(null, F);
  }
  var Te = {
    YAML: function(M, F, O) {
      var S, _, h;
      M.version !== null && Ae(M, "duplication of %YAML directive"), O.length !== 1 && Ae(M, "YAML directive accepts exactly one argument"), S = /^([0-9]+)\.([0-9]+)$/.exec(O[0]), S === null && Ae(M, "ill-formed argument of the YAML directive"), _ = parseInt(S[1], 10), h = parseInt(S[2], 10), _ !== 1 && Ae(M, "found incompatible YAML document (version 1.2 is required)"), M.version = O[0], M.checkLineBreaks = h < 2, h !== 2 && Ae(M, "found incompatible YAML document (version 1.2 is required)");
    },
    TAG: function(M, F, O) {
      var S, _;
      O.length !== 2 && Ae(M, "TAG directive accepts exactly two arguments"), S = O[0], _ = O[1], y.test(S) || Ae(M, "ill-formed tag handle (first argument) of the TAG directive"), o.call(M.tagMap, S) && Ae(M, 'there is a previously declared suffix for "' + S + '" tag handle'), w.test(_) || Ae(M, "ill-formed tag prefix (second argument) of the TAG directive"), M.tagMap[S] = _;
    }
  };
  function we(P, M, F, O) {
    var S, _, h, A, R = P.result;
    if (R.startPosition == -1 && (R.startPosition = M), M <= F) {
      if (A = P.input.slice(M, F), O)
        for (S = 0, _ = A.length; S < _; S += 1)
          h = A.charCodeAt(S), h === 9 || 32 <= h && h <= 1114111 || Ae(P, "expected valid JSON character");
      else g.test(A) && Ae(P, "the stream contains non-printable characters");
      R.value += A, R.endPosition = F;
    }
  }
  function qe(P, M, F, O, S) {
    if (O != null) {
      M === null && (M = {
        startPosition: O.startPosition,
        endPosition: S.endPosition,
        parent: null,
        errors: [],
        mappings: [],
        kind: e.Kind.MAP
      });
      var _ = e.newMapping(O, S);
      return _.parent = M, O.parent = _, S != null && (S.parent = _), !P.ignoreDuplicateKeys && M.mappings.forEach((h) => {
        h.key && h.key.value === (_.key && _.key.value) && (Le(P, _.key.startPosition, "duplicate key"), Le(P, h.key.startPosition, "duplicate key"));
      }), M.mappings.push(_), M.endPosition = S ? S.endPosition : O.endPosition + 1, M;
    }
  }
  function Ge(P) {
    var M;
    M = P.input.charCodeAt(P.position), M === 10 ? P.position++ : M === 13 ? (P.position++, P.input.charCodeAt(P.position) === 10 && P.position++) : Ae(P, "a line break is expected"), P.line += 1, P.lineStart = P.position, P.lines.push({
      start: P.lineStart,
      line: P.line
    });
  }
  function It(P, M) {
    for (var F, O = 0; O < P.lines.length && !(P.lines[O].start > M); O++)
      F = P.lines[O];
    return F || {
      start: 0,
      line: 0
    };
  }
  function Qe(P) {
    var M = 0, F = P.position;
    do
      M = P.input.charCodeAt(++P.position);
    while (M !== 0 && !C(M));
    P.comments.push({
      startPosition: F,
      endPosition: P.position,
      value: P.input.slice(F + 1, P.position)
    });
  }
  function jt(P, M, F) {
    for (var O = 0, S = P.input.charCodeAt(P.position); S !== 0; ) {
      for (; T(S); )
        S === 9 && P.errors.push(Pe(P, "Using tabs can lead to unpredictable results", !0)), S = P.input.charCodeAt(++P.position);
      if (M && S === 35 && (Qe(P), S = P.input.charCodeAt(P.position)), C(S))
        for (Ge(P), S = P.input.charCodeAt(P.position), O++, P.lineIndent = 0; S === 32; )
          P.lineIndent++, S = P.input.charCodeAt(++P.position);
      else
        break;
    }
    return F !== -1 && O !== 0 && P.lineIndent < F && He(P, "deficient indentation"), O;
  }
  function We(P) {
    var M = P.position, F;
    return F = P.input.charCodeAt(M), !!((F === 45 || F === 46) && P.input.charCodeAt(M + 1) === F && P.input.charCodeAt(M + 2) === F && (M += 3, F = P.input.charCodeAt(M), F === 0 || E(F)));
  }
  function Lt(P, M, F) {
    F === 1 ? M.value += " " : F > 1 && (M.value += t.repeat(`
`, F - 1));
  }
  function Fe(P, M, F) {
    var O, S, _, h, A, R, I, k, j = P.kind, z = P.result, H, J = e.newScalar();
    if (J.plainScalar = !0, P.result = J, H = P.input.charCodeAt(P.position), E(H) || D(H) || H === 35 || H === 38 || H === 42 || H === 33 || H === 124 || H === 62 || H === 39 || H === 34 || H === 37 || H === 64 || H === 96 || (H === 63 || H === 45) && (S = P.input.charCodeAt(P.position + 1), E(S) || F && D(S)))
      return !1;
    for (P.kind = "scalar", _ = h = P.position, A = !1; H !== 0; ) {
      if (H === 58) {
        if (S = P.input.charCodeAt(P.position + 1), E(S) || F && D(S))
          break;
      } else if (H === 35) {
        if (O = P.input.charCodeAt(P.position - 1), E(O))
          break;
      } else {
        if (P.position === P.lineStart && We(P) || F && D(H))
          break;
        if (C(H))
          if (R = P.line, I = P.lineStart, k = P.lineIndent, jt(P, !1, -1), P.lineIndent >= M) {
            A = !0, H = P.input.charCodeAt(P.position);
            continue;
          } else {
            P.position = h, P.line = R, P.lineStart = I, P.lineIndent = k;
            break;
          }
      }
      if (A && (we(P, _, h, !1), Lt(P, J, P.line - R), _ = h = P.position, A = !1), T(H) || (h = P.position + 1), H = P.input.charCodeAt(++P.position), P.position >= P.input.length)
        return !1;
    }
    return we(P, _, h, !1), P.result.startPosition != -1 ? (J.rawValue = P.input.substring(J.startPosition, J.endPosition), !0) : (P.kind = j, P.result = z, !1);
  }
  function Ze(P, M) {
    var F, O, S;
    if (F = P.input.charCodeAt(P.position), F !== 39)
      return !1;
    var _ = e.newScalar();
    for (_.singleQuoted = !0, P.kind = "scalar", P.result = _, _.startPosition = P.position, P.position++, O = S = P.position; (F = P.input.charCodeAt(P.position)) !== 0; )
      if (F === 39)
        if (we(P, O, P.position, !0), F = P.input.charCodeAt(++P.position), _.endPosition = P.position, F === 39)
          O = S = P.position, P.position++;
        else
          return !0;
      else C(F) ? (we(P, O, S, !0), Lt(P, _, jt(P, !1, M)), O = S = P.position) : P.position === P.lineStart && We(P) ? Ae(P, "unexpected end of the document within a single quoted scalar") : (P.position++, S = P.position, _.endPosition = P.position);
    Ae(P, "unexpected end of the stream within a single quoted scalar");
  }
  function Ue(P, M) {
    var F, O, S, _, h, A;
    if (A = P.input.charCodeAt(P.position), A !== 34)
      return !1;
    P.kind = "scalar";
    var R = e.newScalar();
    for (R.doubleQuoted = !0, P.result = R, R.startPosition = P.position, P.position++, F = O = P.position; (A = P.input.charCodeAt(P.position)) !== 0; ) {
      if (A === 34)
        return we(P, F, P.position, !0), P.position++, R.endPosition = P.position, R.rawValue = P.input.substring(R.startPosition, R.endPosition), !0;
      if (A === 92) {
        if (we(P, F, P.position, !0), A = P.input.charCodeAt(++P.position), C(A))
          jt(P, !1, M);
        else if (A < 256 && (P.allowAnyEscape ? de[A] : K[A]))
          R.value += P.allowAnyEscape ? ie[A] : re[A], P.position++;
        else if ((h = Z(A)) > 0) {
          for (S = h, _ = 0; S > 0; S--)
            A = P.input.charCodeAt(++P.position), (h = $(A)) >= 0 ? _ = (_ << 4) + h : Ae(P, "expected hexadecimal character");
          R.value += ee(_), P.position++;
        } else
          Ae(P, "unknown escape sequence");
        F = O = P.position;
      } else C(A) ? (we(P, F, O, !0), Lt(P, R, jt(P, !1, M)), F = O = P.position) : P.position === P.lineStart && We(P) ? Ae(P, "unexpected end of the document within a double quoted scalar") : (P.position++, O = P.position);
    }
    Ae(P, "unexpected end of the stream within a double quoted scalar");
  }
  function Rt(P, M) {
    var F = !0, O, S = P.tag, _, h = P.anchor, A, R, I, k, j, z, H, J, U;
    if (U = P.input.charCodeAt(P.position), U === 91)
      R = 93, j = !1, _ = e.newItems(), _.startPosition = P.position;
    else if (U === 123)
      R = 125, j = !0, _ = e.newMap(), _.startPosition = P.position;
    else
      return !1;
    for (P.anchor !== null && (_.anchorId = P.anchor, P.anchorMap[P.anchor] = _), U = P.input.charCodeAt(++P.position); U !== 0; ) {
      if (jt(P, !0, M), U = P.input.charCodeAt(P.position), U === R)
        return P.position++, P.tag = S, P.anchor = h, P.kind = j ? "mapping" : "sequence", P.result = _, _.endPosition = P.position, !0;
      if (!F) {
        var L = P.position;
        Ae(P, "missed comma between flow collection entries"), P.position = L + 1;
      }
      if (H = z = J = null, I = k = !1, U === 63 && (A = P.input.charCodeAt(P.position + 1), E(A) && (I = k = !0, P.position++, jt(P, !0, M))), O = P.line, N(P, M, c, !1, !0), H = P.tag, z = P.result, jt(P, !0, M), U = P.input.charCodeAt(P.position), (k || P.line === O) && U === 58 && (I = !0, U = P.input.charCodeAt(++P.position), jt(P, !0, M), N(P, M, c, !1, !0), J = P.result), j)
        qe(P, _, H, z, J);
      else if (I) {
        var B = qe(P, null, H, z, J);
        B.parent = _, _.items.push(B);
      } else
        z && (z.parent = _), _.items.push(z);
      _.endPosition = P.position + 1, jt(P, !0, M), U = P.input.charCodeAt(P.position), U === 44 ? (F = !0, U = P.input.charCodeAt(++P.position)) : F = !1;
    }
    Ae(P, "unexpected end of the stream within a flow collection");
  }
  function Vr(P, M) {
    var F, O, S = d, _ = !1, h = M, A = 0, R = !1, I, k;
    if (k = P.input.charCodeAt(P.position), k === 124)
      O = !1;
    else if (k === 62)
      O = !0;
    else
      return !1;
    var j = e.newScalar();
    for (P.kind = "scalar", P.result = j, j.startPosition = P.position; k !== 0; )
      if (k = P.input.charCodeAt(++P.position), k === 43 || k === 45)
        d === S ? S = k === 43 ? p : l : Ae(P, "repeat of a chomping mode identifier");
      else if ((I = te(k)) >= 0)
        I === 0 ? Ae(P, "bad explicit indentation width of a block scalar; it cannot be less than one") : _ ? Ae(P, "repeat of an indentation width identifier") : (h = M + I - 1, _ = !0);
      else
        break;
    if (T(k)) {
      do
        k = P.input.charCodeAt(++P.position);
      while (T(k));
      k === 35 && (Qe(P), k = P.input.charCodeAt(P.position));
    }
    for (; k !== 0; ) {
      for (Ge(P), P.lineIndent = 0, k = P.input.charCodeAt(P.position); (!_ || P.lineIndent < h) && k === 32; )
        P.lineIndent++, k = P.input.charCodeAt(++P.position);
      if (!_ && P.lineIndent > h && (h = P.lineIndent), C(k)) {
        A++;
        continue;
      }
      if (P.lineIndent < h) {
        S === p ? j.value += t.repeat(`
`, A) : S === d && _ && (j.value += `
`);
        break;
      }
      for (O ? T(k) ? (R = !0, j.value += t.repeat(`
`, A + 1)) : R ? (R = !1, j.value += t.repeat(`
`, A + 1)) : A === 0 ? _ && (j.value += " ") : j.value += t.repeat(`
`, A) : _ && (j.value += t.repeat(`
`, A + 1)), _ = !0, A = 0, F = P.position; !C(k) && k !== 0; )
        k = P.input.charCodeAt(++P.position);
      we(P, F, P.position, !1);
    }
    j.endPosition = P.position;
    for (var z = P.position - 1; ; ) {
      var H = P.input[z];
      if (H == "\r" || H == `
` || H != " " && H != "	")
        break;
      z--;
    }
    return j.endPosition = z, j.rawValue = P.input.substring(j.startPosition, j.endPosition), !0;
  }
  function ye(P, M) {
    var F, O = P.tag, S = P.anchor, _ = e.newItems(), h, A = !1, R;
    for (P.anchor !== null && (_.anchorId = P.anchor, P.anchorMap[P.anchor] = _), _.startPosition = P.position, R = P.input.charCodeAt(P.position); R !== 0 && !(R !== 45 || (h = P.input.charCodeAt(P.position + 1), !E(h))); ) {
      if (A = !0, P.position++, jt(P, !0, -1) && P.lineIndent <= M) {
        _.items.push(null), R = P.input.charCodeAt(P.position);
        continue;
      }
      if (F = P.line, N(P, M, s, !1, !0), P.result && (P.result.parent = _, _.items.push(P.result)), jt(P, !0, -1), R = P.input.charCodeAt(P.position), (P.line === F || P.lineIndent > M) && R !== 0)
        Ae(P, "bad indentation of a sequence entry");
      else if (P.lineIndent < M)
        break;
    }
    return _.endPosition = P.position, A ? (P.tag = O, P.anchor = S, P.kind = "sequence", P.result = _, _.endPosition = P.position, !0) : !1;
  }
  function G(P, M, F) {
    var O, S, _, h = P.tag, A = P.anchor, R = e.newMap(), I = null, k = null, j = null, z = !1, H = !1, J;
    for (R.startPosition = P.position, P.anchor !== null && (R.anchorId = P.anchor, P.anchorMap[P.anchor] = R), J = P.input.charCodeAt(P.position); J !== 0; ) {
      if (O = P.input.charCodeAt(P.position + 1), _ = P.line, (J === 63 || J === 58) && E(O))
        J === 63 ? (z && (qe(P, R, I, k, null), I = k = j = null), H = !0, z = !0, S = !0) : z ? (z = !1, S = !0) : Ae(P, "incomplete explicit mapping pair; a key node is missed"), P.position += 1, J = O;
      else if (N(P, F, u, !1, !0))
        if (P.line === _) {
          for (J = P.input.charCodeAt(P.position); T(J); )
            J = P.input.charCodeAt(++P.position);
          if (J === 58)
            J = P.input.charCodeAt(++P.position), E(J) || Ae(P, "a whitespace character is expected after the key-value separator within a block mapping"), z && (qe(P, R, I, k, null), I = k = j = null), H = !0, z = !1, S = !1, I = P.tag, k = P.result;
          else {
            if (P.position == P.lineStart && We(P))
              break;
            if (H)
              Ae(P, "can not read an implicit mapping pair; a colon is missed");
            else
              return P.tag = h, P.anchor = A, !0;
          }
        } else if (H) {
          for (Ae(P, "can not read a block mapping entry; a multiline key may not be an implicit key"); P.position > 0; )
            if (J = P.input.charCodeAt(--P.position), C(J)) {
              P.position++;
              break;
            }
        } else
          return P.tag = h, P.anchor = A, !0;
      else
        break;
      if ((P.line === _ || P.lineIndent > M) && (N(P, M, f, !0, S) && (z ? k = P.result : j = P.result), z || (qe(P, R, I, k, j), I = k = j = null), jt(P, !0, -1), J = P.input.charCodeAt(P.position)), P.lineIndent > M && J !== 0)
        Ae(P, "bad indentation of a mapping entry");
      else if (P.lineIndent < M)
        break;
    }
    return z && qe(P, R, I, k, null), H && (P.tag = h, P.anchor = A, P.kind = "mapping", P.result = R), H;
  }
  function Y(P) {
    var M, F = !1, O = !1, S, _, h;
    if (h = P.input.charCodeAt(P.position), h !== 33)
      return !1;
    if (P.tag !== null && Ae(P, "duplication of a tag property"), h = P.input.charCodeAt(++P.position), h === 60 ? (F = !0, h = P.input.charCodeAt(++P.position)) : h === 33 ? (O = !0, S = "!!", h = P.input.charCodeAt(++P.position)) : S = "!", M = P.position, F) {
      do
        h = P.input.charCodeAt(++P.position);
      while (h !== 0 && h !== 62);
      P.position < P.length ? (_ = P.input.slice(M, P.position), h = P.input.charCodeAt(++P.position)) : Ae(P, "unexpected end of the stream within a verbatim tag");
    } else {
      for (; h !== 0 && !E(h); )
        h === 33 && (O ? Ae(P, "tag suffix cannot contain exclamation marks") : (S = P.input.slice(M - 1, P.position + 1), y.test(S) || Ae(P, "named tag handle cannot contain such characters"), O = !0, M = P.position + 1)), h = P.input.charCodeAt(++P.position);
      _ = P.input.slice(M, P.position), b.test(_) && Ae(P, "tag suffix cannot contain flow indicator characters");
    }
    return _ && !w.test(_) && Ae(P, "tag name cannot contain such characters: " + _), F ? P.tag = _ : o.call(P.tagMap, S) ? P.tag = P.tagMap[S] + _ : S === "!" ? P.tag = "!" + _ : S === "!!" ? P.tag = "tag:yaml.org,2002:" + _ : Ae(P, 'undeclared tag handle "' + S + '"'), !0;
  }
  function ae(P) {
    var M, F;
    if (F = P.input.charCodeAt(P.position), F !== 38)
      return !1;
    for (P.anchor !== null && Ae(P, "duplication of an anchor property"), F = P.input.charCodeAt(++P.position), M = P.position; F !== 0 && !E(F) && !D(F); )
      F = P.input.charCodeAt(++P.position);
    return P.position === M && Ae(P, "name of an anchor node must contain at least one character"), P.anchor = P.input.slice(M, P.position), !0;
  }
  function Ee(P) {
    var M, F;
    P.length, P.input;
    var O;
    if (O = P.input.charCodeAt(P.position), O !== 42)
      return !1;
    for (O = P.input.charCodeAt(++P.position), M = P.position; O !== 0 && !E(O) && !D(O); )
      O = P.input.charCodeAt(++P.position);
    return P.position <= M && (Ae(P, "name of an alias node must contain at least one character"), P.position = M + 1), F = P.input.slice(M, P.position), P.anchorMap.hasOwnProperty(F) || (Ae(P, 'unidentified alias "' + F + '"'), P.position <= M && (P.position = M + 1)), P.result = e.newAnchorRef(F, M, P.position, P.anchorMap[F]), jt(P, !0, -1), !0;
  }
  function N(P, M, F, O, S) {
    var _, h, A, R = 1, I = !1, k = !1, j, z, H, J, U;
    P.tag = null, P.anchor = null, P.kind = null, P.result = null, _ = h = A = f === F || s === F, O && jt(P, !0, -1) && (I = !0, P.lineIndent > M ? R = 1 : P.lineIndent === M ? R = 0 : P.lineIndent < M && (R = -1));
    let L = P.position;
    if (P.position - P.lineStart, R === 1)
      for (; Y(P) || ae(P); )
        jt(P, !0, -1) ? (I = !0, A = _, P.lineIndent > M ? R = 1 : P.lineIndent === M ? R = 0 : P.lineIndent < M && (R = -1)) : A = !1;
    if (A && (A = I || S), (R === 1 || f === F) && (c === F || u === F ? J = M : J = M + 1, U = P.position - P.lineStart, R === 1 ? A && (ye(P, U) || G(P, U, J)) || Rt(P, J) ? k = !0 : (h && Vr(P, J) || Ze(P, J) || Ue(P, J) ? k = !0 : Ee(P) ? (k = !0, (P.tag !== null || P.anchor !== null) && Ae(P, "alias node should not have any properties")) : Fe(P, J, c === F) && (k = !0, P.tag === null && (P.tag = "?")), P.anchor !== null && (P.anchorMap[P.anchor] = P.result, P.result.anchorId = P.anchor)) : R === 0 && (k = A && ye(P, U))), P.tag !== null && P.tag !== "!")
      if (P.tag == "!include")
        P.result || (P.result = e.newScalar(), P.result.startPosition = P.position, P.result.endPosition = P.position, Ae(P, "!include without value")), P.result.kind = e.Kind.INCLUDE_REF;
      else if (P.tag === "?")
        for (j = 0, z = P.implicitTypes.length; j < z; j += 1) {
          H = P.implicitTypes[j];
          var B = P.result.value;
          if (H.resolve(B)) {
            P.result.valueObject = H.construct(P.result.value), P.tag = H.tag, P.anchor !== null && (P.result.anchorId = P.anchor, P.anchorMap[P.anchor] = P.result);
            break;
          }
        }
      else o.call(P.typeMap, P.tag) ? (H = P.typeMap[P.tag], P.result !== null && H.kind !== P.kind && Ae(P, "unacceptable node kind for !<" + P.tag + '> tag; it should be "' + H.kind + '", not "' + P.kind + '"'), H.resolve(P.result) ? (P.result = H.construct(P.result), P.anchor !== null && (P.result.anchorId = P.anchor, P.anchorMap[P.anchor] = P.result)) : Ae(P, "cannot resolve a node with !<" + P.tag + "> explicit tag")) : Le(P, L, "unknown tag <" + P.tag + ">", !1, !0);
    return P.tag !== null || P.anchor !== null || k;
  }
  function Se(P) {
    var M = P.position, F, O, S, _ = !1, h;
    for (P.version = null, P.checkLineBreaks = P.legacy, P.tagMap = {}, P.anchorMap = {}, P.comments = []; (h = P.input.charCodeAt(P.position)) !== 0 && (jt(P, !0, -1), h = P.input.charCodeAt(P.position), !(P.lineIndent > 0 || h !== 37)); ) {
      for (_ = !0, h = P.input.charCodeAt(++P.position), F = P.position; h !== 0 && !E(h); )
        h = P.input.charCodeAt(++P.position);
      for (O = P.input.slice(F, P.position), S = [], O.length < 1 && Ae(P, "directive name must not be less than one character in length"); h !== 0; ) {
        for (; T(h); )
          h = P.input.charCodeAt(++P.position);
        if (h === 35) {
          Qe(P), h = P.input.charCodeAt(P.position);
          break;
        }
        if (C(h))
          break;
        for (F = P.position; h !== 0 && !E(h); )
          h = P.input.charCodeAt(++P.position);
        S.push(P.input.slice(F, P.position));
      }
      h !== 0 && Ge(P), o.call(Te, O) ? Te[O](P, O, S) : (He(P, 'unknown document directive "' + O + '"'), P.position++);
    }
    if (jt(P, !0, -1), P.lineIndent === 0 && P.input.charCodeAt(P.position) === 45 && P.input.charCodeAt(P.position + 1) === 45 && P.input.charCodeAt(P.position + 2) === 45 ? (P.position += 3, jt(P, !0, -1)) : _ && Ae(P, "directives end mark is expected"), N(P, P.lineIndent - 1, f, !1, !0), jt(P, !0, -1), P.checkLineBreaks && v.test(P.input.slice(M, P.position)) && He(P, "non-ASCII line breaks are interpreted as content"), P.result.comments = P.comments, P.documents.push(P.result), P.position === P.lineStart && We(P)) {
      P.input.charCodeAt(P.position) === 46 && (P.position += 3, jt(P, !0, -1));
      return;
    }
    if (P.position < P.length - 1)
      Ae(P, "end of the stream or a document separator is expected");
    else
      return;
  }
  function Me(P, M) {
    P = String(P), M = M || {};
    let F = P.length;
    F !== 0 && (P.charCodeAt(F - 1) !== 10 && P.charCodeAt(F - 1) !== 13 && (P += `
`), P.charCodeAt(0) === 65279 && (P = P.slice(1)));
    var O = new $e(P, M);
    for (O.input += "\0"; O.input.charCodeAt(O.position) === 32; )
      O.lineIndent += 1, O.position += 1;
    for (; O.position < O.length - 1; ) {
      var S = O.position;
      if (Se(O), O.position <= S)
        for (; O.position < O.length - 1; O.position++) {
          var _ = O.input.charAt(O.position);
          if (_ == `
`)
            break;
        }
    }
    let h = O.documents, A = h.length;
    A > 0 && (h[A - 1].endPosition = F);
    for (let R of h)
      R.errors = O.errors, R.startPosition > R.endPosition && (R.startPosition = R.endPosition);
    return h;
  }
  function Xe(P, M, F = {}) {
    var O = Me(P, F), S, _;
    for (S = 0, _ = O.length; S < _; S += 1)
      M(O[S]);
  }
  Ua.loadAll = Xe;
  function Ke(P, M = {}) {
    var F = Me(P, M);
    if (F.length !== 0) {
      if (F.length === 1)
        return F[0];
      var O = new n("expected a single document in the stream, but found more");
      return O.mark = new r("", "", 0, 0, 0), O.mark.position = F[0].endPosition, F[0].errors.push(O), F[0];
    }
  }
  Ua.load = Ke;
  function $t(P, M, F = {}) {
    Xe(P, M, t.extend({ schema: i }, F));
  }
  Ua.safeLoadAll = $t;
  function Be(P, M = {}) {
    return Ke(P, t.extend({ schema: i }, M));
  }
  return Ua.safeLoad = Be, Ua.loadAll = Xe, Ua.load = Ke, Ua.safeLoadAll = $t, Ua.safeLoad = Be, Ua;
}
var dl = {}, n4;
function zB() {
  if (n4) return dl;
  n4 = 1, Object.defineProperty(dl, "__esModule", { value: !0 });
  var e = Cc(), t = Gf(), n = JA(), r = I2(), i = Object.prototype.toString, a = Object.prototype.hasOwnProperty, o = 9, c = 10, u = 13, s = 32, f = 33, d = 34, l = 35, p = 37, g = 38, v = 39, b = 42, y = 44, w = 45, C = 58, T = 61, E = 62, D = 63, $ = 64, Z = 91, te = 93, se = 96, ee = 123, K = 124, re = 125, de = {};
  de[0] = "\\0", de[7] = "\\a", de[8] = "\\b", de[9] = "\\t", de[10] = "\\n", de[11] = "\\v", de[12] = "\\f", de[13] = "\\r", de[27] = "\\e", de[34] = '\\"', de[92] = "\\\\", de[133] = "\\N", de[160] = "\\_", de[8232] = "\\L", de[8233] = "\\P";
  var ie = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ];
  function me(h, A) {
    var R, I, k, j, z, H, J;
    if (A === null)
      return {};
    for (R = {}, I = Object.keys(A), k = 0, j = I.length; k < j; k += 1)
      z = I[k], H = String(A[z]), z.slice(0, 2) === "!!" && (z = "tag:yaml.org,2002:" + z.slice(2)), J = h.compiledTypeMap.fallback[z], J && a.call(J.styleAliases, H) && (H = J.styleAliases[H]), R[z] = H;
    return R;
  }
  function $e(h) {
    var A, R, I;
    if (A = h.toString(16).toUpperCase(), h <= 255)
      R = "x", I = 2;
    else if (h <= 65535)
      R = "u", I = 4;
    else if (h <= 4294967295)
      R = "U", I = 8;
    else
      throw new t("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + R + e.repeat("0", I - A.length) + A;
  }
  function Pe(h) {
    this.schema = h.schema || n, this.indent = Math.max(1, h.indent || 2), this.noArrayIndent = h.noArrayIndent || !1, this.skipInvalid = h.skipInvalid || !1, this.flowLevel = e.isNothing(h.flowLevel) ? -1 : h.flowLevel, this.styleMap = me(this.schema, h.styles || null), this.sortKeys = h.sortKeys || !1, this.lineWidth = h.lineWidth || 80, this.noRefs = h.noRefs || !1, this.noCompatMode = h.noCompatMode || !1, this.condenseFlow = h.condenseFlow || !1, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.comments = h.comments || {}, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
  }
  function Le(h, A) {
    for (var R = e.repeat(" ", A), I = 0, k = -1, j = "", z, H = h.length; I < H; )
      k = h.indexOf(`
`, I), k === -1 ? (z = h.slice(I), I = H) : (z = h.slice(I, k + 1), I = k + 1), z.length && z !== `
` && (j += R), j += z;
    return j;
  }
  function Ae(h, A) {
    return `
` + e.repeat(" ", h.indent * A);
  }
  function He(h, A) {
    var R, I, k;
    for (R = 0, I = h.implicitTypes.length; R < I; R += 1)
      if (k = h.implicitTypes[R], k.resolve(A))
        return !0;
    return !1;
  }
  function Te(h) {
    return h === s || h === o;
  }
  function we(h) {
    return 32 <= h && h <= 126 || 161 <= h && h <= 55295 && h !== 8232 && h !== 8233 || 57344 <= h && h <= 65533 && h !== 65279 || 65536 <= h && h <= 1114111;
  }
  function qe(h) {
    return we(h) && !Te(h) && h !== 65279 && h !== u && h !== c;
  }
  function Ge(h, A) {
    return we(h) && h !== 65279 && h !== y && h !== Z && h !== te && h !== ee && h !== re && h !== C && (h !== l || A && qe(A));
  }
  function It(h) {
    return we(h) && h !== 65279 && !Te(h) && h !== w && h !== D && h !== C && h !== y && h !== Z && h !== te && h !== ee && h !== re && h !== l && h !== g && h !== b && h !== f && h !== K && h !== T && h !== E && h !== v && h !== d && h !== p && h !== $ && h !== se;
  }
  function Qe(h) {
    var A = /^\n* /;
    return A.test(h);
  }
  var jt = 1, We = 2, Lt = 3, Fe = 4, Ze = 5;
  function Ue(h, A, R, I, k) {
    var j, z, H, J = !1, U = !1, L = I !== -1, B = -1, Q = It(h.charCodeAt(0)) && !Te(h.charCodeAt(h.length - 1));
    if (A)
      for (j = 0; j < h.length; j++) {
        if (z = h.charCodeAt(j), !we(z))
          return Ze;
        H = j > 0 ? h.charCodeAt(j - 1) : null, Q = Q && Ge(z, H);
      }
    else {
      for (j = 0; j < h.length; j++) {
        if (z = h.charCodeAt(j), z === c)
          J = !0, L && (U = U || j - B - 1 > I && h[B + 1] !== " ", B = j);
        else if (!we(z))
          return Ze;
        H = j > 0 ? h.charCodeAt(j - 1) : null, Q = Q && Ge(z, H);
      }
      U = U || L && j - B - 1 > I && h[B + 1] !== " ";
    }
    return !J && !U ? Q && !k(h) ? jt : We : R > 9 && Qe(h) ? Ze : U ? Fe : Lt;
  }
  function Rt(h, A, R, I, k) {
    var j = function() {
      if (A.length === 0)
        return "''";
      if (!h.noCompatMode && ie.indexOf(A) !== -1)
        return "'" + A + "'";
      var z = h.indent * Math.max(1, R), H = h.lineWidth === -1 ? -1 : Math.max(Math.min(h.lineWidth, 40), h.lineWidth - z), J = I || h.flowLevel > -1 && R >= h.flowLevel;
      function U(L) {
        return He(h, L);
      }
      switch (Ue(A, J, h.indent, H, U)) {
        case jt:
          return A;
        case We:
          return "'" + A.replace(/'/g, "''") + "'";
        case Lt:
          return "|" + Vr(A, h.indent) + ye(Le(A, z));
        case Fe:
          return ">" + Vr(A, h.indent) + ye(Le(G(A, H), z));
        case Ze:
          return '"' + ae(A) + '"';
        default:
          throw new t("impossible error: invalid scalar style");
      }
    }();
    if (!I) {
      let H = new _(h, k).write(R, "before-eol");
      H !== "" && (j += " " + H);
    }
    h.dump = j;
  }
  function Vr(h, A) {
    var R = Qe(h) ? String(A) : "", I = h[h.length - 1] === `
`, k = I && (h[h.length - 2] === `
` || h === `
`), j = k ? "+" : I ? "" : "-";
    return R + j + `
`;
  }
  function ye(h) {
    return h[h.length - 1] === `
` ? h.slice(0, -1) : h;
  }
  function G(h, A) {
    for (var R = /(\n+)([^\n]*)/g, I = function() {
      var U = h.indexOf(`
`);
      return U = U !== -1 ? U : h.length, R.lastIndex = U, Y(h.slice(0, U), A);
    }(), k = h[0] === `
` || h[0] === " ", j, z; z = R.exec(h); ) {
      var H = z[1], J = z[2];
      j = J[0] === " ", I += H + (!k && !j && J !== "" ? `
` : "") + Y(J, A), k = j;
    }
    return I;
  }
  function Y(h, A) {
    if (h === "" || h[0] === " ")
      return h;
    for (var R = / [^ ]/g, I, k = 0, j, z = 0, H = 0, J = ""; I = R.exec(h); )
      H = I.index, H - k > A && (j = z > k ? z : H, J += `
` + h.slice(k, j), k = j + 1), z = H;
    return J += `
`, h.length - k > A && z > k ? J += h.slice(k, z) + `
` + h.slice(z + 1) : J += h.slice(k), J.slice(1);
  }
  function ae(h) {
    for (var A = "", R, I, k, j = 0; j < h.length; j++) {
      if (R = h.charCodeAt(j), R >= 55296 && R <= 56319 && (I = h.charCodeAt(j + 1), I >= 56320 && I <= 57343)) {
        A += $e((R - 55296) * 1024 + I - 56320 + 65536), j++;
        continue;
      }
      k = de[R], A += !k && we(R) ? h[j] : k || $e(R);
    }
    return A;
  }
  function Ee(h, A, R, I) {
    var k = "", j = h.tag, z, H;
    for (z = 0, H = R.length; z < H; z += 1)
      Ke(h, A, R[z], !1, !1, !1, I) && (z !== 0 && (k += "," + (h.condenseFlow ? "" : " ")), k += h.dump);
    h.tag = j, h.dump = "[" + k + "]";
  }
  function N(h, A, R, I, k) {
    var j = "", z = h.tag, H, J, U = new _(h, k);
    for (j += U.write(A, "before-eol"), j += U.write(A, "leading"), H = 0, J = R.length; H < J; H += 1)
      j += U.writeAt(String(H), A, "before"), Ke(h, A + 1, R[H], !0, !0, !1, `${k}/${H}`) && ((!I || H !== 0) && (j += Ae(h, A)), h.dump && c === h.dump.charCodeAt(0) ? j += "-" : j += "- ", j += h.dump), j += U.writeAt(String(H), A, "after");
    h.tag = z, h.dump = j || "[]", h.dump += U.write(A, "trailing");
  }
  function Se(h, A, R, I) {
    var k = "", j = h.tag, z = Object.keys(R), H, J, U, L, B;
    for (H = 0, J = z.length; H < J; H += 1)
      B = "", H !== 0 && (B += ", "), h.condenseFlow && (B += '"'), U = z[H], L = R[U], Ke(h, A, U, !1, !1, !1, I) && (h.dump.length > 1024 && (B += "? "), B += h.dump + (h.condenseFlow ? '"' : "") + ":" + (h.condenseFlow ? "" : " "), Ke(h, A, L, !1, !1, !1, I) && (B += h.dump, k += B));
    h.tag = j, h.dump = "{" + k + "}";
  }
  function Me(h, A, R, I, k) {
    var j = "", z = h.tag, H = Object.keys(R), J, U, L, B, Q, V;
    if (h.sortKeys === !0)
      H.sort();
    else if (typeof h.sortKeys == "function")
      H.sort(h.sortKeys);
    else if (h.sortKeys)
      throw new t("sortKeys must be a boolean or a function");
    var X = new _(h, k);
    for (j += X.write(A, "before-eol"), j += X.write(A, "leading"), J = 0, U = H.length; J < U; J += 1)
      V = "", (!I || J !== 0) && (V += Ae(h, A)), L = H[J], B = R[L], j += X.writeAt(L, A, "before"), Ke(h, A + 1, L, !0, !0, !0, k) && (Q = h.tag !== null && h.tag !== "?" || h.dump && h.dump.length > 1024, Q && (h.dump && c === h.dump.charCodeAt(0) ? V += "?" : V += "? "), V += h.dump, Q && (V += Ae(h, A)), Ke(h, A + 1, B, !0, Q, !1, `${k}/${S(L)}`) && (h.dump && c === h.dump.charCodeAt(0) ? V += ":" : V += ": ", V += h.dump, j += V, j += X.writeAt(A, L, "after")));
    h.tag = z, h.dump = j || "{}", h.dump += X.write(A, "trailing");
  }
  function Xe(h, A, R) {
    var I, k, j, z, H, J;
    for (k = R ? h.explicitTypes : h.implicitTypes, j = 0, z = k.length; j < z; j += 1)
      if (H = k[j], (H.instanceOf || H.predicate) && (!H.instanceOf || typeof A == "object" && A instanceof H.instanceOf) && (!H.predicate || H.predicate(A))) {
        if (h.tag = R ? H.tag : "?", H.represent) {
          if (J = h.styleMap[H.tag] || H.defaultStyle, i.call(H.represent) === "[object Function]")
            I = H.represent(A, J);
          else if (a.call(H.represent, J))
            I = H.represent[J](A, J);
          else
            throw new t("!<" + H.tag + '> tag resolver accepts not "' + J + '" style');
          h.dump = I;
        }
        return !0;
      }
    return !1;
  }
  function Ke(h, A, R, I, k, j, z) {
    h.tag = null, h.dump = R, Xe(h, R, !1) || Xe(h, R, !0);
    var H = i.call(h.dump);
    I && (I = h.flowLevel < 0 || h.flowLevel > A), (h.tag !== null && h.tag !== "?" || h.indent !== 2 && A > 0) && (k = !1);
    var J = H === "[object Object]" || H === "[object Array]", U, L;
    if (J && (U = h.duplicates.indexOf(R), L = U !== -1), (h.tag !== null && h.tag !== "?" || L || h.indent !== 2 && A > 0) && (k = !1), L && h.usedDuplicates[U])
      h.dump = "*ref_" + U;
    else {
      if (J && L && !h.usedDuplicates[U] && (h.usedDuplicates[U] = !0), H === "[object Object]")
        I && Object.keys(h.dump).length !== 0 ? (Me(h, A, h.dump, k, z), L && (h.dump = "&ref_" + U + h.dump)) : (Se(h, A, h.dump, z), L && (h.dump = "&ref_" + U + " " + h.dump));
      else if (H === "[object Array]") {
        var B = h.noArrayIndent && A > 0 ? A - 1 : A;
        I && h.dump.length !== 0 ? (N(h, B, h.dump, k, z), L && (h.dump = "&ref_" + U + h.dump)) : (Ee(h, B, h.dump, z), L && (h.dump = "&ref_" + U + " " + h.dump));
      } else if (H === "[object String]")
        h.tag !== "?" && Rt(h, h.dump, A, j, z);
      else {
        if (h.skipInvalid)
          return !1;
        throw new t("unacceptable kind of an object to dump " + H);
      }
      h.tag !== null && h.tag !== "?" && (h.dump = "!<" + h.tag + "> " + h.dump);
    }
    return !0;
  }
  function $t(h, A) {
    var R = [], I = [], k, j;
    for (Be(h, R, I), k = 0, j = I.length; k < j; k += 1)
      A.duplicates.push(R[I[k]]);
    A.usedDuplicates = new Array(j);
  }
  function Be(h, A, R) {
    var I, k, j;
    if (h !== null && typeof h == "object")
      if (k = A.indexOf(h), k !== -1)
        R.indexOf(k) === -1 && R.push(k);
      else if (A.push(h), Array.isArray(h))
        for (k = 0, j = h.length; k < j; k += 1)
          Be(h[k], A, R);
      else
        for (I = Object.keys(h), k = 0, j = I.length; k < j; k += 1)
          Be(h[I[k]], A, R);
  }
  function P(h, A) {
    A = A || {};
    var R = new Pe(A);
    return A.noRefs || $t(h, R), Ke(R, 0, h, !0, !0, !1, "#") ? R.dump + `
` : "";
  }
  dl.dump = P;
  function M(h, A) {
    return P(h, e.extend({ schema: r }, A));
  }
  dl.safeDump = M;
  const F = /~/g, O = /\//g;
  function S(h) {
    return h.replace(F, "~0").replace(O, "~1");
  }
  function _(h, A) {
    if (this.state = h, this.comments = {
      "before-eol": /* @__PURE__ */ new Set(),
      leading: /* @__PURE__ */ new Set(),
      trailing: /* @__PURE__ */ new Set(),
      before: /* @__PURE__ */ new Map(),
      after: /* @__PURE__ */ new Map()
    }, this.written = /* @__PURE__ */ new WeakSet(), h.comments !== null && A in h.comments)
      for (let R of h.comments[A])
        switch (R.placement) {
          case "before-eol":
          case "leading":
          case "trailing":
            this.comments[R.placement].add(R);
            break;
          case "between":
            let I = this.comments.before.get(R.between[1]);
            I ? I.add(R) : this.comments.before.set(R.between[1], /* @__PURE__ */ new Set([R]));
            let k = this.comments.after.get(R.between[0]);
            k ? k.add(R) : this.comments.after.set(R.between[0], /* @__PURE__ */ new Set([R]));
            break;
        }
  }
  return _.prototype.write = function(h, A) {
    let R = "";
    for (let I of this.comments[A])
      R += this._write(I, h);
    return R;
  }, _.prototype.writeAt = function(h, A, R) {
    let I = "", k = this.comments[R].get(h);
    if (k)
      for (let j of k)
        I += this._write(j, A);
    return I;
  }, _.prototype._write = function(h, A) {
    if (this.written.has(h))
      return "";
    this.written.add(h);
    let R = "#" + h.value;
    return h.placement === "before-eol" ? R : A === 0 && h.placement === "leading" ? R + `
` : Ae(this.state, A) + R;
  }, dl;
}
var S5 = {}, i4;
function GB() {
  return i4 || (i4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    function t(u) {
      if (["true", "True", "TRUE"].lastIndexOf(u) >= 0)
        return !0;
      if (["false", "False", "FALSE"].lastIndexOf(u) >= 0)
        return !1;
      throw `Invalid boolean "${u}"`;
    }
    e.parseYamlBoolean = t;
    function n(u) {
      return u.lastIndexOf("0o", 0) === 0 ? parseInt(u.substring(2), 8) : parseInt(u);
    }
    function r(u) {
      const s = n(u);
      if (Number.isNaN(s))
        throw `Invalid integer "${u}"`;
      return s;
    }
    e.parseYamlInteger = r;
    function i(u) {
      const s = r(u);
      return s > Number.MAX_SAFE_INTEGER && u.lastIndexOf("0o", 0) === -1 ? BigInt(u) : s;
    }
    e.parseYamlBigInteger = i;
    function a(u) {
      if ([".nan", ".NaN", ".NAN"].lastIndexOf(u) >= 0)
        return NaN;
      const f = /^([-+])?(?:\.inf|\.Inf|\.INF)$/.exec(u);
      if (f)
        return f[1] === "-" ? -1 / 0 : 1 / 0;
      const d = parseFloat(u);
      if (!isNaN(d))
        return d;
      throw `Invalid float "${u}"`;
    }
    e.parseYamlFloat = a;
    var o;
    (function(u) {
      u[u.null = 0] = "null", u[u.bool = 1] = "bool", u[u.int = 2] = "int", u[u.float = 3] = "float", u[u.string = 4] = "string";
    })(o = e.ScalarType || (e.ScalarType = {}));
    function c(u) {
      if (u === void 0)
        return o.null;
      if (u.doubleQuoted || !u.plainScalar || u.singleQuoted)
        return o.string;
      const s = u.value;
      if (["null", "Null", "NULL", "~", ""].indexOf(s) >= 0 || s == null)
        return o.null;
      if (["true", "True", "TRUE", "false", "False", "FALSE"].indexOf(s) >= 0)
        return o.bool;
      const f = /^[-+]?[0-9]+$/, d = /^0o[0-7]+$/, l = /^0x[0-9a-fA-F]+$/;
      if (f.test(s) || d.test(s) || l.test(s))
        return o.int;
      const p = /^[-+]?(\.[0-9]+|[0-9]+(\.[0-9]*)?)([eE][-+]?[0-9]+)?$/, g = /^[-+]?(\.inf|\.Inf|\.INF)$/;
      return p.test(s) || g.test(s) || [".nan", ".NaN", ".NAN"].indexOf(s) >= 0 ? o.float : o.string;
    }
    e.determineScalarType = c;
  }(S5)), S5;
}
var a4;
function q2() {
  return a4 || (a4 = 1, function(e) {
    function t(i) {
      for (var a in i) e.hasOwnProperty(a) || (e[a] = i[a]);
    }
    Object.defineProperty(e, "__esModule", { value: !0 });
    var n = HB();
    e.load = n.load, e.loadAll = n.loadAll, e.safeLoad = n.safeLoad, e.safeLoadAll = n.safeLoadAll;
    var r = zB();
    e.dump = r.dump, e.safeDump = r.safeDump, e.YAMLException = Gf(), t(H0()), t(GB());
  }(Qh)), Qh;
}
var o4;
function Ac() {
  if (o4) return fl;
  o4 = 1, Object.defineProperty(fl, "__esModule", { value: !0 });
  const e = q2();
  return fl.Kind = e.Kind, fl.ScalarType = e.ScalarType, fl;
}
var ud = {}, s4;
function Wf() {
  return s4 || (s4 = 1, Object.defineProperty(ud, "__esModule", { value: !0 }), ud.isObject = (e) => e !== null && typeof e == "object"), ud;
}
var u4;
function D2() {
  if (u4) return id;
  u4 = 1, Object.defineProperty(id, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ Ac(), t = /* @__PURE__ */ Wf();
  function n(r) {
    const i = [];
    let a = r;
    for (; r; ) {
      switch (r.kind) {
        case e.Kind.SCALAR:
          i.unshift(r.value);
          break;
        case e.Kind.MAPPING:
          a !== r.key && (i.length > 0 && t.isObject(r.value) && r.value.value === i[0] ? i[0] = r.key.value : i.unshift(r.key.value));
          break;
        case e.Kind.SEQ:
          if (a) {
            const o = r.items.indexOf(a);
            a.kind === e.Kind.SCALAR ? i[0] = o : o !== -1 && i.unshift(o);
          }
          break;
      }
      a = r, r = r.parent;
    }
    return i;
  }
  return id.buildJsonPath = n, id;
}
var C5 = {}, c4;
function QA() {
  return c4 || (c4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = /* @__PURE__ */ Ac(), n = /* @__PURE__ */ Wf();
    e.dereferenceAnchor = (i, a) => {
      if (!n.isObject(i))
        return i;
      if (i.kind === t.Kind.ANCHOR_REF && i.referencesAnchor === a)
        return null;
      switch (i.kind) {
        case t.Kind.MAP:
          return Object.assign({}, i, { mappings: i.mappings.map((o) => e.dereferenceAnchor(o, a)) });
        case t.Kind.SEQ:
          return Object.assign({}, i, { items: i.items.map((o) => e.dereferenceAnchor(o, a)) });
        case t.Kind.MAPPING:
          return Object.assign({}, i, { value: e.dereferenceAnchor(i.value, a) });
        case t.Kind.SCALAR:
          return i;
        case t.Kind.ANCHOR_REF:
          return n.isObject(i.value) && r(i) ? null : i;
        default:
          return i;
      }
    };
    const r = (i) => {
      const { referencesAnchor: a } = i;
      let o = i;
      for (; o = o.parent; )
        if ("anchorId" in o && o.anchorId === a)
          return !0;
      return !1;
    };
  }(C5)), C5;
}
var cd = {}, l4;
function VB() {
  if (l4) return cd;
  l4 = 1, Object.defineProperty(cd, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ D2(), t = /* @__PURE__ */ Ac(), n = /* @__PURE__ */ Wf();
  cd.getJsonPathForPosition = ({ ast: o, lineMap: c }, { line: u, character: s }) => {
    if (u >= c.length || s >= c[u])
      return;
    const f = u === 0 ? 0 : c[u - 1] + 1, d = a(o, Math.min(c[u] - 1, f + s), u, c);
    if (!n.isObject(d))
      return;
    const l = e.buildJsonPath(d);
    if (l.length !== 0)
      return l;
  };
  function* r(o) {
    switch (o.kind) {
      case t.Kind.MAP:
        if (o.mappings.length !== 0)
          for (const c of o.mappings)
            n.isObject(c) && (yield c);
        break;
      case t.Kind.MAPPING:
        n.isObject(o.key) && (yield o.key), n.isObject(o.value) && (yield o.value);
        break;
      case t.Kind.SEQ:
        if (o.items.length !== 0)
          for (const c of o.items)
            n.isObject(c) && (yield c);
        break;
      case t.Kind.SCALAR:
        yield o;
        break;
    }
  }
  function i(o, c, u) {
    const s = u[c - 1] + 1, f = u[c];
    switch (o.kind) {
      case t.Kind.MAPPING:
        return o.key;
      case t.Kind.MAP:
        if (o.mappings.length !== 0) {
          for (const d of o.mappings)
            if (d.startPosition > s && d.startPosition <= f)
              return i(d, c, u);
        }
        break;
      case t.Kind.SEQ:
        if (o.items.length !== 0) {
          for (const d of o.items)
            if (d !== null && d.startPosition > s && d.startPosition <= f)
              return i(d, c, u);
        }
        break;
    }
    return o;
  }
  function a(o, c, u, s) {
    for (const f of r(o))
      if (f.startPosition <= c && c <= f.endPosition)
        return f.kind === t.Kind.SCALAR ? f : a(f, c, u, s);
    if (s[u - 1] === s[u] - 1)
      return o;
    if (o.startPosition < s[u - 1] && c <= o.endPosition) {
      if (o.kind !== t.Kind.MAPPING)
        return i(o, u, s);
      if (o.value && o.key.endPosition < c)
        return i(o.value, u, s);
    }
    return o;
  }
  return cd;
}
var ld = {}, A5 = {}, f4;
function L2() {
  return f4 || (f4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.lineForPosition = (t, n, r = 0, i) => {
      if (t === 0 || n.length === 0 || t < n[0])
        return 0;
      typeof i > "u" && (i = n.length);
      const a = Math.floor((i - r) / 2) + r;
      if (t >= n[a] && !n[a + 1])
        return a + 1;
      const o = n[Math.min(a + 1, n.length)];
      return t === n[a] - 1 ? a : t >= n[a] && t <= o ? t === o ? a + 2 : a + 1 : t > n[a] ? e.lineForPosition(t, n, a + 1, i) : e.lineForPosition(t, n, r, a - 1);
    };
  }(A5)), A5;
}
var p4;
function WB() {
  if (p4) return ld;
  p4 = 1, Object.defineProperty(ld, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ L2(), t = /* @__PURE__ */ Ac(), n = /* @__PURE__ */ Wf();
  ld.getLocationForJsonPath = ({ ast: s, lineMap: f, metadata: d }, l, p = !1) => {
    const g = a(s, l, { closest: p, mergeKeys: d !== void 0 && d.mergeKeys === !0 });
    if (g !== void 0)
      return u(f, {
        start: r(g, f.length > 0 ? f[0] : 0),
        end: i(g)
      });
  };
  function r(s, f) {
    if (s.parent && s.parent.kind === t.Kind.MAPPING) {
      if (s.parent.value === null)
        return s.parent.endPosition;
      if (s.kind !== t.Kind.SCALAR)
        return s.parent.key.endPosition + 1;
    }
    return s.parent === null && f - s.startPosition === 0 ? 0 : s.startPosition;
  }
  function i(s) {
    switch (s.kind) {
      case t.Kind.SEQ:
        const { items: f } = s;
        if (f.length !== 0) {
          const d = f[f.length - 1];
          if (d !== null)
            return i(d);
        }
        break;
      case t.Kind.MAPPING:
        if (s.value !== null)
          return i(s.value);
        break;
      case t.Kind.MAP:
        if (s.value !== null && s.mappings.length !== 0)
          return i(s.mappings[s.mappings.length - 1]);
        break;
      case t.Kind.SCALAR:
        if (s.parent !== null && s.parent.kind === t.Kind.MAPPING && s.parent.value === null)
          return s.parent.endPosition;
        break;
    }
    return s.endPosition;
  }
  function a(s, f, { closest: d, mergeKeys: l }) {
    e: for (const p of f) {
      if (!n.isObject(s))
        return d ? s : void 0;
      switch (s.kind) {
        case t.Kind.MAP:
          const g = o(s.mappings, l);
          for (let v = g.length - 1; v >= 0; v--) {
            const b = g[v];
            if (b.key.value === p) {
              b.value === null ? s = b.key : s = b.value;
              continue e;
            }
          }
          return d ? s : void 0;
        case t.Kind.SEQ:
          for (let v = 0; v < s.items.length; v++)
            if (v === Number(p)) {
              const b = s.items[v];
              if (b === null)
                break;
              s = b;
              continue e;
            }
          return d ? s : void 0;
        default:
          return d ? s : void 0;
      }
    }
    return s;
  }
  function o(s, f) {
    return f ? s.reduce((d, l) => (n.isObject(l) && (l.key.value === "<<" ? d.push(...c(l.value)) : d.push(l)), d), []) : s;
  }
  function c(s) {
    if (!n.isObject(s))
      return [];
    switch (s.kind) {
      case t.Kind.SEQ:
        return s.items.reduceRight((f, d) => (f.push(...c(d)), f), []);
      case t.Kind.MAP:
        return s.mappings;
      case t.Kind.ANCHOR_REF:
        return c(s.value);
      default:
        return [];
    }
  }
  const u = (s, { start: f = 0, end: d = 0 }) => {
    const l = e.lineForPosition(f, s), p = e.lineForPosition(d, s);
    return {
      range: {
        start: {
          line: l,
          character: f - (l === 0 ? 0 : s[l - 1])
        },
        end: {
          line: p,
          character: d - (p === 0 ? 0 : s[p - 1])
        }
      }
    };
  };
  return ld;
}
var fd = {}, pd = {}, uo = {}, d4;
function XA() {
  if (d4) return uo;
  d4 = 1, Object.defineProperty(uo, "__esModule", { value: !0 });
  const t = `__object_order_${Math.floor(Date.now() / 36e5)}__`, n = Symbol.for(t), r = String(n), i = {
    defineProperty(w, C, T) {
      return !Object.prototype.hasOwnProperty.call(w, C) && n in w ? w[n].push(C) : "value" in T && C === n && T.value.lastIndexOf(n) === -1 && T.value.push(n), Reflect.defineProperty(w, C, T);
    },
    deleteProperty(w, C) {
      const T = Object.prototype.hasOwnProperty.call(w, C), E = Reflect.deleteProperty(w, C);
      if (E && T && n in w) {
        const D = w[n].indexOf(C);
        D !== -1 && w[n].splice(D, 1);
      }
      return E;
    },
    ownKeys(w) {
      return n in w ? w[n] : Reflect.ownKeys(w);
    },
    set(w, C, T) {
      const E = Object.prototype.hasOwnProperty.call(w, C), D = Reflect.set(w, C, T);
      return D && !E && n in w && w[n].push(C), D;
    }
  };
  function a(w, C = Reflect.ownKeys(w)) {
    b(w);
    const T = new Proxy(w, i);
    return o(T, C), T;
  }
  function o(w, C) {
    return n in w ? (w[n].length = 0, w[n].push(...C), !0) : Reflect.defineProperty(w, n, {
      configurable: !0,
      value: C
    });
  }
  function c(w) {
    return w[n];
  }
  function u(w) {
    const C = w.slice();
    for (let T = 0; T < C.length; T += 1) {
      const E = C[T];
      p(E) && (C[T] = Array.isArray(E) ? u(E) : s(E, !0));
    }
    return C;
  }
  function s(w, C) {
    b(w, "Invalid target provided");
    const T = { ...w };
    if (n in w && Object.defineProperty(T, r, {
      enumerable: !0,
      value: w[n].filter((E) => E !== n)
    }), C)
      for (const E of Object.keys(w)) {
        if (E === r) continue;
        const D = w[E];
        p(D) && (T[E] = Array.isArray(D) ? u(D) : s(D, !0));
      }
    return T;
  }
  function f(w) {
    for (let C = 0; C < w.length; C += 1) {
      const T = w[C];
      p(T) && (w[C] = Array.isArray(T) ? f(T) : d(T, !0));
    }
    return w;
  }
  function d(w, C) {
    b(w, "Invalid target provided");
    const T = a(
      w,
      r in w ? w[r] : Reflect.ownKeys(w)
    );
    if (delete T[r], C)
      for (const E of Object.keys(w)) {
        const D = w[E];
        p(D) && (w[E] = Array.isArray(D) ? f(D) : d(D, !0));
      }
    return T;
  }
  function l(w) {
    return n in w;
  }
  function p(w) {
    return w !== null && typeof w == "object";
  }
  function g(w) {
    if (!p(w)) return !1;
    if (w[Symbol.toStringTag] !== void 0) {
      const C = Object.getPrototypeOf(w);
      return C === null || C === Object.prototype;
    }
    return v(w) === "Object";
  }
  function v(w) {
    const C = w[Symbol.toStringTag];
    if (typeof C == "string")
      return C;
    const T = Reflect.apply(Object.prototype.toString, w, []);
    return T.slice(8, T.length - 1);
  }
  function b(w, C) {
    if (y() && !g(w))
      throw new TypeError(C);
  }
  function y() {
    return typeof bn > "u" || !p(bn) || !p(bn.env) ? !1 : bn.env.NODE_ENV === "development" || bn.env.NODE_ENV === "test";
  }
  return uo.ORDER_KEY_ID = t, uo.default = a, uo.deserialize = d, uo.getOrder = c, uo.isOrderedObject = l, uo.serialize = s, uo.setOrder = o, uo;
}
var k5 = {}, h4;
function KB() {
  return h4 || (h4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.HttpOperationSecurityDeclarationTypes = void 0, function(t) {
      t.None = "none", t.Declared = "declared", t.InheritedFromService = "inheritedFromService";
    }(e.HttpOperationSecurityDeclarationTypes || (e.HttpOperationSecurityDeclarationTypes = {})), e.HttpParamStyles = void 0, function(t) {
      t.Unspecified = "unspecified", t.Simple = "simple", t.Matrix = "matrix", t.Label = "label", t.Form = "form", t.CommaDelimited = "commaDelimited", t.SpaceDelimited = "spaceDelimited", t.PipeDelimited = "pipeDelimited", t.DeepObject = "deepObject", t.TabDelimited = "tabDelimited";
    }(e.HttpParamStyles || (e.HttpParamStyles = {})), e.DiagnosticSeverity = void 0, function(t) {
      t[t.Error = 0] = "Error", t[t.Warning = 1] = "Warning", t[t.Information = 2] = "Information", t[t.Hint = 3] = "Hint";
    }(e.DiagnosticSeverity || (e.DiagnosticSeverity = {})), e.NodeType = void 0, function(t) {
      t.Article = "article", t.HttpService = "http_service", t.HttpServer = "http_server", t.HttpOperation = "http_operation", t.HttpCallback = "http_callback", t.HttpWebhook = "http_webhook", t.Model = "model", t.Generic = "generic", t.Unknown = "unknown", t.TableOfContents = "table_of_contents", t.SpectralRuleset = "spectral_ruleset", t.Styleguide = "styleguide", t.Image = "image", t.StoplightResolutions = "stoplight_resolutions", t.StoplightOverride = "stoplight_override";
    }(e.NodeType || (e.NodeType = {})), e.NodeFormat = void 0, function(t) {
      t.Json = "json", t.Markdown = "markdown", t.Yaml = "yaml", t.Javascript = "javascript", t.Apng = "apng", t.Avif = "avif", t.Bmp = "bmp", t.Gif = "gif", t.Jpeg = "jpeg", t.Png = "png", t.Svg = "svg", t.Webp = "webp";
    }(e.NodeFormat || (e.NodeFormat = {}));
  }(k5)), k5;
}
var m4;
function ek() {
  if (m4) return pd;
  m4 = 1, Object.defineProperty(pd, "__esModule", { value: !0 });
  const e = XA(), t = /* @__PURE__ */ KB(), n = q2(), r = /* @__PURE__ */ D2(), i = /* @__PURE__ */ QA(), a = /* @__PURE__ */ L2(), o = /* @__PURE__ */ Ac(), c = /* @__PURE__ */ Wf();
  pd.parseWithPointers = (ee, K) => {
    const re = p(ee), de = n.load(ee, Object.assign({}, K, { ignoreDuplicateKeys: !0 })), ie = {
      ast: de,
      lineMap: re,
      data: void 0,
      diagnostics: [],
      metadata: K,
      comments: {}
    };
    if (!de)
      return ie;
    const me = se(K), $e = new te(ie.comments, te.mapComments(me.attachComments && de.comments ? de.comments : [], re), de, re, "#"), Pe = {
      lineMap: re,
      diagnostics: ie.diagnostics
    };
    return ie.data = d(Pe, de, $e, me), de.errors && ie.diagnostics.push(...v(de.errors, re)), ie.diagnostics.length > 0 && ie.diagnostics.sort((Le, Ae) => Le.range.start.line - Ae.range.start.line), Array.isArray(ie.ast.errors) && (ie.ast.errors.length = 0), ie;
  };
  const u = /~/g, s = /\//g;
  function f(ee) {
    return ee.replace(u, "~0").replace(s, "~1");
  }
  const d = (ee, K, re, de) => {
    if (K)
      switch (K.kind) {
        case o.Kind.MAP: {
          const ie = re.enter(K), { lineMap: me, diagnostics: $e } = ee, { preserveKeyOrder: Pe, ignoreDuplicateKeys: Le, json: Ae, mergeKeys: He } = de, Te = y(Pe), we = [], qe = He, Ge = !Ae, It = !Le;
          for (const Qe of K.mappings) {
            if (!E(Qe, me, $e, Ge))
              continue;
            const jt = String(l(Qe.key)), We = ie.enter(Qe, f(jt));
            if ((Ge || It) && (!qe || jt !== "<<"))
              if (we.includes(jt)) {
                if (Ge)
                  throw new Error("Duplicate YAML mapping key encountered");
                It && $e.push($(Qe.key, me, "duplicate key"));
              } else
                we.push(jt);
            if (qe && jt === "<<") {
              const Lt = b(d(ee, Qe.value, We, de), Pe);
              Object.assign(Te, Lt);
            } else
              Te[jt] = d(ee, Qe.value, We, de), Pe && T(Te, jt);
            We.attachComments();
          }
          return ie.attachComments(), Te;
        }
        case o.Kind.SEQ: {
          const ie = re.enter(K), me = K.items.map(($e, Pe) => {
            if ($e !== null) {
              const Le = ie.enter($e, Pe), Ae = d(ee, $e, Le, de);
              return Le.attachComments(), Ae;
            } else
              return null;
          });
          return ie.attachComments(), me;
        }
        case o.Kind.SCALAR: {
          const ie = l(K);
          return !de.bigInt && typeof ie == "bigint" ? Number(ie) : ie;
        }
        case o.Kind.ANCHOR_REF:
          return c.isObject(K.value) && (K.value = i.dereferenceAnchor(K.value, K.referencesAnchor)), d(ee, K.value, re, de);
        default:
          return null;
      }
    return K;
  };
  function l(ee) {
    switch (n.determineScalarType(ee)) {
      case o.ScalarType.null:
        return null;
      case o.ScalarType.string:
        return String(ee.value);
      case o.ScalarType.bool:
        return n.parseYamlBoolean(ee.value);
      case o.ScalarType.int:
        return n.parseYamlBigInteger(ee.value);
      case o.ScalarType.float:
        return n.parseYamlFloat(ee.value);
    }
  }
  const p = (ee) => {
    const K = [];
    let re = 0;
    for (; re < ee.length; re++)
      ee[re] === `
` && K.push(re + 1);
    return K.push(re + 1), K;
  };
  function g(ee, K) {
    return K === 0 ? Math.max(0, ee[0] - 1) : Math.max(0, ee[K] - ee[K - 1] - 1);
  }
  const v = (ee, K) => {
    const re = [];
    let de = -1, ie = 0;
    for (const me of ee) {
      const $e = {
        code: me.name,
        message: me.reason,
        severity: me.isWarning ? t.DiagnosticSeverity.Warning : t.DiagnosticSeverity.Error,
        range: {
          start: {
            line: me.mark.line,
            character: me.mark.column
          },
          end: {
            line: me.mark.line,
            character: me.mark.toLineEnd ? g(K, me.mark.line) : me.mark.column
          }
        }
      };
      me.reason === "missed comma between flow collection entries" ? de = de === -1 ? ie : de : de !== -1 && (re[de].range.end = $e.range.end, re[de].message = "invalid mixed usage of block and flow styles", re.length = de + 1, ie = re.length, de = -1), re.push($e), ie++;
    }
    return re;
  }, b = (ee, K) => Array.isArray(ee) ? ee.reduceRight(K ? (de, ie) => {
    const me = Object.keys(ie);
    Object.assign(de, ie);
    for (let $e = me.length - 1; $e >= 0; $e--)
      C(de, me[$e]);
    return de;
  } : (de, ie) => Object.assign(de, ie), y(K)) : typeof ee != "object" || ee === null ? null : Object(ee);
  function y(ee) {
    return ee ? e.default({}) : {};
  }
  function w(ee, K) {
    if (!(K in ee))
      return;
    const re = e.getOrder(ee), de = re.indexOf(K);
    de !== -1 && re.splice(de, 1);
  }
  function C(ee, K) {
    w(ee, K), e.getOrder(ee).unshift(K);
  }
  function T(ee, K) {
    w(ee, K), e.getOrder(ee).push(K);
  }
  function E(ee, K, re, de) {
    if (ee.key.kind !== o.Kind.SCALAR)
      return de || re.push(D(ee.key, K, "mapping key must be a string scalar", de)), !1;
    if (!de) {
      const ie = typeof l(ee.key);
      ie !== "string" && re.push(D(ee.key, K, `mapping key must be a string scalar rather than ${ee.key.valueObject === null ? "null" : ie}`, de));
    }
    return !0;
  }
  function D(ee, K, re, de) {
    const ie = $(ee, K, re);
    return ie.code = "YAMLIncompatibleValue", ie.severity = de ? t.DiagnosticSeverity.Hint : t.DiagnosticSeverity.Warning, ie;
  }
  function $(ee, K, re) {
    return {
      code: "YAMLException",
      message: re,
      severity: t.DiagnosticSeverity.Error,
      path: r.buildJsonPath(ee),
      range: Z(K, ee.startPosition, ee.endPosition)
    };
  }
  function Z(ee, K, re) {
    const de = a.lineForPosition(K, ee), ie = a.lineForPosition(re, ee);
    return {
      start: {
        line: de,
        character: de === 0 ? K : K - ee[de - 1]
      },
      end: {
        line: ie,
        character: ie === 0 ? re : re - ee[ie - 1]
      }
    };
  }
  class te {
    constructor(K, re, de, ie, me) {
      if (this.attachedComments = K, this.node = de, this.lineMap = ie, this.pointer = me, re.length === 0)
        this.comments = [];
      else {
        const $e = this.getStartPosition(de), Pe = this.getEndPosition(de), Le = a.lineForPosition($e, this.lineMap), Ae = a.lineForPosition(Pe, this.lineMap), He = [];
        for (let Te = re.length - 1; Te >= 0; Te--) {
          const we = re[Te];
          we.range.start.line >= Le && we.range.end.line <= Ae && (He.push(we), re.splice(Te, 1));
        }
        this.comments = He;
      }
    }
    getStartPosition(K) {
      return K.parent === null ? 0 : K.kind === o.Kind.MAPPING ? K.key.startPosition : K.startPosition;
    }
    getEndPosition(K) {
      switch (K.kind) {
        case o.Kind.MAPPING:
          return K.value === null ? K.endPosition : this.getEndPosition(K.value);
        case o.Kind.MAP:
          return K.mappings.length === 0 ? K.endPosition : K.mappings[K.mappings.length - 1].endPosition;
        case o.Kind.SEQ: {
          if (K.items.length === 0)
            return K.endPosition;
          const re = K.items[K.items.length - 1];
          return re === null ? K.endPosition : re.endPosition;
        }
        default:
          return K.endPosition;
      }
    }
    static mapComments(K, re) {
      return K.map((de) => ({
        value: de.value,
        range: Z(re, de.startPosition, de.endPosition),
        startPosition: de.startPosition,
        endPosition: de.endPosition
      }));
    }
    enter(K, re) {
      return new te(this.attachedComments, this.comments, K, this.lineMap, re === void 0 ? this.pointer : `${this.pointer}/${re}`);
    }
    static isLeading(K, re) {
      switch (K.kind) {
        case o.Kind.MAP:
          return K.mappings.length === 0 || K.mappings[0].startPosition > re;
        case o.Kind.SEQ: {
          if (K.items.length === 0)
            return !0;
          const de = K.items[0];
          return de === null || de.startPosition > re;
        }
        case o.Kind.MAPPING:
          return K.value === null || K.value.startPosition > re;
        default:
          return !1;
      }
    }
    static isTrailing(K, re) {
      switch (K.kind) {
        case o.Kind.MAP:
          return K.mappings.length > 0 && re > K.mappings[K.mappings.length - 1].endPosition;
        case o.Kind.SEQ:
          if (K.items.length === 0)
            return !1;
          const de = K.items[K.items.length - 1];
          return de !== null && re > de.endPosition;
        case o.Kind.MAPPING:
          return K.value !== null && re > K.value.endPosition;
        default:
          return !1;
      }
    }
    static findBetween(K, re, de) {
      switch (K.kind) {
        case o.Kind.MAP: {
          let ie;
          for (const me of K.mappings)
            if (re > me.startPosition)
              ie = me.key.value;
            else if (ie !== void 0 && me.startPosition > de)
              return [ie, me.key.value];
          return null;
        }
        case o.Kind.SEQ: {
          let ie;
          for (let me = 0; me < K.items.length; me++) {
            const $e = K.items[me];
            if ($e !== null) {
              if (re > $e.startPosition)
                ie = String(me);
              else if (ie !== void 0 && $e.startPosition > de)
                return [ie, String(me)];
            }
          }
          return null;
        }
        default:
          return null;
      }
    }
    isBeforeEOL(K) {
      return this.node.kind === o.Kind.SCALAR || this.node.kind === o.Kind.MAPPING && K.range.end.line === a.lineForPosition(this.node.key.endPosition, this.lineMap);
    }
    attachComments() {
      if (this.comments.length === 0)
        return;
      const K = this.attachedComments[this.pointer] = this.attachedComments[this.pointer] || [];
      for (const re of this.comments)
        if (this.isBeforeEOL(re))
          K.push({
            value: re.value,
            placement: "before-eol"
          });
        else if (te.isLeading(this.node, re.startPosition))
          K.push({
            value: re.value,
            placement: "leading"
          });
        else if (te.isTrailing(this.node, re.endPosition))
          K.push({
            value: re.value,
            placement: "trailing"
          });
        else {
          const de = te.findBetween(this.node, re.startPosition, re.endPosition);
          de !== null ? K.push({
            value: re.value,
            placement: "between",
            between: de
          }) : K.push({
            value: re.value,
            placement: "trailing"
          });
        }
    }
  }
  function se(ee) {
    return ee === void 0 ? {
      attachComments: !1,
      preserveKeyOrder: !1,
      bigInt: !1,
      mergeKeys: !1,
      json: !0,
      ignoreDuplicateKeys: !1
    } : Object.assign({}, ee, { attachComments: ee.attachComments === !0, preserveKeyOrder: ee.preserveKeyOrder === !0, bigInt: ee.bigInt === !0, mergeKeys: ee.mergeKeys === !0, json: ee.json !== !1, ignoreDuplicateKeys: ee.ignoreDuplicateKeys !== !1 });
  }
  return pd;
}
var g4;
function ZB() {
  if (g4) return fd;
  g4 = 1, Object.defineProperty(fd, "__esModule", { value: !0 });
  const e = /* @__PURE__ */ ek();
  return fd.parse = (t) => e.parseWithPointers(t).data, fd;
}
var dd = {}, v4;
function YB() {
  if (v4) return dd;
  v4 = 1, Object.defineProperty(dd, "__esModule", { value: !0 });
  const e = q2();
  return dd.safeStringify = (t, n) => typeof t == "string" ? t : e.safeDump(t, n), dd;
}
var E5 = {}, y4;
function JB() {
  return y4 || (y4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = XA();
    e.KEYS = Symbol.for(t.ORDER_KEY_ID);
    const n = {
      ownKeys(r) {
        return e.KEYS in r ? r[e.KEYS] : Reflect.ownKeys(r);
      }
    };
    e.trapAccess = (r) => new Proxy(r, n);
  }(E5)), E5;
}
var b4;
function QB() {
  return b4 || (b4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const t = M0;
    t.__exportStar(/* @__PURE__ */ D2(), e), t.__exportStar(/* @__PURE__ */ QA(), e), t.__exportStar(/* @__PURE__ */ VB(), e), t.__exportStar(/* @__PURE__ */ WB(), e), t.__exportStar(/* @__PURE__ */ L2(), e);
    var n = /* @__PURE__ */ ZB();
    e.parse = n.parse;
    var r = /* @__PURE__ */ ek();
    e.parseWithPointers = r.parseWithPointers, t.__exportStar(/* @__PURE__ */ YB(), e), t.__exportStar(/* @__PURE__ */ Ac(), e), t.__exportStar(/* @__PURE__ */ JB(), e);
  }(Jh)), Jh;
}
var XB = /* @__PURE__ */ QB(), tk = {}, z0 = {};
z0.byteLength = rU;
z0.toByteArray = iU;
z0.fromByteArray = sU;
var yo = [], Ea = [], eU = typeof Uint8Array < "u" ? Uint8Array : Array, O5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Vu = 0, tU = O5.length; Vu < tU; ++Vu)
  yo[Vu] = O5[Vu], Ea[O5.charCodeAt(Vu)] = Vu;
Ea[45] = 62;
Ea[95] = 63;
function rk(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function rU(e) {
  var t = rk(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function nU(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function iU(e) {
  var t, n = rk(e), r = n[0], i = n[1], a = new eU(nU(e, r, i)), o = 0, c = i > 0 ? r - 4 : r, u;
  for (u = 0; u < c; u += 4)
    t = Ea[e.charCodeAt(u)] << 18 | Ea[e.charCodeAt(u + 1)] << 12 | Ea[e.charCodeAt(u + 2)] << 6 | Ea[e.charCodeAt(u + 3)], a[o++] = t >> 16 & 255, a[o++] = t >> 8 & 255, a[o++] = t & 255;
  return i === 2 && (t = Ea[e.charCodeAt(u)] << 2 | Ea[e.charCodeAt(u + 1)] >> 4, a[o++] = t & 255), i === 1 && (t = Ea[e.charCodeAt(u)] << 10 | Ea[e.charCodeAt(u + 1)] << 4 | Ea[e.charCodeAt(u + 2)] >> 2, a[o++] = t >> 8 & 255, a[o++] = t & 255), a;
}
function aU(e) {
  return yo[e >> 18 & 63] + yo[e >> 12 & 63] + yo[e >> 6 & 63] + yo[e & 63];
}
function oU(e, t, n) {
  for (var r, i = [], a = t; a < n; a += 3)
    r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (e[a + 2] & 255), i.push(aU(r));
  return i.join("");
}
function sU(e) {
  for (var t, n = e.length, r = n % 3, i = [], a = 16383, o = 0, c = n - r; o < c; o += a)
    i.push(oU(e, o, o + a > c ? c : o + a));
  return r === 1 ? (t = e[n - 1], i.push(
    yo[t >> 2] + yo[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i.push(
    yo[t >> 10] + yo[t >> 4 & 63] + yo[t << 2 & 63] + "="
  )), i.join("");
}
var N2 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
N2.read = function(e, t, n, r, i) {
  var a, o, c = i * 8 - r - 1, u = (1 << c) - 1, s = u >> 1, f = -7, d = n ? i - 1 : 0, l = n ? -1 : 1, p = e[t + d];
  for (d += l, a = p & (1 << -f) - 1, p >>= -f, f += c; f > 0; a = a * 256 + e[t + d], d += l, f -= 8)
    ;
  for (o = a & (1 << -f) - 1, a >>= -f, f += r; f > 0; o = o * 256 + e[t + d], d += l, f -= 8)
    ;
  if (a === 0)
    a = 1 - s;
  else {
    if (a === u)
      return o ? NaN : (p ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), a = a - s;
  }
  return (p ? -1 : 1) * o * Math.pow(2, a - r);
};
N2.write = function(e, t, n, r, i, a) {
  var o, c, u, s = a * 8 - i - 1, f = (1 << s) - 1, d = f >> 1, l = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : a - 1, g = r ? 1 : -1, v = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (c = isNaN(t) ? 1 : 0, o = f) : (o = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -o)) < 1 && (o--, u *= 2), o + d >= 1 ? t += l / u : t += l * Math.pow(2, 1 - d), t * u >= 2 && (o++, u /= 2), o + d >= f ? (c = 0, o = f) : o + d >= 1 ? (c = (t * u - 1) * Math.pow(2, i), o = o + d) : (c = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + p] = c & 255, p += g, c /= 256, i -= 8)
    ;
  for (o = o << i | c, s += i; s > 0; e[n + p] = o & 255, p += g, o /= 256, s -= 8)
    ;
  e[n + p - g] |= v * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = z0, n = N2, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = f, e.SlowBuffer = E, e.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  e.kMaxLength = i;
  const { Uint8Array: a, ArrayBuffer: o, SharedArrayBuffer: c } = globalThis;
  f.TYPED_ARRAY_SUPPORT = u(), !f.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function u() {
    try {
      const F = new a(1), O = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(O, a.prototype), Object.setPrototypeOf(F, O), F.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(f.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (f.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(f.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (f.isBuffer(this))
        return this.byteOffset;
    }
  });
  function s(F) {
    if (F > i)
      throw new RangeError('The value "' + F + '" is invalid for option "size"');
    const O = new a(F);
    return Object.setPrototypeOf(O, f.prototype), O;
  }
  function f(F, O, S) {
    if (typeof F == "number") {
      if (typeof O == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return g(F);
    }
    return d(F, O, S);
  }
  f.poolSize = 8192;
  function d(F, O, S) {
    if (typeof F == "string")
      return v(F, O);
    if (o.isView(F))
      return y(F);
    if (F == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof F
      );
    if (Ke(F, o) || F && Ke(F.buffer, o) || typeof c < "u" && (Ke(F, c) || F && Ke(F.buffer, c)))
      return w(F, O, S);
    if (typeof F == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const _ = F.valueOf && F.valueOf();
    if (_ != null && _ !== F)
      return f.from(_, O, S);
    const h = C(F);
    if (h) return h;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof F[Symbol.toPrimitive] == "function")
      return f.from(F[Symbol.toPrimitive]("string"), O, S);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof F
    );
  }
  f.from = function(F, O, S) {
    return d(F, O, S);
  }, Object.setPrototypeOf(f.prototype, a.prototype), Object.setPrototypeOf(f, a);
  function l(F) {
    if (typeof F != "number")
      throw new TypeError('"size" argument must be of type number');
    if (F < 0)
      throw new RangeError('The value "' + F + '" is invalid for option "size"');
  }
  function p(F, O, S) {
    return l(F), F <= 0 ? s(F) : O !== void 0 ? typeof S == "string" ? s(F).fill(O, S) : s(F).fill(O) : s(F);
  }
  f.alloc = function(F, O, S) {
    return p(F, O, S);
  };
  function g(F) {
    return l(F), s(F < 0 ? 0 : T(F) | 0);
  }
  f.allocUnsafe = function(F) {
    return g(F);
  }, f.allocUnsafeSlow = function(F) {
    return g(F);
  };
  function v(F, O) {
    if ((typeof O != "string" || O === "") && (O = "utf8"), !f.isEncoding(O))
      throw new TypeError("Unknown encoding: " + O);
    const S = D(F, O) | 0;
    let _ = s(S);
    const h = _.write(F, O);
    return h !== S && (_ = _.slice(0, h)), _;
  }
  function b(F) {
    const O = F.length < 0 ? 0 : T(F.length) | 0, S = s(O);
    for (let _ = 0; _ < O; _ += 1)
      S[_] = F[_] & 255;
    return S;
  }
  function y(F) {
    if (Ke(F, a)) {
      const O = new a(F);
      return w(O.buffer, O.byteOffset, O.byteLength);
    }
    return b(F);
  }
  function w(F, O, S) {
    if (O < 0 || F.byteLength < O)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (F.byteLength < O + (S || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let _;
    return O === void 0 && S === void 0 ? _ = new a(F) : S === void 0 ? _ = new a(F, O) : _ = new a(F, O, S), Object.setPrototypeOf(_, f.prototype), _;
  }
  function C(F) {
    if (f.isBuffer(F)) {
      const O = T(F.length) | 0, S = s(O);
      return S.length === 0 || F.copy(S, 0, 0, O), S;
    }
    if (F.length !== void 0)
      return typeof F.length != "number" || $t(F.length) ? s(0) : b(F);
    if (F.type === "Buffer" && Array.isArray(F.data))
      return b(F.data);
  }
  function T(F) {
    if (F >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return F | 0;
  }
  function E(F) {
    return +F != F && (F = 0), f.alloc(+F);
  }
  f.isBuffer = function(O) {
    return O != null && O._isBuffer === !0 && O !== f.prototype;
  }, f.compare = function(O, S) {
    if (Ke(O, a) && (O = f.from(O, O.offset, O.byteLength)), Ke(S, a) && (S = f.from(S, S.offset, S.byteLength)), !f.isBuffer(O) || !f.isBuffer(S))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (O === S) return 0;
    let _ = O.length, h = S.length;
    for (let A = 0, R = Math.min(_, h); A < R; ++A)
      if (O[A] !== S[A]) {
        _ = O[A], h = S[A];
        break;
      }
    return _ < h ? -1 : h < _ ? 1 : 0;
  }, f.isEncoding = function(O) {
    switch (String(O).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, f.concat = function(O, S) {
    if (!Array.isArray(O))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (O.length === 0)
      return f.alloc(0);
    let _;
    if (S === void 0)
      for (S = 0, _ = 0; _ < O.length; ++_)
        S += O[_].length;
    const h = f.allocUnsafe(S);
    let A = 0;
    for (_ = 0; _ < O.length; ++_) {
      let R = O[_];
      if (Ke(R, a))
        A + R.length > h.length ? (f.isBuffer(R) || (R = f.from(R)), R.copy(h, A)) : a.prototype.set.call(
          h,
          R,
          A
        );
      else if (f.isBuffer(R))
        R.copy(h, A);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      A += R.length;
    }
    return h;
  };
  function D(F, O) {
    if (f.isBuffer(F))
      return F.length;
    if (o.isView(F) || Ke(F, o))
      return F.byteLength;
    if (typeof F != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof F
      );
    const S = F.length, _ = arguments.length > 2 && arguments[2] === !0;
    if (!_ && S === 0) return 0;
    let h = !1;
    for (; ; )
      switch (O) {
        case "ascii":
        case "latin1":
        case "binary":
          return S;
        case "utf8":
        case "utf-8":
          return Ee(F).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return S * 2;
        case "hex":
          return S >>> 1;
        case "base64":
          return Me(F).length;
        default:
          if (h)
            return _ ? -1 : Ee(F).length;
          O = ("" + O).toLowerCase(), h = !0;
      }
  }
  f.byteLength = D;
  function $(F, O, S) {
    let _ = !1;
    if ((O === void 0 || O < 0) && (O = 0), O > this.length || ((S === void 0 || S > this.length) && (S = this.length), S <= 0) || (S >>>= 0, O >>>= 0, S <= O))
      return "";
    for (F || (F = "utf8"); ; )
      switch (F) {
        case "hex":
          return Te(this, O, S);
        case "utf8":
        case "utf-8":
          return $e(this, O, S);
        case "ascii":
          return Ae(this, O, S);
        case "latin1":
        case "binary":
          return He(this, O, S);
        case "base64":
          return me(this, O, S);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return we(this, O, S);
        default:
          if (_) throw new TypeError("Unknown encoding: " + F);
          F = (F + "").toLowerCase(), _ = !0;
      }
  }
  f.prototype._isBuffer = !0;
  function Z(F, O, S) {
    const _ = F[O];
    F[O] = F[S], F[S] = _;
  }
  f.prototype.swap16 = function() {
    const O = this.length;
    if (O % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let S = 0; S < O; S += 2)
      Z(this, S, S + 1);
    return this;
  }, f.prototype.swap32 = function() {
    const O = this.length;
    if (O % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let S = 0; S < O; S += 4)
      Z(this, S, S + 3), Z(this, S + 1, S + 2);
    return this;
  }, f.prototype.swap64 = function() {
    const O = this.length;
    if (O % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let S = 0; S < O; S += 8)
      Z(this, S, S + 7), Z(this, S + 1, S + 6), Z(this, S + 2, S + 5), Z(this, S + 3, S + 4);
    return this;
  }, f.prototype.toString = function() {
    const O = this.length;
    return O === 0 ? "" : arguments.length === 0 ? $e(this, 0, O) : $.apply(this, arguments);
  }, f.prototype.toLocaleString = f.prototype.toString, f.prototype.equals = function(O) {
    if (!f.isBuffer(O)) throw new TypeError("Argument must be a Buffer");
    return this === O ? !0 : f.compare(this, O) === 0;
  }, f.prototype.inspect = function() {
    let O = "";
    const S = e.INSPECT_MAX_BYTES;
    return O = this.toString("hex", 0, S).replace(/(.{2})/g, "$1 ").trim(), this.length > S && (O += " ... "), "<Buffer " + O + ">";
  }, r && (f.prototype[r] = f.prototype.inspect), f.prototype.compare = function(O, S, _, h, A) {
    if (Ke(O, a) && (O = f.from(O, O.offset, O.byteLength)), !f.isBuffer(O))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof O
      );
    if (S === void 0 && (S = 0), _ === void 0 && (_ = O ? O.length : 0), h === void 0 && (h = 0), A === void 0 && (A = this.length), S < 0 || _ > O.length || h < 0 || A > this.length)
      throw new RangeError("out of range index");
    if (h >= A && S >= _)
      return 0;
    if (h >= A)
      return -1;
    if (S >= _)
      return 1;
    if (S >>>= 0, _ >>>= 0, h >>>= 0, A >>>= 0, this === O) return 0;
    let R = A - h, I = _ - S;
    const k = Math.min(R, I), j = this.slice(h, A), z = O.slice(S, _);
    for (let H = 0; H < k; ++H)
      if (j[H] !== z[H]) {
        R = j[H], I = z[H];
        break;
      }
    return R < I ? -1 : I < R ? 1 : 0;
  };
  function te(F, O, S, _, h) {
    if (F.length === 0) return -1;
    if (typeof S == "string" ? (_ = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, $t(S) && (S = h ? 0 : F.length - 1), S < 0 && (S = F.length + S), S >= F.length) {
      if (h) return -1;
      S = F.length - 1;
    } else if (S < 0)
      if (h) S = 0;
      else return -1;
    if (typeof O == "string" && (O = f.from(O, _)), f.isBuffer(O))
      return O.length === 0 ? -1 : se(F, O, S, _, h);
    if (typeof O == "number")
      return O = O & 255, typeof a.prototype.indexOf == "function" ? h ? a.prototype.indexOf.call(F, O, S) : a.prototype.lastIndexOf.call(F, O, S) : se(F, [O], S, _, h);
    throw new TypeError("val must be string, number or Buffer");
  }
  function se(F, O, S, _, h) {
    let A = 1, R = F.length, I = O.length;
    if (_ !== void 0 && (_ = String(_).toLowerCase(), _ === "ucs2" || _ === "ucs-2" || _ === "utf16le" || _ === "utf-16le")) {
      if (F.length < 2 || O.length < 2)
        return -1;
      A = 2, R /= 2, I /= 2, S /= 2;
    }
    function k(z, H) {
      return A === 1 ? z[H] : z.readUInt16BE(H * A);
    }
    let j;
    if (h) {
      let z = -1;
      for (j = S; j < R; j++)
        if (k(F, j) === k(O, z === -1 ? 0 : j - z)) {
          if (z === -1 && (z = j), j - z + 1 === I) return z * A;
        } else
          z !== -1 && (j -= j - z), z = -1;
    } else
      for (S + I > R && (S = R - I), j = S; j >= 0; j--) {
        let z = !0;
        for (let H = 0; H < I; H++)
          if (k(F, j + H) !== k(O, H)) {
            z = !1;
            break;
          }
        if (z) return j;
      }
    return -1;
  }
  f.prototype.includes = function(O, S, _) {
    return this.indexOf(O, S, _) !== -1;
  }, f.prototype.indexOf = function(O, S, _) {
    return te(this, O, S, _, !0);
  }, f.prototype.lastIndexOf = function(O, S, _) {
    return te(this, O, S, _, !1);
  };
  function ee(F, O, S, _) {
    S = Number(S) || 0;
    const h = F.length - S;
    _ ? (_ = Number(_), _ > h && (_ = h)) : _ = h;
    const A = O.length;
    _ > A / 2 && (_ = A / 2);
    let R;
    for (R = 0; R < _; ++R) {
      const I = parseInt(O.substr(R * 2, 2), 16);
      if ($t(I)) return R;
      F[S + R] = I;
    }
    return R;
  }
  function K(F, O, S, _) {
    return Xe(Ee(O, F.length - S), F, S, _);
  }
  function re(F, O, S, _) {
    return Xe(N(O), F, S, _);
  }
  function de(F, O, S, _) {
    return Xe(Me(O), F, S, _);
  }
  function ie(F, O, S, _) {
    return Xe(Se(O, F.length - S), F, S, _);
  }
  f.prototype.write = function(O, S, _, h) {
    if (S === void 0)
      h = "utf8", _ = this.length, S = 0;
    else if (_ === void 0 && typeof S == "string")
      h = S, _ = this.length, S = 0;
    else if (isFinite(S))
      S = S >>> 0, isFinite(_) ? (_ = _ >>> 0, h === void 0 && (h = "utf8")) : (h = _, _ = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const A = this.length - S;
    if ((_ === void 0 || _ > A) && (_ = A), O.length > 0 && (_ < 0 || S < 0) || S > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    h || (h = "utf8");
    let R = !1;
    for (; ; )
      switch (h) {
        case "hex":
          return ee(this, O, S, _);
        case "utf8":
        case "utf-8":
          return K(this, O, S, _);
        case "ascii":
        case "latin1":
        case "binary":
          return re(this, O, S, _);
        case "base64":
          return de(this, O, S, _);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ie(this, O, S, _);
        default:
          if (R) throw new TypeError("Unknown encoding: " + h);
          h = ("" + h).toLowerCase(), R = !0;
      }
  }, f.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function me(F, O, S) {
    return O === 0 && S === F.length ? t.fromByteArray(F) : t.fromByteArray(F.slice(O, S));
  }
  function $e(F, O, S) {
    S = Math.min(F.length, S);
    const _ = [];
    let h = O;
    for (; h < S; ) {
      const A = F[h];
      let R = null, I = A > 239 ? 4 : A > 223 ? 3 : A > 191 ? 2 : 1;
      if (h + I <= S) {
        let k, j, z, H;
        switch (I) {
          case 1:
            A < 128 && (R = A);
            break;
          case 2:
            k = F[h + 1], (k & 192) === 128 && (H = (A & 31) << 6 | k & 63, H > 127 && (R = H));
            break;
          case 3:
            k = F[h + 1], j = F[h + 2], (k & 192) === 128 && (j & 192) === 128 && (H = (A & 15) << 12 | (k & 63) << 6 | j & 63, H > 2047 && (H < 55296 || H > 57343) && (R = H));
            break;
          case 4:
            k = F[h + 1], j = F[h + 2], z = F[h + 3], (k & 192) === 128 && (j & 192) === 128 && (z & 192) === 128 && (H = (A & 15) << 18 | (k & 63) << 12 | (j & 63) << 6 | z & 63, H > 65535 && H < 1114112 && (R = H));
        }
      }
      R === null ? (R = 65533, I = 1) : R > 65535 && (R -= 65536, _.push(R >>> 10 & 1023 | 55296), R = 56320 | R & 1023), _.push(R), h += I;
    }
    return Le(_);
  }
  const Pe = 4096;
  function Le(F) {
    const O = F.length;
    if (O <= Pe)
      return String.fromCharCode.apply(String, F);
    let S = "", _ = 0;
    for (; _ < O; )
      S += String.fromCharCode.apply(
        String,
        F.slice(_, _ += Pe)
      );
    return S;
  }
  function Ae(F, O, S) {
    let _ = "";
    S = Math.min(F.length, S);
    for (let h = O; h < S; ++h)
      _ += String.fromCharCode(F[h] & 127);
    return _;
  }
  function He(F, O, S) {
    let _ = "";
    S = Math.min(F.length, S);
    for (let h = O; h < S; ++h)
      _ += String.fromCharCode(F[h]);
    return _;
  }
  function Te(F, O, S) {
    const _ = F.length;
    (!O || O < 0) && (O = 0), (!S || S < 0 || S > _) && (S = _);
    let h = "";
    for (let A = O; A < S; ++A)
      h += Be[F[A]];
    return h;
  }
  function we(F, O, S) {
    const _ = F.slice(O, S);
    let h = "";
    for (let A = 0; A < _.length - 1; A += 2)
      h += String.fromCharCode(_[A] + _[A + 1] * 256);
    return h;
  }
  f.prototype.slice = function(O, S) {
    const _ = this.length;
    O = ~~O, S = S === void 0 ? _ : ~~S, O < 0 ? (O += _, O < 0 && (O = 0)) : O > _ && (O = _), S < 0 ? (S += _, S < 0 && (S = 0)) : S > _ && (S = _), S < O && (S = O);
    const h = this.subarray(O, S);
    return Object.setPrototypeOf(h, f.prototype), h;
  };
  function qe(F, O, S) {
    if (F % 1 !== 0 || F < 0) throw new RangeError("offset is not uint");
    if (F + O > S) throw new RangeError("Trying to access beyond buffer length");
  }
  f.prototype.readUintLE = f.prototype.readUIntLE = function(O, S, _) {
    O = O >>> 0, S = S >>> 0, _ || qe(O, S, this.length);
    let h = this[O], A = 1, R = 0;
    for (; ++R < S && (A *= 256); )
      h += this[O + R] * A;
    return h;
  }, f.prototype.readUintBE = f.prototype.readUIntBE = function(O, S, _) {
    O = O >>> 0, S = S >>> 0, _ || qe(O, S, this.length);
    let h = this[O + --S], A = 1;
    for (; S > 0 && (A *= 256); )
      h += this[O + --S] * A;
    return h;
  }, f.prototype.readUint8 = f.prototype.readUInt8 = function(O, S) {
    return O = O >>> 0, S || qe(O, 1, this.length), this[O];
  }, f.prototype.readUint16LE = f.prototype.readUInt16LE = function(O, S) {
    return O = O >>> 0, S || qe(O, 2, this.length), this[O] | this[O + 1] << 8;
  }, f.prototype.readUint16BE = f.prototype.readUInt16BE = function(O, S) {
    return O = O >>> 0, S || qe(O, 2, this.length), this[O] << 8 | this[O + 1];
  }, f.prototype.readUint32LE = f.prototype.readUInt32LE = function(O, S) {
    return O = O >>> 0, S || qe(O, 4, this.length), (this[O] | this[O + 1] << 8 | this[O + 2] << 16) + this[O + 3] * 16777216;
  }, f.prototype.readUint32BE = f.prototype.readUInt32BE = function(O, S) {
    return O = O >>> 0, S || qe(O, 4, this.length), this[O] * 16777216 + (this[O + 1] << 16 | this[O + 2] << 8 | this[O + 3]);
  }, f.prototype.readBigUInt64LE = P(function(O) {
    O = O >>> 0, ye(O, "offset");
    const S = this[O], _ = this[O + 7];
    (S === void 0 || _ === void 0) && G(O, this.length - 8);
    const h = S + this[++O] * 2 ** 8 + this[++O] * 2 ** 16 + this[++O] * 2 ** 24, A = this[++O] + this[++O] * 2 ** 8 + this[++O] * 2 ** 16 + _ * 2 ** 24;
    return BigInt(h) + (BigInt(A) << BigInt(32));
  }), f.prototype.readBigUInt64BE = P(function(O) {
    O = O >>> 0, ye(O, "offset");
    const S = this[O], _ = this[O + 7];
    (S === void 0 || _ === void 0) && G(O, this.length - 8);
    const h = S * 2 ** 24 + this[++O] * 2 ** 16 + this[++O] * 2 ** 8 + this[++O], A = this[++O] * 2 ** 24 + this[++O] * 2 ** 16 + this[++O] * 2 ** 8 + _;
    return (BigInt(h) << BigInt(32)) + BigInt(A);
  }), f.prototype.readIntLE = function(O, S, _) {
    O = O >>> 0, S = S >>> 0, _ || qe(O, S, this.length);
    let h = this[O], A = 1, R = 0;
    for (; ++R < S && (A *= 256); )
      h += this[O + R] * A;
    return A *= 128, h >= A && (h -= Math.pow(2, 8 * S)), h;
  }, f.prototype.readIntBE = function(O, S, _) {
    O = O >>> 0, S = S >>> 0, _ || qe(O, S, this.length);
    let h = S, A = 1, R = this[O + --h];
    for (; h > 0 && (A *= 256); )
      R += this[O + --h] * A;
    return A *= 128, R >= A && (R -= Math.pow(2, 8 * S)), R;
  }, f.prototype.readInt8 = function(O, S) {
    return O = O >>> 0, S || qe(O, 1, this.length), this[O] & 128 ? (255 - this[O] + 1) * -1 : this[O];
  }, f.prototype.readInt16LE = function(O, S) {
    O = O >>> 0, S || qe(O, 2, this.length);
    const _ = this[O] | this[O + 1] << 8;
    return _ & 32768 ? _ | 4294901760 : _;
  }, f.prototype.readInt16BE = function(O, S) {
    O = O >>> 0, S || qe(O, 2, this.length);
    const _ = this[O + 1] | this[O] << 8;
    return _ & 32768 ? _ | 4294901760 : _;
  }, f.prototype.readInt32LE = function(O, S) {
    return O = O >>> 0, S || qe(O, 4, this.length), this[O] | this[O + 1] << 8 | this[O + 2] << 16 | this[O + 3] << 24;
  }, f.prototype.readInt32BE = function(O, S) {
    return O = O >>> 0, S || qe(O, 4, this.length), this[O] << 24 | this[O + 1] << 16 | this[O + 2] << 8 | this[O + 3];
  }, f.prototype.readBigInt64LE = P(function(O) {
    O = O >>> 0, ye(O, "offset");
    const S = this[O], _ = this[O + 7];
    (S === void 0 || _ === void 0) && G(O, this.length - 8);
    const h = this[O + 4] + this[O + 5] * 2 ** 8 + this[O + 6] * 2 ** 16 + (_ << 24);
    return (BigInt(h) << BigInt(32)) + BigInt(S + this[++O] * 2 ** 8 + this[++O] * 2 ** 16 + this[++O] * 2 ** 24);
  }), f.prototype.readBigInt64BE = P(function(O) {
    O = O >>> 0, ye(O, "offset");
    const S = this[O], _ = this[O + 7];
    (S === void 0 || _ === void 0) && G(O, this.length - 8);
    const h = (S << 24) + // Overflow
    this[++O] * 2 ** 16 + this[++O] * 2 ** 8 + this[++O];
    return (BigInt(h) << BigInt(32)) + BigInt(this[++O] * 2 ** 24 + this[++O] * 2 ** 16 + this[++O] * 2 ** 8 + _);
  }), f.prototype.readFloatLE = function(O, S) {
    return O = O >>> 0, S || qe(O, 4, this.length), n.read(this, O, !0, 23, 4);
  }, f.prototype.readFloatBE = function(O, S) {
    return O = O >>> 0, S || qe(O, 4, this.length), n.read(this, O, !1, 23, 4);
  }, f.prototype.readDoubleLE = function(O, S) {
    return O = O >>> 0, S || qe(O, 8, this.length), n.read(this, O, !0, 52, 8);
  }, f.prototype.readDoubleBE = function(O, S) {
    return O = O >>> 0, S || qe(O, 8, this.length), n.read(this, O, !1, 52, 8);
  };
  function Ge(F, O, S, _, h, A) {
    if (!f.isBuffer(F)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (O > h || O < A) throw new RangeError('"value" argument is out of bounds');
    if (S + _ > F.length) throw new RangeError("Index out of range");
  }
  f.prototype.writeUintLE = f.prototype.writeUIntLE = function(O, S, _, h) {
    if (O = +O, S = S >>> 0, _ = _ >>> 0, !h) {
      const I = Math.pow(2, 8 * _) - 1;
      Ge(this, O, S, _, I, 0);
    }
    let A = 1, R = 0;
    for (this[S] = O & 255; ++R < _ && (A *= 256); )
      this[S + R] = O / A & 255;
    return S + _;
  }, f.prototype.writeUintBE = f.prototype.writeUIntBE = function(O, S, _, h) {
    if (O = +O, S = S >>> 0, _ = _ >>> 0, !h) {
      const I = Math.pow(2, 8 * _) - 1;
      Ge(this, O, S, _, I, 0);
    }
    let A = _ - 1, R = 1;
    for (this[S + A] = O & 255; --A >= 0 && (R *= 256); )
      this[S + A] = O / R & 255;
    return S + _;
  }, f.prototype.writeUint8 = f.prototype.writeUInt8 = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 1, 255, 0), this[S] = O & 255, S + 1;
  }, f.prototype.writeUint16LE = f.prototype.writeUInt16LE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 2, 65535, 0), this[S] = O & 255, this[S + 1] = O >>> 8, S + 2;
  }, f.prototype.writeUint16BE = f.prototype.writeUInt16BE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 2, 65535, 0), this[S] = O >>> 8, this[S + 1] = O & 255, S + 2;
  }, f.prototype.writeUint32LE = f.prototype.writeUInt32LE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 4, 4294967295, 0), this[S + 3] = O >>> 24, this[S + 2] = O >>> 16, this[S + 1] = O >>> 8, this[S] = O & 255, S + 4;
  }, f.prototype.writeUint32BE = f.prototype.writeUInt32BE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 4, 4294967295, 0), this[S] = O >>> 24, this[S + 1] = O >>> 16, this[S + 2] = O >>> 8, this[S + 3] = O & 255, S + 4;
  };
  function It(F, O, S, _, h) {
    Vr(O, _, h, F, S, 7);
    let A = Number(O & BigInt(4294967295));
    F[S++] = A, A = A >> 8, F[S++] = A, A = A >> 8, F[S++] = A, A = A >> 8, F[S++] = A;
    let R = Number(O >> BigInt(32) & BigInt(4294967295));
    return F[S++] = R, R = R >> 8, F[S++] = R, R = R >> 8, F[S++] = R, R = R >> 8, F[S++] = R, S;
  }
  function Qe(F, O, S, _, h) {
    Vr(O, _, h, F, S, 7);
    let A = Number(O & BigInt(4294967295));
    F[S + 7] = A, A = A >> 8, F[S + 6] = A, A = A >> 8, F[S + 5] = A, A = A >> 8, F[S + 4] = A;
    let R = Number(O >> BigInt(32) & BigInt(4294967295));
    return F[S + 3] = R, R = R >> 8, F[S + 2] = R, R = R >> 8, F[S + 1] = R, R = R >> 8, F[S] = R, S + 8;
  }
  f.prototype.writeBigUInt64LE = P(function(O, S = 0) {
    return It(this, O, S, BigInt(0), BigInt("0xffffffffffffffff"));
  }), f.prototype.writeBigUInt64BE = P(function(O, S = 0) {
    return Qe(this, O, S, BigInt(0), BigInt("0xffffffffffffffff"));
  }), f.prototype.writeIntLE = function(O, S, _, h) {
    if (O = +O, S = S >>> 0, !h) {
      const k = Math.pow(2, 8 * _ - 1);
      Ge(this, O, S, _, k - 1, -k);
    }
    let A = 0, R = 1, I = 0;
    for (this[S] = O & 255; ++A < _ && (R *= 256); )
      O < 0 && I === 0 && this[S + A - 1] !== 0 && (I = 1), this[S + A] = (O / R >> 0) - I & 255;
    return S + _;
  }, f.prototype.writeIntBE = function(O, S, _, h) {
    if (O = +O, S = S >>> 0, !h) {
      const k = Math.pow(2, 8 * _ - 1);
      Ge(this, O, S, _, k - 1, -k);
    }
    let A = _ - 1, R = 1, I = 0;
    for (this[S + A] = O & 255; --A >= 0 && (R *= 256); )
      O < 0 && I === 0 && this[S + A + 1] !== 0 && (I = 1), this[S + A] = (O / R >> 0) - I & 255;
    return S + _;
  }, f.prototype.writeInt8 = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 1, 127, -128), O < 0 && (O = 255 + O + 1), this[S] = O & 255, S + 1;
  }, f.prototype.writeInt16LE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 2, 32767, -32768), this[S] = O & 255, this[S + 1] = O >>> 8, S + 2;
  }, f.prototype.writeInt16BE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 2, 32767, -32768), this[S] = O >>> 8, this[S + 1] = O & 255, S + 2;
  }, f.prototype.writeInt32LE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 4, 2147483647, -2147483648), this[S] = O & 255, this[S + 1] = O >>> 8, this[S + 2] = O >>> 16, this[S + 3] = O >>> 24, S + 4;
  }, f.prototype.writeInt32BE = function(O, S, _) {
    return O = +O, S = S >>> 0, _ || Ge(this, O, S, 4, 2147483647, -2147483648), O < 0 && (O = 4294967295 + O + 1), this[S] = O >>> 24, this[S + 1] = O >>> 16, this[S + 2] = O >>> 8, this[S + 3] = O & 255, S + 4;
  }, f.prototype.writeBigInt64LE = P(function(O, S = 0) {
    return It(this, O, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), f.prototype.writeBigInt64BE = P(function(O, S = 0) {
    return Qe(this, O, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function jt(F, O, S, _, h, A) {
    if (S + _ > F.length) throw new RangeError("Index out of range");
    if (S < 0) throw new RangeError("Index out of range");
  }
  function We(F, O, S, _, h) {
    return O = +O, S = S >>> 0, h || jt(F, O, S, 4), n.write(F, O, S, _, 23, 4), S + 4;
  }
  f.prototype.writeFloatLE = function(O, S, _) {
    return We(this, O, S, !0, _);
  }, f.prototype.writeFloatBE = function(O, S, _) {
    return We(this, O, S, !1, _);
  };
  function Lt(F, O, S, _, h) {
    return O = +O, S = S >>> 0, h || jt(F, O, S, 8), n.write(F, O, S, _, 52, 8), S + 8;
  }
  f.prototype.writeDoubleLE = function(O, S, _) {
    return Lt(this, O, S, !0, _);
  }, f.prototype.writeDoubleBE = function(O, S, _) {
    return Lt(this, O, S, !1, _);
  }, f.prototype.copy = function(O, S, _, h) {
    if (!f.isBuffer(O)) throw new TypeError("argument should be a Buffer");
    if (_ || (_ = 0), !h && h !== 0 && (h = this.length), S >= O.length && (S = O.length), S || (S = 0), h > 0 && h < _ && (h = _), h === _ || O.length === 0 || this.length === 0) return 0;
    if (S < 0)
      throw new RangeError("targetStart out of bounds");
    if (_ < 0 || _ >= this.length) throw new RangeError("Index out of range");
    if (h < 0) throw new RangeError("sourceEnd out of bounds");
    h > this.length && (h = this.length), O.length - S < h - _ && (h = O.length - S + _);
    const A = h - _;
    return this === O && typeof a.prototype.copyWithin == "function" ? this.copyWithin(S, _, h) : a.prototype.set.call(
      O,
      this.subarray(_, h),
      S
    ), A;
  }, f.prototype.fill = function(O, S, _, h) {
    if (typeof O == "string") {
      if (typeof S == "string" ? (h = S, S = 0, _ = this.length) : typeof _ == "string" && (h = _, _ = this.length), h !== void 0 && typeof h != "string")
        throw new TypeError("encoding must be a string");
      if (typeof h == "string" && !f.isEncoding(h))
        throw new TypeError("Unknown encoding: " + h);
      if (O.length === 1) {
        const R = O.charCodeAt(0);
        (h === "utf8" && R < 128 || h === "latin1") && (O = R);
      }
    } else typeof O == "number" ? O = O & 255 : typeof O == "boolean" && (O = Number(O));
    if (S < 0 || this.length < S || this.length < _)
      throw new RangeError("Out of range index");
    if (_ <= S)
      return this;
    S = S >>> 0, _ = _ === void 0 ? this.length : _ >>> 0, O || (O = 0);
    let A;
    if (typeof O == "number")
      for (A = S; A < _; ++A)
        this[A] = O;
    else {
      const R = f.isBuffer(O) ? O : f.from(O, h), I = R.length;
      if (I === 0)
        throw new TypeError('The value "' + O + '" is invalid for argument "value"');
      for (A = 0; A < _ - S; ++A)
        this[A + S] = R[A % I];
    }
    return this;
  };
  const Fe = {};
  function Ze(F, O, S) {
    Fe[F] = class extends S {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: O.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${F}]`, this.stack, delete this.name;
      }
      get code() {
        return F;
      }
      set code(h) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: h,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${F}]: ${this.message}`;
      }
    };
  }
  Ze(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(F) {
      return F ? `${F} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Ze(
    "ERR_INVALID_ARG_TYPE",
    function(F, O) {
      return `The "${F}" argument must be of type number. Received type ${typeof O}`;
    },
    TypeError
  ), Ze(
    "ERR_OUT_OF_RANGE",
    function(F, O, S) {
      let _ = `The value of "${F}" is out of range.`, h = S;
      return Number.isInteger(S) && Math.abs(S) > 2 ** 32 ? h = Ue(String(S)) : typeof S == "bigint" && (h = String(S), (S > BigInt(2) ** BigInt(32) || S < -(BigInt(2) ** BigInt(32))) && (h = Ue(h)), h += "n"), _ += ` It must be ${O}. Received ${h}`, _;
    },
    RangeError
  );
  function Ue(F) {
    let O = "", S = F.length;
    const _ = F[0] === "-" ? 1 : 0;
    for (; S >= _ + 4; S -= 3)
      O = `_${F.slice(S - 3, S)}${O}`;
    return `${F.slice(0, S)}${O}`;
  }
  function Rt(F, O, S) {
    ye(O, "offset"), (F[O] === void 0 || F[O + S] === void 0) && G(O, F.length - (S + 1));
  }
  function Vr(F, O, S, _, h, A) {
    if (F > S || F < O) {
      const R = typeof O == "bigint" ? "n" : "";
      let I;
      throw O === 0 || O === BigInt(0) ? I = `>= 0${R} and < 2${R} ** ${(A + 1) * 8}${R}` : I = `>= -(2${R} ** ${(A + 1) * 8 - 1}${R}) and < 2 ** ${(A + 1) * 8 - 1}${R}`, new Fe.ERR_OUT_OF_RANGE("value", I, F);
    }
    Rt(_, h, A);
  }
  function ye(F, O) {
    if (typeof F != "number")
      throw new Fe.ERR_INVALID_ARG_TYPE(O, "number", F);
  }
  function G(F, O, S) {
    throw Math.floor(F) !== F ? (ye(F, S), new Fe.ERR_OUT_OF_RANGE("offset", "an integer", F)) : O < 0 ? new Fe.ERR_BUFFER_OUT_OF_BOUNDS() : new Fe.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${O}`,
      F
    );
  }
  const Y = /[^+/0-9A-Za-z-_]/g;
  function ae(F) {
    if (F = F.split("=")[0], F = F.trim().replace(Y, ""), F.length < 2) return "";
    for (; F.length % 4 !== 0; )
      F = F + "=";
    return F;
  }
  function Ee(F, O) {
    O = O || 1 / 0;
    let S;
    const _ = F.length;
    let h = null;
    const A = [];
    for (let R = 0; R < _; ++R) {
      if (S = F.charCodeAt(R), S > 55295 && S < 57344) {
        if (!h) {
          if (S > 56319) {
            (O -= 3) > -1 && A.push(239, 191, 189);
            continue;
          } else if (R + 1 === _) {
            (O -= 3) > -1 && A.push(239, 191, 189);
            continue;
          }
          h = S;
          continue;
        }
        if (S < 56320) {
          (O -= 3) > -1 && A.push(239, 191, 189), h = S;
          continue;
        }
        S = (h - 55296 << 10 | S - 56320) + 65536;
      } else h && (O -= 3) > -1 && A.push(239, 191, 189);
      if (h = null, S < 128) {
        if ((O -= 1) < 0) break;
        A.push(S);
      } else if (S < 2048) {
        if ((O -= 2) < 0) break;
        A.push(
          S >> 6 | 192,
          S & 63 | 128
        );
      } else if (S < 65536) {
        if ((O -= 3) < 0) break;
        A.push(
          S >> 12 | 224,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else if (S < 1114112) {
        if ((O -= 4) < 0) break;
        A.push(
          S >> 18 | 240,
          S >> 12 & 63 | 128,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return A;
  }
  function N(F) {
    const O = [];
    for (let S = 0; S < F.length; ++S)
      O.push(F.charCodeAt(S) & 255);
    return O;
  }
  function Se(F, O) {
    let S, _, h;
    const A = [];
    for (let R = 0; R < F.length && !((O -= 2) < 0); ++R)
      S = F.charCodeAt(R), _ = S >> 8, h = S % 256, A.push(h), A.push(_);
    return A;
  }
  function Me(F) {
    return t.toByteArray(ae(F));
  }
  function Xe(F, O, S, _) {
    let h;
    for (h = 0; h < _ && !(h + S >= O.length || h >= F.length); ++h)
      O[h + S] = F[h];
    return h;
  }
  function Ke(F, O) {
    return F instanceof O || F != null && F.constructor != null && F.constructor.name != null && F.constructor.name === O.name;
  }
  function $t(F) {
    return F !== F;
  }
  const Be = function() {
    const F = "0123456789abcdef", O = new Array(256);
    for (let S = 0; S < 16; ++S) {
      const _ = S * 16;
      for (let h = 0; h < 16; ++h)
        O[_ + h] = F[S] + F[h];
    }
    return O;
  }();
  function P(F) {
    return typeof BigInt > "u" ? M : F;
  }
  function M() {
    throw new Error("BigInt not supported");
  }
})(tk);
const Dn = tk.Buffer;
var Ha = {}, _a = {};
const uU = !1, cU = /\r?\n/, lU = /\bono[ @]/;
function fU(e) {
  return !!(e && e.configurable && typeof e.get == "function");
}
function pU(e) {
  return !!// If there is no stack property, then it's writable, since assigning it will create it
  (!e || e.writable || typeof e.set == "function");
}
function nk(e, t) {
  let n = ik(e.stack), r = t ? t.stack : void 0;
  return n && r ? n + `

` + r : n || r;
}
function dU(e, t, n) {
  n ? Object.defineProperty(t, "stack", {
    get: () => {
      let r = e.get.apply(t);
      return nk({ stack: r }, n);
    },
    enumerable: !1,
    configurable: !0
  }) : hU(t, e);
}
function ik(e) {
  if (e) {
    let t = e.split(cU), n;
    for (let r = 0; r < t.length; r++) {
      let i = t[r];
      if (lU.test(i))
        n === void 0 && (n = r);
      else if (n !== void 0) {
        t.splice(n, r - n);
        break;
      }
    }
    if (t.length > 0)
      return t.join(`
`);
  }
  return e;
}
function hU(e, t) {
  Object.defineProperty(e, "stack", {
    get: () => ik(t.get.apply(e)),
    enumerable: !1,
    configurable: !0
  });
}
const mU = ["function", "symbol", "undefined"], gU = ["constructor", "prototype", "__proto__"], vU = Object.getPrototypeOf({});
function ak() {
  let e = {}, t = this;
  for (let n of ok(t))
    if (typeof n == "string") {
      let r = t[n], i = typeof r;
      mU.includes(i) || (e[n] = r);
    }
  return e;
}
function ok(e, t = []) {
  let n = [];
  for (; e && e !== vU; )
    n = n.concat(Object.getOwnPropertyNames(e), Object.getOwnPropertySymbols(e)), e = Object.getPrototypeOf(e);
  let r = new Set(n);
  for (let i of t.concat(gU))
    r.delete(i);
  return r;
}
const yU = ["name", "message", "stack"];
function Md(e, t, n) {
  let r = e;
  return bU(r, t), t && typeof t == "object" && xU(r, t), r.toJSON = ak, n && typeof n == "object" && Object.assign(r, n), r;
}
function bU(e, t) {
  let n = Object.getOwnPropertyDescriptor(e, "stack");
  fU(n) ? dU(n, e, t) : pU(n) && (e.stack = nk(e, t));
}
function xU(e, t) {
  let n = ok(t, yU), r = e, i = t;
  for (let a of n)
    if (r[a] === void 0)
      try {
        r[a] = i[a];
      } catch {
      }
}
function _U(e) {
  return e = e || {}, {
    concatMessages: e.concatMessages === void 0 ? !0 : !!e.concatMessages,
    format: e.format === void 0 ? uU : typeof e.format == "function" ? e.format : !1
  };
}
function wU(e, t) {
  let n, r, i, a = "";
  return typeof e[0] == "string" ? i = e : typeof e[1] == "string" ? (e[0] instanceof Error ? n = e[0] : r = e[0], i = e.slice(1)) : (n = e[0], r = e[1], i = e.slice(2)), i.length > 0 && (t.format ? a = t.format.apply(void 0, i) : a = i.join(" ")), t.concatMessages && n && n.message && (a += (a ? ` 
` : "") + n.message), { originalError: n, props: r, message: a };
}
const Ts = $2;
function $2(e, t) {
  t = _U(t);
  function n(...r) {
    let { originalError: i, props: a, message: o } = wU(r, t), c = new e(o);
    return Md(c, i, a);
  }
  return n[Symbol.species] = e, n;
}
$2.toJSON = function(t) {
  return ak.call(t);
};
$2.extend = function(t, n, r) {
  return r || n instanceof Error ? Md(t, n, r) : n ? Md(t, void 0, n) : Md(t);
};
const x4 = wo;
wo.error = new Ts(Error);
wo.eval = new Ts(EvalError);
wo.range = new Ts(RangeError);
wo.reference = new Ts(ReferenceError);
wo.syntax = new Ts(SyntaxError);
wo.type = new Ts(TypeError);
wo.uri = new Ts(URIError);
const SU = wo;
function wo(...e) {
  let t = e[0];
  if (typeof t == "object" && typeof t.name == "string") {
    for (let n of Object.values(SU))
      if (typeof n == "function" && n.name === "ono") {
        let r = n[Symbol.species];
        if (r && r !== Error && (t instanceof r || t.name === r.name))
          return n.apply(void 0, e);
      }
  }
  return wo.error.apply(void 0, e);
}
var T5 = {}, P5 = {}, R5, _4;
function sk() {
  return _4 || (_4 = 1, R5 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), r = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[n] = i;
    for (n in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(t);
    if (a.length !== 1 || a[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var o = Object.getOwnPropertyDescriptor(t, n);
      if (o.value !== i || o.enumerable !== !0)
        return !1;
    }
    return !0;
  }), R5;
}
var j5, w4;
function M2() {
  if (w4) return j5;
  w4 = 1;
  var e = sk();
  return j5 = function() {
    return e() && !!Symbol.toStringTag;
  }, j5;
}
var I5, S4;
function CU() {
  return S4 || (S4 = 1, I5 = Error), I5;
}
var q5, C4;
function AU() {
  return C4 || (C4 = 1, q5 = EvalError), q5;
}
var D5, A4;
function kU() {
  return A4 || (A4 = 1, D5 = RangeError), D5;
}
var L5, k4;
function EU() {
  return k4 || (k4 = 1, L5 = ReferenceError), L5;
}
var N5, E4;
function uk() {
  return E4 || (E4 = 1, N5 = SyntaxError), N5;
}
var $5, O4;
function Kf() {
  return O4 || (O4 = 1, $5 = TypeError), $5;
}
var M5, T4;
function OU() {
  return T4 || (T4 = 1, M5 = URIError), M5;
}
var F5, P4;
function TU() {
  if (P4) return F5;
  P4 = 1;
  var e = typeof Symbol < "u" && Symbol, t = sk();
  return F5 = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, F5;
}
var B5, R4;
function PU() {
  if (R4) return B5;
  R4 = 1;
  var e = {
    __proto__: null,
    foo: {}
  }, t = Object;
  return B5 = function() {
    return { __proto__: e }.foo === e.foo && !(e instanceof t);
  }, B5;
}
var U5, j4;
function RU() {
  if (j4) return U5;
  j4 = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, r = "[object Function]", i = function(u, s) {
    for (var f = [], d = 0; d < u.length; d += 1)
      f[d] = u[d];
    for (var l = 0; l < s.length; l += 1)
      f[l + u.length] = s[l];
    return f;
  }, a = function(u, s) {
    for (var f = [], d = s, l = 0; d < u.length; d += 1, l += 1)
      f[l] = u[d];
    return f;
  }, o = function(c, u) {
    for (var s = "", f = 0; f < c.length; f += 1)
      s += c[f], f + 1 < c.length && (s += u);
    return s;
  };
  return U5 = function(u) {
    var s = this;
    if (typeof s != "function" || t.apply(s) !== r)
      throw new TypeError(e + s);
    for (var f = a(arguments, 1), d, l = function() {
      if (this instanceof d) {
        var y = s.apply(
          this,
          i(f, arguments)
        );
        return Object(y) === y ? y : this;
      }
      return s.apply(
        u,
        i(f, arguments)
      );
    }, p = n(0, s.length - f.length), g = [], v = 0; v < p; v++)
      g[v] = "$" + v;
    if (d = Function("binder", "return function (" + o(g, ",") + "){ return binder.apply(this,arguments); }")(l), s.prototype) {
      var b = function() {
      };
      b.prototype = s.prototype, d.prototype = new b(), b.prototype = null;
    }
    return d;
  }, U5;
}
var H5, I4;
function F2() {
  if (I4) return H5;
  I4 = 1;
  var e = RU();
  return H5 = Function.prototype.bind || e, H5;
}
var z5, q4;
function jU() {
  if (q4) return z5;
  q4 = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = F2();
  return z5 = n.call(e, t), z5;
}
var G5, D4;
function kc() {
  if (D4) return G5;
  D4 = 1;
  var e, t = /* @__PURE__ */ CU(), n = /* @__PURE__ */ AU(), r = /* @__PURE__ */ kU(), i = /* @__PURE__ */ EU(), a = /* @__PURE__ */ uk(), o = /* @__PURE__ */ Kf(), c = /* @__PURE__ */ OU(), u = Function, s = function($e) {
    try {
      return u('"use strict"; return (' + $e + ").constructor;")();
    } catch {
    }
  }, f = Object.getOwnPropertyDescriptor;
  if (f)
    try {
      f({}, "");
    } catch {
      f = null;
    }
  var d = function() {
    throw new o();
  }, l = f ? function() {
    try {
      return arguments.callee, d;
    } catch {
      try {
        return f(arguments, "callee").get;
      } catch {
        return d;
      }
    }
  }() : d, p = TU()(), g = /* @__PURE__ */ PU()(), v = Object.getPrototypeOf || (g ? function($e) {
    return $e.__proto__;
  } : null), b = {}, y = typeof Uint8Array > "u" || !v ? e : v(Uint8Array), w = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": p && v ? v([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": b,
    "%AsyncGenerator%": b,
    "%AsyncGeneratorFunction%": b,
    "%AsyncIteratorPrototype%": b,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": u,
    "%GeneratorFunction%": b,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": p && v ? v(v([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !p || !v ? e : v((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": r,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !p || !v ? e : v((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": p && v ? v(""[Symbol.iterator]()) : e,
    "%Symbol%": p ? Symbol : e,
    "%SyntaxError%": a,
    "%ThrowTypeError%": l,
    "%TypedArray%": y,
    "%TypeError%": o,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": c,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  if (v)
    try {
      null.error;
    } catch ($e) {
      var C = v(v($e));
      w["%Error.prototype%"] = C;
    }
  var T = function $e(Pe) {
    var Le;
    if (Pe === "%AsyncFunction%")
      Le = s("async function () {}");
    else if (Pe === "%GeneratorFunction%")
      Le = s("function* () {}");
    else if (Pe === "%AsyncGeneratorFunction%")
      Le = s("async function* () {}");
    else if (Pe === "%AsyncGenerator%") {
      var Ae = $e("%AsyncGeneratorFunction%");
      Ae && (Le = Ae.prototype);
    } else if (Pe === "%AsyncIteratorPrototype%") {
      var He = $e("%AsyncGenerator%");
      He && v && (Le = v(He.prototype));
    }
    return w[Pe] = Le, Le;
  }, E = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, D = F2(), $ = /* @__PURE__ */ jU(), Z = D.call(Function.call, Array.prototype.concat), te = D.call(Function.apply, Array.prototype.splice), se = D.call(Function.call, String.prototype.replace), ee = D.call(Function.call, String.prototype.slice), K = D.call(Function.call, RegExp.prototype.exec), re = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, de = /\\(\\)?/g, ie = function(Pe) {
    var Le = ee(Pe, 0, 1), Ae = ee(Pe, -1);
    if (Le === "%" && Ae !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (Ae === "%" && Le !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var He = [];
    return se(Pe, re, function(Te, we, qe, Ge) {
      He[He.length] = qe ? se(Ge, de, "$1") : we || Te;
    }), He;
  }, me = function(Pe, Le) {
    var Ae = Pe, He;
    if ($(E, Ae) && (He = E[Ae], Ae = "%" + He[0] + "%"), $(w, Ae)) {
      var Te = w[Ae];
      if (Te === b && (Te = T(Ae)), typeof Te > "u" && !Le)
        throw new o("intrinsic " + Pe + " exists, but is not available. Please file an issue!");
      return {
        alias: He,
        name: Ae,
        value: Te
      };
    }
    throw new a("intrinsic " + Pe + " does not exist!");
  };
  return G5 = function(Pe, Le) {
    if (typeof Pe != "string" || Pe.length === 0)
      throw new o("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Le != "boolean")
      throw new o('"allowMissing" argument must be a boolean');
    if (K(/^%?[^%]*%?$/, Pe) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Ae = ie(Pe), He = Ae.length > 0 ? Ae[0] : "", Te = me("%" + He + "%", Le), we = Te.name, qe = Te.value, Ge = !1, It = Te.alias;
    It && (He = It[0], te(Ae, Z([0, 1], It)));
    for (var Qe = 1, jt = !0; Qe < Ae.length; Qe += 1) {
      var We = Ae[Qe], Lt = ee(We, 0, 1), Fe = ee(We, -1);
      if ((Lt === '"' || Lt === "'" || Lt === "`" || Fe === '"' || Fe === "'" || Fe === "`") && Lt !== Fe)
        throw new a("property names with quotes must have matching quotes");
      if ((We === "constructor" || !jt) && (Ge = !0), He += "." + We, we = "%" + He + "%", $(w, we))
        qe = w[we];
      else if (qe != null) {
        if (!(We in qe)) {
          if (!Le)
            throw new o("base intrinsic for " + Pe + " exists, but the property is not available.");
          return;
        }
        if (f && Qe + 1 >= Ae.length) {
          var Ze = f(qe, We);
          jt = !!Ze, jt && "get" in Ze && !("originalValue" in Ze.get) ? qe = Ze.get : qe = qe[We];
        } else
          jt = $(qe, We), qe = qe[We];
        jt && !Ge && (w[we] = qe);
      }
    }
    return qe;
  }, G5;
}
var V5 = { exports: {} }, W5, L4;
function B2() {
  if (L4) return W5;
  L4 = 1;
  var e = /* @__PURE__ */ kc(), t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return W5 = t, W5;
}
var K5, N4;
function U2() {
  if (N4) return K5;
  N4 = 1;
  var e = /* @__PURE__ */ kc(), t = e("%Object.getOwnPropertyDescriptor%", !0);
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return K5 = t, K5;
}
var Z5, $4;
function IU() {
  if ($4) return Z5;
  $4 = 1;
  var e = /* @__PURE__ */ B2(), t = /* @__PURE__ */ uk(), n = /* @__PURE__ */ Kf(), r = /* @__PURE__ */ U2();
  return Z5 = function(a, o, c) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof o != "string" && typeof o != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var u = arguments.length > 3 ? arguments[3] : null, s = arguments.length > 4 ? arguments[4] : null, f = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, l = !!r && r(a, o);
    if (e)
      e(a, o, {
        configurable: f === null && l ? l.configurable : !f,
        enumerable: u === null && l ? l.enumerable : !u,
        value: c,
        writable: s === null && l ? l.writable : !s
      });
    else if (d || !u && !s && !f)
      a[o] = c;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, Z5;
}
var Y5, M4;
function qU() {
  if (M4) return Y5;
  M4 = 1;
  var e = /* @__PURE__ */ B2(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, Y5 = t, Y5;
}
var J5, F4;
function DU() {
  if (F4) return J5;
  F4 = 1;
  var e = /* @__PURE__ */ kc(), t = /* @__PURE__ */ IU(), n = /* @__PURE__ */ qU()(), r = /* @__PURE__ */ U2(), i = /* @__PURE__ */ Kf(), a = e("%Math.floor%");
  return J5 = function(c, u) {
    if (typeof c != "function")
      throw new i("`fn` is not a function");
    if (typeof u != "number" || u < 0 || u > 4294967295 || a(u) !== u)
      throw new i("`length` must be a positive 32-bit integer");
    var s = arguments.length > 2 && !!arguments[2], f = !0, d = !0;
    if ("length" in c && r) {
      var l = r(c, "length");
      l && !l.configurable && (f = !1), l && !l.writable && (d = !1);
    }
    return (f || d || !s) && (n ? t(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      u,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      u
    )), c;
  }, J5;
}
var B4;
function ck() {
  return B4 || (B4 = 1, function(e) {
    var t = F2(), n = /* @__PURE__ */ kc(), r = /* @__PURE__ */ DU(), i = /* @__PURE__ */ Kf(), a = n("%Function.prototype.apply%"), o = n("%Function.prototype.call%"), c = n("%Reflect.apply%", !0) || t.call(o, a), u = /* @__PURE__ */ B2(), s = n("%Math.max%");
    e.exports = function(l) {
      if (typeof l != "function")
        throw new i("a function is required");
      var p = c(t, o, arguments);
      return r(
        p,
        1 + s(0, l.length - (arguments.length - 1)),
        !0
      );
    };
    var f = function() {
      return c(t, a, arguments);
    };
    u ? u(e.exports, "apply", { value: f }) : e.exports.apply = f;
  }(V5)), V5.exports;
}
var Q5, U4;
function H2() {
  if (U4) return Q5;
  U4 = 1;
  var e = /* @__PURE__ */ kc(), t = ck(), n = t(e("String.prototype.indexOf"));
  return Q5 = function(i, a) {
    var o = e(i, !!a);
    return typeof o == "function" && n(i, ".prototype.") > -1 ? t(o) : o;
  }, Q5;
}
var X5, H4;
function LU() {
  if (H4) return X5;
  H4 = 1;
  var e = M2()(), t = H2(), n = t("Object.prototype.toString"), r = function(c) {
    return e && c && typeof c == "object" && Symbol.toStringTag in c ? !1 : n(c) === "[object Arguments]";
  }, i = function(c) {
    return r(c) ? !0 : c !== null && typeof c == "object" && typeof c.length == "number" && c.length >= 0 && n(c) !== "[object Array]" && n(c.callee) === "[object Function]";
  }, a = function() {
    return r(arguments);
  }();
  return r.isLegacyArguments = i, X5 = a ? r : i, X5;
}
var em, z4;
function NU() {
  if (z4) return em;
  z4 = 1;
  var e = Object.prototype.toString, t = Function.prototype.toString, n = /^\s*(?:function)?\*/, r = M2()(), i = Object.getPrototypeOf, a = function() {
    if (!r)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, o;
  return em = function(u) {
    if (typeof u != "function")
      return !1;
    if (n.test(t.call(u)))
      return !0;
    if (!r) {
      var s = e.call(u);
      return s === "[object GeneratorFunction]";
    }
    if (!i)
      return !1;
    if (typeof o > "u") {
      var f = a();
      o = f ? i(f) : !1;
    }
    return i(u) === o;
  }, em;
}
var tm, G4;
function $U() {
  if (G4) return tm;
  G4 = 1;
  var e = Function.prototype.toString, t = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, r;
  if (typeof t == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, t(function() {
        throw 42;
      }, null, n);
    } catch (w) {
      w !== r && (t = null);
    }
  else
    t = null;
  var i = /^\s*class\b/, a = function(C) {
    try {
      var T = e.call(C);
      return i.test(T);
    } catch {
      return !1;
    }
  }, o = function(C) {
    try {
      return a(C) ? !1 : (e.call(C), !0);
    } catch {
      return !1;
    }
  }, c = Object.prototype.toString, u = "[object Object]", s = "[object Function]", f = "[object GeneratorFunction]", d = "[object HTMLAllCollection]", l = "[object HTML document.all class]", p = "[object HTMLCollection]", g = typeof Symbol == "function" && !!Symbol.toStringTag, v = !(0 in [,]), b = function() {
    return !1;
  };
  if (typeof document == "object") {
    var y = document.all;
    c.call(y) === c.call(document.all) && (b = function(C) {
      if ((v || !C) && (typeof C > "u" || typeof C == "object"))
        try {
          var T = c.call(C);
          return (T === d || T === l || T === p || T === u) && C("") == null;
        } catch {
        }
      return !1;
    });
  }
  return tm = t ? function(C) {
    if (b(C))
      return !0;
    if (!C || typeof C != "function" && typeof C != "object")
      return !1;
    try {
      t(C, null, n);
    } catch (T) {
      if (T !== r)
        return !1;
    }
    return !a(C) && o(C);
  } : function(C) {
    if (b(C))
      return !0;
    if (!C || typeof C != "function" && typeof C != "object")
      return !1;
    if (g)
      return o(C);
    if (a(C))
      return !1;
    var T = c.call(C);
    return T !== s && T !== f && !/^\[object HTML/.test(T) ? !1 : o(C);
  }, tm;
}
var rm, V4;
function MU() {
  if (V4) return rm;
  V4 = 1;
  var e = $U(), t = Object.prototype.toString, n = Object.prototype.hasOwnProperty, r = function(u, s, f) {
    for (var d = 0, l = u.length; d < l; d++)
      n.call(u, d) && (f == null ? s(u[d], d, u) : s.call(f, u[d], d, u));
  }, i = function(u, s, f) {
    for (var d = 0, l = u.length; d < l; d++)
      f == null ? s(u.charAt(d), d, u) : s.call(f, u.charAt(d), d, u);
  }, a = function(u, s, f) {
    for (var d in u)
      n.call(u, d) && (f == null ? s(u[d], d, u) : s.call(f, u[d], d, u));
  }, o = function(u, s, f) {
    if (!e(s))
      throw new TypeError("iterator must be a function");
    var d;
    arguments.length >= 3 && (d = f), t.call(u) === "[object Array]" ? r(u, s, d) : typeof u == "string" ? i(u, s, d) : a(u, s, d);
  };
  return rm = o, rm;
}
var nm, W4;
function FU() {
  return W4 || (W4 = 1, nm = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), nm;
}
var im, K4;
function BU() {
  if (K4) return im;
  K4 = 1;
  var e = /* @__PURE__ */ FU(), t = typeof globalThis > "u" ? Ya : globalThis;
  return im = function() {
    for (var r = [], i = 0; i < e.length; i++)
      typeof t[e[i]] == "function" && (r[r.length] = e[i]);
    return r;
  }, im;
}
var am, Z4;
function lk() {
  if (Z4) return am;
  Z4 = 1;
  var e = MU(), t = /* @__PURE__ */ BU(), n = ck(), r = H2(), i = /* @__PURE__ */ U2(), a = r("Object.prototype.toString"), o = M2()(), c = typeof globalThis > "u" ? Ya : globalThis, u = t(), s = r("String.prototype.slice"), f = Object.getPrototypeOf, d = r("Array.prototype.indexOf", !0) || function(b, y) {
    for (var w = 0; w < b.length; w += 1)
      if (b[w] === y)
        return w;
    return -1;
  }, l = { __proto__: null };
  o && i && f ? e(u, function(v) {
    var b = new c[v]();
    if (Symbol.toStringTag in b) {
      var y = f(b), w = i(y, Symbol.toStringTag);
      if (!w) {
        var C = f(y);
        w = i(C, Symbol.toStringTag);
      }
      l["$" + v] = n(w.get);
    }
  }) : e(u, function(v) {
    var b = new c[v](), y = b.slice || b.set;
    y && (l["$" + v] = n(y));
  });
  var p = function(b) {
    var y = !1;
    return e(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      l,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(w, C) {
        if (!y)
          try {
            "$" + w(b) === C && (y = s(C, 1));
          } catch {
          }
      }
    ), y;
  }, g = function(b) {
    var y = !1;
    return e(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      l,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(w, C) {
        if (!y)
          try {
            w(b), y = s(C, 1);
          } catch {
          }
      }
    ), y;
  };
  return am = function(b) {
    if (!b || typeof b != "object")
      return !1;
    if (!o) {
      var y = s(a(b), 8, -1);
      return d(u, y) > -1 ? y : y !== "Object" ? !1 : g(b);
    }
    return i ? p(b) : null;
  }, am;
}
var om, Y4;
function UU() {
  if (Y4) return om;
  Y4 = 1;
  var e = /* @__PURE__ */ lk();
  return om = function(n) {
    return !!e(n);
  }, om;
}
var J4;
function HU() {
  return J4 || (J4 = 1, function(e) {
    var t = LU(), n = NU(), r = /* @__PURE__ */ lk(), i = /* @__PURE__ */ UU();
    function a(ae) {
      return ae.call.bind(ae);
    }
    var o = typeof BigInt < "u", c = typeof Symbol < "u", u = a(Object.prototype.toString), s = a(Number.prototype.valueOf), f = a(String.prototype.valueOf), d = a(Boolean.prototype.valueOf);
    if (o)
      var l = a(BigInt.prototype.valueOf);
    if (c)
      var p = a(Symbol.prototype.valueOf);
    function g(ae, Ee) {
      if (typeof ae != "object")
        return !1;
      try {
        return Ee(ae), !0;
      } catch {
        return !1;
      }
    }
    e.isArgumentsObject = t, e.isGeneratorFunction = n, e.isTypedArray = i;
    function v(ae) {
      return typeof Promise < "u" && ae instanceof Promise || ae !== null && typeof ae == "object" && typeof ae.then == "function" && typeof ae.catch == "function";
    }
    e.isPromise = v;
    function b(ae) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ae) : i(ae) || we(ae);
    }
    e.isArrayBufferView = b;
    function y(ae) {
      return r(ae) === "Uint8Array";
    }
    e.isUint8Array = y;
    function w(ae) {
      return r(ae) === "Uint8ClampedArray";
    }
    e.isUint8ClampedArray = w;
    function C(ae) {
      return r(ae) === "Uint16Array";
    }
    e.isUint16Array = C;
    function T(ae) {
      return r(ae) === "Uint32Array";
    }
    e.isUint32Array = T;
    function E(ae) {
      return r(ae) === "Int8Array";
    }
    e.isInt8Array = E;
    function D(ae) {
      return r(ae) === "Int16Array";
    }
    e.isInt16Array = D;
    function $(ae) {
      return r(ae) === "Int32Array";
    }
    e.isInt32Array = $;
    function Z(ae) {
      return r(ae) === "Float32Array";
    }
    e.isFloat32Array = Z;
    function te(ae) {
      return r(ae) === "Float64Array";
    }
    e.isFloat64Array = te;
    function se(ae) {
      return r(ae) === "BigInt64Array";
    }
    e.isBigInt64Array = se;
    function ee(ae) {
      return r(ae) === "BigUint64Array";
    }
    e.isBigUint64Array = ee;
    function K(ae) {
      return u(ae) === "[object Map]";
    }
    K.working = typeof Map < "u" && K(/* @__PURE__ */ new Map());
    function re(ae) {
      return typeof Map > "u" ? !1 : K.working ? K(ae) : ae instanceof Map;
    }
    e.isMap = re;
    function de(ae) {
      return u(ae) === "[object Set]";
    }
    de.working = typeof Set < "u" && de(/* @__PURE__ */ new Set());
    function ie(ae) {
      return typeof Set > "u" ? !1 : de.working ? de(ae) : ae instanceof Set;
    }
    e.isSet = ie;
    function me(ae) {
      return u(ae) === "[object WeakMap]";
    }
    me.working = typeof WeakMap < "u" && me(/* @__PURE__ */ new WeakMap());
    function $e(ae) {
      return typeof WeakMap > "u" ? !1 : me.working ? me(ae) : ae instanceof WeakMap;
    }
    e.isWeakMap = $e;
    function Pe(ae) {
      return u(ae) === "[object WeakSet]";
    }
    Pe.working = typeof WeakSet < "u" && Pe(/* @__PURE__ */ new WeakSet());
    function Le(ae) {
      return Pe(ae);
    }
    e.isWeakSet = Le;
    function Ae(ae) {
      return u(ae) === "[object ArrayBuffer]";
    }
    Ae.working = typeof ArrayBuffer < "u" && Ae(new ArrayBuffer());
    function He(ae) {
      return typeof ArrayBuffer > "u" ? !1 : Ae.working ? Ae(ae) : ae instanceof ArrayBuffer;
    }
    e.isArrayBuffer = He;
    function Te(ae) {
      return u(ae) === "[object DataView]";
    }
    Te.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && Te(new DataView(new ArrayBuffer(1), 0, 1));
    function we(ae) {
      return typeof DataView > "u" ? !1 : Te.working ? Te(ae) : ae instanceof DataView;
    }
    e.isDataView = we;
    var qe = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function Ge(ae) {
      return u(ae) === "[object SharedArrayBuffer]";
    }
    function It(ae) {
      return typeof qe > "u" ? !1 : (typeof Ge.working > "u" && (Ge.working = Ge(new qe())), Ge.working ? Ge(ae) : ae instanceof qe);
    }
    e.isSharedArrayBuffer = It;
    function Qe(ae) {
      return u(ae) === "[object AsyncFunction]";
    }
    e.isAsyncFunction = Qe;
    function jt(ae) {
      return u(ae) === "[object Map Iterator]";
    }
    e.isMapIterator = jt;
    function We(ae) {
      return u(ae) === "[object Set Iterator]";
    }
    e.isSetIterator = We;
    function Lt(ae) {
      return u(ae) === "[object Generator]";
    }
    e.isGeneratorObject = Lt;
    function Fe(ae) {
      return u(ae) === "[object WebAssembly.Module]";
    }
    e.isWebAssemblyCompiledModule = Fe;
    function Ze(ae) {
      return g(ae, s);
    }
    e.isNumberObject = Ze;
    function Ue(ae) {
      return g(ae, f);
    }
    e.isStringObject = Ue;
    function Rt(ae) {
      return g(ae, d);
    }
    e.isBooleanObject = Rt;
    function Vr(ae) {
      return o && g(ae, l);
    }
    e.isBigIntObject = Vr;
    function ye(ae) {
      return c && g(ae, p);
    }
    e.isSymbolObject = ye;
    function G(ae) {
      return Ze(ae) || Ue(ae) || Rt(ae) || Vr(ae) || ye(ae);
    }
    e.isBoxedPrimitive = G;
    function Y(ae) {
      return typeof Uint8Array < "u" && (He(ae) || It(ae));
    }
    e.isAnyArrayBuffer = Y, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ae) {
      Object.defineProperty(e, ae, {
        enumerable: !1,
        value: function() {
          throw new Error(ae + " is not supported in userland");
        }
      });
    });
  }(P5)), P5;
}
var sm, Q4;
function zU() {
  return Q4 || (Q4 = 1, sm = function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }), sm;
}
var hd = { exports: {} }, X4;
function GU() {
  return X4 || (X4 = 1, typeof Object.create == "function" ? hd.exports = function(t, n) {
    n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : hd.exports = function(t, n) {
    if (n) {
      t.super_ = n;
      var r = function() {
      };
      r.prototype = n.prototype, t.prototype = new r(), t.prototype.constructor = t;
    }
  }), hd.exports;
}
var ex;
function G0() {
  return ex || (ex = 1, function(e) {
    var t = Object.getOwnPropertyDescriptors || function(we) {
      for (var qe = Object.keys(we), Ge = {}, It = 0; It < qe.length; It++)
        Ge[qe[It]] = Object.getOwnPropertyDescriptor(we, qe[It]);
      return Ge;
    }, n = /%[sdj%]/g;
    e.format = function(Te) {
      if (!E(Te)) {
        for (var we = [], qe = 0; qe < arguments.length; qe++)
          we.push(o(arguments[qe]));
        return we.join(" ");
      }
      for (var qe = 1, Ge = arguments, It = Ge.length, Qe = String(Te).replace(n, function(We) {
        if (We === "%%") return "%";
        if (qe >= It) return We;
        switch (We) {
          case "%s":
            return String(Ge[qe++]);
          case "%d":
            return Number(Ge[qe++]);
          case "%j":
            try {
              return JSON.stringify(Ge[qe++]);
            } catch {
              return "[Circular]";
            }
          default:
            return We;
        }
      }), jt = Ge[qe]; qe < It; jt = Ge[++qe])
        w(jt) || !te(jt) ? Qe += " " + jt : Qe += " " + o(jt);
      return Qe;
    }, e.deprecate = function(Te, we) {
      if (typeof bn < "u" && bn.noDeprecation === !0)
        return Te;
      if (typeof bn > "u")
        return function() {
          return e.deprecate(Te, we).apply(this, arguments);
        };
      var qe = !1;
      function Ge() {
        if (!qe) {
          if (bn.throwDeprecation)
            throw new Error(we);
          bn.traceDeprecation ? console.trace(we) : console.error(we), qe = !0;
        }
        return Te.apply(this, arguments);
      }
      return Ge;
    };
    var r = {}, i = /^$/;
    if (bn.env.NODE_DEBUG) {
      var a = bn.env.NODE_DEBUG;
      a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + a + "$", "i");
    }
    e.debuglog = function(Te) {
      if (Te = Te.toUpperCase(), !r[Te])
        if (i.test(Te)) {
          var we = bn.pid;
          r[Te] = function() {
            var qe = e.format.apply(e, arguments);
            console.error("%s %d: %s", Te, we, qe);
          };
        } else
          r[Te] = function() {
          };
      return r[Te];
    };
    function o(Te, we) {
      var qe = {
        seen: [],
        stylize: u
      };
      return arguments.length >= 3 && (qe.depth = arguments[2]), arguments.length >= 4 && (qe.colors = arguments[3]), y(we) ? qe.showHidden = we : we && e._extend(qe, we), $(qe.showHidden) && (qe.showHidden = !1), $(qe.depth) && (qe.depth = 2), $(qe.colors) && (qe.colors = !1), $(qe.customInspect) && (qe.customInspect = !0), qe.colors && (qe.stylize = c), f(qe, Te, qe.depth);
    }
    e.inspect = o, o.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, o.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function c(Te, we) {
      var qe = o.styles[we];
      return qe ? "\x1B[" + o.colors[qe][0] + "m" + Te + "\x1B[" + o.colors[qe][1] + "m" : Te;
    }
    function u(Te, we) {
      return Te;
    }
    function s(Te) {
      var we = {};
      return Te.forEach(function(qe, Ge) {
        we[qe] = !0;
      }), we;
    }
    function f(Te, we, qe) {
      if (Te.customInspect && we && K(we.inspect) && // Filter out the util module, it's inspect function is special
      we.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
      !(we.constructor && we.constructor.prototype === we)) {
        var Ge = we.inspect(qe, Te);
        return E(Ge) || (Ge = f(Te, Ge, qe)), Ge;
      }
      var It = d(Te, we);
      if (It)
        return It;
      var Qe = Object.keys(we), jt = s(Qe);
      if (Te.showHidden && (Qe = Object.getOwnPropertyNames(we)), ee(we) && (Qe.indexOf("message") >= 0 || Qe.indexOf("description") >= 0))
        return l(we);
      if (Qe.length === 0) {
        if (K(we)) {
          var We = we.name ? ": " + we.name : "";
          return Te.stylize("[Function" + We + "]", "special");
        }
        if (Z(we))
          return Te.stylize(RegExp.prototype.toString.call(we), "regexp");
        if (se(we))
          return Te.stylize(Date.prototype.toString.call(we), "date");
        if (ee(we))
          return l(we);
      }
      var Lt = "", Fe = !1, Ze = ["{", "}"];
      if (b(we) && (Fe = !0, Ze = ["[", "]"]), K(we)) {
        var Ue = we.name ? ": " + we.name : "";
        Lt = " [Function" + Ue + "]";
      }
      if (Z(we) && (Lt = " " + RegExp.prototype.toString.call(we)), se(we) && (Lt = " " + Date.prototype.toUTCString.call(we)), ee(we) && (Lt = " " + l(we)), Qe.length === 0 && (!Fe || we.length == 0))
        return Ze[0] + Lt + Ze[1];
      if (qe < 0)
        return Z(we) ? Te.stylize(RegExp.prototype.toString.call(we), "regexp") : Te.stylize("[Object]", "special");
      Te.seen.push(we);
      var Rt;
      return Fe ? Rt = p(Te, we, qe, jt, Qe) : Rt = Qe.map(function(Vr) {
        return g(Te, we, qe, jt, Vr, Fe);
      }), Te.seen.pop(), v(Rt, Lt, Ze);
    }
    function d(Te, we) {
      if ($(we))
        return Te.stylize("undefined", "undefined");
      if (E(we)) {
        var qe = "'" + JSON.stringify(we).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return Te.stylize(qe, "string");
      }
      if (T(we))
        return Te.stylize("" + we, "number");
      if (y(we))
        return Te.stylize("" + we, "boolean");
      if (w(we))
        return Te.stylize("null", "null");
    }
    function l(Te) {
      return "[" + Error.prototype.toString.call(Te) + "]";
    }
    function p(Te, we, qe, Ge, It) {
      for (var Qe = [], jt = 0, We = we.length; jt < We; ++jt)
        Pe(we, String(jt)) ? Qe.push(g(
          Te,
          we,
          qe,
          Ge,
          String(jt),
          !0
        )) : Qe.push("");
      return It.forEach(function(Lt) {
        Lt.match(/^\d+$/) || Qe.push(g(
          Te,
          we,
          qe,
          Ge,
          Lt,
          !0
        ));
      }), Qe;
    }
    function g(Te, we, qe, Ge, It, Qe) {
      var jt, We, Lt;
      if (Lt = Object.getOwnPropertyDescriptor(we, It) || { value: we[It] }, Lt.get ? Lt.set ? We = Te.stylize("[Getter/Setter]", "special") : We = Te.stylize("[Getter]", "special") : Lt.set && (We = Te.stylize("[Setter]", "special")), Pe(Ge, It) || (jt = "[" + It + "]"), We || (Te.seen.indexOf(Lt.value) < 0 ? (w(qe) ? We = f(Te, Lt.value, null) : We = f(Te, Lt.value, qe - 1), We.indexOf(`
`) > -1 && (Qe ? We = We.split(`
`).map(function(Fe) {
        return "  " + Fe;
      }).join(`
`).slice(2) : We = `
` + We.split(`
`).map(function(Fe) {
        return "   " + Fe;
      }).join(`
`))) : We = Te.stylize("[Circular]", "special")), $(jt)) {
        if (Qe && It.match(/^\d+$/))
          return We;
        jt = JSON.stringify("" + It), jt.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (jt = jt.slice(1, -1), jt = Te.stylize(jt, "name")) : (jt = jt.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), jt = Te.stylize(jt, "string"));
      }
      return jt + ": " + We;
    }
    function v(Te, we, qe) {
      var Ge = Te.reduce(function(It, Qe) {
        return Qe.indexOf(`
`) >= 0, It + Qe.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return Ge > 60 ? qe[0] + (we === "" ? "" : we + `
 `) + " " + Te.join(`,
  `) + " " + qe[1] : qe[0] + we + " " + Te.join(", ") + " " + qe[1];
    }
    e.types = HU();
    function b(Te) {
      return Array.isArray(Te);
    }
    e.isArray = b;
    function y(Te) {
      return typeof Te == "boolean";
    }
    e.isBoolean = y;
    function w(Te) {
      return Te === null;
    }
    e.isNull = w;
    function C(Te) {
      return Te == null;
    }
    e.isNullOrUndefined = C;
    function T(Te) {
      return typeof Te == "number";
    }
    e.isNumber = T;
    function E(Te) {
      return typeof Te == "string";
    }
    e.isString = E;
    function D(Te) {
      return typeof Te == "symbol";
    }
    e.isSymbol = D;
    function $(Te) {
      return Te === void 0;
    }
    e.isUndefined = $;
    function Z(Te) {
      return te(Te) && de(Te) === "[object RegExp]";
    }
    e.isRegExp = Z, e.types.isRegExp = Z;
    function te(Te) {
      return typeof Te == "object" && Te !== null;
    }
    e.isObject = te;
    function se(Te) {
      return te(Te) && de(Te) === "[object Date]";
    }
    e.isDate = se, e.types.isDate = se;
    function ee(Te) {
      return te(Te) && (de(Te) === "[object Error]" || Te instanceof Error);
    }
    e.isError = ee, e.types.isNativeError = ee;
    function K(Te) {
      return typeof Te == "function";
    }
    e.isFunction = K;
    function re(Te) {
      return Te === null || typeof Te == "boolean" || typeof Te == "number" || typeof Te == "string" || typeof Te == "symbol" || // ES6 symbol
      typeof Te > "u";
    }
    e.isPrimitive = re, e.isBuffer = zU();
    function de(Te) {
      return Object.prototype.toString.call(Te);
    }
    function ie(Te) {
      return Te < 10 ? "0" + Te.toString(10) : Te.toString(10);
    }
    var me = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function $e() {
      var Te = /* @__PURE__ */ new Date(), we = [
        ie(Te.getHours()),
        ie(Te.getMinutes()),
        ie(Te.getSeconds())
      ].join(":");
      return [Te.getDate(), me[Te.getMonth()], we].join(" ");
    }
    e.log = function() {
      console.log("%s - %s", $e(), e.format.apply(e, arguments));
    }, e.inherits = GU(), e._extend = function(Te, we) {
      if (!we || !te(we)) return Te;
      for (var qe = Object.keys(we), Ge = qe.length; Ge--; )
        Te[qe[Ge]] = we[qe[Ge]];
      return Te;
    };
    function Pe(Te, we) {
      return Object.prototype.hasOwnProperty.call(Te, we);
    }
    var Le = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    e.promisify = function(we) {
      if (typeof we != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (Le && we[Le]) {
        var qe = we[Le];
        if (typeof qe != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(qe, Le, {
          value: qe,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), qe;
      }
      function qe() {
        for (var Ge, It, Qe = new Promise(function(Lt, Fe) {
          Ge = Lt, It = Fe;
        }), jt = [], We = 0; We < arguments.length; We++)
          jt.push(arguments[We]);
        jt.push(function(Lt, Fe) {
          Lt ? It(Lt) : Ge(Fe);
        });
        try {
          we.apply(this, jt);
        } catch (Lt) {
          It(Lt);
        }
        return Qe;
      }
      return Object.setPrototypeOf(qe, Object.getPrototypeOf(we)), Le && Object.defineProperty(qe, Le, {
        value: qe,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        qe,
        t(we)
      );
    }, e.promisify.custom = Le;
    function Ae(Te, we) {
      if (!Te) {
        var qe = new Error("Promise was rejected with a falsy value");
        qe.reason = Te, Te = qe;
      }
      return we(Te);
    }
    function He(Te) {
      if (typeof Te != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function we() {
        for (var qe = [], Ge = 0; Ge < arguments.length; Ge++)
          qe.push(arguments[Ge]);
        var It = qe.pop();
        if (typeof It != "function")
          throw new TypeError("The last argument must be of type Function");
        var Qe = this, jt = function() {
          return It.apply(Qe, arguments);
        };
        Te.apply(this, qe).then(
          function(We) {
            bn.nextTick(jt.bind(null, null, We));
          },
          function(We) {
            bn.nextTick(Ae.bind(null, We, jt));
          }
        );
      }
      return Object.setPrototypeOf(we, Object.getPrototypeOf(Te)), Object.defineProperties(
        we,
        t(Te)
      ), we;
    }
    e.callbackify = He;
  }(T5)), T5;
}
G0();
const VU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Ono: Ts,
  default: x4,
  ono: x4
}, Symbol.toStringTag, { value: "Module" })), Tu = /* @__PURE__ */ Bf(VU);
var co = {}, za = {}, Hn = {}, Wu = {}, um, tx;
function Ss() {
  if (tx) return um;
  tx = 1;
  function e(i) {
    if (typeof i != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
  }
  function t(i, a) {
    for (var o = "", c = 0, u = -1, s = 0, f, d = 0; d <= i.length; ++d) {
      if (d < i.length)
        f = i.charCodeAt(d);
      else {
        if (f === 47)
          break;
        f = 47;
      }
      if (f === 47) {
        if (!(u === d - 1 || s === 1)) if (u !== d - 1 && s === 2) {
          if (o.length < 2 || c !== 2 || o.charCodeAt(o.length - 1) !== 46 || o.charCodeAt(o.length - 2) !== 46) {
            if (o.length > 2) {
              var l = o.lastIndexOf("/");
              if (l !== o.length - 1) {
                l === -1 ? (o = "", c = 0) : (o = o.slice(0, l), c = o.length - 1 - o.lastIndexOf("/")), u = d, s = 0;
                continue;
              }
            } else if (o.length === 2 || o.length === 1) {
              o = "", c = 0, u = d, s = 0;
              continue;
            }
          }
          a && (o.length > 0 ? o += "/.." : o = "..", c = 2);
        } else
          o.length > 0 ? o += "/" + i.slice(u + 1, d) : o = i.slice(u + 1, d), c = d - u - 1;
        u = d, s = 0;
      } else f === 46 && s !== -1 ? ++s : s = -1;
    }
    return o;
  }
  function n(i, a) {
    var o = a.dir || a.root, c = a.base || (a.name || "") + (a.ext || "");
    return o ? o === a.root ? o + c : o + i + c : c;
  }
  var r = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var a = "", o = !1, c, u = arguments.length - 1; u >= -1 && !o; u--) {
        var s;
        u >= 0 ? s = arguments[u] : (c === void 0 && (c = bn.cwd()), s = c), e(s), s.length !== 0 && (a = s + "/" + a, o = s.charCodeAt(0) === 47);
      }
      return a = t(a, !o), o ? a.length > 0 ? "/" + a : "/" : a.length > 0 ? a : ".";
    },
    normalize: function(a) {
      if (e(a), a.length === 0) return ".";
      var o = a.charCodeAt(0) === 47, c = a.charCodeAt(a.length - 1) === 47;
      return a = t(a, !o), a.length === 0 && !o && (a = "."), a.length > 0 && c && (a += "/"), o ? "/" + a : a;
    },
    isAbsolute: function(a) {
      return e(a), a.length > 0 && a.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var a, o = 0; o < arguments.length; ++o) {
        var c = arguments[o];
        e(c), c.length > 0 && (a === void 0 ? a = c : a += "/" + c);
      }
      return a === void 0 ? "." : r.normalize(a);
    },
    relative: function(a, o) {
      if (e(a), e(o), a === o || (a = r.resolve(a), o = r.resolve(o), a === o)) return "";
      for (var c = 1; c < a.length && a.charCodeAt(c) === 47; ++c)
        ;
      for (var u = a.length, s = u - c, f = 1; f < o.length && o.charCodeAt(f) === 47; ++f)
        ;
      for (var d = o.length, l = d - f, p = s < l ? s : l, g = -1, v = 0; v <= p; ++v) {
        if (v === p) {
          if (l > p) {
            if (o.charCodeAt(f + v) === 47)
              return o.slice(f + v + 1);
            if (v === 0)
              return o.slice(f + v);
          } else s > p && (a.charCodeAt(c + v) === 47 ? g = v : v === 0 && (g = 0));
          break;
        }
        var b = a.charCodeAt(c + v), y = o.charCodeAt(f + v);
        if (b !== y)
          break;
        b === 47 && (g = v);
      }
      var w = "";
      for (v = c + g + 1; v <= u; ++v)
        (v === u || a.charCodeAt(v) === 47) && (w.length === 0 ? w += ".." : w += "/..");
      return w.length > 0 ? w + o.slice(f + g) : (f += g, o.charCodeAt(f) === 47 && ++f, o.slice(f));
    },
    _makeLong: function(a) {
      return a;
    },
    dirname: function(a) {
      if (e(a), a.length === 0) return ".";
      for (var o = a.charCodeAt(0), c = o === 47, u = -1, s = !0, f = a.length - 1; f >= 1; --f)
        if (o = a.charCodeAt(f), o === 47) {
          if (!s) {
            u = f;
            break;
          }
        } else
          s = !1;
      return u === -1 ? c ? "/" : "." : c && u === 1 ? "//" : a.slice(0, u);
    },
    basename: function(a, o) {
      if (o !== void 0 && typeof o != "string") throw new TypeError('"ext" argument must be a string');
      e(a);
      var c = 0, u = -1, s = !0, f;
      if (o !== void 0 && o.length > 0 && o.length <= a.length) {
        if (o.length === a.length && o === a) return "";
        var d = o.length - 1, l = -1;
        for (f = a.length - 1; f >= 0; --f) {
          var p = a.charCodeAt(f);
          if (p === 47) {
            if (!s) {
              c = f + 1;
              break;
            }
          } else
            l === -1 && (s = !1, l = f + 1), d >= 0 && (p === o.charCodeAt(d) ? --d === -1 && (u = f) : (d = -1, u = l));
        }
        return c === u ? u = l : u === -1 && (u = a.length), a.slice(c, u);
      } else {
        for (f = a.length - 1; f >= 0; --f)
          if (a.charCodeAt(f) === 47) {
            if (!s) {
              c = f + 1;
              break;
            }
          } else u === -1 && (s = !1, u = f + 1);
        return u === -1 ? "" : a.slice(c, u);
      }
    },
    extname: function(a) {
      e(a);
      for (var o = -1, c = 0, u = -1, s = !0, f = 0, d = a.length - 1; d >= 0; --d) {
        var l = a.charCodeAt(d);
        if (l === 47) {
          if (!s) {
            c = d + 1;
            break;
          }
          continue;
        }
        u === -1 && (s = !1, u = d + 1), l === 46 ? o === -1 ? o = d : f !== 1 && (f = 1) : o !== -1 && (f = -1);
      }
      return o === -1 || u === -1 || // We saw a non-dot character immediately before the dot
      f === 0 || // The (right-most) trimmed path component is exactly '..'
      f === 1 && o === u - 1 && o === c + 1 ? "" : a.slice(o, u);
    },
    format: function(a) {
      if (a === null || typeof a != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof a);
      return n("/", a);
    },
    parse: function(a) {
      e(a);
      var o = { root: "", dir: "", base: "", ext: "", name: "" };
      if (a.length === 0) return o;
      var c = a.charCodeAt(0), u = c === 47, s;
      u ? (o.root = "/", s = 1) : s = 0;
      for (var f = -1, d = 0, l = -1, p = !0, g = a.length - 1, v = 0; g >= s; --g) {
        if (c = a.charCodeAt(g), c === 47) {
          if (!p) {
            d = g + 1;
            break;
          }
          continue;
        }
        l === -1 && (p = !1, l = g + 1), c === 46 ? f === -1 ? f = g : v !== 1 && (v = 1) : f !== -1 && (v = -1);
      }
      return f === -1 || l === -1 || // We saw a non-dot character immediately before the dot
      v === 0 || // The (right-most) trimmed path component is exactly '..'
      v === 1 && f === l - 1 && f === d + 1 ? l !== -1 && (d === 0 && u ? o.base = o.name = a.slice(1, l) : o.base = o.name = a.slice(d, l)) : (d === 0 && u ? (o.name = a.slice(1, f), o.base = a.slice(1, l)) : (o.name = a.slice(d, f), o.base = a.slice(d, l)), o.ext = a.slice(f, l)), d > 0 ? o.dir = a.slice(0, d - 1) : u && (o.dir = "/"), o;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return r.posix = r, um = r, um;
}
var rx;
function fk() {
  if (rx) return Wu;
  rx = 1;
  var e = Wu && Wu.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Wu, "__esModule", { value: !0 }), Wu.default = n;
  const t = e(Ss());
  function n(r) {
    var a, o, c, u;
    return r.startsWith("\\\\?\\") ? r : r.split((o = (a = t.default) == null ? void 0 : a.win32) == null ? void 0 : o.sep).join(((u = (c = t.default) == null ? void 0 : c.posix) == null ? void 0 : u.sep) ?? "/");
  }
  return Wu;
}
var hl = {}, nx;
function WU() {
  if (nx) return hl;
  nx = 1, Object.defineProperty(hl, "__esModule", { value: !0 }), hl.isWindows = void 0;
  const e = /^win/.test(globalThis.process ? globalThis.process.platform : ""), t = () => e;
  return hl.isWindows = t, hl;
}
var ix;
function ro() {
  if (ix) return Hn;
  ix = 1;
  var e = Hn && Hn.__createBinding || (Object.create ? function(K, re, de, ie) {
    ie === void 0 && (ie = de);
    var me = Object.getOwnPropertyDescriptor(re, de);
    (!me || ("get" in me ? !re.__esModule : me.writable || me.configurable)) && (me = { enumerable: !0, get: function() {
      return re[de];
    } }), Object.defineProperty(K, ie, me);
  } : function(K, re, de, ie) {
    ie === void 0 && (ie = de), K[ie] = re[de];
  }), t = Hn && Hn.__setModuleDefault || (Object.create ? function(K, re) {
    Object.defineProperty(K, "default", { enumerable: !0, value: re });
  } : function(K, re) {
    K.default = re;
  }), n = Hn && Hn.__importStar || /* @__PURE__ */ function() {
    var K = function(re) {
      return K = Object.getOwnPropertyNames || function(de) {
        var ie = [];
        for (var me in de) Object.prototype.hasOwnProperty.call(de, me) && (ie[ie.length] = me);
        return ie;
      }, K(re);
    };
    return function(re) {
      if (re && re.__esModule) return re;
      var de = {};
      if (re != null) for (var ie = K(re), me = 0; me < ie.length; me++) ie[me] !== "default" && e(de, re, ie[me]);
      return t(de, re), de;
    };
  }(), r = Hn && Hn.__importDefault || function(K) {
    return K && K.__esModule ? K : { default: K };
  };
  Object.defineProperty(Hn, "__esModule", { value: !0 }), Hn.parse = void 0, Hn.resolve = v, Hn.cwd = b, Hn.getProtocol = y, Hn.getExtension = w, Hn.stripQuery = C, Hn.getHash = T, Hn.stripHash = E, Hn.isHttp = D, Hn.isFileSystemPath = $, Hn.fromFileSystemPath = Z, Hn.toFileSystemPath = te, Hn.safePointerToPath = se, Hn.relative = ee;
  const i = r(fk()), a = n(Ss()), o = /\//g, c = /^(\w{2,}):\/\//i, u = /~1/g, s = /~0/g, f = Ss(), d = WU(), l = [
    [/\?/g, "%3F"],
    [/#/g, "%23"]
  ], p = [/%23/g, "#", /%24/g, "$", /%26/g, "&", /%2C/g, ",", /%40/g, "@"], g = (K) => new URL(K);
  Hn.parse = g;
  function v(K, re) {
    var $e;
    const de = new URL((0, i.default)(K), "https://aaa.nonexistanturl.com"), ie = new URL((0, i.default)(re), de), me = (($e = re.match(/(\s*)$/)) == null ? void 0 : $e[1]) || "";
    if (ie.hostname === "aaa.nonexistanturl.com") {
      const { pathname: Pe, search: Le, hash: Ae } = ie;
      return Pe + Le + Ae + me;
    }
    return ie.toString() + me;
  }
  function b() {
    if (typeof window < "u")
      return location.href;
    const K = bn.cwd(), re = K.slice(-1);
    return re === "/" || re === "\\" ? K : K + "/";
  }
  function y(K) {
    const re = c.exec(K || "");
    if (re)
      return re[1].toLowerCase();
  }
  function w(K) {
    const re = K.lastIndexOf(".");
    return re >= 0 ? C(K.substr(re).toLowerCase()) : "";
  }
  function C(K) {
    const re = K.indexOf("?");
    return re >= 0 && (K = K.substr(0, re)), K;
  }
  function T(K) {
    if (!K)
      return "#";
    const re = K.indexOf("#");
    return re >= 0 ? K.substring(re) : "#";
  }
  function E(K) {
    if (!K)
      return "";
    const re = K.indexOf("#");
    return re >= 0 && (K = K.substring(0, re)), K;
  }
  function D(K) {
    const re = y(K);
    return re === "http" || re === "https" ? !0 : re === void 0 ? typeof window < "u" : !1;
  }
  function $(K) {
    if (typeof window < "u" || typeof bn < "u" && bn.browser)
      return !1;
    const re = y(K);
    return re === void 0 || re === "file";
  }
  function Z(K) {
    var re;
    if ((0, d.isWindows)()) {
      const de = b(), ie = K.toUpperCase(), $e = (0, i.default)(de).toUpperCase(), Pe = ie.includes($e), Le = ie.includes($e), Ae = ((re = a.win32) == null ? void 0 : re.isAbsolute(K)) || K.startsWith("http://") || K.startsWith("https://") || K.startsWith("file://");
      !(Pe || Le || Ae) && !de.startsWith("http") && (K = (0, f.join)(de, K)), K = (0, i.default)(K);
    }
    K = encodeURI(K);
    for (const de of l)
      K = K.replace(de[0], de[1]);
    return K;
  }
  function te(K, re) {
    K = decodeURI(K);
    for (let ie = 0; ie < p.length; ie += 2)
      K = K.replace(p[ie], p[ie + 1]);
    let de = K.substr(0, 7).toLowerCase() === "file://";
    return de && (K = K[7] === "/" ? K.substr(8) : K.substr(7), (0, d.isWindows)() && K[1] === "/" && (K = K[0] + ":" + K.substr(1)), re ? K = "file:///" + K : (de = !1, K = (0, d.isWindows)() ? K : "/" + K)), (0, d.isWindows)() && !de && (K = K.replace(o, "\\"), K.substr(1, 2) === ":\\" && (K = K[0].toUpperCase() + K.substr(1))), K;
  }
  function se(K) {
    return K.length <= 1 || K[0] !== "#" || K[1] !== "/" ? [] : K.slice(2).split("/").map((re) => decodeURIComponent(re).replace(u, "/").replace(s, "~"));
  }
  function ee(K, re) {
    if (!$(K) || !$(re))
      return v(K, re);
    const de = a.default.dirname(E(K)), ie = E(re);
    return a.default.relative(de, ie) + T(re);
  }
  return Hn;
}
var Qn = {}, ax;
function no() {
  if (ax) return Qn;
  ax = 1, Object.defineProperty(Qn, "__esModule", { value: !0 }), Qn.InvalidPointerError = Qn.TimeoutError = Qn.MissingPointerError = Qn.UnmatchedResolverError = Qn.ResolverError = Qn.UnmatchedParserError = Qn.ParserError = Qn.JSONParserErrorGroup = Qn.JSONParserError = void 0, Qn.isHandledError = d, Qn.normalizeError = l;
  const e = Tu, t = ro();
  class n extends Error {
    constructor(g, v) {
      super(), this.code = "EUNKNOWN", this.name = "JSONParserError", this.message = g, this.source = v, this.path = null, e.Ono.extend(this);
    }
    get footprint() {
      return `${this.path}+${this.source}+${this.code}+${this.message}`;
    }
  }
  Qn.JSONParserError = n;
  class r extends Error {
    constructor(g) {
      super(), this.files = g, this.name = "JSONParserErrorGroup", this.message = `${this.errors.length} error${this.errors.length > 1 ? "s" : ""} occurred while reading '${(0, t.toFileSystemPath)(g.$refs._root$Ref.path)}'`, e.Ono.extend(this);
    }
    static getParserErrors(g) {
      const v = [];
      for (const b of Object.values(g.$refs._$refs))
        b.errors && v.push(...b.errors);
      return v;
    }
    get errors() {
      return r.getParserErrors(this.files);
    }
  }
  Qn.JSONParserErrorGroup = r;
  class i extends n {
    constructor(g, v) {
      super(`Error parsing ${v}: ${g}`, v), this.code = "EPARSER", this.name = "ParserError";
    }
  }
  Qn.ParserError = i;
  class a extends n {
    constructor(g) {
      super(`Could not find parser for "${g}"`, g), this.code = "EUNMATCHEDPARSER", this.name = "UnmatchedParserError";
    }
  }
  Qn.UnmatchedParserError = a;
  class o extends n {
    constructor(g, v) {
      super(g.message || `Error reading file "${v}"`, v), this.code = "ERESOLVER", this.name = "ResolverError", "code" in g && (this.ioErrorCode = String(g.code));
    }
  }
  Qn.ResolverError = o;
  class c extends n {
    constructor(g) {
      super(`Could not find resolver for "${g}"`, g), this.code = "EUNMATCHEDRESOLVER", this.name = "UnmatchedResolverError";
    }
  }
  Qn.UnmatchedResolverError = c;
  class u extends n {
    constructor(g, v, b, y, w) {
      super(`Missing $ref pointer "${(0, t.getHash)(v)}". Token "${g}" does not exist.`, (0, t.stripHash)(v)), this.code = "EMISSINGPOINTER", this.name = "MissingPointerError", this.targetToken = g, this.targetRef = b, this.targetFound = y, this.parentPath = w;
    }
  }
  Qn.MissingPointerError = u;
  class s extends n {
    constructor(g) {
      super(`Dereferencing timeout reached: ${g}ms`), this.code = "ETIMEOUT", this.name = "TimeoutError";
    }
  }
  Qn.TimeoutError = s;
  class f extends n {
    constructor(g, v) {
      super(`Invalid $ref pointer "${g}". Pointers must begin with "#/"`, (0, t.stripHash)(v)), this.code = "EUNMATCHEDRESOLVER", this.name = "InvalidPointerError";
    }
  }
  Qn.InvalidPointerError = f;
  function d(p) {
    return p instanceof n || p instanceof r;
  }
  function l(p) {
    return p.path === null && (p.path = []), p;
  }
  return Qn;
}
var ox;
function V0() {
  return ox || (ox = 1, function(e) {
    var t = za && za.__createBinding || (Object.create ? function(w, C, T, E) {
      E === void 0 && (E = T);
      var D = Object.getOwnPropertyDescriptor(C, T);
      (!D || ("get" in D ? !C.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
        return C[T];
      } }), Object.defineProperty(w, E, D);
    } : function(w, C, T, E) {
      E === void 0 && (E = T), w[E] = C[T];
    }), n = za && za.__setModuleDefault || (Object.create ? function(w, C) {
      Object.defineProperty(w, "default", { enumerable: !0, value: C });
    } : function(w, C) {
      w.default = C;
    }), r = za && za.__importStar || /* @__PURE__ */ function() {
      var w = function(C) {
        return w = Object.getOwnPropertyNames || function(T) {
          var E = [];
          for (var D in T) Object.prototype.hasOwnProperty.call(T, D) && (E[E.length] = D);
          return E;
        }, w(C);
      };
      return function(C) {
        if (C && C.__esModule) return C;
        var T = {};
        if (C != null) for (var E = w(C), D = 0; D < E.length; D++) E[D] !== "default" && t(T, C, E[D]);
        return n(T, C), T;
      };
    }(), i = za && za.__importDefault || function(w) {
      return w && w.__esModule ? w : { default: w };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.nullSymbol = void 0;
    const a = i(Zf()), o = r(ro()), c = no();
    e.nullSymbol = Symbol("null");
    const u = /\//g, s = /~/g, f = /~1/g, d = /~0/g, l = (w) => {
      try {
        return decodeURIComponent(w);
      } catch {
        return w;
      }
    };
    class p {
      constructor(C, T, E) {
        this.$ref = C, this.path = T, this.originalPath = E || T, this.value = void 0, this.circular = !1, this.indirections = 0;
      }
      /**
       * Resolves the value of a nested property within the given object.
       *
       * @param obj - The object that will be crawled
       * @param options
       * @param pathFromRoot - the path of place that initiated resolving
       *
       * @returns
       * Returns a JSON pointer whose {@link Pointer#value} is the resolved value.
       * If resolving this value required resolving other JSON references, then
       * the {@link Pointer#$ref} and {@link Pointer#path} will reflect the resolution path
       * of the resolved value.
       */
      resolve(C, T, E) {
        const D = p.parse(this.path, this.originalPath), $ = [];
        this.value = b(C);
        for (let Z = 0; Z < D.length; Z++) {
          if (g(this, T, E) && (this.path = p.join(this.path, D.slice(Z))), typeof this.value == "object" && this.value !== null && !y(E) && "$ref" in this.value)
            return this;
          const te = D[Z];
          if (this.value[te] === void 0 || this.value[te] === null && Z === D.length - 1) {
            let se = !1;
            for (let ie = D.length - 1; ie > Z; ie--) {
              const me = D.slice(Z, ie + 1).join("/");
              if (this.value[me] !== void 0) {
                this.value = this.value[me], Z = ie, se = !0;
                break;
              }
            }
            if (se)
              continue;
            if (te in this.value && this.value[te] === null) {
              this.value = e.nullSymbol;
              continue;
            }
            this.value = null;
            const ee = this.$ref.path || "", K = this.path.replace(ee, ""), re = p.join("", $), de = E == null ? void 0 : E.replace(ee, "");
            throw new c.MissingPointerError(te, decodeURI(this.originalPath), K, re, de);
          } else
            this.value = this.value[te];
          $.push(te);
        }
        return (!this.value || this.value.$ref && o.resolve(this.path, this.value.$ref) !== E) && g(this, T, E), this;
      }
      /**
       * Sets the value of a nested property within the given object.
       *
       * @param obj - The object that will be crawled
       * @param value - the value to assign
       * @param options
       *
       * @returns
       * Returns the modified object, or an entirely new object if the entire object is overwritten.
       */
      set(C, T, E) {
        const D = p.parse(this.path);
        let $;
        if (D.length === 0)
          return this.value = T, T;
        this.value = b(C);
        for (let Z = 0; Z < D.length - 1; Z++)
          g(this, E), $ = D[Z], this.value && this.value[$] !== void 0 ? this.value = this.value[$] : this.value = v(this, $, {});
        return g(this, E), $ = D[D.length - 1], v(this, $, T), C;
      }
      /**
       * Parses a JSON pointer (or a path containing a JSON pointer in the hash)
       * and returns an array of the pointer's tokens.
       * (e.g. "schema.json#/definitions/person/name" => ["definitions", "person", "name"])
       *
       * The pointer is parsed according to RFC 6901
       * {@link https://tools.ietf.org/html/rfc6901#section-3}
       *
       * @param path
       * @param [originalPath]
       * @returns
       */
      static parse(C, T) {
        const E = o.getHash(C).substring(1);
        if (!E)
          return [];
        const D = E.split("/");
        for (let $ = 0; $ < D.length; $++)
          D[$] = l(D[$].replace(f, "/").replace(d, "~"));
        if (D[0] !== "")
          throw new c.InvalidPointerError(E, T === void 0 ? C : T);
        return D.slice(1);
      }
      /**
       * Creates a JSON pointer path, by joining one or more tokens to a base path.
       *
       * @param base - The base path (e.g. "schema.json#/definitions/person")
       * @param tokens - The token(s) to append (e.g. ["name", "first"])
       * @returns
       */
      static join(C, T) {
        C.indexOf("#") === -1 && (C += "#"), T = Array.isArray(T) ? T : [T];
        for (let E = 0; E < T.length; E++) {
          const D = T[E];
          C += "/" + encodeURIComponent(D.replace(s, "~0").replace(u, "~1"));
        }
        return C;
      }
    }
    function g(w, C, T) {
      if (a.default.isAllowed$Ref(w.value, C)) {
        const E = o.resolve(w.path, w.value.$ref);
        if (E === w.path && !y(T))
          w.circular = !0;
        else {
          const D = w.$ref.$refs._resolve(E, w.path, C);
          return D === null ? !1 : (w.indirections += D.indirections + 1, a.default.isExtended$Ref(w.value) ? (w.value = a.default.dereference(w.value, D.value), !1) : (w.$ref = D.$ref, w.path = D.path, w.value = D.value, !0));
        }
      }
    }
    e.default = p;
    function v(w, C, T) {
      if (w.value && typeof w.value == "object")
        C === "-" && Array.isArray(w.value) ? w.value.push(T) : w.value[C] = T;
      else
        throw new c.JSONParserError(`Error assigning $ref pointer "${w.path}". 
Cannot set "${C}" of a non-object.`);
      return T;
    }
    function b(w) {
      if ((0, c.isHandledError)(w))
        throw w;
      return w;
    }
    function y(w) {
      return typeof w == "string" && p.parse(w).length == 0;
    }
  }(za)), za;
}
var sx;
function Zf() {
  if (sx) return co;
  sx = 1;
  var e = co && co.__createBinding || (Object.create ? function(c, u, s, f) {
    f === void 0 && (f = s);
    var d = Object.getOwnPropertyDescriptor(u, s);
    (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return u[s];
    } }), Object.defineProperty(c, f, d);
  } : function(c, u, s, f) {
    f === void 0 && (f = s), c[f] = u[s];
  }), t = co && co.__setModuleDefault || (Object.create ? function(c, u) {
    Object.defineProperty(c, "default", { enumerable: !0, value: u });
  } : function(c, u) {
    c.default = u;
  }), n = co && co.__importStar || /* @__PURE__ */ function() {
    var c = function(u) {
      return c = Object.getOwnPropertyNames || function(s) {
        var f = [];
        for (var d in s) Object.prototype.hasOwnProperty.call(s, d) && (f[f.length] = d);
        return f;
      }, c(u);
    };
    return function(u) {
      if (u && u.__esModule) return u;
      var s = {};
      if (u != null) for (var f = c(u), d = 0; d < f.length; d++) f[d] !== "default" && e(s, u, f[d]);
      return t(s, u), s;
    };
  }();
  Object.defineProperty(co, "__esModule", { value: !0 });
  const r = n(V0()), i = no(), a = ro();
  class o {
    constructor(u) {
      this.errors = [], this.$refs = u;
    }
    /**
     * Pushes an error to errors array.
     *
     * @param err - The error to be pushed
     * @returns
     */
    addError(u) {
      this.errors === void 0 && (this.errors = []);
      const s = this.errors.map(({ footprint: f }) => f);
      "errors" in u && Array.isArray(u.errors) ? this.errors.push(...u.errors.map(i.normalizeError).filter(({ footprint: f }) => !s.includes(f))) : (!("footprint" in u) || !s.includes(u.footprint)) && this.errors.push((0, i.normalizeError)(u));
    }
    /**
     * Determines whether the given JSON reference exists within this {@link $Ref#value}.
     *
     * @param path - The full path being resolved, optionally with a JSON pointer in the hash
     * @param options
     * @returns
     */
    exists(u, s) {
      try {
        return this.resolve(u, s), !0;
      } catch {
        return !1;
      }
    }
    /**
     * Resolves the given JSON reference within this {@link $Ref#value} and returns the resolved value.
     *
     * @param path - The full path being resolved, optionally with a JSON pointer in the hash
     * @param options
     * @returns - Returns the resolved value
     */
    get(u, s) {
      var f;
      return (f = this.resolve(u, s)) == null ? void 0 : f.value;
    }
    /**
     * Resolves the given JSON reference within this {@link $Ref#value}.
     *
     * @param path - The full path being resolved, optionally with a JSON pointer in the hash
     * @param options
     * @param friendlyPath - The original user-specified path (used for error messages)
     * @param pathFromRoot - The path of `obj` from the schema root
     * @returns
     */
    resolve(u, s, f, d) {
      const l = new r.default(this, u, f);
      try {
        const p = l.resolve(this.value, s, d);
        return p.value === r.nullSymbol && (p.value = null), p;
      } catch (p) {
        if (!s || !s.continueOnError || !(0, i.isHandledError)(p))
          throw p;
        return p.path === null && (p.path = (0, a.safePointerToPath)((0, a.getHash)(d))), p instanceof i.InvalidPointerError && (p.source = decodeURI((0, a.stripHash)(d))), this.addError(p), null;
      }
    }
    /**
     * Sets the value of a nested property within this {@link $Ref#value}.
     * If the property, or any of its parents don't exist, they will be created.
     *
     * @param path - The full path of the property to set, optionally with a JSON pointer in the hash
     * @param value - The value to assign
     */
    set(u, s) {
      const f = new r.default(this, u);
      this.value = f.set(this.value, s), this.value === r.nullSymbol && (this.value = null);
    }
    /**
     * Determines whether the given value is a JSON reference.
     *
     * @param value - The value to inspect
     * @returns
     */
    static is$Ref(u) {
      return !!u && typeof u == "object" && u !== null && "$ref" in u && typeof u.$ref == "string" && u.$ref.length > 0;
    }
    /**
     * Determines whether the given value is an external JSON reference.
     *
     * @param value - The value to inspect
     * @returns
     */
    static isExternal$Ref(u) {
      return o.is$Ref(u) && u.$ref[0] !== "#";
    }
    /**
     * Determines whether the given value is a JSON reference, and whether it is allowed by the options.
     * For example, if it references an external file, then options.resolve.external must be true.
     *
     * @param value - The value to inspect
     * @param options
     * @returns
     */
    static isAllowed$Ref(u, s) {
      var f;
      if (this.is$Ref(u)) {
        if (u.$ref.substring(0, 2) === "#/" || u.$ref === "#")
          return !0;
        if (u.$ref[0] !== "#" && (!s || (f = s.resolve) != null && f.external))
          return !0;
      }
    }
    /**
     * Determines whether the given value is a JSON reference that "extends" its resolved value.
     * That is, it has extra properties (in addition to "$ref"), so rather than simply pointing to
     * an existing value, this $ref actually creates a NEW value that is a shallow copy of the resolved
     * value, plus the extra properties.
     *
     * @example: {
       person: {
         properties: {
           firstName: { type: string }
           lastName: { type: string }
         }
       }
       employee: {
         properties: {
           $ref: #/person/properties
           salary: { type: number }
         }
       }
     }
     *  In this example, "employee" is an extended $ref, since it extends "person" with an additional
     *  property (salary).  The result is a NEW value that looks like this:
     *
     *  {
     *    properties: {
     *      firstName: { type: string }
     *      lastName: { type: string }
     *      salary: { type: number }
     *    }
     *  }
     *
     * @param value - The value to inspect
     * @returns
     */
    static isExtended$Ref(u) {
      return o.is$Ref(u) && Object.keys(u).length > 1;
    }
    /**
     * Returns the resolved value of a JSON Reference.
     * If necessary, the resolved value is merged with the JSON Reference to create a new object
     *
     * @example: {
    person: {
      properties: {
        firstName: { type: string }
        lastName: { type: string }
      }
    }
    employee: {
      properties: {
        $ref: #/person/properties
        salary: { type: number }
      }
    }
    } When "person" and "employee" are merged, you end up with the following object:
     *
     *  {
     *    properties: {
     *      firstName: { type: string }
     *      lastName: { type: string }
     *      salary: { type: number }
     *    }
     *  }
     *
     * @param $ref - The JSON reference object (the one with the "$ref" property)
     * @param resolvedValue - The resolved value, which can be any type
     * @returns - Returns the dereferenced value
     */
    static dereference(u, s) {
      if (s && typeof s == "object" && o.isExtended$Ref(u)) {
        const f = {};
        for (const d of Object.keys(u))
          d !== "$ref" && (f[d] = u[d]);
        for (const d of Object.keys(s))
          d in f || (f[d] = s[d]);
        return f;
      } else
        return s;
    }
  }
  return co.default = o, co;
}
var ux;
function KU() {
  if (ux) return _a;
  ux = 1;
  var e = _a && _a.__createBinding || (Object.create ? function(f, d, l, p) {
    p === void 0 && (p = l);
    var g = Object.getOwnPropertyDescriptor(d, l);
    (!g || ("get" in g ? !d.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return d[l];
    } }), Object.defineProperty(f, p, g);
  } : function(f, d, l, p) {
    p === void 0 && (p = l), f[p] = d[l];
  }), t = _a && _a.__setModuleDefault || (Object.create ? function(f, d) {
    Object.defineProperty(f, "default", { enumerable: !0, value: d });
  } : function(f, d) {
    f.default = d;
  }), n = _a && _a.__importStar || /* @__PURE__ */ function() {
    var f = function(d) {
      return f = Object.getOwnPropertyNames || function(l) {
        var p = [];
        for (var g in l) Object.prototype.hasOwnProperty.call(l, g) && (p[p.length] = g);
        return p;
      }, f(d);
    };
    return function(d) {
      if (d && d.__esModule) return d;
      var l = {};
      if (d != null) for (var p = f(d), g = 0; g < p.length; g++) p[g] !== "default" && e(l, d, p[g]);
      return t(l, d), l;
    };
  }(), r = _a && _a.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(_a, "__esModule", { value: !0 });
  const i = Tu, a = r(Zf()), o = n(ro()), c = r(fk());
  class u {
    /**
     * Returns the paths/URLs of all the files in your schema (including the main schema file).
     *
     * See https://apitools.dev/json-schema-ref-parser/docs/refs.html#pathstypes
     *
     * @param types (optional) Optionally only return certain types of paths ("file", "http", etc.)
     */
    paths(...d) {
      return s(this._$refs, d.flat()).map((p) => (0, c.default)(p.decoded));
    }
    /**
     * Returns a map of paths/URLs and their correspond values.
     *
     * See https://apitools.dev/json-schema-ref-parser/docs/refs.html#valuestypes
     *
     * @param types (optional) Optionally only return values from certain locations ("file", "http", etc.)
     */
    values(...d) {
      const l = this._$refs;
      return s(l, d.flat()).reduce((g, v) => (g[(0, c.default)(v.decoded)] = l[v.encoded].value, g), {});
    }
    /**
     * Returns `true` if the given path exists in the schema; otherwise, returns `false`
     *
     * See https://apitools.dev/json-schema-ref-parser/docs/refs.html#existsref
     *
     * @param $ref The JSON Reference path, optionally with a JSON Pointer in the hash
     */
    /**
     * Determines whether the given JSON reference exists.
     *
     * @param path - The path being resolved, optionally with a JSON pointer in the hash
     * @param [options]
     * @returns
     */
    exists(d, l) {
      try {
        return this._resolve(d, "", l), !0;
      } catch {
        return !1;
      }
    }
    /**
     * Resolves the given JSON reference and returns the resolved value.
     *
     * @param path - The path being resolved, with a JSON pointer in the hash
     * @param [options]
     * @returns - Returns the resolved value
     */
    get(d, l) {
      return this._resolve(d, "", l).value;
    }
    /**
     * Sets the value at the given path in the schema. If the property, or any of its parents, don't exist, they will be created.
     *
     * @param path The JSON Reference path, optionally with a JSON Pointer in the hash
     * @param value The value to assign. Can be anything (object, string, number, etc.)
     */
    set(d, l) {
      const p = o.resolve(this._root$Ref.path, d), g = o.stripHash(p), v = this._$refs[g];
      if (!v)
        throw (0, i.ono)(`Error resolving $ref pointer "${d}". 
"${g}" not found.`);
      v.set(p, l);
    }
    /**
     * Returns the specified {@link $Ref} object, or undefined.
     *
     * @param path - The path being resolved, optionally with a JSON pointer in the hash
     * @returns
     * @protected
     */
    _get$Ref(d) {
      d = o.resolve(this._root$Ref.path, d);
      const l = o.stripHash(d);
      return this._$refs[l];
    }
    /**
     * Creates a new {@link $Ref} object and adds it to this {@link $Refs} object.
     *
     * @param path  - The file path or URL of the referenced file
     */
    _add(d) {
      const l = o.stripHash(d), p = new a.default(this);
      return p.path = l, this._$refs[l] = p, this._root$Ref = this._root$Ref || p, p;
    }
    /**
     * Resolves the given JSON reference.
     *
     * @param path - The path being resolved, optionally with a JSON pointer in the hash
     * @param pathFromRoot - The path of `obj` from the schema root
     * @param [options]
     * @returns
     * @protected
     */
    _resolve(d, l, p) {
      const g = o.resolve(this._root$Ref.path, d), v = o.stripHash(g), b = this._$refs[v];
      if (!b)
        throw (0, i.ono)(`Error resolving $ref pointer "${d}". 
"${v}" not found.`);
      return b.resolve(g, p, d, l);
    }
    constructor() {
      this._$refs = {}, this.toJSON = this.values, this.circular = !1, this._$refs = {}, this._root$Ref = null;
    }
  }
  _a.default = u;
  function s(f, d) {
    let l = Object.keys(f);
    return d = Array.isArray(d[0]) ? d[0] : Array.prototype.slice.call(d), d.length > 0 && d[0] && (l = l.filter((p) => d.includes(f[p].pathType))), l.map((p) => ({
      encoded: p,
      decoded: f[p].pathType === "file" ? o.toFileSystemPath(p, !0) : p
    }));
  }
  return _a;
}
var lo = {}, zs = {}, cx;
function ZU() {
  if (cx) return zs;
  cx = 1, Object.defineProperty(zs, "__esModule", { value: !0 }), zs.all = e, zs.filter = t, zs.sort = n, zs.run = r;
  function e(a) {
    return Object.keys(a || {}).filter((o) => typeof a[o] == "object").map((o) => (a[o].name = o, a[o]));
  }
  function t(a, o, c) {
    return a.filter((u) => !!i(u, o, c));
  }
  function n(a) {
    for (const o of a)
      o.order = o.order || Number.MAX_SAFE_INTEGER;
    return a.sort((o, c) => o.order - c.order);
  }
  async function r(a, o, c, u) {
    let s, f, d = 0;
    return new Promise((l, p) => {
      g();
      function g() {
        if (s = a[d++], !s)
          return p(f);
        try {
          const w = i(s, o, c, v, u);
          if (w && typeof w.then == "function")
            w.then(b, y);
          else if (w !== void 0)
            b(w);
          else if (d === a.length)
            throw new Error("No promise has been returned or callback has been called.");
        } catch (w) {
          y(w);
        }
      }
      function v(w, C) {
        w ? y(w) : b(C);
      }
      function b(w) {
        l({
          plugin: s,
          result: w
        });
      }
      function y(w) {
        f = {
          plugin: s,
          error: w
        }, g();
      }
    });
  }
  function i(a, o, c, u, s) {
    const f = a[o];
    if (typeof f == "function")
      return f.apply(a, [c, u, s]);
    if (!u) {
      if (f instanceof RegExp)
        return f.test(c.url);
      if (typeof f == "string")
        return f === c.extension;
      if (Array.isArray(f))
        return f.indexOf(c.extension) !== -1;
    }
    return f;
  }
  return zs;
}
var lx;
function pk() {
  if (lx) return lo;
  lx = 1;
  var e = lo && lo.__createBinding || (Object.create ? function(d, l, p, g) {
    g === void 0 && (g = p);
    var v = Object.getOwnPropertyDescriptor(l, p);
    (!v || ("get" in v ? !l.__esModule : v.writable || v.configurable)) && (v = { enumerable: !0, get: function() {
      return l[p];
    } }), Object.defineProperty(d, g, v);
  } : function(d, l, p, g) {
    g === void 0 && (g = p), d[g] = l[p];
  }), t = lo && lo.__setModuleDefault || (Object.create ? function(d, l) {
    Object.defineProperty(d, "default", { enumerable: !0, value: l });
  } : function(d, l) {
    d.default = l;
  }), n = lo && lo.__importStar || /* @__PURE__ */ function() {
    var d = function(l) {
      return d = Object.getOwnPropertyNames || function(p) {
        var g = [];
        for (var v in p) Object.prototype.hasOwnProperty.call(p, v) && (g[g.length] = v);
        return g;
      }, d(l);
    };
    return function(l) {
      if (l && l.__esModule) return l;
      var p = {};
      if (l != null) for (var g = d(l), v = 0; v < g.length; v++) g[v] !== "default" && e(p, l, g[v]);
      return t(p, l), p;
    };
  }();
  Object.defineProperty(lo, "__esModule", { value: !0 });
  const r = Tu, i = n(ro()), a = n(ZU()), o = no();
  async function c(d, l, p) {
    const g = d.indexOf("#");
    let v = "";
    g >= 0 && (v = d.substring(g), d = d.substring(0, g));
    const b = l._add(d), y = {
      url: d,
      hash: v,
      extension: i.getExtension(d)
    };
    try {
      const w = await u(y, p, l);
      b.pathType = w.plugin.name, y.data = w.result;
      const C = await s(y, p, l);
      return b.value = C.result, C.result;
    } catch (w) {
      throw (0, o.isHandledError)(w) && (b.value = w), w;
    }
  }
  async function u(d, l, p) {
    let g = a.all(l.resolve);
    g = a.filter(g, "canRead", d), a.sort(g);
    try {
      return await a.run(g, "read", d, p);
    } catch (v) {
      throw !v && l.continueOnError ? new o.UnmatchedResolverError(d.url) : !v || !("error" in v) ? r.ono.syntax(`Unable to resolve $ref pointer "${d.url}"`) : v.error instanceof o.ResolverError ? v.error : new o.ResolverError(v, d.url);
    }
  }
  async function s(d, l, p) {
    const g = a.all(l.parse), v = a.filter(g, "canParse", d), b = v.length > 0 ? v : g;
    a.sort(b);
    try {
      const y = await a.run(b, "parse", d, p);
      if (!y.plugin.allowEmpty && f(y.result))
        throw r.ono.syntax(`Error parsing "${d.url}" as ${y.plugin.name}. 
Parsed value is empty`);
      return y;
    } catch (y) {
      throw !y && l.continueOnError ? new o.UnmatchedParserError(d.url) : y && y.message && y.message.startsWith("Error parsing") ? y : !y || !("error" in y) ? r.ono.syntax(`Unable to parse ${d.url}`) : y.error instanceof o.ParserError ? y.error : new o.ParserError(y.error.message, d.url);
    }
  }
  function f(d) {
    return d === void 0 || typeof d == "object" && Object.keys(d).length === 0 || typeof d == "string" && d.trim().length === 0 || Dn.isBuffer(d) && d.length === 0;
  }
  return lo.default = c, lo;
}
var ml = {}, gl = {}, md = {}, fx;
function YU() {
  if (fx) return md;
  fx = 1, Object.defineProperty(md, "__esModule", { value: !0 });
  const e = no();
  return md.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 100,
    /**
     * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
     */
    allowEmpty: !0,
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that match will be tried, in order, until one successfully parses the file.
     * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
     * every parser will be tried.
     */
    canParse: ".json",
    /**
     * Allow JSON files with byte order marks (BOM)
     */
    allowBOM: !0,
    /**
     * Parses the given file as JSON
     */
    async parse(t) {
      let n = t.data;
      if (Dn.isBuffer(n) && (n = n.toString()), typeof n == "string") {
        if (n.trim().length === 0)
          return;
        try {
          return JSON.parse(n);
        } catch (r) {
          if (this.allowBOM)
            try {
              const i = n.indexOf("{");
              return n = n.slice(i), JSON.parse(n);
            } catch (i) {
              throw new e.ParserError(i.message, t.url);
            }
          throw new e.ParserError(r.message, t.url);
        }
      } else
        return n;
    }
  }, md;
}
var Ku = {}, Pi = {}, gd = {}, ms = {}, px;
function Yf() {
  if (px) return ms;
  px = 1;
  function e(o) {
    return typeof o > "u" || o === null;
  }
  function t(o) {
    return typeof o == "object" && o !== null;
  }
  function n(o) {
    return Array.isArray(o) ? o : e(o) ? [] : [o];
  }
  function r(o, c) {
    var u, s, f, d;
    if (c)
      for (d = Object.keys(c), u = 0, s = d.length; u < s; u += 1)
        f = d[u], o[f] = c[f];
    return o;
  }
  function i(o, c) {
    var u = "", s;
    for (s = 0; s < c; s += 1)
      u += o;
    return u;
  }
  function a(o) {
    return o === 0 && Number.NEGATIVE_INFINITY === 1 / o;
  }
  return ms.isNothing = e, ms.isObject = t, ms.toArray = n, ms.repeat = i, ms.isNegativeZero = a, ms.extend = r, ms;
}
var cm, dx;
function Jf() {
  if (dx) return cm;
  dx = 1;
  function e(n, r) {
    var i = "", a = n.reason || "(unknown reason)";
    return n.mark ? (n.mark.name && (i += 'in "' + n.mark.name + '" '), i += "(" + (n.mark.line + 1) + ":" + (n.mark.column + 1) + ")", !r && n.mark.snippet && (i += `

` + n.mark.snippet), a + " " + i) : a;
  }
  function t(n, r) {
    Error.call(this), this.name = "YAMLException", this.reason = n, this.mark = r, this.message = e(this, !1), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
  }
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t.prototype.toString = function(r) {
    return this.name + ": " + e(this, r);
  }, cm = t, cm;
}
var lm, hx;
function JU() {
  if (hx) return lm;
  hx = 1;
  var e = Yf();
  function t(i, a, o, c, u) {
    var s = "", f = "", d = Math.floor(u / 2) - 1;
    return c - a > d && (s = " ... ", a = c - d + s.length), o - c > d && (f = " ...", o = c + d - f.length), {
      str: s + i.slice(a, o).replace(/\t/g, "→") + f,
      pos: c - a + s.length
      // relative position
    };
  }
  function n(i, a) {
    return e.repeat(" ", a - i.length) + i;
  }
  function r(i, a) {
    if (a = Object.create(a || null), !i.buffer) return null;
    a.maxLength || (a.maxLength = 79), typeof a.indent != "number" && (a.indent = 1), typeof a.linesBefore != "number" && (a.linesBefore = 3), typeof a.linesAfter != "number" && (a.linesAfter = 2);
    for (var o = /\r?\n|\r|\0/g, c = [0], u = [], s, f = -1; s = o.exec(i.buffer); )
      u.push(s.index), c.push(s.index + s[0].length), i.position <= s.index && f < 0 && (f = c.length - 2);
    f < 0 && (f = c.length - 1);
    var d = "", l, p, g = Math.min(i.line + a.linesAfter, u.length).toString().length, v = a.maxLength - (a.indent + g + 3);
    for (l = 1; l <= a.linesBefore && !(f - l < 0); l++)
      p = t(
        i.buffer,
        c[f - l],
        u[f - l],
        i.position - (c[f] - c[f - l]),
        v
      ), d = e.repeat(" ", a.indent) + n((i.line - l + 1).toString(), g) + " | " + p.str + `
` + d;
    for (p = t(i.buffer, c[f], u[f], i.position, v), d += e.repeat(" ", a.indent) + n((i.line + 1).toString(), g) + " | " + p.str + `
`, d += e.repeat("-", a.indent + g + 3 + p.pos) + `^
`, l = 1; l <= a.linesAfter && !(f + l >= u.length); l++)
      p = t(
        i.buffer,
        c[f + l],
        u[f + l],
        i.position - (c[f] - c[f + l]),
        v
      ), d += e.repeat(" ", a.indent) + n((i.line + l + 1).toString(), g) + " | " + p.str + `
`;
    return d.replace(/\n$/, "");
  }
  return lm = r, lm;
}
var fm, mx;
function Vi() {
  if (mx) return fm;
  mx = 1;
  var e = Jf(), t = [
    "kind",
    "multi",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "representName",
    "defaultStyle",
    "styleAliases"
  ], n = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function r(a) {
    var o = {};
    return a !== null && Object.keys(a).forEach(function(c) {
      a[c].forEach(function(u) {
        o[String(u)] = c;
      });
    }), o;
  }
  function i(a, o) {
    if (o = o || {}, Object.keys(o).forEach(function(c) {
      if (t.indexOf(c) === -1)
        throw new e('Unknown option "' + c + '" is met in definition of "' + a + '" YAML type.');
    }), this.options = o, this.tag = a, this.kind = o.kind || null, this.resolve = o.resolve || function() {
      return !0;
    }, this.construct = o.construct || function(c) {
      return c;
    }, this.instanceOf = o.instanceOf || null, this.predicate = o.predicate || null, this.represent = o.represent || null, this.representName = o.representName || null, this.defaultStyle = o.defaultStyle || null, this.multi = o.multi || !1, this.styleAliases = r(o.styleAliases || null), n.indexOf(this.kind) === -1)
      throw new e('Unknown kind "' + this.kind + '" is specified for "' + a + '" YAML type.');
  }
  return fm = i, fm;
}
var pm, gx;
function dk() {
  if (gx) return pm;
  gx = 1;
  var e = Jf(), t = Vi();
  function n(a, o) {
    var c = [];
    return a[o].forEach(function(u) {
      var s = c.length;
      c.forEach(function(f, d) {
        f.tag === u.tag && f.kind === u.kind && f.multi === u.multi && (s = d);
      }), c[s] = u;
    }), c;
  }
  function r() {
    var a = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {},
      multi: {
        scalar: [],
        sequence: [],
        mapping: [],
        fallback: []
      }
    }, o, c;
    function u(s) {
      s.multi ? (a.multi[s.kind].push(s), a.multi.fallback.push(s)) : a[s.kind][s.tag] = a.fallback[s.tag] = s;
    }
    for (o = 0, c = arguments.length; o < c; o += 1)
      arguments[o].forEach(u);
    return a;
  }
  function i(a) {
    return this.extend(a);
  }
  return i.prototype.extend = function(o) {
    var c = [], u = [];
    if (o instanceof t)
      u.push(o);
    else if (Array.isArray(o))
      u = u.concat(o);
    else if (o && (Array.isArray(o.implicit) || Array.isArray(o.explicit)))
      o.implicit && (c = c.concat(o.implicit)), o.explicit && (u = u.concat(o.explicit));
    else
      throw new e("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    c.forEach(function(f) {
      if (!(f instanceof t))
        throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
      if (f.loadKind && f.loadKind !== "scalar")
        throw new e("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
      if (f.multi)
        throw new e("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
    }), u.forEach(function(f) {
      if (!(f instanceof t))
        throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    });
    var s = Object.create(i.prototype);
    return s.implicit = (this.implicit || []).concat(c), s.explicit = (this.explicit || []).concat(u), s.compiledImplicit = n(s, "implicit"), s.compiledExplicit = n(s, "explicit"), s.compiledTypeMap = r(s.compiledImplicit, s.compiledExplicit), s;
  }, pm = i, pm;
}
var dm, vx;
function hk() {
  if (vx) return dm;
  vx = 1;
  var e = Vi();
  return dm = new e("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(t) {
      return t !== null ? t : "";
    }
  }), dm;
}
var hm, yx;
function mk() {
  if (yx) return hm;
  yx = 1;
  var e = Vi();
  return hm = new e("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(t) {
      return t !== null ? t : [];
    }
  }), hm;
}
var mm, bx;
function gk() {
  if (bx) return mm;
  bx = 1;
  var e = Vi();
  return mm = new e("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(t) {
      return t !== null ? t : {};
    }
  }), mm;
}
var gm, xx;
function vk() {
  if (xx) return gm;
  xx = 1;
  var e = dk();
  return gm = new e({
    explicit: [
      hk(),
      mk(),
      gk()
    ]
  }), gm;
}
var vm, _x;
function yk() {
  if (_x) return vm;
  _x = 1;
  var e = Vi();
  function t(i) {
    if (i === null) return !0;
    var a = i.length;
    return a === 1 && i === "~" || a === 4 && (i === "null" || i === "Null" || i === "NULL");
  }
  function n() {
    return null;
  }
  function r(i) {
    return i === null;
  }
  return vm = new e("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      },
      empty: function() {
        return "";
      }
    },
    defaultStyle: "lowercase"
  }), vm;
}
var ym, wx;
function bk() {
  if (wx) return ym;
  wx = 1;
  var e = Vi();
  function t(i) {
    if (i === null) return !1;
    var a = i.length;
    return a === 4 && (i === "true" || i === "True" || i === "TRUE") || a === 5 && (i === "false" || i === "False" || i === "FALSE");
  }
  function n(i) {
    return i === "true" || i === "True" || i === "TRUE";
  }
  function r(i) {
    return Object.prototype.toString.call(i) === "[object Boolean]";
  }
  return ym = new e("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: t,
    construct: n,
    predicate: r,
    represent: {
      lowercase: function(i) {
        return i ? "true" : "false";
      },
      uppercase: function(i) {
        return i ? "TRUE" : "FALSE";
      },
      camelcase: function(i) {
        return i ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  }), ym;
}
var bm, Sx;
function xk() {
  if (Sx) return bm;
  Sx = 1;
  var e = Yf(), t = Vi();
  function n(u) {
    return 48 <= u && u <= 57 || 65 <= u && u <= 70 || 97 <= u && u <= 102;
  }
  function r(u) {
    return 48 <= u && u <= 55;
  }
  function i(u) {
    return 48 <= u && u <= 57;
  }
  function a(u) {
    if (u === null) return !1;
    var s = u.length, f = 0, d = !1, l;
    if (!s) return !1;
    if (l = u[f], (l === "-" || l === "+") && (l = u[++f]), l === "0") {
      if (f + 1 === s) return !0;
      if (l = u[++f], l === "b") {
        for (f++; f < s; f++)
          if (l = u[f], l !== "_") {
            if (l !== "0" && l !== "1") return !1;
            d = !0;
          }
        return d && l !== "_";
      }
      if (l === "x") {
        for (f++; f < s; f++)
          if (l = u[f], l !== "_") {
            if (!n(u.charCodeAt(f))) return !1;
            d = !0;
          }
        return d && l !== "_";
      }
      if (l === "o") {
        for (f++; f < s; f++)
          if (l = u[f], l !== "_") {
            if (!r(u.charCodeAt(f))) return !1;
            d = !0;
          }
        return d && l !== "_";
      }
    }
    if (l === "_") return !1;
    for (; f < s; f++)
      if (l = u[f], l !== "_") {
        if (!i(u.charCodeAt(f)))
          return !1;
        d = !0;
      }
    return !(!d || l === "_");
  }
  function o(u) {
    var s = u, f = 1, d;
    if (s.indexOf("_") !== -1 && (s = s.replace(/_/g, "")), d = s[0], (d === "-" || d === "+") && (d === "-" && (f = -1), s = s.slice(1), d = s[0]), s === "0") return 0;
    if (d === "0") {
      if (s[1] === "b") return f * parseInt(s.slice(2), 2);
      if (s[1] === "x") return f * parseInt(s.slice(2), 16);
      if (s[1] === "o") return f * parseInt(s.slice(2), 8);
    }
    return f * parseInt(s, 10);
  }
  function c(u) {
    return Object.prototype.toString.call(u) === "[object Number]" && u % 1 === 0 && !e.isNegativeZero(u);
  }
  return bm = new t("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: a,
    construct: o,
    predicate: c,
    represent: {
      binary: function(u) {
        return u >= 0 ? "0b" + u.toString(2) : "-0b" + u.toString(2).slice(1);
      },
      octal: function(u) {
        return u >= 0 ? "0o" + u.toString(8) : "-0o" + u.toString(8).slice(1);
      },
      decimal: function(u) {
        return u.toString(10);
      },
      /* eslint-disable max-len */
      hexadecimal: function(u) {
        return u >= 0 ? "0x" + u.toString(16).toUpperCase() : "-0x" + u.toString(16).toUpperCase().slice(1);
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }), bm;
}
var xm, Cx;
function _k() {
  if (Cx) return xm;
  Cx = 1;
  var e = Yf(), t = Vi(), n = new RegExp(
    // 2.5e4, 2.5 and integers
    "^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"
  );
  function r(u) {
    return !(u === null || !n.test(u) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    u[u.length - 1] === "_");
  }
  function i(u) {
    var s, f;
    return s = u.replace(/_/g, "").toLowerCase(), f = s[0] === "-" ? -1 : 1, "+-".indexOf(s[0]) >= 0 && (s = s.slice(1)), s === ".inf" ? f === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : s === ".nan" ? NaN : f * parseFloat(s, 10);
  }
  var a = /^[-+]?[0-9]+e/;
  function o(u, s) {
    var f;
    if (isNaN(u))
      switch (s) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    else if (Number.POSITIVE_INFINITY === u)
      switch (s) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    else if (Number.NEGATIVE_INFINITY === u)
      switch (s) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    else if (e.isNegativeZero(u))
      return "-0.0";
    return f = u.toString(10), a.test(f) ? f.replace("e", ".e") : f;
  }
  function c(u) {
    return Object.prototype.toString.call(u) === "[object Number]" && (u % 1 !== 0 || e.isNegativeZero(u));
  }
  return xm = new t("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: r,
    construct: i,
    predicate: c,
    represent: o,
    defaultStyle: "lowercase"
  }), xm;
}
var _m, Ax;
function wk() {
  return Ax || (Ax = 1, _m = vk().extend({
    implicit: [
      yk(),
      bk(),
      xk(),
      _k()
    ]
  })), _m;
}
var wm, kx;
function Sk() {
  return kx || (kx = 1, wm = wk()), wm;
}
var Sm, Ex;
function Ck() {
  if (Ex) return Sm;
  Ex = 1;
  var e = Vi(), t = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"
  ), n = new RegExp(
    "^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"
  );
  function r(o) {
    return o === null ? !1 : t.exec(o) !== null || n.exec(o) !== null;
  }
  function i(o) {
    var c, u, s, f, d, l, p, g = 0, v = null, b, y, w;
    if (c = t.exec(o), c === null && (c = n.exec(o)), c === null) throw new Error("Date resolve error");
    if (u = +c[1], s = +c[2] - 1, f = +c[3], !c[4])
      return new Date(Date.UTC(u, s, f));
    if (d = +c[4], l = +c[5], p = +c[6], c[7]) {
      for (g = c[7].slice(0, 3); g.length < 3; )
        g += "0";
      g = +g;
    }
    return c[9] && (b = +c[10], y = +(c[11] || 0), v = (b * 60 + y) * 6e4, c[9] === "-" && (v = -v)), w = new Date(Date.UTC(u, s, f, d, l, p, g)), v && w.setTime(w.getTime() - v), w;
  }
  function a(o) {
    return o.toISOString();
  }
  return Sm = new e("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: r,
    construct: i,
    instanceOf: Date,
    represent: a
  }), Sm;
}
var Cm, Ox;
function Ak() {
  if (Ox) return Cm;
  Ox = 1;
  var e = Vi();
  function t(n) {
    return n === "<<" || n === null;
  }
  return Cm = new e("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: t
  }), Cm;
}
var Am, Tx;
function kk() {
  if (Tx) return Am;
  Tx = 1;
  var e = Vi(), t = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function n(o) {
    if (o === null) return !1;
    var c, u, s = 0, f = o.length, d = t;
    for (u = 0; u < f; u++)
      if (c = d.indexOf(o.charAt(u)), !(c > 64)) {
        if (c < 0) return !1;
        s += 6;
      }
    return s % 8 === 0;
  }
  function r(o) {
    var c, u, s = o.replace(/[\r\n=]/g, ""), f = s.length, d = t, l = 0, p = [];
    for (c = 0; c < f; c++)
      c % 4 === 0 && c && (p.push(l >> 16 & 255), p.push(l >> 8 & 255), p.push(l & 255)), l = l << 6 | d.indexOf(s.charAt(c));
    return u = f % 4 * 6, u === 0 ? (p.push(l >> 16 & 255), p.push(l >> 8 & 255), p.push(l & 255)) : u === 18 ? (p.push(l >> 10 & 255), p.push(l >> 2 & 255)) : u === 12 && p.push(l >> 4 & 255), new Uint8Array(p);
  }
  function i(o) {
    var c = "", u = 0, s, f, d = o.length, l = t;
    for (s = 0; s < d; s++)
      s % 3 === 0 && s && (c += l[u >> 18 & 63], c += l[u >> 12 & 63], c += l[u >> 6 & 63], c += l[u & 63]), u = (u << 8) + o[s];
    return f = d % 3, f === 0 ? (c += l[u >> 18 & 63], c += l[u >> 12 & 63], c += l[u >> 6 & 63], c += l[u & 63]) : f === 2 ? (c += l[u >> 10 & 63], c += l[u >> 4 & 63], c += l[u << 2 & 63], c += l[64]) : f === 1 && (c += l[u >> 2 & 63], c += l[u << 4 & 63], c += l[64], c += l[64]), c;
  }
  function a(o) {
    return Object.prototype.toString.call(o) === "[object Uint8Array]";
  }
  return Am = new e("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: n,
    construct: r,
    predicate: a,
    represent: i
  }), Am;
}
var km, Px;
function Ek() {
  if (Px) return km;
  Px = 1;
  var e = Vi(), t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  function r(a) {
    if (a === null) return !0;
    var o = [], c, u, s, f, d, l = a;
    for (c = 0, u = l.length; c < u; c += 1) {
      if (s = l[c], d = !1, n.call(s) !== "[object Object]") return !1;
      for (f in s)
        if (t.call(s, f))
          if (!d) d = !0;
          else return !1;
      if (!d) return !1;
      if (o.indexOf(f) === -1) o.push(f);
      else return !1;
    }
    return !0;
  }
  function i(a) {
    return a !== null ? a : [];
  }
  return km = new e("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: r,
    construct: i
  }), km;
}
var Em, Rx;
function Ok() {
  if (Rx) return Em;
  Rx = 1;
  var e = Vi(), t = Object.prototype.toString;
  function n(i) {
    if (i === null) return !0;
    var a, o, c, u, s, f = i;
    for (s = new Array(f.length), a = 0, o = f.length; a < o; a += 1) {
      if (c = f[a], t.call(c) !== "[object Object]" || (u = Object.keys(c), u.length !== 1)) return !1;
      s[a] = [u[0], c[u[0]]];
    }
    return !0;
  }
  function r(i) {
    if (i === null) return [];
    var a, o, c, u, s, f = i;
    for (s = new Array(f.length), a = 0, o = f.length; a < o; a += 1)
      c = f[a], u = Object.keys(c), s[a] = [u[0], c[u[0]]];
    return s;
  }
  return Em = new e("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: n,
    construct: r
  }), Em;
}
var Om, jx;
function Tk() {
  if (jx) return Om;
  jx = 1;
  var e = Vi(), t = Object.prototype.hasOwnProperty;
  function n(i) {
    if (i === null) return !0;
    var a, o = i;
    for (a in o)
      if (t.call(o, a) && o[a] !== null)
        return !1;
    return !0;
  }
  function r(i) {
    return i !== null ? i : {};
  }
  return Om = new e("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: n,
    construct: r
  }), Om;
}
var Tm, Ix;
function z2() {
  return Ix || (Ix = 1, Tm = Sk().extend({
    implicit: [
      Ck(),
      Ak()
    ],
    explicit: [
      kk(),
      Ek(),
      Ok(),
      Tk()
    ]
  })), Tm;
}
var qx;
function QU() {
  if (qx) return gd;
  qx = 1;
  var e = Yf(), t = Jf(), n = JU(), r = z2(), i = Object.prototype.hasOwnProperty, a = 1, o = 2, c = 3, u = 4, s = 1, f = 2, d = 3, l = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, p = /[\x85\u2028\u2029]/, g = /[,\[\]\{\}]/, v = /^(?:!|!!|![a-z\-]+!)$/i, b = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
  function y(N) {
    return Object.prototype.toString.call(N);
  }
  function w(N) {
    return N === 10 || N === 13;
  }
  function C(N) {
    return N === 9 || N === 32;
  }
  function T(N) {
    return N === 9 || N === 32 || N === 10 || N === 13;
  }
  function E(N) {
    return N === 44 || N === 91 || N === 93 || N === 123 || N === 125;
  }
  function D(N) {
    var Se;
    return 48 <= N && N <= 57 ? N - 48 : (Se = N | 32, 97 <= Se && Se <= 102 ? Se - 97 + 10 : -1);
  }
  function $(N) {
    return N === 120 ? 2 : N === 117 ? 4 : N === 85 ? 8 : 0;
  }
  function Z(N) {
    return 48 <= N && N <= 57 ? N - 48 : -1;
  }
  function te(N) {
    return N === 48 ? "\0" : N === 97 ? "\x07" : N === 98 ? "\b" : N === 116 || N === 9 ? "	" : N === 110 ? `
` : N === 118 ? "\v" : N === 102 ? "\f" : N === 114 ? "\r" : N === 101 ? "\x1B" : N === 32 ? " " : N === 34 ? '"' : N === 47 ? "/" : N === 92 ? "\\" : N === 78 ? "" : N === 95 ? " " : N === 76 ? "\u2028" : N === 80 ? "\u2029" : "";
  }
  function se(N) {
    return N <= 65535 ? String.fromCharCode(N) : String.fromCharCode(
      (N - 65536 >> 10) + 55296,
      (N - 65536 & 1023) + 56320
    );
  }
  for (var ee = new Array(256), K = new Array(256), re = 0; re < 256; re++)
    ee[re] = te(re) ? 1 : 0, K[re] = te(re);
  function de(N, Se) {
    this.input = N, this.filename = Se.filename || null, this.schema = Se.schema || r, this.onWarning = Se.onWarning || null, this.legacy = Se.legacy || !1, this.json = Se.json || !1, this.listener = Se.listener || null, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = N.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.firstTabInLine = -1, this.documents = [];
  }
  function ie(N, Se) {
    var Me = {
      name: N.filename,
      buffer: N.input.slice(0, -1),
      // omit trailing \0
      position: N.position,
      line: N.line,
      column: N.position - N.lineStart
    };
    return Me.snippet = n(Me), new t(Se, Me);
  }
  function me(N, Se) {
    throw ie(N, Se);
  }
  function $e(N, Se) {
    N.onWarning && N.onWarning.call(null, ie(N, Se));
  }
  var Pe = {
    YAML: function(Se, Me, Xe) {
      var Ke, $t, Be;
      Se.version !== null && me(Se, "duplication of %YAML directive"), Xe.length !== 1 && me(Se, "YAML directive accepts exactly one argument"), Ke = /^([0-9]+)\.([0-9]+)$/.exec(Xe[0]), Ke === null && me(Se, "ill-formed argument of the YAML directive"), $t = parseInt(Ke[1], 10), Be = parseInt(Ke[2], 10), $t !== 1 && me(Se, "unacceptable YAML version of the document"), Se.version = Xe[0], Se.checkLineBreaks = Be < 2, Be !== 1 && Be !== 2 && $e(Se, "unsupported YAML version of the document");
    },
    TAG: function(Se, Me, Xe) {
      var Ke, $t;
      Xe.length !== 2 && me(Se, "TAG directive accepts exactly two arguments"), Ke = Xe[0], $t = Xe[1], v.test(Ke) || me(Se, "ill-formed tag handle (first argument) of the TAG directive"), i.call(Se.tagMap, Ke) && me(Se, 'there is a previously declared suffix for "' + Ke + '" tag handle'), b.test($t) || me(Se, "ill-formed tag prefix (second argument) of the TAG directive");
      try {
        $t = decodeURIComponent($t);
      } catch {
        me(Se, "tag prefix is malformed: " + $t);
      }
      Se.tagMap[Ke] = $t;
    }
  };
  function Le(N, Se, Me, Xe) {
    var Ke, $t, Be, P;
    if (Se < Me) {
      if (P = N.input.slice(Se, Me), Xe)
        for (Ke = 0, $t = P.length; Ke < $t; Ke += 1)
          Be = P.charCodeAt(Ke), Be === 9 || 32 <= Be && Be <= 1114111 || me(N, "expected valid JSON character");
      else l.test(P) && me(N, "the stream contains non-printable characters");
      N.result += P;
    }
  }
  function Ae(N, Se, Me, Xe) {
    var Ke, $t, Be, P;
    for (e.isObject(Me) || me(N, "cannot merge mappings; the provided source object is unacceptable"), Ke = Object.keys(Me), Be = 0, P = Ke.length; Be < P; Be += 1)
      $t = Ke[Be], i.call(Se, $t) || (Se[$t] = Me[$t], Xe[$t] = !0);
  }
  function He(N, Se, Me, Xe, Ke, $t, Be, P, M) {
    var F, O;
    if (Array.isArray(Ke))
      for (Ke = Array.prototype.slice.call(Ke), F = 0, O = Ke.length; F < O; F += 1)
        Array.isArray(Ke[F]) && me(N, "nested arrays are not supported inside keys"), typeof Ke == "object" && y(Ke[F]) === "[object Object]" && (Ke[F] = "[object Object]");
    if (typeof Ke == "object" && y(Ke) === "[object Object]" && (Ke = "[object Object]"), Ke = String(Ke), Se === null && (Se = {}), Xe === "tag:yaml.org,2002:merge")
      if (Array.isArray($t))
        for (F = 0, O = $t.length; F < O; F += 1)
          Ae(N, Se, $t[F], Me);
      else
        Ae(N, Se, $t, Me);
    else
      !N.json && !i.call(Me, Ke) && i.call(Se, Ke) && (N.line = Be || N.line, N.lineStart = P || N.lineStart, N.position = M || N.position, me(N, "duplicated mapping key")), Ke === "__proto__" ? Object.defineProperty(Se, Ke, {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        value: $t
      }) : Se[Ke] = $t, delete Me[Ke];
    return Se;
  }
  function Te(N) {
    var Se;
    Se = N.input.charCodeAt(N.position), Se === 10 ? N.position++ : Se === 13 ? (N.position++, N.input.charCodeAt(N.position) === 10 && N.position++) : me(N, "a line break is expected"), N.line += 1, N.lineStart = N.position, N.firstTabInLine = -1;
  }
  function we(N, Se, Me) {
    for (var Xe = 0, Ke = N.input.charCodeAt(N.position); Ke !== 0; ) {
      for (; C(Ke); )
        Ke === 9 && N.firstTabInLine === -1 && (N.firstTabInLine = N.position), Ke = N.input.charCodeAt(++N.position);
      if (Se && Ke === 35)
        do
          Ke = N.input.charCodeAt(++N.position);
        while (Ke !== 10 && Ke !== 13 && Ke !== 0);
      if (w(Ke))
        for (Te(N), Ke = N.input.charCodeAt(N.position), Xe++, N.lineIndent = 0; Ke === 32; )
          N.lineIndent++, Ke = N.input.charCodeAt(++N.position);
      else
        break;
    }
    return Me !== -1 && Xe !== 0 && N.lineIndent < Me && $e(N, "deficient indentation"), Xe;
  }
  function qe(N) {
    var Se = N.position, Me;
    return Me = N.input.charCodeAt(Se), !!((Me === 45 || Me === 46) && Me === N.input.charCodeAt(Se + 1) && Me === N.input.charCodeAt(Se + 2) && (Se += 3, Me = N.input.charCodeAt(Se), Me === 0 || T(Me)));
  }
  function Ge(N, Se) {
    Se === 1 ? N.result += " " : Se > 1 && (N.result += e.repeat(`
`, Se - 1));
  }
  function It(N, Se, Me) {
    var Xe, Ke, $t, Be, P, M, F, O, S = N.kind, _ = N.result, h;
    if (h = N.input.charCodeAt(N.position), T(h) || E(h) || h === 35 || h === 38 || h === 42 || h === 33 || h === 124 || h === 62 || h === 39 || h === 34 || h === 37 || h === 64 || h === 96 || (h === 63 || h === 45) && (Ke = N.input.charCodeAt(N.position + 1), T(Ke) || Me && E(Ke)))
      return !1;
    for (N.kind = "scalar", N.result = "", $t = Be = N.position, P = !1; h !== 0; ) {
      if (h === 58) {
        if (Ke = N.input.charCodeAt(N.position + 1), T(Ke) || Me && E(Ke))
          break;
      } else if (h === 35) {
        if (Xe = N.input.charCodeAt(N.position - 1), T(Xe))
          break;
      } else {
        if (N.position === N.lineStart && qe(N) || Me && E(h))
          break;
        if (w(h))
          if (M = N.line, F = N.lineStart, O = N.lineIndent, we(N, !1, -1), N.lineIndent >= Se) {
            P = !0, h = N.input.charCodeAt(N.position);
            continue;
          } else {
            N.position = Be, N.line = M, N.lineStart = F, N.lineIndent = O;
            break;
          }
      }
      P && (Le(N, $t, Be, !1), Ge(N, N.line - M), $t = Be = N.position, P = !1), C(h) || (Be = N.position + 1), h = N.input.charCodeAt(++N.position);
    }
    return Le(N, $t, Be, !1), N.result ? !0 : (N.kind = S, N.result = _, !1);
  }
  function Qe(N, Se) {
    var Me, Xe, Ke;
    if (Me = N.input.charCodeAt(N.position), Me !== 39)
      return !1;
    for (N.kind = "scalar", N.result = "", N.position++, Xe = Ke = N.position; (Me = N.input.charCodeAt(N.position)) !== 0; )
      if (Me === 39)
        if (Le(N, Xe, N.position, !0), Me = N.input.charCodeAt(++N.position), Me === 39)
          Xe = N.position, N.position++, Ke = N.position;
        else
          return !0;
      else w(Me) ? (Le(N, Xe, Ke, !0), Ge(N, we(N, !1, Se)), Xe = Ke = N.position) : N.position === N.lineStart && qe(N) ? me(N, "unexpected end of the document within a single quoted scalar") : (N.position++, Ke = N.position);
    me(N, "unexpected end of the stream within a single quoted scalar");
  }
  function jt(N, Se) {
    var Me, Xe, Ke, $t, Be, P;
    if (P = N.input.charCodeAt(N.position), P !== 34)
      return !1;
    for (N.kind = "scalar", N.result = "", N.position++, Me = Xe = N.position; (P = N.input.charCodeAt(N.position)) !== 0; ) {
      if (P === 34)
        return Le(N, Me, N.position, !0), N.position++, !0;
      if (P === 92) {
        if (Le(N, Me, N.position, !0), P = N.input.charCodeAt(++N.position), w(P))
          we(N, !1, Se);
        else if (P < 256 && ee[P])
          N.result += K[P], N.position++;
        else if ((Be = $(P)) > 0) {
          for (Ke = Be, $t = 0; Ke > 0; Ke--)
            P = N.input.charCodeAt(++N.position), (Be = D(P)) >= 0 ? $t = ($t << 4) + Be : me(N, "expected hexadecimal character");
          N.result += se($t), N.position++;
        } else
          me(N, "unknown escape sequence");
        Me = Xe = N.position;
      } else w(P) ? (Le(N, Me, Xe, !0), Ge(N, we(N, !1, Se)), Me = Xe = N.position) : N.position === N.lineStart && qe(N) ? me(N, "unexpected end of the document within a double quoted scalar") : (N.position++, Xe = N.position);
    }
    me(N, "unexpected end of the stream within a double quoted scalar");
  }
  function We(N, Se) {
    var Me = !0, Xe, Ke, $t, Be = N.tag, P, M = N.anchor, F, O, S, _, h, A = /* @__PURE__ */ Object.create(null), R, I, k, j;
    if (j = N.input.charCodeAt(N.position), j === 91)
      O = 93, h = !1, P = [];
    else if (j === 123)
      O = 125, h = !0, P = {};
    else
      return !1;
    for (N.anchor !== null && (N.anchorMap[N.anchor] = P), j = N.input.charCodeAt(++N.position); j !== 0; ) {
      if (we(N, !0, Se), j = N.input.charCodeAt(N.position), j === O)
        return N.position++, N.tag = Be, N.anchor = M, N.kind = h ? "mapping" : "sequence", N.result = P, !0;
      Me ? j === 44 && me(N, "expected the node content, but found ','") : me(N, "missed comma between flow collection entries"), I = R = k = null, S = _ = !1, j === 63 && (F = N.input.charCodeAt(N.position + 1), T(F) && (S = _ = !0, N.position++, we(N, !0, Se))), Xe = N.line, Ke = N.lineStart, $t = N.position, ye(N, Se, a, !1, !0), I = N.tag, R = N.result, we(N, !0, Se), j = N.input.charCodeAt(N.position), (_ || N.line === Xe) && j === 58 && (S = !0, j = N.input.charCodeAt(++N.position), we(N, !0, Se), ye(N, Se, a, !1, !0), k = N.result), h ? He(N, P, A, I, R, k, Xe, Ke, $t) : S ? P.push(He(N, null, A, I, R, k, Xe, Ke, $t)) : P.push(R), we(N, !0, Se), j = N.input.charCodeAt(N.position), j === 44 ? (Me = !0, j = N.input.charCodeAt(++N.position)) : Me = !1;
    }
    me(N, "unexpected end of the stream within a flow collection");
  }
  function Lt(N, Se) {
    var Me, Xe, Ke = s, $t = !1, Be = !1, P = Se, M = 0, F = !1, O, S;
    if (S = N.input.charCodeAt(N.position), S === 124)
      Xe = !1;
    else if (S === 62)
      Xe = !0;
    else
      return !1;
    for (N.kind = "scalar", N.result = ""; S !== 0; )
      if (S = N.input.charCodeAt(++N.position), S === 43 || S === 45)
        s === Ke ? Ke = S === 43 ? d : f : me(N, "repeat of a chomping mode identifier");
      else if ((O = Z(S)) >= 0)
        O === 0 ? me(N, "bad explicit indentation width of a block scalar; it cannot be less than one") : Be ? me(N, "repeat of an indentation width identifier") : (P = Se + O - 1, Be = !0);
      else
        break;
    if (C(S)) {
      do
        S = N.input.charCodeAt(++N.position);
      while (C(S));
      if (S === 35)
        do
          S = N.input.charCodeAt(++N.position);
        while (!w(S) && S !== 0);
    }
    for (; S !== 0; ) {
      for (Te(N), N.lineIndent = 0, S = N.input.charCodeAt(N.position); (!Be || N.lineIndent < P) && S === 32; )
        N.lineIndent++, S = N.input.charCodeAt(++N.position);
      if (!Be && N.lineIndent > P && (P = N.lineIndent), w(S)) {
        M++;
        continue;
      }
      if (N.lineIndent < P) {
        Ke === d ? N.result += e.repeat(`
`, $t ? 1 + M : M) : Ke === s && $t && (N.result += `
`);
        break;
      }
      for (Xe ? C(S) ? (F = !0, N.result += e.repeat(`
`, $t ? 1 + M : M)) : F ? (F = !1, N.result += e.repeat(`
`, M + 1)) : M === 0 ? $t && (N.result += " ") : N.result += e.repeat(`
`, M) : N.result += e.repeat(`
`, $t ? 1 + M : M), $t = !0, Be = !0, M = 0, Me = N.position; !w(S) && S !== 0; )
        S = N.input.charCodeAt(++N.position);
      Le(N, Me, N.position, !1);
    }
    return !0;
  }
  function Fe(N, Se) {
    var Me, Xe = N.tag, Ke = N.anchor, $t = [], Be, P = !1, M;
    if (N.firstTabInLine !== -1) return !1;
    for (N.anchor !== null && (N.anchorMap[N.anchor] = $t), M = N.input.charCodeAt(N.position); M !== 0 && (N.firstTabInLine !== -1 && (N.position = N.firstTabInLine, me(N, "tab characters must not be used in indentation")), !(M !== 45 || (Be = N.input.charCodeAt(N.position + 1), !T(Be)))); ) {
      if (P = !0, N.position++, we(N, !0, -1) && N.lineIndent <= Se) {
        $t.push(null), M = N.input.charCodeAt(N.position);
        continue;
      }
      if (Me = N.line, ye(N, Se, c, !1, !0), $t.push(N.result), we(N, !0, -1), M = N.input.charCodeAt(N.position), (N.line === Me || N.lineIndent > Se) && M !== 0)
        me(N, "bad indentation of a sequence entry");
      else if (N.lineIndent < Se)
        break;
    }
    return P ? (N.tag = Xe, N.anchor = Ke, N.kind = "sequence", N.result = $t, !0) : !1;
  }
  function Ze(N, Se, Me) {
    var Xe, Ke, $t, Be, P, M, F = N.tag, O = N.anchor, S = {}, _ = /* @__PURE__ */ Object.create(null), h = null, A = null, R = null, I = !1, k = !1, j;
    if (N.firstTabInLine !== -1) return !1;
    for (N.anchor !== null && (N.anchorMap[N.anchor] = S), j = N.input.charCodeAt(N.position); j !== 0; ) {
      if (!I && N.firstTabInLine !== -1 && (N.position = N.firstTabInLine, me(N, "tab characters must not be used in indentation")), Xe = N.input.charCodeAt(N.position + 1), $t = N.line, (j === 63 || j === 58) && T(Xe))
        j === 63 ? (I && (He(N, S, _, h, A, null, Be, P, M), h = A = R = null), k = !0, I = !0, Ke = !0) : I ? (I = !1, Ke = !0) : me(N, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), N.position += 1, j = Xe;
      else {
        if (Be = N.line, P = N.lineStart, M = N.position, !ye(N, Me, o, !1, !0))
          break;
        if (N.line === $t) {
          for (j = N.input.charCodeAt(N.position); C(j); )
            j = N.input.charCodeAt(++N.position);
          if (j === 58)
            j = N.input.charCodeAt(++N.position), T(j) || me(N, "a whitespace character is expected after the key-value separator within a block mapping"), I && (He(N, S, _, h, A, null, Be, P, M), h = A = R = null), k = !0, I = !1, Ke = !1, h = N.tag, A = N.result;
          else if (k)
            me(N, "can not read an implicit mapping pair; a colon is missed");
          else
            return N.tag = F, N.anchor = O, !0;
        } else if (k)
          me(N, "can not read a block mapping entry; a multiline key may not be an implicit key");
        else
          return N.tag = F, N.anchor = O, !0;
      }
      if ((N.line === $t || N.lineIndent > Se) && (I && (Be = N.line, P = N.lineStart, M = N.position), ye(N, Se, u, !0, Ke) && (I ? A = N.result : R = N.result), I || (He(N, S, _, h, A, R, Be, P, M), h = A = R = null), we(N, !0, -1), j = N.input.charCodeAt(N.position)), (N.line === $t || N.lineIndent > Se) && j !== 0)
        me(N, "bad indentation of a mapping entry");
      else if (N.lineIndent < Se)
        break;
    }
    return I && He(N, S, _, h, A, null, Be, P, M), k && (N.tag = F, N.anchor = O, N.kind = "mapping", N.result = S), k;
  }
  function Ue(N) {
    var Se, Me = !1, Xe = !1, Ke, $t, Be;
    if (Be = N.input.charCodeAt(N.position), Be !== 33) return !1;
    if (N.tag !== null && me(N, "duplication of a tag property"), Be = N.input.charCodeAt(++N.position), Be === 60 ? (Me = !0, Be = N.input.charCodeAt(++N.position)) : Be === 33 ? (Xe = !0, Ke = "!!", Be = N.input.charCodeAt(++N.position)) : Ke = "!", Se = N.position, Me) {
      do
        Be = N.input.charCodeAt(++N.position);
      while (Be !== 0 && Be !== 62);
      N.position < N.length ? ($t = N.input.slice(Se, N.position), Be = N.input.charCodeAt(++N.position)) : me(N, "unexpected end of the stream within a verbatim tag");
    } else {
      for (; Be !== 0 && !T(Be); )
        Be === 33 && (Xe ? me(N, "tag suffix cannot contain exclamation marks") : (Ke = N.input.slice(Se - 1, N.position + 1), v.test(Ke) || me(N, "named tag handle cannot contain such characters"), Xe = !0, Se = N.position + 1)), Be = N.input.charCodeAt(++N.position);
      $t = N.input.slice(Se, N.position), g.test($t) && me(N, "tag suffix cannot contain flow indicator characters");
    }
    $t && !b.test($t) && me(N, "tag name cannot contain such characters: " + $t);
    try {
      $t = decodeURIComponent($t);
    } catch {
      me(N, "tag name is malformed: " + $t);
    }
    return Me ? N.tag = $t : i.call(N.tagMap, Ke) ? N.tag = N.tagMap[Ke] + $t : Ke === "!" ? N.tag = "!" + $t : Ke === "!!" ? N.tag = "tag:yaml.org,2002:" + $t : me(N, 'undeclared tag handle "' + Ke + '"'), !0;
  }
  function Rt(N) {
    var Se, Me;
    if (Me = N.input.charCodeAt(N.position), Me !== 38) return !1;
    for (N.anchor !== null && me(N, "duplication of an anchor property"), Me = N.input.charCodeAt(++N.position), Se = N.position; Me !== 0 && !T(Me) && !E(Me); )
      Me = N.input.charCodeAt(++N.position);
    return N.position === Se && me(N, "name of an anchor node must contain at least one character"), N.anchor = N.input.slice(Se, N.position), !0;
  }
  function Vr(N) {
    var Se, Me, Xe;
    if (Xe = N.input.charCodeAt(N.position), Xe !== 42) return !1;
    for (Xe = N.input.charCodeAt(++N.position), Se = N.position; Xe !== 0 && !T(Xe) && !E(Xe); )
      Xe = N.input.charCodeAt(++N.position);
    return N.position === Se && me(N, "name of an alias node must contain at least one character"), Me = N.input.slice(Se, N.position), i.call(N.anchorMap, Me) || me(N, 'unidentified alias "' + Me + '"'), N.result = N.anchorMap[Me], we(N, !0, -1), !0;
  }
  function ye(N, Se, Me, Xe, Ke) {
    var $t, Be, P, M = 1, F = !1, O = !1, S, _, h, A, R, I;
    if (N.listener !== null && N.listener("open", N), N.tag = null, N.anchor = null, N.kind = null, N.result = null, $t = Be = P = u === Me || c === Me, Xe && we(N, !0, -1) && (F = !0, N.lineIndent > Se ? M = 1 : N.lineIndent === Se ? M = 0 : N.lineIndent < Se && (M = -1)), M === 1)
      for (; Ue(N) || Rt(N); )
        we(N, !0, -1) ? (F = !0, P = $t, N.lineIndent > Se ? M = 1 : N.lineIndent === Se ? M = 0 : N.lineIndent < Se && (M = -1)) : P = !1;
    if (P && (P = F || Ke), (M === 1 || u === Me) && (a === Me || o === Me ? R = Se : R = Se + 1, I = N.position - N.lineStart, M === 1 ? P && (Fe(N, I) || Ze(N, I, R)) || We(N, R) ? O = !0 : (Be && Lt(N, R) || Qe(N, R) || jt(N, R) ? O = !0 : Vr(N) ? (O = !0, (N.tag !== null || N.anchor !== null) && me(N, "alias node should not have any properties")) : It(N, R, a === Me) && (O = !0, N.tag === null && (N.tag = "?")), N.anchor !== null && (N.anchorMap[N.anchor] = N.result)) : M === 0 && (O = P && Fe(N, I))), N.tag === null)
      N.anchor !== null && (N.anchorMap[N.anchor] = N.result);
    else if (N.tag === "?") {
      for (N.result !== null && N.kind !== "scalar" && me(N, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + N.kind + '"'), S = 0, _ = N.implicitTypes.length; S < _; S += 1)
        if (A = N.implicitTypes[S], A.resolve(N.result)) {
          N.result = A.construct(N.result), N.tag = A.tag, N.anchor !== null && (N.anchorMap[N.anchor] = N.result);
          break;
        }
    } else if (N.tag !== "!") {
      if (i.call(N.typeMap[N.kind || "fallback"], N.tag))
        A = N.typeMap[N.kind || "fallback"][N.tag];
      else
        for (A = null, h = N.typeMap.multi[N.kind || "fallback"], S = 0, _ = h.length; S < _; S += 1)
          if (N.tag.slice(0, h[S].tag.length) === h[S].tag) {
            A = h[S];
            break;
          }
      A || me(N, "unknown tag !<" + N.tag + ">"), N.result !== null && A.kind !== N.kind && me(N, "unacceptable node kind for !<" + N.tag + '> tag; it should be "' + A.kind + '", not "' + N.kind + '"'), A.resolve(N.result, N.tag) ? (N.result = A.construct(N.result, N.tag), N.anchor !== null && (N.anchorMap[N.anchor] = N.result)) : me(N, "cannot resolve a node with !<" + N.tag + "> explicit tag");
    }
    return N.listener !== null && N.listener("close", N), N.tag !== null || N.anchor !== null || O;
  }
  function G(N) {
    var Se = N.position, Me, Xe, Ke, $t = !1, Be;
    for (N.version = null, N.checkLineBreaks = N.legacy, N.tagMap = /* @__PURE__ */ Object.create(null), N.anchorMap = /* @__PURE__ */ Object.create(null); (Be = N.input.charCodeAt(N.position)) !== 0 && (we(N, !0, -1), Be = N.input.charCodeAt(N.position), !(N.lineIndent > 0 || Be !== 37)); ) {
      for ($t = !0, Be = N.input.charCodeAt(++N.position), Me = N.position; Be !== 0 && !T(Be); )
        Be = N.input.charCodeAt(++N.position);
      for (Xe = N.input.slice(Me, N.position), Ke = [], Xe.length < 1 && me(N, "directive name must not be less than one character in length"); Be !== 0; ) {
        for (; C(Be); )
          Be = N.input.charCodeAt(++N.position);
        if (Be === 35) {
          do
            Be = N.input.charCodeAt(++N.position);
          while (Be !== 0 && !w(Be));
          break;
        }
        if (w(Be)) break;
        for (Me = N.position; Be !== 0 && !T(Be); )
          Be = N.input.charCodeAt(++N.position);
        Ke.push(N.input.slice(Me, N.position));
      }
      Be !== 0 && Te(N), i.call(Pe, Xe) ? Pe[Xe](N, Xe, Ke) : $e(N, 'unknown document directive "' + Xe + '"');
    }
    if (we(N, !0, -1), N.lineIndent === 0 && N.input.charCodeAt(N.position) === 45 && N.input.charCodeAt(N.position + 1) === 45 && N.input.charCodeAt(N.position + 2) === 45 ? (N.position += 3, we(N, !0, -1)) : $t && me(N, "directives end mark is expected"), ye(N, N.lineIndent - 1, u, !1, !0), we(N, !0, -1), N.checkLineBreaks && p.test(N.input.slice(Se, N.position)) && $e(N, "non-ASCII line breaks are interpreted as content"), N.documents.push(N.result), N.position === N.lineStart && qe(N)) {
      N.input.charCodeAt(N.position) === 46 && (N.position += 3, we(N, !0, -1));
      return;
    }
    if (N.position < N.length - 1)
      me(N, "end of the stream or a document separator is expected");
    else
      return;
  }
  function Y(N, Se) {
    N = String(N), Se = Se || {}, N.length !== 0 && (N.charCodeAt(N.length - 1) !== 10 && N.charCodeAt(N.length - 1) !== 13 && (N += `
`), N.charCodeAt(0) === 65279 && (N = N.slice(1)));
    var Me = new de(N, Se), Xe = N.indexOf("\0");
    for (Xe !== -1 && (Me.position = Xe, me(Me, "null byte is not allowed in input")), Me.input += "\0"; Me.input.charCodeAt(Me.position) === 32; )
      Me.lineIndent += 1, Me.position += 1;
    for (; Me.position < Me.length - 1; )
      G(Me);
    return Me.documents;
  }
  function ae(N, Se, Me) {
    Se !== null && typeof Se == "object" && typeof Me > "u" && (Me = Se, Se = null);
    var Xe = Y(N, Me);
    if (typeof Se != "function")
      return Xe;
    for (var Ke = 0, $t = Xe.length; Ke < $t; Ke += 1)
      Se(Xe[Ke]);
  }
  function Ee(N, Se) {
    var Me = Y(N, Se);
    if (Me.length !== 0) {
      if (Me.length === 1)
        return Me[0];
      throw new t("expected a single document in the stream, but found more");
    }
  }
  return gd.loadAll = ae, gd.load = Ee, gd;
}
var Pm = {}, Dx;
function XU() {
  if (Dx) return Pm;
  Dx = 1;
  var e = Yf(), t = Jf(), n = z2(), r = Object.prototype.toString, i = Object.prototype.hasOwnProperty, a = 65279, o = 9, c = 10, u = 13, s = 32, f = 33, d = 34, l = 35, p = 37, g = 38, v = 39, b = 42, y = 44, w = 45, C = 58, T = 61, E = 62, D = 63, $ = 64, Z = 91, te = 93, se = 96, ee = 123, K = 124, re = 125, de = {};
  de[0] = "\\0", de[7] = "\\a", de[8] = "\\b", de[9] = "\\t", de[10] = "\\n", de[11] = "\\v", de[12] = "\\f", de[13] = "\\r", de[27] = "\\e", de[34] = '\\"', de[92] = "\\\\", de[133] = "\\N", de[160] = "\\_", de[8232] = "\\L", de[8233] = "\\P";
  var ie = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ], me = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
  function $e(h, A) {
    var R, I, k, j, z, H, J;
    if (A === null) return {};
    for (R = {}, I = Object.keys(A), k = 0, j = I.length; k < j; k += 1)
      z = I[k], H = String(A[z]), z.slice(0, 2) === "!!" && (z = "tag:yaml.org,2002:" + z.slice(2)), J = h.compiledTypeMap.fallback[z], J && i.call(J.styleAliases, H) && (H = J.styleAliases[H]), R[z] = H;
    return R;
  }
  function Pe(h) {
    var A, R, I;
    if (A = h.toString(16).toUpperCase(), h <= 255)
      R = "x", I = 2;
    else if (h <= 65535)
      R = "u", I = 4;
    else if (h <= 4294967295)
      R = "U", I = 8;
    else
      throw new t("code point within a string may not be greater than 0xFFFFFFFF");
    return "\\" + R + e.repeat("0", I - A.length) + A;
  }
  var Le = 1, Ae = 2;
  function He(h) {
    this.schema = h.schema || n, this.indent = Math.max(1, h.indent || 2), this.noArrayIndent = h.noArrayIndent || !1, this.skipInvalid = h.skipInvalid || !1, this.flowLevel = e.isNothing(h.flowLevel) ? -1 : h.flowLevel, this.styleMap = $e(this.schema, h.styles || null), this.sortKeys = h.sortKeys || !1, this.lineWidth = h.lineWidth || 80, this.noRefs = h.noRefs || !1, this.noCompatMode = h.noCompatMode || !1, this.condenseFlow = h.condenseFlow || !1, this.quotingType = h.quotingType === '"' ? Ae : Le, this.forceQuotes = h.forceQuotes || !1, this.replacer = typeof h.replacer == "function" ? h.replacer : null, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
  }
  function Te(h, A) {
    for (var R = e.repeat(" ", A), I = 0, k = -1, j = "", z, H = h.length; I < H; )
      k = h.indexOf(`
`, I), k === -1 ? (z = h.slice(I), I = H) : (z = h.slice(I, k + 1), I = k + 1), z.length && z !== `
` && (j += R), j += z;
    return j;
  }
  function we(h, A) {
    return `
` + e.repeat(" ", h.indent * A);
  }
  function qe(h, A) {
    var R, I, k;
    for (R = 0, I = h.implicitTypes.length; R < I; R += 1)
      if (k = h.implicitTypes[R], k.resolve(A))
        return !0;
    return !1;
  }
  function Ge(h) {
    return h === s || h === o;
  }
  function It(h) {
    return 32 <= h && h <= 126 || 161 <= h && h <= 55295 && h !== 8232 && h !== 8233 || 57344 <= h && h <= 65533 && h !== a || 65536 <= h && h <= 1114111;
  }
  function Qe(h) {
    return It(h) && h !== a && h !== u && h !== c;
  }
  function jt(h, A, R) {
    var I = Qe(h), k = I && !Ge(h);
    return (
      // ns-plain-safe
      (R ? (
        // c = flow-in
        I
      ) : I && h !== y && h !== Z && h !== te && h !== ee && h !== re) && h !== l && !(A === C && !k) || Qe(A) && !Ge(A) && h === l || A === C && k
    );
  }
  function We(h) {
    return It(h) && h !== a && !Ge(h) && h !== w && h !== D && h !== C && h !== y && h !== Z && h !== te && h !== ee && h !== re && h !== l && h !== g && h !== b && h !== f && h !== K && h !== T && h !== E && h !== v && h !== d && h !== p && h !== $ && h !== se;
  }
  function Lt(h) {
    return !Ge(h) && h !== C;
  }
  function Fe(h, A) {
    var R = h.charCodeAt(A), I;
    return R >= 55296 && R <= 56319 && A + 1 < h.length && (I = h.charCodeAt(A + 1), I >= 56320 && I <= 57343) ? (R - 55296) * 1024 + I - 56320 + 65536 : R;
  }
  function Ze(h) {
    var A = /^\n* /;
    return A.test(h);
  }
  var Ue = 1, Rt = 2, Vr = 3, ye = 4, G = 5;
  function Y(h, A, R, I, k, j, z, H) {
    var J, U = 0, L = null, B = !1, Q = !1, V = I !== -1, X = -1, ue = We(Fe(h, 0)) && Lt(Fe(h, h.length - 1));
    if (A || z)
      for (J = 0; J < h.length; U >= 65536 ? J += 2 : J++) {
        if (U = Fe(h, J), !It(U))
          return G;
        ue = ue && jt(U, L, H), L = U;
      }
    else {
      for (J = 0; J < h.length; U >= 65536 ? J += 2 : J++) {
        if (U = Fe(h, J), U === c)
          B = !0, V && (Q = Q || // Foldable line = too long, and not more-indented.
          J - X - 1 > I && h[X + 1] !== " ", X = J);
        else if (!It(U))
          return G;
        ue = ue && jt(U, L, H), L = U;
      }
      Q = Q || V && J - X - 1 > I && h[X + 1] !== " ";
    }
    return !B && !Q ? ue && !z && !k(h) ? Ue : j === Ae ? G : Rt : R > 9 && Ze(h) ? G : z ? j === Ae ? G : Rt : Q ? ye : Vr;
  }
  function ae(h, A, R, I, k) {
    h.dump = function() {
      if (A.length === 0)
        return h.quotingType === Ae ? '""' : "''";
      if (!h.noCompatMode && (ie.indexOf(A) !== -1 || me.test(A)))
        return h.quotingType === Ae ? '"' + A + '"' : "'" + A + "'";
      var j = h.indent * Math.max(1, R), z = h.lineWidth === -1 ? -1 : Math.max(Math.min(h.lineWidth, 40), h.lineWidth - j), H = I || h.flowLevel > -1 && R >= h.flowLevel;
      function J(U) {
        return qe(h, U);
      }
      switch (Y(
        A,
        H,
        h.indent,
        z,
        J,
        h.quotingType,
        h.forceQuotes && !I,
        k
      )) {
        case Ue:
          return A;
        case Rt:
          return "'" + A.replace(/'/g, "''") + "'";
        case Vr:
          return "|" + Ee(A, h.indent) + N(Te(A, j));
        case ye:
          return ">" + Ee(A, h.indent) + N(Te(Se(A, z), j));
        case G:
          return '"' + Xe(A) + '"';
        default:
          throw new t("impossible error: invalid scalar style");
      }
    }();
  }
  function Ee(h, A) {
    var R = Ze(h) ? String(A) : "", I = h[h.length - 1] === `
`, k = I && (h[h.length - 2] === `
` || h === `
`), j = k ? "+" : I ? "" : "-";
    return R + j + `
`;
  }
  function N(h) {
    return h[h.length - 1] === `
` ? h.slice(0, -1) : h;
  }
  function Se(h, A) {
    for (var R = /(\n+)([^\n]*)/g, I = function() {
      var U = h.indexOf(`
`);
      return U = U !== -1 ? U : h.length, R.lastIndex = U, Me(h.slice(0, U), A);
    }(), k = h[0] === `
` || h[0] === " ", j, z; z = R.exec(h); ) {
      var H = z[1], J = z[2];
      j = J[0] === " ", I += H + (!k && !j && J !== "" ? `
` : "") + Me(J, A), k = j;
    }
    return I;
  }
  function Me(h, A) {
    if (h === "" || h[0] === " ") return h;
    for (var R = / [^ ]/g, I, k = 0, j, z = 0, H = 0, J = ""; I = R.exec(h); )
      H = I.index, H - k > A && (j = z > k ? z : H, J += `
` + h.slice(k, j), k = j + 1), z = H;
    return J += `
`, h.length - k > A && z > k ? J += h.slice(k, z) + `
` + h.slice(z + 1) : J += h.slice(k), J.slice(1);
  }
  function Xe(h) {
    for (var A = "", R = 0, I, k = 0; k < h.length; R >= 65536 ? k += 2 : k++)
      R = Fe(h, k), I = de[R], !I && It(R) ? (A += h[k], R >= 65536 && (A += h[k + 1])) : A += I || Pe(R);
    return A;
  }
  function Ke(h, A, R) {
    var I = "", k = h.tag, j, z, H;
    for (j = 0, z = R.length; j < z; j += 1)
      H = R[j], h.replacer && (H = h.replacer.call(R, String(j), H)), (F(h, A, H, !1, !1) || typeof H > "u" && F(h, A, null, !1, !1)) && (I !== "" && (I += "," + (h.condenseFlow ? "" : " ")), I += h.dump);
    h.tag = k, h.dump = "[" + I + "]";
  }
  function $t(h, A, R, I) {
    var k = "", j = h.tag, z, H, J;
    for (z = 0, H = R.length; z < H; z += 1)
      J = R[z], h.replacer && (J = h.replacer.call(R, String(z), J)), (F(h, A + 1, J, !0, !0, !1, !0) || typeof J > "u" && F(h, A + 1, null, !0, !0, !1, !0)) && ((!I || k !== "") && (k += we(h, A)), h.dump && c === h.dump.charCodeAt(0) ? k += "-" : k += "- ", k += h.dump);
    h.tag = j, h.dump = k || "[]";
  }
  function Be(h, A, R) {
    var I = "", k = h.tag, j = Object.keys(R), z, H, J, U, L;
    for (z = 0, H = j.length; z < H; z += 1)
      L = "", I !== "" && (L += ", "), h.condenseFlow && (L += '"'), J = j[z], U = R[J], h.replacer && (U = h.replacer.call(R, J, U)), F(h, A, J, !1, !1) && (h.dump.length > 1024 && (L += "? "), L += h.dump + (h.condenseFlow ? '"' : "") + ":" + (h.condenseFlow ? "" : " "), F(h, A, U, !1, !1) && (L += h.dump, I += L));
    h.tag = k, h.dump = "{" + I + "}";
  }
  function P(h, A, R, I) {
    var k = "", j = h.tag, z = Object.keys(R), H, J, U, L, B, Q;
    if (h.sortKeys === !0)
      z.sort();
    else if (typeof h.sortKeys == "function")
      z.sort(h.sortKeys);
    else if (h.sortKeys)
      throw new t("sortKeys must be a boolean or a function");
    for (H = 0, J = z.length; H < J; H += 1)
      Q = "", (!I || k !== "") && (Q += we(h, A)), U = z[H], L = R[U], h.replacer && (L = h.replacer.call(R, U, L)), F(h, A + 1, U, !0, !0, !0) && (B = h.tag !== null && h.tag !== "?" || h.dump && h.dump.length > 1024, B && (h.dump && c === h.dump.charCodeAt(0) ? Q += "?" : Q += "? "), Q += h.dump, B && (Q += we(h, A)), F(h, A + 1, L, !0, B) && (h.dump && c === h.dump.charCodeAt(0) ? Q += ":" : Q += ": ", Q += h.dump, k += Q));
    h.tag = j, h.dump = k || "{}";
  }
  function M(h, A, R) {
    var I, k, j, z, H, J;
    for (k = R ? h.explicitTypes : h.implicitTypes, j = 0, z = k.length; j < z; j += 1)
      if (H = k[j], (H.instanceOf || H.predicate) && (!H.instanceOf || typeof A == "object" && A instanceof H.instanceOf) && (!H.predicate || H.predicate(A))) {
        if (R ? H.multi && H.representName ? h.tag = H.representName(A) : h.tag = H.tag : h.tag = "?", H.represent) {
          if (J = h.styleMap[H.tag] || H.defaultStyle, r.call(H.represent) === "[object Function]")
            I = H.represent(A, J);
          else if (i.call(H.represent, J))
            I = H.represent[J](A, J);
          else
            throw new t("!<" + H.tag + '> tag resolver accepts not "' + J + '" style');
          h.dump = I;
        }
        return !0;
      }
    return !1;
  }
  function F(h, A, R, I, k, j, z) {
    h.tag = null, h.dump = R, M(h, R, !1) || M(h, R, !0);
    var H = r.call(h.dump), J = I, U;
    I && (I = h.flowLevel < 0 || h.flowLevel > A);
    var L = H === "[object Object]" || H === "[object Array]", B, Q;
    if (L && (B = h.duplicates.indexOf(R), Q = B !== -1), (h.tag !== null && h.tag !== "?" || Q || h.indent !== 2 && A > 0) && (k = !1), Q && h.usedDuplicates[B])
      h.dump = "*ref_" + B;
    else {
      if (L && Q && !h.usedDuplicates[B] && (h.usedDuplicates[B] = !0), H === "[object Object]")
        I && Object.keys(h.dump).length !== 0 ? (P(h, A, h.dump, k), Q && (h.dump = "&ref_" + B + h.dump)) : (Be(h, A, h.dump), Q && (h.dump = "&ref_" + B + " " + h.dump));
      else if (H === "[object Array]")
        I && h.dump.length !== 0 ? (h.noArrayIndent && !z && A > 0 ? $t(h, A - 1, h.dump, k) : $t(h, A, h.dump, k), Q && (h.dump = "&ref_" + B + h.dump)) : (Ke(h, A, h.dump), Q && (h.dump = "&ref_" + B + " " + h.dump));
      else if (H === "[object String]")
        h.tag !== "?" && ae(h, h.dump, A, j, J);
      else {
        if (H === "[object Undefined]")
          return !1;
        if (h.skipInvalid) return !1;
        throw new t("unacceptable kind of an object to dump " + H);
      }
      h.tag !== null && h.tag !== "?" && (U = encodeURI(
        h.tag[0] === "!" ? h.tag.slice(1) : h.tag
      ).replace(/!/g, "%21"), h.tag[0] === "!" ? U = "!" + U : U.slice(0, 18) === "tag:yaml.org,2002:" ? U = "!!" + U.slice(18) : U = "!<" + U + ">", h.dump = U + " " + h.dump);
    }
    return !0;
  }
  function O(h, A) {
    var R = [], I = [], k, j;
    for (S(h, R, I), k = 0, j = I.length; k < j; k += 1)
      A.duplicates.push(R[I[k]]);
    A.usedDuplicates = new Array(j);
  }
  function S(h, A, R) {
    var I, k, j;
    if (h !== null && typeof h == "object")
      if (k = A.indexOf(h), k !== -1)
        R.indexOf(k) === -1 && R.push(k);
      else if (A.push(h), Array.isArray(h))
        for (k = 0, j = h.length; k < j; k += 1)
          S(h[k], A, R);
      else
        for (I = Object.keys(h), k = 0, j = I.length; k < j; k += 1)
          S(h[I[k]], A, R);
  }
  function _(h, A) {
    A = A || {};
    var R = new He(A);
    R.noRefs || O(h, R);
    var I = h;
    return R.replacer && (I = R.replacer.call({ "": I }, "", I)), F(R, 0, I, !0, !0) ? R.dump + `
` : "";
  }
  return Pm.dump = _, Pm;
}
var Lx;
function Nx() {
  if (Lx) return Pi;
  Lx = 1;
  var e = QU(), t = XU();
  function n(r, i) {
    return function() {
      throw new Error("Function yaml." + r + " is removed in js-yaml 4. Use yaml." + i + " instead, which is now safe by default.");
    };
  }
  return Pi.Type = Vi(), Pi.Schema = dk(), Pi.FAILSAFE_SCHEMA = vk(), Pi.JSON_SCHEMA = wk(), Pi.CORE_SCHEMA = Sk(), Pi.DEFAULT_SCHEMA = z2(), Pi.load = e.load, Pi.loadAll = e.loadAll, Pi.dump = t.dump, Pi.YAMLException = Jf(), Pi.types = {
    binary: kk(),
    float: _k(),
    map: gk(),
    null: yk(),
    pairs: Ok(),
    set: Tk(),
    timestamp: Ck(),
    bool: bk(),
    int: xk(),
    merge: Ak(),
    omap: Ek(),
    seq: mk(),
    str: hk()
  }, Pi.safeLoad = n("safeLoad", "load"), Pi.safeLoadAll = n("safeLoadAll", "loadAll"), Pi.safeDump = n("safeDump", "dump"), Pi;
}
var $x;
function eH() {
  if ($x) return Ku;
  $x = 1;
  var e = Ku && Ku.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ku, "__esModule", { value: !0 });
  const t = no(), n = e(Nx()), r = Nx();
  return Ku.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 200,
    /**
     * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
     */
    allowEmpty: !0,
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that match will be tried, in order, until one successfully parses the file.
     * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
     * every parser will be tried.
     */
    canParse: [".yaml", ".yml", ".json"],
    // JSON is valid YAML
    /**
     * Parses the given file as YAML
     *
     * @param file           - An object containing information about the referenced file
     * @param file.url       - The full URL of the referenced file
     * @param file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
     * @param file.data      - The file contents. This will be whatever data type was returned by the resolver
     * @returns
     */
    async parse(i) {
      let a = i.data;
      if (Dn.isBuffer(a) && (a = a.toString()), typeof a == "string")
        try {
          return n.default.load(a, { schema: r.JSON_SCHEMA });
        } catch (o) {
          throw new t.ParserError((o == null ? void 0 : o.message) || "Parser Error", i.url);
        }
      else
        return a;
    }
  }, Ku;
}
var vd = {}, Mx;
function tH() {
  if (Mx) return vd;
  Mx = 1, Object.defineProperty(vd, "__esModule", { value: !0 });
  const e = no(), t = /\.(txt|htm|html|md|xml|js|min|map|css|scss|less|svg)$/i;
  return vd.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 300,
    /**
     * Whether to allow "empty" files (zero bytes).
     */
    allowEmpty: !0,
    /**
     * The encoding that the text is expected to be in.
     */
    encoding: "utf8",
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that return true will be tried, in order, until one successfully parses the file.
     * Parsers that return false will be skipped, UNLESS all parsers returned false, in which case
     * every parser will be tried.
     */
    canParse(n) {
      return (typeof n.data == "string" || Dn.isBuffer(n.data)) && t.test(n.url);
    },
    /**
     * Parses the given file as text
     */
    parse(n) {
      if (typeof n.data == "string")
        return n.data;
      if (Dn.isBuffer(n.data))
        return n.data.toString(this.encoding);
      throw new e.ParserError("data is not text", n.url);
    }
  }, vd;
}
var yd = {}, Fx;
function rH() {
  if (Fx) return yd;
  Fx = 1, Object.defineProperty(yd, "__esModule", { value: !0 });
  const e = /\.(jpeg|jpg|gif|png|bmp|ico)$/i;
  return yd.default = {
    /**
     * The order that this parser will run, in relation to other parsers.
     */
    order: 400,
    /**
     * Whether to allow "empty" files (zero bytes).
     */
    allowEmpty: !0,
    /**
     * Determines whether this parser can parse a given file reference.
     * Parsers that return true will be tried, in order, until one successfully parses the file.
     * Parsers that return false will be skipped, UNLESS all parsers returned false, in which case
     * every parser will be tried.
     */
    canParse(t) {
      return Dn.isBuffer(t.data) && e.test(t.url);
    },
    /**
     * Parses the given data as a Buffer (byte array).
     */
    parse(t) {
      return Dn.isBuffer(t.data) ? t.data : Dn.from(t.data);
    }
  }, yd;
}
var wa = {};
const nH = {}, iH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nH
}, Symbol.toStringTag, { value: "Module" })), ai = /* @__PURE__ */ Bf(iH);
var Bx;
function aH() {
  if (Bx) return wa;
  Bx = 1;
  var e = wa && wa.__createBinding || (Object.create ? function(u, s, f, d) {
    d === void 0 && (d = f);
    var l = Object.getOwnPropertyDescriptor(s, f);
    (!l || ("get" in l ? !s.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return s[f];
    } }), Object.defineProperty(u, d, l);
  } : function(u, s, f, d) {
    d === void 0 && (d = f), u[d] = s[f];
  }), t = wa && wa.__setModuleDefault || (Object.create ? function(u, s) {
    Object.defineProperty(u, "default", { enumerable: !0, value: s });
  } : function(u, s) {
    u.default = s;
  }), n = wa && wa.__importStar || /* @__PURE__ */ function() {
    var u = function(s) {
      return u = Object.getOwnPropertyNames || function(f) {
        var d = [];
        for (var l in f) Object.prototype.hasOwnProperty.call(f, l) && (d[d.length] = l);
        return d;
      }, u(s);
    };
    return function(s) {
      if (s && s.__esModule) return s;
      var f = {};
      if (s != null) for (var d = u(s), l = 0; l < d.length; l++) d[l] !== "default" && e(f, s, d[l]);
      return t(f, s), f;
    };
  }(), r = wa && wa.__importDefault || function(u) {
    return u && u.__esModule ? u : { default: u };
  };
  Object.defineProperty(wa, "__esModule", { value: !0 });
  const i = r(ai), a = Tu, o = n(ro()), c = no();
  return wa.default = {
    /**
     * The order that this resolver will run, in relation to other resolvers.
     */
    order: 100,
    /**
     * Determines whether this resolver can read a given file reference.
     * Resolvers that return true will be tried, in order, until one successfully resolves the file.
     * Resolvers that return false will not be given a chance to resolve the file.
     */
    canRead(u) {
      return o.isFileSystemPath(u.url);
    },
    /**
     * Reads the given file and returns its raw contents as a Buffer.
     */
    async read(u) {
      let s;
      try {
        s = o.toFileSystemPath(u.url);
      } catch (f) {
        throw new c.ResolverError(a.ono.uri(f, `Malformed URI: ${u.url}`), u.url);
      }
      try {
        return await i.default.promises.readFile(s);
      } catch (f) {
        throw new c.ResolverError((0, a.ono)(f, `Error opening file "${s}"`), s);
      }
    }
  }, wa;
}
var fo = {}, Ux;
function oH() {
  if (Ux) return fo;
  Ux = 1;
  var e = fo && fo.__createBinding || (Object.create ? function(u, s, f, d) {
    d === void 0 && (d = f);
    var l = Object.getOwnPropertyDescriptor(s, f);
    (!l || ("get" in l ? !s.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return s[f];
    } }), Object.defineProperty(u, d, l);
  } : function(u, s, f, d) {
    d === void 0 && (d = f), u[d] = s[f];
  }), t = fo && fo.__setModuleDefault || (Object.create ? function(u, s) {
    Object.defineProperty(u, "default", { enumerable: !0, value: s });
  } : function(u, s) {
    u.default = s;
  }), n = fo && fo.__importStar || /* @__PURE__ */ function() {
    var u = function(s) {
      return u = Object.getOwnPropertyNames || function(f) {
        var d = [];
        for (var l in f) Object.prototype.hasOwnProperty.call(f, l) && (d[d.length] = l);
        return d;
      }, u(s);
    };
    return function(s) {
      if (s && s.__esModule) return s;
      var f = {};
      if (s != null) for (var d = u(s), l = 0; l < d.length; l++) d[l] !== "default" && e(f, s, d[l]);
      return t(f, s), f;
    };
  }();
  Object.defineProperty(fo, "__esModule", { value: !0 });
  const r = Tu, i = n(ro()), a = no();
  fo.default = {
    /**
     * The order that this resolver will run, in relation to other resolvers.
     */
    order: 200,
    /**
     * HTTP headers to send when downloading files.
     *
     * @example:
     * {
     *   "User-Agent": "JSON Schema $Ref Parser",
     *   Accept: "application/json"
     * }
     */
    headers: null,
    /**
     * HTTP request timeout (in milliseconds).
     */
    timeout: 6e4,
    // 60 seconds
    /**
     * The maximum number of HTTP redirects to follow.
     * To disable automatic following of redirects, set this to zero.
     */
    redirects: 5,
    /**
     * The `withCredentials` option of XMLHttpRequest.
     * Set this to `true` if you're downloading files from a CORS-enabled server that requires authentication
     */
    withCredentials: !1,
    /**
     * Determines whether this resolver can read a given file reference.
     * Resolvers that return true will be tried in order, until one successfully resolves the file.
     * Resolvers that return false will not be given a chance to resolve the file.
     */
    canRead(u) {
      return i.isHttp(u.url);
    },
    /**
     * Reads the given URL and returns its raw contents as a Buffer.
     */
    read(u) {
      const s = i.parse(u.url);
      return typeof window < "u" && !s.protocol && (s.protocol = i.parse(location.href).protocol), o(s, this);
    }
  };
  async function o(u, s, f) {
    u = i.parse(u);
    const d = f || [];
    d.push(u.href);
    try {
      const l = await c(u, s);
      if (l.status >= 400)
        throw (0, r.ono)({ status: l.status }, `HTTP ERROR ${l.status}`);
      if (l.status >= 300) {
        if (!Number.isNaN(s.redirects) && d.length > s.redirects)
          throw new a.ResolverError((0, r.ono)({ status: l.status }, `Error downloading ${d[0]}. 
Too many redirects: 
  ${d.join(` 
  `)}`));
        if (!("location" in l.headers) || !l.headers.location)
          throw (0, r.ono)({ status: l.status }, `HTTP ${l.status} redirect with no location header`);
        {
          const p = i.resolve(u.href, l.headers.location);
          return o(p, s, d);
        }
      } else {
        if (l.body) {
          const p = await l.arrayBuffer();
          return Dn.from(p);
        }
        return Dn.alloc(0);
      }
    } catch (l) {
      throw new a.ResolverError((0, r.ono)(l, `Error downloading ${u.href}`), u.href);
    }
  }
  async function c(u, s) {
    let f, d;
    s.timeout && (f = new AbortController(), d = setTimeout(() => f.abort(), s.timeout));
    const l = await fetch(u, {
      method: "GET",
      headers: s.headers || {},
      credentials: s.withCredentials ? "include" : "same-origin",
      signal: f ? f.signal : null
    });
    return d && clearTimeout(d), l;
  }
  return fo;
}
var Hx;
function Pk() {
  return Hx || (Hx = 1, function(e) {
    var t = gl && gl.__importDefault || function(l) {
      return l && l.__esModule ? l : { default: l };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getNewOptions = e.getJsonSchemaRefParserDefaultOptions = void 0;
    const n = t(YU()), r = t(eH()), i = t(tH()), a = t(rH()), o = t(aH()), c = t(oH()), u = () => ({
      /**
       * Determines how different types of files will be parsed.
       *
       * You can add additional parsers of your own, replace an existing one with
       * your own implementation, or disable any parser by setting it to false.
       */
      parse: {
        json: { ...n.default },
        yaml: { ...r.default },
        text: { ...i.default },
        binary: { ...a.default }
      },
      /**
       * Determines how JSON References will be resolved.
       *
       * You can add additional resolvers of your own, replace an existing one with
       * your own implementation, or disable any resolver by setting it to false.
       */
      resolve: {
        file: { ...o.default },
        http: { ...c.default },
        /**
         * Determines whether external $ref pointers will be resolved.
         * If this option is disabled, then none of above resolvers will be called.
         * Instead, external $ref pointers will simply be ignored.
         *
         * @type {boolean}
         */
        external: !0
      },
      /**
       * By default, JSON Schema $Ref Parser throws the first error it encounters. Setting `continueOnError` to `true`
       * causes it to keep processing as much as possible and then throw a single error that contains all errors
       * that were encountered.
       */
      continueOnError: !1,
      /**
       * Determines the types of JSON references that are allowed.
       */
      dereference: {
        /**
         * Dereference circular (recursive) JSON references?
         * If false, then a {@link ReferenceError} will be thrown if a circular reference is found.
         * If "ignore", then circular references will not be dereferenced.
         *
         * @type {boolean|string}
         */
        circular: !0,
        /**
         * A function, called for each path, which can return true to stop this path and all
         * subpaths from being dereferenced further. This is useful in schemas where some
         * subpaths contain literal $ref keys that should not be dereferenced.
         *
         * @type {function}
         */
        excludedPathMatcher: () => !1,
        referenceResolution: "relative"
      },
      mutateInputSchema: !0
    });
    e.getJsonSchemaRefParserDefaultOptions = u;
    const s = (l) => {
      const p = (0, e.getJsonSchemaRefParserDefaultOptions)();
      return l && f(p, l), p;
    };
    e.getNewOptions = s;
    function f(l, p) {
      if (d(p)) {
        const g = Object.keys(p).filter((v) => !["__proto__", "constructor", "prototype"].includes(v));
        for (let v = 0; v < g.length; v++) {
          const b = g[v], y = p[b], w = l[b];
          d(y) ? l[b] = f(w || {}, y) : y !== void 0 && (l[b] = y);
        }
      }
      return l;
    }
    function d(l) {
      return l && typeof l == "object" && !Array.isArray(l) && !(l instanceof RegExp) && !(l instanceof Date);
    }
  }(gl)), gl;
}
var zx;
function sH() {
  if (zx) return ml;
  zx = 1, Object.defineProperty(ml, "__esModule", { value: !0 }), ml.normalizeArgs = t;
  const e = Pk();
  function t(n) {
    let r, i, a, o;
    const c = Array.prototype.slice.call(n);
    typeof c[c.length - 1] == "function" && (o = c.pop()), typeof c[0] == "string" ? (r = c[0], typeof c[2] == "object" ? (i = c[1], a = c[2]) : (i = void 0, a = c[1])) : (r = "", i = c[0], a = c[1]);
    try {
      a = (0, e.getNewOptions)(a);
    } catch (u) {
      console.error(`JSON Schema Ref Parser: Error normalizing options: ${u}`);
    }
    return !a.mutateInputSchema && typeof i == "object" && (i = JSON.parse(JSON.stringify(i))), {
      path: r,
      schema: i,
      options: a,
      callback: o
    };
  }
  return ml.default = t, ml;
}
var Sa = {}, Gx;
function uH() {
  if (Gx) return Sa;
  Gx = 1;
  var e = Sa && Sa.__createBinding || (Object.create ? function(l, p, g, v) {
    v === void 0 && (v = g);
    var b = Object.getOwnPropertyDescriptor(p, g);
    (!b || ("get" in b ? !p.__esModule : b.writable || b.configurable)) && (b = { enumerable: !0, get: function() {
      return p[g];
    } }), Object.defineProperty(l, v, b);
  } : function(l, p, g, v) {
    v === void 0 && (v = g), l[v] = p[g];
  }), t = Sa && Sa.__setModuleDefault || (Object.create ? function(l, p) {
    Object.defineProperty(l, "default", { enumerable: !0, value: p });
  } : function(l, p) {
    l.default = p;
  }), n = Sa && Sa.__importStar || /* @__PURE__ */ function() {
    var l = function(p) {
      return l = Object.getOwnPropertyNames || function(g) {
        var v = [];
        for (var b in g) Object.prototype.hasOwnProperty.call(g, b) && (v[v.length] = b);
        return v;
      }, l(p);
    };
    return function(p) {
      if (p && p.__esModule) return p;
      var g = {};
      if (p != null) for (var v = l(p), b = 0; b < v.length; b++) v[b] !== "default" && e(g, p, v[b]);
      return t(g, p), g;
    };
  }(), r = Sa && Sa.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(Sa, "__esModule", { value: !0 });
  const i = r(Zf()), a = r(V0()), o = r(pk()), c = n(ro()), u = no();
  function s(l, p) {
    var g;
    if (!((g = p.resolve) != null && g.external))
      return Promise.resolve();
    try {
      const v = f(l.schema, l.$refs._root$Ref.path + "#", l.$refs, p);
      return Promise.all(v);
    } catch (v) {
      return Promise.reject(v);
    }
  }
  function f(l, p, g, v, b, y) {
    b || (b = /* @__PURE__ */ new Set());
    let w = [];
    if (l && typeof l == "object" && !ArrayBuffer.isView(l) && !b.has(l)) {
      b.add(l), i.default.isExternal$Ref(l) && w.push(d(l, p, g, v));
      const C = Object.keys(l);
      for (const T of C) {
        const E = a.default.join(p, T), D = l[T];
        w = w.concat(f(D, E, g, v, b));
      }
    }
    return w;
  }
  async function d(l, p, g, v) {
    var T;
    const b = ((T = v.dereference) == null ? void 0 : T.externalReferenceResolution) === "root", y = c.resolve(b ? c.cwd() : p, l.$ref), w = c.stripHash(y), C = g._$refs[w];
    if (C)
      return Promise.resolve(C.value);
    try {
      const E = await (0, o.default)(y, g, v), D = f(E, w + "#", g, v, /* @__PURE__ */ new Set(), !0);
      return Promise.all(D);
    } catch (E) {
      if (!(v != null && v.continueOnError) || !(0, u.isHandledError)(E))
        throw E;
      return g._$refs[w] && (E.source = decodeURI(c.stripHash(p)), E.path = c.safePointerToPath(c.getHash(p))), [];
    }
  }
  return Sa.default = s, Sa;
}
var Ca = {}, Vx;
function cH() {
  if (Vx) return Ca;
  Vx = 1;
  var e = Ca && Ca.__createBinding || (Object.create ? function(p, g, v, b) {
    b === void 0 && (b = v);
    var y = Object.getOwnPropertyDescriptor(g, v);
    (!y || ("get" in y ? !g.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return g[v];
    } }), Object.defineProperty(p, b, y);
  } : function(p, g, v, b) {
    b === void 0 && (b = v), p[b] = g[v];
  }), t = Ca && Ca.__setModuleDefault || (Object.create ? function(p, g) {
    Object.defineProperty(p, "default", { enumerable: !0, value: g });
  } : function(p, g) {
    p.default = g;
  }), n = Ca && Ca.__importStar || /* @__PURE__ */ function() {
    var p = function(g) {
      return p = Object.getOwnPropertyNames || function(v) {
        var b = [];
        for (var y in v) Object.prototype.hasOwnProperty.call(v, y) && (b[b.length] = y);
        return b;
      }, p(g);
    };
    return function(g) {
      if (g && g.__esModule) return g;
      var v = {};
      if (g != null) for (var b = p(g), y = 0; y < b.length; y++) b[y] !== "default" && e(v, g, b[y]);
      return t(v, g), v;
    };
  }(), r = Ca && Ca.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(Ca, "__esModule", { value: !0 });
  const i = r(Zf()), a = r(V0()), o = n(ro());
  function c(p, g) {
    const v = [];
    u(p, "schema", p.$refs._root$Ref.path + "#", "#", 0, v, p.$refs, g), f(v);
  }
  function u(p, g, v, b, y, w, C, T) {
    const E = g === null ? p : p[g];
    if (E && typeof E == "object" && !ArrayBuffer.isView(E))
      if (i.default.isAllowed$Ref(E))
        s(p, g, v, b, y, w, C, T);
      else {
        const D = Object.keys(E).sort(($, Z) => $ === "definitions" ? -1 : Z === "definitions" ? 1 : $.length - Z.length);
        for (const $ of D) {
          const Z = a.default.join(v, $), te = a.default.join(b, $), se = E[$];
          i.default.isAllowed$Ref(se) ? s(E, $, v, te, y, w, C, T) : u(E, $, Z, te, y, w, C, T);
        }
      }
  }
  function s(p, g, v, b, y, w, C, T) {
    const E = g === null ? p : p[g], D = o.resolve(v, E.$ref), $ = C._resolve(D, b, T);
    if ($ === null)
      return;
    const te = a.default.parse(b).length, se = o.stripHash($.path), ee = o.getHash($.path), K = se !== C._root$Ref.path, re = i.default.isExtended$Ref(E);
    y += $.indirections;
    const de = d(w, p, g);
    if (de)
      if (te < de.depth || y < de.indirections)
        l(w, de);
      else
        return;
    w.push({
      $ref: E,
      // The JSON Reference (e.g. {$ref: string})
      parent: p,
      // The object that contains this $ref pointer
      key: g,
      // The key in `parent` that is the $ref pointer
      pathFromRoot: b,
      // The path to the $ref pointer, from the JSON Schema root
      depth: te,
      // How far from the JSON Schema root is this $ref pointer?
      file: se,
      // The file that the $ref pointer resolves to
      hash: ee,
      // The hash within `file` that the $ref pointer resolves to
      value: $.value,
      // The resolved value of the $ref pointer
      circular: $.circular,
      // Is this $ref pointer DIRECTLY circular? (i.e. it references itself)
      extended: re,
      // Does this $ref extend its resolved value? (i.e. it has extra properties, in addition to "$ref")
      external: K,
      // Does this $ref pointer point to a file other than the main JSON Schema file?
      indirections: y
      // The number of indirect references that were traversed to resolve the value
    }), (!de || K) && u($.value, null, $.path, b, y + 1, w, C, T);
  }
  function f(p) {
    p.sort((y, w) => {
      if (y.file !== w.file)
        return y.file < w.file ? -1 : 1;
      if (y.hash !== w.hash)
        return y.hash < w.hash ? -1 : 1;
      if (y.circular !== w.circular)
        return y.circular ? -1 : 1;
      if (y.extended !== w.extended)
        return y.extended ? 1 : -1;
      if (y.indirections !== w.indirections)
        return y.indirections - w.indirections;
      if (y.depth !== w.depth)
        return y.depth - w.depth;
      {
        const C = y.pathFromRoot.lastIndexOf("/definitions"), T = w.pathFromRoot.lastIndexOf("/definitions");
        return C !== T ? T - C : y.pathFromRoot.length - w.pathFromRoot.length;
      }
    });
    let g, v, b;
    for (const y of p)
      y.external ? y.file === g && y.hash === v ? y.$ref.$ref = b : y.file === g && y.hash.indexOf(v + "/") === 0 ? y.$ref.$ref = a.default.join(b, a.default.parse(y.hash.replace(v, "#"))) : (g = y.file, v = y.hash, b = y.pathFromRoot, y.$ref = y.parent[y.key] = i.default.dereference(y.$ref, y.value), y.circular && (y.$ref.$ref = y.pathFromRoot)) : y.$ref.$ref = y.hash;
  }
  function d(p, g, v) {
    for (const b of p)
      if (b && b.parent === g && b.key === v)
        return b;
  }
  function l(p, g) {
    const v = p.indexOf(g);
    p.splice(v, 1);
  }
  return Ca.default = c, Ca;
}
var Aa = {}, Wx;
function lH() {
  if (Wx) return Aa;
  Wx = 1;
  var e = Aa && Aa.__createBinding || (Object.create ? function(p, g, v, b) {
    b === void 0 && (b = v);
    var y = Object.getOwnPropertyDescriptor(g, v);
    (!y || ("get" in y ? !g.__esModule : y.writable || y.configurable)) && (y = { enumerable: !0, get: function() {
      return g[v];
    } }), Object.defineProperty(p, b, y);
  } : function(p, g, v, b) {
    b === void 0 && (b = v), p[b] = g[v];
  }), t = Aa && Aa.__setModuleDefault || (Object.create ? function(p, g) {
    Object.defineProperty(p, "default", { enumerable: !0, value: g });
  } : function(p, g) {
    p.default = g;
  }), n = Aa && Aa.__importStar || /* @__PURE__ */ function() {
    var p = function(g) {
      return p = Object.getOwnPropertyNames || function(v) {
        var b = [];
        for (var y in v) Object.prototype.hasOwnProperty.call(v, y) && (b[b.length] = y);
        return b;
      }, p(g);
    };
    return function(g) {
      if (g && g.__esModule) return g;
      var v = {};
      if (g != null) for (var b = p(g), y = 0; y < b.length; y++) b[y] !== "default" && e(v, g, b[y]);
      return t(v, g), v;
    };
  }(), r = Aa && Aa.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(Aa, "__esModule", { value: !0 });
  const i = r(Zf()), a = r(V0()), o = Tu, c = n(ro()), u = no();
  Aa.default = s;
  function s(p, g) {
    const v = Date.now(), b = f(p.schema, p.$refs._root$Ref.path, "#", /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Map(), p.$refs, g, v);
    p.$refs.circular = b.circular, p.schema = b.value;
  }
  function f(p, g, v, b, y, w, C, T, E) {
    var se;
    let D;
    const $ = {
      value: p,
      circular: !1
    };
    if (T && T.timeoutMs && Date.now() - E > T.timeoutMs)
      throw new u.TimeoutError(T.timeoutMs);
    const Z = T.dereference || {}, te = Z.excludedPathMatcher || (() => !1);
    if (((Z == null ? void 0 : Z.circular) === "ignore" || !y.has(p)) && p && typeof p == "object" && !ArrayBuffer.isView(p) && !te(v)) {
      if (b.add(p), y.add(p), i.default.isAllowed$Ref(p, T))
        D = d(p, g, v, b, y, w, C, T, E), $.circular = D.circular, $.value = D.value;
      else
        for (const ee of Object.keys(p)) {
          const K = a.default.join(g, ee), re = a.default.join(v, ee);
          if (te(re))
            continue;
          const de = p[ee];
          let ie = !1;
          if (i.default.isAllowed$Ref(de, T)) {
            if (D = d(de, K, re, b, y, w, C, T, E), ie = D.circular, p[ee] !== D.value) {
              const me = /* @__PURE__ */ new Map();
              Z != null && Z.preservedProperties && typeof p[ee] == "object" && !Array.isArray(p[ee]) && (Z == null || Z.preservedProperties.forEach(($e) => {
                $e in p[ee] && me.set($e, p[ee][$e]);
              })), p[ee] = D.value, Z != null && Z.preservedProperties && me.size && typeof p[ee] == "object" && !Array.isArray(p[ee]) && me.forEach(($e, Pe) => {
                p[ee][Pe] = $e;
              }), (se = Z == null ? void 0 : Z.onDereference) == null || se.call(Z, de.$ref, p[ee], p, ee);
            }
          } else
            b.has(de) ? ie = l(K, C, T) : (D = f(de, K, re, b, y, w, C, T, E), ie = D.circular, p[ee] !== D.value && (p[ee] = D.value));
          $.circular = $.circular || ie;
        }
      b.delete(p);
    }
    return $;
  }
  function d(p, g, v, b, y, w, C, T, E) {
    var ie, me;
    const $ = i.default.isExternal$Ref(p) && ((ie = T == null ? void 0 : T.dereference) == null ? void 0 : ie.externalReferenceResolution) === "root", Z = c.resolve($ ? c.cwd() : g, p.$ref), te = w.get(Z);
    if (te && !te.circular) {
      const $e = Object.keys(p);
      if ($e.length > 1) {
        const Pe = {};
        for (const Le of $e)
          Le !== "$ref" && !(Le in te.value) && (Pe[Le] = p[Le]);
        return {
          circular: te.circular,
          value: Object.assign({}, te.value, Pe)
        };
      }
      return te;
    }
    const se = C._resolve(Z, g, T);
    if (se === null)
      return {
        circular: !1,
        value: null
      };
    const ee = se.circular;
    let K = ee || b.has(se.value);
    K && l(g, C, T);
    let re = i.default.dereference(p, se.value);
    if (!K) {
      const $e = f(re, se.path, v, b, y, w, C, T, E);
      K = $e.circular, re = $e.value;
    }
    K && !ee && ((me = T.dereference) == null ? void 0 : me.circular) === "ignore" && (re = p), ee && (re.$ref = v);
    const de = {
      circular: K,
      value: re
    };
    return Object.keys(p).length === 1 && w.set(Z, de), de;
  }
  function l(p, g, v) {
    var b, y;
    if (g.circular = !0, (y = (b = v == null ? void 0 : v.dereference) == null ? void 0 : b.onCircular) == null || y.call(b, p), !v.dereference.circular)
      throw o.ono.reference(`Circular $ref pointer found at ${p}`);
    return !0;
  }
  return Aa;
}
var Zu = {}, bd = {}, Kx;
function fH() {
  if (Kx) return bd;
  Kx = 1, Object.defineProperty(bd, "__esModule", { value: !0 });
  function e() {
    return typeof bn == "object" && typeof bn.nextTick == "function" ? bn.nextTick : typeof setImmediate == "function" ? setImmediate : function(n) {
      setTimeout(n, 0);
    };
  }
  return bd.default = e(), bd;
}
var Zx;
function pH() {
  if (Zx) return Zu;
  Zx = 1;
  var e = Zu && Zu.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Zu, "__esModule", { value: !0 }), Zu.default = n;
  const t = e(fH());
  function n(r, i) {
    if (r) {
      i.then(function(a) {
        (0, t.default)(function() {
          r(null, a);
        });
      }, function(a) {
        (0, t.default)(function() {
          r(a);
        });
      });
      return;
    } else
      return i;
  }
  return Zu;
}
var Yx;
function dH() {
  return Yx || (Yx = 1, function(e) {
    var t = Ha && Ha.__createBinding || (Object.create ? function(w, C, T, E) {
      E === void 0 && (E = T);
      var D = Object.getOwnPropertyDescriptor(C, T);
      (!D || ("get" in D ? !C.__esModule : D.writable || D.configurable)) && (D = { enumerable: !0, get: function() {
        return C[T];
      } }), Object.defineProperty(w, E, D);
    } : function(w, C, T, E) {
      E === void 0 && (E = T), w[E] = C[T];
    }), n = Ha && Ha.__setModuleDefault || (Object.create ? function(w, C) {
      Object.defineProperty(w, "default", { enumerable: !0, value: C });
    } : function(w, C) {
      w.default = C;
    }), r = Ha && Ha.__importStar || /* @__PURE__ */ function() {
      var w = function(C) {
        return w = Object.getOwnPropertyNames || function(T) {
          var E = [];
          for (var D in T) Object.prototype.hasOwnProperty.call(T, D) && (E[E.length] = D);
          return E;
        }, w(C);
      };
      return function(C) {
        if (C && C.__esModule) return C;
        var T = {};
        if (C != null) for (var E = w(C), D = 0; D < E.length; D++) E[D] !== "default" && t(T, C, E[D]);
        return n(T, C), T;
      };
    }(), i = Ha && Ha.__importDefault || function(w) {
      return w && w.__esModule ? w : { default: w };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getJsonSchemaRefParserDefaultOptions = e.jsonSchemaParserNormalizeArgs = e.dereferenceInternal = e.JSONParserErrorGroup = e.isHandledError = e.UnmatchedParserError = e.ParserError = e.ResolverError = e.MissingPointerError = e.InvalidPointerError = e.JSONParserError = e.UnmatchedResolverError = e.dereference = e.bundle = e.resolve = e.parse = e.$RefParser = void 0;
    const a = i(KU()), o = i(pk()), c = i(sH());
    e.jsonSchemaParserNormalizeArgs = c.default;
    const u = i(uH()), s = i(cH()), f = i(lH());
    e.dereferenceInternal = f.default;
    const d = r(ro()), l = no();
    Object.defineProperty(e, "JSONParserError", { enumerable: !0, get: function() {
      return l.JSONParserError;
    } }), Object.defineProperty(e, "InvalidPointerError", { enumerable: !0, get: function() {
      return l.InvalidPointerError;
    } }), Object.defineProperty(e, "MissingPointerError", { enumerable: !0, get: function() {
      return l.MissingPointerError;
    } }), Object.defineProperty(e, "ResolverError", { enumerable: !0, get: function() {
      return l.ResolverError;
    } }), Object.defineProperty(e, "ParserError", { enumerable: !0, get: function() {
      return l.ParserError;
    } }), Object.defineProperty(e, "UnmatchedParserError", { enumerable: !0, get: function() {
      return l.UnmatchedParserError;
    } }), Object.defineProperty(e, "UnmatchedResolverError", { enumerable: !0, get: function() {
      return l.UnmatchedResolverError;
    } }), Object.defineProperty(e, "isHandledError", { enumerable: !0, get: function() {
      return l.isHandledError;
    } }), Object.defineProperty(e, "JSONParserErrorGroup", { enumerable: !0, get: function() {
      return l.JSONParserErrorGroup;
    } });
    const p = Tu, g = i(pH()), v = Pk();
    Object.defineProperty(e, "getJsonSchemaRefParserDefaultOptions", { enumerable: !0, get: function() {
      return v.getJsonSchemaRefParserDefaultOptions;
    } });
    class b {
      constructor() {
        this.schema = null, this.$refs = new a.default();
      }
      async parse() {
        const C = (0, c.default)(arguments);
        let T;
        if (!C.path && !C.schema) {
          const D = (0, p.ono)(`Expected a file path, URL, or object. Got ${C.path || C.schema}`);
          return (0, g.default)(C.callback, Promise.reject(D));
        }
        this.schema = null, this.$refs = new a.default();
        let E = "http";
        if (d.isFileSystemPath(C.path))
          C.path = d.fromFileSystemPath(C.path), E = "file";
        else if (!C.path && C.schema && "$id" in C.schema && C.schema.$id) {
          const D = d.parse(C.schema.$id), $ = D.protocol === "https:" ? 443 : 80;
          C.path = `${D.protocol}//${D.hostname}:${$}`;
        }
        if (C.path = d.resolve(d.cwd(), C.path), C.schema && typeof C.schema == "object") {
          const D = this.$refs._add(C.path);
          D.value = C.schema, D.pathType = E, T = Promise.resolve(C.schema);
        } else
          T = (0, o.default)(C.path, this.$refs, C.options);
        try {
          const D = await T;
          if (D !== null && typeof D == "object" && !Dn.isBuffer(D))
            return this.schema = D, (0, g.default)(C.callback, Promise.resolve(this.schema));
          if (C.options.continueOnError)
            return this.schema = null, (0, g.default)(C.callback, Promise.resolve(this.schema));
          throw p.ono.syntax(`"${this.$refs._root$Ref.path || D}" is not a valid JSON Schema`);
        } catch (D) {
          return !C.options.continueOnError || !(0, l.isHandledError)(D) ? (0, g.default)(C.callback, Promise.reject(D)) : (this.$refs._$refs[d.stripHash(C.path)] && this.$refs._$refs[d.stripHash(C.path)].addError(D), (0, g.default)(C.callback, Promise.resolve(null)));
        }
      }
      static parse() {
        const C = new b();
        return C.parse.apply(C, arguments);
      }
      async resolve() {
        const C = (0, c.default)(arguments);
        try {
          return await this.parse(C.path, C.schema, C.options), await (0, u.default)(this, C.options), y(this), (0, g.default)(C.callback, Promise.resolve(this.$refs));
        } catch (T) {
          return (0, g.default)(C.callback, Promise.reject(T));
        }
      }
      static resolve() {
        const C = new b();
        return C.resolve.apply(C, arguments);
      }
      static bundle() {
        const C = new b();
        return C.bundle.apply(C, arguments);
      }
      async bundle() {
        const C = (0, c.default)(arguments);
        try {
          return await this.resolve(C.path, C.schema, C.options), (0, s.default)(this, C.options), y(this), (0, g.default)(C.callback, Promise.resolve(this.schema));
        } catch (T) {
          return (0, g.default)(C.callback, Promise.reject(T));
        }
      }
      static dereference() {
        const C = new b();
        return C.dereference.apply(C, arguments);
      }
      async dereference() {
        const C = (0, c.default)(arguments);
        try {
          return await this.resolve(C.path, C.schema, C.options), (0, f.default)(this, C.options), y(this), (0, g.default)(C.callback, Promise.resolve(this.schema));
        } catch (T) {
          return (0, g.default)(C.callback, Promise.reject(T));
        }
      }
    }
    e.$RefParser = b, e.default = b;
    function y(w) {
      if (l.JSONParserErrorGroup.getParserErrors(w).length > 0)
        throw new l.JSONParserErrorGroup(w);
    }
    e.parse = b.parse, e.resolve = b.resolve, e.bundle = b.bundle, e.dereference = b.dereference;
  }(Ha)), Ha;
}
var hH = dH();
const Jx = /* @__PURE__ */ g2(hH), { parse: mH, stringify: gH } = JSON, { keys: vH } = Object, Cf = String, Rk = "string", Qx = {}, s0 = "object", jk = (e, t) => t, yH = (e) => e instanceof Cf ? Cf(e) : e, bH = (e, t) => typeof t === Rk ? new Cf(t) : t, Ik = (e, t, n, r) => {
  const i = [];
  for (let a = vH(n), { length: o } = a, c = 0; c < o; c++) {
    const u = a[c], s = n[u];
    if (s instanceof Cf) {
      const f = e[s];
      typeof f === s0 && !t.has(f) ? (t.add(f), n[u] = Qx, i.push({ k: u, a: [e, t, f, r] })) : n[u] = r.call(n, u, f);
    } else n[u] !== Qx && (n[u] = r.call(n, u, s));
  }
  for (let { length: a } = i, o = 0; o < a; o++) {
    const { k: c, a: u } = i[o];
    n[c] = r.call(n, c, Ik.apply(null, u));
  }
  return n;
}, Xx = (e, t, n) => {
  const r = Cf(t.push(n) - 1);
  return e.set(n, r), r;
}, u0 = (e, t) => {
  const n = mH(e, bH).map(yH), r = n[0], i = jk, a = typeof r === s0 && r ? Ik(n, /* @__PURE__ */ new Set(), r, i) : r;
  return i.call({ "": a }, "", a);
}, Fd = (e, t, n) => {
  const r = t && typeof t === s0 ? (f, d) => f === "" || -1 < t.indexOf(f) ? d : void 0 : t || jk, i = /* @__PURE__ */ new Map(), a = [], o = [];
  let c = +Xx(i, a, r.call({ "": e }, "", e)), u = !c;
  for (; c < a.length; )
    u = !0, o[c] = gH(a[c++], s, n);
  return "[" + o.join(",") + "]";
  function s(f, d) {
    if (u)
      return u = !u, d;
    const l = r.call(this, f, d);
    switch (typeof l) {
      case s0:
        if (l === null) return l;
      case Rk:
        return i.get(l) || Xx(i, a, l);
    }
    return l;
  }
}, xH = [
  "maximum",
  "minimum",
  "maxLength",
  "minLength",
  "exclusiveMaximum",
  "exclusiveMinimum",
  "multipleOf",
  "maxItems",
  "minItems"
], qk = ["small", "large"], _H = ["neutral", "primary"];
var pc = /* @__PURE__ */ ((e) => (e.ResponseCodeSelectMenu = "response-code-select-menu", e.ContentTypeSelectMenu = "content-type-select-menu", e))(pc || {});
const G2 = [
  "top",
  "right",
  "bottom",
  "left",
  "top-start",
  "top-end",
  "right-start",
  "right-end",
  "bottom-start",
  "bottom-end",
  "left-start",
  "left-end"
], wH = ["2xx", "4xx"], SH = ["small", "large"], CH = ["bash", "python", "node", "java", "javascript", "go", "ruby", "swift", "c#", "c++", "php", "c", "r", "json"];
var ys = /* @__PURE__ */ ((e) => (e.SEND = "send", e.RECEIVE = "receive", e.REQUEST = "request", e.REPLY = "reply", e))(ys || {});
const Xi = {
  ...ji,
  AsyncMessage: "async_message",
  AsyncOperation: "async_operation"
}, e7 = ({
  type: e,
  isAsyncAPIv2: t
}) => e === ys.RECEIVE ? t ? "PUB" : "RECEIVE" : e === ys.REPLY ? "REPLY" : e === ys.REQUEST ? "REQUEST" : t ? "SUB" : "SEND", Dk = (e) => {
  var t;
  return {
    type: Xi.AsyncMessage,
    uri: `/message-${e.id()}`,
    name: e.id() || "",
    data: {
      description: e.description(),
      summary: e.summary(),
      correlationId: (t = e.correlationId()) == null ? void 0 : t.location(),
      title: e.title(),
      messageId: e.id(),
      ...e.hasPayload() ? {
        payload: Jo(e.payload())
      } : null
    }
  };
}, t7 = (e) => e.isSend() ? e.reply() !== void 0 ? ys.REQUEST : ys.SEND : e.isReceive() && e.reply() !== void 0 ? ys.REPLY : ys.RECEIVE, Jo = (e) => {
  if (!e)
    return {};
  const t = {
    ...e.description() ? { description: e.description() } : null,
    ...e.examples() ? { examples: e.examples() } : null,
    ...e.format() ? { format: e.format() } : null,
    ...e.pattern() ? { pattern: e.pattern() } : null,
    ...e.title() ? { title: e.title() } : null,
    ...e.required() ? { required: e.required() } : null,
    ...e.type() ? { type: e.type() } : null,
    ...e.additionalProperties !== void 0 ? { additionalProperties: e.additionalProperties() } : null,
    ...e.enum() ? { enum: e.enum() } : null,
    ...e.isCircular() ? { isCircular: e.isCircular() } : null,
    ...e.const() ? { const: e.const() } : null,
    ...e.default() !== void 0 ? { default: e.default() } : null
  }, n = e.properties();
  n && (t.properties = {}, Object.keys(n).forEach((c) => {
    t.properties[c] = Jo(n[c]);
  }));
  const r = e.items();
  if (r)
    if (Array.isArray(r)) {
      t.items = [];
      for (let c = 0; c < r.length; c++)
        t.push(Jo(r[c]));
    } else
      t.items = Jo(r);
  const i = e.allOf();
  if (i) {
    t.allOf = [];
    for (let c = 0; c < i.length; c++)
      t.allOf.push(Jo(i[c]));
  }
  const a = e.anyOf();
  if (a) {
    t.anyOf = [];
    for (let c = 0; c < a.length; c++)
      t.anyOf.push(Jo(a[c]));
  }
  const o = e.oneOf();
  if (o) {
    t.oneOf = [];
    for (let c = 0; c < o.length; c++)
      t.oneOf.push(Jo(o[c]));
  }
  return t;
}, AH = (e, t) => {
  var g, v, b, y, w, C, T;
  const n = e.info(), r = e.version(), a = r.localeCompare("2.6.0", void 0, { numeric: !0 }) === 0, o = [], c = {
    type: Xi.HttpService,
    name: n.title(),
    // @ts-ignore version of async is not yet in SpecVersion enum
    specVersion: df.ASYNC + " " + r,
    uri: "/",
    tags: [],
    children: [],
    data: {
      id: "undefined",
      version: n.version(),
      name: n.title(),
      description: n.description(),
      ...n.hasExternalDocs() ? {
        externalDocs: {
          url: (g = n.externalDocs()) == null ? void 0 : g.url(),
          description: ((v = n.externalDocs()) == null ? void 0 : v.description()) || "External Docs"
        }
      } : null,
      ...n.hasContact() ? {
        contact: {
          name: (b = n.contact()) == null ? void 0 : b.name(),
          email: (y = n.contact()) == null ? void 0 : y.email(),
          url: (w = n.contact()) == null ? void 0 : w.url()
        }
      } : null,
      ...n.hasLicense() ? {
        license: {
          name: (C = n.license()) == null ? void 0 : C.name(),
          url: (T = n.license()) == null ? void 0 : T.url()
        }
      } : null
    }
  };
  n && o.push(
    { id: "/", slug: "/", title: "Overview", type: "overview", meta: "" }
  );
  const u = [], s = e.securitySchemes();
  s && s.length && (s.forEach((E) => {
    u.push({
      id: E.id(),
      key: E.id(),
      //@ts-ignore converting string to enum
      in: E.in(),
      name: E.name() || E.id(),
      //@ts-ignore converting string to enum
      type: E.type(),
      description: E.description() || E.openIdConnectUrl()
    });
  }), c.data.securitySchemes = u);
  const f = e.allServers();
  if (f && f.length) {
    c.data.servers = [];
    const E = {
      items: []
    };
    f.forEach((D) => {
      var $;
      ($ = c.data.servers) == null || $.push({ id: D.id(), url: D.url(), name: D.id(), description: D.description() }), E.items.push({
        id: `/operation-${D.id()}`,
        slug: `/operation-${D.id()}`,
        title: D.id() || "",
        type: "http_operation",
        meta: ""
      });
    });
  }
  const d = e.allOperations();
  if (d && d.length) {
    const E = {
      title: "Operations",
      items: [],
      hideTitle: !1,
      initiallyExpanded: !0
    };
    d.forEach((D) => {
      !E.initiallyExpanded && `/operation-${D.id()}` === t.currentPath && (E.initiallyExpanded = !0), E.items.push({
        id: `/operation-${D.id()}`,
        slug: `/operation-${D.id()}`,
        title: D.id() || "",
        type: "http_operation",
        meta: e7({ type: t7(D), isAsyncAPIv2: a })
      }), c.children.push({
        type: "async_operation",
        uri: `/operation-${D.id()}`,
        name: D.id() || "",
        data: {
          operation: D,
          method: e7({ type: t7(D), isAsyncAPIv2: a })
        }
      });
    }), o.push(E);
  }
  const l = e.allMessages();
  if (l && l.length) {
    const E = {
      title: "Messages",
      items: [],
      hideTitle: !1,
      initiallyExpanded: !0
    };
    l.forEach((D) => {
      !E.initiallyExpanded && `/message-${D.id()}` === t.currentPath && (E.initiallyExpanded = !0), E.items.push({
        id: `/message-${D.id()}`,
        slug: `/message-${D.id()}`,
        title: D.id() || "",
        type: Xi.Model,
        meta: ""
      }), c.children.push(Dk(D));
    }), o.push(E);
  }
  const p = e.components().schemas().all();
  if (p && p.length && !t.hideSchemas) {
    const E = {
      title: "Schemas",
      items: [],
      hideTitle: !1,
      initiallyExpanded: !1
    };
    p.forEach((D) => {
      !E.initiallyExpanded && `/schema-${D.id()}` === t.currentPath && (E.initiallyExpanded = !0), E.items.push({
        id: `/schema-${D.id()}`,
        slug: `/schema-${D.id()}`,
        title: D.id() || "",
        type: Xi.Model,
        meta: ""
      }), c.children.push({
        type: Xi.Model,
        uri: `/schema-${D.id()}`,
        name: D.id() || "",
        data: Jo(D)
      });
    }), o.push(E);
  }
  return { toc: o, document: c };
}, c0 = () => typeof window > "u" || typeof document > "u" || !window || !document;
function r7(e) {
  return e.replace(/\/$/, "");
}
const Lk = (e) => {
  let t = "";
  return Array.isArray(e) ? e.forEach((n, r) => {
    t += typeof n == "object" ? JSON.stringify(n) : n + `${r < e.length - 1 ? ", " : ""}`;
  }) : typeof e == "object" && (t = JSON.stringify(e)), t || e;
}, kH = (e) => {
  try {
    return typeof e == "string" ? JSON.parse(e) : e;
  } catch {
    return e;
  }
}, U6 = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_/]+/g, "-").toLowerCase(), Bi = (e, ...t) => {
  e && console.log(...t);
};
let xd = null, Yu = "", n7 = "";
const EH = () => {
  const e = Sr(), t = Sr(), n = Sr(), r = Sr();
  function i(p) {
    if (typeof p == "object" && p !== null) return p;
    if (typeof p == "string")
      if (p.startsWith("{"))
        try {
          return JSON.parse(p);
        } catch (g) {
          console.error("@kong/spec-renderer: in parseJSSON:", g);
        }
      else
        try {
          return XB.parse(p);
        } catch (g) {
          console.error("@kong/spec-renderer: in parseYaml:", g);
        }
  }
  const a = (p) => {
    const g = /* @__PURE__ */ new Set(), v = /* @__PURE__ */ new Set(), b = (C, T) => T.reduce((E, D) => (E == null ? void 0 : E[D]) ?? null, C), y = (C, T = "") => (Object.keys(C).forEach((E) => {
      try {
        if (!g.has(C[E]) && !v.has(C[E])) {
          if (typeof C[E] == "object" && C[E] !== null)
            v.add(C[E]), C[E] = y(C[E], T + "/" + E);
          else if (C[E] && N0(C[E])) {
            const D = b(p, C[E].replace("#/", "").split("/"));
            D && typeof D == "object" && (D.title = D.title || C[E].split("/").pop()), g.add(C[E]);
          }
        }
      } catch (D) {
        console.warn("@kong/spec-renderer: Issue in titleResolve:", D);
      }
    }), C);
    return y(p);
  }, o = async (p, g = {}) => {
    if (!xd) {
      const y = await import("./index-Buzul6x4.js").then((C) => C.i), w = await import("./index-CPvJadBI.js");
      xd = new y.default(), xd.registerSchemaParser(w.default());
    }
    let v = p;
    if (g.specUrl && !p) {
      try {
        v = await (await fetch(g.specUrl)).text();
      } catch (y) {
        console.error(`@kong/spec-renderer: error fetching async document from ${g.specUrl}`, y);
        return;
      }
      Bi(g.traceParsing, "async document fetched");
    }
    Yu || f(v);
    let b = null;
    try {
      const {
        document: y
        /*, diagnostics*/
      } = await xd.parse(v);
      if (!y) {
        Bi(g.traceParsing, "async document undefined after parsing");
        return;
      }
      b = y;
    } catch (y) {
      console.error("@kong/spec-renderer: error parsing async document", y);
      return;
    }
    Bi(g.traceParsing, "async document parsed");
    try {
      const { toc: y, document: w } = AH(b, {
        hideSchemas: g == null ? void 0 : g.hideSchemas,
        hideInternal: g == null ? void 0 : g.hideInternal,
        hideDeprecated: g == null ? void 0 : g.hideDeprecated,
        currentPath: g == null ? void 0 : g.currentPath
      });
      Bi(g.traceParsing, "async document transformed"), n.value = y, e.value = w;
      return;
    } catch (y) {
      console.error("@kong/spec-renderer: error transforming async document", y);
      return;
    }
  }, c = async (p, g = {}) => {
    var v, b;
    g.specUrl && !p ? (t.value = await Jx.bundle(g.specUrl, {
      resolve: {
        file: !1,
        external: !0,
        http: {
          timeout: 2e3,
          withCredentials: g.withCredentials
        }
      },
      dereference: {
        circular: !0
      },
      continueOnError: !0
    }), Bi(g.traceParsing, "fetched and external referenced bundled")) : (t.value = i(p), Bi(g.traceParsing, "parsed from string")), n7 = (b = (v = t.value) == null ? void 0 : v.info) == null ? void 0 : b.title;
  }, u = async (p, g = {}) => {
    if (await f(p, g.specUrl), (!t.value || g.enforceResetBeforeParsing) && await c(p, g), !t.value) {
      console.error("@kong/spec-renderer: empty jsonDocument initial processing");
      return;
    }
    Bi(g.traceParsing, "json document available"), Bi(g.traceParsing, "validated"), t.value = a(t.value), Bi(g.traceParsing, "title resolved");
    try {
      const v = await Jx.dereference(t.value, {
        continueOnError: !0,
        dereference: {
          circular: !0
        },
        external: !1,
        resolve: {
          file: !1,
          // http references resolved during bundle call above
          http: !1
        }
      });
      t.value = v;
    } catch (v) {
      console.error("@kong/spec-renderer: error dereferencing:", v);
    }
    Bi(g.traceParsing, "dereferenced");
    try {
      e.value = xB(t.value);
    } catch (v) {
      console.error("@kong/spec-renderer: error in transformOasToServiceNode:", v);
    }
    Bi(g.traceParsing, "transformed");
    try {
      e.value && (n.value = FM(e.value, {
        hideSchemas: g == null ? void 0 : g.hideSchemas,
        hideInternal: g == null ? void 0 : g.hideInternal,
        hideDeprecated: g == null ? void 0 : g.hideDeprecated,
        currentPath: g == null ? void 0 : g.currentPath
      }));
    } catch (v) {
      console.error("@kong/spec-renderer: error in computeAPITree:", v);
    }
    if (g.webComponentSafe)
      try {
        e.value = Fd(e.value), n.value = Fd(n.value), r.value = Fd(r.value);
      } catch (v) {
        console.error("@kong/spec-renderer: error in stringifying for web-component:", v);
      }
    Bi(g.traceParsing, "APITree computed");
  }, s = async (p, g = {}) => {
    var v;
    if (await c(p, g), !t.value) {
      console.error("@kong/spec-renderer: empty jsonDocument initial processing");
      return;
    }
    Bi(g.traceParsing, "json document available"), (v = t.value) != null && v.asyncapi ? (Bi(g.traceParsing, "asyncapi spec detected"), await o(p, g)) : (Bi(g.traceParsing, "openapi spec detected"), await u(p, g));
  }, f = async (p, g) => {
    if (Yu = p ?? "", !p && g)
      try {
        const v = await fetch(g);
        if (!v.ok)
          throw new Error(`HTTP error! status: ${v.status}`);
        Yu = await v.text();
      } catch (v) {
        console.error("@kong/spec-renderer: error in fetching spec file:", v);
      }
  }, d = async () => {
    if (!(c0() || !Yu))
      try {
        const p = l(Yu), g = window.location.pathname.replace(/[^a-zA-Z0-9]/g, ""), b = `${U6(n7 || g || "spec-file")}.${p}`, y = new Blob([Yu], { type: p === "json" ? "application/json" : "text/yaml" }), w = window.URL.createObjectURL(y), C = document.createElement("a");
        C.href = w, C.setAttribute("download", b), document.body.appendChild(C), C.click(), document.body.removeChild(C), window.URL.revokeObjectURL(w);
      } catch (p) {
        console.error("@kong/spec-renderer: error in downloading spec file:", p);
      }
  }, l = (p) => p.startsWith("{") || p.startsWith("[") ? "json" : "yaml";
  return {
    parseSpecDocument: s,
    parseOpenApiSpecDocument: u,
    parseAsyncApiSpecDocument: o,
    downloadSpecFile: d,
    parsedDocument: e,
    tableOfContents: n,
    validationResults: r
  };
};
let Ii = class extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
};
function OH(e) {
  return V2(e);
}
function V2(e) {
  return Array.isArray(e) ? TH(e) : e instanceof RegExp ? e : typeof e == "object" ? PH(e) : e;
}
function TH(e) {
  let t = [];
  for (let n = 0, r = e.length; n < r; n++)
    t[n] = V2(e[n]);
  return t;
}
function PH(e) {
  let t = {};
  for (let n in e)
    t[n] = V2(e[n]);
  return t;
}
function Nk(e, ...t) {
  return t.forEach((n) => {
    for (let r in n)
      e[r] = n[r];
  }), e;
}
function $k(e) {
  const t = ~e.lastIndexOf("/") || ~e.lastIndexOf("\\");
  return t === 0 ? e : ~t === e.length - 1 ? $k(e.substring(0, e.length - 1)) : e.substr(~t + 1);
}
var Rm = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g, _d = class {
  static hasCaptures(e) {
    return e === null ? !1 : (Rm.lastIndex = 0, Rm.test(e));
  }
  static replaceCaptures(e, t, n) {
    return e.replace(Rm, (r, i, a, o) => {
      let c = n[parseInt(i || a, 10)];
      if (c) {
        let u = t.substring(c.start, c.end);
        for (; u[0] === "."; )
          u = u.substring(1);
        switch (o) {
          case "downcase":
            return u.toLowerCase();
          case "upcase":
            return u.toUpperCase();
          default:
            return u;
        }
      } else
        return r;
    });
  }
};
function Mk(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function Fk(e, t) {
  if (e === null && t === null)
    return 0;
  if (!e)
    return -1;
  if (!t)
    return 1;
  let n = e.length, r = t.length;
  if (n === r) {
    for (let i = 0; i < n; i++) {
      let a = Mk(e[i], t[i]);
      if (a !== 0)
        return a;
    }
    return 0;
  }
  return n - r;
}
function i7(e) {
  return !!(/^#[0-9a-f]{6}$/i.test(e) || /^#[0-9a-f]{8}$/i.test(e) || /^#[0-9a-f]{3}$/i.test(e) || /^#[0-9a-f]{4}$/i.test(e));
}
function Bk(e) {
  return e.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var Uk = class {
  constructor(e) {
    Ut(this, "cache", /* @__PURE__ */ new Map());
    this.fn = e;
  }
  get(e) {
    if (this.cache.has(e))
      return this.cache.get(e);
    const t = this.fn(e);
    return this.cache.set(e, t), t;
  }
}, l0 = class {
  constructor(e, t, n) {
    Ut(this, "_cachedMatchRoot", new Uk(
      (e) => this._root.match(e)
    ));
    this._colorMap = e, this._defaults = t, this._root = n;
  }
  static createFromRawTheme(e, t) {
    return this.createFromParsedTheme(IH(e), t);
  }
  static createFromParsedTheme(e, t) {
    return DH(e, t);
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  getDefaults() {
    return this._defaults;
  }
  match(e) {
    if (e === null)
      return this._defaults;
    const t = e.scopeName, r = this._cachedMatchRoot.get(t).find(
      (i) => RH(e.parent, i.parentScopes)
    );
    return r ? new Hk(
      r.fontStyle,
      r.foreground,
      r.background
    ) : null;
  }
}, jm = class Bd {
  constructor(t, n) {
    this.parent = t, this.scopeName = n;
  }
  static push(t, n) {
    for (const r of n)
      t = new Bd(t, r);
    return t;
  }
  static from(...t) {
    let n = null;
    for (let r = 0; r < t.length; r++)
      n = new Bd(n, t[r]);
    return n;
  }
  push(t) {
    return new Bd(this, t);
  }
  getSegments() {
    let t = this;
    const n = [];
    for (; t; )
      n.push(t.scopeName), t = t.parent;
    return n.reverse(), n;
  }
  toString() {
    return this.getSegments().join(" ");
  }
  extends(t) {
    return this === t ? !0 : this.parent === null ? !1 : this.parent.extends(t);
  }
  getExtensionIfDefined(t) {
    const n = [];
    let r = this;
    for (; r && r !== t; )
      n.push(r.scopeName), r = r.parent;
    return r === t ? n.reverse() : void 0;
  }
};
function RH(e, t) {
  if (t.length === 0)
    return !0;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], i = !1;
    if (r === ">") {
      if (n === t.length - 1)
        return !1;
      r = t[++n], i = !0;
    }
    for (; e && !jH(e.scopeName, r); ) {
      if (i)
        return !1;
      e = e.parent;
    }
    if (!e)
      return !1;
    e = e.parent;
  }
  return !0;
}
function jH(e, t) {
  return t === e || e.startsWith(t) && e[t.length] === ".";
}
var Hk = class {
  constructor(e, t, n) {
    this.fontStyle = e, this.foregroundId = t, this.backgroundId = n;
  }
};
function IH(e) {
  if (!e)
    return [];
  if (!e.settings || !Array.isArray(e.settings))
    return [];
  let t = e.settings, n = [], r = 0;
  for (let i = 0, a = t.length; i < a; i++) {
    let o = t[i];
    if (!o.settings)
      continue;
    let c;
    if (typeof o.scope == "string") {
      let d = o.scope;
      d = d.replace(/^[,]+/, ""), d = d.replace(/[,]+$/, ""), c = d.split(",");
    } else Array.isArray(o.scope) ? c = o.scope : c = [""];
    let u = -1;
    if (typeof o.settings.fontStyle == "string") {
      u = 0;
      let d = o.settings.fontStyle.split(" ");
      for (let l = 0, p = d.length; l < p; l++)
        switch (d[l]) {
          case "italic":
            u = u | 1;
            break;
          case "bold":
            u = u | 2;
            break;
          case "underline":
            u = u | 4;
            break;
          case "strikethrough":
            u = u | 8;
            break;
        }
    }
    let s = null;
    typeof o.settings.foreground == "string" && i7(o.settings.foreground) && (s = o.settings.foreground);
    let f = null;
    typeof o.settings.background == "string" && i7(o.settings.background) && (f = o.settings.background);
    for (let d = 0, l = c.length; d < l; d++) {
      let g = c[d].trim().split(" "), v = g[g.length - 1], b = null;
      g.length > 1 && (b = g.slice(0, g.length - 1), b.reverse()), n[r++] = new qH(
        v,
        b,
        i,
        u,
        s,
        f
      );
    }
  }
  return n;
}
var qH = class {
  constructor(e, t, n, r, i, a) {
    this.scope = e, this.parentScopes = t, this.index = n, this.fontStyle = r, this.foreground = i, this.background = a;
  }
}, qi = /* @__PURE__ */ ((e) => (e[e.NotSet = -1] = "NotSet", e[e.None = 0] = "None", e[e.Italic = 1] = "Italic", e[e.Bold = 2] = "Bold", e[e.Underline = 4] = "Underline", e[e.Strikethrough = 8] = "Strikethrough", e))(qi || {});
function DH(e, t) {
  e.sort((u, s) => {
    let f = Mk(u.scope, s.scope);
    return f !== 0 || (f = Fk(u.parentScopes, s.parentScopes), f !== 0) ? f : u.index - s.index;
  });
  let n = 0, r = "#000000", i = "#ffffff";
  for (; e.length >= 1 && e[0].scope === ""; ) {
    let u = e.shift();
    u.fontStyle !== -1 && (n = u.fontStyle), u.foreground !== null && (r = u.foreground), u.background !== null && (i = u.background);
  }
  let a = new LH(t), o = new Hk(n, a.getId(r), a.getId(i)), c = new $H(new H6(0, null, -1, 0, 0), []);
  for (let u = 0, s = e.length; u < s; u++) {
    let f = e[u];
    c.insert(0, f.scope, f.parentScopes, f.fontStyle, a.getId(f.foreground), a.getId(f.background));
  }
  return new l0(a, o, c);
}
var LH = class {
  constructor(e) {
    Ut(this, "_isFrozen");
    Ut(this, "_lastColorId");
    Ut(this, "_id2color");
    Ut(this, "_color2id");
    if (this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ Object.create(null), Array.isArray(e)) {
      this._isFrozen = !0;
      for (let t = 0, n = e.length; t < n; t++)
        this._color2id[e[t]] = t, this._id2color[t] = e[t];
    } else
      this._isFrozen = !1;
  }
  getId(e) {
    if (e === null)
      return 0;
    e = e.toUpperCase();
    let t = this._color2id[e];
    if (t)
      return t;
    if (this._isFrozen)
      throw new Error(`Missing color in color map - ${e}`);
    return t = ++this._lastColorId, this._color2id[e] = t, this._id2color[t] = e, t;
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}, NH = Object.freeze([]), H6 = class zk {
  constructor(t, n, r, i, a) {
    Ut(this, "scopeDepth");
    Ut(this, "parentScopes");
    Ut(this, "fontStyle");
    Ut(this, "foreground");
    Ut(this, "background");
    this.scopeDepth = t, this.parentScopes = n || NH, this.fontStyle = r, this.foreground = i, this.background = a;
  }
  clone() {
    return new zk(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
  }
  static cloneArr(t) {
    let n = [];
    for (let r = 0, i = t.length; r < i; r++)
      n[r] = t[r].clone();
    return n;
  }
  acceptOverwrite(t, n, r, i) {
    this.scopeDepth > t ? console.log("how did this happen?") : this.scopeDepth = t, n !== -1 && (this.fontStyle = n), r !== 0 && (this.foreground = r), i !== 0 && (this.background = i);
  }
}, $H = class z6 {
  constructor(t, n = [], r = {}) {
    Ut(this, "_rulesWithParentScopes");
    this._mainRule = t, this._children = r, this._rulesWithParentScopes = n;
  }
  static _cmpBySpecificity(t, n) {
    if (t.scopeDepth !== n.scopeDepth)
      return n.scopeDepth - t.scopeDepth;
    let r = 0, i = 0;
    for (; t.parentScopes[r] === ">" && r++, n.parentScopes[i] === ">" && i++, !(r >= t.parentScopes.length || i >= n.parentScopes.length); ) {
      const a = n.parentScopes[i].length - t.parentScopes[r].length;
      if (a !== 0)
        return a;
      r++, i++;
    }
    return n.parentScopes.length - t.parentScopes.length;
  }
  match(t) {
    if (t !== "") {
      let r = t.indexOf("."), i, a;
      if (r === -1 ? (i = t, a = "") : (i = t.substring(0, r), a = t.substring(r + 1)), this._children.hasOwnProperty(i))
        return this._children[i].match(a);
    }
    const n = this._rulesWithParentScopes.concat(this._mainRule);
    return n.sort(z6._cmpBySpecificity), n;
  }
  insert(t, n, r, i, a, o) {
    if (n === "") {
      this._doInsertHere(t, r, i, a, o);
      return;
    }
    let c = n.indexOf("."), u, s;
    c === -1 ? (u = n, s = "") : (u = n.substring(0, c), s = n.substring(c + 1));
    let f;
    this._children.hasOwnProperty(u) ? f = this._children[u] : (f = new z6(this._mainRule.clone(), H6.cloneArr(this._rulesWithParentScopes)), this._children[u] = f), f.insert(t + 1, s, r, i, a, o);
  }
  _doInsertHere(t, n, r, i, a) {
    if (n === null) {
      this._mainRule.acceptOverwrite(t, r, i, a);
      return;
    }
    for (let o = 0, c = this._rulesWithParentScopes.length; o < c; o++) {
      let u = this._rulesWithParentScopes[o];
      if (Fk(u.parentScopes, n) === 0) {
        u.acceptOverwrite(t, r, i, a);
        return;
      }
    }
    r === -1 && (r = this._mainRule.fontStyle), i === 0 && (i = this._mainRule.foreground), a === 0 && (a = this._mainRule.background), this._rulesWithParentScopes.push(new H6(t, n, r, i, a));
  }
}, dc = class ka {
  static toBinaryStr(t) {
    return t.toString(2).padStart(32, "0");
  }
  static print(t) {
    const n = ka.getLanguageId(t), r = ka.getTokenType(t), i = ka.getFontStyle(t), a = ka.getForeground(t), o = ka.getBackground(t);
    console.log({
      languageId: n,
      tokenType: r,
      fontStyle: i,
      foreground: a,
      background: o
    });
  }
  static getLanguageId(t) {
    return (t & 255) >>> 0;
  }
  static getTokenType(t) {
    return (t & 768) >>> 8;
  }
  static containsBalancedBrackets(t) {
    return (t & 1024) !== 0;
  }
  static getFontStyle(t) {
    return (t & 30720) >>> 11;
  }
  static getForeground(t) {
    return (t & 16744448) >>> 15;
  }
  static getBackground(t) {
    return (t & 4278190080) >>> 24;
  }
  /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */
  static set(t, n, r, i, a, o, c) {
    let u = ka.getLanguageId(t), s = ka.getTokenType(t), f = ka.containsBalancedBrackets(t) ? 1 : 0, d = ka.getFontStyle(t), l = ka.getForeground(t), p = ka.getBackground(t);
    return n !== 0 && (u = n), r !== 8 && (s = r), i !== null && (f = i ? 1 : 0), a !== -1 && (d = a), o !== 0 && (l = o), c !== 0 && (p = c), (u << 0 | s << 8 | f << 10 | d << 11 | l << 15 | p << 24) >>> 0;
  }
};
function f0(e, t) {
  const n = [], r = MH(e);
  let i = r.next();
  for (; i !== null; ) {
    let u = 0;
    if (i.length === 2 && i.charAt(1) === ":") {
      switch (i.charAt(0)) {
        case "R":
          u = 1;
          break;
        case "L":
          u = -1;
          break;
        default:
          console.log(`Unknown priority ${i} in scope selector`);
      }
      i = r.next();
    }
    let s = o();
    if (n.push({ matcher: s, priority: u }), i !== ",")
      break;
    i = r.next();
  }
  return n;
  function a() {
    if (i === "-") {
      i = r.next();
      const u = a();
      return (s) => !!u && !u(s);
    }
    if (i === "(") {
      i = r.next();
      const u = c();
      return i === ")" && (i = r.next()), u;
    }
    if (a7(i)) {
      const u = [];
      do
        u.push(i), i = r.next();
      while (a7(i));
      return (s) => t(u, s);
    }
    return null;
  }
  function o() {
    const u = [];
    let s = a();
    for (; s; )
      u.push(s), s = a();
    return (f) => u.every((d) => d(f));
  }
  function c() {
    const u = [];
    let s = o();
    for (; s && (u.push(s), i === "|" || i === ","); ) {
      do
        i = r.next();
      while (i === "|" || i === ",");
      s = o();
    }
    return (f) => u.some((d) => d(f));
  }
}
function a7(e) {
  return !!e && !!e.match(/[\w\.:]+/);
}
function MH(e) {
  let t = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g, n = t.exec(e);
  return {
    next: () => {
      if (!n)
        return null;
      const r = n[0];
      return n = t.exec(e), r;
    }
  };
}
function Gk(e) {
  typeof e.dispose == "function" && e.dispose();
}
var Af = class {
  constructor(e) {
    this.scopeName = e;
  }
  toKey() {
    return this.scopeName;
  }
}, FH = class {
  constructor(e, t) {
    this.scopeName = e, this.ruleName = t;
  }
  toKey() {
    return `${this.scopeName}#${this.ruleName}`;
  }
}, BH = class {
  constructor() {
    Ut(this, "_references", []);
    Ut(this, "_seenReferenceKeys", /* @__PURE__ */ new Set());
    Ut(this, "visitedRule", /* @__PURE__ */ new Set());
  }
  get references() {
    return this._references;
  }
  add(e) {
    const t = e.toKey();
    this._seenReferenceKeys.has(t) || (this._seenReferenceKeys.add(t), this._references.push(e));
  }
}, UH = class {
  constructor(e, t) {
    Ut(this, "seenFullScopeRequests", /* @__PURE__ */ new Set());
    Ut(this, "seenPartialScopeRequests", /* @__PURE__ */ new Set());
    Ut(this, "Q");
    this.repo = e, this.initialScopeName = t, this.seenFullScopeRequests.add(this.initialScopeName), this.Q = [new Af(this.initialScopeName)];
  }
  processQueue() {
    const e = this.Q;
    this.Q = [];
    const t = new BH();
    for (const n of e)
      HH(n, this.initialScopeName, this.repo, t);
    for (const n of t.references)
      if (n instanceof Af) {
        if (this.seenFullScopeRequests.has(n.scopeName))
          continue;
        this.seenFullScopeRequests.add(n.scopeName), this.Q.push(n);
      } else {
        if (this.seenFullScopeRequests.has(n.scopeName) || this.seenPartialScopeRequests.has(n.toKey()))
          continue;
        this.seenPartialScopeRequests.add(n.toKey()), this.Q.push(n);
      }
  }
};
function HH(e, t, n, r) {
  const i = n.lookup(e.scopeName);
  if (!i) {
    if (e.scopeName === t)
      throw new Error(`No grammar provided for <${t}>`);
    return;
  }
  const a = n.lookup(t);
  e instanceof Af ? Ud({ baseGrammar: a, selfGrammar: i }, r) : G6(
    e.ruleName,
    { baseGrammar: a, selfGrammar: i, repository: i.repository },
    r
  );
  const o = n.injections(e.scopeName);
  if (o)
    for (const c of o)
      r.add(new Af(c));
}
function G6(e, t, n) {
  if (t.repository && t.repository[e]) {
    const r = t.repository[e];
    p0([r], t, n);
  }
}
function Ud(e, t) {
  e.selfGrammar.patterns && Array.isArray(e.selfGrammar.patterns) && p0(
    e.selfGrammar.patterns,
    { ...e, repository: e.selfGrammar.repository },
    t
  ), e.selfGrammar.injections && p0(
    Object.values(e.selfGrammar.injections),
    { ...e, repository: e.selfGrammar.repository },
    t
  );
}
function p0(e, t, n) {
  for (const r of e) {
    if (n.visitedRule.has(r))
      continue;
    n.visitedRule.add(r);
    const i = r.repository ? Nk({}, t.repository, r.repository) : t.repository;
    Array.isArray(r.patterns) && p0(r.patterns, { ...t, repository: i }, n);
    const a = r.include;
    if (!a)
      continue;
    const o = Vk(a);
    switch (o.kind) {
      case 0:
        Ud({ ...t, selfGrammar: t.baseGrammar }, n);
        break;
      case 1:
        Ud(t, n);
        break;
      case 2:
        G6(o.ruleName, { ...t, repository: i }, n);
        break;
      case 3:
      case 4:
        const c = o.scopeName === t.selfGrammar.scopeName ? t.selfGrammar : o.scopeName === t.baseGrammar.scopeName ? t.baseGrammar : void 0;
        if (c) {
          const u = { baseGrammar: t.baseGrammar, selfGrammar: c, repository: i };
          o.kind === 4 ? G6(o.ruleName, u, n) : Ud(u, n);
        } else
          o.kind === 4 ? n.add(new FH(o.scopeName, o.ruleName)) : n.add(new Af(o.scopeName));
        break;
    }
  }
}
var zH = class {
  constructor() {
    Ut(this, "kind", 0);
  }
}, GH = class {
  constructor() {
    Ut(this, "kind", 1);
  }
}, VH = class {
  constructor(e) {
    Ut(this, "kind", 2);
    this.ruleName = e;
  }
}, WH = class {
  constructor(e) {
    Ut(this, "kind", 3);
    this.scopeName = e;
  }
}, KH = class {
  constructor(e, t) {
    Ut(this, "kind", 4);
    this.scopeName = e, this.ruleName = t;
  }
};
function Vk(e) {
  if (e === "$base")
    return new zH();
  if (e === "$self")
    return new GH();
  const t = e.indexOf("#");
  if (t === -1)
    return new WH(e);
  if (t === 0)
    return new VH(e.substring(1));
  {
    const n = e.substring(0, t), r = e.substring(t + 1);
    return new KH(n, r);
  }
}
var ZH = /\\(\d+)/, o7 = /\\(\d+)/g, YH = -1, Wk = -2;
var Qf = class {
  constructor(e, t, n, r) {
    Ut(this, "$location");
    Ut(this, "id");
    Ut(this, "_nameIsCapturing");
    Ut(this, "_name");
    Ut(this, "_contentNameIsCapturing");
    Ut(this, "_contentName");
    this.$location = e, this.id = t, this._name = n || null, this._nameIsCapturing = _d.hasCaptures(this._name), this._contentName = r || null, this._contentNameIsCapturing = _d.hasCaptures(this._contentName);
  }
  get debugName() {
    const e = this.$location ? `${$k(this.$location.filename)}:${this.$location.line}` : "unknown";
    return `${this.constructor.name}#${this.id} @ ${e}`;
  }
  getName(e, t) {
    return !this._nameIsCapturing || this._name === null || e === null || t === null ? this._name : _d.replaceCaptures(this._name, e, t);
  }
  getContentName(e, t) {
    return !this._contentNameIsCapturing || this._contentName === null ? this._contentName : _d.replaceCaptures(this._contentName, e, t);
  }
}, JH = class extends Qf {
  constructor(t, n, r, i, a) {
    super(t, n, r, i);
    Ut(this, "retokenizeCapturedWithRuleId");
    this.retokenizeCapturedWithRuleId = a;
  }
  dispose() {
  }
  collectPatterns(t, n) {
    throw new Error("Not supported!");
  }
  compile(t, n) {
    throw new Error("Not supported!");
  }
  compileAG(t, n, r, i) {
    throw new Error("Not supported!");
  }
}, QH = class extends Qf {
  constructor(t, n, r, i, a) {
    super(t, n, r, null);
    Ut(this, "_match");
    Ut(this, "captures");
    Ut(this, "_cachedCompiledPatterns");
    this._match = new kf(i, this.id), this.captures = a, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugMatchRegExp() {
    return `${this._match.source}`;
  }
  collectPatterns(t, n) {
    n.push(this._match);
  }
  compile(t, n) {
    return this._getCachedCompiledPatterns(t).compile(t);
  }
  compileAG(t, n, r, i) {
    return this._getCachedCompiledPatterns(t).compileAG(t, r, i);
  }
  _getCachedCompiledPatterns(t) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new Ef(), this.collectPatterns(t, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, s7 = class extends Qf {
  constructor(t, n, r, i, a) {
    super(t, n, r, i);
    Ut(this, "hasMissingPatterns");
    Ut(this, "patterns");
    Ut(this, "_cachedCompiledPatterns");
    this.patterns = a.patterns, this.hasMissingPatterns = a.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  collectPatterns(t, n) {
    for (const r of this.patterns)
      t.getRule(r).collectPatterns(t, n);
  }
  compile(t, n) {
    return this._getCachedCompiledPatterns(t).compile(t);
  }
  compileAG(t, n, r, i) {
    return this._getCachedCompiledPatterns(t).compileAG(t, r, i);
  }
  _getCachedCompiledPatterns(t) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new Ef(), this.collectPatterns(t, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, V6 = class extends Qf {
  constructor(t, n, r, i, a, o, c, u, s, f) {
    super(t, n, r, i);
    Ut(this, "_begin");
    Ut(this, "beginCaptures");
    Ut(this, "_end");
    Ut(this, "endHasBackReferences");
    Ut(this, "endCaptures");
    Ut(this, "applyEndPatternLast");
    Ut(this, "hasMissingPatterns");
    Ut(this, "patterns");
    Ut(this, "_cachedCompiledPatterns");
    this._begin = new kf(a, this.id), this.beginCaptures = o, this._end = new kf(c || "￿", -1), this.endHasBackReferences = this._end.hasBackReferences, this.endCaptures = u, this.applyEndPatternLast = s || !1, this.patterns = f.patterns, this.hasMissingPatterns = f.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugEndRegExp() {
    return `${this._end.source}`;
  }
  getEndWithResolvedBackReferences(t, n) {
    return this._end.resolveBackReferences(t, n);
  }
  collectPatterns(t, n) {
    n.push(this._begin);
  }
  compile(t, n) {
    return this._getCachedCompiledPatterns(t, n).compile(t);
  }
  compileAG(t, n, r, i) {
    return this._getCachedCompiledPatterns(t, n).compileAG(t, r, i);
  }
  _getCachedCompiledPatterns(t, n) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new Ef();
      for (const r of this.patterns)
        t.getRule(r).collectPatterns(t, this._cachedCompiledPatterns);
      this.applyEndPatternLast ? this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end) : this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
    }
    return this._end.hasBackReferences && (this.applyEndPatternLast ? this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, n) : this._cachedCompiledPatterns.setSource(0, n)), this._cachedCompiledPatterns;
  }
}, d0 = class extends Qf {
  constructor(t, n, r, i, a, o, c, u, s) {
    super(t, n, r, i);
    Ut(this, "_begin");
    Ut(this, "beginCaptures");
    Ut(this, "whileCaptures");
    Ut(this, "_while");
    Ut(this, "whileHasBackReferences");
    Ut(this, "hasMissingPatterns");
    Ut(this, "patterns");
    Ut(this, "_cachedCompiledPatterns");
    Ut(this, "_cachedCompiledWhilePatterns");
    this._begin = new kf(a, this.id), this.beginCaptures = o, this.whileCaptures = u, this._while = new kf(c, Wk), this.whileHasBackReferences = this._while.hasBackReferences, this.patterns = s.patterns, this.hasMissingPatterns = s.hasMissingPatterns, this._cachedCompiledPatterns = null, this._cachedCompiledWhilePatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null), this._cachedCompiledWhilePatterns && (this._cachedCompiledWhilePatterns.dispose(), this._cachedCompiledWhilePatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugWhileRegExp() {
    return `${this._while.source}`;
  }
  getWhileWithResolvedBackReferences(t, n) {
    return this._while.resolveBackReferences(t, n);
  }
  collectPatterns(t, n) {
    n.push(this._begin);
  }
  compile(t, n) {
    return this._getCachedCompiledPatterns(t).compile(t);
  }
  compileAG(t, n, r, i) {
    return this._getCachedCompiledPatterns(t).compileAG(t, r, i);
  }
  _getCachedCompiledPatterns(t) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new Ef();
      for (const n of this.patterns)
        t.getRule(n).collectPatterns(t, this._cachedCompiledPatterns);
    }
    return this._cachedCompiledPatterns;
  }
  compileWhile(t, n) {
    return this._getCachedCompiledWhilePatterns(t, n).compile(t);
  }
  compileWhileAG(t, n, r, i) {
    return this._getCachedCompiledWhilePatterns(t, n).compileAG(t, r, i);
  }
  _getCachedCompiledWhilePatterns(t, n) {
    return this._cachedCompiledWhilePatterns || (this._cachedCompiledWhilePatterns = new Ef(), this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while)), this._while.hasBackReferences && this._cachedCompiledWhilePatterns.setSource(0, n || "￿"), this._cachedCompiledWhilePatterns;
  }
}, Kk = class Ri {
  static createCaptureRule(t, n, r, i, a) {
    return t.registerRule((o) => new JH(n, o, r, i, a));
  }
  static getCompiledRuleId(t, n, r) {
    return t.id || n.registerRule((i) => {
      if (t.id = i, t.match)
        return new QH(
          t.$vscodeTextmateLocation,
          t.id,
          t.name,
          t.match,
          Ri._compileCaptures(t.captures, n, r)
        );
      if (typeof t.begin > "u") {
        t.repository && (r = Nk({}, r, t.repository));
        let a = t.patterns;
        return typeof a > "u" && t.include && (a = [{ include: t.include }]), new s7(
          t.$vscodeTextmateLocation,
          t.id,
          t.name,
          t.contentName,
          Ri._compilePatterns(a, n, r)
        );
      }
      return t.while ? new d0(
        t.$vscodeTextmateLocation,
        t.id,
        t.name,
        t.contentName,
        t.begin,
        Ri._compileCaptures(t.beginCaptures || t.captures, n, r),
        t.while,
        Ri._compileCaptures(t.whileCaptures || t.captures, n, r),
        Ri._compilePatterns(t.patterns, n, r)
      ) : new V6(
        t.$vscodeTextmateLocation,
        t.id,
        t.name,
        t.contentName,
        t.begin,
        Ri._compileCaptures(t.beginCaptures || t.captures, n, r),
        t.end,
        Ri._compileCaptures(t.endCaptures || t.captures, n, r),
        t.applyEndPatternLast,
        Ri._compilePatterns(t.patterns, n, r)
      );
    }), t.id;
  }
  static _compileCaptures(t, n, r) {
    let i = [];
    if (t) {
      let a = 0;
      for (const o in t) {
        if (o === "$vscodeTextmateLocation")
          continue;
        const c = parseInt(o, 10);
        c > a && (a = c);
      }
      for (let o = 0; o <= a; o++)
        i[o] = null;
      for (const o in t) {
        if (o === "$vscodeTextmateLocation")
          continue;
        const c = parseInt(o, 10);
        let u = 0;
        t[o].patterns && (u = Ri.getCompiledRuleId(t[o], n, r)), i[c] = Ri.createCaptureRule(n, t[o].$vscodeTextmateLocation, t[o].name, t[o].contentName, u);
      }
    }
    return i;
  }
  static _compilePatterns(t, n, r) {
    let i = [];
    if (t)
      for (let a = 0, o = t.length; a < o; a++) {
        const c = t[a];
        let u = -1;
        if (c.include) {
          const s = Vk(c.include);
          switch (s.kind) {
            case 0:
            case 1:
              u = Ri.getCompiledRuleId(r[c.include], n, r);
              break;
            case 2:
              let f = r[s.ruleName];
              f && (u = Ri.getCompiledRuleId(f, n, r));
              break;
            case 3:
            case 4:
              const d = s.scopeName, l = s.kind === 4 ? s.ruleName : null, p = n.getExternalGrammar(d, r);
              if (p)
                if (l) {
                  let g = p.repository[l];
                  g && (u = Ri.getCompiledRuleId(g, n, p.repository));
                } else
                  u = Ri.getCompiledRuleId(p.repository.$self, n, p.repository);
              break;
          }
        } else
          u = Ri.getCompiledRuleId(c, n, r);
        if (u !== -1) {
          const s = n.getRule(u);
          let f = !1;
          if ((s instanceof s7 || s instanceof V6 || s instanceof d0) && s.hasMissingPatterns && s.patterns.length === 0 && (f = !0), f)
            continue;
          i.push(u);
        }
      }
    return {
      patterns: i,
      hasMissingPatterns: (t ? t.length : 0) !== i.length
    };
  }
}, kf = class Zk {
  constructor(t, n) {
    Ut(this, "source");
    Ut(this, "ruleId");
    Ut(this, "hasAnchor");
    Ut(this, "hasBackReferences");
    Ut(this, "_anchorCache");
    if (t && typeof t == "string") {
      const r = t.length;
      let i = 0, a = [], o = !1;
      for (let c = 0; c < r; c++)
        if (t.charAt(c) === "\\" && c + 1 < r) {
          const s = t.charAt(c + 1);
          s === "z" ? (a.push(t.substring(i, c)), a.push("$(?!\\n)(?<!\\n)"), i = c + 2) : (s === "A" || s === "G") && (o = !0), c++;
        }
      this.hasAnchor = o, i === 0 ? this.source = t : (a.push(t.substring(i, r)), this.source = a.join(""));
    } else
      this.hasAnchor = !1, this.source = t;
    this.hasAnchor ? this._anchorCache = this._buildAnchorCache() : this._anchorCache = null, this.ruleId = n, typeof this.source == "string" ? this.hasBackReferences = ZH.test(this.source) : this.hasBackReferences = !1;
  }
  clone() {
    return new Zk(this.source, this.ruleId);
  }
  setSource(t) {
    this.source !== t && (this.source = t, this.hasAnchor && (this._anchorCache = this._buildAnchorCache()));
  }
  resolveBackReferences(t, n) {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let r = n.map((i) => t.substring(i.start, i.end));
    return o7.lastIndex = 0, this.source.replace(o7, (i, a) => Bk(r[parseInt(a, 10)] || ""));
  }
  _buildAnchorCache() {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let t = [], n = [], r = [], i = [], a, o, c, u;
    for (a = 0, o = this.source.length; a < o; a++)
      c = this.source.charAt(a), t[a] = c, n[a] = c, r[a] = c, i[a] = c, c === "\\" && a + 1 < o && (u = this.source.charAt(a + 1), u === "A" ? (t[a + 1] = "￿", n[a + 1] = "￿", r[a + 1] = "A", i[a + 1] = "A") : u === "G" ? (t[a + 1] = "￿", n[a + 1] = "G", r[a + 1] = "￿", i[a + 1] = "G") : (t[a + 1] = u, n[a + 1] = u, r[a + 1] = u, i[a + 1] = u), a++);
    return {
      A0_G0: t.join(""),
      A0_G1: n.join(""),
      A1_G0: r.join(""),
      A1_G1: i.join("")
    };
  }
  resolveAnchors(t, n) {
    return !this.hasAnchor || !this._anchorCache || typeof this.source != "string" ? this.source : t ? n ? this._anchorCache.A1_G1 : this._anchorCache.A1_G0 : n ? this._anchorCache.A0_G1 : this._anchorCache.A0_G0;
  }
}, Ef = class {
  constructor() {
    Ut(this, "_items");
    Ut(this, "_hasAnchors");
    Ut(this, "_cached");
    Ut(this, "_anchorCache");
    this._items = [], this._hasAnchors = !1, this._cached = null, this._anchorCache = {
      A0_G0: null,
      A0_G1: null,
      A1_G0: null,
      A1_G1: null
    };
  }
  dispose() {
    this._disposeCaches();
  }
  _disposeCaches() {
    this._cached && (this._cached.dispose(), this._cached = null), this._anchorCache.A0_G0 && (this._anchorCache.A0_G0.dispose(), this._anchorCache.A0_G0 = null), this._anchorCache.A0_G1 && (this._anchorCache.A0_G1.dispose(), this._anchorCache.A0_G1 = null), this._anchorCache.A1_G0 && (this._anchorCache.A1_G0.dispose(), this._anchorCache.A1_G0 = null), this._anchorCache.A1_G1 && (this._anchorCache.A1_G1.dispose(), this._anchorCache.A1_G1 = null);
  }
  push(e) {
    this._items.push(e), this._hasAnchors = this._hasAnchors || e.hasAnchor;
  }
  unshift(e) {
    this._items.unshift(e), this._hasAnchors = this._hasAnchors || e.hasAnchor;
  }
  length() {
    return this._items.length;
  }
  setSource(e, t) {
    this._items[e].source !== t && (this._disposeCaches(), this._items[e].setSource(t));
  }
  compile(e) {
    if (!this._cached) {
      let t = this._items.map((n) => n.source);
      this._cached = new u7(e, t, this._items.map((n) => n.ruleId));
    }
    return this._cached;
  }
  compileAG(e, t, n) {
    return this._hasAnchors ? t ? n ? (this._anchorCache.A1_G1 || (this._anchorCache.A1_G1 = this._resolveAnchors(e, t, n)), this._anchorCache.A1_G1) : (this._anchorCache.A1_G0 || (this._anchorCache.A1_G0 = this._resolveAnchors(e, t, n)), this._anchorCache.A1_G0) : n ? (this._anchorCache.A0_G1 || (this._anchorCache.A0_G1 = this._resolveAnchors(e, t, n)), this._anchorCache.A0_G1) : (this._anchorCache.A0_G0 || (this._anchorCache.A0_G0 = this._resolveAnchors(e, t, n)), this._anchorCache.A0_G0) : this.compile(e);
  }
  _resolveAnchors(e, t, n) {
    let r = this._items.map((i) => i.resolveAnchors(t, n));
    return new u7(e, r, this._items.map((i) => i.ruleId));
  }
}, u7 = class {
  constructor(e, t, n) {
    Ut(this, "scanner");
    this.regExps = t, this.rules = n, this.scanner = e.createOnigScanner(t);
  }
  dispose() {
    typeof this.scanner.dispose == "function" && this.scanner.dispose();
  }
  toString() {
    const e = [];
    for (let t = 0, n = this.rules.length; t < n; t++)
      e.push("   - " + this.rules[t] + ": " + this.regExps[t]);
    return e.join(`
`);
  }
  findNextMatchSync(e, t, n) {
    const r = this.scanner.findNextMatchSync(e, t, n);
    return r ? {
      ruleId: this.rules[r.index],
      captureIndices: r.captureIndices
    } : null;
  }
}, Im = class {
  constructor(e, t) {
    this.languageId = e, this.tokenType = t;
  }
}, Qo, XH = (Qo = class {
  constructor(t, n) {
    Ut(this, "_defaultAttributes");
    Ut(this, "_embeddedLanguagesMatcher");
    Ut(this, "_getBasicScopeAttributes", new Uk((t) => {
      const n = this._scopeToLanguage(t), r = this._toStandardTokenType(t);
      return new Im(n, r);
    }));
    this._defaultAttributes = new Im(
      t,
      8
      /* NotSet */
    ), this._embeddedLanguagesMatcher = new ez(Object.entries(n || {}));
  }
  getDefaultAttributes() {
    return this._defaultAttributes;
  }
  getBasicScopeAttributes(t) {
    return t === null ? Qo._NULL_SCOPE_METADATA : this._getBasicScopeAttributes.get(t);
  }
  /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */
  _scopeToLanguage(t) {
    return this._embeddedLanguagesMatcher.match(t) || 0;
  }
  _toStandardTokenType(t) {
    const n = t.match(Qo.STANDARD_TOKEN_TYPE_REGEXP);
    if (!n)
      return 8;
    switch (n[1]) {
      case "comment":
        return 1;
      case "string":
        return 2;
      case "regex":
        return 3;
      case "meta.embedded":
        return 0;
    }
    throw new Error("Unexpected match for standard token type!");
  }
}, Ut(Qo, "_NULL_SCOPE_METADATA", new Im(0, 0)), Ut(Qo, "STANDARD_TOKEN_TYPE_REGEXP", /\b(comment|string|regex|meta\.embedded)\b/), Qo), ez = class {
  constructor(e) {
    Ut(this, "values");
    Ut(this, "scopesRegExp");
    if (e.length === 0)
      this.values = null, this.scopesRegExp = null;
    else {
      this.values = new Map(e);
      const t = e.map(
        ([n, r]) => Bk(n)
      );
      t.sort(), t.reverse(), this.scopesRegExp = new RegExp(
        `^((${t.join(")|(")}))($|\\.)`,
        ""
      );
    }
  }
  match(e) {
    if (!this.scopesRegExp)
      return;
    const t = e.match(this.scopesRegExp);
    if (t)
      return this.values.get(t[1]);
  }
};
typeof bn < "u" && bn.env.VSCODE_TEXTMATE_DEBUG;
var c7 = class {
  constructor(e, t) {
    this.stack = e, this.stoppedEarly = t;
  }
};
function Yk(e, t, n, r, i, a, o, c) {
  const u = t.content.length;
  let s = !1, f = -1;
  if (o) {
    const p = tz(
      e,
      t,
      n,
      r,
      i,
      a
    );
    i = p.stack, r = p.linePos, n = p.isFirstLine, f = p.anchorPosition;
  }
  const d = Date.now();
  for (; !s; ) {
    if (c !== 0 && Date.now() - d > c)
      return new c7(i, !0);
    l();
  }
  return new c7(i, !1);
  function l() {
    const p = rz(
      e,
      t,
      n,
      r,
      i,
      f
    );
    if (!p) {
      a.produce(i, u), s = !0;
      return;
    }
    const g = p.captureIndices, v = p.matchedRuleId, b = g && g.length > 0 ? g[0].end > r : !1;
    if (v === YH) {
      const y = i.getRule(e);
      a.produce(i, g[0].start), i = i.withContentNameScopesList(i.nameScopesList), cf(
        e,
        t,
        n,
        i,
        a,
        y.endCaptures,
        g
      ), a.produce(i, g[0].end);
      const w = i;
      if (i = i.parent, f = w.getAnchorPos(), !b && w.getEnterPos() === r) {
        i = w, a.produce(i, u), s = !0;
        return;
      }
    } else {
      const y = e.getRule(v);
      a.produce(i, g[0].start);
      const w = i, C = y.getName(t.content, g), T = i.contentNameScopesList.pushAttributed(
        C,
        e
      );
      if (i = i.push(
        v,
        r,
        f,
        g[0].end === u,
        null,
        T,
        T
      ), y instanceof V6) {
        const E = y;
        cf(
          e,
          t,
          n,
          i,
          a,
          E.beginCaptures,
          g
        ), a.produce(i, g[0].end), f = g[0].end;
        const D = E.getContentName(
          t.content,
          g
        ), $ = T.pushAttributed(
          D,
          e
        );
        if (i = i.withContentNameScopesList($), E.endHasBackReferences && (i = i.withEndRule(
          E.getEndWithResolvedBackReferences(
            t.content,
            g
          )
        )), !b && w.hasSameRuleAs(i)) {
          i = i.pop(), a.produce(i, u), s = !0;
          return;
        }
      } else if (y instanceof d0) {
        const E = y;
        cf(
          e,
          t,
          n,
          i,
          a,
          E.beginCaptures,
          g
        ), a.produce(i, g[0].end), f = g[0].end;
        const D = E.getContentName(
          t.content,
          g
        ), $ = T.pushAttributed(
          D,
          e
        );
        if (i = i.withContentNameScopesList($), E.whileHasBackReferences && (i = i.withEndRule(
          E.getWhileWithResolvedBackReferences(
            t.content,
            g
          )
        )), !b && w.hasSameRuleAs(i)) {
          i = i.pop(), a.produce(i, u), s = !0;
          return;
        }
      } else if (cf(
        e,
        t,
        n,
        i,
        a,
        y.captures,
        g
      ), a.produce(i, g[0].end), i = i.pop(), !b) {
        i = i.safePop(), a.produce(i, u), s = !0;
        return;
      }
    }
    g[0].end > r && (r = g[0].end, n = !1);
  }
}
function tz(e, t, n, r, i, a) {
  let o = i.beginRuleCapturedEOL ? 0 : -1;
  const c = [];
  for (let u = i; u; u = u.pop()) {
    const s = u.getRule(e);
    s instanceof d0 && c.push({
      rule: s,
      stack: u
    });
  }
  for (let u = c.pop(); u; u = c.pop()) {
    const { ruleScanner: s, findOptions: f } = az(u.rule, e, u.stack.endRule, n, r === o), d = s.findNextMatchSync(t, r, f);
    if (d) {
      if (d.ruleId !== Wk) {
        i = u.stack.pop();
        break;
      }
      d.captureIndices && d.captureIndices.length && (a.produce(u.stack, d.captureIndices[0].start), cf(e, t, n, u.stack, a, u.rule.whileCaptures, d.captureIndices), a.produce(u.stack, d.captureIndices[0].end), o = d.captureIndices[0].end, d.captureIndices[0].end > r && (r = d.captureIndices[0].end, n = !1));
    } else {
      i = u.stack.pop();
      break;
    }
  }
  return { stack: i, linePos: r, anchorPosition: o, isFirstLine: n };
}
function rz(e, t, n, r, i, a) {
  const o = nz(e, t, n, r, i, a), c = e.getInjections();
  if (c.length === 0)
    return o;
  const u = iz(c, e, t, n, r, i, a);
  if (!u)
    return o;
  if (!o)
    return u;
  const s = o.captureIndices[0].start, f = u.captureIndices[0].start;
  return f < s || u.priorityMatch && f === s ? u : o;
}
function nz(e, t, n, r, i, a) {
  const o = i.getRule(e), { ruleScanner: c, findOptions: u } = Jk(o, e, i.endRule, n, r === a), s = c.findNextMatchSync(t, r, u);
  return s ? {
    captureIndices: s.captureIndices,
    matchedRuleId: s.ruleId
  } : null;
}
function iz(e, t, n, r, i, a, o) {
  let c = Number.MAX_VALUE, u = null, s, f = 0;
  const d = a.contentNameScopesList.getScopeNames();
  for (let l = 0, p = e.length; l < p; l++) {
    const g = e[l];
    if (!g.matcher(d))
      continue;
    const v = t.getRule(g.ruleId), { ruleScanner: b, findOptions: y } = Jk(v, t, null, r, i === o), w = b.findNextMatchSync(n, i, y);
    if (!w)
      continue;
    const C = w.captureIndices[0].start;
    if (!(C >= c) && (c = C, u = w.captureIndices, s = w.ruleId, f = g.priority, c === i))
      break;
  }
  return u ? {
    priorityMatch: f === -1,
    captureIndices: u,
    matchedRuleId: s
  } : null;
}
function Jk(e, t, n, r, i) {
  return {
    ruleScanner: e.compileAG(t, n, r, i),
    findOptions: 0
    /* None */
  };
}
function az(e, t, n, r, i) {
  return {
    ruleScanner: e.compileWhileAG(t, n, r, i),
    findOptions: 0
    /* None */
  };
}
function cf(e, t, n, r, i, a, o) {
  if (a.length === 0)
    return;
  const c = t.content, u = Math.min(a.length, o.length), s = [], f = o[0].end;
  for (let d = 0; d < u; d++) {
    const l = a[d];
    if (l === null)
      continue;
    const p = o[d];
    if (p.length === 0)
      continue;
    if (p.start > f)
      break;
    for (; s.length > 0 && s[s.length - 1].endPos <= p.start; )
      i.produceFromScopes(s[s.length - 1].scopes, s[s.length - 1].endPos), s.pop();
    if (s.length > 0 ? i.produceFromScopes(s[s.length - 1].scopes, p.start) : i.produce(r, p.start), l.retokenizeCapturedWithRuleId) {
      const v = l.getName(c, o), b = r.contentNameScopesList.pushAttributed(v, e), y = l.getContentName(c, o), w = b.pushAttributed(y, e), C = r.push(l.retokenizeCapturedWithRuleId, p.start, -1, !1, null, b, w), T = e.createOnigString(c.substring(0, p.end));
      Yk(
        e,
        T,
        n && p.start === 0,
        p.start,
        C,
        i,
        !1,
        /* no time limit */
        0
      ), Gk(T);
      continue;
    }
    const g = l.getName(c, o);
    if (g !== null) {
      const b = (s.length > 0 ? s[s.length - 1].scopes : r.contentNameScopesList).pushAttributed(g, e);
      s.push(new oz(b, p.end));
    }
  }
  for (; s.length > 0; )
    i.produceFromScopes(s[s.length - 1].scopes, s[s.length - 1].endPos), s.pop();
}
var oz = class {
  constructor(e, t) {
    Ut(this, "scopes");
    Ut(this, "endPos");
    this.scopes = e, this.endPos = t;
  }
};
function sz(e, t, n, r, i, a, o, c) {
  return new cz(
    e,
    t,
    n,
    r,
    i,
    a,
    o,
    c
  );
}
function l7(e, t, n, r, i) {
  const a = f0(t, h0), o = Kk.getCompiledRuleId(n, r, i.repository);
  for (const c of a)
    e.push({
      debugSelector: t,
      matcher: c.matcher,
      ruleId: o,
      grammar: i,
      priority: c.priority
    });
}
function h0(e, t) {
  if (t.length < e.length)
    return !1;
  let n = 0;
  return e.every((r) => {
    for (let i = n; i < t.length; i++)
      if (uz(t[i], r))
        return n = i + 1, !0;
    return !1;
  });
}
function uz(e, t) {
  if (!e)
    return !1;
  if (e === t)
    return !0;
  const n = t.length;
  return e.length > n && e.substr(0, n) === t && e[n] === ".";
}
var cz = class {
  constructor(e, t, n, r, i, a, o, c) {
    Ut(this, "_rootId");
    Ut(this, "_lastRuleId");
    Ut(this, "_ruleId2desc");
    Ut(this, "_includedGrammars");
    Ut(this, "_grammarRepository");
    Ut(this, "_grammar");
    Ut(this, "_injections");
    Ut(this, "_basicScopeAttributesProvider");
    Ut(this, "_tokenTypeMatchers");
    if (this._rootScopeName = e, this.balancedBracketSelectors = a, this._onigLib = c, this._basicScopeAttributesProvider = new XH(
      n,
      r
    ), this._rootId = -1, this._lastRuleId = 0, this._ruleId2desc = [null], this._includedGrammars = {}, this._grammarRepository = o, this._grammar = f7(t, null), this._injections = null, this._tokenTypeMatchers = [], i)
      for (const u of Object.keys(i)) {
        const s = f0(u, h0);
        for (const f of s)
          this._tokenTypeMatchers.push({
            matcher: f.matcher,
            type: i[u]
          });
      }
  }
  get themeProvider() {
    return this._grammarRepository;
  }
  dispose() {
    for (const e of this._ruleId2desc)
      e && e.dispose();
  }
  createOnigScanner(e) {
    return this._onigLib.createOnigScanner(e);
  }
  createOnigString(e) {
    return this._onigLib.createOnigString(e);
  }
  getMetadataForScope(e) {
    return this._basicScopeAttributesProvider.getBasicScopeAttributes(e);
  }
  _collectInjections() {
    const e = {
      lookup: (i) => i === this._rootScopeName ? this._grammar : this.getExternalGrammar(i),
      injections: (i) => this._grammarRepository.injections(i)
    }, t = [], n = this._rootScopeName, r = e.lookup(n);
    if (r) {
      const i = r.injections;
      if (i)
        for (let o in i)
          l7(
            t,
            o,
            i[o],
            this,
            r
          );
      const a = this._grammarRepository.injections(n);
      a && a.forEach((o) => {
        const c = this.getExternalGrammar(o);
        if (c) {
          const u = c.injectionSelector;
          u && l7(
            t,
            u,
            c,
            this,
            c
          );
        }
      });
    }
    return t.sort((i, a) => i.priority - a.priority), t;
  }
  getInjections() {
    return this._injections === null && (this._injections = this._collectInjections()), this._injections;
  }
  registerRule(e) {
    const t = ++this._lastRuleId, n = e(t);
    return this._ruleId2desc[t] = n, n;
  }
  getRule(e) {
    return this._ruleId2desc[e];
  }
  getExternalGrammar(e, t) {
    if (this._includedGrammars[e])
      return this._includedGrammars[e];
    if (this._grammarRepository) {
      const n = this._grammarRepository.lookup(e);
      if (n)
        return this._includedGrammars[e] = f7(
          n,
          t && t.$base
        ), this._includedGrammars[e];
    }
  }
  tokenizeLine(e, t, n = 0) {
    const r = this._tokenize(e, t, !1, n);
    return {
      tokens: r.lineTokens.getResult(r.ruleStack, r.lineLength),
      ruleStack: r.ruleStack,
      stoppedEarly: r.stoppedEarly
    };
  }
  tokenizeLine2(e, t, n = 0) {
    const r = this._tokenize(e, t, !0, n);
    return {
      tokens: r.lineTokens.getBinaryResult(r.ruleStack, r.lineLength),
      ruleStack: r.ruleStack,
      stoppedEarly: r.stoppedEarly
    };
  }
  _tokenize(e, t, n, r) {
    this._rootId === -1 && (this._rootId = Kk.getCompiledRuleId(
      this._grammar.repository.$self,
      this,
      this._grammar.repository
    ), this.getInjections());
    let i;
    if (!t || t === W6.NULL) {
      i = !0;
      const s = this._basicScopeAttributesProvider.getDefaultAttributes(), f = this.themeProvider.getDefaults(), d = dc.set(
        0,
        s.languageId,
        s.tokenType,
        null,
        f.fontStyle,
        f.foregroundId,
        f.backgroundId
      ), l = this.getRule(this._rootId).getName(
        null,
        null
      );
      let p;
      l ? p = hf.createRootAndLookUpScopeName(
        l,
        d,
        this
      ) : p = hf.createRoot(
        "unknown",
        d
      ), t = new W6(
        null,
        this._rootId,
        -1,
        -1,
        !1,
        null,
        p,
        p
      );
    } else
      i = !1, t.reset();
    e = e + `
`;
    const a = this.createOnigString(e), o = a.content.length, c = new fz(
      n,
      e,
      this._tokenTypeMatchers,
      this.balancedBracketSelectors
    ), u = Yk(
      this,
      a,
      i,
      0,
      t,
      c,
      !0,
      r
    );
    return Gk(a), {
      lineLength: o,
      lineTokens: c,
      ruleStack: u.stack,
      stoppedEarly: u.stoppedEarly
    };
  }
};
function f7(e, t) {
  return e = OH(e), e.repository = e.repository || {}, e.repository.$self = {
    $vscodeTextmateLocation: e.$vscodeTextmateLocation,
    patterns: e.patterns,
    name: e.scopeName
  }, e.repository.$base = t || e.repository.$self, e;
}
var hf = class po {
  /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(t, n, r) {
    this.parent = t, this.scopePath = n, this.tokenAttributes = r;
  }
  static fromExtension(t, n) {
    let r = t, i = (t == null ? void 0 : t.scopePath) ?? null;
    for (const a of n)
      i = jm.push(i, a.scopeNames), r = new po(r, i, a.encodedTokenAttributes);
    return r;
  }
  static createRoot(t, n) {
    return new po(null, new jm(null, t), n);
  }
  static createRootAndLookUpScopeName(t, n, r) {
    const i = r.getMetadataForScope(t), a = new jm(null, t), o = r.themeProvider.themeMatch(a), c = po.mergeAttributes(
      n,
      i,
      o
    );
    return new po(null, a, c);
  }
  get scopeName() {
    return this.scopePath.scopeName;
  }
  toString() {
    return this.getScopeNames().join(" ");
  }
  equals(t) {
    return po.equals(this, t);
  }
  static equals(t, n) {
    do {
      if (t === n || !t && !n)
        return !0;
      if (!t || !n || t.scopeName !== n.scopeName || t.tokenAttributes !== n.tokenAttributes)
        return !1;
      t = t.parent, n = n.parent;
    } while (!0);
  }
  static mergeAttributes(t, n, r) {
    let i = -1, a = 0, o = 0;
    return r !== null && (i = r.fontStyle, a = r.foregroundId, o = r.backgroundId), dc.set(
      t,
      n.languageId,
      n.tokenType,
      null,
      i,
      a,
      o
    );
  }
  pushAttributed(t, n) {
    if (t === null)
      return this;
    if (t.indexOf(" ") === -1)
      return po._pushAttributed(this, t, n);
    const r = t.split(/ /g);
    let i = this;
    for (const a of r)
      i = po._pushAttributed(i, a, n);
    return i;
  }
  static _pushAttributed(t, n, r) {
    const i = r.getMetadataForScope(n), a = t.scopePath.push(n), o = r.themeProvider.themeMatch(a), c = po.mergeAttributes(
      t.tokenAttributes,
      i,
      o
    );
    return new po(t, a, c);
  }
  getScopeNames() {
    return this.scopePath.getSegments();
  }
  getExtensionIfDefined(t) {
    var i;
    const n = [];
    let r = this;
    for (; r && r !== t; )
      n.push({
        encodedTokenAttributes: r.tokenAttributes,
        scopeNames: r.scopePath.getExtensionIfDefined(((i = r.parent) == null ? void 0 : i.scopePath) ?? null)
      }), r = r.parent;
    return r === t ? n.reverse() : void 0;
  }
}, Pa, W6 = (Pa = class {
  /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(t, n, r, i, a, o, c, u) {
    Ut(this, "_stackElementBrand");
    /**
     * The position on the current line where this state was pushed.
     * This is relevant only while tokenizing a line, to detect endless loops.
     * Its value is meaningless across lines.
     */
    Ut(this, "_enterPos");
    /**
     * The captured anchor position when this stack element was pushed.
     * This is relevant only while tokenizing a line, to restore the anchor position when popping.
     * Its value is meaningless across lines.
     */
    Ut(this, "_anchorPos");
    /**
     * The depth of the stack.
     */
    Ut(this, "depth");
    this.parent = t, this.ruleId = n, this.beginRuleCapturedEOL = a, this.endRule = o, this.nameScopesList = c, this.contentNameScopesList = u, this.depth = this.parent ? this.parent.depth + 1 : 1, this._enterPos = r, this._anchorPos = i;
  }
  equals(t) {
    return t === null ? !1 : Pa._equals(this, t);
  }
  static _equals(t, n) {
    return t === n ? !0 : this._structuralEquals(t, n) ? hf.equals(t.contentNameScopesList, n.contentNameScopesList) : !1;
  }
  /**
   * A structural equals check. Does not take into account `scopes`.
   */
  static _structuralEquals(t, n) {
    do {
      if (t === n || !t && !n)
        return !0;
      if (!t || !n || t.depth !== n.depth || t.ruleId !== n.ruleId || t.endRule !== n.endRule)
        return !1;
      t = t.parent, n = n.parent;
    } while (!0);
  }
  clone() {
    return this;
  }
  static _reset(t) {
    for (; t; )
      t._enterPos = -1, t._anchorPos = -1, t = t.parent;
  }
  reset() {
    Pa._reset(this);
  }
  pop() {
    return this.parent;
  }
  safePop() {
    return this.parent ? this.parent : this;
  }
  push(t, n, r, i, a, o, c) {
    return new Pa(
      this,
      t,
      n,
      r,
      i,
      a,
      o,
      c
    );
  }
  getEnterPos() {
    return this._enterPos;
  }
  getAnchorPos() {
    return this._anchorPos;
  }
  getRule(t) {
    return t.getRule(this.ruleId);
  }
  toString() {
    const t = [];
    return this._writeString(t, 0), "[" + t.join(",") + "]";
  }
  _writeString(t, n) {
    var r, i;
    return this.parent && (n = this.parent._writeString(t, n)), t[n++] = `(${this.ruleId}, ${(r = this.nameScopesList) == null ? void 0 : r.toString()}, ${(i = this.contentNameScopesList) == null ? void 0 : i.toString()})`, n;
  }
  withContentNameScopesList(t) {
    return this.contentNameScopesList === t ? this : this.parent.push(
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      this.endRule,
      this.nameScopesList,
      t
    );
  }
  withEndRule(t) {
    return this.endRule === t ? this : new Pa(
      this.parent,
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      t,
      this.nameScopesList,
      this.contentNameScopesList
    );
  }
  // Used to warn of endless loops
  hasSameRuleAs(t) {
    let n = this;
    for (; n && n._enterPos === t._enterPos; ) {
      if (n.ruleId === t.ruleId)
        return !0;
      n = n.parent;
    }
    return !1;
  }
  toStateStackFrame() {
    var t, n, r;
    return {
      ruleId: this.ruleId,
      beginRuleCapturedEOL: this.beginRuleCapturedEOL,
      endRule: this.endRule,
      nameScopesList: ((n = this.nameScopesList) == null ? void 0 : n.getExtensionIfDefined(((t = this.parent) == null ? void 0 : t.nameScopesList) ?? null)) ?? [],
      contentNameScopesList: ((r = this.contentNameScopesList) == null ? void 0 : r.getExtensionIfDefined(this.nameScopesList)) ?? []
    };
  }
  static pushFrame(t, n) {
    const r = hf.fromExtension((t == null ? void 0 : t.nameScopesList) ?? null, n.nameScopesList);
    return new Pa(
      t,
      n.ruleId,
      n.enterPos ?? -1,
      n.anchorPos ?? -1,
      n.beginRuleCapturedEOL,
      n.endRule,
      r,
      hf.fromExtension(r, n.contentNameScopesList)
    );
  }
}, // TODO remove me
Ut(Pa, "NULL", new Pa(
  null,
  0,
  0,
  0,
  !1,
  null,
  null,
  null
)), Pa), lz = class {
  constructor(e, t) {
    Ut(this, "balancedBracketScopes");
    Ut(this, "unbalancedBracketScopes");
    Ut(this, "allowAny", !1);
    this.balancedBracketScopes = e.flatMap(
      (n) => n === "*" ? (this.allowAny = !0, []) : f0(n, h0).map((r) => r.matcher)
    ), this.unbalancedBracketScopes = t.flatMap(
      (n) => f0(n, h0).map((r) => r.matcher)
    );
  }
  get matchesAlways() {
    return this.allowAny && this.unbalancedBracketScopes.length === 0;
  }
  get matchesNever() {
    return this.balancedBracketScopes.length === 0 && !this.allowAny;
  }
  match(e) {
    for (const t of this.unbalancedBracketScopes)
      if (t(e))
        return !1;
    for (const t of this.balancedBracketScopes)
      if (t(e))
        return !0;
    return this.allowAny;
  }
}, fz = class {
  constructor(e, t, n, r) {
    Ut(this, "_emitBinaryTokens");
    /**
     * defined only if `false`.
     */
    Ut(this, "_lineText");
    /**
     * used only if `_emitBinaryTokens` is false.
     */
    Ut(this, "_tokens");
    /**
     * used only if `_emitBinaryTokens` is true.
     */
    Ut(this, "_binaryTokens");
    Ut(this, "_lastTokenEndIndex");
    Ut(this, "_tokenTypeOverrides");
    this.balancedBracketSelectors = r, this._emitBinaryTokens = e, this._tokenTypeOverrides = n, this._lineText = null, this._tokens = [], this._binaryTokens = [], this._lastTokenEndIndex = 0;
  }
  produce(e, t) {
    this.produceFromScopes(e.contentNameScopesList, t);
  }
  produceFromScopes(e, t) {
    var r;
    if (this._lastTokenEndIndex >= t)
      return;
    if (this._emitBinaryTokens) {
      let i = (e == null ? void 0 : e.tokenAttributes) ?? 0, a = !1;
      if ((r = this.balancedBracketSelectors) != null && r.matchesAlways && (a = !0), this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
        const o = (e == null ? void 0 : e.getScopeNames()) ?? [];
        for (const c of this._tokenTypeOverrides)
          c.matcher(o) && (i = dc.set(
            i,
            0,
            c.type,
            null,
            -1,
            0,
            0
          ));
        this.balancedBracketSelectors && (a = this.balancedBracketSelectors.match(o));
      }
      if (a && (i = dc.set(
        i,
        0,
        8,
        a,
        -1,
        0,
        0
      )), this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === i) {
        this._lastTokenEndIndex = t;
        return;
      }
      this._binaryTokens.push(this._lastTokenEndIndex), this._binaryTokens.push(i), this._lastTokenEndIndex = t;
      return;
    }
    const n = (e == null ? void 0 : e.getScopeNames()) ?? [];
    this._tokens.push({
      startIndex: this._lastTokenEndIndex,
      endIndex: t,
      // value: lineText.substring(lastTokenEndIndex, endIndex),
      scopes: n
    }), this._lastTokenEndIndex = t;
  }
  getResult(e, t) {
    return this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === t - 1 && this._tokens.pop(), this._tokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(e, t), this._tokens[this._tokens.length - 1].startIndex = 0), this._tokens;
  }
  getBinaryResult(e, t) {
    this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === t - 1 && (this._binaryTokens.pop(), this._binaryTokens.pop()), this._binaryTokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(e, t), this._binaryTokens[this._binaryTokens.length - 2] = 0);
    const n = new Uint32Array(this._binaryTokens.length);
    for (let r = 0, i = this._binaryTokens.length; r < i; r++)
      n[r] = this._binaryTokens[r];
    return n;
  }
}, pz = class {
  constructor(e, t) {
    Ut(this, "_grammars", /* @__PURE__ */ new Map());
    Ut(this, "_rawGrammars", /* @__PURE__ */ new Map());
    Ut(this, "_injectionGrammars", /* @__PURE__ */ new Map());
    Ut(this, "_theme");
    this._onigLib = t, this._theme = e;
  }
  dispose() {
    for (const e of this._grammars.values())
      e.dispose();
  }
  setTheme(e) {
    this._theme = e;
  }
  getColorMap() {
    return this._theme.getColorMap();
  }
  /**
   * Add `grammar` to registry and return a list of referenced scope names
   */
  addGrammar(e, t) {
    this._rawGrammars.set(e.scopeName, e), t && this._injectionGrammars.set(e.scopeName, t);
  }
  /**
   * Lookup a raw grammar.
   */
  lookup(e) {
    return this._rawGrammars.get(e);
  }
  /**
   * Returns the injections for the given grammar
   */
  injections(e) {
    return this._injectionGrammars.get(e);
  }
  /**
   * Get the default theme settings
   */
  getDefaults() {
    return this._theme.getDefaults();
  }
  /**
   * Match a scope in the theme.
   */
  themeMatch(e) {
    return this._theme.match(e);
  }
  /**
   * Lookup a grammar.
   */
  grammarForScopeName(e, t, n, r, i) {
    if (!this._grammars.has(e)) {
      let a = this._rawGrammars.get(e);
      if (!a)
        return null;
      this._grammars.set(e, sz(
        e,
        a,
        t,
        n,
        r,
        i,
        this,
        this._onigLib
      ));
    }
    return this._grammars.get(e);
  }
}, dz = class {
  constructor(t) {
    Ut(this, "_options");
    Ut(this, "_syncRegistry");
    Ut(this, "_ensureGrammarCache");
    this._options = t, this._syncRegistry = new pz(
      l0.createFromRawTheme(t.theme, t.colorMap),
      t.onigLib
    ), this._ensureGrammarCache = /* @__PURE__ */ new Map();
  }
  dispose() {
    this._syncRegistry.dispose();
  }
  /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */
  setTheme(t, n) {
    this._syncRegistry.setTheme(l0.createFromRawTheme(t, n));
  }
  /**
   * Returns a lookup array for color ids.
   */
  getColorMap() {
    return this._syncRegistry.getColorMap();
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithEmbeddedLanguages(t, n, r) {
    return this.loadGrammarWithConfiguration(t, n, { embeddedLanguages: r });
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithConfiguration(t, n, r) {
    return this._loadGrammar(
      t,
      n,
      r.embeddedLanguages,
      r.tokenTypes,
      new lz(
        r.balancedBracketSelectors || [],
        r.unbalancedBracketSelectors || []
      )
    );
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */
  loadGrammar(t) {
    return this._loadGrammar(t, 0, null, null, null);
  }
  _loadGrammar(t, n, r, i, a) {
    const o = new UH(this._syncRegistry, t);
    for (; o.Q.length > 0; )
      o.Q.map((c) => this._loadSingleGrammar(c.scopeName)), o.processQueue();
    return this._grammarForScopeName(
      t,
      n,
      r,
      i,
      a
    );
  }
  _loadSingleGrammar(t) {
    this._ensureGrammarCache.has(t) || (this._doLoadSingleGrammar(t), this._ensureGrammarCache.set(t, !0));
  }
  _doLoadSingleGrammar(t) {
    const n = this._options.loadGrammar(t);
    if (n) {
      const r = typeof this._options.getInjections == "function" ? this._options.getInjections(t) : void 0;
      this._syncRegistry.addGrammar(n, r);
    }
  }
  /**
   * Adds a rawGrammar.
   */
  addGrammar(t, n = [], r = 0, i = null) {
    return this._syncRegistry.addGrammar(t, n), this._grammarForScopeName(t.scopeName, r, i);
  }
  /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */
  _grammarForScopeName(t, n = 0, r = null, i = null, a = null) {
    return this._syncRegistry.grammarForScopeName(
      t,
      n,
      r,
      i,
      a
    );
  }
}, K6 = W6.NULL;
const hz = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
];
class Xf {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Xf.prototype.normal = {};
Xf.prototype.property = {};
Xf.prototype.space = void 0;
function Qk(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new Xf(n, r, t);
}
function Z6(e) {
  return e.toLowerCase();
}
class ra {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
ra.prototype.attribute = "";
ra.prototype.booleanish = !1;
ra.prototype.boolean = !1;
ra.prototype.commaOrSpaceSeparated = !1;
ra.prototype.commaSeparated = !1;
ra.prototype.defined = !1;
ra.prototype.mustUseProperty = !1;
ra.prototype.number = !1;
ra.prototype.overloadedBoolean = !1;
ra.prototype.property = "";
ra.prototype.spaceSeparated = !1;
ra.prototype.space = void 0;
let mz = 0;
const wn = Pu(), si = Pu(), Xk = Pu(), Cr = Pu(), zn = Pu(), rc = Pu(), fa = Pu();
function Pu() {
  return 2 ** ++mz;
}
const Y6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: wn,
  booleanish: si,
  commaOrSpaceSeparated: fa,
  commaSeparated: rc,
  number: Cr,
  overloadedBoolean: Xk,
  spaceSeparated: zn
}, Symbol.toStringTag, { value: "Module" })), qm = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Y6)
);
class W2 extends ra {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), p7(this, "space", i), typeof r == "number")
      for (; ++a < qm.length; ) {
        const o = qm[a];
        p7(this, qm[a], (r & Y6[o]) === Y6[o]);
      }
  }
}
W2.prototype.defined = !0;
function p7(e, t, n) {
  n && (e[t] = n);
}
function Ec(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new W2(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[Z6(r)] = r, n[Z6(a.attribute)] = r;
  }
  return new Xf(t, n, e.space);
}
const eE = Ec({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: si,
    ariaAutoComplete: null,
    ariaBusy: si,
    ariaChecked: si,
    ariaColCount: Cr,
    ariaColIndex: Cr,
    ariaColSpan: Cr,
    ariaControls: zn,
    ariaCurrent: null,
    ariaDescribedBy: zn,
    ariaDetails: null,
    ariaDisabled: si,
    ariaDropEffect: zn,
    ariaErrorMessage: null,
    ariaExpanded: si,
    ariaFlowTo: zn,
    ariaGrabbed: si,
    ariaHasPopup: null,
    ariaHidden: si,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: zn,
    ariaLevel: Cr,
    ariaLive: null,
    ariaModal: si,
    ariaMultiLine: si,
    ariaMultiSelectable: si,
    ariaOrientation: null,
    ariaOwns: zn,
    ariaPlaceholder: null,
    ariaPosInSet: Cr,
    ariaPressed: si,
    ariaReadOnly: si,
    ariaRelevant: null,
    ariaRequired: si,
    ariaRoleDescription: zn,
    ariaRowCount: Cr,
    ariaRowIndex: Cr,
    ariaRowSpan: Cr,
    ariaSelected: si,
    ariaSetSize: Cr,
    ariaSort: null,
    ariaValueMax: Cr,
    ariaValueMin: Cr,
    ariaValueNow: Cr,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function tE(e, t) {
  return t in e ? e[t] : t;
}
function rE(e, t) {
  return tE(e, t.toLowerCase());
}
const gz = Ec({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: rc,
    acceptCharset: zn,
    accessKey: zn,
    action: null,
    allow: null,
    allowFullScreen: wn,
    allowPaymentRequest: wn,
    allowUserMedia: wn,
    alt: null,
    as: null,
    async: wn,
    autoCapitalize: null,
    autoComplete: zn,
    autoFocus: wn,
    autoPlay: wn,
    blocking: zn,
    capture: null,
    charSet: null,
    checked: wn,
    cite: null,
    className: zn,
    cols: Cr,
    colSpan: null,
    content: null,
    contentEditable: si,
    controls: wn,
    controlsList: zn,
    coords: Cr | rc,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: wn,
    defer: wn,
    dir: null,
    dirName: null,
    disabled: wn,
    download: Xk,
    draggable: si,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: wn,
    formTarget: null,
    headers: zn,
    height: Cr,
    hidden: wn,
    high: Cr,
    href: null,
    hrefLang: null,
    htmlFor: zn,
    httpEquiv: zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: wn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: wn,
    itemId: null,
    itemProp: zn,
    itemRef: zn,
    itemScope: wn,
    itemType: zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: wn,
    low: Cr,
    manifest: null,
    max: null,
    maxLength: Cr,
    media: null,
    method: null,
    min: null,
    minLength: Cr,
    multiple: wn,
    muted: wn,
    name: null,
    nonce: null,
    noModule: wn,
    noValidate: wn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: wn,
    optimum: Cr,
    pattern: null,
    ping: zn,
    placeholder: null,
    playsInline: wn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: wn,
    referrerPolicy: null,
    rel: zn,
    required: wn,
    reversed: wn,
    rows: Cr,
    rowSpan: Cr,
    sandbox: zn,
    scope: null,
    scoped: wn,
    seamless: wn,
    selected: wn,
    shadowRootClonable: wn,
    shadowRootDelegatesFocus: wn,
    shadowRootMode: null,
    shape: null,
    size: Cr,
    sizes: null,
    slot: null,
    span: Cr,
    spellCheck: si,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Cr,
    step: null,
    style: null,
    tabIndex: Cr,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: wn,
    useMap: null,
    value: si,
    width: Cr,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Cr,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Cr,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: wn,
    // Lists. Use CSS to reduce space between items instead
    declare: wn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Cr,
    // `<img>` and `<object>`
    leftMargin: Cr,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Cr,
    // `<body>`
    marginWidth: Cr,
    // `<body>`
    noResize: wn,
    // `<frame>`
    noHref: wn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: wn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: wn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Cr,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: si,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Cr,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Cr,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: wn,
    disableRemotePlayback: wn,
    prefix: null,
    property: null,
    results: Cr,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: rE
}), vz = Ec({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: fa,
    accentHeight: Cr,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Cr,
    amplitude: Cr,
    arabicForm: null,
    ascent: Cr,
    attributeName: null,
    attributeType: null,
    azimuth: Cr,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Cr,
    by: null,
    calcMode: null,
    capHeight: Cr,
    className: zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Cr,
    diffuseConstant: Cr,
    direction: null,
    display: null,
    dur: null,
    divisor: Cr,
    dominantBaseline: null,
    download: wn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Cr,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Cr,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Cr,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: rc,
    g2: rc,
    glyphName: rc,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Cr,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Cr,
    horizOriginX: Cr,
    horizOriginY: Cr,
    id: null,
    ideographic: Cr,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Cr,
    k: Cr,
    k1: Cr,
    k2: Cr,
    k3: Cr,
    k4: Cr,
    kernelMatrix: fa,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Cr,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Cr,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Cr,
    overlineThickness: Cr,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Cr,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Cr,
    pointsAtY: Cr,
    pointsAtZ: Cr,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: fa,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: fa,
    rev: fa,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: fa,
    requiredFeatures: fa,
    requiredFonts: fa,
    requiredFormats: fa,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Cr,
    specularExponent: Cr,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Cr,
    strikethroughThickness: Cr,
    string: null,
    stroke: null,
    strokeDashArray: fa,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Cr,
    strokeOpacity: Cr,
    strokeWidth: null,
    style: null,
    surfaceScale: Cr,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: fa,
    tabIndex: Cr,
    tableValues: null,
    target: null,
    targetX: Cr,
    targetY: Cr,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: fa,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Cr,
    underlineThickness: Cr,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Cr,
    values: null,
    vAlphabetic: Cr,
    vMathematical: Cr,
    vectorEffect: null,
    vHanging: Cr,
    vIdeographic: Cr,
    version: null,
    vertAdvY: Cr,
    vertOriginX: Cr,
    vertOriginY: Cr,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Cr,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: tE
}), nE = Ec({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), iE = Ec({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: rE
}), aE = Ec({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), yz = /[A-Z]/g, d7 = /-[a-z]/g, bz = /^data[-\w.:]+$/i;
function xz(e, t) {
  const n = Z6(t);
  let r = t, i = ra;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && bz.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(d7, wz);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!d7.test(a)) {
        let o = a.replace(yz, _z);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = W2;
  }
  return new i(r, t);
}
function _z(e) {
  return "-" + e.toLowerCase();
}
function wz(e) {
  return e.charAt(1).toUpperCase();
}
const Sz = Qk([eE, gz, nE, iE, aE], "html"), oE = Qk([eE, vz, nE, iE, aE], "svg"), h7 = {}.hasOwnProperty;
function Cz(e, t) {
  const n = t || {};
  function r(i, ...a) {
    let o = r.invalid;
    const c = r.handlers;
    if (i && h7.call(i, e)) {
      const u = String(i[e]);
      o = h7.call(c, u) ? c[u] : r.unknown;
    }
    if (o)
      return o.call(this, i, ...a);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const Az = /["&'<>`]/g, kz = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, Ez = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), Oz = /[|\\{}()[\]^$+*?.]/g, m7 = /* @__PURE__ */ new WeakMap();
function Tz(e, t) {
  if (e = e.replace(
    t.subset ? Pz(t.subset) : Az,
    r
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(kz, n).replace(Ez, r);
  function n(i, a, o) {
    return t.format(
      (i.charCodeAt(0) - 55296) * 1024 + i.charCodeAt(1) - 56320 + 65536,
      o.charCodeAt(a + 2),
      t
    );
  }
  function r(i, a, o) {
    return t.format(
      i.charCodeAt(0),
      o.charCodeAt(a + 1),
      t
    );
  }
}
function Pz(e) {
  let t = m7.get(e);
  return t || (t = Rz(e), m7.set(e, t)), t;
}
function Rz(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(Oz, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
const jz = /[\dA-Fa-f]/;
function Iz(e, t, n) {
  const r = "&#x" + e.toString(16).toUpperCase();
  return n && t && !jz.test(String.fromCharCode(t)) ? r : r + ";";
}
const qz = /\d/;
function Dz(e, t, n) {
  const r = "&#" + String(e);
  return n && t && !qz.test(String.fromCharCode(t)) ? r : r + ";";
}
const Lz = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], Dm = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, Nz = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], sE = {}.hasOwnProperty, J6 = {};
let wd;
for (wd in Dm)
  sE.call(Dm, wd) && (J6[Dm[wd]] = wd);
const $z = /[^\dA-Za-z]/;
function Mz(e, t, n, r) {
  const i = String.fromCharCode(e);
  if (sE.call(J6, i)) {
    const a = J6[i], o = "&" + a;
    return n && Lz.includes(a) && !Nz.includes(a) && (!r || t && t !== 61 && $z.test(String.fromCharCode(t))) ? o : o + ";";
  }
  return "";
}
function Fz(e, t, n) {
  let r = Iz(e, t, n.omitOptionalSemicolons), i;
  if ((n.useNamedReferences || n.useShortestReferences) && (i = Mz(
    e,
    t,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !i) && n.useShortestReferences) {
    const a = Dz(e, t, n.omitOptionalSemicolons);
    a.length < r.length && (r = a);
  }
  return i && (!n.useShortestReferences || i.length < r.length) ? i : r;
}
function nc(e, t) {
  return Tz(e, Object.assign({ format: Fz }, t));
}
const Bz = /^>|^->|<!--|-->|--!>|<!-$/g, Uz = [">"], Hz = ["<", ">"];
function zz(e, t, n, r) {
  return r.settings.bogusComments ? "<?" + nc(
    e.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: Uz
    })
  ) + ">" : "<!--" + e.value.replace(Bz, i) + "-->";
  function i(a) {
    return nc(
      a,
      Object.assign({}, r.settings.characterReferences, {
        subset: Hz
      })
    );
  }
}
function Gz(e, t, n, r) {
  return "<!" + (r.settings.upperDoctype ? "DOCTYPE" : "doctype") + (r.settings.tightDoctype ? "" : " ") + "html>";
}
function g7(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function Vz(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
function Wz(e) {
  return e.join(" ").trim();
}
const Kz = /[ \t\n\f\r]/g;
function K2(e) {
  return typeof e == "object" ? e.type === "text" ? v7(e.value) : !1 : v7(e);
}
function v7(e) {
  return e.replace(Kz, "") === "";
}
const mi = cE(1), uE = cE(-1), Zz = [];
function cE(e) {
  return t;
  function t(n, r, i) {
    const a = n ? n.children : Zz;
    let o = (r || 0) + e, c = a[o];
    if (!i)
      for (; c && K2(c); )
        o += e, c = a[o];
    return c;
  }
}
const Yz = {}.hasOwnProperty;
function lE(e) {
  return t;
  function t(n, r, i) {
    return Yz.call(e, n.tagName) && e[n.tagName](n, r, i);
  }
}
const Z2 = lE({
  body: Qz,
  caption: Lm,
  colgroup: Lm,
  dd: rG,
  dt: tG,
  head: Lm,
  html: Jz,
  li: eG,
  optgroup: nG,
  option: iG,
  p: Xz,
  rp: y7,
  rt: y7,
  tbody: oG,
  td: b7,
  tfoot: sG,
  th: b7,
  thead: aG,
  tr: uG
});
function Lm(e, t, n) {
  const r = mi(n, t, !0);
  return !r || r.type !== "comment" && !(r.type === "text" && K2(r.value.charAt(0)));
}
function Jz(e, t, n) {
  const r = mi(n, t);
  return !r || r.type !== "comment";
}
function Qz(e, t, n) {
  const r = mi(n, t);
  return !r || r.type !== "comment";
}
function Xz(e, t, n) {
  const r = mi(n, t);
  return r ? r.type === "element" && (r.tagName === "address" || r.tagName === "article" || r.tagName === "aside" || r.tagName === "blockquote" || r.tagName === "details" || r.tagName === "div" || r.tagName === "dl" || r.tagName === "fieldset" || r.tagName === "figcaption" || r.tagName === "figure" || r.tagName === "footer" || r.tagName === "form" || r.tagName === "h1" || r.tagName === "h2" || r.tagName === "h3" || r.tagName === "h4" || r.tagName === "h5" || r.tagName === "h6" || r.tagName === "header" || r.tagName === "hgroup" || r.tagName === "hr" || r.tagName === "main" || r.tagName === "menu" || r.tagName === "nav" || r.tagName === "ol" || r.tagName === "p" || r.tagName === "pre" || r.tagName === "section" || r.tagName === "table" || r.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function eG(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && r.tagName === "li";
}
function tG(e, t, n) {
  const r = mi(n, t);
  return !!(r && r.type === "element" && (r.tagName === "dt" || r.tagName === "dd"));
}
function rG(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function y7(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && (r.tagName === "rp" || r.tagName === "rt");
}
function nG(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && r.tagName === "optgroup";
}
function iG(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && (r.tagName === "option" || r.tagName === "optgroup");
}
function aG(e, t, n) {
  const r = mi(n, t);
  return !!(r && r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot"));
}
function oG(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function sG(e, t, n) {
  return !mi(n, t);
}
function uG(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && r.tagName === "tr";
}
function b7(e, t, n) {
  const r = mi(n, t);
  return !r || r.type === "element" && (r.tagName === "td" || r.tagName === "th");
}
const cG = lE({
  body: pG,
  colgroup: dG,
  head: fG,
  html: lG,
  tbody: hG
});
function lG(e) {
  const t = mi(e, -1);
  return !t || t.type !== "comment";
}
function fG(e) {
  const t = /* @__PURE__ */ new Set();
  for (const r of e.children)
    if (r.type === "element" && (r.tagName === "base" || r.tagName === "title")) {
      if (t.has(r.tagName)) return !1;
      t.add(r.tagName);
    }
  const n = e.children[0];
  return !n || n.type === "element";
}
function pG(e) {
  const t = mi(e, -1, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && K2(t.value.charAt(0))) && !(t.type === "element" && (t.tagName === "meta" || t.tagName === "link" || t.tagName === "script" || t.tagName === "style" || t.tagName === "template"));
}
function dG(e, t, n) {
  const r = uE(n, t), i = mi(e, -1, !0);
  return n && r && r.type === "element" && r.tagName === "colgroup" && Z2(r, n.children.indexOf(r), n) ? !1 : !!(i && i.type === "element" && i.tagName === "col");
}
function hG(e, t, n) {
  const r = uE(n, t), i = mi(e, -1);
  return n && r && r.type === "element" && (r.tagName === "thead" || r.tagName === "tbody") && Z2(r, n.children.indexOf(r), n) ? !1 : !!(i && i.type === "element" && i.tagName === "tr");
}
const Sd = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function mG(e, t, n, r) {
  const i = r.schema, a = i.space === "svg" ? !1 : r.settings.omitOptionalTags;
  let o = i.space === "svg" ? r.settings.closeEmptyElements : r.settings.voids.includes(e.tagName.toLowerCase());
  const c = [];
  let u;
  i.space === "html" && e.tagName === "svg" && (r.schema = oE);
  const s = gG(r, e.properties), f = r.all(
    i.space === "html" && e.tagName === "template" ? e.content : e
  );
  return r.schema = i, f && (o = !1), (s || !a || !cG(e, t, n)) && (c.push("<", e.tagName, s ? " " + s : ""), o && (i.space === "svg" || r.settings.closeSelfClosing) && (u = s.charAt(s.length - 1), (!r.settings.tightSelfClosing || u === "/" || u && u !== '"' && u !== "'") && c.push(" "), c.push("/")), c.push(">")), c.push(f), !o && (!a || !Z2(e, t, n)) && c.push("</" + e.tagName + ">"), c.join("");
}
function gG(e, t) {
  const n = [];
  let r = -1, i;
  if (t) {
    for (i in t)
      if (t[i] !== null && t[i] !== void 0) {
        const a = vG(e, i, t[i]);
        a && n.push(a);
      }
  }
  for (; ++r < n.length; ) {
    const a = e.settings.tightAttributes ? n[r].charAt(n[r].length - 1) : void 0;
    r !== n.length - 1 && a !== '"' && a !== "'" && (n[r] += " ");
  }
  return n.join("");
}
function vG(e, t, n) {
  const r = xz(e.schema, t), i = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, a = e.settings.allowDangerousCharacters ? 0 : 1;
  let o = e.quote, c;
  if (r.overloadedBoolean && (n === r.attribute || n === "") ? n = !0 : (r.boolean || r.overloadedBoolean) && (typeof n != "string" || n === r.attribute || n === "") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const u = nc(
    r.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: Sd.name[i][a]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (r.commaSeparated ? Vz : Wz)(n, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(n), e.settings.collapseEmptyAttributes && !n) ? u : (e.settings.preferUnquoted && (c = nc(
    n,
    Object.assign({}, e.settings.characterReferences, {
      attribute: !0,
      subset: Sd.unquoted[i][a]
    })
  )), c !== n && (e.settings.quoteSmart && g7(n, o) > g7(n, e.alternative) && (o = e.alternative), c = o + nc(
    n,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (o === "'" ? Sd.single : Sd.double)[i][a],
      attribute: !0
    })
  ) + o), u + (c && "=" + c));
}
const yG = ["<", "&"];
function fE(e, t, n, r) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? e.value : nc(
    e.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: yG
    })
  );
}
function bG(e, t, n, r) {
  return r.settings.allowDangerousHtml ? e.value : fE(e, t, n, r);
}
function xG(e, t, n, r) {
  return r.all(e);
}
const _G = Cz("type", {
  invalid: wG,
  unknown: SG,
  handlers: { comment: zz, doctype: Gz, element: mG, raw: bG, root: xG, text: fE }
});
function wG(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function SG(e) {
  const t = (
    /** @type {Nodes} */
    e
  );
  throw new Error("Cannot compile unknown node `" + t.type + "`");
}
const CG = {}, AG = {}, kG = [];
function EG(e, t) {
  const n = t || CG, r = n.quote || '"', i = r === '"' ? "'" : '"';
  if (r !== '"' && r !== "'")
    throw new Error("Invalid quote `" + r + "`, expected `'` or `\"`");
  return {
    one: OG,
    all: TG,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || hz,
      characterReferences: n.characterReferences || AG,
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? oE : Sz,
    quote: r,
    alternative: i
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function OG(e, t, n) {
  return _G(e, t, n, this);
}
function TG(e) {
  const t = [], n = e && e.children || kG;
  let r = -1;
  for (; ++r < n.length; )
    t[r] = this.one(n[r], r, e);
  return t.join("");
}
function m0(e, t) {
  const n = typeof e == "string" ? {} : { ...e.colorReplacements }, r = typeof e == "string" ? e : e.name;
  for (const [i, a] of Object.entries((t == null ? void 0 : t.colorReplacements) || {}))
    typeof a == "string" ? n[i] = a : i === r && Object.assign(n, a);
  return n;
}
function vu(e, t) {
  return e && ((t == null ? void 0 : t[e == null ? void 0 : e.toLowerCase()]) || e);
}
function PG(e) {
  return Array.isArray(e) ? e : [e];
}
async function pE(e) {
  return Promise.resolve(typeof e == "function" ? e() : e).then((t) => t.default || t);
}
function Y2(e) {
  return !e || ["plaintext", "txt", "text", "plain"].includes(e);
}
function RG(e) {
  return e === "ansi" || Y2(e);
}
function J2(e) {
  return e === "none";
}
function jG(e) {
  return J2(e);
}
function dE(e, t) {
  var r;
  if (!t)
    return e;
  e.properties || (e.properties = {}), (r = e.properties).class || (r.class = []), typeof e.properties.class == "string" && (e.properties.class = e.properties.class.split(/\s+/g)), Array.isArray(e.properties.class) || (e.properties.class = []);
  const n = Array.isArray(t) ? t : t.split(/\s+/g);
  for (const i of n)
    i && !e.properties.class.includes(i) && e.properties.class.push(i);
  return e;
}
function W0(e, t = !1) {
  var a;
  const n = e.split(/(\r?\n)/g);
  let r = 0;
  const i = [];
  for (let o = 0; o < n.length; o += 2) {
    const c = t ? n[o] + (n[o + 1] || "") : n[o];
    i.push([c, r]), r += n[o].length, r += ((a = n[o + 1]) == null ? void 0 : a.length) || 0;
  }
  return i;
}
function IG(e) {
  const t = W0(e, !0).map(([i]) => i);
  function n(i) {
    if (i === e.length)
      return {
        line: t.length - 1,
        character: t[t.length - 1].length
      };
    let a = i, o = 0;
    for (const c of t) {
      if (a < c.length)
        break;
      a -= c.length, o++;
    }
    return { line: o, character: a };
  }
  function r(i, a) {
    let o = 0;
    for (let c = 0; c < i; c++)
      o += t[c].length;
    return o += a, o;
  }
  return {
    lines: t,
    indexToPos: n,
    posToIndex: r
  };
}
function qG(e, t) {
  let n = 0;
  const r = [];
  for (const i of t)
    i > n && r.push({
      ...e,
      content: e.content.slice(n, i),
      offset: e.offset + n
    }), n = i;
  return n < e.content.length && r.push({
    ...e,
    content: e.content.slice(n),
    offset: e.offset + n
  }), r;
}
function DG(e, t) {
  const n = Array.from(t instanceof Set ? t : new Set(t)).sort((r, i) => r - i);
  return n.length ? e.map((r) => r.flatMap((i) => {
    const a = n.filter((o) => i.offset < o && o < i.offset + i.content.length).map((o) => o - i.offset).sort((o, c) => o - c);
    return a.length ? qG(i, a) : i;
  })) : e;
}
function LG(e, t, n, r) {
  const i = {
    content: e.content,
    explanation: e.explanation,
    offset: e.offset
  }, a = t.map((u) => g0(e.variants[u])), o = new Set(a.flatMap((u) => Object.keys(u))), c = {};
  return a.forEach((u, s) => {
    for (const f of o) {
      const d = u[f] || "inherit";
      if (s === 0 && r)
        c[f] = d;
      else {
        const l = f === "color" ? "" : f === "background-color" ? "-bg" : `-${f}`, p = n + t[s] + (f === "color" ? "" : l);
        c[p] = d;
      }
    }
  }), i.htmlStyle = c, i;
}
function g0(e) {
  const t = {};
  if (e.color && (t.color = e.color), e.bgColor && (t["background-color"] = e.bgColor), e.fontStyle) {
    e.fontStyle & qi.Italic && (t["font-style"] = "italic"), e.fontStyle & qi.Bold && (t["font-weight"] = "bold");
    const n = [];
    e.fontStyle & qi.Underline && n.push("underline"), e.fontStyle & qi.Strikethrough && n.push("line-through"), n.length && (t["text-decoration"] = n.join(" "));
  }
  return t;
}
function Q6(e) {
  return typeof e == "string" ? e : Object.entries(e).map(([t, n]) => `${t}:${n}`).join(";");
}
const hE = /* @__PURE__ */ new WeakMap();
function K0(e, t) {
  hE.set(e, t);
}
function Of(e) {
  return hE.get(e);
}
class Oc {
  constructor(...t) {
    /**
     * Theme to Stack mapping
     */
    Ut(this, "_stacks", {});
    Ut(this, "lang");
    if (t.length === 2) {
      const [n, r] = t;
      this.lang = r, this._stacks = n;
    } else {
      const [n, r, i] = t;
      this.lang = r, this._stacks = { [i]: n };
    }
  }
  get themes() {
    return Object.keys(this._stacks);
  }
  get theme() {
    return this.themes[0];
  }
  get _stack() {
    return this._stacks[this.theme];
  }
  /**
   * Static method to create a initial grammar state.
   */
  static initial(t, n) {
    return new Oc(
      Object.fromEntries(PG(n).map((r) => [r, K6])),
      t
    );
  }
  /**
   * Get the internal stack object.
   * @internal
   */
  getInternalStack(t = this.theme) {
    return this._stacks[t];
  }
  getScopes(t = this.theme) {
    return NG(this._stacks[t]);
  }
  toJSON() {
    return {
      lang: this.lang,
      theme: this.theme,
      themes: this.themes,
      scopes: this.getScopes()
    };
  }
}
function NG(e) {
  const t = [], n = /* @__PURE__ */ new Set();
  function r(i) {
    var o;
    if (n.has(i))
      return;
    n.add(i);
    const a = (o = i == null ? void 0 : i.nameScopesList) == null ? void 0 : o.scopeName;
    a && t.push(a), i.parent && r(i.parent);
  }
  return r(e), t;
}
function $G(e, t) {
  if (!(e instanceof Oc))
    throw new Ii("Invalid grammar state");
  return e.getInternalStack(t);
}
function MG() {
  const e = /* @__PURE__ */ new WeakMap();
  function t(n) {
    if (!e.has(n.meta)) {
      let r = function(o) {
        if (typeof o == "number") {
          if (o < 0 || o > n.source.length)
            throw new Ii(`Invalid decoration offset: ${o}. Code length: ${n.source.length}`);
          return {
            ...i.indexToPos(o),
            offset: o
          };
        } else {
          const c = i.lines[o.line];
          if (c === void 0)
            throw new Ii(`Invalid decoration position ${JSON.stringify(o)}. Lines length: ${i.lines.length}`);
          if (o.character < 0 || o.character > c.length)
            throw new Ii(`Invalid decoration position ${JSON.stringify(o)}. Line ${o.line} length: ${c.length}`);
          return {
            ...o,
            offset: i.posToIndex(o.line, o.character)
          };
        }
      };
      const i = IG(n.source), a = (n.options.decorations || []).map((o) => ({
        ...o,
        start: r(o.start),
        end: r(o.end)
      }));
      FG(a), e.set(n.meta, {
        decorations: a,
        converter: i,
        source: n.source
      });
    }
    return e.get(n.meta);
  }
  return {
    name: "shiki:decorations",
    tokens(n) {
      var o;
      if (!((o = this.options.decorations) != null && o.length))
        return;
      const i = t(this).decorations.flatMap((c) => [c.start.offset, c.end.offset]);
      return DG(n, i);
    },
    code(n) {
      var f;
      if (!((f = this.options.decorations) != null && f.length))
        return;
      const r = t(this), i = Array.from(n.children).filter((d) => d.type === "element" && d.tagName === "span");
      if (i.length !== r.converter.lines.length)
        throw new Ii(`Number of lines in code element (${i.length}) does not match the number of lines in the source (${r.converter.lines.length}). Failed to apply decorations.`);
      function a(d, l, p, g) {
        const v = i[d];
        let b = "", y = -1, w = -1;
        if (l === 0 && (y = 0), p === 0 && (w = 0), p === Number.POSITIVE_INFINITY && (w = v.children.length), y === -1 || w === -1)
          for (let T = 0; T < v.children.length; T++)
            b += mE(v.children[T]), y === -1 && b.length === l && (y = T + 1), w === -1 && b.length === p && (w = T + 1);
        if (y === -1)
          throw new Ii(`Failed to find start index for decoration ${JSON.stringify(g.start)}`);
        if (w === -1)
          throw new Ii(`Failed to find end index for decoration ${JSON.stringify(g.end)}`);
        const C = v.children.slice(y, w);
        if (!g.alwaysWrap && C.length === v.children.length)
          c(v, g, "line");
        else if (!g.alwaysWrap && C.length === 1 && C[0].type === "element")
          c(C[0], g, "token");
        else {
          const T = {
            type: "element",
            tagName: "span",
            properties: {},
            children: C
          };
          c(T, g, "wrapper"), v.children.splice(y, C.length, T);
        }
      }
      function o(d, l) {
        i[d] = c(i[d], l, "line");
      }
      function c(d, l, p) {
        var b;
        const g = l.properties || {}, v = l.transform || ((y) => y);
        return d.tagName = l.tagName || "span", d.properties = {
          ...d.properties,
          ...g,
          class: d.properties.class
        }, (b = l.properties) != null && b.class && dE(d, l.properties.class), d = v(d, p) || d, d;
      }
      const u = [], s = r.decorations.sort((d, l) => l.start.offset - d.start.offset || d.end.offset - l.end.offset);
      for (const d of s) {
        const { start: l, end: p } = d;
        if (l.line === p.line)
          a(l.line, l.character, p.character, d);
        else if (l.line < p.line) {
          a(l.line, l.character, Number.POSITIVE_INFINITY, d);
          for (let g = l.line + 1; g < p.line; g++)
            u.unshift(() => o(g, d));
          a(p.line, 0, p.character, d);
        }
      }
      u.forEach((d) => d());
    }
  };
}
function FG(e) {
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (n.start.offset > n.end.offset)
      throw new Ii(`Invalid decoration range: ${JSON.stringify(n.start)} - ${JSON.stringify(n.end)}`);
    for (let r = t + 1; r < e.length; r++) {
      const i = e[r], a = n.start.offset <= i.start.offset && i.start.offset < n.end.offset, o = n.start.offset < i.end.offset && i.end.offset <= n.end.offset, c = i.start.offset <= n.start.offset && n.start.offset < i.end.offset, u = i.start.offset < n.end.offset && n.end.offset <= i.end.offset;
      if (a || o || c || u) {
        if (a && o || c && u)
          continue;
        throw new Ii(`Decorations ${JSON.stringify(n.start)} and ${JSON.stringify(i.start)} intersect.`);
      }
    }
  }
}
function mE(e) {
  return e.type === "text" ? e.value : e.type === "element" ? e.children.map(mE).join("") : "";
}
const BG = [
  /* @__PURE__ */ MG()
];
function v0(e) {
  return [
    ...e.transformers || [],
    ...BG
  ];
}
var yu = [
  "black",
  "red",
  "green",
  "yellow",
  "blue",
  "magenta",
  "cyan",
  "white",
  "brightBlack",
  "brightRed",
  "brightGreen",
  "brightYellow",
  "brightBlue",
  "brightMagenta",
  "brightCyan",
  "brightWhite"
], Nm = {
  1: "bold",
  2: "dim",
  3: "italic",
  4: "underline",
  7: "reverse",
  8: "hidden",
  9: "strikethrough"
};
function UG(e, t) {
  const n = e.indexOf("\x1B", t);
  if (n !== -1 && e[n + 1] === "[") {
    const r = e.indexOf("m", n);
    if (r !== -1)
      return {
        sequence: e.substring(n + 2, r).split(";"),
        startPosition: n,
        position: r + 1
      };
  }
  return {
    position: e.length
  };
}
function x7(e) {
  const t = e.shift();
  if (t === "2") {
    const n = e.splice(0, 3).map((r) => Number.parseInt(r));
    return n.length !== 3 || n.some((r) => Number.isNaN(r)) ? void 0 : {
      type: "rgb",
      rgb: n
    };
  } else if (t === "5") {
    const n = e.shift();
    if (n)
      return { type: "table", index: Number(n) };
  }
}
function HG(e) {
  const t = [];
  for (; e.length > 0; ) {
    const n = e.shift();
    if (!n)
      continue;
    const r = Number.parseInt(n);
    if (!Number.isNaN(r))
      if (r === 0)
        t.push({ type: "resetAll" });
      else if (r <= 9)
        Nm[r] && t.push({
          type: "setDecoration",
          value: Nm[r]
        });
      else if (r <= 29) {
        const i = Nm[r - 20];
        i && (t.push({
          type: "resetDecoration",
          value: i
        }), i === "dim" && t.push({
          type: "resetDecoration",
          value: "bold"
        }));
      } else if (r <= 37)
        t.push({
          type: "setForegroundColor",
          value: { type: "named", name: yu[r - 30] }
        });
      else if (r === 38) {
        const i = x7(e);
        i && t.push({
          type: "setForegroundColor",
          value: i
        });
      } else if (r === 39)
        t.push({
          type: "resetForegroundColor"
        });
      else if (r <= 47)
        t.push({
          type: "setBackgroundColor",
          value: { type: "named", name: yu[r - 40] }
        });
      else if (r === 48) {
        const i = x7(e);
        i && t.push({
          type: "setBackgroundColor",
          value: i
        });
      } else r === 49 ? t.push({
        type: "resetBackgroundColor"
      }) : r === 53 ? t.push({
        type: "setDecoration",
        value: "overline"
      }) : r === 55 ? t.push({
        type: "resetDecoration",
        value: "overline"
      }) : r >= 90 && r <= 97 ? t.push({
        type: "setForegroundColor",
        value: { type: "named", name: yu[r - 90 + 8] }
      }) : r >= 100 && r <= 107 && t.push({
        type: "setBackgroundColor",
        value: { type: "named", name: yu[r - 100 + 8] }
      });
  }
  return t;
}
function zG() {
  let e = null, t = null, n = /* @__PURE__ */ new Set();
  return {
    parse(r) {
      const i = [];
      let a = 0;
      do {
        const o = UG(r, a), c = o.sequence ? r.substring(a, o.startPosition) : r.substring(a);
        if (c.length > 0 && i.push({
          value: c,
          foreground: e,
          background: t,
          decorations: new Set(n)
        }), o.sequence) {
          const u = HG(o.sequence);
          for (const s of u)
            s.type === "resetAll" ? (e = null, t = null, n.clear()) : s.type === "resetForegroundColor" ? e = null : s.type === "resetBackgroundColor" ? t = null : s.type === "resetDecoration" && n.delete(s.value);
          for (const s of u)
            s.type === "setForegroundColor" ? e = s.value : s.type === "setBackgroundColor" ? t = s.value : s.type === "setDecoration" && n.add(s.value);
        }
        a = o.position;
      } while (a < r.length);
      return i;
    }
  };
}
var GG = {
  black: "#000000",
  red: "#bb0000",
  green: "#00bb00",
  yellow: "#bbbb00",
  blue: "#0000bb",
  magenta: "#ff00ff",
  cyan: "#00bbbb",
  white: "#eeeeee",
  brightBlack: "#555555",
  brightRed: "#ff5555",
  brightGreen: "#00ff00",
  brightYellow: "#ffff55",
  brightBlue: "#5555ff",
  brightMagenta: "#ff55ff",
  brightCyan: "#55ffff",
  brightWhite: "#ffffff"
};
function VG(e = GG) {
  function t(c) {
    return e[c];
  }
  function n(c) {
    return `#${c.map((u) => Math.max(0, Math.min(u, 255)).toString(16).padStart(2, "0")).join("")}`;
  }
  let r;
  function i() {
    if (r)
      return r;
    r = [];
    for (let s = 0; s < yu.length; s++)
      r.push(t(yu[s]));
    let c = [0, 95, 135, 175, 215, 255];
    for (let s = 0; s < 6; s++)
      for (let f = 0; f < 6; f++)
        for (let d = 0; d < 6; d++)
          r.push(n([c[s], c[f], c[d]]));
    let u = 8;
    for (let s = 0; s < 24; s++, u += 10)
      r.push(n([u, u, u]));
    return r;
  }
  function a(c) {
    return i()[c];
  }
  function o(c) {
    switch (c.type) {
      case "named":
        return t(c.name);
      case "rgb":
        return n(c.rgb);
      case "table":
        return a(c.index);
    }
  }
  return {
    value: o
  };
}
function WG(e, t, n) {
  const r = m0(e, n), i = W0(t), a = VG(
    Object.fromEntries(
      yu.map((c) => {
        var u;
        return [
          c,
          (u = e.colors) == null ? void 0 : u[`terminal.ansi${c[0].toUpperCase()}${c.substring(1)}`]
        ];
      })
    )
  ), o = zG();
  return i.map(
    (c) => o.parse(c[0]).map((u) => {
      let s, f;
      u.decorations.has("reverse") ? (s = u.background ? a.value(u.background) : e.bg, f = u.foreground ? a.value(u.foreground) : e.fg) : (s = u.foreground ? a.value(u.foreground) : e.fg, f = u.background ? a.value(u.background) : void 0), s = vu(s, r), f = vu(f, r), u.decorations.has("dim") && (s = KG(s));
      let d = qi.None;
      return u.decorations.has("bold") && (d |= qi.Bold), u.decorations.has("italic") && (d |= qi.Italic), u.decorations.has("underline") && (d |= qi.Underline), u.decorations.has("strikethrough") && (d |= qi.Strikethrough), {
        content: u.value,
        offset: c[1],
        // TODO: more accurate offset? might need to fork ansi-sequence-parser
        color: s,
        bgColor: f,
        fontStyle: d
      };
    })
  );
}
function KG(e) {
  const t = e.match(/#([0-9a-f]{3})([0-9a-f]{3})?([0-9a-f]{2})?/);
  if (t)
    if (t[3]) {
      const r = Math.round(Number.parseInt(t[3], 16) / 2).toString(16).padStart(2, "0");
      return `#${t[1]}${t[2]}${r}`;
    } else return t[2] ? `#${t[1]}${t[2]}80` : `#${Array.from(t[1]).map((r) => `${r}${r}`).join("")}80`;
  const n = e.match(/var\((--[\w-]+-ansi-[\w-]+)\)/);
  return n ? `var(${n[1]}-dim)` : e;
}
function Q2(e, t, n = {}) {
  const {
    lang: r = "text",
    theme: i = e.getLoadedThemes()[0]
  } = n;
  if (Y2(r) || J2(i))
    return W0(t).map((u) => [{ content: u[0], offset: u[1] }]);
  const { theme: a, colorMap: o } = e.setTheme(i);
  if (r === "ansi")
    return WG(a, t, n);
  const c = e.getLanguage(r);
  if (n.grammarState) {
    if (n.grammarState.lang !== c.name)
      throw new Ii(`Grammar state language "${n.grammarState.lang}" does not match highlight language "${c.name}"`);
    if (!n.grammarState.themes.includes(a.name))
      throw new Ii(`Grammar state themes "${n.grammarState.themes}" do not contain highlight theme "${a.name}"`);
  }
  return YG(t, c, a, o, n);
}
function ZG(...e) {
  if (e.length === 2)
    return Of(e[1]);
  const [t, n, r = {}] = e, {
    lang: i = "text",
    theme: a = t.getLoadedThemes()[0]
  } = r;
  if (Y2(i) || J2(a))
    throw new Ii("Plain language does not have grammar state");
  if (i === "ansi")
    throw new Ii("ANSI language does not have grammar state");
  const { theme: o, colorMap: c } = t.setTheme(a), u = t.getLanguage(i);
  return new Oc(
    y0(n, u, o, c, r).stateStack,
    u.name,
    o.name
  );
}
function YG(e, t, n, r, i) {
  const a = y0(e, t, n, r, i), o = new Oc(
    y0(e, t, n, r, i).stateStack,
    t.name,
    n.name
  );
  return K0(a.tokens, o), a.tokens;
}
function y0(e, t, n, r, i) {
  const a = m0(n, i), {
    tokenizeMaxLineLength: o = 0,
    tokenizeTimeLimit: c = 500
  } = i, u = W0(e);
  let s = i.grammarState ? $G(i.grammarState, n.name) ?? K6 : i.grammarContextCode != null ? y0(
    i.grammarContextCode,
    t,
    n,
    r,
    {
      ...i,
      grammarState: void 0,
      grammarContextCode: void 0
    }
  ).stateStack : K6, f = [];
  const d = [];
  for (let l = 0, p = u.length; l < p; l++) {
    const [g, v] = u[l];
    if (g === "") {
      f = [], d.push([]);
      continue;
    }
    if (o > 0 && g.length >= o) {
      f = [], d.push([{
        content: g,
        offset: v,
        color: "",
        fontStyle: 0
      }]);
      continue;
    }
    let b, y, w;
    i.includeExplanation && (b = t.tokenizeLine(g, s, c), y = b.tokens, w = 0);
    const C = t.tokenizeLine2(g, s, c), T = C.tokens.length / 2;
    for (let E = 0; E < T; E++) {
      const D = C.tokens[2 * E], $ = E + 1 < T ? C.tokens[2 * E + 2] : g.length;
      if (D === $)
        continue;
      const Z = C.tokens[2 * E + 1], te = vu(
        r[dc.getForeground(Z)],
        a
      ), se = dc.getFontStyle(Z), ee = {
        content: g.substring(D, $),
        offset: v + D,
        color: te,
        fontStyle: se
      };
      if (i.includeExplanation) {
        const K = [];
        if (i.includeExplanation !== "scopeName")
          for (const de of n.settings) {
            let ie;
            switch (typeof de.scope) {
              case "string":
                ie = de.scope.split(/,/).map((me) => me.trim());
                break;
              case "object":
                ie = de.scope;
                break;
              default:
                continue;
            }
            K.push({
              settings: de,
              selectors: ie.map((me) => me.split(/ /))
            });
          }
        ee.explanation = [];
        let re = 0;
        for (; D + re < $; ) {
          const de = y[w], ie = g.substring(
            de.startIndex,
            de.endIndex
          );
          re += ie.length, ee.explanation.push({
            content: ie,
            scopes: i.includeExplanation === "scopeName" ? JG(
              de.scopes
            ) : QG(
              K,
              de.scopes
            )
          }), w += 1;
        }
      }
      f.push(ee);
    }
    d.push(f), f = [], s = C.ruleStack;
  }
  return {
    tokens: d,
    stateStack: s
  };
}
function JG(e) {
  return e.map((t) => ({ scopeName: t }));
}
function QG(e, t) {
  const n = [];
  for (let r = 0, i = t.length; r < i; r++) {
    const a = t[r];
    n[r] = {
      scopeName: a,
      themeMatches: eV(e, a, t.slice(0, r))
    };
  }
  return n;
}
function _7(e, t) {
  return e === t || t.substring(0, e.length) === e && t[e.length] === ".";
}
function XG(e, t, n) {
  if (!_7(e[e.length - 1], t))
    return !1;
  let r = e.length - 2, i = n.length - 1;
  for (; r >= 0 && i >= 0; )
    _7(e[r], n[i]) && (r -= 1), i -= 1;
  return r === -1;
}
function eV(e, t, n) {
  const r = [];
  for (const { selectors: i, settings: a } of e)
    for (const o of i)
      if (XG(o, t, n)) {
        r.push(a);
        break;
      }
  return r;
}
function gE(e, t, n) {
  const r = Object.entries(n.themes).filter((u) => u[1]).map((u) => ({ color: u[0], theme: u[1] })), i = r.map((u) => {
    const s = Q2(e, t, {
      ...n,
      theme: u.theme
    }), f = Of(s), d = typeof u.theme == "string" ? u.theme : u.theme.name;
    return {
      tokens: s,
      state: f,
      theme: d
    };
  }), a = tV(
    ...i.map((u) => u.tokens)
  ), o = a[0].map(
    (u, s) => u.map((f, d) => {
      const l = {
        content: f.content,
        variants: {},
        offset: f.offset
      };
      return "includeExplanation" in n && n.includeExplanation && (l.explanation = f.explanation), a.forEach((p, g) => {
        const {
          content: v,
          explanation: b,
          offset: y,
          ...w
        } = p[s][d];
        l.variants[r[g].color] = w;
      }), l;
    })
  ), c = i[0].state ? new Oc(
    Object.fromEntries(i.map((u) => {
      var s;
      return [u.theme, (s = u.state) == null ? void 0 : s.getInternalStack(u.theme)];
    })),
    i[0].state.lang
  ) : void 0;
  return c && K0(o, c), o;
}
function tV(...e) {
  const t = e.map(() => []), n = e.length;
  for (let r = 0; r < e[0].length; r++) {
    const i = e.map((u) => u[r]), a = t.map(() => []);
    t.forEach((u, s) => u.push(a[s]));
    const o = i.map(() => 0), c = i.map((u) => u[0]);
    for (; c.every((u) => u); ) {
      const u = Math.min(...c.map((s) => s.content.length));
      for (let s = 0; s < n; s++) {
        const f = c[s];
        f.content.length === u ? (a[s].push(f), o[s] += 1, c[s] = i[s][o[s]]) : (a[s].push({
          ...f,
          content: f.content.slice(0, u)
        }), c[s] = {
          ...f,
          content: f.content.slice(u),
          offset: f.offset + u
        });
      }
    }
  }
  return t;
}
function b0(e, t, n) {
  let r, i, a, o, c, u;
  if ("themes" in n) {
    const {
      defaultColor: s = "light",
      cssVariablePrefix: f = "--shiki-"
    } = n, d = Object.entries(n.themes).filter((b) => b[1]).map((b) => ({ color: b[0], theme: b[1] })).sort((b, y) => b.color === s ? -1 : y.color === s ? 1 : 0);
    if (d.length === 0)
      throw new Ii("`themes` option must not be empty");
    const l = gE(
      e,
      t,
      n
    );
    if (u = Of(l), s && !d.find((b) => b.color === s))
      throw new Ii(`\`themes\` option must contain the defaultColor key \`${s}\``);
    const p = d.map((b) => e.getTheme(b.theme)), g = d.map((b) => b.color);
    a = l.map((b) => b.map((y) => LG(y, g, f, s))), u && K0(a, u);
    const v = d.map((b) => m0(b.theme, n));
    i = d.map((b, y) => (y === 0 && s ? "" : `${f + b.color}:`) + (vu(p[y].fg, v[y]) || "inherit")).join(";"), r = d.map((b, y) => (y === 0 && s ? "" : `${f + b.color}-bg:`) + (vu(p[y].bg, v[y]) || "inherit")).join(";"), o = `shiki-themes ${p.map((b) => b.name).join(" ")}`, c = s ? void 0 : [i, r].join(";");
  } else if ("theme" in n) {
    const s = m0(n.theme, n);
    a = Q2(
      e,
      t,
      n
    );
    const f = e.getTheme(n.theme);
    r = vu(f.bg, s), i = vu(f.fg, s), o = f.name, u = Of(a);
  } else
    throw new Ii("Invalid options, either `theme` or `themes` must be provided");
  return {
    tokens: a,
    fg: i,
    bg: r,
    themeName: o,
    rootStyle: c,
    grammarState: u
  };
}
function x0(e, t, n, r = {
  meta: {},
  options: n,
  codeToHast: (i, a) => x0(e, i, a),
  codeToTokens: (i, a) => b0(e, i, a)
}) {
  var g, v;
  let i = t;
  for (const b of v0(n))
    i = ((g = b.preprocess) == null ? void 0 : g.call(r, i, n)) || i;
  let {
    tokens: a,
    fg: o,
    bg: c,
    themeName: u,
    rootStyle: s,
    grammarState: f
  } = b0(e, i, n);
  const {
    mergeWhitespaces: d = !0,
    mergeSameStyleTokens: l = !1
  } = n;
  d === !0 ? a = nV(a) : d === "never" && (a = iV(a)), l && (a = aV(a));
  const p = {
    ...r,
    get source() {
      return i;
    }
  };
  for (const b of v0(n))
    a = ((v = b.tokens) == null ? void 0 : v.call(p, a)) || a;
  return rV(
    a,
    {
      ...n,
      fg: o,
      bg: c,
      themeName: u,
      rootStyle: s
    },
    p,
    f
  );
}
function rV(e, t, n, r = Of(e)) {
  var g, v, b;
  const i = v0(t), a = [], o = {
    type: "root",
    children: []
  }, {
    structure: c = "classic",
    tabindex: u = "0"
  } = t;
  let s = {
    type: "element",
    tagName: "pre",
    properties: {
      class: `shiki ${t.themeName || ""}`,
      style: t.rootStyle || `background-color:${t.bg};color:${t.fg}`,
      ...u !== !1 && u != null ? {
        tabindex: u.toString()
      } : {},
      ...Object.fromEntries(
        Array.from(
          Object.entries(t.meta || {})
        ).filter(([y]) => !y.startsWith("_"))
      )
    },
    children: []
  }, f = {
    type: "element",
    tagName: "code",
    properties: {},
    children: a
  };
  const d = [], l = {
    ...n,
    structure: c,
    addClassToHast: dE,
    get source() {
      return n.source;
    },
    get tokens() {
      return e;
    },
    get options() {
      return t;
    },
    get root() {
      return o;
    },
    get pre() {
      return s;
    },
    get code() {
      return f;
    },
    get lines() {
      return d;
    }
  };
  if (e.forEach((y, w) => {
    var E, D;
    w && (c === "inline" ? o.children.push({ type: "element", tagName: "br", properties: {}, children: [] }) : c === "classic" && a.push({ type: "text", value: `
` }));
    let C = {
      type: "element",
      tagName: "span",
      properties: { class: "line" },
      children: []
    }, T = 0;
    for (const $ of y) {
      let Z = {
        type: "element",
        tagName: "span",
        properties: {
          ...$.htmlAttrs
        },
        children: [{ type: "text", value: $.content }]
      };
      const te = Q6($.htmlStyle || g0($));
      te && (Z.properties.style = te);
      for (const se of i)
        Z = ((E = se == null ? void 0 : se.span) == null ? void 0 : E.call(l, Z, w + 1, T, C, $)) || Z;
      c === "inline" ? o.children.push(Z) : c === "classic" && C.children.push(Z), T += $.content.length;
    }
    if (c === "classic") {
      for (const $ of i)
        C = ((D = $ == null ? void 0 : $.line) == null ? void 0 : D.call(l, C, w + 1)) || C;
      d.push(C), a.push(C);
    }
  }), c === "classic") {
    for (const y of i)
      f = ((g = y == null ? void 0 : y.code) == null ? void 0 : g.call(l, f)) || f;
    s.children.push(f);
    for (const y of i)
      s = ((v = y == null ? void 0 : y.pre) == null ? void 0 : v.call(l, s)) || s;
    o.children.push(s);
  }
  let p = o;
  for (const y of i)
    p = ((b = y == null ? void 0 : y.root) == null ? void 0 : b.call(l, p)) || p;
  return r && K0(p, r), p;
}
function nV(e) {
  return e.map((t) => {
    const n = [];
    let r = "", i = 0;
    return t.forEach((a, o) => {
      const u = !(a.fontStyle && (a.fontStyle & qi.Underline || a.fontStyle & qi.Strikethrough));
      u && a.content.match(/^\s+$/) && t[o + 1] ? (i || (i = a.offset), r += a.content) : r ? (u ? n.push({
        ...a,
        offset: i,
        content: r + a.content
      }) : n.push(
        {
          content: r,
          offset: i
        },
        a
      ), i = 0, r = "") : n.push(a);
    }), n;
  });
}
function iV(e) {
  return e.map((t) => t.flatMap((n) => {
    if (n.content.match(/^\s+$/))
      return n;
    const r = n.content.match(/^(\s*)(.*?)(\s*)$/);
    if (!r)
      return n;
    const [, i, a, o] = r;
    if (!i && !o)
      return n;
    const c = [{
      ...n,
      offset: n.offset + i.length,
      content: a
    }];
    return i && c.unshift({
      content: i,
      offset: n.offset
    }), o && c.push({
      content: o,
      offset: n.offset + i.length + a.length
    }), c;
  }));
}
function aV(e) {
  return e.map((t) => {
    const n = [];
    for (const r of t) {
      if (n.length === 0) {
        n.push({ ...r });
        continue;
      }
      const i = n[n.length - 1], a = i.htmlStyle || Q6(g0(i)), o = r.htmlStyle || Q6(g0(r)), c = i.fontStyle && (i.fontStyle & qi.Underline || i.fontStyle & qi.Strikethrough), u = r.fontStyle && (r.fontStyle & qi.Underline || r.fontStyle & qi.Strikethrough);
      !c && !u && a === o ? i.content += r.content : n.push({ ...r });
    }
    return n;
  });
}
const oV = EG;
function sV(e, t, n) {
  var a;
  const r = {
    meta: {},
    options: n,
    codeToHast: (o, c) => x0(e, o, c),
    codeToTokens: (o, c) => b0(e, o, c)
  };
  let i = oV(x0(e, t, n, r));
  for (const o of v0(n))
    i = ((a = o.postprocess) == null ? void 0 : a.call(r, i, n)) || i;
  return i;
}
const w7 = { light: "#333333", dark: "#bbbbbb" }, S7 = { light: "#fffffe", dark: "#1e1e1e" }, C7 = "__shiki_resolved";
function X2(e) {
  var c, u, s, f, d;
  if (e != null && e[C7])
    return e;
  const t = {
    ...e
  };
  t.tokenColors && !t.settings && (t.settings = t.tokenColors, delete t.tokenColors), t.type || (t.type = "dark"), t.colorReplacements = { ...t.colorReplacements }, t.settings || (t.settings = []);
  let { bg: n, fg: r } = t;
  if (!n || !r) {
    const l = t.settings ? t.settings.find((p) => !p.name && !p.scope) : void 0;
    (c = l == null ? void 0 : l.settings) != null && c.foreground && (r = l.settings.foreground), (u = l == null ? void 0 : l.settings) != null && u.background && (n = l.settings.background), !r && ((s = t == null ? void 0 : t.colors) != null && s["editor.foreground"]) && (r = t.colors["editor.foreground"]), !n && ((f = t == null ? void 0 : t.colors) != null && f["editor.background"]) && (n = t.colors["editor.background"]), r || (r = t.type === "light" ? w7.light : w7.dark), n || (n = t.type === "light" ? S7.light : S7.dark), t.fg = r, t.bg = n;
  }
  t.settings[0] && t.settings[0].settings && !t.settings[0].scope || t.settings.unshift({
    settings: {
      foreground: t.fg,
      background: t.bg
    }
  });
  let i = 0;
  const a = /* @__PURE__ */ new Map();
  function o(l) {
    var g;
    if (a.has(l))
      return a.get(l);
    i += 1;
    const p = `#${i.toString(16).padStart(8, "0").toLowerCase()}`;
    return (g = t.colorReplacements) != null && g[`#${p}`] ? o(l) : (a.set(l, p), p);
  }
  t.settings = t.settings.map((l) => {
    var b, y;
    const p = ((b = l.settings) == null ? void 0 : b.foreground) && !l.settings.foreground.startsWith("#"), g = ((y = l.settings) == null ? void 0 : y.background) && !l.settings.background.startsWith("#");
    if (!p && !g)
      return l;
    const v = {
      ...l,
      settings: {
        ...l.settings
      }
    };
    if (p) {
      const w = o(l.settings.foreground);
      t.colorReplacements[w] = l.settings.foreground, v.settings.foreground = w;
    }
    if (g) {
      const w = o(l.settings.background);
      t.colorReplacements[w] = l.settings.background, v.settings.background = w;
    }
    return v;
  });
  for (const l of Object.keys(t.colors || {}))
    if ((l === "editor.foreground" || l === "editor.background" || l.startsWith("terminal.ansi")) && !((d = t.colors[l]) != null && d.startsWith("#"))) {
      const p = o(t.colors[l]);
      t.colorReplacements[p] = t.colors[l], t.colors[l] = p;
    }
  return Object.defineProperty(t, C7, {
    enumerable: !1,
    writable: !1,
    value: !0
  }), t;
}
async function vE(e) {
  return Array.from(new Set((await Promise.all(
    e.filter((t) => !RG(t)).map(async (t) => await pE(t).then((n) => Array.isArray(n) ? n : [n]))
  )).flat()));
}
async function yE(e) {
  return (await Promise.all(
    e.map(
      async (n) => jG(n) ? null : X2(await pE(n))
    )
  )).filter((n) => !!n);
}
let uV = 3;
function cV(e, t = 3) {
  t > uV || console.trace(`[SHIKI DEPRECATE]: ${e}`);
}
let ec = class extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
};
class lV extends dz {
  constructor(n, r, i, a = {}) {
    super(n);
    Ut(this, "_resolvedThemes", /* @__PURE__ */ new Map());
    Ut(this, "_resolvedGrammars", /* @__PURE__ */ new Map());
    Ut(this, "_langMap", /* @__PURE__ */ new Map());
    Ut(this, "_langGraph", /* @__PURE__ */ new Map());
    Ut(this, "_textmateThemeCache", /* @__PURE__ */ new WeakMap());
    Ut(this, "_loadedThemesCache", null);
    Ut(this, "_loadedLanguagesCache", null);
    this._resolver = n, this._themes = r, this._langs = i, this._alias = a, this._themes.map((o) => this.loadTheme(o)), this.loadLanguages(this._langs);
  }
  getTheme(n) {
    return typeof n == "string" ? this._resolvedThemes.get(n) : this.loadTheme(n);
  }
  loadTheme(n) {
    const r = X2(n);
    return r.name && (this._resolvedThemes.set(r.name, r), this._loadedThemesCache = null), r;
  }
  getLoadedThemes() {
    return this._loadedThemesCache || (this._loadedThemesCache = [...this._resolvedThemes.keys()]), this._loadedThemesCache;
  }
  // Override and re-implement this method to cache the textmate themes as `TextMateTheme.createFromRawTheme`
  // is expensive. Themes can switch often especially for dual-theme support.
  //
  // The parent class also accepts `colorMap` as the second parameter, but since we don't use that,
  // we omit here so it's easier to cache the themes.
  setTheme(n) {
    let r = this._textmateThemeCache.get(n);
    r || (r = l0.createFromRawTheme(n), this._textmateThemeCache.set(n, r)), this._syncRegistry.setTheme(r);
  }
  getGrammar(n) {
    if (this._alias[n]) {
      const r = /* @__PURE__ */ new Set([n]);
      for (; this._alias[n]; ) {
        if (n = this._alias[n], r.has(n))
          throw new ec(`Circular alias \`${Array.from(r).join(" -> ")} -> ${n}\``);
        r.add(n);
      }
    }
    return this._resolvedGrammars.get(n);
  }
  loadLanguage(n) {
    var o, c, u, s;
    if (this.getGrammar(n.name))
      return;
    const r = new Set(
      [...this._langMap.values()].filter((f) => {
        var d;
        return (d = f.embeddedLangsLazy) == null ? void 0 : d.includes(n.name);
      })
    );
    this._resolver.addLanguage(n);
    const i = {
      balancedBracketSelectors: n.balancedBracketSelectors || ["*"],
      unbalancedBracketSelectors: n.unbalancedBracketSelectors || []
    };
    this._syncRegistry._rawGrammars.set(n.scopeName, n);
    const a = this.loadGrammarWithConfiguration(n.scopeName, 1, i);
    if (a.name = n.name, this._resolvedGrammars.set(n.name, a), n.aliases && n.aliases.forEach((f) => {
      this._alias[f] = n.name;
    }), this._loadedLanguagesCache = null, r.size)
      for (const f of r)
        this._resolvedGrammars.delete(f.name), this._loadedLanguagesCache = null, (c = (o = this._syncRegistry) == null ? void 0 : o._injectionGrammars) == null || c.delete(f.scopeName), (s = (u = this._syncRegistry) == null ? void 0 : u._grammars) == null || s.delete(f.scopeName), this.loadLanguage(this._langMap.get(f.name));
  }
  dispose() {
    super.dispose(), this._resolvedThemes.clear(), this._resolvedGrammars.clear(), this._langMap.clear(), this._langGraph.clear(), this._loadedThemesCache = null;
  }
  loadLanguages(n) {
    for (const a of n)
      this.resolveEmbeddedLanguages(a);
    const r = Array.from(this._langGraph.entries()), i = r.filter(([a, o]) => !o);
    if (i.length) {
      const a = r.filter(([o, c]) => {
        var u;
        return c && ((u = c.embeddedLangs) == null ? void 0 : u.some((s) => i.map(([f]) => f).includes(s)));
      }).filter((o) => !i.includes(o));
      throw new ec(`Missing languages ${i.map(([o]) => `\`${o}\``).join(", ")}, required by ${a.map(([o]) => `\`${o}\``).join(", ")}`);
    }
    for (const [a, o] of r)
      this._resolver.addLanguage(o);
    for (const [a, o] of r)
      this.loadLanguage(o);
  }
  getLoadedLanguages() {
    return this._loadedLanguagesCache || (this._loadedLanguagesCache = [
      .../* @__PURE__ */ new Set([...this._resolvedGrammars.keys(), ...Object.keys(this._alias)])
    ]), this._loadedLanguagesCache;
  }
  resolveEmbeddedLanguages(n) {
    if (this._langMap.set(n.name, n), this._langGraph.set(n.name, n), n.embeddedLangs)
      for (const r of n.embeddedLangs)
        this._langGraph.set(r, this._langMap.get(r));
  }
}
class fV {
  constructor(t, n) {
    Ut(this, "_langs", /* @__PURE__ */ new Map());
    Ut(this, "_scopeToLang", /* @__PURE__ */ new Map());
    Ut(this, "_injections", /* @__PURE__ */ new Map());
    Ut(this, "_onigLib");
    this._onigLib = {
      createOnigScanner: (r) => t.createScanner(r),
      createOnigString: (r) => t.createString(r)
    }, n.forEach((r) => this.addLanguage(r));
  }
  get onigLib() {
    return this._onigLib;
  }
  getLangRegistration(t) {
    return this._langs.get(t);
  }
  loadGrammar(t) {
    return this._scopeToLang.get(t);
  }
  addLanguage(t) {
    this._langs.set(t.name, t), t.aliases && t.aliases.forEach((n) => {
      this._langs.set(n, t);
    }), this._scopeToLang.set(t.scopeName, t), t.injectTo && t.injectTo.forEach((n) => {
      this._injections.get(n) || this._injections.set(n, []), this._injections.get(n).push(t.scopeName);
    });
  }
  getInjections(t) {
    const n = t.split(".");
    let r = [];
    for (let i = 1; i <= n.length; i++) {
      const a = n.slice(0, i).join(".");
      r = [...r, ...this._injections.get(a) || []];
    }
    return r;
  }
}
let vl = 0;
function pV(e) {
  vl += 1, e.warnings !== !1 && vl >= 10 && vl % 10 === 0 && console.warn(`[Shiki] ${vl} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
  let t = !1;
  if (!e.engine)
    throw new ec("`engine` option is required for synchronous mode");
  const n = (e.langs || []).flat(1), r = (e.themes || []).flat(1).map(X2), i = new fV(e.engine, n), a = new lV(i, r, n, e.langAlias);
  let o;
  function c(w) {
    b();
    const C = a.getGrammar(typeof w == "string" ? w : w.name);
    if (!C)
      throw new ec(`Language \`${w}\` not found, you may need to load it first`);
    return C;
  }
  function u(w) {
    if (w === "none")
      return { bg: "", fg: "", name: "none", settings: [], type: "dark" };
    b();
    const C = a.getTheme(w);
    if (!C)
      throw new ec(`Theme \`${w}\` not found, you may need to load it first`);
    return C;
  }
  function s(w) {
    b();
    const C = u(w);
    o !== w && (a.setTheme(C), o = w);
    const T = a.getColorMap();
    return {
      theme: C,
      colorMap: T
    };
  }
  function f() {
    return b(), a.getLoadedThemes();
  }
  function d() {
    return b(), a.getLoadedLanguages();
  }
  function l(...w) {
    b(), a.loadLanguages(w.flat(1));
  }
  async function p(...w) {
    return l(await vE(w));
  }
  function g(...w) {
    b();
    for (const C of w.flat(1))
      a.loadTheme(C);
  }
  async function v(...w) {
    return b(), g(await yE(w));
  }
  function b() {
    if (t)
      throw new ec("Shiki instance has been disposed");
  }
  function y() {
    t || (t = !0, a.dispose(), vl -= 1);
  }
  return {
    setTheme: s,
    getTheme: u,
    getLanguage: c,
    getLoadedThemes: f,
    getLoadedLanguages: d,
    loadLanguage: p,
    loadLanguageSync: l,
    loadTheme: v,
    loadThemeSync: g,
    dispose: y,
    [Symbol.dispose]: y
  };
}
async function dV(e) {
  e.engine || cV("`engine` option is required. Use `createOnigurumaEngine` or `createJavaScriptRegexEngine` to create an engine.");
  const [
    t,
    n,
    r
  ] = await Promise.all([
    yE(e.themes || []),
    vE(e.langs || []),
    e.engine
  ]);
  return pV({
    ...e,
    themes: t,
    langs: n,
    engine: r
  });
}
async function hV(e) {
  const t = await dV(e);
  return {
    getLastGrammarState: (...n) => ZG(t, ...n),
    codeToTokensBase: (n, r) => Q2(t, n, r),
    codeToTokensWithThemes: (n, r) => gE(t, n, r),
    codeToTokens: (n, r) => b0(t, n, r),
    codeToHast: (n, r) => x0(t, n, r),
    codeToHtml: (n, r) => sV(t, n, r),
    getBundledLanguages: () => ({}),
    getBundledThemes: () => ({}),
    ...t,
    getInternalContext: () => t
  };
}
class eg extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
}
function mV() {
  return 2147483648;
}
function gV() {
  return typeof performance < "u" ? performance.now() : Date.now();
}
const vV = (e, t) => e + (t - e % t) % t;
async function yV(e) {
  let t, n;
  const r = {};
  function i(p) {
    n = p, r.HEAPU8 = new Uint8Array(p), r.HEAPU32 = new Uint32Array(p);
  }
  function a(p, g, v) {
    r.HEAPU8.copyWithin(p, g, g + v);
  }
  function o(p) {
    try {
      return t.grow(p - n.byteLength + 65535 >>> 16), i(t.buffer), 1;
    } catch {
    }
  }
  function c(p) {
    const g = r.HEAPU8.length;
    p = p >>> 0;
    const v = mV();
    if (p > v)
      return !1;
    for (let b = 1; b <= 4; b *= 2) {
      let y = g * (1 + 0.2 / b);
      y = Math.min(y, p + 100663296);
      const w = Math.min(v, vV(Math.max(p, y), 65536));
      if (o(w))
        return !0;
    }
    return !1;
  }
  const u = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
  function s(p, g, v = 1024) {
    const b = g + v;
    let y = g;
    for (; p[y] && !(y >= b); ) ++y;
    if (y - g > 16 && p.buffer && u)
      return u.decode(p.subarray(g, y));
    let w = "";
    for (; g < y; ) {
      let C = p[g++];
      if (!(C & 128)) {
        w += String.fromCharCode(C);
        continue;
      }
      const T = p[g++] & 63;
      if ((C & 224) === 192) {
        w += String.fromCharCode((C & 31) << 6 | T);
        continue;
      }
      const E = p[g++] & 63;
      if ((C & 240) === 224 ? C = (C & 15) << 12 | T << 6 | E : C = (C & 7) << 18 | T << 12 | E << 6 | p[g++] & 63, C < 65536)
        w += String.fromCharCode(C);
      else {
        const D = C - 65536;
        w += String.fromCharCode(55296 | D >> 10, 56320 | D & 1023);
      }
    }
    return w;
  }
  function f(p, g) {
    return p ? s(r.HEAPU8, p, g) : "";
  }
  const d = {
    emscripten_get_now: gV,
    emscripten_memcpy_big: a,
    emscripten_resize_heap: c,
    fd_write: () => 0
  };
  async function l() {
    const g = await e({
      env: d,
      wasi_snapshot_preview1: d
    });
    t = g.memory, i(t.buffer), Object.assign(r, g), r.UTF8ToString = f;
  }
  return await l(), r;
}
var bV = Object.defineProperty, xV = (e, t, n) => t in e ? bV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pi = (e, t, n) => xV(e, typeof t != "symbol" ? t + "" : t, n);
let xi = null;
function _V(e) {
  throw new eg(e.UTF8ToString(e.getLastOnigError()));
}
class Z0 {
  constructor(t) {
    pi(this, "utf16Length"), pi(this, "utf8Length"), pi(this, "utf16Value"), pi(this, "utf8Value"), pi(this, "utf16OffsetToUtf8"), pi(this, "utf8OffsetToUtf16");
    const n = t.length, r = Z0._utf8ByteLength(t), i = r !== n, a = i ? new Uint32Array(n + 1) : null;
    i && (a[n] = r);
    const o = i ? new Uint32Array(r + 1) : null;
    i && (o[r] = n);
    const c = new Uint8Array(r);
    let u = 0;
    for (let s = 0; s < n; s++) {
      const f = t.charCodeAt(s);
      let d = f, l = !1;
      if (f >= 55296 && f <= 56319 && s + 1 < n) {
        const p = t.charCodeAt(s + 1);
        p >= 56320 && p <= 57343 && (d = (f - 55296 << 10) + 65536 | p - 56320, l = !0);
      }
      i && (a[s] = u, l && (a[s + 1] = u), d <= 127 ? o[u + 0] = s : d <= 2047 ? (o[u + 0] = s, o[u + 1] = s) : d <= 65535 ? (o[u + 0] = s, o[u + 1] = s, o[u + 2] = s) : (o[u + 0] = s, o[u + 1] = s, o[u + 2] = s, o[u + 3] = s)), d <= 127 ? c[u++] = d : d <= 2047 ? (c[u++] = 192 | (d & 1984) >>> 6, c[u++] = 128 | (d & 63) >>> 0) : d <= 65535 ? (c[u++] = 224 | (d & 61440) >>> 12, c[u++] = 128 | (d & 4032) >>> 6, c[u++] = 128 | (d & 63) >>> 0) : (c[u++] = 240 | (d & 1835008) >>> 18, c[u++] = 128 | (d & 258048) >>> 12, c[u++] = 128 | (d & 4032) >>> 6, c[u++] = 128 | (d & 63) >>> 0), l && s++;
    }
    this.utf16Length = n, this.utf8Length = r, this.utf16Value = t, this.utf8Value = c, this.utf16OffsetToUtf8 = a, this.utf8OffsetToUtf16 = o;
  }
  static _utf8ByteLength(t) {
    let n = 0;
    for (let r = 0, i = t.length; r < i; r++) {
      const a = t.charCodeAt(r);
      let o = a, c = !1;
      if (a >= 55296 && a <= 56319 && r + 1 < i) {
        const u = t.charCodeAt(r + 1);
        u >= 56320 && u <= 57343 && (o = (a - 55296 << 10) + 65536 | u - 56320, c = !0);
      }
      o <= 127 ? n += 1 : o <= 2047 ? n += 2 : o <= 65535 ? n += 3 : n += 4, c && r++;
    }
    return n;
  }
  createString(t) {
    const n = t.omalloc(this.utf8Length);
    return t.HEAPU8.set(this.utf8Value, n), n;
  }
}
const Y0 = class ho {
  constructor(t) {
    if (pi(this, "id", ++ho.LAST_ID), pi(this, "_onigBinding"), pi(this, "content"), pi(this, "utf16Length"), pi(this, "utf8Length"), pi(this, "utf16OffsetToUtf8"), pi(this, "utf8OffsetToUtf16"), pi(this, "ptr"), !xi)
      throw new eg("Must invoke loadWasm first.");
    this._onigBinding = xi, this.content = t;
    const n = new Z0(t);
    this.utf16Length = n.utf16Length, this.utf8Length = n.utf8Length, this.utf16OffsetToUtf8 = n.utf16OffsetToUtf8, this.utf8OffsetToUtf16 = n.utf8OffsetToUtf16, this.utf8Length < 1e4 && !ho._sharedPtrInUse ? (ho._sharedPtr || (ho._sharedPtr = xi.omalloc(1e4)), ho._sharedPtrInUse = !0, xi.HEAPU8.set(n.utf8Value, ho._sharedPtr), this.ptr = ho._sharedPtr) : this.ptr = n.createString(xi);
  }
  convertUtf8OffsetToUtf16(t) {
    return this.utf8OffsetToUtf16 ? t < 0 ? 0 : t > this.utf8Length ? this.utf16Length : this.utf8OffsetToUtf16[t] : t;
  }
  convertUtf16OffsetToUtf8(t) {
    return this.utf16OffsetToUtf8 ? t < 0 ? 0 : t > this.utf16Length ? this.utf8Length : this.utf16OffsetToUtf8[t] : t;
  }
  dispose() {
    this.ptr === ho._sharedPtr ? ho._sharedPtrInUse = !1 : this._onigBinding.ofree(this.ptr);
  }
};
pi(Y0, "LAST_ID", 0);
pi(Y0, "_sharedPtr", 0);
pi(Y0, "_sharedPtrInUse", !1);
let bE = Y0;
class wV {
  constructor(t) {
    if (pi(this, "_onigBinding"), pi(this, "_ptr"), !xi)
      throw new eg("Must invoke loadWasm first.");
    const n = [], r = [];
    for (let c = 0, u = t.length; c < u; c++) {
      const s = new Z0(t[c]);
      n[c] = s.createString(xi), r[c] = s.utf8Length;
    }
    const i = xi.omalloc(4 * t.length);
    xi.HEAPU32.set(n, i / 4);
    const a = xi.omalloc(4 * t.length);
    xi.HEAPU32.set(r, a / 4);
    const o = xi.createOnigScanner(i, a, t.length);
    for (let c = 0, u = t.length; c < u; c++)
      xi.ofree(n[c]);
    xi.ofree(a), xi.ofree(i), o === 0 && _V(xi), this._onigBinding = xi, this._ptr = o;
  }
  dispose() {
    this._onigBinding.freeOnigScanner(this._ptr);
  }
  findNextMatchSync(t, n, r) {
    let i = 0;
    if (typeof r == "number" && (i = r), typeof t == "string") {
      t = new bE(t);
      const a = this._findNextMatchSync(t, n, !1, i);
      return t.dispose(), a;
    }
    return this._findNextMatchSync(t, n, !1, i);
  }
  _findNextMatchSync(t, n, r, i) {
    const a = this._onigBinding, o = a.findNextOnigScannerMatch(this._ptr, t.id, t.ptr, t.utf8Length, t.convertUtf16OffsetToUtf8(n), i);
    if (o === 0)
      return null;
    const c = a.HEAPU32;
    let u = o / 4;
    const s = c[u++], f = c[u++], d = [];
    for (let l = 0; l < f; l++) {
      const p = t.convertUtf8OffsetToUtf16(c[u++]), g = t.convertUtf8OffsetToUtf16(c[u++]);
      d[l] = {
        start: p,
        end: g,
        length: g - p
      };
    }
    return {
      index: s,
      captureIndices: d
    };
  }
}
function SV(e) {
  return typeof e.instantiator == "function";
}
function CV(e) {
  return typeof e.default == "function";
}
function AV(e) {
  return typeof e.data < "u";
}
function kV(e) {
  return typeof Response < "u" && e instanceof Response;
}
function EV(e) {
  var t;
  return typeof ArrayBuffer < "u" && (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) || typeof Dn < "u" && ((t = Dn.isBuffer) == null ? void 0 : t.call(Dn, e)) || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer || typeof Uint32Array < "u" && e instanceof Uint32Array;
}
let Cd;
function OV(e) {
  if (Cd)
    return Cd;
  async function t() {
    xi = await yV(async (n) => {
      let r = e;
      return r = await r, typeof r == "function" && (r = await r(n)), typeof r == "function" && (r = await r(n)), SV(r) ? r = await r.instantiator(n) : CV(r) ? r = await r.default(n) : (AV(r) && (r = r.data), kV(r) ? typeof WebAssembly.instantiateStreaming == "function" ? r = await TV(r)(n) : r = await PV(r)(n) : EV(r) ? r = await $m(r)(n) : r instanceof WebAssembly.Module ? r = await $m(r)(n) : "default" in r && r.default instanceof WebAssembly.Module && (r = await $m(r.default)(n))), "instance" in r && (r = r.instance), "exports" in r && (r = r.exports), r;
    });
  }
  return Cd = t(), Cd;
}
function $m(e) {
  return (t) => WebAssembly.instantiate(e, t);
}
function TV(e) {
  return (t) => WebAssembly.instantiateStreaming(e, t);
}
function PV(e) {
  return async (t) => {
    const n = await e.arrayBuffer();
    return WebAssembly.instantiate(n, t);
  };
}
async function RV(e) {
  return e && await OV(e), {
    createScanner(t) {
      return new wV(t.map((n) => typeof n == "string" ? n : n.source));
    },
    createString(t) {
      return new bE(t);
    }
  };
}
const Mm = Sr();
function jV() {
  const e = async () => {
    Mm.value || (Mm.value = await hV({
      themes: [
        import("./catppuccin-latte-DDI4I_Rd.js"),
        import("./catppuccin-mocha-CwrFPXRy.js")
      ],
      langs: [
        import("./java-D4mTlHIx.js"),
        import("./javascript-7UOe5Mty.js"),
        import("./json-DxJze_jm.js"),
        import("./python-BJbwsA0T.js"),
        import("./go-C40b7FzD.js"),
        import("./ruby-YmQJjO2y.js"),
        import("./fish-B6QqlqeT.js")
      ],
      // Important: If running in SSR, the host application must have a `shiki/onig.wasm` file available at the root of the assets. If in new Konnect Dev Portal, this is already handled.
      engine: RV(() => import.meta.server ? import(
        /* @vite-ignore */
        "shiki/onig.wasm"
      ) : import("./wasm-DQxwEHae.js"))
    }));
  };
  return {
    highlighter: DD(Mm),
    createHighlighter: e
  };
}
const Xu = [
  {
    label: "Shell",
    httpSnippetLanguage: "shell",
    highlightLanguage: "fish"
    // libraries: [
    //   {
    //     label: 'cURL',
    //     httpSnippetLibrary: 'curl',
    //   },
    //   {
    //     label: 'Wget',
    //     httpSnippetLibrary: 'wget',
    //   },
    // ],
  },
  {
    label: "JSON (body)",
    httpSnippetLanguage: "json",
    highlightLanguage: "json"
  },
  {
    label: "Python",
    httpSnippetLanguage: "python",
    highlightLanguage: "python"
    // libraries: [
    //   {
    //     label: 'Python 3',
    //     httpSnippetLibrary: 'python3',
    //   },
    //   {
    //     label: 'Requests',
    //     httpSnippetLibrary: 'requests',
    //   },
    // ],
  },
  {
    label: "Node",
    httpSnippetLanguage: "node",
    highlightLanguage: "javascript"
    // libraries: [
    //   {
    //     label: 'Native',
    //     httpSnippetLibrary: 'native',
    //   },
    //   {
    //     label: 'Request',
    //     httpSnippetLibrary: 'request',
    //   },
    //   {
    //     label: 'Unirest',
    //     httpSnippetLibrary: 'unirest',
    //   },
    //   {
    //     label: 'Fetch',
    //     httpSnippetLibrary: 'fetch',
    //   },
    //   {
    //     label: 'Axios',
    //     httpSnippetLibrary: 'axios',
    //   },
    // ],
  },
  {
    label: "JavaScript",
    httpSnippetLanguage: "javascript",
    highlightLanguage: "javascript"
    // libraries: [
    //   {
    //     label: 'Fetch',
    //     httpSnippetLibrary: 'fetch',
    //   },
    //   {
    //     label: 'XMLHttpRequest',
    //     httpSnippetLibrary: 'xhr',
    //   },
    //   {
    //     label: 'Axios',
    //     httpSnippetLibrary: 'axios',
    //   },
    // ],
  },
  {
    label: "Go",
    httpSnippetLanguage: "go",
    highlightLanguage: "go"
  },
  {
    label: "Java",
    httpSnippetLanguage: "java",
    highlightLanguage: "java"
    // libraries: [
    //   {
    //     label: 'AsyncHttp',
    //     httpSnippetLibrary: 'asynchttp',
    //   },
    //   {
    //     label: 'NetHttp',
    //     httpSnippetLibrary: 'nethttp',
    //   },
    //   {
    //     label: 'OkHttp',
    //     httpSnippetLibrary: 'okhttp',
    //   },
    //   {
    //     label: 'Unirest',
    //     httpSnippetLibrary: 'unirest',
    //   },
    // ],
  },
  {
    label: "Ruby",
    httpSnippetLanguage: "ruby",
    highlightLanguage: "ruby"
  }
], xE = 10, ns = 2, A7 = 2, IV = 20, k7 = 1200, hc = 1;
/*!
 * allof-merge v0.6.6
 * Copyright (C) 2012-2024 Damir Yusipov
 * Date: Sat, 17 Feb 2024 19:27:36 GMT
 */
function Tf(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
function qV(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
const DV = (e = {}, t, n, r) => {
  const i = `/${t}`, a = typeof e["/**"] == "function" ? e["/**"]({ key: t, path: n, value: r }) : e["/**"], o = typeof e["/*"] == "function" ? e["/*"]({ key: t, path: n, value: r }) : e["/*"];
  let c = {};
  if (i in e) c = e[i];
  else if (!a && !o) return;
  return c = typeof c == "function" ? c({ key: t, path: n, value: r }) : c, o && (c = Object.assign(Object.assign({}, o), c)), a ? Object.assign(Object.assign({ "/**": e["/**"] }, a), c) : c;
}, _E = (e) => {
  const t = {}, n = e.reduce((r, i) => (Object.keys(i).forEach((a) => r.add(a)), r), /* @__PURE__ */ new Set());
  for (const r of n.keys()) {
    const i = e.filter((a) => r in a);
    if (i.length !== 1) {
      if (r.charAt(0) !== "/") throw new Error(`Cannot merge rules. Duplicate key: ${r}. Rules should not have same Rule key`);
      t[r] = (a, o) => {
        const c = i.map((u) => typeof u[r] == "function" ? u[r](a, o) : u[r]);
        return _E(c);
      };
    } else t[r] = i[0][r];
  }
  return t;
}, is = (e) => typeof e == "object" && e !== null, Fm = (e) => Array.isArray(e), LV = (e, t, n = {}) => {
  var r, i;
  t = Fm(t) ? t : [t];
  const a = Fm(n.rules) ? _E(n.rules) : n.rules, o = [{ data: e, state: n.state, path: [], keys: [], keyIndex: -1, rules: a }];
  for (; o.length > 0; ) {
    const c = o[o.length - 1];
    if (c.keyIndex >= c.keys.length) {
      for (; !((r = c.hooks) === null || r === void 0) && r.length; ) c.hooks.pop()();
      o.pop();
      continue;
    }
    const u = c.keys[c.keyIndex++], [s, f, d] = o.length > 1 ? [c.data[u], [...c.path, u], DV(c.rules, u, [...c.path, u], c.data[u])] : [c.data, c.path, a];
    let l = { value: s, path: f, key: u, state: c.state, rules: d };
    const p = [];
    for (const g of t) {
      if (!g || typeof g != "function") continue;
      const v = (i = g(l)) !== null && i !== void 0 ? i : {}, { terminate: b, done: y, exitHook: w } = v, C = qV(v, ["terminate", "done", "exitHook"]);
      if (b) return;
      if (w && p.push(w), l = Object.assign(Object.assign({}, l), C), y) {
        l = null;
        break;
      }
    }
    if (l && is(l.value)) {
      const g = Fm(l.value) ? [...l.value.keys()] : Object.keys(l.value);
      o.push({ hooks: p, state: l.state, data: l.value, path: f, keys: g, keyIndex: 0, rules: l.rules });
    } else for (; p.length; ) p.pop()();
  }
}, NV = () => {
  const e = /* @__PURE__ */ new WeakMap();
  let t;
  return [({ value: n }) => {
    t = n;
  }, ({ value: n, path: r, key: i, state: a }) => {
    if (i = r.length ? i : "#", is(t) && is(n)) {
      if (e.has(t)) return a.node[i] = e.get(t), { done: !0 };
      const o = Array.isArray(n) ? [] : {};
      a.node[i] = o, e.set(t, o);
    } else a.node[i] = n;
    return { value: n, state: Object.assign(Object.assign({}, a), { node: a.node[i] }) };
  }];
};
class wE extends Map {
  add(t, n) {
    const r = this.get(t);
    return r ? r.push(n) : this.set(t, [n]), this;
  }
}
const $V = (e, t) => {
  const n = {};
  for (const r of t) r in e && (n[r] = e[r], delete e[r]);
  return n;
}, SE = (e, t) => {
  if (Array.isArray(e) && Array.isArray(t)) return [...e, ...t];
  if (is(e) && is(t)) {
    const n = Object.assign({}, e);
    for (const r of Object.keys(t)) n[r] = SE(n[r], t[r]);
    return n;
  }
  return t;
}, X6 = (e) => e && e.$ref && typeof e.$ref == "string", E7 = (e) => e && e.anyOf && Array.isArray(e.anyOf), O7 = (e) => e && e.oneOf && Array.isArray(e.oneOf), CE = (e, t = "") => {
  const [n = t, r] = e.split("#"), i = r && r !== "/" ? r : "";
  return { filePath: n, pointer: i, normalized: MV(n, i), jsonPath: kE(i) };
}, MV = (e, t) => e ? `${e}${t ? "#" + t : ""}` : t ? `#${t}` : "#", AE = (e, t, n = [t]) => {
  if (!is(e)) return;
  let r = e;
  const i = kE(t);
  for (const a of i) if (Array.isArray(r) && r.length > +a) r = r[+a];
  else if (is(r) && a in r) r = r[a];
  else {
    if (!X6(r)) return;
    {
      const o = CE(r.$ref);
      r = o.filePath || n.includes(o.pointer) ? void 0 : AE(e, o.pointer, [...n, o.pointer]);
    }
  }
  return r;
}, _0 = { slash: /\//g, tilde: /~/g, escapedSlash: /~1/g, escapedTilde: /~0/g }, kE = (e) => e.split("/").map((t) => decodeURIComponent(t.replace(_0.escapedSlash, "/").replace(_0.escapedTilde, "~"))).slice(1), tg = (e) => e.length ? "/" + e.map((t) => encodeURIComponent(String(t).replace(_0.tilde, "~0").replace(_0.slash, "~1"))).join("/") : "", FV = (e, t) => JSON.stringify(e) == JSON.stringify(t), BV = (e) => {
  let t = 1;
  for (; e * t % 1 != 0; ) t *= 10;
  return t;
};
function UV(e) {
  const t = e.reduce((n, r) => Math.max(n, BV(r)), 0);
  return e.reduce((n, r) => Math.round(n * t * r * t / EE(n * t, r * t)) / t);
}
function EE(e, t) {
  return t === 0 ? e : EE(t, e % t);
}
const OE = (e) => {
  if (e.length === 0) return [[]];
  const t = e[0], n = e.slice(1), r = OE(n), i = [];
  for (const a of t) for (const o of r) i.push([a, ...o]);
  return i;
}, HV = (e) => {
  const t = [];
  for (const n of e) {
    if (!("properties" in n)) continue;
    const r = new Set(Object.keys(n.properties)), i = new wE();
    for (const o of r.values()) for (const c of e) if (!(c == n || c.properties && o in c.properties)) if ("patternProperties" in c && c.patternProperties) for (const u of Object.keys(c.patternProperties)) new RegExp(u).test(o) || r.delete(o);
    else "additionalProperties" in c && (c.additionalProperties === !1 ? r.delete(o) : typeof c.additionalProperties == "object" && i.add(o, c.additionalProperties));
    if (!r.size) continue;
    const a = {};
    for (const o of r.values()) i.has(o) ? a[o] = { allOf: [n.properties[o], ...i.get(o)] } : a[o] = n.properties[o];
    t.push(a);
  }
  return t;
}, zV = (e) => {
  const t = [];
  for (const n of e) {
    if (!("patternProperties" in n)) continue;
    const r = new Set(Object.keys(n.patternProperties));
    for (const a of e) if (a != n && "additionalProperties" in a && !a.additionalProperties) for (const o of r.values()) a.patternProperties && o in a.patternProperties || r.delete(o);
    if (!r.size) continue;
    const i = {};
    for (const a of r.values()) i[a] = n.patternProperties[a];
    t.push(i);
  }
  return t;
}, T7 = (e) => {
  const t = {}, n = rg(e);
  for (const [r, i] of Object.entries(n)) i.includes(!1) ? t[r] = !1 : t[r] = i.length > 1 ? { allOf: i } : i[0];
  return t;
}, GV = (e, t) => !!e.reduce((n, r) => n && r === !0, !0) || ep(e, t), VV = () => "Could not merge values, they are probably incompatible", WV = (e) => `Merge rule not found for key: ${e}`, rg = (e) => {
  const t = {};
  for (const n of e) for (const r of Object.keys(n)) Array.isArray(t[r]) ? t[r].push(n[r]) : t[r] = [n[r]];
  return t;
}, ep = (e, t) => {
  if (e.includes(!1)) return !1;
  const n = {}, r = rg(e);
  "properties" in r && (r.properties = HV(e)), "patternProperties" in r && (r.patternProperties = zV(e));
  for (let [i, a] of Object.entries(r)) {
    if (!a.length) continue;
    const o = t.mergeRules;
    let c = `/${i}` in o ? o[`/${i}`] : o["/?"];
    c = c && !("$" in c) && "/" in c ? c["/"] : c, c = typeof c == "function" ? c() : c;
    const u = c && "$" in c ? c.$ : void 0;
    if (!u) throw new Error(WV(i));
    const s = a.length > 1 ? u(a, Object.assign(Object.assign({}, t), { allOfItems: e })) : a[0];
    s === void 0 ? t.mergeError(a) : n[i] = s;
  }
  return Object.keys(n).length ? n : void 0;
}, vo = (e) => e[e.length - 1], hu = (e) => e.reduce((t, n) => t || n, !1), yl = (e) => Math.min(...e), bl = (e) => Math.max(...e), KV = (e) => e.length > 1 ? e.reduce((t, n) => `${t}(?=${n})`, "") : e[0], TE = ([e, ...t]) => t.reduce((n, r) => n.filter((i) => r.includes(i)), e), ZV = ([e, ...t]) => t.find((n) => !FV(n, e)) ? void 0 : e, Ta = ([e, ...t]) => t.reduce((n, r) => SE(n, r), e), mf = (e) => OE(e).map((t) => ({ allOf: t })), YV = (e) => ({ anyOf: e }), JV = (e) => UV(e), QV = (e, t) => {
  const n = e.map((i) => i.map((a) => JSON.stringify(a))), r = TE(n).map((i) => JSON.parse(i)).sort();
  return r.length || t.mergeError(e), r;
}, XV = (e, t) => {
  const n = e.map((i) => Array.isArray(i) ? i : [i]), r = TE(n);
  return r.length === 1 ? r[0] : r.length ? r : void 0;
}, PE = (e) => {
  const t = /* @__PURE__ */ new Set();
  for (const n of e) for (const r of n) t.add(r);
  return Array.from(t).sort();
}, eW = (e, t) => {
  const n = {}, r = rg(e);
  for (const [i, a] of Object.entries(r))
    if (a.reduce((o, c) => o && Array.isArray(c), !0)) n[i] = PE(a);
    else {
      const o = a.map((c) => Array.isArray(c) ? { required: c } : c);
      n[i] = o.length > 1 ? { allOf: o } : o[0];
    }
  return n;
}, RE = (e, t) => {
  if (!e.reduce((u, s) => Array.isArray(s) || u, !1)) return ep(e, t);
  const n = [];
  let r = 1 / 0, i = 0;
  const a = new wE();
  for (const u of t.allOfItems) "additionalItems" in u && u.additionalItems && "items" in u && Array.isArray(u.items) && a.add(u.items.length, u.additionalItems), "items" in u && (n.push(u.items), Array.isArray(u.items) && (i = Math.max(i, u.items.length), "additionalItems" in u && u.additionalItems === !1 && (r = Math.min(r, u.items.length))));
  const o = Math.min(i, r), c = [...Array(o)].map(() => ({ allOf: [] }));
  for (const u of n) if (Array.isArray(u)) for (let s = 0; s < o; s++) {
    const f = [];
    for (let d = 0; d <= s; d++) a.has(d) && f.push(...a.get(d));
    s < u.length ? c[s].allOf.push(f.length ? Object.assign(Object.assign({}, u[s]), { allOf: f }) : u[s]) : c[s].allOf.push(!f.length || { allOf: f });
  }
  else c.forEach(({ allOf: s }) => s.push(u));
  return c;
}, tW = (e, t) => {
  const n = [], r = [];
  for (const i of t.allOfItems) "items" in i && !Array.isArray(i.items) && r.push(i.items), "additionalItems" in i && "items" in i && Array.isArray(i.items) && n.push(i.additionalItems);
  return r.length && n.forEach((i) => i.allOf = r), ep(n, t);
}, bi = (e = "draft-06", t = {}) => Object.assign(Object.assign(Object.assign(Object.assign({ "/maximum": { $: yl }, "/exclusiveMaximum": { $: hu }, "/minimum": { $: bl }, "/exclusiveMinimum": { $: hu }, "/maxLength": { $: yl }, "/minLength": { $: bl }, "/maxItems": { $: yl }, "/minItems": { $: bl }, "/uniqueItems": { $: hu }, "/maxProperties": { $: yl }, "/minProperties": { $: bl }, "/required": { $: PE }, "/multipleOf": { $: JV }, "/enum": { $: QV }, "/type": { $: XV }, "/allOf": { "/*": () => bi(e, t), $: mf }, "/not": { $: YV }, "/oneOf": { "/*": () => bi(e, t), $: mf, sibling: ["definitions", "$defs", "$id", "$schema"] }, "/anyOf": { "/*": () => bi(e, t), $: mf, sibling: ["definitions", "$defs", "$id", "$schema"] }, "/properties": { "/*": () => bi(e, t), $: T7 }, "/items": () => Object.assign(Object.assign({}, bi(e, t)), { $: RE, "/*": ({ key: n }) => typeof n == "number" ? bi(e, t) : {} }), "/additionalProperties": () => Object.assign(Object.assign({}, bi(e, t)), { $: GV }), "/additionalItems": () => Object.assign(Object.assign({}, bi(e, t)), { $: tW }), "/patternProperties": { "/*": () => bi(e, t), $: T7 }, "/pattern": { $: KV }, "/readOnly": { $: hu }, "/writeOnly": { $: hu }, "/example": { $: Ta }, "/examples": { $: Ta }, "/deprecated": { $: hu } }, e !== "draft-04" ? { "/propertyNames": () => bi(e, t), "/contains": () => bi(e, t), "/dependencies": { "/*": () => bi(e, t), $: eW }, "/const": { $: ZV }, "/exclusiveMaximum": { $: yl }, "/exclusiveMinimum": { $: bl }, "/$defs": { "/*": () => bi(e, t), $: Ta } } : {}), { "/definitions": { "/*": () => bi(e, t), $: Ta }, "/xml": { $: Ta }, "/externalDocs": { $: vo }, "/description": { $: vo }, "/title": { $: vo }, "/format": { $: vo }, "/default": { $: vo }, "/?": { $: vo } }), t), { $: ep }), gf = (e) => bi(e, { "/discriminator": { $: Ta }, "/oneOf": { "/*": () => gf(e), $: mf, sibling: ["discriminator"] }, "/anyOf": { "/*": () => gf(e), $: mf, sibling: ["discriminator"] } }), J0 = (e) => e === "3.0.x" ? Object.assign(Object.assign({}, gf("draft-04")), { "/items": ({ key: t }) => Object.assign(Object.assign({}, gf("draft-04")), { $: RE }) }) : gf("draft-06"), bu = (e) => ({ "/*": { "/schema": J0(e) } }), P7 = (e) => ({ "/content": { "/*": { "/schema": J0(e), "/encoding": { "/headers": bu(e) } } } }), R7 = (e) => ({ "/*": { "/headers": bu(e), "/content": { "/*": { "/schema": J0(e), "/encoding": { "/headers": bu(e) } } } } }), rW = (e = "3.0.x") => ({ "/paths": { "/*": { "/*": { "/parameters": bu(e), "/requestBody": P7(e), "/responses": R7(e) }, "/parameters": bu(e) } }, "/components": { "/schemas": { "/*": J0(e) }, "/responses": R7(e), "/parameters": bu(e), "/requestBodies": { "/*": P7(e) }, "/headers": bu(e) } }), mu = bi("draft-06", { "/args": () => mu, "/nullable": { $: hu }, "/specifiedByURL": { $: vo }, "/values": { $: Ta, "/*": { $: Ta, "/description": { $: vo }, "/deprecated": { $: vo, "/reason": { $: vo } } } }, "/interfaces": { $: Ta, "/*": { $: Ta } }, "/directives": { $: Ta, "/*": () => Object.assign(Object.assign({}, mu), { "/meta": { $: Ta } }) } }), nW = { "/queries": { "/*": () => mu }, "/mutations": { "/*": () => mu }, "/subscriptions": { "/*": () => mu }, "/components": { "/*": { "/*": mu }, "/directives": { "/*": { "/args": () => mu } } } }, Ad = (e, t, n) => {
  const r = n.sibling || [], i = e, a = t, o = i[a], c = Tf(i, [typeof a == "symbol" ? a : a + ""]), u = $V(c, r);
  return Object.keys(c).length ? Object.assign({ [t]: o.map((s) => ({ allOf: [c, s] })) }, u) : e;
}, jE = (e, t, n, r) => {
  const i = [], a = tg(t), o = [], c = { pointer: a, data: "", refs: [] };
  for (const s of e) if (X6(s) && !o.includes(s.$ref)) {
    c.data === "" && (c.data = JSON.stringify(e));
    const { $ref: f } = s, d = Tf(s, ["$ref"]), { filePath: l, normalized: p, pointer: g } = CE(f), v = r.find((y) => y.refs.includes(s.$ref) && y.data === c.data && g !== y.pointer);
    if (v) return { allOfItems: [{ $ref: "#" + v.pointer }], brokenRefs: o };
    c.refs.push(p);
    const b = l ? void 0 : AE(n, g);
    b === void 0 ? (o.push(p), i.push(s)) : i.push(b), Object.keys(d).length && i.push(d);
  } else i.push(s);
  c.refs.length && r.push(c);
  const u = IE(i);
  return u.find((s) => X6(s) && !o.includes(s.$ref)) ? jE(u, t, n, r) : { allOfItems: u, brokenRefs: o };
}, IE = (e) => {
  const t = [];
  for (const n of e) if (is(n)) if (n.allOf && Array.isArray(n.allOf)) {
    const { allOf: r } = n, i = Tf(n, ["allOf"]), a = Object.keys(i).length ? [...r, i] : r;
    t.push(...IE(a));
  } else t.push(n);
  return t;
}, iW = (e) => {
  if (typeof e != "object" || !e) return bi();
  if ("openapi" in e && typeof e.openapi == "string" && /3.+/.test(e.openapi)) {
    const t = e.openapi.startsWith("3.1") ? "3.1.x" : "3.0.x";
    return rW(t);
  }
  return "graphapi" in e && typeof e.graphapi == "string" ? nW : bi();
}, aW = (e, t) => {
  var n;
  const r = (n = t == null ? void 0 : t.rules) !== null && n !== void 0 ? n : iW(e);
  return ((i, a = [], o = {}) => {
    var c;
    a = Array.isArray(a) ? a : [a];
    const u = { "#": void 0 }, s = Object.assign({ state: Object.assign(Object.assign({}, (c = o.state) !== null && c !== void 0 ? c : {}), { root: u, node: u }) }, o.rules ? { rules: o.rules } : {}), [f, d] = NV();
    return LV(i, [f, ...a, d], s), u["#"];
  })(e, oW(t), { rules: r });
}, oW = (e) => {
  const t = /* @__PURE__ */ new Map();
  let n = e == null ? void 0 : e.source;
  const r = [];
  return ({ value: i, key: a, path: o, rules: c, state: u }) => {
    o.length || e != null && e.source || (n = i);
    const s = (y) => {
      var w;
      const C = sW(o);
      C ? t.set(...C) : (w = e == null ? void 0 : e.onMergeError) === null || w === void 0 || w.call(e, VV(), o, y);
    }, f = () => {
      const { node: y } = u, w = tg(o);
      if (t.has(w)) {
        const C = t.get(w), T = y[a];
        Array.isArray(T) && (T.length < 2 && s((i == null ? void 0 : i.allOf) || []), T.splice(C, 1));
      }
    };
    if (!is(i) || Array.isArray(i)) return { exitHook: f };
    if (!((y) => !!y && y["/allOf"] && "$" in y["/allOf"])(c)) return { exitHook: f };
    const { allOf: d } = i, l = Tf(i, ["allOf"]), p = [];
    if (Array.isArray(d) && p.push(...d), p.length) Object.keys(l).length && p.push(l);
    else {
      const { $ref: y } = l, w = Tf(l, ["$ref"]);
      if (e != null && e.mergeRefSibling && y && Object.keys(w).length > 0) p.push({ $ref: y }, w);
      else if (e != null && e.mergeCombinarySibling) {
        if (E7(l) && c["/anyOf"]) return { value: Ad(l, "anyOf", c["/anyOf"]), exitHook: f };
        if (O7(l) && c["/oneOf"]) return { value: Ad(l, "oneOf", c["/oneOf"]), exitHook: f };
      }
    }
    if (!p.length) return { value: l, exitHook: f };
    const { allOfItems: g, brokenRefs: v } = jE(p, o, n, r);
    if (v.length) return v.forEach((y) => {
      var w;
      return (w = e == null ? void 0 : e.onRefResolveError) === null || w === void 0 ? void 0 : w.call(e, "Cannot resolve $ref", o, y);
    }), { value: { allOf: g }, exitHook: f };
    if (g.length < 2) return { value: g.length ? g[0] : {}, exitHook: f };
    const b = ep(g, { allOfItems: g, mergeRules: c, mergeError: s });
    return e != null && e.mergeCombinarySibling && E7(b) ? { value: Ad(b, "anyOf", c["/anyOf"]), exitHook: f } : e != null && e.mergeCombinarySibling && O7(b) ? { value: Ad(b, "oneOf", c["/oneOf"]), exitHook: f } : { value: b, exitHook: f };
  };
}, sW = (e) => {
  for (let t = e.length - 2; t >= 0; t--) if (e[t] === "anyOf" || e[t] === "oneOf") {
    const n = e.slice(0, t + 1);
    return [tg(n), e[t + 1]];
  }
};
function es(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const j7 = (e) => Array.isArray(e == null ? void 0 : e.allOf) && e.allOf.length > 0 ? {
  ...aW(e, { mergeCombinarySibling: !0 }),
  // when merging combinary siblings, the title is lost, so we add it back
  ...e.title ? { title: e.title } : {}
} : e, ng = (e) => Array.isArray(e) ? e.includes("array") ? "array" : e.includes("object") ? "object" : e[0] : e, Tc = (e) => {
  if (!es(e)) return {};
  if (ng(e.type) === "array" && e.items && es(e.items)) {
    const n = { ...e };
    return delete n.items, {
      ...n,
      ...j7(e.items),
      type: e.type,
      itemType: e.items.type
    };
  }
  return j7(e);
}, uW = (e, t) => t ?? `Variant ${e + 1}`;
function Bm(e, t) {
  if (!e) return {};
  const n = {};
  return Object.keys(e).forEach((r) => {
    const i = e[r];
    if (!es(i)) return {};
    if (t(i))
      return {};
    n[r] = ig(i, t);
  }), n;
}
function ig(e, t = qE) {
  var r, i;
  const n = JSON.parse(JSON.stringify(e));
  if (e.properties) {
    const a = Bm(e.properties, t);
    n.properties = a;
  }
  if (es(e.items)) {
    const a = ig(e.items, t);
    n.items = a;
  }
  if ((r = e.oneOf) != null && r.length) {
    const a = [];
    e.oneOf.forEach((o) => {
      if (!es(o) || t(o)) return;
      const c = Bm(o.properties, t);
      a.push({ ...o, properties: c });
    }), n.oneOf = a;
  }
  if ((i = e.anyOf) != null && i.length) {
    const a = [];
    e.anyOf.forEach((o) => {
      if (!es(o) || t(o)) return;
      const c = Bm(o.properties, t);
      a.push({ ...o, properties: c });
    }), n.anyOf = a;
  }
  return n;
}
function qE(e) {
  return !!e.readOnly;
}
const Hd = (e, t) => {
  var r, i;
  if (!e)
    return "";
  let n = e.example;
  if (n !== void 0 || (r = e.schema) != null && r.examples && (n = (i = e.schema) == null ? void 0 : i.examples[0], n !== void 0) || e.examples && (n = e.examples[0], n !== void 0))
    return n;
  if (e.enum)
    return e.enum[0];
  if (e.default !== null && e.default !== void 0)
    return typeof e.default == "object" ? JSON.stringify(e.default) : e.default;
  switch (ng(e.type)) {
    case "boolean":
      return !1;
    case "integer":
      return 0;
    case "number":
      return 0;
    case "string":
      return t;
    case "object":
      return "{}";
    case "array":
      return "[]";
  }
  return "";
}, ts = ({ objData: e, parentKey: t, nestedLevel: n, filteringOptions: r }) => {
  let i = {};
  return typeof e > "u" ? i : n > xE ? (i[t] = Hd(e, t), i) : e.example ? e.example : (i = Um({ objData: e, parentKey: t, nestedLevel: n, filteringOptions: r }) ?? {}, Object.keys(e.properties || {}).forEach((a) => {
    if (r.excludeNotRequired && (!e.required || !Array.isArray(e.required) || !e.required.includes(a)))
      return;
    const o = Tc(e.properties[a]);
    if (r.excludeReadonly && o.readOnly)
      return;
    const c = ng(o.type);
    if (c === "array")
      i[a] = o.itemType === "object" ? [ts({
        objData: o || {},
        parentKey: a,
        nestedLevel: n + 1,
        filteringOptions: r
      })] : [Um({
        objData: o,
        parentKey: a,
        nestedLevel: n + 1,
        filteringOptions: r
      }) ?? Hd(o, a)];
    else if (c === "object" || o.allOf) {
      const u = ts({ objData: o || {}, parentKey: a, nestedLevel: n + 1, filteringOptions: r });
      u !== null && (i[a] = u);
    } else
      i[a] = Um({
        objData: o,
        parentKey: a,
        nestedLevel: n + 1,
        filteringOptions: r
      }) ?? Hd(o, a);
  }), i);
}, Um = ({ objData: e, parentKey: t, nestedLevel: n, filteringOptions: r }) => {
  if (typeof e > "u")
    return null;
  let i = {};
  if (e.allOf && Array.isArray(e.allOf)) {
    if (r.excludeReadonly) {
      for (let a = 0; a < e.allOf.length; a++)
        if (e.allOf[a].readOnly === !0)
          return null;
    }
    for (let a = 0; a < e.allOf.length; a++)
      i = {
        ...i,
        ...ts({
          objData: e.allOf[a],
          parentKey: `allOf-${a}`,
          nestedLevel: n,
          filteringOptions: r
        })
      };
    return i;
  }
  return Array.isArray(e.anyOf) && typeof e.anyOf[0] == "object" ? ts({ objData: e.anyOf[0] || {}, parentKey: t, nestedLevel: n + 1, filteringOptions: r }) : Array.isArray(e.oneOf) && typeof e.oneOf[0] == "object" ? ts({ objData: e.oneOf[0] || {}, parentKey: t, nestedLevel: n + 1, filteringOptions: r }) : null;
}, cW = (e) => {
  var n;
  const t = /* @__PURE__ */ new Set();
  return (n = e.responses) == null || n.forEach((r) => {
    (r.contents || []).forEach((i) => {
      t.add(i.mediaType);
    });
  }), [...t].join(", ");
}, DE = (e) => {
  var r, i, a, o;
  const t = [], n = cW(e);
  return n && t.push({
    name: "Accept",
    value: n
  }), t.push({
    name: "Content-Type",
    value: ((o = (a = (i = (r = e.responses) == null ? void 0 : r[0]) == null ? void 0 : i.contents) == null ? void 0 : a[0]) == null ? void 0 : o.mediaType) ?? "application/json"
  }), t;
}, ag = (e) => {
  const t = {};
  return e ? (Object.keys(e).forEach((n) => {
    var r;
    t[((r = e[n]) == null ? void 0 : r.name) || n] = Hd(e[n], n);
  }), t) : {};
}, og = (e, t) => {
  var i, a;
  if (!e.path)
    return "";
  if (!((i = e.request) != null && i.path))
    return e.path.replaceAll("{", "").replaceAll("}", "");
  const n = t || ag((a = e.request) == null ? void 0 : a.path) || {};
  let r = e.path;
  return Object.keys(n).forEach((o) => {
    const c = n[o];
    r = r.replaceAll(`{${o}}`, c);
  }), r.replaceAll("{", "").replaceAll("}", "");
}, sg = (e, t) => {
  var i;
  const n = t || ag((i = e.request) == null ? void 0 : i.query) || {}, r = new URLSearchParams();
  return Object.keys(n).forEach((a) => {
    r.append(a, n[a]);
  }), r.toString();
}, vf = (e, t = { excludeReadonly: !0, excludeNotRequired: !1 }, n = 0) => {
  var r;
  if (!e.length || !e[0])
    return "";
  if (n !== void 0 && Array.isArray(e[0].examples) && // @ts-ignore value is valid property of example
  (r = e[0].examples[n]) != null && r.value) {
    const i = kH(e[0].examples[n].value);
    return JSON.stringify(i, null, ns);
  }
  return JSON.stringify(
    ts({
      objData: Tc(e[0].schema),
      parentKey: "",
      nestedLevel: 0,
      filteringOptions: t
    }),
    null,
    ns
  );
}, lW = (e) => e.startsWith("2") ? "2xx" : "4xx";
function LE(e) {
  var c;
  const t = (u) => u.replace("/", "-"), n = Ye(() => Nt(e)), r = Ye(() => n.value.map((u) => ({ value: u.mediaType, label: u.mediaType, key: t(u.mediaType) })) ?? []), i = Sr(((c = r.value[0]) == null ? void 0 : c.value) ?? ""), a = Ye(() => r.value.length < 2 ? n.value : n.value.filter((u) => u.mediaType === i.value) ?? []), o = Ye(() => [{
    name: pc.ContentTypeSelectMenu,
    value: i.value,
    optionList: r.value
  }]);
  return {
    contentTypeList: r,
    activeContentType: i,
    activeResponseContentList: a,
    contentSelectComponentList: o
  };
}
function NE(e) {
  var f;
  const t = Ye(() => {
    var d;
    return ((d = e.value) == null ? void 0 : d.map((l) => ({ value: l.code, label: l.code, key: lW(l.code) }))) ?? [];
  }), n = Sr((f = t.value[0]) == null ? void 0 : f.value), r = Ye(() => {
    var d;
    return (d = e.value) == null ? void 0 : d.find((l) => l.code === n.value);
  }), i = Ye(() => {
    var d;
    return ((d = r.value) == null ? void 0 : d.description) ?? "";
  }), a = Ye(() => {
    var d;
    return ((d = r.value) == null ? void 0 : d.contents) ?? [];
  }), { activeContentType: o, activeResponseContentList: c, contentTypeList: u } = LE(a), s = Ye(() => {
    const d = [{
      name: pc.ResponseCodeSelectMenu,
      value: n.value,
      optionList: t.value
    }];
    return u.value.length > 0 && d.push({
      name: pc.ContentTypeSelectMenu,
      value: o.value,
      optionList: u.value
    }), d;
  });
  return In(t, (d) => {
    var l, p;
    n.value = (l = d[0]) == null ? void 0 : l.value, o.value = (p = u.value[0]) == null ? void 0 : p.value;
  }), In(n, () => {
    var d;
    o.value = (d = u.value[0]) == null ? void 0 : d.value;
  }), {
    responseCodeList: t,
    activeResponseCode: n,
    activeResponse: r,
    activeResponseDescription: i,
    activeContentType: o,
    contentTypeList: u,
    activeResponseContentList: c,
    responseSelectComponentList: s
  };
}
function fW(e) {
  var d;
  const t = Sr(((d = e.value[0]) == null ? void 0 : d.key) ?? ""), n = Ye(() => e.value.map((l) => ({ value: l.key, label: l.key, key: l.method })) ?? []), r = Ye(() => e.value.find((l) => l.key === t.value)), i = Ye(() => {
    var l, p, g;
    return (g = (p = (l = r.value) == null ? void 0 : l.request) == null ? void 0 : p.body) != null && g.contents ? vf(
      r.value.request.body.contents,
      { excludeReadonly: !0, excludeNotRequired: !1 },
      0
    ) : "";
  }), a = Ye(() => {
    var l;
    return ((l = r.value) == null ? void 0 : l.responses) ?? [];
  }), {
    activeResponseDescription: o,
    activeResponseCode: c,
    activeContentType: u,
    activeResponseContentList: s,
    responseSelectComponentList: f
  } = NE(a);
  return In(n, (l) => {
    var p;
    t.value = ((p = l[0]) == null ? void 0 : p.value) ?? "";
  }), {
    activeCallbackKey: t,
    callbackKeyList: n,
    activeCallback: r,
    activeCallbackRequestSample: i,
    activeCallbackResponseDescription: o,
    activeCallbackResponseCode: c,
    activeCallbackContentType: u,
    activeCallbackResponseContentList: s,
    activeCallbackResponseSelectComponentList: f
  };
}
const Gs = Sr([]), Hm = di("");
function pW() {
  const e = (i) => {
    var o;
    const a = i.map((c) => ({
      ...c,
      url: r7(c.url)
    }));
    Gs.value = a, Hm.value = ((o = a[0]) == null ? void 0 : o.url) || "";
  }, t = (i) => {
    const a = r7(i);
    Gs.value.push({
      id: Gs.value.length.toString(),
      url: a
    }), Hm.value = a;
  }, n = (i) => {
    Gs.value = Gs.value.filter((a) => a.url !== i);
  }, r = Ye(() => {
    var i;
    return ((i = Gs.value) == null ? void 0 : i.map((a) => a.url)) ?? [];
  });
  return {
    serverList: Gs,
    selectedServerUrl: Hm,
    serverUrlList: r,
    initialize: e,
    addServerUrl: t,
    removeServerUrl: n
  };
}
const dW = Sr(""), hW = Sr({}), mW = Sr({}), gW = Sr({});
function vW() {
  return {
    /**
     * state for storing the active security scheme group key.
     * e.g. "bearerAuth-xApiKeyAuth"
     * gets initialized in HttpOperation
     */
    activeSecurityScheme: dW,
    /**
     * state for storing raw auth token values
     * e.g.
     * ```
     * {
     *   "bearerAuth": "sample-jwt",
     *   "apiKeyAuth": "sample-x-api-key",
     *   "API Key": "sample-api-key"
     * }
     * ```
     * Key is the security scheme key, value is the token value.
     */
    tokenValueMap: hW,
    /**
     * state for storing list of auth header objects for each security scheme.
     * e.g.
     * ```
     * {
     *   "bearerAuth-xApiKeyAuth": [
     *     {
     *       "name": "Authorization",
     *       "value": "sample-api-key"
     *     },
     *     {
     *       "name": "X-API-Key",
     *       "value": "sample-x-api-key"
     *     }
     *   ]
     * }
     * ```
     * The key is the securty scheme group key, value is list of auth header objects.
     *
     * Auth header object: key is securty scheme name, value is the token value.
     */
    authHeaderMap: mW,
    /**
     * state for storing auth query string for each security scheme.
     * e.g.
     * ```
     * {
     *   "apiKeyAuth-xApiKeyAuth": "apikey=sample-api-key&x-api-key=sample-x-api-key"
     * }
     * ```
     * The key is the securty scheme group key, value is the unified query param string.
     */
    authQueryMap: gW
  };
}
const yW = Sr("browser");
function bW() {
  return {
    selectedTryItMethodKey: yW
  };
}
const I7 = {};
function xW(e) {
  let t = I7[e];
  if (t)
    return t;
  t = I7[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    t.push(r);
  }
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    t[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  }
  return t;
}
function mc(e, t) {
  typeof t != "string" && (t = mc.defaultChars);
  const n = xW(t);
  return e.replace(/(%[a-f0-9]{2})+/gi, function(r) {
    let i = "";
    for (let a = 0, o = r.length; a < o; a += 3) {
      const c = parseInt(r.slice(a + 1, a + 3), 16);
      if (c < 128) {
        i += n[c];
        continue;
      }
      if ((c & 224) === 192 && a + 3 < o) {
        const u = parseInt(r.slice(a + 4, a + 6), 16);
        if ((u & 192) === 128) {
          const s = c << 6 & 1984 | u & 63;
          s < 128 ? i += "��" : i += String.fromCharCode(s), a += 3;
          continue;
        }
      }
      if ((c & 240) === 224 && a + 6 < o) {
        const u = parseInt(r.slice(a + 4, a + 6), 16), s = parseInt(r.slice(a + 7, a + 9), 16);
        if ((u & 192) === 128 && (s & 192) === 128) {
          const f = c << 12 & 61440 | u << 6 & 4032 | s & 63;
          f < 2048 || f >= 55296 && f <= 57343 ? i += "���" : i += String.fromCharCode(f), a += 6;
          continue;
        }
      }
      if ((c & 248) === 240 && a + 9 < o) {
        const u = parseInt(r.slice(a + 4, a + 6), 16), s = parseInt(r.slice(a + 7, a + 9), 16), f = parseInt(r.slice(a + 10, a + 12), 16);
        if ((u & 192) === 128 && (s & 192) === 128 && (f & 192) === 128) {
          let d = c << 18 & 1835008 | u << 12 & 258048 | s << 6 & 4032 | f & 63;
          d < 65536 || d > 1114111 ? i += "����" : (d -= 65536, i += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), a += 9;
          continue;
        }
      }
      i += "�";
    }
    return i;
  });
}
mc.defaultChars = ";/?:@&=+$,#";
mc.componentChars = "";
const q7 = {};
function _W(e) {
  let t = q7[e];
  if (t)
    return t;
  t = q7[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(r) ? t.push(r) : t.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < e.length; n++)
    t[e.charCodeAt(n)] = e[n];
  return t;
}
function tp(e, t, n) {
  typeof t != "string" && (n = t, t = tp.defaultChars), typeof n > "u" && (n = !0);
  const r = _W(t);
  let i = "";
  for (let a = 0, o = e.length; a < o; a++) {
    const c = e.charCodeAt(a);
    if (n && c === 37 && a + 2 < o && /^[0-9a-f]{2}$/i.test(e.slice(a + 1, a + 3))) {
      i += e.slice(a, a + 3), a += 2;
      continue;
    }
    if (c < 128) {
      i += r[c];
      continue;
    }
    if (c >= 55296 && c <= 57343) {
      if (c >= 55296 && c <= 56319 && a + 1 < o) {
        const u = e.charCodeAt(a + 1);
        if (u >= 56320 && u <= 57343) {
          i += encodeURIComponent(e[a] + e[a + 1]), a++;
          continue;
        }
      }
      i += "%EF%BF%BD";
      continue;
    }
    i += encodeURIComponent(e[a]);
  }
  return i;
}
tp.defaultChars = ";/?:@&=+$,-_.!~*'()#";
tp.componentChars = "-_.!~*'()";
function ug(e) {
  let t = "";
  return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
}
function w0() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const wW = /^([a-z0-9.+-]+:)/i, SW = /:[0-9]*$/, CW = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, AW = ["<", ">", '"', "`", " ", "\r", `
`, "	"], kW = ["{", "}", "|", "\\", "^", "`"].concat(AW), EW = ["'"].concat(kW), D7 = ["%", "/", "?", ";", "#"].concat(EW), L7 = ["/", "?", "#"], OW = 255, N7 = /^[+a-z0-9A-Z_-]{0,63}$/, TW = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, $7 = {
  javascript: !0,
  "javascript:": !0
}, M7 = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function cg(e, t) {
  if (e && e instanceof w0) return e;
  const n = new w0();
  return n.parse(e, t), n;
}
w0.prototype.parse = function(e, t) {
  let n, r, i, a = e;
  if (a = a.trim(), !t && e.split("#").length === 1) {
    const s = CW.exec(a);
    if (s)
      return this.pathname = s[1], s[2] && (this.search = s[2]), this;
  }
  let o = wW.exec(a);
  if (o && (o = o[0], n = o.toLowerCase(), this.protocol = o, a = a.substr(o.length)), (t || o || a.match(/^\/\/[^@\/]+@[^@\/]+/)) && (i = a.substr(0, 2) === "//", i && !(o && $7[o]) && (a = a.substr(2), this.slashes = !0)), !$7[o] && (i || o && !M7[o])) {
    let s = -1;
    for (let g = 0; g < L7.length; g++)
      r = a.indexOf(L7[g]), r !== -1 && (s === -1 || r < s) && (s = r);
    let f, d;
    s === -1 ? d = a.lastIndexOf("@") : d = a.lastIndexOf("@", s), d !== -1 && (f = a.slice(0, d), a = a.slice(d + 1), this.auth = f), s = -1;
    for (let g = 0; g < D7.length; g++)
      r = a.indexOf(D7[g]), r !== -1 && (s === -1 || r < s) && (s = r);
    s === -1 && (s = a.length), a[s - 1] === ":" && s--;
    const l = a.slice(0, s);
    a = a.slice(s), this.parseHost(l), this.hostname = this.hostname || "";
    const p = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!p) {
      const g = this.hostname.split(/\./);
      for (let v = 0, b = g.length; v < b; v++) {
        const y = g[v];
        if (y && !y.match(N7)) {
          let w = "";
          for (let C = 0, T = y.length; C < T; C++)
            y.charCodeAt(C) > 127 ? w += "x" : w += y[C];
          if (!w.match(N7)) {
            const C = g.slice(0, v), T = g.slice(v + 1), E = y.match(TW);
            E && (C.push(E[1]), T.unshift(E[2])), T.length && (a = T.join(".") + a), this.hostname = C.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > OW && (this.hostname = ""), p && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const c = a.indexOf("#");
  c !== -1 && (this.hash = a.substr(c), a = a.slice(0, c));
  const u = a.indexOf("?");
  return u !== -1 && (this.search = a.substr(u), a = a.slice(0, u)), a && (this.pathname = a), M7[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
w0.prototype.parseHost = function(e) {
  let t = SW.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
const PW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: mc,
  encode: tp,
  format: ug,
  parse: cg
}, Symbol.toStringTag, { value: "Module" })), $E = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, ME = /[\0-\x1F\x7F-\x9F]/, RW = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, lg = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, FE = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, BE = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, jW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: $E,
  Cc: ME,
  Cf: RW,
  P: lg,
  S: FE,
  Z: BE
}, Symbol.toStringTag, { value: "Module" })), IW = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), qW = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var zm;
const DW = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), LW = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (zm = String.fromCodePoint) !== null && zm !== void 0 ? zm : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function NW(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = DW.get(e)) !== null && t !== void 0 ? t : e;
}
var Si;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(Si || (Si = {}));
const $W = 32;
var bs;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(bs || (bs = {}));
function e2(e) {
  return e >= Si.ZERO && e <= Si.NINE;
}
function MW(e) {
  return e >= Si.UPPER_A && e <= Si.UPPER_F || e >= Si.LOWER_A && e <= Si.LOWER_F;
}
function FW(e) {
  return e >= Si.UPPER_A && e <= Si.UPPER_Z || e >= Si.LOWER_A && e <= Si.LOWER_Z || e2(e);
}
function BW(e) {
  return e === Si.EQUALS || FW(e);
}
var yi;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(yi || (yi = {}));
var vs;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(vs || (vs = {}));
class UW {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = yi.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = vs.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = yi.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case yi.EntityStart:
        return t.charCodeAt(n) === Si.NUM ? (this.state = yi.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = yi.NamedEntity, this.stateNamedEntity(t, n));
      case yi.NumericStart:
        return this.stateNumericStart(t, n);
      case yi.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case yi.NumericHex:
        return this.stateNumericHex(t, n);
      case yi.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | $W) === Si.LOWER_X ? (this.state = yi.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = yi.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, i) {
    if (n !== r) {
      const a = r - n;
      this.result = this.result * Math.pow(i, a) + parseInt(t.substr(n, a), i), this.consumed += a;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (e2(i) || MW(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (e2(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === Si.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === vs.Strict)
      return 0;
    return this.emitCodePoint(NW(this.result), this.consumed), this.errors && (t !== Si.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], a = (i & bs.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const o = t.charCodeAt(n);
      if (this.treeIndex = HW(r, i, this.treeIndex + Math.max(1, a), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === vs.Attribute && // We shouldn't have consumed any characters after the entity,
        (a === 0 || // And there should be no invalid characters.
        BW(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], a = (i & bs.VALUE_LENGTH) >> 14, a !== 0) {
        if (o === Si.SEMI)
          return this.emitNamedEntityData(this.treeIndex, a, this.consumed + this.excess);
        this.decodeMode !== vs.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, i = (r[n] & bs.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[t] & ~bs.VALUE_LENGTH : i[t + 1], r), n === 3 && this.emitCodePoint(i[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case yi.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== vs.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case yi.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case yi.NumericHex:
        return this.emitNumericEntity(0, 3);
      case yi.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case yi.EntityStart:
        return 0;
    }
  }
}
function UE(e) {
  let t = "";
  const n = new UW(e, (r) => t += LW(r));
  return function(i, a) {
    let o = 0, c = 0;
    for (; (c = i.indexOf("&", c)) >= 0; ) {
      t += i.slice(o, c), n.startEntity(a);
      const s = n.write(
        i,
        // Skip the "&"
        c + 1
      );
      if (s < 0) {
        o = c + n.end();
        break;
      }
      o = c + s, c = s === 0 ? o + 1 : o;
    }
    const u = t + i.slice(o);
    return t = "", u;
  };
}
function HW(e, t, n, r) {
  const i = (t & bs.BRANCH_LENGTH) >> 7, a = t & bs.JUMP_TABLE;
  if (i === 0)
    return a !== 0 && r === a ? n : -1;
  if (a) {
    const u = r - a;
    return u < 0 || u >= i ? -1 : e[n + u] - 1;
  }
  let o = n, c = o + i - 1;
  for (; o <= c; ) {
    const u = o + c >>> 1, s = e[u];
    if (s < r)
      o = u + 1;
    else if (s > r)
      c = u - 1;
    else
      return e[u + i];
  }
  return -1;
}
const zW = UE(IW);
UE(qW);
function HE(e, t = vs.Legacy) {
  return zW(e, t);
}
function GW(e) {
  return Object.prototype.toString.call(e);
}
function fg(e) {
  return GW(e) === "[object String]";
}
const VW = Object.prototype.hasOwnProperty;
function WW(e, t) {
  return VW.call(e, t);
}
function Q0(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(r) {
        e[r] = n[r];
      });
    }
  }), e;
}
function zE(e, t, n) {
  return [].concat(e.slice(0, t), n, e.slice(t + 1));
}
function pg(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function S0(e) {
  if (e > 65535) {
    e -= 65536;
    const t = 55296 + (e >> 10), n = 56320 + (e & 1023);
    return String.fromCharCode(t, n);
  }
  return String.fromCharCode(e);
}
const GE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, KW = /&([a-z#][a-z0-9]{1,31});/gi, ZW = new RegExp(GE.source + "|" + KW.source, "gi"), YW = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function JW(e, t) {
  if (t.charCodeAt(0) === 35 && YW.test(t)) {
    const r = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
    return pg(r) ? S0(r) : e;
  }
  const n = HE(e);
  return n !== e ? n : e;
}
function QW(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(GE, "$1");
}
function gc(e) {
  return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(ZW, function(t, n, r) {
    return n || JW(t, r);
  });
}
const XW = /[&<>"]/, eK = /[&<>"]/g, tK = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function rK(e) {
  return tK[e];
}
function Cs(e) {
  return XW.test(e) ? e.replace(eK, rK) : e;
}
const nK = /[.?*+^$[\]\\(){}|-]/g;
function iK(e) {
  return e.replace(nK, "\\$&");
}
function Vn(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function Pf(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Rf(e) {
  return lg.test(e) || FE.test(e);
}
function jf(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function X0(e) {
  return e = e.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
}
const aK = { mdurl: PW, ucmicro: jW }, oK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: zE,
  assign: Q0,
  escapeHtml: Cs,
  escapeRE: iK,
  fromCodePoint: S0,
  has: WW,
  isMdAsciiPunct: jf,
  isPunctChar: Rf,
  isSpace: Vn,
  isString: fg,
  isValidEntityCode: pg,
  isWhiteSpace: Pf,
  lib: aK,
  normalizeReference: X0,
  unescapeAll: gc,
  unescapeMd: QW
}, Symbol.toStringTag, { value: "Module" }));
function sK(e, t, n) {
  let r, i, a, o;
  const c = e.posMax, u = e.pos;
  for (e.pos = t + 1, r = 1; e.pos < c; ) {
    if (a = e.src.charCodeAt(e.pos), a === 93 && (r--, r === 0)) {
      i = !0;
      break;
    }
    if (o = e.pos, e.md.inline.skipToken(e), a === 91) {
      if (o === e.pos - 1)
        r++;
      else if (n)
        return e.pos = u, -1;
    }
  }
  let s = -1;
  return i && (s = e.pos), e.pos = u, s;
}
function uK(e, t, n) {
  let r, i = t;
  const a = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (e.charCodeAt(i) === 60) {
    for (i++; i < n; ) {
      if (r = e.charCodeAt(i), r === 10 || r === 60)
        return a;
      if (r === 62)
        return a.pos = i + 1, a.str = gc(e.slice(t + 1, i)), a.ok = !0, a;
      if (r === 92 && i + 1 < n) {
        i += 2;
        continue;
      }
      i++;
    }
    return a;
  }
  let o = 0;
  for (; i < n && (r = e.charCodeAt(i), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && i + 1 < n) {
      if (e.charCodeAt(i + 1) === 32)
        break;
      i += 2;
      continue;
    }
    if (r === 40 && (o++, o > 32))
      return a;
    if (r === 41) {
      if (o === 0)
        break;
      o--;
    }
    i++;
  }
  return t === i || o !== 0 || (a.str = gc(e.slice(t, i)), a.pos = i, a.ok = !0), a;
}
function cK(e, t, n, r) {
  let i, a = t;
  const o = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (r)
    o.str = r.str, o.marker = r.marker;
  else {
    if (a >= n)
      return o;
    let c = e.charCodeAt(a);
    if (c !== 34 && c !== 39 && c !== 40)
      return o;
    t++, a++, c === 40 && (c = 41), o.marker = c;
  }
  for (; a < n; ) {
    if (i = e.charCodeAt(a), i === o.marker)
      return o.pos = a + 1, o.str += gc(e.slice(t, a)), o.ok = !0, o;
    if (i === 40 && o.marker === 41)
      return o;
    i === 92 && a + 1 < n && a++, a++;
  }
  return o.can_continue = !0, o.str += gc(e.slice(t, a)), o;
}
const lK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: uK,
  parseLinkLabel: sK,
  parseLinkTitle: cK
}, Symbol.toStringTag, { value: "Module" })), So = {};
So.code_inline = function(e, t, n, r, i) {
  const a = e[t];
  return "<code" + i.renderAttrs(a) + ">" + Cs(a.content) + "</code>";
};
So.code_block = function(e, t, n, r, i) {
  const a = e[t];
  return "<pre" + i.renderAttrs(a) + "><code>" + Cs(e[t].content) + `</code></pre>
`;
};
So.fence = function(e, t, n, r, i) {
  const a = e[t], o = a.info ? gc(a.info).trim() : "";
  let c = "", u = "";
  if (o) {
    const f = o.split(/(\s+)/g);
    c = f[0], u = f.slice(2).join("");
  }
  let s;
  if (n.highlight ? s = n.highlight(a.content, c, u) || Cs(a.content) : s = Cs(a.content), s.indexOf("<pre") === 0)
    return s + `
`;
  if (o) {
    const f = a.attrIndex("class"), d = a.attrs ? a.attrs.slice() : [];
    f < 0 ? d.push(["class", n.langPrefix + c]) : (d[f] = d[f].slice(), d[f][1] += " " + n.langPrefix + c);
    const l = {
      attrs: d
    };
    return `<pre><code${i.renderAttrs(l)}>${s}</code></pre>
`;
  }
  return `<pre><code${i.renderAttrs(a)}>${s}</code></pre>
`;
};
So.image = function(e, t, n, r, i) {
  const a = e[t];
  return a.attrs[a.attrIndex("alt")][1] = i.renderInlineAsText(a.children, n, r), i.renderToken(e, t, n);
};
So.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
So.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
So.text = function(e, t) {
  return Cs(e[t].content);
};
So.html_block = function(e, t) {
  return e[t].content;
};
So.html_inline = function(e, t) {
  return e[t].content;
};
function Pc() {
  this.rules = Q0({}, So);
}
Pc.prototype.renderAttrs = function(t) {
  let n, r, i;
  if (!t.attrs)
    return "";
  for (i = "", n = 0, r = t.attrs.length; n < r; n++)
    i += " " + Cs(t.attrs[n][0]) + '="' + Cs(t.attrs[n][1]) + '"';
  return i;
};
Pc.prototype.renderToken = function(t, n, r) {
  const i = t[n];
  let a = "";
  if (i.hidden)
    return "";
  i.block && i.nesting !== -1 && n && t[n - 1].hidden && (a += `
`), a += (i.nesting === -1 ? "</" : "<") + i.tag, a += this.renderAttrs(i), i.nesting === 0 && r.xhtmlOut && (a += " /");
  let o = !1;
  if (i.block && (o = !0, i.nesting === 1 && n + 1 < t.length)) {
    const c = t[n + 1];
    (c.type === "inline" || c.hidden || c.nesting === -1 && c.tag === i.tag) && (o = !1);
  }
  return a += o ? `>
` : ">", a;
};
Pc.prototype.renderInline = function(e, t, n) {
  let r = "";
  const i = this.rules;
  for (let a = 0, o = e.length; a < o; a++) {
    const c = e[a].type;
    typeof i[c] < "u" ? r += i[c](e, a, t, n, this) : r += this.renderToken(e, a, t);
  }
  return r;
};
Pc.prototype.renderInlineAsText = function(e, t, n) {
  let r = "";
  for (let i = 0, a = e.length; i < a; i++)
    switch (e[i].type) {
      case "text":
        r += e[i].content;
        break;
      case "image":
        r += this.renderInlineAsText(e[i].children, t, n);
        break;
      case "html_inline":
      case "html_block":
        r += e[i].content;
        break;
      case "softbreak":
      case "hardbreak":
        r += `
`;
        break;
    }
  return r;
};
Pc.prototype.render = function(e, t, n) {
  let r = "";
  const i = this.rules;
  for (let a = 0, o = e.length; a < o; a++) {
    const c = e[a].type;
    c === "inline" ? r += this.renderInline(e[a].children, t, n) : typeof i[c] < "u" ? r += i[c](e, a, t, n, this) : r += this.renderToken(e, a, t, n);
  }
  return r;
};
function ta() {
  this.__rules__ = [], this.__cache__ = null;
}
ta.prototype.__find__ = function(e) {
  for (let t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
ta.prototype.__compile__ = function() {
  const e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      t.indexOf(r) < 0 && t.push(r);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || e.__cache__[n].push(r.fn));
    });
  });
};
ta.prototype.at = function(e, t, n) {
  const r = this.__find__(e), i = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[r].fn = t, this.__rules__[r].alt = i.alt || [], this.__cache__ = null;
};
ta.prototype.before = function(e, t, n, r) {
  const i = this.__find__(e), a = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: a.alt || []
  }), this.__cache__ = null;
};
ta.prototype.after = function(e, t, n, r) {
  const i = this.__find__(e), a = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: a.alt || []
  }), this.__cache__ = null;
};
ta.prototype.push = function(e, t, n) {
  const r = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: r.alt || []
  }), this.__cache__ = null;
};
ta.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !0, n.push(r);
  }, this), this.__cache__ = null, n;
};
ta.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(e, t);
};
ta.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !1, n.push(r);
  }, this), this.__cache__ = null, n;
};
ta.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function io(e, t, n) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
io.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const n = this.attrs;
  for (let r = 0, i = n.length; r < i; r++)
    if (n[r][0] === t)
      return r;
  return -1;
};
io.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
io.prototype.attrSet = function(t, n) {
  const r = this.attrIndex(t), i = [t, n];
  r < 0 ? this.attrPush(i) : this.attrs[r] = i;
};
io.prototype.attrGet = function(t) {
  const n = this.attrIndex(t);
  let r = null;
  return n >= 0 && (r = this.attrs[n][1]), r;
};
io.prototype.attrJoin = function(t, n) {
  const r = this.attrIndex(t);
  r < 0 ? this.attrPush([t, n]) : this.attrs[r][1] = this.attrs[r][1] + " " + n;
};
function VE(e, t, n) {
  this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
}
VE.prototype.Token = io;
const fK = /\r\n?|\n/g, pK = /\0/g;
function dK(e) {
  let t;
  t = e.src.replace(fK, `
`), t = t.replace(pK, "�"), e.src = t;
}
function hK(e) {
  let t;
  e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function mK(e) {
  const t = e.tokens;
  for (let n = 0, r = t.length; n < r; n++) {
    const i = t[n];
    i.type === "inline" && e.md.inline.parse(i.content, e.md, e.env, i.children);
  }
}
function gK(e) {
  return /^<a[>\s]/i.test(e);
}
function vK(e) {
  return /^<\/a\s*>/i.test(e);
}
function yK(e) {
  const t = e.tokens;
  if (e.md.options.linkify)
    for (let n = 0, r = t.length; n < r; n++) {
      if (t[n].type !== "inline" || !e.md.linkify.pretest(t[n].content))
        continue;
      let i = t[n].children, a = 0;
      for (let o = i.length - 1; o >= 0; o--) {
        const c = i[o];
        if (c.type === "link_close") {
          for (o--; i[o].level !== c.level && i[o].type !== "link_open"; )
            o--;
          continue;
        }
        if (c.type === "html_inline" && (gK(c.content) && a > 0 && a--, vK(c.content) && a++), !(a > 0) && c.type === "text" && e.md.linkify.test(c.content)) {
          const u = c.content;
          let s = e.md.linkify.match(u);
          const f = [];
          let d = c.level, l = 0;
          s.length > 0 && s[0].index === 0 && o > 0 && i[o - 1].type === "text_special" && (s = s.slice(1));
          for (let p = 0; p < s.length; p++) {
            const g = s[p].url, v = e.md.normalizeLink(g);
            if (!e.md.validateLink(v))
              continue;
            let b = s[p].text;
            s[p].schema ? s[p].schema === "mailto:" && !/^mailto:/i.test(b) ? b = e.md.normalizeLinkText("mailto:" + b).replace(/^mailto:/, "") : b = e.md.normalizeLinkText(b) : b = e.md.normalizeLinkText("http://" + b).replace(/^http:\/\//, "");
            const y = s[p].index;
            if (y > l) {
              const E = new e.Token("text", "", 0);
              E.content = u.slice(l, y), E.level = d, f.push(E);
            }
            const w = new e.Token("link_open", "a", 1);
            w.attrs = [["href", v]], w.level = d++, w.markup = "linkify", w.info = "auto", f.push(w);
            const C = new e.Token("text", "", 0);
            C.content = b, C.level = d, f.push(C);
            const T = new e.Token("link_close", "a", -1);
            T.level = --d, T.markup = "linkify", T.info = "auto", f.push(T), l = s[p].lastIndex;
          }
          if (l < u.length) {
            const p = new e.Token("text", "", 0);
            p.content = u.slice(l), p.level = d, f.push(p);
          }
          t[n].children = i = zE(i, o, f);
        }
      }
    }
}
const WE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, bK = /\((c|tm|r)\)/i, xK = /\((c|tm|r)\)/ig, _K = {
  c: "©",
  r: "®",
  tm: "™"
};
function wK(e, t) {
  return _K[t.toLowerCase()];
}
function SK(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && (r.content = r.content.replace(xK, wK)), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function CK(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && WE.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function AK(e) {
  let t;
  if (e.md.options.typographer)
    for (t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type === "inline" && (bK.test(e.tokens[t].content) && SK(e.tokens[t].children), WE.test(e.tokens[t].content) && CK(e.tokens[t].children));
}
const kK = /['"]/, F7 = /['"]/g, B7 = "’";
function kd(e, t, n) {
  return e.slice(0, t) + n + e.slice(t + 1);
}
function EK(e, t) {
  let n;
  const r = [];
  for (let i = 0; i < e.length; i++) {
    const a = e[i], o = e[i].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= o); n--)
      ;
    if (r.length = n + 1, a.type !== "text")
      continue;
    let c = a.content, u = 0, s = c.length;
    e:
      for (; u < s; ) {
        F7.lastIndex = u;
        const f = F7.exec(c);
        if (!f)
          break;
        let d = !0, l = !0;
        u = f.index + 1;
        const p = f[0] === "'";
        let g = 32;
        if (f.index - 1 >= 0)
          g = c.charCodeAt(f.index - 1);
        else
          for (n = i - 1; n >= 0 && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n--)
            if (e[n].content) {
              g = e[n].content.charCodeAt(e[n].content.length - 1);
              break;
            }
        let v = 32;
        if (u < s)
          v = c.charCodeAt(u);
        else
          for (n = i + 1; n < e.length && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n++)
            if (e[n].content) {
              v = e[n].content.charCodeAt(0);
              break;
            }
        const b = jf(g) || Rf(String.fromCharCode(g)), y = jf(v) || Rf(String.fromCharCode(v)), w = Pf(g), C = Pf(v);
        if (C ? d = !1 : y && (w || b || (d = !1)), w ? l = !1 : b && (C || y || (l = !1)), v === 34 && f[0] === '"' && g >= 48 && g <= 57 && (l = d = !1), d && l && (d = b, l = y), !d && !l) {
          p && (a.content = kd(a.content, f.index, B7));
          continue;
        }
        if (l)
          for (n = r.length - 1; n >= 0; n--) {
            let T = r[n];
            if (r[n].level < o)
              break;
            if (T.single === p && r[n].level === o) {
              T = r[n];
              let E, D;
              p ? (E = t.md.options.quotes[2], D = t.md.options.quotes[3]) : (E = t.md.options.quotes[0], D = t.md.options.quotes[1]), a.content = kd(a.content, f.index, D), e[T.token].content = kd(
                e[T.token].content,
                T.pos,
                E
              ), u += D.length - 1, T.token === i && (u += E.length - 1), c = a.content, s = c.length, r.length = n;
              continue e;
            }
          }
        d ? r.push({
          token: i,
          pos: f.index,
          single: p,
          level: o
        }) : l && p && (a.content = kd(a.content, f.index, B7));
      }
  }
}
function OK(e) {
  if (e.md.options.typographer)
    for (let t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type !== "inline" || !kK.test(e.tokens[t].content) || EK(e.tokens[t].children, e);
}
function TK(e) {
  let t, n;
  const r = e.tokens, i = r.length;
  for (let a = 0; a < i; a++) {
    if (r[a].type !== "inline") continue;
    const o = r[a].children, c = o.length;
    for (t = 0; t < c; t++)
      o[t].type === "text_special" && (o[t].type = "text");
    for (t = n = 0; t < c; t++)
      o[t].type === "text" && t + 1 < c && o[t + 1].type === "text" ? o[t + 1].content = o[t].content + o[t + 1].content : (t !== n && (o[n] = o[t]), n++);
    t !== n && (o.length = n);
  }
}
const Gm = [
  ["normalize", dK],
  ["block", hK],
  ["inline", mK],
  ["linkify", yK],
  ["replacements", AK],
  ["smartquotes", OK],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", TK]
];
function dg() {
  this.ruler = new ta();
  for (let e = 0; e < Gm.length; e++)
    this.ruler.push(Gm[e][0], Gm[e][1]);
}
dg.prototype.process = function(e) {
  const t = this.ruler.getRules("");
  for (let n = 0, r = t.length; n < r; n++)
    t[n](e);
};
dg.prototype.State = VE;
function Co(e, t, n, r) {
  this.src = e, this.md = t, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const i = this.src;
  for (let a = 0, o = 0, c = 0, u = 0, s = i.length, f = !1; o < s; o++) {
    const d = i.charCodeAt(o);
    if (!f)
      if (Vn(d)) {
        c++, d === 9 ? u += 4 - u % 4 : u++;
        continue;
      } else
        f = !0;
    (d === 10 || o === s - 1) && (d !== 10 && o++, this.bMarks.push(a), this.eMarks.push(o), this.tShift.push(c), this.sCount.push(u), this.bsCount.push(0), f = !1, c = 0, u = 0, a = o + 1);
  }
  this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
Co.prototype.push = function(e, t, n) {
  const r = new io(e, t, n);
  return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
};
Co.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
Co.prototype.skipEmptyLines = function(t) {
  for (let n = this.lineMax; t < n && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
Co.prototype.skipSpaces = function(t) {
  for (let n = this.src.length; t < n; t++) {
    const r = this.src.charCodeAt(t);
    if (!Vn(r))
      break;
  }
  return t;
};
Co.prototype.skipSpacesBack = function(t, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (!Vn(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
Co.prototype.skipChars = function(t, n) {
  for (let r = this.src.length; t < r && this.src.charCodeAt(t) === n; t++)
    ;
  return t;
};
Co.prototype.skipCharsBack = function(t, n, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (n !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
Co.prototype.getLines = function(t, n, r, i) {
  if (t >= n)
    return "";
  const a = new Array(n - t);
  for (let o = 0, c = t; c < n; c++, o++) {
    let u = 0;
    const s = this.bMarks[c];
    let f = s, d;
    for (c + 1 < n || i ? d = this.eMarks[c] + 1 : d = this.eMarks[c]; f < d && u < r; ) {
      const l = this.src.charCodeAt(f);
      if (Vn(l))
        l === 9 ? u += 4 - (u + this.bsCount[c]) % 4 : u++;
      else if (f - s < this.tShift[c])
        u++;
      else
        break;
      f++;
    }
    u > r ? a[o] = new Array(u - r + 1).join(" ") + this.src.slice(f, d) : a[o] = this.src.slice(f, d);
  }
  return a.join("");
};
Co.prototype.Token = io;
const PK = 65536;
function Vm(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  return e.src.slice(n, r);
}
function U7(e) {
  const t = [], n = e.length;
  let r = 0, i = e.charCodeAt(r), a = !1, o = 0, c = "";
  for (; r < n; )
    i === 124 && (a ? (c += e.substring(o, r - 1), o = r) : (t.push(c + e.substring(o, r)), c = "", o = r + 1)), a = i === 92, r++, i = e.charCodeAt(r);
  return t.push(c + e.substring(o)), t;
}
function RK(e, t, n, r) {
  if (t + 2 > n)
    return !1;
  let i = t + 1;
  if (e.sCount[i] < e.blkIndent || e.sCount[i] - e.blkIndent >= 4)
    return !1;
  let a = e.bMarks[i] + e.tShift[i];
  if (a >= e.eMarks[i])
    return !1;
  const o = e.src.charCodeAt(a++);
  if (o !== 124 && o !== 45 && o !== 58 || a >= e.eMarks[i])
    return !1;
  const c = e.src.charCodeAt(a++);
  if (c !== 124 && c !== 45 && c !== 58 && !Vn(c) || o === 45 && Vn(c))
    return !1;
  for (; a < e.eMarks[i]; ) {
    const T = e.src.charCodeAt(a);
    if (T !== 124 && T !== 45 && T !== 58 && !Vn(T))
      return !1;
    a++;
  }
  let u = Vm(e, t + 1), s = u.split("|");
  const f = [];
  for (let T = 0; T < s.length; T++) {
    const E = s[T].trim();
    if (!E) {
      if (T === 0 || T === s.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(E))
      return !1;
    E.charCodeAt(E.length - 1) === 58 ? f.push(E.charCodeAt(0) === 58 ? "center" : "right") : E.charCodeAt(0) === 58 ? f.push("left") : f.push("");
  }
  if (u = Vm(e, t).trim(), u.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4)
    return !1;
  s = U7(u), s.length && s[0] === "" && s.shift(), s.length && s[s.length - 1] === "" && s.pop();
  const d = s.length;
  if (d === 0 || d !== f.length)
    return !1;
  if (r)
    return !0;
  const l = e.parentType;
  e.parentType = "table";
  const p = e.md.block.ruler.getRules("blockquote"), g = e.push("table_open", "table", 1), v = [t, 0];
  g.map = v;
  const b = e.push("thead_open", "thead", 1);
  b.map = [t, t + 1];
  const y = e.push("tr_open", "tr", 1);
  y.map = [t, t + 1];
  for (let T = 0; T < s.length; T++) {
    const E = e.push("th_open", "th", 1);
    f[T] && (E.attrs = [["style", "text-align:" + f[T]]]);
    const D = e.push("inline", "", 0);
    D.content = s[T].trim(), D.children = [], e.push("th_close", "th", -1);
  }
  e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
  let w, C = 0;
  for (i = t + 2; i < n && !(e.sCount[i] < e.blkIndent); i++) {
    let T = !1;
    for (let D = 0, $ = p.length; D < $; D++)
      if (p[D](e, i, n, !0)) {
        T = !0;
        break;
      }
    if (T || (u = Vm(e, i).trim(), !u) || e.sCount[i] - e.blkIndent >= 4 || (s = U7(u), s.length && s[0] === "" && s.shift(), s.length && s[s.length - 1] === "" && s.pop(), C += d - s.length, C > PK))
      break;
    if (i === t + 2) {
      const D = e.push("tbody_open", "tbody", 1);
      D.map = w = [t + 2, 0];
    }
    const E = e.push("tr_open", "tr", 1);
    E.map = [i, i + 1];
    for (let D = 0; D < d; D++) {
      const $ = e.push("td_open", "td", 1);
      f[D] && ($.attrs = [["style", "text-align:" + f[D]]]);
      const Z = e.push("inline", "", 0);
      Z.content = s[D] ? s[D].trim() : "", Z.children = [], e.push("td_close", "td", -1);
    }
    e.push("tr_close", "tr", -1);
  }
  return w && (e.push("tbody_close", "tbody", -1), w[1] = i), e.push("table_close", "table", -1), v[1] = i, e.parentType = l, e.line = i, !0;
}
function jK(e, t, n) {
  if (e.sCount[t] - e.blkIndent < 4)
    return !1;
  let r = t + 1, i = r;
  for (; r < n; ) {
    if (e.isEmpty(r)) {
      r++;
      continue;
    }
    if (e.sCount[r] - e.blkIndent >= 4) {
      r++, i = r;
      continue;
    }
    break;
  }
  e.line = i;
  const a = e.push("code_block", "code", 0);
  return a.content = e.getLines(t, i, 4 + e.blkIndent, !1) + `
`, a.map = [t, e.line], !0;
}
function IK(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || i + 3 > a)
    return !1;
  const o = e.src.charCodeAt(i);
  if (o !== 126 && o !== 96)
    return !1;
  let c = i;
  i = e.skipChars(i, o);
  let u = i - c;
  if (u < 3)
    return !1;
  const s = e.src.slice(c, i), f = e.src.slice(i, a);
  if (o === 96 && f.indexOf(String.fromCharCode(o)) >= 0)
    return !1;
  if (r)
    return !0;
  let d = t, l = !1;
  for (; d++, !(d >= n || (i = c = e.bMarks[d] + e.tShift[d], a = e.eMarks[d], i < a && e.sCount[d] < e.blkIndent)); )
    if (e.src.charCodeAt(i) === o && !(e.sCount[d] - e.blkIndent >= 4) && (i = e.skipChars(i, o), !(i - c < u) && (i = e.skipSpaces(i), !(i < a)))) {
      l = !0;
      break;
    }
  u = e.sCount[t], e.line = d + (l ? 1 : 0);
  const p = e.push("fence", "code", 0);
  return p.info = f, p.content = e.getLines(t + 1, d, u, !0), p.markup = s, p.map = [t, e.line], !0;
}
function qK(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  const o = e.lineMax;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 62)
    return !1;
  if (r)
    return !0;
  const c = [], u = [], s = [], f = [], d = e.md.block.ruler.getRules("blockquote"), l = e.parentType;
  e.parentType = "blockquote";
  let p = !1, g;
  for (g = t; g < n; g++) {
    const C = e.sCount[g] < e.blkIndent;
    if (i = e.bMarks[g] + e.tShift[g], a = e.eMarks[g], i >= a)
      break;
    if (e.src.charCodeAt(i++) === 62 && !C) {
      let E = e.sCount[g] + 1, D, $;
      e.src.charCodeAt(i) === 32 ? (i++, E++, $ = !1, D = !0) : e.src.charCodeAt(i) === 9 ? (D = !0, (e.bsCount[g] + E) % 4 === 3 ? (i++, E++, $ = !1) : $ = !0) : D = !1;
      let Z = E;
      for (c.push(e.bMarks[g]), e.bMarks[g] = i; i < a; ) {
        const te = e.src.charCodeAt(i);
        if (Vn(te))
          te === 9 ? Z += 4 - (Z + e.bsCount[g] + ($ ? 1 : 0)) % 4 : Z++;
        else
          break;
        i++;
      }
      p = i >= a, u.push(e.bsCount[g]), e.bsCount[g] = e.sCount[g] + 1 + (D ? 1 : 0), s.push(e.sCount[g]), e.sCount[g] = Z - E, f.push(e.tShift[g]), e.tShift[g] = i - e.bMarks[g];
      continue;
    }
    if (p)
      break;
    let T = !1;
    for (let E = 0, D = d.length; E < D; E++)
      if (d[E](e, g, n, !0)) {
        T = !0;
        break;
      }
    if (T) {
      e.lineMax = g, e.blkIndent !== 0 && (c.push(e.bMarks[g]), u.push(e.bsCount[g]), f.push(e.tShift[g]), s.push(e.sCount[g]), e.sCount[g] -= e.blkIndent);
      break;
    }
    c.push(e.bMarks[g]), u.push(e.bsCount[g]), f.push(e.tShift[g]), s.push(e.sCount[g]), e.sCount[g] = -1;
  }
  const v = e.blkIndent;
  e.blkIndent = 0;
  const b = e.push("blockquote_open", "blockquote", 1);
  b.markup = ">";
  const y = [t, 0];
  b.map = y, e.md.block.tokenize(e, t, g);
  const w = e.push("blockquote_close", "blockquote", -1);
  w.markup = ">", e.lineMax = o, e.parentType = l, y[1] = e.line;
  for (let C = 0; C < f.length; C++)
    e.bMarks[C + t] = c[C], e.tShift[C + t] = f[C], e.sCount[C + t] = s[C], e.bsCount[C + t] = u[C];
  return e.blkIndent = v, !0;
}
function DK(e, t, n, r) {
  const i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let a = e.bMarks[t] + e.tShift[t];
  const o = e.src.charCodeAt(a++);
  if (o !== 42 && o !== 45 && o !== 95)
    return !1;
  let c = 1;
  for (; a < i; ) {
    const s = e.src.charCodeAt(a++);
    if (s !== o && !Vn(s))
      return !1;
    s === o && c++;
  }
  if (c < 3)
    return !1;
  if (r)
    return !0;
  e.line = t + 1;
  const u = e.push("hr", "hr", 0);
  return u.map = [t, e.line], u.markup = Array(c + 1).join(String.fromCharCode(o)), !0;
}
function H7(e, t) {
  const n = e.eMarks[t];
  let r = e.bMarks[t] + e.tShift[t];
  const i = e.src.charCodeAt(r++);
  if (i !== 42 && i !== 45 && i !== 43)
    return -1;
  if (r < n) {
    const a = e.src.charCodeAt(r);
    if (!Vn(a))
      return -1;
  }
  return r;
}
function z7(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  let i = n;
  if (i + 1 >= r)
    return -1;
  let a = e.src.charCodeAt(i++);
  if (a < 48 || a > 57)
    return -1;
  for (; ; ) {
    if (i >= r)
      return -1;
    if (a = e.src.charCodeAt(i++), a >= 48 && a <= 57) {
      if (i - n >= 10)
        return -1;
      continue;
    }
    if (a === 41 || a === 46)
      break;
    return -1;
  }
  return i < r && (a = e.src.charCodeAt(i), !Vn(a)) ? -1 : i;
}
function LK(e, t) {
  const n = e.level + 2;
  for (let r = t + 2, i = e.tokens.length - 2; r < i; r++)
    e.tokens[r].level === n && e.tokens[r].type === "paragraph_open" && (e.tokens[r + 2].hidden = !0, e.tokens[r].hidden = !0, r += 2);
}
function NK(e, t, n, r) {
  let i, a, o, c, u = t, s = !0;
  if (e.sCount[u] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[u] - e.listIndent >= 4 && e.sCount[u] < e.blkIndent)
    return !1;
  let f = !1;
  r && e.parentType === "paragraph" && e.sCount[u] >= e.blkIndent && (f = !0);
  let d, l, p;
  if ((p = z7(e, u)) >= 0) {
    if (d = !0, o = e.bMarks[u] + e.tShift[u], l = Number(e.src.slice(o, p - 1)), f && l !== 1) return !1;
  } else if ((p = H7(e, u)) >= 0)
    d = !1;
  else
    return !1;
  if (f && e.skipSpaces(p) >= e.eMarks[u])
    return !1;
  if (r)
    return !0;
  const g = e.src.charCodeAt(p - 1), v = e.tokens.length;
  d ? (c = e.push("ordered_list_open", "ol", 1), l !== 1 && (c.attrs = [["start", l]])) : c = e.push("bullet_list_open", "ul", 1);
  const b = [u, 0];
  c.map = b, c.markup = String.fromCharCode(g);
  let y = !1;
  const w = e.md.block.ruler.getRules("list"), C = e.parentType;
  for (e.parentType = "list"; u < n; ) {
    a = p, i = e.eMarks[u];
    const T = e.sCount[u] + p - (e.bMarks[u] + e.tShift[u]);
    let E = T;
    for (; a < i; ) {
      const ie = e.src.charCodeAt(a);
      if (ie === 9)
        E += 4 - (E + e.bsCount[u]) % 4;
      else if (ie === 32)
        E++;
      else
        break;
      a++;
    }
    const D = a;
    let $;
    D >= i ? $ = 1 : $ = E - T, $ > 4 && ($ = 1);
    const Z = T + $;
    c = e.push("list_item_open", "li", 1), c.markup = String.fromCharCode(g);
    const te = [u, 0];
    c.map = te, d && (c.info = e.src.slice(o, p - 1));
    const se = e.tight, ee = e.tShift[u], K = e.sCount[u], re = e.listIndent;
    if (e.listIndent = e.blkIndent, e.blkIndent = Z, e.tight = !0, e.tShift[u] = D - e.bMarks[u], e.sCount[u] = E, D >= i && e.isEmpty(u + 1) ? e.line = Math.min(e.line + 2, n) : e.md.block.tokenize(e, u, n, !0), (!e.tight || y) && (s = !1), y = e.line - u > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = re, e.tShift[u] = ee, e.sCount[u] = K, e.tight = se, c = e.push("list_item_close", "li", -1), c.markup = String.fromCharCode(g), u = e.line, te[1] = u, u >= n || e.sCount[u] < e.blkIndent || e.sCount[u] - e.blkIndent >= 4)
      break;
    let de = !1;
    for (let ie = 0, me = w.length; ie < me; ie++)
      if (w[ie](e, u, n, !0)) {
        de = !0;
        break;
      }
    if (de)
      break;
    if (d) {
      if (p = z7(e, u), p < 0)
        break;
      o = e.bMarks[u] + e.tShift[u];
    } else if (p = H7(e, u), p < 0)
      break;
    if (g !== e.src.charCodeAt(p - 1))
      break;
  }
  return d ? c = e.push("ordered_list_close", "ol", -1) : c = e.push("bullet_list_close", "ul", -1), c.markup = String.fromCharCode(g), b[1] = u, e.line = u, e.parentType = C, s && LK(e, v), !0;
}
function $K(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t], o = t + 1;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 91)
    return !1;
  function c(w) {
    const C = e.lineMax;
    if (w >= C || e.isEmpty(w))
      return null;
    let T = !1;
    if (e.sCount[w] - e.blkIndent > 3 && (T = !0), e.sCount[w] < 0 && (T = !0), !T) {
      const $ = e.md.block.ruler.getRules("reference"), Z = e.parentType;
      e.parentType = "reference";
      let te = !1;
      for (let se = 0, ee = $.length; se < ee; se++)
        if ($[se](e, w, C, !0)) {
          te = !0;
          break;
        }
      if (e.parentType = Z, te)
        return null;
    }
    const E = e.bMarks[w] + e.tShift[w], D = e.eMarks[w];
    return e.src.slice(E, D + 1);
  }
  let u = e.src.slice(i, a + 1);
  a = u.length;
  let s = -1;
  for (i = 1; i < a; i++) {
    const w = u.charCodeAt(i);
    if (w === 91)
      return !1;
    if (w === 93) {
      s = i;
      break;
    } else if (w === 10) {
      const C = c(o);
      C !== null && (u += C, a = u.length, o++);
    } else if (w === 92 && (i++, i < a && u.charCodeAt(i) === 10)) {
      const C = c(o);
      C !== null && (u += C, a = u.length, o++);
    }
  }
  if (s < 0 || u.charCodeAt(s + 1) !== 58)
    return !1;
  for (i = s + 2; i < a; i++) {
    const w = u.charCodeAt(i);
    if (w === 10) {
      const C = c(o);
      C !== null && (u += C, a = u.length, o++);
    } else if (!Vn(w)) break;
  }
  const f = e.md.helpers.parseLinkDestination(u, i, a);
  if (!f.ok)
    return !1;
  const d = e.md.normalizeLink(f.str);
  if (!e.md.validateLink(d))
    return !1;
  i = f.pos;
  const l = i, p = o, g = i;
  for (; i < a; i++) {
    const w = u.charCodeAt(i);
    if (w === 10) {
      const C = c(o);
      C !== null && (u += C, a = u.length, o++);
    } else if (!Vn(w)) break;
  }
  let v = e.md.helpers.parseLinkTitle(u, i, a);
  for (; v.can_continue; ) {
    const w = c(o);
    if (w === null) break;
    u += w, i = a, a = u.length, o++, v = e.md.helpers.parseLinkTitle(u, i, a, v);
  }
  let b;
  for (i < a && g !== i && v.ok ? (b = v.str, i = v.pos) : (b = "", i = l, o = p); i < a; ) {
    const w = u.charCodeAt(i);
    if (!Vn(w))
      break;
    i++;
  }
  if (i < a && u.charCodeAt(i) !== 10 && b)
    for (b = "", i = l, o = p; i < a; ) {
      const w = u.charCodeAt(i);
      if (!Vn(w))
        break;
      i++;
    }
  if (i < a && u.charCodeAt(i) !== 10)
    return !1;
  const y = X0(u.slice(1, s));
  return y ? (r || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[y] > "u" && (e.env.references[y] = { title: b, href: d }), e.line = o), !0) : !1;
}
const MK = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], FK = "[a-zA-Z_:][a-zA-Z0-9:._-]*", BK = "[^\"'=<>`\\x00-\\x20]+", UK = "'[^']*'", HK = '"[^"]*"', zK = "(?:" + BK + "|" + UK + "|" + HK + ")", GK = "(?:\\s+" + FK + "(?:\\s*=\\s*" + zK + ")?)", KE = "<[A-Za-z][A-Za-z0-9\\-]*" + GK + "*\\s*\\/?>", ZE = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", VK = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", WK = "<[?][\\s\\S]*?[?]>", KK = "<![A-Za-z][^>]*>", ZK = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", YK = new RegExp("^(?:" + KE + "|" + ZE + "|" + VK + "|" + WK + "|" + KK + "|" + ZK + ")"), JK = new RegExp("^(?:" + KE + "|" + ZE + ")"), Ju = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + MK.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(JK.source + "\\s*$"), /^$/, !1]
];
function QK(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(i) !== 60)
    return !1;
  let o = e.src.slice(i, a), c = 0;
  for (; c < Ju.length && !Ju[c][0].test(o); c++)
    ;
  if (c === Ju.length)
    return !1;
  if (r)
    return Ju[c][2];
  let u = t + 1;
  if (!Ju[c][1].test(o)) {
    for (; u < n && !(e.sCount[u] < e.blkIndent); u++)
      if (i = e.bMarks[u] + e.tShift[u], a = e.eMarks[u], o = e.src.slice(i, a), Ju[c][1].test(o)) {
        o.length !== 0 && u++;
        break;
      }
  }
  e.line = u;
  const s = e.push("html_block", "", 0);
  return s.map = [t, u], s.content = e.getLines(t, u, e.blkIndent, !0), !0;
}
function XK(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let o = e.src.charCodeAt(i);
  if (o !== 35 || i >= a)
    return !1;
  let c = 1;
  for (o = e.src.charCodeAt(++i); o === 35 && i < a && c <= 6; )
    c++, o = e.src.charCodeAt(++i);
  if (c > 6 || i < a && !Vn(o))
    return !1;
  if (r)
    return !0;
  a = e.skipSpacesBack(a, i);
  const u = e.skipCharsBack(a, 35, i);
  u > i && Vn(e.src.charCodeAt(u - 1)) && (a = u), e.line = t + 1;
  const s = e.push("heading_open", "h" + String(c), 1);
  s.markup = "########".slice(0, c), s.map = [t, e.line];
  const f = e.push("inline", "", 0);
  f.content = e.src.slice(i, a).trim(), f.map = [t, e.line], f.children = [];
  const d = e.push("heading_close", "h" + String(c), -1);
  return d.markup = "########".slice(0, c), !0;
}
function eZ(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  const i = e.parentType;
  e.parentType = "paragraph";
  let a = 0, o, c = t + 1;
  for (; c < n && !e.isEmpty(c); c++) {
    if (e.sCount[c] - e.blkIndent > 3)
      continue;
    if (e.sCount[c] >= e.blkIndent) {
      let p = e.bMarks[c] + e.tShift[c];
      const g = e.eMarks[c];
      if (p < g && (o = e.src.charCodeAt(p), (o === 45 || o === 61) && (p = e.skipChars(p, o), p = e.skipSpaces(p), p >= g))) {
        a = o === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[c] < 0)
      continue;
    let l = !1;
    for (let p = 0, g = r.length; p < g; p++)
      if (r[p](e, c, n, !0)) {
        l = !0;
        break;
      }
    if (l)
      break;
  }
  if (!a)
    return !1;
  const u = e.getLines(t, c, e.blkIndent, !1).trim();
  e.line = c + 1;
  const s = e.push("heading_open", "h" + String(a), 1);
  s.markup = String.fromCharCode(o), s.map = [t, e.line];
  const f = e.push("inline", "", 0);
  f.content = u, f.map = [t, e.line - 1], f.children = [];
  const d = e.push("heading_close", "h" + String(a), -1);
  return d.markup = String.fromCharCode(o), e.parentType = i, !0;
}
function tZ(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph"), i = e.parentType;
  let a = t + 1;
  for (e.parentType = "paragraph"; a < n && !e.isEmpty(a); a++) {
    if (e.sCount[a] - e.blkIndent > 3 || e.sCount[a] < 0)
      continue;
    let s = !1;
    for (let f = 0, d = r.length; f < d; f++)
      if (r[f](e, a, n, !0)) {
        s = !0;
        break;
      }
    if (s)
      break;
  }
  const o = e.getLines(t, a, e.blkIndent, !1).trim();
  e.line = a;
  const c = e.push("paragraph_open", "p", 1);
  c.map = [t, e.line];
  const u = e.push("inline", "", 0);
  return u.content = o, u.map = [t, e.line], u.children = [], e.push("paragraph_close", "p", -1), e.parentType = i, !0;
}
const Ed = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", RK, ["paragraph", "reference"]],
  ["code", jK],
  ["fence", IK, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", qK, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", DK, ["paragraph", "reference", "blockquote", "list"]],
  ["list", NK, ["paragraph", "reference", "blockquote"]],
  ["reference", $K],
  ["html_block", QK, ["paragraph", "reference", "blockquote"]],
  ["heading", XK, ["paragraph", "reference", "blockquote"]],
  ["lheading", eZ],
  ["paragraph", tZ]
];
function e1() {
  this.ruler = new ta();
  for (let e = 0; e < Ed.length; e++)
    this.ruler.push(Ed[e][0], Ed[e][1], { alt: (Ed[e][2] || []).slice() });
}
e1.prototype.tokenize = function(e, t, n) {
  const r = this.ruler.getRules(""), i = r.length, a = e.md.options.maxNesting;
  let o = t, c = !1;
  for (; o < n && (e.line = o = e.skipEmptyLines(o), !(o >= n || e.sCount[o] < e.blkIndent)); ) {
    if (e.level >= a) {
      e.line = n;
      break;
    }
    const u = e.line;
    let s = !1;
    for (let f = 0; f < i; f++)
      if (s = r[f](e, o, n, !1), s) {
        if (u >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!s) throw new Error("none of the block rules matched");
    e.tight = !c, e.isEmpty(e.line - 1) && (c = !0), o = e.line, o < n && e.isEmpty(o) && (c = !0, o++, e.line = o);
  }
};
e1.prototype.parse = function(e, t, n, r) {
  if (!e)
    return;
  const i = new this.State(e, t, n, r);
  this.tokenize(i, i.line, i.lineMax);
};
e1.prototype.State = Co;
function rp(e, t, n, r) {
  this.src = e, this.env = n, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
rp.prototype.pushPending = function() {
  const e = new io("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
rp.prototype.push = function(e, t, n) {
  this.pending && this.pushPending();
  const r = new io(e, t, n);
  let i = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], i = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(i), r;
};
rp.prototype.scanDelims = function(e, t) {
  const n = this.posMax, r = this.src.charCodeAt(e), i = e > 0 ? this.src.charCodeAt(e - 1) : 32;
  let a = e;
  for (; a < n && this.src.charCodeAt(a) === r; )
    a++;
  const o = a - e, c = a < n ? this.src.charCodeAt(a) : 32, u = jf(i) || Rf(String.fromCharCode(i)), s = jf(c) || Rf(String.fromCharCode(c)), f = Pf(i), d = Pf(c), l = !d && (!s || f || u), p = !f && (!u || d || s);
  return { can_open: l && (t || !p || u), can_close: p && (t || !l || s), length: o };
};
rp.prototype.Token = io;
function rZ(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function nZ(e, t) {
  let n = e.pos;
  for (; n < e.posMax && !rZ(e.src.charCodeAt(n)); )
    n++;
  return n === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
}
const iZ = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function aZ(e, t) {
  if (!e.md.options.linkify || e.linkLevel > 0) return !1;
  const n = e.pos, r = e.posMax;
  if (n + 3 > r || e.src.charCodeAt(n) !== 58 || e.src.charCodeAt(n + 1) !== 47 || e.src.charCodeAt(n + 2) !== 47) return !1;
  const i = e.pending.match(iZ);
  if (!i) return !1;
  const a = i[1], o = e.md.linkify.matchAtStart(e.src.slice(n - a.length));
  if (!o) return !1;
  let c = o.url;
  if (c.length <= a.length) return !1;
  c = c.replace(/\*+$/, "");
  const u = e.md.normalizeLink(c);
  if (!e.md.validateLink(u)) return !1;
  if (!t) {
    e.pending = e.pending.slice(0, -a.length);
    const s = e.push("link_open", "a", 1);
    s.attrs = [["href", u]], s.markup = "linkify", s.info = "auto";
    const f = e.push("text", "", 0);
    f.content = e.md.normalizeLinkText(c);
    const d = e.push("link_close", "a", -1);
    d.markup = "linkify", d.info = "auto";
  }
  return e.pos += c.length - a.length, !0;
}
function oZ(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 10)
    return !1;
  const r = e.pending.length - 1, i = e.posMax;
  if (!t)
    if (r >= 0 && e.pending.charCodeAt(r) === 32)
      if (r >= 1 && e.pending.charCodeAt(r - 1) === 32) {
        let a = r - 1;
        for (; a >= 1 && e.pending.charCodeAt(a - 1) === 32; ) a--;
        e.pending = e.pending.slice(0, a), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (n++; n < i && Vn(e.src.charCodeAt(n)); )
    n++;
  return e.pos = n, !0;
}
const hg = [];
for (let e = 0; e < 256; e++)
  hg.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  hg[e.charCodeAt(0)] = 1;
});
function sZ(e, t) {
  let n = e.pos;
  const r = e.posMax;
  if (e.src.charCodeAt(n) !== 92 || (n++, n >= r)) return !1;
  let i = e.src.charCodeAt(n);
  if (i === 10) {
    for (t || e.push("hardbreak", "br", 0), n++; n < r && (i = e.src.charCodeAt(n), !!Vn(i)); )
      n++;
    return e.pos = n, !0;
  }
  let a = e.src[n];
  if (i >= 55296 && i <= 56319 && n + 1 < r) {
    const c = e.src.charCodeAt(n + 1);
    c >= 56320 && c <= 57343 && (a += e.src[n + 1], n++);
  }
  const o = "\\" + a;
  if (!t) {
    const c = e.push("text_special", "", 0);
    i < 256 && hg[i] !== 0 ? c.content = a : c.content = o, c.markup = o, c.info = "escape";
  }
  return e.pos = n + 1, !0;
}
function uZ(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 96)
    return !1;
  const i = n;
  n++;
  const a = e.posMax;
  for (; n < a && e.src.charCodeAt(n) === 96; )
    n++;
  const o = e.src.slice(i, n), c = o.length;
  if (e.backticksScanned && (e.backticks[c] || 0) <= i)
    return t || (e.pending += o), e.pos += c, !0;
  let u = n, s;
  for (; (s = e.src.indexOf("`", u)) !== -1; ) {
    for (u = s + 1; u < a && e.src.charCodeAt(u) === 96; )
      u++;
    const f = u - s;
    if (f === c) {
      if (!t) {
        const d = e.push("code_inline", "code", 0);
        d.markup = o, d.content = e.src.slice(n, s).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return e.pos = u, !0;
    }
    e.backticks[f] = s;
  }
  return e.backticksScanned = !0, t || (e.pending += o), e.pos += c, !0;
}
function cZ(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 126)
    return !1;
  const i = e.scanDelims(e.pos, !0);
  let a = i.length;
  const o = String.fromCharCode(r);
  if (a < 2)
    return !1;
  let c;
  a % 2 && (c = e.push("text", "", 0), c.content = o, a--);
  for (let u = 0; u < a; u += 2)
    c = e.push("text", "", 0), c.content = o + o, e.delimiters.push({
      marker: r,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: i.can_open,
      close: i.can_close
    });
  return e.pos += i.length, !0;
}
function G7(e, t) {
  let n;
  const r = [], i = t.length;
  for (let a = 0; a < i; a++) {
    const o = t[a];
    if (o.marker !== 126 || o.end === -1)
      continue;
    const c = t[o.end];
    n = e.tokens[o.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = e.tokens[c.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", e.tokens[c.token - 1].type === "text" && e.tokens[c.token - 1].content === "~" && r.push(c.token - 1);
  }
  for (; r.length; ) {
    const a = r.pop();
    let o = a + 1;
    for (; o < e.tokens.length && e.tokens[o].type === "s_close"; )
      o++;
    o--, a !== o && (n = e.tokens[o], e.tokens[o] = e.tokens[a], e.tokens[a] = n);
  }
}
function lZ(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  G7(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && G7(e, t[r].delimiters);
}
const YE = {
  tokenize: cZ,
  postProcess: lZ
};
function fZ(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 95 && r !== 42)
    return !1;
  const i = e.scanDelims(e.pos, r === 42);
  for (let a = 0; a < i.length; a++) {
    const o = e.push("text", "", 0);
    o.content = String.fromCharCode(r), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: r,
      // Total length of these series of delimiters.
      //
      length: i.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: i.can_open,
      close: i.can_close
    });
  }
  return e.pos += i.length, !0;
}
function V7(e, t) {
  const n = t.length;
  for (let r = n - 1; r >= 0; r--) {
    const i = t[r];
    if (i.marker !== 95 && i.marker !== 42 || i.end === -1)
      continue;
    const a = t[i.end], o = r > 0 && t[r - 1].end === i.end + 1 && // check that first two markers match and adjacent
    t[r - 1].marker === i.marker && t[r - 1].token === i.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[i.end + 1].token === a.token + 1, c = String.fromCharCode(i.marker), u = e.tokens[i.token];
    u.type = o ? "strong_open" : "em_open", u.tag = o ? "strong" : "em", u.nesting = 1, u.markup = o ? c + c : c, u.content = "";
    const s = e.tokens[a.token];
    s.type = o ? "strong_close" : "em_close", s.tag = o ? "strong" : "em", s.nesting = -1, s.markup = o ? c + c : c, s.content = "", o && (e.tokens[t[r - 1].token].content = "", e.tokens[t[i.end + 1].token].content = "", r--);
  }
}
function pZ(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  V7(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && V7(e, t[r].delimiters);
}
const JE = {
  tokenize: fZ,
  postProcess: pZ
};
function dZ(e, t) {
  let n, r, i, a, o = "", c = "", u = e.pos, s = !0;
  if (e.src.charCodeAt(e.pos) !== 91)
    return !1;
  const f = e.pos, d = e.posMax, l = e.pos + 1, p = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (p < 0)
    return !1;
  let g = p + 1;
  if (g < d && e.src.charCodeAt(g) === 40) {
    for (s = !1, g++; g < d && (n = e.src.charCodeAt(g), !(!Vn(n) && n !== 10)); g++)
      ;
    if (g >= d)
      return !1;
    if (u = g, i = e.md.helpers.parseLinkDestination(e.src, g, e.posMax), i.ok) {
      for (o = e.md.normalizeLink(i.str), e.md.validateLink(o) ? g = i.pos : o = "", u = g; g < d && (n = e.src.charCodeAt(g), !(!Vn(n) && n !== 10)); g++)
        ;
      if (i = e.md.helpers.parseLinkTitle(e.src, g, e.posMax), g < d && u !== g && i.ok)
        for (c = i.str, g = i.pos; g < d && (n = e.src.charCodeAt(g), !(!Vn(n) && n !== 10)); g++)
          ;
    }
    (g >= d || e.src.charCodeAt(g) !== 41) && (s = !0), g++;
  }
  if (s) {
    if (typeof e.env.references > "u")
      return !1;
    if (g < d && e.src.charCodeAt(g) === 91 ? (u = g + 1, g = e.md.helpers.parseLinkLabel(e, g), g >= 0 ? r = e.src.slice(u, g++) : g = p + 1) : g = p + 1, r || (r = e.src.slice(l, p)), a = e.env.references[X0(r)], !a)
      return e.pos = f, !1;
    o = a.href, c = a.title;
  }
  if (!t) {
    e.pos = l, e.posMax = p;
    const v = e.push("link_open", "a", 1), b = [["href", o]];
    v.attrs = b, c && b.push(["title", c]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
  }
  return e.pos = g, e.posMax = d, !0;
}
function hZ(e, t) {
  let n, r, i, a, o, c, u, s, f = "";
  const d = e.pos, l = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91)
    return !1;
  const p = e.pos + 2, g = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (g < 0)
    return !1;
  if (a = g + 1, a < l && e.src.charCodeAt(a) === 40) {
    for (a++; a < l && (n = e.src.charCodeAt(a), !(!Vn(n) && n !== 10)); a++)
      ;
    if (a >= l)
      return !1;
    for (s = a, c = e.md.helpers.parseLinkDestination(e.src, a, e.posMax), c.ok && (f = e.md.normalizeLink(c.str), e.md.validateLink(f) ? a = c.pos : f = ""), s = a; a < l && (n = e.src.charCodeAt(a), !(!Vn(n) && n !== 10)); a++)
      ;
    if (c = e.md.helpers.parseLinkTitle(e.src, a, e.posMax), a < l && s !== a && c.ok)
      for (u = c.str, a = c.pos; a < l && (n = e.src.charCodeAt(a), !(!Vn(n) && n !== 10)); a++)
        ;
    else
      u = "";
    if (a >= l || e.src.charCodeAt(a) !== 41)
      return e.pos = d, !1;
    a++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (a < l && e.src.charCodeAt(a) === 91 ? (s = a + 1, a = e.md.helpers.parseLinkLabel(e, a), a >= 0 ? i = e.src.slice(s, a++) : a = g + 1) : a = g + 1, i || (i = e.src.slice(p, g)), o = e.env.references[X0(i)], !o)
      return e.pos = d, !1;
    f = o.href, u = o.title;
  }
  if (!t) {
    r = e.src.slice(p, g);
    const v = [];
    e.md.inline.parse(
      r,
      e.md,
      e.env,
      v
    );
    const b = e.push("image", "img", 0), y = [["src", f], ["alt", ""]];
    b.attrs = y, b.children = v, b.content = r, u && y.push(["title", u]);
  }
  return e.pos = a, e.posMax = l, !0;
}
const mZ = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, gZ = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function vZ(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 60)
    return !1;
  const r = e.pos, i = e.posMax;
  for (; ; ) {
    if (++n >= i) return !1;
    const o = e.src.charCodeAt(n);
    if (o === 60) return !1;
    if (o === 62) break;
  }
  const a = e.src.slice(r + 1, n);
  if (gZ.test(a)) {
    const o = e.md.normalizeLink(a);
    if (!e.md.validateLink(o))
      return !1;
    if (!t) {
      const c = e.push("link_open", "a", 1);
      c.attrs = [["href", o]], c.markup = "autolink", c.info = "auto";
      const u = e.push("text", "", 0);
      u.content = e.md.normalizeLinkText(a);
      const s = e.push("link_close", "a", -1);
      s.markup = "autolink", s.info = "auto";
    }
    return e.pos += a.length + 2, !0;
  }
  if (mZ.test(a)) {
    const o = e.md.normalizeLink("mailto:" + a);
    if (!e.md.validateLink(o))
      return !1;
    if (!t) {
      const c = e.push("link_open", "a", 1);
      c.attrs = [["href", o]], c.markup = "autolink", c.info = "auto";
      const u = e.push("text", "", 0);
      u.content = e.md.normalizeLinkText(a);
      const s = e.push("link_close", "a", -1);
      s.markup = "autolink", s.info = "auto";
    }
    return e.pos += a.length + 2, !0;
  }
  return !1;
}
function yZ(e) {
  return /^<a[>\s]/i.test(e);
}
function bZ(e) {
  return /^<\/a\s*>/i.test(e);
}
function xZ(e) {
  const t = e | 32;
  return t >= 97 && t <= 122;
}
function _Z(e, t) {
  if (!e.md.options.html)
    return !1;
  const n = e.posMax, r = e.pos;
  if (e.src.charCodeAt(r) !== 60 || r + 2 >= n)
    return !1;
  const i = e.src.charCodeAt(r + 1);
  if (i !== 33 && i !== 63 && i !== 47 && !xZ(i))
    return !1;
  const a = e.src.slice(r).match(YK);
  if (!a)
    return !1;
  if (!t) {
    const o = e.push("html_inline", "", 0);
    o.content = a[0], yZ(o.content) && e.linkLevel++, bZ(o.content) && e.linkLevel--;
  }
  return e.pos += a[0].length, !0;
}
const wZ = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, SZ = /^&([a-z][a-z0-9]{1,31});/i;
function CZ(e, t) {
  const n = e.pos, r = e.posMax;
  if (e.src.charCodeAt(n) !== 38 || n + 1 >= r) return !1;
  if (e.src.charCodeAt(n + 1) === 35) {
    const a = e.src.slice(n).match(wZ);
    if (a) {
      if (!t) {
        const o = a[1][0].toLowerCase() === "x" ? parseInt(a[1].slice(1), 16) : parseInt(a[1], 10), c = e.push("text_special", "", 0);
        c.content = pg(o) ? S0(o) : S0(65533), c.markup = a[0], c.info = "entity";
      }
      return e.pos += a[0].length, !0;
    }
  } else {
    const a = e.src.slice(n).match(SZ);
    if (a) {
      const o = HE(a[0]);
      if (o !== a[0]) {
        if (!t) {
          const c = e.push("text_special", "", 0);
          c.content = o, c.markup = a[0], c.info = "entity";
        }
        return e.pos += a[0].length, !0;
      }
    }
  }
  return !1;
}
function W7(e) {
  const t = {}, n = e.length;
  if (!n) return;
  let r = 0, i = -2;
  const a = [];
  for (let o = 0; o < n; o++) {
    const c = e[o];
    if (a.push(0), (e[r].marker !== c.marker || i !== c.token - 1) && (r = o), i = c.token, c.length = c.length || 0, !c.close) continue;
    t.hasOwnProperty(c.marker) || (t[c.marker] = [-1, -1, -1, -1, -1, -1]);
    const u = t[c.marker][(c.open ? 3 : 0) + c.length % 3];
    let s = r - a[r] - 1, f = s;
    for (; s > u; s -= a[s] + 1) {
      const d = e[s];
      if (d.marker === c.marker && d.open && d.end < 0) {
        let l = !1;
        if ((d.close || c.open) && (d.length + c.length) % 3 === 0 && (d.length % 3 !== 0 || c.length % 3 !== 0) && (l = !0), !l) {
          const p = s > 0 && !e[s - 1].open ? a[s - 1] + 1 : 0;
          a[o] = o - s + p, a[s] = p, c.open = !1, d.end = o, d.close = !1, f = -1, i = -2;
          break;
        }
      }
    }
    f !== -1 && (t[c.marker][(c.open ? 3 : 0) + (c.length || 0) % 3] = f);
  }
}
function AZ(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  W7(e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && W7(t[r].delimiters);
}
function kZ(e) {
  let t, n, r = 0;
  const i = e.tokens, a = e.tokens.length;
  for (t = n = 0; t < a; t++)
    i[t].nesting < 0 && r--, i[t].level = r, i[t].nesting > 0 && r++, i[t].type === "text" && t + 1 < a && i[t + 1].type === "text" ? i[t + 1].content = i[t].content + i[t + 1].content : (t !== n && (i[n] = i[t]), n++);
  t !== n && (i.length = n);
}
const Wm = [
  ["text", nZ],
  ["linkify", aZ],
  ["newline", oZ],
  ["escape", sZ],
  ["backticks", uZ],
  ["strikethrough", YE.tokenize],
  ["emphasis", JE.tokenize],
  ["link", dZ],
  ["image", hZ],
  ["autolink", vZ],
  ["html_inline", _Z],
  ["entity", CZ]
], Km = [
  ["balance_pairs", AZ],
  ["strikethrough", YE.postProcess],
  ["emphasis", JE.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", kZ]
];
function np() {
  this.ruler = new ta();
  for (let e = 0; e < Wm.length; e++)
    this.ruler.push(Wm[e][0], Wm[e][1]);
  this.ruler2 = new ta();
  for (let e = 0; e < Km.length; e++)
    this.ruler2.push(Km[e][0], Km[e][1]);
}
np.prototype.skipToken = function(e) {
  const t = e.pos, n = this.ruler.getRules(""), r = n.length, i = e.md.options.maxNesting, a = e.cache;
  if (typeof a[t] < "u") {
    e.pos = a[t];
    return;
  }
  let o = !1;
  if (e.level < i) {
    for (let c = 0; c < r; c++)
      if (e.level++, o = n[c](e, !0), e.level--, o) {
        if (t >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  o || e.pos++, a[t] = e.pos;
};
np.prototype.tokenize = function(e) {
  const t = this.ruler.getRules(""), n = t.length, r = e.posMax, i = e.md.options.maxNesting;
  for (; e.pos < r; ) {
    const a = e.pos;
    let o = !1;
    if (e.level < i) {
      for (let c = 0; c < n; c++)
        if (o = t[c](e, !1), o) {
          if (a >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (o) {
      if (e.pos >= r)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
np.prototype.parse = function(e, t, n, r) {
  const i = new this.State(e, t, n, r);
  this.tokenize(i);
  const a = this.ruler2.getRules(""), o = a.length;
  for (let c = 0; c < o; c++)
    a[c](i);
};
np.prototype.State = rp;
function EZ(e) {
  const t = {};
  e = e || {}, t.src_Any = $E.source, t.src_Cc = ME.source, t.src_Z = BE.source, t.src_P = lg.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
  const n = "[><｜]";
  return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
}
function t2(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    n && Object.keys(n).forEach(function(r) {
      e[r] = n[r];
    });
  }), e;
}
function t1(e) {
  return Object.prototype.toString.call(e);
}
function OZ(e) {
  return t1(e) === "[object String]";
}
function TZ(e) {
  return t1(e) === "[object Object]";
}
function PZ(e) {
  return t1(e) === "[object RegExp]";
}
function K7(e) {
  return t1(e) === "[object Function]";
}
function RZ(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const QE = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function jZ(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t || QE.hasOwnProperty(n);
  }, !1);
}
const IZ = {
  "http:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(r) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : r.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
    }
  }
}, qZ = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", DZ = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function LZ(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function NZ(e) {
  return function(t, n) {
    const r = t.slice(n);
    return e.test(r) ? r.match(e)[0].length : 0;
  };
}
function Z7() {
  return function(e, t) {
    t.normalize(e);
  };
}
function C0(e) {
  const t = e.re = EZ(e.__opts__), n = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || n.push(qZ), n.push(t.src_xn), t.src_tlds = n.join("|");
  function r(c) {
    return c.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), "i");
  const i = [];
  e.__compiled__ = {};
  function a(c, u) {
    throw new Error('(LinkifyIt) Invalid schema "' + c + '": ' + u);
  }
  Object.keys(e.__schemas__).forEach(function(c) {
    const u = e.__schemas__[c];
    if (u === null)
      return;
    const s = { validate: null, link: null };
    if (e.__compiled__[c] = s, TZ(u)) {
      PZ(u.validate) ? s.validate = NZ(u.validate) : K7(u.validate) ? s.validate = u.validate : a(c, u), K7(u.normalize) ? s.normalize = u.normalize : u.normalize ? a(c, u) : s.normalize = Z7();
      return;
    }
    if (OZ(u)) {
      i.push(c);
      return;
    }
    a(c, u);
  }), i.forEach(function(c) {
    e.__compiled__[e.__schemas__[c]] && (e.__compiled__[c].validate = e.__compiled__[e.__schemas__[c]].validate, e.__compiled__[c].normalize = e.__compiled__[e.__schemas__[c]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: Z7() };
  const o = Object.keys(e.__compiled__).filter(function(c) {
    return c.length > 0 && e.__compiled__[c];
  }).map(RZ).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + o + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + o + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), LZ(e);
}
function $Z(e, t) {
  const n = e.__index__, r = e.__last_index__, i = e.__text_cache__.slice(n, r);
  this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = r + t, this.raw = i, this.text = i, this.url = i;
}
function r2(e, t) {
  const n = new $Z(e, t);
  return e.__compiled__[n.schema].normalize(n, e), n;
}
function da(e, t) {
  if (!(this instanceof da))
    return new da(e, t);
  t || jZ(e) && (t = e, e = {}), this.__opts__ = t2({}, QE, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = t2({}, IZ, e), this.__compiled__ = {}, this.__tlds__ = DZ, this.__tlds_replaced__ = !1, this.re = {}, C0(this);
}
da.prototype.add = function(t, n) {
  return this.__schemas__[t] = n, C0(this), this;
};
da.prototype.set = function(t) {
  return this.__opts__ = t2(this.__opts__, t), this;
};
da.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  let n, r, i, a, o, c, u, s, f;
  if (this.re.schema_test.test(t)) {
    for (u = this.re.schema_search, u.lastIndex = 0; (n = u.exec(t)) !== null; )
      if (a = this.testSchemaAt(t, n[2], u.lastIndex), a) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + a;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (s = t.search(this.re.host_fuzzy_test), s >= 0 && (this.__index__ < 0 || s < this.__index__) && (r = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (o = r.index + r[1].length, (this.__index__ < 0 || o < this.__index__) && (this.__schema__ = "", this.__index__ = o, this.__last_index__ = r.index + r[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (f = t.indexOf("@"), f >= 0 && (i = t.match(this.re.email_fuzzy)) !== null && (o = i.index + i[1].length, c = i.index + i[0].length, (this.__index__ < 0 || o < this.__index__ || o === this.__index__ && c > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = o, this.__last_index__ = c))), this.__index__ >= 0;
};
da.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
da.prototype.testSchemaAt = function(t, n, r) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(t, r, this) : 0;
};
da.prototype.match = function(t) {
  const n = [];
  let r = 0;
  this.__index__ >= 0 && this.__text_cache__ === t && (n.push(r2(this, r)), r = this.__last_index__);
  let i = r ? t.slice(r) : t;
  for (; this.test(i); )
    n.push(r2(this, r)), i = i.slice(this.__last_index__), r += this.__last_index__;
  return n.length ? n : null;
};
da.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
  const n = this.re.schema_at_start.exec(t);
  if (!n) return null;
  const r = this.testSchemaAt(t, n[2], n[0].length);
  return r ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + r, r2(this, 0)) : null;
};
da.prototype.tlds = function(t, n) {
  return t = Array.isArray(t) ? t : [t], n ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(r, i, a) {
    return r !== a[i - 1];
  }).reverse(), C0(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, C0(this), this);
};
da.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
da.prototype.onCompile = function() {
};
const ic = 2147483647, bo = 36, mg = 1, If = 26, MZ = 38, FZ = 700, XE = 72, eO = 128, tO = "-", BZ = /^xn--/, UZ = /[^\0-\x7F]/, HZ = /[\x2E\u3002\uFF0E\uFF61]/g, zZ = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, Zm = bo - mg, xo = Math.floor, Ym = String.fromCharCode;
function gs(e) {
  throw new RangeError(zZ[e]);
}
function GZ(e, t) {
  const n = [];
  let r = e.length;
  for (; r--; )
    n[r] = t(e[r]);
  return n;
}
function rO(e, t) {
  const n = e.split("@");
  let r = "";
  n.length > 1 && (r = n[0] + "@", e = n[1]), e = e.replace(HZ, ".");
  const i = e.split("."), a = GZ(i, t).join(".");
  return r + a;
}
function nO(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const a = e.charCodeAt(n++);
      (a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
const VZ = (e) => String.fromCodePoint(...e), WZ = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : bo;
}, Y7 = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, iO = function(e, t, n) {
  let r = 0;
  for (e = n ? xo(e / FZ) : e >> 1, e += xo(e / t); e > Zm * If >> 1; r += bo)
    e = xo(e / Zm);
  return xo(r + (Zm + 1) * e / (e + MZ));
}, aO = function(e) {
  const t = [], n = e.length;
  let r = 0, i = eO, a = XE, o = e.lastIndexOf(tO);
  o < 0 && (o = 0);
  for (let c = 0; c < o; ++c)
    e.charCodeAt(c) >= 128 && gs("not-basic"), t.push(e.charCodeAt(c));
  for (let c = o > 0 ? o + 1 : 0; c < n; ) {
    const u = r;
    for (let f = 1, d = bo; ; d += bo) {
      c >= n && gs("invalid-input");
      const l = WZ(e.charCodeAt(c++));
      l >= bo && gs("invalid-input"), l > xo((ic - r) / f) && gs("overflow"), r += l * f;
      const p = d <= a ? mg : d >= a + If ? If : d - a;
      if (l < p)
        break;
      const g = bo - p;
      f > xo(ic / g) && gs("overflow"), f *= g;
    }
    const s = t.length + 1;
    a = iO(r - u, s, u == 0), xo(r / s) > ic - i && gs("overflow"), i += xo(r / s), r %= s, t.splice(r++, 0, i);
  }
  return String.fromCodePoint(...t);
}, oO = function(e) {
  const t = [];
  e = nO(e);
  const n = e.length;
  let r = eO, i = 0, a = XE;
  for (const u of e)
    u < 128 && t.push(Ym(u));
  const o = t.length;
  let c = o;
  for (o && t.push(tO); c < n; ) {
    let u = ic;
    for (const f of e)
      f >= r && f < u && (u = f);
    const s = c + 1;
    u - r > xo((ic - i) / s) && gs("overflow"), i += (u - r) * s, r = u;
    for (const f of e)
      if (f < r && ++i > ic && gs("overflow"), f === r) {
        let d = i;
        for (let l = bo; ; l += bo) {
          const p = l <= a ? mg : l >= a + If ? If : l - a;
          if (d < p)
            break;
          const g = d - p, v = bo - p;
          t.push(
            Ym(Y7(p + g % v, 0))
          ), d = xo(g / v);
        }
        t.push(Ym(Y7(d, 0))), a = iO(i, s, c === o), i = 0, ++c;
      }
    ++i, ++r;
  }
  return t.join("");
}, KZ = function(e) {
  return rO(e, function(t) {
    return BZ.test(t) ? aO(t.slice(4).toLowerCase()) : t;
  });
}, ZZ = function(e) {
  return rO(e, function(t) {
    return UZ.test(t) ? "xn--" + oO(t) : t;
  });
}, sO = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: nO,
    encode: VZ
  },
  decode: aO,
  encode: oO,
  toASCII: ZZ,
  toUnicode: KZ
}, YZ = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, JZ = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, QZ = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, XZ = {
  default: YZ,
  zero: JZ,
  commonmark: QZ
}, eY = /^(vbscript|javascript|file|data):/, tY = /^data:image\/(gif|png|jpeg|webp);/;
function rY(e) {
  const t = e.trim().toLowerCase();
  return eY.test(t) ? tY.test(t) : !0;
}
const uO = ["http:", "https:", "mailto:"];
function nY(e) {
  const t = cg(e, !0);
  if (t.hostname && (!t.protocol || uO.indexOf(t.protocol) >= 0))
    try {
      t.hostname = sO.toASCII(t.hostname);
    } catch {
    }
  return tp(ug(t));
}
function iY(e) {
  const t = cg(e, !0);
  if (t.hostname && (!t.protocol || uO.indexOf(t.protocol) >= 0))
    try {
      t.hostname = sO.toUnicode(t.hostname);
    } catch {
    }
  return mc(ug(t), mc.defaultChars + "%");
}
function ja(e, t) {
  if (!(this instanceof ja))
    return new ja(e, t);
  t || fg(e) || (t = e || {}, e = "default"), this.inline = new np(), this.block = new e1(), this.core = new dg(), this.renderer = new Pc(), this.linkify = new da(), this.validateLink = rY, this.normalizeLink = nY, this.normalizeLinkText = iY, this.utils = oK, this.helpers = Q0({}, lK), this.options = {}, this.configure(e), t && this.set(t);
}
ja.prototype.set = function(e) {
  return Q0(this.options, e), this;
};
ja.prototype.configure = function(e) {
  const t = this;
  if (fg(e)) {
    const n = e;
    if (e = XZ[n], !e)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(n) {
    e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules), e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2);
  }), this;
};
ja.prototype.enable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.enable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
  const r = e.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
  return this;
};
ja.prototype.disable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.disable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
  const r = e.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
  return this;
};
ja.prototype.use = function(e) {
  const t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
ja.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(e, this, t);
  return this.core.process(n), n.tokens;
};
ja.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
ja.prototype.parseInline = function(e, t) {
  const n = new this.core.State(e, this, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
ja.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
var Ga = {}, Va = {}, Jm = {}, Wa = {}, Od = {}, J7;
function aY() {
  return J7 || (J7 = 1, Object.defineProperty(Od, "__esModule", { value: !0 }), Od.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), Od;
}
var Td = {}, Q7;
function oY() {
  return Q7 || (Q7 = 1, Object.defineProperty(Td, "__esModule", { value: !0 }), Td.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
      return e.charCodeAt(0);
    })
  )), Td;
}
var Qm = {}, X7;
function e9() {
  return X7 || (X7 = 1, function(e) {
    var t;
    Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
    var n = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (t = String.fromCodePoint) !== null && t !== void 0 ? t : function(a) {
      var o = "";
      return a > 65535 && (a -= 65536, o += String.fromCharCode(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), o += String.fromCharCode(a), o;
    };
    function r(a) {
      var o;
      return a >= 55296 && a <= 57343 || a > 1114111 ? 65533 : (o = n.get(a)) !== null && o !== void 0 ? o : a;
    }
    e.replaceCodePoint = r;
    function i(a) {
      return (0, e.fromCodePoint)(r(a));
    }
    e.default = i;
  }(Qm)), Qm;
}
var t9;
function A0() {
  return t9 || (t9 = 1, function(e) {
    var t = Wa && Wa.__createBinding || (Object.create ? function(ee, K, re, de) {
      de === void 0 && (de = re);
      var ie = Object.getOwnPropertyDescriptor(K, re);
      (!ie || ("get" in ie ? !K.__esModule : ie.writable || ie.configurable)) && (ie = { enumerable: !0, get: function() {
        return K[re];
      } }), Object.defineProperty(ee, de, ie);
    } : function(ee, K, re, de) {
      de === void 0 && (de = re), ee[de] = K[re];
    }), n = Wa && Wa.__setModuleDefault || (Object.create ? function(ee, K) {
      Object.defineProperty(ee, "default", { enumerable: !0, value: K });
    } : function(ee, K) {
      ee.default = K;
    }), r = Wa && Wa.__importStar || function(ee) {
      if (ee && ee.__esModule) return ee;
      var K = {};
      if (ee != null) for (var re in ee) re !== "default" && Object.prototype.hasOwnProperty.call(ee, re) && t(K, ee, re);
      return n(K, ee), K;
    }, i = Wa && Wa.__importDefault || function(ee) {
      return ee && ee.__esModule ? ee : { default: ee };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
    var a = i(/* @__PURE__ */ aY());
    e.htmlDecodeTree = a.default;
    var o = i(/* @__PURE__ */ oY());
    e.xmlDecodeTree = o.default;
    var c = r(/* @__PURE__ */ e9());
    e.decodeCodePoint = c.default;
    var u = /* @__PURE__ */ e9();
    Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
      return u.replaceCodePoint;
    } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
      return u.fromCodePoint;
    } });
    var s;
    (function(ee) {
      ee[ee.NUM = 35] = "NUM", ee[ee.SEMI = 59] = "SEMI", ee[ee.EQUALS = 61] = "EQUALS", ee[ee.ZERO = 48] = "ZERO", ee[ee.NINE = 57] = "NINE", ee[ee.LOWER_A = 97] = "LOWER_A", ee[ee.LOWER_F = 102] = "LOWER_F", ee[ee.LOWER_X = 120] = "LOWER_X", ee[ee.LOWER_Z = 122] = "LOWER_Z", ee[ee.UPPER_A = 65] = "UPPER_A", ee[ee.UPPER_F = 70] = "UPPER_F", ee[ee.UPPER_Z = 90] = "UPPER_Z";
    })(s || (s = {}));
    var f = 32, d;
    (function(ee) {
      ee[ee.VALUE_LENGTH = 49152] = "VALUE_LENGTH", ee[ee.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", ee[ee.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(d = e.BinTrieFlags || (e.BinTrieFlags = {}));
    function l(ee) {
      return ee >= s.ZERO && ee <= s.NINE;
    }
    function p(ee) {
      return ee >= s.UPPER_A && ee <= s.UPPER_F || ee >= s.LOWER_A && ee <= s.LOWER_F;
    }
    function g(ee) {
      return ee >= s.UPPER_A && ee <= s.UPPER_Z || ee >= s.LOWER_A && ee <= s.LOWER_Z || l(ee);
    }
    function v(ee) {
      return ee === s.EQUALS || g(ee);
    }
    var b;
    (function(ee) {
      ee[ee.EntityStart = 0] = "EntityStart", ee[ee.NumericStart = 1] = "NumericStart", ee[ee.NumericDecimal = 2] = "NumericDecimal", ee[ee.NumericHex = 3] = "NumericHex", ee[ee.NamedEntity = 4] = "NamedEntity";
    })(b || (b = {}));
    var y;
    (function(ee) {
      ee[ee.Legacy = 0] = "Legacy", ee[ee.Strict = 1] = "Strict", ee[ee.Attribute = 2] = "Attribute";
    })(y = e.DecodingMode || (e.DecodingMode = {}));
    var w = (
      /** @class */
      function() {
        function ee(K, re, de) {
          this.decodeTree = K, this.emitCodePoint = re, this.errors = de, this.state = b.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = y.Strict;
        }
        return ee.prototype.startEntity = function(K) {
          this.decodeMode = K, this.state = b.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }, ee.prototype.write = function(K, re) {
          switch (this.state) {
            case b.EntityStart:
              return K.charCodeAt(re) === s.NUM ? (this.state = b.NumericStart, this.consumed += 1, this.stateNumericStart(K, re + 1)) : (this.state = b.NamedEntity, this.stateNamedEntity(K, re));
            case b.NumericStart:
              return this.stateNumericStart(K, re);
            case b.NumericDecimal:
              return this.stateNumericDecimal(K, re);
            case b.NumericHex:
              return this.stateNumericHex(K, re);
            case b.NamedEntity:
              return this.stateNamedEntity(K, re);
          }
        }, ee.prototype.stateNumericStart = function(K, re) {
          return re >= K.length ? -1 : (K.charCodeAt(re) | f) === s.LOWER_X ? (this.state = b.NumericHex, this.consumed += 1, this.stateNumericHex(K, re + 1)) : (this.state = b.NumericDecimal, this.stateNumericDecimal(K, re));
        }, ee.prototype.addToNumericResult = function(K, re, de, ie) {
          if (re !== de) {
            var me = de - re;
            this.result = this.result * Math.pow(ie, me) + parseInt(K.substr(re, me), ie), this.consumed += me;
          }
        }, ee.prototype.stateNumericHex = function(K, re) {
          for (var de = re; re < K.length; ) {
            var ie = K.charCodeAt(re);
            if (l(ie) || p(ie))
              re += 1;
            else
              return this.addToNumericResult(K, de, re, 16), this.emitNumericEntity(ie, 3);
          }
          return this.addToNumericResult(K, de, re, 16), -1;
        }, ee.prototype.stateNumericDecimal = function(K, re) {
          for (var de = re; re < K.length; ) {
            var ie = K.charCodeAt(re);
            if (l(ie))
              re += 1;
            else
              return this.addToNumericResult(K, de, re, 10), this.emitNumericEntity(ie, 2);
          }
          return this.addToNumericResult(K, de, re, 10), -1;
        }, ee.prototype.emitNumericEntity = function(K, re) {
          var de;
          if (this.consumed <= re)
            return (de = this.errors) === null || de === void 0 || de.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          if (K === s.SEMI)
            this.consumed += 1;
          else if (this.decodeMode === y.Strict)
            return 0;
          return this.emitCodePoint((0, c.replaceCodePoint)(this.result), this.consumed), this.errors && (K !== s.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }, ee.prototype.stateNamedEntity = function(K, re) {
          for (var de = this.decodeTree, ie = de[this.treeIndex], me = (ie & d.VALUE_LENGTH) >> 14; re < K.length; re++, this.excess++) {
            var $e = K.charCodeAt(re);
            if (this.treeIndex = T(de, ie, this.treeIndex + Math.max(1, me), $e), this.treeIndex < 0)
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === y.Attribute && // We shouldn't have consumed any characters after the entity,
              (me === 0 || // And there should be no invalid characters.
              v($e)) ? 0 : this.emitNotTerminatedNamedEntity();
            if (ie = de[this.treeIndex], me = (ie & d.VALUE_LENGTH) >> 14, me !== 0) {
              if ($e === s.SEMI)
                return this.emitNamedEntityData(this.treeIndex, me, this.consumed + this.excess);
              this.decodeMode !== y.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
            }
          }
          return -1;
        }, ee.prototype.emitNotTerminatedNamedEntity = function() {
          var K, re = this, de = re.result, ie = re.decodeTree, me = (ie[de] & d.VALUE_LENGTH) >> 14;
          return this.emitNamedEntityData(de, me, this.consumed), (K = this.errors) === null || K === void 0 || K.missingSemicolonAfterCharacterReference(), this.consumed;
        }, ee.prototype.emitNamedEntityData = function(K, re, de) {
          var ie = this.decodeTree;
          return this.emitCodePoint(re === 1 ? ie[K] & ~d.VALUE_LENGTH : ie[K + 1], de), re === 3 && this.emitCodePoint(ie[K + 2], de), de;
        }, ee.prototype.end = function() {
          var K;
          switch (this.state) {
            case b.NamedEntity:
              return this.result !== 0 && (this.decodeMode !== y.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case b.NumericDecimal:
              return this.emitNumericEntity(0, 2);
            case b.NumericHex:
              return this.emitNumericEntity(0, 3);
            case b.NumericStart:
              return (K = this.errors) === null || K === void 0 || K.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            case b.EntityStart:
              return 0;
          }
        }, ee;
      }()
    );
    e.EntityDecoder = w;
    function C(ee) {
      var K = "", re = new w(ee, function(de) {
        return K += (0, c.fromCodePoint)(de);
      });
      return function(ie, me) {
        for (var $e = 0, Pe = 0; (Pe = ie.indexOf("&", Pe)) >= 0; ) {
          K += ie.slice($e, Pe), re.startEntity(me);
          var Le = re.write(
            ie,
            // Skip the "&"
            Pe + 1
          );
          if (Le < 0) {
            $e = Pe + re.end();
            break;
          }
          $e = Pe + Le, Pe = Le === 0 ? $e + 1 : $e;
        }
        var Ae = K + ie.slice($e);
        return K = "", Ae;
      };
    }
    function T(ee, K, re, de) {
      var ie = (K & d.BRANCH_LENGTH) >> 7, me = K & d.JUMP_TABLE;
      if (ie === 0)
        return me !== 0 && de === me ? re : -1;
      if (me) {
        var $e = de - me;
        return $e < 0 || $e >= ie ? -1 : ee[re + $e] - 1;
      }
      for (var Pe = re, Le = Pe + ie - 1; Pe <= Le; ) {
        var Ae = Pe + Le >>> 1, He = ee[Ae];
        if (He < de)
          Pe = Ae + 1;
        else if (He > de)
          Le = Ae - 1;
        else
          return ee[Ae + ie];
      }
      return -1;
    }
    e.determineBranch = T;
    var E = C(a.default), D = C(o.default);
    function $(ee, K) {
      return K === void 0 && (K = y.Legacy), E(ee, K);
    }
    e.decodeHTML = $;
    function Z(ee) {
      return E(ee, y.Attribute);
    }
    e.decodeHTMLAttribute = Z;
    function te(ee) {
      return E(ee, y.Strict);
    }
    e.decodeHTMLStrict = te;
    function se(ee) {
      return D(ee, y.Strict);
    }
    e.decodeXML = se;
  }(Wa)), Wa;
}
var r9;
function cO() {
  return r9 || (r9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.QuoteType = void 0;
    var t = /* @__PURE__ */ A0(), n;
    (function(l) {
      l[l.Tab = 9] = "Tab", l[l.NewLine = 10] = "NewLine", l[l.FormFeed = 12] = "FormFeed", l[l.CarriageReturn = 13] = "CarriageReturn", l[l.Space = 32] = "Space", l[l.ExclamationMark = 33] = "ExclamationMark", l[l.Number = 35] = "Number", l[l.Amp = 38] = "Amp", l[l.SingleQuote = 39] = "SingleQuote", l[l.DoubleQuote = 34] = "DoubleQuote", l[l.Dash = 45] = "Dash", l[l.Slash = 47] = "Slash", l[l.Zero = 48] = "Zero", l[l.Nine = 57] = "Nine", l[l.Semi = 59] = "Semi", l[l.Lt = 60] = "Lt", l[l.Eq = 61] = "Eq", l[l.Gt = 62] = "Gt", l[l.Questionmark = 63] = "Questionmark", l[l.UpperA = 65] = "UpperA", l[l.LowerA = 97] = "LowerA", l[l.UpperF = 70] = "UpperF", l[l.LowerF = 102] = "LowerF", l[l.UpperZ = 90] = "UpperZ", l[l.LowerZ = 122] = "LowerZ", l[l.LowerX = 120] = "LowerX", l[l.OpeningSquareBracket = 91] = "OpeningSquareBracket";
    })(n || (n = {}));
    var r;
    (function(l) {
      l[l.Text = 1] = "Text", l[l.BeforeTagName = 2] = "BeforeTagName", l[l.InTagName = 3] = "InTagName", l[l.InSelfClosingTag = 4] = "InSelfClosingTag", l[l.BeforeClosingTagName = 5] = "BeforeClosingTagName", l[l.InClosingTagName = 6] = "InClosingTagName", l[l.AfterClosingTagName = 7] = "AfterClosingTagName", l[l.BeforeAttributeName = 8] = "BeforeAttributeName", l[l.InAttributeName = 9] = "InAttributeName", l[l.AfterAttributeName = 10] = "AfterAttributeName", l[l.BeforeAttributeValue = 11] = "BeforeAttributeValue", l[l.InAttributeValueDq = 12] = "InAttributeValueDq", l[l.InAttributeValueSq = 13] = "InAttributeValueSq", l[l.InAttributeValueNq = 14] = "InAttributeValueNq", l[l.BeforeDeclaration = 15] = "BeforeDeclaration", l[l.InDeclaration = 16] = "InDeclaration", l[l.InProcessingInstruction = 17] = "InProcessingInstruction", l[l.BeforeComment = 18] = "BeforeComment", l[l.CDATASequence = 19] = "CDATASequence", l[l.InSpecialComment = 20] = "InSpecialComment", l[l.InCommentLike = 21] = "InCommentLike", l[l.BeforeSpecialS = 22] = "BeforeSpecialS", l[l.SpecialStartSequence = 23] = "SpecialStartSequence", l[l.InSpecialTag = 24] = "InSpecialTag", l[l.BeforeEntity = 25] = "BeforeEntity", l[l.BeforeNumericEntity = 26] = "BeforeNumericEntity", l[l.InNamedEntity = 27] = "InNamedEntity", l[l.InNumericEntity = 28] = "InNumericEntity", l[l.InHexEntity = 29] = "InHexEntity";
    })(r || (r = {}));
    function i(l) {
      return l === n.Space || l === n.NewLine || l === n.Tab || l === n.FormFeed || l === n.CarriageReturn;
    }
    function a(l) {
      return l === n.Slash || l === n.Gt || i(l);
    }
    function o(l) {
      return l >= n.Zero && l <= n.Nine;
    }
    function c(l) {
      return l >= n.LowerA && l <= n.LowerZ || l >= n.UpperA && l <= n.UpperZ;
    }
    function u(l) {
      return l >= n.UpperA && l <= n.UpperF || l >= n.LowerA && l <= n.LowerF;
    }
    var s;
    (function(l) {
      l[l.NoValue = 0] = "NoValue", l[l.Unquoted = 1] = "Unquoted", l[l.Single = 2] = "Single", l[l.Double = 3] = "Double";
    })(s = e.QuoteType || (e.QuoteType = {}));
    var f = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    }, d = (
      /** @class */
      function() {
        function l(p, g) {
          var v = p.xmlMode, b = v === void 0 ? !1 : v, y = p.decodeEntities, w = y === void 0 ? !0 : y;
          this.cbs = g, this.state = r.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = r.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = b, this.decodeEntities = w, this.entityTrie = b ? t.xmlDecodeTree : t.htmlDecodeTree;
        }
        return l.prototype.reset = function() {
          this.state = r.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = r.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
        }, l.prototype.write = function(p) {
          this.offset += this.buffer.length, this.buffer = p, this.parse();
        }, l.prototype.end = function() {
          this.running && this.finish();
        }, l.prototype.pause = function() {
          this.running = !1;
        }, l.prototype.resume = function() {
          this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
        }, l.prototype.getIndex = function() {
          return this.index;
        }, l.prototype.getSectionStart = function() {
          return this.sectionStart;
        }, l.prototype.stateText = function(p) {
          p === n.Lt || !this.decodeEntities && this.fastForwardTo(n.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = r.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && p === n.Amp && (this.state = r.BeforeEntity);
        }, l.prototype.stateSpecialStartSequence = function(p) {
          var g = this.sequenceIndex === this.currentSequence.length, v = g ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            a(p)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (p | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!v)
            this.isSpecial = !1;
          else if (!g) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0, this.state = r.InTagName, this.stateInTagName(p);
        }, l.prototype.stateInSpecialTag = function(p) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (p === n.Gt || i(p)) {
              var g = this.index - this.currentSequence.length;
              if (this.sectionStart < g) {
                var v = this.index;
                this.index = g, this.cbs.ontext(this.sectionStart, g), this.index = v;
              }
              this.isSpecial = !1, this.sectionStart = g + 2, this.stateInClosingTagName(p);
              return;
            }
            this.sequenceIndex = 0;
          }
          (p | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === f.TitleEnd ? this.decodeEntities && p === n.Amp && (this.state = r.BeforeEntity) : this.fastForwardTo(n.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(p === n.Lt);
        }, l.prototype.stateCDATASequence = function(p) {
          p === f.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === f.Cdata.length && (this.state = r.InCommentLike, this.currentSequence = f.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = r.InDeclaration, this.stateInDeclaration(p));
        }, l.prototype.fastForwardTo = function(p) {
          for (; ++this.index < this.buffer.length + this.offset; )
            if (this.buffer.charCodeAt(this.index - this.offset) === p)
              return !0;
          return this.index = this.buffer.length + this.offset - 1, !1;
        }, l.prototype.stateInCommentLike = function(p) {
          p === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === f.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = r.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : p !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
        }, l.prototype.isTagStartChar = function(p) {
          return this.xmlMode ? !a(p) : c(p);
        }, l.prototype.startSpecial = function(p, g) {
          this.isSpecial = !0, this.currentSequence = p, this.sequenceIndex = g, this.state = r.SpecialStartSequence;
        }, l.prototype.stateBeforeTagName = function(p) {
          if (p === n.ExclamationMark)
            this.state = r.BeforeDeclaration, this.sectionStart = this.index + 1;
          else if (p === n.Questionmark)
            this.state = r.InProcessingInstruction, this.sectionStart = this.index + 1;
          else if (this.isTagStartChar(p)) {
            var g = p | 32;
            this.sectionStart = this.index, !this.xmlMode && g === f.TitleEnd[2] ? this.startSpecial(f.TitleEnd, 3) : this.state = !this.xmlMode && g === f.ScriptEnd[2] ? r.BeforeSpecialS : r.InTagName;
          } else p === n.Slash ? this.state = r.BeforeClosingTagName : (this.state = r.Text, this.stateText(p));
        }, l.prototype.stateInTagName = function(p) {
          a(p) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p));
        }, l.prototype.stateBeforeClosingTagName = function(p) {
          i(p) || (p === n.Gt ? this.state = r.Text : (this.state = this.isTagStartChar(p) ? r.InClosingTagName : r.InSpecialComment, this.sectionStart = this.index));
        }, l.prototype.stateInClosingTagName = function(p) {
          (p === n.Gt || i(p)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.AfterClosingTagName, this.stateAfterClosingTagName(p));
        }, l.prototype.stateAfterClosingTagName = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.state = r.Text, this.baseState = r.Text, this.sectionStart = this.index + 1);
        }, l.prototype.stateBeforeAttributeName = function(p) {
          p === n.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = r.InSpecialTag, this.sequenceIndex = 0) : this.state = r.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : p === n.Slash ? this.state = r.InSelfClosingTag : i(p) || (this.state = r.InAttributeName, this.sectionStart = this.index);
        }, l.prototype.stateInSelfClosingTag = function(p) {
          p === n.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = r.Text, this.baseState = r.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : i(p) || (this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p));
        }, l.prototype.stateInAttributeName = function(p) {
          (p === n.Eq || a(p)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = r.AfterAttributeName, this.stateAfterAttributeName(p));
        }, l.prototype.stateAfterAttributeName = function(p) {
          p === n.Eq ? this.state = r.BeforeAttributeValue : p === n.Slash || p === n.Gt ? (this.cbs.onattribend(s.NoValue, this.index), this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p)) : i(p) || (this.cbs.onattribend(s.NoValue, this.index), this.state = r.InAttributeName, this.sectionStart = this.index);
        }, l.prototype.stateBeforeAttributeValue = function(p) {
          p === n.DoubleQuote ? (this.state = r.InAttributeValueDq, this.sectionStart = this.index + 1) : p === n.SingleQuote ? (this.state = r.InAttributeValueSq, this.sectionStart = this.index + 1) : i(p) || (this.sectionStart = this.index, this.state = r.InAttributeValueNq, this.stateInAttributeValueNoQuotes(p));
        }, l.prototype.handleInAttributeValue = function(p, g) {
          p === g || !this.decodeEntities && this.fastForwardTo(g) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(g === n.DoubleQuote ? s.Double : s.Single, this.index), this.state = r.BeforeAttributeName) : this.decodeEntities && p === n.Amp && (this.baseState = this.state, this.state = r.BeforeEntity);
        }, l.prototype.stateInAttributeValueDoubleQuotes = function(p) {
          this.handleInAttributeValue(p, n.DoubleQuote);
        }, l.prototype.stateInAttributeValueSingleQuotes = function(p) {
          this.handleInAttributeValue(p, n.SingleQuote);
        }, l.prototype.stateInAttributeValueNoQuotes = function(p) {
          i(p) || p === n.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(s.Unquoted, this.index), this.state = r.BeforeAttributeName, this.stateBeforeAttributeName(p)) : this.decodeEntities && p === n.Amp && (this.baseState = this.state, this.state = r.BeforeEntity);
        }, l.prototype.stateBeforeDeclaration = function(p) {
          p === n.OpeningSquareBracket ? (this.state = r.CDATASequence, this.sequenceIndex = 0) : this.state = p === n.Dash ? r.BeforeComment : r.InDeclaration;
        }, l.prototype.stateInDeclaration = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = r.Text, this.sectionStart = this.index + 1);
        }, l.prototype.stateInProcessingInstruction = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = r.Text, this.sectionStart = this.index + 1);
        }, l.prototype.stateBeforeComment = function(p) {
          p === n.Dash ? (this.state = r.InCommentLike, this.currentSequence = f.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = r.InDeclaration;
        }, l.prototype.stateInSpecialComment = function(p) {
          (p === n.Gt || this.fastForwardTo(n.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = r.Text, this.sectionStart = this.index + 1);
        }, l.prototype.stateBeforeSpecialS = function(p) {
          var g = p | 32;
          g === f.ScriptEnd[3] ? this.startSpecial(f.ScriptEnd, 4) : g === f.StyleEnd[3] ? this.startSpecial(f.StyleEnd, 4) : (this.state = r.InTagName, this.stateInTagName(p));
        }, l.prototype.stateBeforeEntity = function(p) {
          this.entityExcess = 1, this.entityResult = 0, p === n.Number ? this.state = r.BeforeNumericEntity : p === n.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = r.InNamedEntity, this.stateInNamedEntity(p));
        }, l.prototype.stateInNamedEntity = function(p) {
          if (this.entityExcess += 1, this.trieIndex = (0, t.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, p), this.trieIndex < 0) {
            this.emitNamedEntity(), this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var g = this.trieCurrent & t.BinTrieFlags.VALUE_LENGTH;
          if (g) {
            var v = (g >> 14) - 1;
            if (!this.allowLegacyEntity() && p !== n.Semi)
              this.trieIndex += v;
            else {
              var b = this.index - this.entityExcess + 1;
              b > this.sectionStart && this.emitPartial(this.sectionStart, b), this.entityResult = this.trieIndex, this.trieIndex += v, this.entityExcess = 0, this.sectionStart = this.index + 1, v === 0 && this.emitNamedEntity();
            }
          }
        }, l.prototype.emitNamedEntity = function() {
          if (this.state = this.baseState, this.entityResult !== 0) {
            var p = (this.entityTrie[this.entityResult] & t.BinTrieFlags.VALUE_LENGTH) >> 14;
            switch (p) {
              case 1: {
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~t.BinTrieFlags.VALUE_LENGTH);
                break;
              }
              case 2: {
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
              }
              case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        }, l.prototype.stateBeforeNumericEntity = function(p) {
          (p | 32) === n.LowerX ? (this.entityExcess++, this.state = r.InHexEntity) : (this.state = r.InNumericEntity, this.stateInNumericEntity(p));
        }, l.prototype.emitNumericEntity = function(p) {
          var g = this.index - this.entityExcess - 1, v = g + 2 + +(this.state === r.InHexEntity);
          v !== this.index && (g > this.sectionStart && this.emitPartial(this.sectionStart, g), this.sectionStart = this.index + Number(p), this.emitCodePoint((0, t.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
        }, l.prototype.stateInNumericEntity = function(p) {
          p === n.Semi ? this.emitNumericEntity(!0) : o(p) ? (this.entityResult = this.entityResult * 10 + (p - n.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, l.prototype.stateInHexEntity = function(p) {
          p === n.Semi ? this.emitNumericEntity(!0) : o(p) ? (this.entityResult = this.entityResult * 16 + (p - n.Zero), this.entityExcess++) : u(p) ? (this.entityResult = this.entityResult * 16 + ((p | 32) - n.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
        }, l.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === r.Text || this.baseState === r.InSpecialTag);
        }, l.prototype.cleanup = function() {
          this.running && this.sectionStart !== this.index && (this.state === r.Text || this.state === r.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === r.InAttributeValueDq || this.state === r.InAttributeValueSq || this.state === r.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
        }, l.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        }, l.prototype.parse = function() {
          for (; this.shouldContinue(); ) {
            var p = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case r.Text: {
                this.stateText(p);
                break;
              }
              case r.SpecialStartSequence: {
                this.stateSpecialStartSequence(p);
                break;
              }
              case r.InSpecialTag: {
                this.stateInSpecialTag(p);
                break;
              }
              case r.CDATASequence: {
                this.stateCDATASequence(p);
                break;
              }
              case r.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(p);
                break;
              }
              case r.InAttributeName: {
                this.stateInAttributeName(p);
                break;
              }
              case r.InCommentLike: {
                this.stateInCommentLike(p);
                break;
              }
              case r.InSpecialComment: {
                this.stateInSpecialComment(p);
                break;
              }
              case r.BeforeAttributeName: {
                this.stateBeforeAttributeName(p);
                break;
              }
              case r.InTagName: {
                this.stateInTagName(p);
                break;
              }
              case r.InClosingTagName: {
                this.stateInClosingTagName(p);
                break;
              }
              case r.BeforeTagName: {
                this.stateBeforeTagName(p);
                break;
              }
              case r.AfterAttributeName: {
                this.stateAfterAttributeName(p);
                break;
              }
              case r.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(p);
                break;
              }
              case r.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(p);
                break;
              }
              case r.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(p);
                break;
              }
              case r.AfterClosingTagName: {
                this.stateAfterClosingTagName(p);
                break;
              }
              case r.BeforeSpecialS: {
                this.stateBeforeSpecialS(p);
                break;
              }
              case r.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(p);
                break;
              }
              case r.InSelfClosingTag: {
                this.stateInSelfClosingTag(p);
                break;
              }
              case r.InDeclaration: {
                this.stateInDeclaration(p);
                break;
              }
              case r.BeforeDeclaration: {
                this.stateBeforeDeclaration(p);
                break;
              }
              case r.BeforeComment: {
                this.stateBeforeComment(p);
                break;
              }
              case r.InProcessingInstruction: {
                this.stateInProcessingInstruction(p);
                break;
              }
              case r.InNamedEntity: {
                this.stateInNamedEntity(p);
                break;
              }
              case r.BeforeEntity: {
                this.stateBeforeEntity(p);
                break;
              }
              case r.InHexEntity: {
                this.stateInHexEntity(p);
                break;
              }
              case r.InNumericEntity: {
                this.stateInNumericEntity(p);
                break;
              }
              default:
                this.stateBeforeNumericEntity(p);
            }
            this.index++;
          }
          this.cleanup();
        }, l.prototype.finish = function() {
          this.state === r.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
        }, l.prototype.handleTrailingData = function() {
          var p = this.buffer.length + this.offset;
          this.state === r.InCommentLike ? this.currentSequence === f.CdataEnd ? this.cbs.oncdata(this.sectionStart, p, 0) : this.cbs.oncomment(this.sectionStart, p, 0) : this.state === r.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === r.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === r.InTagName || this.state === r.BeforeAttributeName || this.state === r.BeforeAttributeValue || this.state === r.AfterAttributeName || this.state === r.InAttributeName || this.state === r.InAttributeValueSq || this.state === r.InAttributeValueDq || this.state === r.InAttributeValueNq || this.state === r.InClosingTagName || this.cbs.ontext(this.sectionStart, p);
        }, l.prototype.emitPartial = function(p, g) {
          this.baseState !== r.Text && this.baseState !== r.InSpecialTag ? this.cbs.onattribdata(p, g) : this.cbs.ontext(p, g);
        }, l.prototype.emitCodePoint = function(p) {
          this.baseState !== r.Text && this.baseState !== r.InSpecialTag ? this.cbs.onattribentity(p) : this.cbs.ontextentity(p);
        }, l;
      }()
    );
    e.default = d;
  }(Jm)), Jm;
}
var n9;
function i9() {
  if (n9) return Va;
  n9 = 1;
  var e = Va && Va.__createBinding || (Object.create ? function(b, y, w, C) {
    C === void 0 && (C = w);
    var T = Object.getOwnPropertyDescriptor(y, w);
    (!T || ("get" in T ? !y.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return y[w];
    } }), Object.defineProperty(b, C, T);
  } : function(b, y, w, C) {
    C === void 0 && (C = w), b[C] = y[w];
  }), t = Va && Va.__setModuleDefault || (Object.create ? function(b, y) {
    Object.defineProperty(b, "default", { enumerable: !0, value: y });
  } : function(b, y) {
    b.default = y;
  }), n = Va && Va.__importStar || function(b) {
    if (b && b.__esModule) return b;
    var y = {};
    if (b != null) for (var w in b) w !== "default" && Object.prototype.hasOwnProperty.call(b, w) && e(y, b, w);
    return t(y, b), y;
  };
  Object.defineProperty(Va, "__esModule", { value: !0 }), Va.Parser = void 0;
  var r = n(/* @__PURE__ */ cO()), i = /* @__PURE__ */ A0(), a = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]), o = /* @__PURE__ */ new Set(["p"]), c = /* @__PURE__ */ new Set(["thead", "tbody"]), u = /* @__PURE__ */ new Set(["dd", "dt"]), s = /* @__PURE__ */ new Set(["rt", "rp"]), f = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", o],
    ["h1", o],
    ["h2", o],
    ["h3", o],
    ["h4", o],
    ["h5", o],
    ["h6", o],
    ["select", a],
    ["input", a],
    ["output", a],
    ["button", a],
    ["datalist", a],
    ["textarea", a],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", u],
    ["dt", u],
    ["address", o],
    ["article", o],
    ["aside", o],
    ["blockquote", o],
    ["details", o],
    ["div", o],
    ["dl", o],
    ["fieldset", o],
    ["figcaption", o],
    ["figure", o],
    ["footer", o],
    ["form", o],
    ["header", o],
    ["hr", o],
    ["main", o],
    ["nav", o],
    ["ol", o],
    ["pre", o],
    ["section", o],
    ["table", o],
    ["ul", o],
    ["rt", s],
    ["rp", s],
    ["tbody", c],
    ["tfoot", c]
  ]), d = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]), l = /* @__PURE__ */ new Set(["math", "svg"]), p = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]), g = /\s|\//, v = (
    /** @class */
    function() {
      function b(y, w) {
        w === void 0 && (w = {});
        var C, T, E, D, $;
        this.options = w, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = y ?? {}, this.lowerCaseTagNames = (C = w.lowerCaseTags) !== null && C !== void 0 ? C : !w.xmlMode, this.lowerCaseAttributeNames = (T = w.lowerCaseAttributeNames) !== null && T !== void 0 ? T : !w.xmlMode, this.tokenizer = new ((E = w.Tokenizer) !== null && E !== void 0 ? E : r.default)(this.options, this), ($ = (D = this.cbs).onparserinit) === null || $ === void 0 || $.call(D, this);
      }
      return b.prototype.ontext = function(y, w) {
        var C, T, E = this.getSlice(y, w);
        this.endIndex = w - 1, (T = (C = this.cbs).ontext) === null || T === void 0 || T.call(C, E), this.startIndex = w;
      }, b.prototype.ontextentity = function(y) {
        var w, C, T = this.tokenizer.getSectionStart();
        this.endIndex = T - 1, (C = (w = this.cbs).ontext) === null || C === void 0 || C.call(w, (0, i.fromCodePoint)(y)), this.startIndex = T;
      }, b.prototype.isVoidElement = function(y) {
        return !this.options.xmlMode && d.has(y);
      }, b.prototype.onopentagname = function(y, w) {
        this.endIndex = w;
        var C = this.getSlice(y, w);
        this.lowerCaseTagNames && (C = C.toLowerCase()), this.emitOpenTag(C);
      }, b.prototype.emitOpenTag = function(y) {
        var w, C, T, E;
        this.openTagStart = this.startIndex, this.tagname = y;
        var D = !this.options.xmlMode && f.get(y);
        if (D)
          for (; this.stack.length > 0 && D.has(this.stack[this.stack.length - 1]); ) {
            var $ = this.stack.pop();
            (C = (w = this.cbs).onclosetag) === null || C === void 0 || C.call(w, $, !0);
          }
        this.isVoidElement(y) || (this.stack.push(y), l.has(y) ? this.foreignContext.push(!0) : p.has(y) && this.foreignContext.push(!1)), (E = (T = this.cbs).onopentagname) === null || E === void 0 || E.call(T, y), this.cbs.onopentag && (this.attribs = {});
      }, b.prototype.endOpenTag = function(y) {
        var w, C;
        this.startIndex = this.openTagStart, this.attribs && ((C = (w = this.cbs).onopentag) === null || C === void 0 || C.call(w, this.tagname, this.attribs, y), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
      }, b.prototype.onopentagend = function(y) {
        this.endIndex = y, this.endOpenTag(!1), this.startIndex = y + 1;
      }, b.prototype.onclosetag = function(y, w) {
        var C, T, E, D, $, Z;
        this.endIndex = w;
        var te = this.getSlice(y, w);
        if (this.lowerCaseTagNames && (te = te.toLowerCase()), (l.has(te) || p.has(te)) && this.foreignContext.pop(), this.isVoidElement(te))
          !this.options.xmlMode && te === "br" && ((T = (C = this.cbs).onopentagname) === null || T === void 0 || T.call(C, "br"), (D = (E = this.cbs).onopentag) === null || D === void 0 || D.call(E, "br", {}, !0), (Z = ($ = this.cbs).onclosetag) === null || Z === void 0 || Z.call($, "br", !1));
        else {
          var se = this.stack.lastIndexOf(te);
          if (se !== -1)
            if (this.cbs.onclosetag)
              for (var ee = this.stack.length - se; ee--; )
                this.cbs.onclosetag(this.stack.pop(), ee !== 0);
            else
              this.stack.length = se;
          else !this.options.xmlMode && te === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
        }
        this.startIndex = w + 1;
      }, b.prototype.onselfclosingtag = function(y) {
        this.endIndex = y, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = y + 1) : this.onopentagend(y);
      }, b.prototype.closeCurrentTag = function(y) {
        var w, C, T = this.tagname;
        this.endOpenTag(y), this.stack[this.stack.length - 1] === T && ((C = (w = this.cbs).onclosetag) === null || C === void 0 || C.call(w, T, !y), this.stack.pop());
      }, b.prototype.onattribname = function(y, w) {
        this.startIndex = y;
        var C = this.getSlice(y, w);
        this.attribname = this.lowerCaseAttributeNames ? C.toLowerCase() : C;
      }, b.prototype.onattribdata = function(y, w) {
        this.attribvalue += this.getSlice(y, w);
      }, b.prototype.onattribentity = function(y) {
        this.attribvalue += (0, i.fromCodePoint)(y);
      }, b.prototype.onattribend = function(y, w) {
        var C, T;
        this.endIndex = w, (T = (C = this.cbs).onattribute) === null || T === void 0 || T.call(C, this.attribname, this.attribvalue, y === r.QuoteType.Double ? '"' : y === r.QuoteType.Single ? "'" : y === r.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
      }, b.prototype.getInstructionName = function(y) {
        var w = y.search(g), C = w < 0 ? y : y.substr(0, w);
        return this.lowerCaseTagNames && (C = C.toLowerCase()), C;
      }, b.prototype.ondeclaration = function(y, w) {
        this.endIndex = w;
        var C = this.getSlice(y, w);
        if (this.cbs.onprocessinginstruction) {
          var T = this.getInstructionName(C);
          this.cbs.onprocessinginstruction("!".concat(T), "!".concat(C));
        }
        this.startIndex = w + 1;
      }, b.prototype.onprocessinginstruction = function(y, w) {
        this.endIndex = w;
        var C = this.getSlice(y, w);
        if (this.cbs.onprocessinginstruction) {
          var T = this.getInstructionName(C);
          this.cbs.onprocessinginstruction("?".concat(T), "?".concat(C));
        }
        this.startIndex = w + 1;
      }, b.prototype.oncomment = function(y, w, C) {
        var T, E, D, $;
        this.endIndex = w, (E = (T = this.cbs).oncomment) === null || E === void 0 || E.call(T, this.getSlice(y, w - C)), ($ = (D = this.cbs).oncommentend) === null || $ === void 0 || $.call(D), this.startIndex = w + 1;
      }, b.prototype.oncdata = function(y, w, C) {
        var T, E, D, $, Z, te, se, ee, K, re;
        this.endIndex = w;
        var de = this.getSlice(y, w - C);
        this.options.xmlMode || this.options.recognizeCDATA ? ((E = (T = this.cbs).oncdatastart) === null || E === void 0 || E.call(T), ($ = (D = this.cbs).ontext) === null || $ === void 0 || $.call(D, de), (te = (Z = this.cbs).oncdataend) === null || te === void 0 || te.call(Z)) : ((ee = (se = this.cbs).oncomment) === null || ee === void 0 || ee.call(se, "[CDATA[".concat(de, "]]")), (re = (K = this.cbs).oncommentend) === null || re === void 0 || re.call(K)), this.startIndex = w + 1;
      }, b.prototype.onend = function() {
        var y, w;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var C = this.stack.length; C > 0; this.cbs.onclosetag(this.stack[--C], !0))
            ;
        }
        (w = (y = this.cbs).onend) === null || w === void 0 || w.call(y);
      }, b.prototype.reset = function() {
        var y, w, C, T;
        (w = (y = this.cbs).onreset) === null || w === void 0 || w.call(y), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (T = (C = this.cbs).onparserinit) === null || T === void 0 || T.call(C, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
      }, b.prototype.parseComplete = function(y) {
        this.reset(), this.end(y);
      }, b.prototype.getSlice = function(y, w) {
        for (; y - this.bufferOffset >= this.buffers[0].length; )
          this.shiftBuffer();
        for (var C = this.buffers[0].slice(y - this.bufferOffset, w - this.bufferOffset); w - this.bufferOffset > this.buffers[0].length; )
          this.shiftBuffer(), C += this.buffers[0].slice(0, w - this.bufferOffset);
        return C;
      }, b.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
      }, b.prototype.write = function(y) {
        var w, C;
        if (this.ended) {
          (C = (w = this.cbs).onerror) === null || C === void 0 || C.call(w, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(y), this.tokenizer.running && (this.tokenizer.write(y), this.writeIndex++);
      }, b.prototype.end = function(y) {
        var w, C;
        if (this.ended) {
          (C = (w = this.cbs).onerror) === null || C === void 0 || C.call(w, new Error(".end() after done!"));
          return;
        }
        y && this.write(y), this.ended = !0, this.tokenizer.end();
      }, b.prototype.pause = function() {
        this.tokenizer.pause();
      }, b.prototype.resume = function() {
        for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        this.ended && this.tokenizer.end();
      }, b.prototype.parseChunk = function(y) {
        this.write(y);
      }, b.prototype.done = function(y) {
        this.end(y);
      }, b;
    }()
  );
  return Va.Parser = v, Va;
}
var Vs = {}, Xm = {}, a9;
function ip() {
  return a9 || (a9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
    var t;
    (function(r) {
      r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
    })(t = e.ElementType || (e.ElementType = {}));
    function n(r) {
      return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
    }
    e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
  }(Xm)), Xm;
}
var Cn = {}, o9;
function s9() {
  if (o9) return Cn;
  o9 = 1;
  var e = Cn && Cn.__extends || /* @__PURE__ */ function() {
    var E = function(D, $) {
      return E = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Z, te) {
        Z.__proto__ = te;
      } || function(Z, te) {
        for (var se in te) Object.prototype.hasOwnProperty.call(te, se) && (Z[se] = te[se]);
      }, E(D, $);
    };
    return function(D, $) {
      if (typeof $ != "function" && $ !== null)
        throw new TypeError("Class extends value " + String($) + " is not a constructor or null");
      E(D, $);
      function Z() {
        this.constructor = D;
      }
      D.prototype = $ === null ? Object.create($) : (Z.prototype = $.prototype, new Z());
    };
  }(), t = Cn && Cn.__assign || function() {
    return t = Object.assign || function(E) {
      for (var D, $ = 1, Z = arguments.length; $ < Z; $++) {
        D = arguments[$];
        for (var te in D) Object.prototype.hasOwnProperty.call(D, te) && (E[te] = D[te]);
      }
      return E;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(Cn, "__esModule", { value: !0 }), Cn.cloneNode = Cn.hasChildren = Cn.isDocument = Cn.isDirective = Cn.isComment = Cn.isText = Cn.isCDATA = Cn.isTag = Cn.Element = Cn.Document = Cn.CDATA = Cn.NodeWithChildren = Cn.ProcessingInstruction = Cn.Comment = Cn.Text = Cn.DataNode = Cn.Node = void 0;
  var n = /* @__PURE__ */ ip(), r = (
    /** @class */
    function() {
      function E() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(E.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(D) {
          this.parent = D;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(E.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(D) {
          this.prev = D;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(E.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(D) {
          this.next = D;
        },
        enumerable: !1,
        configurable: !0
      }), E.prototype.cloneNode = function(D) {
        return D === void 0 && (D = !1), C(this, D);
      }, E;
    }()
  );
  Cn.Node = r;
  var i = (
    /** @class */
    function(E) {
      e(D, E);
      function D($) {
        var Z = E.call(this) || this;
        return Z.data = $, Z;
      }
      return Object.defineProperty(D.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function($) {
          this.data = $;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(r)
  );
  Cn.DataNode = i;
  var a = (
    /** @class */
    function(E) {
      e(D, E);
      function D() {
        var $ = E !== null && E.apply(this, arguments) || this;
        return $.type = n.ElementType.Text, $;
      }
      return Object.defineProperty(D.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(i)
  );
  Cn.Text = a;
  var o = (
    /** @class */
    function(E) {
      e(D, E);
      function D() {
        var $ = E !== null && E.apply(this, arguments) || this;
        return $.type = n.ElementType.Comment, $;
      }
      return Object.defineProperty(D.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(i)
  );
  Cn.Comment = o;
  var c = (
    /** @class */
    function(E) {
      e(D, E);
      function D($, Z) {
        var te = E.call(this, Z) || this;
        return te.name = $, te.type = n.ElementType.Directive, te;
      }
      return Object.defineProperty(D.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(i)
  );
  Cn.ProcessingInstruction = c;
  var u = (
    /** @class */
    function(E) {
      e(D, E);
      function D($) {
        var Z = E.call(this) || this;
        return Z.children = $, Z;
      }
      return Object.defineProperty(D.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var $;
          return ($ = this.children[0]) !== null && $ !== void 0 ? $ : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(D.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(D.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function($) {
          this.children = $;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(r)
  );
  Cn.NodeWithChildren = u;
  var s = (
    /** @class */
    function(E) {
      e(D, E);
      function D() {
        var $ = E !== null && E.apply(this, arguments) || this;
        return $.type = n.ElementType.CDATA, $;
      }
      return Object.defineProperty(D.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(u)
  );
  Cn.CDATA = s;
  var f = (
    /** @class */
    function(E) {
      e(D, E);
      function D() {
        var $ = E !== null && E.apply(this, arguments) || this;
        return $.type = n.ElementType.Root, $;
      }
      return Object.defineProperty(D.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(u)
  );
  Cn.Document = f;
  var d = (
    /** @class */
    function(E) {
      e(D, E);
      function D($, Z, te, se) {
        te === void 0 && (te = []), se === void 0 && (se = $ === "script" ? n.ElementType.Script : $ === "style" ? n.ElementType.Style : n.ElementType.Tag);
        var ee = E.call(this, te) || this;
        return ee.name = $, ee.attribs = Z, ee.type = se, ee;
      }
      return Object.defineProperty(D.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(D.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function($) {
          this.name = $;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(D.prototype, "attributes", {
        get: function() {
          var $ = this;
          return Object.keys(this.attribs).map(function(Z) {
            var te, se;
            return {
              name: Z,
              value: $.attribs[Z],
              namespace: (te = $["x-attribsNamespace"]) === null || te === void 0 ? void 0 : te[Z],
              prefix: (se = $["x-attribsPrefix"]) === null || se === void 0 ? void 0 : se[Z]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), D;
    }(u)
  );
  Cn.Element = d;
  function l(E) {
    return (0, n.isTag)(E);
  }
  Cn.isTag = l;
  function p(E) {
    return E.type === n.ElementType.CDATA;
  }
  Cn.isCDATA = p;
  function g(E) {
    return E.type === n.ElementType.Text;
  }
  Cn.isText = g;
  function v(E) {
    return E.type === n.ElementType.Comment;
  }
  Cn.isComment = v;
  function b(E) {
    return E.type === n.ElementType.Directive;
  }
  Cn.isDirective = b;
  function y(E) {
    return E.type === n.ElementType.Root;
  }
  Cn.isDocument = y;
  function w(E) {
    return Object.prototype.hasOwnProperty.call(E, "children");
  }
  Cn.hasChildren = w;
  function C(E, D) {
    D === void 0 && (D = !1);
    var $;
    if (g(E))
      $ = new a(E.data);
    else if (v(E))
      $ = new o(E.data);
    else if (l(E)) {
      var Z = D ? T(E.children) : [], te = new d(E.name, t({}, E.attribs), Z);
      Z.forEach(function(re) {
        return re.parent = te;
      }), E.namespace != null && (te.namespace = E.namespace), E["x-attribsNamespace"] && (te["x-attribsNamespace"] = t({}, E["x-attribsNamespace"])), E["x-attribsPrefix"] && (te["x-attribsPrefix"] = t({}, E["x-attribsPrefix"])), $ = te;
    } else if (p(E)) {
      var Z = D ? T(E.children) : [], se = new s(Z);
      Z.forEach(function(de) {
        return de.parent = se;
      }), $ = se;
    } else if (y(E)) {
      var Z = D ? T(E.children) : [], ee = new f(Z);
      Z.forEach(function(de) {
        return de.parent = ee;
      }), E["x-mode"] && (ee["x-mode"] = E["x-mode"]), $ = ee;
    } else if (b(E)) {
      var K = new c(E.name, E.data);
      E["x-name"] != null && (K["x-name"] = E["x-name"], K["x-publicId"] = E["x-publicId"], K["x-systemId"] = E["x-systemId"]), $ = K;
    } else
      throw new Error("Not implemented yet: ".concat(E.type));
    return $.startIndex = E.startIndex, $.endIndex = E.endIndex, E.sourceCodeLocation != null && ($.sourceCodeLocation = E.sourceCodeLocation), $;
  }
  Cn.cloneNode = C;
  function T(E) {
    for (var D = E.map(function(Z) {
      return C(Z, !0);
    }), $ = 1; $ < D.length; $++)
      D[$].prev = D[$ - 1], D[$ - 1].next = D[$];
    return D;
  }
  return Cn;
}
var u9;
function As() {
  return u9 || (u9 = 1, function(e) {
    var t = Vs && Vs.__createBinding || (Object.create ? function(c, u, s, f) {
      f === void 0 && (f = s);
      var d = Object.getOwnPropertyDescriptor(u, s);
      (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return u[s];
      } }), Object.defineProperty(c, f, d);
    } : function(c, u, s, f) {
      f === void 0 && (f = s), c[f] = u[s];
    }), n = Vs && Vs.__exportStar || function(c, u) {
      for (var s in c) s !== "default" && !Object.prototype.hasOwnProperty.call(u, s) && t(u, c, s);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
    var r = /* @__PURE__ */ ip(), i = /* @__PURE__ */ s9();
    n(/* @__PURE__ */ s9(), e);
    var a = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, o = (
      /** @class */
      function() {
        function c(u, s, f) {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof s == "function" && (f = s, s = a), typeof u == "object" && (s = u, u = void 0), this.callback = u ?? null, this.options = s ?? a, this.elementCB = f ?? null;
        }
        return c.prototype.onparserinit = function(u) {
          this.parser = u;
        }, c.prototype.onreset = function() {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, c.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, c.prototype.onerror = function(u) {
          this.handleCallback(u);
        }, c.prototype.onclosetag = function() {
          this.lastNode = null;
          var u = this.tagStack.pop();
          this.options.withEndIndices && (u.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(u);
        }, c.prototype.onopentag = function(u, s) {
          var f = this.options.xmlMode ? r.ElementType.Tag : void 0, d = new i.Element(u, s, void 0, f);
          this.addNode(d), this.tagStack.push(d);
        }, c.prototype.ontext = function(u) {
          var s = this.lastNode;
          if (s && s.type === r.ElementType.Text)
            s.data += u, this.options.withEndIndices && (s.endIndex = this.parser.endIndex);
          else {
            var f = new i.Text(u);
            this.addNode(f), this.lastNode = f;
          }
        }, c.prototype.oncomment = function(u) {
          if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
            this.lastNode.data += u;
            return;
          }
          var s = new i.Comment(u);
          this.addNode(s), this.lastNode = s;
        }, c.prototype.oncommentend = function() {
          this.lastNode = null;
        }, c.prototype.oncdatastart = function() {
          var u = new i.Text(""), s = new i.CDATA([u]);
          this.addNode(s), u.parent = s, this.lastNode = u;
        }, c.prototype.oncdataend = function() {
          this.lastNode = null;
        }, c.prototype.onprocessinginstruction = function(u, s) {
          var f = new i.ProcessingInstruction(u, s);
          this.addNode(f);
        }, c.prototype.handleCallback = function(u) {
          if (typeof this.callback == "function")
            this.callback(u, this.dom);
          else if (u)
            throw u;
        }, c.prototype.addNode = function(u) {
          var s = this.tagStack[this.tagStack.length - 1], f = s.children[s.children.length - 1];
          this.options.withStartIndices && (u.startIndex = this.parser.startIndex), this.options.withEndIndices && (u.endIndex = this.parser.endIndex), s.children.push(u), f && (u.prev = f, f.next = u), u.parent = s, this.lastNode = null;
        }, c;
      }()
    );
    e.DomHandler = o, e.default = o;
  }(Vs)), Vs;
}
var Ws = {}, Ui = {}, Qi = {}, e3 = {}, Lo = {}, Pd = {}, c9;
function sY() {
  if (c9) return Pd;
  c9 = 1, Object.defineProperty(Pd, "__esModule", { value: !0 });
  function e(t) {
    for (var n = 1; n < t.length; n++)
      t[n][0] += t[n - 1][0] + 1;
    return t;
  }
  return Pd.default = new Map(/* @__PURE__ */ e([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ e([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ e([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ e([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]])), Pd;
}
var t3 = {}, l9;
function n2() {
  return l9 || (l9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var t = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    e.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(i, a) {
      return i.codePointAt(a);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(i, a) {
        return (i.charCodeAt(a) & 64512) === 55296 ? (i.charCodeAt(a) - 55296) * 1024 + i.charCodeAt(a + 1) - 56320 + 65536 : i.charCodeAt(a);
      }
    );
    function n(i) {
      for (var a = "", o = 0, c; (c = e.xmlReplacer.exec(i)) !== null; ) {
        var u = c.index, s = i.charCodeAt(u), f = t.get(s);
        f !== void 0 ? (a += i.substring(o, u) + f, o = u + 1) : (a += "".concat(i.substring(o, u), "&#x").concat((0, e.getCodePoint)(i, u).toString(16), ";"), o = e.xmlReplacer.lastIndex += +((s & 64512) === 55296));
      }
      return a + i.substr(o);
    }
    e.encodeXML = n, e.escape = n;
    function r(i, a) {
      return function(c) {
        for (var u, s = 0, f = ""; u = i.exec(c); )
          s !== u.index && (f += c.substring(s, u.index)), f += a.get(u[0].charCodeAt(0)), s = u.index + 1;
        return f + c.substring(s);
      };
    }
    e.escapeUTF8 = r(/[&<>'"]/g, t), e.escapeAttribute = r(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ])), e.escapeText = r(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  }(t3)), t3;
}
var f9;
function p9() {
  if (f9) return Lo;
  f9 = 1;
  var e = Lo && Lo.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(Lo, "__esModule", { value: !0 }), Lo.encodeNonAsciiHTML = Lo.encodeHTML = void 0;
  var t = e(/* @__PURE__ */ sY()), n = /* @__PURE__ */ n2(), r = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function i(c) {
    return o(r, c);
  }
  Lo.encodeHTML = i;
  function a(c) {
    return o(n.xmlReplacer, c);
  }
  Lo.encodeNonAsciiHTML = a;
  function o(c, u) {
    for (var s = "", f = 0, d; (d = c.exec(u)) !== null; ) {
      var l = d.index;
      s += u.substring(f, l);
      var p = u.charCodeAt(l), g = t.default.get(p);
      if (typeof g == "object") {
        if (l + 1 < u.length) {
          var v = u.charCodeAt(l + 1), b = typeof g.n == "number" ? g.n === v ? g.o : void 0 : g.n.get(v);
          if (b !== void 0) {
            s += b, f = c.lastIndex += 1;
            continue;
          }
        }
        g = g.v;
      }
      if (g !== void 0)
        s += g, f = l + 1;
      else {
        var y = (0, n.getCodePoint)(u, l);
        s += "&#x".concat(y.toString(16), ";"), f = c.lastIndex += +(y !== p);
      }
    }
    return s + u.substr(f);
  }
  return Lo;
}
var d9;
function uY() {
  return d9 || (d9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
    var t = /* @__PURE__ */ A0(), n = /* @__PURE__ */ p9(), r = /* @__PURE__ */ n2(), i;
    (function(l) {
      l[l.XML = 0] = "XML", l[l.HTML = 1] = "HTML";
    })(i = e.EntityLevel || (e.EntityLevel = {}));
    var a;
    (function(l) {
      l[l.UTF8 = 0] = "UTF8", l[l.ASCII = 1] = "ASCII", l[l.Extensive = 2] = "Extensive", l[l.Attribute = 3] = "Attribute", l[l.Text = 4] = "Text";
    })(a = e.EncodingMode || (e.EncodingMode = {}));
    function o(l, p) {
      p === void 0 && (p = i.XML);
      var g = typeof p == "number" ? p : p.level;
      if (g === i.HTML) {
        var v = typeof p == "object" ? p.mode : void 0;
        return (0, t.decodeHTML)(l, v);
      }
      return (0, t.decodeXML)(l);
    }
    e.decode = o;
    function c(l, p) {
      var g;
      p === void 0 && (p = i.XML);
      var v = typeof p == "number" ? { level: p } : p;
      return (g = v.mode) !== null && g !== void 0 || (v.mode = t.DecodingMode.Strict), o(l, v);
    }
    e.decodeStrict = c;
    function u(l, p) {
      p === void 0 && (p = i.XML);
      var g = typeof p == "number" ? { level: p } : p;
      return g.mode === a.UTF8 ? (0, r.escapeUTF8)(l) : g.mode === a.Attribute ? (0, r.escapeAttribute)(l) : g.mode === a.Text ? (0, r.escapeText)(l) : g.level === i.HTML ? g.mode === a.ASCII ? (0, n.encodeNonAsciiHTML)(l) : (0, n.encodeHTML)(l) : (0, r.encodeXML)(l);
    }
    e.encode = u;
    var s = /* @__PURE__ */ n2();
    Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
      return s.encodeXML;
    } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
      return s.escape;
    } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
      return s.escapeUTF8;
    } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
      return s.escapeAttribute;
    } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
      return s.escapeText;
    } });
    var f = /* @__PURE__ */ p9();
    Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
      return f.encodeHTML;
    } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return f.encodeNonAsciiHTML;
    } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
      return f.encodeHTML;
    } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
      return f.encodeHTML;
    } });
    var d = /* @__PURE__ */ A0();
    Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
      return d.EntityDecoder;
    } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
      return d.DecodingMode;
    } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
      return d.decodeXML;
    } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
      return d.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return d.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
      return d.decodeHTMLAttribute;
    } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
      return d.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
      return d.decodeHTML;
    } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return d.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return d.decodeHTMLStrict;
    } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
      return d.decodeXML;
    } });
  }(e3)), e3;
}
var Ks = {}, h9;
function cY() {
  return h9 || (h9 = 1, Object.defineProperty(Ks, "__esModule", { value: !0 }), Ks.attributeNames = Ks.elementNames = void 0, Ks.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  })), Ks.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(e) {
    return [e.toLowerCase(), e];
  }))), Ks;
}
var m9;
function lY() {
  if (m9) return Qi;
  m9 = 1;
  var e = Qi && Qi.__assign || function() {
    return e = Object.assign || function(T) {
      for (var E, D = 1, $ = arguments.length; D < $; D++) {
        E = arguments[D];
        for (var Z in E) Object.prototype.hasOwnProperty.call(E, Z) && (T[Z] = E[Z]);
      }
      return T;
    }, e.apply(this, arguments);
  }, t = Qi && Qi.__createBinding || (Object.create ? function(T, E, D, $) {
    $ === void 0 && ($ = D);
    var Z = Object.getOwnPropertyDescriptor(E, D);
    (!Z || ("get" in Z ? !E.__esModule : Z.writable || Z.configurable)) && (Z = { enumerable: !0, get: function() {
      return E[D];
    } }), Object.defineProperty(T, $, Z);
  } : function(T, E, D, $) {
    $ === void 0 && ($ = D), T[$] = E[D];
  }), n = Qi && Qi.__setModuleDefault || (Object.create ? function(T, E) {
    Object.defineProperty(T, "default", { enumerable: !0, value: E });
  } : function(T, E) {
    T.default = E;
  }), r = Qi && Qi.__importStar || function(T) {
    if (T && T.__esModule) return T;
    var E = {};
    if (T != null) for (var D in T) D !== "default" && Object.prototype.hasOwnProperty.call(T, D) && t(E, T, D);
    return n(E, T), E;
  };
  Object.defineProperty(Qi, "__esModule", { value: !0 }), Qi.render = void 0;
  var i = r(/* @__PURE__ */ ip()), a = /* @__PURE__ */ uY(), o = /* @__PURE__ */ cY(), c = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function u(T) {
    return T.replace(/"/g, "&quot;");
  }
  function s(T, E) {
    var D;
    if (T) {
      var $ = ((D = E.encodeEntities) !== null && D !== void 0 ? D : E.decodeEntities) === !1 ? u : E.xmlMode || E.encodeEntities !== "utf8" ? a.encodeXML : a.escapeAttribute;
      return Object.keys(T).map(function(Z) {
        var te, se, ee = (te = T[Z]) !== null && te !== void 0 ? te : "";
        return E.xmlMode === "foreign" && (Z = (se = o.attributeNames.get(Z)) !== null && se !== void 0 ? se : Z), !E.emptyAttrs && !E.xmlMode && ee === "" ? Z : "".concat(Z, '="').concat($(ee), '"');
      }).join(" ");
    }
  }
  var f = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function d(T, E) {
    E === void 0 && (E = {});
    for (var D = ("length" in T) ? T : [T], $ = "", Z = 0; Z < D.length; Z++)
      $ += l(D[Z], E);
    return $;
  }
  Qi.render = d, Qi.default = d;
  function l(T, E) {
    switch (T.type) {
      case i.Root:
        return d(T.children, E);
      // @ts-expect-error We don't use `Doctype` yet
      case i.Doctype:
      case i.Directive:
        return b(T);
      case i.Comment:
        return C(T);
      case i.CDATA:
        return w(T);
      case i.Script:
      case i.Style:
      case i.Tag:
        return v(T, E);
      case i.Text:
        return y(T, E);
    }
  }
  var p = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]), g = /* @__PURE__ */ new Set(["svg", "math"]);
  function v(T, E) {
    var D;
    E.xmlMode === "foreign" && (T.name = (D = o.elementNames.get(T.name)) !== null && D !== void 0 ? D : T.name, T.parent && p.has(T.parent.name) && (E = e(e({}, E), { xmlMode: !1 }))), !E.xmlMode && g.has(T.name) && (E = e(e({}, E), { xmlMode: "foreign" }));
    var $ = "<".concat(T.name), Z = s(T.attribs, E);
    return Z && ($ += " ".concat(Z)), T.children.length === 0 && (E.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      E.selfClosingTags !== !1
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      E.selfClosingTags && f.has(T.name)
    )) ? (E.xmlMode || ($ += " "), $ += "/>") : ($ += ">", T.children.length > 0 && ($ += d(T.children, E)), (E.xmlMode || !f.has(T.name)) && ($ += "</".concat(T.name, ">"))), $;
  }
  function b(T) {
    return "<".concat(T.data, ">");
  }
  function y(T, E) {
    var D, $ = T.data || "";
    return ((D = E.encodeEntities) !== null && D !== void 0 ? D : E.decodeEntities) !== !1 && !(!E.xmlMode && T.parent && c.has(T.parent.name)) && ($ = E.xmlMode || E.encodeEntities !== "utf8" ? (0, a.encodeXML)($) : (0, a.escapeText)($)), $;
  }
  function w(T) {
    return "<![CDATA[".concat(T.children[0].data, "]]>");
  }
  function C(T) {
    return "<!--".concat(T.data, "-->");
  }
  return Qi;
}
var g9;
function lO() {
  if (g9) return Ui;
  g9 = 1;
  var e = Ui && Ui.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(Ui, "__esModule", { value: !0 }), Ui.innerText = Ui.textContent = Ui.getText = Ui.getInnerHTML = Ui.getOuterHTML = void 0;
  var t = /* @__PURE__ */ As(), n = e(/* @__PURE__ */ lY()), r = /* @__PURE__ */ ip();
  function i(s, f) {
    return (0, n.default)(s, f);
  }
  Ui.getOuterHTML = i;
  function a(s, f) {
    return (0, t.hasChildren)(s) ? s.children.map(function(d) {
      return i(d, f);
    }).join("") : "";
  }
  Ui.getInnerHTML = a;
  function o(s) {
    return Array.isArray(s) ? s.map(o).join("") : (0, t.isTag)(s) ? s.name === "br" ? `
` : o(s.children) : (0, t.isCDATA)(s) ? o(s.children) : (0, t.isText)(s) ? s.data : "";
  }
  Ui.getText = o;
  function c(s) {
    return Array.isArray(s) ? s.map(c).join("") : (0, t.hasChildren)(s) && !(0, t.isComment)(s) ? c(s.children) : (0, t.isText)(s) ? s.data : "";
  }
  Ui.textContent = c;
  function u(s) {
    return Array.isArray(s) ? s.map(u).join("") : (0, t.hasChildren)(s) && (s.type === r.ElementType.Tag || (0, t.isCDATA)(s)) ? u(s.children) : (0, t.isText)(s) ? s.data : "";
  }
  return Ui.innerText = u, Ui;
}
var fi = {}, v9;
function fY() {
  if (v9) return fi;
  v9 = 1, Object.defineProperty(fi, "__esModule", { value: !0 }), fi.prevElementSibling = fi.nextElementSibling = fi.getName = fi.hasAttrib = fi.getAttributeValue = fi.getSiblings = fi.getParent = fi.getChildren = void 0;
  var e = /* @__PURE__ */ As();
  function t(s) {
    return (0, e.hasChildren)(s) ? s.children : [];
  }
  fi.getChildren = t;
  function n(s) {
    return s.parent || null;
  }
  fi.getParent = n;
  function r(s) {
    var f, d, l = n(s);
    if (l != null)
      return t(l);
    for (var p = [s], g = s.prev, v = s.next; g != null; )
      p.unshift(g), f = g, g = f.prev;
    for (; v != null; )
      p.push(v), d = v, v = d.next;
    return p;
  }
  fi.getSiblings = r;
  function i(s, f) {
    var d;
    return (d = s.attribs) === null || d === void 0 ? void 0 : d[f];
  }
  fi.getAttributeValue = i;
  function a(s, f) {
    return s.attribs != null && Object.prototype.hasOwnProperty.call(s.attribs, f) && s.attribs[f] != null;
  }
  fi.hasAttrib = a;
  function o(s) {
    return s.name;
  }
  fi.getName = o;
  function c(s) {
    for (var f, d = s.next; d !== null && !(0, e.isTag)(d); )
      f = d, d = f.next;
    return d;
  }
  fi.nextElementSibling = c;
  function u(s) {
    for (var f, d = s.prev; d !== null && !(0, e.isTag)(d); )
      f = d, d = f.prev;
    return d;
  }
  return fi.prevElementSibling = u, fi;
}
var Hi = {}, y9;
function pY() {
  if (y9) return Hi;
  y9 = 1, Object.defineProperty(Hi, "__esModule", { value: !0 }), Hi.prepend = Hi.prependChild = Hi.append = Hi.appendChild = Hi.replaceElement = Hi.removeElement = void 0;
  function e(o) {
    if (o.prev && (o.prev.next = o.next), o.next && (o.next.prev = o.prev), o.parent) {
      var c = o.parent.children, u = c.lastIndexOf(o);
      u >= 0 && c.splice(u, 1);
    }
    o.next = null, o.prev = null, o.parent = null;
  }
  Hi.removeElement = e;
  function t(o, c) {
    var u = c.prev = o.prev;
    u && (u.next = c);
    var s = c.next = o.next;
    s && (s.prev = c);
    var f = c.parent = o.parent;
    if (f) {
      var d = f.children;
      d[d.lastIndexOf(o)] = c, o.parent = null;
    }
  }
  Hi.replaceElement = t;
  function n(o, c) {
    if (e(c), c.next = null, c.parent = o, o.children.push(c) > 1) {
      var u = o.children[o.children.length - 2];
      u.next = c, c.prev = u;
    } else
      c.prev = null;
  }
  Hi.appendChild = n;
  function r(o, c) {
    e(c);
    var u = o.parent, s = o.next;
    if (c.next = s, c.prev = o, o.next = c, c.parent = u, s) {
      if (s.prev = c, u) {
        var f = u.children;
        f.splice(f.lastIndexOf(s), 0, c);
      }
    } else u && u.children.push(c);
  }
  Hi.append = r;
  function i(o, c) {
    if (e(c), c.parent = o, c.prev = null, o.children.unshift(c) !== 1) {
      var u = o.children[1];
      u.prev = c, c.next = u;
    } else
      c.next = null;
  }
  Hi.prependChild = i;
  function a(o, c) {
    e(c);
    var u = o.parent;
    if (u) {
      var s = u.children;
      s.splice(s.indexOf(o), 0, c);
    }
    o.prev && (o.prev.next = c), c.parent = u, c.prev = o.prev, c.next = o, o.prev = c;
  }
  return Hi.prepend = a, Hi;
}
var zi = {}, b9;
function fO() {
  if (b9) return zi;
  b9 = 1, Object.defineProperty(zi, "__esModule", { value: !0 }), zi.findAll = zi.existsOne = zi.findOne = zi.findOneChild = zi.find = zi.filter = void 0;
  var e = /* @__PURE__ */ As();
  function t(c, u, s, f) {
    return s === void 0 && (s = !0), f === void 0 && (f = 1 / 0), n(c, Array.isArray(u) ? u : [u], s, f);
  }
  zi.filter = t;
  function n(c, u, s, f) {
    for (var d = [], l = [u], p = [0]; ; ) {
      if (p[0] >= l[0].length) {
        if (p.length === 1)
          return d;
        l.shift(), p.shift();
        continue;
      }
      var g = l[0][p[0]++];
      if (c(g) && (d.push(g), --f <= 0))
        return d;
      s && (0, e.hasChildren)(g) && g.children.length > 0 && (p.unshift(0), l.unshift(g.children));
    }
  }
  zi.find = n;
  function r(c, u) {
    return u.find(c);
  }
  zi.findOneChild = r;
  function i(c, u, s) {
    s === void 0 && (s = !0);
    for (var f = null, d = 0; d < u.length && !f; d++) {
      var l = u[d];
      if ((0, e.isTag)(l))
        c(l) ? f = l : s && l.children.length > 0 && (f = i(c, l.children, !0));
      else continue;
    }
    return f;
  }
  zi.findOne = i;
  function a(c, u) {
    return u.some(function(s) {
      return (0, e.isTag)(s) && (c(s) || a(c, s.children));
    });
  }
  zi.existsOne = a;
  function o(c, u) {
    for (var s = [], f = [u], d = [0]; ; ) {
      if (d[0] >= f[0].length) {
        if (f.length === 1)
          return s;
        f.shift(), d.shift();
        continue;
      }
      var l = f[0][d[0]++];
      (0, e.isTag)(l) && (c(l) && s.push(l), l.children.length > 0 && (d.unshift(0), f.unshift(l.children)));
    }
  }
  return zi.findAll = o, zi;
}
var ca = {}, x9;
function pO() {
  if (x9) return ca;
  x9 = 1, Object.defineProperty(ca, "__esModule", { value: !0 }), ca.getElementsByTagType = ca.getElementsByTagName = ca.getElementById = ca.getElements = ca.testElement = void 0;
  var e = /* @__PURE__ */ As(), t = /* @__PURE__ */ fO(), n = {
    tag_name: function(d) {
      return typeof d == "function" ? function(l) {
        return (0, e.isTag)(l) && d(l.name);
      } : d === "*" ? e.isTag : function(l) {
        return (0, e.isTag)(l) && l.name === d;
      };
    },
    tag_type: function(d) {
      return typeof d == "function" ? function(l) {
        return d(l.type);
      } : function(l) {
        return l.type === d;
      };
    },
    tag_contains: function(d) {
      return typeof d == "function" ? function(l) {
        return (0, e.isText)(l) && d(l.data);
      } : function(l) {
        return (0, e.isText)(l) && l.data === d;
      };
    }
  };
  function r(d, l) {
    return typeof l == "function" ? function(p) {
      return (0, e.isTag)(p) && l(p.attribs[d]);
    } : function(p) {
      return (0, e.isTag)(p) && p.attribs[d] === l;
    };
  }
  function i(d, l) {
    return function(p) {
      return d(p) || l(p);
    };
  }
  function a(d) {
    var l = Object.keys(d).map(function(p) {
      var g = d[p];
      return Object.prototype.hasOwnProperty.call(n, p) ? n[p](g) : r(p, g);
    });
    return l.length === 0 ? null : l.reduce(i);
  }
  function o(d, l) {
    var p = a(d);
    return p ? p(l) : !0;
  }
  ca.testElement = o;
  function c(d, l, p, g) {
    g === void 0 && (g = 1 / 0);
    var v = a(d);
    return v ? (0, t.filter)(v, l, p, g) : [];
  }
  ca.getElements = c;
  function u(d, l, p) {
    return p === void 0 && (p = !0), Array.isArray(l) || (l = [l]), (0, t.findOne)(r("id", d), l, p);
  }
  ca.getElementById = u;
  function s(d, l, p, g) {
    return p === void 0 && (p = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(n.tag_name(d), l, p, g);
  }
  ca.getElementsByTagName = s;
  function f(d, l, p, g) {
    return p === void 0 && (p = !0), g === void 0 && (g = 1 / 0), (0, t.filter)(n.tag_type(d), l, p, g);
  }
  return ca.getElementsByTagType = f, ca;
}
var r3 = {}, _9;
function dY() {
  return _9 || (_9 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.uniqueSort = e.compareDocumentPosition = e.DocumentPosition = e.removeSubsets = void 0;
    var t = /* @__PURE__ */ As();
    function n(o) {
      for (var c = o.length; --c >= 0; ) {
        var u = o[c];
        if (c > 0 && o.lastIndexOf(u, c - 1) >= 0) {
          o.splice(c, 1);
          continue;
        }
        for (var s = u.parent; s; s = s.parent)
          if (o.includes(s)) {
            o.splice(c, 1);
            break;
          }
      }
      return o;
    }
    e.removeSubsets = n;
    var r;
    (function(o) {
      o[o.DISCONNECTED = 1] = "DISCONNECTED", o[o.PRECEDING = 2] = "PRECEDING", o[o.FOLLOWING = 4] = "FOLLOWING", o[o.CONTAINS = 8] = "CONTAINS", o[o.CONTAINED_BY = 16] = "CONTAINED_BY";
    })(r = e.DocumentPosition || (e.DocumentPosition = {}));
    function i(o, c) {
      var u = [], s = [];
      if (o === c)
        return 0;
      for (var f = (0, t.hasChildren)(o) ? o : o.parent; f; )
        u.unshift(f), f = f.parent;
      for (f = (0, t.hasChildren)(c) ? c : c.parent; f; )
        s.unshift(f), f = f.parent;
      for (var d = Math.min(u.length, s.length), l = 0; l < d && u[l] === s[l]; )
        l++;
      if (l === 0)
        return r.DISCONNECTED;
      var p = u[l - 1], g = p.children, v = u[l], b = s[l];
      return g.indexOf(v) > g.indexOf(b) ? p === c ? r.FOLLOWING | r.CONTAINED_BY : r.FOLLOWING : p === o ? r.PRECEDING | r.CONTAINS : r.PRECEDING;
    }
    e.compareDocumentPosition = i;
    function a(o) {
      return o = o.filter(function(c, u, s) {
        return !s.includes(c, u + 1);
      }), o.sort(function(c, u) {
        var s = i(c, u);
        return s & r.PRECEDING ? -1 : s & r.FOLLOWING ? 1 : 0;
      }), o;
    }
    e.uniqueSort = a;
  }(r3)), r3;
}
var xl = {}, w9;
function hY() {
  if (w9) return xl;
  w9 = 1, Object.defineProperty(xl, "__esModule", { value: !0 }), xl.getFeed = void 0;
  var e = /* @__PURE__ */ lO(), t = /* @__PURE__ */ pO();
  function n(l) {
    var p = u(d, l);
    return p ? p.name === "feed" ? r(p) : i(p) : null;
  }
  xl.getFeed = n;
  function r(l) {
    var p, g = l.children, v = {
      type: "atom",
      items: (0, t.getElementsByTagName)("entry", g).map(function(w) {
        var C, T = w.children, E = { media: c(T) };
        f(E, "id", "id", T), f(E, "title", "title", T);
        var D = (C = u("link", T)) === null || C === void 0 ? void 0 : C.attribs.href;
        D && (E.link = D);
        var $ = s("summary", T) || s("content", T);
        $ && (E.description = $);
        var Z = s("updated", T);
        return Z && (E.pubDate = new Date(Z)), E;
      })
    };
    f(v, "id", "id", g), f(v, "title", "title", g);
    var b = (p = u("link", g)) === null || p === void 0 ? void 0 : p.attribs.href;
    b && (v.link = b), f(v, "description", "subtitle", g);
    var y = s("updated", g);
    return y && (v.updated = new Date(y)), f(v, "author", "email", g, !0), v;
  }
  function i(l) {
    var p, g, v = (g = (p = u("channel", l.children)) === null || p === void 0 ? void 0 : p.children) !== null && g !== void 0 ? g : [], b = {
      type: l.name.substr(0, 3),
      id: "",
      items: (0, t.getElementsByTagName)("item", l.children).map(function(w) {
        var C = w.children, T = { media: c(C) };
        f(T, "id", "guid", C), f(T, "title", "title", C), f(T, "link", "link", C), f(T, "description", "description", C);
        var E = s("pubDate", C) || s("dc:date", C);
        return E && (T.pubDate = new Date(E)), T;
      })
    };
    f(b, "title", "title", v), f(b, "link", "link", v), f(b, "description", "description", v);
    var y = s("lastBuildDate", v);
    return y && (b.updated = new Date(y)), f(b, "author", "managingEditor", v, !0), b;
  }
  var a = ["url", "type", "lang"], o = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function c(l) {
    return (0, t.getElementsByTagName)("media:content", l).map(function(p) {
      for (var g = p.attribs, v = {
        medium: g.medium,
        isDefault: !!g.isDefault
      }, b = 0, y = a; b < y.length; b++) {
        var w = y[b];
        g[w] && (v[w] = g[w]);
      }
      for (var C = 0, T = o; C < T.length; C++) {
        var w = T[C];
        g[w] && (v[w] = parseInt(g[w], 10));
      }
      return g.expression && (v.expression = g.expression), v;
    });
  }
  function u(l, p) {
    return (0, t.getElementsByTagName)(l, p, !0, 1)[0];
  }
  function s(l, p, g) {
    return g === void 0 && (g = !1), (0, e.textContent)((0, t.getElementsByTagName)(l, p, g, 1)).trim();
  }
  function f(l, p, g, v, b) {
    b === void 0 && (b = !1);
    var y = s(g, v, b);
    y && (l[p] = y);
  }
  function d(l) {
    return l === "rss" || l === "feed" || l === "rdf:RDF";
  }
  return xl;
}
var S9;
function n3() {
  return S9 || (S9 = 1, function(e) {
    var t = Ws && Ws.__createBinding || (Object.create ? function(i, a, o, c) {
      c === void 0 && (c = o);
      var u = Object.getOwnPropertyDescriptor(a, o);
      (!u || ("get" in u ? !a.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return a[o];
      } }), Object.defineProperty(i, c, u);
    } : function(i, a, o, c) {
      c === void 0 && (c = o), i[c] = a[o];
    }), n = Ws && Ws.__exportStar || function(i, a) {
      for (var o in i) o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && t(a, i, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, n(/* @__PURE__ */ lO(), e), n(/* @__PURE__ */ fY(), e), n(/* @__PURE__ */ pY(), e), n(/* @__PURE__ */ fO(), e), n(/* @__PURE__ */ pO(), e), n(/* @__PURE__ */ dY(), e), n(/* @__PURE__ */ hY(), e);
    var r = /* @__PURE__ */ As();
    Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
      return r.isTag;
    } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
      return r.isCDATA;
    } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
      return r.isText;
    } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
      return r.isComment;
    } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
      return r.isDocument;
    } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
      return r.hasChildren;
    } });
  }(Ws)), Ws;
}
var C9;
function mY() {
  return C9 || (C9 = 1, function(e) {
    var t = Ga && Ga.__createBinding || (Object.create ? function(y, w, C, T) {
      T === void 0 && (T = C);
      var E = Object.getOwnPropertyDescriptor(w, C);
      (!E || ("get" in E ? !w.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return w[C];
      } }), Object.defineProperty(y, T, E);
    } : function(y, w, C, T) {
      T === void 0 && (T = C), y[T] = w[C];
    }), n = Ga && Ga.__setModuleDefault || (Object.create ? function(y, w) {
      Object.defineProperty(y, "default", { enumerable: !0, value: w });
    } : function(y, w) {
      y.default = w;
    }), r = Ga && Ga.__importStar || function(y) {
      if (y && y.__esModule) return y;
      var w = {};
      if (y != null) for (var C in y) C !== "default" && Object.prototype.hasOwnProperty.call(y, C) && t(w, y, C);
      return n(w, y), w;
    }, i = Ga && Ga.__importDefault || function(y) {
      return y && y.__esModule ? y : { default: y };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.Tokenizer = e.createDomStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
    var a = /* @__PURE__ */ i9(), o = /* @__PURE__ */ i9();
    Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
      return o.Parser;
    } });
    var c = /* @__PURE__ */ As(), u = /* @__PURE__ */ As();
    Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
      return u.DomHandler;
    } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
      return u.DomHandler;
    } });
    function s(y, w) {
      var C = new c.DomHandler(void 0, w);
      return new a.Parser(C, w).end(y), C.root;
    }
    e.parseDocument = s;
    function f(y, w) {
      return s(y, w).children;
    }
    e.parseDOM = f;
    function d(y, w, C) {
      var T = new c.DomHandler(y, w, C);
      return new a.Parser(T, w);
    }
    e.createDomStream = d;
    var l = /* @__PURE__ */ cO();
    Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
      return i(l).default;
    } }), e.ElementType = r(/* @__PURE__ */ ip());
    var p = /* @__PURE__ */ n3(), g = /* @__PURE__ */ n3();
    Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
      return g.getFeed;
    } });
    var v = { xmlMode: !0 };
    function b(y, w) {
      return w === void 0 && (w = v), (0, p.getFeed)(f(y, w));
    }
    e.parseFeed = b, e.DomUtils = r(/* @__PURE__ */ n3());
  }(Ga)), Ga;
}
var i3, A9;
function gY() {
  return A9 || (A9 = 1, i3 = (e) => {
    if (typeof e != "string")
      throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }), i3;
}
var Rd = {}, k9;
function vY() {
  if (k9) return Rd;
  k9 = 1, Object.defineProperty(Rd, "__esModule", { value: !0 });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function e(n) {
    return Object.prototype.toString.call(n) === "[object Object]";
  }
  function t(n) {
    var r, i;
    return e(n) === !1 ? !1 : (r = n.constructor, r === void 0 ? !0 : (i = r.prototype, !(e(i) === !1 || i.hasOwnProperty("isPrototypeOf") === !1)));
  }
  return Rd.isPlainObject = t, Rd;
}
var a3, E9;
function yY() {
  if (E9) return a3;
  E9 = 1;
  var e = function(w) {
    return t(w) && !n(w);
  };
  function t(y) {
    return !!y && typeof y == "object";
  }
  function n(y) {
    var w = Object.prototype.toString.call(y);
    return w === "[object RegExp]" || w === "[object Date]" || a(y);
  }
  var r = typeof Symbol == "function" && Symbol.for, i = r ? Symbol.for("react.element") : 60103;
  function a(y) {
    return y.$$typeof === i;
  }
  function o(y) {
    return Array.isArray(y) ? [] : {};
  }
  function c(y, w) {
    return w.clone !== !1 && w.isMergeableObject(y) ? v(o(y), y, w) : y;
  }
  function u(y, w, C) {
    return y.concat(w).map(function(T) {
      return c(T, C);
    });
  }
  function s(y, w) {
    if (!w.customMerge)
      return v;
    var C = w.customMerge(y);
    return typeof C == "function" ? C : v;
  }
  function f(y) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(y).filter(function(w) {
      return Object.propertyIsEnumerable.call(y, w);
    }) : [];
  }
  function d(y) {
    return Object.keys(y).concat(f(y));
  }
  function l(y, w) {
    try {
      return w in y;
    } catch {
      return !1;
    }
  }
  function p(y, w) {
    return l(y, w) && !(Object.hasOwnProperty.call(y, w) && Object.propertyIsEnumerable.call(y, w));
  }
  function g(y, w, C) {
    var T = {};
    return C.isMergeableObject(y) && d(y).forEach(function(E) {
      T[E] = c(y[E], C);
    }), d(w).forEach(function(E) {
      p(y, E) || (l(y, E) && C.isMergeableObject(w[E]) ? T[E] = s(E, C)(y[E], w[E], C) : T[E] = c(w[E], C));
    }), T;
  }
  function v(y, w, C) {
    C = C || {}, C.arrayMerge = C.arrayMerge || u, C.isMergeableObject = C.isMergeableObject || e, C.cloneUnlessOtherwiseSpecified = c;
    var T = Array.isArray(w), E = Array.isArray(y), D = T === E;
    return D ? T ? C.arrayMerge(y, w, C) : g(y, w, C) : c(w, C);
  }
  v.all = function(w, C) {
    if (!Array.isArray(w))
      throw new Error("first argument should be an array");
    return w.reduce(function(T, E) {
      return v(T, E, C);
    }, {});
  };
  var b = v;
  return a3 = b, a3;
}
var zd = { exports: {} }, bY = zd.exports, O9;
function xY() {
  return O9 || (O9 = 1, function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.parseSrcset = n();
    })(bY, function() {
      return function(t) {
        function n(T) {
          return T === " " || // space
          T === "	" || // horizontal tab
          T === `
` || // new line
          T === "\f" || // form feed
          T === "\r";
        }
        function r(T) {
          var E, D = T.exec(t.substring(b));
          if (D)
            return E = D[0], b += E.length, E;
        }
        for (var i = t.length, a = /^[ \t\n\r\u000c]+/, o = /^[, \t\n\r\u000c]+/, c = /^[^ \t\n\r\u000c]+/, u = /[,]+$/, s = /^\d+$/, f = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, d, l, p, g, v, b = 0, y = []; ; ) {
          if (r(o), b >= i)
            return y;
          d = r(c), l = [], d.slice(-1) === "," ? (d = d.replace(u, ""), C()) : w();
        }
        function w() {
          for (r(a), p = "", g = "in descriptor"; ; ) {
            if (v = t.charAt(b), g === "in descriptor")
              if (n(v))
                p && (l.push(p), p = "", g = "after descriptor");
              else if (v === ",") {
                b += 1, p && l.push(p), C();
                return;
              } else if (v === "(")
                p = p + v, g = "in parens";
              else if (v === "") {
                p && l.push(p), C();
                return;
              } else
                p = p + v;
            else if (g === "in parens")
              if (v === ")")
                p = p + v, g = "in descriptor";
              else if (v === "") {
                l.push(p), C();
                return;
              } else
                p = p + v;
            else if (g === "after descriptor" && !n(v))
              if (v === "") {
                C();
                return;
              } else
                g = "in descriptor", b -= 1;
            b += 1;
          }
        }
        function C() {
          var T = !1, E, D, $, Z, te = {}, se, ee, K, re, de;
          for (Z = 0; Z < l.length; Z++)
            se = l[Z], ee = se[se.length - 1], K = se.substring(0, se.length - 1), re = parseInt(K, 10), de = parseFloat(K), s.test(K) && ee === "w" ? ((E || D) && (T = !0), re === 0 ? T = !0 : E = re) : f.test(K) && ee === "x" ? ((E || D || $) && (T = !0), de < 0 ? T = !0 : D = de) : s.test(K) && ee === "h" ? (($ || D) && (T = !0), re === 0 ? T = !0 : $ = re) : T = !0;
          T ? console && console.log && console.log("Invalid srcset descriptor found in '" + t + "' at '" + se + "'.") : (te.url = d, E && (te.w = E), D && (te.d = D), $ && (te.h = $), y.push(te));
        }
      };
    });
  }(zd)), zd.exports;
}
var jd = { exports: {} }, T9;
function _Y() {
  if (T9) return jd.exports;
  T9 = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return jd.exports = t(), jd.exports.createColors = t, jd.exports;
}
var o3, P9;
function gg() {
  if (P9) return o3;
  P9 = 1;
  let e = /* @__PURE__ */ _Y(), t = ai;
  class n extends Error {
    constructor(i, a, o, c, u, s) {
      super(i), this.name = "CssSyntaxError", this.reason = i, u && (this.file = u), c && (this.source = c), s && (this.plugin = s), typeof a < "u" && typeof o < "u" && (typeof a == "number" ? (this.line = a, this.column = o) : (this.line = a.line, this.column = a.column, this.endLine = o.line, this.endColumn = o.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, n);
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
    }
    showSourceCode(i) {
      if (!this.source) return "";
      let a = this.source;
      i == null && (i = e.isColorSupported);
      let o = (p) => p, c = (p) => p, u = (p) => p;
      if (i) {
        let { bold: p, gray: g, red: v } = e.createColors(!0);
        c = (b) => p(v(b)), o = (b) => g(b), t && (u = (b) => t(b));
      }
      let s = a.split(/\r?\n/), f = Math.max(this.line - 3, 0), d = Math.min(this.line + 2, s.length), l = String(d).length;
      return s.slice(f, d).map((p, g) => {
        let v = f + 1 + g, b = " " + (" " + v).slice(-l) + " | ";
        if (v === this.line) {
          if (p.length > 160) {
            let w = 20, C = Math.max(0, this.column - w), T = Math.max(
              this.column + w,
              this.endColumn + w
            ), E = p.slice(C, T), D = o(b.replace(/\d/g, " ")) + p.slice(0, Math.min(this.column - 1, w - 1)).replace(/[^\t]/g, " ");
            return c(">") + o(b) + u(E) + `
 ` + D + c("^");
          }
          let y = o(b.replace(/\d/g, " ")) + p.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return c(">") + o(b) + u(p) + `
 ` + y + c("^");
        }
        return " " + o(b) + u(p);
      }).join(`
`);
    }
    toString() {
      let i = this.showSourceCode();
      return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
    }
  }
  return o3 = n, n.default = n, o3;
}
var s3, R9;
function dO() {
  if (R9) return s3;
  R9 = 1;
  const e = {
    after: `
`,
    beforeClose: `
`,
    beforeComment: `
`,
    beforeDecl: `
`,
    beforeOpen: " ",
    beforeRule: `
`,
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: !1
  };
  function t(r) {
    return r[0].toUpperCase() + r.slice(1);
  }
  class n {
    constructor(i) {
      this.builder = i;
    }
    atrule(i, a) {
      let o = "@" + i.name, c = i.params ? this.rawValue(i, "params") : "";
      if (typeof i.raws.afterName < "u" ? o += i.raws.afterName : c && (o += " "), i.nodes)
        this.block(i, o + c);
      else {
        let u = (i.raws.between || "") + (a ? ";" : "");
        this.builder(o + c + u, i);
      }
    }
    beforeAfter(i, a) {
      let o;
      i.type === "decl" ? o = this.raw(i, null, "beforeDecl") : i.type === "comment" ? o = this.raw(i, null, "beforeComment") : a === "before" ? o = this.raw(i, null, "beforeRule") : o = this.raw(i, null, "beforeClose");
      let c = i.parent, u = 0;
      for (; c && c.type !== "root"; )
        u += 1, c = c.parent;
      if (o.includes(`
`)) {
        let s = this.raw(i, null, "indent");
        if (s.length)
          for (let f = 0; f < u; f++) o += s;
      }
      return o;
    }
    block(i, a) {
      let o = this.raw(i, "between", "beforeOpen");
      this.builder(a + o + "{", i, "start");
      let c;
      i.nodes && i.nodes.length ? (this.body(i), c = this.raw(i, "after")) : c = this.raw(i, "after", "emptyBody"), c && this.builder(c), this.builder("}", i, "end");
    }
    body(i) {
      let a = i.nodes.length - 1;
      for (; a > 0 && i.nodes[a].type === "comment"; )
        a -= 1;
      let o = this.raw(i, "semicolon");
      for (let c = 0; c < i.nodes.length; c++) {
        let u = i.nodes[c], s = this.raw(u, "before");
        s && this.builder(s), this.stringify(u, a !== c || o);
      }
    }
    comment(i) {
      let a = this.raw(i, "left", "commentLeft"), o = this.raw(i, "right", "commentRight");
      this.builder("/*" + a + i.text + o + "*/", i);
    }
    decl(i, a) {
      let o = this.raw(i, "between", "colon"), c = i.prop + o + this.rawValue(i, "value");
      i.important && (c += i.raws.important || " !important"), a && (c += ";"), this.builder(c, i);
    }
    document(i) {
      this.body(i);
    }
    raw(i, a, o) {
      let c;
      if (o || (o = a), a && (c = i.raws[a], typeof c < "u"))
        return c;
      let u = i.parent;
      if (o === "before" && (!u || u.type === "root" && u.first === i || u && u.type === "document"))
        return "";
      if (!u) return e[o];
      let s = i.root();
      if (s.rawCache || (s.rawCache = {}), typeof s.rawCache[o] < "u")
        return s.rawCache[o];
      if (o === "before" || o === "after")
        return this.beforeAfter(i, o);
      {
        let f = "raw" + t(o);
        this[f] ? c = this[f](s, i) : s.walk((d) => {
          if (c = d.raws[a], typeof c < "u") return !1;
        });
      }
      return typeof c > "u" && (c = e[o]), s.rawCache[o] = c, c;
    }
    rawBeforeClose(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && o.nodes.length > 0 && typeof o.raws.after < "u")
          return a = o.raws.after, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), a && (a = a.replace(/\S/g, "")), a;
    }
    rawBeforeComment(i, a) {
      let o;
      return i.walkComments((c) => {
        if (typeof c.raws.before < "u")
          return o = c.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
      }), typeof o > "u" ? o = this.raw(a, null, "beforeDecl") : o && (o = o.replace(/\S/g, "")), o;
    }
    rawBeforeDecl(i, a) {
      let o;
      return i.walkDecls((c) => {
        if (typeof c.raws.before < "u")
          return o = c.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
      }), typeof o > "u" ? o = this.raw(a, null, "beforeRule") : o && (o = o.replace(/\S/g, "")), o;
    }
    rawBeforeOpen(i) {
      let a;
      return i.walk((o) => {
        if (o.type !== "decl" && (a = o.raws.between, typeof a < "u"))
          return !1;
      }), a;
    }
    rawBeforeRule(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && (o.parent !== i || i.first !== o) && typeof o.raws.before < "u")
          return a = o.raws.before, a.includes(`
`) && (a = a.replace(/[^\n]+$/, "")), !1;
      }), a && (a = a.replace(/\S/g, "")), a;
    }
    rawColon(i) {
      let a;
      return i.walkDecls((o) => {
        if (typeof o.raws.between < "u")
          return a = o.raws.between.replace(/[^\s:]/g, ""), !1;
      }), a;
    }
    rawEmptyBody(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && o.nodes.length === 0 && (a = o.raws.after, typeof a < "u"))
          return !1;
      }), a;
    }
    rawIndent(i) {
      if (i.raws.indent) return i.raws.indent;
      let a;
      return i.walk((o) => {
        let c = o.parent;
        if (c && c !== i && c.parent && c.parent === i && typeof o.raws.before < "u") {
          let u = o.raws.before.split(`
`);
          return a = u[u.length - 1], a = a.replace(/\S/g, ""), !1;
        }
      }), a;
    }
    rawSemicolon(i) {
      let a;
      return i.walk((o) => {
        if (o.nodes && o.nodes.length && o.last.type === "decl" && (a = o.raws.semicolon, typeof a < "u"))
          return !1;
      }), a;
    }
    rawValue(i, a) {
      let o = i[a], c = i.raws[a];
      return c && c.value === o ? c.raw : o;
    }
    root(i) {
      this.body(i), i.raws.after && this.builder(i.raws.after);
    }
    rule(i) {
      this.block(i, this.rawValue(i, "selector")), i.raws.ownSemicolon && this.builder(i.raws.ownSemicolon, i, "end");
    }
    stringify(i, a) {
      if (!this[i.type])
        throw new Error(
          "Unknown AST node type " + i.type + ". Maybe you need to change PostCSS stringifier."
        );
      this[i.type](i, a);
    }
  }
  return s3 = n, n.default = n, s3;
}
var u3, j9;
function r1() {
  if (j9) return u3;
  j9 = 1;
  let e = dO();
  function t(n, r) {
    new e(r).stringify(n);
  }
  return u3 = t, t.default = t, u3;
}
var Id = {}, I9;
function vg() {
  return I9 || (I9 = 1, Id.isClean = Symbol("isClean"), Id.my = Symbol("my")), Id;
}
var c3, q9;
function n1() {
  if (q9) return c3;
  q9 = 1;
  let e = gg(), t = dO(), n = r1(), { isClean: r, my: i } = vg();
  function a(u, s) {
    let f = new u.constructor();
    for (let d in u) {
      if (!Object.prototype.hasOwnProperty.call(u, d) || d === "proxyCache") continue;
      let l = u[d], p = typeof l;
      d === "parent" && p === "object" ? s && (f[d] = s) : d === "source" ? f[d] = l : Array.isArray(l) ? f[d] = l.map((g) => a(g, f)) : (p === "object" && l !== null && (l = a(l)), f[d] = l);
    }
    return f;
  }
  function o(u, s) {
    if (s && typeof s.offset < "u")
      return s.offset;
    let f = 1, d = 1, l = 0;
    for (let p = 0; p < u.length; p++) {
      if (d === s.line && f === s.column) {
        l = p;
        break;
      }
      u[p] === `
` ? (f = 1, d += 1) : f += 1;
    }
    return l;
  }
  class c {
    get proxyOf() {
      return this;
    }
    constructor(s = {}) {
      this.raws = {}, this[r] = !1, this[i] = !0;
      for (let f in s)
        if (f === "nodes") {
          this.nodes = [];
          for (let d of s[f])
            typeof d.clone == "function" ? this.append(d.clone()) : this.append(d);
        } else
          this[f] = s[f];
    }
    addToError(s) {
      if (s.postcssNode = this, s.stack && this.source && /\n\s{4}at /.test(s.stack)) {
        let f = this.source;
        s.stack = s.stack.replace(
          /\n\s{4}at /,
          `$&${f.input.from}:${f.start.line}:${f.start.column}$&`
        );
      }
      return s;
    }
    after(s) {
      return this.parent.insertAfter(this, s), this;
    }
    assign(s = {}) {
      for (let f in s)
        this[f] = s[f];
      return this;
    }
    before(s) {
      return this.parent.insertBefore(this, s), this;
    }
    cleanRaws(s) {
      delete this.raws.before, delete this.raws.after, s || delete this.raws.between;
    }
    clone(s = {}) {
      let f = a(this);
      for (let d in s)
        f[d] = s[d];
      return f;
    }
    cloneAfter(s = {}) {
      let f = this.clone(s);
      return this.parent.insertAfter(this, f), f;
    }
    cloneBefore(s = {}) {
      let f = this.clone(s);
      return this.parent.insertBefore(this, f), f;
    }
    error(s, f = {}) {
      if (this.source) {
        let { end: d, start: l } = this.rangeBy(f);
        return this.source.input.error(
          s,
          { column: l.column, line: l.line },
          { column: d.column, line: d.line },
          f
        );
      }
      return new e(s);
    }
    getProxyProcessor() {
      return {
        get(s, f) {
          return f === "proxyOf" ? s : f === "root" ? () => s.root().toProxy() : s[f];
        },
        set(s, f, d) {
          return s[f] === d || (s[f] = d, (f === "prop" || f === "value" || f === "name" || f === "params" || f === "important" || /* c8 ignore next */
          f === "text") && s.markDirty()), !0;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[r] = !0;
    }
    markDirty() {
      if (this[r]) {
        this[r] = !1;
        let s = this;
        for (; s = s.parent; )
          s[r] = !1;
      }
    }
    next() {
      if (!this.parent) return;
      let s = this.parent.index(this);
      return this.parent.nodes[s + 1];
    }
    positionBy(s) {
      let f = this.source.start;
      if (s.index)
        f = this.positionInside(s.index);
      else if (s.word) {
        let d = "document" in this.source.input ? this.source.input.document : this.source.input.css, p = d.slice(
          o(d, this.source.start),
          o(d, this.source.end)
        ).indexOf(s.word);
        p !== -1 && (f = this.positionInside(p));
      }
      return f;
    }
    positionInside(s) {
      let f = this.source.start.column, d = this.source.start.line, l = "document" in this.source.input ? this.source.input.document : this.source.input.css, p = o(l, this.source.start), g = p + s;
      for (let v = p; v < g; v++)
        l[v] === `
` ? (f = 1, d += 1) : f += 1;
      return { column: f, line: d };
    }
    prev() {
      if (!this.parent) return;
      let s = this.parent.index(this);
      return this.parent.nodes[s - 1];
    }
    rangeBy(s) {
      let f = {
        column: this.source.start.column,
        line: this.source.start.line
      }, d = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line
      } : {
        column: f.column + 1,
        line: f.line
      };
      if (s.word) {
        let l = "document" in this.source.input ? this.source.input.document : this.source.input.css, g = l.slice(
          o(l, this.source.start),
          o(l, this.source.end)
        ).indexOf(s.word);
        g !== -1 && (f = this.positionInside(g), d = this.positionInside(
          g + s.word.length
        ));
      } else
        s.start ? f = {
          column: s.start.column,
          line: s.start.line
        } : s.index && (f = this.positionInside(s.index)), s.end ? d = {
          column: s.end.column,
          line: s.end.line
        } : typeof s.endIndex == "number" ? d = this.positionInside(s.endIndex) : s.index && (d = this.positionInside(s.index + 1));
      return (d.line < f.line || d.line === f.line && d.column <= f.column) && (d = { column: f.column + 1, line: f.line }), { end: d, start: f };
    }
    raw(s, f) {
      return new t().raw(this, s, f);
    }
    remove() {
      return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
    }
    replaceWith(...s) {
      if (this.parent) {
        let f = this, d = !1;
        for (let l of s)
          l === this ? d = !0 : d ? (this.parent.insertAfter(f, l), f = l) : this.parent.insertBefore(f, l);
        d || this.remove();
      }
      return this;
    }
    root() {
      let s = this;
      for (; s.parent && s.parent.type !== "document"; )
        s = s.parent;
      return s;
    }
    toJSON(s, f) {
      let d = {}, l = f == null;
      f = f || /* @__PURE__ */ new Map();
      let p = 0;
      for (let g in this) {
        if (!Object.prototype.hasOwnProperty.call(this, g) || g === "parent" || g === "proxyCache") continue;
        let v = this[g];
        if (Array.isArray(v))
          d[g] = v.map((b) => typeof b == "object" && b.toJSON ? b.toJSON(null, f) : b);
        else if (typeof v == "object" && v.toJSON)
          d[g] = v.toJSON(null, f);
        else if (g === "source") {
          let b = f.get(v.input);
          b == null && (b = p, f.set(v.input, p), p++), d[g] = {
            end: v.end,
            inputId: b,
            start: v.start
          };
        } else
          d[g] = v;
      }
      return l && (d.inputs = [...f.keys()].map((g) => g.toJSON())), d;
    }
    toProxy() {
      return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
    }
    toString(s = n) {
      s.stringify && (s = s.stringify);
      let f = "";
      return s(this, (d) => {
        f += d;
      }), f;
    }
    warn(s, f, d) {
      let l = { node: this };
      for (let p in d) l[p] = d[p];
      return s.warn(f, l);
    }
  }
  return c3 = c, c.default = c, c3;
}
var l3, D9;
function i1() {
  if (D9) return l3;
  D9 = 1;
  let e = n1();
  class t extends e {
    constructor(r) {
      super(r), this.type = "comment";
    }
  }
  return l3 = t, t.default = t, l3;
}
var f3, L9;
function a1() {
  if (L9) return f3;
  L9 = 1;
  let e = n1();
  class t extends e {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(r) {
      r && typeof r.value < "u" && typeof r.value != "string" && (r = { ...r, value: String(r.value) }), super(r), this.type = "decl";
    }
  }
  return f3 = t, t.default = t, f3;
}
var p3, N9;
function Ru() {
  if (N9) return p3;
  N9 = 1;
  let e = i1(), t = a1(), n = n1(), { isClean: r, my: i } = vg(), a, o, c, u;
  function s(l) {
    return l.map((p) => (p.nodes && (p.nodes = s(p.nodes)), delete p.source, p));
  }
  function f(l) {
    if (l[r] = !1, l.proxyOf.nodes)
      for (let p of l.proxyOf.nodes)
        f(p);
  }
  class d extends n {
    get first() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[0];
    }
    get last() {
      if (this.proxyOf.nodes)
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...p) {
      for (let g of p) {
        let v = this.normalize(g, this.last);
        for (let b of v) this.proxyOf.nodes.push(b);
      }
      return this.markDirty(), this;
    }
    cleanRaws(p) {
      if (super.cleanRaws(p), this.nodes)
        for (let g of this.nodes) g.cleanRaws(p);
    }
    each(p) {
      if (!this.proxyOf.nodes) return;
      let g = this.getIterator(), v, b;
      for (; this.indexes[g] < this.proxyOf.nodes.length && (v = this.indexes[g], b = p(this.proxyOf.nodes[v], v), b !== !1); )
        this.indexes[g] += 1;
      return delete this.indexes[g], b;
    }
    every(p) {
      return this.nodes.every(p);
    }
    getIterator() {
      this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
      let p = this.lastEach;
      return this.indexes[p] = 0, p;
    }
    getProxyProcessor() {
      return {
        get(p, g) {
          return g === "proxyOf" ? p : p[g] ? g === "each" || typeof g == "string" && g.startsWith("walk") ? (...v) => p[g](
            ...v.map((b) => typeof b == "function" ? (y, w) => b(y.toProxy(), w) : b)
          ) : g === "every" || g === "some" ? (v) => p[g](
            (b, ...y) => v(b.toProxy(), ...y)
          ) : g === "root" ? () => p.root().toProxy() : g === "nodes" ? p.nodes.map((v) => v.toProxy()) : g === "first" || g === "last" ? p[g].toProxy() : p[g] : p[g];
        },
        set(p, g, v) {
          return p[g] === v || (p[g] = v, (g === "name" || g === "params" || g === "selector") && p.markDirty()), !0;
        }
      };
    }
    index(p) {
      return typeof p == "number" ? p : (p.proxyOf && (p = p.proxyOf), this.proxyOf.nodes.indexOf(p));
    }
    insertAfter(p, g) {
      let v = this.index(p), b = this.normalize(g, this.proxyOf.nodes[v]).reverse();
      v = this.index(p);
      for (let w of b) this.proxyOf.nodes.splice(v + 1, 0, w);
      let y;
      for (let w in this.indexes)
        y = this.indexes[w], v < y && (this.indexes[w] = y + b.length);
      return this.markDirty(), this;
    }
    insertBefore(p, g) {
      let v = this.index(p), b = v === 0 ? "prepend" : !1, y = this.normalize(
        g,
        this.proxyOf.nodes[v],
        b
      ).reverse();
      v = this.index(p);
      for (let C of y) this.proxyOf.nodes.splice(v, 0, C);
      let w;
      for (let C in this.indexes)
        w = this.indexes[C], v <= w && (this.indexes[C] = w + y.length);
      return this.markDirty(), this;
    }
    normalize(p, g) {
      if (typeof p == "string")
        p = s(o(p).nodes);
      else if (typeof p > "u")
        p = [];
      else if (Array.isArray(p)) {
        p = p.slice(0);
        for (let b of p)
          b.parent && b.parent.removeChild(b, "ignore");
      } else if (p.type === "root" && this.type !== "document") {
        p = p.nodes.slice(0);
        for (let b of p)
          b.parent && b.parent.removeChild(b, "ignore");
      } else if (p.type)
        p = [p];
      else if (p.prop) {
        if (typeof p.value > "u")
          throw new Error("Value field is missed in node creation");
        typeof p.value != "string" && (p.value = String(p.value)), p = [new t(p)];
      } else if (p.selector || p.selectors)
        p = [new u(p)];
      else if (p.name)
        p = [new a(p)];
      else if (p.text)
        p = [new e(p)];
      else
        throw new Error("Unknown node type in node creation");
      return p.map((b) => (b[i] || d.rebuild(b), b = b.proxyOf, b.parent && b.parent.removeChild(b), b[r] && f(b), b.raws || (b.raws = {}), typeof b.raws.before > "u" && g && typeof g.raws.before < "u" && (b.raws.before = g.raws.before.replace(/\S/g, "")), b.parent = this.proxyOf, b));
    }
    prepend(...p) {
      p = p.reverse();
      for (let g of p) {
        let v = this.normalize(g, this.first, "prepend").reverse();
        for (let b of v) this.proxyOf.nodes.unshift(b);
        for (let b in this.indexes)
          this.indexes[b] = this.indexes[b] + v.length;
      }
      return this.markDirty(), this;
    }
    push(p) {
      return p.parent = this, this.proxyOf.nodes.push(p), this;
    }
    removeAll() {
      for (let p of this.proxyOf.nodes) p.parent = void 0;
      return this.proxyOf.nodes = [], this.markDirty(), this;
    }
    removeChild(p) {
      p = this.index(p), this.proxyOf.nodes[p].parent = void 0, this.proxyOf.nodes.splice(p, 1);
      let g;
      for (let v in this.indexes)
        g = this.indexes[v], g >= p && (this.indexes[v] = g - 1);
      return this.markDirty(), this;
    }
    replaceValues(p, g, v) {
      return v || (v = g, g = {}), this.walkDecls((b) => {
        g.props && !g.props.includes(b.prop) || g.fast && !b.value.includes(g.fast) || (b.value = b.value.replace(p, v));
      }), this.markDirty(), this;
    }
    some(p) {
      return this.nodes.some(p);
    }
    walk(p) {
      return this.each((g, v) => {
        let b;
        try {
          b = p(g, v);
        } catch (y) {
          throw g.addToError(y);
        }
        return b !== !1 && g.walk && (b = g.walk(p)), b;
      });
    }
    walkAtRules(p, g) {
      return g ? p instanceof RegExp ? this.walk((v, b) => {
        if (v.type === "atrule" && p.test(v.name))
          return g(v, b);
      }) : this.walk((v, b) => {
        if (v.type === "atrule" && v.name === p)
          return g(v, b);
      }) : (g = p, this.walk((v, b) => {
        if (v.type === "atrule")
          return g(v, b);
      }));
    }
    walkComments(p) {
      return this.walk((g, v) => {
        if (g.type === "comment")
          return p(g, v);
      });
    }
    walkDecls(p, g) {
      return g ? p instanceof RegExp ? this.walk((v, b) => {
        if (v.type === "decl" && p.test(v.prop))
          return g(v, b);
      }) : this.walk((v, b) => {
        if (v.type === "decl" && v.prop === p)
          return g(v, b);
      }) : (g = p, this.walk((v, b) => {
        if (v.type === "decl")
          return g(v, b);
      }));
    }
    walkRules(p, g) {
      return g ? p instanceof RegExp ? this.walk((v, b) => {
        if (v.type === "rule" && p.test(v.selector))
          return g(v, b);
      }) : this.walk((v, b) => {
        if (v.type === "rule" && v.selector === p)
          return g(v, b);
      }) : (g = p, this.walk((v, b) => {
        if (v.type === "rule")
          return g(v, b);
      }));
    }
  }
  return d.registerParse = (l) => {
    o = l;
  }, d.registerRule = (l) => {
    u = l;
  }, d.registerAtRule = (l) => {
    a = l;
  }, d.registerRoot = (l) => {
    c = l;
  }, p3 = d, d.default = d, d.rebuild = (l) => {
    l.type === "atrule" ? Object.setPrototypeOf(l, a.prototype) : l.type === "rule" ? Object.setPrototypeOf(l, u.prototype) : l.type === "decl" ? Object.setPrototypeOf(l, t.prototype) : l.type === "comment" ? Object.setPrototypeOf(l, e.prototype) : l.type === "root" && Object.setPrototypeOf(l, c.prototype), l[i] = !0, l.nodes && l.nodes.forEach((p) => {
      d.rebuild(p);
    });
  }, p3;
}
var d3, $9;
function yg() {
  if ($9) return d3;
  $9 = 1;
  let e = Ru();
  class t extends e {
    constructor(r) {
      super(r), this.type = "atrule";
    }
    append(...r) {
      return this.proxyOf.nodes || (this.nodes = []), super.append(...r);
    }
    prepend(...r) {
      return this.proxyOf.nodes || (this.nodes = []), super.prepend(...r);
    }
  }
  return d3 = t, t.default = t, e.registerAtRule(t), d3;
}
var h3, M9;
function bg() {
  if (M9) return h3;
  M9 = 1;
  let e = Ru(), t, n;
  class r extends e {
    constructor(a) {
      super({ type: "document", ...a }), this.nodes || (this.nodes = []);
    }
    toResult(a = {}) {
      return new t(new n(), this, a).stringify();
    }
  }
  return r.registerLazyResult = (i) => {
    t = i;
  }, r.registerProcessor = (i) => {
    n = i;
  }, h3 = r, r.default = r, h3;
}
var m3, F9;
function wY() {
  if (F9) return m3;
  F9 = 1;
  let e = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  return m3 = { nanoid: (r = 21) => {
    let i = "", a = r | 0;
    for (; a--; )
      i += e[Math.random() * 64 | 0];
    return i;
  }, customAlphabet: (r, i = 21) => (a = i) => {
    let o = "", c = a | 0;
    for (; c--; )
      o += r[Math.random() * r.length | 0];
    return o;
  } }, m3;
}
var g3, B9;
function hO() {
  if (B9) return g3;
  B9 = 1;
  let { existsSync: e, readFileSync: t } = ai, { dirname: n, join: r } = Ss(), { SourceMapConsumer: i, SourceMapGenerator: a } = ai;
  function o(u) {
    return Dn ? Dn.from(u, "base64").toString() : window.atob(u);
  }
  class c {
    constructor(s, f) {
      if (f.map === !1) return;
      this.loadAnnotation(s), this.inline = this.startWith(this.annotation, "data:");
      let d = f.map ? f.map.prev : void 0, l = this.loadMap(f.from, d);
      !this.mapFile && f.from && (this.mapFile = f.from), this.mapFile && (this.root = n(this.mapFile)), l && (this.text = l);
    }
    consumer() {
      return this.consumerCache || (this.consumerCache = new i(this.text)), this.consumerCache;
    }
    decodeInline(s) {
      let f = /^data:application\/json;charset=utf-?8;base64,/, d = /^data:application\/json;base64,/, l = /^data:application\/json;charset=utf-?8,/, p = /^data:application\/json,/, g = s.match(l) || s.match(p);
      if (g)
        return decodeURIComponent(s.substr(g[0].length));
      let v = s.match(f) || s.match(d);
      if (v)
        return o(s.substr(v[0].length));
      let b = s.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + b);
    }
    getAnnotationURL(s) {
      return s.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(s) {
      return typeof s != "object" ? !1 : typeof s.mappings == "string" || typeof s._mappings == "string" || Array.isArray(s.sections);
    }
    loadAnnotation(s) {
      let f = s.match(/\/\*\s*# sourceMappingURL=/g);
      if (!f) return;
      let d = s.lastIndexOf(f.pop()), l = s.indexOf("*/", d);
      d > -1 && l > -1 && (this.annotation = this.getAnnotationURL(s.substring(d, l)));
    }
    loadFile(s) {
      if (this.root = n(s), e(s))
        return this.mapFile = s, t(s, "utf-8").toString().trim();
    }
    loadMap(s, f) {
      if (f === !1) return !1;
      if (f) {
        if (typeof f == "string")
          return f;
        if (typeof f == "function") {
          let d = f(s);
          if (d) {
            let l = this.loadFile(d);
            if (!l)
              throw new Error(
                "Unable to load previous source map: " + d.toString()
              );
            return l;
          }
        } else {
          if (f instanceof i)
            return a.fromSourceMap(f).toString();
          if (f instanceof a)
            return f.toString();
          if (this.isMap(f))
            return JSON.stringify(f);
          throw new Error(
            "Unsupported previous source map format: " + f.toString()
          );
        }
      } else {
        if (this.inline)
          return this.decodeInline(this.annotation);
        if (this.annotation) {
          let d = this.annotation;
          return s && (d = r(n(s), d)), this.loadFile(d);
        }
      }
    }
    startWith(s, f) {
      return s ? s.substr(0, f.length) === f : !1;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  return g3 = c, c.default = c, g3;
}
var v3, U9;
function o1() {
  if (U9) return v3;
  U9 = 1;
  let { nanoid: e } = /* @__PURE__ */ wY(), { isAbsolute: t, resolve: n } = Ss(), { SourceMapConsumer: r, SourceMapGenerator: i } = ai, { fileURLToPath: a, pathToFileURL: o } = ai, c = gg(), u = hO(), s = ai, f = Symbol("fromOffsetCache"), d = !!(r && i), l = !!(n && t);
  class p {
    get from() {
      return this.file || this.id;
    }
    constructor(v, b = {}) {
      if (v === null || typeof v > "u" || typeof v == "object" && !v.toString)
        throw new Error(`PostCSS received ${v} instead of CSS string`);
      if (this.css = v.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, b.document && (this.document = b.document.toString()), b.from && (!l || /^\w+:\/\//.test(b.from) || t(b.from) ? this.file = b.from : this.file = n(b.from)), l && d) {
        let y = new u(this.css, b);
        if (y.text) {
          this.map = y;
          let w = y.consumer().file;
          !this.file && w && (this.file = this.mapResolve(w));
        }
      }
      this.file || (this.id = "<input css " + e(6) + ">"), this.map && (this.map.file = this.from);
    }
    error(v, b, y, w = {}) {
      let C, T, E;
      if (b && typeof b == "object") {
        let $ = b, Z = y;
        if (typeof $.offset == "number") {
          let te = this.fromOffset($.offset);
          b = te.line, y = te.col;
        } else
          b = $.line, y = $.column;
        if (typeof Z.offset == "number") {
          let te = this.fromOffset(Z.offset);
          T = te.line, C = te.col;
        } else
          T = Z.line, C = Z.column;
      } else if (!y) {
        let $ = this.fromOffset(b);
        b = $.line, y = $.col;
      }
      let D = this.origin(b, y, T, C);
      return D ? E = new c(
        v,
        D.endLine === void 0 ? D.line : { column: D.column, line: D.line },
        D.endLine === void 0 ? D.column : { column: D.endColumn, line: D.endLine },
        D.source,
        D.file,
        w.plugin
      ) : E = new c(
        v,
        T === void 0 ? b : { column: y, line: b },
        T === void 0 ? y : { column: C, line: T },
        this.css,
        this.file,
        w.plugin
      ), E.input = { column: y, endColumn: C, endLine: T, line: b, source: this.css }, this.file && (o && (E.input.url = o(this.file).toString()), E.input.file = this.file), E;
    }
    fromOffset(v) {
      let b, y;
      if (this[f])
        y = this[f];
      else {
        let C = this.css.split(`
`);
        y = new Array(C.length);
        let T = 0;
        for (let E = 0, D = C.length; E < D; E++)
          y[E] = T, T += C[E].length + 1;
        this[f] = y;
      }
      b = y[y.length - 1];
      let w = 0;
      if (v >= b)
        w = y.length - 1;
      else {
        let C = y.length - 2, T;
        for (; w < C; )
          if (T = w + (C - w >> 1), v < y[T])
            C = T - 1;
          else if (v >= y[T + 1])
            w = T + 1;
          else {
            w = T;
            break;
          }
      }
      return {
        col: v - y[w] + 1,
        line: w + 1
      };
    }
    mapResolve(v) {
      return /^\w+:\/\//.test(v) ? v : n(this.map.consumer().sourceRoot || this.map.root || ".", v);
    }
    origin(v, b, y, w) {
      if (!this.map) return !1;
      let C = this.map.consumer(), T = C.originalPositionFor({ column: b, line: v });
      if (!T.source) return !1;
      let E;
      typeof y == "number" && (E = C.originalPositionFor({ column: w, line: y }));
      let D;
      t(T.source) ? D = o(T.source) : D = new URL(
        T.source,
        this.map.consumer().sourceRoot || o(this.map.mapFile)
      );
      let $ = {
        column: T.column,
        endColumn: E && E.column,
        endLine: E && E.line,
        line: T.line,
        url: D.toString()
      };
      if (D.protocol === "file:")
        if (a)
          $.file = a(D);
        else
          throw new Error("file: protocol is not available in this PostCSS build");
      let Z = C.sourceContentFor(T.source);
      return Z && ($.source = Z), $;
    }
    toJSON() {
      let v = {};
      for (let b of ["hasBOM", "css", "file", "id"])
        this[b] != null && (v[b] = this[b]);
      return this.map && (v.map = { ...this.map }, v.map.consumerCache && (v.map.consumerCache = void 0)), v;
    }
  }
  return v3 = p, p.default = p, s && s.registerInput && s.registerInput(p), v3;
}
var y3, H9;
function ap() {
  if (H9) return y3;
  H9 = 1;
  let e = Ru(), t, n;
  class r extends e {
    constructor(a) {
      super(a), this.type = "root", this.nodes || (this.nodes = []);
    }
    normalize(a, o, c) {
      let u = super.normalize(a);
      if (o) {
        if (c === "prepend")
          this.nodes.length > 1 ? o.raws.before = this.nodes[1].raws.before : delete o.raws.before;
        else if (this.first !== o)
          for (let s of u)
            s.raws.before = o.raws.before;
      }
      return u;
    }
    removeChild(a, o) {
      let c = this.index(a);
      return !o && c === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[c].raws.before), super.removeChild(a);
    }
    toResult(a = {}) {
      return new t(new n(), this, a).stringify();
    }
  }
  return r.registerLazyResult = (i) => {
    t = i;
  }, r.registerProcessor = (i) => {
    n = i;
  }, y3 = r, r.default = r, e.registerRoot(r), y3;
}
var b3, z9;
function mO() {
  if (z9) return b3;
  z9 = 1;
  let e = {
    comma(t) {
      return e.split(t, [","], !0);
    },
    space(t) {
      let n = [" ", `
`, "	"];
      return e.split(t, n);
    },
    split(t, n, r) {
      let i = [], a = "", o = !1, c = 0, u = !1, s = "", f = !1;
      for (let d of t)
        f ? f = !1 : d === "\\" ? f = !0 : u ? d === s && (u = !1) : d === '"' || d === "'" ? (u = !0, s = d) : d === "(" ? c += 1 : d === ")" ? c > 0 && (c -= 1) : c === 0 && n.includes(d) && (o = !0), o ? (a !== "" && i.push(a.trim()), a = "", o = !1) : a += d;
      return (r || a !== "") && i.push(a.trim()), i;
    }
  };
  return b3 = e, e.default = e, b3;
}
var x3, G9;
function xg() {
  if (G9) return x3;
  G9 = 1;
  let e = Ru(), t = mO();
  class n extends e {
    get selectors() {
      return t.comma(this.selector);
    }
    set selectors(i) {
      let a = this.selector ? this.selector.match(/,\s*/) : null, o = a ? a[0] : "," + this.raw("between", "beforeOpen");
      this.selector = i.join(o);
    }
    constructor(i) {
      super(i), this.type = "rule", this.nodes || (this.nodes = []);
    }
  }
  return x3 = n, n.default = n, e.registerRule(n), x3;
}
var _3, V9;
function SY() {
  if (V9) return _3;
  V9 = 1;
  let e = yg(), t = i1(), n = a1(), r = o1(), i = hO(), a = ap(), o = xg();
  function c(u, s) {
    if (Array.isArray(u)) return u.map((l) => c(l));
    let { inputs: f, ...d } = u;
    if (f) {
      s = [];
      for (let l of f) {
        let p = { ...l, __proto__: r.prototype };
        p.map && (p.map = {
          ...p.map,
          __proto__: i.prototype
        }), s.push(p);
      }
    }
    if (d.nodes && (d.nodes = u.nodes.map((l) => c(l, s))), d.source) {
      let { inputId: l, ...p } = d.source;
      d.source = p, l != null && (d.source.input = s[l]);
    }
    if (d.type === "root")
      return new a(d);
    if (d.type === "decl")
      return new n(d);
    if (d.type === "rule")
      return new o(d);
    if (d.type === "comment")
      return new t(d);
    if (d.type === "atrule")
      return new e(d);
    throw new Error("Unknown node type: " + u.type);
  }
  return _3 = c, c.default = c, _3;
}
var w3, W9;
function gO() {
  if (W9) return w3;
  W9 = 1;
  let { dirname: e, relative: t, resolve: n, sep: r } = Ss(), { SourceMapConsumer: i, SourceMapGenerator: a } = ai, { pathToFileURL: o } = ai, c = o1(), u = !!(i && a), s = !!(e && n && t && r);
  class f {
    constructor(l, p, g, v) {
      this.stringify = l, this.mapOpts = g.map || {}, this.root = p, this.opts = g, this.css = v, this.originalCSS = v, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let l;
      this.isInline() ? l = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? l = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? l = this.mapOpts.annotation(this.opts.to, this.root) : l = this.outputFile() + ".map";
      let p = `
`;
      this.css.includes(`\r
`) && (p = `\r
`), this.css += p + "/*# sourceMappingURL=" + l + " */";
    }
    applyPrevMaps() {
      for (let l of this.previous()) {
        let p = this.toUrl(this.path(l.file)), g = l.root || e(l.file), v;
        this.mapOpts.sourcesContent === !1 ? (v = new i(l.text), v.sourcesContent && (v.sourcesContent = null)) : v = l.consumer(), this.map.applySourceMap(v, p, this.toUrl(this.path(g)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation !== !1)
        if (this.root) {
          let l;
          for (let p = this.root.nodes.length - 1; p >= 0; p--)
            l = this.root.nodes[p], l.type === "comment" && l.text.startsWith("# sourceMappingURL=") && this.root.removeChild(p);
        } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
    }
    generate() {
      if (this.clearAnnotation(), s && u && this.isMap())
        return this.generateMap();
      {
        let l = "";
        return this.stringify(this.root, (p) => {
          l += p;
        }), [l];
      }
    }
    generateMap() {
      if (this.root)
        this.generateString();
      else if (this.previous().length === 1) {
        let l = this.previous()[0].consumer();
        l.file = this.outputFile(), this.map = a.fromSourceMap(l, {
          ignoreInvalidMapping: !0
        });
      } else
        this.map = new a({
          file: this.outputFile(),
          ignoreInvalidMapping: !0
        }), this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
    }
    generateString() {
      this.css = "", this.map = new a({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      });
      let l = 1, p = 1, g = "<no source>", v = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      }, b, y;
      this.stringify(this.root, (w, C, T) => {
        if (this.css += w, C && T !== "end" && (v.generated.line = l, v.generated.column = p - 1, C.source && C.source.start ? (v.source = this.sourcePath(C), v.original.line = C.source.start.line, v.original.column = C.source.start.column - 1, this.map.addMapping(v)) : (v.source = g, v.original.line = 1, v.original.column = 0, this.map.addMapping(v))), y = w.match(/\n/g), y ? (l += y.length, b = w.lastIndexOf(`
`), p = w.length - b) : p += w.length, C && T !== "start") {
          let E = C.parent || { raws: {} };
          (!(C.type === "decl" || C.type === "atrule" && !C.nodes) || C !== E.last || E.raws.semicolon) && (C.source && C.source.end ? (v.source = this.sourcePath(C), v.original.line = C.source.end.line, v.original.column = C.source.end.column - 1, v.generated.line = l, v.generated.column = p - 2, this.map.addMapping(v)) : (v.source = g, v.original.line = 1, v.original.column = 0, v.generated.line = l, v.generated.column = p - 1, this.map.addMapping(v)));
        }
      });
    }
    isAnnotation() {
      return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((l) => l.annotation) : !0;
    }
    isInline() {
      if (typeof this.mapOpts.inline < "u")
        return this.mapOpts.inline;
      let l = this.mapOpts.annotation;
      return typeof l < "u" && l !== !0 ? !1 : this.previous().length ? this.previous().some((p) => p.inline) : !0;
    }
    isMap() {
      return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
    }
    isSourcesContent() {
      return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((l) => l.withContent()) : !0;
    }
    outputFile() {
      return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
    }
    path(l) {
      if (this.mapOpts.absolute || l.charCodeAt(0) === 60 || /^\w+:\/\//.test(l)) return l;
      let p = this.memoizedPaths.get(l);
      if (p) return p;
      let g = this.opts.to ? e(this.opts.to) : ".";
      typeof this.mapOpts.annotation == "string" && (g = e(n(g, this.mapOpts.annotation)));
      let v = t(g, l);
      return this.memoizedPaths.set(l, v), v;
    }
    previous() {
      if (!this.previousMaps)
        if (this.previousMaps = [], this.root)
          this.root.walk((l) => {
            if (l.source && l.source.input.map) {
              let p = l.source.input.map;
              this.previousMaps.includes(p) || this.previousMaps.push(p);
            }
          });
        else {
          let l = new c(this.originalCSS, this.opts);
          l.map && this.previousMaps.push(l.map);
        }
      return this.previousMaps;
    }
    setSourcesContent() {
      let l = {};
      if (this.root)
        this.root.walk((p) => {
          if (p.source) {
            let g = p.source.input.from;
            if (g && !l[g]) {
              l[g] = !0;
              let v = this.usesFileUrls ? this.toFileUrl(g) : this.toUrl(this.path(g));
              this.map.setSourceContent(v, p.source.input.css);
            }
          }
        });
      else if (this.css) {
        let p = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(p, this.css);
      }
    }
    sourcePath(l) {
      return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(l.source.input.from) : this.toUrl(this.path(l.source.input.from));
    }
    toBase64(l) {
      return Dn ? Dn.from(l).toString("base64") : window.btoa(unescape(encodeURIComponent(l)));
    }
    toFileUrl(l) {
      let p = this.memoizedFileURLs.get(l);
      if (p) return p;
      if (o) {
        let g = o(l).toString();
        return this.memoizedFileURLs.set(l, g), g;
      } else
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
    }
    toUrl(l) {
      let p = this.memoizedURLs.get(l);
      if (p) return p;
      r === "\\" && (l = l.replace(/\\/g, "/"));
      let g = encodeURI(l).replace(/[#?]/g, encodeURIComponent);
      return this.memoizedURLs.set(l, g), g;
    }
  }
  return w3 = f, w3;
}
var S3, K9;
function CY() {
  if (K9) return S3;
  K9 = 1;
  const e = 39, t = 34, n = 92, r = 47, i = 10, a = 32, o = 12, c = 9, u = 13, s = 91, f = 93, d = 40, l = 41, p = 123, g = 125, v = 59, b = 42, y = 58, w = 64, C = /[\t\n\f\r "#'()/;[\\\]{}]/g, T = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, E = /.[\r\n"'(/\\]/, D = /[\da-f]/i;
  return S3 = function(Z, te = {}) {
    let se = Z.css.valueOf(), ee = te.ignoreErrors, K, re, de, ie, me, $e, Pe, Le, Ae, He, Te = se.length, we = 0, qe = [], Ge = [];
    function It() {
      return we;
    }
    function Qe(Fe) {
      throw Z.error("Unclosed " + Fe, we);
    }
    function jt() {
      return Ge.length === 0 && we >= Te;
    }
    function We(Fe) {
      if (Ge.length) return Ge.pop();
      if (we >= Te) return;
      let Ze = Fe ? Fe.ignoreUnclosed : !1;
      switch (K = se.charCodeAt(we), K) {
        case i:
        case a:
        case c:
        case u:
        case o: {
          ie = we;
          do
            ie += 1, K = se.charCodeAt(ie);
          while (K === a || K === i || K === c || K === u || K === o);
          $e = ["space", se.slice(we, ie)], we = ie - 1;
          break;
        }
        case s:
        case f:
        case p:
        case g:
        case y:
        case v:
        case l: {
          let Ue = String.fromCharCode(K);
          $e = [Ue, Ue, we];
          break;
        }
        case d: {
          if (He = qe.length ? qe.pop()[1] : "", Ae = se.charCodeAt(we + 1), He === "url" && Ae !== e && Ae !== t && Ae !== a && Ae !== i && Ae !== c && Ae !== o && Ae !== u) {
            ie = we;
            do {
              if (Pe = !1, ie = se.indexOf(")", ie + 1), ie === -1)
                if (ee || Ze) {
                  ie = we;
                  break;
                } else
                  Qe("bracket");
              for (Le = ie; se.charCodeAt(Le - 1) === n; )
                Le -= 1, Pe = !Pe;
            } while (Pe);
            $e = ["brackets", se.slice(we, ie + 1), we, ie], we = ie;
          } else
            ie = se.indexOf(")", we + 1), re = se.slice(we, ie + 1), ie === -1 || E.test(re) ? $e = ["(", "(", we] : ($e = ["brackets", re, we, ie], we = ie);
          break;
        }
        case e:
        case t: {
          me = K === e ? "'" : '"', ie = we;
          do {
            if (Pe = !1, ie = se.indexOf(me, ie + 1), ie === -1)
              if (ee || Ze) {
                ie = we + 1;
                break;
              } else
                Qe("string");
            for (Le = ie; se.charCodeAt(Le - 1) === n; )
              Le -= 1, Pe = !Pe;
          } while (Pe);
          $e = ["string", se.slice(we, ie + 1), we, ie], we = ie;
          break;
        }
        case w: {
          C.lastIndex = we + 1, C.test(se), C.lastIndex === 0 ? ie = se.length - 1 : ie = C.lastIndex - 2, $e = ["at-word", se.slice(we, ie + 1), we, ie], we = ie;
          break;
        }
        case n: {
          for (ie = we, de = !0; se.charCodeAt(ie + 1) === n; )
            ie += 1, de = !de;
          if (K = se.charCodeAt(ie + 1), de && K !== r && K !== a && K !== i && K !== c && K !== u && K !== o && (ie += 1, D.test(se.charAt(ie)))) {
            for (; D.test(se.charAt(ie + 1)); )
              ie += 1;
            se.charCodeAt(ie + 1) === a && (ie += 1);
          }
          $e = ["word", se.slice(we, ie + 1), we, ie], we = ie;
          break;
        }
        default: {
          K === r && se.charCodeAt(we + 1) === b ? (ie = se.indexOf("*/", we + 2) + 1, ie === 0 && (ee || Ze ? ie = se.length : Qe("comment")), $e = ["comment", se.slice(we, ie + 1), we, ie], we = ie) : (T.lastIndex = we + 1, T.test(se), T.lastIndex === 0 ? ie = se.length - 1 : ie = T.lastIndex - 2, $e = ["word", se.slice(we, ie + 1), we, ie], qe.push($e), we = ie);
          break;
        }
      }
      return we++, $e;
    }
    function Lt(Fe) {
      Ge.push(Fe);
    }
    return {
      back: Lt,
      endOfFile: jt,
      nextToken: We,
      position: It
    };
  }, S3;
}
var C3, Z9;
function AY() {
  if (Z9) return C3;
  Z9 = 1;
  let e = yg(), t = i1(), n = a1(), r = ap(), i = xg(), a = CY();
  const o = {
    empty: !0,
    space: !0
  };
  function c(s) {
    for (let f = s.length - 1; f >= 0; f--) {
      let d = s[f], l = d[3] || d[2];
      if (l) return l;
    }
  }
  class u {
    constructor(f) {
      this.input = f, this.root = new r(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: f, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(f) {
      let d = new e();
      d.name = f[1].slice(1), d.name === "" && this.unnamedAtrule(d, f), this.init(d, f[2]);
      let l, p, g, v = !1, b = !1, y = [], w = [];
      for (; !this.tokenizer.endOfFile(); ) {
        if (f = this.tokenizer.nextToken(), l = f[0], l === "(" || l === "[" ? w.push(l === "(" ? ")" : "]") : l === "{" && w.length > 0 ? w.push("}") : l === w[w.length - 1] && w.pop(), w.length === 0)
          if (l === ";") {
            d.source.end = this.getPosition(f[2]), d.source.end.offset++, this.semicolon = !0;
            break;
          } else if (l === "{") {
            b = !0;
            break;
          } else if (l === "}") {
            if (y.length > 0) {
              for (g = y.length - 1, p = y[g]; p && p[0] === "space"; )
                p = y[--g];
              p && (d.source.end = this.getPosition(p[3] || p[2]), d.source.end.offset++);
            }
            this.end(f);
            break;
          } else
            y.push(f);
        else
          y.push(f);
        if (this.tokenizer.endOfFile()) {
          v = !0;
          break;
        }
      }
      d.raws.between = this.spacesAndCommentsFromEnd(y), y.length ? (d.raws.afterName = this.spacesAndCommentsFromStart(y), this.raw(d, "params", y), v && (f = y[y.length - 1], d.source.end = this.getPosition(f[3] || f[2]), d.source.end.offset++, this.spaces = d.raws.between, d.raws.between = "")) : (d.raws.afterName = "", d.params = ""), b && (d.nodes = [], this.current = d);
    }
    checkMissedSemicolon(f) {
      let d = this.colon(f);
      if (d === !1) return;
      let l = 0, p;
      for (let g = d - 1; g >= 0 && (p = f[g], !(p[0] !== "space" && (l += 1, l === 2))); g--)
        ;
      throw this.input.error(
        "Missed semicolon",
        p[0] === "word" ? p[3] + 1 : p[2]
      );
    }
    colon(f) {
      let d = 0, l, p, g;
      for (let [v, b] of f.entries()) {
        if (p = b, g = p[0], g === "(" && (d += 1), g === ")" && (d -= 1), d === 0 && g === ":")
          if (!l)
            this.doubleColon(p);
          else {
            if (l[0] === "word" && l[1] === "progid")
              continue;
            return v;
          }
        l = p;
      }
      return !1;
    }
    comment(f) {
      let d = new t();
      this.init(d, f[2]), d.source.end = this.getPosition(f[3] || f[2]), d.source.end.offset++;
      let l = f[1].slice(2, -2);
      if (/^\s*$/.test(l))
        d.text = "", d.raws.left = l, d.raws.right = "";
      else {
        let p = l.match(/^(\s*)([^]*\S)(\s*)$/);
        d.text = p[2], d.raws.left = p[1], d.raws.right = p[3];
      }
    }
    createTokenizer() {
      this.tokenizer = a(this.input);
    }
    decl(f, d) {
      let l = new n();
      this.init(l, f[0][2]);
      let p = f[f.length - 1];
      for (p[0] === ";" && (this.semicolon = !0, f.pop()), l.source.end = this.getPosition(
        p[3] || p[2] || c(f)
      ), l.source.end.offset++; f[0][0] !== "word"; )
        f.length === 1 && this.unknownWord(f), l.raws.before += f.shift()[1];
      for (l.source.start = this.getPosition(f[0][2]), l.prop = ""; f.length; ) {
        let w = f[0][0];
        if (w === ":" || w === "space" || w === "comment")
          break;
        l.prop += f.shift()[1];
      }
      l.raws.between = "";
      let g;
      for (; f.length; )
        if (g = f.shift(), g[0] === ":") {
          l.raws.between += g[1];
          break;
        } else
          g[0] === "word" && /\w/.test(g[1]) && this.unknownWord([g]), l.raws.between += g[1];
      (l.prop[0] === "_" || l.prop[0] === "*") && (l.raws.before += l.prop[0], l.prop = l.prop.slice(1));
      let v = [], b;
      for (; f.length && (b = f[0][0], !(b !== "space" && b !== "comment")); )
        v.push(f.shift());
      this.precheckMissedSemicolon(f);
      for (let w = f.length - 1; w >= 0; w--) {
        if (g = f[w], g[1].toLowerCase() === "!important") {
          l.important = !0;
          let C = this.stringFrom(f, w);
          C = this.spacesFromEnd(f) + C, C !== " !important" && (l.raws.important = C);
          break;
        } else if (g[1].toLowerCase() === "important") {
          let C = f.slice(0), T = "";
          for (let E = w; E > 0; E--) {
            let D = C[E][0];
            if (T.trim().startsWith("!") && D !== "space")
              break;
            T = C.pop()[1] + T;
          }
          T.trim().startsWith("!") && (l.important = !0, l.raws.important = T, f = C);
        }
        if (g[0] !== "space" && g[0] !== "comment")
          break;
      }
      f.some((w) => w[0] !== "space" && w[0] !== "comment") && (l.raws.between += v.map((w) => w[1]).join(""), v = []), this.raw(l, "value", v.concat(f), d), l.value.includes(":") && !d && this.checkMissedSemicolon(f);
    }
    doubleColon(f) {
      throw this.input.error(
        "Double colon",
        { offset: f[2] },
        { offset: f[2] + f[1].length }
      );
    }
    emptyRule(f) {
      let d = new i();
      this.init(d, f[2]), d.selector = "", d.raws.between = "", this.current = d;
    }
    end(f) {
      this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(f[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(f);
    }
    endFile() {
      this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(f) {
      if (this.spaces += f[1], this.current.nodes) {
        let d = this.current.nodes[this.current.nodes.length - 1];
        d && d.type === "rule" && !d.raws.ownSemicolon && (d.raws.ownSemicolon = this.spaces, this.spaces = "", d.source.end = this.getPosition(f[2]), d.source.end.offset += d.raws.ownSemicolon.length);
      }
    }
    // Helpers
    getPosition(f) {
      let d = this.input.fromOffset(f);
      return {
        column: d.col,
        line: d.line,
        offset: f
      };
    }
    init(f, d) {
      this.current.push(f), f.source = {
        input: this.input,
        start: this.getPosition(d)
      }, f.raws.before = this.spaces, this.spaces = "", f.type !== "comment" && (this.semicolon = !1);
    }
    other(f) {
      let d = !1, l = null, p = !1, g = null, v = [], b = f[1].startsWith("--"), y = [], w = f;
      for (; w; ) {
        if (l = w[0], y.push(w), l === "(" || l === "[")
          g || (g = w), v.push(l === "(" ? ")" : "]");
        else if (b && p && l === "{")
          g || (g = w), v.push("}");
        else if (v.length === 0)
          if (l === ";")
            if (p) {
              this.decl(y, b);
              return;
            } else
              break;
          else if (l === "{") {
            this.rule(y);
            return;
          } else if (l === "}") {
            this.tokenizer.back(y.pop()), d = !0;
            break;
          } else l === ":" && (p = !0);
        else l === v[v.length - 1] && (v.pop(), v.length === 0 && (g = null));
        w = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile() && (d = !0), v.length > 0 && this.unclosedBracket(g), d && p) {
        if (!b)
          for (; y.length && (w = y[y.length - 1][0], !(w !== "space" && w !== "comment")); )
            this.tokenizer.back(y.pop());
        this.decl(y, b);
      } else
        this.unknownWord(y);
    }
    parse() {
      let f;
      for (; !this.tokenizer.endOfFile(); )
        switch (f = this.tokenizer.nextToken(), f[0]) {
          case "space":
            this.spaces += f[1];
            break;
          case ";":
            this.freeSemicolon(f);
            break;
          case "}":
            this.end(f);
            break;
          case "comment":
            this.comment(f);
            break;
          case "at-word":
            this.atrule(f);
            break;
          case "{":
            this.emptyRule(f);
            break;
          default:
            this.other(f);
            break;
        }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(f, d, l, p) {
      let g, v, b = l.length, y = "", w = !0, C, T;
      for (let E = 0; E < b; E += 1)
        g = l[E], v = g[0], v === "space" && E === b - 1 && !p ? w = !1 : v === "comment" ? (T = l[E - 1] ? l[E - 1][0] : "empty", C = l[E + 1] ? l[E + 1][0] : "empty", !o[T] && !o[C] ? y.slice(-1) === "," ? w = !1 : y += g[1] : w = !1) : y += g[1];
      if (!w) {
        let E = l.reduce((D, $) => D + $[1], "");
        f.raws[d] = { raw: E, value: y };
      }
      f[d] = y;
    }
    rule(f) {
      f.pop();
      let d = new i();
      this.init(d, f[0][2]), d.raws.between = this.spacesAndCommentsFromEnd(f), this.raw(d, "selector", f), this.current = d;
    }
    spacesAndCommentsFromEnd(f) {
      let d, l = "";
      for (; f.length && (d = f[f.length - 1][0], !(d !== "space" && d !== "comment")); )
        l = f.pop()[1] + l;
      return l;
    }
    // Errors
    spacesAndCommentsFromStart(f) {
      let d, l = "";
      for (; f.length && (d = f[0][0], !(d !== "space" && d !== "comment")); )
        l += f.shift()[1];
      return l;
    }
    spacesFromEnd(f) {
      let d, l = "";
      for (; f.length && (d = f[f.length - 1][0], d === "space"); )
        l = f.pop()[1] + l;
      return l;
    }
    stringFrom(f, d) {
      let l = "";
      for (let p = d; p < f.length; p++)
        l += f[p][1];
      return f.splice(d, f.length - d), l;
    }
    unclosedBlock() {
      let f = this.current.source.start;
      throw this.input.error("Unclosed block", f.line, f.column);
    }
    unclosedBracket(f) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: f[2] },
        { offset: f[2] + 1 }
      );
    }
    unexpectedClose(f) {
      throw this.input.error(
        "Unexpected }",
        { offset: f[2] },
        { offset: f[2] + 1 }
      );
    }
    unknownWord(f) {
      throw this.input.error(
        "Unknown word " + f[0][1],
        { offset: f[0][2] },
        { offset: f[0][2] + f[0][1].length }
      );
    }
    unnamedAtrule(f, d) {
      throw this.input.error(
        "At-rule without name",
        { offset: d[2] },
        { offset: d[2] + d[1].length }
      );
    }
  }
  return C3 = u, C3;
}
var A3, Y9;
function _g() {
  if (Y9) return A3;
  Y9 = 1;
  let e = Ru(), t = o1(), n = AY();
  function r(i, a) {
    let o = new t(i, a), c = new n(o);
    try {
      c.parse();
    } catch (u) {
      throw bn.env.NODE_ENV !== "production" && u.name === "CssSyntaxError" && a && a.from && (/\.scss$/i.test(a.from) ? u.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(a.from) ? u.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(a.from) && (u.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), u;
    }
    return c.root;
  }
  return A3 = r, r.default = r, e.registerParse(r), A3;
}
var k3, J9;
function vO() {
  if (J9) return k3;
  J9 = 1;
  class e {
    constructor(n, r = {}) {
      if (this.type = "warning", this.text = n, r.node && r.node.source) {
        let i = r.node.rangeBy(r);
        this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
      }
      for (let i in r) this[i] = r[i];
    }
    toString() {
      return this.node ? this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
    }
  }
  return k3 = e, e.default = e, k3;
}
var E3, Q9;
function wg() {
  if (Q9) return E3;
  Q9 = 1;
  let e = vO();
  class t {
    get content() {
      return this.css;
    }
    constructor(r, i, a) {
      this.processor = r, this.messages = [], this.root = i, this.opts = a, this.css = void 0, this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(r, i = {}) {
      i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
      let a = new e(r, i);
      return this.messages.push(a), a;
    }
    warnings() {
      return this.messages.filter((r) => r.type === "warning");
    }
  }
  return E3 = t, t.default = t, E3;
}
var O3, X9;
function yO() {
  if (X9) return O3;
  X9 = 1;
  let e = {};
  return O3 = function(n) {
    e[n] || (e[n] = !0, typeof console < "u" && console.warn && console.warn(n));
  }, O3;
}
var T3, e_;
function bO() {
  if (e_) return T3;
  e_ = 1;
  let e = Ru(), t = bg(), n = gO(), r = _g(), i = wg(), a = ap(), o = r1(), { isClean: c, my: u } = vg(), s = yO();
  const f = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  }, d = {
    AtRule: !0,
    AtRuleExit: !0,
    Comment: !0,
    CommentExit: !0,
    Declaration: !0,
    DeclarationExit: !0,
    Document: !0,
    DocumentExit: !0,
    Once: !0,
    OnceExit: !0,
    postcssPlugin: !0,
    prepare: !0,
    Root: !0,
    RootExit: !0,
    Rule: !0,
    RuleExit: !0
  }, l = {
    Once: !0,
    postcssPlugin: !0,
    prepare: !0
  }, p = 0;
  function g(T) {
    return typeof T == "object" && typeof T.then == "function";
  }
  function v(T) {
    let E = !1, D = f[T.type];
    return T.type === "decl" ? E = T.prop.toLowerCase() : T.type === "atrule" && (E = T.name.toLowerCase()), E && T.append ? [
      D,
      D + "-" + E,
      p,
      D + "Exit",
      D + "Exit-" + E
    ] : E ? [D, D + "-" + E, D + "Exit", D + "Exit-" + E] : T.append ? [D, p, D + "Exit"] : [D, D + "Exit"];
  }
  function b(T) {
    let E;
    return T.type === "document" ? E = ["Document", p, "DocumentExit"] : T.type === "root" ? E = ["Root", p, "RootExit"] : E = v(T), {
      eventIndex: 0,
      events: E,
      iterator: 0,
      node: T,
      visitorIndex: 0,
      visitors: []
    };
  }
  function y(T) {
    return T[c] = !1, T.nodes && T.nodes.forEach((E) => y(E)), T;
  }
  let w = {};
  class C {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(E, D, $) {
      this.stringified = !1, this.processed = !1;
      let Z;
      if (typeof D == "object" && D !== null && (D.type === "root" || D.type === "document"))
        Z = y(D);
      else if (D instanceof C || D instanceof i)
        Z = y(D.root), D.map && (typeof $.map > "u" && ($.map = {}), $.map.inline || ($.map.inline = !1), $.map.prev = D.map);
      else {
        let te = r;
        $.syntax && (te = $.syntax.parse), $.parser && (te = $.parser), te.parse && (te = te.parse);
        try {
          Z = te(D, $);
        } catch (se) {
          this.processed = !0, this.error = se;
        }
        Z && !Z[u] && e.rebuild(Z);
      }
      this.result = new i(E, Z, $), this.helpers = { ...w, postcss: w, result: this.result }, this.plugins = this.processor.plugins.map((te) => typeof te == "object" && te.prepare ? { ...te, ...te.prepare(this.result) } : te);
    }
    async() {
      return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
    }
    catch(E) {
      return this.async().catch(E);
    }
    finally(E) {
      return this.async().then(E, E);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(E, D) {
      let $ = this.result.lastPlugin;
      try {
        if (D && D.addToError(E), this.error = E, E.name === "CssSyntaxError" && !E.plugin)
          E.plugin = $.postcssPlugin, E.setMessage();
        else if ($.postcssVersion && bn.env.NODE_ENV !== "production") {
          let Z = $.postcssPlugin, te = $.postcssVersion, se = this.result.processor.version, ee = te.split("."), K = se.split(".");
          (ee[0] !== K[0] || parseInt(ee[1]) > parseInt(K[1])) && console.error(
            "Unknown error from PostCSS plugin. Your current PostCSS version is " + se + ", but " + Z + " uses " + te + ". Perhaps this is the source of the error below."
          );
        }
      } catch (Z) {
        console && console.error && console.error(Z);
      }
      return E;
    }
    prepareVisitors() {
      this.listeners = {};
      let E = (D, $, Z) => {
        this.listeners[$] || (this.listeners[$] = []), this.listeners[$].push([D, Z]);
      };
      for (let D of this.plugins)
        if (typeof D == "object")
          for (let $ in D) {
            if (!d[$] && /^[A-Z]/.test($))
              throw new Error(
                `Unknown event ${$} in ${D.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            if (!l[$])
              if (typeof D[$] == "object")
                for (let Z in D[$])
                  Z === "*" ? E(D, $, D[$][Z]) : E(
                    D,
                    $ + "-" + Z.toLowerCase(),
                    D[$][Z]
                  );
              else typeof D[$] == "function" && E(D, $, D[$]);
          }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let E = 0; E < this.plugins.length; E++) {
        let D = this.plugins[E], $ = this.runOnRoot(D);
        if (g($))
          try {
            await $;
          } catch (Z) {
            throw this.handleError(Z);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let E = this.result.root;
        for (; !E[c]; ) {
          E[c] = !0;
          let D = [b(E)];
          for (; D.length > 0; ) {
            let $ = this.visitTick(D);
            if (g($))
              try {
                await $;
              } catch (Z) {
                let te = D[D.length - 1].node;
                throw this.handleError(Z, te);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [D, $] of this.listeners.OnceExit) {
            this.result.lastPlugin = D;
            try {
              if (E.type === "document") {
                let Z = E.nodes.map(
                  (te) => $(te, this.helpers)
                );
                await Promise.all(Z);
              } else
                await $(E, this.helpers);
            } catch (Z) {
              throw this.handleError(Z);
            }
          }
      }
      return this.processed = !0, this.stringify();
    }
    runOnRoot(E) {
      this.result.lastPlugin = E;
      try {
        if (typeof E == "object" && E.Once) {
          if (this.result.root.type === "document") {
            let D = this.result.root.nodes.map(
              ($) => E.Once($, this.helpers)
            );
            return g(D[0]) ? Promise.all(D) : D;
          }
          return E.Once(this.result.root, this.helpers);
        } else if (typeof E == "function")
          return E(this.result.root, this.result);
      } catch (D) {
        throw this.handleError(D);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = !0, this.sync();
      let E = this.result.opts, D = o;
      E.syntax && (D = E.syntax.stringify), E.stringifier && (D = E.stringifier), D.stringify && (D = D.stringify);
      let Z = new n(D, this.result.root, this.result.opts).generate();
      return this.result.css = Z[0], this.result.map = Z[1], this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      if (this.processed = !0, this.processing)
        throw this.getAsyncError();
      for (let E of this.plugins) {
        let D = this.runOnRoot(E);
        if (g(D))
          throw this.getAsyncError();
      }
      if (this.prepareVisitors(), this.hasListener) {
        let E = this.result.root;
        for (; !E[c]; )
          E[c] = !0, this.walkSync(E);
        if (this.listeners.OnceExit)
          if (E.type === "document")
            for (let D of E.nodes)
              this.visitSync(this.listeners.OnceExit, D);
          else
            this.visitSync(this.listeners.OnceExit, E);
      }
      return this.result;
    }
    then(E, D) {
      return bn.env.NODE_ENV !== "production" && ("from" in this.opts || s(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(E, D);
    }
    toString() {
      return this.css;
    }
    visitSync(E, D) {
      for (let [$, Z] of E) {
        this.result.lastPlugin = $;
        let te;
        try {
          te = Z(D, this.helpers);
        } catch (se) {
          throw this.handleError(se, D.proxyOf);
        }
        if (D.type !== "root" && D.type !== "document" && !D.parent)
          return !0;
        if (g(te))
          throw this.getAsyncError();
      }
    }
    visitTick(E) {
      let D = E[E.length - 1], { node: $, visitors: Z } = D;
      if ($.type !== "root" && $.type !== "document" && !$.parent) {
        E.pop();
        return;
      }
      if (Z.length > 0 && D.visitorIndex < Z.length) {
        let [se, ee] = Z[D.visitorIndex];
        D.visitorIndex += 1, D.visitorIndex === Z.length && (D.visitors = [], D.visitorIndex = 0), this.result.lastPlugin = se;
        try {
          return ee($.toProxy(), this.helpers);
        } catch (K) {
          throw this.handleError(K, $);
        }
      }
      if (D.iterator !== 0) {
        let se = D.iterator, ee;
        for (; ee = $.nodes[$.indexes[se]]; )
          if ($.indexes[se] += 1, !ee[c]) {
            ee[c] = !0, E.push(b(ee));
            return;
          }
        D.iterator = 0, delete $.indexes[se];
      }
      let te = D.events;
      for (; D.eventIndex < te.length; ) {
        let se = te[D.eventIndex];
        if (D.eventIndex += 1, se === p) {
          $.nodes && $.nodes.length && ($[c] = !0, D.iterator = $.getIterator());
          return;
        } else if (this.listeners[se]) {
          D.visitors = this.listeners[se];
          return;
        }
      }
      E.pop();
    }
    walkSync(E) {
      E[c] = !0;
      let D = v(E);
      for (let $ of D)
        if ($ === p)
          E.nodes && E.each((Z) => {
            Z[c] || this.walkSync(Z);
          });
        else {
          let Z = this.listeners[$];
          if (Z && this.visitSync(Z, E.toProxy()))
            return;
        }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  return C.registerPostcss = (T) => {
    w = T;
  }, T3 = C, C.default = C, a.registerLazyResult(C), t.registerLazyResult(C), T3;
}
var P3, t_;
function kY() {
  if (t_) return P3;
  t_ = 1;
  let e = gO(), t = _g();
  const n = wg();
  let r = r1(), i = yO();
  class a {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root)
        return this._root;
      let c, u = t;
      try {
        c = u(this._css, this._opts);
      } catch (s) {
        this.error = s;
      }
      if (this.error)
        throw this.error;
      return this._root = c, c;
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(c, u, s) {
      u = u.toString(), this.stringified = !1, this._processor = c, this._css = u, this._opts = s, this._map = void 0;
      let f, d = r;
      this.result = new n(this._processor, f, this._opts), this.result.css = u;
      let l = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return l.root;
        }
      });
      let p = new e(d, f, this._opts, u);
      if (p.isMap()) {
        let [g, v] = p.generate();
        g && (this.result.css = g), v && (this.result.map = v);
      } else
        p.clearAnnotation(), this.result.css = p.css;
    }
    async() {
      return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
    }
    catch(c) {
      return this.async().catch(c);
    }
    finally(c) {
      return this.async().then(c, c);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(c, u) {
      return bn.env.NODE_ENV !== "production" && ("from" in this._opts || i(
        "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
      )), this.async().then(c, u);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  return P3 = a, a.default = a, P3;
}
var R3, r_;
function EY() {
  if (r_) return R3;
  r_ = 1;
  let e = bg(), t = bO(), n = kY(), r = ap();
  class i {
    constructor(o = []) {
      this.version = "8.5.3", this.plugins = this.normalize(o);
    }
    normalize(o) {
      let c = [];
      for (let u of o)
        if (u.postcss === !0 ? u = u() : u.postcss && (u = u.postcss), typeof u == "object" && Array.isArray(u.plugins))
          c = c.concat(u.plugins);
        else if (typeof u == "object" && u.postcssPlugin)
          c.push(u);
        else if (typeof u == "function")
          c.push(u);
        else if (typeof u == "object" && (u.parse || u.stringify)) {
          if (bn.env.NODE_ENV !== "production")
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
        } else
          throw new Error(u + " is not a PostCSS plugin");
      return c;
    }
    process(o, c = {}) {
      return !this.plugins.length && !c.parser && !c.stringifier && !c.syntax ? new n(this, o, c) : new t(this, o, c);
    }
    use(o) {
      return this.plugins = this.plugins.concat(this.normalize([o])), this;
    }
  }
  return R3 = i, i.default = i, r.registerProcessor(i), e.registerProcessor(i), R3;
}
var j3, n_;
function OY() {
  if (n_) return j3;
  n_ = 1;
  let e = yg(), t = i1(), n = Ru(), r = gg(), i = a1(), a = bg(), o = SY(), c = o1(), u = bO(), s = mO(), f = n1(), d = _g(), l = EY(), p = wg(), g = ap(), v = xg(), b = r1(), y = vO();
  function w(...C) {
    return C.length === 1 && Array.isArray(C[0]) && (C = C[0]), new l(C);
  }
  return w.plugin = function(T, E) {
    let D = !1;
    function $(...te) {
      console && console.warn && !D && (D = !0, console.warn(
        T + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
      ), bn.env.LANG && bn.env.LANG.startsWith("cn") && console.warn(
        T + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
      ));
      let se = E(...te);
      return se.postcssPlugin = T, se.postcssVersion = new l().version, se;
    }
    let Z;
    return Object.defineProperty($, "postcss", {
      get() {
        return Z || (Z = $()), Z;
      }
    }), $.process = function(te, se, ee) {
      return w([$(ee)]).process(te, se);
    }, $;
  }, w.stringify = b, w.parse = d, w.fromJSON = o, w.list = s, w.comment = (C) => new t(C), w.atRule = (C) => new e(C), w.decl = (C) => new i(C), w.rule = (C) => new v(C), w.root = (C) => new g(C), w.document = (C) => new a(C), w.CssSyntaxError = r, w.Declaration = i, w.Container = n, w.Processor = l, w.Document = a, w.Comment = t, w.Warning = y, w.AtRule = e, w.Result = p, w.Input = c, w.Rule = v, w.Root = g, w.Node = f, u.registerPostcss(w), j3 = w, w.default = w, j3;
}
var I3, i_;
function TY() {
  if (i_) return I3;
  i_ = 1;
  const e = /* @__PURE__ */ mY(), t = gY(), { isPlainObject: n } = vY(), r = yY(), i = xY(), { parse: a } = OY(), o = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ], c = ["script", "style"];
  function u(b, y) {
    b && Object.keys(b).forEach(function(w) {
      y(b[w], w);
    });
  }
  function s(b, y) {
    return {}.hasOwnProperty.call(b, y);
  }
  function f(b, y) {
    const w = [];
    return u(b, function(C) {
      y(C) && w.push(C);
    }), w;
  }
  function d(b) {
    for (const y in b)
      if (s(b, y))
        return !1;
    return !0;
  }
  function l(b) {
    return b.map(function(y) {
      if (!y.url)
        throw new Error("URL missing");
      return y.url + (y.w ? ` ${y.w}w` : "") + (y.h ? ` ${y.h}h` : "") + (y.d ? ` ${y.d}x` : "");
    }).join(", ");
  }
  I3 = g;
  const p = /^[^\0\t\n\f\r /<=>]+$/;
  function g(b, y, w) {
    if (b == null)
      return "";
    typeof b == "number" && (b = b.toString());
    let C = "", T = "";
    function E(Fe, Ze) {
      const Ue = this;
      this.tag = Fe, this.attribs = Ze || {}, this.tagPosition = C.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
        if (me.length) {
          const Rt = me[me.length - 1];
          Rt.text += Ue.text;
        }
      }, this.updateParentNodeMediaChildren = function() {
        me.length && o.includes(this.tag) && me[me.length - 1].mediaChildren.push(this.tag);
      };
    }
    y = Object.assign({}, g.defaults, y), y.parser = Object.assign({}, v, y.parser);
    const D = function(Fe) {
      return y.allowedTags === !1 || (y.allowedTags || []).indexOf(Fe) > -1;
    };
    c.forEach(function(Fe) {
      D(Fe) && !y.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${Fe}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
    });
    const $ = y.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let Z, te;
    y.allowedAttributes && (Z = {}, te = {}, u(y.allowedAttributes, function(Fe, Ze) {
      Z[Ze] = [];
      const Ue = [];
      Fe.forEach(function(Rt) {
        typeof Rt == "string" && Rt.indexOf("*") >= 0 ? Ue.push(t(Rt).replace(/\\\*/g, ".*")) : Z[Ze].push(Rt);
      }), Ue.length && (te[Ze] = new RegExp("^(" + Ue.join("|") + ")$"));
    }));
    const se = {}, ee = {}, K = {};
    u(y.allowedClasses, function(Fe, Ze) {
      if (Z && (s(Z, Ze) || (Z[Ze] = []), Z[Ze].push("class")), se[Ze] = Fe, Array.isArray(Fe)) {
        const Ue = [];
        se[Ze] = [], K[Ze] = [], Fe.forEach(function(Rt) {
          typeof Rt == "string" && Rt.indexOf("*") >= 0 ? Ue.push(t(Rt).replace(/\\\*/g, ".*")) : Rt instanceof RegExp ? K[Ze].push(Rt) : se[Ze].push(Rt);
        }), Ue.length && (ee[Ze] = new RegExp("^(" + Ue.join("|") + ")$"));
      }
    });
    const re = {};
    let de;
    u(y.transformTags, function(Fe, Ze) {
      let Ue;
      typeof Fe == "function" ? Ue = Fe : typeof Fe == "string" && (Ue = g.simpleTransform(Fe)), Ze === "*" ? de = Ue : re[Ze] = Ue;
    });
    let ie, me, $e, Pe, Le, Ae, He = !1;
    we();
    const Te = new e.Parser({
      onopentag: function(Fe, Ze) {
        if (y.enforceHtmlBoundary && Fe === "html" && we(), Le) {
          Ae++;
          return;
        }
        const Ue = new E(Fe, Ze);
        me.push(Ue);
        let Rt = !1;
        const Vr = !!Ue.text;
        let ye;
        if (s(re, Fe) && (ye = re[Fe](Fe, Ze), Ue.attribs = Ze = ye.attribs, ye.text !== void 0 && (Ue.innerText = ye.text), Fe !== ye.tagName && (Ue.name = Fe = ye.tagName, Pe[ie] = ye.tagName)), de && (ye = de(Fe, Ze), Ue.attribs = Ze = ye.attribs, Fe !== ye.tagName && (Ue.name = Fe = ye.tagName, Pe[ie] = ye.tagName)), (!D(Fe) || y.disallowedTagsMode === "recursiveEscape" && !d($e) || y.nestingLimit != null && ie >= y.nestingLimit) && (Rt = !0, $e[ie] = !0, (y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") && $.indexOf(Fe) !== -1 && (Le = !0, Ae = 1)), ie++, Rt) {
          if (y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") {
            if (Ue.innerText && !Vr) {
              const G = qe(Ue.innerText);
              y.textFilter ? C += y.textFilter(G, Fe) : C += G, He = !0;
            }
            return;
          }
          T = C, C = "";
        }
        C += "<" + Fe, Fe === "script" && (y.allowedScriptHostnames || y.allowedScriptDomains) && (Ue.innerText = ""), (!Z || s(Z, Fe) || Z["*"]) && u(Ze, function(G, Y) {
          if (!p.test(Y)) {
            delete Ue.attribs[Y];
            return;
          }
          if (G === "" && !y.allowedEmptyAttributes.includes(Y) && (y.nonBooleanAttributes.includes(Y) || y.nonBooleanAttributes.includes("*"))) {
            delete Ue.attribs[Y];
            return;
          }
          let ae = !1;
          if (!Z || s(Z, Fe) && Z[Fe].indexOf(Y) !== -1 || Z["*"] && Z["*"].indexOf(Y) !== -1 || s(te, Fe) && te[Fe].test(Y) || te["*"] && te["*"].test(Y))
            ae = !0;
          else if (Z && Z[Fe]) {
            for (const Ee of Z[Fe])
              if (n(Ee) && Ee.name && Ee.name === Y) {
                ae = !0;
                let N = "";
                if (Ee.multiple === !0) {
                  const Se = G.split(" ");
                  for (const Me of Se)
                    Ee.values.indexOf(Me) !== -1 && (N === "" ? N = Me : N += " " + Me);
                } else Ee.values.indexOf(G) >= 0 && (N = G);
                G = N;
              }
          }
          if (ae) {
            if (y.allowedSchemesAppliedToAttributes.indexOf(Y) !== -1 && Ge(Fe, G)) {
              delete Ue.attribs[Y];
              return;
            }
            if (Fe === "script" && Y === "src") {
              let Ee = !0;
              try {
                const N = It(G);
                if (y.allowedScriptHostnames || y.allowedScriptDomains) {
                  const Se = (y.allowedScriptHostnames || []).find(function(Xe) {
                    return Xe === N.url.hostname;
                  }), Me = (y.allowedScriptDomains || []).find(function(Xe) {
                    return N.url.hostname === Xe || N.url.hostname.endsWith(`.${Xe}`);
                  });
                  Ee = Se || Me;
                }
              } catch {
                Ee = !1;
              }
              if (!Ee) {
                delete Ue.attribs[Y];
                return;
              }
            }
            if (Fe === "iframe" && Y === "src") {
              let Ee = !0;
              try {
                const N = It(G);
                if (N.isRelativeUrl)
                  Ee = s(y, "allowIframeRelativeUrls") ? y.allowIframeRelativeUrls : !y.allowedIframeHostnames && !y.allowedIframeDomains;
                else if (y.allowedIframeHostnames || y.allowedIframeDomains) {
                  const Se = (y.allowedIframeHostnames || []).find(function(Xe) {
                    return Xe === N.url.hostname;
                  }), Me = (y.allowedIframeDomains || []).find(function(Xe) {
                    return N.url.hostname === Xe || N.url.hostname.endsWith(`.${Xe}`);
                  });
                  Ee = Se || Me;
                }
              } catch {
                Ee = !1;
              }
              if (!Ee) {
                delete Ue.attribs[Y];
                return;
              }
            }
            if (Y === "srcset")
              try {
                let Ee = i(G);
                if (Ee.forEach(function(N) {
                  Ge("srcset", N.url) && (N.evil = !0);
                }), Ee = f(Ee, function(N) {
                  return !N.evil;
                }), Ee.length)
                  G = l(f(Ee, function(N) {
                    return !N.evil;
                  })), Ue.attribs[Y] = G;
                else {
                  delete Ue.attribs[Y];
                  return;
                }
              } catch {
                delete Ue.attribs[Y];
                return;
              }
            if (Y === "class") {
              const Ee = se[Fe], N = se["*"], Se = ee[Fe], Me = K[Fe], Xe = K["*"], Ke = ee["*"], $t = [
                Se,
                Ke
              ].concat(Me, Xe).filter(function(Be) {
                return Be;
              });
              if (Ee && N ? G = Lt(G, r(Ee, N), $t) : G = Lt(G, Ee || N, $t), !G.length) {
                delete Ue.attribs[Y];
                return;
              }
            }
            if (Y === "style") {
              if (y.parseStyleAttributes)
                try {
                  const Ee = a(Fe + " {" + G + "}", { map: !1 }), N = Qe(Ee, y.allowedStyles);
                  if (G = jt(N), G.length === 0) {
                    delete Ue.attribs[Y];
                    return;
                  }
                } catch {
                  typeof window < "u" && console.warn('Failed to parse "' + Fe + " {" + G + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete Ue.attribs[Y];
                  return;
                }
              else if (y.allowedStyles)
                throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
            }
            C += " " + Y, G && G.length ? C += '="' + qe(G, !0) + '"' : y.allowedEmptyAttributes.includes(Y) && (C += '=""');
          } else
            delete Ue.attribs[Y];
        }), y.selfClosing.indexOf(Fe) !== -1 ? C += " />" : (C += ">", Ue.innerText && !Vr && !y.textFilter && (C += qe(Ue.innerText), He = !0)), Rt && (C = T + qe(C), T = ""), Ue.openingTagLength = C.length - Ue.tagPosition;
      },
      ontext: function(Fe) {
        if (Le)
          return;
        const Ze = me[me.length - 1];
        let Ue;
        if (Ze && (Ue = Ze.tag, Fe = Ze.innerText !== void 0 ? Ze.innerText : Fe), y.disallowedTagsMode === "completelyDiscard" && !D(Ue))
          Fe = "";
        else if ((y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") && (Ue === "script" || Ue === "style"))
          C += Fe;
        else if (!He) {
          const Rt = qe(Fe, !1);
          y.textFilter ? C += y.textFilter(Rt, Ue) : C += Rt;
        }
        if (me.length) {
          const Rt = me[me.length - 1];
          Rt.text += Fe;
        }
      },
      onclosetag: function(Fe, Ze) {
        if (Le)
          if (Ae--, !Ae)
            Le = !1;
          else
            return;
        const Ue = me.pop();
        if (!Ue)
          return;
        if (Ue.tag !== Fe) {
          me.push(Ue);
          return;
        }
        Le = y.enforceHtmlBoundary ? Fe === "html" : !1, ie--;
        const Rt = $e[ie];
        if (Rt) {
          if (delete $e[ie], y.disallowedTagsMode === "discard" || y.disallowedTagsMode === "completelyDiscard") {
            Ue.updateParentNodeText();
            return;
          }
          T = C, C = "";
        }
        if (Pe[ie] && (Fe = Pe[ie], delete Pe[ie]), y.exclusiveFilter) {
          const Vr = y.exclusiveFilter(Ue);
          if (Vr === "excludeTag") {
            Rt && (C = T, T = ""), C = C.substring(0, Ue.tagPosition) + C.substring(Ue.tagPosition + Ue.openingTagLength);
            return;
          } else if (Vr) {
            C = C.substring(0, Ue.tagPosition);
            return;
          }
        }
        if (Ue.updateParentNodeMediaChildren(), Ue.updateParentNodeText(), // Already output />
        y.selfClosing.indexOf(Fe) !== -1 || // Escaped tag, closing tag is implied
        Ze && !D(Fe) && ["escape", "recursiveEscape"].indexOf(y.disallowedTagsMode) >= 0) {
          Rt && (C = T, T = "");
          return;
        }
        C += "</" + Fe + ">", Rt && (C = T + qe(C), T = ""), He = !1;
      }
    }, y.parser);
    return Te.write(b), Te.end(), C;
    function we() {
      C = "", ie = 0, me = [], $e = {}, Pe = {}, Le = !1, Ae = 0;
    }
    function qe(Fe, Ze) {
      return typeof Fe != "string" && (Fe = Fe + ""), y.parser.decodeEntities && (Fe = Fe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Ze && (Fe = Fe.replace(/"/g, "&quot;"))), Fe = Fe.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), Ze && (Fe = Fe.replace(/"/g, "&quot;")), Fe;
    }
    function Ge(Fe, Ze) {
      for (Ze = Ze.replace(/[\x00-\x20]+/g, ""); ; ) {
        const Vr = Ze.indexOf("<!--");
        if (Vr === -1)
          break;
        const ye = Ze.indexOf("-->", Vr + 4);
        if (ye === -1)
          break;
        Ze = Ze.substring(0, Vr) + Ze.substring(ye + 3);
      }
      const Ue = Ze.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!Ue)
        return Ze.match(/^[/\\]{2}/) ? !y.allowProtocolRelative : !1;
      const Rt = Ue[1].toLowerCase();
      return s(y.allowedSchemesByTag, Fe) ? y.allowedSchemesByTag[Fe].indexOf(Rt) === -1 : !y.allowedSchemes || y.allowedSchemes.indexOf(Rt) === -1;
    }
    function It(Fe) {
      if (Fe = Fe.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), Fe.startsWith("relative:"))
        throw new Error("relative: exploit attempt");
      let Ze = "relative://relative-site";
      for (let Vr = 0; Vr < 100; Vr++)
        Ze += `/${Vr}`;
      const Ue = new URL(Fe, Ze);
      return {
        isRelativeUrl: Ue && Ue.hostname === "relative-site" && Ue.protocol === "relative:",
        url: Ue
      };
    }
    function Qe(Fe, Ze) {
      if (!Ze)
        return Fe;
      const Ue = Fe.nodes[0];
      let Rt;
      return Ze[Ue.selector] && Ze["*"] ? Rt = r(
        Ze[Ue.selector],
        Ze["*"]
      ) : Rt = Ze[Ue.selector] || Ze["*"], Rt && (Fe.nodes[0].nodes = Ue.nodes.reduce(We(Rt), [])), Fe;
    }
    function jt(Fe) {
      return Fe.nodes[0].nodes.reduce(function(Ze, Ue) {
        return Ze.push(
          `${Ue.prop}:${Ue.value}${Ue.important ? " !important" : ""}`
        ), Ze;
      }, []).join(";");
    }
    function We(Fe) {
      return function(Ze, Ue) {
        return s(Fe, Ue.prop) && Fe[Ue.prop].some(function(Vr) {
          return Vr.test(Ue.value);
        }) && Ze.push(Ue), Ze;
      };
    }
    function Lt(Fe, Ze, Ue) {
      return Ze ? (Fe = Fe.split(/\s+/), Fe.filter(function(Rt) {
        return Ze.indexOf(Rt) !== -1 || Ue.some(function(Vr) {
          return Vr.test(Rt);
        });
      }).join(" ")) : Fe;
    }
  }
  const v = {
    decodeEntities: !0
  };
  return g.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: !0,
    enforceHtmlBoundary: !1,
    parseStyleAttributes: !0
  }, g.simpleTransform = function(b, y, w) {
    return w = w === void 0 ? !0 : w, y = y || {}, function(C, T) {
      let E;
      if (w)
        for (E in y)
          T[E] = y[E];
      else
        T = y;
      return {
        tagName: b,
        attribs: T
      };
    };
  }, I3;
}
var PY = /* @__PURE__ */ TY();
const a_ = /* @__PURE__ */ g2(PY);
let _l;
function xO() {
  function e() {
    _l || (_l = ja({
      html: !0,
      // enabled to allow raw HTML in source
      xhtmlOut: !0,
      // Use '/' to close single tags (<br />)
      linkify: !0,
      // Convert URL-like text to links
      breaks: !0,
      // Convert '\n' in paragraphs into <br>
      typographer: !0
      // Enable some language-neutral replacement + quotes beautification
    }));
  }
  function t(n) {
    if (!String(n || "").trim())
      return "";
    e();
    try {
      const r = (_l == null ? void 0 : _l.render(n)) || n;
      return a_(r, {
        allowedTags: a_.defaults.allowedTags.concat(["img", "details", "summary"])
      });
    } catch {
      return n;
    }
  }
  return {
    mdRender: t
  };
}
const Di = {
  useSchemaParser: EH,
  useShiki: jV,
  useCurrentCallback: fW,
  useCurrentResponse: NE,
  useContentTypes: LE,
  useServerList: pW,
  useAuthTokenState: vW,
  useTryItState: bW,
  useMarkdown: xO
}, dn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, RY = {};
function jY(e, t) {
  return Re(), vt("div", null, " !!!!Unknown!!!! ");
}
const IY = /* @__PURE__ */ dn(RY, [["render", jY]]), qY = /* @__PURE__ */ xr({
  __name: "MethodBadge",
  props: {
    method: {
      type: String,
      default: ""
    },
    /**
    * Size variations
    * One of ['small', 'large' ]
    */
    size: {
      type: String,
      default: "small",
      validator: (e) => qk.includes(e)
    },
    /**
     * Invert the badge colors
     * Styles for both inverted and non-inverted appearances are defined in mixins/_badges.scss
     */
    inverted: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("span", {
      class: Bn(["method-badge", [e.method, e.size, { inverted: e.inverted }]]),
      "data-testid": "method-badge"
    }, pn(e.method), 3));
  }
}), s1 = /* @__PURE__ */ dn(qY, [["__scopeId", "data-v-97b136aa"]]), DY = ["data-spec-renderer-toc-active"], LY = ["href", "title"], NY = /* @__PURE__ */ xr({
  __name: "NodeItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    activePath: {
      type: String,
      default: "/"
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = e, r = Qa("base-path", Sr("")), i = Qa("navigation-type", Sr("path")), a = t, o = Ye(() => {
      var f, d;
      return !((d = (f = n.item.title) == null ? void 0 : f.trim()) != null && d.includes(" "));
    }), c = Ye(() => n.activePath === n.item.id), u = Ye(() => n.item.deprecated ? `${n.item.title} (deprecated)` : n.item.title), s = (f) => {
      a("item-selected", f);
    };
    return (f, d) => (Re(), vt("li", {
      class: "node-item",
      "data-spec-renderer-toc-active": c.value ? !0 : void 0,
      "data-testid": "node-item"
    }, [
      Gt("a", {
        class: Bn({ "single-word": o.value, active: c.value }),
        "data-testid": "node-item-title-link",
        href: `${Nt(r)}${Nt(i) === "hash" ? "#" : ""}${e.item.id}`,
        title: u.value,
        onClick: d[0] || (d[0] = $f((l) => s(e.item.id), ["prevent"]))
      }, [
        Gt("span", {
          class: Bn(["node-item-title", { "deprecated-node-item": e.item.deprecated }]),
          "data-testid": "node-item-title"
        }, pn(e.item.title), 3),
        e.item.type === Nt(Xi).HttpOperation || e.item.type === Nt(Xi).HttpWebhook ? (Re(), Bt(s1, {
          key: 0,
          class: "http-operation-badge",
          "data-testid": "http-operation-badge",
          inverted: c.value,
          method: e.item.meta
        }, null, 8, ["inverted", "method"])) : Kt("", !0)
      ], 10, LY)
    ], 8, DY));
  }
}), $Y = /* @__PURE__ */ dn(NY, [["__scopeId", "data-v-a45c803a"]]), mn = "24px", MY = ["aria-hidden"], o_ = `<path d="M20.4394 5.37004L13.365 1.17004C12.9431 0.920669 12.4706 0.795044 12 0.795044C11.5294 0.795044 11.0569 0.920669 10.635 1.17192L3.55873 5.37192C2.71498 5.87254 2.19373 6.79879 2.19373 7.80192V16.2019C2.19373 17.205 2.7131 18.1313 3.55873 18.6319L10.6331 22.8319C11.055 23.0832 11.5256 23.2069 11.9981 23.2069C12.4687 23.2069 12.9412 23.0813 13.3631 22.8319L20.4394 18.6319C21.2831 18.1313 21.8044 17.2032 21.8044 16.2019V7.80004C21.8044 6.79879 21.285 5.87067 20.4394 5.37004ZM14.9606 18.4857L14.9719 19.0894C14.9719 19.1625 14.925 19.245 14.8687 19.275L14.5106 19.4813C14.4544 19.5094 14.4056 19.4757 14.4056 19.4025L14.4 18.8082C14.0944 18.9357 13.7831 18.9657 13.5862 18.8869C13.5487 18.8719 13.5319 18.8175 13.5469 18.7538L13.6762 18.2082C13.6875 18.165 13.71 18.1219 13.74 18.0957C13.7512 18.0844 13.7625 18.0769 13.7737 18.0713C13.7944 18.06 13.815 18.0582 13.8319 18.0657C14.0456 18.1369 14.3175 18.1032 14.58 17.9719C14.9137 17.8032 15.1369 17.4619 15.1331 17.1244C15.1294 16.8169 14.9644 16.6913 14.5612 16.6875C14.0475 16.6894 13.5675 16.5882 13.56 15.8307C13.5544 15.2082 13.8769 14.5594 14.3906 14.1507L14.385 13.5413C14.385 13.4663 14.43 13.3838 14.4881 13.3538L14.835 13.1325C14.8912 13.1044 14.94 13.14 14.94 13.2132L14.9456 13.8225C15.2006 13.7213 15.4219 13.6932 15.6225 13.74C15.6656 13.7513 15.6862 13.8113 15.6675 13.8807L15.5325 14.4207C15.5212 14.4619 15.4987 14.5032 15.4706 14.5294C15.4601 14.5399 15.4481 14.5488 15.435 14.5557C15.4162 14.565 15.3994 14.5669 15.3825 14.565C15.2906 14.5444 15.0731 14.4975 14.73 14.67C14.37 14.8519 14.2444 15.165 14.2462 15.3975C14.25 15.675 14.3906 15.7594 14.8819 15.7669C15.5362 15.7782 15.8175 16.0632 15.825 16.7213C15.8344 17.3663 15.4894 18.0619 14.9606 18.4857ZM19.8994 7.14192L13.2056 11.2763C12.3712 11.7638 11.7562 12.3113 11.7544 13.3182V21.5663C11.7544 22.1682 11.9981 22.5582 12.3712 22.6725C12.2494 22.6932 12.1237 22.7082 12 22.7082C11.6081 22.7082 11.2219 22.6013 10.8825 22.4007L3.8081 18.2007C3.11623 17.79 2.68685 17.0232 2.68685 16.2V7.80004C2.68685 6.97692 3.11623 6.21004 3.8081 5.79942L10.8843 1.59942C11.2237 1.39879 11.61 1.29192 12.0019 1.29192C12.3937 1.29192 12.78 1.39879 13.1194 1.59942L20.1956 5.79942C20.7787 6.14629 21.1725 6.74442 21.2831 7.41754C21.045 6.91692 20.5162 6.78192 19.8994 7.14192Z" fill="#293138"/>
<path d="M18.5849 17.0119L16.8224 18.0656C16.7756 18.0938 16.7418 18.1238 16.7418 18.18V18.6413C16.7418 18.6975 16.7793 18.7219 16.8262 18.6938L18.6149 17.6063C18.6618 17.5781 18.6693 17.5275 18.6693 17.4713V17.0644C18.6693 17.0081 18.6318 16.9856 18.5849 17.0119Z" fill="#4FA847"/>`, s_ = /* @__PURE__ */ xr({
  __name: "LanguageBashIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? o_ : i(o_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-bash-icon",
      "data-testid": "kui-icon-wrapper-language-bash-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-bash-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, MY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), FY = ["aria-hidden"], u_ = `<g clip-path="url(#clip0_2_1231)">
<path d="M22.2686 17.9663C22.4355 17.677 22.5388 17.3513 22.5388 17.0582V6.89627C22.5388 6.60414 22.4357 6.27808 22.2686 5.98877L11.8961 11.9775L22.2686 17.9663Z" fill="#00599C"/>
<path d="M12.8175 23.7349L21.6174 18.6548C21.8709 18.5084 22.1015 18.2556 22.2686 17.9663L11.8961 11.9775L1.52246 17.9663C1.68934 18.2556 1.92015 18.5082 2.17365 18.6548L10.9736 23.7349C11.4804 24.0278 12.3105 24.0278 12.8171 23.7349H12.8175Z" fill="#004482"/>
<path d="M22.2686 5.98898C22.1015 5.69911 21.8709 5.44636 21.6174 5.30067L12.8173 0.219797C12.3104 -0.0732656 11.4806 -0.0732656 10.9738 0.219797L2.17382 5.30067C1.66682 5.5928 1.25244 6.3113 1.25244 6.8963V17.058C1.25244 17.3509 1.35557 17.6768 1.52263 17.9661L11.8959 11.9775L22.2686 5.98898Z" fill="#659AD2"/>
<path d="M11.896 4.88154C7.98342 4.88154 4.80042 8.06472 4.80042 11.9773C4.80042 15.8898 7.98342 19.073 11.896 19.073C14.4207 19.073 16.7755 17.7142 18.0404 15.5274L14.97 13.7503C14.3363 14.8453 13.1588 15.525 11.896 15.525C9.93979 15.525 8.3481 13.9335 8.3481 11.9771C8.3481 10.0207 9.93998 8.42922 11.896 8.42922C13.1579 8.42922 14.3367 9.10966 14.9691 10.2039L18.0404 8.42697C16.7747 6.23997 14.4207 4.88154 11.896 4.88154ZM17.415 10.7943V11.5832H16.6262V12.3712H17.415V13.16H18.2031V12.3712H18.9912V11.5832H18.2031V10.7943H17.415ZM20.3712 10.7943V11.5832H19.5829V12.3712H20.3712V13.16H21.16V12.3712H21.948V11.5832H21.16V10.7943H20.3712Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2_1231">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, BY = /* @__PURE__ */ xr({
  __name: "LanguageCPlusPlusIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? u_ : i(u_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-c-plus-plus-icon",
      "data-testid": "kui-icon-wrapper-language-c-plus-plus-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-c-plus-plus-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, FY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), UY = ["aria-hidden"], c_ = `<path d="M21.6375 5.75623L12.5813 0.543726C12.4313 0.449976 12.225 0.412476 12 0.412476C11.775 0.412476 11.5688 0.468726 11.4188 0.543726L2.41875 5.77498C2.1 5.96248 1.875 6.43123 1.875 6.78748V17.2312C1.875 17.4375 1.9125 17.6812 2.0625 17.8875L22.0875 6.26248C21.975 6.03748 21.8063 5.86873 21.6375 5.75623Z" fill="#9B4F96"/>
<path d="M2.00623 17.8688C2.09998 18.0188 2.23123 18.15 2.36248 18.225L11.4 23.4563C11.55 23.55 11.7562 23.5875 11.9812 23.5875C12.2062 23.5875 12.4125 23.5313 12.5625 23.4563L21.5625 18.225C21.8812 18.0375 22.1062 17.5688 22.1062 17.2125V6.76877C22.1062 6.60002 22.0875 6.41252 21.9937 6.24377L2.00623 17.8688Z" fill="#68217A"/>
<path d="M15.9937 14.2687C15.2063 15.6562 13.7062 16.5938 12 16.5938C9.46875 16.5938 7.40625 14.5312 7.40625 12C7.40625 9.46875 9.46875 7.40625 12 7.40625C13.7062 7.40625 15.2063 8.34375 15.9937 9.75L18.4312 8.34375C17.1562 6.1125 14.7562 4.59375 12 4.59375C7.9125 4.59375 4.59375 7.9125 4.59375 12C4.59375 16.0875 7.9125 19.4062 12 19.4062C14.7375 19.4062 17.1375 17.9062 18.4125 15.6937L15.9937 14.2687ZM18.1875 12.4125L18.3562 11.6063H17.5687V10.725H18.525L18.75 9.5625H19.6687L19.4437 10.7062H20.1562L20.3812 9.5625H21.2812L21.0562 10.7062H21.5062V11.5875H20.8875L20.7187 12.3937H21.5062V13.275H20.55L20.325 14.4H19.4062L19.6312 13.275H18.9187L18.6937 14.4H17.7937L18.0187 13.275H17.5687V12.3937H18.1875V12.4125ZM19.0875 12.4125H19.8L19.9687 11.6063H19.2562L19.0875 12.4125Z" fill="white"/>`, HY = /* @__PURE__ */ xr({
  __name: "LanguageCSharpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? c_ : i(c_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-c-sharp-icon",
      "data-testid": "kui-icon-wrapper-language-c-sharp-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-c-sharp-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, UY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), zY = ["aria-hidden"], l_ = `<path d="M21.6375 5.75623L12.5813 0.543726C12.4313 0.449976 12.225 0.412476 12 0.412476C11.775 0.412476 11.5688 0.468726 11.4188 0.543726L2.41875 5.77498C2.1 5.96248 1.875 6.43123 1.875 6.78748V17.2312C1.875 17.4375 1.9125 17.6812 2.0625 17.8875L22.0875 6.26248C21.975 6.03748 21.8063 5.86873 21.6375 5.75623Z" fill="#659AD3"/>
<path d="M2.00623 17.8688C2.09998 18.0188 2.23123 18.15 2.36248 18.225L11.4 23.4563C11.55 23.55 11.7562 23.5875 11.9812 23.5875C12.2062 23.5875 12.4125 23.5313 12.5625 23.4563L21.5625 18.225C21.8812 18.0375 22.1062 17.5688 22.1062 17.2125V6.76877C22.1062 6.60002 22.0875 6.41252 21.9937 6.24377L2.00623 17.8688Z" fill="#03599C"/>
<path d="M15.9938 14.2687C15.2063 15.6562 13.7063 16.5938 12 16.5938C9.46875 16.5938 7.40625 14.5312 7.40625 12C7.40625 9.46875 9.46875 7.40625 12 7.40625C13.7063 7.40625 15.2063 8.34375 15.9938 9.75L18.4313 8.34375C17.1563 6.1125 14.7563 4.59375 12 4.59375C7.9125 4.59375 4.59375 7.9125 4.59375 12C4.59375 16.0875 7.9125 19.4062 12 19.4062C14.7375 19.4062 17.1375 17.9062 18.4125 15.6937L15.9938 14.2687Z" fill="white"/>`, GY = /* @__PURE__ */ xr({
  __name: "LanguageCIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? l_ : i(l_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-c-icon",
      "data-testid": "kui-icon-wrapper-language-c-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-c-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, zY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), VY = ["aria-hidden"], f_ = `<mask id="mask0_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask0_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.9563 12.8813C3.9938 13.5375 4.65005 13.2375 4.95005 13.0313C5.2313 12.825 5.32505 12.9938 5.3438 12.6C5.36255 12.3375 5.3813 12.0938 5.3813 11.8313C4.95005 11.7938 4.4813 11.8875 4.12505 12.15C3.9563 12.2813 3.60005 12.7125 3.9563 12.8813Z" fill="#F6D2A2"/>
</g>
<mask id="mask1_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask1_2_1240)">
<path d="M4.31255 13.35C4.1813 13.35 3.93755 13.2938 3.90005 12.9188C3.78755 12.8438 3.75005 12.75 3.75005 12.6938C3.7313 12.4688 3.97505 12.2063 4.1063 12.1125C4.4063 11.8875 4.80005 11.775 5.21255 11.775H5.4563V11.8313C5.47505 12.0375 5.4563 12.2438 5.43755 12.4313C5.43755 12.4875 5.43755 12.5438 5.4188 12.6C5.40005 12.8813 5.3438 12.9188 5.21255 12.975C5.1563 12.9938 5.10005 13.0125 5.0063 13.0875C4.91255 13.1438 4.5938 13.35 4.31255 13.35ZM5.21255 11.8875C4.8188 11.8875 4.46255 12 4.1813 12.2063C4.05005 12.3 3.86255 12.525 3.8813 12.675C3.8813 12.7313 3.9188 12.7875 3.9938 12.825L4.0313 12.8438V12.8813C4.05005 13.1813 4.20005 13.2188 4.31255 13.2188C4.50005 13.2188 4.76255 13.0875 4.9313 12.975C5.0438 12.9 5.1188 12.8813 5.17505 12.8625C5.2688 12.825 5.28755 12.825 5.3063 12.6C5.3063 12.5438 5.3063 12.4875 5.32505 12.4313C5.3438 12.2625 5.3438 12.075 5.3438 11.9063C5.28755 11.8875 5.25005 11.8875 5.21255 11.8875Z" fill="black"/>
</g>
<mask id="mask2_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask2_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.9563 12.8812C4.05005 12.8437 4.16255 12.825 4.2188 12.7312L3.9563 12.8812Z" fill="#C6B198"/>
</g>
<mask id="mask3_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask3_2_1240)">
<path d="M3.95631 12.9375C3.93756 12.9375 3.90006 12.9188 3.90006 12.9C3.88131 12.8625 3.90006 12.825 3.93756 12.825C3.95631 12.825 3.97506 12.8063 3.97506 12.8063C4.05006 12.7688 4.12506 12.75 4.16256 12.6938C4.18131 12.675 4.21881 12.6563 4.25631 12.675C4.27506 12.6938 4.29381 12.7313 4.27506 12.7688C4.20006 12.8625 4.10631 12.9 4.03131 12.9188L3.99381 12.9375H3.95631Z" fill="black"/>
</g>
<mask id="mask4_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask4_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.49371 4.94997C2.94371 4.23747 4.83746 0.993718 6.88121 2.32497L5.49371 4.94997Z" fill="#6AD7E5"/>
</g>
<mask id="mask5_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask5_2_1240)">
<path d="M5.53122 5.02495L5.47497 5.0062C4.16247 4.6312 4.18122 3.6937 4.21872 3.41245C4.31247 2.69995 4.98747 1.94995 5.88747 1.94995C6.24372 1.94995 6.58122 2.06245 6.91872 2.28745L6.97497 2.32495L5.53122 5.02495ZM5.88747 2.0812C5.04372 2.0812 4.42497 2.77495 4.33122 3.4312C4.23747 4.1062 4.64997 4.6312 5.45622 4.87495L6.78747 2.3437C6.50622 2.17495 6.20622 2.0812 5.88747 2.0812Z" fill="black"/>
</g>
<mask id="mask6_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask6_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.8 2.08131C18.8063 0.675056 20.6438 3.86256 18.3 4.66881L16.8 2.08131Z" fill="#6AD7E5"/>
</g>
<mask id="mask7_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask7_2_1240)">
<path d="M18.2812 4.74377L16.725 2.06252L16.7812 2.02502C17.1375 1.78127 17.4937 1.65002 17.85 1.65002C18.7125 1.65002 19.3312 2.36252 19.4625 3.05627C19.5187 3.33752 19.575 4.29377 18.3375 4.70627L18.2812 4.74377ZM16.8937 2.11877L18.3375 4.61252C19.0687 4.35002 19.4437 3.78752 19.3312 3.11252C19.2187 2.47502 18.6375 1.81877 17.85 1.81877C17.5312 1.80002 17.2125 1.89377 16.8937 2.11877Z" fill="black"/>
</g>
<mask id="mask8_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask8_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 21.0563C17.7563 21.375 18.6937 22.3313 17.925 22.8C17.1937 23.475 16.7812 22.05 16.125 21.8625C16.4062 21.4875 16.7625 21.1313 17.25 21.0563Z" fill="#F6D2A2"/>
</g>
<mask id="mask9_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask9_2_1240)">
<path d="M17.5313 23.0438C17.2313 23.0438 16.9688 22.7438 16.7438 22.4625C16.5376 22.2375 16.3313 21.9938 16.1063 21.9188L16.0126 21.9L16.0688 21.825C16.2938 21.5063 16.6688 21.0938 17.2313 21H17.2501L17.2688 21.0187C17.5876 21.225 18.2813 21.8062 18.2626 22.35C18.2626 22.5562 18.1501 22.725 17.9438 22.8563C17.8126 22.9875 17.6813 23.0438 17.5313 23.0438ZM16.2188 21.825C16.4438 21.9188 16.6313 22.1625 16.8188 22.3688C17.0438 22.65 17.2688 22.8937 17.5126 22.8937C17.6251 22.8937 17.7376 22.8375 17.8501 22.725H17.8688C18.0376 22.6125 18.1313 22.4813 18.1313 22.3125C18.1313 21.8813 17.5876 21.3375 17.2126 21.0938C16.8751 21.1875 16.5376 21.4125 16.2188 21.825ZM17.9251 22.8563C17.9063 22.8563 17.8876 22.8375 17.8688 22.8187C17.8313 22.7437 17.7938 22.65 17.7751 22.575C17.7188 22.425 17.6626 22.275 17.5501 22.1625C17.5313 22.1437 17.5313 22.1062 17.5501 22.0687C17.5688 22.05 17.6063 22.05 17.6438 22.0687C17.7751 22.2 17.8501 22.3687 17.9063 22.5375L18.0001 22.7625C18.0188 22.8 18.0001 22.8375 17.9813 22.8563H17.9251Z" fill="black"/>
</g>
<mask id="mask10_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask10_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.10007 22.1437C7.50007 22.2375 7.16257 22.7812 6.65632 23.0625C6.18757 23.3437 6.00007 22.9687 5.96257 22.8937C5.88757 22.8562 5.88757 22.9312 5.77507 22.8187C5.34382 22.125 6.22507 21.6187 6.69382 21.2812C7.35007 21.1312 7.76257 21.6937 8.10007 22.1437Z" fill="#F6D2A2"/>
</g>
<mask id="mask11_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask11_2_1240)">
<path d="M6.33748 23.2125C6.09373 23.2125 5.96248 23.0063 5.92498 22.9313H5.90623C5.84998 22.9313 5.81248 22.9125 5.73748 22.8375V22.8187C5.32498 22.1625 6.03748 21.6562 6.50623 21.3187L6.67498 21.2062H6.71248C6.78748 21.1875 6.84373 21.1875 6.91873 21.1875C7.48123 21.1875 7.83748 21.675 8.13748 22.0687L8.23123 22.2L8.11873 22.2188C7.76248 22.275 7.49998 22.5 7.23748 22.725C7.06873 22.875 6.89998 23.0063 6.71248 23.1188C6.56248 23.175 6.44998 23.2125 6.33748 23.2125ZM5.92498 22.8187C5.94373 22.8187 5.96248 22.8188 5.99998 22.8375H6.01873L6.03748 22.8563C6.07498 22.9125 6.16873 23.0812 6.35623 23.0812C6.44998 23.0812 6.54373 23.0437 6.63748 22.9875C6.82498 22.8937 6.99373 22.7437 7.14373 22.6125C7.38748 22.4062 7.64998 22.1813 7.98748 22.0875C7.70623 21.7125 7.36873 21.3 6.89998 21.3C6.84373 21.3 6.78748 21.3 6.73123 21.3187L6.58123 21.4313C6.09373 21.7688 5.49373 22.2 5.84998 22.7625C5.86873 22.8 5.88748 22.8187 5.92498 22.8187ZM5.96248 22.95C5.92498 22.95 5.88748 22.9125 5.90623 22.875C5.92498 22.6875 6.01873 22.5562 6.11248 22.4062C6.16873 22.3312 6.20623 22.2563 6.24373 22.1813C6.26248 22.1438 6.29998 22.1437 6.31873 22.1437C6.35623 22.1625 6.35623 22.2 6.35623 22.2188C6.31873 22.3125 6.26248 22.3875 6.20623 22.4625C6.11248 22.5938 6.03748 22.7063 6.01873 22.8563C6.01873 22.9313 5.99998 22.95 5.96248 22.95Z" fill="black"/>
</g>
<mask id="mask12_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask12_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.6063 4.06881C5.2688 3.90006 5.02505 3.65631 5.2313 3.26256C5.4188 2.90631 5.77505 2.94381 6.11255 3.11256L5.6063 4.06881ZM17.7751 3.73131C18.1125 3.56256 18.3563 3.31881 18.1501 2.92506C17.9626 2.56881 17.6063 2.60631 17.2688 2.77506L17.7751 3.73131Z" fill="black"/>
</g>
<mask id="mask13_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask13_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0812 12.7875C20.0437 13.4438 19.3875 13.1438 19.0875 12.9375C18.8063 12.7313 18.7125 12.9 18.6937 12.5063C18.675 12.2438 18.6562 12 18.6562 11.7375C19.0875 11.7 19.5562 11.7938 19.9125 12.0563C20.1 12.2063 20.4375 12.6188 20.0812 12.7875Z" fill="#F6D2A2"/>
</g>
<mask id="mask14_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask14_2_1240)">
<path d="M19.7438 13.2563C19.4626 13.2563 19.1438 13.05 19.0501 12.9938C18.9563 12.9375 18.9001 12.9 18.8438 12.8813C18.6938 12.825 18.6563 12.7875 18.6376 12.5063C18.6376 12.45 18.6376 12.3938 18.6188 12.3375C18.6001 12.15 18.5813 11.9438 18.6001 11.7375V11.6813H18.8438C19.2563 11.6813 19.6501 11.7938 19.9501 12.0188C20.0813 12.1125 20.3251 12.375 20.3063 12.6C20.3063 12.675 20.2688 12.7688 20.1563 12.825C20.1188 13.2 19.8751 13.2563 19.7438 13.2563ZM18.7126 11.8125C18.7126 11.9813 18.7126 12.1688 18.7313 12.3375C18.7313 12.3938 18.7313 12.45 18.7501 12.5063C18.7688 12.7313 18.7876 12.7313 18.8813 12.7688C18.9376 12.7875 19.0126 12.825 19.1251 12.8813C19.2938 12.9938 19.5563 13.125 19.7438 13.125C19.8563 13.125 20.0063 13.0875 20.0251 12.7875V12.75L20.0626 12.7313C20.1376 12.6938 20.1751 12.6563 20.1751 12.5813C20.1938 12.4313 20.0063 12.2063 19.8751 12.1125C19.5938 11.9063 19.2188 11.7938 18.8438 11.7938C18.8063 11.8125 18.7688 11.8125 18.7126 11.8125Z" fill="black"/>
</g>
<mask id="mask15_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask15_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0812 12.7875C19.9875 12.75 19.875 12.7312 19.8187 12.6375L20.0812 12.7875Z" fill="#C6B198"/>
</g>
<mask id="mask16_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask16_2_1240)">
<path d="M20.0812 12.8625H20.0625L20.025 12.8437C19.9312 12.8062 19.8375 12.7875 19.7812 12.6937C19.7625 12.675 19.7625 12.6187 19.8 12.6C19.8187 12.5812 19.875 12.5812 19.8937 12.6187C19.9312 12.675 20.0062 12.6937 20.0812 12.7312C20.1 12.7312 20.1187 12.75 20.1187 12.75C20.1562 12.7687 20.175 12.8062 20.1562 12.825C20.1375 12.8437 20.1 12.8625 20.0812 12.8625Z" fill="black"/>
</g>
<mask id="mask17_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask17_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.775 0.75C14.325 0.75 16.7063 1.10625 17.9625 3.5625C19.0875 6.3 18.675 9.2625 18.8625 12.1688C19.0125 14.6625 19.3313 17.5313 18.1875 19.8375C16.9688 22.2563 13.9313 22.875 11.4375 22.7813C9.46879 22.7063 7.10629 22.0688 5.98129 20.2688C4.68754 18.1688 5.28754 15.0375 5.38129 12.6938C5.49379 9.91875 4.63129 7.125 5.55004 4.425C6.46879 1.59375 9.01879 0.95625 11.775 0.75Z" fill="#6AD7E5"/>
</g>
<mask id="mask18_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask18_2_1240)">
<path d="M11.8688 22.8563H11.4C10.6313 22.8375 9.46876 22.7063 8.32501 22.2375C7.21876 21.7875 6.41251 21.15 5.88751 20.3063C4.83751 18.6 5.02501 16.2563 5.19376 14.175C5.23126 13.65 5.26876 13.1625 5.28751 12.6938C5.32501 11.7188 5.25001 10.7063 5.15626 9.75004C5.00626 7.98754 4.85626 6.16879 5.43751 4.40629C5.88751 3.09379 6.69376 2.15629 7.91251 1.55629C8.86876 1.08754 10.05 0.825043 11.7375 0.693793C14.25 0.675043 16.7438 1.03129 18 3.52504C18.825 5.53129 18.825 7.68754 18.8438 9.76879C18.8438 10.5563 18.8438 11.3625 18.9 12.15C18.9188 12.3938 18.9375 12.6375 18.9375 12.8813C19.0875 15.1688 19.2563 17.7563 18.2063 19.8563C17.6813 20.925 16.7625 21.7125 15.5063 22.2188C14.4938 22.6313 13.2188 22.8563 11.8688 22.8563ZM11.775 0.806293C9.13126 1.01254 6.54376 1.59379 5.58751 4.44379C5.00626 6.18754 5.15626 7.98754 5.30626 9.73129C5.38126 10.7063 5.47501 11.7 5.43751 12.6938C5.41876 13.1625 5.38126 13.65 5.34376 14.175C5.17501 16.2375 4.98751 18.5625 6.01876 20.2313C6.45001 20.925 7.83751 22.575 11.4188 22.7063H11.8875C16.0313 22.7063 17.5688 20.8688 18.1313 19.7813C19.1625 17.7188 18.9938 15.1313 18.8625 12.8625C18.8438 12.6188 18.825 12.375 18.825 12.1313C18.7875 11.3438 18.7688 10.5375 18.7688 9.75004C18.75 7.68754 18.75 5.53129 17.9438 3.54379C17.3813 2.43754 16.5375 1.68754 15.375 1.25629C14.175 0.862543 12.825 0.806293 11.775 0.806293Z" fill="black"/>
</g>
<mask id="mask19_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask19_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.2251 4.16253C12.6751 6.82503 17.0251 6.11253 16.4063 3.43128C15.8438 1.03128 12.0751 1.70628 12.2251 4.16253Z" fill="white"/>
</g>
<mask id="mask20_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask20_2_1240)">
<path d="M14.2876 5.9063C13.4438 5.9063 12.3751 5.4563 12.1501 4.1813C12.1126 3.5813 12.3001 3.03755 12.6938 2.62505C13.1251 2.1563 13.7813 1.8938 14.4563 1.8938C15.2438 1.8938 16.1813 2.3063 16.4438 3.45005C16.5938 4.08755 16.4813 4.65005 16.1251 5.10005C15.7313 5.58755 15.0376 5.9063 14.2876 5.9063ZM12.2813 4.16255C12.3751 4.68755 12.6188 5.10005 13.0126 5.40005C13.3501 5.66255 13.8188 5.7938 14.2876 5.7938C14.9813 5.7938 15.6563 5.4938 16.0313 5.02505C16.3688 4.61255 16.4626 4.0688 16.3313 3.4688C16.0876 2.40005 15.2063 2.02505 14.4563 2.02505C13.8188 2.02505 13.2001 2.28755 12.7876 2.7188C12.4313 3.0938 12.2438 3.60005 12.2813 4.16255Z" fill="black"/>
</g>
<mask id="mask21_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask21_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.03123 4.5938C7.63123 6.90005 11.325 6.3188 11.1937 3.9938C11.025 1.2188 6.44998 1.7438 7.03123 4.5938Z" fill="white"/>
</g>
<mask id="mask22_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask22_2_1240)">
<path d="M9 6.13123C8.19375 6.13123 7.25625 5.73748 6.95625 4.61248C6.825 3.95623 6.95625 3.35623 7.33125 2.90623C7.74375 2.39998 8.41875 2.09998 9.15 2.09998C10.125 2.09998 11.1563 2.68123 11.2313 3.99373C11.2688 4.53748 11.1 5.02498 10.725 5.41873C10.3313 5.84998 9.675 6.13123 9 6.13123ZM9.15 2.23123C8.45625 2.23123 7.81875 2.51248 7.425 2.98123C7.06875 3.41248 6.95625 3.95623 7.0875 4.57498C7.35 5.62498 8.25 5.99998 9 5.99998C9.6375 5.99998 10.2563 5.75623 10.65 5.32498C10.9875 4.96873 11.1563 4.49998 11.1188 3.99373C11.0813 3.18748 10.5375 2.23123 9.15 2.23123Z" fill="black"/>
</g>
<mask id="mask23_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask23_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 7.34995C12.75 7.68745 12.825 8.0812 12.7688 8.4562C12.675 8.62495 12.5063 8.6437 12.3563 8.69995C12.15 8.66245 11.9813 8.5312 11.8875 8.3437C11.8313 7.9312 11.9063 7.5187 11.925 7.1062L12.75 7.34995Z" fill="white"/>
</g>
<mask id="mask24_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask24_2_1240)">
<path d="M12.3562 8.77505C12.1125 8.73755 11.925 8.58755 11.8312 8.3813C11.7937 8.0813 11.8125 7.80005 11.8312 7.5188C11.85 7.38755 11.85 7.2563 11.85 7.12505V7.05005L12.8062 7.35005V7.38755C12.8062 7.50005 12.825 7.61255 12.825 7.7438C12.8437 7.98755 12.8625 8.25005 12.825 8.4938V8.51255C12.75 8.66255 12.6187 8.70005 12.4875 8.7563C12.45 8.73755 12.4125 8.7563 12.3562 8.77505ZM11.9437 8.32505C12.0187 8.4938 12.1687 8.6063 12.3375 8.6438C12.375 8.62505 12.4125 8.62505 12.4312 8.6063C12.5437 8.5688 12.6375 8.5313 12.6937 8.43755C12.7312 8.21255 12.7125 7.9688 12.6937 7.72505C12.6937 7.61255 12.675 7.50005 12.675 7.4063L11.9625 7.1813C11.9625 7.2938 11.9437 7.4063 11.9437 7.50005C11.925 7.80005 11.9062 8.06255 11.9437 8.32505Z" fill="black"/>
</g>
<mask id="mask25_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask25_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.68123 4.2187C8.68123 4.5937 8.39998 4.8937 8.06248 4.8937C7.72498 4.8937 7.44373 4.5937 7.44373 4.2187C7.44373 3.8437 7.72498 3.5437 8.06248 3.5437C8.39998 3.5437 8.68123 3.8437 8.68123 4.2187Z" fill="black"/>
</g>
<mask id="mask26_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask26_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.47505 4.3687C8.47505 4.46245 8.40005 4.53745 8.32505 4.53745C8.25005 4.53745 8.17505 4.46245 8.17505 4.3687C8.17505 4.27495 8.25005 4.19995 8.32505 4.19995C8.4188 4.19995 8.47505 4.27495 8.47505 4.3687Z" fill="white"/>
</g>
<mask id="mask27_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask27_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9125 4.05C13.9125 4.425 13.6313 4.725 13.2938 4.725C12.9563 4.725 12.675 4.425 12.675 4.05C12.675 3.675 12.9563 3.375 13.2938 3.375C13.6313 3.375 13.9125 3.675 13.9125 4.05Z" fill="black"/>
</g>
<mask id="mask28_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask28_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.725 4.2C13.725 4.29375 13.6687 4.36875 13.575 4.36875C13.5 4.36875 13.425 4.29375 13.425 4.2C13.425 4.10625 13.4812 4.03125 13.575 4.03125C13.65 4.03125 13.725 4.10625 13.725 4.2ZM10.95 7.3125C10.6687 7.96875 11.1 9.3 11.85 8.325C11.7937 7.9125 11.8687 7.5 11.8875 7.0875L10.95 7.3125Z" fill="white"/>
</g>
<mask id="mask29_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask29_2_1240)">
<path d="M11.3437 8.73752C11.2125 8.73752 11.0812 8.66252 10.9875 8.51252C10.7812 8.21252 10.7437 7.65002 10.8937 7.29377L10.9125 7.25627L11.9437 6.99377V7.06877L11.925 7.48127C11.9062 7.76252 11.8875 8.02502 11.925 8.30627V8.32502L11.9062 8.34377C11.7187 8.60627 11.5312 8.73752 11.3437 8.73752ZM11.0062 7.36877C10.8937 7.68752 10.9312 8.19377 11.1 8.43752C11.175 8.55002 11.25 8.60627 11.3437 8.60627C11.475 8.60627 11.625 8.49377 11.775 8.30627C11.7375 8.02502 11.7562 7.74377 11.7937 7.48127L11.8125 7.16252L11.0062 7.36877Z" fill="black"/>
</g>
<mask id="mask30_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask30_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0438 6.03752C10.5375 6.07502 10.125 6.69377 10.3875 7.16252C10.7438 7.80002 11.5125 7.10627 12 7.16252C12.5625 7.18127 13.0125 7.76252 13.4625 7.27502C13.9688 6.73127 13.2375 6.20627 12.6938 5.96252L11.0438 6.03752Z" fill="#F6D2A2"/>
</g>
<mask id="mask31_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask31_2_1240)">
<path d="M13.0688 7.5375C12.9 7.5375 12.7313 7.4625 12.5625 7.3875C12.3938 7.3125 12.2063 7.2375 12 7.2375H11.9438C11.7938 7.2375 11.625 7.29375 11.4375 7.36875C11.2313 7.44375 11.025 7.5 10.8375 7.5C10.6125 7.5 10.4438 7.40625 10.3313 7.2C10.2 6.975 10.2188 6.7125 10.35 6.46875C10.5 6.1875 10.7625 6.01875 11.0438 5.98125L12.7125 5.90625H12.7313C13.1438 6.075 13.6125 6.39375 13.7063 6.76875C13.7438 6.95625 13.6875 7.14375 13.5375 7.3125C13.3875 7.48125 13.2375 7.5375 13.0688 7.5375ZM12.0188 7.125C12.225 7.125 12.4313 7.21875 12.6188 7.29375C12.7875 7.36875 12.9375 7.425 13.0875 7.425C13.2188 7.425 13.3313 7.36875 13.4438 7.25625C13.575 7.125 13.6125 6.975 13.5938 6.825C13.5188 6.50625 13.0688 6.20625 12.7125 6.05625L11.0813 6.13125C10.8375 6.15 10.6125 6.31875 10.4813 6.54375C10.3688 6.75 10.3688 6.975 10.4625 7.1625C10.5563 7.33125 10.6688 7.40625 10.8563 7.40625C11.025 7.40625 11.2125 7.33125 11.4 7.275C11.6063 7.2 11.775 7.14375 11.9625 7.14375C11.9625 7.10625 11.9813 7.10625 12.0188 7.125Z" fill="#231F20"/>
</g>
<mask id="mask32_2_1240" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="18" height="24">
<path d="M3.52502 0.1875H20.4938V23.8125H3.52502V0.1875Z" fill="white"/>
</mask>
<g mask="url(#mask32_2_1240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.9876 6.01876C10.9501 5.13751 12.6376 5.02501 12.8251 5.75626C13.0313 6.50626 11.0626 6.67501 10.9876 6.01876Z" fill="black"/>
</g>`, WY = /* @__PURE__ */ xr({
  __name: "LanguageGoIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? f_ : i(f_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-go-icon",
      "data-testid": "kui-icon-wrapper-language-go-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-go-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, VY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), KY = ["aria-hidden"], p_ = `<path d="M8.92824 18.3975C8.92824 18.3975 8.03443 18.9176 9.56518 19.0931C11.4199 19.305 12.3677 19.2746 14.4111 18.8884C14.4111 18.8884 14.9494 19.225 15.6998 19.5167C11.1175 21.4798 5.32956 19.4029 8.92824 18.3975ZM8.36799 15.8353C8.36799 15.8353 7.36524 16.5776 8.89731 16.7363C10.8786 16.9408 12.4429 16.9575 15.1512 16.4363C15.1512 16.4363 15.5249 16.816 16.1134 17.0233C10.5743 18.6433 4.40481 17.1508 8.36799 15.8353Z" fill="#0074BD"/>
<path d="M13.0879 11.4883C14.2175 12.7886 12.7916 13.9577 12.7916 13.9577C12.7916 13.9577 15.6583 12.4781 14.342 10.6245C13.1122 8.89669 12.1695 8.0385 17.2736 5.07825C17.2736 5.07843 9.26154 7.07887 13.0879 11.4883Z" fill="#EA2D2E"/>
<path d="M19.1481 20.2929C19.1481 20.2929 19.8098 20.8386 18.4191 21.2602C15.775 22.0612 7.4117 22.3027 5.08895 21.2923C4.25439 20.9289 5.82002 20.4251 6.31258 20.3188C6.82614 20.2076 7.11939 20.2279 7.11939 20.2279C6.1907 19.5741 1.11695 21.5122 4.54258 22.0682C13.884 23.5824 21.5708 21.3862 19.1481 20.2929ZM9.35852 13.1801C9.35852 13.1801 5.10489 14.1906 7.85233 14.5579C9.01258 14.7131 11.3245 14.6775 13.4794 14.4967C15.24 14.3488 17.0068 14.0329 17.0068 14.0329C17.0068 14.0329 16.3866 14.2989 15.9373 14.6053C11.617 15.7417 3.27283 15.2124 5.67527 14.0507C7.70627 13.0684 9.35852 13.1801 9.35852 13.1801ZM16.9892 17.4452C21.3806 15.1639 19.35 12.9714 17.9327 13.2667C17.5862 13.3389 17.4308 13.4017 17.4308 13.4017C17.4308 13.4017 17.5598 13.1994 17.8058 13.1124C20.6095 12.1271 22.7653 16.0192 16.9015 17.5609C16.9015 17.5605 16.9688 17.4996 16.9892 17.4452Z" fill="#0074BD"/>
<path d="M14.342 0.297607C14.342 0.297607 16.7735 2.73061 12.0352 6.47067C8.23535 9.47179 11.1688 11.1825 12.0339 13.138C9.81559 11.1368 8.18847 9.37486 9.27991 7.73517C10.8827 5.32879 15.3228 4.16161 14.342 0.297607Z" fill="#EA2D2E"/>
<path d="M9.79014 23.629C14.0044 23.8984 20.4776 23.479 20.6308 21.4847C20.6308 21.4847 20.3363 22.2407 17.1476 22.8406C13.5503 23.5178 9.11251 23.4389 6.48132 23.0044C6.48132 23.0046 7.02039 23.4509 9.79014 23.629Z" fill="#0074BD"/>`, ZY = /* @__PURE__ */ xr({
  __name: "LanguageJavaIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? p_ : i(p_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-java-icon",
      "data-testid": "kui-icon-wrapper-language-java-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-java-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, KY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), YY = ["aria-hidden"], d_ = `<g clip-path="url(#clip0_2_1379)">
<path d="M0.264038 0.264038H23.736V23.7362H0.264038V0.264038Z" fill="#F0DB4F"/>
<path d="M21.815 18.138C21.6431 17.0672 20.9449 16.1678 18.8765 15.3291C18.158 14.9989 17.357 14.7625 17.1184 14.218C17.0336 13.9011 17.0224 13.7226 17.076 13.5308C17.2299 12.9083 17.973 12.7142 18.5619 12.8927C18.9412 13.0199 19.3003 13.3122 19.5169 13.7785C20.5297 13.1226 20.5277 13.1269 21.2349 12.6762C20.976 12.2747 20.8378 12.0895 20.6683 11.9177C20.0591 11.2373 19.229 10.8869 17.9015 10.9137L17.21 11.0031C16.5474 11.1705 15.9159 11.5184 15.5456 11.9847C14.4345 13.2454 14.7514 15.4519 16.1034 16.36C17.4354 17.3597 19.3922 17.5872 19.6421 18.522C19.8853 19.6665 18.801 20.037 17.7232 19.9054C16.929 19.7402 16.4872 19.3365 16.0097 18.6025C15.1307 19.1112 15.1307 19.1112 14.2269 19.6309C14.4412 20.0995 14.6664 20.3115 15.0257 20.7175C16.7259 22.4421 20.9807 22.3574 21.7438 19.747C21.7747 19.6574 21.9802 19.0596 21.815 18.138ZM13.0241 11.0519H10.8287L10.8197 16.7278C10.8197 17.935 10.8821 19.0416 10.6858 19.3808C10.3646 20.0479 9.53229 19.9652 9.15298 19.8358C8.76692 19.6461 8.57061 19.3763 8.34317 18.9949C8.28073 18.8854 8.23386 18.8007 8.21811 18.7941L6.43311 19.8872C6.72992 20.4964 7.16717 21.0252 7.72723 21.3687C8.56386 21.8708 9.68829 22.0247 10.8643 21.7547C11.6297 21.5318 12.29 21.07 12.6358 20.367C13.1357 19.4455 13.0284 18.33 13.0239 17.0963C13.0352 15.0835 13.0241 13.071 13.0241 11.0519Z" fill="#323330"/>
</g>
<defs>
<clipPath id="clip0_2_1379">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, JY = /* @__PURE__ */ xr({
  __name: "LanguageJavascriptIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? d_ : i(d_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-javascript-icon",
      "data-testid": "kui-icon-wrapper-language-javascript-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-javascript-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, YY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), QY = ["aria-hidden"], h_ = `<g clip-path="url(#clip0_2_1382)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9803 17.6818C17.124 24.6939 22.158 15.7247 22.1505 10.3308C22.1419 3.95359 15.6784 0.389404 11.9762 0.389404C6.03413 0.389404 0.375 5.30041 0.375 12.0197C0.375 19.4882 6.86175 23.625 11.9762 23.625C10.8189 23.4583 6.96206 22.632 6.91012 13.7486C6.87525 7.74034 8.87006 5.33997 11.9677 6.39597C12.0371 6.42165 15.3846 7.74222 15.3846 12.056C15.3846 16.3513 11.9803 17.6818 11.9803 17.6818Z" fill="url(#paint0_linear_2_1382)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9743 6.39109C8.57549 5.21959 4.41187 8.02084 4.41187 13.6318C4.41187 22.7934 11.2011 23.625 12.024 23.625C17.9659 23.625 23.625 18.714 23.625 11.9947C23.625 4.52621 17.1382 0.389399 12.0238 0.389399C13.4404 0.193274 19.6586 1.9224 19.6586 10.4214C19.6586 15.9637 15.0154 18.981 11.9955 17.6919C11.9261 17.6662 8.57868 16.3456 8.57868 12.0318C8.57868 7.73621 11.9743 6.3909 11.9743 6.39109Z" fill="url(#paint1_linear_2_1382)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2_1382" x1="3.60969" y1="4.02333" x2="19.9869" y2="20.4052" gradientUnits="userSpaceOnUse">
<stop/>
<stop offset="1" stop-color="white"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1382" x1="20.7296" y1="19.6609" x2="4.35237" y2="3.28052" gradientUnits="userSpaceOnUse">
<stop/>
<stop offset="1" stop-color="white"/>
</linearGradient>
<clipPath id="clip0_2_1382">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, XY = /* @__PURE__ */ xr({
  __name: "LanguageJsonIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? h_ : i(h_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-json-icon",
      "data-testid": "kui-icon-wrapper-language-json-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-json-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, QY))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), eJ = ["aria-hidden"], m_ = `<g clip-path="url(#clip0_2_1385)">
<path d="M12.5547 0.154743C12.3824 0.0560657 12.1874 0.00415039 11.9889 0.00415039C11.7904 0.00415039 11.5953 0.0560657 11.4231 0.154743L2.08186 5.58006C1.72654 5.78106 1.52686 6.16037 1.52686 6.56256V17.4353C1.52686 17.8371 1.74867 18.2166 2.08148 18.4178L11.4227 23.8429C11.595 23.9416 11.7901 23.9936 11.9886 23.9936C12.1871 23.9936 12.3822 23.9416 12.5545 23.8429L21.8957 18.4176C22.2509 18.2166 22.4504 17.8371 22.4504 17.4351V6.56256C22.4504 6.16056 22.2285 5.78124 21.8957 5.58006L12.5547 0.154743Z" fill="url(#paint0_linear_2_1385)"/>
<path d="M21.9182 5.57997L12.5327 0.154653C12.4406 0.107813 12.3439 0.0704341 12.2442 0.0430908L1.72693 18.1496C1.81392 18.2565 1.91909 18.3473 2.03762 18.4177L11.4233 23.8428C11.6896 23.999 12.0001 24.0438 12.2886 23.9544L22.1624 5.78097C22.0975 5.69608 22.014 5.62729 21.9182 5.57997Z" fill="url(#paint1_linear_2_1385)"/>
<path d="M21.9184 18.4172C22.1847 18.261 22.3843 17.9931 22.473 17.7029L12.1999 0.0202985C11.9337 -0.0243265 11.6451 -0.00201398 11.4012 0.154361L2.08203 5.55736L12.1332 23.9989C12.2663 23.9764 12.4219 23.9318 12.555 23.8649L21.9184 18.4172Z" fill="url(#paint2_linear_2_1385)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2_1385" x1="15.793" y1="4.19491" x2="7.26197" y2="21.49" gradientUnits="userSpaceOnUse">
<stop stop-color="#3F873F"/>
<stop offset="0.33" stop-color="#3F8B3D"/>
<stop offset="0.637" stop-color="#3E9638"/>
<stop offset="0.934" stop-color="#3DA92E"/>
<stop offset="1" stop-color="#3DAE2B"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1385" x1="10.5695" y1="13.2686" x2="34.3718" y2="-4.20975" gradientUnits="userSpaceOnUse">
<stop offset="0.138" stop-color="#3F873F"/>
<stop offset="0.402" stop-color="#52A044"/>
<stop offset="0.713" stop-color="#64B749"/>
<stop offset="0.908" stop-color="#6ABF4B"/>
</linearGradient>
<linearGradient id="paint2_linear_2_1385" x1="1.18497" y1="11.9952" x2="22.8" y2="11.9952" gradientUnits="userSpaceOnUse">
<stop offset="0.092" stop-color="#6ABF4B"/>
<stop offset="0.287" stop-color="#64B749"/>
<stop offset="0.598" stop-color="#52A044"/>
<stop offset="0.862" stop-color="#3F873F"/>
</linearGradient>
<clipPath id="clip0_2_1385">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, tJ = /* @__PURE__ */ xr({
  __name: "LanguageNodejsIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? m_ : i(m_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-nodejs-icon",
      "data-testid": "kui-icon-wrapper-language-nodejs-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-nodejs-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, eJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), rJ = ["aria-hidden"], g_ = `<path d="M0 11.9999C0 15.4861 5.37262 18.3125 12 18.3125C18.6274 18.3125 24 15.4861 24 11.9999C24 8.51375 18.6272 5.68738 12 5.68738C5.37262 5.68738 0 8.51375 0 11.9999Z" fill="url(#paint0_radial_2_1389)"/>
<path d="M12 17.8438C18.3684 17.8438 23.5312 15.2272 23.5312 11.9999C23.5312 8.77232 18.3684 6.15613 12 6.15613C5.63156 6.15613 0.46875 8.77232 0.46875 11.9999C0.46875 15.2272 5.63156 17.8438 12 17.8438Z" fill="#777BB3"/>
<path d="M6.51973 12.7245C7.04341 12.7245 7.43416 12.6279 7.68148 12.4376C7.92635 12.249 8.09529 11.9225 8.18398 11.4673C8.26648 11.0417 8.23498 10.7447 8.09023 10.5842C7.94248 10.4203 7.62279 10.3372 7.14016 10.3372H6.30316L5.83948 12.7245H6.51973ZM3.78241 15.665C3.76321 15.665 3.74425 15.6607 3.7269 15.6525C3.70954 15.6443 3.69422 15.6323 3.68203 15.6175C3.66984 15.6027 3.66109 15.5853 3.6564 15.5667C3.65172 15.5481 3.65121 15.5286 3.65491 15.5098L4.88435 9.18392C4.89016 9.15435 4.90604 9.12771 4.92929 9.10853C4.95254 9.08935 4.98171 9.07882 5.01185 9.07874H7.66198C8.49485 9.07874 9.11473 9.30486 9.50454 9.75092C9.89604 10.199 10.0172 10.826 9.86398 11.6137C9.80154 11.9345 9.69429 12.2325 9.54523 12.4995C9.39006 12.7741 9.19207 13.0222 8.95873 13.2345C8.67166 13.503 8.34673 13.698 7.99366 13.8125C7.64641 13.9258 7.20016 13.9832 6.66804 13.9832H5.59479L5.28841 15.5597C5.28263 15.5893 5.26671 15.6161 5.24338 15.6353C5.22005 15.6545 5.19077 15.665 5.16054 15.665H3.78241Z" fill="black"/>
<path d="M6.41067 10.4674H7.14024C7.7228 10.4674 7.92511 10.5953 7.99392 10.6716C8.10774 10.798 8.12949 11.0648 8.05599 11.4426C7.97367 11.8658 7.82105 12.166 7.60224 12.3344C7.37836 12.5069 7.01386 12.5942 6.5198 12.5942H5.99742L6.41086 10.4676L6.41067 10.4674ZM7.66205 8.94867H5.01211C4.95168 8.94868 4.89313 8.96968 4.84648 9.00809C4.79983 9.0465 4.76797 9.09993 4.75636 9.15924L3.52692 15.4853C3.51966 15.523 3.52081 15.5618 3.53029 15.599C3.53977 15.6362 3.55735 15.6708 3.58176 15.7004C3.60617 15.73 3.63682 15.7539 3.67152 15.7703C3.70622 15.7867 3.74411 15.7952 3.78249 15.7952H5.16061C5.22104 15.7952 5.27956 15.7741 5.32618 15.7357C5.3728 15.6972 5.40461 15.6438 5.41617 15.5845L5.70211 14.1134H6.66792C7.21392 14.1134 7.67367 14.0537 8.03424 13.9364C8.40492 13.816 8.74599 13.6118 9.04786 13.3294C9.29092 13.108 9.49719 12.8494 9.65892 12.5631C9.81474 12.2843 9.92686 11.973 9.99174 11.6385C10.153 10.8092 10.0219 10.1453 9.60249 9.6653C9.18699 9.18961 8.53411 8.94849 7.66205 8.94849V8.94867ZM5.68149 12.8545H6.5198C7.07536 12.8545 7.48917 12.75 7.76105 12.5404C8.03311 12.3312 8.2163 11.9817 8.31192 11.4921C8.40286 11.0219 8.36142 10.6902 8.18724 10.4969C8.01267 10.3037 7.66393 10.207 7.14024 10.207H6.19599L5.68149 12.8545ZM7.66224 9.20855C8.45949 9.20855 9.04092 9.41799 9.40655 9.8363C9.77217 10.2548 9.88205 10.8389 9.73655 11.5887C9.67617 11.8977 9.57474 12.18 9.43186 12.4358C9.28861 12.6919 9.10186 12.9259 8.87105 13.1384C8.5958 13.3958 8.29036 13.5794 7.9538 13.6887C7.61742 13.7982 7.1888 13.8527 6.66811 13.8527H5.48761L5.1608 15.5346H3.78267L5.0123 9.20855H7.66224Z" fill="white"/>
<path d="M13.0235 13.9832C13.0043 13.9832 12.9853 13.979 12.9679 13.9708C12.9505 13.9626 12.9352 13.9507 12.923 13.9358C12.9107 13.921 12.9019 13.9037 12.8972 13.885C12.8925 13.8664 12.892 13.847 12.8956 13.8281L13.4394 11.0291C13.4913 10.7629 13.4786 10.572 13.4038 10.491C13.3578 10.4417 13.2202 10.359 12.8131 10.359H11.8276L11.144 13.878C11.1381 13.9076 11.1222 13.9343 11.0988 13.9534C11.0754 13.9726 11.0462 13.983 11.0159 13.983H9.64908C9.62987 13.983 9.61091 13.9788 9.59353 13.9706C9.57615 13.9624 9.5608 13.9505 9.54856 13.9357C9.53633 13.9209 9.52751 13.9036 9.52275 13.885C9.51799 13.8664 9.51739 13.847 9.52101 13.8281L10.7506 7.50204C10.7565 7.4724 10.7724 7.44571 10.7957 7.42652C10.819 7.40734 10.8483 7.39685 10.8785 7.39685H12.2454C12.2646 7.39684 12.2836 7.40107 12.3009 7.40924C12.3183 7.41741 12.3337 7.42932 12.3459 7.44412C12.3581 7.45892 12.367 7.47624 12.3717 7.49484C12.3765 7.51344 12.3771 7.53287 12.3734 7.55173L12.0768 9.07873H13.1368C13.9443 9.07873 14.4918 9.22085 14.8108 9.51391C15.1357 9.8126 15.2373 10.2902 15.1123 10.9339L14.5402 13.878C14.5343 13.9076 14.5184 13.9342 14.4951 13.9534C14.4717 13.9725 14.4425 13.983 14.4123 13.983H13.0235V13.9832Z" fill="black"/>
<path d="M12.2457 7.2666H10.8786C10.8181 7.26662 10.7596 7.28765 10.7129 7.32609C10.6663 7.36454 10.6344 7.41801 10.6229 7.47735L9.39342 13.8032C9.38612 13.8409 9.38725 13.8798 9.39671 13.917C9.40618 13.9542 9.42375 13.9888 9.44817 14.0185C9.47258 14.0481 9.50324 14.072 9.53796 14.0884C9.57267 14.1048 9.61058 14.1133 9.64898 14.1134H11.016C11.0765 14.1133 11.1351 14.0923 11.1817 14.0539C11.2284 14.0154 11.2602 13.9619 11.2718 13.9026L11.935 10.4892H12.8129C13.2194 10.4892 13.3049 10.576 13.308 10.5799C13.3328 10.6062 13.3652 10.729 13.3116 11.0044L12.7679 13.8032C12.7606 13.8409 12.7617 13.8798 12.7712 13.917C12.7806 13.9542 12.7982 13.9889 12.8227 14.0185C12.8471 14.0482 12.8778 14.072 12.9125 14.0884C12.9473 14.1048 12.9852 14.1133 13.0236 14.1134H14.4126C14.473 14.1133 14.5316 14.0922 14.5782 14.0538C14.6248 14.0154 14.6566 13.9619 14.6682 13.9026L15.2402 10.9589C15.3743 10.2677 15.2595 9.74948 14.899 9.41816C14.5547 9.10204 13.9784 8.94848 13.1369 8.94848H12.235L12.5014 7.57691C12.5087 7.53919 12.5076 7.50031 12.4982 7.46306C12.4887 7.42582 12.4711 7.39112 12.4467 7.36147C12.4223 7.33181 12.3916 7.30793 12.3568 7.29153C12.322 7.27513 12.2841 7.26662 12.2457 7.2666ZM12.2457 7.52723L11.9189 9.20873H13.1369C13.9032 9.20873 14.4319 9.3426 14.7225 9.60998C15.0137 9.87735 15.1007 10.3103 14.9847 10.9094L14.4124 13.8529H13.0236L13.5675 11.0539C13.6294 10.7355 13.6065 10.5184 13.4991 10.4025C13.3917 10.2869 13.1629 10.2289 12.8132 10.2289H11.7203L11.016 13.8527H9.64879L10.8784 7.52666H12.2457V7.52723Z" fill="white"/>
<path d="M17.2755 12.7245C17.7992 12.7245 18.1901 12.6279 18.4376 12.4376C18.6821 12.249 18.8513 11.9225 18.94 11.4673C19.0225 11.0417 18.9911 10.7447 18.8462 10.5842C18.6985 10.4203 18.3788 10.3372 17.8961 10.3372H17.0593L16.5953 12.7245H17.2755ZM14.5388 15.665C14.5195 15.6651 14.5005 15.6608 14.4831 15.6526C14.4657 15.6445 14.4504 15.6325 14.4381 15.6177C14.4259 15.6028 14.4171 15.5854 14.4124 15.5668C14.4077 15.5481 14.4072 15.5287 14.4109 15.5098L15.6403 9.18392C15.6462 9.15429 15.6621 9.1276 15.6854 9.10841C15.7087 9.08922 15.738 9.07873 15.7682 9.07874H18.4181C19.251 9.07874 19.8709 9.30486 20.2605 9.75092C20.6522 10.199 20.7731 10.826 20.62 11.6137C20.5614 11.924 20.4539 12.223 20.3014 12.4995C20.1462 12.7741 19.9482 13.0222 19.7149 13.2345C19.428 13.503 19.1027 13.698 18.7498 13.8125C18.4026 13.9258 17.9563 13.9832 17.424 13.9832H16.351L16.0448 15.5597C16.039 15.5894 16.023 15.6161 15.9997 15.6354C15.9763 15.6546 15.947 15.6651 15.9167 15.665H14.5388Z" fill="black"/>
<path d="M17.1665 10.4674H17.8961C18.4787 10.4674 18.681 10.5953 18.7496 10.6716C18.864 10.798 18.8853 11.0648 18.812 11.4426C18.7295 11.8658 18.5769 12.166 18.3581 12.3344C18.134 12.5069 17.7695 12.5942 17.2757 12.5942H16.7533L17.1665 10.4674ZM18.4179 8.94867H15.768C15.7076 8.94872 15.6491 8.96975 15.6025 9.00815C15.5558 9.04656 15.524 9.09996 15.5124 9.15924L14.2828 15.4853C14.2755 15.523 14.2767 15.5618 14.2862 15.599C14.2957 15.6362 14.3132 15.6709 14.3377 15.7005C14.3621 15.7301 14.3928 15.7539 14.4275 15.7703C14.4622 15.7867 14.5001 15.7952 14.5385 15.7952H15.9167C15.9771 15.7952 16.0356 15.7741 16.0822 15.7357C16.1288 15.6972 16.1607 15.6438 16.1722 15.5845L16.4582 14.1134H17.4238C17.9696 14.1134 18.4295 14.0537 18.7899 13.9364C19.1608 13.816 19.5018 13.6118 19.8039 13.3292C20.0469 13.1079 20.2531 12.8493 20.4148 12.5631C20.5708 12.2843 20.6825 11.973 20.7476 11.6385C20.9088 10.8092 20.778 10.1453 20.3583 9.6653C19.9428 9.18961 19.2902 8.94849 18.4177 8.94849L18.4179 8.94867ZM16.4373 12.8545H17.2755C17.8312 12.8545 18.2448 12.75 18.5171 12.5404C18.789 12.3312 18.9723 11.9817 19.0676 11.4921C19.1589 11.0219 19.1175 10.6902 18.9429 10.4969C18.7685 10.3037 18.4196 10.207 17.8961 10.207H16.952L16.4373 12.8545ZM18.4179 9.20855C19.215 9.20855 19.7968 9.41799 20.1622 9.8363C20.5278 10.2548 20.6379 10.8389 20.492 11.5887C20.432 11.8977 20.3304 12.18 20.1875 12.4358C20.0445 12.6919 19.8575 12.9259 19.6265 13.1384C19.3515 13.3958 19.0458 13.5794 18.7093 13.6887C18.3731 13.7982 17.9447 13.8527 17.4238 13.8527H16.2435L15.9163 15.5346H14.5382L15.7678 9.20855H18.4179Z" fill="white"/>
<defs>
<radialGradient id="paint0_radial_2_1389" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.20487 7.90663) scale(15.7578)">
<stop stop-color="#AEB2D5"/>
<stop offset="0.3" stop-color="#AEB2D5"/>
<stop offset="0.75" stop-color="#484C89"/>
<stop offset="1" stop-color="#484C89"/>
</radialGradient>
</defs>`, nJ = /* @__PURE__ */ xr({
  __name: "LanguagePhpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? g_ : i(g_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-php-icon",
      "data-testid": "kui-icon-wrapper-language-php-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-php-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, rJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), iJ = ["aria-hidden"], v_ = `<path d="M11.8858 2.29654C11.0942 2.30029 10.3386 2.3676 9.67335 2.48535C7.71398 2.83147 7.35848 3.55597 7.35848 4.89229V6.65685H11.9884V7.24504H5.62073C4.27523 7.24504 3.09698 8.05372 2.72835 9.59272C2.3031 11.3562 2.28435 12.4568 2.72835 14.2982C3.05741 15.669 3.84341 16.6455 5.1891 16.6455H6.78116V14.5302C6.78116 13.0018 8.10323 11.6539 9.67354 11.6539H14.2982C15.5856 11.6539 16.6131 10.5938 16.6131 9.30116V4.89247C16.6131 3.63754 15.5545 2.69497 14.2982 2.48554C13.5025 2.35316 12.6773 2.29297 11.8858 2.29654ZM9.38198 3.71572C9.8601 3.71572 10.2509 4.11266 10.2509 4.60091C10.2509 5.0871 9.86029 5.48029 9.38198 5.48029C8.90198 5.48029 8.51329 5.0871 8.51329 4.60091C8.5131 4.11266 8.90198 3.71572 9.38198 3.71572Z" fill="url(#paint0_linear_2_1403)"/>
<path d="M17.1903 7.24506V9.30119C17.1903 10.8949 15.8388 12.2365 14.298 12.2365H9.67327C8.40652 12.2365 7.3584 13.3208 7.3584 14.5894V18.9985C7.3584 20.2531 8.44927 20.9912 9.67327 21.3511C11.1388 21.7817 12.5443 21.8597 14.298 21.3511C15.4635 21.0134 16.6128 20.3342 16.6128 18.9985V17.2337H11.9883V16.6454H18.9281C20.2736 16.6454 20.7753 15.7069 21.2433 14.2981C21.7267 12.8477 21.7059 11.4529 21.2433 9.59256C20.9107 8.25287 20.2756 7.24487 18.9281 7.24487L17.1903 7.24506ZM14.5891 18.4101C15.0693 18.4101 15.458 18.8033 15.458 19.2899C15.458 19.7777 15.0691 20.1747 14.5891 20.1747C14.111 20.1747 13.7205 19.7777 13.7205 19.2899C13.7205 18.8033 14.111 18.4101 14.5891 18.4101Z" fill="url(#paint1_linear_2_1403)"/>
<path opacity="0.444" d="M18.2455 22.4244C18.2455 23.0887 15.4675 23.6274 12.0409 23.6274C8.61418 23.6274 5.83618 23.0887 5.83618 22.4244C5.83618 21.7599 8.61399 21.2212 12.0409 21.2212C15.4675 21.2212 18.2455 21.7597 18.2455 22.4244Z" fill="url(#paint2_radial_2_1403)"/>
<defs>
<linearGradient id="paint0_linear_2_1403" x1="1.9382" y1="2.84828" x2="12.617" y2="11.9551" gradientUnits="userSpaceOnUse">
<stop stop-color="#5A9FD4"/>
<stop offset="1" stop-color="#306998"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1403" x1="16.6347" y1="17.6161" x2="12.8051" y2="12.2457" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFD43B"/>
<stop offset="1" stop-color="#FFE873"/>
</linearGradient>
<radialGradient id="paint2_radial_2_1403" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.0159 22.3899) rotate(-90) scale(1.20343 5.2901)">
<stop stop-color="#B8B8B8" stop-opacity="0.498"/>
<stop offset="1" stop-color="#7F7F7F" stop-opacity="0"/>
</radialGradient>
</defs>`, aJ = /* @__PURE__ */ xr({
  __name: "LanguagePythonIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? v_ : i(v_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-python-icon",
      "data-testid": "kui-icon-wrapper-language-python-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-python-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, iJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), oJ = ["aria-hidden"], y_ = `<path fill-rule="evenodd" clip-rule="evenodd" d="M12 18.8213C5.37262 18.8213 0 15.2232 0 10.7845C0 6.34599 5.37262 2.74768 12 2.74768C18.6274 2.74768 24 6.34581 24 10.7845C24 15.223 18.6274 18.8213 12 18.8213ZM13.8368 5.88999C8.79937 5.88999 4.71562 8.34981 4.71562 11.3843C4.71562 14.4186 8.79937 16.8786 13.8368 16.8786C18.8741 16.8786 22.5917 15.1967 22.5917 11.3843C22.5917 7.57299 18.8741 5.88999 13.8368 5.88999Z" fill="url(#paint0_linear_2_1407)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.2754 15.1936C18.2754 15.1936 19.0018 15.4128 19.4237 15.6264C19.5699 15.7005 19.8234 15.8482 20.0061 16.0425C20.1133 16.156 20.203 16.2849 20.2723 16.425L23.1347 21.2512L18.5083 21.2531L16.3451 17.1907C16.3451 17.1907 15.9021 16.4295 15.6294 16.2088C15.402 16.0246 15.3051 15.9592 15.0802 15.9592H13.9811L13.9819 21.2503L9.88818 21.252V7.73621H18.1089C18.1089 7.73621 21.8533 7.80371 21.8533 11.366C21.8533 14.9283 18.2754 15.1936 18.2754 15.1936ZM16.4947 10.668L14.0164 10.6663L14.0152 12.9646L16.4947 12.9637C16.4947 12.9637 17.643 12.9601 17.643 11.7946C17.643 10.6059 16.4947 10.668 16.4947 10.668Z" fill="url(#paint1_linear_2_1407)"/>
<defs>
<linearGradient id="paint0_linear_2_1407" x1="0.000135372" y1="2.74591" x2="14.8636" y2="24.9385" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCED0"/>
<stop offset="1" stop-color="#84838B"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1407" x1="9.88818" y1="7.73612" x2="23.4023" y2="20.9796" gradientUnits="userSpaceOnUse">
<stop stop-color="#276DC3"/>
<stop offset="1" stop-color="#165CAA"/>
</linearGradient>
</defs>`, sJ = /* @__PURE__ */ xr({
  __name: "LanguageRIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? y_ : i(y_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-r-icon",
      "data-testid": "kui-icon-wrapper-language-r-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-r-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, oJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), uJ = ["aria-hidden"], b_ = `<g clip-path="url(#clip0_2_1410)">
<path d="M18.2021 15.6026L5.31372 23.2558L22.0018 22.1233L23.2871 5.29614L18.2021 15.6026Z" fill="url(#paint0_linear_2_1410)"/>
<path d="M22.029 22.1118L20.5948 12.212L16.6879 17.3709L22.029 22.1118Z" fill="url(#paint1_linear_2_1410)"/>
<path d="M22.0485 22.1119L11.5403 21.2871L5.36963 23.2343L22.0485 22.1119Z" fill="url(#paint2_linear_2_1410)"/>
<path d="M5.38448 23.2365L8.00966 14.6365L2.23279 15.8717L5.38448 23.2365Z" fill="url(#paint3_linear_2_1410)"/>
<path d="M16.6868 17.3995L14.2714 7.93823L7.35901 14.4179L16.6868 17.3995Z" fill="url(#paint4_linear_2_1410)"/>
<path d="M22.7391 8.07137L16.2049 2.73474L14.3854 8.61718L22.7391 8.07137Z" fill="url(#paint5_linear_2_1410)"/>
<path d="M19.6833 0.831967L15.8401 2.95578L13.4158 0.803467L19.6833 0.831967Z" fill="url(#paint6_linear_2_1410)"/>
<path d="M0.712891 18.7564L2.32277 15.8203L1.02039 12.3225L0.712891 18.7564Z" fill="url(#paint7_linear_2_1410)"/>
<path d="M0.93396 12.212L2.24402 15.9285L7.93746 14.6512L14.4375 8.61033L16.2718 2.78377L13.3838 0.744141L8.47315 2.58202C6.9259 4.02108 3.92384 6.86827 3.81565 6.92189C3.70821 6.97645 1.83283 10.521 0.93396 12.212Z" fill="white"/>
<path d="M5.53484 5.53519C8.88771 2.21081 13.2105 0.246377 14.8695 1.92019C16.5276 3.59381 14.7694 7.66144 11.4161 10.9849C8.0629 14.3083 3.79371 16.3809 2.13621 14.7071C0.477024 13.0346 2.18159 8.85881 5.53484 5.53519Z" fill="url(#paint8_linear_2_1410)"/>
<path d="M5.3844 23.233L7.98877 14.6057L16.6391 17.3845C13.5116 20.3173 10.0329 22.7966 5.3844 23.233Z" fill="url(#paint9_linear_2_1410)"/>
<path d="M14.4491 8.59326L16.6698 17.3891C19.2825 14.6422 21.6272 11.6889 22.7754 8.03601L14.4491 8.59326Z" fill="url(#paint10_linear_2_1410)"/>
<path d="M22.7528 8.08073C23.6415 5.39855 23.8465 1.55104 19.6558 0.83667L16.2173 2.73604L22.7528 8.08073Z" fill="url(#paint11_linear_2_1410)"/>
<path d="M0.712891 18.7177C0.835891 23.1442 4.02958 23.21 5.39008 23.249L2.24777 15.9103L0.712891 18.7177Z" fill="#9E1209"/>
<path d="M14.4615 8.60695C16.4693 9.84089 20.5152 12.3191 20.5971 12.3646C20.7246 12.4365 22.3416 9.63802 22.7085 8.05664L14.4615 8.60695Z" fill="url(#paint12_radial_2_1410)"/>
<path d="M7.98547 14.6057L11.4673 21.3235C13.5261 20.2069 15.1384 18.8464 16.615 17.3891L7.98547 14.6057Z" fill="url(#paint13_radial_2_1410)"/>
<path d="M2.23391 15.9196L1.7406 21.7941C2.67135 23.0656 3.95198 23.1762 5.2956 23.077C4.3236 20.6582 2.38223 15.8215 2.23391 15.9196Z" fill="url(#paint14_linear_2_1410)"/>
<path d="M16.197 2.7506L23.1141 3.72128C22.7449 2.15697 21.6113 1.14747 19.6791 0.831909L16.197 2.7506Z" fill="url(#paint15_linear_2_1410)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2_1410" x1="20.5462" y1="25.3031" x2="15.7841" y2="16.8953" gradientUnits="userSpaceOnUse">
<stop stop-color="#FB7655"/>
<stop offset="0.41" stop-color="#E42B1E"/>
<stop offset="0.99" stop-color="#990000"/>
<stop offset="1" stop-color="#990000"/>
</linearGradient>
<linearGradient id="paint1_linear_2_1410" x1="22.9183" y1="18.24" x2="16.7809" y2="14.1215" gradientUnits="userSpaceOnUse">
<stop stop-color="#871101"/>
<stop offset="0.99" stop-color="#911209"/>
<stop offset="1" stop-color="#911209"/>
</linearGradient>
<linearGradient id="paint2_linear_2_1410" x1="18.0079" y1="25.5582" x2="11.8706" y2="21.4397" gradientUnits="userSpaceOnUse">
<stop stop-color="#871101"/>
<stop offset="0.99" stop-color="#911209"/>
<stop offset="1" stop-color="#911209"/>
</linearGradient>
<linearGradient id="paint3_linear_2_1410" x1="5.12198" y1="15.2584" x2="6.07335" y2="21.4418" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.23" stop-color="#E57252"/>
<stop offset="0.46" stop-color="#DE3B20"/>
<stop offset="0.99" stop-color="#A60003"/>
<stop offset="1" stop-color="#A60003"/>
</linearGradient>
<linearGradient id="paint4_linear_2_1410" x1="11.6661" y1="9.48511" x2="12.0167" y2="15.7956" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.23" stop-color="#E4714E"/>
<stop offset="0.56" stop-color="#BE1A0D"/>
<stop offset="0.99" stop-color="#A80D00"/>
<stop offset="1" stop-color="#A80D00"/>
</linearGradient>
<linearGradient id="paint5_linear_2_1410" x1="17.4733" y1="3.65199" x2="18.5229" y2="8.17487" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.18" stop-color="#E46342"/>
<stop offset="0.4" stop-color="#C82410"/>
<stop offset="0.99" stop-color="#A80D00"/>
<stop offset="1" stop-color="#A80D00"/>
</linearGradient>
<linearGradient id="paint6_linear_2_1410" x1="14.2687" y1="2.05915" x2="18.791" y2="-0.201908" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.54" stop-color="#C81F11"/>
<stop offset="0.99" stop-color="#BF0905"/>
<stop offset="1" stop-color="#BF0905"/>
</linearGradient>
<linearGradient id="paint7_linear_2_1410" x1="1.15764" y1="13.6823" x2="1.53002" y2="17.4088" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="0.31" stop-color="#DE4024"/>
<stop offset="0.99" stop-color="#BF190B"/>
<stop offset="1" stop-color="#BF190B"/>
</linearGradient>
<linearGradient id="paint8_linear_2_1410" x1="-1.40135" y1="18.4161" x2="16.096" y2="0.42394" gradientUnits="userSpaceOnUse">
<stop stop-color="#BD0012"/>
<stop offset="0.07" stop-color="white"/>
<stop offset="0.17" stop-color="white"/>
<stop offset="0.27" stop-color="#C82F1C"/>
<stop offset="0.33" stop-color="#820C01"/>
<stop offset="0.46" stop-color="#A31601"/>
<stop offset="0.72" stop-color="#B31301"/>
<stop offset="0.99" stop-color="#E82609"/>
<stop offset="1" stop-color="#E82609"/>
</linearGradient>
<linearGradient id="paint9_linear_2_1410" x1="12.0013" y1="20.2309" x2="6.73084" y2="18.9302" gradientUnits="userSpaceOnUse">
<stop stop-color="#8C0C01"/>
<stop offset="0.54" stop-color="#990C00"/>
<stop offset="0.99" stop-color="#A80D0E"/>
<stop offset="1" stop-color="#A80D0E"/>
</linearGradient>
<linearGradient id="paint10_linear_2_1410" x1="21.0534" y1="13.9055" x2="16.3713" y2="9.70926" gradientUnits="userSpaceOnUse">
<stop stop-color="#7E110B"/>
<stop offset="0.99" stop-color="#9E0C00"/>
<stop offset="1" stop-color="#9E0C00"/>
</linearGradient>
<linearGradient id="paint11_linear_2_1410" x1="22.7736" y1="6.20611" x2="20.4415" y2="3.71273" gradientUnits="userSpaceOnUse">
<stop stop-color="#79130D"/>
<stop offset="0.99" stop-color="#9E120B"/>
<stop offset="1" stop-color="#9E120B"/>
</linearGradient>
<radialGradient id="paint12_radial_2_1410" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.1006 9.78952) scale(5.73769)">
<stop stop-color="#A80D00"/>
<stop offset="0.99" stop-color="#7E0E08"/>
<stop offset="1" stop-color="#7E0E08"/>
</radialGradient>
<radialGradient id="paint13_radial_2_1410" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9.15472 17.3503) scale(7.62731)">
<stop stop-color="#A30C00"/>
<stop offset="0.99" stop-color="#800E08"/>
<stop offset="1" stop-color="#800E08"/>
</radialGradient>
<linearGradient id="paint14_linear_2_1410" x1="3.75173" y1="23.2285" x2="1.85122" y2="16.7802" gradientUnits="userSpaceOnUse">
<stop stop-color="#8B2114"/>
<stop offset="0.43" stop-color="#9E100A"/>
<stop offset="0.99" stop-color="#B3100C"/>
<stop offset="1" stop-color="#B3100C"/>
</linearGradient>
<linearGradient id="paint15_linear_2_1410" x1="18.3323" y1="1.86072" x2="22.593" y2="3.74153" gradientUnits="userSpaceOnUse">
<stop stop-color="#B31000"/>
<stop offset="0.44" stop-color="#910F08"/>
<stop offset="0.99" stop-color="#791C12"/>
<stop offset="1" stop-color="#791C12"/>
</linearGradient>
<clipPath id="clip0_2_1410">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, cJ = /* @__PURE__ */ xr({
  __name: "LanguageRubyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? b_ : i(b_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-ruby-icon",
      "data-testid": "kui-icon-wrapper-language-ruby-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-ruby-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, uJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), lJ = ["aria-hidden"], x_ = `<g clip-path="url(#clip0_2_1429)">
<path d="M23.6868 6.38629C23.6867 5.8932 23.6371 5.40136 23.5387 4.91817C23.4403 4.42353 23.2731 3.94512 23.0418 3.49692C22.8002 3.06279 22.4999 2.66404 22.1493 2.31192C21.7878 1.95818 21.3679 1.66956 20.9081 1.45879C20.4543 1.22999 19.969 1.07011 19.4681 0.984419C18.9712 0.888794 18.4256 0.888794 17.9287 0.841919H5.67185C5.28951 0.848145 4.90802 0.880092 4.52997 0.937544C4.15481 0.98171 3.78757 1.07762 3.43873 1.22254C3.33935 1.26942 3.19123 1.31817 3.09185 1.36504C2.7618 1.54196 2.44808 1.74776 2.15435 1.98004C2.05498 2.07567 1.9556 2.12254 1.85623 2.21629C1.4908 2.55523 1.18859 2.95649 0.963726 3.40129C0.718162 3.8432 0.550107 4.3239 0.466851 4.82254C0.392961 5.30913 0.343524 5.79912 0.318726 6.29067V17.6138C0.31888 18.1069 0.368503 18.5987 0.466851 19.0819C0.565247 19.5766 0.732499 20.055 0.963726 20.5032C1.20537 20.9373 1.5057 21.336 1.85623 21.6882C2.21775 22.0419 2.63768 22.3305 3.09748 22.5413C3.55123 22.7701 4.03657 22.93 4.53748 23.0157C5.03435 23.1113 5.57998 23.1113 6.07685 23.1582H17.9306C18.447 23.1578 18.9623 23.1101 19.47 23.0157C19.9709 22.93 20.4562 22.7701 20.91 22.5413C21.3599 22.3136 21.7774 22.0267 22.1512 21.6882C22.5167 21.3492 22.8189 20.948 23.0437 20.5032C23.2893 20.0613 23.4573 19.5806 23.5406 19.0819C23.6145 18.5953 23.6639 18.1053 23.6887 17.6138V6.38629H23.6868Z" fill="#F05138"/>
<path d="M15.9375 18.0938C13.8543 19.2431 10.9912 19.3613 8.10935 18.1819C5.86238 17.2702 3.9412 15.7044 2.59497 13.6875C3.22061 14.1664 3.90412 14.5646 4.62935 14.8725C7.60497 16.2038 10.5787 16.1119 12.6731 14.8725C9.69184 12.6863 7.1606 9.84377 5.27435 7.52252C4.90212 7.13023 4.56986 6.70187 4.28247 6.24377C6.56247 8.23314 10.1887 10.7438 11.4787 11.4544C9.63686 9.56718 7.94428 7.53984 6.41622 5.39064C8.9563 7.85905 11.7514 10.0507 14.7543 11.9288C14.8875 12 14.9906 12.06 15.0731 12.1163C15.1611 11.9014 15.2369 11.6816 15.3 11.4581C15.9956 9.04127 15.2006 6.29439 13.4643 4.02002C17.4843 6.33939 19.875 10.6969 18.8737 14.3456C18.8475 14.445 18.8193 14.5331 18.7893 14.6363L18.825 14.6775C20.8106 17.0456 20.265 19.5525 20.0156 19.0838C18.9375 17.0625 16.9443 17.6869 15.9375 18.0938Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_2_1429">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, fJ = /* @__PURE__ */ xr({
  __name: "LanguageSwiftIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? x_ : i(x_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon language-swift-icon",
      "data-testid": "kui-icon-wrapper-language-swift-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-language-swift-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, lJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), pJ = ["aria-hidden"], __ = `<g clip-path="url(#clip0_55_22054)">
<path d="M12 23.3899C18.2905 23.3899 23.3899 18.2905 23.3899 12.0001C23.3899 5.70963 18.2905 0.610229 12 0.610229C5.70963 0.610229 0.610229 5.70963 0.610229 12.0001C0.610229 18.2905 5.70963 23.3899 12 23.3899Z" fill="white"/>
<path d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6275 5.37258 24 12 24C18.6275 24 24 18.6275 24 12C24 5.37258 18.6275 0 12 0ZM12 1.22034C17.9534 1.22034 22.7797 6.04656 22.7797 12C22.7797 17.9534 17.9534 22.7797 12 22.7797C6.04656 22.7797 1.22034 17.9534 1.22034 12C1.22034 6.04656 6.04656 1.22034 12 1.22034Z" fill="#4000BF"/>
<path d="M12.1355 3.45764C16.8534 3.45764 20.6779 7.28219 20.6779 12C20.6779 16.7178 16.8534 20.5424 12.1355 20.5424C7.41769 20.5424 3.59314 16.7178 3.59314 12C3.59314 10.847 3.82157 9.74739 4.23566 8.74381C4.84027 9.56716 5.8153 10.1017 6.91517 10.1017C8.74992 10.1017 10.2372 8.61436 10.2372 6.77968C10.2372 5.6798 9.70272 4.70477 8.8793 4.10017C9.88287 3.68608 10.9825 3.45764 12.1355 3.45764Z" fill="url(#paint0_linear_55_22054)"/>
</g>
<defs>
<linearGradient id="paint0_linear_55_22054" x1="857.829" y1="1711.93" x2="857.829" y2="3.45764" gradientUnits="userSpaceOnUse">
<stop stop-color="#7400E1"/>
<stop offset="1" stop-color="#4000BF"/>
</linearGradient>
<clipPath id="clip0_55_22054">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, w_ = /* @__PURE__ */ xr({
  __name: "InsomniaIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? __ : i(__)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon insomnia-icon",
      "data-testid": "kui-icon-wrapper-insomnia-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-insomnia-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, pJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), dJ = ["aria-hidden"], S_ = '<path d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z" fill="currentColor"/>', _O = /* @__PURE__ */ xr({
  __name: "AddIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? S_ : i(S_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon add-icon",
      "data-testid": "kui-icon-wrapper-add-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-add-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, dJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), hJ = ["aria-hidden"], C_ = '<path d="M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z" fill="currentColor"/>', mJ = /* @__PURE__ */ xr({
  __name: "ArrowLeftIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? C_ : i(C_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-left-icon",
      "data-testid": "kui-icon-wrapper-arrow-left-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-left-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, hJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), gJ = ["aria-hidden"], A_ = '<path d="M12 20L10.575 18.6L16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20Z" fill="currentColor"/>', vJ = /* @__PURE__ */ xr({
  __name: "ArrowRightIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? A_ : i(A_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-right-icon",
      "data-testid": "kui-icon-wrapper-arrow-right-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-right-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, gJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), yJ = ["aria-hidden"], k_ = '<path d="M9.7 18.025L4 12.325L5.425 10.9L9.7 15.175L18.875 6L20.3 7.425L9.7 18.025Z" fill="currentColor"/>', bJ = /* @__PURE__ */ xr({
  __name: "CheckIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? k_ : i(k_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-icon",
      "data-testid": "kui-icon-wrapper-check-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, yJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), xJ = ["aria-hidden"], E_ = '<path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="currentColor"/>', wO = /* @__PURE__ */ xr({
  __name: "ChevronDownIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? E_ : i(E_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-down-icon",
      "data-testid": "kui-icon-wrapper-chevron-down-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-down-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, xJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), _J = ["aria-hidden"], O_ = '<path d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z" fill="currentColor"/>', u1 = /* @__PURE__ */ xr({
  __name: "ChevronRightIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? O_ : i(O_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-right-icon",
      "data-testid": "kui-icon-wrapper-chevron-right-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-right-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, _J))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), wJ = ["aria-hidden"], T_ = '<path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="currentColor"/>', SJ = /* @__PURE__ */ xr({
  __name: "CloseIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? T_ : i(T_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon close-icon",
      "data-testid": "kui-icon-wrapper-close-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-close-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, wJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), CJ = ["aria-hidden"], P_ = '<path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16Z" fill="currentColor"/>', AJ = /* @__PURE__ */ xr({
  __name: "CopyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? P_ : i(P_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon copy-icon",
      "data-testid": "kui-icon-wrapper-copy-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-copy-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, CJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), kJ = ["aria-hidden"], R_ = '<path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', SO = /* @__PURE__ */ xr({
  __name: "InfoIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? R_ : i(R_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon info-icon",
      "data-testid": "kui-icon-wrapper-info-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-info-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, kJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), EJ = ["aria-hidden"], j_ = '<path d="M7 17C5.61667 17 4.4375 16.5125 3.4625 15.5375C2.4875 14.5625 2 13.3833 2 12C2 10.6167 2.4875 9.4375 3.4625 8.4625C4.4375 7.4875 5.61667 7 7 7H10C10.2833 7 10.5208 7.09583 10.7125 7.2875C10.9042 7.47917 11 7.71667 11 8C11 8.28333 10.9042 8.52083 10.7125 8.7125C10.5208 8.90417 10.2833 9 10 9H7C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15H10C10.2833 15 10.5208 15.0958 10.7125 15.2875C10.9042 15.4792 11 15.7167 11 16C11 16.2833 10.9042 16.5208 10.7125 16.7125C10.5208 16.9042 10.2833 17 10 17H7ZM9 13C8.71667 13 8.47917 12.9042 8.2875 12.7125C8.09583 12.5208 8 12.2833 8 12C8 11.7167 8.09583 11.4792 8.2875 11.2875C8.47917 11.0958 8.71667 11 9 11H15C15.2833 11 15.5208 11.0958 15.7125 11.2875C15.9042 11.4792 16 11.7167 16 12C16 12.2833 15.9042 12.5208 15.7125 12.7125C15.5208 12.9042 15.2833 13 15 13H9ZM14 17C13.7167 17 13.4792 16.9042 13.2875 16.7125C13.0958 16.5208 13 16.2833 13 16C13 15.7167 13.0958 15.4792 13.2875 15.2875C13.4792 15.0958 13.7167 15 14 15H17C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9H14C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8C13 7.71667 13.0958 7.47917 13.2875 7.2875C13.4792 7.09583 13.7167 7 14 7H17C18.3833 7 19.5625 7.4875 20.5375 8.4625C21.5125 9.4375 22 10.6167 22 12C22 13.3833 21.5125 14.5625 20.5375 15.5375C19.5625 16.5125 18.3833 17 17 17H14Z" fill="currentColor"/>', OJ = /* @__PURE__ */ xr({
  __name: "LinkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? j_ : i(j_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon link-icon",
      "data-testid": "kui-icon-wrapper-link-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-link-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, EJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), TJ = ["aria-hidden"], I_ = '<path d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z" fill="currentColor"/>', CO = /* @__PURE__ */ xr({
  __name: "LockIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? I_ : i(I_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon lock-icon",
      "data-testid": "kui-icon-wrapper-lock-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-lock-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, TJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), PJ = ["aria-hidden"], q_ = '<path d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z" fill="currentColor"/>', RJ = /* @__PURE__ */ xr({
  __name: "MenuIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? q_ : i(q_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon menu-icon",
      "data-testid": "kui-icon-wrapper-menu-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-menu-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, PJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), jJ = ["aria-hidden"], D_ = '<path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z" fill="currentColor"/>', i2 = /* @__PURE__ */ xr({
  __name: "NetworkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? D_ : i(D_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon network-icon",
      "data-testid": "kui-icon-wrapper-network-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-network-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, jJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), IJ = ["aria-hidden"], L_ = `<path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.7167 20.0958 11.4792 20.2875 11.2875C20.4792 11.0958 20.7167 11 21 11C21.2833 11 21.5208 11.0958 21.7125 11.2875C21.9042 11.4792 22 11.7167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22Z" fill="currentColor" transform-origin="center"/>
<animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0" to="360" dur="1.5s" repeatCount="indefinite"/>`, qJ = /* @__PURE__ */ xr({
  __name: "ProgressIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: mn,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), n = Number(t);
          if (n && !isNaN(n) && Number.isInteger(n) && n > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const u = String(t.size).replace(/px/gi, ""), s = Number(u);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return mn;
    }), r = Ye(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: n.value,
      lineHeight: "0",
      width: n.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), i = (u) => {
      const s = {}, f = Math.random().toString(36).substring(2, 12);
      return u.replace(/id="([^"]+)"/g, (d, l) => {
        const p = `${f}-${l}`;
        return s[l] = p, `id="${p}"`;
      }).replace(/#([^\s^")]+)/g, (d, l) => s[l] ? `#${s[l]}` : d);
    }, a = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (u) => u.replace(/[<>"'&]/g, (s) => a[s]), c = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? L_ : i(L_)}`;
    return (u, s) => (Re(), Bt(An(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon progress-icon",
      "data-testid": "kui-icon-wrapper-progress-icon",
      style: $n(r.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: _r(() => [
        (Re(), vt("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-progress-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: c
        }, null, 8, IJ))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), {
  parseSpecDocument: Eae,
  parsedDocument: Oae,
  tableOfContents: Tae,
  validationResults: Pae,
  parseOpenApiSpecDocument: Rae,
  parseAsyncApiSpecDocument: jae,
  downloadSpecFile: Iae
} = Di.useSchemaParser();
function N_(e) {
  return e ? e.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-") : "";
}
const Gn = (e) => [!0, !1, "true", "false"].includes(e), wi = (e) => [!0, "true"].includes(e), $_ = (e, t) => {
  const n = e.children.find((i) => i.uri === t);
  if (n)
    return n;
  const r = e.children.filter((i) => i.tags.length > 1);
  for (const i of r)
    for (const a of i.tags)
      if (i.uri.split("/").toSpliced(2, 0, t0(a).toLowerCase()).join("/") === t)
        return i;
  return null;
}, AO = (e) => typeof e == "number" ? e : Number.parseInt(e), Sg = (e) => {
  if (typeof e == "number")
    return Number.isFinite(e);
  if (typeof e == "string") {
    const t = Number.parseInt(e);
    return !Number.isNaN(t) && Number.isFinite(t);
  }
  return !1;
}, DJ = ["aria-expanded"], LJ = /* @__PURE__ */ xr({
  __name: "GroupItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    /**
     * Whether this is the root group item (otherwise it's a child of another group item)
     */
    root: {
      type: Boolean,
      default: !0
    },
    activePath: {
      type: String,
      default: "/"
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = `spec-renderer-toc-group-${N_(n.item.title)}-${N_(n.item.items[0].title)}`, a = (s) => {
      r("item-selected", s);
    }, o = Sr(n.item.hideTitle || n.item.initiallyExpanded), c = Sr(null), u = (s) => {
      c.value === s.target && (o.value = !o.value);
    };
    return In(() => n.item.initiallyExpanded, (s) => {
      o.value = s;
    }), (s, f) => (Re(), vt("li", {
      class: Bn(["group-item", { root: e.root }]),
      "data-testid": "group-item"
    }, [
      e.item.hideTitle ? Kt("", !0) : (Re(), vt("button", {
        key: 0,
        ref_key: "collapseTriggerRef",
        ref: c,
        "aria-controls": i,
        "aria-expanded": o.value,
        "data-testid": "group-item-button",
        type: "button",
        onClick: u
      }, [
        Rn(pn(e.item.title) + " ", 1),
        Br(Nt(u1), {
          class: Bn(["chevron-icon", { expanded: o.value }])
        }, null, 8, ["class"])
      ], 8, DJ)),
      Br(Wd, { name: "spec-renderer-fade" }, {
        default: _r(() => [
          rs(Gt("ul", {
            id: i,
            "data-testid": "group-item-list"
          }, [
            (Re(!0), vt(Wn, null, hi(e.item.items, (d, l) => (Re(), Bt(An(Nt(EO)(d)), {
              key: l + " " + d.title + d,
              "active-path": e.activePath,
              item: d,
              root: Nt(kO)(d) ? !1 : void 0,
              onItemSelected: a
            }, null, 40, ["active-path", "item", "root"]))), 128))
          ], 512), [
            [yf, o.value]
          ])
        ]),
        _: 1
      })
    ], 2));
  }
}), NJ = /* @__PURE__ */ dn(LJ, [["__scopeId", "data-v-970cb8eb"]]), $J = /* @__PURE__ */ xr({
  __name: "NodeGroupItem",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("li", null, " node-group-item "));
  }
}), MJ = /* @__PURE__ */ xr({
  __name: "ExternalLinkItem",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("li", null, " node-group-item "));
  }
});
function kO(e) {
  return Object.keys(e).length >= 2 && "title" in e && "items" in e;
}
function FJ(e) {
  return "title" in e && "items" in e && "slug" in e && "id" in e && "meta" in e && "type" in e;
}
function BJ(e) {
  return "title" in e && "slug" in e && "id" in e && "meta" in e && "type" in e;
}
function UJ(e) {
  return Object.keys(e).length === 2 && "title" in e && "url" in e;
}
const EO = (e) => FJ(e) ? $J : kO(e) ? NJ : BJ(e) ? $Y : UJ(e) ? MJ : IY;
function Cg(e) {
  return lC() ? (fC(e), !0) : !1;
}
const q3 = /* @__PURE__ */ new WeakMap(), HJ = (...e) => {
  var t;
  const n = e[0], r = (t = f2()) == null ? void 0 : t.proxy;
  if (r == null && !pC())
    throw new Error("injectLocal must be called in setup");
  return r && q3.has(r) && n in q3.get(r) ? q3.get(r)[n] : Qa(...e);
}, Ag = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const zJ = Object.prototype.toString, GJ = (e) => zJ.call(e) === "[object Object]", wu = () => {
};
function OO(e, t) {
  function n(...r) {
    return new Promise((i, a) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(i).catch(a);
    });
  }
  return n;
}
function VJ(e, t = {}) {
  let n, r, i = wu;
  const a = (u) => {
    clearTimeout(u), i(), i = wu;
  };
  let o;
  return (u) => {
    const s = Zn(e), f = Zn(t.maxWait);
    return n && a(n), s <= 0 || f !== void 0 && f <= 0 ? (r && (a(r), r = null), Promise.resolve(u())) : new Promise((d, l) => {
      i = t.rejectOnCancel ? l : d, o = u, f && !r && (r = setTimeout(() => {
        n && a(n), r = null, d(o());
      }, f)), n = setTimeout(() => {
        r && a(r), r = null, d(u());
      }, s);
    });
  };
}
function WJ(...e) {
  let t = 0, n, r = !0, i = wu, a, o, c, u, s;
  !bf(e[0]) && typeof e[0] == "object" ? { delay: o, trailing: c = !0, leading: u = !0, rejectOnCancel: s = !1 } = e[0] : [o, c = !0, u = !0, s = !1] = e;
  const f = () => {
    n && (clearTimeout(n), n = void 0, i(), i = wu);
  };
  return (l) => {
    const p = Zn(o), g = Date.now() - t, v = () => a = l();
    return f(), p <= 0 ? (t = Date.now(), v()) : (g > p && (u || !r) ? (t = Date.now(), v()) : c && (a = new Promise((b, y) => {
      i = s ? y : b, n = setTimeout(() => {
        t = Date.now(), r = !0, b(v()), f();
      }, Math.max(0, p - g));
    })), !u && !n && (n = setTimeout(() => r = !0, p)), r = !1, a);
  };
}
function M_(e, t = !1, n = "Timeout") {
  return new Promise((r, i) => {
    setTimeout(t ? () => i(n) : r, e);
  });
}
function KJ(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const r = t;
    t = void 0, r && await r;
  }, n;
}
function F_(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Gd(e) {
  return Array.isArray(e) ? e : [e];
}
function ZJ(e) {
  return f2();
}
function TO(e, t = 200, n = {}) {
  return OO(
    VJ(t, n),
    e
  );
}
function YJ(e, t = 200, n = !1, r = !0, i = !1) {
  return OO(
    WJ(t, n, r, i),
    e
  );
}
function kg(e, t = !0, n) {
  ZJ() ? R0(e, n) : t ? e() : sc(e);
}
function a2(e, t = !1) {
  function n(d, { flush: l = "sync", deep: p = !1, timeout: g, throwOnTimeout: v } = {}) {
    let b = null;
    const w = [new Promise((C) => {
      b = In(
        e,
        (T) => {
          d(T) !== t && (b ? b() : sc(() => b == null ? void 0 : b()), C(T));
        },
        {
          flush: l,
          deep: p,
          immediate: !0
        }
      );
    })];
    return g != null && w.push(
      M_(g, v).then(() => Zn(e)).finally(() => b == null ? void 0 : b())
    ), Promise.race(w);
  }
  function r(d, l) {
    if (!bf(d))
      return n((T) => T === d, l);
    const { flush: p = "sync", deep: g = !1, timeout: v, throwOnTimeout: b } = l ?? {};
    let y = null;
    const C = [new Promise((T) => {
      y = In(
        [e, d],
        ([E, D]) => {
          t !== (E === D) && (y ? y() : sc(() => y == null ? void 0 : y()), T(E));
        },
        {
          flush: p,
          deep: g,
          immediate: !0
        }
      );
    })];
    return v != null && C.push(
      M_(v, b).then(() => Zn(e)).finally(() => (y == null || y(), Zn(e)))
    ), Promise.race(C);
  }
  function i(d) {
    return n((l) => !!l, d);
  }
  function a(d) {
    return r(null, d);
  }
  function o(d) {
    return r(void 0, d);
  }
  function c(d) {
    return n(Number.isNaN, d);
  }
  function u(d, l) {
    return n((p) => {
      const g = Array.from(p);
      return g.includes(d) || g.includes(Zn(d));
    }, l);
  }
  function s(d) {
    return f(1, d);
  }
  function f(d = 1, l) {
    let p = -1;
    return n(() => (p += 1, p >= d), l);
  }
  return Array.isArray(Zn(e)) ? {
    toMatch: n,
    toContains: u,
    changed: s,
    changedTimes: f,
    get not() {
      return a2(e, !t);
    }
  } : {
    toMatch: n,
    toBe: r,
    toBeTruthy: i,
    toBeNull: a,
    toBeNaN: c,
    toBeUndefined: o,
    changed: s,
    changedTimes: f,
    get not() {
      return a2(e, !t);
    }
  };
}
function JJ(e) {
  return a2(e);
}
function QJ(e, t, n = {}) {
  const {
    immediate: r = !0,
    immediateCallback: i = !1
  } = n, a = di(!1);
  let o = null;
  function c() {
    o && (clearTimeout(o), o = null);
  }
  function u() {
    a.value = !1, c();
  }
  function s(...f) {
    i && e(), c(), a.value = !0, o = setTimeout(() => {
      a.value = !1, o = null, e(...f);
    }, Zn(t));
  }
  return r && (a.value = !0, Ag && s()), Cg(u), {
    isPending: pu(a),
    start: s,
    stop: u
  };
}
function XJ(e, t, n) {
  return In(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function eQ(e, t, n) {
  const r = In(
    e,
    (i, a, o) => {
      i && (n != null && n.once && sc(() => r()), t(i, a, o));
    },
    {
      ...n,
      once: !1
    }
  );
  return r;
}
const Ps = Ag ? window : void 0, PO = Ag ? window.navigator : void 0;
function xs(e) {
  var t;
  const n = Zn(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Ja(...e) {
  const t = [], n = () => {
    t.forEach((c) => c()), t.length = 0;
  }, r = (c, u, s, f) => (c.addEventListener(u, s, f), () => c.removeEventListener(u, s, f)), i = Ye(() => {
    const c = Gd(Zn(e[0])).filter((u) => u != null);
    return c.every((u) => typeof u != "string") ? c : void 0;
  }), a = XJ(
    () => {
      var c, u;
      return [
        (u = (c = i.value) == null ? void 0 : c.map((s) => xs(s))) != null ? u : [Ps].filter((s) => s != null),
        Gd(Zn(i.value ? e[1] : e[0])),
        Gd(Nt(i.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Zn(i.value ? e[3] : e[2])
      ];
    },
    ([c, u, s, f]) => {
      if (n(), !(c != null && c.length) || !(u != null && u.length) || !(s != null && s.length))
        return;
      const d = GJ(f) ? { ...f } : f;
      t.push(
        ...c.flatMap(
          (l) => u.flatMap(
            (p) => s.map((g) => r(l, p, g, d))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    a(), n();
  };
  return Cg(n), o;
}
function tQ() {
  const e = di(!1), t = f2();
  return t && R0(() => {
    e.value = !0;
  }, t), e;
}
function c1(e) {
  const t = tQ();
  return Ye(() => (t.value, !!e()));
}
const rQ = Symbol("vueuse-ssr-width");
function nQ() {
  const e = pC() ? HJ(rQ, null) : null;
  return typeof e == "number" ? e : void 0;
}
function iQ(e, t = {}) {
  const { window: n = Ps, ssrWidth: r = nQ() } = t, i = c1(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = di(typeof r == "number"), o = di(), c = di(!1), u = (s) => {
    c.value = s.matches;
  };
  return LD(() => {
    if (a.value) {
      a.value = !i.value;
      const s = Zn(e).split(",");
      c.value = s.some((f) => {
        const d = f.includes("not all"), l = f.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), p = f.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let g = !!(l || p);
        return l && g && (g = r >= F_(l[1])), p && g && (g = r <= F_(p[1])), d ? !g : g;
      });
      return;
    }
    i.value && (o.value = n.matchMedia(Zn(e)), c.value = o.value.matches);
  }), Ja(o, "change", u, { passive: !0 }), Ye(() => c.value);
}
function B_(e, t = {}) {
  const {
    controls: n = !1,
    navigator: r = PO
  } = t, i = c1(() => r && "permissions" in r), a = di(), o = typeof e == "string" ? { name: e } : e, c = di(), u = () => {
    var f, d;
    c.value = (d = (f = a.value) == null ? void 0 : f.state) != null ? d : "prompt";
  };
  Ja(a, "change", u, { passive: !0 });
  const s = KJ(async () => {
    if (i.value) {
      if (!a.value)
        try {
          a.value = await r.permissions.query(o);
        } catch {
          a.value = void 0;
        } finally {
          u();
        }
      if (n)
        return ND(a.value);
    }
  });
  return s(), n ? {
    state: c,
    isSupported: i,
    query: s
  } : c;
}
function aQ(e = {}) {
  const {
    navigator: t = PO,
    read: n = !1,
    source: r,
    copiedDuring: i = 1500,
    legacy: a = !1
  } = e, o = c1(() => t && "clipboard" in t), c = B_("clipboard-read"), u = B_("clipboard-write"), s = Ye(() => o.value || a), f = di(""), d = di(!1), l = QJ(() => d.value = !1, i, { immediate: !1 });
  async function p() {
    let w = !(o.value && y(c.value));
    if (!w)
      try {
        f.value = await t.clipboard.readText();
      } catch {
        w = !0;
      }
    w && (f.value = b());
  }
  s.value && n && Ja(["copy", "cut"], p, { passive: !0 });
  async function g(w = Zn(r)) {
    if (s.value && w != null) {
      let C = !(o.value && y(u.value));
      if (!C)
        try {
          await t.clipboard.writeText(w);
        } catch {
          C = !0;
        }
      C && v(w), f.value = w, d.value = !0, l.start();
    }
  }
  function v(w) {
    const C = document.createElement("textarea");
    C.value = w ?? "", C.style.position = "absolute", C.style.opacity = "0", document.body.appendChild(C), C.select(), document.execCommand("copy"), C.remove();
  }
  function b() {
    var w, C, T;
    return (T = (C = (w = document == null ? void 0 : document.getSelection) == null ? void 0 : w.call(document)) == null ? void 0 : C.toString()) != null ? T : "";
  }
  function y(w) {
    return w === "granted" || w === "prompt";
  }
  return {
    isSupported: s,
    text: f,
    copied: d,
    copy: g
  };
}
function oQ(e, t, n = {}) {
  const { window: r = Ps, ...i } = n;
  let a;
  const o = c1(() => r && "ResizeObserver" in r), c = () => {
    a && (a.disconnect(), a = void 0);
  }, u = Ye(() => {
    const d = Zn(e);
    return Array.isArray(d) ? d.map((l) => xs(l)) : [xs(d)];
  }), s = In(
    u,
    (d) => {
      if (c(), o.value && r) {
        a = new ResizeObserver(t);
        for (const l of d)
          l && a.observe(l, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    c(), s();
  };
  return Cg(f), {
    isSupported: o,
    stop: f
  };
}
function sQ(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = Ps, box: i = "content-box" } = n, a = Ye(() => {
    var d, l;
    return (l = (d = xs(e)) == null ? void 0 : d.namespaceURI) == null ? void 0 : l.includes("svg");
  }), o = di(t.width), c = di(t.height), { stop: u } = oQ(
    e,
    ([d]) => {
      const l = i === "border-box" ? d.borderBoxSize : i === "content-box" ? d.contentBoxSize : d.devicePixelContentBoxSize;
      if (r && a.value) {
        const p = xs(e);
        if (p) {
          const g = p.getBoundingClientRect();
          o.value = g.width, c.value = g.height;
        }
      } else if (l) {
        const p = Gd(l);
        o.value = p.reduce((g, { inlineSize: v }) => g + v, 0), c.value = p.reduce((g, { blockSize: v }) => g + v, 0);
      } else
        o.value = d.contentRect.width, c.value = d.contentRect.height;
    },
    n
  );
  kg(() => {
    const d = xs(e);
    d && (o.value = "offsetWidth" in d ? d.offsetWidth : t.width, c.value = "offsetHeight" in d ? d.offsetHeight : t.height);
  });
  const s = In(
    () => xs(e),
    (d) => {
      o.value = d ? t.width : 0, c.value = d ? t.height : 0;
    }
  );
  function f() {
    u(), s();
  }
  return {
    width: o,
    height: c,
    stop: f
  };
}
const U_ = 1;
function Eg(e, t = {}) {
  const {
    throttle: n = 0,
    idle: r = 200,
    onStop: i = wu,
    onScroll: a = wu,
    offset: o = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: c = {
      capture: !1,
      passive: !0
    },
    behavior: u = "auto",
    window: s = Ps,
    onError: f = ($) => {
      console.error($);
    }
  } = t, d = di(0), l = di(0), p = Ye({
    get() {
      return d.value;
    },
    set($) {
      v($, void 0);
    }
  }), g = Ye({
    get() {
      return l.value;
    },
    set($) {
      v(void 0, $);
    }
  });
  function v($, Z) {
    var te, se, ee, K;
    if (!s)
      return;
    const re = Zn(e);
    if (!re)
      return;
    (ee = re instanceof Document ? s.document.body : re) == null || ee.scrollTo({
      top: (te = Zn(Z)) != null ? te : g.value,
      left: (se = Zn($)) != null ? se : p.value,
      behavior: Zn(u)
    });
    const de = ((K = re == null ? void 0 : re.document) == null ? void 0 : K.documentElement) || (re == null ? void 0 : re.documentElement) || re;
    p != null && (d.value = de.scrollLeft), g != null && (l.value = de.scrollTop);
  }
  const b = di(!1), y = Kd({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), w = Kd({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), C = ($) => {
    b.value && (b.value = !1, w.left = !1, w.right = !1, w.top = !1, w.bottom = !1, i($));
  }, T = TO(C, n + r), E = ($) => {
    var Z;
    if (!s)
      return;
    const te = ((Z = $ == null ? void 0 : $.document) == null ? void 0 : Z.documentElement) || ($ == null ? void 0 : $.documentElement) || xs($), { display: se, flexDirection: ee, direction: K } = getComputedStyle(te), re = K === "rtl" ? -1 : 1, de = te.scrollLeft;
    w.left = de < d.value, w.right = de > d.value;
    const ie = Math.abs(de * re) <= (o.left || 0), me = Math.abs(de * re) + te.clientWidth >= te.scrollWidth - (o.right || 0) - U_;
    se === "flex" && ee === "row-reverse" ? (y.left = me, y.right = ie) : (y.left = ie, y.right = me), d.value = de;
    let $e = te.scrollTop;
    $ === s.document && !$e && ($e = s.document.body.scrollTop), w.top = $e < l.value, w.bottom = $e > l.value;
    const Pe = Math.abs($e) <= (o.top || 0), Le = Math.abs($e) + te.clientHeight >= te.scrollHeight - (o.bottom || 0) - U_;
    se === "flex" && ee === "column-reverse" ? (y.top = Le, y.bottom = Pe) : (y.top = Pe, y.bottom = Le), l.value = $e;
  }, D = ($) => {
    var Z;
    if (!s)
      return;
    const te = (Z = $.target.documentElement) != null ? Z : $.target;
    E(te), b.value = !0, T($), a($);
  };
  return Ja(
    e,
    "scroll",
    n ? YJ(D, n, !0, !1) : D,
    c
  ), kg(() => {
    try {
      const $ = Zn(e);
      if (!$)
        return;
      E($);
    } catch ($) {
      f($);
    }
  }), Ja(
    e,
    "scrollend",
    C,
    c
  ), {
    x: p,
    y: g,
    isScrolling: b,
    arrivedState: y,
    directions: w,
    measure() {
      const $ = Zn(e);
      s && $ && E($);
    }
  };
}
const uQ = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function cQ(e = {}) {
  const {
    reactive: t = !1,
    target: n = Ps,
    aliasMap: r = uQ,
    passive: i = !0,
    onEventFired: a = wu
  } = e, o = Kd(/* @__PURE__ */ new Set()), c = {
    toJSON() {
      return {};
    },
    current: o
  }, u = t ? Kd(c) : c, s = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new Set();
  function d(v, b) {
    v in u && (t ? u[v] = b : u[v].value = b);
  }
  function l() {
    o.clear();
    for (const v of f)
      d(v, !1);
  }
  function p(v, b) {
    var y, w;
    const C = (y = v.key) == null ? void 0 : y.toLowerCase(), E = [(w = v.code) == null ? void 0 : w.toLowerCase(), C].filter(Boolean);
    C && (b ? o.add(C) : o.delete(C));
    for (const D of E)
      f.add(D), d(D, b);
    C === "meta" && !b ? (s.forEach((D) => {
      o.delete(D), d(D, !1);
    }), s.clear()) : typeof v.getModifierState == "function" && v.getModifierState("Meta") && b && [...o, ...E].forEach((D) => s.add(D));
  }
  Ja(n, "keydown", (v) => (p(v, !0), a(v)), { passive: i }), Ja(n, "keyup", (v) => (p(v, !1), a(v)), { passive: i }), Ja("blur", l, { passive: i }), Ja("focus", l, { passive: i });
  const g = new Proxy(
    u,
    {
      get(v, b, y) {
        if (typeof b != "string")
          return Reflect.get(v, b, y);
        if (b = b.toLowerCase(), b in r && (b = r[b]), !(b in u))
          if (/[+_-]/.test(b)) {
            const C = b.split(/[+_-]/g).map((T) => T.trim());
            u[b] = Ye(() => C.map((T) => Zn(g[T])).every(Boolean));
          } else
            u[b] = di(!1);
        const w = Reflect.get(v, b, y);
        return t ? Zn(w) : w;
      }
    }
  );
  return g;
}
function lQ(e = {}) {
  const { window: t = Ps, ...n } = e;
  return Eg(t, n);
}
function fQ(e = {}) {
  const {
    window: t = Ps,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: a = !0,
    type: o = "inner"
  } = e, c = di(n), u = di(r), s = () => {
    if (t)
      if (o === "outer")
        c.value = t.outerWidth, u.value = t.outerHeight;
      else if (o === "visual" && t.visualViewport) {
        const { width: d, height: l, scale: p } = t.visualViewport;
        c.value = Math.round(d * p), u.value = Math.round(l * p);
      } else a ? (c.value = t.innerWidth, u.value = t.innerHeight) : (c.value = t.document.documentElement.clientWidth, u.value = t.document.documentElement.clientHeight);
  };
  s(), kg(s);
  const f = { passive: !0 };
  if (Ja("resize", s, f), t && o === "visual" && t.visualViewport && Ja(t.visualViewport, "resize", s, f), i) {
    const d = iQ("(orientation: portrait)");
    In(d, () => s());
  }
  return { width: c, height: u };
}
const pQ = /* @__PURE__ */ xr({
  __name: "SpecRendererToc",
  props: {
    tableOfContents: {
      type: [Object, String],
      required: !0
    },
    /**
     * Path of the page where spec-renderer is loaded on.
     * his is needed to compute path to individual specification details
     */
    basePath: {
      type: String,
      default: ""
    },
    /**
     * Selected path of the spec section (ui)
     */
    currentPath: {
      type: String,
      default: "/"
    },
    /**
     * this is designed scrolling container for TOC, by default it's '',meaning tocNavRef scrollable.
     * If toc is part of some external list and that list is scrollable - we need a selector for that scollable container
     */
    tocScrollingContainer: {
      type: String,
      default: ""
    },
    /**
     * Allow component itself to control URL in browser URL.
     * When false it becomes the responsibility of consuming app
     */
    controlAddressBar: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
        Defines how links are specified in toc
          path - id becomes part of the URL path.
          hash - uses the hash portion of the URL to keep the UI in sync with the URL.
    */
    navigationType: {
      type: String,
      default: "path"
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = e;
    Oa("base-path", Ye(() => n.basePath)), Oa("current-path", Ye(() => n.currentPath)), Oa("navigation-type", Ye(() => n.navigationType));
    const r = t, i = Sr(null), a = Sr(null), { y: o } = Eg(a), c = Ye(() => {
      if (!n.tableOfContents)
        return;
      let s = n.tableOfContents;
      if (typeof n.tableOfContents == "string")
        try {
          s = u0(s);
        } catch {
          console.error("@kong/spec-renderer: error parsing provided toc");
          return;
        }
      const f = (d, l) => {
        if (Array.isArray(d.items))
          for (let p = 0; p < d.items.length; p++)
            d.items[p].id === l && (d.initiallyExpanded = !0), f(d.items[p], l);
      };
      return f({ initiallyExpanded: !1, items: s }, n.currentPath), s;
    });
    In(() => ({ path: n.currentPath, navRef: i.value }), async (s) => {
      if (await sc(), !s.navRef || !document || (a.value || (a.value = n.tocScrollingContainer === "" ? s.navRef : document.querySelector(n.tocScrollingContainer)), !a.value))
        return;
      const f = a.value.querySelector('li[data-spec-renderer-toc-active="true"]') || null;
      if (f) {
        if (f.offsetTop < o.value) {
          f.scrollIntoView({ behavior: "instant", block: "start" });
          return;
        }
        if (o.value + a.value.offsetHeight < f.offsetTop + 2 * f.offsetHeight) {
          f.scrollIntoView({ behavior: "instant", block: "end" });
          return;
        }
      }
    }, { immediate: !0 });
    const u = (s) => {
      if (wi(n.controlAddressBar)) {
        const f = n.navigationType === "path" ? n.basePath + s : n.basePath + "#" + s;
        window.history.pushState({}, "", f);
      }
      r("item-selected", s);
    };
    return (s, f) => (Re(), vt("nav", {
      ref_key: "tocNavRef",
      ref: i,
      class: "table-of-contents",
      "data-testid": "table-of-contents"
    }, [
      Gt("ul", null, [
        (Re(!0), vt(Wn, null, hi(c.value, (d, l) => (Re(), Bt(An(Nt(EO)(d)), {
          key: l + "_" + d.title,
          "active-path": e.currentPath,
          item: d,
          onItemSelected: u
        }, null, 40, ["active-path", "item"]))), 128))
      ])
    ], 512));
  }
}), k0 = /* @__PURE__ */ dn(pQ, [["__scopeId", "data-v-3f8c1dac"]]), dQ = { class: "overview-panel" }, hQ = { class: "overview-panel-header" }, mQ = {
  key: 0,
  class: "default-header"
}, gQ = { class: "default-header-title" }, vQ = { class: "overview-panel-content" }, yQ = /* @__PURE__ */ xr({
  __name: "OverviewPanel",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", dQ, [
      Gt("div", hQ, [
        Fn(t.$slots, "header", {}, () => [
          e.title ? (Re(), vt("div", mQ, [
            Fn(t.$slots, "header-icon", {}, void 0, !0),
            Gt("span", gQ, pn(e.title), 1)
          ])) : Kt("", !0)
        ], !0)
      ]),
      Gt("div", vQ, [
        Fn(t.$slots, "content", {}, void 0, !0)
      ])
    ]));
  }
}), Og = /* @__PURE__ */ dn(yQ, [["__scopeId", "data-v-2f0878ae"]]), bQ = /* @__PURE__ */ xr({
  __name: "MarkdownRenderer",
  props: {
    markdown: {
      type: String,
      required: !0
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e) {
    const { mdRender: t } = xO(), n = e, r = Ye(() => t(n.markdown)), i = () => dC(n.tag, {
      innerHTML: r.value
    }), a = Qa("markdown-styles", Sr(!0));
    return (o, c) => (Re(), vt("div", {
      class: Bn({ "default-markdown": Nt(a) })
    }, [
      (Re(), Bt(An(i())))
    ], 2));
  }
}), os = /* @__PURE__ */ dn(bQ, [["__scopeId", "data-v-c7c683c6"]]), xQ = {
  class: "overview-server-list",
  "data-testid": "overview-server-list"
}, _Q = ["data-testid"], wQ = { class: "server-item-header" }, SQ = {
  key: 0,
  class: "overview-server-list-add-custom-url-input"
}, CQ = /* @__PURE__ */ xr({
  __name: "ServerList",
  props: {
    serverList: {
      type: Array,
      required: !0
    },
    allowCustomServerUrl: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["add-custom-url"],
  setup(e, { emit: t }) {
    const n = t, r = Sr(!1), i = Sr(""), a = () => {
      i.value.length && (n("add-custom-url", i.value), o());
    }, o = () => {
      r.value = !1, i.value = "";
    };
    return (c, u) => (Re(), Bt(Og, { title: "API Base URL" }, {
      "header-icon": _r(() => [
        Br(Nt(i2), { size: 20 })
      ]),
      content: _r(() => [
        Gt("ul", xQ, [
          (Re(!0), vt(Wn, null, hi(e.serverList, (s, f) => (Re(), vt("li", {
            key: s.id,
            class: "overview-server-list-item",
            "data-testid": `overview-server-list-item-${s.id}`
          }, [
            Gt("div", wQ, [
              Gt("span", null, "Server " + pn(f + 1) + ":", 1),
              Gt("span", null, pn(s.url), 1)
            ]),
            s.description ? (Re(), Bt(os, {
              key: 0,
              markdown: s.description
            }, null, 8, ["markdown"])) : Kt("", !0)
          ], 8, _Q))), 128)),
          e.allowCustomServerUrl ? (Re(), vt(Wn, { key: 0 }, [
            r.value ? (Re(), vt("div", SQ, [
              rs(Gt("input", {
                "onUpdate:modelValue": u[0] || (u[0] = (s) => i.value = s),
                placeholder: "Enter custom URL",
                type: "text"
              }, null, 512), [
                [
                  p2,
                  i.value,
                  void 0,
                  { trim: !0 }
                ]
              ]),
              Gt("button", {
                class: "secondary",
                onClick: a
              }, " Save URL "),
              Gt("button", {
                class: "tertiary",
                onClick: o
              }, " Cancel ")
            ])) : (Re(), vt("button", {
              key: 1,
              class: "secondary",
              onClick: u[1] || (u[1] = (s) => r.value = !0)
            }, [
              Br(Nt(_O), { decorative: "" }),
              u[2] || (u[2] = Rn(" Add custom URL "))
            ]))
          ], 64)) : Kt("", !0)
        ])
      ]),
      _: 1
    }));
  }
}), AQ = /* @__PURE__ */ dn(CQ, [["__scopeId", "data-v-681b0e3d"]]), kQ = {
  ref: "overviewCollapsiblePanelDetail",
  class: "overview-collapsible-panel"
}, EQ = { class: "overview-collapsible-panel-header-title" }, OQ = { class: "overview-collapsible-panel-content" }, TQ = /* @__PURE__ */ xr({
  __name: "OverviewCollapsiblePanel",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = Sr(!1);
    return (n, r) => (Re(), vt("details", kQ, [
      Gt("summary", {
        class: "overview-collapsible-panel-header",
        onClick: r[0] || (r[0] = (i) => t.value = !t.value)
      }, [
        Br(Nt(u1), {
          class: Bn(["chevron-icon", { expanded: t.value }])
        }, null, 8, ["class"]),
        Gt("span", EQ, pn(e.title), 1)
      ]),
      Gt("div", OQ, [
        Fn(n.$slots, "default", {}, void 0, !0)
      ])
    ], 512));
  }
}), PQ = /* @__PURE__ */ dn(TQ, [["__scopeId", "data-v-64c1c7e1"]]), RQ = (e) => ea(e) && "authorizationUrl" in e && !("tokenUrl" in e), H_ = (e) => ea(e) && "authorizationUrl" in e && "tokenUrl" in e, jQ = (e) => ea(e) && !("authorizationUrl" in e) && "tokenUrl" in e, IQ = {
  implicit: "Implicit",
  authorizationCode: "Authorization Code",
  clientCredentials: "Client Credentials",
  password: "Password"
};
function qQ(e) {
  switch (e.type) {
    case "apiKey":
    case "httpApiKey":
      return DQ(e.in, e.name);
    case "http":
      switch (e.scheme) {
        case "basic":
          return LQ();
        case "bearer":
          return NQ();
        case "digest":
          return $Q();
      }
      break;
    case "oauth2":
      return MQ(e);
  }
  return "";
}
function DQ(e, t) {
  return `An API key is a token that you provide when making API calls. Include the token in a ${e} parameter called \`${t}\`.

  Example: ${e === "query" ? `\`?${t}=123\`` : `\`${t}: 123\``}`;
}
function LQ() {
  return "Basic authentication is a simple authentication scheme built into the HTTP protocol.\n  To use it, send your HTTP requests with an Authorization header that contains the word Basic\n  followed by a space and a base64-encoded string `username:password`.\n\n  Example: `Authorization: Basic ZGVtbzpwQDU1dzByZA==`";
}
function NQ() {
  return "Provide your bearer token in the Authorization header when making requests to protected resources.\n\n  Example: `Authorization: Bearer 123`";
}
function $Q() {
  return 'Provide your encrypted digest scheme data in the Authorization header when making requests to protected resources.\n\n  Example: `Authorization: Digest username=guest, realm="test", nonce="2", uri="/uri", response="123"`';
}
function MQ(e) {
  return $C(e.flows).map((n) => FQ(IQ[n], e.flows[n])).join(`

`);
}
function FQ(e, t) {
  let n = `**${e} OAuth Flow**`;
  n += RQ(t) || H_(t) ? `

Authorize URL: ${t.authorizationUrl}` : "", n += H_(t) || jQ(t) ? `

Token URL: ${t.tokenUrl}` : "", n += t.refreshUrl ? `

Refresh URL: ${t.refreshUrl}` : "";
  const r = LM(t.scopes);
  return r.length && (n += `

Scopes:
${r.map(([i, a]) => `- \`${i}\` - ${a}`).join(`
`)}`), n;
}
const BQ = {
  class: "security-list",
  "data-testid": "overview-security-list"
}, UQ = /* @__PURE__ */ xr({
  __name: "SecurityList",
  props: {
    securitySchemeList: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const t = (n) => n.description ?? qQ(n);
    return (n, r) => (Re(), Bt(Og, { title: "Security" }, {
      "header-icon": _r(() => [
        Br(Nt(CO), { size: 20 })
      ]),
      content: _r(() => [
        Gt("div", BQ, [
          (Re(!0), vt(Wn, null, hi(e.securitySchemeList, (i) => (Re(), Bt(PQ, {
            key: i.id,
            "data-testid": `overview-security-scheme-${i.id}`,
            title: `${i.key} (${i.type})`
          }, {
            default: _r(() => [
              Br(os, {
                markdown: t(i)
              }, null, 8, ["markdown"])
            ]),
            _: 2
          }, 1032, ["data-testid", "title"]))), 128))
        ])
      ]),
      _: 1
    }));
  }
}), HQ = /* @__PURE__ */ dn(UQ, [["__scopeId", "data-v-e3ae802d"]]), zQ = {
  class: "overview-additional-info",
  "data-testid": "overview-additional-info"
}, GQ = {
  key: 0,
  class: "overview-additional-info-contact",
  "data-testid": "overview-additional-info-contact"
}, VQ = ["href"], WQ = ["href"], KQ = ["href"], ZQ = /* @__PURE__ */ xr({
  __name: "AdditionalInfo",
  props: {
    contact: {
      type: Object,
      default: () => ({})
    },
    license: {
      type: Object,
      default: () => ({})
    },
    externalDocs: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    return (t, n) => (Re(), Bt(Og, { title: "Additional Information" }, {
      "header-icon": _r(() => [
        Br(Nt(SO), { size: 20 })
      ]),
      content: _r(() => {
        var r, i, a, o, c, u, s;
        return [
          Gt("div", zQ, [
            (r = e.contact) != null && r.url || (i = e.contact) != null && i.email ? (Re(), vt("div", GQ, [
              n[0] || (n[0] = Rn(" Contact ")),
              (a = e.contact) != null && a.url ? (Re(), vt("a", {
                key: 0,
                href: e.contact.url,
                rel: "noopener noreferrer",
                target: "_blank"
              }, pn(e.contact.name), 9, VQ)) : Kt("", !0),
              (o = e.contact) != null && o.email ? (Re(), vt("a", {
                key: 1,
                href: `mailto:${e.contact.email}`,
                rel: "noopener noreferrer",
                target: "_blank"
              }, " (" + pn(e.contact.email) + ") ", 9, WQ)) : Kt("", !0)
            ])) : Kt("", !0),
            (c = e.license) != null && c.name ? (Re(), Bt(An((u = e.license) != null && u.url ? "a" : "p"), {
              key: 1,
              class: "overview-additional-info-license",
              "data-testid": "overview-additional-info-license",
              href: e.license.url,
              rel: "noopener noreferrer",
              target: "_blank"
            }, {
              default: _r(() => [
                Rn(pn(e.license.name) + " License ", 1)
              ]),
              _: 1
            }, 8, ["href"])) : Kt("", !0),
            (s = e.externalDocs) != null && s.url ? (Re(), vt("a", {
              key: 2,
              class: "overview-additional-info-external-docs",
              href: e.externalDocs.url,
              rel: "noopener noreferrer",
              target: "_blank"
            }, pn(e.externalDocs.description || e.externalDocs.url), 9, KQ)) : Kt("", !0)
          ])
        ];
      }),
      _: 1
    }));
  }
}), YQ = /* @__PURE__ */ dn(ZQ, [["__scopeId", "data-v-e9182adb"]]), JQ = /* @__PURE__ */ xr({
  __name: "LabelBadge",
  props: {
    label: {
      type: String,
      default: ""
    },
    /**
     * Type variations
     * One of ['neutral', 'primary' ]
     */
    type: {
      type: String,
      required: !0,
      validator: (e) => _H.includes(e)
    },
    /**
    * Size variations
    * One of ['small', 'large' ]
    */
    size: {
      type: String,
      default: "large",
      validator: (e) => qk.includes(e)
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("span", {
      class: Bn(["label-badge", [e.type, e.size]]),
      "data-testid": "label-badge"
    }, pn(e.label), 3));
  }
}), qf = /* @__PURE__ */ dn(JQ, [["__scopeId", "data-v-9753a96d"]]), QQ = {
  class: "spec-renderer-page-header",
  "data-testid": "spec-renderer-page-header"
}, XQ = { class: "page-header-title" }, eX = { "data-testid": "spec-renderer-page-header-title" }, tX = {
  key: 2,
  class: "page-header-actions"
}, rX = /* @__PURE__ */ xr({
  __name: "PageHeader",
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    deprecated: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", QQ, [
      Gt("div", XQ, [
        Gt("h2", eX, pn(e.title), 1),
        e.type ? (Re(), Bt(qf, {
          key: 0,
          "data-testid": "data-type-badge",
          label: e.type,
          type: "neutral"
        }, null, 8, ["label"])) : Kt("", !0),
        e.deprecated ? (Re(), Bt(qf, {
          key: 1,
          "data-testid": "deprecated-badge",
          label: "DEPRECATED",
          type: "neutral"
        })) : Kt("", !0),
        t.$slots.actions ? (Re(), vt("div", tX, [
          Fn(t.$slots, "actions", {}, void 0, !0)
        ])) : Kt("", !0)
      ]),
      e.description ? (Re(), Bt(os, {
        key: 0,
        "data-testid": "spec-renderer-page-header-description",
        markdown: e.description
      }, null, 8, ["markdown"])) : Kt("", !0),
      Fn(t.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Rc = /* @__PURE__ */ dn(rX, [["__scopeId", "data-v-0ab20dd0"]]), nX = { class: "overview-page" }, iX = { class: "overview-page-versions" }, aX = { class: "overview-page-content" }, oX = /* @__PURE__ */ xr({
  __name: "HttpService",
  props: {
    data: {
      type: Object,
      required: !0
    },
    specVersion: {
      type: String,
      required: !0
    },
    allowCustomServerUrl: {
      type: Boolean,
      default: !1
    },
    hideDownloadButton: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { serverList: n, addServerUrl: r } = Di.useServerList(), { downloadSpecFile: i } = Di.useSchemaParser(), a = Ye(() => {
      var o, c, u, s;
      return ((o = t.data.externalDocs) == null ? void 0 : o.url) || ((c = t.data.contact) == null ? void 0 : c.url) || ((u = t.data.contact) == null ? void 0 : u.email) || ((s = t.data.license) == null ? void 0 : s.name);
    });
    return (o, c) => (Re(), vt("div", nX, [
      Br(Rc, {
        class: "overview-page-header",
        title: e.data.name
      }, hC({
        default: _r(() => [
          Gt("div", iX, [
            Br(qf, {
              label: `v${e.data.version}`,
              type: "primary"
            }, null, 8, ["label"]),
            Br(qf, {
              label: e.specVersion,
              type: "neutral"
            }, null, 8, ["label"])
          ])
        ]),
        _: 2
      }, [
        e.hideDownloadButton ? void 0 : {
          name: "actions",
          fn: _r(() => [
            Gt("button", {
              class: "download-spec-btn",
              onClick: c[0] || (c[0] = //@ts-ignore
              (...u) => Nt(i) && Nt(i)(...u))
            }, " Download ")
          ]),
          key: "0"
        }
      ]), 1032, ["title"]),
      Gt("section", aX, [
        e.data.description ? (Re(), Bt(os, {
          key: 0,
          markdown: e.data.description
        }, null, 8, ["markdown"])) : Kt("", !0),
        Nt(n).length || e.allowCustomServerUrl ? (Re(), Bt(AQ, {
          key: 1,
          "allow-custom-server-url": e.allowCustomServerUrl,
          "server-list": Nt(n),
          onAddCustomUrl: Nt(r)
        }, null, 8, ["allow-custom-server-url", "server-list", "onAddCustomUrl"])) : Kt("", !0),
        Array.isArray(e.data.securitySchemes) && e.data.securitySchemes.length ? (Re(), Bt(HQ, {
          key: 2,
          "security-scheme-list": e.data.securitySchemes
        }, null, 8, ["security-scheme-list"])) : Kt("", !0),
        a.value ? (Re(), Bt(YQ, {
          key: 3,
          contact: e.data.contact,
          "external-docs": e.data.externalDocs,
          license: e.data.license
        }, null, 8, ["contact", "external-docs", "license"])) : Kt("", !0)
      ])
    ]));
  }
}), sX = /* @__PURE__ */ dn(oX, [["__scopeId", "data-v-f5b59a94"]]), o2 = Math.min, ac = Math.max, E0 = Math.round, qd = Math.floor, ks = (e) => ({
  x: e,
  y: e
}), uX = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, cX = {
  start: "end",
  end: "start"
};
function Tg(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vc(e) {
  return e.split("-")[0];
}
function l1(e) {
  return e.split("-")[1];
}
function lX(e) {
  return e === "x" ? "y" : "x";
}
function RO(e) {
  return e === "y" ? "height" : "width";
}
function Df(e) {
  return ["top", "bottom"].includes(vc(e)) ? "y" : "x";
}
function jO(e) {
  return lX(Df(e));
}
function fX(e, t, n) {
  n === void 0 && (n = !1);
  const r = l1(e), i = jO(e), a = RO(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = O0(o)), [o, O0(o)];
}
function pX(e) {
  const t = O0(e);
  return [s2(e), t, s2(t)];
}
function s2(e) {
  return e.replace(/start|end/g, (t) => cX[t]);
}
function dX(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function hX(e, t, n, r) {
  const i = l1(e);
  let a = dX(vc(e), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(s2)))), a;
}
function O0(e) {
  return e.replace(/left|right|bottom|top/g, (t) => uX[t]);
}
function mX(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function gX(e) {
  return typeof e != "number" ? mX(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function T0(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function z_(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = Df(t), o = jO(t), c = RO(o), u = vc(t), s = a === "y", f = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, l = r[c] / 2 - i[c] / 2;
  let p;
  switch (u) {
    case "top":
      p = {
        x: f,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (l1(t)) {
    case "start":
      p[o] -= l * (n && s ? -1 : 1);
      break;
    case "end":
      p[o] += l * (n && s ? -1 : 1);
      break;
  }
  return p;
}
const vX = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, c = a.filter(Boolean), u = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let s = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: f,
    y: d
  } = z_(s, r, u), l = r, p = {}, g = 0;
  for (let v = 0; v < c.length; v++) {
    const {
      name: b,
      fn: y
    } = c[v], {
      x: w,
      y: C,
      data: T,
      reset: E
    } = await y({
      x: f,
      y: d,
      initialPlacement: r,
      placement: l,
      strategy: i,
      middlewareData: p,
      rects: s,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = w ?? f, d = C ?? d, p = {
      ...p,
      [b]: {
        ...p[b],
        ...T
      }
    }, E && g <= 50 && (g++, typeof E == "object" && (E.placement && (l = E.placement), E.rects && (s = E.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : E.rects), {
      x: f,
      y: d
    } = z_(s, l, u)), v = -1);
  }
  return {
    x: f,
    y: d,
    placement: l,
    strategy: i,
    middlewareData: p
  };
};
async function yX(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: c,
    strategy: u
  } = e, {
    boundary: s = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: d = "floating",
    altBoundary: l = !1,
    padding: p = 0
  } = Tg(t, e), g = gX(p), b = c[l ? d === "floating" ? "reference" : "floating" : d], y = T0(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(b))) == null || n ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(c.floating)),
    boundary: s,
    rootBoundary: f,
    strategy: u
  })), w = d === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c.floating)), T = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = T0(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: w,
    offsetParent: C,
    strategy: u
  }) : w);
  return {
    top: (y.top - E.top + g.top) / T.y,
    bottom: (E.bottom - y.bottom + g.bottom) / T.y,
    left: (y.left - E.left + g.left) / T.x,
    right: (E.right - y.right + g.right) / T.x
  };
}
const bX = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: c,
        platform: u,
        elements: s
      } = t, {
        mainAxis: f = !0,
        crossAxis: d = !0,
        fallbackPlacements: l,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...b
      } = Tg(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const y = vc(i), w = Df(c), C = vc(c) === c, T = await (u.isRTL == null ? void 0 : u.isRTL(s.floating)), E = l || (C || !v ? [O0(c)] : pX(c)), D = g !== "none";
      !l && D && E.push(...hX(c, v, g, T));
      const $ = [c, ...E], Z = await yX(t, b), te = [];
      let se = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (f && te.push(Z[y]), d) {
        const de = fX(i, o, T);
        te.push(Z[de[0]], Z[de[1]]);
      }
      if (se = [...se, {
        placement: i,
        overflows: te
      }], !te.every((de) => de <= 0)) {
        var ee, K;
        const de = (((ee = a.flip) == null ? void 0 : ee.index) || 0) + 1, ie = $[de];
        if (ie)
          return {
            data: {
              index: de,
              overflows: se
            },
            reset: {
              placement: ie
            }
          };
        let me = (K = se.filter(($e) => $e.overflows[0] <= 0).sort(($e, Pe) => $e.overflows[1] - Pe.overflows[1])[0]) == null ? void 0 : K.placement;
        if (!me)
          switch (p) {
            case "bestFit": {
              var re;
              const $e = (re = se.filter((Pe) => {
                if (D) {
                  const Le = Df(Pe.placement);
                  return Le === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Le === "y";
                }
                return !0;
              }).map((Pe) => [Pe.placement, Pe.overflows.filter((Le) => Le > 0).reduce((Le, Ae) => Le + Ae, 0)]).sort((Pe, Le) => Pe[1] - Le[1])[0]) == null ? void 0 : re[0];
              $e && (me = $e);
              break;
            }
            case "initialPlacement":
              me = c;
              break;
          }
        if (i !== me)
          return {
            reset: {
              placement: me
            }
          };
      }
      return {};
    }
  };
};
async function xX(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = vc(n), c = l1(n), u = Df(n) === "y", s = ["left", "top"].includes(o) ? -1 : 1, f = a && u ? -1 : 1, d = Tg(t, e);
  let {
    mainAxis: l,
    crossAxis: p,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return c && typeof g == "number" && (p = c === "end" ? g * -1 : g), u ? {
    x: p * f,
    y: l * s
  } : {
    x: l * s,
    y: p * f
  };
}
const _X = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: c
      } = t, u = await xX(t, e);
      return o === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: i + u.x,
        y: a + u.y,
        data: {
          ...u,
          placement: o
        }
      };
    }
  };
};
function f1() {
  return typeof window < "u";
}
function ju(e) {
  return Pg(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pa(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ao(e) {
  var t;
  return (t = (Pg(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Pg(e) {
  return f1() ? e instanceof Node || e instanceof pa(e).Node : !1;
}
function eo(e) {
  return f1() ? e instanceof Element || e instanceof pa(e).Element : !1;
}
function _o(e) {
  return f1() ? e instanceof HTMLElement || e instanceof pa(e).HTMLElement : !1;
}
function G_(e) {
  return !f1() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pa(e).ShadowRoot;
}
function op(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = to(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function wX(e) {
  return ["table", "td", "th"].includes(ju(e));
}
function p1(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Rg(e) {
  const t = jg(), n = eo(e) ? to(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function SX(e) {
  let t = Es(e);
  for (; _o(t) && !yc(t); ) {
    if (Rg(t))
      return t;
    if (p1(t))
      return null;
    t = Es(t);
  }
  return null;
}
function jg() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function yc(e) {
  return ["html", "body", "#document"].includes(ju(e));
}
function to(e) {
  return pa(e).getComputedStyle(e);
}
function d1(e) {
  return eo(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Es(e) {
  if (ju(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    G_(e) && e.host || // Fallback.
    Ao(e)
  );
  return G_(t) ? t.host : t;
}
function IO(e) {
  const t = Es(e);
  return yc(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : _o(t) && op(t) ? t : IO(t);
}
function Lf(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = IO(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = pa(i);
  if (a) {
    const c = u2(o);
    return t.concat(o, o.visualViewport || [], op(i) ? i : [], c && n ? Lf(c) : []);
  }
  return t.concat(i, Lf(i, [], n));
}
function u2(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function qO(e) {
  const t = to(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = _o(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, c = E0(n) !== a || E0(r) !== o;
  return c && (n = a, r = o), {
    width: n,
    height: r,
    $: c
  };
}
function Ig(e) {
  return eo(e) ? e : e.contextElement;
}
function oc(e) {
  const t = Ig(e);
  if (!_o(t))
    return ks(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = qO(t);
  let o = (a ? E0(n.width) : n.width) / r, c = (a ? E0(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: o,
    y: c
  };
}
const CX = /* @__PURE__ */ ks(0);
function DO(e) {
  const t = pa(e);
  return !jg() || !t.visualViewport ? CX : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function AX(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== pa(e) ? !1 : t;
}
function Su(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Ig(e);
  let o = ks(1);
  t && (r ? eo(r) && (o = oc(r)) : o = oc(e));
  const c = AX(a, n, r) ? DO(a) : ks(0);
  let u = (i.left + c.x) / o.x, s = (i.top + c.y) / o.y, f = i.width / o.x, d = i.height / o.y;
  if (a) {
    const l = pa(a), p = r && eo(r) ? pa(r) : r;
    let g = l, v = u2(g);
    for (; v && r && p !== g; ) {
      const b = oc(v), y = v.getBoundingClientRect(), w = to(v), C = y.left + (v.clientLeft + parseFloat(w.paddingLeft)) * b.x, T = y.top + (v.clientTop + parseFloat(w.paddingTop)) * b.y;
      u *= b.x, s *= b.y, f *= b.x, d *= b.y, u += C, s += T, g = pa(v), v = u2(g);
    }
  }
  return T0({
    width: f,
    height: d,
    x: u,
    y: s
  });
}
function kX(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", o = Ao(r), c = t ? p1(t.floating) : !1;
  if (r === o || c && a)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = ks(1);
  const f = ks(0), d = _o(r);
  if ((d || !d && !a) && ((ju(r) !== "body" || op(o)) && (u = d1(r)), _o(r))) {
    const l = Su(r);
    s = oc(r), f.x = l.x + r.clientLeft, f.y = l.y + r.clientTop;
  }
  return {
    width: n.width * s.x,
    height: n.height * s.y,
    x: n.x * s.x - u.scrollLeft * s.x + f.x,
    y: n.y * s.y - u.scrollTop * s.y + f.y
  };
}
function EX(e) {
  return Array.from(e.getClientRects());
}
function c2(e, t) {
  const n = d1(e).scrollLeft;
  return t ? t.left + n : Su(Ao(e)).left + n;
}
function OX(e) {
  const t = Ao(e), n = d1(e), r = e.ownerDocument.body, i = ac(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = ac(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + c2(e);
  const c = -n.scrollTop;
  return to(r).direction === "rtl" && (o += ac(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: c
  };
}
function TX(e, t) {
  const n = pa(e), r = Ao(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, c = 0, u = 0;
  if (i) {
    a = i.width, o = i.height;
    const s = jg();
    (!s || s && t === "fixed") && (c = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: c,
    y: u
  };
}
function PX(e, t) {
  const n = Su(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = _o(e) ? oc(e) : ks(1), o = e.clientWidth * a.x, c = e.clientHeight * a.y, u = i * a.x, s = r * a.y;
  return {
    width: o,
    height: c,
    x: u,
    y: s
  };
}
function V_(e, t, n) {
  let r;
  if (t === "viewport")
    r = TX(e, n);
  else if (t === "document")
    r = OX(Ao(e));
  else if (eo(t))
    r = PX(t, n);
  else {
    const i = DO(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return T0(r);
}
function LO(e, t) {
  const n = Es(e);
  return n === t || !eo(n) || yc(n) ? !1 : to(n).position === "fixed" || LO(n, t);
}
function RX(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Lf(e, [], !1).filter((c) => eo(c) && ju(c) !== "body"), i = null;
  const a = to(e).position === "fixed";
  let o = a ? Es(e) : e;
  for (; eo(o) && !yc(o); ) {
    const c = to(o), u = Rg(o);
    !u && c.position === "fixed" && (i = null), (a ? !u && !i : !u && c.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || op(o) && !u && LO(e, o)) ? r = r.filter((f) => f !== o) : i = c, o = Es(o);
  }
  return t.set(e, r), r;
}
function jX(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? p1(t) ? [] : RX(t, this._c) : [].concat(n), r], c = o[0], u = o.reduce((s, f) => {
    const d = V_(t, f, i);
    return s.top = ac(d.top, s.top), s.right = o2(d.right, s.right), s.bottom = o2(d.bottom, s.bottom), s.left = ac(d.left, s.left), s;
  }, V_(t, c, i));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function IX(e) {
  const {
    width: t,
    height: n
  } = qO(e);
  return {
    width: t,
    height: n
  };
}
function qX(e, t, n) {
  const r = _o(t), i = Ao(t), a = n === "fixed", o = Su(e, !0, a, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = ks(0);
  if (r || !r && !a)
    if ((ju(t) !== "body" || op(i)) && (c = d1(t)), r) {
      const p = Su(t, !0, a, t);
      u.x = p.x + t.clientLeft, u.y = p.y + t.clientTop;
    } else i && (u.x = c2(i));
  let s = 0, f = 0;
  if (i && !r && !a) {
    const p = i.getBoundingClientRect();
    f = p.top + c.scrollTop, s = p.left + c.scrollLeft - // RTL <body> scrollbar.
    c2(i, p);
  }
  const d = o.left + c.scrollLeft - u.x - s, l = o.top + c.scrollTop - u.y - f;
  return {
    x: d,
    y: l,
    width: o.width,
    height: o.height
  };
}
function D3(e) {
  return to(e).position === "static";
}
function W_(e, t) {
  if (!_o(e) || to(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ao(e) === n && (n = n.ownerDocument.body), n;
}
function NO(e, t) {
  const n = pa(e);
  if (p1(e))
    return n;
  if (!_o(e)) {
    let i = Es(e);
    for (; i && !yc(i); ) {
      if (eo(i) && !D3(i))
        return i;
      i = Es(i);
    }
    return n;
  }
  let r = W_(e, t);
  for (; r && wX(r) && D3(r); )
    r = W_(r, t);
  return r && yc(r) && D3(r) && !Rg(r) ? n : r || SX(e) || n;
}
const DX = async function(e) {
  const t = this.getOffsetParent || NO, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: qX(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function LX(e) {
  return to(e).direction === "rtl";
}
const NX = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kX,
  getDocumentElement: Ao,
  getClippingRect: jX,
  getOffsetParent: NO,
  getElementRects: DX,
  getClientRects: EX,
  getDimensions: IX,
  getScale: oc,
  isElement: eo,
  isRTL: LX
};
function $X(e, t) {
  let n = null, r;
  const i = Ao(e);
  function a() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function o(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), a();
    const {
      left: s,
      top: f,
      width: d,
      height: l
    } = e.getBoundingClientRect();
    if (c || t(), !d || !l)
      return;
    const p = qd(f), g = qd(i.clientWidth - (s + d)), v = qd(i.clientHeight - (f + l)), b = qd(s), w = {
      rootMargin: -p + "px " + -g + "px " + -v + "px " + -b + "px",
      threshold: ac(0, o2(1, u)) || 1
    };
    let C = !0;
    function T(E) {
      const D = E[0].intersectionRatio;
      if (D !== u) {
        if (!C)
          return o();
        D ? o(!1, D) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, w);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function MX(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, s = Ig(e), f = i || a ? [...s ? Lf(s) : [], ...Lf(t)] : [];
  f.forEach((y) => {
    i && y.addEventListener("scroll", n, {
      passive: !0
    }), a && y.addEventListener("resize", n);
  });
  const d = s && c ? $X(s, n) : null;
  let l = -1, p = null;
  o && (p = new ResizeObserver((y) => {
    let [w] = y;
    w && w.target === s && p && (p.unobserve(t), cancelAnimationFrame(l), l = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(t);
    })), n();
  }), s && !u && p.observe(s), p.observe(t));
  let g, v = u ? Su(e) : null;
  u && b();
  function b() {
    const y = Su(e);
    v && (y.x !== v.x || y.y !== v.y || y.width !== v.width || y.height !== v.height) && n(), v = y, g = requestAnimationFrame(b);
  }
  return n(), () => {
    var y;
    f.forEach((w) => {
      i && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), d == null || d(), (y = p) == null || y.disconnect(), p = null, u && cancelAnimationFrame(g);
  };
}
const FX = _X, BX = bX, UX = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: NX,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return vX(e, t, {
    ...i,
    platform: a
  });
};
function HX(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function K_(e) {
  if (HX(e)) {
    const t = e.$el;
    return Pg(t) && ju(t) === "#comment" ? null : t;
  }
  return e;
}
function wl(e) {
  return typeof e == "function" ? e() : Nt(e);
}
function $O(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Z_(e, t) {
  const n = $O(e);
  return Math.round(t * n) / n;
}
function zX(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, i = Ye(() => {
    var $;
    return ($ = wl(n.open)) != null ? $ : !0;
  }), a = Ye(() => wl(n.middleware)), o = Ye(() => {
    var $;
    return ($ = wl(n.placement)) != null ? $ : "bottom";
  }), c = Ye(() => {
    var $;
    return ($ = wl(n.strategy)) != null ? $ : "absolute";
  }), u = Ye(() => {
    var $;
    return ($ = wl(n.transform)) != null ? $ : !0;
  }), s = Ye(() => K_(e.value)), f = Ye(() => K_(t.value)), d = Sr(0), l = Sr(0), p = Sr(c.value), g = Sr(o.value), v = di({}), b = Sr(!1), y = Ye(() => {
    const $ = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!f.value)
      return $;
    const Z = Z_(f.value, d.value), te = Z_(f.value, l.value);
    return u.value ? {
      ...$,
      transform: "translate(" + Z + "px, " + te + "px)",
      ...$O(f.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: Z + "px",
      top: te + "px"
    };
  });
  let w;
  function C() {
    if (s.value == null || f.value == null)
      return;
    const $ = i.value;
    UX(s.value, f.value, {
      middleware: a.value,
      placement: o.value,
      strategy: c.value
    }).then((Z) => {
      d.value = Z.x, l.value = Z.y, p.value = Z.strategy, g.value = Z.placement, v.value = Z.middlewareData, b.value = $ !== !1;
    });
  }
  function T() {
    typeof w == "function" && (w(), w = void 0);
  }
  function E() {
    if (T(), r === void 0) {
      C();
      return;
    }
    if (s.value != null && f.value != null) {
      w = r(s.value, f.value, C);
      return;
    }
  }
  function D() {
    i.value || (b.value = !1);
  }
  return In([a, o, c, i], C, {
    flush: "sync"
  }), In([s, f], E, {
    flush: "sync"
  }), In(i, D, {
    flush: "sync"
  }), lC() && fC(T), {
    x: pu(d),
    y: pu(l),
    strategy: pu(p),
    placement: pu(g),
    middlewareData: pu(v),
    isPositioned: pu(b),
    floatingStyles: y,
    update: C
  };
}
const GX = ["aria-activedescendant", "aria-labelledby", "role", "x-placement"], VX = /* @__PURE__ */ xr({
  inheritAttrs: !1,
  __name: "HeadlessPopover",
  props: {
    placement: {
      type: String,
      validator: (e) => G2.includes(e),
      default: "bottom-start"
    },
    popoverOffset: {
      type: Number,
      default: 6
    },
    role: {
      type: String,
      default: "listbox"
    },
    openOnMouseover: {
      type: Boolean,
      default: !1
    },
    closeOnPopoverClick: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maxWidth: {
      type: String,
      default: "auto"
    },
    width: {
      type: String,
      default: "auto"
    },
    maxHeight: {
      type: String,
      default: "auto"
    },
    popoverClasses: {
      type: String,
      default: ""
    }
  },
  emits: ["open", "close"],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = n, a = j0(), o = Ye(() => {
      const C = { ...a };
      return delete C.id, delete C["aria-activedescendant"], delete C["aria-labelledby"], C;
    }), c = Sr(null), u = Sr(null), s = Sr(null), f = Sr(!1), d = Ye(() => {
      var C, T;
      return u.value && ((C = u.value) != null && C.children[0]) ? (T = u.value) == null ? void 0 : T.children[0] : null;
    }), l = Sr(null), p = () => {
      f.value ? v() : g();
    }, g = async () => {
      r.disabled || (l.value && clearTimeout(l.value), f.value = !0);
    }, v = () => {
      window && (l.value = window.setTimeout(() => {
        f.value = !1;
      }, r.openOnMouseover ? 300 : 0));
    }, b = (C) => {
      var E, D, $, Z, te;
      const T = C.target;
      (E = d.value) != null && E.contains(T) && !((D = s.value) != null && D.contains(T)) ? p() : ($ = s.value) != null && $.contains(T) && !((Z = u.value) != null && Z.contains(T)) ? r.closeOnPopoverClick && v() : f.value && !((te = c.value) != null && te.contains(T)) && v();
    }, y = Ye(() => ({
      maxWidth: r.maxWidth,
      width: r.width,
      maxHeight: r.maxHeight
    })), { floatingStyles: w } = zX(d, s, {
      placement: r.placement,
      middleware: [FX(r.popoverOffset), BX()],
      transform: !1,
      whileElementsMounted: MX
    });
    return t({
      hidePopover: v
    }), R0(() => {
      document && (document == null || document.addEventListener("click", b), d.value && r.openOnMouseover && (d.value.addEventListener("mouseenter", g), d.value.addEventListener("focus", g), d.value.addEventListener("mouseleave", v), d.value.addEventListener("blur", v)), s.value && r.openOnMouseover && (s.value.addEventListener("mouseenter", g), s.value.addEventListener("focusin", g), s.value.addEventListener("mouseleave", v), s.value.addEventListener("focusout", v)));
    }), $D(() => {
      document && (document == null || document.removeEventListener("click", b), d.value && r.openOnMouseover && (d.value.removeEventListener("mouseenter", g), d.value.removeEventListener("focus", g), d.value.removeEventListener("mouseleave", v), d.value.removeEventListener("blur", v)), s.value && r.openOnMouseover && (s.value.removeEventListener("mouseenter", g), s.value.removeEventListener("focusin", g), s.value.removeEventListener("mouseleave", v), s.value.removeEventListener("focusout", v)));
    }), In(f, (C) => {
      i(C ? "open" : "close");
    }), (C, T) => (Re(), vt("div", Li({
      ref_key: "popoverWrapperRef",
      ref: c,
      class: "popover",
      "data-testid": "popover"
    }, o.value), [
      Gt("div", {
        ref_key: "triggerWrapperRef",
        ref: u,
        class: "popover-trigger-wrapper"
      }, [
        Fn(C.$slots, "default", {}, void 0, !0)
      ], 512),
      Br(Wd, { name: "spec-renderer-fade" }, {
        default: _r(() => [
          f.value ? (Re(), vt("div", Li({
            key: 0,
            ref_key: "popoverRef",
            ref: s,
            "aria-activedescendant": Nt(a)["aria-activedescendant"] ? String(Nt(a)["aria-activedescendant"]) : void 0,
            "aria-labelledby": Nt(a)["aria-labelledby"] ? String(Nt(a)["aria-labelledby"]) : void 0,
            class: ["popover-container", [`popover-${e.placement}`, e.popoverClasses]],
            "data-testid": "popover-container",
            role: e.role,
            style: Nt(w),
            "x-placement": e.placement
          }, Nt(a).id ? { id: String(Nt(a).id) } : {}), [
            Gt("div", {
              class: "popover-content",
              style: $n(y.value)
            }, [
              Fn(C.$slots, "content", {}, void 0, !0)
            ], 4)
          ], 16, GX)) : Kt("", !0)
        ]),
        _: 3
      })
    ], 16));
  }
}), MO = /* @__PURE__ */ dn(VX, [["__scopeId", "data-v-3487d311"]]), WX = ["aria-label", "disabled"], KX = { key: 0 }, ZX = { class: "select-items-container" }, YX = ["id", "aria-selected", "data-testid"], JX = ["data-testid", "onClick"], QX = /* @__PURE__ */ xr({
  inheritAttrs: !1,
  __name: "SelectDropdown",
  props: /* @__PURE__ */ Xa({
    triggerButton: {
      type: String,
      default: "Select"
    },
    items: {
      type: Object,
      required: !0
    },
    placement: {
      type: String,
      validator: (e) => G2.includes(e),
      default: "bottom-start"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    popoverOffset: {
      type: Number,
      default: 10
    }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xa(["change"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = t, i = j0(), a = Ye(() => {
      const f = { ...i };
      return delete f.id, f;
    }), o = bc(e, "modelValue"), c = Sr(null), u = (f) => {
      var d;
      o.value = f, (d = c.value) == null || d.hidePopover();
    }, s = Ye(() => n.items.find((f) => f.value === o.value));
    return In(o, (f) => {
      const d = n.items.find((l) => l.value === f);
      d && r("change", d);
    }), (f, d) => (Re(), Bt(MO, Li({
      ref_key: "selectPopoverRef",
      ref: c,
      "aria-activedescendant": s.value ? `${s.value.key ? s.value.key : s.value.value}-item` : void 0,
      "aria-labelledby": Nt(i).id ? String(Nt(i).id) : void 0,
      class: "select-dropdown",
      "close-on-popover-click": "",
      "data-testid": "select-dropdown",
      disabled: e.disabled,
      placement: e.placement,
      "popover-offset": e.popoverOffset,
      width: "300px"
    }, a.value), {
      content: _r(() => [
        Gt("div", ZX, [
          Gt("ul", null, [
            (Re(!0), vt(Wn, null, hi(e.items, (l) => (Re(), vt("li", {
              id: `${l.key ? l.key : l.value}-item`,
              key: `${l.key ? l.key : l.value}-item`,
              "aria-selected": l.value === o.value ? "true" : "false",
              class: Bn(["select-item", { selected: l.value === o.value }]),
              "data-testid": l.key ? `${l.key}-item` : "select-item",
              role: "option"
            }, [
              Fn(f.$slots, `${l.key}-item`, { item: l }, () => [
                Gt("button", {
                  "data-testid": l.key ? `${l.key}-item-trigger` : "select-item-trigger",
                  onClick: $f((p) => u(l.value), ["stop"])
                }, [
                  Fn(f.$slots, `${l.key}-item-content`, { item: l }, () => [
                    Gt("span", null, pn(l.label), 1)
                  ])
                ], 8, JX)
              ])
            ], 10, YX))), 128))
          ])
        ])
      ]),
      default: _r(() => {
        var l;
        return [
          Gt("button", Li({
            "aria-label": (l = s.value) != null && l.label || e.triggerButton ? void 0 : "Select one option",
            class: "trigger-button",
            "data-select-dropdown-trigger": "true",
            "data-testid": "trigger-button",
            disabled: e.disabled ? !0 : void 0,
            type: "button"
          }, Nt(i).id ? { id: String(Nt(i).id) } : {}), [
            Fn(f.$slots, "trigger-content", {}, () => {
              var p;
              return [
                Fn(f.$slots, `${(p = s.value) == null ? void 0 : p.key}-item-content`, { item: s.value }, () => {
                  var g, v;
                  return [
                    (g = s.value) != null && g.label || e.triggerButton ? (Re(), vt("span", KX, pn(((v = s.value) == null ? void 0 : v.label) || e.triggerButton), 1)) : Kt("", !0)
                  ];
                })
              ];
            }),
            Br(Nt(wO), {
              class: "select-chevron-icon",
              decorative: ""
            })
          ], 16, WX)
        ];
      }),
      _: 3
    }, 16, ["aria-activedescendant", "aria-labelledby", "disabled", "placement", "popover-offset"]));
  }
}), Ia = /* @__PURE__ */ dn(QX, [["__scopeId", "data-v-d90cef62"]]);
function FO(e) {
  const t = Ye(
    () => {
      var o, c, u, s;
      return (c = (o = e.value) == null ? void 0 : o.oneOf) != null && c.length ? "One Of" : (s = (u = e.value) == null ? void 0 : u.anyOf) != null && s.length ? "Any Of" : "";
    }
  ), n = Ye(
    () => {
      var o, c;
      return (((o = e.value) == null ? void 0 : o.oneOf) || ((c = e.value) == null ? void 0 : c.anyOf) || []).filter(
        es
      ).map(Tc);
    }
  ), r = Ye(() => n.value.map((o, c) => {
    const u = uW(c, o.title);
    return {
      key: u,
      value: c.toString(),
      label: u + `${o.deprecated ? " (deprecated)" : ""}`
    };
  })), i = Sr(0), a = Ye(() => n.value[i.value] ?? e.value);
  return {
    inheritanceTypeLabel: t,
    variantSelectItemList: r,
    selectedVariantIndex: i,
    selectedSchemaModel: a
  };
}
const XX = { class: "variant-label" }, eee = /* @__PURE__ */ xr({
  __name: "VariantLabel",
  props: {
    label: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("code", XX, pn(e.label), 1));
  }
}), BO = /* @__PURE__ */ dn(eee, [["__scopeId", "data-v-224a855a"]]), tee = ["data-testid"], ree = /* @__PURE__ */ xr({
  __name: "ModelNode",
  props: {
    schema: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    /**
     * Hides the example field from the model node
     * in case example is already shown on the page
     */
    hideExampleField: {
      type: Boolean,
      default: !1
    },
    /**
     * used for links to individual properties of a Schema Model
     */
    basePathId: {
      type: String,
      default: ""
    },
    /**
     * The depth at which the current property is at
     */
    depth: {
      type: Number,
      default: 1
    }
  },
  emits: ["selected-model-changed"],
  setup(e, { emit: t }) {
    const n = e, r = Ye(() => Tc(n.schema)), { variantSelectItemList: i, selectedSchemaModel: a, selectedVariantIndex: o, inheritanceTypeLabel: c } = FO(r);
    function u(d) {
      o.value = Number(d.value);
    }
    const s = t;
    In(a, (d) => {
      s("selected-model-changed", d);
    }, {
      immediate: !0
    });
    const f = Ye(() => `model-node-${n.title.replaceAll(" ", "-")}`);
    return (d, l) => {
      var p, g, v, b;
      return Re(), vt("div", {
        class: "model-node-container",
        "data-testid": f.value
      }, [
        Nt(i).length ? (Re(), vt(Wn, { key: 0 }, [
          Gt("div", null, [
            Nt(c) ? (Re(), Bt(BO, {
              key: 0,
              label: Nt(c)
            }, null, 8, ["label"])) : Kt("", !0),
            Br(Ia, {
              id: `${f.value}-variant-select-dropdown`,
              class: "model-node-variant-select",
              items: Nt(i),
              "model-value": Nt(o).toString(),
              onChange: u
            }, null, 8, ["id", "items", "model-value"])
          ]),
          (p = Nt(a)) != null && p.oneOf || (g = Nt(a)) != null && g.anyOf ? (Re(), Bt(l2, {
            key: 0,
            "base-path-id": e.basePathId,
            depth: e.depth,
            property: Nt(a),
            "property-name": Nt(a).title || Nt(i)[Nt(o)].label,
            "required-fields": (v = Nt(a)) == null ? void 0 : v.required
          }, null, 8, ["base-path-id", "depth", "property", "property-name", "required-fields"])) : Kt("", !0)
        ], 64)) : Kt("", !0),
        (Re(!0), vt(Wn, null, hi((b = Nt(a)) == null ? void 0 : b.properties, (y, w, C) => {
          var T;
          return Re(), vt(Wn, { key: w }, [
            Nt(es)(y) ? (Re(), Bt(l2, {
              key: 0,
              "base-path-id": e.basePathId,
              class: Bn({ "model-node-property": C !== 0 }),
              "data-testid": `model-property-${w}`,
              depth: e.depth,
              property: y,
              "property-name": w.toString(),
              "required-fields": (T = Nt(a)) == null ? void 0 : T.required
            }, null, 8, ["base-path-id", "class", "data-testid", "depth", "property", "property-name", "required-fields"])) : Kt("", !0)
          ], 64);
        }), 128))
      ], 8, tee);
    };
  }
}), sp = /* @__PURE__ */ dn(ree, [["__scopeId", "data-v-7e77caeb"]]), nee = /* @__PURE__ */ xr({
  __name: "PropertyDescription",
  props: {
    description: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.description ? (Re(), Bt(os, {
      key: 0,
      class: "property-field-description",
      "data-testid": "property-field-description",
      markdown: e.description
    }, null, 8, ["markdown"])) : Kt("", !0);
  }
}), iee = /* @__PURE__ */ dn(nee, [["__scopeId", "data-v-16e5f22c"]]), aee = {
  class: "property-field-example",
  "data-testid": "property-field-example"
}, oee = { class: "property-field-example-value" }, see = /* @__PURE__ */ xr({
  __name: "PropertyExample",
  props: {
    example: {
      // allow any type since typeof example is unknown
      type: null,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("p", aee, [
      n[0] || (n[0] = Gt("span", { class: "field-title" }, "Example:", -1)),
      Gt("span", oee, pn(Nt(Lk)(e.example)), 1)
    ]));
  }
}), uee = /* @__PURE__ */ dn(see, [["__scopeId", "data-v-05b820a3"]]), cee = {
  key: 0,
  class: "property-title",
  "data-testid": "property-field-title"
}, lee = { class: "property-title-name" }, fee = { class: "property-type" }, pee = {
  key: 0,
  "data-testid": "property-field-type"
}, dee = {
  key: 1,
  "data-testid": "property-field-item-type"
}, hee = {
  key: 2,
  "data-testid": "property-field-format"
}, mee = {
  key: 3,
  class: "required-property",
  "data-testid": "property-field-required"
}, gee = {
  key: 4,
  class: "readonly-property",
  "data-testid": "property-field-read-only"
}, vee = {
  key: 5,
  "data-testid": "property-field-unique-items"
}, yee = ["href"], bee = /* @__PURE__ */ xr({
  __name: "PropertyInfo",
  props: {
    title: {
      type: String,
      default: ""
    },
    propertyType: {
      type: [Array, String],
      default: ""
    },
    format: {
      type: String,
      default: ""
    },
    propertyItemType: {
      type: [Array, String],
      default: ""
    },
    uniqueItems: {
      type: Boolean,
      default: !1
    },
    deprecated: {
      type: Boolean,
      default: !1
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    variantsList: {
      type: Array,
      default: () => []
    },
    inheritanceTypeLabel: {
      type: String,
      default: ""
    },
    propertyPath: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["variant-changed"],
  setup(e, { emit: t }) {
    const n = e, r = Sr("0"), i = t, a = Ye(() => Array.isArray(n.propertyType) ? n.propertyType.join(" | ") : n.propertyType ?? "");
    function o(c) {
      i("variant-changed", Number(c.value));
    }
    return (c, u) => {
      var s;
      return Re(), vt("div", {
        class: Bn(["property-info", { "deprecated-property": e.deprecated }]),
        "data-testid": "property-field-info"
      }, [
        e.title || e.inheritanceTypeLabel || e.variantsList.length ? (Re(), vt("span", cee, [
          Gt("span", lee, pn(e.title), 1),
          e.inheritanceTypeLabel ? (Re(), Bt(BO, {
            key: 0,
            class: "property-title-variant-label",
            label: e.inheritanceTypeLabel
          }, null, 8, ["label"])) : Kt("", !0),
          e.variantsList.length ? (Re(), Bt(Ia, {
            key: 1,
            id: `${e.title}-variant-select-dropdown`,
            modelValue: r.value,
            "onUpdate:modelValue": u[0] || (u[0] = (f) => r.value = f),
            class: "property-title-variant-select",
            items: e.variantsList,
            onChange: o
          }, null, 8, ["id", "modelValue", "items"])) : Kt("", !0)
        ])) : Kt("", !0),
        Gt("span", fee, [
          a.value ? (Re(), vt("span", pee, pn(a.value), 1)) : Kt("", !0),
          e.propertyItemType ? (Re(), vt("span", dee, pn(`[${e.propertyItemType}]`), 1)) : Kt("", !0),
          e.format ? (Re(), vt("span", hee, pn(`(${e.format})`), 1)) : Kt("", !0),
          (s = e.requiredFields) != null && s.includes(e.title) ? (Re(), vt("span", mee, "required")) : Kt("", !0),
          e.readOnly ? (Re(), vt("span", gee, "read-only")) : Kt("", !0),
          e.uniqueItems ? (Re(), vt("span", vee, "unique-items")) : Kt("", !0),
          e.deprecated ? (Re(), Bt(qf, {
            key: 6,
            "data-testid": "property-field-deprecated",
            label: "DEPRECATED",
            size: "small",
            type: "neutral"
          })) : Kt("", !0)
        ]),
        e.propertyPath ? (Re(), vt("a", {
          key: 1,
          class: "property-info-permalink",
          href: `#${e.propertyPath}`
        }, [
          Br(Nt(OJ))
        ], 8, yee)) : Kt("", !0)
      ], 2);
    };
  }
}), xee = /* @__PURE__ */ dn(bee, [["__scopeId", "data-v-12ce9f9a"]]), _ee = {
  class: "property-field-enum",
  "data-testid": "property-field-enum"
}, wee = { class: "enum-field-list" }, See = ["data-testid"], Cee = /* @__PURE__ */ xr({
  __name: "PropertyEnum",
  props: {
    enumValueList: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("p", _ee, [
      n[0] || (n[0] = Gt("span", { class: "field-title" }, "Allowed values:", -1)),
      Gt("span", wee, [
        (Re(!0), vt(Wn, null, hi(e.enumValueList, (r) => (Re(), vt("span", {
          key: r == null ? void 0 : r.toString(),
          class: "property-field-enum-value",
          "data-testid": `property-field-enum-value-${r}`
        }, pn(r), 9, See))), 128))
      ])
    ]));
  }
}), Aee = /* @__PURE__ */ dn(Cee, [["__scopeId", "data-v-cfb8d026"]]), kee = {
  class: "property-field-pattern",
  "data-testid": "property-field-pattern"
}, Eee = { class: "property-field-pattern-value" }, Oee = /* @__PURE__ */ xr({
  __name: "PropertyPattern",
  props: {
    pattern: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("p", kee, [
      n[0] || (n[0] = Gt("span", { class: "field-title" }, "Match pattern:", -1)),
      Gt("span", Eee, pn(e.pattern), 1)
    ]));
  }
}), Tee = /* @__PURE__ */ dn(Oee, [["__scopeId", "data-v-106ddaac"]]), Pee = {
  class: "property-field-range",
  "data-testid": "property-field-range"
}, Ree = /* @__PURE__ */ xr({
  __name: "PropertyRange",
  props: {
    maximum: {
      type: Number,
      default: null
    },
    minimum: {
      type: Number,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    minLength: {
      type: Number,
      default: null
    },
    exclusiveMaximum: {
      type: [Boolean, Number],
      default: null
    },
    exclusiveMinimum: {
      type: [Boolean, Number],
      default: null
    },
    multipleOf: {
      type: Number,
      default: null
    },
    maxItems: {
      type: Number,
      default: null
    },
    minItems: {
      type: Number,
      default: null
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      const r = [];
      return Number.isFinite(t.minimum) && r.push({
        key: "range-min",
        value: typeof t.exclusiveMinimum == "boolean" && t.exclusiveMinimum ? `> ${t.minimum}` : `>= ${t.minimum}`
      }), Number.isFinite(t.maximum) && r.push({
        key: "range-max",
        value: typeof t.exclusiveMaximum == "boolean" && t.exclusiveMaximum ? `< ${t.maximum}` : `<= ${t.maximum}`
      }), Number.isFinite(t.minLength) && r.push({
        key: "range-min-length",
        value: `>= ${t.minLength} characters`
      }), Number.isFinite(t.maxLength) && r.push({
        key: "range-max-length",
        value: `<= ${t.maxLength} characters`
      }), Number.isFinite(t.exclusiveMinimum) && r.push({
        key: "range-exclusive-min",
        value: `> ${t.exclusiveMinimum}`
      }), Number.isFinite(t.exclusiveMaximum) && r.push({
        key: "range-exclusive-max",
        value: `< ${t.exclusiveMaximum}`
      }), Number.isFinite(t.multipleOf) && r.push({ key: "range-multiple-of", value: `x ${t.multipleOf}` }), Number.isFinite(t.minItems) && r.push({ key: "range-min-items", value: `>= ${t.minItems} items` }), Number.isFinite(t.maxItems) && r.push({ key: "range-max-items", value: `<= ${t.maxItems} items` }), r;
    });
    return (r, i) => (Re(), vt("p", Pee, [
      (Re(!0), vt(Wn, null, hi(n.value, (a) => (Re(), vt("span", {
        key: a.key,
        class: "property-field-range-value"
      }, pn(a.value), 1))), 128))
    ]));
  }
}), jee = /* @__PURE__ */ dn(Ree, [["__scopeId", "data-v-c0174553"]]), Iee = {
  class: "property-field-default",
  "data-testid": "property-field-default"
}, qee = { class: "property-field-default-value" }, Dee = /* @__PURE__ */ xr({
  __name: "PropertyDefault",
  props: {
    defaultValue: {
      // allow any type since typeof default value is unknown
      type: null,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("p", Iee, [
      n[0] || (n[0] = Gt("span", { class: "field-title" }, "Default:", -1)),
      Gt("span", qee, pn(Nt(Lk)(e.defaultValue)), 1)
    ]));
  }
}), Lee = /* @__PURE__ */ dn(Dee, [["__scopeId", "data-v-b5e94329"]]), Nee = {
  class: "property-field-additional-properties",
  "data-testid": "property-field-additional-properties"
}, $ee = {
  key: 0,
  class: "footprint"
}, Mee = {
  key: 1,
  class: "footprint"
}, Fee = /* @__PURE__ */ xr({
  __name: "AdditionalProperties",
  props: {
    additionalProperties: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", Nee, [
      e.additionalProperties === !0 ? (Re(), vt("div", $ee, " * Additional properties are allowed. ")) : Kt("", !0),
      e.additionalProperties === !1 ? (Re(), vt("div", Mee, n[0] || (n[0] = [
        Rn(" * Additional properties are "),
        Gt("b", null, "NOT", -1),
        Rn(" allowed. ")
      ]))) : Kt("", !0)
    ]));
  }
}), Bee = /* @__PURE__ */ dn(Fee, [["__scopeId", "data-v-c16e0515"]]), Uee = { class: "property-field-list" }, Hee = /* @__PURE__ */ xr({
  __name: "PropertyFieldList",
  props: {
    property: {
      type: Object,
      required: !0
    },
    propertyName: {
      type: String,
      default: ""
    },
    hiddenFieldList: {
      type: Array,
      default: () => []
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    variantSelectItemList: {
      type: Array,
      default: () => []
    },
    inheritanceTypeLabel: {
      type: String,
      default: ""
    },
    propertyPath: {
      type: String,
      default: ""
    }
  },
  emits: ["variant-changed"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = (o) => {
      var u, s;
      if (n.hiddenFieldList.includes(o))
        return !1;
      const c = (s = (u = n.property) == null ? void 0 : u["x-stoplight"]) == null ? void 0 : s.explicitProperties;
      return Array.isArray(c) && c.length ? c.includes(o) : !0;
    }, a = Ye(() => {
      const o = [];
      if (!es(n.property)) return [];
      !n.hiddenFieldList.includes("info") && (n.property.title || n.propertyName || n.property.type) && o.push({
        component: xee,
        props: {
          title: n.propertyName || n.property.title,
          propertyType: n.property.type,
          uniqueItems: n.property.uniqueItems,
          requiredFields: n.requiredFields,
          variantsList: n.variantSelectItemList,
          inheritanceTypeLabel: n.inheritanceTypeLabel,
          deprecated: n.property.deprecated,
          propertyPath: n.propertyPath,
          propertyItemType: n.property.itemType,
          format: n.property.format,
          readOnly: n.property.readOnly
        },
        eventHandlers: {
          "variant-changed": (s) => {
            r("variant-changed", s);
          }
        },
        key: "property-info"
      }), i("description") && n.property.description && o.push({
        component: iee,
        props: {
          description: n.property.description
        },
        eventHandlers: {},
        key: "property-description"
      }), i("enum") && n.property.enum && o.push({
        component: Aee,
        props: {
          enumValueList: n.property.enum
        },
        eventHandlers: {},
        key: "property-enum"
      }), i("pattern") && n.property.pattern && o.push({
        component: Tee,
        props: {
          pattern: n.property.pattern
        },
        eventHandlers: {},
        key: "property-pattern"
      }), i("default") && n.property.default !== void 0 && o.push({
        component: Lee,
        props: {
          defaultValue: n.property.default
        },
        eventHandlers: {},
        key: "property-default"
      });
      const c = {};
      return xH.forEach((s) => {
        i(s) && (c[s] = n.property[s]);
      }), !n.hiddenFieldList.includes("range") && Object.values(c).some((s) => s !== void 0) && o.push({
        component: jee,
        props: c,
        eventHandlers: {},
        key: "property-range"
      }), (n.property.example && i("example") || n.property.examples && i("examples")) && o.push({
        component: uee,
        props: {
          example: n.property.examples || n.property.example
        },
        eventHandlers: {},
        key: "property-example"
      }), i("additionalProperties") && typeof n.property.additionalProperties == "boolean" && o.push({
        component: Bee,
        props: {
          additionalProperties: n.property.additionalProperties
        },
        eventHandlers: {},
        key: "property-additional-properties"
      }), o;
    });
    return (o, c) => (Re(), vt("div", Uee, [
      (Re(!0), vt(Wn, null, hi(a.value, (u) => (Re(), Bt(An(u.component), Li({
        key: u.key,
        ref_for: !0
      }, u.props, MD(u.eventHandlers)), null, 16))), 128))
    ]));
  }
}), up = /* @__PURE__ */ dn(Hee, [["__scopeId", "data-v-4788b76b"]]), zee = ["id", "data-testid"], Gee = {
  key: 0,
  class: "selected-variant-container"
}, Vee = {
  key: 1,
  ref: "nested-fields"
}, Wee = /* @__PURE__ */ xr({
  __name: "ModelProperty",
  props: {
    property: {
      type: Object,
      required: !0
    },
    propertyName: {
      type: String,
      required: !0
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    /**
     * used for links to individual properties of a Schema Model
     */
    basePathId: {
      type: String,
      default: ""
    },
    /**
     * The depth at which the current property is at
     */
    depth: {
      type: Number,
      default: 1
    }
  },
  setup(e) {
    const t = e, n = Qa("max-expanded-depth", Sr(hc)), r = Sr(t.depth < n.value), i = Dy("model-property"), a = Dy("nested-fields"), o = Ye(() => `model-property-${U6(t.propertyName)}`), c = Ye(() => t.basePathId ? U6(`${t.basePathId}-${t.propertyName}`) : void 0), u = Ye(() => Tc(t.property)), {
      variantSelectItemList: s,
      selectedSchemaModel: f,
      selectedVariantIndex: d,
      inheritanceTypeLabel: l
    } = FO(u), p = Ye(() => {
      var v, b;
      return (v = f.value) != null && v.properties ? !!Object.keys((b = f.value) == null ? void 0 : b.properties).length : !1;
    });
    R0(() => {
      var y;
      if (r.value && g(), c0() || !c.value)
        return;
      const v = `#${c.value}`, b = window.location.hash;
      b.length && (b === v ? (y = i.value) == null || y.scrollIntoView({ behavior: "smooth" }) : b.startsWith(v) && (r.value = !0, g()));
    });
    const g = () => {
      a.value && (a.value.open = !0);
    };
    return (v, b) => {
      const y = FD("ModelProperty", !0);
      return Re(), vt("div", {
        id: c.value,
        ref: "model-property",
        class: "model-property",
        "data-testid": o.value
      }, [
        Br(up, {
          "inheritance-type-label": Nt(l),
          property: u.value,
          "property-name": e.propertyName,
          "property-path": c.value,
          "required-fields": e.requiredFields,
          "variant-select-item-list": Nt(s),
          onVariantChanged: b[0] || (b[0] = (w) => d.value = w)
        }, null, 8, ["inheritance-type-label", "property", "property-name", "property-path", "required-fields", "variant-select-item-list"]),
        Nt(s).length ? (Re(), vt("div", Gee, [
          Br(y, {
            "base-path-id": c.value,
            depth: e.depth,
            property: Nt(f),
            "property-name": Nt(f).title || Nt(s)[Nt(d)].label,
            "required-fields": Nt(f).required
          }, null, 8, ["base-path-id", "depth", "property", "property-name", "required-fields"])
        ])) : p.value ? (Re(), vt("details", Vee, [
          Gt("summary", {
            class: "nested-fields-summary",
            onClick: b[1] || (b[1] = () => r.value = !r.value)
          }, [
            Br(Nt(_O), {
              class: Bn(["add-circle-icon", { expanded: r.value }]),
              size: "16px"
            }, null, 8, ["class"]),
            Gt("span", null, pn(r.value ? "Hide" : "Show") + " Child Parameters", 1)
          ]),
          r.value ? (Re(), Bt(sp, {
            key: 0,
            "base-path-id": c.value,
            class: "nested-model-node",
            depth: e.depth + 1,
            schema: Nt(f),
            title: e.propertyName
          }, null, 8, ["base-path-id", "depth", "schema", "title"])) : Kt("", !0)
        ], 512)) : Kt("", !0)
      ], 8, zee);
    };
  }
}), l2 = /* @__PURE__ */ dn(Wee, [["__scopeId", "data-v-9f3a63be"]]), Kee = { key: 0 }, Zee = {
  key: 0,
  class: "endpoint-collapsible-section-content"
}, Yee = /* @__PURE__ */ xr({
  __name: "CollapsibleSection",
  props: {
    borderVisible: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = Sr(!0);
    return (n, r) => (Re(), vt("details", {
      class: Bn(["endpoint-collapsible-section", { "border-visible": e.borderVisible }]),
      open: ""
    }, [
      Gt("summary", {
        class: "endpoint-collapsible-section-header",
        onClick: r[0] || (r[0] = (i) => t.value = !t.value)
      }, [
        Fn(n.$slots, "title", {}, () => [
          e.title ? (Re(), vt("h3", Kee, pn(e.title), 1)) : Kt("", !0)
        ]),
        Br(Nt(u1), {
          class: Bn(["chevron-icon", { expanded: t.value }]),
          size: 16
        }, null, 8, ["class"])
      ]),
      n.$slots.default ? (Re(), vt("div", Zee, [
        Fn(n.$slots, "default")
      ])) : Kt("", !0)
    ], 2));
  }
}), jc = /* @__PURE__ */ dn(Yee, [["__scopeId", "data-v-a1989300"]]), Jee = { class: "request-param-list-items" }, Qee = /* @__PURE__ */ xr({
  __name: "RequestParamList",
  props: {
    paramList: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = (r, i) => {
      if (!r.schema) return null;
      const a = i;
      return r.description && !(a != null && a.description) && (a.description = r.description), a;
    }, n = (r) => {
      var i, a;
      return (i = r.schema) != null && i.required ? (a = r.schema) == null ? void 0 : a.required : r.required ? [r.name] : [];
    };
    return (r, i) => (Re(), Bt(jc, {
      class: "request-param-list",
      title: e.title
    }, {
      default: _r(() => [
        Gt("div", Jee, [
          (Re(!0), vt(Wn, null, hi(e.paramList, (a) => (Re(), vt(Wn, {
            key: a.id
          }, [
            a.schema ? (Re(), Bt(l2, {
              key: 0,
              property: { ...a.schema, ...t(a, a.schema) },
              "property-name": a.name,
              "required-fields": n(a)
            }, null, 8, ["property", "property-name", "required-fields"])) : Kt("", !0)
          ], 64))), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]));
  }
}), Vd = /* @__PURE__ */ dn(Qee, [["__scopeId", "data-v-8b2416ed"]]), Xee = { "data-testid": "endpoint-http-request" }, UO = /* @__PURE__ */ xr({
  __name: "HttpRequest",
  props: {
    query: {
      type: Array,
      default: () => []
    },
    path: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    titlePrefix: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      var u, s, f;
      const r = [], { query: i, path: a, headers: o } = BD(t), c = t.titlePrefix + " ";
      return (u = i.value) != null && u.length && r.push({
        component: Vd,
        componentProps: {
          paramList: i.value,
          title: `${c}Query Parameters`,
          "data-testid": "endpoint-query-param-list"
        },
        key: "query"
      }), (s = a.value) != null && s.length && r.push({
        component: Vd,
        componentProps: {
          paramList: a.value,
          title: `${c}Path Parameters`,
          "data-testid": "endpoint-path-param-list"
        },
        key: "path"
      }), (f = o.value) != null && f.length && r.push({
        component: Vd,
        componentProps: {
          paramList: o.value,
          title: `${c}Headers`,
          "data-testid": "endpoint-header-param-list"
        },
        key: "headers"
      }), r;
    });
    return (r, i) => (Re(), vt("section", Xee, [
      (Re(!0), vt(Wn, null, hi(n.value, ({ component: a, componentProps: o, key: c }) => (Re(), vt(Wn, { key: c }, [
        o ? (Re(), Bt(An(a), Li({
          key: 0,
          ref_for: !0
        }, o), null, 16)) : Kt("", !0)
      ], 64))), 128)),
      Fn(r.$slots, "default")
    ]));
  }
}), ete = { class: "content-list-item-schema" }, Y_ = /* @__PURE__ */ xr({
  __name: "ContentListItemSchema",
  props: {
    schema: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = Ye(() => {
      var r;
      const n = ["example", "examples"];
      return e.schema.properties && ((r = Object.keys(e.schema.properties)) != null && r.length) && n.push("info"), n;
    });
    return (n, r) => (Re(), vt("div", ete, [
      Br(up, {
        "hidden-field-list": t.value,
        property: e.schema,
        "required-fields": e.schema.required
      }, null, 8, ["hidden-field-list", "property", "required-fields"]),
      Br(sp, {
        schema: e.schema,
        title: e.schema.title
      }, null, 8, ["schema", "title"])
    ]));
  }
}), tte = {
  class: "body-content-list",
  "data-testid": "endpoint-body-content-list"
}, rte = { class: "content-list-schema-title" }, nte = /* @__PURE__ */ xr({
  __name: "BodyContentList",
  props: {
    description: {
      type: String,
      default: ""
    },
    contents: {
      type: Array,
      required: !0
    },
    hideReadonly: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e;
    function n(r) {
      const i = Tc(r);
      return t.hideReadonly ? ig(i, qE) : i;
    }
    return (r, i) => (Re(), vt("div", tte, [
      e.description ? (Re(), Bt(os, {
        key: 0,
        class: "body-content-list-description",
        markdown: e.description
      }, null, 8, ["markdown"])) : Kt("", !0),
      (Re(!0), vt(Wn, null, hi(e.contents, (a) => {
        var o;
        return Re(), vt(Wn, {
          key: a.id
        }, [
          (o = a.schema) != null && o.title ? (Re(), Bt(jc, {
            key: 0,
            "border-visible": !1
          }, hC({
            default: _r(() => [
              Br(Y_, {
                schema: n(a.schema)
              }, null, 8, ["schema"])
            ]),
            _: 2
          }, [
            a.schema.title ? {
              name: "title",
              fn: _r(() => [
                Gt("h4", rte, pn(a.schema.title), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1024)) : a.schema ? (Re(), Bt(Y_, {
            key: 1,
            schema: n(a.schema)
          }, null, 8, ["schema"])) : Kt("", !0)
        ], 64);
      }), 128))
    ]));
  }
}), ite = /* @__PURE__ */ dn(nte, [["__scopeId", "data-v-4ffc541f"]]), ate = {
  class: "endpoint-http-response",
  "data-testid": "endpoint-http-response"
}, ote = { class: "http-response-header" }, ste = /* @__PURE__ */ xr({
  __name: "HttpOperationBody",
  props: {
    description: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Response"
    },
    contentList: {
      type: Array,
      default: () => []
    },
    hideReadonly: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("section", ate, [
      Br(jc, null, {
        title: _r(() => [
          Gt("div", ote, [
            Gt("h3", null, pn(e.title), 1),
            Fn(t.$slots, "default", {}, void 0, !0)
          ])
        ]),
        default: _r(() => [
          Br(ite, {
            contents: e.contentList,
            description: e.description,
            "hide-readonly": e.hideReadonly
          }, null, 8, ["contents", "description", "hide-readonly"])
        ]),
        _: 3
      })
    ]));
  }
}), L3 = /* @__PURE__ */ dn(ste, [["__scopeId", "data-v-ac5bc66c"]]), ute = ["title"], cte = /* @__PURE__ */ xr({
  __name: "CopyButton",
  props: {
    content: {
      required: !0,
      type: String
    },
    iconsSize: {
      type: String,
      default: "16px"
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  },
  setup(e) {
    const t = e, n = Sr(), { copy: r, copied: i } = aQ({ source: t.content, legacy: !0 });
    async function a() {
      await r(t.content);
    }
    return (o, c) => (Re(), vt("button", {
      ref_key: "copyButton",
      ref: n,
      class: "copy-button",
      title: Nt(i) ? "Copied!" : "Copy",
      onClick: $f(a, ["stop"])
    }, [
      (Re(), Bt(An(Nt(i) ? Nt(bJ) : Nt(AJ)), {
        color: Nt(i) ? "green" : e.iconColor,
        size: e.iconsSize
      }, null, 8, ["color", "size"]))
    ], 8, ute));
  }
}), h1 = /* @__PURE__ */ dn(cte, [["__scopeId", "data-v-5b6abdcb"]]), lte = {
  class: "server-endpoint",
  "data-testid": "server-endpoint"
}, fte = { class: "current-endpoint" }, pte = { class: "endpoint-body" }, dte = {
  key: 0,
  class: "endpoint-path",
  "data-testid": "endpoint-path"
}, hte = ["data-testid"], mte = {
  key: 0,
  class: "endpoint-body"
}, gte = {
  class: "endpoint-path",
  "data-testid": "endpoint-path"
}, vte = /* @__PURE__ */ xr({
  __name: "ServerEndpoint",
  props: {
    method: {
      type: String,
      required: !0
    },
    serverUrlList: {
      type: Array,
      required: !0
    },
    selectedServerUrl: {
      type: String,
      required: !0
    },
    path: {
      type: String,
      default: ""
    }
  },
  emits: ["selected-server-changed"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = Ye(() => `${n.method}-${n.serverUrlList[0]}${n.path}`), a = (c) => {
      r("selected-server-changed", c);
    }, o = Ye(() => n.serverUrlList.map((c) => ({ label: c, value: c, key: c })));
    return (c, u) => (Re(), vt("div", lte, [
      Gt("div", fte, [
        Br(s1, {
          method: e.method,
          size: "large"
        }, null, 8, ["method"]),
        e.serverUrlList.length > 1 ? (Re(), Bt(Ia, {
          key: 0,
          id: "server-select-dropdown",
          class: "server-select-dropdown",
          "data-testid": `server-dropdown-${i.value}`,
          items: o.value,
          "model-value": e.selectedServerUrl,
          "onUpdate:modelValue": a
        }, {
          "trigger-content": _r(() => [
            Gt("span", pte, pn(e.selectedServerUrl), 1),
            e.path ? (Re(), vt("span", dte, pn(e.path), 1)) : Kt("", !0)
          ]),
          _: 1
        }, 8, ["data-testid", "items", "model-value"])) : (Re(), vt("div", {
          key: 1,
          class: "server-url-with-path",
          "data-testid": `server-url-${i.value}`
        }, [
          e.selectedServerUrl ? (Re(), vt("span", mte, pn(e.selectedServerUrl), 1)) : Kt("", !0),
          Gt("span", gte, pn(e.path), 1)
        ], 8, hte))
      ]),
      Br(h1, {
        content: e.selectedServerUrl + e.path
      }, null, 8, ["content"])
    ]));
  }
}), qg = /* @__PURE__ */ dn(vte, [["__scopeId", "data-v-a1bb8db6"]]), yte = {
  class: "endpoint-http-callbacks",
  "data-testid": "endpoint-http-callbacks"
}, bte = { class: "http-callbacks-header" }, xte = { class: "callback-collapsible-section-content" }, _te = /* @__PURE__ */ xr({
  __name: "HttpCallbacks",
  props: {
    callback: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("section", yte, [
      Br(jc, { "border-visible": !1 }, {
        title: _r(() => [
          Gt("div", bte, [
            n[0] || (n[0] = Gt("h3", null, "Callbacks", -1)),
            Fn(t.$slots, "default", {}, void 0, !0)
          ])
        ]),
        default: _r(() => [
          Gt("div", xte, [
            Br(qg, {
              class: "callback-path-url",
              method: e.callback.method,
              "selected-server-url": e.callback.path,
              "server-url-list": [e.callback.path]
            }, null, 8, ["method", "selected-server-url", "server-url-list"]),
            e.callback.request ? (Re(), Bt(UO, Li({ key: 0 }, e.callback.request, { "title-prefix": "Callback" }), null, 16)) : Kt("", !0),
            Fn(t.$slots, "callback-response", {}, void 0, !0)
          ])
        ]),
        _: 3
      })
    ]));
  }
}), wte = /* @__PURE__ */ dn(_te, [["__scopeId", "data-v-2cf20e98"]]), Ste = ["data-testid", "disabled"], Cte = ["data-testid", "onClick"], Ate = ["data-testid", "onClick"], kte = /* @__PURE__ */ xr({
  __name: "TryItDropdown",
  props: {
    data: {
      type: Object,
      required: !0
    },
    isLoading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["tryit-api-call"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = [
      {
        label: "in Browser",
        value: "browser",
        key: "browser"
      },
      {
        label: "in Insomnia",
        value: "insomnia",
        key: "insomnia"
      }
    ], a = Qa("hide-insomnia-tryit", Sr(!1)), o = Qa("spec-url", Sr("")), c = Ye(() => !(a.value || !o.value)), u = Ye(() => n.isLoading ? qJ : c.value ? s.value === "browser" ? i2 : w_ : null), { selectedTryItMethodKey: s } = Di.useTryItState(), f = (l) => {
      (!l || !l.target.dataset.selectDropdownTrigger) && (s.value === "browser" ? r("tryit-api-call") : window.open(
        `https://insomnia.rest/run?uri=${encodeURIComponent(o.value)}`,
        "_blank"
      ));
    }, d = (l) => {
      s.value = l.key || "browser", f();
    };
    return (l, p) => (Re(), vt("div", {
      class: Bn(["tryit-wrapper", e.data.method])
    }, [
      Gt("button", {
        class: Bn(["call-button", { "no-dropdown": !c.value }]),
        "data-testid": `tryit-call-button-${e.data.id}`,
        disabled: e.isLoading,
        onClick: f
      }, [
        u.value ? (Re(), Bt(An(u.value), {
          key: 0,
          class: "tryit-method-icon"
        })) : Kt("", !0),
        p[0] || (p[0] = Rn(" Try It! "))
      ], 10, Ste),
      c.value ? (Re(), Bt(Ia, {
        key: 0,
        id: `tryit-dropdown-${e.data.id}`,
        class: "tryit-dropdown",
        "data-testid": `tryit-dropdown-${e.data.id}`,
        disabled: e.isLoading,
        items: i,
        placement: "bottom-end",
        "trigger-button": ""
      }, {
        "browser-item": _r(({ item: g }) => [
          Gt("button", {
            "data-testid": `tryit-send-request-${e.data.id}`,
            onClick: (v) => d(g)
          }, [
            Br(Nt(i2)),
            Rn(" " + pn(g.label), 1)
          ], 8, Cte)
        ]),
        "insomnia-item": _r(({ item: g }) => [
          Gt("button", {
            "data-testid": `tryit-insomnia-${e.data.id}`,
            onClick: (v) => d(g)
          }, [
            Br(Nt(w_)),
            Rn(" " + pn(g.label), 1)
          ], 8, Ate)
        ]),
        _: 1
      }, 8, ["id", "data-testid", "disabled"])) : Kt("", !0)
    ], 2));
  }
}), Ete = /* @__PURE__ */ dn(kte, [["__scopeId", "data-v-dcc79e9a"]]), Ote = "#232633", Tte = "#f9fafb", HO = "#6c7489", J_ = "#0044f4", Q_ = "20px", Pte = { class: "collapsable-panel" }, Rte = { class: "btn-container" }, jte = ["aria-expanded"], Ite = { class: "panel-body" }, qte = /* @__PURE__ */ xr({
  __name: "CollapsablePanel",
  props: {
    collapsible: {
      type: Boolean,
      default: !0
    },
    contentToCopy: {
      type: String,
      default: ""
    },
    startCollapsed: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, n = Sr(t.collapsible && t.startCollapsed), r = (i) => {
      t.collapsible && !i.target.dataset.selectDropdownTrigger && (n.value = !n.value);
    };
    return (i, a) => (Re(), vt("div", Pte, [
      Gt("div", {
        class: Bn(["panel-header", { collapsed: n.value, collapsible: e.collapsible }]),
        onClick: r
      }, [
        Fn(i.$slots, "header", {}, void 0, !0),
        Gt("div", Rte, [
          e.contentToCopy && !n.value ? (Re(), Bt(h1, {
            key: 0,
            content: e.contentToCopy
          }, null, 8, ["content"])) : Kt("", !0),
          e.collapsible ? (Re(), vt("button", {
            key: 1,
            "aria-expanded": !n.value,
            "aria-label": "Toggle content",
            class: "collapse-trigger-btn",
            type: "button"
          }, [
            n.value ? (Re(), Bt(Nt(u1), {
              key: 0,
              class: "chevron-icon"
            })) : (Re(), Bt(Nt(wO), {
              key: 1,
              class: "chevron-icon"
            }))
          ], 8, jte)) : Kt("", !0)
        ])
      ], 2),
      rs(Gt("div", Ite, [
        Fn(i.$slots, "default", {}, void 0, !0)
      ], 512), [
        [yf, !n.value]
      ])
    ]));
  }
}), m1 = /* @__PURE__ */ dn(qte, [["__scopeId", "data-v-6fd8039c"]]), Dte = /* @__PURE__ */ xr({
  __name: "InputLabel",
  props: {
    required: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("label", {
      class: Bn({ required: e.required })
    }, [
      Fn(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), g1 = /* @__PURE__ */ dn(Dte, [["__scopeId", "data-v-7de4374b"]]), Lte = /* @__PURE__ */ xr({
  __name: "TooltipPopover",
  props: {
    text: {
      type: String,
      default: "Tooltip content"
    },
    placement: {
      type: String,
      validator: (e) => G2.includes(e),
      default: "top-start"
    }
  },
  setup(e) {
    return (t, n) => (Re(), Bt(MO, {
      class: "tooltip-popover",
      "max-width": "300px",
      "open-on-mouseover": "",
      placement: e.placement,
      role: "tooltip"
    }, {
      content: _r(() => [
        Fn(t.$slots, "content", {}, () => [
          Rn(pn(e.text), 1)
        ], !0)
      ]),
      default: _r(() => [
        Fn(t.$slots, "default", {}, () => [
          Br(Nt(SO), {
            class: "tooltip-trigger-info-icon",
            color: `var(--kui-color-text-neutral, ${Nt(HO)})`,
            tabindex: "0"
          }, null, 8, ["color"])
        ], !0)
      ]),
      _: 3
    }, 8, ["placement"]));
  }
}), zO = /* @__PURE__ */ dn(Lte, [["__scopeId", "data-v-0d81e24a"]]), Nte = ["id", "onUpdate:modelValue", "aria-describedby"], $te = /* @__PURE__ */ xr({
  __name: "TryItAuth",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { activeSecurityScheme: t, tokenValueMap: n, authHeaderMap: r, authQueryMap: i } = Di.useAuthTokenState(), a = Qa("security-scheme-group-list", Ye(() => [])), o = Ye(() => a.value.map((d) => ({
      label: d.title,
      value: d.key,
      key: d.key
    }))), c = Ye(() => {
      var p;
      const d = {};
      return (((p = a.value.find((g) => g.key === t.value)) == null ? void 0 : p.schemeList) ?? []).forEach((g) => {
        d[g.key] = g;
      }), d;
    }), u = TO(() => {
      const d = [], l = {};
      for (const p in c.value) {
        const g = c.value[p];
        if (g) {
          const v = n.value[p] ?? "", b = g.name, y = g.in, w = g.scheme == "bearer";
          if (y === "query")
            l[b] = v;
          else {
            const C = w || !b ? "Authorization" : b;
            d.push({
              name: C,
              value: `${w ? "Bearer" : ""} ${v}`
            });
          }
        }
      }
      r.value[t.value] = d, i.value[t.value] = new URLSearchParams(l).toString();
    }, 500), s = (d, l) => d.name || d.bearerFormat || l || "Access Token", f = Ye(() => {
      let d = "";
      for (const l in c.value)
        n.value[l] && (d += n.value[l]);
      return d;
    });
    return In(f, () => {
      u();
    }, { immediate: !0 }), (d, l) => {
      var p;
      return (p = Nt(a)) != null && p.length && e.data.path ? (Re(), Bt(m1, {
        key: 0,
        "data-testid": `tryit-auth-${e.data.id}`
      }, {
        header: _r(() => [
          Br(Nt(CO), {
            color: Nt(HO),
            size: 20
          }, null, 8, ["color"]),
          l[1] || (l[1] = Gt("h3", null, " Authentication ", -1)),
          o.value.length > 1 ? (Re(), Bt(Ia, {
            key: 0,
            id: `tryit-scheme-selector-${e.data.id}`,
            modelValue: Nt(t),
            "onUpdate:modelValue": l[0] || (l[0] = (g) => bf(t) ? t.value = g : null),
            class: "scheme-selector",
            items: o.value,
            placement: "bottom-end",
            onChange: Nt(u)
          }, null, 8, ["id", "modelValue", "items", "onChange"])) : Kt("", !0)
        ]),
        default: _r(() => [
          (Re(!0), vt(Wn, null, hi(c.value, (g, v) => (Re(), vt("div", {
            key: g.id,
            class: "wide"
          }, [
            Br(g1, {
              for: `auth-token-input-${s(g)}-${e.data.id}`
            }, {
              default: _r(() => [
                Rn(pn(s(g)) + " ", 1),
                g.description ? (Re(), Bt(zO, {
                  key: 0,
                  id: `auth-token-tooltip-${s(g)}-${e.data.id}`,
                  text: g.description
                }, null, 8, ["id", "text"])) : Kt("", !0)
              ]),
              _: 2
            }, 1032, ["for"]),
            rs(Gt("input", {
              id: `auth-token-input-${s(g)}-${e.data.id}`,
              "onUpdate:modelValue": (b) => Nt(n)[v] = b,
              "aria-describedby": `auth-token-tooltip-${s(g)}-${e.data.id}`,
              autocomplete: "off",
              placeholder: "App credential",
              type: "text"
            }, null, 8, Nte), [
              [p2, Nt(n)[v]]
            ])
          ]))), 128))
        ]),
        _: 1
      }, 8, ["data-testid"])) : Kt("", !0);
    };
  }
}), Mte = /* @__PURE__ */ dn($te, [["__scopeId", "data-v-3067eca9"]]), Fte = /* @__PURE__ */ xr({
  __name: "CodeBlock",
  props: {
    code: {
      type: String,
      required: !0
    },
    lang: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, { highlighter: n } = Di.useShiki(), r = (o) => {
      var c;
      return (c = Xu.find((u) => u.httpSnippetLanguage === o)) == null ? void 0 : c.highlightLanguage;
    }, i = Ye(() => {
      if (n.value && t.lang) {
        const o = r(t.lang);
        return n.value.codeToHtml(t.code, {
          lang: o,
          themes: {
            light: "catppuccin-latte",
            dark: "catppuccin-mocha"
          },
          colorReplacements: {
            "catppuccin-latte": {
              // Always use the neutral weakest token, fallback to **light** background
              "#eff1f5": `var(--kui-color-background-neutral-weakest, ${Tte})`
            },
            "catppuccin-mocha": {
              // Always use the neutral weakest token, fallback to **dark** background
              "#1e1e2e": `var(--kui-color-background-neutral-weakest, ${Ote})`
            }
          }
        });
      }
      return "";
    }), a = () => dC("div", { class: "code-block", innerHTML: i.value });
    return (o, c) => (Re(), vt("div", null, [
      Br(a)
    ]));
  }
}), Nf = /* @__PURE__ */ dn(Fte, [["__scopeId", "data-v-59d7a9fe"]]), Bte = /* @__PURE__ */ xr({
  __name: "EditableCodeBlock",
  props: {
    code: {
      type: String,
      required: !0
    },
    lang: {
      type: String,
      default: ""
    }
  },
  emits: ["request-body-changed"],
  setup(e, { emit: t }) {
    const n = e, r = t, i = Sr(!1), a = (g, v) => {
      let b = g;
      if (i.value = !1, v === "json")
        try {
          b = JSON.stringify(JSON.parse(g), null, ns);
        } catch {
          i.value = !0;
        }
      return b;
    }, o = Sr(), c = Sr(a(n.code, n.lang)), u = Sr(n.code), s = Sr(0), f = (g, v) => {
      var T, E, D;
      if (typeof window > "u" || !o.value || !o.value.childNodes[0])
        return;
      const b = window.getSelection(), y = document.createRange();
      let w = 0, C = g;
      for (let $ = 0; $ < o.value.childNodes.length; $++) {
        const Z = (((T = o.value.childNodes[$]) == null ? void 0 : T.textContent) || "").length;
        if (C - Z <= 0)
          break;
        w++, C -= Z, ((E = o.value.childNodes[$]) == null ? void 0 : E.nodeName) === "BR" && C--;
      }
      o.value.childNodes[w] && (C = ((D = o.value.childNodes[w].textContent) == null ? void 0 : D.length) || 0, y.setStart(o.value.childNodes[w], C), y.collapse(!0), b == null || b.removeAllRanges(), b == null || b.addRange(y), o.value.focus());
    }, d = () => {
      if (typeof window > "u" || !o.value)
        return 0;
      const g = window.getSelection();
      if (!g)
        return 0;
      const v = o.value.innerText.split(""), b = g.rangeCount > 0 ? g == null ? void 0 : g.getRangeAt(0) : null;
      if (b) {
        const y = b == null ? void 0 : b.cloneRange();
        y == null || y.selectNodeContents(o.value), y == null || y.setEnd(b.endContainer, b == null ? void 0 : b.endOffset);
        let w = y.toString();
        const C = w.split("");
        let T = w.length, E = 0;
        for (let D = 0; D < C.length; D++)
          C[D] !== `
` && v[E] === `
` && (E++, T++), E++;
        return g.anchorOffset === 0 && v[E] === `
` && T++, T;
      }
      return 0;
    }, l = (g) => {
      let v = g.target.innerText;
      if (g.inputType === "insertParagraph") {
        if (s.value = d(), s.value > 1 && u.value) {
          const y = u.value.split(`
`);
          let w = "", C = 0, T = 0;
          do
            C += y[T].length + 1, C >= s.value && (w = y[T]), T++;
          while (w === "" && T <= y.length - 1);
          if (w) {
            let E = w.replace(/[^\s].*/, "").length;
            (w.endsWith("{") || w.endsWith("[")) && (E += ns), E > 0 && (v = v.substring(0, s.value) + Array(E + 1).join(" ") + v.substring(s.value), o.value && (o.value.innerText = v), u.value = v, f(s.value));
          }
        }
        u.value = v;
        return;
      }
      if (g.inputType === "deleteContentBackward") {
        u.value = v;
        return;
      }
      i.value = !1;
      let b = a(v, n.lang);
      u.value = b, s.value = d(), r("request-body-changed", b);
    }, p = (g) => {
      i.value = !1;
      const v = g.target.innerText;
      let b = a(v, n.lang);
      c.value = b, o.value && (o.value.innerText = c.value), u.value = b, r("request-body-changed", b);
    };
    return In(
      () => ({ code: n.code, lang: n.lang, editableInput: o.value }),
      ({ code: g, lang: v, editableInput: b }) => {
        g !== (b == null ? void 0 : b.innerText) && (c.value = a(g, v), u.value = c.value, b && (b.innerText = c.value, s.value !== 0 && f(s.value)));
      }
    ), (g, v) => (Re(), vt("div", {
      class: Bn(["editable-code-wrapper", { "error-wrapper": i.value }])
    }, [
      Br(Nf, {
        code: u.value || "",
        lang: e.lang
      }, null, 8, ["code", "lang"]),
      v[0] || (Ly(-1, !0), (v[0] = Gt("div", {
        ref_key: "editableInput",
        ref: o,
        class: "editable-code",
        contenteditable: "true",
        spellcheck: "false",
        onFocusout: p,
        onInput: l
      }, [
        Rn(pn(c.value), 1)
      ], 544)).cacheIndex = 0, Ly(1), v[0])
    ], 2));
  }
}), Ute = /* @__PURE__ */ dn(Bte, [["__scopeId", "data-v-90e4ab56"]]), Hte = { class: "switch-control-wrapper" }, zte = /* @__PURE__ */ xr({
  inheritAttrs: !1,
  __name: "ToggleSwitch",
  props: /* @__PURE__ */ Xa({
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xa(["change", "input"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = t, i = j0(), a = Ye(() => {
      const l = { ...i };
      return delete l.id, l;
    }), o = Ye(() => ({
      disabled: n.disabled,
      checked: u.value,
      ...!!i.id && { id: String(i.id) }
    })), c = Ye(() => ({
      "aria-checked": u.value,
      tabindex: n.disabled ? -1 : 0,
      ...!!i.id && { "aria-labelledby": String(i.id) }
    })), u = bc(e, "modelValue"), s = Sr(null), f = (l) => {
      var p;
      n.disabled || (l.type === "click" || l.type === "keyup" && l.code === "Space") && ((p = s.value) == null || p.click());
    }, d = (l) => {
      u.value !== l.target.checked && (u.value = l.target.checked, r("change", l.target.checked), r("input", l.target.checked));
    };
    return (l, p) => (Re(), vt("div", Li({
      class: ["toggle-switch", { disabled: e.disabled }]
    }, a.value), [
      Gt("input", Li({
        ref_key: "switchInputRef",
        ref: s,
        hidden: "",
        tabindex: "-1",
        type: "checkbox"
      }, o.value, { onInput: d }), null, 16),
      Gt("div", Hte, [
        Gt("span", Li({
          class: ["switch-control", { checked: u.value, disabled: e.disabled }],
          "data-testid": "switch-control",
          role: "checkbox"
        }, c.value, {
          onClick: f,
          onKeydown: p[0] || (p[0] = Ny($f(() => {
          }, ["prevent"]), ["space"])),
          onKeyup: Ny(f, ["space"])
        }), p[1] || (p[1] = [
          Gt("span", { class: "switch-control-enabled-bar" }, null, -1)
        ]), 16)
      ]),
      e.label || l.$slots.label ? (Re(), Bt(g1, I0(Li({ key: 0 }, Nt(i).id ? { for: String(Nt(i).id) } : {})), {
        default: _r(() => [
          Rn(pn(e.label), 1)
        ]),
        _: 1
      }, 16)) : Kt("", !0)
    ], 16));
  }
}), Gte = /* @__PURE__ */ dn(zte, [["__scopeId", "data-v-235d465f"]]), Vte = {
  key: 0,
  class: "wide required-only-wrapper"
}, Wte = /* @__PURE__ */ xr({
  __name: "RequiredToggle",
  props: /* @__PURE__ */ Xa({
    data: {
      type: Object,
      required: !0
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = bc(e, "modelValue"), r = Ye(() => {
      var a, o, c, u, s, f;
      if (!((c = (o = (a = t.data.request) == null ? void 0 : a.body) == null ? void 0 : o.contents) != null && c.length) || !t.data.request.body.contents[0] || (f = (s = (u = t.data) == null ? void 0 : u.request) == null ? void 0 : s.body) != null && f.contents && t.data.request.body.contents.length && Array.isArray(t.data.request.body.contents[0].examples) && t.data.request.body.contents[0].examples.length)
        return !1;
      const i = (d, l, p) => {
        if (p > xE || !d || Object.keys(d).length < 1)
          return !1;
        if (d.required && d.required.length > 0)
          return !0;
        let g = !1;
        return Object.keys(d.properties || {}).forEach((v) => {
          const b = d.properties[v];
          b.anyOf && Array.isArray(b.anyOf) && b.anyOf.length ? g = i(b.anyOf[0] || {}, v, p) : b.type === "object" || b.allOf ? g = i(b || {}, v, ++p) : g = i(d.properties[v], v, p);
        }), g;
      };
      return i(t.data.request.body.contents[0].schema, "", 0);
    });
    return In(r, (i) => {
      i === !1 && (n.value = !1);
    }, { immediate: !0 }), (i, a) => r.value ? (Re(), vt("div", Vte, [
      Br(g1, {
        for: `required-toggle-switch-${e.data.id}`
      }, {
        default: _r(() => a[1] || (a[1] = [
          Rn(" Show only required parameters ")
        ])),
        _: 1
      }, 8, ["for"]),
      Br(Gte, {
        id: `required-toggle-switch-${e.data.id}`,
        modelValue: n.value,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => n.value = o)
      }, null, 8, ["id", "modelValue"])
    ])) : Kt("", !0);
  }
}), GO = /* @__PURE__ */ dn(Wte, [["__scopeId", "data-v-a8313dc3"]]), Kte = {
  key: 0,
  class: "wide"
}, Zte = ["id", "onUpdate:modelValue", "aria-describedby", "data-testid"], Yte = {
  key: 1,
  class: "wide body-param"
}, Jte = /* @__PURE__ */ xr({
  __name: "TryItParams",
  props: /* @__PURE__ */ Xa({
    data: {
      type: Object,
      required: !0
    },
    paramType: {
      type: String,
      required: !0
    },
    /* coming as a property when request sample is picked in RequestSample */
    requestBody: {
      type: String,
      default: ""
    },
    /** list of headers to exclude from TryIt */
    excludeHeaderList: {
      type: Array,
      default: () => []
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xa(["request-path-changed", "request-query-changed", "request-headers-changed", "request-body-changed"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = bc(e, "modelValue"), i = t, a = {
      path: "Path Parameters",
      query: "Query Parameters",
      body: "Body",
      headers: "Headers"
    }, o = Ye(() => {
      var f, d, l, p, g, v;
      return n.paramType === "query" ? (d = (f = n.data.request) == null ? void 0 : f.query) == null ? void 0 : d.reduce((b, y) => (b[y.name] = y, b), {}) : n.paramType === "path" ? (p = (l = n.data.request) == null ? void 0 : l.path) == null ? void 0 : p.reduce((b, y) => (b[y.name] = y, b), {}) : n.paramType === "headers" ? (v = (g = n.data.request) == null ? void 0 : g.headers) == null ? void 0 : v.reduce((b, y) => (n.excludeHeaderList.includes(y.name) || (b[y.name] = y), b), {}) : n.requestBody ? { body: { example: n.requestBody } } : {};
    }), c = Sr({}), u = Ye(() => n.paramType !== "body" ? "" : c.value.body);
    In(o, (f) => {
      if (f) {
        const d = ag(f);
        Object.keys(f).forEach((l) => {
          c.value[l] = d[l];
        });
      }
    }, { immediate: !0 });
    const s = (f) => {
      f && i("request-body-changed", f);
    };
    return In(c, (f) => {
      if (n.paramType === "path") {
        i("request-path-changed", og(n.data, f));
        return;
      }
      if (n.paramType === "query" && i("request-query-changed", sg(n.data, f)), n.paramType === "headers") {
        const d = Object.keys(f).map((l) => ({
          name: l,
          value: f[l]
        })).filter(({ value: l }) => !!l);
        i("request-headers-changed", d);
      }
    }, { deep: !0 }), (f, d) => rs((Re(), Bt(m1, {
      class: "try-it-params",
      "content-to-copy": u.value,
      "data-testid": `tryit-params-${e.paramType}-${e.data.id}`,
      "start-collapsed": e.paramType !== "body"
    }, {
      header: _r(() => [
        Gt("h3", null, pn(a[n.paramType]), 1)
      ]),
      default: _r(() => [
        e.paramType !== "body" && o.value && Object.keys(o.value).length ? (Re(), vt("div", Kte, [
          (Re(!0), vt(Wn, null, hi(Object.keys(o.value), (l) => (Re(), vt("div", {
            key: `${o.value[l].name}${e.paramType}`
          }, [
            Br(g1, {
              class: "param-label",
              for: `request-${e.paramType}-input-${o.value[l].name || l}-${e.data.id}`
            }, {
              default: _r(() => [
                Rn(pn(o.value[l].name || l) + " ", 1),
                o.value[l].description ? (Re(), Bt(zO, {
                  key: 0,
                  id: `request-${e.paramType}-tooltip-${o.value[l].name || l}-${e.data.id}`
                }, {
                  content: _r(() => [
                    Br(os, {
                      markdown: o.value[l].description
                    }, null, 8, ["markdown"])
                  ]),
                  _: 2
                }, 1032, ["id"])) : Kt("", !0)
              ]),
              _: 2
            }, 1032, ["for"]),
            rs(Gt("input", {
              id: `request-${e.paramType}-input-${o.value[l].name || l}-${e.data.id}`,
              "onUpdate:modelValue": (p) => c.value[l] = p,
              "aria-describedby": `request-${e.paramType}-tooltip-${o.value[l].name || l}-${e.data.id}`,
              autocomplete: "off",
              "data-testid": `tryit-${e.paramType}-param-${l}-${e.data.id}`,
              type: "text"
            }, null, 8, Zte), [
              [p2, c.value[l]]
            ])
          ]))), 128))
        ])) : Kt("", !0),
        e.paramType === "body" && o.value && Object.keys(o.value).length ? (Re(), vt("div", Yte, [
          Br(GO, {
            modelValue: r.value,
            "onUpdate:modelValue": d[0] || (d[0] = (l) => r.value = l),
            class: "required-fields-toggle",
            data: e.data
          }, null, 8, ["modelValue", "data"]),
          Br(Ute, {
            class: "body-param-code-block",
            code: c.value.body,
            lang: "json",
            onRequestBodyChanged: s
          }, null, 8, ["code"])
        ])) : Kt("", !0)
      ]),
      _: 1
    }, 8, ["content-to-copy", "data-testid", "start-collapsed"])), [
      [yf, o.value && Object.keys(o.value).length]
    ]);
  }
}), Dd = /* @__PURE__ */ dn(Jte, [["__scopeId", "data-v-3e4b856f"]]), Qte = { class: "h-wrapper" }, Xte = { key: 0 }, ere = {
  key: 0,
  class: "wide"
}, tre = {
  key: 1,
  class: "wide"
}, rre = { class: "error-panel" }, nre = {
  key: 0,
  class: "cors-error"
}, ire = {
  key: 2,
  class: "wide"
}, are = /* @__PURE__ */ xr({
  __name: "TryItResponse",
  props: {
    dataId: {
      type: String,
      required: !0
    },
    response: {
      type: Object,
      default: () => {
      }
    },
    responseError: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      var f;
      return ((f = t.responseError) == null ? void 0 : f.message) || "";
    }), r = Ye(() => {
      const f = {};
      if (t.response)
        for (const d of t.response.headers.entries())
          f[d[0]] = d[1];
      return Object.keys(f).length ? JSON.stringify(f, null, ns) : "";
    }), i = Sr(""), a = Ye(() => {
      const f = [];
      return i.value && f.push({ value: "body", label: "Result" }), r.value && f.push({ value: "headers", label: "Headers" }), n.value && f.push({ value: "error", label: "Error" }), f;
    }), o = Ye(() => {
      var f;
      return ((f = t.response.headers.get("content-type")) == null ? void 0 : f.includes("image")) ?? !1;
    }), c = Ye(() => o.value ? {
      component: "img",
      props: {
        src: i.value,
        alt: "response image",
        width: "300px"
      }
    } : {
      component: Nf,
      props: {
        code: i.value,
        lang: s.value,
        class: "response-body"
      }
    }), u = Sr();
    In(a, (f) => {
      f.length && (u.value = f[0].value);
    }, { immediate: !0 });
    const s = Sr("");
    return In(() => t.response, async (f) => {
      var d;
      if (f)
        if ((d = f.headers.get("content-type")) != null && d.includes("/json"))
          i.value = JSON.stringify(await f.json(), null, ns), s.value = "json";
        else if (o.value) {
          const l = await f.blob();
          i.value = URL.createObjectURL(l);
        } else
          i.value = await f.text(), s.value = "text";
      else
        i.value = "", s.value = "";
    }, { immediate: !0 }), (f, d) => (Re(), Bt(m1, {
      collapsible: !1,
      "data-testid": `tryit-response-${e.dataId}`
    }, {
      header: _r(() => {
        var l, p, g, v;
        return [
          Gt("div", Qte, [
            Gt("h3", null, [
              (l = e.response) != null && l.status ? Kt("", !0) : (Re(), vt("span", Xte, " Response ")),
              (p = e.response) != null && p.status ? (Re(), vt("span", {
                key: 1,
                class: Bn(`response-status ${(g = e.response) == null ? void 0 : g.ok}`)
              }, pn((v = e.response) == null ? void 0 : v.status), 3)) : Kt("", !0)
            ])
          ]),
          Br(Ia, {
            id: `response-option-select-${e.dataId}`,
            modelValue: u.value,
            "onUpdate:modelValue": d[0] || (d[0] = (b) => u.value = b),
            class: "res-option-selector",
            items: a.value,
            placement: "bottom-end"
          }, null, 8, ["id", "modelValue", "items"])
        ];
      }),
      default: _r(() => [
        i.value && u.value === "body" ? (Re(), vt("div", ere, [
          (Re(), Bt(An(c.value.component), I0(UD(c.value.props)), null, 16))
        ])) : Kt("", !0),
        n.value && u.value === "error" ? (Re(), vt("div", tre, [
          Gt("div", rre, [
            Rn(pn(n.value) + " ", 1),
            e.response ? Kt("", !0) : (Re(), vt("div", nre, " Make sure CORS is enabled for the server. "))
          ])
        ])) : Kt("", !0),
        r.value && u.value === "headers" ? (Re(), vt("div", ire, [
          Br(Nf, {
            code: r.value,
            lang: "json"
          }, null, 8, ["code"])
        ])) : Kt("", !0)
      ]),
      _: 1
    }, 8, ["data-testid"]));
  }
}), ore = /* @__PURE__ */ dn(are, [["__scopeId", "data-v-079bb407"]]), sre = ["data-testid"], ure = { class: "method-path" }, cre = { class: "path" }, lre = {
  key: 0,
  class: "tryit-body"
}, fre = /* @__PURE__ */ xr({
  __name: "TryIt",
  props: /* @__PURE__ */ Xa({
    data: {
      type: Object,
      required: !0
    },
    serverUrl: {
      type: String,
      required: !0
    },
    requestBody: {
      type: String,
      default: ""
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xa(["request-path-changed", "request-query-changed", "request-headers-changed", "request-body-changed"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, r = bc(e, "modelValue"), i = t, { activeSecurityScheme: a, authHeaderMap: o, authQueryMap: c } = Di.useAuthTokenState(), u = Ye(() => o.value[a.value] ?? []), s = Ye(() => c.value[a.value] ?? ""), f = Sr(), d = Sr(), l = Sr(n.serverUrl), p = Sr(""), g = Sr(""), v = Sr([]), b = Sr(""), y = Sr(!1), w = Ye(
      () => {
        var ee, K, re, de, ie, me;
        return (!n.data.servers || !n.data.servers.some(($e) => $e.variables)) && (!((ee = n.data.request) != null && ee.query) || !((K = n.data.request) != null && K.query.length)) && (!((re = n.data.request) != null && re.path) || !((de = n.data.request) != null && de.path.length)) && (!((ie = n.data.request) != null && ie.headers) || !((me = n.data.request) != null && me.headers.length)) && !b.value && !f.value && !d.value;
      }
    ), C = (ee) => {
      p.value = ee, i("request-path-changed", ee);
    }, T = (ee) => {
      g.value = ee, i("request-query-changed", ee);
    }, E = (ee) => {
      v.value = ee, i("request-headers-changed", ee);
    }, D = (ee) => {
      b.value = ee, i("request-body-changed", ee);
    }, $ = Qa("hide-tryit", Sr(!1)), Z = async () => {
      try {
        y.value = !0, f.value = void 0;
        const ee = new URL(`${l.value}${p.value}`.replaceAll("{", "").replaceAll("}", ""));
        let K = g.value;
        s.value && (K += (g.value ? "&" : "?") + s.value), ee.search = K, f.value = await fetch(ee, {
          method: n.data.method,
          headers: [
            ...(u == null ? void 0 : u.value) || [],
            ...DE(n.data),
            ...v.value
          ].reduce(
            (re, de) => (re[de.name] = de.value, re),
            {}
          ),
          ...b.value ? { body: b.value } : null
        });
      } catch (ee) {
        d.value = ee;
      } finally {
        y.value = !1;
      }
    }, te = Ye(() => !$.value && Array.isArray(n.data.servers) && !!n.data.servers.length), se = Ye(() => {
      var ee;
      return ((ee = u.value) == null ? void 0 : ee.map(({ name: K }) => K)) ?? [];
    });
    return In(() => n.serverUrl, () => {
      l.value = n.serverUrl;
    }), In(() => n.requestBody, (ee) => {
      b.value = ee;
    }, { immediate: !0 }), In(() => n.data.id, () => {
      p.value = og(n.data), g.value = sg(n.data), v.value = [], f.value = void 0, d.value = void 0;
    }, { immediate: !0 }), (ee, K) => te.value ? (Re(), vt("div", {
      key: 0,
      class: "tryit-wrapper",
      "data-testid": `tryit-wrapper-${e.data.id}`
    }, [
      Gt("div", {
        class: Bn(["tryit-header", { "no-body": w.value }])
      }, [
        Gt("div", ure, [
          Br(s1, {
            method: e.data.method,
            size: "small"
          }, null, 8, ["method"]),
          Gt("span", cre, pn(e.data.path), 1)
        ]),
        e.data.path ? (Re(), Bt(Ete, {
          key: 0,
          class: "tryit-button-dropdown",
          data: e.data,
          "is-loading": y.value,
          onTryitApiCall: Z
        }, null, 8, ["data", "is-loading"])) : Kt("", !0)
      ], 2),
      w.value ? Kt("", !0) : (Re(), vt("div", lre, [
        Br(Mte, { data: e.data }, null, 8, ["data"]),
        Br(Dd, {
          data: e.data,
          "param-type": "path",
          onRequestPathChanged: C
        }, null, 8, ["data"]),
        Br(Dd, {
          data: e.data,
          "param-type": "query",
          onRequestQueryChanged: T
        }, null, 8, ["data"]),
        Br(Dd, {
          data: e.data,
          "exclude-header-list": se.value,
          "param-type": "headers",
          onRequestHeadersChanged: E
        }, null, 8, ["data", "exclude-header-list"]),
        Br(Dd, {
          modelValue: r.value,
          "onUpdate:modelValue": K[0] || (K[0] = (re) => r.value = re),
          data: e.data,
          "param-type": "body",
          "request-body": b.value,
          onRequestBodyChanged: D
        }, null, 8, ["modelValue", "data", "request-body"]),
        f.value || d.value ? (Re(), Bt(ore, {
          key: 0,
          "data-id": e.data.id,
          response: f.value,
          "response-error": d.value
        }, null, 8, ["data-id", "response", "response-error"])) : Kt("", !0)
      ]))
    ], 8, sre)) : Kt("", !0);
  }
}), pre = /* @__PURE__ */ dn(fre, [["__scopeId", "data-v-5962e069"]]);
var Sl = {}, No = {}, X_;
function Tn() {
  if (X_) return No;
  X_ = 1;
  var e = No && No.__read || function(a, o) {
    var c = typeof Symbol == "function" && a[Symbol.iterator];
    if (!c) return a;
    var u = c.call(a), s, f = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(s = u.next()).done; ) f.push(s.value);
    } catch (l) {
      d = { error: l };
    } finally {
      try {
        s && !s.done && (c = u.return) && c.call(u);
      } finally {
        if (d) throw d.error;
      }
    }
    return f;
  }, t = No && No.__spreadArray || function(a, o, c) {
    if (c || arguments.length === 2) for (var u = 0, s = o.length, f; u < s; u++)
      (f || !(u in o)) && (f || (f = Array.prototype.slice.call(o, 0, u)), f[u] = o[u]);
    return a.concat(f || Array.prototype.slice.call(o));
  };
  No.__esModule = !0, No.CodeBuilder = void 0;
  var n = "", r = `
`, i = (
    /** @class */
    /* @__PURE__ */ function() {
      function a(o) {
        var c = o === void 0 ? {} : o, u = c.indent, s = c.join, f = this;
        this.postProcessors = [], this.code = [], this.indentationCharacter = n, this.lineJoin = r, this.indentLine = function(d, l) {
          l === void 0 && (l = 0);
          var p = f.indentationCharacter.repeat(l);
          return "".concat(p).concat(d);
        }, this.unshift = function(d, l) {
          var p = f.indentLine(d, l);
          f.code.unshift(p);
        }, this.push = function(d, l) {
          var p = f.indentLine(d, l);
          f.code.push(p);
        }, this.pushToLast = function(d) {
          f.code || f.push(d);
          var l = "".concat(f.code[f.code.length - 1]).concat(d);
          f.code[f.code.length - 1] = l;
        }, this.blank = function() {
          f.code.push("");
        }, this.join = function() {
          var d = f.code.join(f.lineJoin), l = f.postProcessors.reduce(function(p, g) {
            return g(p);
          }, d);
          return l;
        }, this.addPostProcessor = function(d) {
          f.postProcessors = t(t([], e(f.postProcessors), !1), [d], !1);
        }, this.indentationCharacter = u || n, this.lineJoin = s ?? r;
      }
      return a;
    }()
  );
  return No.CodeBuilder = i, No;
}
var la = {}, ew;
function ri() {
  if (ew) return la;
  ew = 1;
  var e = la && la.__read || function(a, o) {
    var c = typeof Symbol == "function" && a[Symbol.iterator];
    if (!c) return a;
    var u = c.call(a), s, f = [], d;
    try {
      for (; (o === void 0 || o-- > 0) && !(s = u.next()).done; ) f.push(s.value);
    } catch (l) {
      d = { error: l };
    } finally {
      try {
        s && !s.done && (c = u.return) && c.call(u);
      } finally {
        if (d) throw d.error;
      }
    }
    return f;
  }, t = la && la.__spreadArray || function(a, o, c) {
    if (c || arguments.length === 2) for (var u = 0, s = o.length, f; u < s; u++)
      (f || !(u in o)) && (f || (f = Array.prototype.slice.call(o, 0, u)), f[u] = o[u]);
    return a.concat(f || Array.prototype.slice.call(o));
  };
  la.__esModule = !0, la.escapeForDoubleQuotes = la.escapeForSingleQuotes = la.escapeString = void 0;
  function n(a, o) {
    o === void 0 && (o = {});
    var c = o.delimiter, u = c === void 0 ? '"' : c, s = o.escapeChar, f = s === void 0 ? "\\" : s, d = o.escapeNewlines, l = d === void 0 ? !0 : d, p = a.toString();
    return t([], e(p), !1).map(function(g) {
      return g === "\b" ? "".concat(f, "b") : g === "	" ? "".concat(f, "t") : g === `
` ? l ? "".concat(f, "n") : g : g === "\f" ? "".concat(f, "f") : g === "\r" ? l ? "".concat(f, "r") : g : g === f ? f + f : g === u ? f + u : g < " " || g > "~" ? JSON.stringify(g).slice(1, -1) : g;
    }).join("");
  }
  la.escapeString = n;
  var r = function(a) {
    return n(a, { delimiter: "'" });
  };
  la.escapeForSingleQuotes = r;
  var i = function(a) {
    return n(a, { delimiter: '"' });
  };
  return la.escapeForDoubleQuotes = i, la;
}
var N3 = {}, tw;
function Wi() {
  return tw || (tw = 1, function(e) {
    e.__esModule = !0, e.isMimeTypeJSON = e.hasHeader = e.getHeader = e.getHeaderName = void 0;
    var t = function(o, c) {
      return Object.keys(o).find(function(u) {
        return u.toLowerCase() === c.toLowerCase();
      });
    };
    e.getHeaderName = t;
    var n = function(o, c) {
      var u = (0, e.getHeaderName)(o, c);
      if (u)
        return o[u];
    };
    e.getHeader = n;
    var r = function(o, c) {
      return !!(0, e.getHeaderName)(o, c);
    };
    e.hasHeader = r;
    var i = [
      "application/json",
      "application/x-json",
      "text/json",
      "text/x-json",
      "+json"
    ], a = function(o) {
      return i.some(function(c) {
        return o.includes(c);
      });
    };
    e.isMimeTypeJSON = a;
  }(N3)), N3;
}
var $o = {}, $3 = {}, Cl = {}, Al = {}, rw;
function dre() {
  if (rw) return Al;
  rw = 1, Al.__esModule = !0, Al.libcurl = void 0;
  var e = Tn(), t = ri();
  return Al.libcurl = {
    info: {
      key: "libcurl",
      title: "Libcurl",
      link: "http://curl.haxx.se/libcurl",
      description: "Simple REST and HTTP API Client for C"
    },
    convert: function(n) {
      var r = n.method, i = n.fullUrl, a = n.headersObj, o = n.allHeaders, c = n.postData, u = new e.CodeBuilder(), s = u.push, f = u.blank, d = u.join;
      s("CURL *hnd = curl_easy_init();"), f(), s('curl_easy_setopt(hnd, CURLOPT_CUSTOMREQUEST, "'.concat(r.toUpperCase(), '");')), s('curl_easy_setopt(hnd, CURLOPT_URL, "'.concat(i, '");'));
      var l = Object.keys(a);
      return l.length && (f(), s("struct curl_slist *headers = NULL;"), l.forEach(function(p) {
        s('headers = curl_slist_append(headers, "'.concat(p, ": ").concat((0, t.escapeForDoubleQuotes)(a[p]), '");'));
      }), s("curl_easy_setopt(hnd, CURLOPT_HTTPHEADER, headers);")), o.cookie && (f(), s('curl_easy_setopt(hnd, CURLOPT_COOKIE, "'.concat(o.cookie, '");'))), c.text && (f(), s("curl_easy_setopt(hnd, CURLOPT_POSTFIELDS, ".concat(JSON.stringify(c.text), ");"))), f(), s("CURLcode ret = curl_easy_perform(hnd);"), d();
    }
  }, Al;
}
var nw;
function hre() {
  if (nw) return Cl;
  nw = 1, Cl.__esModule = !0, Cl.c = void 0;
  var e = dre();
  return Cl.c = {
    info: {
      key: "c",
      title: "C",
      extname: ".c",
      default: "libcurl"
    },
    clientsById: {
      libcurl: e.libcurl
    }
  }, Cl;
}
var kl = {}, El = {}, iw;
function mre() {
  if (iw) return El;
  iw = 1, El.__esModule = !0, El.clj_http = void 0;
  var e = Tn(), t = Wi(), n = (
    /** @class */
    /* @__PURE__ */ function() {
      function s(f) {
        var d = this;
        this.name = "", this.toString = function() {
          return ":".concat(d.name);
        }, this.name = f;
      }
      return s;
    }()
  ), r = (
    /** @class */
    /* @__PURE__ */ function() {
      function s(f) {
        var d = this;
        this.path = "", this.toString = function() {
          return '(clojure.java.io/file "'.concat(d.path, '")');
        }, this.path = f;
      }
      return s;
    }()
  ), i = function(s) {
    return s === void 0 ? null : s === null ? "null" : s.constructor.name.toLowerCase();
  }, a = function(s) {
    return i(s) === "object" ? Object.keys(s).length === 0 : !1;
  }, o = function(s) {
    return Object.keys(s).filter(function(f) {
      return a(s[f]);
    }).forEach(function(f) {
      delete s[f];
    }), s;
  }, c = function(s, f) {
    var d = " ".repeat(s);
    return f.replace(/\n/g, `
`.concat(d));
  }, u = function(s) {
    switch (i(s)) {
      case "string":
        return '"'.concat(s.replace(/"/g, '\\"'), '"');
      case "file":
        return s.toString();
      case "keyword":
        return s.toString();
      case "null":
        return "nil";
      case "regexp":
        return '#"'.concat(s.source, '"');
      case "object": {
        var f = Object.keys(s).reduce(function(l, p) {
          var g = c(p.length + 2, u(s[p]));
          return "".concat(l, ":").concat(p, " ").concat(g, `
 `);
        }, "").trim();
        return "{".concat(c(1, f), "}");
      }
      case "array": {
        var d = s.reduce(function(l, p) {
          return "".concat(l, " ").concat(u(p));
        }, "").trim();
        return "[".concat(c(1, d), "]");
      }
      default:
        return s.toString();
    }
  };
  return El.clj_http = {
    info: {
      key: "clj_http",
      title: "clj-http",
      link: "https://github.com/dakrone/clj-http",
      description: "An idiomatic clojure http client wrapping the apache client."
    },
    convert: function(s, f) {
      var d = s.queryObj, l = s.method, p = s.postData, g = s.url, v = s.allHeaders, b = new e.CodeBuilder({ indent: f == null ? void 0 : f.indent }), y = b.push, w = b.join, C = ["get", "post", "put", "delete", "patch", "head", "options"];
      if (l = l.toLowerCase(), !C.includes(l))
        return y("Method not supported"), w();
      var T = {
        headers: v,
        "query-params": d
      };
      switch (p.mimeType) {
        case "application/json":
          {
            T["content-type"] = new n("json"), T["form-params"] = p.jsonObj;
            var E = (0, t.getHeaderName)(T.headers, "content-type");
            E && delete T.headers[E];
          }
          break;
        case "application/x-www-form-urlencoded":
          {
            T["form-params"] = p.paramsObj;
            var E = (0, t.getHeaderName)(T.headers, "content-type");
            E && delete T.headers[E];
          }
          break;
        case "text/plain":
          {
            T.body = p.text;
            var E = (0, t.getHeaderName)(T.headers, "content-type");
            E && delete T.headers[E];
          }
          break;
        case "multipart/form-data": {
          if (p.params) {
            T.multipart = p.params.map(function(te) {
              return te.fileName && !te.value ? {
                name: te.name,
                content: new r(te.fileName)
              } : {
                name: te.name,
                content: te.value
              };
            });
            var E = (0, t.getHeaderName)(T.headers, "content-type");
            E && delete T.headers[E];
          }
          break;
        }
      }
      switch ((0, t.getHeader)(T.headers, "accept")) {
        case "application/json":
          {
            T.accept = new n("json");
            var E = (0, t.getHeaderName)(T.headers, "accept");
            E && delete T.headers[E];
          }
          break;
      }
      if (y(`(require '[clj-http.client :as client])
`), a(o(T)))
        y("(client/".concat(l, ' "').concat(g, '")'));
      else {
        var D = 11 + l.length + g.length, $ = c(D, u(o(T)));
        y("(client/".concat(l, ' "').concat(g, '" ').concat($, ")"));
      }
      return w();
    }
  }, El;
}
var aw;
function gre() {
  if (aw) return kl;
  aw = 1, kl.__esModule = !0, kl.clojure = void 0;
  var e = mre();
  return kl.clojure = {
    info: {
      key: "clojure",
      title: "Clojure",
      extname: ".clj",
      default: "clj_http"
    },
    clientsById: {
      clj_http: e.clj_http
    }
  }, kl;
}
var Ol = {}, Tl = {}, ow;
function vre() {
  if (ow) return Tl;
  ow = 1, Tl.__esModule = !0, Tl.native = void 0;
  var e = Tn(), t = ri();
  return Tl.native = {
    info: {
      key: "native",
      title: "http::client",
      link: "https://crystal-lang.org/api/master/HTTP/Client.html",
      description: "Crystal HTTP client"
    },
    convert: function(n, r) {
      var i = n.method, a = n.fullUrl, o = n.postData, c = n.allHeaders;
      r === void 0 && (r = {});
      var u = r.insecureSkipVerify, s = u === void 0 ? !1 : u, f = new e.CodeBuilder(), d = f.push, l = f.blank, p = f.join;
      d('require "http/client"'), l(), d('url = "'.concat(a, '"'));
      var g = Object.keys(c);
      g.length && (d("headers = HTTP::Headers{"), g.forEach(function(T) {
        d('  "'.concat(T, '" => "').concat((0, t.escapeForDoubleQuotes)(c[T]), '"'));
      }), d("}")), o.text && d("reqBody = ".concat(JSON.stringify(o.text))), l();
      var v = i.toUpperCase(), b = ["GET", "POST", "HEAD", "DELETE", "PATCH", "PUT", "OPTIONS"], y = g.length ? ", headers: headers" : "", w = o.text ? ", body: reqBody" : "", C = s ? ", tls: OpenSSL::SSL::Context::Client.insecure" : "";
      return b.includes(v) ? d("response = HTTP::Client.".concat(v.toLowerCase(), " url").concat(y).concat(w).concat(C)) : d('response = HTTP::Client.exec "'.concat(v, '", url').concat(y).concat(w).concat(C)), d("puts response.body"), p();
    }
  }, Tl;
}
var sw;
function yre() {
  if (sw) return Ol;
  sw = 1, Ol.__esModule = !0, Ol.crystal = void 0;
  var e = vre();
  return Ol.crystal = {
    info: {
      key: "crystal",
      title: "Crystal",
      extname: ".cr",
      default: "native"
    },
    clientsById: {
      native: e.native
    }
  }, Ol;
}
var Pl = {}, Zs = {}, uw;
function bre() {
  if (uw) return Zs;
  uw = 1;
  var e = Zs && Zs.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  };
  Zs.__esModule = !0, Zs.httpclient = void 0;
  var t = Tn(), n = ri(), r = Wi(), i = function(a) {
    var o = (0, r.getHeader)(a, "accept-encoding");
    if (!o)
      return [];
    var c = {
      gzip: "DecompressionMethods.GZip",
      deflate: "DecompressionMethods.Deflate"
    }, u = [];
    return typeof o == "string" && (o = [o]), o.forEach(function(s) {
      s.split(",").forEach(function(f) {
        var d = /\s*([^;\s]+)/.exec(f);
        if (d) {
          var l = c[d[1]];
          l && u.push(l);
        }
      });
    }), u;
  };
  return Zs.httpclient = {
    info: {
      key: "httpclient",
      title: "HttpClient",
      link: "https://docs.microsoft.com/en-us/dotnet/api/system.net.http.httpclient",
      description: ".NET Standard HTTP Client"
    },
    convert: function(a, o) {
      var c, u, s = a.allHeaders, f = a.postData, d = a.method, l = a.fullUrl, p = e({ indent: "    " }, o), g = new t.CodeBuilder({ indent: p.indent }), v = g.push, b = g.join;
      v("using System.Net.Http.Headers;");
      var y = "", w = !!s.cookie, C = i(s);
      (w || C.length) && (y = "clientHandler", v("var clientHandler = new HttpClientHandler"), v("{"), w && v("UseCookies = false,", 1), C.length && v("AutomaticDecompression = ".concat(C.join(" | "), ","), 1), v("};")), v("var client = new HttpClient(".concat(y, ");")), v("var request = new HttpRequestMessage"), v("{");
      var T = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS", "TRACE"];
      d = d.toUpperCase(), d && T.includes(d) ? d = "HttpMethod.".concat(d[0]).concat(d.substring(1).toLowerCase()) : d = 'new HttpMethod("'.concat(d, '")'), v("Method = ".concat(d, ","), 1), v('RequestUri = new Uri("'.concat(l, '"),'), 1);
      var E = Object.keys(s).filter(function($) {
        switch ($.toLowerCase()) {
          case "content-type":
          case "content-length":
          case "accept-encoding":
            return !1;
          default:
            return !0;
        }
      });
      if (E.length && (v("Headers =", 1), v("{", 1), E.forEach(function($) {
        v('{ "'.concat($, '", "').concat((0, n.escapeForDoubleQuotes)(s[$]), '" },'), 2);
      }), v("},", 1)), f.text) {
        var D = f.mimeType;
        switch (D) {
          case "application/x-www-form-urlencoded":
            v("Content = new FormUrlEncodedContent(new Dictionary<string, string>", 1), v("{", 1), (c = f.params) === null || c === void 0 || c.forEach(function($) {
              v('{ "'.concat($.name, '", "').concat($.value, '" },'), 2);
            }), v("}),", 1);
            break;
          case "multipart/form-data":
            v("Content = new MultipartFormDataContent", 1), v("{", 1), (u = f.params) === null || u === void 0 || u.forEach(function($) {
              v("new StringContent(".concat(JSON.stringify($.value || ""), ")"), 2), v("{", 2), v("Headers =", 3), v("{", 3), $.contentType && v('ContentType = new MediaTypeHeaderValue("'.concat($.contentType, '"),'), 4), v('ContentDisposition = new ContentDispositionHeaderValue("form-data")', 4), v("{", 4), v('Name = "'.concat($.name, '",'), 5), $.fileName && v('FileName = "'.concat($.fileName, '",'), 5), v("}", 4), v("}", 3), v("},", 2);
            }), v("},", 1);
            break;
          default:
            v("Content = new StringContent(".concat(JSON.stringify(f.text || ""), ")"), 1), v("{", 1), v("Headers =", 2), v("{", 2), v('ContentType = new MediaTypeHeaderValue("'.concat(D, '")'), 3), v("}", 2), v("}", 1);
            break;
        }
      }
      return v("};"), v("using (var response = await client.SendAsync(request))"), v("{"), v("response.EnsureSuccessStatusCode();", 1), v("var body = await response.Content.ReadAsStringAsync();", 1), v("Console.WriteLine(body);", 1), v("}"), b();
    }
  }, Zs;
}
var Rl = {}, cw;
function xre() {
  if (cw) return Rl;
  cw = 1, Rl.__esModule = !0, Rl.restsharp = void 0;
  var e = Tn(), t = ri(), n = Wi();
  return Rl.restsharp = {
    info: {
      key: "restsharp",
      title: "RestSharp",
      link: "http://restsharp.org/",
      description: "Simple REST and HTTP API Client for .NET"
    },
    convert: function(r) {
      var i = r.allHeaders, a = r.method, o = r.fullUrl, c = r.headersObj, u = r.cookies, s = r.postData, f = new e.CodeBuilder(), d = f.push, l = f.join, p = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS"].includes(a.toUpperCase());
      if (!p)
        return "Method not supported";
      function g(y) {
        return y.replace(/\w+/g, function(w) {
          return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
        });
      }
      if (d('var client = new RestClient("'.concat(o, '");')), d('var request = new RestRequest("", Method.'.concat(g(a), ");")), Object.keys(c).forEach(function(y) {
        d('request.AddHeader("'.concat(y, '", "').concat((0, t.escapeForDoubleQuotes)(c[y]), '");'));
      }), u.forEach(function(y) {
        var w = y.name, C = y.value;
        d('request.AddCookie("'.concat(w, '", "').concat(C, '");'));
      }), s.text) {
        var v = (0, n.getHeader)(i, "content-type"), b = JSON.stringify(s.text);
        d('request.AddParameter("'.concat(v, '", ').concat(b, ", ParameterType.RequestBody);"));
      }
      return d("var response = client.Execute(request);"), l();
    }
  }, Rl;
}
var lw;
function _re() {
  if (lw) return Pl;
  lw = 1, Pl.__esModule = !0, Pl.csharp = void 0;
  var e = bre(), t = xre();
  return Pl.csharp = {
    info: {
      key: "csharp",
      title: "C#",
      extname: ".cs",
      default: "restsharp"
    },
    clientsById: {
      httpclient: e.httpclient,
      restsharp: t.restsharp
    }
  }, Pl;
}
var jl = {}, Il = {}, fw;
function wre() {
  if (fw) return Il;
  fw = 1, Il.__esModule = !0, Il.native = void 0;
  var e = Tn(), t = ri();
  return Il.native = {
    info: {
      key: "native",
      title: "NewRequest",
      link: "http://golang.org/pkg/net/http/#NewRequest",
      description: "Golang HTTP client request"
    },
    convert: function(n, r) {
      var i = n.postData, a = n.method, o = n.allHeaders, c = n.fullUrl;
      r === void 0 && (r = {});
      var u = new e.CodeBuilder({ indent: "	" }), s = u.blank, f = u.push, d = u.join, l = r.showBoilerplate, p = l === void 0 ? !0 : l, g = r.checkErrors, v = g === void 0 ? !1 : g, b = r.printBody, y = b === void 0 ? !0 : b, w = r.timeout, C = w === void 0 ? -1 : w, T = r.insecureSkipVerify, E = T === void 0 ? !1 : T, D = v ? "err" : "_", $ = p ? 1 : 0, Z = function() {
        v && (f("if err != nil {", $), f("panic(err)", $ + 1), f("}", $));
      };
      p && (f("package main"), s(), f("import ("), f('"fmt"', $), C > 0 && f('"time"', $), E && f('"crypto/tls"', $), i.text && f('"strings"', $), f('"net/http"', $), y && f('"io"', $), f(")"), s(), f("func main() {"), s()), E && (f("insecureTransport := http.DefaultTransport.(*http.Transport).Clone()", $), f("insecureTransport.TLSClientConfig = &tls.Config{InsecureSkipVerify: true}", $));
      var te = C > 0, se = te || E, ee = se ? "client" : "http.DefaultClient";
      return se && (f("client := http.Client{", $), te && f("Timeout: time.Duration(".concat(C, " * time.Second),"), $ + 1), E && f("Transport: insecureTransport,", $ + 1), f("}", $), s()), f('url := "'.concat(c, '"'), $), s(), i.text ? (f("payload := strings.NewReader(".concat(JSON.stringify(i.text), ")"), $), s(), f("req, ".concat(D, ' := http.NewRequest("').concat(a, '", url, payload)'), $), s()) : (f("req, ".concat(D, ' := http.NewRequest("').concat(a, '", url, nil)'), $), s()), Z(), Object.keys(o).length && (Object.keys(o).forEach(function(K) {
        f('req.Header.Add("'.concat(K, '", "').concat((0, t.escapeForDoubleQuotes)(o[K]), '")'), $);
      }), s()), f("res, ".concat(D, " := ").concat(ee, ".Do(req)"), $), Z(), y && (s(), f("defer res.Body.Close()", $), f("body, ".concat(D, " := io.ReadAll(res.Body)"), $), Z()), s(), f("fmt.Println(res)", $), y && f("fmt.Println(string(body))", $), p && (s(), f("}")), d();
    }
  }, Il;
}
var pw;
function Sre() {
  if (pw) return jl;
  pw = 1, jl.__esModule = !0, jl.go = void 0;
  var e = wre();
  return jl.go = {
    info: {
      key: "go",
      title: "Go",
      extname: ".go",
      default: "native"
    },
    clientsById: {
      native: e.native
    }
  }, jl;
}
var ql = {}, Ys = {}, dw;
function Cre() {
  if (dw) return Ys;
  dw = 1;
  var e = Ys && Ys.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Ys.__esModule = !0, Ys.http11 = void 0;
  var t = Tn(), n = `\r
`;
  return Ys.http11 = {
    info: {
      key: "http1.1",
      title: "HTTP/1.1",
      link: "https://tools.ietf.org/html/rfc7230",
      description: "HTTP/1.1 request string in accordance with RFC 7230"
    },
    convert: function(r, i) {
      var a = r.method, o = r.fullUrl, c = r.uriObj, u = r.httpVersion, s = r.allHeaders, f = r.postData, d = e({ absoluteURI: !1, autoContentLength: !0, autoHost: !0 }, i), l = new t.CodeBuilder({ indent: "", join: n }), p = l.blank, g = l.push, v = l.join, b = d.absoluteURI ? o : c.path;
      g("".concat(a, " ").concat(b, " ").concat(u));
      var y = Object.keys(s);
      if (y.forEach(function(E) {
        var D = E.toLowerCase().replace(/(^|-)(\w)/g, function($) {
          return $.toUpperCase();
        });
        g("".concat(D, ": ").concat(s[E]));
      }), d.autoHost && !y.includes("host") && g("Host: ".concat(c.host)), d.autoContentLength && f.text && !y.includes("content-length")) {
        var w = Dn.byteLength(f.text, "ascii").toString();
        g("Content-Length: ".concat(w));
      }
      p();
      var C = v(), T = f.text || "";
      return "".concat(C).concat(n).concat(T);
    }
  }, Ys;
}
var hw;
function Are() {
  if (hw) return ql;
  hw = 1, ql.__esModule = !0, ql.http = void 0;
  var e = Cre();
  return ql.http = {
    info: {
      key: "http",
      title: "HTTP",
      extname: null,
      default: "1.1"
    },
    clientsById: {
      "http1.1": e.http11
    }
  }, ql;
}
var Dl = {}, Js = {}, mw;
function kre() {
  if (mw) return Js;
  mw = 1;
  var e = Js && Js.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Js.__esModule = !0, Js.asynchttp = void 0;
  var t = Tn(), n = ri();
  return Js.asynchttp = {
    info: {
      key: "asynchttp",
      title: "AsyncHttp",
      link: "https://github.com/AsyncHttpClient/async-http-client",
      description: "Asynchronous Http and WebSocket Client library for Java"
    },
    convert: function(r, i) {
      var a = r.method, o = r.allHeaders, c = r.postData, u = r.fullUrl, s = e({ indent: "  " }, i), f = new t.CodeBuilder({ indent: s.indent }), d = f.blank, l = f.push, p = f.join;
      return l("AsyncHttpClient client = new DefaultAsyncHttpClient();"), l('client.prepare("'.concat(a.toUpperCase(), '", "').concat(u, '")')), Object.keys(o).forEach(function(g) {
        l('.setHeader("'.concat(g, '", "').concat((0, n.escapeForDoubleQuotes)(o[g]), '")'), 1);
      }), c.text && l(".setBody(".concat(JSON.stringify(c.text), ")"), 1), l(".execute()", 1), l(".toCompletableFuture()", 1), l(".thenAccept(System.out::println)", 1), l(".join();", 1), d(), l("client.close();"), p();
    }
  }, Js;
}
var Qs = {}, gw;
function Ere() {
  if (gw) return Qs;
  gw = 1;
  var e = Qs && Qs.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Qs.__esModule = !0, Qs.nethttp = void 0;
  var t = Tn(), n = ri();
  return Qs.nethttp = {
    info: {
      key: "nethttp",
      title: "java.net.http",
      link: "https://openjdk.java.net/groups/net/httpclient/intro.html",
      description: "Java Standardized HTTP Client API"
    },
    convert: function(r, i) {
      var a = r.allHeaders, o = r.fullUrl, c = r.method, u = r.postData, s = e({ indent: "  " }, i), f = new t.CodeBuilder({ indent: s.indent }), d = f.push, l = f.join;
      return d("HttpRequest request = HttpRequest.newBuilder()"), d('.uri(URI.create("'.concat(o, '"))'), 2), Object.keys(a).forEach(function(p) {
        d('.header("'.concat(p, '", "').concat((0, n.escapeForDoubleQuotes)(a[p]), '")'), 2);
      }), u.text ? d('.method("'.concat(c.toUpperCase(), '", HttpRequest.BodyPublishers.ofString(').concat(JSON.stringify(u.text), "))"), 2) : d('.method("'.concat(c.toUpperCase(), '", HttpRequest.BodyPublishers.noBody())'), 2), d(".build();", 2), d("HttpResponse<String> response = HttpClient.newHttpClient().send(request, HttpResponse.BodyHandlers.ofString());"), d("System.out.println(response.body());"), l();
    }
  }, Qs;
}
var Xs = {}, vw;
function Ore() {
  if (vw) return Xs;
  vw = 1;
  var e = Xs && Xs.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  Xs.__esModule = !0, Xs.okhttp = void 0;
  var t = Tn(), n = ri();
  return Xs.okhttp = {
    info: {
      key: "okhttp",
      title: "OkHttp",
      link: "http://square.github.io/okhttp/",
      description: "An HTTP Request Client Library"
    },
    convert: function(r, i) {
      var a = r.postData, o = r.method, c = r.fullUrl, u = r.allHeaders, s = e({ indent: "  " }, i), f = new t.CodeBuilder({ indent: s.indent }), d = f.push, l = f.blank, p = f.join, g = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD"], v = ["POST", "PUT", "DELETE", "PATCH"];
      return d("OkHttpClient client = new OkHttpClient();"), l(), a.text && (a.boundary ? d('MediaType mediaType = MediaType.parse("'.concat(a.mimeType, "; boundary=").concat(a.boundary, '");')) : d('MediaType mediaType = MediaType.parse("'.concat(a.mimeType, '");')), d("RequestBody body = RequestBody.create(mediaType, ".concat(JSON.stringify(a.text), ");"))), d("Request request = new Request.Builder()"), d('.url("'.concat(c, '")'), 1), g.includes(o.toUpperCase()) ? v.includes(o.toUpperCase()) ? a.text ? d(".".concat(o.toLowerCase(), "(body)"), 1) : d(".".concat(o.toLowerCase(), "(null)"), 1) : d(".".concat(o.toLowerCase(), "()"), 1) : a.text ? d('.method("'.concat(o.toUpperCase(), '", body)'), 1) : d('.method("'.concat(o.toUpperCase(), '", null)'), 1), Object.keys(u).forEach(function(b) {
        d('.addHeader("'.concat(b, '", "').concat((0, n.escapeForDoubleQuotes)(u[b]), '")'), 1);
      }), d(".build();", 1), l(), d("Response response = client.newCall(request).execute();"), p();
    }
  }, Xs;
}
var eu = {}, yw;
function Tre() {
  if (yw) return eu;
  yw = 1;
  var e = eu && eu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  eu.__esModule = !0, eu.unirest = void 0;
  var t = Tn(), n = ri();
  return eu.unirest = {
    info: {
      key: "unirest",
      title: "Unirest",
      link: "http://unirest.io/java.html",
      description: "Lightweight HTTP Request Client Library"
    },
    convert: function(r, i) {
      var a = r.method, o = r.allHeaders, c = r.postData, u = r.fullUrl, s = e({ indent: "  " }, i), f = new t.CodeBuilder({ indent: s.indent }), d = f.join, l = f.push, p = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD", "OPTIONS"];
      return p.includes(a.toUpperCase()) ? l("HttpResponse<String> response = Unirest.".concat(a.toLowerCase(), '("').concat(u, '")')) : l('HttpResponse<String> response = Unirest.customMethod("'.concat(a.toUpperCase(), '","').concat(u, '")')), Object.keys(o).forEach(function(g) {
        l('.header("'.concat(g, '", "').concat((0, n.escapeForDoubleQuotes)(o[g]), '")'), 1);
      }), c.text && l(".body(".concat(JSON.stringify(c.text), ")"), 1), l(".asString();", 1), d();
    }
  }, eu;
}
var bw;
function Pre() {
  if (bw) return Dl;
  bw = 1, Dl.__esModule = !0, Dl.java = void 0;
  var e = kre(), t = Ere(), n = Ore(), r = Tre();
  return Dl.java = {
    info: {
      key: "java",
      title: "Java",
      extname: ".java",
      default: "unirest"
    },
    clientsById: {
      asynchttp: e.asynchttp,
      nethttp: t.nethttp,
      okhttp: n.okhttp,
      unirest: r.unirest
    }
  }, Dl;
}
var Ll = {}, Mo = {}, M3, xw;
function Rre() {
  return xw || (xw = 1, M3 = function(e) {
    return Object.prototype.toString.call(e) === "[object RegExp]";
  }), M3;
}
var F3, _w;
function jre() {
  return _w || (_w = 1, F3 = function(e) {
    var t = typeof e;
    return e !== null && (t === "object" || t === "function");
  }), F3;
}
var Ld = {}, ww;
function Ire() {
  return ww || (ww = 1, Object.defineProperty(Ld, "__esModule", { value: !0 }), Ld.default = (e) => Object.getOwnPropertySymbols(e).filter((t) => Object.prototype.propertyIsEnumerable.call(e, t))), Ld;
}
var B3, Sw;
function ss() {
  if (Sw) return B3;
  Sw = 1;
  const e = Rre(), t = jre(), n = Ire().default;
  return B3 = (r, i, a) => {
    const o = [];
    return function c(u, s, f) {
      s = s || {}, s.indent = s.indent || "	", f = f || "";
      let d;
      s.inlineCharacterLimit === void 0 ? d = {
        newLine: `
`,
        newLineOrSpace: `
`,
        pad: f,
        indent: f + s.indent
      } : d = {
        newLine: "@@__STRINGIFY_OBJECT_NEW_LINE__@@",
        newLineOrSpace: "@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@",
        pad: "@@__STRINGIFY_OBJECT_PAD__@@",
        indent: "@@__STRINGIFY_OBJECT_INDENT__@@"
      };
      const l = (p) => {
        if (s.inlineCharacterLimit === void 0)
          return p;
        const g = p.replace(new RegExp(d.newLine, "g"), "").replace(new RegExp(d.newLineOrSpace, "g"), " ").replace(new RegExp(d.pad + "|" + d.indent, "g"), "");
        return g.length <= s.inlineCharacterLimit ? g : p.replace(new RegExp(d.newLine + "|" + d.newLineOrSpace, "g"), `
`).replace(new RegExp(d.pad, "g"), f).replace(new RegExp(d.indent, "g"), f + s.indent);
      };
      if (o.indexOf(u) !== -1)
        return '"[Circular]"';
      if (u == null || typeof u == "number" || typeof u == "boolean" || typeof u == "function" || typeof u == "symbol" || e(u))
        return String(u);
      if (u instanceof Date)
        return `new Date('${u.toISOString()}')`;
      if (Array.isArray(u)) {
        if (u.length === 0)
          return "[]";
        o.push(u);
        const p = "[" + d.newLine + u.map((g, v) => {
          const b = u.length - 1 === v ? d.newLine : "," + d.newLineOrSpace;
          let y = c(g, s, f + s.indent);
          return s.transform && (y = s.transform(u, v, y)), d.indent + y + b;
        }).join("") + d.pad + "]";
        return o.pop(), l(p);
      }
      if (t(u)) {
        let p = Object.keys(u).concat(n(u));
        if (s.filter && (p = p.filter((v) => s.filter(u, v))), p.length === 0)
          return "{}";
        o.push(u);
        const g = "{" + d.newLine + p.map((v, b) => {
          const y = p.length - 1 === b ? d.newLine : "," + d.newLineOrSpace, w = typeof v == "symbol", C = !w && /^[a-z$_][a-z$_0-9]*$/i.test(v), T = w || C ? v : c(v, s);
          let E = c(u[v], s, f + s.indent);
          return s.transform && (E = s.transform(u, v, E)), d.indent + String(T) + ": " + E + y;
        }).join("") + d.pad + "}";
        return o.pop(), l(g);
      }
      return u = String(u).replace(/[\r\n]/g, (p) => p === `
` ? "\\n" : "\\r"), s.singleQuotes === !1 ? (u = u.replace(/"/g, '\\"'), `"${u}"`) : (u = u.replace(/\\?'/g, "\\'"), `'${u}'`);
    }(r, i, a);
  }, B3;
}
var Cw;
function qre() {
  if (Cw) return Mo;
  Cw = 1;
  var e = Mo && Mo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Mo && Mo.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Mo.__esModule = !0, Mo.axios = void 0;
  var n = t(ss()), r = Tn();
  return Mo.axios = {
    info: {
      key: "axios",
      title: "Axios",
      link: "https://github.com/axios/axios",
      description: "Promise based HTTP client for the browser and node.js"
    },
    convert: function(i, a) {
      var o = i.allHeaders, c = i.method, u = i.url, s = i.queryObj, f = i.postData, d = e({ indent: "  " }, a), l = new r.CodeBuilder({ indent: d.indent }), p = l.blank, g = l.push, v = l.join, b = l.addPostProcessor;
      g("import axios from 'axios';"), p();
      var y = {
        method: c,
        url: u
      };
      switch (Object.keys(s).length && (y.params = s), Object.keys(o).length && (y.headers = o), f.mimeType) {
        case "application/x-www-form-urlencoded":
          f.params && (g("const encodedParams = new URLSearchParams();"), f.params.forEach(function(C) {
            g("encodedParams.set('".concat(C.name, "', '").concat(C.value, "');"));
          }), p(), y.data = "encodedParams,", b(function(C) {
            return C.replace(/'encodedParams,'/, "encodedParams,");
          }));
          break;
        case "application/json":
          f.jsonObj && (y.data = f.jsonObj);
          break;
        case "multipart/form-data":
          if (!f.params)
            break;
          g("const form = new FormData();"), f.params.forEach(function(C) {
            g("form.append('".concat(C.name, "', '").concat(C.value || C.fileName || "", "');"));
          }), p(), y.data = "[form]";
          break;
        default:
          f.text && (y.data = f.text);
      }
      var w = (0, n.default)(y, {
        indent: "  ",
        inlineCharacterLimit: 80
      }).replace('"[form]"', "form");
      return g("const options = ".concat(w, ";")), p(), g("try {"), g("const { data } = await axios.request(options);", 1), g("console.log(data);", 1), g("} catch (error) {"), g("console.error(error);", 1), g("}"), v();
    }
  }, Mo;
}
var Fo = {}, Aw;
function Dre() {
  if (Aw) return Fo;
  Aw = 1;
  var e = Fo && Fo.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  }, t = Fo && Fo.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Fo.__esModule = !0, Fo.fetch = void 0;
  var n = t(ss()), r = Tn(), i = Wi();
  return Fo.fetch = {
    info: {
      key: "fetch",
      title: "fetch",
      link: "https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch",
      description: "Perform asynchronous HTTP requests with the Fetch API"
    },
    convert: function(a, o) {
      var c = a.method, u = a.allHeaders, s = a.postData, f = a.fullUrl, d = e({ indent: "  ", credentials: null }, o), l = new r.CodeBuilder({ indent: d.indent }), p = l.blank, g = l.join, v = l.push, b = {
        method: c
      };
      switch (Object.keys(u).length && (b.headers = u), d.credentials !== null && (b.credentials = d.credentials), v("const url = '".concat(f, "';")), s.mimeType) {
        case "application/x-www-form-urlencoded":
          b.body = s.paramsObj ? s.paramsObj : s.text;
          break;
        case "application/json":
          b.body = JSON.stringify(s.jsonObj);
          break;
        case "multipart/form-data":
          if (!s.params)
            break;
          var y = (0, i.getHeaderName)(u, "content-type");
          y && delete u[y], v("const form = new FormData();"), s.params.forEach(function(w) {
            v("form.append('".concat(w.name, "', '").concat(w.value || w.fileName || "", "');"));
          }), p();
          break;
        default:
          s.text && (b.body = s.text);
      }
      return b.headers && !Object.keys(b.headers).length && delete b.headers, v("const options = ".concat((0, n.default)(b, {
        indent: d.indent,
        inlineCharacterLimit: 80,
        transform: function(w, C, T) {
          return C === "body" && s.mimeType === "application/x-www-form-urlencoded" ? "new URLSearchParams(".concat(T, ")") : T;
        }
      }), ";")), p(), s.params && s.mimeType === "multipart/form-data" && (v("options.body = form;"), p()), v("try {"), v("const response = await fetch(url, options);", 1), v("const data = await response.json();", 1), v("console.log(data);", 1), v("} catch (error) {"), v("console.error(error);", 1), v("}"), g();
    }
  }, Fo;
}
var Bo = {}, kw;
function Lre() {
  if (kw) return Bo;
  kw = 1;
  var e = Bo && Bo.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  }, t = Bo && Bo.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Bo.__esModule = !0, Bo.jquery = void 0;
  var n = t(ss()), r = Tn(), i = Wi();
  return Bo.jquery = {
    info: {
      key: "jquery",
      title: "jQuery",
      link: "http://api.jquery.com/jquery.ajax/",
      description: "Perform an asynchronous HTTP (Ajax) requests with jQuery"
    },
    convert: function(a, o) {
      var c, u = a.fullUrl, s = a.method, f = a.allHeaders, d = a.postData, l = e({ indent: "  " }, o), p = new r.CodeBuilder({ indent: l.indent }), g = p.blank, v = p.push, b = p.join, y = {
        async: !0,
        crossDomain: !0,
        url: u,
        method: s,
        headers: f
      };
      switch (d.mimeType) {
        case "application/x-www-form-urlencoded":
          y.data = d.paramsObj ? d.paramsObj : d.text;
          break;
        case "application/json":
          y.processData = !1, y.data = d.text;
          break;
        case "multipart/form-data":
          if (!d.params)
            break;
          if (v("const form = new FormData();"), d.params.forEach(function(T) {
            v("form.append('".concat(T.name, "', '").concat(T.value || T.fileName || "", "');"));
          }), y.processData = !1, y.contentType = !1, y.mimeType = "multipart/form-data", y.data = "[form]", (0, i.hasHeader)(f, "content-type") && !((c = (0, i.getHeader)(f, "content-type")) === null || c === void 0) && c.includes("boundary")) {
            var w = (0, i.getHeaderName)(f, "content-type");
            w && delete y.headers[w];
          }
          g();
          break;
        default:
          d.text && (y.data = d.text);
      }
      var C = (0, n.default)(y, { indent: l.indent }).replace("'[form]'", "form");
      return v("const settings = ".concat(C, ";")), g(), v("$.ajax(settings).done(function (response) {"), v("console.log(response);", 1), v("});"), b();
    }
  }, Bo;
}
var Uo = {}, Ew;
function Nre() {
  if (Ew) return Uo;
  Ew = 1;
  var e = Uo && Uo.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (o[f] = c[f]);
      }
      return o;
    }, e.apply(this, arguments);
  }, t = Uo && Uo.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Uo.__esModule = !0, Uo.xhr = void 0;
  var n = t(ss()), r = Tn(), i = ri(), a = Wi();
  return Uo.xhr = {
    info: {
      key: "xhr",
      title: "XMLHttpRequest",
      link: "https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest",
      description: "W3C Standard API that provides scripted client functionality"
    },
    convert: function(o, c) {
      var u, s = o.postData, f = o.allHeaders, d = o.method, l = o.fullUrl, p = e({ indent: "  ", cors: !0 }, c), g = new r.CodeBuilder({ indent: p.indent }), v = g.blank, b = g.push, y = g.join;
      switch (s.mimeType) {
        case "application/json":
          b("const data = JSON.stringify(".concat((0, n.default)(s.jsonObj, {
            indent: p.indent
          }), ");")), v();
          break;
        case "multipart/form-data":
          if (!s.params)
            break;
          if (b("const data = new FormData();"), s.params.forEach(function(C) {
            b("data.append('".concat(C.name, "', '").concat(C.value || C.fileName || "", "');"));
          }), (0, a.hasHeader)(f, "content-type") && !((u = (0, a.getHeader)(f, "content-type")) === null || u === void 0) && u.includes("boundary")) {
            var w = (0, a.getHeaderName)(f, "content-type");
            w && delete f[w];
          }
          v();
          break;
        default:
          b("const data = ".concat(s.text ? "'".concat(s.text, "'") : "null", ";")), v();
      }
      return b("const xhr = new XMLHttpRequest();"), p.cors && b("xhr.withCredentials = true;"), v(), b("xhr.addEventListener('readystatechange', function () {"), b("if (this.readyState === this.DONE) {", 1), b("console.log(this.responseText);", 2), b("}", 1), b("});"), v(), b("xhr.open('".concat(d, "', '").concat(l, "');")), Object.keys(f).forEach(function(C) {
        b("xhr.setRequestHeader('".concat(C, "', '").concat((0, i.escapeForSingleQuotes)(f[C]), "');"));
      }), v(), b("xhr.send(data);"), y();
    }
  }, Uo;
}
var Ow;
function $re() {
  if (Ow) return Ll;
  Ow = 1, Ll.__esModule = !0, Ll.javascript = void 0;
  var e = qre(), t = Dre(), n = Lre(), r = Nre();
  return Ll.javascript = {
    info: {
      key: "javascript",
      title: "JavaScript",
      extname: ".js",
      default: "xhr"
    },
    clientsById: {
      xhr: r.xhr,
      axios: e.axios,
      fetch: t.fetch,
      jquery: n.jquery
    }
  }, Ll;
}
var Nl = {}, tu = {}, Tw;
function Mre() {
  if (Tw) return tu;
  Tw = 1;
  var e = tu && tu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  tu.__esModule = !0, tu.okhttp = void 0;
  var t = Tn(), n = ri();
  return tu.okhttp = {
    info: {
      key: "okhttp",
      title: "OkHttp",
      link: "http://square.github.io/okhttp/",
      description: "An HTTP Request Client Library"
    },
    convert: function(r, i) {
      var a = r.postData, o = r.fullUrl, c = r.method, u = r.allHeaders, s = e({ indent: "  " }, i), f = new t.CodeBuilder({ indent: s.indent }), d = f.blank, l = f.join, p = f.push, g = ["GET", "POST", "PUT", "DELETE", "PATCH", "HEAD"], v = ["POST", "PUT", "DELETE", "PATCH"];
      return p("val client = OkHttpClient()"), d(), a.text && (a.boundary ? p('val mediaType = MediaType.parse("'.concat(a.mimeType, "; boundary=").concat(a.boundary, '")')) : p('val mediaType = MediaType.parse("'.concat(a.mimeType, '")')), p("val body = RequestBody.create(mediaType, ".concat(JSON.stringify(a.text), ")"))), p("val request = Request.Builder()"), p('.url("'.concat(o, '")'), 1), g.includes(c.toUpperCase()) ? v.includes(c.toUpperCase()) ? a.text ? p(".".concat(c.toLowerCase(), "(body)"), 1) : p(".".concat(c.toLowerCase(), "(null)"), 1) : p(".".concat(c.toLowerCase(), "()"), 1) : a.text ? p('.method("'.concat(c.toUpperCase(), '", body)'), 1) : p('.method("'.concat(c.toUpperCase(), '", null)'), 1), Object.keys(u).forEach(function(b) {
        p('.addHeader("'.concat(b, '", "').concat((0, n.escapeForDoubleQuotes)(u[b]), '")'), 1);
      }), p(".build()", 1), d(), p("val response = client.newCall(request).execute()"), l();
    }
  }, tu;
}
var Pw;
function Fre() {
  if (Pw) return Nl;
  Pw = 1, Nl.__esModule = !0, Nl.kotlin = void 0;
  var e = Mre();
  return Nl.kotlin = {
    info: {
      key: "kotlin",
      title: "Kotlin",
      extname: ".kt",
      default: "okhttp"
    },
    clientsById: {
      okhttp: e.okhttp
    }
  }, Nl;
}
var $l = {}, Ho = {}, Rw;
function Bre() {
  if (Rw) return Ho;
  Rw = 1;
  var e = Ho && Ho.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Ho && Ho.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Ho.__esModule = !0, Ho.axios = void 0;
  var n = t(ss()), r = Tn();
  return Ho.axios = {
    info: {
      key: "axios",
      title: "Axios",
      link: "https://github.com/axios/axios",
      description: "Promise based HTTP client for the browser and node.js"
    },
    convert: function(i, a) {
      var o = i.method, c = i.url, u = i.queryObj, s = i.allHeaders, f = i.postData, d = e({ indent: "  " }, a), l = new r.CodeBuilder({ indent: d.indent }), p = l.blank, g = l.join, v = l.push, b = l.addPostProcessor;
      v("const axios = require('axios').default;");
      var y = {
        method: o,
        url: c
      };
      switch (Object.keys(u).length && (y.params = u), Object.keys(s).length && (y.headers = s), f.mimeType) {
        case "application/x-www-form-urlencoded":
          f.params && (v("const { URLSearchParams } = require('url');"), p(), v("const encodedParams = new URLSearchParams();"), f.params.forEach(function(C) {
            v("encodedParams.set('".concat(C.name, "', '").concat(C.value, "');"));
          }), p(), y.data = "encodedParams,", b(function(C) {
            return C.replace(/'encodedParams,'/, "encodedParams,");
          }));
          break;
        case "application/json":
          p(), f.jsonObj && (y.data = f.jsonObj);
          break;
        default:
          p(), f.text && (y.data = f.text);
      }
      var w = (0, n.default)(y, { indent: "  ", inlineCharacterLimit: 80 });
      return v("const options = ".concat(w, ";")), p(), v("try {"), v("const { data } = await axios.request(options);", 1), v("console.log(data);", 1), v("} catch (error) {"), v("console.error(error);", 1), v("}"), g();
    }
  }, Ho;
}
var zo = {}, jw;
function Ure() {
  if (jw) return zo;
  jw = 1;
  var e = zo && zo.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  }, t = zo && zo.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  zo.__esModule = !0, zo.fetch = void 0;
  var n = t(ss()), r = Tn(), i = Wi();
  return zo.fetch = {
    info: {
      key: "fetch",
      title: "Fetch",
      link: "https://github.com/bitinn/node-fetch",
      description: "Simplified HTTP node-fetch client"
    },
    convert: function(a, o) {
      var c, u = a.method, s = a.fullUrl, f = a.postData, d = a.headersObj, l = a.cookies, p = e({ indent: "  " }, o), g = !1, v = new r.CodeBuilder({ indent: p.indent }), b = v.blank, y = v.push, w = v.join, C = v.unshift;
      y("const fetch = require('node-fetch');"), b();
      var T = {
        method: u
      };
      switch (Object.keys(d).length && (T.headers = d), f.mimeType) {
        case "application/x-www-form-urlencoded":
          C("const { URLSearchParams } = require('url');"), y("const encodedParams = new URLSearchParams();"), (c = f.params) === null || c === void 0 || c.forEach(function(Z) {
            y("encodedParams.set('".concat(Z.name, "', '").concat(Z.value, "');"));
          }), b(), T.body = "encodedParams";
          break;
        case "application/json":
          f.jsonObj && (T.body = JSON.stringify(f.jsonObj));
          break;
        case "multipart/form-data":
          if (!f.params)
            break;
          var E = (0, i.getHeaderName)(d, "content-type");
          E && delete d[E], C("const FormData = require('form-data');"), y("const formData = new FormData();"), f.params.forEach(function(Z) {
            if (!Z.fileName && !Z.fileName && !Z.contentType) {
              y("formData.append('".concat(Z.name, "', '").concat(Z.value, "');"));
              return;
            }
            Z.fileName && (g = !0, y("formData.append('".concat(Z.name, "', fs.createReadStream('").concat(Z.fileName, "'));")));
          }), b();
          break;
        default:
          f.text && (T.body = f.text);
      }
      if (l.length) {
        var D = l.map(function(Z) {
          return "".concat(encodeURIComponent(Z.name), "=").concat(encodeURIComponent(Z.value));
        }).join("; ");
        T.headers || (T.headers = {}), T.headers.cookie = D;
      }
      y("const url = '".concat(s, "';")), T.headers && !Object.keys(T.headers).length && delete T.headers;
      var $ = (0, n.default)(T, { indent: "  ", inlineCharacterLimit: 80 });
      return y("const options = ".concat($, ";")), g && C("const fs = require('fs');"), f.params && f.mimeType === "multipart/form-data" && y("options.body = formData;"), b(), y("try {"), y("const response = await fetch(url, options);", 1), y("const data = await response.json();", 1), y("console.log(data);", 1), y("} catch (error) {"), y("console.error(error);", 1), y("}"), w().replace(/'encodedParams'/, "encodedParams").replace(/"fs\.createReadStream\(\\"(.+)\\"\)"/, 'fs.createReadStream("$1")');
    }
  }, zo;
}
var Go = {}, Iw;
function Hre() {
  if (Iw) return Go;
  Iw = 1;
  var e = Go && Go.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Go && Go.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Go.__esModule = !0, Go.native = void 0;
  var n = t(ss()), r = Tn();
  return Go.native = {
    info: {
      key: "native",
      title: "HTTP",
      link: "http://nodejs.org/api/http.html#http_http_request_options_callback",
      description: "Node.js native HTTP interface"
    },
    convert: function(i, a) {
      var o = i.uriObj, c = i.method, u = i.allHeaders, s = i.postData;
      a === void 0 && (a = {});
      var f = a.indent, d = f === void 0 ? "  " : f, l = a.insecureSkipVerify, p = l === void 0 ? !1 : l, g = new r.CodeBuilder({ indent: d }), v = g.blank, b = g.join, y = g.push, w = g.unshift, C = e({ method: c, hostname: o.hostname, port: o.port, path: o.path, headers: u }, p ? { rejectUnauthorized: !1 } : {});
      switch (y("const http = require('".concat(o.protocol.replace(":", ""), "');")), v(), y("const options = ".concat((0, n.default)(C, { indent: d }), ";")), v(), y("const req = http.request(options, function (res) {"), y("const chunks = [];", 1), v(), y("res.on('data', function (chunk) {", 1), y("chunks.push(chunk);", 2), y("});", 1), v(), y("res.on('end', function () {", 1), y("const body = Buffer.concat(chunks);", 2), y("console.log(body.toString());", 2), y("});", 1), y("});"), v(), s.mimeType) {
        case "application/x-www-form-urlencoded":
          s.paramsObj && (w("const qs = require('querystring');"), y("req.write(qs.stringify(".concat((0, n.default)(s.paramsObj, {
            indent: "  ",
            inlineCharacterLimit: 80
          }), "));")));
          break;
        case "application/json":
          s.jsonObj && y("req.write(JSON.stringify(".concat((0, n.default)(s.jsonObj, {
            indent: "  ",
            inlineCharacterLimit: 80
          }), "));"));
          break;
        default:
          s.text && y("req.write(".concat((0, n.default)(s.text, { indent: d }), ");"));
      }
      return y("req.end();"), b();
    }
  }, Go;
}
var Vo = {}, qw;
function zre() {
  if (qw) return Vo;
  qw = 1;
  var e = Vo && Vo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Vo && Vo.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Vo.__esModule = !0, Vo.request = void 0;
  var n = t(ss()), r = Tn();
  return Vo.request = {
    info: {
      key: "request",
      title: "Request",
      link: "https://github.com/request/request",
      description: "Simplified HTTP request client"
    },
    convert: function(i, a) {
      var o = i.method, c = i.url, u = i.queryObj, s = i.postData, f = i.headersObj, d = i.cookies, l = e({ indent: "  " }, a), p = !1, g = new r.CodeBuilder({ indent: l.indent }), v = g.push, b = g.blank, y = g.join, w = g.unshift;
      v("const request = require('request');"), b();
      var C = {
        method: o,
        url: c
      };
      switch (Object.keys(u).length && (C.qs = u), Object.keys(f).length && (C.headers = f), s.mimeType) {
        case "application/x-www-form-urlencoded":
          C.form = s.paramsObj;
          break;
        case "application/json":
          s.jsonObj && (C.body = s.jsonObj, C.json = !0);
          break;
        case "multipart/form-data":
          if (!s.params)
            break;
          C.formData = {}, s.params.forEach(function(T) {
            if (!T.fileName && !T.fileName && !T.contentType) {
              C.formData[T.name] = T.value;
              return;
            }
            var E = {};
            T.fileName ? (p = !0, E = {
              value: "fs.createReadStream(".concat(T.fileName, ")"),
              options: {
                filename: T.fileName,
                contentType: T.contentType ? T.contentType : null
              }
            }) : T.value && (E.value = T.value), C.formData[T.name] = E;
          });
          break;
        default:
          s.text && (C.body = s.text);
      }
      return d.length && (C.jar = "JAR", v("const jar = request.jar();"), d.forEach(function(T) {
        v("jar.setCookie(request.cookie('".concat(encodeURIComponent(T.name), "=").concat(encodeURIComponent(T.value), "'), '").concat(c, "');"));
      }), b()), p && w("const fs = require('fs');"), v("const options = ".concat((0, n.default)(C, { indent: "  ", inlineCharacterLimit: 80 }), ";")), b(), v("request(options, function (error, response, body) {"), v("if (error) throw new Error(error);", 1), b(), v("console.log(body);", 1), v("});"), y().replace("'JAR'", "jar").replace(/'fs\.createReadStream\((.*)\)'/, "fs.createReadStream('$1')");
    }
  }, Vo;
}
var Wo = {}, Dw;
function Gre() {
  if (Dw) return Wo;
  Dw = 1;
  var e = Wo && Wo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Wo && Wo.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Wo.__esModule = !0, Wo.unirest = void 0;
  var n = t(ss()), r = Tn();
  return Wo.unirest = {
    info: {
      key: "unirest",
      title: "Unirest",
      link: "http://unirest.io/nodejs.html",
      description: "Lightweight HTTP Request Client Library"
    },
    convert: function(i, a) {
      var o = i.method, c = i.url, u = i.cookies, s = i.queryObj, f = i.postData, d = i.headersObj, l = e({ indent: "  " }, a), p = !1, g = new r.CodeBuilder({
        indent: l.indent
      }), v = g.addPostProcessor, b = g.blank, y = g.join, w = g.push, C = g.unshift;
      switch (w("const unirest = require('unirest');"), b(), w("const req = unirest('".concat(o, "', '").concat(c, "');")), b(), u.length && (w("const CookieJar = unirest.jar();"), u.forEach(function(E) {
        w("CookieJar.add('".concat(encodeURIComponent(E.name), "=").concat(encodeURIComponent(E.value), "', '").concat(c, "');"));
      }), w("req.jar(CookieJar);"), b()), Object.keys(s).length && (w("req.query(".concat((0, n.default)(s, { indent: l.indent }), ");")), b()), Object.keys(d).length && (w("req.headers(".concat((0, n.default)(d, { indent: l.indent }), ");")), b()), f.mimeType) {
        case "application/x-www-form-urlencoded":
          f.paramsObj && (w("req.form(".concat((0, n.default)(f.paramsObj, { indent: l.indent }), ");")), b());
          break;
        case "application/json":
          f.jsonObj && (w("req.type('json');"), w("req.send(".concat((0, n.default)(f.jsonObj, { indent: l.indent }), ");")), b());
          break;
        case "multipart/form-data": {
          if (!f.params)
            break;
          var T = [];
          f.params.forEach(function(E) {
            var D = {};
            E.fileName && !E.value ? (p = !0, D.body = "fs.createReadStream('".concat(E.fileName, "')"), v(function($) {
              return $.replace(/'fs\.createReadStream\(\\'(.+)\\'\)'/, "fs.createReadStream('$1')");
            })) : E.value && (D.body = E.value), D.body && (E.contentType && (D["content-type"] = E.contentType), T.push(D));
          }), w("req.multipart(".concat((0, n.default)(T, { indent: l.indent }), ");")), b();
          break;
        }
        default:
          f.text && (w("req.send(".concat((0, n.default)(f.text, { indent: l.indent }), ");")), b());
      }
      return p && C("const fs = require('fs');"), w("req.end(function (res) {"), w("if (res.error) throw new Error(res.error);", 1), b(), w("console.log(res.body);", 1), w("});"), y();
    }
  }, Wo;
}
var Lw;
function Vre() {
  if (Lw) return $l;
  Lw = 1, $l.__esModule = !0, $l.node = void 0;
  var e = Bre(), t = Ure(), n = Hre(), r = zre(), i = Gre();
  return $l.node = {
    info: {
      key: "node",
      title: "Node.js",
      extname: ".js",
      default: "native"
    },
    clientsById: {
      native: n.native,
      request: r.request,
      unirest: i.unirest,
      axios: e.axios,
      fetch: t.fetch
    }
  }, $l;
}
var Ml = {}, Ko = {}, U3 = {}, Nw;
function Wre() {
  return Nw || (Nw = 1, function(e) {
    e.__esModule = !0, e.literalRepresentation = e.nsDeclaration = void 0;
    var t = function(r, i, a, o) {
      var c = "".concat(r, " *").concat(i, " = "), u = (0, e.literalRepresentation)(a, o ? c.length : void 0);
      return "".concat(c).concat(u, ";");
    };
    e.nsDeclaration = t;
    var n = function(r, i) {
      var a = i === void 0 ? ", " : `,
   `.concat(" ".repeat(i));
      switch (Object.prototype.toString.call(r)) {
        case "[object Number]":
          return "@".concat(r);
        case "[object Array]": {
          var o = r.map(function(s) {
            return (0, e.literalRepresentation)(s);
          });
          return "@[ ".concat(o.join(a), " ]");
        }
        case "[object Object]": {
          var c = [];
          for (var u in r)
            c.push('@"'.concat(u, '": ').concat((0, e.literalRepresentation)(r[u])));
          return "@{ ".concat(c.join(a), " }");
        }
        case "[object Boolean]":
          return r ? "@YES" : "@NO";
        default:
          return r == null ? "" : '@"'.concat(r.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = n;
  }(U3)), U3;
}
var $w;
function Kre() {
  if ($w) return Ko;
  $w = 1;
  var e = Ko && Ko.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Ko && Ko.__read || function(i, a) {
    var o = typeof Symbol == "function" && i[Symbol.iterator];
    if (!o) return i;
    var c = o.call(i), u, s = [], f;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) s.push(u.value);
    } catch (d) {
      f = { error: d };
    } finally {
      try {
        u && !u.done && (o = c.return) && o.call(c);
      } finally {
        if (f) throw f.error;
      }
    }
    return s;
  };
  Ko.__esModule = !0, Ko.nsurlsession = void 0;
  var n = Tn(), r = Wre();
  return Ko.nsurlsession = {
    info: {
      key: "nsurlsession",
      title: "NSURLSession",
      link: "https://developer.apple.com/library/mac/documentation/Foundation/Reference/NSURLSession_class/index.html",
      description: "Foundation's NSURLSession request"
    },
    convert: function(i, a) {
      var o, c = i.allHeaders, u = i.postData, s = i.method, f = i.fullUrl, d = e({ indent: "    ", pretty: !0, timeout: 10 }, a), l = new n.CodeBuilder({ indent: d.indent }), p = l.push, g = l.join, v = l.blank, b = {
        hasHeaders: !1,
        hasBody: !1
      };
      if (p("#import <Foundation/Foundation.h>"), Object.keys(c).length && (b.hasHeaders = !0, v(), p((0, r.nsDeclaration)("NSDictionary", "headers", c, d.pretty))), u.text || u.jsonObj || u.params)
        switch (b.hasBody = !0, u.mimeType) {
          case "application/x-www-form-urlencoded":
            if (!((o = u.params) === null || o === void 0) && o.length) {
              v();
              var y = t(u.params), w = y[0], C = y.slice(1);
              p('NSMutableData *postData = [[NSMutableData alloc] initWithData:[@"'.concat(w.name, "=").concat(w.value, '" dataUsingEncoding:NSUTF8StringEncoding]];')), C.forEach(function(T) {
                var E = T.name, D = T.value;
                p('[postData appendData:[@"&'.concat(E, "=").concat(D, '" dataUsingEncoding:NSUTF8StringEncoding]];'));
              });
            } else
              b.hasBody = !1;
            break;
          case "application/json":
            u.jsonObj && (p((0, r.nsDeclaration)("NSDictionary", "parameters", u.jsonObj, d.pretty)), v(), p("NSData *postData = [NSJSONSerialization dataWithJSONObject:parameters options:0 error:nil];"));
            break;
          case "multipart/form-data":
            p((0, r.nsDeclaration)("NSArray", "parameters", u.params || [], d.pretty)), p('NSString *boundary = @"'.concat(u.boundary, '";')), v(), p("NSError *error;"), p("NSMutableString *body = [NSMutableString string];"), p("for (NSDictionary *param in parameters) {"), p('[body appendFormat:@"--%@\\r\\n", boundary];', 1), p('if (param[@"fileName"]) {', 1), p('[body appendFormat:@"Content-Disposition:form-data; name=\\"%@\\"; filename=\\"%@\\"\\r\\n", param[@"name"], param[@"fileName"]];', 2), p('[body appendFormat:@"Content-Type: %@\\r\\n\\r\\n", param[@"contentType"]];', 2), p('[body appendFormat:@"%@", [NSString stringWithContentsOfFile:param[@"fileName"] encoding:NSUTF8StringEncoding error:&error]];', 2), p("if (error) {", 2), p('NSLog(@"%@", error);', 3), p("}", 2), p("} else {", 1), p('[body appendFormat:@"Content-Disposition:form-data; name=\\"%@\\"\\r\\n\\r\\n", param[@"name"]];', 2), p('[body appendFormat:@"%@", param[@"value"]];', 2), p("}", 1), p("}"), p('[body appendFormat:@"\\r\\n--%@--\\r\\n", boundary];'), p("NSData *postData = [body dataUsingEncoding:NSUTF8StringEncoding];");
            break;
          default:
            v(), p('NSData *postData = [[NSData alloc] initWithData:[@"'.concat(u.text, '" dataUsingEncoding:NSUTF8StringEncoding]];'));
        }
      return v(), p('NSMutableURLRequest *request = [NSMutableURLRequest requestWithURL:[NSURL URLWithString:@"'.concat(f, '"]')), p("                                                       cachePolicy:NSURLRequestUseProtocolCachePolicy"), p("                                                   timeoutInterval:".concat(d.timeout.toFixed(1), "];")), p('[request setHTTPMethod:@"'.concat(s, '"];')), b.hasHeaders && p("[request setAllHTTPHeaderFields:headers];"), b.hasBody && p("[request setHTTPBody:postData];"), v(), p("NSURLSession *session = [NSURLSession sharedSession];"), p("NSURLSessionDataTask *dataTask = [session dataTaskWithRequest:request"), p("                                            completionHandler:^(NSData *data, NSURLResponse *response, NSError *error) {"), p("                                            if (error) {", 1), p('                                            NSLog(@"%@", error);', 2), p("                                            } else {", 1), p("                                            NSHTTPURLResponse *httpResponse = (NSHTTPURLResponse *) response;", 2), p('                                            NSLog(@"%@", httpResponse);', 2), p("                                            }", 1), p("                                            }];"), p("[dataTask resume];"), g();
    }
  }, Ko;
}
var Mw;
function Zre() {
  if (Mw) return Ml;
  Mw = 1, Ml.__esModule = !0, Ml.objc = void 0;
  var e = Kre();
  return Ml.objc = {
    info: {
      key: "objc",
      title: "Objective-C",
      extname: ".m",
      default: "nsurlsession"
    },
    clientsById: {
      nsurlsession: e.nsurlsession
    }
  }, Ml;
}
var Fl = {}, ru = {}, Fw;
function Yre() {
  if (Fw) return ru;
  Fw = 1;
  var e = ru && ru.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  ru.__esModule = !0, ru.cohttp = void 0;
  var t = Tn(), n = ri();
  return ru.cohttp = {
    info: {
      key: "cohttp",
      title: "CoHTTP",
      link: "https://github.com/mirage/ocaml-cohttp",
      description: "Cohttp is a very lightweight HTTP server using Lwt or Async for OCaml"
    },
    convert: function(r, i) {
      var a = r.fullUrl, o = r.allHeaders, c = r.postData, u = r.method, s = e({ indent: "  " }, i), f = ["get", "post", "head", "delete", "patch", "put", "options"], d = new t.CodeBuilder({ indent: s.indent }), l = d.push, p = d.blank, g = d.join;
      l("open Cohttp_lwt_unix"), l("open Cohttp"), l("open Lwt"), p(), l('let uri = Uri.of_string "'.concat(a, '" in'));
      var v = Object.keys(o);
      v.length === 1 ? l('let headers = Header.add (Header.init ()) "'.concat(v[0], '" "').concat((0, n.escapeForDoubleQuotes)(o[v[0]]), '" in')) : v.length > 1 && (l("let headers = Header.add_list (Header.init ()) ["), v.forEach(function(C) {
        l('("'.concat(C, '", "').concat((0, n.escapeForDoubleQuotes)(o[C]), '");'), 1);
      }), l("] in")), c.text && l("let body = Cohttp_lwt_body.of_string ".concat(JSON.stringify(c.text), " in")), p();
      var b = v.length ? "~headers " : "", y = c.text ? "~body " : "", w = f.includes(u.toLowerCase()) ? "`".concat(u.toUpperCase()) : '(Code.method_of_string "'.concat(u, '")');
      return l("Client.call ".concat(b).concat(y).concat(w, " uri")), l(">>= fun (res, body_stream) ->"), l("(* Do stuff with the result *)", 1), g();
    }
  }, ru;
}
var Bw;
function Jre() {
  if (Bw) return Fl;
  Bw = 1, Fl.__esModule = !0, Fl.ocaml = void 0;
  var e = Yre();
  return Fl.ocaml = {
    info: {
      key: "ocaml",
      title: "OCaml",
      extname: ".ml",
      default: "cohttp"
    },
    clientsById: {
      cohttp: e.cohttp
    }
  }, Fl;
}
var Bl = {}, Ul = {}, H3 = {}, Uw;
function v1() {
  return Uw || (Uw = 1, function(e) {
    e.__esModule = !0, e.supportedMethods = e.convertType = void 0;
    var t = ri(), n = function(r, i, a) {
      switch (a = a || "", i = i || "", Object.prototype.toString.call(r)) {
        case "[object Null]":
          return "null";
        case "[object Undefined]":
          return "null";
        case "[object String]":
          return "'".concat((0, t.escapeString)(r, { delimiter: "'", escapeNewlines: !1 }), "'");
        case "[object Number]":
          return r.toString();
        case "[object Array]": {
          var o = r.map(function(s) {
            return (0, e.convertType)(s, "".concat(i).concat(i), i);
          }).join(`,
`.concat(i));
          return `[
`.concat(i).concat(o, `
`).concat(a, "]");
        }
        case "[object Object]": {
          var c = [];
          for (var u in r)
            Object.prototype.hasOwnProperty.call(r, u) && c.push("".concat((0, e.convertType)(u, i), " => ").concat((0, e.convertType)(r[u], "".concat(i).concat(i), i)));
          return `[
`.concat(i).concat(c.join(`,
`.concat(i)), `
`).concat(a, "]");
        }
        default:
          return "null";
      }
    };
    e.convertType = n, e.supportedMethods = [
      "ACL",
      "BASELINE_CONTROL",
      "CHECKIN",
      "CHECKOUT",
      "CONNECT",
      "COPY",
      "DELETE",
      "GET",
      "HEAD",
      "LABEL",
      "LOCK",
      "MERGE",
      "MKACTIVITY",
      "MKCOL",
      "MKWORKSPACE",
      "MOVE",
      "OPTIONS",
      "POST",
      "PROPFIND",
      "PROPPATCH",
      "PUT",
      "REPORT",
      "TRACE",
      "UNCHECKOUT",
      "UNLOCK",
      "UPDATE",
      "VERSION_CONTROL"
    ];
  }(H3)), H3;
}
var Hw;
function Qre() {
  if (Hw) return Ul;
  Hw = 1, Ul.__esModule = !0, Ul.curl = void 0;
  var e = Tn(), t = ri(), n = v1();
  return Ul.curl = {
    info: {
      key: "curl",
      title: "cURL",
      link: "http://php.net/manual/en/book.curl.php",
      description: "PHP with ext-curl"
    },
    convert: function(r, i) {
      var a = r.uriObj, o = r.postData, c = r.fullUrl, u = r.method, s = r.httpVersion, f = r.cookies, d = r.headersObj;
      i === void 0 && (i = {});
      var l = i.closingTag, p = l === void 0 ? !1 : l, g = i.indent, v = g === void 0 ? "  " : g, b = i.maxRedirects, y = b === void 0 ? 10 : b, w = i.namedErrors, C = w === void 0 ? !1 : w, T = i.noTags, E = T === void 0 ? !1 : T, D = i.shortTags, $ = D === void 0 ? !1 : D, Z = i.timeout, te = Z === void 0 ? 30 : Z, se = new e.CodeBuilder({ indent: v }), ee = se.push, K = se.blank, re = se.join;
      E || (ee($ ? "<?" : "<?php"), K()), ee("$curl = curl_init();"), K();
      var de = [
        {
          escape: !0,
          name: "CURLOPT_PORT",
          value: a.port
        },
        {
          escape: !0,
          name: "CURLOPT_URL",
          value: c
        },
        {
          escape: !1,
          name: "CURLOPT_RETURNTRANSFER",
          value: "true"
        },
        {
          escape: !0,
          name: "CURLOPT_ENCODING",
          value: ""
        },
        {
          escape: !1,
          name: "CURLOPT_MAXREDIRS",
          value: y
        },
        {
          escape: !1,
          name: "CURLOPT_TIMEOUT",
          value: te
        },
        {
          escape: !1,
          name: "CURLOPT_HTTP_VERSION",
          value: s === "HTTP/1.0" ? "CURL_HTTP_VERSION_1_0" : "CURL_HTTP_VERSION_1_1"
        },
        {
          escape: !0,
          name: "CURLOPT_CUSTOMREQUEST",
          value: u
        },
        {
          escape: !o.jsonObj,
          name: "CURLOPT_POSTFIELDS",
          value: o ? o.jsonObj ? "json_encode(".concat((0, n.convertType)(o.jsonObj, v.repeat(2), v), ")") : o.text : void 0
        }
      ];
      ee("curl_setopt_array($curl, [");
      var ie = new e.CodeBuilder({ indent: v, join: `
`.concat(v) });
      de.forEach(function(Pe) {
        var Le = Pe.value, Ae = Pe.name, He = Pe.escape;
        Le != null && ie.push("".concat(Ae, " => ").concat(He ? JSON.stringify(Le) : Le, ","));
      });
      var me = f.map(function(Pe) {
        return "".concat(encodeURIComponent(Pe.name), "=").concat(encodeURIComponent(Pe.value));
      });
      me.length && ie.push('CURLOPT_COOKIE => "'.concat(me.join("; "), '",'));
      var $e = Object.keys(d).sort().map(function(Pe) {
        return '"'.concat(Pe, ": ").concat((0, t.escapeForDoubleQuotes)(d[Pe]), '"');
      });
      return $e.length && (ie.push("CURLOPT_HTTPHEADER => ["), ie.push($e.join(`,
`.concat(v).concat(v)), 1), ie.push("],")), ee(ie.join(), 1), ee("]);"), K(), ee("$response = curl_exec($curl);"), ee("$err = curl_error($curl);"), K(), ee("curl_close($curl);"), K(), ee("if ($err) {"), ee(C ? 'echo array_flip(get_defined_constants(true)["curl"])[$err];' : 'echo "cURL Error #:" . $err;', 1), ee("} else {"), ee("echo $response;", 1), ee("}"), !E && p && (K(), ee("?>")), re();
    }
  }, Ul;
}
var nu = {}, zw;
function Xre() {
  if (zw) return nu;
  zw = 1;
  var e = nu && nu.__assign || function() {
    return e = Object.assign || function(a) {
      for (var o, c = 1, u = arguments.length; c < u; c++) {
        o = arguments[c];
        for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (a[s] = o[s]);
      }
      return a;
    }, e.apply(this, arguments);
  };
  nu.__esModule = !0, nu.guzzle = void 0;
  var t = Tn(), n = ri(), r = Wi(), i = v1();
  return nu.guzzle = {
    info: {
      key: "guzzle",
      title: "Guzzle",
      link: "http://docs.guzzlephp.org/en/stable/",
      description: "PHP with Guzzle"
    },
    convert: function(a, o) {
      var c, u = a.postData, s = a.fullUrl, f = a.method, d = a.cookies, l = a.headersObj, p = e({ closingTag: !1, indent: "  ", noTags: !1, shortTags: !1 }, o), g = new t.CodeBuilder({ indent: p.indent }), v = g.push, b = g.blank, y = g.join, w = new t.CodeBuilder({ indent: p.indent }), C = w.code, T = w.push, E = w.join;
      switch (p.noTags || (v(p.shortTags ? "<?" : "<?php"), b()), u.mimeType) {
        case "application/x-www-form-urlencoded":
          T("'form_params' => ".concat((0, i.convertType)(u.paramsObj, p.indent + p.indent, p.indent), ","), 1);
          break;
        case "multipart/form-data": {
          var D = [];
          if (u.params && u.params.forEach(function(se) {
            if (se.fileName) {
              var ee = {
                name: se.name,
                filename: se.fileName,
                contents: se.value
              };
              se.contentType && (ee.headers = { "Content-Type": se.contentType }), D.push(ee);
            } else se.value && D.push({
              name: se.name,
              contents: se.value
            });
          }), D.length && (T("'multipart' => ".concat((0, i.convertType)(D, p.indent + p.indent, p.indent)), 1), (0, r.hasHeader)(l, "content-type") && !((c = (0, r.getHeader)(l, "content-type")) === null || c === void 0) && c.indexOf("boundary"))) {
            var $ = (0, r.getHeaderName)(l, "content-type");
            $ && delete l[$];
          }
          break;
        }
        default:
          u.text && T("'body' => ".concat((0, i.convertType)(u.text), ","), 1);
      }
      var Z = Object.keys(l).sort().map(function(se) {
        return "".concat(p.indent).concat(p.indent, "'").concat(se, "' => '").concat((0, n.escapeForSingleQuotes)(l[se]), "',");
      }), te = d.map(function(se) {
        return "".concat(encodeURIComponent(se.name), "=").concat(encodeURIComponent(se.value));
      }).join("; ");
      return te.length && Z.push("".concat(p.indent).concat(p.indent, "'cookie' => '").concat((0, n.escapeForSingleQuotes)(te), "',")), Z.length && (T("'headers' => [", 1), T(Z.join(`
`)), T("],", 1)), v("$client = new \\GuzzleHttp\\Client();"), b(), C.length ? (v("$response = $client->request('".concat(f, "', '").concat(s, "', [")), v(E()), v("]);")) : v("$response = $client->request('".concat(f, "', '").concat(s, "');")), b(), v("echo $response->getBody();"), !p.noTags && p.closingTag && (b(), v("?>")), y();
    }
  }, nu;
}
var Hl = {}, Gw;
function ene() {
  if (Gw) return Hl;
  Gw = 1, Hl.__esModule = !0, Hl.http1 = void 0;
  var e = Tn(), t = v1();
  return Hl.http1 = {
    info: {
      key: "http1",
      title: "HTTP v1",
      link: "http://php.net/manual/en/book.http.php",
      description: "PHP with pecl/http v1"
    },
    convert: function(n, r) {
      var i = n.method, a = n.url, o = n.postData, c = n.queryObj, u = n.headersObj, s = n.cookiesObj;
      r === void 0 && (r = {});
      var f = r.closingTag, d = f === void 0 ? !1 : f, l = r.indent, p = l === void 0 ? "  " : l, g = r.noTags, v = g === void 0 ? !1 : g, b = r.shortTags, y = b === void 0 ? !1 : b, w = new e.CodeBuilder({ indent: p }), C = w.push, T = w.blank, E = w.join;
      switch (v || (C(y ? "<?" : "<?php"), T()), t.supportedMethods.includes(i.toUpperCase()) || C("HttpRequest::methodRegister('".concat(i, "');")), C("$request = new HttpRequest();"), C("$request->setUrl(".concat((0, t.convertType)(a), ");")), t.supportedMethods.includes(i.toUpperCase()) ? C("$request->setMethod(HTTP_METH_".concat(i.toUpperCase(), ");")) : C("$request->setMethod(HttpRequest::HTTP_METH_".concat(i.toUpperCase(), ");")), T(), Object.keys(c).length && (C("$request->setQueryData(".concat((0, t.convertType)(c, p), ");")), T()), Object.keys(u).length && (C("$request->setHeaders(".concat((0, t.convertType)(u, p), ");")), T()), Object.keys(s).length && (C("$request->setCookies(".concat((0, t.convertType)(s, p), ");")), T()), o.mimeType) {
        case "application/x-www-form-urlencoded":
          C("$request->setContentType(".concat((0, t.convertType)(o.mimeType), ");")), C("$request->setPostFields(".concat((0, t.convertType)(o.paramsObj, p), ");")), T();
          break;
        case "application/json":
          C("$request->setContentType(".concat((0, t.convertType)(o.mimeType), ");")), C("$request->setBody(json_encode(".concat((0, t.convertType)(o.jsonObj, p), "));")), T();
          break;
        default:
          o.text && (C("$request->setBody(".concat((0, t.convertType)(o.text), ");")), T());
      }
      return C("try {"), C("$response = $request->send();", 1), T(), C("echo $response->getBody();", 1), C("} catch (HttpException $ex) {"), C("echo $ex;", 1), C("}"), !v && d && (T(), C("?>")), E();
    }
  }, Hl;
}
var zl = {}, Vw;
function tne() {
  if (Vw) return zl;
  Vw = 1, zl.__esModule = !0, zl.http2 = void 0;
  var e = Tn(), t = Wi(), n = v1();
  return zl.http2 = {
    info: {
      key: "http2",
      title: "HTTP v2",
      link: "http://devel-m6w6.rhcloud.com/mdref/http",
      description: "PHP with pecl/http v2"
    },
    convert: function(r, i) {
      var a, o = r.postData, c = r.headersObj, u = r.method, s = r.queryObj, f = r.cookiesObj, d = r.url;
      i === void 0 && (i = {});
      var l = i.closingTag, p = l === void 0 ? !1 : l, g = i.indent, v = g === void 0 ? "  " : g, b = i.noTags, y = b === void 0 ? !1 : b, w = i.shortTags, C = w === void 0 ? !1 : w, T = new e.CodeBuilder({ indent: v }), E = T.push, D = T.blank, $ = T.join, Z = !1;
      switch (y || (E(C ? "<?" : "<?php"), D()), E("$client = new http\\Client;"), E("$request = new http\\Client\\Request;"), D(), o.mimeType) {
        case "application/x-www-form-urlencoded":
          E("$body = new http\\Message\\Body;"), E("$body->append(new http\\QueryString(".concat((0, n.convertType)(o.paramsObj, v), "));")), D(), Z = !0;
          break;
        case "multipart/form-data": {
          if (!o.params)
            break;
          var te = [], se = {};
          o.params.forEach(function(de) {
            var ie = de.name, me = de.fileName, $e = de.value, Pe = de.contentType;
            if (me) {
              te.push({
                name: ie,
                type: Pe,
                file: me,
                data: $e
              });
              return;
            }
            $e && (se[ie] = $e);
          });
          var ee = Object.keys(se).length ? (0, n.convertType)(se, v) : "null", K = te.length ? (0, n.convertType)(te, v) : "null";
          if (E("$body = new http\\Message\\Body;"), E("$body->addForm(".concat(ee, ", ").concat(K, ");")), (0, t.hasHeader)(c, "content-type") && !((a = (0, t.getHeader)(c, "content-type")) === null || a === void 0) && a.indexOf("boundary")) {
            var re = (0, t.getHeaderName)(c, "content-type");
            re && delete c[re];
          }
          D(), Z = !0;
          break;
        }
        case "application/json":
          E("$body = new http\\Message\\Body;"), E("$body->append(json_encode(".concat((0, n.convertType)(o.jsonObj, v), "));")), Z = !0;
          break;
        default:
          o.text && (E("$body = new http\\Message\\Body;"), E("$body->append(".concat((0, n.convertType)(o.text), ");")), D(), Z = !0);
      }
      return E("$request->setRequestUrl(".concat((0, n.convertType)(d), ");")), E("$request->setRequestMethod(".concat((0, n.convertType)(u), ");")), Z && (E("$request->setBody($body);"), D()), Object.keys(s).length && (E("$request->setQuery(new http\\QueryString(".concat((0, n.convertType)(s, v), "));")), D()), Object.keys(c).length && (E("$request->setHeaders(".concat((0, n.convertType)(c, v), ");")), D()), Object.keys(f).length && (D(), E("$client->setCookies(".concat((0, n.convertType)(f, v), ");")), D()), E("$client->enqueue($request)->send();"), E("$response = $client->getResponse();"), D(), E("echo $response->getBody();"), !y && p && (D(), E("?>")), $();
    }
  }, zl;
}
var Ww;
function rne() {
  if (Ww) return Bl;
  Ww = 1, Bl.__esModule = !0, Bl.php = void 0;
  var e = Qre(), t = Xre(), n = ene(), r = tne();
  return Bl.php = {
    info: {
      key: "php",
      title: "PHP",
      extname: ".php",
      default: "curl"
    },
    clientsById: {
      curl: e.curl,
      guzzle: t.guzzle,
      http1: n.http1,
      http2: r.http2
    }
  }, Bl;
}
var Gl = {}, Vl = {}, Wl = {}, Kw;
function VO() {
  if (Kw) return Wl;
  Kw = 1, Wl.__esModule = !0, Wl.generatePowershellConvert = void 0;
  var e = Tn(), t = ri(), n = Wi(), r = function(i) {
    var a = function(o) {
      var c = o.method, u = o.headersObj, s = o.cookies, f = o.uriObj, d = o.fullUrl, l = o.postData, p = o.allHeaders, g = new e.CodeBuilder(), v = g.push, b = g.join, y = [
        "DEFAULT",
        "DELETE",
        "GET",
        "HEAD",
        "MERGE",
        "OPTIONS",
        "PATCH",
        "POST",
        "PUT",
        "TRACE"
      ], w = y.includes(c.toUpperCase()) ? "-Method" : "-CustomMethod", C = [], T = Object.keys(u);
      return T.length && (v("$headers=@{}"), T.forEach(function(E) {
        E !== "connection" && v('$headers.Add("'.concat(E, '", "').concat((0, t.escapeString)(u[E], { escapeChar: "`" }), '")'));
      }), C.push("-Headers $headers")), s.length && (v("$session = New-Object Microsoft.PowerShell.Commands.WebRequestSession"), s.forEach(function(E) {
        v("$cookie = New-Object System.Net.Cookie"), v("$cookie.Name = '".concat(E.name, "'")), v("$cookie.Value = '".concat(E.value, "'")), v("$cookie.Domain = '".concat(f.host, "'")), v("$session.Cookies.Add($cookie)");
      }), C.push("-WebSession $session")), l.text && (C.push("-ContentType '".concat((0, t.escapeString)((0, n.getHeader)(p, "content-type"), {
        delimiter: "'",
        escapeChar: "`"
      }), "'")), C.push("-Body '".concat(l.text, "'"))), v("$response = ".concat(i, " -Uri '").concat(d, "' ").concat(w, " ").concat(c, " ").concat(C.join(" "))), b();
    };
    return a;
  };
  return Wl.generatePowershellConvert = r, Wl;
}
var Zw;
function nne() {
  if (Zw) return Vl;
  Zw = 1, Vl.__esModule = !0, Vl.restmethod = void 0;
  var e = VO();
  return Vl.restmethod = {
    info: {
      key: "restmethod",
      title: "Invoke-RestMethod",
      link: "https://docs.microsoft.com/en-us/powershell/module/Microsoft.PowerShell.Utility/Invoke-RestMethod",
      description: "Powershell Invoke-RestMethod client"
    },
    convert: (0, e.generatePowershellConvert)("Invoke-RestMethod")
  }, Vl;
}
var Kl = {}, Yw;
function ine() {
  if (Yw) return Kl;
  Yw = 1, Kl.__esModule = !0, Kl.webrequest = void 0;
  var e = VO();
  return Kl.webrequest = {
    info: {
      key: "webrequest",
      title: "Invoke-WebRequest",
      link: "https://docs.microsoft.com/en-us/powershell/module/Microsoft.PowerShell.Utility/Invoke-WebRequest",
      description: "Powershell Invoke-WebRequest client"
    },
    convert: (0, e.generatePowershellConvert)("Invoke-WebRequest")
  }, Kl;
}
var Jw;
function ane() {
  if (Jw) return Gl;
  Jw = 1, Gl.__esModule = !0, Gl.powershell = void 0;
  var e = nne(), t = ine();
  return Gl.powershell = {
    info: {
      key: "powershell",
      title: "Powershell",
      extname: ".ps1",
      default: "webrequest"
    },
    clientsById: {
      webrequest: t.webrequest,
      restmethod: e.restmethod
    }
  }, Gl;
}
var Zl = {}, Yl = {}, Qw;
function one() {
  if (Qw) return Yl;
  Qw = 1, Yl.__esModule = !0, Yl.python3 = void 0;
  var e = Tn(), t = ri();
  return Yl.python3 = {
    info: {
      key: "python3",
      title: "http.client",
      link: "https://docs.python.org/3/library/http.client.html",
      description: "Python3 HTTP Client"
    },
    convert: function(n, r) {
      var i = n.uriObj, a = i.path, o = i.protocol, c = i.host, u = n.postData, s = n.allHeaders, f = n.method;
      r === void 0 && (r = {});
      var d = r.insecureSkipVerify, l = d === void 0 ? !1 : d, p = new e.CodeBuilder(), g = p.push, v = p.blank, b = p.join;
      if (g("import http.client"), l && g("import ssl"), v(), o === "https:") {
        var y = l ? ", context = ssl._create_unverified_context()" : "";
        g('conn = http.client.HTTPSConnection("'.concat(c, '"').concat(y, ")")), v();
      } else
        g('conn = http.client.HTTPConnection("'.concat(c, '")')), v();
      var w = JSON.stringify(u.text);
      w && (g("payload = ".concat(w)), v());
      var C = s, T = Object.keys(C).length;
      if (T === 1)
        for (var E in C)
          g("headers = { '".concat(E, `': "`).concat((0, t.escapeForDoubleQuotes)(C[E]), '" }')), v();
      else if (T > 1) {
        var D = 1;
        g("headers = {");
        for (var E in C)
          D++ !== T ? g("    '".concat(E, `': "`).concat((0, t.escapeForDoubleQuotes)(C[E]), '",')) : g("    '".concat(E, `': "`).concat((0, t.escapeForDoubleQuotes)(C[E]), '"'));
        g("}"), v();
      }
      return g(w && T ? 'conn.request("'.concat(f, '", "').concat(a, '", payload, headers)') : w && !T ? 'conn.request("'.concat(f, '", "').concat(a, '", payload)') : !w && T ? 'conn.request("'.concat(f, '", "').concat(a, '", headers=headers)') : 'conn.request("'.concat(f, '", "').concat(a, '")')), v(), g("res = conn.getresponse()"), g("data = res.read()"), v(), g('print(data.decode("utf-8"))'), b();
    }
  }, Yl;
}
var iu = {}, z3 = {}, Xw;
function sne() {
  return Xw || (Xw = 1, function(e) {
    e.__esModule = !0, e.literalRepresentation = void 0;
    function t(r, i, a, o, c) {
      var u = o.repeat(c), s = o.repeat(c - 1), f = a ? `,
`.concat(u) : ", ", d = r === "object" ? "{" : "[", l = r === "object" ? "}" : "]";
      return a ? "".concat(d, `
`).concat(u).concat(i.join(f), `
`).concat(s).concat(l) : r === "object" && i.length > 0 ? "".concat(d, " ").concat(i.join(f), " ").concat(l) : "".concat(d).concat(i.join(f)).concat(l);
    }
    var n = function(r, i, a) {
      switch (a = a === void 0 ? 1 : a + 1, Object.prototype.toString.call(r)) {
        case "[object Number]":
          return r;
        case "[object Array]": {
          var o = !1, c = r.map(function(f) {
            return Object.prototype.toString.call(f) === "[object Object]" && (o = Object.keys(f).length > 1), (0, e.literalRepresentation)(f, i, a);
          });
          return t("array", c, o, i.indent, a);
        }
        case "[object Object]": {
          var u = [];
          for (var s in r)
            u.push('"'.concat(s, '": ').concat((0, e.literalRepresentation)(r[s], i, a)));
          return t("object", u, i.pretty && u.length > 1, i.indent, a);
        }
        case "[object Null]":
          return "None";
        case "[object Boolean]":
          return r ? "True" : "False";
        default:
          return r == null ? "" : '"'.concat(r.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = n;
  }(z3)), z3;
}
var eS;
function une() {
  if (eS) return iu;
  eS = 1;
  var e = iu && iu.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (o[f] = c[f]);
      }
      return o;
    }, e.apply(this, arguments);
  };
  iu.__esModule = !0, iu.requests = void 0;
  var t = Tn(), n = ri(), r = Wi(), i = sne(), a = ["HEAD", "GET", "POST", "PUT", "PATCH", "DELETE", "OPTIONS"];
  return iu.requests = {
    info: {
      key: "requests",
      title: "Requests",
      link: "http://docs.python-requests.org/en/latest/api/#requests.request",
      description: "Requests HTTP library"
    },
    convert: function(o, c) {
      var u = o.queryObj, s = o.url, f = o.postData, d = o.allHeaders, l = o.method, p = e({ indent: "    ", pretty: !0 }, c), g = new t.CodeBuilder({ indent: p.indent }), v = g.push, b = g.blank, y = g.join;
      v("import requests"), b(), v('url = "'.concat(s, '"')), b();
      var w;
      Object.keys(u).length && (w = "querystring = ".concat(JSON.stringify(u)), v(w), b());
      var C = d, T = {}, E = {}, D = !1, $ = !1, Z = !1;
      switch (f.mimeType) {
        case "application/json":
          f.jsonObj && (v("payload = ".concat((0, i.literalRepresentation)(f.jsonObj, p))), Z = !0, $ = !0);
          break;
        case "multipart/form-data":
          if (!f.params)
            break;
          if (T = {}, f.params.forEach(function(me) {
            me.fileName ? (E[me.name] = "open('".concat(me.fileName, "', 'rb')"), D = !0) : (T[me.name] = me.value, $ = !0);
          }), D) {
            v("files = ".concat((0, i.literalRepresentation)(E, p))), $ && v("payload = ".concat((0, i.literalRepresentation)(T, p)));
            var te = (0, r.getHeaderName)(C, "content-type");
            te && delete C[te];
          } else {
            var se = JSON.stringify(f.text);
            se && (v("payload = ".concat(se)), $ = !0);
          }
          break;
        default: {
          if (f.mimeType === "application/x-www-form-urlencoded" && f.paramsObj) {
            v("payload = ".concat((0, i.literalRepresentation)(f.paramsObj, p))), $ = !0;
            break;
          }
          var ee = JSON.stringify(f.text);
          ee && (v("payload = ".concat(ee)), $ = !0);
        }
      }
      var K = Object.keys(C).length;
      if (K === 0 && ($ || D))
        b();
      else if (K === 1)
        for (var re in C)
          v('headers = {"'.concat(re, '": "').concat((0, n.escapeForDoubleQuotes)(C[re]), '"}')), b();
      else if (K > 1) {
        var de = 1;
        v("headers = {");
        for (var re in C)
          v(de !== K ? '"'.concat(re, '": "').concat((0, n.escapeForDoubleQuotes)(C[re]), '",') : '"'.concat(re, '": "').concat((0, n.escapeForDoubleQuotes)(C[re]), '"'), 1), de += 1;
        v("}"), b();
      }
      var ie = a.includes(l) ? "response = requests.".concat(l.toLowerCase(), "(url") : 'response = requests.request("'.concat(l, '", url');
      return $ && (Z ? ie += ", json=payload" : ie += ", data=payload"), D && (ie += ", files=files"), K > 0 && (ie += ", headers=headers"), w && (ie += ", params=querystring"), ie += ")", v(ie), b(), v("print(response.json())"), y();
    }
  }, iu;
}
var tS;
function cne() {
  if (tS) return Zl;
  tS = 1, Zl.__esModule = !0, Zl.python = void 0;
  var e = one(), t = une();
  return Zl.python = {
    info: {
      key: "python",
      title: "Python",
      extname: ".py",
      default: "python3"
    },
    clientsById: {
      python3: e.python3,
      requests: t.requests
    }
  }, Zl;
}
var Jl = {}, au = {}, rS;
function lne() {
  if (rS) return au;
  rS = 1;
  var e = au && au.__read || function(i, a) {
    var o = typeof Symbol == "function" && i[Symbol.iterator];
    if (!o) return i;
    var c = o.call(i), u, s = [], f;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) s.push(u.value);
    } catch (d) {
      f = { error: d };
    } finally {
      try {
        u && !u.done && (o = c.return) && o.call(c);
      } finally {
        if (f) throw f.error;
      }
    }
    return s;
  };
  au.__esModule = !0, au.httr = void 0;
  var t = Tn(), n = ri(), r = Wi();
  return au.httr = {
    info: {
      key: "httr",
      title: "httr",
      link: "https://cran.r-project.org/web/packages/httr/vignettes/quickstart.html",
      description: "httr: Tools for Working with URLs and HTTP"
    },
    convert: function(i, a) {
      var o, c = i.url, u = i.queryObj, s = i.queryString, f = i.postData, d = i.allHeaders, l = i.method;
      a === void 0 && (a = {});
      var p = new t.CodeBuilder({
        indent: (o = a.indent) !== null && o !== void 0 ? o : "  "
      }), g = p.push, v = p.blank, b = p.join;
      g("library(httr)"), v(), g('url <- "'.concat(c, '"')), v();
      var y = u;
      delete u.key;
      var w = Object.entries(y), C = w.length;
      if (C === 1) {
        var T = w[0];
        g("queryString <- list(".concat(T[0], ' = "').concat(T[1], '")')), v();
      } else C > 1 && (g("queryString <- list("), w.forEach(function(ie, me) {
        var $e = e(ie, 2), Pe = $e[0], Le = $e[1], Ae = me !== C - 1, He = Ae ? "," : "";
        g("".concat(Pe, ' = "').concat(Le, '"').concat(He), 1);
      }), g(")"), v());
      var E = JSON.stringify(f.text);
      if (E && (g("payload <- ".concat(E)), v()), f.text || f.jsonObj || f.params)
        switch (f.mimeType) {
          case "application/x-www-form-urlencoded":
            g('encode <- "form"'), v();
            break;
          case "application/json":
            g('encode <- "json"'), v();
            break;
          case "multipart/form-data":
            g('encode <- "multipart"'), v();
            break;
          default:
            g('encode <- "raw"'), v();
            break;
        }
      var D = (0, r.getHeader)(d, "cookie"), $ = (0, r.getHeader)(d, "accept"), Z = D ? "set_cookies(`".concat(String(D).replace(/;/g, '", `').replace(/` /g, "`").replace(/[=]/g, '` = "'), '")') : void 0, te = $ ? 'accept("'.concat((0, n.escapeForDoubleQuotes)($), '")') : void 0, se = 'content_type("'.concat((0, n.escapeForDoubleQuotes)(f.mimeType), '")'), ee = Object.entries(d).filter(function(ie) {
        var me = e(ie, 1), $e = me[0];
        return !["cookie", "accept", "content-type"].includes($e.toLowerCase());
      }).map(function(ie) {
        var me = e(ie, 2), $e = me[0], Pe = me[1];
        return "'".concat($e, "' = '").concat((0, n.escapeForSingleQuotes)(Pe), "'");
      }).join(", "), K = ee ? "add_headers(".concat(ee, ")") : void 0, re = 'response <- VERB("'.concat(l, '", url');
      E && (re += ", body = payload"), s.length && (re += ", query = queryString");
      var de = [K, se, te, Z].filter(function(ie) {
        return !!ie;
      }).join(", ");
      return de && (re += ", ".concat(de)), (f.text || f.jsonObj || f.params) && (re += ", encode = encode"), re += ")", g(re), v(), g('content(response, "text")'), b();
    }
  }, au;
}
var nS;
function fne() {
  if (nS) return Jl;
  nS = 1, Jl.__esModule = !0, Jl.r = void 0;
  var e = lne();
  return Jl.r = {
    info: {
      key: "r",
      title: "R",
      extname: ".r",
      default: "httr"
    },
    clientsById: {
      httr: e.httr
    }
  }, Jl;
}
var Ql = {}, Xl = {}, iS;
function pne() {
  if (iS) return Xl;
  iS = 1, Xl.__esModule = !0, Xl.faraday = void 0;
  var e = Tn(), t = ri();
  return Xl.faraday = {
    info: {
      key: "faraday",
      title: "faraday",
      link: "https://github.com/lostisland/faraday",
      description: "Faraday HTTP client"
    },
    convert: function(n) {
      var r = n.uriObj, i = n.queryObj, a = n.method, o = n.postData, c = n.allHeaders, u = new e.CodeBuilder(), s = u.push, f = u.blank, d = u.join, l = a.toUpperCase(), p = [
        "GET",
        "POST",
        "HEAD",
        "DELETE",
        "PATCH",
        "PUT",
        "OPTIONS",
        "COPY",
        "LOCK",
        "UNLOCK",
        "MOVE",
        "TRACE"
      ];
      if (!p.includes(l))
        return s("# Faraday cannot currently run ".concat(l, " requests. Please use another client.")), d();
      s("require 'faraday'"), f(), o.mimeType === "application/x-www-form-urlencoded" && o.params && (s("data = {"), o.params.forEach(function(v) {
        s("  :".concat(v.name, " => ").concat(JSON.stringify(v.value), ","));
      }), s("}"), f()), s("conn = Faraday.new("), s("  url: '".concat(r.protocol, "//").concat(r.host, "',")), (c["content-type"] || c["Content-Type"]) && s("  headers: {'Content-Type' => '".concat(c["content-type"] || c["Content-Type"], "'}")), s(")"), f(), s("response = conn.".concat(l.toLowerCase(), "('").concat(r.pathname, "') do |req|"));
      var g = Object.keys(c);
      switch (g.length && g.forEach(function(v) {
        v.toLowerCase() !== "content-type" && s("  req.headers['".concat(v, "'] = '").concat((0, t.escapeForSingleQuotes)(c[v]), "'"));
      }), Object.keys(i).forEach(function(v) {
        var b = i[v];
        Array.isArray(b) ? s("  req.params['".concat(v, "'] = ").concat(JSON.stringify(b))) : s("  req.params['".concat(v, "'] = '").concat(b, "'"));
      }), o.mimeType) {
        case "application/x-www-form-urlencoded":
          o.params && s("  req.body = URI.encode_www_form(data)");
          break;
        case "application/json":
          o.jsonObj && s("  req.body = ".concat(JSON.stringify(o.text)));
          break;
        default:
          o.text && s("  req.body = ".concat(JSON.stringify(o.text)));
      }
      return s("end"), f(), s("puts response.status"), s("puts response.body"), d();
    }
  }, Xl;
}
var ef = {}, aS;
function dne() {
  if (aS) return ef;
  aS = 1, ef.__esModule = !0, ef.native = void 0;
  var e = Tn(), t = ri();
  return ef.native = {
    info: {
      key: "native",
      title: "net::http",
      link: "http://ruby-doc.org/stdlib-2.2.1/libdoc/net/http/rdoc/Net/HTTP.html",
      description: "Ruby HTTP client"
    },
    convert: function(n, r) {
      var i = n.uriObj, a = n.method, o = n.fullUrl, c = n.postData, u = n.allHeaders;
      r === void 0 && (r = {});
      var s = r.insecureSkipVerify, f = s === void 0 ? !1 : s, d = new e.CodeBuilder(), l = d.push, p = d.blank, g = d.join;
      l("require 'uri'"), l("require 'net/http'"), p();
      var v = a.toUpperCase(), b = [
        "GET",
        "POST",
        "HEAD",
        "DELETE",
        "PATCH",
        "PUT",
        "OPTIONS",
        "COPY",
        "LOCK",
        "UNLOCK",
        "MOVE",
        "TRACE"
      ], y = v.charAt(0) + v.substring(1).toLowerCase();
      b.includes(v) || (l("class Net::HTTP::".concat(y, " < Net::HTTPRequest")), l("  METHOD = '".concat(v.toUpperCase(), "'")), l("  REQUEST_HAS_BODY = '".concat(c.text ? "true" : "false", "'")), l("  RESPONSE_HAS_BODY = true"), l("end"), p()), l('url = URI("'.concat(o, '")')), p(), l("http = Net::HTTP.new(url.host, url.port)"), i.protocol === "https:" && (l("http.use_ssl = true"), f && l("http.verify_mode = OpenSSL::SSL::VERIFY_NONE")), p(), l("request = Net::HTTP::".concat(y, ".new(url)"));
      var w = Object.keys(u);
      return w.length && w.forEach(function(C) {
        l('request["'.concat(C, `"] = '`).concat((0, t.escapeForSingleQuotes)(u[C]), "'"));
      }), c.text && l("request.body = ".concat(JSON.stringify(c.text))), p(), l("response = http.request(request)"), l("puts response.read_body"), g();
    }
  }, ef;
}
var oS;
function hne() {
  if (oS) return Ql;
  oS = 1, Ql.__esModule = !0, Ql.ruby = void 0;
  var e = pne(), t = dne();
  return Ql.ruby = {
    info: {
      key: "ruby",
      title: "Ruby",
      extname: ".rb",
      default: "native"
    },
    clientsById: {
      native: t.native,
      faraday: e.faraday
    }
  }, Ql;
}
var tf = {}, Ka = {}, G3 = {}, sS;
function mne() {
  return sS || (sS = 1, function(e) {
    e.__esModule = !0, e.literalRepresentation = void 0;
    function t(r, i, a, o, c) {
      var u = o.repeat(c), s = o.repeat(c - 1), f = a ? `,
`.concat(u) : ", ", d = r === "object" ? "json!({" : "(", l = r === "object" ? "})" : ")";
      return a ? "".concat(d, `
`).concat(u).concat(i.join(f), `
`).concat(s).concat(l) : "".concat(d).concat(i.join(f)).concat(l);
    }
    var n = function(r, i, a) {
      switch (a = a === void 0 ? 1 : a + 1, Object.prototype.toString.call(r)) {
        case "[object Number]":
          return r;
        case "[object Array]": {
          var o = !1, c = r.map(function(f) {
            return Object.prototype.toString.call(f) === "[object Object]" && (o = Object.keys(f).length > 1), (0, e.literalRepresentation)(f, i, a);
          });
          return t("array", c, o, i.indent, a);
        }
        case "[object Object]": {
          var u = [];
          for (var s in r)
            u.push('"'.concat(s, '": ').concat((0, e.literalRepresentation)(r[s], i, a)));
          return t("object", u, i.pretty && u.length > 1, i.indent, a);
        }
        case "[object Null]":
          return "json!(null)";
        case "[object Boolean]":
          return r ? "true" : "false";
        default:
          return r == null ? "" : '"'.concat(r.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = n;
  }(G3)), G3;
}
var uS;
function gne() {
  if (uS) return Ka;
  uS = 1;
  var e = Ka && Ka.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (o[f] = c[f]);
      }
      return o;
    }, e.apply(this, arguments);
  }, t = Ka && Ka.__values || function(o) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = c && o[c], s = 0;
    if (u) return u.call(o);
    if (o && typeof o.length == "number") return {
      next: function() {
        return o && s >= o.length && (o = void 0), { value: o && o[s++], done: !o };
      }
    };
    throw new TypeError(c ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }, n = Ka && Ka.__read || function(o, c) {
    var u = typeof Symbol == "function" && o[Symbol.iterator];
    if (!u) return o;
    var s = u.call(o), f, d = [], l;
    try {
      for (; (c === void 0 || c-- > 0) && !(f = s.next()).done; ) d.push(f.value);
    } catch (p) {
      l = { error: p };
    } finally {
      try {
        f && !f.done && (u = s.return) && u.call(s);
      } finally {
        if (l) throw l.error;
      }
    }
    return d;
  };
  Ka.__esModule = !0, Ka.reqwest = void 0;
  var r = Tn(), i = mne();
  Ka.reqwest = {
    info: {
      key: "reqwest",
      title: "reqwest",
      link: "https://docs.rs/reqwest/latest/reqwest/",
      description: "reqwest HTTP library"
    },
    convert: function(o, c) {
      var u, s, f, d, l, p, g, v, b, y, w = o.queryObj, C = o.url, T = o.postData, E = o.allHeaders, D = o.method, $ = e({ indent: "    ", pretty: !0 }, c), Z = 0, te = new r.CodeBuilder({ indent: $.indent }), se = te.push, ee = te.blank, K = te.join, re = te.pushToLast, de = te.unshift;
      se("use reqwest;", Z), ee(), se("#[tokio::main]", Z), se("pub async fn main() {", Z), Z += 1, se('let url = "'.concat(C, '";'), Z), ee();
      var ie = !1;
      if (Object.keys(w).length) {
        ie = !0, se("let querystring = [", Z), Z += 1;
        try {
          for (var me = t(Object.entries(w)), $e = me.next(); !$e.done; $e = me.next()) {
            var Pe = n($e.value, 2), Le = Pe[0], Ae = Pe[1];
            se('("'.concat(Le, '", "').concat(Ae, '"),'), Z);
          }
        } catch (Me) {
          u = { error: Me };
        } finally {
          try {
            $e && !$e.done && (s = me.return) && s.call(me);
          } finally {
            if (u) throw u.error;
          }
        }
        Z -= 1, se("];", Z), ee();
      }
      var He = {}, Te = {}, we = !1, qe = !1, Ge = !1, It = !1, Qe = !1;
      switch (T.mimeType) {
        case "application/json":
          T.jsonObj && se("let payload = ".concat((0, i.literalRepresentation)(T.jsonObj, $, Z), ";"), Z), It = !0;
          break;
        case "multipart/form-data":
          if (Qe = !0, !T.params) {
            se("let form = reqwest::multipart::Form::new()", Z), se('.text("", "");', Z + 1);
            break;
          }
          if (He = {}, T.params.forEach(function(Me) {
            Me.fileName ? (Te[Me.name] = Me.fileName, we = !0) : He[Me.name] = Me.value;
          }), we) {
            try {
              for (var jt = t(a), We = jt.next(); !We.done; We = jt.next()) {
                var Lt = We.value;
                se(Lt, Z);
              }
            } catch (Me) {
              f = { error: Me };
            } finally {
              try {
                We && !We.done && (d = jt.return) && d.call(jt);
              } finally {
                if (f) throw f.error;
              }
            }
            ee();
          }
          se("let form = reqwest::multipart::Form::new()", Z);
          try {
            for (var Fe = t(Object.entries(Te)), Ze = Fe.next(); !Ze.done; Ze = Fe.next()) {
              var Ue = n(Ze.value, 2), Rt = Ue[0], Vr = Ue[1];
              se('.part("'.concat(Rt, '", file_to_part("').concat(Vr, '").await)'), Z + 1);
            }
          } catch (Me) {
            l = { error: Me };
          } finally {
            try {
              Ze && !Ze.done && (p = Fe.return) && p.call(Fe);
            } finally {
              if (l) throw l.error;
            }
          }
          try {
            for (var ye = t(Object.entries(He)), G = ye.next(); !G.done; G = ye.next()) {
              var Y = n(G.value, 2), Rt = Y[0], Ae = Y[1];
              se('.text("'.concat(Rt, '", "').concat(Ae, '")'), Z + 1);
            }
          } catch (Me) {
            g = { error: Me };
          } finally {
            try {
              G && !G.done && (v = ye.return) && v.call(ye);
            } finally {
              if (g) throw g.error;
            }
          }
          re(";");
          break;
        default: {
          if (T.mimeType === "application/x-www-form-urlencoded" && T.paramsObj) {
            se("let payload = ".concat((0, i.literalRepresentation)(T.paramsObj, $, Z), ";"), Z), qe = !0;
            break;
          }
          if (T.text) {
            se("let payload = ".concat((0, i.literalRepresentation)(T.text, $, Z), ";"), Z), Ge = !0;
            break;
          }
        }
      }
      (qe || It || Ge) && (de("use serde_json::json;"), ee());
      var ae = !1;
      if (Object.keys(E).length) {
        ae = !0, se("let mut headers = reqwest::header::HeaderMap::new();", Z);
        try {
          for (var Ee = t(Object.entries(E)), N = Ee.next(); !N.done; N = Ee.next()) {
            var Se = n(N.value, 2), Le = Se[0], Ae = Se[1];
            Le.toLowerCase() === "content-type" && Qe || se('headers.insert("'.concat(Le, '", ').concat((0, i.literalRepresentation)(Ae, $), ".parse().unwrap());"), Z);
          }
        } catch (Me) {
          b = { error: Me };
        } finally {
          try {
            N && !N.done && (y = Ee.return) && y.call(Ee);
          } finally {
            if (b) throw b.error;
          }
        }
        ee();
      }
      switch (se("let client = reqwest::Client::new();", Z), D) {
        case "POST":
          se("let response = client.post(url)", Z);
          break;
        case "GET":
          se("let response = client.get(url)", Z);
          break;
        default: {
          se('let response = client.request(reqwest::Method::from_str("'.concat(D, '").unwrap(), url)'), Z), de("use std::str::FromStr;");
          break;
        }
      }
      return ie && se(".query(&querystring)", Z + 1), Qe && se(".multipart(form)", Z + 1), ae && se(".headers(headers)", Z + 1), It && se(".json(&payload)", Z + 1), qe && se(".form(&payload)", Z + 1), Ge && se(".body(payload)", Z + 1), se(".send()", Z + 1), se(".await;", Z + 1), ee(), se("let results = response.unwrap()", Z), se(".json::<serde_json::Value>()", Z + 1), se(".await", Z + 1), se(".unwrap();", Z + 1), ee(), se("dbg!(results);", Z), se(`}
`), K();
    }
  };
  var a = [
    "async fn file_to_part(file_name: &'static str) -> reqwest::multipart::Part {",
    "    let file = tokio::fs::File::open(file_name).await.unwrap();",
    "    let stream = tokio_util::codec::FramedRead::new(file, tokio_util::codec::BytesCodec::new());",
    "    let body = reqwest::Body::wrap_stream(stream);",
    "    reqwest::multipart::Part::stream(body)",
    "        .file_name(file_name)",
    '        .mime_str("text/plain").unwrap()',
    "}"
  ];
  return Ka;
}
var cS;
function vne() {
  if (cS) return tf;
  cS = 1, tf.__esModule = !0, tf.rust = void 0;
  var e = gne();
  return tf.rust = {
    info: {
      key: "rust",
      title: "Rust",
      extname: ".rs",
      default: "reqwest"
    },
    clientsById: {
      reqwest: e.reqwest
    }
  }, tf;
}
var rf = {}, ou = {}, su = {}, lS;
function Dg() {
  if (lS) return su;
  lS = 1, su.__esModule = !0, su.escape = su.quote = void 0;
  var e = function(n) {
    n === void 0 && (n = "");
    var r = /^[a-z0-9-_/.@%^=:]+$/i, i = r.test(n);
    return i ? n : "'".concat(n.replace(/'/g, "'\\''"), "'");
  };
  su.quote = e;
  var t = function(n) {
    return n.replace(/\r/g, "\\r").replace(/\n/g, "\\n");
  };
  return su.escape = t, su;
}
var fS;
function yne() {
  if (fS) return ou;
  fS = 1;
  var e = ou && ou.__assign || function() {
    return e = Object.assign || function(o) {
      for (var c, u = 1, s = arguments.length; u < s; u++) {
        c = arguments[u];
        for (var f in c) Object.prototype.hasOwnProperty.call(c, f) && (o[f] = c[f]);
      }
      return o;
    }, e.apply(this, arguments);
  };
  ou.__esModule = !0, ou.curl = void 0;
  var t = Tn(), n = Wi(), r = Dg(), i = {
    "http1.0": "0",
    "url ": "",
    cookie: "b",
    data: "d",
    form: "F",
    globoff: "g",
    header: "H",
    insecure: "k",
    request: "X"
  }, a = function(o) {
    return function(c) {
      if (o) {
        var u = i[c];
        return u ? "-".concat(u) : "";
      }
      return "--".concat(c);
    };
  };
  return ou.curl = {
    info: {
      key: "curl",
      title: "cURL",
      link: "http://curl.haxx.se/",
      description: "cURL is a command line tool and library for transferring data with URL syntax"
    },
    convert: function(o, c) {
      var u, s = o.fullUrl, f = o.method, d = o.httpVersion, l = o.headersObj, p = o.allHeaders, g = o.postData;
      c === void 0 && (c = {});
      var v = c.binary, b = v === void 0 ? !1 : v, y = c.globOff, w = y === void 0 ? !1 : y, C = c.indent, T = C === void 0 ? "  " : C, E = c.insecureSkipVerify, D = E === void 0 ? !1 : E, $ = c.prettifyJson, Z = $ === void 0 ? !1 : $, te = c.short, se = te === void 0 ? !1 : te, ee = new t.CodeBuilder(e(e({}, typeof T == "string" ? { indent: T } : {}), { join: T !== !1 ? ` \\
`.concat(T) : " " })), K = ee.push, re = ee.join, de = a(se), ie = (0, r.quote)(s);
      if (K("curl ".concat(de("request"), " ").concat(f)), w && (ie = unescape(ie), K(de("globoff"))), K("".concat(de("url ")).concat(ie)), D && K(de("insecure")), d === "HTTP/1.0" && K(de("http1.0")), (0, n.getHeader)(p, "accept-encoding") && K("--compressed"), g.mimeType === "multipart/form-data") {
        var me = (0, n.getHeaderName)(l, "content-type");
        if (me) {
          var $e = l[me];
          if (me && $e) {
            var Pe = $e.replace(/; boundary.+?(?=(;|$))/, "");
            l[me] = Pe, p[me] = Pe;
          }
        }
      }
      switch (Object.keys(l).sort().forEach(function(qe) {
        var Ge = "".concat(qe, ": ").concat(l[qe]);
        K("".concat(de("header"), " ").concat((0, r.quote)(Ge)));
      }), p.cookie && K("".concat(de("cookie"), " ").concat((0, r.quote)(p.cookie))), g.mimeType) {
        case "multipart/form-data":
          (u = g.params) === null || u === void 0 || u.forEach(function(qe) {
            var Ge = "";
            qe.fileName ? Ge = "".concat(qe.name, "=@").concat(qe.fileName) : Ge = "".concat(qe.name, "=").concat(qe.value), K("".concat(de("form"), " ").concat((0, r.quote)(Ge)));
          });
          break;
        case "application/x-www-form-urlencoded":
          g.params ? g.params.forEach(function(qe) {
            var Ge = qe.name, It = encodeURIComponent(qe.name), Qe = It !== Ge, jt = Qe ? It : Ge, We = b ? "--data-binary" : "--data".concat(Qe ? "-urlencode" : "");
            K("".concat(We, " ").concat((0, r.quote)("".concat(jt, "=").concat(qe.value))));
          }) : K("".concat(b ? "--data-binary" : de("data"), " ").concat((0, r.quote)(g.text)));
          break;
        default: {
          if (!g.text)
            break;
          var Le = b ? "--data-binary" : de("data"), Ae = !1;
          if ((0, n.isMimeTypeJSON)(g.mimeType)) {
            var He = g.text.length > 2;
            if (He && Z)
              try {
                var Te = JSON.parse(g.text);
                Ae = !0;
                var we = JSON.stringify(Te, void 0, T);
                g.text.indexOf("'") > 0 ? K("".concat(Le, ` @- <<EOF
`).concat(we, `
EOF`)) : K("".concat(Le, ` '
`).concat(we, `
'`));
              } catch {
              }
          }
          Ae || K("".concat(Le, " ").concat((0, r.quote)(g.text)));
        }
      }
      return re();
    }
  }, ou;
}
var uu = {}, pS;
function bne() {
  if (pS) return uu;
  pS = 1;
  var e = uu && uu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  uu.__esModule = !0, uu.httpie = void 0;
  var t = Tn(), n = Dg();
  return uu.httpie = {
    info: {
      key: "httpie",
      title: "HTTPie",
      link: "http://httpie.org/",
      description: "a CLI, cURL-like tool for humans"
    },
    convert: function(r, i) {
      var a = r.allHeaders, o = r.postData, c = r.queryObj, u = r.fullUrl, s = r.method, f = r.url, d = e({ body: !1, cert: !1, headers: !1, indent: "  ", pretty: !1, print: !1, queryParams: !1, short: !1, style: !1, timeout: !1, verbose: !1, verify: !1 }, i), l = new t.CodeBuilder({
        indent: d.indent,
        // @ts-expect-error SEEMS LEGIT
        join: d.indent !== !1 ? ` \\
`.concat(d.indent) : " "
      }), p = l.push, g = l.join, v = l.unshift, b = !1, y = [];
      d.headers && y.push(d.short ? "-h" : "--headers"), d.body && y.push(d.short ? "-b" : "--body"), d.verbose && y.push(d.short ? "-v" : "--verbose"), d.print && y.push("".concat(d.short ? "-p" : "--print", "=").concat(d.print)), d.verify && y.push("--verify=".concat(d.verify)), d.cert && y.push("--cert=".concat(d.cert)), d.pretty && y.push("--pretty=".concat(d.pretty)), d.style && y.push("--style=".concat(d.style)), d.timeout && y.push("--timeout=".concat(d.timeout)), d.queryParams && Object.keys(c).forEach(function(T) {
        var E = c[T];
        Array.isArray(E) ? E.forEach(function(D) {
          p("".concat(T, "==").concat((0, n.quote)(D)));
        }) : p("".concat(T, "==").concat((0, n.quote)(E)));
      }), Object.keys(a).sort().forEach(function(T) {
        p("".concat(T, ":").concat((0, n.quote)(a[T])));
      }), o.mimeType === "application/x-www-form-urlencoded" ? o.params && o.params.length && (y.push(d.short ? "-f" : "--form"), o.params.forEach(function(T) {
        p("".concat(T.name, "=").concat((0, n.quote)(T.value)));
      })) : b = !0;
      var w = y.length ? "".concat(y.join(" "), " ") : "";
      if (f = (0, n.quote)(d.queryParams ? f : u), v("http ".concat(w).concat(s, " ").concat(f)), b && o.text) {
        var C = (0, n.quote)(o.text);
        v("echo ".concat(C, " | "));
      }
      return g();
    }
  }, uu;
}
var cu = {}, dS;
function xne() {
  if (dS) return cu;
  dS = 1;
  var e = cu && cu.__assign || function() {
    return e = Object.assign || function(r) {
      for (var i, a = 1, o = arguments.length; a < o; a++) {
        i = arguments[a];
        for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
      }
      return r;
    }, e.apply(this, arguments);
  };
  cu.__esModule = !0, cu.wget = void 0;
  var t = Tn(), n = Dg();
  return cu.wget = {
    info: {
      key: "wget",
      title: "Wget",
      link: "https://www.gnu.org/software/wget/",
      description: "a free software package for retrieving files using HTTP, HTTPS"
    },
    convert: function(r, i) {
      var a = r.method, o = r.postData, c = r.allHeaders, u = r.fullUrl, s = e({ indent: "  ", short: !1, verbose: !1 }, i), f = new t.CodeBuilder({
        indent: s.indent,
        // @ts-expect-error SEEMS LEGIT
        join: s.indent !== !1 ? ` \\
`.concat(s.indent) : " "
      }), d = f.push, l = f.join;
      return s.verbose ? d("wget ".concat(s.short ? "-v" : "--verbose")) : d("wget ".concat(s.short ? "-q" : "--quiet")), d("--method ".concat((0, n.quote)(a))), Object.keys(c).forEach(function(p) {
        var g = "".concat(p, ": ").concat(c[p]);
        d("--header ".concat((0, n.quote)(g)));
      }), o.text && d("--body-data ".concat((0, n.escape)((0, n.quote)(o.text)))), d(s.short ? "-O" : "--output-document"), d("- ".concat((0, n.quote)(u))), l();
    }
  }, cu;
}
var hS;
function _ne() {
  if (hS) return rf;
  hS = 1, rf.__esModule = !0, rf.shell = void 0;
  var e = yne(), t = bne(), n = xne();
  return rf.shell = {
    info: {
      key: "shell",
      title: "Shell",
      extname: ".sh",
      default: "curl"
    },
    clientsById: {
      curl: e.curl,
      httpie: t.httpie,
      wget: n.wget
    }
  }, rf;
}
var nf = {}, Zo = {}, V3 = {}, mS;
function wne() {
  return mS || (mS = 1, function(e) {
    e.__esModule = !0, e.literalRepresentation = e.literalDeclaration = void 0;
    var t = function(a, o) {
      return o.repeat(a);
    }, n = function(a, o, c, u) {
      var s = t(u, c), f = t(u - 1, c), d = o ? `,
`.concat(s) : ", ";
      return o ? `[
`.concat(s).concat(a.join(d), `
`).concat(f, "]") : "[".concat(a.join(d), "]");
    }, r = function(a, o, c) {
      return "let ".concat(a, " = ").concat((0, e.literalRepresentation)(o, c));
    };
    e.literalDeclaration = r;
    var i = function(a, o, c) {
      switch (c = c === void 0 ? 1 : c + 1, Object.prototype.toString.call(a)) {
        case "[object Number]":
          return a;
        case "[object Array]": {
          var u = !1, s = a.map(function(l) {
            return Object.prototype.toString.call(l) === "[object Object]" && (u = Object.keys(l).length > 1), (0, e.literalRepresentation)(l, o, c);
          });
          return n(s, u, o.indent, c);
        }
        case "[object Object]": {
          var f = [];
          for (var d in a)
            f.push('"'.concat(d, '": ').concat((0, e.literalRepresentation)(a[d], o, c)));
          return n(
            f,
            // @ts-expect-error needs better types
            o.pretty && f.length > 1,
            // @ts-expect-error needs better types
            o.indent,
            c
          );
        }
        case "[object Boolean]":
          return a.toString();
        default:
          return a == null ? "" : '"'.concat(a.toString().replace(/"/g, '\\"'), '"');
      }
    };
    e.literalRepresentation = i;
  }(V3)), V3;
}
var gS;
function Sne() {
  if (gS) return Zo;
  gS = 1;
  var e = Zo && Zo.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = Zo && Zo.__read || function(i, a) {
    var o = typeof Symbol == "function" && i[Symbol.iterator];
    if (!o) return i;
    var c = o.call(i), u, s = [], f;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) s.push(u.value);
    } catch (d) {
      f = { error: d };
    } finally {
      try {
        u && !u.done && (o = c.return) && o.call(c);
      } finally {
        if (f) throw f.error;
      }
    }
    return s;
  };
  Zo.__esModule = !0, Zo.nsurlsession = void 0;
  var n = Tn(), r = wne();
  return Zo.nsurlsession = {
    info: {
      key: "nsurlsession",
      title: "NSURLSession",
      link: "https://developer.apple.com/library/mac/documentation/Foundation/Reference/NSURLSession_class/index.html",
      description: "Foundation's NSURLSession request"
    },
    convert: function(i, a) {
      var o, c = i.allHeaders, u = i.postData, s = i.fullUrl, f = i.method, d = e({ indent: "  ", pretty: !0, timeout: "10" }, a), l = new n.CodeBuilder({ indent: d.indent }), p = l.push, g = l.blank, v = l.join, b = {
        hasHeaders: !1,
        hasBody: !1
      };
      if (p("import Foundation"), Object.keys(c).length && (b.hasHeaders = !0, g(), p((0, r.literalDeclaration)("headers", c, d))), u.text || u.jsonObj || u.params)
        switch (b.hasBody = !0, u.mimeType) {
          case "application/x-www-form-urlencoded":
            if (g(), !((o = u.params) === null || o === void 0) && o.length) {
              var y = t(u.params), w = y[0], C = y.slice(1);
              p('let postData = NSMutableData(data: "'.concat(w.name, "=").concat(w.value, '".data(using: String.Encoding.utf8)!)')), C.forEach(function(T) {
                var E = T.name, D = T.value;
                p('postData.append("&'.concat(E, "=").concat(D, '".data(using: String.Encoding.utf8)!)'));
              });
            } else
              b.hasBody = !1;
            break;
          case "application/json":
            u.jsonObj && (p("".concat((0, r.literalDeclaration)("parameters", u.jsonObj, d), " as [String : Any]")), g(), p("let postData = JSONSerialization.data(withJSONObject: parameters, options: [])"));
            break;
          case "multipart/form-data":
            p((0, r.literalDeclaration)("parameters", u.params, d)), g(), p('let boundary = "'.concat(u.boundary, '"')), g(), p('var body = ""'), p("var error: NSError? = nil"), p("for param in parameters {"), p('let paramName = param["name"]!', 1), p('body += "--\\(boundary)\\r\\n"', 1), p('body += "Content-Disposition:form-data; name=\\"\\(paramName)\\""', 1), p('if let filename = param["fileName"] {', 1), p('let contentType = param["content-type"]!', 2), p("let fileContent = String(contentsOfFile: filename, encoding: String.Encoding.utf8)", 2), p("if (error != nil) {", 2), p("print(error as Any)", 3), p("}", 2), p('body += "; filename=\\"\\(filename)\\"\\r\\n"', 2), p('body += "Content-Type: \\(contentType)\\r\\n\\r\\n"', 2), p("body += fileContent", 2), p('} else if let paramValue = param["value"] {', 1), p('body += "\\r\\n\\r\\n\\(paramValue)"', 2), p("}", 1), p("}");
            break;
          default:
            g(), p('let postData = NSData(data: "'.concat(u.text, '".data(using: String.Encoding.utf8)!)'));
        }
      return g(), p('let request = NSMutableURLRequest(url: NSURL(string: "'.concat(s, '")! as URL,')), p("                                        cachePolicy: .useProtocolCachePolicy,"), p(
        // @ts-expect-error needs better types
        "                                    timeoutInterval: ".concat(parseInt(d.timeout, 10).toFixed(1), ")")
      ), p('request.httpMethod = "'.concat(f, '"')), b.hasHeaders && p("request.allHTTPHeaderFields = headers"), b.hasBody && p("request.httpBody = postData as Data"), g(), p("let session = URLSession.shared"), p("let dataTask = session.dataTask(with: request as URLRequest, completionHandler: { (data, response, error) -> Void in"), p("if (error != nil) {", 1), p("print(error as Any)", 2), p("} else {", 1), p("let httpResponse = response as? HTTPURLResponse", 2), p("print(httpResponse)", 2), p("}", 1), p("})"), g(), p("dataTask.resume()"), v();
    }
  }, Zo;
}
var vS;
function Cne() {
  if (vS) return nf;
  vS = 1, nf.__esModule = !0, nf.swift = void 0;
  var e = Sne();
  return nf.swift = {
    info: {
      key: "swift",
      title: "Swift",
      extname: ".swift",
      default: "nsurlsession"
    },
    clientsById: {
      nsurlsession: e.nsurlsession
    }
  }, nf;
}
var yS;
function P0() {
  return yS || (yS = 1, function(e) {
    e.__esModule = !0, e.addTargetClient = e.isClient = e.addTarget = e.isTarget = e.targets = void 0;
    var t = hre(), n = gre(), r = yre(), i = _re(), a = Sre(), o = Are(), c = Pre(), u = $re(), s = Fre(), f = Vre(), d = Zre(), l = Jre(), p = rne(), g = ane(), v = cne(), b = fne(), y = hne(), w = vne(), C = _ne(), T = Cne();
    e.targets = {
      c: t.c,
      clojure: n.clojure,
      crystal: r.crystal,
      csharp: i.csharp,
      go: a.go,
      http: o.http,
      java: c.java,
      javascript: u.javascript,
      kotlin: s.kotlin,
      node: f.node,
      objc: d.objc,
      ocaml: l.ocaml,
      php: p.php,
      powershell: g.powershell,
      python: v.python,
      r: b.r,
      ruby: y.ruby,
      rust: w.rust,
      shell: C.shell,
      swift: T.swift
    };
    var E = function(te) {
      if (typeof te != "object" || te === null || Array.isArray(te)) {
        var se = te === null ? "null" : Array.isArray(te) ? "array" : typeof te;
        throw new Error('you tried to add a target which is not an object, got type: "'.concat(se, '"'));
      }
      if (!Object.prototype.hasOwnProperty.call(te, "info"))
        throw new Error("targets must contain an `info` object");
      if (!Object.prototype.hasOwnProperty.call(te.info, "key"))
        throw new Error("targets must have an `info` object with the property `key`");
      if (!te.info.key)
        throw new Error("target key must be a unique string");
      if (Object.prototype.hasOwnProperty.call(e.targets, te.info.key))
        throw new Error("a target already exists with this key, `".concat(te.info.key, "`"));
      if (!Object.prototype.hasOwnProperty.call(te.info, "title"))
        throw new Error("targets must have an `info` object with the property `title`");
      if (!te.info.title)
        throw new Error("target title must be a non-zero-length string");
      if (!Object.prototype.hasOwnProperty.call(te.info, "extname"))
        throw new Error("targets must have an `info` object with the property `extname`");
      if (!Object.prototype.hasOwnProperty.call(te, "clientsById") || !te.clientsById || Object.keys(te.clientsById).length === 0)
        throw new Error("No clients provided in target ".concat(te.info.key, ".  You must provide the property `clientsById` containg your clients."));
      if (!Object.prototype.hasOwnProperty.call(te.info, "default"))
        throw new Error("targets must have an `info` object with the property `default`");
      if (!Object.prototype.hasOwnProperty.call(te.clientsById, te.info.default))
        throw new Error("target ".concat(te.info.key, " is configured with a default client ").concat(te.info.default, ", but no such client was found in the property `clientsById` (found ").concat(JSON.stringify(Object.keys(te.clientsById)), ")"));
      return Object.values(te.clientsById).forEach(e.isClient), !0;
    };
    e.isTarget = E;
    var D = function(te) {
      (0, e.isTarget)(te) && (e.targets[te.info.key] = te);
    };
    e.addTarget = D;
    var $ = function(te) {
      if (!te)
        throw new Error("clients must be objects");
      if (!Object.prototype.hasOwnProperty.call(te, "info"))
        throw new Error("targets client must contain an `info` object");
      if (!Object.prototype.hasOwnProperty.call(te.info, "key"))
        throw new Error("targets client must have an `info` object with property `key`");
      if (!te.info.key)
        throw new Error("client.info.key must contain an identifier unique to this target");
      if (!Object.prototype.hasOwnProperty.call(te.info, "title"))
        throw new Error("targets client must have an `info` object with property `title`");
      if (!Object.prototype.hasOwnProperty.call(te.info, "description"))
        throw new Error("targets client must have an `info` object with property `description`");
      if (!Object.prototype.hasOwnProperty.call(te.info, "link"))
        throw new Error("targets client must have an `info` object with property `link`");
      if (!Object.prototype.hasOwnProperty.call(te, "convert") || typeof te.convert != "function")
        throw new Error("targets client must have a `convert` property containing a conversion function");
      return !0;
    };
    e.isClient = $;
    var Z = function(te, se) {
      if ((0, e.isClient)(se)) {
        if (!Object.prototype.hasOwnProperty.call(e.targets, te))
          throw new Error("Sorry, but no ".concat(te, " target exists to add clients to"));
        if (Object.prototype.hasOwnProperty.call(e.targets[te], se.info.key))
          throw new Error("the target ".concat(te, " already has a client with the key ").concat(se.info.key, ", please use a different key"));
        e.targets[te].clientsById[se.info.key] = se;
      }
    };
    e.addTargetClient = Z;
  }($3)), $3;
}
var bS;
function WO() {
  if (bS) return $o;
  bS = 1;
  var e = $o && $o.__assign || function() {
    return e = Object.assign || function(i) {
      for (var a, o = 1, c = arguments.length; o < c; o++) {
        a = arguments[o];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (i[u] = a[u]);
      }
      return i;
    }, e.apply(this, arguments);
  };
  $o.__esModule = !0, $o.extname = $o.availableTargets = void 0;
  var t = P0(), n = function() {
    return Object.keys(t.targets).map(function(i) {
      return e(e({}, t.targets[i].info), { clients: Object.keys(t.targets[i].clientsById).map(function(a) {
        return t.targets[i].clientsById[a].info;
      }) });
    });
  };
  $o.availableTargets = n;
  var r = function(i) {
    var a;
    return ((a = t.targets[i]) === null || a === void 0 ? void 0 : a.info.extname) || "";
  };
  return $o.extname = r, $o;
}
var Za = {}, W3 = {}, K3 = { exports: {} }, xS;
function y1() {
  return xS || (xS = 1, function(e, t) {
    var n = ai;
    e.exports = r, r.through = r;
    function r(i, a, o) {
      i = i || function(g) {
        this.queue(g);
      }, a = a || function() {
        this.queue(null);
      };
      var c = !1, u = !1, s = [], f = !1, d = new n();
      d.readable = d.writable = !0, d.paused = !1, d.autoDestroy = !(o && o.autoDestroy === !1), d.write = function(g) {
        return i.call(this, g), !d.paused;
      };
      function l() {
        for (; s.length && !d.paused; ) {
          var g = s.shift();
          if (g === null)
            return d.emit("end");
          d.emit("data", g);
        }
      }
      d.queue = d.push = function(g) {
        return f || (g === null && (f = !0), s.push(g), l()), d;
      }, d.on("end", function() {
        d.readable = !1, !d.writable && d.autoDestroy && bn.nextTick(function() {
          d.destroy();
        });
      });
      function p() {
        d.writable = !1, a.call(d), !d.readable && d.autoDestroy && d.destroy();
      }
      return d.end = function(g) {
        if (!c)
          return c = !0, arguments.length && d.write(g), p(), d;
      }, d.destroy = function() {
        if (!u)
          return u = !0, c = !0, s.length = 0, d.writable = d.readable = !1, d.emit("close"), d;
      }, d.pause = function() {
        if (!d.paused)
          return d.paused = !0, d;
      }, d.resume = function() {
        return d.paused && (d.paused = !1, d.emit("resume")), l(), d.paused || d.emit("drain"), d;
      }, d;
    }
  }(K3)), K3.exports;
}
var Z3, _S;
function Ane() {
  if (_S) return Z3;
  _S = 1;
  var e = ai;
  return Z3 = function t(n) {
    if (Array.isArray(n)) {
      var r = 0, i = n.length;
      return t(function(u) {
        return r < i ? this.emit("data", n[r++]) : this.emit("end"), !0;
      });
    }
    var a = new e(), o = 0;
    a.ended = !1, a.started = !1, a.readable = !0, a.writable = !1, a.paused = !1, a.ended = !1, a.pause = function() {
      a.started = !0, a.paused = !0;
    };
    function c() {
      if (a.started = !0, !a.ended)
        for (; !a.ended && !a.paused && n.call(a, o++, function() {
          !a.ended && !a.paused && bn.nextTick(c);
        }); )
          ;
    }
    return a.resume = function() {
      a.started = !0, a.paused = !1, c();
    }, a.on("end", function() {
      a.ended = !0, a.readable = !1, bn.nextTick(a.destroy);
    }), a.destroy = function() {
      a.ended = !0, a.emit("close");
    }, bn.nextTick(function() {
      a.started || a.resume();
    }), a;
  }, Z3;
}
var Y3, wS;
function KO() {
  if (wS) return Y3;
  wS = 1;
  var e = ai, t = ["write", "end", "destroy"], n = ["resume", "pause"], r = ["data", "close"], i = Array.prototype.slice;
  Y3 = o;
  function a(c, u) {
    if (c.forEach)
      return c.forEach(u);
    for (var s = 0; s < c.length; s++)
      u(c[s], s);
  }
  function o(c, u) {
    var s = new e(), f = !1;
    return a(t, d), a(n, l), a(r, p), u.on("end", g), c.on("drain", function() {
      s.emit("drain");
    }), c.on("error", v), u.on("error", v), s.writable = c.writable, s.readable = u.readable, s;
    function d(b) {
      s[b] = y;
      function y() {
        return c[b].apply(c, arguments);
      }
    }
    function l(b) {
      s[b] = y;
      function y() {
        s.emit(b);
        var w = u[b];
        if (w)
          return w.apply(u, arguments);
        u.emit(b);
      }
    }
    function p(b) {
      u.on(b, y);
      function y() {
        var w = i.call(arguments);
        w.unshift(b), s.emit.apply(s, w);
      }
    }
    function g() {
      if (!f) {
        f = !0;
        var b = i.call(arguments);
        b.unshift("end"), s.emit.apply(s, b);
      }
    }
    function v(b) {
      s.emit("error", b);
    }
  }
  return Y3;
}
var J3, SS;
function kne() {
  if (SS) return J3;
  SS = 1;
  var e = ai.Stream;
  return J3 = function(t, n) {
    var r = new e(), i = 0, a = 0, o = !1, c = !1, u = !1, s = 0, f = !1;
    n = n || {};
    var d = n.failures ? "failure" : "error", l = {};
    r.writable = !0, r.readable = !0;
    function p(y, w) {
      var C = s + 1;
      if (w === C ? (y !== void 0 && r.emit.apply(r, ["data", y]), s++, C++) : l[w] = y, l.hasOwnProperty(C)) {
        var T = l[C];
        return delete l[C], p(T, C);
      }
      a++, i === a && (c && (c = !1, r.emit("drain")), o && b());
    }
    function g(y, w, C) {
      u || (f = !0, (!y || n.failures) && p(w, C), y && r.emit.apply(r, [d, y]), f = !1);
    }
    function v(y, w, C) {
      return t.call(null, y, function(T, E) {
        C(T, E, w);
      });
    }
    r.write = function(y) {
      if (o) throw new Error("map stream is not writable");
      f = !1, i++;
      try {
        var w = v(y, i, g);
        return c = w === !1, !c;
      } catch (C) {
        if (f)
          throw C;
        return g(C), !c;
      }
    };
    function b(y) {
      if (o = !0, r.writable = !1, y !== void 0)
        return p(y, i);
      i == a && (r.readable = !1, r.emit("end"), r.destroy());
    }
    return r.end = function(y) {
      o || b(y);
    }, r.destroy = function() {
      o = u = !0, r.writable = r.readable = c = !1, bn.nextTick(function() {
        r.emit("close");
      });
    }, r.pause = function() {
      c = !0;
    }, r.resume = function() {
      c = !1;
    }, r;
  }, J3;
}
var Q3, CS;
function Ene() {
  return CS || (CS = 1, Q3 = y1()), Q3;
}
var X3 = {}, Nd = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var AS;
function One() {
  return AS || (AS = 1, function(e, t) {
    var n = j2(), r = n.Buffer;
    function i(o, c) {
      for (var u in o)
        c[u] = o[u];
    }
    r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = a);
    function a(o, c, u) {
      return r(o, c, u);
    }
    a.prototype = Object.create(r.prototype), i(r, a), a.from = function(o, c, u) {
      if (typeof o == "number")
        throw new TypeError("Argument must not be a number");
      return r(o, c, u);
    }, a.alloc = function(o, c, u) {
      if (typeof o != "number")
        throw new TypeError("Argument must be a number");
      var s = r(o);
      return c !== void 0 ? typeof u == "string" ? s.fill(c, u) : s.fill(c) : s.fill(0), s;
    }, a.allocUnsafe = function(o) {
      if (typeof o != "number")
        throw new TypeError("Argument must be a number");
      return r(o);
    }, a.allocUnsafeSlow = function(o) {
      if (typeof o != "number")
        throw new TypeError("Argument must be a number");
      return n.SlowBuffer(o);
    };
  }(Nd, Nd.exports)), Nd.exports;
}
var kS;
function Tne() {
  if (kS) return X3;
  kS = 1;
  var e = One().Buffer, t = e.isEncoding || function(y) {
    switch (y = "" + y, y && y.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function n(y) {
    if (!y) return "utf8";
    for (var w; ; )
      switch (y) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return y;
        default:
          if (w) return;
          y = ("" + y).toLowerCase(), w = !0;
      }
  }
  function r(y) {
    var w = n(y);
    if (typeof w != "string" && (e.isEncoding === t || !t(y))) throw new Error("Unknown encoding: " + y);
    return w || y;
  }
  X3.StringDecoder = i;
  function i(y) {
    this.encoding = r(y);
    var w;
    switch (this.encoding) {
      case "utf16le":
        this.text = d, this.end = l, w = 4;
        break;
      case "utf8":
        this.fillLast = u, w = 4;
        break;
      case "base64":
        this.text = p, this.end = g, w = 3;
        break;
      default:
        this.write = v, this.end = b;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(w);
  }
  i.prototype.write = function(y) {
    if (y.length === 0) return "";
    var w, C;
    if (this.lastNeed) {
      if (w = this.fillLast(y), w === void 0) return "";
      C = this.lastNeed, this.lastNeed = 0;
    } else
      C = 0;
    return C < y.length ? w ? w + this.text(y, C) : this.text(y, C) : w || "";
  }, i.prototype.end = f, i.prototype.text = s, i.prototype.fillLast = function(y) {
    if (this.lastNeed <= y.length)
      return y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, y.length), this.lastNeed -= y.length;
  };
  function a(y) {
    return y <= 127 ? 0 : y >> 5 === 6 ? 2 : y >> 4 === 14 ? 3 : y >> 3 === 30 ? 4 : y >> 6 === 2 ? -1 : -2;
  }
  function o(y, w, C) {
    var T = w.length - 1;
    if (T < C) return 0;
    var E = a(w[T]);
    return E >= 0 ? (E > 0 && (y.lastNeed = E - 1), E) : --T < C || E === -2 ? 0 : (E = a(w[T]), E >= 0 ? (E > 0 && (y.lastNeed = E - 2), E) : --T < C || E === -2 ? 0 : (E = a(w[T]), E >= 0 ? (E > 0 && (E === 2 ? E = 0 : y.lastNeed = E - 3), E) : 0));
  }
  function c(y, w, C) {
    if ((w[0] & 192) !== 128)
      return y.lastNeed = 0, "�";
    if (y.lastNeed > 1 && w.length > 1) {
      if ((w[1] & 192) !== 128)
        return y.lastNeed = 1, "�";
      if (y.lastNeed > 2 && w.length > 2 && (w[2] & 192) !== 128)
        return y.lastNeed = 2, "�";
    }
  }
  function u(y) {
    var w = this.lastTotal - this.lastNeed, C = c(this, y);
    if (C !== void 0) return C;
    if (this.lastNeed <= y.length)
      return y.copy(this.lastChar, w, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    y.copy(this.lastChar, w, 0, y.length), this.lastNeed -= y.length;
  }
  function s(y, w) {
    var C = o(this, y, w);
    if (!this.lastNeed) return y.toString("utf8", w);
    this.lastTotal = C;
    var T = y.length - (C - this.lastNeed);
    return y.copy(this.lastChar, 0, T), y.toString("utf8", w, T);
  }
  function f(y) {
    var w = y && y.length ? this.write(y) : "";
    return this.lastNeed ? w + "�" : w;
  }
  function d(y, w) {
    if ((y.length - w) % 2 === 0) {
      var C = y.toString("utf16le", w);
      if (C) {
        var T = C.charCodeAt(C.length - 1);
        if (T >= 55296 && T <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1], C.slice(0, -1);
      }
      return C;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = y[y.length - 1], y.toString("utf16le", w, y.length - 1);
  }
  function l(y) {
    var w = y && y.length ? this.write(y) : "";
    if (this.lastNeed) {
      var C = this.lastTotal - this.lastNeed;
      return w + this.lastChar.toString("utf16le", 0, C);
    }
    return w;
  }
  function p(y, w) {
    var C = (y.length - w) % 3;
    return C === 0 ? y.toString("base64", w) : (this.lastNeed = 3 - C, this.lastTotal = 3, C === 1 ? this.lastChar[0] = y[y.length - 1] : (this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1]), y.toString("base64", w, y.length - C));
  }
  function g(y) {
    var w = y && y.length ? this.write(y) : "";
    return this.lastNeed ? w + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : w;
  }
  function v(y) {
    return y.toString(this.encoding);
  }
  function b(y) {
    return y && y.length ? this.write(y) : "";
  }
  return X3;
}
var e6, ES;
function Pne() {
  if (ES) return e6;
  ES = 1;
  var e = y1(), t = Tne().StringDecoder;
  e6 = n;
  function n(r, i, a) {
    var o = new t(), c = "", u = a && a.maxLength, s = !(a && a.trailing === !1);
    typeof r == "function" && (i = r, r = null), r || (r = /\r?\n/);
    function f(l, p) {
      if (i) {
        try {
          p = i(p);
        } catch (g) {
          return l.emit("error", g);
        }
        typeof p < "u" && l.queue(p);
      } else
        l.queue(p);
    }
    function d(l, p) {
      var g = ((c ?? "") + p).split(r);
      if (c = g.pop(), u && c.length > u)
        return l.emit("error", new Error("maximum buffer reached"));
      for (var v = 0; v < g.length; v++) {
        var b = g[v];
        f(l, b);
      }
    }
    return e(
      function(l) {
        d(this, o.write(l));
      },
      function() {
        o.end && d(this, o.end()), s && c != null && f(this, c), this.queue(null);
      }
    );
  }
  return e6;
}
var t6, OS;
function Rne() {
  if (OS) return t6;
  OS = 1;
  var e = KO(), t = y1();
  return t6 = function() {
    var n;
    if (arguments.length == 1 && Array.isArray(arguments[0]) ? n = arguments[0] : n = [].slice.call(arguments), n.length == 0)
      return t();
    if (n.length == 1)
      return n[0];
    var r = n[0], i = n[n.length - 1], a = e(r, i);
    function o(s) {
      s.length < 2 || (s[0].pipe(s[1]), o(s.slice(1)));
    }
    o(n);
    function c() {
      var s = [].slice.call(arguments);
      s.unshift("error"), a.emit.apply(a, s);
    }
    for (var u = 1; u < n.length - 1; u++)
      n[u].on("error", c);
    return a;
  }, t6;
}
var TS;
function jne() {
  return TS || (TS = 1, function(e) {
    var t = ai.Stream, n = e, r = y1(), i = Ane(), a = KO(), o = kne(), c = Ene(), u = Pne(), s = Rne(), f = Ya.setImmediate || bn.nextTick;
    n.Stream = t, n.through = r, n.from = i, n.duplex = a, n.map = o, n.pause = c, n.split = u, n.pipeline = n.connect = n.pipe = s, n.concat = //actually this should be called concat
    n.merge = function() {
      var d = [].slice.call(arguments);
      d.length === 1 && d[0] instanceof Array && (d = d[0]);
      var l = new t();
      l.setMaxListeners(0);
      var p = 0;
      return l.writable = l.readable = !0, d.length ? d.forEach(function(g) {
        g.pipe(l, { end: !1 });
        var v = !1;
        g.on("end", function() {
          v || (v = !0, p++, p == d.length && l.emit("end"));
        });
      }) : bn.nextTick(function() {
        l.emit("end");
      }), l.write = function(g) {
        this.emit("data", g);
      }, l.destroy = function() {
        d.forEach(function(g) {
          g.destroy && g.destroy();
        });
      }, l;
    }, n.collect = n.writeArray = function(d) {
      if (typeof d != "function")
        throw new Error("function writeArray (done): done must be function");
      var l = new t(), p = [], g = !1;
      return l.write = function(v) {
        p.push(v);
      }, l.end = function() {
        g = !0, d(null, p);
      }, l.writable = !0, l.readable = !1, l.destroy = function() {
        l.writable = l.readable = !1, !g && d(new Error("destroyed before end"), p);
      }, l;
    }, n.readArray = function(d) {
      var l = new t(), p = 0, g = !1, v = !1;
      if (l.readable = !0, l.writable = !1, !Array.isArray(d))
        throw new Error("event-stream.read expects an array");
      return l.resume = function() {
        if (!v) {
          g = !1;
          for (var b = d.length; p < b && !g && !v; )
            l.emit("data", d[p++]);
          p == b && !v && (v = !0, l.readable = !1, l.emit("end"));
        }
      }, bn.nextTick(l.resume), l.pause = function() {
        g = !0;
      }, l.destroy = function() {
        v = !0, l.emit("close");
      }, l;
    }, n.readable = function(d, l) {
      var p = new t(), g = 0, v = !1, b = !1, y = !1;
      if (p.readable = !0, p.writable = !1, typeof d != "function")
        throw new Error("event-stream.readable expects async function");
      p.on("end", function() {
        b = !0;
      });
      function w(C, T) {
        C ? (p.emit("error", C), l || p.emit("end")) : arguments.length > 1 && p.emit("data", T), f(function() {
          if (!(b || v || y))
            try {
              y = !0, d.call(p, g++, function() {
                y = !1, w.apply(null, arguments);
              });
            } catch (E) {
              p.emit("error", E);
            }
        });
      }
      return p.resume = function() {
        v = !1, w();
      }, bn.nextTick(w), p.pause = function() {
        v = !0;
      }, p.destroy = function() {
        p.emit("end"), p.emit("close"), b = !0;
      }, p;
    }, n.mapSync = function(d) {
      return n.through(function(p) {
        var g;
        try {
          g = d(p);
        } catch (v) {
          return this.emit("error", v);
        }
        g !== void 0 && this.emit("data", g);
      });
    }, n.filterSync = function(d) {
      return n.through(function(l) {
        var p = this;
        d(l) && p.queue(l);
      });
    }, n.flatmapSync = function(d) {
      return n.through(function(l) {
        var p = this;
        l.forEach(function(g) {
          p.queue(d(g));
        });
      });
    }, n.log = function(d) {
      return n.through(function(l) {
        [].slice.call(arguments), d ? console.error(d, l) : console.error(l), this.emit("data", l);
      });
    }, n.child = function(d) {
      return n.duplex(d.stdin, d.stdout);
    }, n.parse = function(d) {
      var l = !!(d && d.error);
      return n.through(function(p) {
        var g;
        try {
          p && (g = JSON.parse(p.toString()));
        } catch (v) {
          return l ? this.emit("error", v) : console.error(v, "attempting to parse:", p);
        }
        g !== void 0 && this.emit("data", g);
      });
    }, n.stringify = function() {
      var d = j2().Buffer;
      return n.mapSync(function(l) {
        return JSON.stringify(d.isBuffer(l) ? l.toString() : l) + `
`;
      });
    }, n.replace = function(d, l) {
      return n.pipeline(n.split(d), n.join(l));
    }, n.join = function(d) {
      if (typeof d == "function")
        return n.wait(d);
      var l = !0;
      return n.through(function(p) {
        return l || this.emit("data", d), l = !1, this.emit("data", p), !0;
      });
    }, n.wait = function(d) {
      var l = [];
      return n.through(
        function(p) {
          l.push(p);
        },
        function() {
          var p = Dn.isBuffer(l[0]) ? Dn.concat(l) : l.join("");
          this.emit("data", p), this.emit("end"), d && d(null, p);
        }
      );
    }, n.pipeable = function() {
      throw new Error("[EVENT-STREAM] es.pipeable is deprecated");
    };
  }(W3)), W3;
}
var r6, PS;
function Ine() {
  if (PS) return r6;
  PS = 1;
  var e = ai.Stream, t = G0();
  r6 = n;
  function n() {
    this.source = null, this.dataSize = 0, this.maxDataSize = 1024 * 1024, this.pauseStream = !0, this._maxDataSizeExceeded = !1, this._released = !1, this._bufferedEvents = [];
  }
  return t.inherits(n, e), n.create = function(r, i) {
    var a = new this();
    i = i || {};
    for (var o in i)
      a[o] = i[o];
    a.source = r;
    var c = r.emit;
    return r.emit = function() {
      return a._handleEmit(arguments), c.apply(r, arguments);
    }, r.on("error", function() {
    }), a.pauseStream && r.pause(), a;
  }, Object.defineProperty(n.prototype, "readable", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.source.readable;
    }
  }), n.prototype.setEncoding = function() {
    return this.source.setEncoding.apply(this.source, arguments);
  }, n.prototype.resume = function() {
    this._released || this.release(), this.source.resume();
  }, n.prototype.pause = function() {
    this.source.pause();
  }, n.prototype.release = function() {
    this._released = !0, this._bufferedEvents.forEach((function(r) {
      this.emit.apply(this, r);
    }).bind(this)), this._bufferedEvents = [];
  }, n.prototype.pipe = function() {
    var r = e.prototype.pipe.apply(this, arguments);
    return this.resume(), r;
  }, n.prototype._handleEmit = function(r) {
    if (this._released) {
      this.emit.apply(this, r);
      return;
    }
    r[0] === "data" && (this.dataSize += r[1].length, this._checkIfMaxDataSizeExceeded()), this._bufferedEvents.push(r);
  }, n.prototype._checkIfMaxDataSizeExceeded = function() {
    if (!this._maxDataSizeExceeded && !(this.dataSize <= this.maxDataSize)) {
      this._maxDataSizeExceeded = !0;
      var r = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
      this.emit("error", new Error(r));
    }
  }, r6;
}
var n6, RS;
function qne() {
  if (RS) return n6;
  RS = 1;
  var e = G0(), t = ai.Stream, n = Ine();
  n6 = r;
  function r() {
    this.writable = !1, this.readable = !0, this.dataSize = 0, this.maxDataSize = 2 * 1024 * 1024, this.pauseStreams = !0, this._released = !1, this._streams = [], this._currentStream = null, this._insideLoop = !1, this._pendingNext = !1;
  }
  return e.inherits(r, t), r.create = function(i) {
    var a = new this();
    i = i || {};
    for (var o in i)
      a[o] = i[o];
    return a;
  }, r.isStreamLike = function(i) {
    return typeof i != "function" && typeof i != "string" && typeof i != "boolean" && typeof i != "number" && !Dn.isBuffer(i);
  }, r.prototype.append = function(i) {
    var a = r.isStreamLike(i);
    if (a) {
      if (!(i instanceof n)) {
        var o = n.create(i, {
          maxDataSize: 1 / 0,
          pauseStream: this.pauseStreams
        });
        i.on("data", this._checkDataSize.bind(this)), i = o;
      }
      this._handleErrors(i), this.pauseStreams && i.pause();
    }
    return this._streams.push(i), this;
  }, r.prototype.pipe = function(i, a) {
    return t.prototype.pipe.call(this, i, a), this.resume(), i;
  }, r.prototype._getNext = function() {
    if (this._currentStream = null, this._insideLoop) {
      this._pendingNext = !0;
      return;
    }
    this._insideLoop = !0;
    try {
      do
        this._pendingNext = !1, this._realGetNext();
      while (this._pendingNext);
    } finally {
      this._insideLoop = !1;
    }
  }, r.prototype._realGetNext = function() {
    var i = this._streams.shift();
    if (typeof i > "u") {
      this.end();
      return;
    }
    if (typeof i != "function") {
      this._pipeNext(i);
      return;
    }
    var a = i;
    a((function(o) {
      var c = r.isStreamLike(o);
      c && (o.on("data", this._checkDataSize.bind(this)), this._handleErrors(o)), this._pipeNext(o);
    }).bind(this));
  }, r.prototype._pipeNext = function(i) {
    this._currentStream = i;
    var a = r.isStreamLike(i);
    if (a) {
      i.on("end", this._getNext.bind(this)), i.pipe(this, { end: !1 });
      return;
    }
    var o = i;
    this.write(o), this._getNext();
  }, r.prototype._handleErrors = function(i) {
    var a = this;
    i.on("error", function(o) {
      a._emitError(o);
    });
  }, r.prototype.write = function(i) {
    this.emit("data", i);
  }, r.prototype.pause = function() {
    this.pauseStreams && (this.pauseStreams && this._currentStream && typeof this._currentStream.pause == "function" && this._currentStream.pause(), this.emit("pause"));
  }, r.prototype.resume = function() {
    this._released || (this._released = !0, this.writable = !0, this._getNext()), this.pauseStreams && this._currentStream && typeof this._currentStream.resume == "function" && this._currentStream.resume(), this.emit("resume");
  }, r.prototype.end = function() {
    this._reset(), this.emit("end");
  }, r.prototype.destroy = function() {
    this._reset(), this.emit("close");
  }, r.prototype._reset = function() {
    this.writable = !1, this._streams = [], this._currentStream = null;
  }, r.prototype._checkDataSize = function() {
    if (this._updateDataSize(), !(this.dataSize <= this.maxDataSize)) {
      var i = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
      this._emitError(new Error(i));
    }
  }, r.prototype._updateDataSize = function() {
    this.dataSize = 0;
    var i = this;
    this._streams.forEach(function(a) {
      a.dataSize && (i.dataSize += a.dataSize);
    }), this._currentStream && this._currentStream.dataSize && (this.dataSize += this._currentStream.dataSize);
  }, r.prototype._emitError = function(i) {
    this._reset(), this.emit("error", i);
  }, n6;
}
var lu = {}, lf = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
var Dne = lf.exports, jS;
function Lne() {
  return jS || (jS = 1, function(e, t) {
    (function(n) {
      var r = t && !t.nodeType && t, i = e && !e.nodeType && e, a = typeof Ya == "object" && Ya;
      (a.global === a || a.window === a || a.self === a) && (n = a);
      var o, c = 2147483647, u = 36, s = 1, f = 26, d = 38, l = 700, p = 72, g = 128, v = "-", b = /^xn--/, y = /[^\x20-\x7E]/, w = /[\x2E\u3002\uFF0E\uFF61]/g, C = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, T = u - s, E = Math.floor, D = String.fromCharCode, $;
      function Z(Ae) {
        throw new RangeError(C[Ae]);
      }
      function te(Ae, He) {
        for (var Te = Ae.length, we = []; Te--; )
          we[Te] = He(Ae[Te]);
        return we;
      }
      function se(Ae, He) {
        var Te = Ae.split("@"), we = "";
        Te.length > 1 && (we = Te[0] + "@", Ae = Te[1]), Ae = Ae.replace(w, ".");
        var qe = Ae.split("."), Ge = te(qe, He).join(".");
        return we + Ge;
      }
      function ee(Ae) {
        for (var He = [], Te = 0, we = Ae.length, qe, Ge; Te < we; )
          qe = Ae.charCodeAt(Te++), qe >= 55296 && qe <= 56319 && Te < we ? (Ge = Ae.charCodeAt(Te++), (Ge & 64512) == 56320 ? He.push(((qe & 1023) << 10) + (Ge & 1023) + 65536) : (He.push(qe), Te--)) : He.push(qe);
        return He;
      }
      function K(Ae) {
        return te(Ae, function(He) {
          var Te = "";
          return He > 65535 && (He -= 65536, Te += D(He >>> 10 & 1023 | 55296), He = 56320 | He & 1023), Te += D(He), Te;
        }).join("");
      }
      function re(Ae) {
        return Ae - 48 < 10 ? Ae - 22 : Ae - 65 < 26 ? Ae - 65 : Ae - 97 < 26 ? Ae - 97 : u;
      }
      function de(Ae, He) {
        return Ae + 22 + 75 * (Ae < 26) - ((He != 0) << 5);
      }
      function ie(Ae, He, Te) {
        var we = 0;
        for (Ae = Te ? E(Ae / l) : Ae >> 1, Ae += E(Ae / He); Ae > T * f >> 1; we += u)
          Ae = E(Ae / T);
        return E(we + (T + 1) * Ae / (Ae + d));
      }
      function me(Ae) {
        var He = [], Te = Ae.length, we, qe = 0, Ge = g, It = p, Qe, jt, We, Lt, Fe, Ze, Ue, Rt, Vr;
        for (Qe = Ae.lastIndexOf(v), Qe < 0 && (Qe = 0), jt = 0; jt < Qe; ++jt)
          Ae.charCodeAt(jt) >= 128 && Z("not-basic"), He.push(Ae.charCodeAt(jt));
        for (We = Qe > 0 ? Qe + 1 : 0; We < Te; ) {
          for (Lt = qe, Fe = 1, Ze = u; We >= Te && Z("invalid-input"), Ue = re(Ae.charCodeAt(We++)), (Ue >= u || Ue > E((c - qe) / Fe)) && Z("overflow"), qe += Ue * Fe, Rt = Ze <= It ? s : Ze >= It + f ? f : Ze - It, !(Ue < Rt); Ze += u)
            Vr = u - Rt, Fe > E(c / Vr) && Z("overflow"), Fe *= Vr;
          we = He.length + 1, It = ie(qe - Lt, we, Lt == 0), E(qe / we) > c - Ge && Z("overflow"), Ge += E(qe / we), qe %= we, He.splice(qe++, 0, Ge);
        }
        return K(He);
      }
      function $e(Ae) {
        var He, Te, we, qe, Ge, It, Qe, jt, We, Lt, Fe, Ze = [], Ue, Rt, Vr, ye;
        for (Ae = ee(Ae), Ue = Ae.length, He = g, Te = 0, Ge = p, It = 0; It < Ue; ++It)
          Fe = Ae[It], Fe < 128 && Ze.push(D(Fe));
        for (we = qe = Ze.length, qe && Ze.push(v); we < Ue; ) {
          for (Qe = c, It = 0; It < Ue; ++It)
            Fe = Ae[It], Fe >= He && Fe < Qe && (Qe = Fe);
          for (Rt = we + 1, Qe - He > E((c - Te) / Rt) && Z("overflow"), Te += (Qe - He) * Rt, He = Qe, It = 0; It < Ue; ++It)
            if (Fe = Ae[It], Fe < He && ++Te > c && Z("overflow"), Fe == He) {
              for (jt = Te, We = u; Lt = We <= Ge ? s : We >= Ge + f ? f : We - Ge, !(jt < Lt); We += u)
                ye = jt - Lt, Vr = u - Lt, Ze.push(
                  D(de(Lt + ye % Vr, 0))
                ), jt = E(ye / Vr);
              Ze.push(D(de(jt, 0))), Ge = ie(Te, Rt, we == qe), Te = 0, ++we;
            }
          ++Te, ++He;
        }
        return Ze.join("");
      }
      function Pe(Ae) {
        return se(Ae, function(He) {
          return b.test(He) ? me(He.slice(4).toLowerCase()) : He;
        });
      }
      function Le(Ae) {
        return se(Ae, function(He) {
          return y.test(He) ? "xn--" + $e(He) : He;
        });
      }
      if (o = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: ee,
          encode: K
        },
        decode: me,
        encode: $e,
        toASCII: Le,
        toUnicode: Pe
      }, r && i)
        if (e.exports == r)
          i.exports = o;
        else
          for ($ in o)
            o.hasOwnProperty($) && (r[$] = o[$]);
      else
        n.punycode = o;
    })(Dne);
  }(lf, lf.exports)), lf.exports;
}
var i6, IS;
function Nne() {
  if (IS) return i6;
  IS = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = e && t && typeof t.get == "function" ? t.get : null, r = e && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, a = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = i && a && typeof a.get == "function" ? a.get : null, c = i && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype, s = u ? WeakMap.prototype.has : null, f = typeof WeakSet == "function" && WeakSet.prototype, d = f ? WeakSet.prototype.has : null, l = typeof WeakRef == "function" && WeakRef.prototype, p = l ? WeakRef.prototype.deref : null, g = Boolean.prototype.valueOf, v = Object.prototype.toString, b = Function.prototype.toString, y = String.prototype.match, w = String.prototype.slice, C = String.prototype.replace, T = String.prototype.toUpperCase, E = String.prototype.toLowerCase, D = RegExp.prototype.test, $ = Array.prototype.concat, Z = Array.prototype.join, te = Array.prototype.slice, se = Math.floor, ee = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, K = Object.getOwnPropertySymbols, re = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, de = typeof Symbol == "function" && typeof Symbol.iterator == "object", ie = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === de || !0) ? Symbol.toStringTag : null, me = Object.prototype.propertyIsEnumerable, $e = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(_) {
    return _.__proto__;
  } : null);
  function Pe(_, h) {
    if (_ === 1 / 0 || _ === -1 / 0 || _ !== _ || _ && _ > -1e3 && _ < 1e3 || D.call(/e/, h))
      return h;
    var A = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof _ == "number") {
      var R = _ < 0 ? -se(-_) : se(_);
      if (R !== _) {
        var I = String(R), k = w.call(h, I.length + 1);
        return C.call(I, A, "$&_") + "." + C.call(C.call(k, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return C.call(h, A, "$&_");
  }
  var Le = ai, Ae = Le.custom, He = Fe(Ae) ? Ae : null;
  i6 = function _(h, A, R, I) {
    var k = A || {};
    if (Rt(k, "quoteStyle") && k.quoteStyle !== "single" && k.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Rt(k, "maxStringLength") && (typeof k.maxStringLength == "number" ? k.maxStringLength < 0 && k.maxStringLength !== 1 / 0 : k.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var j = Rt(k, "customInspect") ? k.customInspect : !0;
    if (typeof j != "boolean" && j !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Rt(k, "indent") && k.indent !== null && k.indent !== "	" && !(parseInt(k.indent, 10) === k.indent && k.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Rt(k, "numericSeparator") && typeof k.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var z = k.numericSeparator;
    if (typeof h > "u")
      return "undefined";
    if (h === null)
      return "null";
    if (typeof h == "boolean")
      return h ? "true" : "false";
    if (typeof h == "string")
      return Xe(h, k);
    if (typeof h == "number") {
      if (h === 0)
        return 1 / 0 / h > 0 ? "0" : "-0";
      var H = String(h);
      return z ? Pe(h, H) : H;
    }
    if (typeof h == "bigint") {
      var J = String(h) + "n";
      return z ? Pe(h, J) : J;
    }
    var U = typeof k.depth > "u" ? 5 : k.depth;
    if (typeof R > "u" && (R = 0), R >= U && U > 0 && typeof h == "object")
      return qe(h) ? "[Array]" : "[Object]";
    var L = F(k, R);
    if (typeof I > "u")
      I = [];
    else if (G(I, h) >= 0)
      return "[Circular]";
    function B(je, Oe, De) {
      if (Oe && (I = te.call(I), I.push(Oe)), De) {
        var ze = {
          depth: k.depth
        };
        return Rt(k, "quoteStyle") && (ze.quoteStyle = k.quoteStyle), _(je, ze, R + 1, I);
      }
      return _(je, k, R + 1, I);
    }
    if (typeof h == "function" && !It(h)) {
      var Q = ye(h), V = S(h, B);
      return "[Function" + (Q ? ": " + Q : " (anonymous)") + "]" + (V.length > 0 ? " { " + Z.call(V, ", ") + " }" : "");
    }
    if (Fe(h)) {
      var X = de ? C.call(String(h), /^(Symbol\(.*\))_[^)]*$/, "$1") : re.call(h);
      return typeof h == "object" && !de ? $t(X) : X;
    }
    if (Me(h)) {
      for (var ue = "<" + E.call(String(h.nodeName)), ve = h.attributes || [], pe = 0; pe < ve.length; pe++)
        ue += " " + ve[pe].name + "=" + Te(we(ve[pe].value), "double", k);
      return ue += ">", h.childNodes && h.childNodes.length && (ue += "..."), ue += "</" + E.call(String(h.nodeName)) + ">", ue;
    }
    if (qe(h)) {
      if (h.length === 0)
        return "[]";
      var oe = S(h, B);
      return L && !M(oe) ? "[" + O(oe, L) + "]" : "[ " + Z.call(oe, ", ") + " ]";
    }
    if (Qe(h)) {
      var ce = S(h, B);
      return !("cause" in Error.prototype) && "cause" in h && !me.call(h, "cause") ? "{ [" + String(h) + "] " + Z.call($.call("[cause]: " + B(h.cause), ce), ", ") + " }" : ce.length === 0 ? "[" + String(h) + "]" : "{ [" + String(h) + "] " + Z.call(ce, ", ") + " }";
    }
    if (typeof h == "object" && j) {
      if (He && typeof h[He] == "function" && Le)
        return Le(h, { depth: U - R });
      if (j !== "symbol" && typeof h.inspect == "function")
        return h.inspect();
    }
    if (Y(h)) {
      var ke = [];
      return r && r.call(h, function(je, Oe) {
        ke.push(B(Oe, h, !0) + " => " + B(je, h));
      }), P("Map", n.call(h), ke, L);
    }
    if (N(h)) {
      var fe = [];
      return c && c.call(h, function(je) {
        fe.push(B(je, h));
      }), P("Set", o.call(h), fe, L);
    }
    if (ae(h))
      return Be("WeakMap");
    if (Se(h))
      return Be("WeakSet");
    if (Ee(h))
      return Be("WeakRef");
    if (We(h))
      return $t(B(Number(h)));
    if (Ze(h))
      return $t(B(ee.call(h)));
    if (Lt(h))
      return $t(g.call(h));
    if (jt(h))
      return $t(B(String(h)));
    if (typeof window < "u" && h === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && h === globalThis || typeof Ya < "u" && h === Ya)
      return "{ [object globalThis] }";
    if (!Ge(h) && !It(h)) {
      var be = S(h, B), ge = $e ? $e(h) === Object.prototype : h instanceof Object || h.constructor === Object, Ie = h instanceof Object ? "" : "null prototype", le = !ge && ie && Object(h) === h && ie in h ? w.call(Vr(h), 8, -1) : Ie ? "Object" : "", he = ge || typeof h.constructor != "function" ? "" : h.constructor.name ? h.constructor.name + " " : "", xe = he + (le || Ie ? "[" + Z.call($.call([], le || [], Ie || []), ": ") + "] " : "");
      return be.length === 0 ? xe + "{}" : L ? xe + "{" + O(be, L) + "}" : xe + "{ " + Z.call(be, ", ") + " }";
    }
    return String(h);
  };
  function Te(_, h, A) {
    var R = (A.quoteStyle || h) === "double" ? '"' : "'";
    return R + _ + R;
  }
  function we(_) {
    return C.call(String(_), /"/g, "&quot;");
  }
  function qe(_) {
    return Vr(_) === "[object Array]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function Ge(_) {
    return Vr(_) === "[object Date]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function It(_) {
    return Vr(_) === "[object RegExp]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function Qe(_) {
    return Vr(_) === "[object Error]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function jt(_) {
    return Vr(_) === "[object String]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function We(_) {
    return Vr(_) === "[object Number]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function Lt(_) {
    return Vr(_) === "[object Boolean]" && (!ie || !(typeof _ == "object" && ie in _));
  }
  function Fe(_) {
    if (de)
      return _ && typeof _ == "object" && _ instanceof Symbol;
    if (typeof _ == "symbol")
      return !0;
    if (!_ || typeof _ != "object" || !re)
      return !1;
    try {
      return re.call(_), !0;
    } catch {
    }
    return !1;
  }
  function Ze(_) {
    if (!_ || typeof _ != "object" || !ee)
      return !1;
    try {
      return ee.call(_), !0;
    } catch {
    }
    return !1;
  }
  var Ue = Object.prototype.hasOwnProperty || function(_) {
    return _ in this;
  };
  function Rt(_, h) {
    return Ue.call(_, h);
  }
  function Vr(_) {
    return v.call(_);
  }
  function ye(_) {
    if (_.name)
      return _.name;
    var h = y.call(b.call(_), /^function\s*([\w$]+)/);
    return h ? h[1] : null;
  }
  function G(_, h) {
    if (_.indexOf)
      return _.indexOf(h);
    for (var A = 0, R = _.length; A < R; A++)
      if (_[A] === h)
        return A;
    return -1;
  }
  function Y(_) {
    if (!n || !_ || typeof _ != "object")
      return !1;
    try {
      n.call(_);
      try {
        o.call(_);
      } catch {
        return !0;
      }
      return _ instanceof Map;
    } catch {
    }
    return !1;
  }
  function ae(_) {
    if (!s || !_ || typeof _ != "object")
      return !1;
    try {
      s.call(_, s);
      try {
        d.call(_, d);
      } catch {
        return !0;
      }
      return _ instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Ee(_) {
    if (!p || !_ || typeof _ != "object")
      return !1;
    try {
      return p.call(_), !0;
    } catch {
    }
    return !1;
  }
  function N(_) {
    if (!o || !_ || typeof _ != "object")
      return !1;
    try {
      o.call(_);
      try {
        n.call(_);
      } catch {
        return !0;
      }
      return _ instanceof Set;
    } catch {
    }
    return !1;
  }
  function Se(_) {
    if (!d || !_ || typeof _ != "object")
      return !1;
    try {
      d.call(_, d);
      try {
        s.call(_, s);
      } catch {
        return !0;
      }
      return _ instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Me(_) {
    return !_ || typeof _ != "object" ? !1 : typeof HTMLElement < "u" && _ instanceof HTMLElement ? !0 : typeof _.nodeName == "string" && typeof _.getAttribute == "function";
  }
  function Xe(_, h) {
    if (_.length > h.maxStringLength) {
      var A = _.length - h.maxStringLength, R = "... " + A + " more character" + (A > 1 ? "s" : "");
      return Xe(w.call(_, 0, h.maxStringLength), h) + R;
    }
    var I = C.call(C.call(_, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Ke);
    return Te(I, "single", h);
  }
  function Ke(_) {
    var h = _.charCodeAt(0), A = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[h];
    return A ? "\\" + A : "\\x" + (h < 16 ? "0" : "") + T.call(h.toString(16));
  }
  function $t(_) {
    return "Object(" + _ + ")";
  }
  function Be(_) {
    return _ + " { ? }";
  }
  function P(_, h, A, R) {
    var I = R ? O(A, R) : Z.call(A, ", ");
    return _ + " (" + h + ") {" + I + "}";
  }
  function M(_) {
    for (var h = 0; h < _.length; h++)
      if (G(_[h], `
`) >= 0)
        return !1;
    return !0;
  }
  function F(_, h) {
    var A;
    if (_.indent === "	")
      A = "	";
    else if (typeof _.indent == "number" && _.indent > 0)
      A = Z.call(Array(_.indent + 1), " ");
    else
      return null;
    return {
      base: A,
      prev: Z.call(Array(h + 1), A)
    };
  }
  function O(_, h) {
    if (_.length === 0)
      return "";
    var A = `
` + h.prev + h.base;
    return A + Z.call(_, "," + A) + `
` + h.prev;
  }
  function S(_, h) {
    var A = qe(_), R = [];
    if (A) {
      R.length = _.length;
      for (var I = 0; I < _.length; I++)
        R[I] = Rt(_, I) ? h(_[I], _) : "";
    }
    var k = typeof K == "function" ? K(_) : [], j;
    if (de) {
      j = {};
      for (var z = 0; z < k.length; z++)
        j["$" + k[z]] = k[z];
    }
    for (var H in _)
      Rt(_, H) && (A && String(Number(H)) === H && H < _.length || de && j["$" + H] instanceof Symbol || (D.call(/[^\w$]/, H) ? R.push(h(H, _) + ": " + h(_[H], _)) : R.push(H + ": " + h(_[H], _))));
    if (typeof K == "function")
      for (var J = 0; J < k.length; J++)
        me.call(_, k[J]) && R.push("[" + h(k[J]) + "]: " + h(_[k[J]], _));
    return R;
  }
  return i6;
}
var a6, qS;
function $ne() {
  if (qS) return a6;
  qS = 1;
  var e = /* @__PURE__ */ kc(), t = H2(), n = /* @__PURE__ */ Nne(), r = /* @__PURE__ */ Kf(), i = e("%WeakMap%", !0), a = e("%Map%", !0), o = t("WeakMap.prototype.get", !0), c = t("WeakMap.prototype.set", !0), u = t("WeakMap.prototype.has", !0), s = t("Map.prototype.get", !0), f = t("Map.prototype.set", !0), d = t("Map.prototype.has", !0), l = function(b, y) {
    for (var w = b, C; (C = w.next) !== null; w = C)
      if (C.key === y)
        return w.next = C.next, C.next = /** @type {NonNullable<typeof list.next>} */
        b.next, b.next = C, C;
  }, p = function(b, y) {
    var w = l(b, y);
    return w && w.value;
  }, g = function(b, y, w) {
    var C = l(b, y);
    C ? C.value = w : b.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: y,
      next: b.next,
      value: w
    };
  }, v = function(b, y) {
    return !!l(b, y);
  };
  return a6 = function() {
    var y, w, C, T = {
      assert: function(E) {
        if (!T.has(E))
          throw new r("Side channel does not contain " + n(E));
      },
      get: function(E) {
        if (i && E && (typeof E == "object" || typeof E == "function")) {
          if (y)
            return o(y, E);
        } else if (a) {
          if (w)
            return s(w, E);
        } else if (C)
          return p(C, E);
      },
      has: function(E) {
        if (i && E && (typeof E == "object" || typeof E == "function")) {
          if (y)
            return u(y, E);
        } else if (a) {
          if (w)
            return d(w, E);
        } else if (C)
          return v(C, E);
        return !1;
      },
      set: function(E, D) {
        i && E && (typeof E == "object" || typeof E == "function") ? (y || (y = new i()), c(y, E, D)) : a ? (w || (w = new a()), f(w, E, D)) : (C || (C = { key: {}, next: null }), g(C, E, D));
      }
    };
    return T;
  }, a6;
}
var o6, DS;
function Lg() {
  if (DS) return o6;
  DS = 1;
  var e = String.prototype.replace, t = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return o6 = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(r) {
        return e.call(r, t, "+");
      },
      RFC3986: function(r) {
        return String(r);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, o6;
}
var s6, LS;
function ZO() {
  if (LS) return s6;
  LS = 1;
  var e = /* @__PURE__ */ Lg(), t = Object.prototype.hasOwnProperty, n = Array.isArray, r = function() {
    for (var b = [], y = 0; y < 256; ++y)
      b.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return b;
  }(), i = function(y) {
    for (; y.length > 1; ) {
      var w = y.pop(), C = w.obj[w.prop];
      if (n(C)) {
        for (var T = [], E = 0; E < C.length; ++E)
          typeof C[E] < "u" && T.push(C[E]);
        w.obj[w.prop] = T;
      }
    }
  }, a = function(y, w) {
    for (var C = w && w.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, T = 0; T < y.length; ++T)
      typeof y[T] < "u" && (C[T] = y[T]);
    return C;
  }, o = function b(y, w, C) {
    if (!w)
      return y;
    if (typeof w != "object") {
      if (n(y))
        y.push(w);
      else if (y && typeof y == "object")
        (C && (C.plainObjects || C.allowPrototypes) || !t.call(Object.prototype, w)) && (y[w] = !0);
      else
        return [y, w];
      return y;
    }
    if (!y || typeof y != "object")
      return [y].concat(w);
    var T = y;
    return n(y) && !n(w) && (T = a(y, C)), n(y) && n(w) ? (w.forEach(function(E, D) {
      if (t.call(y, D)) {
        var $ = y[D];
        $ && typeof $ == "object" && E && typeof E == "object" ? y[D] = b($, E, C) : y.push(E);
      } else
        y[D] = E;
    }), y) : Object.keys(w).reduce(function(E, D) {
      var $ = w[D];
      return t.call(E, D) ? E[D] = b(E[D], $, C) : E[D] = $, E;
    }, T);
  }, c = function(y, w) {
    return Object.keys(w).reduce(function(C, T) {
      return C[T] = w[T], C;
    }, y);
  }, u = function(b, y, w) {
    var C = b.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return C.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(C);
    } catch {
      return C;
    }
  }, s = 1024, f = function(y, w, C, T, E) {
    if (y.length === 0)
      return y;
    var D = y;
    if (typeof y == "symbol" ? D = Symbol.prototype.toString.call(y) : typeof y != "string" && (D = String(y)), C === "iso-8859-1")
      return escape(D).replace(/%u[0-9a-f]{4}/gi, function(re) {
        return "%26%23" + parseInt(re.slice(2), 16) + "%3B";
      });
    for (var $ = "", Z = 0; Z < D.length; Z += s) {
      for (var te = D.length >= s ? D.slice(Z, Z + s) : D, se = [], ee = 0; ee < te.length; ++ee) {
        var K = te.charCodeAt(ee);
        if (K === 45 || K === 46 || K === 95 || K === 126 || K >= 48 && K <= 57 || K >= 65 && K <= 90 || K >= 97 && K <= 122 || E === e.RFC1738 && (K === 40 || K === 41)) {
          se[se.length] = te.charAt(ee);
          continue;
        }
        if (K < 128) {
          se[se.length] = r[K];
          continue;
        }
        if (K < 2048) {
          se[se.length] = r[192 | K >> 6] + r[128 | K & 63];
          continue;
        }
        if (K < 55296 || K >= 57344) {
          se[se.length] = r[224 | K >> 12] + r[128 | K >> 6 & 63] + r[128 | K & 63];
          continue;
        }
        ee += 1, K = 65536 + ((K & 1023) << 10 | te.charCodeAt(ee) & 1023), se[se.length] = r[240 | K >> 18] + r[128 | K >> 12 & 63] + r[128 | K >> 6 & 63] + r[128 | K & 63];
      }
      $ += se.join("");
    }
    return $;
  }, d = function(y) {
    for (var w = [{ obj: { o: y }, prop: "o" }], C = [], T = 0; T < w.length; ++T)
      for (var E = w[T], D = E.obj[E.prop], $ = Object.keys(D), Z = 0; Z < $.length; ++Z) {
        var te = $[Z], se = D[te];
        typeof se == "object" && se !== null && C.indexOf(se) === -1 && (w.push({ obj: D, prop: te }), C.push(se));
      }
    return i(w), y;
  }, l = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, p = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, g = function(y, w) {
    return [].concat(y, w);
  }, v = function(y, w) {
    if (n(y)) {
      for (var C = [], T = 0; T < y.length; T += 1)
        C.push(w(y[T]));
      return C;
    }
    return w(y);
  };
  return s6 = {
    arrayToObject: a,
    assign: c,
    combine: g,
    compact: d,
    decode: u,
    encode: f,
    isBuffer: p,
    isRegExp: l,
    maybeMap: v,
    merge: o
  }, s6;
}
var u6, NS;
function Mne() {
  if (NS) return u6;
  NS = 1;
  var e = $ne(), t = /* @__PURE__ */ ZO(), n = /* @__PURE__ */ Lg(), r = Object.prototype.hasOwnProperty, i = {
    brackets: function(b) {
      return b + "[]";
    },
    comma: "comma",
    indices: function(b, y) {
      return b + "[" + y + "]";
    },
    repeat: function(b) {
      return b;
    }
  }, a = Array.isArray, o = Array.prototype.push, c = function(v, b) {
    o.apply(v, a(b) ? b : [b]);
  }, u = Date.prototype.toISOString, s = n.default, f = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    format: s,
    formatter: n.formatters[s],
    // deprecated
    indices: !1,
    serializeDate: function(b) {
      return u.call(b);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, d = function(b) {
    return typeof b == "string" || typeof b == "number" || typeof b == "boolean" || typeof b == "symbol" || typeof b == "bigint";
  }, l = {}, p = function v(b, y, w, C, T, E, D, $, Z, te, se, ee, K, re, de, ie, me, $e) {
    for (var Pe = b, Le = $e, Ae = 0, He = !1; (Le = Le.get(l)) !== void 0 && !He; ) {
      var Te = Le.get(b);
      if (Ae += 1, typeof Te < "u") {
        if (Te === Ae)
          throw new RangeError("Cyclic object value");
        He = !0;
      }
      typeof Le.get(l) > "u" && (Ae = 0);
    }
    if (typeof te == "function" ? Pe = te(y, Pe) : Pe instanceof Date ? Pe = K(Pe) : w === "comma" && a(Pe) && (Pe = t.maybeMap(Pe, function(Vr) {
      return Vr instanceof Date ? K(Vr) : Vr;
    })), Pe === null) {
      if (E)
        return Z && !ie ? Z(y, f.encoder, me, "key", re) : y;
      Pe = "";
    }
    if (d(Pe) || t.isBuffer(Pe)) {
      if (Z) {
        var we = ie ? y : Z(y, f.encoder, me, "key", re);
        return [de(we) + "=" + de(Z(Pe, f.encoder, me, "value", re))];
      }
      return [de(y) + "=" + de(String(Pe))];
    }
    var qe = [];
    if (typeof Pe > "u")
      return qe;
    var Ge;
    if (w === "comma" && a(Pe))
      ie && Z && (Pe = t.maybeMap(Pe, Z)), Ge = [{ value: Pe.length > 0 ? Pe.join(",") || null : void 0 }];
    else if (a(te))
      Ge = te;
    else {
      var It = Object.keys(Pe);
      Ge = se ? It.sort(se) : It;
    }
    var Qe = $ ? y.replace(/\./g, "%2E") : y, jt = C && a(Pe) && Pe.length === 1 ? Qe + "[]" : Qe;
    if (T && a(Pe) && Pe.length === 0)
      return jt + "[]";
    for (var We = 0; We < Ge.length; ++We) {
      var Lt = Ge[We], Fe = typeof Lt == "object" && typeof Lt.value < "u" ? Lt.value : Pe[Lt];
      if (!(D && Fe === null)) {
        var Ze = ee && $ ? Lt.replace(/\./g, "%2E") : Lt, Ue = a(Pe) ? typeof w == "function" ? w(jt, Ze) : jt : jt + (ee ? "." + Ze : "[" + Ze + "]");
        $e.set(b, Ae);
        var Rt = e();
        Rt.set(l, $e), c(qe, v(
          Fe,
          Ue,
          w,
          C,
          T,
          E,
          D,
          $,
          w === "comma" && ie && a(Pe) ? null : Z,
          te,
          se,
          ee,
          K,
          re,
          de,
          ie,
          me,
          Rt
        ));
      }
    }
    return qe;
  }, g = function(b) {
    if (!b)
      return f;
    if (typeof b.allowEmptyArrays < "u" && typeof b.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof b.encodeDotInKeys < "u" && typeof b.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (b.encoder !== null && typeof b.encoder < "u" && typeof b.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var y = b.charset || f.charset;
    if (typeof b.charset < "u" && b.charset !== "utf-8" && b.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = n.default;
    if (typeof b.format < "u") {
      if (!r.call(n.formatters, b.format))
        throw new TypeError("Unknown format option provided.");
      w = b.format;
    }
    var C = n.formatters[w], T = f.filter;
    (typeof b.filter == "function" || a(b.filter)) && (T = b.filter);
    var E;
    if (b.arrayFormat in i ? E = b.arrayFormat : "indices" in b ? E = b.indices ? "indices" : "repeat" : E = f.arrayFormat, "commaRoundTrip" in b && typeof b.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var D = typeof b.allowDots > "u" ? b.encodeDotInKeys === !0 ? !0 : f.allowDots : !!b.allowDots;
    return {
      addQueryPrefix: typeof b.addQueryPrefix == "boolean" ? b.addQueryPrefix : f.addQueryPrefix,
      allowDots: D,
      allowEmptyArrays: typeof b.allowEmptyArrays == "boolean" ? !!b.allowEmptyArrays : f.allowEmptyArrays,
      arrayFormat: E,
      charset: y,
      charsetSentinel: typeof b.charsetSentinel == "boolean" ? b.charsetSentinel : f.charsetSentinel,
      commaRoundTrip: b.commaRoundTrip,
      delimiter: typeof b.delimiter > "u" ? f.delimiter : b.delimiter,
      encode: typeof b.encode == "boolean" ? b.encode : f.encode,
      encodeDotInKeys: typeof b.encodeDotInKeys == "boolean" ? b.encodeDotInKeys : f.encodeDotInKeys,
      encoder: typeof b.encoder == "function" ? b.encoder : f.encoder,
      encodeValuesOnly: typeof b.encodeValuesOnly == "boolean" ? b.encodeValuesOnly : f.encodeValuesOnly,
      filter: T,
      format: w,
      formatter: C,
      serializeDate: typeof b.serializeDate == "function" ? b.serializeDate : f.serializeDate,
      skipNulls: typeof b.skipNulls == "boolean" ? b.skipNulls : f.skipNulls,
      sort: typeof b.sort == "function" ? b.sort : null,
      strictNullHandling: typeof b.strictNullHandling == "boolean" ? b.strictNullHandling : f.strictNullHandling
    };
  };
  return u6 = function(v, b) {
    var y = v, w = g(b), C, T;
    typeof w.filter == "function" ? (T = w.filter, y = T("", y)) : a(w.filter) && (T = w.filter, C = T);
    var E = [];
    if (typeof y != "object" || y === null)
      return "";
    var D = i[w.arrayFormat], $ = D === "comma" && w.commaRoundTrip;
    C || (C = Object.keys(y)), w.sort && C.sort(w.sort);
    for (var Z = e(), te = 0; te < C.length; ++te) {
      var se = C[te];
      w.skipNulls && y[se] === null || c(E, p(
        y[se],
        se,
        D,
        $,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        Z
      ));
    }
    var ee = E.join(w.delimiter), K = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? K += "utf8=%26%2310003%3B&" : K += "utf8=%E2%9C%93&"), ee.length > 0 ? K + ee : "";
  }, u6;
}
var c6, $S;
function Fne() {
  if ($S) return c6;
  $S = 1;
  var e = /* @__PURE__ */ ZO(), t = Object.prototype.hasOwnProperty, n = Array.isArray, r = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1
  }, i = function(l) {
    return l.replace(/&#(\d+);/g, function(p, g) {
      return String.fromCharCode(parseInt(g, 10));
    });
  }, a = function(l, p) {
    return l && typeof l == "string" && p.comma && l.indexOf(",") > -1 ? l.split(",") : l;
  }, o = "utf8=%26%2310003%3B", c = "utf8=%E2%9C%93", u = function(p, g) {
    var v = { __proto__: null }, b = g.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    b = b.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var y = g.parameterLimit === 1 / 0 ? void 0 : g.parameterLimit, w = b.split(g.delimiter, y), C = -1, T, E = g.charset;
    if (g.charsetSentinel)
      for (T = 0; T < w.length; ++T)
        w[T].indexOf("utf8=") === 0 && (w[T] === c ? E = "utf-8" : w[T] === o && (E = "iso-8859-1"), C = T, T = w.length);
    for (T = 0; T < w.length; ++T)
      if (T !== C) {
        var D = w[T], $ = D.indexOf("]="), Z = $ === -1 ? D.indexOf("=") : $ + 1, te, se;
        Z === -1 ? (te = g.decoder(D, r.decoder, E, "key"), se = g.strictNullHandling ? null : "") : (te = g.decoder(D.slice(0, Z), r.decoder, E, "key"), se = e.maybeMap(
          a(D.slice(Z + 1), g),
          function(K) {
            return g.decoder(K, r.decoder, E, "value");
          }
        )), se && g.interpretNumericEntities && E === "iso-8859-1" && (se = i(se)), D.indexOf("[]=") > -1 && (se = n(se) ? [se] : se);
        var ee = t.call(v, te);
        ee && g.duplicates === "combine" ? v[te] = e.combine(v[te], se) : (!ee || g.duplicates === "last") && (v[te] = se);
      }
    return v;
  }, s = function(l, p, g, v) {
    for (var b = v ? p : a(p, g), y = l.length - 1; y >= 0; --y) {
      var w, C = l[y];
      if (C === "[]" && g.parseArrays)
        w = g.allowEmptyArrays && (b === "" || g.strictNullHandling && b === null) ? [] : [].concat(b);
      else {
        w = g.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var T = C.charAt(0) === "[" && C.charAt(C.length - 1) === "]" ? C.slice(1, -1) : C, E = g.decodeDotInKeys ? T.replace(/%2E/g, ".") : T, D = parseInt(E, 10);
        !g.parseArrays && E === "" ? w = { 0: b } : !isNaN(D) && C !== E && String(D) === E && D >= 0 && g.parseArrays && D <= g.arrayLimit ? (w = [], w[D] = b) : E !== "__proto__" && (w[E] = b);
      }
      b = w;
    }
    return b;
  }, f = function(p, g, v, b) {
    if (p) {
      var y = v.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p, w = /(\[[^[\]]*])/, C = /(\[[^[\]]*])/g, T = v.depth > 0 && w.exec(y), E = T ? y.slice(0, T.index) : y, D = [];
      if (E) {
        if (!v.plainObjects && t.call(Object.prototype, E) && !v.allowPrototypes)
          return;
        D.push(E);
      }
      for (var $ = 0; v.depth > 0 && (T = C.exec(y)) !== null && $ < v.depth; ) {
        if ($ += 1, !v.plainObjects && t.call(Object.prototype, T[1].slice(1, -1)) && !v.allowPrototypes)
          return;
        D.push(T[1]);
      }
      if (T) {
        if (v.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + v.depth + " and strictDepth is true");
        D.push("[" + y.slice(T.index) + "]");
      }
      return s(D, g, v, b);
    }
  }, d = function(p) {
    if (!p)
      return r;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var g = typeof p.charset > "u" ? r.charset : p.charset, v = typeof p.duplicates > "u" ? r.duplicates : p.duplicates;
    if (v !== "combine" && v !== "first" && v !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var b = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : r.allowDots : !!p.allowDots;
    return {
      allowDots: b,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : r.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : r.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : r.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : r.arrayLimit,
      charset: g,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : r.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : r.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : r.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : r.decoder,
      delimiter: typeof p.delimiter == "string" || e.isRegExp(p.delimiter) ? p.delimiter : r.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : r.depth,
      duplicates: v,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : r.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : r.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : r.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : r.strictDepth,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : r.strictNullHandling
    };
  };
  return c6 = function(l, p) {
    var g = d(p);
    if (l === "" || l === null || typeof l > "u")
      return g.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var v = typeof l == "string" ? u(l, g) : l, b = g.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, y = Object.keys(v), w = 0; w < y.length; ++w) {
      var C = y[w], T = f(C, v[C], g, typeof l == "string");
      b = e.merge(b, T, g);
    }
    return g.allowSparse === !0 ? b : e.compact(b);
  }, c6;
}
var l6, MS;
function Bne() {
  if (MS) return l6;
  MS = 1;
  var e = /* @__PURE__ */ Mne(), t = /* @__PURE__ */ Fne(), n = /* @__PURE__ */ Lg();
  return l6 = {
    formats: n,
    parse: t,
    stringify: e
  }, l6;
}
var FS;
function YO() {
  if (FS) return lu;
  FS = 1;
  var e = Lne();
  function t() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  var n = /^([a-z0-9.+-]+:)/i, r = /:[0-9]*$/, i = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, a = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
  ], o = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
  ].concat(a), c = ["'"].concat(o), u = [
    "%",
    "/",
    "?",
    ";",
    "#"
  ].concat(c), s = [
    "/",
    "?",
    "#"
  ], f = 255, d = /^[+a-z0-9A-Z_-]{0,63}$/, l = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, p = {
    javascript: !0,
    "javascript:": !0
  }, g = {
    javascript: !0,
    "javascript:": !0
  }, v = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  }, b = /* @__PURE__ */ Bne();
  function y(E, D, $) {
    if (E && typeof E == "object" && E instanceof t)
      return E;
    var Z = new t();
    return Z.parse(E, D, $), Z;
  }
  t.prototype.parse = function(E, D, $) {
    if (typeof E != "string")
      throw new TypeError("Parameter 'url' must be a string, not " + typeof E);
    var Z = E.indexOf("?"), te = Z !== -1 && Z < E.indexOf("#") ? "?" : "#", se = E.split(te), ee = /\\/g;
    se[0] = se[0].replace(ee, "/"), E = se.join(te);
    var K = E;
    if (K = K.trim(), !$ && E.split("#").length === 1) {
      var re = i.exec(K);
      if (re)
        return this.path = K, this.href = K, this.pathname = re[1], re[2] ? (this.search = re[2], D ? this.query = b.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : D && (this.search = "", this.query = {}), this;
    }
    var de = n.exec(K);
    if (de) {
      de = de[0];
      var ie = de.toLowerCase();
      this.protocol = ie, K = K.substr(de.length);
    }
    if ($ || de || K.match(/^\/\/[^@/]+@[^@/]+/)) {
      var me = K.substr(0, 2) === "//";
      me && !(de && g[de]) && (K = K.substr(2), this.slashes = !0);
    }
    if (!g[de] && (me || de && !v[de])) {
      for (var $e = -1, Pe = 0; Pe < s.length; Pe++) {
        var Le = K.indexOf(s[Pe]);
        Le !== -1 && ($e === -1 || Le < $e) && ($e = Le);
      }
      var Ae, He;
      $e === -1 ? He = K.lastIndexOf("@") : He = K.lastIndexOf("@", $e), He !== -1 && (Ae = K.slice(0, He), K = K.slice(He + 1), this.auth = decodeURIComponent(Ae)), $e = -1;
      for (var Pe = 0; Pe < u.length; Pe++) {
        var Le = K.indexOf(u[Pe]);
        Le !== -1 && ($e === -1 || Le < $e) && ($e = Le);
      }
      $e === -1 && ($e = K.length), this.host = K.slice(0, $e), K = K.slice($e), this.parseHost(), this.hostname = this.hostname || "";
      var Te = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!Te)
        for (var we = this.hostname.split(/\./), Pe = 0, qe = we.length; Pe < qe; Pe++) {
          var Ge = we[Pe];
          if (Ge && !Ge.match(d)) {
            for (var It = "", Qe = 0, jt = Ge.length; Qe < jt; Qe++)
              Ge.charCodeAt(Qe) > 127 ? It += "x" : It += Ge[Qe];
            if (!It.match(d)) {
              var We = we.slice(0, Pe), Lt = we.slice(Pe + 1), Fe = Ge.match(l);
              Fe && (We.push(Fe[1]), Lt.unshift(Fe[2])), Lt.length && (K = "/" + Lt.join(".") + K), this.hostname = We.join(".");
              break;
            }
          }
        }
      this.hostname.length > f ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), Te || (this.hostname = e.toASCII(this.hostname));
      var Ze = this.port ? ":" + this.port : "", Ue = this.hostname || "";
      this.host = Ue + Ze, this.href += this.host, Te && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), K[0] !== "/" && (K = "/" + K));
    }
    if (!p[ie])
      for (var Pe = 0, qe = c.length; Pe < qe; Pe++) {
        var Rt = c[Pe];
        if (K.indexOf(Rt) !== -1) {
          var Vr = encodeURIComponent(Rt);
          Vr === Rt && (Vr = escape(Rt)), K = K.split(Rt).join(Vr);
        }
      }
    var ye = K.indexOf("#");
    ye !== -1 && (this.hash = K.substr(ye), K = K.slice(0, ye));
    var G = K.indexOf("?");
    if (G !== -1 ? (this.search = K.substr(G), this.query = K.substr(G + 1), D && (this.query = b.parse(this.query)), K = K.slice(0, G)) : D && (this.search = "", this.query = {}), K && (this.pathname = K), v[ie] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var Ze = this.pathname || "", Y = this.search || "";
      this.path = Ze + Y;
    }
    return this.href = this.format(), this;
  };
  function w(E) {
    return typeof E == "string" && (E = y(E)), E instanceof t ? E.format() : t.prototype.format.call(E);
  }
  t.prototype.format = function() {
    var E = this.auth || "";
    E && (E = encodeURIComponent(E), E = E.replace(/%3A/i, ":"), E += "@");
    var D = this.protocol || "", $ = this.pathname || "", Z = this.hash || "", te = !1, se = "";
    this.host ? te = E + this.host : this.hostname && (te = E + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (te += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (se = b.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var ee = this.search || se && "?" + se || "";
    return D && D.substr(-1) !== ":" && (D += ":"), this.slashes || (!D || v[D]) && te !== !1 ? (te = "//" + (te || ""), $ && $.charAt(0) !== "/" && ($ = "/" + $)) : te || (te = ""), Z && Z.charAt(0) !== "#" && (Z = "#" + Z), ee && ee.charAt(0) !== "?" && (ee = "?" + ee), $ = $.replace(/[?#]/g, function(K) {
      return encodeURIComponent(K);
    }), ee = ee.replace("#", "%23"), D + te + $ + ee + Z;
  };
  function C(E, D) {
    return y(E, !1, !0).resolve(D);
  }
  t.prototype.resolve = function(E) {
    return this.resolveObject(y(E, !1, !0)).format();
  };
  function T(E, D) {
    return E ? y(E, !1, !0).resolveObject(D) : D;
  }
  return t.prototype.resolveObject = function(E) {
    if (typeof E == "string") {
      var D = new t();
      D.parse(E, !1, !0), E = D;
    }
    for (var $ = new t(), Z = Object.keys(this), te = 0; te < Z.length; te++) {
      var se = Z[te];
      $[se] = this[se];
    }
    if ($.hash = E.hash, E.href === "")
      return $.href = $.format(), $;
    if (E.slashes && !E.protocol) {
      for (var ee = Object.keys(E), K = 0; K < ee.length; K++) {
        var re = ee[K];
        re !== "protocol" && ($[re] = E[re]);
      }
      return v[$.protocol] && $.hostname && !$.pathname && ($.pathname = "/", $.path = $.pathname), $.href = $.format(), $;
    }
    if (E.protocol && E.protocol !== $.protocol) {
      if (!v[E.protocol]) {
        for (var de = Object.keys(E), ie = 0; ie < de.length; ie++) {
          var me = de[ie];
          $[me] = E[me];
        }
        return $.href = $.format(), $;
      }
      if ($.protocol = E.protocol, !E.host && !g[E.protocol]) {
        for (var qe = (E.pathname || "").split("/"); qe.length && !(E.host = qe.shift()); )
          ;
        E.host || (E.host = ""), E.hostname || (E.hostname = ""), qe[0] !== "" && qe.unshift(""), qe.length < 2 && qe.unshift(""), $.pathname = qe.join("/");
      } else
        $.pathname = E.pathname;
      if ($.search = E.search, $.query = E.query, $.host = E.host || "", $.auth = E.auth, $.hostname = E.hostname || E.host, $.port = E.port, $.pathname || $.search) {
        var $e = $.pathname || "", Pe = $.search || "";
        $.path = $e + Pe;
      }
      return $.slashes = $.slashes || E.slashes, $.href = $.format(), $;
    }
    var Le = $.pathname && $.pathname.charAt(0) === "/", Ae = E.host || E.pathname && E.pathname.charAt(0) === "/", He = Ae || Le || $.host && E.pathname, Te = He, we = $.pathname && $.pathname.split("/") || [], qe = E.pathname && E.pathname.split("/") || [], Ge = $.protocol && !v[$.protocol];
    if (Ge && ($.hostname = "", $.port = null, $.host && (we[0] === "" ? we[0] = $.host : we.unshift($.host)), $.host = "", E.protocol && (E.hostname = null, E.port = null, E.host && (qe[0] === "" ? qe[0] = E.host : qe.unshift(E.host)), E.host = null), He = He && (qe[0] === "" || we[0] === "")), Ae)
      $.host = E.host || E.host === "" ? E.host : $.host, $.hostname = E.hostname || E.hostname === "" ? E.hostname : $.hostname, $.search = E.search, $.query = E.query, we = qe;
    else if (qe.length)
      we || (we = []), we.pop(), we = we.concat(qe), $.search = E.search, $.query = E.query;
    else if (E.search != null) {
      if (Ge) {
        $.host = we.shift(), $.hostname = $.host;
        var It = $.host && $.host.indexOf("@") > 0 ? $.host.split("@") : !1;
        It && ($.auth = It.shift(), $.hostname = It.shift(), $.host = $.hostname);
      }
      return $.search = E.search, $.query = E.query, ($.pathname !== null || $.search !== null) && ($.path = ($.pathname ? $.pathname : "") + ($.search ? $.search : "")), $.href = $.format(), $;
    }
    if (!we.length)
      return $.pathname = null, $.search ? $.path = "/" + $.search : $.path = null, $.href = $.format(), $;
    for (var Qe = we.slice(-1)[0], jt = ($.host || E.host || we.length > 1) && (Qe === "." || Qe === "..") || Qe === "", We = 0, Lt = we.length; Lt >= 0; Lt--)
      Qe = we[Lt], Qe === "." ? we.splice(Lt, 1) : Qe === ".." ? (we.splice(Lt, 1), We++) : We && (we.splice(Lt, 1), We--);
    if (!He && !Te)
      for (; We--; We)
        we.unshift("..");
    He && we[0] !== "" && (!we[0] || we[0].charAt(0) !== "/") && we.unshift(""), jt && we.join("/").substr(-1) !== "/" && we.push("");
    var Fe = we[0] === "" || we[0] && we[0].charAt(0) === "/";
    if (Ge) {
      $.hostname = Fe ? "" : we.length ? we.shift() : "", $.host = $.hostname;
      var It = $.host && $.host.indexOf("@") > 0 ? $.host.split("@") : !1;
      It && ($.auth = It.shift(), $.hostname = It.shift(), $.host = $.hostname);
    }
    return He = He || $.host && we.length, He && !Fe && we.unshift(""), we.length > 0 ? $.pathname = we.join("/") : ($.pathname = null, $.path = null), ($.pathname !== null || $.search !== null) && ($.path = ($.pathname ? $.pathname : "") + ($.search ? $.search : "")), $.auth = E.auth || $.auth, $.slashes = $.slashes || E.slashes, $.href = $.format(), $;
  }, t.prototype.parseHost = function() {
    var E = this.host, D = r.exec(E);
    D && (D = D[0], D !== ":" && (this.port = D.substr(1)), E = E.substr(0, E.length - D.length)), E && (this.hostname = E);
  }, lu.parse = y, lu.resolve = C, lu.resolveObject = T, lu.format = w, lu.Url = t, lu;
}
var f6 = {};
const Une = {
  "application/1d-interleaved-parityfec": { source: "iana" },
  "application/3gpdash-qoe-report+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/3gpp-ims+xml": { source: "iana", compressible: !0 },
  "application/3gpphal+json": { source: "iana", compressible: !0 },
  "application/3gpphalforms+json": { source: "iana", compressible: !0 },
  "application/a2l": { source: "iana" },
  "application/ace+cbor": { source: "iana" },
  "application/activemessage": { source: "iana" },
  "application/activity+json": { source: "iana", compressible: !0 },
  "application/alto-costmap+json": { source: "iana", compressible: !0 },
  "application/alto-costmapfilter+json": { source: "iana", compressible: !0 },
  "application/alto-directory+json": { source: "iana", compressible: !0 },
  "application/alto-endpointcost+json": { source: "iana", compressible: !0 },
  "application/alto-endpointcostparams+json": { source: "iana", compressible: !0 },
  "application/alto-endpointprop+json": { source: "iana", compressible: !0 },
  "application/alto-endpointpropparams+json": { source: "iana", compressible: !0 },
  "application/alto-error+json": { source: "iana", compressible: !0 },
  "application/alto-networkmap+json": { source: "iana", compressible: !0 },
  "application/alto-networkmapfilter+json": { source: "iana", compressible: !0 },
  "application/alto-updatestreamcontrol+json": { source: "iana", compressible: !0 },
  "application/alto-updatestreamparams+json": { source: "iana", compressible: !0 },
  "application/aml": { source: "iana" },
  "application/andrew-inset": { source: "iana", extensions: ["ez"] },
  "application/applefile": { source: "iana" },
  "application/applixware": { source: "apache", extensions: ["aw"] },
  "application/at+jwt": { source: "iana" },
  "application/atf": { source: "iana" },
  "application/atfx": { source: "iana" },
  "application/atom+xml": { source: "iana", compressible: !0, extensions: ["atom"] },
  "application/atomcat+xml": { source: "iana", compressible: !0, extensions: ["atomcat"] },
  "application/atomdeleted+xml": { source: "iana", compressible: !0, extensions: ["atomdeleted"] },
  "application/atomicmail": { source: "iana" },
  "application/atomsvc+xml": { source: "iana", compressible: !0, extensions: ["atomsvc"] },
  "application/atsc-dwd+xml": { source: "iana", compressible: !0, extensions: ["dwd"] },
  "application/atsc-dynamic-event-message": { source: "iana" },
  "application/atsc-held+xml": { source: "iana", compressible: !0, extensions: ["held"] },
  "application/atsc-rdt+json": { source: "iana", compressible: !0 },
  "application/atsc-rsat+xml": { source: "iana", compressible: !0, extensions: ["rsat"] },
  "application/atxml": { source: "iana" },
  "application/auth-policy+xml": { source: "iana", compressible: !0 },
  "application/bacnet-xdd+zip": { source: "iana", compressible: !1 },
  "application/batch-smtp": { source: "iana" },
  "application/bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/beep+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/calendar+json": { source: "iana", compressible: !0 },
  "application/calendar+xml": { source: "iana", compressible: !0, extensions: ["xcs"] },
  "application/call-completion": { source: "iana" },
  "application/cals-1840": { source: "iana" },
  "application/captive+json": { source: "iana", compressible: !0 },
  "application/cbor": { source: "iana" },
  "application/cbor-seq": { source: "iana" },
  "application/cccex": { source: "iana" },
  "application/ccmp+xml": { source: "iana", compressible: !0 },
  "application/ccxml+xml": { source: "iana", compressible: !0, extensions: ["ccxml"] },
  "application/cdfx+xml": { source: "iana", compressible: !0, extensions: ["cdfx"] },
  "application/cdmi-capability": { source: "iana", extensions: ["cdmia"] },
  "application/cdmi-container": { source: "iana", extensions: ["cdmic"] },
  "application/cdmi-domain": { source: "iana", extensions: ["cdmid"] },
  "application/cdmi-object": { source: "iana", extensions: ["cdmio"] },
  "application/cdmi-queue": { source: "iana", extensions: ["cdmiq"] },
  "application/cdni": { source: "iana" },
  "application/cea": { source: "iana" },
  "application/cea-2018+xml": { source: "iana", compressible: !0 },
  "application/cellml+xml": { source: "iana", compressible: !0 },
  "application/cfw": { source: "iana" },
  "application/city+json": { source: "iana", compressible: !0 },
  "application/clr": { source: "iana" },
  "application/clue+xml": { source: "iana", compressible: !0 },
  "application/clue_info+xml": { source: "iana", compressible: !0 },
  "application/cms": { source: "iana" },
  "application/cnrp+xml": { source: "iana", compressible: !0 },
  "application/coap-group+json": { source: "iana", compressible: !0 },
  "application/coap-payload": { source: "iana" },
  "application/commonground": { source: "iana" },
  "application/conference-info+xml": { source: "iana", compressible: !0 },
  "application/cose": { source: "iana" },
  "application/cose-key": { source: "iana" },
  "application/cose-key-set": { source: "iana" },
  "application/cpl+xml": { source: "iana", compressible: !0, extensions: ["cpl"] },
  "application/csrattrs": { source: "iana" },
  "application/csta+xml": { source: "iana", compressible: !0 },
  "application/cstadata+xml": { source: "iana", compressible: !0 },
  "application/csvm+json": { source: "iana", compressible: !0 },
  "application/cu-seeme": { source: "apache", extensions: ["cu"] },
  "application/cwt": { source: "iana" },
  "application/cybercash": { source: "iana" },
  "application/dart": { compressible: !0 },
  "application/dash+xml": { source: "iana", compressible: !0, extensions: ["mpd"] },
  "application/dash-patch+xml": { source: "iana", compressible: !0, extensions: ["mpp"] },
  "application/dashdelta": { source: "iana" },
  "application/davmount+xml": { source: "iana", compressible: !0, extensions: ["davmount"] },
  "application/dca-rft": { source: "iana" },
  "application/dcd": { source: "iana" },
  "application/dec-dx": { source: "iana" },
  "application/dialog-info+xml": { source: "iana", compressible: !0 },
  "application/dicom": { source: "iana" },
  "application/dicom+json": { source: "iana", compressible: !0 },
  "application/dicom+xml": { source: "iana", compressible: !0 },
  "application/dii": { source: "iana" },
  "application/dit": { source: "iana" },
  "application/dns": { source: "iana" },
  "application/dns+json": { source: "iana", compressible: !0 },
  "application/dns-message": { source: "iana" },
  "application/docbook+xml": { source: "apache", compressible: !0, extensions: ["dbk"] },
  "application/dots+cbor": { source: "iana" },
  "application/dskpp+xml": { source: "iana", compressible: !0 },
  "application/dssc+der": { source: "iana", extensions: ["dssc"] },
  "application/dssc+xml": { source: "iana", compressible: !0, extensions: ["xdssc"] },
  "application/dvcs": { source: "iana" },
  "application/ecmascript": { source: "iana", compressible: !0, extensions: ["es", "ecma"] },
  "application/edi-consent": { source: "iana" },
  "application/edi-x12": { source: "iana", compressible: !1 },
  "application/edifact": { source: "iana", compressible: !1 },
  "application/efi": { source: "iana" },
  "application/elm+json": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/elm+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.cap+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/emergencycalldata.comment+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.control+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.deviceinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.ecall.msd": { source: "iana" },
  "application/emergencycalldata.providerinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.serviceinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.subscriberinfo+xml": { source: "iana", compressible: !0 },
  "application/emergencycalldata.veds+xml": { source: "iana", compressible: !0 },
  "application/emma+xml": { source: "iana", compressible: !0, extensions: ["emma"] },
  "application/emotionml+xml": { source: "iana", compressible: !0, extensions: ["emotionml"] },
  "application/encaprtp": { source: "iana" },
  "application/epp+xml": { source: "iana", compressible: !0 },
  "application/epub+zip": { source: "iana", compressible: !1, extensions: ["epub"] },
  "application/eshop": { source: "iana" },
  "application/exi": { source: "iana", extensions: ["exi"] },
  "application/expect-ct-report+json": { source: "iana", compressible: !0 },
  "application/express": { source: "iana", extensions: ["exp"] },
  "application/fastinfoset": { source: "iana" },
  "application/fastsoap": { source: "iana" },
  "application/fdt+xml": { source: "iana", compressible: !0, extensions: ["fdt"] },
  "application/fhir+json": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/fhir+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/fido.trusted-apps+json": { compressible: !0 },
  "application/fits": { source: "iana" },
  "application/flexfec": { source: "iana" },
  "application/font-sfnt": { source: "iana" },
  "application/font-tdpfr": { source: "iana", extensions: ["pfr"] },
  "application/font-woff": { source: "iana", compressible: !1 },
  "application/framework-attributes+xml": { source: "iana", compressible: !0 },
  "application/geo+json": { source: "iana", compressible: !0, extensions: ["geojson"] },
  "application/geo+json-seq": { source: "iana" },
  "application/geopackage+sqlite3": { source: "iana" },
  "application/geoxacml+xml": { source: "iana", compressible: !0 },
  "application/gltf-buffer": { source: "iana" },
  "application/gml+xml": { source: "iana", compressible: !0, extensions: ["gml"] },
  "application/gpx+xml": { source: "apache", compressible: !0, extensions: ["gpx"] },
  "application/gxf": { source: "apache", extensions: ["gxf"] },
  "application/gzip": { source: "iana", compressible: !1, extensions: ["gz"] },
  "application/h224": { source: "iana" },
  "application/held+xml": { source: "iana", compressible: !0 },
  "application/hjson": { extensions: ["hjson"] },
  "application/http": { source: "iana" },
  "application/hyperstudio": { source: "iana", extensions: ["stk"] },
  "application/ibe-key-request+xml": { source: "iana", compressible: !0 },
  "application/ibe-pkg-reply+xml": { source: "iana", compressible: !0 },
  "application/ibe-pp-data": { source: "iana" },
  "application/iges": { source: "iana" },
  "application/im-iscomposing+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/index": { source: "iana" },
  "application/index.cmd": { source: "iana" },
  "application/index.obj": { source: "iana" },
  "application/index.response": { source: "iana" },
  "application/index.vnd": { source: "iana" },
  "application/inkml+xml": { source: "iana", compressible: !0, extensions: ["ink", "inkml"] },
  "application/iotp": { source: "iana" },
  "application/ipfix": { source: "iana", extensions: ["ipfix"] },
  "application/ipp": { source: "iana" },
  "application/isup": { source: "iana" },
  "application/its+xml": { source: "iana", compressible: !0, extensions: ["its"] },
  "application/java-archive": { source: "apache", compressible: !1, extensions: ["jar", "war", "ear"] },
  "application/java-serialized-object": { source: "apache", compressible: !1, extensions: ["ser"] },
  "application/java-vm": { source: "apache", compressible: !1, extensions: ["class"] },
  "application/javascript": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["js", "mjs"] },
  "application/jf2feed+json": { source: "iana", compressible: !0 },
  "application/jose": { source: "iana" },
  "application/jose+json": { source: "iana", compressible: !0 },
  "application/jrd+json": { source: "iana", compressible: !0 },
  "application/jscalendar+json": { source: "iana", compressible: !0 },
  "application/json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["json", "map"] },
  "application/json-patch+json": { source: "iana", compressible: !0 },
  "application/json-seq": { source: "iana" },
  "application/json5": { extensions: ["json5"] },
  "application/jsonml+json": { source: "apache", compressible: !0, extensions: ["jsonml"] },
  "application/jwk+json": { source: "iana", compressible: !0 },
  "application/jwk-set+json": { source: "iana", compressible: !0 },
  "application/jwt": { source: "iana" },
  "application/kpml-request+xml": { source: "iana", compressible: !0 },
  "application/kpml-response+xml": { source: "iana", compressible: !0 },
  "application/ld+json": { source: "iana", compressible: !0, extensions: ["jsonld"] },
  "application/lgr+xml": { source: "iana", compressible: !0, extensions: ["lgr"] },
  "application/link-format": { source: "iana" },
  "application/load-control+xml": { source: "iana", compressible: !0 },
  "application/lost+xml": { source: "iana", compressible: !0, extensions: ["lostxml"] },
  "application/lostsync+xml": { source: "iana", compressible: !0 },
  "application/lpf+zip": { source: "iana", compressible: !1 },
  "application/lxf": { source: "iana" },
  "application/mac-binhex40": { source: "iana", extensions: ["hqx"] },
  "application/mac-compactpro": { source: "apache", extensions: ["cpt"] },
  "application/macwriteii": { source: "iana" },
  "application/mads+xml": { source: "iana", compressible: !0, extensions: ["mads"] },
  "application/manifest+json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["webmanifest"] },
  "application/marc": { source: "iana", extensions: ["mrc"] },
  "application/marcxml+xml": { source: "iana", compressible: !0, extensions: ["mrcx"] },
  "application/mathematica": { source: "iana", extensions: ["ma", "nb", "mb"] },
  "application/mathml+xml": { source: "iana", compressible: !0, extensions: ["mathml"] },
  "application/mathml-content+xml": { source: "iana", compressible: !0 },
  "application/mathml-presentation+xml": { source: "iana", compressible: !0 },
  "application/mbms-associated-procedure-description+xml": { source: "iana", compressible: !0 },
  "application/mbms-deregister+xml": { source: "iana", compressible: !0 },
  "application/mbms-envelope+xml": { source: "iana", compressible: !0 },
  "application/mbms-msk+xml": { source: "iana", compressible: !0 },
  "application/mbms-msk-response+xml": { source: "iana", compressible: !0 },
  "application/mbms-protection-description+xml": { source: "iana", compressible: !0 },
  "application/mbms-reception-report+xml": { source: "iana", compressible: !0 },
  "application/mbms-register+xml": { source: "iana", compressible: !0 },
  "application/mbms-register-response+xml": { source: "iana", compressible: !0 },
  "application/mbms-schedule+xml": { source: "iana", compressible: !0 },
  "application/mbms-user-service-description+xml": { source: "iana", compressible: !0 },
  "application/mbox": { source: "iana", extensions: ["mbox"] },
  "application/media-policy-dataset+xml": { source: "iana", compressible: !0, extensions: ["mpf"] },
  "application/media_control+xml": { source: "iana", compressible: !0 },
  "application/mediaservercontrol+xml": { source: "iana", compressible: !0, extensions: ["mscml"] },
  "application/merge-patch+json": { source: "iana", compressible: !0 },
  "application/metalink+xml": { source: "apache", compressible: !0, extensions: ["metalink"] },
  "application/metalink4+xml": { source: "iana", compressible: !0, extensions: ["meta4"] },
  "application/mets+xml": { source: "iana", compressible: !0, extensions: ["mets"] },
  "application/mf4": { source: "iana" },
  "application/mikey": { source: "iana" },
  "application/mipc": { source: "iana" },
  "application/missing-blocks+cbor-seq": { source: "iana" },
  "application/mmt-aei+xml": { source: "iana", compressible: !0, extensions: ["maei"] },
  "application/mmt-usd+xml": { source: "iana", compressible: !0, extensions: ["musd"] },
  "application/mods+xml": { source: "iana", compressible: !0, extensions: ["mods"] },
  "application/moss-keys": { source: "iana" },
  "application/moss-signature": { source: "iana" },
  "application/mosskey-data": { source: "iana" },
  "application/mosskey-request": { source: "iana" },
  "application/mp21": { source: "iana", extensions: ["m21", "mp21"] },
  "application/mp4": { source: "iana", extensions: ["mp4s", "m4p"] },
  "application/mpeg4-generic": { source: "iana" },
  "application/mpeg4-iod": { source: "iana" },
  "application/mpeg4-iod-xmt": { source: "iana" },
  "application/mrb-consumer+xml": { source: "iana", compressible: !0 },
  "application/mrb-publish+xml": { source: "iana", compressible: !0 },
  "application/msc-ivr+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/msc-mixer+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/msword": { source: "iana", compressible: !1, extensions: ["doc", "dot"] },
  "application/mud+json": { source: "iana", compressible: !0 },
  "application/multipart-core": { source: "iana" },
  "application/mxf": { source: "iana", extensions: ["mxf"] },
  "application/n-quads": { source: "iana", extensions: ["nq"] },
  "application/n-triples": { source: "iana", extensions: ["nt"] },
  "application/nasdata": { source: "iana" },
  "application/news-checkgroups": { source: "iana", charset: "US-ASCII" },
  "application/news-groupinfo": { source: "iana", charset: "US-ASCII" },
  "application/news-transmission": { source: "iana" },
  "application/nlsml+xml": { source: "iana", compressible: !0 },
  "application/node": { source: "iana", extensions: ["cjs"] },
  "application/nss": { source: "iana" },
  "application/oauth-authz-req+jwt": { source: "iana" },
  "application/oblivious-dns-message": { source: "iana" },
  "application/ocsp-request": { source: "iana" },
  "application/ocsp-response": { source: "iana" },
  "application/octet-stream": { source: "iana", compressible: !1, extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] },
  "application/oda": { source: "iana", extensions: ["oda"] },
  "application/odm+xml": { source: "iana", compressible: !0 },
  "application/odx": { source: "iana" },
  "application/oebps-package+xml": { source: "iana", compressible: !0, extensions: ["opf"] },
  "application/ogg": { source: "iana", compressible: !1, extensions: ["ogx"] },
  "application/omdoc+xml": { source: "apache", compressible: !0, extensions: ["omdoc"] },
  "application/onenote": { source: "apache", extensions: ["onetoc", "onetoc2", "onetmp", "onepkg"] },
  "application/opc-nodeset+xml": { source: "iana", compressible: !0 },
  "application/oscore": { source: "iana" },
  "application/oxps": { source: "iana", extensions: ["oxps"] },
  "application/p21": { source: "iana" },
  "application/p21+zip": { source: "iana", compressible: !1 },
  "application/p2p-overlay+xml": { source: "iana", compressible: !0, extensions: ["relo"] },
  "application/parityfec": { source: "iana" },
  "application/passport": { source: "iana" },
  "application/patch-ops-error+xml": { source: "iana", compressible: !0, extensions: ["xer"] },
  "application/pdf": { source: "iana", compressible: !1, extensions: ["pdf"] },
  "application/pdx": { source: "iana" },
  "application/pem-certificate-chain": { source: "iana" },
  "application/pgp-encrypted": { source: "iana", compressible: !1, extensions: ["pgp"] },
  "application/pgp-keys": { source: "iana", extensions: ["asc"] },
  "application/pgp-signature": { source: "iana", extensions: ["asc", "sig"] },
  "application/pics-rules": { source: "apache", extensions: ["prf"] },
  "application/pidf+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/pidf-diff+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/pkcs10": { source: "iana", extensions: ["p10"] },
  "application/pkcs12": { source: "iana" },
  "application/pkcs7-mime": { source: "iana", extensions: ["p7m", "p7c"] },
  "application/pkcs7-signature": { source: "iana", extensions: ["p7s"] },
  "application/pkcs8": { source: "iana", extensions: ["p8"] },
  "application/pkcs8-encrypted": { source: "iana" },
  "application/pkix-attr-cert": { source: "iana", extensions: ["ac"] },
  "application/pkix-cert": { source: "iana", extensions: ["cer"] },
  "application/pkix-crl": { source: "iana", extensions: ["crl"] },
  "application/pkix-pkipath": { source: "iana", extensions: ["pkipath"] },
  "application/pkixcmp": { source: "iana", extensions: ["pki"] },
  "application/pls+xml": { source: "iana", compressible: !0, extensions: ["pls"] },
  "application/poc-settings+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/postscript": { source: "iana", compressible: !0, extensions: ["ai", "eps", "ps"] },
  "application/ppsp-tracker+json": { source: "iana", compressible: !0 },
  "application/problem+json": { source: "iana", compressible: !0 },
  "application/problem+xml": { source: "iana", compressible: !0 },
  "application/provenance+xml": { source: "iana", compressible: !0, extensions: ["provx"] },
  "application/prs.alvestrand.titrax-sheet": { source: "iana" },
  "application/prs.cww": { source: "iana", extensions: ["cww"] },
  "application/prs.cyn": { source: "iana", charset: "7-BIT" },
  "application/prs.hpub+zip": { source: "iana", compressible: !1 },
  "application/prs.nprend": { source: "iana" },
  "application/prs.plucker": { source: "iana" },
  "application/prs.rdf-xml-crypt": { source: "iana" },
  "application/prs.xsf+xml": { source: "iana", compressible: !0 },
  "application/pskc+xml": { source: "iana", compressible: !0, extensions: ["pskcxml"] },
  "application/pvd+json": { source: "iana", compressible: !0 },
  "application/qsig": { source: "iana" },
  "application/raml+yaml": { compressible: !0, extensions: ["raml"] },
  "application/raptorfec": { source: "iana" },
  "application/rdap+json": { source: "iana", compressible: !0 },
  "application/rdf+xml": { source: "iana", compressible: !0, extensions: ["rdf", "owl"] },
  "application/reginfo+xml": { source: "iana", compressible: !0, extensions: ["rif"] },
  "application/relax-ng-compact-syntax": { source: "iana", extensions: ["rnc"] },
  "application/remote-printing": { source: "iana" },
  "application/reputon+json": { source: "iana", compressible: !0 },
  "application/resource-lists+xml": { source: "iana", compressible: !0, extensions: ["rl"] },
  "application/resource-lists-diff+xml": { source: "iana", compressible: !0, extensions: ["rld"] },
  "application/rfc+xml": { source: "iana", compressible: !0 },
  "application/riscos": { source: "iana" },
  "application/rlmi+xml": { source: "iana", compressible: !0 },
  "application/rls-services+xml": { source: "iana", compressible: !0, extensions: ["rs"] },
  "application/route-apd+xml": { source: "iana", compressible: !0, extensions: ["rapd"] },
  "application/route-s-tsid+xml": { source: "iana", compressible: !0, extensions: ["sls"] },
  "application/route-usd+xml": { source: "iana", compressible: !0, extensions: ["rusd"] },
  "application/rpki-ghostbusters": { source: "iana", extensions: ["gbr"] },
  "application/rpki-manifest": { source: "iana", extensions: ["mft"] },
  "application/rpki-publication": { source: "iana" },
  "application/rpki-roa": { source: "iana", extensions: ["roa"] },
  "application/rpki-updown": { source: "iana" },
  "application/rsd+xml": { source: "apache", compressible: !0, extensions: ["rsd"] },
  "application/rss+xml": { source: "apache", compressible: !0, extensions: ["rss"] },
  "application/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "application/rtploopback": { source: "iana" },
  "application/rtx": { source: "iana" },
  "application/samlassertion+xml": { source: "iana", compressible: !0 },
  "application/samlmetadata+xml": { source: "iana", compressible: !0 },
  "application/sarif+json": { source: "iana", compressible: !0 },
  "application/sarif-external-properties+json": { source: "iana", compressible: !0 },
  "application/sbe": { source: "iana" },
  "application/sbml+xml": { source: "iana", compressible: !0, extensions: ["sbml"] },
  "application/scaip+xml": { source: "iana", compressible: !0 },
  "application/scim+json": { source: "iana", compressible: !0 },
  "application/scvp-cv-request": { source: "iana", extensions: ["scq"] },
  "application/scvp-cv-response": { source: "iana", extensions: ["scs"] },
  "application/scvp-vp-request": { source: "iana", extensions: ["spq"] },
  "application/scvp-vp-response": { source: "iana", extensions: ["spp"] },
  "application/sdp": { source: "iana", extensions: ["sdp"] },
  "application/secevent+jwt": { source: "iana" },
  "application/senml+cbor": { source: "iana" },
  "application/senml+json": { source: "iana", compressible: !0 },
  "application/senml+xml": { source: "iana", compressible: !0, extensions: ["senmlx"] },
  "application/senml-etch+cbor": { source: "iana" },
  "application/senml-etch+json": { source: "iana", compressible: !0 },
  "application/senml-exi": { source: "iana" },
  "application/sensml+cbor": { source: "iana" },
  "application/sensml+json": { source: "iana", compressible: !0 },
  "application/sensml+xml": { source: "iana", compressible: !0, extensions: ["sensmlx"] },
  "application/sensml-exi": { source: "iana" },
  "application/sep+xml": { source: "iana", compressible: !0 },
  "application/sep-exi": { source: "iana" },
  "application/session-info": { source: "iana" },
  "application/set-payment": { source: "iana" },
  "application/set-payment-initiation": { source: "iana", extensions: ["setpay"] },
  "application/set-registration": { source: "iana" },
  "application/set-registration-initiation": { source: "iana", extensions: ["setreg"] },
  "application/sgml": { source: "iana" },
  "application/sgml-open-catalog": { source: "iana" },
  "application/shf+xml": { source: "iana", compressible: !0, extensions: ["shf"] },
  "application/sieve": { source: "iana", extensions: ["siv", "sieve"] },
  "application/simple-filter+xml": { source: "iana", compressible: !0 },
  "application/simple-message-summary": { source: "iana" },
  "application/simplesymbolcontainer": { source: "iana" },
  "application/sipc": { source: "iana" },
  "application/slate": { source: "iana" },
  "application/smil": { source: "iana" },
  "application/smil+xml": { source: "iana", compressible: !0, extensions: ["smi", "smil"] },
  "application/smpte336m": { source: "iana" },
  "application/soap+fastinfoset": { source: "iana" },
  "application/soap+xml": { source: "iana", compressible: !0 },
  "application/sparql-query": { source: "iana", extensions: ["rq"] },
  "application/sparql-results+xml": { source: "iana", compressible: !0, extensions: ["srx"] },
  "application/spdx+json": { source: "iana", compressible: !0 },
  "application/spirits-event+xml": { source: "iana", compressible: !0 },
  "application/sql": { source: "iana" },
  "application/srgs": { source: "iana", extensions: ["gram"] },
  "application/srgs+xml": { source: "iana", compressible: !0, extensions: ["grxml"] },
  "application/sru+xml": { source: "iana", compressible: !0, extensions: ["sru"] },
  "application/ssdl+xml": { source: "apache", compressible: !0, extensions: ["ssdl"] },
  "application/ssml+xml": { source: "iana", compressible: !0, extensions: ["ssml"] },
  "application/stix+json": { source: "iana", compressible: !0 },
  "application/swid+xml": { source: "iana", compressible: !0, extensions: ["swidtag"] },
  "application/tamp-apex-update": { source: "iana" },
  "application/tamp-apex-update-confirm": { source: "iana" },
  "application/tamp-community-update": { source: "iana" },
  "application/tamp-community-update-confirm": { source: "iana" },
  "application/tamp-error": { source: "iana" },
  "application/tamp-sequence-adjust": { source: "iana" },
  "application/tamp-sequence-adjust-confirm": { source: "iana" },
  "application/tamp-status-query": { source: "iana" },
  "application/tamp-status-response": { source: "iana" },
  "application/tamp-update": { source: "iana" },
  "application/tamp-update-confirm": { source: "iana" },
  "application/tar": { compressible: !0 },
  "application/taxii+json": { source: "iana", compressible: !0 },
  "application/td+json": { source: "iana", compressible: !0 },
  "application/tei+xml": { source: "iana", compressible: !0, extensions: ["tei", "teicorpus"] },
  "application/tetra_isi": { source: "iana" },
  "application/thraud+xml": { source: "iana", compressible: !0, extensions: ["tfi"] },
  "application/timestamp-query": { source: "iana" },
  "application/timestamp-reply": { source: "iana" },
  "application/timestamped-data": { source: "iana", extensions: ["tsd"] },
  "application/tlsrpt+gzip": { source: "iana" },
  "application/tlsrpt+json": { source: "iana", compressible: !0 },
  "application/tnauthlist": { source: "iana" },
  "application/token-introspection+jwt": { source: "iana" },
  "application/toml": { compressible: !0, extensions: ["toml"] },
  "application/trickle-ice-sdpfrag": { source: "iana" },
  "application/trig": { source: "iana", extensions: ["trig"] },
  "application/ttml+xml": { source: "iana", compressible: !0, extensions: ["ttml"] },
  "application/tve-trigger": { source: "iana" },
  "application/tzif": { source: "iana" },
  "application/tzif-leap": { source: "iana" },
  "application/ubjson": { compressible: !1, extensions: ["ubj"] },
  "application/ulpfec": { source: "iana" },
  "application/urc-grpsheet+xml": { source: "iana", compressible: !0 },
  "application/urc-ressheet+xml": { source: "iana", compressible: !0, extensions: ["rsheet"] },
  "application/urc-targetdesc+xml": { source: "iana", compressible: !0, extensions: ["td"] },
  "application/urc-uisocketdesc+xml": { source: "iana", compressible: !0 },
  "application/vcard+json": { source: "iana", compressible: !0 },
  "application/vcard+xml": { source: "iana", compressible: !0 },
  "application/vemmi": { source: "iana" },
  "application/vividence.scriptfile": { source: "apache" },
  "application/vnd.1000minds.decision-model+xml": { source: "iana", compressible: !0, extensions: ["1km"] },
  "application/vnd.3gpp-prose+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp-prose-pc3ch+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp-v2x-local-service-information": { source: "iana" },
  "application/vnd.3gpp.5gnas": { source: "iana" },
  "application/vnd.3gpp.access-transfer-events+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.bsf+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.gmop+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.gtpc": { source: "iana" },
  "application/vnd.3gpp.interworking-data": { source: "iana" },
  "application/vnd.3gpp.lpp": { source: "iana" },
  "application/vnd.3gpp.mc-signalling-ear": { source: "iana" },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-payload": { source: "iana" },
  "application/vnd.3gpp.mcdata-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-signalling": { source: "iana" },
  "application/vnd.3gpp.mcdata-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcdata-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-floor-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-location-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-signed+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcptt-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-affiliation-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-location-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-service-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-ue-config+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mcvideo-user-profile+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.mid-call+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.ngap": { source: "iana" },
  "application/vnd.3gpp.pfcp": { source: "iana" },
  "application/vnd.3gpp.pic-bw-large": { source: "iana", extensions: ["plb"] },
  "application/vnd.3gpp.pic-bw-small": { source: "iana", extensions: ["psb"] },
  "application/vnd.3gpp.pic-bw-var": { source: "iana", extensions: ["pvb"] },
  "application/vnd.3gpp.s1ap": { source: "iana" },
  "application/vnd.3gpp.sms": { source: "iana" },
  "application/vnd.3gpp.sms+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.srvcc-ext+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.srvcc-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.state-and-event-info+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp.ussd+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp2.bcmcsinfo+xml": { source: "iana", compressible: !0 },
  "application/vnd.3gpp2.sms": { source: "iana" },
  "application/vnd.3gpp2.tcap": { source: "iana", extensions: ["tcap"] },
  "application/vnd.3lightssoftware.imagescal": { source: "iana" },
  "application/vnd.3m.post-it-notes": { source: "iana", extensions: ["pwn"] },
  "application/vnd.accpac.simply.aso": { source: "iana", extensions: ["aso"] },
  "application/vnd.accpac.simply.imp": { source: "iana", extensions: ["imp"] },
  "application/vnd.acucobol": { source: "iana", extensions: ["acu"] },
  "application/vnd.acucorp": { source: "iana", extensions: ["atc", "acutc"] },
  "application/vnd.adobe.air-application-installer-package+zip": { source: "apache", compressible: !1, extensions: ["air"] },
  "application/vnd.adobe.flash.movie": { source: "iana" },
  "application/vnd.adobe.formscentral.fcdt": { source: "iana", extensions: ["fcdt"] },
  "application/vnd.adobe.fxp": { source: "iana", extensions: ["fxp", "fxpl"] },
  "application/vnd.adobe.partial-upload": { source: "iana" },
  "application/vnd.adobe.xdp+xml": { source: "iana", compressible: !0, extensions: ["xdp"] },
  "application/vnd.adobe.xfdf": { source: "iana", extensions: ["xfdf"] },
  "application/vnd.aether.imp": { source: "iana" },
  "application/vnd.afpc.afplinedata": { source: "iana" },
  "application/vnd.afpc.afplinedata-pagedef": { source: "iana" },
  "application/vnd.afpc.cmoca-cmresource": { source: "iana" },
  "application/vnd.afpc.foca-charset": { source: "iana" },
  "application/vnd.afpc.foca-codedfont": { source: "iana" },
  "application/vnd.afpc.foca-codepage": { source: "iana" },
  "application/vnd.afpc.modca": { source: "iana" },
  "application/vnd.afpc.modca-cmtable": { source: "iana" },
  "application/vnd.afpc.modca-formdef": { source: "iana" },
  "application/vnd.afpc.modca-mediummap": { source: "iana" },
  "application/vnd.afpc.modca-objectcontainer": { source: "iana" },
  "application/vnd.afpc.modca-overlay": { source: "iana" },
  "application/vnd.afpc.modca-pagesegment": { source: "iana" },
  "application/vnd.age": { source: "iana", extensions: ["age"] },
  "application/vnd.ah-barcode": { source: "iana" },
  "application/vnd.ahead.space": { source: "iana", extensions: ["ahead"] },
  "application/vnd.airzip.filesecure.azf": { source: "iana", extensions: ["azf"] },
  "application/vnd.airzip.filesecure.azs": { source: "iana", extensions: ["azs"] },
  "application/vnd.amadeus+json": { source: "iana", compressible: !0 },
  "application/vnd.amazon.ebook": { source: "apache", extensions: ["azw"] },
  "application/vnd.amazon.mobi8-ebook": { source: "iana" },
  "application/vnd.americandynamics.acc": { source: "iana", extensions: ["acc"] },
  "application/vnd.amiga.ami": { source: "iana", extensions: ["ami"] },
  "application/vnd.amundsen.maze+xml": { source: "iana", compressible: !0 },
  "application/vnd.android.ota": { source: "iana" },
  "application/vnd.android.package-archive": { source: "apache", compressible: !1, extensions: ["apk"] },
  "application/vnd.anki": { source: "iana" },
  "application/vnd.anser-web-certificate-issue-initiation": { source: "iana", extensions: ["cii"] },
  "application/vnd.anser-web-funds-transfer-initiation": { source: "apache", extensions: ["fti"] },
  "application/vnd.antix.game-component": { source: "iana", extensions: ["atx"] },
  "application/vnd.apache.arrow.file": { source: "iana" },
  "application/vnd.apache.arrow.stream": { source: "iana" },
  "application/vnd.apache.thrift.binary": { source: "iana" },
  "application/vnd.apache.thrift.compact": { source: "iana" },
  "application/vnd.apache.thrift.json": { source: "iana" },
  "application/vnd.api+json": { source: "iana", compressible: !0 },
  "application/vnd.aplextor.warrp+json": { source: "iana", compressible: !0 },
  "application/vnd.apothekende.reservation+json": { source: "iana", compressible: !0 },
  "application/vnd.apple.installer+xml": { source: "iana", compressible: !0, extensions: ["mpkg"] },
  "application/vnd.apple.keynote": { source: "iana", extensions: ["key"] },
  "application/vnd.apple.mpegurl": { source: "iana", extensions: ["m3u8"] },
  "application/vnd.apple.numbers": { source: "iana", extensions: ["numbers"] },
  "application/vnd.apple.pages": { source: "iana", extensions: ["pages"] },
  "application/vnd.apple.pkpass": { compressible: !1, extensions: ["pkpass"] },
  "application/vnd.arastra.swi": { source: "iana" },
  "application/vnd.aristanetworks.swi": { source: "iana", extensions: ["swi"] },
  "application/vnd.artisan+json": { source: "iana", compressible: !0 },
  "application/vnd.artsquare": { source: "iana" },
  "application/vnd.astraea-software.iota": { source: "iana", extensions: ["iota"] },
  "application/vnd.audiograph": { source: "iana", extensions: ["aep"] },
  "application/vnd.autopackage": { source: "iana" },
  "application/vnd.avalon+json": { source: "iana", compressible: !0 },
  "application/vnd.avistar+xml": { source: "iana", compressible: !0 },
  "application/vnd.balsamiq.bmml+xml": { source: "iana", compressible: !0, extensions: ["bmml"] },
  "application/vnd.balsamiq.bmpr": { source: "iana" },
  "application/vnd.banana-accounting": { source: "iana" },
  "application/vnd.bbf.usp.error": { source: "iana" },
  "application/vnd.bbf.usp.msg": { source: "iana" },
  "application/vnd.bbf.usp.msg+json": { source: "iana", compressible: !0 },
  "application/vnd.bekitzur-stech+json": { source: "iana", compressible: !0 },
  "application/vnd.bint.med-content": { source: "iana" },
  "application/vnd.biopax.rdf+xml": { source: "iana", compressible: !0 },
  "application/vnd.blink-idb-value-wrapper": { source: "iana" },
  "application/vnd.blueice.multipass": { source: "iana", extensions: ["mpm"] },
  "application/vnd.bluetooth.ep.oob": { source: "iana" },
  "application/vnd.bluetooth.le.oob": { source: "iana" },
  "application/vnd.bmi": { source: "iana", extensions: ["bmi"] },
  "application/vnd.bpf": { source: "iana" },
  "application/vnd.bpf3": { source: "iana" },
  "application/vnd.businessobjects": { source: "iana", extensions: ["rep"] },
  "application/vnd.byu.uapi+json": { source: "iana", compressible: !0 },
  "application/vnd.cab-jscript": { source: "iana" },
  "application/vnd.canon-cpdl": { source: "iana" },
  "application/vnd.canon-lips": { source: "iana" },
  "application/vnd.capasystems-pg+json": { source: "iana", compressible: !0 },
  "application/vnd.cendio.thinlinc.clientconf": { source: "iana" },
  "application/vnd.century-systems.tcp_stream": { source: "iana" },
  "application/vnd.chemdraw+xml": { source: "iana", compressible: !0, extensions: ["cdxml"] },
  "application/vnd.chess-pgn": { source: "iana" },
  "application/vnd.chipnuts.karaoke-mmd": { source: "iana", extensions: ["mmd"] },
  "application/vnd.ciedi": { source: "iana" },
  "application/vnd.cinderella": { source: "iana", extensions: ["cdy"] },
  "application/vnd.cirpack.isdn-ext": { source: "iana" },
  "application/vnd.citationstyles.style+xml": { source: "iana", compressible: !0, extensions: ["csl"] },
  "application/vnd.claymore": { source: "iana", extensions: ["cla"] },
  "application/vnd.cloanto.rp9": { source: "iana", extensions: ["rp9"] },
  "application/vnd.clonk.c4group": { source: "iana", extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"] },
  "application/vnd.cluetrust.cartomobile-config": { source: "iana", extensions: ["c11amc"] },
  "application/vnd.cluetrust.cartomobile-config-pkg": { source: "iana", extensions: ["c11amz"] },
  "application/vnd.coffeescript": { source: "iana" },
  "application/vnd.collabio.xodocuments.document": { source: "iana" },
  "application/vnd.collabio.xodocuments.document-template": { source: "iana" },
  "application/vnd.collabio.xodocuments.presentation": { source: "iana" },
  "application/vnd.collabio.xodocuments.presentation-template": { source: "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet": { source: "iana" },
  "application/vnd.collabio.xodocuments.spreadsheet-template": { source: "iana" },
  "application/vnd.collection+json": { source: "iana", compressible: !0 },
  "application/vnd.collection.doc+json": { source: "iana", compressible: !0 },
  "application/vnd.collection.next+json": { source: "iana", compressible: !0 },
  "application/vnd.comicbook+zip": { source: "iana", compressible: !1 },
  "application/vnd.comicbook-rar": { source: "iana" },
  "application/vnd.commerce-battelle": { source: "iana" },
  "application/vnd.commonspace": { source: "iana", extensions: ["csp"] },
  "application/vnd.contact.cmsg": { source: "iana", extensions: ["cdbcmsg"] },
  "application/vnd.coreos.ignition+json": { source: "iana", compressible: !0 },
  "application/vnd.cosmocaller": { source: "iana", extensions: ["cmc"] },
  "application/vnd.crick.clicker": { source: "iana", extensions: ["clkx"] },
  "application/vnd.crick.clicker.keyboard": { source: "iana", extensions: ["clkk"] },
  "application/vnd.crick.clicker.palette": { source: "iana", extensions: ["clkp"] },
  "application/vnd.crick.clicker.template": { source: "iana", extensions: ["clkt"] },
  "application/vnd.crick.clicker.wordbank": { source: "iana", extensions: ["clkw"] },
  "application/vnd.criticaltools.wbs+xml": { source: "iana", compressible: !0, extensions: ["wbs"] },
  "application/vnd.cryptii.pipe+json": { source: "iana", compressible: !0 },
  "application/vnd.crypto-shade-file": { source: "iana" },
  "application/vnd.cryptomator.encrypted": { source: "iana" },
  "application/vnd.cryptomator.vault": { source: "iana" },
  "application/vnd.ctc-posml": { source: "iana", extensions: ["pml"] },
  "application/vnd.ctct.ws+xml": { source: "iana", compressible: !0 },
  "application/vnd.cups-pdf": { source: "iana" },
  "application/vnd.cups-postscript": { source: "iana" },
  "application/vnd.cups-ppd": { source: "iana", extensions: ["ppd"] },
  "application/vnd.cups-raster": { source: "iana" },
  "application/vnd.cups-raw": { source: "iana" },
  "application/vnd.curl": { source: "iana" },
  "application/vnd.curl.car": { source: "apache", extensions: ["car"] },
  "application/vnd.curl.pcurl": { source: "apache", extensions: ["pcurl"] },
  "application/vnd.cyan.dean.root+xml": { source: "iana", compressible: !0 },
  "application/vnd.cybank": { source: "iana" },
  "application/vnd.cyclonedx+json": { source: "iana", compressible: !0 },
  "application/vnd.cyclonedx+xml": { source: "iana", compressible: !0 },
  "application/vnd.d2l.coursepackage1p0+zip": { source: "iana", compressible: !1 },
  "application/vnd.d3m-dataset": { source: "iana" },
  "application/vnd.d3m-problem": { source: "iana" },
  "application/vnd.dart": { source: "iana", compressible: !0, extensions: ["dart"] },
  "application/vnd.data-vision.rdz": { source: "iana", extensions: ["rdz"] },
  "application/vnd.datapackage+json": { source: "iana", compressible: !0 },
  "application/vnd.dataresource+json": { source: "iana", compressible: !0 },
  "application/vnd.dbf": { source: "iana", extensions: ["dbf"] },
  "application/vnd.debian.binary-package": { source: "iana" },
  "application/vnd.dece.data": { source: "iana", extensions: ["uvf", "uvvf", "uvd", "uvvd"] },
  "application/vnd.dece.ttml+xml": { source: "iana", compressible: !0, extensions: ["uvt", "uvvt"] },
  "application/vnd.dece.unspecified": { source: "iana", extensions: ["uvx", "uvvx"] },
  "application/vnd.dece.zip": { source: "iana", extensions: ["uvz", "uvvz"] },
  "application/vnd.denovo.fcselayout-link": { source: "iana", extensions: ["fe_launch"] },
  "application/vnd.desmume.movie": { source: "iana" },
  "application/vnd.dir-bi.plate-dl-nosuffix": { source: "iana" },
  "application/vnd.dm.delegation+xml": { source: "iana", compressible: !0 },
  "application/vnd.dna": { source: "iana", extensions: ["dna"] },
  "application/vnd.document+json": { source: "iana", compressible: !0 },
  "application/vnd.dolby.mlp": { source: "apache", extensions: ["mlp"] },
  "application/vnd.dolby.mobile.1": { source: "iana" },
  "application/vnd.dolby.mobile.2": { source: "iana" },
  "application/vnd.doremir.scorecloud-binary-document": { source: "iana" },
  "application/vnd.dpgraph": { source: "iana", extensions: ["dpg"] },
  "application/vnd.dreamfactory": { source: "iana", extensions: ["dfac"] },
  "application/vnd.drive+json": { source: "iana", compressible: !0 },
  "application/vnd.ds-keypoint": { source: "apache", extensions: ["kpxx"] },
  "application/vnd.dtg.local": { source: "iana" },
  "application/vnd.dtg.local.flash": { source: "iana" },
  "application/vnd.dtg.local.html": { source: "iana" },
  "application/vnd.dvb.ait": { source: "iana", extensions: ["ait"] },
  "application/vnd.dvb.dvbisl+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.dvbj": { source: "iana" },
  "application/vnd.dvb.esgcontainer": { source: "iana" },
  "application/vnd.dvb.ipdcdftnotifaccess": { source: "iana" },
  "application/vnd.dvb.ipdcesgaccess": { source: "iana" },
  "application/vnd.dvb.ipdcesgaccess2": { source: "iana" },
  "application/vnd.dvb.ipdcesgpdd": { source: "iana" },
  "application/vnd.dvb.ipdcroaming": { source: "iana" },
  "application/vnd.dvb.iptv.alfec-base": { source: "iana" },
  "application/vnd.dvb.iptv.alfec-enhancement": { source: "iana" },
  "application/vnd.dvb.notif-aggregate-root+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-container+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-generic+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-msglist+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-registration-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-ia-registration-response+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.notif-init+xml": { source: "iana", compressible: !0 },
  "application/vnd.dvb.pfr": { source: "iana" },
  "application/vnd.dvb.service": { source: "iana", extensions: ["svc"] },
  "application/vnd.dxr": { source: "iana" },
  "application/vnd.dynageo": { source: "iana", extensions: ["geo"] },
  "application/vnd.dzr": { source: "iana" },
  "application/vnd.easykaraoke.cdgdownload": { source: "iana" },
  "application/vnd.ecdis-update": { source: "iana" },
  "application/vnd.ecip.rlp": { source: "iana" },
  "application/vnd.eclipse.ditto+json": { source: "iana", compressible: !0 },
  "application/vnd.ecowin.chart": { source: "iana", extensions: ["mag"] },
  "application/vnd.ecowin.filerequest": { source: "iana" },
  "application/vnd.ecowin.fileupdate": { source: "iana" },
  "application/vnd.ecowin.series": { source: "iana" },
  "application/vnd.ecowin.seriesrequest": { source: "iana" },
  "application/vnd.ecowin.seriesupdate": { source: "iana" },
  "application/vnd.efi.img": { source: "iana" },
  "application/vnd.efi.iso": { source: "iana" },
  "application/vnd.emclient.accessrequest+xml": { source: "iana", compressible: !0 },
  "application/vnd.enliven": { source: "iana", extensions: ["nml"] },
  "application/vnd.enphase.envoy": { source: "iana" },
  "application/vnd.eprints.data+xml": { source: "iana", compressible: !0 },
  "application/vnd.epson.esf": { source: "iana", extensions: ["esf"] },
  "application/vnd.epson.msf": { source: "iana", extensions: ["msf"] },
  "application/vnd.epson.quickanime": { source: "iana", extensions: ["qam"] },
  "application/vnd.epson.salt": { source: "iana", extensions: ["slt"] },
  "application/vnd.epson.ssf": { source: "iana", extensions: ["ssf"] },
  "application/vnd.ericsson.quickcall": { source: "iana" },
  "application/vnd.espass-espass+zip": { source: "iana", compressible: !1 },
  "application/vnd.eszigno3+xml": { source: "iana", compressible: !0, extensions: ["es3", "et3"] },
  "application/vnd.etsi.aoc+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.asic-e+zip": { source: "iana", compressible: !1 },
  "application/vnd.etsi.asic-s+zip": { source: "iana", compressible: !1 },
  "application/vnd.etsi.cug+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvcommand+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvdiscovery+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-bc+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-cod+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsad-npvr+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvservice+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvsync+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.iptvueprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.mcid+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.mheg5": { source: "iana" },
  "application/vnd.etsi.overload-control-policy-dataset+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.pstn+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.sci+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.simservs+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.timestamp-token": { source: "iana" },
  "application/vnd.etsi.tsl+xml": { source: "iana", compressible: !0 },
  "application/vnd.etsi.tsl.der": { source: "iana" },
  "application/vnd.eu.kasparian.car+json": { source: "iana", compressible: !0 },
  "application/vnd.eudora.data": { source: "iana" },
  "application/vnd.evolv.ecig.profile": { source: "iana" },
  "application/vnd.evolv.ecig.settings": { source: "iana" },
  "application/vnd.evolv.ecig.theme": { source: "iana" },
  "application/vnd.exstream-empower+zip": { source: "iana", compressible: !1 },
  "application/vnd.exstream-package": { source: "iana" },
  "application/vnd.ezpix-album": { source: "iana", extensions: ["ez2"] },
  "application/vnd.ezpix-package": { source: "iana", extensions: ["ez3"] },
  "application/vnd.f-secure.mobile": { source: "iana" },
  "application/vnd.familysearch.gedcom+zip": { source: "iana", compressible: !1 },
  "application/vnd.fastcopy-disk-image": { source: "iana" },
  "application/vnd.fdf": { source: "iana", extensions: ["fdf"] },
  "application/vnd.fdsn.mseed": { source: "iana", extensions: ["mseed"] },
  "application/vnd.fdsn.seed": { source: "iana", extensions: ["seed", "dataless"] },
  "application/vnd.ffsns": { source: "iana" },
  "application/vnd.ficlab.flb+zip": { source: "iana", compressible: !1 },
  "application/vnd.filmit.zfc": { source: "iana" },
  "application/vnd.fints": { source: "iana" },
  "application/vnd.firemonkeys.cloudcell": { source: "iana" },
  "application/vnd.flographit": { source: "iana", extensions: ["gph"] },
  "application/vnd.fluxtime.clip": { source: "iana", extensions: ["ftc"] },
  "application/vnd.font-fontforge-sfd": { source: "iana" },
  "application/vnd.framemaker": { source: "iana", extensions: ["fm", "frame", "maker", "book"] },
  "application/vnd.frogans.fnc": { source: "iana", extensions: ["fnc"] },
  "application/vnd.frogans.ltf": { source: "iana", extensions: ["ltf"] },
  "application/vnd.fsc.weblaunch": { source: "iana", extensions: ["fsc"] },
  "application/vnd.fujifilm.fb.docuworks": { source: "iana" },
  "application/vnd.fujifilm.fb.docuworks.binder": { source: "iana" },
  "application/vnd.fujifilm.fb.docuworks.container": { source: "iana" },
  "application/vnd.fujifilm.fb.jfi+xml": { source: "iana", compressible: !0 },
  "application/vnd.fujitsu.oasys": { source: "iana", extensions: ["oas"] },
  "application/vnd.fujitsu.oasys2": { source: "iana", extensions: ["oa2"] },
  "application/vnd.fujitsu.oasys3": { source: "iana", extensions: ["oa3"] },
  "application/vnd.fujitsu.oasysgp": { source: "iana", extensions: ["fg5"] },
  "application/vnd.fujitsu.oasysprs": { source: "iana", extensions: ["bh2"] },
  "application/vnd.fujixerox.art-ex": { source: "iana" },
  "application/vnd.fujixerox.art4": { source: "iana" },
  "application/vnd.fujixerox.ddd": { source: "iana", extensions: ["ddd"] },
  "application/vnd.fujixerox.docuworks": { source: "iana", extensions: ["xdw"] },
  "application/vnd.fujixerox.docuworks.binder": { source: "iana", extensions: ["xbd"] },
  "application/vnd.fujixerox.docuworks.container": { source: "iana" },
  "application/vnd.fujixerox.hbpl": { source: "iana" },
  "application/vnd.fut-misnet": { source: "iana" },
  "application/vnd.futoin+cbor": { source: "iana" },
  "application/vnd.futoin+json": { source: "iana", compressible: !0 },
  "application/vnd.fuzzysheet": { source: "iana", extensions: ["fzs"] },
  "application/vnd.genomatix.tuxedo": { source: "iana", extensions: ["txd"] },
  "application/vnd.gentics.grd+json": { source: "iana", compressible: !0 },
  "application/vnd.geo+json": { source: "iana", compressible: !0 },
  "application/vnd.geocube+xml": { source: "iana", compressible: !0 },
  "application/vnd.geogebra.file": { source: "iana", extensions: ["ggb"] },
  "application/vnd.geogebra.slides": { source: "iana" },
  "application/vnd.geogebra.tool": { source: "iana", extensions: ["ggt"] },
  "application/vnd.geometry-explorer": { source: "iana", extensions: ["gex", "gre"] },
  "application/vnd.geonext": { source: "iana", extensions: ["gxt"] },
  "application/vnd.geoplan": { source: "iana", extensions: ["g2w"] },
  "application/vnd.geospace": { source: "iana", extensions: ["g3w"] },
  "application/vnd.gerber": { source: "iana" },
  "application/vnd.globalplatform.card-content-mgt": { source: "iana" },
  "application/vnd.globalplatform.card-content-mgt-response": { source: "iana" },
  "application/vnd.gmx": { source: "iana", extensions: ["gmx"] },
  "application/vnd.google-apps.document": { compressible: !1, extensions: ["gdoc"] },
  "application/vnd.google-apps.presentation": { compressible: !1, extensions: ["gslides"] },
  "application/vnd.google-apps.spreadsheet": { compressible: !1, extensions: ["gsheet"] },
  "application/vnd.google-earth.kml+xml": { source: "iana", compressible: !0, extensions: ["kml"] },
  "application/vnd.google-earth.kmz": { source: "iana", compressible: !1, extensions: ["kmz"] },
  "application/vnd.gov.sk.e-form+xml": { source: "iana", compressible: !0 },
  "application/vnd.gov.sk.e-form+zip": { source: "iana", compressible: !1 },
  "application/vnd.gov.sk.xmldatacontainer+xml": { source: "iana", compressible: !0 },
  "application/vnd.grafeq": { source: "iana", extensions: ["gqf", "gqs"] },
  "application/vnd.gridmp": { source: "iana" },
  "application/vnd.groove-account": { source: "iana", extensions: ["gac"] },
  "application/vnd.groove-help": { source: "iana", extensions: ["ghf"] },
  "application/vnd.groove-identity-message": { source: "iana", extensions: ["gim"] },
  "application/vnd.groove-injector": { source: "iana", extensions: ["grv"] },
  "application/vnd.groove-tool-message": { source: "iana", extensions: ["gtm"] },
  "application/vnd.groove-tool-template": { source: "iana", extensions: ["tpl"] },
  "application/vnd.groove-vcard": { source: "iana", extensions: ["vcg"] },
  "application/vnd.hal+json": { source: "iana", compressible: !0 },
  "application/vnd.hal+xml": { source: "iana", compressible: !0, extensions: ["hal"] },
  "application/vnd.handheld-entertainment+xml": { source: "iana", compressible: !0, extensions: ["zmm"] },
  "application/vnd.hbci": { source: "iana", extensions: ["hbci"] },
  "application/vnd.hc+json": { source: "iana", compressible: !0 },
  "application/vnd.hcl-bireports": { source: "iana" },
  "application/vnd.hdt": { source: "iana" },
  "application/vnd.heroku+json": { source: "iana", compressible: !0 },
  "application/vnd.hhe.lesson-player": { source: "iana", extensions: ["les"] },
  "application/vnd.hl7cda+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.hl7v2+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.hp-hpgl": { source: "iana", extensions: ["hpgl"] },
  "application/vnd.hp-hpid": { source: "iana", extensions: ["hpid"] },
  "application/vnd.hp-hps": { source: "iana", extensions: ["hps"] },
  "application/vnd.hp-jlyt": { source: "iana", extensions: ["jlt"] },
  "application/vnd.hp-pcl": { source: "iana", extensions: ["pcl"] },
  "application/vnd.hp-pclxl": { source: "iana", extensions: ["pclxl"] },
  "application/vnd.httphone": { source: "iana" },
  "application/vnd.hydrostatix.sof-data": { source: "iana", extensions: ["sfd-hdstx"] },
  "application/vnd.hyper+json": { source: "iana", compressible: !0 },
  "application/vnd.hyper-item+json": { source: "iana", compressible: !0 },
  "application/vnd.hyperdrive+json": { source: "iana", compressible: !0 },
  "application/vnd.hzn-3d-crossword": { source: "iana" },
  "application/vnd.ibm.afplinedata": { source: "iana" },
  "application/vnd.ibm.electronic-media": { source: "iana" },
  "application/vnd.ibm.minipay": { source: "iana", extensions: ["mpy"] },
  "application/vnd.ibm.modcap": { source: "iana", extensions: ["afp", "listafp", "list3820"] },
  "application/vnd.ibm.rights-management": { source: "iana", extensions: ["irm"] },
  "application/vnd.ibm.secure-container": { source: "iana", extensions: ["sc"] },
  "application/vnd.iccprofile": { source: "iana", extensions: ["icc", "icm"] },
  "application/vnd.ieee.1905": { source: "iana" },
  "application/vnd.igloader": { source: "iana", extensions: ["igl"] },
  "application/vnd.imagemeter.folder+zip": { source: "iana", compressible: !1 },
  "application/vnd.imagemeter.image+zip": { source: "iana", compressible: !1 },
  "application/vnd.immervision-ivp": { source: "iana", extensions: ["ivp"] },
  "application/vnd.immervision-ivu": { source: "iana", extensions: ["ivu"] },
  "application/vnd.ims.imsccv1p1": { source: "iana" },
  "application/vnd.ims.imsccv1p2": { source: "iana" },
  "application/vnd.ims.imsccv1p3": { source: "iana" },
  "application/vnd.ims.lis.v2.result+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolproxy+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolproxy.id+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolsettings+json": { source: "iana", compressible: !0 },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": { source: "iana", compressible: !0 },
  "application/vnd.informedcontrol.rms+xml": { source: "iana", compressible: !0 },
  "application/vnd.informix-visionary": { source: "iana" },
  "application/vnd.infotech.project": { source: "iana" },
  "application/vnd.infotech.project+xml": { source: "iana", compressible: !0 },
  "application/vnd.innopath.wamp.notification": { source: "iana" },
  "application/vnd.insors.igm": { source: "iana", extensions: ["igm"] },
  "application/vnd.intercon.formnet": { source: "iana", extensions: ["xpw", "xpx"] },
  "application/vnd.intergeo": { source: "iana", extensions: ["i2g"] },
  "application/vnd.intertrust.digibox": { source: "iana" },
  "application/vnd.intertrust.nncp": { source: "iana" },
  "application/vnd.intu.qbo": { source: "iana", extensions: ["qbo"] },
  "application/vnd.intu.qfx": { source: "iana", extensions: ["qfx"] },
  "application/vnd.iptc.g2.catalogitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.conceptitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.knowledgeitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.newsitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.newsmessage+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.packageitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.iptc.g2.planningitem+xml": { source: "iana", compressible: !0 },
  "application/vnd.ipunplugged.rcprofile": { source: "iana", extensions: ["rcprofile"] },
  "application/vnd.irepository.package+xml": { source: "iana", compressible: !0, extensions: ["irp"] },
  "application/vnd.is-xpr": { source: "iana", extensions: ["xpr"] },
  "application/vnd.isac.fcs": { source: "iana", extensions: ["fcs"] },
  "application/vnd.iso11783-10+zip": { source: "iana", compressible: !1 },
  "application/vnd.jam": { source: "iana", extensions: ["jam"] },
  "application/vnd.japannet-directory-service": { source: "iana" },
  "application/vnd.japannet-jpnstore-wakeup": { source: "iana" },
  "application/vnd.japannet-payment-wakeup": { source: "iana" },
  "application/vnd.japannet-registration": { source: "iana" },
  "application/vnd.japannet-registration-wakeup": { source: "iana" },
  "application/vnd.japannet-setstore-wakeup": { source: "iana" },
  "application/vnd.japannet-verification": { source: "iana" },
  "application/vnd.japannet-verification-wakeup": { source: "iana" },
  "application/vnd.jcp.javame.midlet-rms": { source: "iana", extensions: ["rms"] },
  "application/vnd.jisp": { source: "iana", extensions: ["jisp"] },
  "application/vnd.joost.joda-archive": { source: "iana", extensions: ["joda"] },
  "application/vnd.jsk.isdn-ngn": { source: "iana" },
  "application/vnd.kahootz": { source: "iana", extensions: ["ktz", "ktr"] },
  "application/vnd.kde.karbon": { source: "iana", extensions: ["karbon"] },
  "application/vnd.kde.kchart": { source: "iana", extensions: ["chrt"] },
  "application/vnd.kde.kformula": { source: "iana", extensions: ["kfo"] },
  "application/vnd.kde.kivio": { source: "iana", extensions: ["flw"] },
  "application/vnd.kde.kontour": { source: "iana", extensions: ["kon"] },
  "application/vnd.kde.kpresenter": { source: "iana", extensions: ["kpr", "kpt"] },
  "application/vnd.kde.kspread": { source: "iana", extensions: ["ksp"] },
  "application/vnd.kde.kword": { source: "iana", extensions: ["kwd", "kwt"] },
  "application/vnd.kenameaapp": { source: "iana", extensions: ["htke"] },
  "application/vnd.kidspiration": { source: "iana", extensions: ["kia"] },
  "application/vnd.kinar": { source: "iana", extensions: ["kne", "knp"] },
  "application/vnd.koan": { source: "iana", extensions: ["skp", "skd", "skt", "skm"] },
  "application/vnd.kodak-descriptor": { source: "iana", extensions: ["sse"] },
  "application/vnd.las": { source: "iana" },
  "application/vnd.las.las+json": { source: "iana", compressible: !0 },
  "application/vnd.las.las+xml": { source: "iana", compressible: !0, extensions: ["lasxml"] },
  "application/vnd.laszip": { source: "iana" },
  "application/vnd.leap+json": { source: "iana", compressible: !0 },
  "application/vnd.liberty-request+xml": { source: "iana", compressible: !0 },
  "application/vnd.llamagraphics.life-balance.desktop": { source: "iana", extensions: ["lbd"] },
  "application/vnd.llamagraphics.life-balance.exchange+xml": { source: "iana", compressible: !0, extensions: ["lbe"] },
  "application/vnd.logipipe.circuit+zip": { source: "iana", compressible: !1 },
  "application/vnd.loom": { source: "iana" },
  "application/vnd.lotus-1-2-3": { source: "iana", extensions: ["123"] },
  "application/vnd.lotus-approach": { source: "iana", extensions: ["apr"] },
  "application/vnd.lotus-freelance": { source: "iana", extensions: ["pre"] },
  "application/vnd.lotus-notes": { source: "iana", extensions: ["nsf"] },
  "application/vnd.lotus-organizer": { source: "iana", extensions: ["org"] },
  "application/vnd.lotus-screencam": { source: "iana", extensions: ["scm"] },
  "application/vnd.lotus-wordpro": { source: "iana", extensions: ["lwp"] },
  "application/vnd.macports.portpkg": { source: "iana", extensions: ["portpkg"] },
  "application/vnd.mapbox-vector-tile": { source: "iana", extensions: ["mvt"] },
  "application/vnd.marlin.drm.actiontoken+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.conftoken+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.license+xml": { source: "iana", compressible: !0 },
  "application/vnd.marlin.drm.mdcf": { source: "iana" },
  "application/vnd.mason+json": { source: "iana", compressible: !0 },
  "application/vnd.maxar.archive.3tz+zip": { source: "iana", compressible: !1 },
  "application/vnd.maxmind.maxmind-db": { source: "iana" },
  "application/vnd.mcd": { source: "iana", extensions: ["mcd"] },
  "application/vnd.medcalcdata": { source: "iana", extensions: ["mc1"] },
  "application/vnd.mediastation.cdkey": { source: "iana", extensions: ["cdkey"] },
  "application/vnd.meridian-slingshot": { source: "iana" },
  "application/vnd.mfer": { source: "iana", extensions: ["mwf"] },
  "application/vnd.mfmp": { source: "iana", extensions: ["mfm"] },
  "application/vnd.micro+json": { source: "iana", compressible: !0 },
  "application/vnd.micrografx.flo": { source: "iana", extensions: ["flo"] },
  "application/vnd.micrografx.igx": { source: "iana", extensions: ["igx"] },
  "application/vnd.microsoft.portable-executable": { source: "iana" },
  "application/vnd.microsoft.windows.thumbnail-cache": { source: "iana" },
  "application/vnd.miele+json": { source: "iana", compressible: !0 },
  "application/vnd.mif": { source: "iana", extensions: ["mif"] },
  "application/vnd.minisoft-hp3000-save": { source: "iana" },
  "application/vnd.mitsubishi.misty-guard.trustweb": { source: "iana" },
  "application/vnd.mobius.daf": { source: "iana", extensions: ["daf"] },
  "application/vnd.mobius.dis": { source: "iana", extensions: ["dis"] },
  "application/vnd.mobius.mbk": { source: "iana", extensions: ["mbk"] },
  "application/vnd.mobius.mqy": { source: "iana", extensions: ["mqy"] },
  "application/vnd.mobius.msl": { source: "iana", extensions: ["msl"] },
  "application/vnd.mobius.plc": { source: "iana", extensions: ["plc"] },
  "application/vnd.mobius.txf": { source: "iana", extensions: ["txf"] },
  "application/vnd.mophun.application": { source: "iana", extensions: ["mpn"] },
  "application/vnd.mophun.certificate": { source: "iana", extensions: ["mpc"] },
  "application/vnd.motorola.flexsuite": { source: "iana" },
  "application/vnd.motorola.flexsuite.adsi": { source: "iana" },
  "application/vnd.motorola.flexsuite.fis": { source: "iana" },
  "application/vnd.motorola.flexsuite.gotap": { source: "iana" },
  "application/vnd.motorola.flexsuite.kmr": { source: "iana" },
  "application/vnd.motorola.flexsuite.ttc": { source: "iana" },
  "application/vnd.motorola.flexsuite.wem": { source: "iana" },
  "application/vnd.motorola.iprm": { source: "iana" },
  "application/vnd.mozilla.xul+xml": { source: "iana", compressible: !0, extensions: ["xul"] },
  "application/vnd.ms-3mfdocument": { source: "iana" },
  "application/vnd.ms-artgalry": { source: "iana", extensions: ["cil"] },
  "application/vnd.ms-asf": { source: "iana" },
  "application/vnd.ms-cab-compressed": { source: "iana", extensions: ["cab"] },
  "application/vnd.ms-color.iccprofile": { source: "apache" },
  "application/vnd.ms-excel": { source: "iana", compressible: !1, extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] },
  "application/vnd.ms-excel.addin.macroenabled.12": { source: "iana", extensions: ["xlam"] },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": { source: "iana", extensions: ["xlsb"] },
  "application/vnd.ms-excel.sheet.macroenabled.12": { source: "iana", extensions: ["xlsm"] },
  "application/vnd.ms-excel.template.macroenabled.12": { source: "iana", extensions: ["xltm"] },
  "application/vnd.ms-fontobject": { source: "iana", compressible: !0, extensions: ["eot"] },
  "application/vnd.ms-htmlhelp": { source: "iana", extensions: ["chm"] },
  "application/vnd.ms-ims": { source: "iana", extensions: ["ims"] },
  "application/vnd.ms-lrm": { source: "iana", extensions: ["lrm"] },
  "application/vnd.ms-office.activex+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-officetheme": { source: "iana", extensions: ["thmx"] },
  "application/vnd.ms-opentype": { source: "apache", compressible: !0 },
  "application/vnd.ms-outlook": { compressible: !1, extensions: ["msg"] },
  "application/vnd.ms-package.obfuscated-opentype": { source: "apache" },
  "application/vnd.ms-pki.seccat": { source: "apache", extensions: ["cat"] },
  "application/vnd.ms-pki.stl": { source: "apache", extensions: ["stl"] },
  "application/vnd.ms-playready.initiator+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-powerpoint": { source: "iana", compressible: !1, extensions: ["ppt", "pps", "pot"] },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": { source: "iana", extensions: ["ppam"] },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": { source: "iana", extensions: ["pptm"] },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": { source: "iana", extensions: ["sldm"] },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": { source: "iana", extensions: ["ppsm"] },
  "application/vnd.ms-powerpoint.template.macroenabled.12": { source: "iana", extensions: ["potm"] },
  "application/vnd.ms-printdevicecapabilities+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-printing.printticket+xml": { source: "apache", compressible: !0 },
  "application/vnd.ms-printschematicket+xml": { source: "iana", compressible: !0 },
  "application/vnd.ms-project": { source: "iana", extensions: ["mpp", "mpt"] },
  "application/vnd.ms-tnef": { source: "iana" },
  "application/vnd.ms-windows.devicepairing": { source: "iana" },
  "application/vnd.ms-windows.nwprinting.oob": { source: "iana" },
  "application/vnd.ms-windows.printerpairing": { source: "iana" },
  "application/vnd.ms-windows.wsd.oob": { source: "iana" },
  "application/vnd.ms-wmdrm.lic-chlg-req": { source: "iana" },
  "application/vnd.ms-wmdrm.lic-resp": { source: "iana" },
  "application/vnd.ms-wmdrm.meter-chlg-req": { source: "iana" },
  "application/vnd.ms-wmdrm.meter-resp": { source: "iana" },
  "application/vnd.ms-word.document.macroenabled.12": { source: "iana", extensions: ["docm"] },
  "application/vnd.ms-word.template.macroenabled.12": { source: "iana", extensions: ["dotm"] },
  "application/vnd.ms-works": { source: "iana", extensions: ["wps", "wks", "wcm", "wdb"] },
  "application/vnd.ms-wpl": { source: "iana", extensions: ["wpl"] },
  "application/vnd.ms-xpsdocument": { source: "iana", compressible: !1, extensions: ["xps"] },
  "application/vnd.msa-disk-image": { source: "iana" },
  "application/vnd.mseq": { source: "iana", extensions: ["mseq"] },
  "application/vnd.msign": { source: "iana" },
  "application/vnd.multiad.creator": { source: "iana" },
  "application/vnd.multiad.creator.cif": { source: "iana" },
  "application/vnd.music-niff": { source: "iana" },
  "application/vnd.musician": { source: "iana", extensions: ["mus"] },
  "application/vnd.muvee.style": { source: "iana", extensions: ["msty"] },
  "application/vnd.mynfc": { source: "iana", extensions: ["taglet"] },
  "application/vnd.nacamar.ybrid+json": { source: "iana", compressible: !0 },
  "application/vnd.ncd.control": { source: "iana" },
  "application/vnd.ncd.reference": { source: "iana" },
  "application/vnd.nearst.inv+json": { source: "iana", compressible: !0 },
  "application/vnd.nebumind.line": { source: "iana" },
  "application/vnd.nervana": { source: "iana" },
  "application/vnd.netfpx": { source: "iana" },
  "application/vnd.neurolanguage.nlu": { source: "iana", extensions: ["nlu"] },
  "application/vnd.nimn": { source: "iana" },
  "application/vnd.nintendo.nitro.rom": { source: "iana" },
  "application/vnd.nintendo.snes.rom": { source: "iana" },
  "application/vnd.nitf": { source: "iana", extensions: ["ntf", "nitf"] },
  "application/vnd.noblenet-directory": { source: "iana", extensions: ["nnd"] },
  "application/vnd.noblenet-sealer": { source: "iana", extensions: ["nns"] },
  "application/vnd.noblenet-web": { source: "iana", extensions: ["nnw"] },
  "application/vnd.nokia.catalogs": { source: "iana" },
  "application/vnd.nokia.conml+wbxml": { source: "iana" },
  "application/vnd.nokia.conml+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.iptv.config+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.isds-radio-presets": { source: "iana" },
  "application/vnd.nokia.landmark+wbxml": { source: "iana" },
  "application/vnd.nokia.landmark+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.landmarkcollection+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.n-gage.ac+xml": { source: "iana", compressible: !0, extensions: ["ac"] },
  "application/vnd.nokia.n-gage.data": { source: "iana", extensions: ["ngdat"] },
  "application/vnd.nokia.n-gage.symbian.install": { source: "iana", extensions: ["n-gage"] },
  "application/vnd.nokia.ncd": { source: "iana" },
  "application/vnd.nokia.pcd+wbxml": { source: "iana" },
  "application/vnd.nokia.pcd+xml": { source: "iana", compressible: !0 },
  "application/vnd.nokia.radio-preset": { source: "iana", extensions: ["rpst"] },
  "application/vnd.nokia.radio-presets": { source: "iana", extensions: ["rpss"] },
  "application/vnd.novadigm.edm": { source: "iana", extensions: ["edm"] },
  "application/vnd.novadigm.edx": { source: "iana", extensions: ["edx"] },
  "application/vnd.novadigm.ext": { source: "iana", extensions: ["ext"] },
  "application/vnd.ntt-local.content-share": { source: "iana" },
  "application/vnd.ntt-local.file-transfer": { source: "iana" },
  "application/vnd.ntt-local.ogw_remote-access": { source: "iana" },
  "application/vnd.ntt-local.sip-ta_remote": { source: "iana" },
  "application/vnd.ntt-local.sip-ta_tcp_stream": { source: "iana" },
  "application/vnd.oasis.opendocument.chart": { source: "iana", extensions: ["odc"] },
  "application/vnd.oasis.opendocument.chart-template": { source: "iana", extensions: ["otc"] },
  "application/vnd.oasis.opendocument.database": { source: "iana", extensions: ["odb"] },
  "application/vnd.oasis.opendocument.formula": { source: "iana", extensions: ["odf"] },
  "application/vnd.oasis.opendocument.formula-template": { source: "iana", extensions: ["odft"] },
  "application/vnd.oasis.opendocument.graphics": { source: "iana", compressible: !1, extensions: ["odg"] },
  "application/vnd.oasis.opendocument.graphics-template": { source: "iana", extensions: ["otg"] },
  "application/vnd.oasis.opendocument.image": { source: "iana", extensions: ["odi"] },
  "application/vnd.oasis.opendocument.image-template": { source: "iana", extensions: ["oti"] },
  "application/vnd.oasis.opendocument.presentation": { source: "iana", compressible: !1, extensions: ["odp"] },
  "application/vnd.oasis.opendocument.presentation-template": { source: "iana", extensions: ["otp"] },
  "application/vnd.oasis.opendocument.spreadsheet": { source: "iana", compressible: !1, extensions: ["ods"] },
  "application/vnd.oasis.opendocument.spreadsheet-template": { source: "iana", extensions: ["ots"] },
  "application/vnd.oasis.opendocument.text": { source: "iana", compressible: !1, extensions: ["odt"] },
  "application/vnd.oasis.opendocument.text-master": { source: "iana", extensions: ["odm"] },
  "application/vnd.oasis.opendocument.text-template": { source: "iana", extensions: ["ott"] },
  "application/vnd.oasis.opendocument.text-web": { source: "iana", extensions: ["oth"] },
  "application/vnd.obn": { source: "iana" },
  "application/vnd.ocf+cbor": { source: "iana" },
  "application/vnd.oci.image.manifest.v1+json": { source: "iana", compressible: !0 },
  "application/vnd.oftn.l10n+json": { source: "iana", compressible: !0 },
  "application/vnd.oipf.contentaccessdownload+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.contentaccessstreaming+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.cspg-hexbinary": { source: "iana" },
  "application/vnd.oipf.dae.svg+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.dae.xhtml+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.mippvcontrolmessage+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.pae.gem": { source: "iana" },
  "application/vnd.oipf.spdiscovery+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.spdlist+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.ueprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.oipf.userprofile+xml": { source: "iana", compressible: !0 },
  "application/vnd.olpc-sugar": { source: "iana", extensions: ["xo"] },
  "application/vnd.oma-scws-config": { source: "iana" },
  "application/vnd.oma-scws-http-request": { source: "iana" },
  "application/vnd.oma-scws-http-response": { source: "iana" },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.drm-trigger+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.imd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.ltkm": { source: "iana" },
  "application/vnd.oma.bcast.notification+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.provisioningtrigger": { source: "iana" },
  "application/vnd.oma.bcast.sgboot": { source: "iana" },
  "application/vnd.oma.bcast.sgdd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.sgdu": { source: "iana" },
  "application/vnd.oma.bcast.simple-symbol-container": { source: "iana" },
  "application/vnd.oma.bcast.smartcard-trigger+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.sprov+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.bcast.stkm": { source: "iana" },
  "application/vnd.oma.cab-address-book+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-feature-handler+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-pcc+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-subs-invite+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.cab-user-prefs+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.dcd": { source: "iana" },
  "application/vnd.oma.dcdc": { source: "iana" },
  "application/vnd.oma.dd2+xml": { source: "iana", compressible: !0, extensions: ["dd2"] },
  "application/vnd.oma.drm.risd+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.group-usage-list+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.lwm2m+cbor": { source: "iana" },
  "application/vnd.oma.lwm2m+json": { source: "iana", compressible: !0 },
  "application/vnd.oma.lwm2m+tlv": { source: "iana" },
  "application/vnd.oma.pal+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.detailed-progress-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.final-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.groups+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.invocation-descriptor+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.poc.optimized-progress-report+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.push": { source: "iana" },
  "application/vnd.oma.scidm.messages+xml": { source: "iana", compressible: !0 },
  "application/vnd.oma.xcap-directory+xml": { source: "iana", compressible: !0 },
  "application/vnd.omads-email+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omads-file+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omads-folder+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.omaloc-supl-init": { source: "iana" },
  "application/vnd.onepager": { source: "iana" },
  "application/vnd.onepagertamp": { source: "iana" },
  "application/vnd.onepagertamx": { source: "iana" },
  "application/vnd.onepagertat": { source: "iana" },
  "application/vnd.onepagertatp": { source: "iana" },
  "application/vnd.onepagertatx": { source: "iana" },
  "application/vnd.openblox.game+xml": { source: "iana", compressible: !0, extensions: ["obgx"] },
  "application/vnd.openblox.game-binary": { source: "iana" },
  "application/vnd.openeye.oeb": { source: "iana" },
  "application/vnd.openofficeorg.extension": { source: "apache", extensions: ["oxt"] },
  "application/vnd.openstreetmap.data+xml": { source: "iana", compressible: !0, extensions: ["osm"] },
  "application/vnd.opentimestamps.ots": { source: "iana" },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawing+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { source: "iana", compressible: !1, extensions: ["pptx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": { source: "iana", extensions: ["sldx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { source: "iana", extensions: ["ppsx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { source: "iana", extensions: ["potx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { source: "iana", compressible: !1, extensions: ["xlsx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": { source: "iana", extensions: ["xltx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.theme+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.vmldrawing": { source: "iana" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { source: "iana", compressible: !1, extensions: ["docx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { source: "iana", extensions: ["dotx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.core-properties+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": { source: "iana", compressible: !0 },
  "application/vnd.openxmlformats-package.relationships+xml": { source: "iana", compressible: !0 },
  "application/vnd.oracle.resource+json": { source: "iana", compressible: !0 },
  "application/vnd.orange.indata": { source: "iana" },
  "application/vnd.osa.netdeploy": { source: "iana" },
  "application/vnd.osgeo.mapguide.package": { source: "iana", extensions: ["mgp"] },
  "application/vnd.osgi.bundle": { source: "iana" },
  "application/vnd.osgi.dp": { source: "iana", extensions: ["dp"] },
  "application/vnd.osgi.subsystem": { source: "iana", extensions: ["esa"] },
  "application/vnd.otps.ct-kip+xml": { source: "iana", compressible: !0 },
  "application/vnd.oxli.countgraph": { source: "iana" },
  "application/vnd.pagerduty+json": { source: "iana", compressible: !0 },
  "application/vnd.palm": { source: "iana", extensions: ["pdb", "pqa", "oprc"] },
  "application/vnd.panoply": { source: "iana" },
  "application/vnd.paos.xml": { source: "iana" },
  "application/vnd.patentdive": { source: "iana" },
  "application/vnd.patientecommsdoc": { source: "iana" },
  "application/vnd.pawaafile": { source: "iana", extensions: ["paw"] },
  "application/vnd.pcos": { source: "iana" },
  "application/vnd.pg.format": { source: "iana", extensions: ["str"] },
  "application/vnd.pg.osasli": { source: "iana", extensions: ["ei6"] },
  "application/vnd.piaccess.application-licence": { source: "iana" },
  "application/vnd.picsel": { source: "iana", extensions: ["efif"] },
  "application/vnd.pmi.widget": { source: "iana", extensions: ["wg"] },
  "application/vnd.poc.group-advertisement+xml": { source: "iana", compressible: !0 },
  "application/vnd.pocketlearn": { source: "iana", extensions: ["plf"] },
  "application/vnd.powerbuilder6": { source: "iana", extensions: ["pbd"] },
  "application/vnd.powerbuilder6-s": { source: "iana" },
  "application/vnd.powerbuilder7": { source: "iana" },
  "application/vnd.powerbuilder7-s": { source: "iana" },
  "application/vnd.powerbuilder75": { source: "iana" },
  "application/vnd.powerbuilder75-s": { source: "iana" },
  "application/vnd.preminet": { source: "iana" },
  "application/vnd.previewsystems.box": { source: "iana", extensions: ["box"] },
  "application/vnd.proteus.magazine": { source: "iana", extensions: ["mgz"] },
  "application/vnd.psfs": { source: "iana" },
  "application/vnd.publishare-delta-tree": { source: "iana", extensions: ["qps"] },
  "application/vnd.pvi.ptid1": { source: "iana", extensions: ["ptid"] },
  "application/vnd.pwg-multiplexed": { source: "iana" },
  "application/vnd.pwg-xhtml-print+xml": { source: "iana", compressible: !0 },
  "application/vnd.qualcomm.brew-app-res": { source: "iana" },
  "application/vnd.quarantainenet": { source: "iana" },
  "application/vnd.quark.quarkxpress": { source: "iana", extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"] },
  "application/vnd.quobject-quoxdocument": { source: "iana" },
  "application/vnd.radisys.moml+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-conf+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-conn+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-dialog+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-audit-stream+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-conf+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-base+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-group+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-speech+xml": { source: "iana", compressible: !0 },
  "application/vnd.radisys.msml-dialog-transform+xml": { source: "iana", compressible: !0 },
  "application/vnd.rainstor.data": { source: "iana" },
  "application/vnd.rapid": { source: "iana" },
  "application/vnd.rar": { source: "iana", extensions: ["rar"] },
  "application/vnd.realvnc.bed": { source: "iana", extensions: ["bed"] },
  "application/vnd.recordare.musicxml": { source: "iana", extensions: ["mxl"] },
  "application/vnd.recordare.musicxml+xml": { source: "iana", compressible: !0, extensions: ["musicxml"] },
  "application/vnd.renlearn.rlprint": { source: "iana" },
  "application/vnd.resilient.logic": { source: "iana" },
  "application/vnd.restful+json": { source: "iana", compressible: !0 },
  "application/vnd.rig.cryptonote": { source: "iana", extensions: ["cryptonote"] },
  "application/vnd.rim.cod": { source: "apache", extensions: ["cod"] },
  "application/vnd.rn-realmedia": { source: "apache", extensions: ["rm"] },
  "application/vnd.rn-realmedia-vbr": { source: "apache", extensions: ["rmvb"] },
  "application/vnd.route66.link66+xml": { source: "iana", compressible: !0, extensions: ["link66"] },
  "application/vnd.rs-274x": { source: "iana" },
  "application/vnd.ruckus.download": { source: "iana" },
  "application/vnd.s3sms": { source: "iana" },
  "application/vnd.sailingtracker.track": { source: "iana", extensions: ["st"] },
  "application/vnd.sar": { source: "iana" },
  "application/vnd.sbm.cid": { source: "iana" },
  "application/vnd.sbm.mid2": { source: "iana" },
  "application/vnd.scribus": { source: "iana" },
  "application/vnd.sealed.3df": { source: "iana" },
  "application/vnd.sealed.csf": { source: "iana" },
  "application/vnd.sealed.doc": { source: "iana" },
  "application/vnd.sealed.eml": { source: "iana" },
  "application/vnd.sealed.mht": { source: "iana" },
  "application/vnd.sealed.net": { source: "iana" },
  "application/vnd.sealed.ppt": { source: "iana" },
  "application/vnd.sealed.tiff": { source: "iana" },
  "application/vnd.sealed.xls": { source: "iana" },
  "application/vnd.sealedmedia.softseal.html": { source: "iana" },
  "application/vnd.sealedmedia.softseal.pdf": { source: "iana" },
  "application/vnd.seemail": { source: "iana", extensions: ["see"] },
  "application/vnd.seis+json": { source: "iana", compressible: !0 },
  "application/vnd.sema": { source: "iana", extensions: ["sema"] },
  "application/vnd.semd": { source: "iana", extensions: ["semd"] },
  "application/vnd.semf": { source: "iana", extensions: ["semf"] },
  "application/vnd.shade-save-file": { source: "iana" },
  "application/vnd.shana.informed.formdata": { source: "iana", extensions: ["ifm"] },
  "application/vnd.shana.informed.formtemplate": { source: "iana", extensions: ["itp"] },
  "application/vnd.shana.informed.interchange": { source: "iana", extensions: ["iif"] },
  "application/vnd.shana.informed.package": { source: "iana", extensions: ["ipk"] },
  "application/vnd.shootproof+json": { source: "iana", compressible: !0 },
  "application/vnd.shopkick+json": { source: "iana", compressible: !0 },
  "application/vnd.shp": { source: "iana" },
  "application/vnd.shx": { source: "iana" },
  "application/vnd.sigrok.session": { source: "iana" },
  "application/vnd.simtech-mindmapper": { source: "iana", extensions: ["twd", "twds"] },
  "application/vnd.siren+json": { source: "iana", compressible: !0 },
  "application/vnd.smaf": { source: "iana", extensions: ["mmf"] },
  "application/vnd.smart.notebook": { source: "iana" },
  "application/vnd.smart.teacher": { source: "iana", extensions: ["teacher"] },
  "application/vnd.snesdev-page-table": { source: "iana" },
  "application/vnd.software602.filler.form+xml": { source: "iana", compressible: !0, extensions: ["fo"] },
  "application/vnd.software602.filler.form-xml-zip": { source: "iana" },
  "application/vnd.solent.sdkm+xml": { source: "iana", compressible: !0, extensions: ["sdkm", "sdkd"] },
  "application/vnd.spotfire.dxp": { source: "iana", extensions: ["dxp"] },
  "application/vnd.spotfire.sfs": { source: "iana", extensions: ["sfs"] },
  "application/vnd.sqlite3": { source: "iana" },
  "application/vnd.sss-cod": { source: "iana" },
  "application/vnd.sss-dtf": { source: "iana" },
  "application/vnd.sss-ntf": { source: "iana" },
  "application/vnd.stardivision.calc": { source: "apache", extensions: ["sdc"] },
  "application/vnd.stardivision.draw": { source: "apache", extensions: ["sda"] },
  "application/vnd.stardivision.impress": { source: "apache", extensions: ["sdd"] },
  "application/vnd.stardivision.math": { source: "apache", extensions: ["smf"] },
  "application/vnd.stardivision.writer": { source: "apache", extensions: ["sdw", "vor"] },
  "application/vnd.stardivision.writer-global": { source: "apache", extensions: ["sgl"] },
  "application/vnd.stepmania.package": { source: "iana", extensions: ["smzip"] },
  "application/vnd.stepmania.stepchart": { source: "iana", extensions: ["sm"] },
  "application/vnd.street-stream": { source: "iana" },
  "application/vnd.sun.wadl+xml": { source: "iana", compressible: !0, extensions: ["wadl"] },
  "application/vnd.sun.xml.calc": { source: "apache", extensions: ["sxc"] },
  "application/vnd.sun.xml.calc.template": { source: "apache", extensions: ["stc"] },
  "application/vnd.sun.xml.draw": { source: "apache", extensions: ["sxd"] },
  "application/vnd.sun.xml.draw.template": { source: "apache", extensions: ["std"] },
  "application/vnd.sun.xml.impress": { source: "apache", extensions: ["sxi"] },
  "application/vnd.sun.xml.impress.template": { source: "apache", extensions: ["sti"] },
  "application/vnd.sun.xml.math": { source: "apache", extensions: ["sxm"] },
  "application/vnd.sun.xml.writer": { source: "apache", extensions: ["sxw"] },
  "application/vnd.sun.xml.writer.global": { source: "apache", extensions: ["sxg"] },
  "application/vnd.sun.xml.writer.template": { source: "apache", extensions: ["stw"] },
  "application/vnd.sus-calendar": { source: "iana", extensions: ["sus", "susp"] },
  "application/vnd.svd": { source: "iana", extensions: ["svd"] },
  "application/vnd.swiftview-ics": { source: "iana" },
  "application/vnd.sycle+xml": { source: "iana", compressible: !0 },
  "application/vnd.syft+json": { source: "iana", compressible: !0 },
  "application/vnd.symbian.install": { source: "apache", extensions: ["sis", "sisx"] },
  "application/vnd.syncml+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xsm"] },
  "application/vnd.syncml.dm+wbxml": { source: "iana", charset: "UTF-8", extensions: ["bdm"] },
  "application/vnd.syncml.dm+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xdm"] },
  "application/vnd.syncml.dm.notification": { source: "iana" },
  "application/vnd.syncml.dmddf+wbxml": { source: "iana" },
  "application/vnd.syncml.dmddf+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["ddf"] },
  "application/vnd.syncml.dmtnds+wbxml": { source: "iana" },
  "application/vnd.syncml.dmtnds+xml": { source: "iana", charset: "UTF-8", compressible: !0 },
  "application/vnd.syncml.ds.notification": { source: "iana" },
  "application/vnd.tableschema+json": { source: "iana", compressible: !0 },
  "application/vnd.tao.intent-module-archive": { source: "iana", extensions: ["tao"] },
  "application/vnd.tcpdump.pcap": { source: "iana", extensions: ["pcap", "cap", "dmp"] },
  "application/vnd.think-cell.ppttc+json": { source: "iana", compressible: !0 },
  "application/vnd.tmd.mediaflex.api+xml": { source: "iana", compressible: !0 },
  "application/vnd.tml": { source: "iana" },
  "application/vnd.tmobile-livetv": { source: "iana", extensions: ["tmo"] },
  "application/vnd.tri.onesource": { source: "iana" },
  "application/vnd.trid.tpt": { source: "iana", extensions: ["tpt"] },
  "application/vnd.triscape.mxs": { source: "iana", extensions: ["mxs"] },
  "application/vnd.trueapp": { source: "iana", extensions: ["tra"] },
  "application/vnd.truedoc": { source: "iana" },
  "application/vnd.ubisoft.webplayer": { source: "iana" },
  "application/vnd.ufdl": { source: "iana", extensions: ["ufd", "ufdl"] },
  "application/vnd.uiq.theme": { source: "iana", extensions: ["utz"] },
  "application/vnd.umajin": { source: "iana", extensions: ["umj"] },
  "application/vnd.unity": { source: "iana", extensions: ["unityweb"] },
  "application/vnd.uoml+xml": { source: "iana", compressible: !0, extensions: ["uoml"] },
  "application/vnd.uplanet.alert": { source: "iana" },
  "application/vnd.uplanet.alert-wbxml": { source: "iana" },
  "application/vnd.uplanet.bearer-choice": { source: "iana" },
  "application/vnd.uplanet.bearer-choice-wbxml": { source: "iana" },
  "application/vnd.uplanet.cacheop": { source: "iana" },
  "application/vnd.uplanet.cacheop-wbxml": { source: "iana" },
  "application/vnd.uplanet.channel": { source: "iana" },
  "application/vnd.uplanet.channel-wbxml": { source: "iana" },
  "application/vnd.uplanet.list": { source: "iana" },
  "application/vnd.uplanet.list-wbxml": { source: "iana" },
  "application/vnd.uplanet.listcmd": { source: "iana" },
  "application/vnd.uplanet.listcmd-wbxml": { source: "iana" },
  "application/vnd.uplanet.signal": { source: "iana" },
  "application/vnd.uri-map": { source: "iana" },
  "application/vnd.valve.source.material": { source: "iana" },
  "application/vnd.vcx": { source: "iana", extensions: ["vcx"] },
  "application/vnd.vd-study": { source: "iana" },
  "application/vnd.vectorworks": { source: "iana" },
  "application/vnd.vel+json": { source: "iana", compressible: !0 },
  "application/vnd.verimatrix.vcas": { source: "iana" },
  "application/vnd.veritone.aion+json": { source: "iana", compressible: !0 },
  "application/vnd.veryant.thin": { source: "iana" },
  "application/vnd.ves.encrypted": { source: "iana" },
  "application/vnd.vidsoft.vidconference": { source: "iana" },
  "application/vnd.visio": { source: "iana", extensions: ["vsd", "vst", "vss", "vsw"] },
  "application/vnd.visionary": { source: "iana", extensions: ["vis"] },
  "application/vnd.vividence.scriptfile": { source: "iana" },
  "application/vnd.vsf": { source: "iana", extensions: ["vsf"] },
  "application/vnd.wap.sic": { source: "iana" },
  "application/vnd.wap.slc": { source: "iana" },
  "application/vnd.wap.wbxml": { source: "iana", charset: "UTF-8", extensions: ["wbxml"] },
  "application/vnd.wap.wmlc": { source: "iana", extensions: ["wmlc"] },
  "application/vnd.wap.wmlscriptc": { source: "iana", extensions: ["wmlsc"] },
  "application/vnd.webturbo": { source: "iana", extensions: ["wtb"] },
  "application/vnd.wfa.dpp": { source: "iana" },
  "application/vnd.wfa.p2p": { source: "iana" },
  "application/vnd.wfa.wsc": { source: "iana" },
  "application/vnd.windows.devicepairing": { source: "iana" },
  "application/vnd.wmc": { source: "iana" },
  "application/vnd.wmf.bootstrap": { source: "iana" },
  "application/vnd.wolfram.mathematica": { source: "iana" },
  "application/vnd.wolfram.mathematica.package": { source: "iana" },
  "application/vnd.wolfram.player": { source: "iana", extensions: ["nbp"] },
  "application/vnd.wordperfect": { source: "iana", extensions: ["wpd"] },
  "application/vnd.wqd": { source: "iana", extensions: ["wqd"] },
  "application/vnd.wrq-hp3000-labelled": { source: "iana" },
  "application/vnd.wt.stf": { source: "iana", extensions: ["stf"] },
  "application/vnd.wv.csp+wbxml": { source: "iana" },
  "application/vnd.wv.csp+xml": { source: "iana", compressible: !0 },
  "application/vnd.wv.ssp+xml": { source: "iana", compressible: !0 },
  "application/vnd.xacml+json": { source: "iana", compressible: !0 },
  "application/vnd.xara": { source: "iana", extensions: ["xar"] },
  "application/vnd.xfdl": { source: "iana", extensions: ["xfdl"] },
  "application/vnd.xfdl.webform": { source: "iana" },
  "application/vnd.xmi+xml": { source: "iana", compressible: !0 },
  "application/vnd.xmpie.cpkg": { source: "iana" },
  "application/vnd.xmpie.dpkg": { source: "iana" },
  "application/vnd.xmpie.plan": { source: "iana" },
  "application/vnd.xmpie.ppkg": { source: "iana" },
  "application/vnd.xmpie.xlim": { source: "iana" },
  "application/vnd.yamaha.hv-dic": { source: "iana", extensions: ["hvd"] },
  "application/vnd.yamaha.hv-script": { source: "iana", extensions: ["hvs"] },
  "application/vnd.yamaha.hv-voice": { source: "iana", extensions: ["hvp"] },
  "application/vnd.yamaha.openscoreformat": { source: "iana", extensions: ["osf"] },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": { source: "iana", compressible: !0, extensions: ["osfpvg"] },
  "application/vnd.yamaha.remote-setup": { source: "iana" },
  "application/vnd.yamaha.smaf-audio": { source: "iana", extensions: ["saf"] },
  "application/vnd.yamaha.smaf-phrase": { source: "iana", extensions: ["spf"] },
  "application/vnd.yamaha.through-ngn": { source: "iana" },
  "application/vnd.yamaha.tunnel-udpencap": { source: "iana" },
  "application/vnd.yaoweme": { source: "iana" },
  "application/vnd.yellowriver-custom-menu": { source: "iana", extensions: ["cmp"] },
  "application/vnd.youtube.yt": { source: "iana" },
  "application/vnd.zul": { source: "iana", extensions: ["zir", "zirz"] },
  "application/vnd.zzazz.deck+xml": { source: "iana", compressible: !0, extensions: ["zaz"] },
  "application/voicexml+xml": { source: "iana", compressible: !0, extensions: ["vxml"] },
  "application/voucher-cms+json": { source: "iana", compressible: !0 },
  "application/vq-rtcpxr": { source: "iana" },
  "application/wasm": { source: "iana", compressible: !0, extensions: ["wasm"] },
  "application/watcherinfo+xml": { source: "iana", compressible: !0, extensions: ["wif"] },
  "application/webpush-options+json": { source: "iana", compressible: !0 },
  "application/whoispp-query": { source: "iana" },
  "application/whoispp-response": { source: "iana" },
  "application/widget": { source: "iana", extensions: ["wgt"] },
  "application/winhlp": { source: "apache", extensions: ["hlp"] },
  "application/wita": { source: "iana" },
  "application/wordperfect5.1": { source: "iana" },
  "application/wsdl+xml": { source: "iana", compressible: !0, extensions: ["wsdl"] },
  "application/wspolicy+xml": { source: "iana", compressible: !0, extensions: ["wspolicy"] },
  "application/x-7z-compressed": { source: "apache", compressible: !1, extensions: ["7z"] },
  "application/x-abiword": { source: "apache", extensions: ["abw"] },
  "application/x-ace-compressed": { source: "apache", extensions: ["ace"] },
  "application/x-amf": { source: "apache" },
  "application/x-apple-diskimage": { source: "apache", extensions: ["dmg"] },
  "application/x-arj": { compressible: !1, extensions: ["arj"] },
  "application/x-authorware-bin": { source: "apache", extensions: ["aab", "x32", "u32", "vox"] },
  "application/x-authorware-map": { source: "apache", extensions: ["aam"] },
  "application/x-authorware-seg": { source: "apache", extensions: ["aas"] },
  "application/x-bcpio": { source: "apache", extensions: ["bcpio"] },
  "application/x-bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/x-bittorrent": { source: "apache", extensions: ["torrent"] },
  "application/x-blorb": { source: "apache", extensions: ["blb", "blorb"] },
  "application/x-bzip": { source: "apache", compressible: !1, extensions: ["bz"] },
  "application/x-bzip2": { source: "apache", compressible: !1, extensions: ["bz2", "boz"] },
  "application/x-cbr": { source: "apache", extensions: ["cbr", "cba", "cbt", "cbz", "cb7"] },
  "application/x-cdlink": { source: "apache", extensions: ["vcd"] },
  "application/x-cfs-compressed": { source: "apache", extensions: ["cfs"] },
  "application/x-chat": { source: "apache", extensions: ["chat"] },
  "application/x-chess-pgn": { source: "apache", extensions: ["pgn"] },
  "application/x-chrome-extension": { extensions: ["crx"] },
  "application/x-cocoa": { source: "nginx", extensions: ["cco"] },
  "application/x-compress": { source: "apache" },
  "application/x-conference": { source: "apache", extensions: ["nsc"] },
  "application/x-cpio": { source: "apache", extensions: ["cpio"] },
  "application/x-csh": { source: "apache", extensions: ["csh"] },
  "application/x-deb": { compressible: !1 },
  "application/x-debian-package": { source: "apache", extensions: ["deb", "udeb"] },
  "application/x-dgc-compressed": { source: "apache", extensions: ["dgc"] },
  "application/x-director": { source: "apache", extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"] },
  "application/x-doom": { source: "apache", extensions: ["wad"] },
  "application/x-dtbncx+xml": { source: "apache", compressible: !0, extensions: ["ncx"] },
  "application/x-dtbook+xml": { source: "apache", compressible: !0, extensions: ["dtb"] },
  "application/x-dtbresource+xml": { source: "apache", compressible: !0, extensions: ["res"] },
  "application/x-dvi": { source: "apache", compressible: !1, extensions: ["dvi"] },
  "application/x-envoy": { source: "apache", extensions: ["evy"] },
  "application/x-eva": { source: "apache", extensions: ["eva"] },
  "application/x-font-bdf": { source: "apache", extensions: ["bdf"] },
  "application/x-font-dos": { source: "apache" },
  "application/x-font-framemaker": { source: "apache" },
  "application/x-font-ghostscript": { source: "apache", extensions: ["gsf"] },
  "application/x-font-libgrx": { source: "apache" },
  "application/x-font-linux-psf": { source: "apache", extensions: ["psf"] },
  "application/x-font-pcf": { source: "apache", extensions: ["pcf"] },
  "application/x-font-snf": { source: "apache", extensions: ["snf"] },
  "application/x-font-speedo": { source: "apache" },
  "application/x-font-sunos-news": { source: "apache" },
  "application/x-font-type1": { source: "apache", extensions: ["pfa", "pfb", "pfm", "afm"] },
  "application/x-font-vfont": { source: "apache" },
  "application/x-freearc": { source: "apache", extensions: ["arc"] },
  "application/x-futuresplash": { source: "apache", extensions: ["spl"] },
  "application/x-gca-compressed": { source: "apache", extensions: ["gca"] },
  "application/x-glulx": { source: "apache", extensions: ["ulx"] },
  "application/x-gnumeric": { source: "apache", extensions: ["gnumeric"] },
  "application/x-gramps-xml": { source: "apache", extensions: ["gramps"] },
  "application/x-gtar": { source: "apache", extensions: ["gtar"] },
  "application/x-gzip": { source: "apache" },
  "application/x-hdf": { source: "apache", extensions: ["hdf"] },
  "application/x-httpd-php": { compressible: !0, extensions: ["php"] },
  "application/x-install-instructions": { source: "apache", extensions: ["install"] },
  "application/x-iso9660-image": { source: "apache", extensions: ["iso"] },
  "application/x-iwork-keynote-sffkey": { extensions: ["key"] },
  "application/x-iwork-numbers-sffnumbers": { extensions: ["numbers"] },
  "application/x-iwork-pages-sffpages": { extensions: ["pages"] },
  "application/x-java-archive-diff": { source: "nginx", extensions: ["jardiff"] },
  "application/x-java-jnlp-file": { source: "apache", compressible: !1, extensions: ["jnlp"] },
  "application/x-javascript": { compressible: !0 },
  "application/x-keepass2": { extensions: ["kdbx"] },
  "application/x-latex": { source: "apache", compressible: !1, extensions: ["latex"] },
  "application/x-lua-bytecode": { extensions: ["luac"] },
  "application/x-lzh-compressed": { source: "apache", extensions: ["lzh", "lha"] },
  "application/x-makeself": { source: "nginx", extensions: ["run"] },
  "application/x-mie": { source: "apache", extensions: ["mie"] },
  "application/x-mobipocket-ebook": { source: "apache", extensions: ["prc", "mobi"] },
  "application/x-mpegurl": { compressible: !1 },
  "application/x-ms-application": { source: "apache", extensions: ["application"] },
  "application/x-ms-shortcut": { source: "apache", extensions: ["lnk"] },
  "application/x-ms-wmd": { source: "apache", extensions: ["wmd"] },
  "application/x-ms-wmz": { source: "apache", extensions: ["wmz"] },
  "application/x-ms-xbap": { source: "apache", extensions: ["xbap"] },
  "application/x-msaccess": { source: "apache", extensions: ["mdb"] },
  "application/x-msbinder": { source: "apache", extensions: ["obd"] },
  "application/x-mscardfile": { source: "apache", extensions: ["crd"] },
  "application/x-msclip": { source: "apache", extensions: ["clp"] },
  "application/x-msdos-program": { extensions: ["exe"] },
  "application/x-msdownload": { source: "apache", extensions: ["exe", "dll", "com", "bat", "msi"] },
  "application/x-msmediaview": { source: "apache", extensions: ["mvb", "m13", "m14"] },
  "application/x-msmetafile": { source: "apache", extensions: ["wmf", "wmz", "emf", "emz"] },
  "application/x-msmoney": { source: "apache", extensions: ["mny"] },
  "application/x-mspublisher": { source: "apache", extensions: ["pub"] },
  "application/x-msschedule": { source: "apache", extensions: ["scd"] },
  "application/x-msterminal": { source: "apache", extensions: ["trm"] },
  "application/x-mswrite": { source: "apache", extensions: ["wri"] },
  "application/x-netcdf": { source: "apache", extensions: ["nc", "cdf"] },
  "application/x-ns-proxy-autoconfig": { compressible: !0, extensions: ["pac"] },
  "application/x-nzb": { source: "apache", extensions: ["nzb"] },
  "application/x-perl": { source: "nginx", extensions: ["pl", "pm"] },
  "application/x-pilot": { source: "nginx", extensions: ["prc", "pdb"] },
  "application/x-pkcs12": { source: "apache", compressible: !1, extensions: ["p12", "pfx"] },
  "application/x-pkcs7-certificates": { source: "apache", extensions: ["p7b", "spc"] },
  "application/x-pkcs7-certreqresp": { source: "apache", extensions: ["p7r"] },
  "application/x-pki-message": { source: "iana" },
  "application/x-rar-compressed": { source: "apache", compressible: !1, extensions: ["rar"] },
  "application/x-redhat-package-manager": { source: "nginx", extensions: ["rpm"] },
  "application/x-research-info-systems": { source: "apache", extensions: ["ris"] },
  "application/x-sea": { source: "nginx", extensions: ["sea"] },
  "application/x-sh": { source: "apache", compressible: !0, extensions: ["sh"] },
  "application/x-shar": { source: "apache", extensions: ["shar"] },
  "application/x-shockwave-flash": { source: "apache", compressible: !1, extensions: ["swf"] },
  "application/x-silverlight-app": { source: "apache", extensions: ["xap"] },
  "application/x-sql": { source: "apache", extensions: ["sql"] },
  "application/x-stuffit": { source: "apache", compressible: !1, extensions: ["sit"] },
  "application/x-stuffitx": { source: "apache", extensions: ["sitx"] },
  "application/x-subrip": { source: "apache", extensions: ["srt"] },
  "application/x-sv4cpio": { source: "apache", extensions: ["sv4cpio"] },
  "application/x-sv4crc": { source: "apache", extensions: ["sv4crc"] },
  "application/x-t3vm-image": { source: "apache", extensions: ["t3"] },
  "application/x-tads": { source: "apache", extensions: ["gam"] },
  "application/x-tar": { source: "apache", compressible: !0, extensions: ["tar"] },
  "application/x-tcl": { source: "apache", extensions: ["tcl", "tk"] },
  "application/x-tex": { source: "apache", extensions: ["tex"] },
  "application/x-tex-tfm": { source: "apache", extensions: ["tfm"] },
  "application/x-texinfo": { source: "apache", extensions: ["texinfo", "texi"] },
  "application/x-tgif": { source: "apache", extensions: ["obj"] },
  "application/x-ustar": { source: "apache", extensions: ["ustar"] },
  "application/x-virtualbox-hdd": { compressible: !0, extensions: ["hdd"] },
  "application/x-virtualbox-ova": { compressible: !0, extensions: ["ova"] },
  "application/x-virtualbox-ovf": { compressible: !0, extensions: ["ovf"] },
  "application/x-virtualbox-vbox": { compressible: !0, extensions: ["vbox"] },
  "application/x-virtualbox-vbox-extpack": { compressible: !1, extensions: ["vbox-extpack"] },
  "application/x-virtualbox-vdi": { compressible: !0, extensions: ["vdi"] },
  "application/x-virtualbox-vhd": { compressible: !0, extensions: ["vhd"] },
  "application/x-virtualbox-vmdk": { compressible: !0, extensions: ["vmdk"] },
  "application/x-wais-source": { source: "apache", extensions: ["src"] },
  "application/x-web-app-manifest+json": { compressible: !0, extensions: ["webapp"] },
  "application/x-www-form-urlencoded": { source: "iana", compressible: !0 },
  "application/x-x509-ca-cert": { source: "iana", extensions: ["der", "crt", "pem"] },
  "application/x-x509-ca-ra-cert": { source: "iana" },
  "application/x-x509-next-ca-cert": { source: "iana" },
  "application/x-xfig": { source: "apache", extensions: ["fig"] },
  "application/x-xliff+xml": { source: "apache", compressible: !0, extensions: ["xlf"] },
  "application/x-xpinstall": { source: "apache", compressible: !1, extensions: ["xpi"] },
  "application/x-xz": { source: "apache", extensions: ["xz"] },
  "application/x-zmachine": { source: "apache", extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"] },
  "application/x400-bp": { source: "iana" },
  "application/xacml+xml": { source: "iana", compressible: !0 },
  "application/xaml+xml": { source: "apache", compressible: !0, extensions: ["xaml"] },
  "application/xcap-att+xml": { source: "iana", compressible: !0, extensions: ["xav"] },
  "application/xcap-caps+xml": { source: "iana", compressible: !0, extensions: ["xca"] },
  "application/xcap-diff+xml": { source: "iana", compressible: !0, extensions: ["xdf"] },
  "application/xcap-el+xml": { source: "iana", compressible: !0, extensions: ["xel"] },
  "application/xcap-error+xml": { source: "iana", compressible: !0 },
  "application/xcap-ns+xml": { source: "iana", compressible: !0, extensions: ["xns"] },
  "application/xcon-conference-info+xml": { source: "iana", compressible: !0 },
  "application/xcon-conference-info-diff+xml": { source: "iana", compressible: !0 },
  "application/xenc+xml": { source: "iana", compressible: !0, extensions: ["xenc"] },
  "application/xhtml+xml": { source: "iana", compressible: !0, extensions: ["xhtml", "xht"] },
  "application/xhtml-voice+xml": { source: "apache", compressible: !0 },
  "application/xliff+xml": { source: "iana", compressible: !0, extensions: ["xlf"] },
  "application/xml": { source: "iana", compressible: !0, extensions: ["xml", "xsl", "xsd", "rng"] },
  "application/xml-dtd": { source: "iana", compressible: !0, extensions: ["dtd"] },
  "application/xml-external-parsed-entity": { source: "iana" },
  "application/xml-patch+xml": { source: "iana", compressible: !0 },
  "application/xmpp+xml": { source: "iana", compressible: !0 },
  "application/xop+xml": { source: "iana", compressible: !0, extensions: ["xop"] },
  "application/xproc+xml": { source: "apache", compressible: !0, extensions: ["xpl"] },
  "application/xslt+xml": { source: "iana", compressible: !0, extensions: ["xsl", "xslt"] },
  "application/xspf+xml": { source: "apache", compressible: !0, extensions: ["xspf"] },
  "application/xv+xml": { source: "iana", compressible: !0, extensions: ["mxml", "xhvml", "xvml", "xvm"] },
  "application/yang": { source: "iana", extensions: ["yang"] },
  "application/yang-data+json": { source: "iana", compressible: !0 },
  "application/yang-data+xml": { source: "iana", compressible: !0 },
  "application/yang-patch+json": { source: "iana", compressible: !0 },
  "application/yang-patch+xml": { source: "iana", compressible: !0 },
  "application/yin+xml": { source: "iana", compressible: !0, extensions: ["yin"] },
  "application/zip": { source: "iana", compressible: !1, extensions: ["zip"] },
  "application/zlib": { source: "iana" },
  "application/zstd": { source: "iana" },
  "audio/1d-interleaved-parityfec": { source: "iana" },
  "audio/32kadpcm": { source: "iana" },
  "audio/3gpp": { source: "iana", compressible: !1, extensions: ["3gpp"] },
  "audio/3gpp2": { source: "iana" },
  "audio/aac": { source: "iana" },
  "audio/ac3": { source: "iana" },
  "audio/adpcm": { source: "apache", extensions: ["adp"] },
  "audio/amr": { source: "iana", extensions: ["amr"] },
  "audio/amr-wb": { source: "iana" },
  "audio/amr-wb+": { source: "iana" },
  "audio/aptx": { source: "iana" },
  "audio/asc": { source: "iana" },
  "audio/atrac-advanced-lossless": { source: "iana" },
  "audio/atrac-x": { source: "iana" },
  "audio/atrac3": { source: "iana" },
  "audio/basic": { source: "iana", compressible: !1, extensions: ["au", "snd"] },
  "audio/bv16": { source: "iana" },
  "audio/bv32": { source: "iana" },
  "audio/clearmode": { source: "iana" },
  "audio/cn": { source: "iana" },
  "audio/dat12": { source: "iana" },
  "audio/dls": { source: "iana" },
  "audio/dsr-es201108": { source: "iana" },
  "audio/dsr-es202050": { source: "iana" },
  "audio/dsr-es202211": { source: "iana" },
  "audio/dsr-es202212": { source: "iana" },
  "audio/dv": { source: "iana" },
  "audio/dvi4": { source: "iana" },
  "audio/eac3": { source: "iana" },
  "audio/encaprtp": { source: "iana" },
  "audio/evrc": { source: "iana" },
  "audio/evrc-qcp": { source: "iana" },
  "audio/evrc0": { source: "iana" },
  "audio/evrc1": { source: "iana" },
  "audio/evrcb": { source: "iana" },
  "audio/evrcb0": { source: "iana" },
  "audio/evrcb1": { source: "iana" },
  "audio/evrcnw": { source: "iana" },
  "audio/evrcnw0": { source: "iana" },
  "audio/evrcnw1": { source: "iana" },
  "audio/evrcwb": { source: "iana" },
  "audio/evrcwb0": { source: "iana" },
  "audio/evrcwb1": { source: "iana" },
  "audio/evs": { source: "iana" },
  "audio/flexfec": { source: "iana" },
  "audio/fwdred": { source: "iana" },
  "audio/g711-0": { source: "iana" },
  "audio/g719": { source: "iana" },
  "audio/g722": { source: "iana" },
  "audio/g7221": { source: "iana" },
  "audio/g723": { source: "iana" },
  "audio/g726-16": { source: "iana" },
  "audio/g726-24": { source: "iana" },
  "audio/g726-32": { source: "iana" },
  "audio/g726-40": { source: "iana" },
  "audio/g728": { source: "iana" },
  "audio/g729": { source: "iana" },
  "audio/g7291": { source: "iana" },
  "audio/g729d": { source: "iana" },
  "audio/g729e": { source: "iana" },
  "audio/gsm": { source: "iana" },
  "audio/gsm-efr": { source: "iana" },
  "audio/gsm-hr-08": { source: "iana" },
  "audio/ilbc": { source: "iana" },
  "audio/ip-mr_v2.5": { source: "iana" },
  "audio/isac": { source: "apache" },
  "audio/l16": { source: "iana" },
  "audio/l20": { source: "iana" },
  "audio/l24": { source: "iana", compressible: !1 },
  "audio/l8": { source: "iana" },
  "audio/lpc": { source: "iana" },
  "audio/melp": { source: "iana" },
  "audio/melp1200": { source: "iana" },
  "audio/melp2400": { source: "iana" },
  "audio/melp600": { source: "iana" },
  "audio/mhas": { source: "iana" },
  "audio/midi": { source: "apache", extensions: ["mid", "midi", "kar", "rmi"] },
  "audio/mobile-xmf": { source: "iana", extensions: ["mxmf"] },
  "audio/mp3": { compressible: !1, extensions: ["mp3"] },
  "audio/mp4": { source: "iana", compressible: !1, extensions: ["m4a", "mp4a"] },
  "audio/mp4a-latm": { source: "iana" },
  "audio/mpa": { source: "iana" },
  "audio/mpa-robust": { source: "iana" },
  "audio/mpeg": { source: "iana", compressible: !1, extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] },
  "audio/mpeg4-generic": { source: "iana" },
  "audio/musepack": { source: "apache" },
  "audio/ogg": { source: "iana", compressible: !1, extensions: ["oga", "ogg", "spx", "opus"] },
  "audio/opus": { source: "iana" },
  "audio/parityfec": { source: "iana" },
  "audio/pcma": { source: "iana" },
  "audio/pcma-wb": { source: "iana" },
  "audio/pcmu": { source: "iana" },
  "audio/pcmu-wb": { source: "iana" },
  "audio/prs.sid": { source: "iana" },
  "audio/qcelp": { source: "iana" },
  "audio/raptorfec": { source: "iana" },
  "audio/red": { source: "iana" },
  "audio/rtp-enc-aescm128": { source: "iana" },
  "audio/rtp-midi": { source: "iana" },
  "audio/rtploopback": { source: "iana" },
  "audio/rtx": { source: "iana" },
  "audio/s3m": { source: "apache", extensions: ["s3m"] },
  "audio/scip": { source: "iana" },
  "audio/silk": { source: "apache", extensions: ["sil"] },
  "audio/smv": { source: "iana" },
  "audio/smv-qcp": { source: "iana" },
  "audio/smv0": { source: "iana" },
  "audio/sofa": { source: "iana" },
  "audio/sp-midi": { source: "iana" },
  "audio/speex": { source: "iana" },
  "audio/t140c": { source: "iana" },
  "audio/t38": { source: "iana" },
  "audio/telephone-event": { source: "iana" },
  "audio/tetra_acelp": { source: "iana" },
  "audio/tetra_acelp_bb": { source: "iana" },
  "audio/tone": { source: "iana" },
  "audio/tsvcis": { source: "iana" },
  "audio/uemclip": { source: "iana" },
  "audio/ulpfec": { source: "iana" },
  "audio/usac": { source: "iana" },
  "audio/vdvi": { source: "iana" },
  "audio/vmr-wb": { source: "iana" },
  "audio/vnd.3gpp.iufp": { source: "iana" },
  "audio/vnd.4sb": { source: "iana" },
  "audio/vnd.audiokoz": { source: "iana" },
  "audio/vnd.celp": { source: "iana" },
  "audio/vnd.cisco.nse": { source: "iana" },
  "audio/vnd.cmles.radio-events": { source: "iana" },
  "audio/vnd.cns.anp1": { source: "iana" },
  "audio/vnd.cns.inf1": { source: "iana" },
  "audio/vnd.dece.audio": { source: "iana", extensions: ["uva", "uvva"] },
  "audio/vnd.digital-winds": { source: "iana", extensions: ["eol"] },
  "audio/vnd.dlna.adts": { source: "iana" },
  "audio/vnd.dolby.heaac.1": { source: "iana" },
  "audio/vnd.dolby.heaac.2": { source: "iana" },
  "audio/vnd.dolby.mlp": { source: "iana" },
  "audio/vnd.dolby.mps": { source: "iana" },
  "audio/vnd.dolby.pl2": { source: "iana" },
  "audio/vnd.dolby.pl2x": { source: "iana" },
  "audio/vnd.dolby.pl2z": { source: "iana" },
  "audio/vnd.dolby.pulse.1": { source: "iana" },
  "audio/vnd.dra": { source: "iana", extensions: ["dra"] },
  "audio/vnd.dts": { source: "iana", extensions: ["dts"] },
  "audio/vnd.dts.hd": { source: "iana", extensions: ["dtshd"] },
  "audio/vnd.dts.uhd": { source: "iana" },
  "audio/vnd.dvb.file": { source: "iana" },
  "audio/vnd.everad.plj": { source: "iana" },
  "audio/vnd.hns.audio": { source: "iana" },
  "audio/vnd.lucent.voice": { source: "iana", extensions: ["lvp"] },
  "audio/vnd.ms-playready.media.pya": { source: "iana", extensions: ["pya"] },
  "audio/vnd.nokia.mobile-xmf": { source: "iana" },
  "audio/vnd.nortel.vbk": { source: "iana" },
  "audio/vnd.nuera.ecelp4800": { source: "iana", extensions: ["ecelp4800"] },
  "audio/vnd.nuera.ecelp7470": { source: "iana", extensions: ["ecelp7470"] },
  "audio/vnd.nuera.ecelp9600": { source: "iana", extensions: ["ecelp9600"] },
  "audio/vnd.octel.sbc": { source: "iana" },
  "audio/vnd.presonus.multitrack": { source: "iana" },
  "audio/vnd.qcelp": { source: "iana" },
  "audio/vnd.rhetorex.32kadpcm": { source: "iana" },
  "audio/vnd.rip": { source: "iana", extensions: ["rip"] },
  "audio/vnd.rn-realaudio": { compressible: !1 },
  "audio/vnd.sealedmedia.softseal.mpeg": { source: "iana" },
  "audio/vnd.vmx.cvsd": { source: "iana" },
  "audio/vnd.wave": { compressible: !1 },
  "audio/vorbis": { source: "iana", compressible: !1 },
  "audio/vorbis-config": { source: "iana" },
  "audio/wav": { compressible: !1, extensions: ["wav"] },
  "audio/wave": { compressible: !1, extensions: ["wav"] },
  "audio/webm": { source: "apache", compressible: !1, extensions: ["weba"] },
  "audio/x-aac": { source: "apache", compressible: !1, extensions: ["aac"] },
  "audio/x-aiff": { source: "apache", extensions: ["aif", "aiff", "aifc"] },
  "audio/x-caf": { source: "apache", compressible: !1, extensions: ["caf"] },
  "audio/x-flac": { source: "apache", extensions: ["flac"] },
  "audio/x-m4a": { source: "nginx", extensions: ["m4a"] },
  "audio/x-matroska": { source: "apache", extensions: ["mka"] },
  "audio/x-mpegurl": { source: "apache", extensions: ["m3u"] },
  "audio/x-ms-wax": { source: "apache", extensions: ["wax"] },
  "audio/x-ms-wma": { source: "apache", extensions: ["wma"] },
  "audio/x-pn-realaudio": { source: "apache", extensions: ["ram", "ra"] },
  "audio/x-pn-realaudio-plugin": { source: "apache", extensions: ["rmp"] },
  "audio/x-realaudio": { source: "nginx", extensions: ["ra"] },
  "audio/x-tta": { source: "apache" },
  "audio/x-wav": { source: "apache", extensions: ["wav"] },
  "audio/xm": { source: "apache", extensions: ["xm"] },
  "chemical/x-cdx": { source: "apache", extensions: ["cdx"] },
  "chemical/x-cif": { source: "apache", extensions: ["cif"] },
  "chemical/x-cmdf": { source: "apache", extensions: ["cmdf"] },
  "chemical/x-cml": { source: "apache", extensions: ["cml"] },
  "chemical/x-csml": { source: "apache", extensions: ["csml"] },
  "chemical/x-pdb": { source: "apache" },
  "chemical/x-xyz": { source: "apache", extensions: ["xyz"] },
  "font/collection": { source: "iana", extensions: ["ttc"] },
  "font/otf": { source: "iana", compressible: !0, extensions: ["otf"] },
  "font/sfnt": { source: "iana" },
  "font/ttf": { source: "iana", compressible: !0, extensions: ["ttf"] },
  "font/woff": { source: "iana", extensions: ["woff"] },
  "font/woff2": { source: "iana", extensions: ["woff2"] },
  "image/aces": { source: "iana", extensions: ["exr"] },
  "image/apng": { compressible: !1, extensions: ["apng"] },
  "image/avci": { source: "iana", extensions: ["avci"] },
  "image/avcs": { source: "iana", extensions: ["avcs"] },
  "image/avif": { source: "iana", compressible: !1, extensions: ["avif"] },
  "image/bmp": { source: "iana", compressible: !0, extensions: ["bmp"] },
  "image/cgm": { source: "iana", extensions: ["cgm"] },
  "image/dicom-rle": { source: "iana", extensions: ["drle"] },
  "image/emf": { source: "iana", extensions: ["emf"] },
  "image/fits": { source: "iana", extensions: ["fits"] },
  "image/g3fax": { source: "iana", extensions: ["g3"] },
  "image/gif": { source: "iana", compressible: !1, extensions: ["gif"] },
  "image/heic": { source: "iana", extensions: ["heic"] },
  "image/heic-sequence": { source: "iana", extensions: ["heics"] },
  "image/heif": { source: "iana", extensions: ["heif"] },
  "image/heif-sequence": { source: "iana", extensions: ["heifs"] },
  "image/hej2k": { source: "iana", extensions: ["hej2"] },
  "image/hsj2": { source: "iana", extensions: ["hsj2"] },
  "image/ief": { source: "iana", extensions: ["ief"] },
  "image/jls": { source: "iana", extensions: ["jls"] },
  "image/jp2": { source: "iana", compressible: !1, extensions: ["jp2", "jpg2"] },
  "image/jpeg": { source: "iana", compressible: !1, extensions: ["jpeg", "jpg", "jpe"] },
  "image/jph": { source: "iana", extensions: ["jph"] },
  "image/jphc": { source: "iana", extensions: ["jhc"] },
  "image/jpm": { source: "iana", compressible: !1, extensions: ["jpm"] },
  "image/jpx": { source: "iana", compressible: !1, extensions: ["jpx", "jpf"] },
  "image/jxr": { source: "iana", extensions: ["jxr"] },
  "image/jxra": { source: "iana", extensions: ["jxra"] },
  "image/jxrs": { source: "iana", extensions: ["jxrs"] },
  "image/jxs": { source: "iana", extensions: ["jxs"] },
  "image/jxsc": { source: "iana", extensions: ["jxsc"] },
  "image/jxsi": { source: "iana", extensions: ["jxsi"] },
  "image/jxss": { source: "iana", extensions: ["jxss"] },
  "image/ktx": { source: "iana", extensions: ["ktx"] },
  "image/ktx2": { source: "iana", extensions: ["ktx2"] },
  "image/naplps": { source: "iana" },
  "image/pjpeg": { compressible: !1 },
  "image/png": { source: "iana", compressible: !1, extensions: ["png"] },
  "image/prs.btif": { source: "iana", extensions: ["btif"] },
  "image/prs.pti": { source: "iana", extensions: ["pti"] },
  "image/pwg-raster": { source: "iana" },
  "image/sgi": { source: "apache", extensions: ["sgi"] },
  "image/svg+xml": { source: "iana", compressible: !0, extensions: ["svg", "svgz"] },
  "image/t38": { source: "iana", extensions: ["t38"] },
  "image/tiff": { source: "iana", compressible: !1, extensions: ["tif", "tiff"] },
  "image/tiff-fx": { source: "iana", extensions: ["tfx"] },
  "image/vnd.adobe.photoshop": { source: "iana", compressible: !0, extensions: ["psd"] },
  "image/vnd.airzip.accelerator.azv": { source: "iana", extensions: ["azv"] },
  "image/vnd.cns.inf2": { source: "iana" },
  "image/vnd.dece.graphic": { source: "iana", extensions: ["uvi", "uvvi", "uvg", "uvvg"] },
  "image/vnd.djvu": { source: "iana", extensions: ["djvu", "djv"] },
  "image/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "image/vnd.dwg": { source: "iana", extensions: ["dwg"] },
  "image/vnd.dxf": { source: "iana", extensions: ["dxf"] },
  "image/vnd.fastbidsheet": { source: "iana", extensions: ["fbs"] },
  "image/vnd.fpx": { source: "iana", extensions: ["fpx"] },
  "image/vnd.fst": { source: "iana", extensions: ["fst"] },
  "image/vnd.fujixerox.edmics-mmr": { source: "iana", extensions: ["mmr"] },
  "image/vnd.fujixerox.edmics-rlc": { source: "iana", extensions: ["rlc"] },
  "image/vnd.globalgraphics.pgb": { source: "iana" },
  "image/vnd.microsoft.icon": { source: "iana", compressible: !0, extensions: ["ico"] },
  "image/vnd.mix": { source: "iana" },
  "image/vnd.mozilla.apng": { source: "iana" },
  "image/vnd.ms-dds": { compressible: !0, extensions: ["dds"] },
  "image/vnd.ms-modi": { source: "iana", extensions: ["mdi"] },
  "image/vnd.ms-photo": { source: "apache", extensions: ["wdp"] },
  "image/vnd.net-fpx": { source: "iana", extensions: ["npx"] },
  "image/vnd.pco.b16": { source: "iana", extensions: ["b16"] },
  "image/vnd.radiance": { source: "iana" },
  "image/vnd.sealed.png": { source: "iana" },
  "image/vnd.sealedmedia.softseal.gif": { source: "iana" },
  "image/vnd.sealedmedia.softseal.jpg": { source: "iana" },
  "image/vnd.svf": { source: "iana" },
  "image/vnd.tencent.tap": { source: "iana", extensions: ["tap"] },
  "image/vnd.valve.source.texture": { source: "iana", extensions: ["vtf"] },
  "image/vnd.wap.wbmp": { source: "iana", extensions: ["wbmp"] },
  "image/vnd.xiff": { source: "iana", extensions: ["xif"] },
  "image/vnd.zbrush.pcx": { source: "iana", extensions: ["pcx"] },
  "image/webp": { source: "apache", extensions: ["webp"] },
  "image/wmf": { source: "iana", extensions: ["wmf"] },
  "image/x-3ds": { source: "apache", extensions: ["3ds"] },
  "image/x-cmu-raster": { source: "apache", extensions: ["ras"] },
  "image/x-cmx": { source: "apache", extensions: ["cmx"] },
  "image/x-freehand": { source: "apache", extensions: ["fh", "fhc", "fh4", "fh5", "fh7"] },
  "image/x-icon": { source: "apache", compressible: !0, extensions: ["ico"] },
  "image/x-jng": { source: "nginx", extensions: ["jng"] },
  "image/x-mrsid-image": { source: "apache", extensions: ["sid"] },
  "image/x-ms-bmp": { source: "nginx", compressible: !0, extensions: ["bmp"] },
  "image/x-pcx": { source: "apache", extensions: ["pcx"] },
  "image/x-pict": { source: "apache", extensions: ["pic", "pct"] },
  "image/x-portable-anymap": { source: "apache", extensions: ["pnm"] },
  "image/x-portable-bitmap": { source: "apache", extensions: ["pbm"] },
  "image/x-portable-graymap": { source: "apache", extensions: ["pgm"] },
  "image/x-portable-pixmap": { source: "apache", extensions: ["ppm"] },
  "image/x-rgb": { source: "apache", extensions: ["rgb"] },
  "image/x-tga": { source: "apache", extensions: ["tga"] },
  "image/x-xbitmap": { source: "apache", extensions: ["xbm"] },
  "image/x-xcf": { compressible: !1 },
  "image/x-xpixmap": { source: "apache", extensions: ["xpm"] },
  "image/x-xwindowdump": { source: "apache", extensions: ["xwd"] },
  "message/cpim": { source: "iana" },
  "message/delivery-status": { source: "iana" },
  "message/disposition-notification": { source: "iana", extensions: ["disposition-notification"] },
  "message/external-body": { source: "iana" },
  "message/feedback-report": { source: "iana" },
  "message/global": { source: "iana", extensions: ["u8msg"] },
  "message/global-delivery-status": { source: "iana", extensions: ["u8dsn"] },
  "message/global-disposition-notification": { source: "iana", extensions: ["u8mdn"] },
  "message/global-headers": { source: "iana", extensions: ["u8hdr"] },
  "message/http": { source: "iana", compressible: !1 },
  "message/imdn+xml": { source: "iana", compressible: !0 },
  "message/news": { source: "iana" },
  "message/partial": { source: "iana", compressible: !1 },
  "message/rfc822": { source: "iana", compressible: !0, extensions: ["eml", "mime"] },
  "message/s-http": { source: "iana" },
  "message/sip": { source: "iana" },
  "message/sipfrag": { source: "iana" },
  "message/tracking-status": { source: "iana" },
  "message/vnd.si.simp": { source: "iana" },
  "message/vnd.wfa.wsc": { source: "iana", extensions: ["wsc"] },
  "model/3mf": { source: "iana", extensions: ["3mf"] },
  "model/e57": { source: "iana" },
  "model/gltf+json": { source: "iana", compressible: !0, extensions: ["gltf"] },
  "model/gltf-binary": { source: "iana", compressible: !0, extensions: ["glb"] },
  "model/iges": { source: "iana", compressible: !1, extensions: ["igs", "iges"] },
  "model/mesh": { source: "iana", compressible: !1, extensions: ["msh", "mesh", "silo"] },
  "model/mtl": { source: "iana", extensions: ["mtl"] },
  "model/obj": { source: "iana", extensions: ["obj"] },
  "model/step": { source: "iana" },
  "model/step+xml": { source: "iana", compressible: !0, extensions: ["stpx"] },
  "model/step+zip": { source: "iana", compressible: !1, extensions: ["stpz"] },
  "model/step-xml+zip": { source: "iana", compressible: !1, extensions: ["stpxz"] },
  "model/stl": { source: "iana", extensions: ["stl"] },
  "model/vnd.collada+xml": { source: "iana", compressible: !0, extensions: ["dae"] },
  "model/vnd.dwf": { source: "iana", extensions: ["dwf"] },
  "model/vnd.flatland.3dml": { source: "iana" },
  "model/vnd.gdl": { source: "iana", extensions: ["gdl"] },
  "model/vnd.gs-gdl": { source: "apache" },
  "model/vnd.gs.gdl": { source: "iana" },
  "model/vnd.gtw": { source: "iana", extensions: ["gtw"] },
  "model/vnd.moml+xml": { source: "iana", compressible: !0 },
  "model/vnd.mts": { source: "iana", extensions: ["mts"] },
  "model/vnd.opengex": { source: "iana", extensions: ["ogex"] },
  "model/vnd.parasolid.transmit.binary": { source: "iana", extensions: ["x_b"] },
  "model/vnd.parasolid.transmit.text": { source: "iana", extensions: ["x_t"] },
  "model/vnd.pytha.pyox": { source: "iana" },
  "model/vnd.rosette.annotated-data-model": { source: "iana" },
  "model/vnd.sap.vds": { source: "iana", extensions: ["vds"] },
  "model/vnd.usdz+zip": { source: "iana", compressible: !1, extensions: ["usdz"] },
  "model/vnd.valve.source.compiled-map": { source: "iana", extensions: ["bsp"] },
  "model/vnd.vtu": { source: "iana", extensions: ["vtu"] },
  "model/vrml": { source: "iana", compressible: !1, extensions: ["wrl", "vrml"] },
  "model/x3d+binary": { source: "apache", compressible: !1, extensions: ["x3db", "x3dbz"] },
  "model/x3d+fastinfoset": { source: "iana", extensions: ["x3db"] },
  "model/x3d+vrml": { source: "apache", compressible: !1, extensions: ["x3dv", "x3dvz"] },
  "model/x3d+xml": { source: "iana", compressible: !0, extensions: ["x3d", "x3dz"] },
  "model/x3d-vrml": { source: "iana", extensions: ["x3dv"] },
  "multipart/alternative": { source: "iana", compressible: !1 },
  "multipart/appledouble": { source: "iana" },
  "multipart/byteranges": { source: "iana" },
  "multipart/digest": { source: "iana" },
  "multipart/encrypted": { source: "iana", compressible: !1 },
  "multipart/form-data": { source: "iana", compressible: !1 },
  "multipart/header-set": { source: "iana" },
  "multipart/mixed": { source: "iana" },
  "multipart/multilingual": { source: "iana" },
  "multipart/parallel": { source: "iana" },
  "multipart/related": { source: "iana", compressible: !1 },
  "multipart/report": { source: "iana" },
  "multipart/signed": { source: "iana", compressible: !1 },
  "multipart/vnd.bint.med-plus": { source: "iana" },
  "multipart/voice-message": { source: "iana" },
  "multipart/x-mixed-replace": { source: "iana" },
  "text/1d-interleaved-parityfec": { source: "iana" },
  "text/cache-manifest": { source: "iana", compressible: !0, extensions: ["appcache", "manifest"] },
  "text/calendar": { source: "iana", extensions: ["ics", "ifb"] },
  "text/calender": { compressible: !0 },
  "text/cmd": { compressible: !0 },
  "text/coffeescript": { extensions: ["coffee", "litcoffee"] },
  "text/cql": { source: "iana" },
  "text/cql-expression": { source: "iana" },
  "text/cql-identifier": { source: "iana" },
  "text/css": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["css"] },
  "text/csv": { source: "iana", compressible: !0, extensions: ["csv"] },
  "text/csv-schema": { source: "iana" },
  "text/directory": { source: "iana" },
  "text/dns": { source: "iana" },
  "text/ecmascript": { source: "iana" },
  "text/encaprtp": { source: "iana" },
  "text/enriched": { source: "iana" },
  "text/fhirpath": { source: "iana" },
  "text/flexfec": { source: "iana" },
  "text/fwdred": { source: "iana" },
  "text/gff3": { source: "iana" },
  "text/grammar-ref-list": { source: "iana" },
  "text/html": { source: "iana", compressible: !0, extensions: ["html", "htm", "shtml"] },
  "text/jade": { extensions: ["jade"] },
  "text/javascript": { source: "iana", compressible: !0 },
  "text/jcr-cnd": { source: "iana" },
  "text/jsx": { compressible: !0, extensions: ["jsx"] },
  "text/less": { compressible: !0, extensions: ["less"] },
  "text/markdown": { source: "iana", compressible: !0, extensions: ["markdown", "md"] },
  "text/mathml": { source: "nginx", extensions: ["mml"] },
  "text/mdx": { compressible: !0, extensions: ["mdx"] },
  "text/mizar": { source: "iana" },
  "text/n3": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["n3"] },
  "text/parameters": { source: "iana", charset: "UTF-8" },
  "text/parityfec": { source: "iana" },
  "text/plain": { source: "iana", compressible: !0, extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"] },
  "text/provenance-notation": { source: "iana", charset: "UTF-8" },
  "text/prs.fallenstein.rst": { source: "iana" },
  "text/prs.lines.tag": { source: "iana", extensions: ["dsc"] },
  "text/prs.prop.logic": { source: "iana" },
  "text/raptorfec": { source: "iana" },
  "text/red": { source: "iana" },
  "text/rfc822-headers": { source: "iana" },
  "text/richtext": { source: "iana", compressible: !0, extensions: ["rtx"] },
  "text/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "text/rtp-enc-aescm128": { source: "iana" },
  "text/rtploopback": { source: "iana" },
  "text/rtx": { source: "iana" },
  "text/sgml": { source: "iana", extensions: ["sgml", "sgm"] },
  "text/shaclc": { source: "iana" },
  "text/shex": { source: "iana", extensions: ["shex"] },
  "text/slim": { extensions: ["slim", "slm"] },
  "text/spdx": { source: "iana", extensions: ["spdx"] },
  "text/strings": { source: "iana" },
  "text/stylus": { extensions: ["stylus", "styl"] },
  "text/t140": { source: "iana" },
  "text/tab-separated-values": { source: "iana", compressible: !0, extensions: ["tsv"] },
  "text/troff": { source: "iana", extensions: ["t", "tr", "roff", "man", "me", "ms"] },
  "text/turtle": { source: "iana", charset: "UTF-8", extensions: ["ttl"] },
  "text/ulpfec": { source: "iana" },
  "text/uri-list": { source: "iana", compressible: !0, extensions: ["uri", "uris", "urls"] },
  "text/vcard": { source: "iana", compressible: !0, extensions: ["vcard"] },
  "text/vnd.a": { source: "iana" },
  "text/vnd.abc": { source: "iana" },
  "text/vnd.ascii-art": { source: "iana" },
  "text/vnd.curl": { source: "iana", extensions: ["curl"] },
  "text/vnd.curl.dcurl": { source: "apache", extensions: ["dcurl"] },
  "text/vnd.curl.mcurl": { source: "apache", extensions: ["mcurl"] },
  "text/vnd.curl.scurl": { source: "apache", extensions: ["scurl"] },
  "text/vnd.debian.copyright": { source: "iana", charset: "UTF-8" },
  "text/vnd.dmclientscript": { source: "iana" },
  "text/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "text/vnd.esmertec.theme-descriptor": { source: "iana", charset: "UTF-8" },
  "text/vnd.familysearch.gedcom": { source: "iana", extensions: ["ged"] },
  "text/vnd.ficlab.flt": { source: "iana" },
  "text/vnd.fly": { source: "iana", extensions: ["fly"] },
  "text/vnd.fmi.flexstor": { source: "iana", extensions: ["flx"] },
  "text/vnd.gml": { source: "iana" },
  "text/vnd.graphviz": { source: "iana", extensions: ["gv"] },
  "text/vnd.hans": { source: "iana" },
  "text/vnd.hgl": { source: "iana" },
  "text/vnd.in3d.3dml": { source: "iana", extensions: ["3dml"] },
  "text/vnd.in3d.spot": { source: "iana", extensions: ["spot"] },
  "text/vnd.iptc.newsml": { source: "iana" },
  "text/vnd.iptc.nitf": { source: "iana" },
  "text/vnd.latex-z": { source: "iana" },
  "text/vnd.motorola.reflex": { source: "iana" },
  "text/vnd.ms-mediapackage": { source: "iana" },
  "text/vnd.net2phone.commcenter.command": { source: "iana" },
  "text/vnd.radisys.msml-basic-layout": { source: "iana" },
  "text/vnd.senx.warpscript": { source: "iana" },
  "text/vnd.si.uricatalogue": { source: "iana" },
  "text/vnd.sosi": { source: "iana" },
  "text/vnd.sun.j2me.app-descriptor": { source: "iana", charset: "UTF-8", extensions: ["jad"] },
  "text/vnd.trolltech.linguist": { source: "iana", charset: "UTF-8" },
  "text/vnd.wap.si": { source: "iana" },
  "text/vnd.wap.sl": { source: "iana" },
  "text/vnd.wap.wml": { source: "iana", extensions: ["wml"] },
  "text/vnd.wap.wmlscript": { source: "iana", extensions: ["wmls"] },
  "text/vtt": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["vtt"] },
  "text/x-asm": { source: "apache", extensions: ["s", "asm"] },
  "text/x-c": { source: "apache", extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"] },
  "text/x-component": { source: "nginx", extensions: ["htc"] },
  "text/x-fortran": { source: "apache", extensions: ["f", "for", "f77", "f90"] },
  "text/x-gwt-rpc": { compressible: !0 },
  "text/x-handlebars-template": { extensions: ["hbs"] },
  "text/x-java-source": { source: "apache", extensions: ["java"] },
  "text/x-jquery-tmpl": { compressible: !0 },
  "text/x-lua": { extensions: ["lua"] },
  "text/x-markdown": { compressible: !0, extensions: ["mkd"] },
  "text/x-nfo": { source: "apache", extensions: ["nfo"] },
  "text/x-opml": { source: "apache", extensions: ["opml"] },
  "text/x-org": { compressible: !0, extensions: ["org"] },
  "text/x-pascal": { source: "apache", extensions: ["p", "pas"] },
  "text/x-processing": { compressible: !0, extensions: ["pde"] },
  "text/x-sass": { extensions: ["sass"] },
  "text/x-scss": { extensions: ["scss"] },
  "text/x-setext": { source: "apache", extensions: ["etx"] },
  "text/x-sfv": { source: "apache", extensions: ["sfv"] },
  "text/x-suse-ymp": { compressible: !0, extensions: ["ymp"] },
  "text/x-uuencode": { source: "apache", extensions: ["uu"] },
  "text/x-vcalendar": { source: "apache", extensions: ["vcs"] },
  "text/x-vcard": { source: "apache", extensions: ["vcf"] },
  "text/xml": { source: "iana", compressible: !0, extensions: ["xml"] },
  "text/xml-external-parsed-entity": { source: "iana" },
  "text/yaml": { compressible: !0, extensions: ["yaml", "yml"] },
  "video/1d-interleaved-parityfec": { source: "iana" },
  "video/3gpp": { source: "iana", extensions: ["3gp", "3gpp"] },
  "video/3gpp-tt": { source: "iana" },
  "video/3gpp2": { source: "iana", extensions: ["3g2"] },
  "video/av1": { source: "iana" },
  "video/bmpeg": { source: "iana" },
  "video/bt656": { source: "iana" },
  "video/celb": { source: "iana" },
  "video/dv": { source: "iana" },
  "video/encaprtp": { source: "iana" },
  "video/ffv1": { source: "iana" },
  "video/flexfec": { source: "iana" },
  "video/h261": { source: "iana", extensions: ["h261"] },
  "video/h263": { source: "iana", extensions: ["h263"] },
  "video/h263-1998": { source: "iana" },
  "video/h263-2000": { source: "iana" },
  "video/h264": { source: "iana", extensions: ["h264"] },
  "video/h264-rcdo": { source: "iana" },
  "video/h264-svc": { source: "iana" },
  "video/h265": { source: "iana" },
  "video/iso.segment": { source: "iana", extensions: ["m4s"] },
  "video/jpeg": { source: "iana", extensions: ["jpgv"] },
  "video/jpeg2000": { source: "iana" },
  "video/jpm": { source: "apache", extensions: ["jpm", "jpgm"] },
  "video/jxsv": { source: "iana" },
  "video/mj2": { source: "iana", extensions: ["mj2", "mjp2"] },
  "video/mp1s": { source: "iana" },
  "video/mp2p": { source: "iana" },
  "video/mp2t": { source: "iana", extensions: ["ts"] },
  "video/mp4": { source: "iana", compressible: !1, extensions: ["mp4", "mp4v", "mpg4"] },
  "video/mp4v-es": { source: "iana" },
  "video/mpeg": { source: "iana", compressible: !1, extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"] },
  "video/mpeg4-generic": { source: "iana" },
  "video/mpv": { source: "iana" },
  "video/nv": { source: "iana" },
  "video/ogg": { source: "iana", compressible: !1, extensions: ["ogv"] },
  "video/parityfec": { source: "iana" },
  "video/pointer": { source: "iana" },
  "video/quicktime": { source: "iana", compressible: !1, extensions: ["qt", "mov"] },
  "video/raptorfec": { source: "iana" },
  "video/raw": { source: "iana" },
  "video/rtp-enc-aescm128": { source: "iana" },
  "video/rtploopback": { source: "iana" },
  "video/rtx": { source: "iana" },
  "video/scip": { source: "iana" },
  "video/smpte291": { source: "iana" },
  "video/smpte292m": { source: "iana" },
  "video/ulpfec": { source: "iana" },
  "video/vc1": { source: "iana" },
  "video/vc2": { source: "iana" },
  "video/vnd.cctv": { source: "iana" },
  "video/vnd.dece.hd": { source: "iana", extensions: ["uvh", "uvvh"] },
  "video/vnd.dece.mobile": { source: "iana", extensions: ["uvm", "uvvm"] },
  "video/vnd.dece.mp4": { source: "iana" },
  "video/vnd.dece.pd": { source: "iana", extensions: ["uvp", "uvvp"] },
  "video/vnd.dece.sd": { source: "iana", extensions: ["uvs", "uvvs"] },
  "video/vnd.dece.video": { source: "iana", extensions: ["uvv", "uvvv"] },
  "video/vnd.directv.mpeg": { source: "iana" },
  "video/vnd.directv.mpeg-tts": { source: "iana" },
  "video/vnd.dlna.mpeg-tts": { source: "iana" },
  "video/vnd.dvb.file": { source: "iana", extensions: ["dvb"] },
  "video/vnd.fvt": { source: "iana", extensions: ["fvt"] },
  "video/vnd.hns.video": { source: "iana" },
  "video/vnd.iptvforum.1dparityfec-1010": { source: "iana" },
  "video/vnd.iptvforum.1dparityfec-2005": { source: "iana" },
  "video/vnd.iptvforum.2dparityfec-1010": { source: "iana" },
  "video/vnd.iptvforum.2dparityfec-2005": { source: "iana" },
  "video/vnd.iptvforum.ttsavc": { source: "iana" },
  "video/vnd.iptvforum.ttsmpeg2": { source: "iana" },
  "video/vnd.motorola.video": { source: "iana" },
  "video/vnd.motorola.videop": { source: "iana" },
  "video/vnd.mpegurl": { source: "iana", extensions: ["mxu", "m4u"] },
  "video/vnd.ms-playready.media.pyv": { source: "iana", extensions: ["pyv"] },
  "video/vnd.nokia.interleaved-multimedia": { source: "iana" },
  "video/vnd.nokia.mp4vr": { source: "iana" },
  "video/vnd.nokia.videovoip": { source: "iana" },
  "video/vnd.objectvideo": { source: "iana" },
  "video/vnd.radgamettools.bink": { source: "iana" },
  "video/vnd.radgamettools.smacker": { source: "iana" },
  "video/vnd.sealed.mpeg1": { source: "iana" },
  "video/vnd.sealed.mpeg4": { source: "iana" },
  "video/vnd.sealed.swf": { source: "iana" },
  "video/vnd.sealedmedia.softseal.mov": { source: "iana" },
  "video/vnd.uvvu.mp4": { source: "iana", extensions: ["uvu", "uvvu"] },
  "video/vnd.vivo": { source: "iana", extensions: ["viv"] },
  "video/vnd.youtube.yt": { source: "iana" },
  "video/vp8": { source: "iana" },
  "video/vp9": { source: "iana" },
  "video/webm": { source: "apache", compressible: !1, extensions: ["webm"] },
  "video/x-f4v": { source: "apache", extensions: ["f4v"] },
  "video/x-fli": { source: "apache", extensions: ["fli"] },
  "video/x-flv": { source: "apache", compressible: !1, extensions: ["flv"] },
  "video/x-m4v": { source: "apache", extensions: ["m4v"] },
  "video/x-matroska": { source: "apache", compressible: !1, extensions: ["mkv", "mk3d", "mks"] },
  "video/x-mng": { source: "apache", extensions: ["mng"] },
  "video/x-ms-asf": { source: "apache", extensions: ["asf", "asx"] },
  "video/x-ms-vob": { source: "apache", extensions: ["vob"] },
  "video/x-ms-wm": { source: "apache", extensions: ["wm"] },
  "video/x-ms-wmv": { source: "apache", compressible: !1, extensions: ["wmv"] },
  "video/x-ms-wmx": { source: "apache", extensions: ["wmx"] },
  "video/x-ms-wvx": { source: "apache", extensions: ["wvx"] },
  "video/x-msvideo": { source: "apache", extensions: ["avi"] },
  "video/x-sgi-movie": { source: "apache", extensions: ["movie"] },
  "video/x-smv": { source: "apache", extensions: ["smv"] },
  "x-conference/x-cooltalk": { source: "apache", extensions: ["ice"] },
  "x-shader/x-fragment": { compressible: !0 },
  "x-shader/x-vertex": { compressible: !0 }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
var p6, BS;
function Hne() {
  return BS || (BS = 1, p6 = Une), p6;
}
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var US;
function zne() {
  return US || (US = 1, function(e) {
    var t = Hne(), n = Ss().extname, r = /^\s*([^;\s]*)(?:;|\s|$)/, i = /^text\//i;
    e.charset = a, e.charsets = { lookup: a }, e.contentType = o, e.extension = c, e.extensions = /* @__PURE__ */ Object.create(null), e.lookup = u, e.types = /* @__PURE__ */ Object.create(null), s(e.extensions, e.types);
    function a(f) {
      if (!f || typeof f != "string")
        return !1;
      var d = r.exec(f), l = d && t[d[1].toLowerCase()];
      return l && l.charset ? l.charset : d && i.test(d[1]) ? "UTF-8" : !1;
    }
    function o(f) {
      if (!f || typeof f != "string")
        return !1;
      var d = f.indexOf("/") === -1 ? e.lookup(f) : f;
      if (!d)
        return !1;
      if (d.indexOf("charset") === -1) {
        var l = e.charset(d);
        l && (d += "; charset=" + l.toLowerCase());
      }
      return d;
    }
    function c(f) {
      if (!f || typeof f != "string")
        return !1;
      var d = r.exec(f), l = d && e.extensions[d[1].toLowerCase()];
      return !l || !l.length ? !1 : l[0];
    }
    function u(f) {
      if (!f || typeof f != "string")
        return !1;
      var d = n("x." + f).toLowerCase().substr(1);
      return d && e.types[d] || !1;
    }
    function s(f, d) {
      var l = ["nginx", "apache", void 0, "iana"];
      Object.keys(t).forEach(function(g) {
        var v = t[g], b = v.extensions;
        if (!(!b || !b.length)) {
          f[g] = b;
          for (var y = 0; y < b.length; y++) {
            var w = b[y];
            if (d[w]) {
              var C = l.indexOf(t[d[w]].source), T = l.indexOf(v.source);
              if (d[w] !== "application/octet-stream" && (C > T || C === T && d[w].substr(0, 12) === "application/"))
                continue;
            }
            d[w] = g;
          }
        }
      });
    }
  }(f6)), f6;
}
var d6, HS;
function Gne() {
  if (HS) return d6;
  HS = 1, d6 = e;
  function e(t) {
    var n = typeof setImmediate == "function" ? setImmediate : typeof bn == "object" && typeof bn.nextTick == "function" ? bn.nextTick : null;
    n ? n(t) : setTimeout(t, 0);
  }
  return d6;
}
var h6, zS;
function JO() {
  if (zS) return h6;
  zS = 1;
  var e = Gne();
  h6 = t;
  function t(n) {
    var r = !1;
    return e(function() {
      r = !0;
    }), function(a, o) {
      r ? n(a, o) : e(function() {
        n(a, o);
      });
    };
  }
  return h6;
}
var m6, GS;
function QO() {
  if (GS) return m6;
  GS = 1, m6 = e;
  function e(n) {
    Object.keys(n.jobs).forEach(t.bind(n)), n.jobs = {};
  }
  function t(n) {
    typeof this.jobs[n] == "function" && this.jobs[n]();
  }
  return m6;
}
var g6, VS;
function XO() {
  if (VS) return g6;
  VS = 1;
  var e = JO(), t = QO();
  g6 = n;
  function n(i, a, o, c) {
    var u = o.keyedList ? o.keyedList[o.index] : o.index;
    o.jobs[u] = r(a, u, i[u], function(s, f) {
      u in o.jobs && (delete o.jobs[u], s ? t(o) : o.results[u] = f, c(s, o.results));
    });
  }
  function r(i, a, o, c) {
    var u;
    return i.length == 2 ? u = i(o, e(c)) : u = i(o, a, e(c)), u;
  }
  return g6;
}
var v6, WS;
function eT() {
  if (WS) return v6;
  WS = 1, v6 = e;
  function e(t, n) {
    var r = !Array.isArray(t), i = {
      index: 0,
      keyedList: r || n ? Object.keys(t) : null,
      jobs: {},
      results: r ? {} : [],
      size: r ? Object.keys(t).length : t.length
    };
    return n && i.keyedList.sort(r ? n : function(a, o) {
      return n(t[a], t[o]);
    }), i;
  }
  return v6;
}
var y6, KS;
function tT() {
  if (KS) return y6;
  KS = 1;
  var e = QO(), t = JO();
  y6 = n;
  function n(r) {
    Object.keys(this.jobs).length && (this.index = this.size, e(this), t(r)(null, this.results));
  }
  return y6;
}
var b6, ZS;
function Vne() {
  if (ZS) return b6;
  ZS = 1;
  var e = XO(), t = eT(), n = tT();
  b6 = r;
  function r(i, a, o) {
    for (var c = t(i); c.index < (c.keyedList || i).length; )
      e(i, a, c, function(u, s) {
        if (u) {
          o(u, s);
          return;
        }
        if (Object.keys(c.jobs).length === 0) {
          o(null, c.results);
          return;
        }
      }), c.index++;
    return n.bind(c, o);
  }
  return b6;
}
var af = { exports: {} }, YS;
function rT() {
  if (YS) return af.exports;
  YS = 1;
  var e = XO(), t = eT(), n = tT();
  af.exports = r, af.exports.ascending = i, af.exports.descending = a;
  function r(o, c, u, s) {
    var f = t(o, u);
    return e(o, c, f, function d(l, p) {
      if (l) {
        s(l, p);
        return;
      }
      if (f.index++, f.index < (f.keyedList || o).length) {
        e(o, c, f, d);
        return;
      }
      s(null, f.results);
    }), n.bind(f, s);
  }
  function i(o, c) {
    return o < c ? -1 : o > c ? 1 : 0;
  }
  function a(o, c) {
    return -1 * i(o, c);
  }
  return af.exports;
}
var x6, JS;
function Wne() {
  if (JS) return x6;
  JS = 1;
  var e = rT();
  x6 = t;
  function t(n, r, i) {
    return e(n, r, null, i);
  }
  return x6;
}
var _6, QS;
function Kne() {
  return QS || (QS = 1, _6 = {
    parallel: Vne(),
    serial: Wne(),
    serialOrdered: rT()
  }), _6;
}
var w6, XS;
function Zne() {
  return XS || (XS = 1, w6 = function(e, t) {
    return Object.keys(t).forEach(function(n) {
      e[n] = e[n] || t[n];
    }), e;
  }), w6;
}
var S6, eC;
function Yne() {
  if (eC) return S6;
  eC = 1;
  var e = qne(), t = G0(), n = Ss(), r = ai, i = ai, a = YO().parse, o = ai, c = ai.Stream, u = zne(), s = Kne(), f = Zne();
  S6 = d, t.inherits(d, e);
  function d(l) {
    if (!(this instanceof d))
      return new d(l);
    this._overheadLength = 0, this._valueLength = 0, this._valuesToMeasure = [], e.call(this), l = l || {};
    for (var p in l)
      this[p] = l[p];
  }
  return d.LINE_BREAK = `\r
`, d.DEFAULT_CONTENT_TYPE = "application/octet-stream", d.prototype.append = function(l, p, g) {
    g = g || {}, typeof g == "string" && (g = { filename: g });
    var v = e.prototype.append.bind(this);
    if (typeof p == "number" && (p = "" + p), t.isArray(p)) {
      this._error(new Error("Arrays are not supported."));
      return;
    }
    var b = this._multiPartHeader(l, p, g), y = this._multiPartFooter();
    v(b), v(p), v(y), this._trackLength(b, p, g);
  }, d.prototype._trackLength = function(l, p, g) {
    var v = 0;
    g.knownLength != null ? v += +g.knownLength : Dn.isBuffer(p) ? v = p.length : typeof p == "string" && (v = Dn.byteLength(p)), this._valueLength += v, this._overheadLength += Dn.byteLength(l) + d.LINE_BREAK.length, !(!p || !p.path && !(p.readable && p.hasOwnProperty("httpVersion")) && !(p instanceof c)) && (g.knownLength || this._valuesToMeasure.push(p));
  }, d.prototype._lengthRetriever = function(l, p) {
    l.hasOwnProperty("fd") ? l.end != null && l.end != 1 / 0 && l.start != null ? p(null, l.end + 1 - (l.start ? l.start : 0)) : o.stat(l.path, function(g, v) {
      var b;
      if (g) {
        p(g);
        return;
      }
      b = v.size - (l.start ? l.start : 0), p(null, b);
    }) : l.hasOwnProperty("httpVersion") ? p(null, +l.headers["content-length"]) : l.hasOwnProperty("httpModule") ? (l.on("response", function(g) {
      l.pause(), p(null, +g.headers["content-length"]);
    }), l.resume()) : p("Unknown stream");
  }, d.prototype._multiPartHeader = function(l, p, g) {
    if (typeof g.header == "string")
      return g.header;
    var v = this._getContentDisposition(p, g), b = this._getContentType(p, g), y = "", w = {
      // add custom disposition as third element or keep it two elements if not
      "Content-Disposition": ["form-data", 'name="' + l + '"'].concat(v || []),
      // if no content type. allow it to be empty array
      "Content-Type": [].concat(b || [])
    };
    typeof g.header == "object" && f(w, g.header);
    var C;
    for (var T in w)
      w.hasOwnProperty(T) && (C = w[T], C != null && (Array.isArray(C) || (C = [C]), C.length && (y += T + ": " + C.join("; ") + d.LINE_BREAK)));
    return "--" + this.getBoundary() + d.LINE_BREAK + y + d.LINE_BREAK;
  }, d.prototype._getContentDisposition = function(l, p) {
    var g, v;
    return typeof p.filepath == "string" ? g = n.normalize(p.filepath).replace(/\\/g, "/") : p.filename || l.name || l.path ? g = n.basename(p.filename || l.name || l.path) : l.readable && l.hasOwnProperty("httpVersion") && (g = n.basename(l.client._httpMessage.path || "")), g && (v = 'filename="' + g + '"'), v;
  }, d.prototype._getContentType = function(l, p) {
    var g = p.contentType;
    return !g && l.name && (g = u.lookup(l.name)), !g && l.path && (g = u.lookup(l.path)), !g && l.readable && l.hasOwnProperty("httpVersion") && (g = l.headers["content-type"]), !g && (p.filepath || p.filename) && (g = u.lookup(p.filepath || p.filename)), !g && typeof l == "object" && (g = d.DEFAULT_CONTENT_TYPE), g;
  }, d.prototype._multiPartFooter = function() {
    return (function(l) {
      var p = d.LINE_BREAK, g = this._streams.length === 0;
      g && (p += this._lastBoundary()), l(p);
    }).bind(this);
  }, d.prototype._lastBoundary = function() {
    return "--" + this.getBoundary() + "--" + d.LINE_BREAK;
  }, d.prototype.getHeaders = function(l) {
    var p, g = {
      "content-type": "multipart/form-data; boundary=" + this.getBoundary()
    };
    for (p in l)
      l.hasOwnProperty(p) && (g[p.toLowerCase()] = l[p]);
    return g;
  }, d.prototype.setBoundary = function(l) {
    this._boundary = l;
  }, d.prototype.getBoundary = function() {
    return this._boundary || this._generateBoundary(), this._boundary;
  }, d.prototype.getBuffer = function() {
    for (var l = new Dn.alloc(0), p = this.getBoundary(), g = 0, v = this._streams.length; g < v; g++)
      typeof this._streams[g] != "function" && (Dn.isBuffer(this._streams[g]) ? l = Dn.concat([l, this._streams[g]]) : l = Dn.concat([l, Dn.from(this._streams[g])]), (typeof this._streams[g] != "string" || this._streams[g].substring(2, p.length + 2) !== p) && (l = Dn.concat([l, Dn.from(d.LINE_BREAK)])));
    return Dn.concat([l, Dn.from(this._lastBoundary())]);
  }, d.prototype._generateBoundary = function() {
    for (var l = "--------------------------", p = 0; p < 24; p++)
      l += Math.floor(Math.random() * 10).toString(16);
    this._boundary = l;
  }, d.prototype.getLengthSync = function() {
    var l = this._overheadLength + this._valueLength;
    return this._streams.length && (l += this._lastBoundary().length), this.hasKnownLength() || this._error(new Error("Cannot calculate proper length in synchronous way.")), l;
  }, d.prototype.hasKnownLength = function() {
    var l = !0;
    return this._valuesToMeasure.length && (l = !1), l;
  }, d.prototype.getLength = function(l) {
    var p = this._overheadLength + this._valueLength;
    if (this._streams.length && (p += this._lastBoundary().length), !this._valuesToMeasure.length) {
      bn.nextTick(l.bind(this, null, p));
      return;
    }
    s.parallel(this._valuesToMeasure, this._lengthRetriever, function(g, v) {
      if (g) {
        l(g);
        return;
      }
      v.forEach(function(b) {
        p += b;
      }), l(null, p);
    });
  }, d.prototype.submit = function(l, p) {
    var g, v, b = { method: "post" };
    return typeof l == "string" ? (l = a(l), v = f({
      port: l.port,
      path: l.pathname,
      host: l.hostname,
      protocol: l.protocol
    }, b)) : (v = f(l, b), v.port || (v.port = v.protocol == "https:" ? 443 : 80)), v.headers = this.getHeaders(l.headers), v.protocol == "https:" ? g = i.request(v) : g = r.request(v), this.getLength((function(y, w) {
      if (y && y !== "Unknown stream") {
        this._error(y);
        return;
      }
      if (w && g.setHeader("Content-Length", w), this.pipe(g), p) {
        var C, T = function(E, D) {
          return g.removeListener("error", T), g.removeListener("response", C), p.call(this, E, D);
        };
        C = T.bind(this, null), g.on("error", T), g.on("response", C);
      }
    }).bind(this)), g;
  }, d.prototype._error = function(l) {
    this.error || (this.error = l, this.pause(), this.emit("error", l));
  }, d.prototype.toString = function() {
    return "[object FormData]";
  }, S6;
}
var C6 = { exports: {} }, tC;
function Jne() {
  return tC || (tC = 1, function(e) {
    var t = Object.create, n = Object.defineProperty, r = Object.defineProperties, i = Object.getOwnPropertyDescriptor, a = Object.getOwnPropertyDescriptors, o = Object.getOwnPropertyNames, c = Object.getOwnPropertySymbols, u = Object.getPrototypeOf, s = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable, d = Math.pow, l = (ie, me, $e) => me in ie ? n(ie, me, { enumerable: !0, configurable: !0, writable: !0, value: $e }) : ie[me] = $e, p = (ie, me) => {
      for (var $e in me || (me = {}))
        s.call(me, $e) && l(ie, $e, me[$e]);
      if (c)
        for (var $e of c(me))
          f.call(me, $e) && l(ie, $e, me[$e]);
      return ie;
    }, g = (ie, me) => r(ie, a(me)), v = (ie, me) => function() {
      return me || (0, ie[o(ie)[0]])((me = { exports: {} }).exports, me), me.exports;
    }, b = (ie, me) => {
      for (var $e in me)
        n(ie, $e, { get: me[$e], enumerable: !0 });
    }, y = (ie, me, $e, Pe) => {
      if (me && typeof me == "object" || typeof me == "function")
        for (let Le of o(me))
          !s.call(ie, Le) && Le !== $e && n(ie, Le, { get: () => me[Le], enumerable: !(Pe = i(me, Le)) || Pe.enumerable });
      return ie;
    }, w = (ie, me, $e) => ($e = ie != null ? t(u(ie)) : {}, y(
      !ie || !ie.__esModule ? n($e, "default", { value: ie, enumerable: !0 }) : $e,
      ie
    )), C = (ie) => y(n({}, "__esModule", { value: !0 }), ie), T = v({
      "node_modules/ajv-formats/dist/formats.js"(ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.formatNames = ie.fastFormats = ie.fullFormats = void 0;
        function me(Ee, N) {
          return { validate: Ee, compare: N };
        }
        ie.fullFormats = {
          date: me(Ae, He),
          time: me(we, qe),
          "date-time": me(It, Qe),
          duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
          uri: Lt,
          "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
          "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
          url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
          email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
          hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
          ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
          ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
          regex: ae,
          uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
          "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
          "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
          "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
          byte: Ze,
          int32: { type: "number", validate: Vr },
          int64: { type: "number", validate: ye },
          float: { type: "number", validate: G },
          double: { type: "number", validate: G },
          password: !0,
          binary: !0
        }, ie.fastFormats = g(p({}, ie.fullFormats), {
          date: me(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, He),
          time: me(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, qe),
          "date-time": me(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, Qe),
          uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
          "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
          email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
        }), ie.formatNames = Object.keys(ie.fullFormats);
        function $e(Ee) {
          return Ee % 4 === 0 && (Ee % 100 !== 0 || Ee % 400 === 0);
        }
        var Pe = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, Le = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function Ae(Ee) {
          const N = Pe.exec(Ee);
          if (!N)
            return !1;
          const Se = +N[1], Me = +N[2], Xe = +N[3];
          return Me >= 1 && Me <= 12 && Xe >= 1 && Xe <= (Me === 2 && $e(Se) ? 29 : Le[Me]);
        }
        function He(Ee, N) {
          if (Ee && N)
            return Ee > N ? 1 : Ee < N ? -1 : 0;
        }
        var Te = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
        function we(Ee, N) {
          const Se = Te.exec(Ee);
          if (!Se)
            return !1;
          const Me = +Se[1], Xe = +Se[2], Ke = +Se[3], $t = Se[5];
          return (Me <= 23 && Xe <= 59 && Ke <= 59 || Me === 23 && Xe === 59 && Ke === 60) && (!N || $t !== "");
        }
        function qe(Ee, N) {
          if (!(Ee && N))
            return;
          const Se = Te.exec(Ee), Me = Te.exec(N);
          if (Se && Me)
            return Ee = Se[1] + Se[2] + Se[3] + (Se[4] || ""), N = Me[1] + Me[2] + Me[3] + (Me[4] || ""), Ee > N ? 1 : Ee < N ? -1 : 0;
        }
        var Ge = /t|\s/i;
        function It(Ee) {
          const N = Ee.split(Ge);
          return N.length === 2 && Ae(N[0]) && we(N[1], !0);
        }
        function Qe(Ee, N) {
          if (!(Ee && N))
            return;
          const [Se, Me] = Ee.split(Ge), [Xe, Ke] = N.split(Ge), $t = He(Se, Xe);
          if ($t !== void 0)
            return $t || qe(Me, Ke);
        }
        var jt = /\/|:/, We = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
        function Lt(Ee) {
          return jt.test(Ee) && We.test(Ee);
        }
        var Fe = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
        function Ze(Ee) {
          return Fe.lastIndex = 0, Fe.test(Ee);
        }
        var Ue = -d(2, 31), Rt = d(2, 31) - 1;
        function Vr(Ee) {
          return Number.isInteger(Ee) && Ee <= Rt && Ee >= Ue;
        }
        function ye(Ee) {
          return Number.isInteger(Ee);
        }
        function G() {
          return !0;
        }
        var Y = /[^\\]\\Z/;
        function ae(Ee) {
          if (Y.test(Ee))
            return !1;
          try {
            return new RegExp(Ee), !0;
          } catch {
            return !1;
          }
        }
      }
    }), E = v({
      "src/validate.js"(ie) {
        ie["afterRequest.json"] = Pe;
        var me = { $id: "afterRequest.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["lastAccess", "eTag", "hitCount"], properties: { expires: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, lastAccess: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, eTag: { type: "string" }, hitCount: { type: "integer" }, comment: { type: "string" } } }, $e = new RegExp("^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", "u");
        function Pe(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.lastAccess === void 0 && (Q = "lastAccess") || k.eTag === void 0 && (Q = "eTag") || k.hitCount === void 0 && (Q = "hitCount"))
              return Pe.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: me.required, parentSchema: me, data: k }], !1;
            if (k.expires !== void 0) {
              let V = k.expires;
              const X = L;
              if (typeof V == "string") {
                if (!$e.test(V))
                  return Pe.errors = [{ instancePath: j + "/expires", schemaPath: "#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: me.properties.expires, data: V }], !1;
              } else
                return Pe.errors = [{ instancePath: j + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.expires.type, parentSchema: me.properties.expires, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.lastAccess !== void 0) {
                let V = k.lastAccess;
                const X = L;
                if (typeof V == "string") {
                  if (!$e.test(V))
                    return Pe.errors = [{ instancePath: j + "/lastAccess", schemaPath: "#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: me.properties.lastAccess, data: V }], !1;
                } else
                  return Pe.errors = [{ instancePath: j + "/lastAccess", schemaPath: "#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.lastAccess.type, parentSchema: me.properties.lastAccess, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B) {
                if (k.eTag !== void 0) {
                  let V = k.eTag;
                  const X = L;
                  if (typeof V != "string")
                    return Pe.errors = [{ instancePath: j + "/eTag", schemaPath: "#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.eTag.type, parentSchema: me.properties.eTag, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.hitCount !== void 0) {
                    let V = k.hitCount;
                    const X = L;
                    if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                      return Pe.errors = [{ instancePath: j + "/hitCount", schemaPath: "#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: me.properties.hitCount.type, parentSchema: me.properties.hitCount, data: V }], !1;
                    var B = X === L;
                  } else
                    var B = !0;
                  if (B)
                    if (k.comment !== void 0) {
                      let V = k.comment;
                      const X = L;
                      if (typeof V != "string")
                        return Pe.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.comment.type, parentSchema: me.properties.comment, data: V }], !1;
                      var B = X === L;
                    } else
                      var B = !0;
                }
              }
            }
          } else
            return Pe.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: me.type, parentSchema: me, data: k }], !1;
          return Pe.errors = U, L === 0;
        }
        ie["beforeRequest.json"] = Ae;
        var Le = { $id: "beforeRequest.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["lastAccess", "eTag", "hitCount"], properties: { expires: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, lastAccess: { type: "string", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, eTag: { type: "string" }, hitCount: { type: "integer" }, comment: { type: "string" } } };
        function Ae(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.lastAccess === void 0 && (Q = "lastAccess") || k.eTag === void 0 && (Q = "eTag") || k.hitCount === void 0 && (Q = "hitCount"))
              return Ae.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: Le.required, parentSchema: Le, data: k }], !1;
            if (k.expires !== void 0) {
              let V = k.expires;
              const X = L;
              if (typeof V == "string") {
                if (!$e.test(V))
                  return Ae.errors = [{ instancePath: j + "/expires", schemaPath: "#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Le.properties.expires, data: V }], !1;
              } else
                return Ae.errors = [{ instancePath: j + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.expires.type, parentSchema: Le.properties.expires, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.lastAccess !== void 0) {
                let V = k.lastAccess;
                const X = L;
                if (typeof V == "string") {
                  if (!$e.test(V))
                    return Ae.errors = [{ instancePath: j + "/lastAccess", schemaPath: "#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Le.properties.lastAccess, data: V }], !1;
                } else
                  return Ae.errors = [{ instancePath: j + "/lastAccess", schemaPath: "#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.lastAccess.type, parentSchema: Le.properties.lastAccess, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B) {
                if (k.eTag !== void 0) {
                  let V = k.eTag;
                  const X = L;
                  if (typeof V != "string")
                    return Ae.errors = [{ instancePath: j + "/eTag", schemaPath: "#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.eTag.type, parentSchema: Le.properties.eTag, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.hitCount !== void 0) {
                    let V = k.hitCount;
                    const X = L;
                    if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                      return Ae.errors = [{ instancePath: j + "/hitCount", schemaPath: "#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Le.properties.hitCount.type, parentSchema: Le.properties.hitCount, data: V }], !1;
                    var B = X === L;
                  } else
                    var B = !0;
                  if (B)
                    if (k.comment !== void 0) {
                      let V = k.comment;
                      const X = L;
                      if (typeof V != "string")
                        return Ae.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.comment.type, parentSchema: Le.properties.comment, data: V }], !1;
                      var B = X === L;
                    } else
                      var B = !0;
                }
              }
            }
          } else
            return Ae.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Le.type, parentSchema: Le, data: k }], !1;
          return Ae.errors = U, L === 0;
        }
        ie["browser.json"] = Te;
        var He = { $id: "browser.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "version"], properties: { name: { type: "string" }, version: { type: "string" }, comment: { type: "string" } } };
        function Te(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.name === void 0 && (Q = "name") || k.version === void 0 && (Q = "version"))
              return Te.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: He.required, parentSchema: He, data: k }], !1;
            if (k.name !== void 0) {
              let V = k.name;
              const X = L;
              if (typeof V != "string")
                return Te.errors = [{ instancePath: j + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: He.properties.name.type, parentSchema: He.properties.name, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.version !== void 0) {
                let V = k.version;
                const X = L;
                if (typeof V != "string")
                  return Te.errors = [{ instancePath: j + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: He.properties.version.type, parentSchema: He.properties.version, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B)
                if (k.comment !== void 0) {
                  let V = k.comment;
                  const X = L;
                  if (typeof V != "string")
                    return Te.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: He.properties.comment.type, parentSchema: He.properties.comment, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
            }
          } else
            return Te.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: He.type, parentSchema: He, data: k }], !1;
          return Te.errors = U, L === 0;
        }
        ie["cache.json"] = qe;
        var we = { properties: { beforeRequest: { oneOf: [{ type: "null" }, { $ref: "beforeRequest.json#" }] }, afterRequest: { oneOf: [{ type: "null" }, { $ref: "afterRequest.json#" }] }, comment: { type: "string" } } };
        function qe(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            if (k.beforeRequest !== void 0) {
              let ve = k.beforeRequest;
              const pe = L, oe = L;
              let ce = !1, ke = null;
              const fe = L;
              if (ve !== null) {
                const Ie = { instancePath: j + "/beforeRequest", schemaPath: "#/properties/beforeRequest/oneOf/0/type", keyword: "type", params: { type: "null" }, message: "must be null", schema: we.properties.beforeRequest.oneOf[0].type, parentSchema: we.properties.beforeRequest.oneOf[0], data: ve };
                U === null ? U = [Ie] : U.push(Ie), L++;
              }
              var Q = fe === L;
              Q && (ce = !0, ke = 0);
              const be = L;
              if (L === L)
                if (ve && typeof ve == "object" && !Array.isArray(ve)) {
                  let Ie;
                  if (ve.lastAccess === void 0 && (Ie = "lastAccess") || ve.eTag === void 0 && (Ie = "eTag") || ve.hitCount === void 0 && (Ie = "hitCount")) {
                    const le = { instancePath: j + "/beforeRequest", schemaPath: "beforeRequest.json#/required", keyword: "required", params: { missingProperty: Ie }, message: "must have required property '" + Ie + "'", schema: Le.required, parentSchema: Le, data: ve };
                    U === null ? U = [le] : U.push(le), L++;
                  } else {
                    if (ve.expires !== void 0) {
                      let le = ve.expires;
                      const he = L;
                      if (L === he)
                        if (typeof le == "string") {
                          if (!$e.test(le)) {
                            const xe = { instancePath: j + "/beforeRequest/expires", schemaPath: "beforeRequest.json#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Le.properties.expires, data: le };
                            U === null ? U = [xe] : U.push(xe), L++;
                          }
                        } else {
                          const xe = { instancePath: j + "/beforeRequest/expires", schemaPath: "beforeRequest.json#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.expires.type, parentSchema: Le.properties.expires, data: le };
                          U === null ? U = [xe] : U.push(xe), L++;
                        }
                      var B = he === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (ve.lastAccess !== void 0) {
                        let le = ve.lastAccess;
                        const he = L;
                        if (L === he)
                          if (typeof le == "string") {
                            if (!$e.test(le)) {
                              const je = { instancePath: j + "/beforeRequest/lastAccess", schemaPath: "beforeRequest.json#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: Le.properties.lastAccess, data: le };
                              U === null ? U = [je] : U.push(je), L++;
                            }
                          } else {
                            const je = { instancePath: j + "/beforeRequest/lastAccess", schemaPath: "beforeRequest.json#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.lastAccess.type, parentSchema: Le.properties.lastAccess, data: le };
                            U === null ? U = [je] : U.push(je), L++;
                          }
                        var B = he === L;
                      } else
                        var B = !0;
                      if (B) {
                        if (ve.eTag !== void 0) {
                          let le = ve.eTag;
                          const he = L;
                          if (typeof le != "string") {
                            const je = { instancePath: j + "/beforeRequest/eTag", schemaPath: "beforeRequest.json#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.eTag.type, parentSchema: Le.properties.eTag, data: le };
                            U === null ? U = [je] : U.push(je), L++;
                          }
                          var B = he === L;
                        } else
                          var B = !0;
                        if (B) {
                          if (ve.hitCount !== void 0) {
                            let le = ve.hitCount;
                            const he = L;
                            if (!(typeof le == "number" && !(le % 1) && !isNaN(le))) {
                              const je = { instancePath: j + "/beforeRequest/hitCount", schemaPath: "beforeRequest.json#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Le.properties.hitCount.type, parentSchema: Le.properties.hitCount, data: le };
                              U === null ? U = [je] : U.push(je), L++;
                            }
                            var B = he === L;
                          } else
                            var B = !0;
                          if (B)
                            if (ve.comment !== void 0) {
                              let le = ve.comment;
                              const he = L;
                              if (typeof le != "string") {
                                const je = { instancePath: j + "/beforeRequest/comment", schemaPath: "beforeRequest.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Le.properties.comment.type, parentSchema: Le.properties.comment, data: le };
                                U === null ? U = [je] : U.push(je), L++;
                              }
                              var B = he === L;
                            } else
                              var B = !0;
                        }
                      }
                    }
                  }
                } else {
                  const Ie = { instancePath: j + "/beforeRequest", schemaPath: "beforeRequest.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Le.type, parentSchema: Le, data: ve };
                  U === null ? U = [Ie] : U.push(Ie), L++;
                }
              var Q = be === L;
              if (Q && ce ? (ce = !1, ke = [ke, 1]) : Q && (ce = !0, ke = 1), ce)
                L = oe, U !== null && (oe ? U.length = oe : U = null);
              else {
                const Ie = { instancePath: j + "/beforeRequest", schemaPath: "#/properties/beforeRequest/oneOf", keyword: "oneOf", params: { passingSchemas: ke }, message: "must match exactly one schema in oneOf", schema: we.properties.beforeRequest.oneOf, parentSchema: we.properties.beforeRequest, data: ve };
                return U === null ? U = [Ie] : U.push(Ie), L++, qe.errors = U, !1;
              }
              var V = pe === L;
            } else
              var V = !0;
            if (V) {
              if (k.afterRequest !== void 0) {
                let ve = k.afterRequest;
                const pe = L, oe = L;
                let ce = !1, ke = null;
                const fe = L;
                if (ve !== null) {
                  const le = { instancePath: j + "/afterRequest", schemaPath: "#/properties/afterRequest/oneOf/0/type", keyword: "type", params: { type: "null" }, message: "must be null", schema: we.properties.afterRequest.oneOf[0].type, parentSchema: we.properties.afterRequest.oneOf[0], data: ve };
                  U === null ? U = [le] : U.push(le), L++;
                }
                var ue = fe === L;
                ue && (ce = !0, ke = 0);
                const be = L;
                if (L === L)
                  if (ve && typeof ve == "object" && !Array.isArray(ve)) {
                    let le;
                    if (ve.lastAccess === void 0 && (le = "lastAccess") || ve.eTag === void 0 && (le = "eTag") || ve.hitCount === void 0 && (le = "hitCount")) {
                      const he = { instancePath: j + "/afterRequest", schemaPath: "afterRequest.json#/required", keyword: "required", params: { missingProperty: le }, message: "must have required property '" + le + "'", schema: me.required, parentSchema: me, data: ve };
                      U === null ? U = [he] : U.push(he), L++;
                    } else {
                      if (ve.expires !== void 0) {
                        let he = ve.expires;
                        const xe = L;
                        if (L === xe)
                          if (typeof he == "string") {
                            if (!$e.test(he)) {
                              const je = { instancePath: j + "/afterRequest/expires", schemaPath: "afterRequest.json#/properties/expires/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: me.properties.expires, data: he };
                              U === null ? U = [je] : U.push(je), L++;
                            }
                          } else {
                            const je = { instancePath: j + "/afterRequest/expires", schemaPath: "afterRequest.json#/properties/expires/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.expires.type, parentSchema: me.properties.expires, data: he };
                            U === null ? U = [je] : U.push(je), L++;
                          }
                        var X = xe === L;
                      } else
                        var X = !0;
                      if (X) {
                        if (ve.lastAccess !== void 0) {
                          let he = ve.lastAccess;
                          const xe = L;
                          if (L === xe)
                            if (typeof he == "string") {
                              if (!$e.test(he)) {
                                const Oe = { instancePath: j + "/afterRequest/lastAccess", schemaPath: "afterRequest.json#/properties/lastAccess/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?", parentSchema: me.properties.lastAccess, data: he };
                                U === null ? U = [Oe] : U.push(Oe), L++;
                              }
                            } else {
                              const Oe = { instancePath: j + "/afterRequest/lastAccess", schemaPath: "afterRequest.json#/properties/lastAccess/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.lastAccess.type, parentSchema: me.properties.lastAccess, data: he };
                              U === null ? U = [Oe] : U.push(Oe), L++;
                            }
                          var X = xe === L;
                        } else
                          var X = !0;
                        if (X) {
                          if (ve.eTag !== void 0) {
                            let he = ve.eTag;
                            const xe = L;
                            if (typeof he != "string") {
                              const Oe = { instancePath: j + "/afterRequest/eTag", schemaPath: "afterRequest.json#/properties/eTag/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.eTag.type, parentSchema: me.properties.eTag, data: he };
                              U === null ? U = [Oe] : U.push(Oe), L++;
                            }
                            var X = xe === L;
                          } else
                            var X = !0;
                          if (X) {
                            if (ve.hitCount !== void 0) {
                              let he = ve.hitCount;
                              const xe = L;
                              if (!(typeof he == "number" && !(he % 1) && !isNaN(he))) {
                                const Oe = { instancePath: j + "/afterRequest/hitCount", schemaPath: "afterRequest.json#/properties/hitCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: me.properties.hitCount.type, parentSchema: me.properties.hitCount, data: he };
                                U === null ? U = [Oe] : U.push(Oe), L++;
                              }
                              var X = xe === L;
                            } else
                              var X = !0;
                            if (X)
                              if (ve.comment !== void 0) {
                                let he = ve.comment;
                                const xe = L;
                                if (typeof he != "string") {
                                  const Oe = { instancePath: j + "/afterRequest/comment", schemaPath: "afterRequest.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: me.properties.comment.type, parentSchema: me.properties.comment, data: he };
                                  U === null ? U = [Oe] : U.push(Oe), L++;
                                }
                                var X = xe === L;
                              } else
                                var X = !0;
                          }
                        }
                      }
                    }
                  } else {
                    const le = { instancePath: j + "/afterRequest", schemaPath: "afterRequest.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: me.type, parentSchema: me, data: ve };
                    U === null ? U = [le] : U.push(le), L++;
                  }
                var ue = be === L;
                if (ue && ce ? (ce = !1, ke = [ke, 1]) : ue && (ce = !0, ke = 1), ce)
                  L = oe, U !== null && (oe ? U.length = oe : U = null);
                else {
                  const le = { instancePath: j + "/afterRequest", schemaPath: "#/properties/afterRequest/oneOf", keyword: "oneOf", params: { passingSchemas: ke }, message: "must match exactly one schema in oneOf", schema: we.properties.afterRequest.oneOf, parentSchema: we.properties.afterRequest, data: ve };
                  return U === null ? U = [le] : U.push(le), L++, qe.errors = U, !1;
                }
                var V = pe === L;
              } else
                var V = !0;
              if (V)
                if (k.comment !== void 0) {
                  let ve = k.comment;
                  const pe = L;
                  if (typeof ve != "string")
                    return qe.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: we.properties.comment.type, parentSchema: we.properties.comment, data: ve }], !1;
                  var V = pe === L;
                } else
                  var V = !0;
            }
          }
          return qe.errors = U, L === 0;
        }
        ie["content.json"] = It;
        var Ge = { $id: "content.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["size", "mimeType"], properties: { size: { type: "integer" }, compression: { type: "integer" }, mimeType: { type: "string" }, text: { type: "string" }, encoding: { type: "string" }, comment: { type: "string" } } };
        function It(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.size === void 0 && (Q = "size") || k.mimeType === void 0 && (Q = "mimeType"))
              return It.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: Ge.required, parentSchema: Ge, data: k }], !1;
            if (k.size !== void 0) {
              let V = k.size;
              const X = L;
              if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                return It.errors = [{ instancePath: j + "/size", schemaPath: "#/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ge.properties.size.type, parentSchema: Ge.properties.size, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.compression !== void 0) {
                let V = k.compression;
                const X = L;
                if (!(typeof V == "number" && !(V % 1) && !isNaN(V)))
                  return It.errors = [{ instancePath: j + "/compression", schemaPath: "#/properties/compression/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ge.properties.compression.type, parentSchema: Ge.properties.compression, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B) {
                if (k.mimeType !== void 0) {
                  let V = k.mimeType;
                  const X = L;
                  if (typeof V != "string")
                    return It.errors = [{ instancePath: j + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.mimeType.type, parentSchema: Ge.properties.mimeType, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.text !== void 0) {
                    let V = k.text;
                    const X = L;
                    if (typeof V != "string")
                      return It.errors = [{ instancePath: j + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.text.type, parentSchema: Ge.properties.text, data: V }], !1;
                    var B = X === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.encoding !== void 0) {
                      let V = k.encoding;
                      const X = L;
                      if (typeof V != "string")
                        return It.errors = [{ instancePath: j + "/encoding", schemaPath: "#/properties/encoding/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.encoding.type, parentSchema: Ge.properties.encoding, data: V }], !1;
                      var B = X === L;
                    } else
                      var B = !0;
                    if (B)
                      if (k.comment !== void 0) {
                        let V = k.comment;
                        const X = L;
                        if (typeof V != "string")
                          return It.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.comment.type, parentSchema: Ge.properties.comment, data: V }], !1;
                        var B = X === L;
                      } else
                        var B = !0;
                  }
                }
              }
            }
          } else
            return It.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ge.type, parentSchema: Ge, data: k }], !1;
          return It.errors = U, L === 0;
        }
        ie["cookie.json"] = We;
        var Qe = { $id: "cookie.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "value"], properties: { name: { type: "string" }, value: { type: "string" }, path: { type: "string" }, domain: { type: "string" }, expires: { type: ["string", "null"], format: "date-time" }, httpOnly: { type: "boolean" }, secure: { type: "boolean" }, comment: { type: "string" } } }, jt = T().fullFormats["date-time"];
        function We(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.name === void 0 && (Q = "name") || k.value === void 0 && (Q = "value"))
              return We.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: Qe.required, parentSchema: Qe, data: k }], !1;
            if (k.name !== void 0) {
              let V = k.name;
              const X = L;
              if (typeof V != "string")
                return We.errors = [{ instancePath: j + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.name.type, parentSchema: Qe.properties.name, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.value !== void 0) {
                let V = k.value;
                const X = L;
                if (typeof V != "string")
                  return We.errors = [{ instancePath: j + "/value", schemaPath: "#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.value.type, parentSchema: Qe.properties.value, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B) {
                if (k.path !== void 0) {
                  let V = k.path;
                  const X = L;
                  if (typeof V != "string")
                    return We.errors = [{ instancePath: j + "/path", schemaPath: "#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.path.type, parentSchema: Qe.properties.path, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.domain !== void 0) {
                    let V = k.domain;
                    const X = L;
                    if (typeof V != "string")
                      return We.errors = [{ instancePath: j + "/domain", schemaPath: "#/properties/domain/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.domain.type, parentSchema: Qe.properties.domain, data: V }], !1;
                    var B = X === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.expires !== void 0) {
                      let V = k.expires;
                      const X = L;
                      if (typeof V != "string" && V !== null)
                        return We.errors = [{ instancePath: j + "/expires", schemaPath: "#/properties/expires/type", keyword: "type", params: { type: Qe.properties.expires.type }, message: "must be string,null", schema: Qe.properties.expires.type, parentSchema: Qe.properties.expires, data: V }], !1;
                      if (typeof V == "string" && !jt.validate(V))
                        return We.errors = [{ instancePath: j + "/expires", schemaPath: "#/properties/expires/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Qe.properties.expires, data: V }], !1;
                      var B = X === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (k.httpOnly !== void 0) {
                        let V = k.httpOnly;
                        const X = L;
                        if (typeof V != "boolean")
                          return We.errors = [{ instancePath: j + "/httpOnly", schemaPath: "#/properties/httpOnly/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Qe.properties.httpOnly.type, parentSchema: Qe.properties.httpOnly, data: V }], !1;
                        var B = X === L;
                      } else
                        var B = !0;
                      if (B) {
                        if (k.secure !== void 0) {
                          let V = k.secure;
                          const X = L;
                          if (typeof V != "boolean")
                            return We.errors = [{ instancePath: j + "/secure", schemaPath: "#/properties/secure/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Qe.properties.secure.type, parentSchema: Qe.properties.secure, data: V }], !1;
                          var B = X === L;
                        } else
                          var B = !0;
                        if (B)
                          if (k.comment !== void 0) {
                            let V = k.comment;
                            const X = L;
                            if (typeof V != "string")
                              return We.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.comment.type, parentSchema: Qe.properties.comment, data: V }], !1;
                            var B = X === L;
                          } else
                            var B = !0;
                      }
                    }
                  }
                }
              }
            }
          } else
            return We.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Qe.type, parentSchema: Qe, data: k }], !1;
          return We.errors = U, L === 0;
        }
        ie["creator.json"] = Fe;
        var Lt = { $id: "creator.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "version"], properties: { name: { type: "string" }, version: { type: "string" }, comment: { type: "string" } } };
        function Fe(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.name === void 0 && (Q = "name") || k.version === void 0 && (Q = "version"))
              return Fe.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: Lt.required, parentSchema: Lt, data: k }], !1;
            if (k.name !== void 0) {
              let V = k.name;
              const X = L;
              if (typeof V != "string")
                return Fe.errors = [{ instancePath: j + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Lt.properties.name.type, parentSchema: Lt.properties.name, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.version !== void 0) {
                let V = k.version;
                const X = L;
                if (typeof V != "string")
                  return Fe.errors = [{ instancePath: j + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Lt.properties.version.type, parentSchema: Lt.properties.version, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B)
                if (k.comment !== void 0) {
                  let V = k.comment;
                  const X = L;
                  if (typeof V != "string")
                    return Fe.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Lt.properties.comment.type, parentSchema: Lt.properties.comment, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
            }
          } else
            return Fe.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Lt.type, parentSchema: Lt, data: k }], !1;
          return Fe.errors = U, L === 0;
        }
        ie["entry.json"] = Ke;
        var Ze = { $id: "entry.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["startedDateTime", "time", "request", "response", "cache", "timings"], properties: { pageref: { type: "string" }, startedDateTime: { type: "string", format: "date-time", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, time: { type: "number", min: 0 }, request: { $ref: "request.json#" }, response: { $ref: "response.json#" }, cache: { $ref: "cache.json#" }, timings: { $ref: "timings.json#" }, serverIPAddress: { type: "string", oneOf: [{ format: "ipv4" }, { format: "ipv6" }] }, connection: { type: "string" }, comment: { type: "string" } } }, Ue = { $id: "timings.json#", $schema: "http://json-schema.org/draft-06/schema#", required: ["send", "wait", "receive"], properties: { dns: { type: "number", min: -1 }, connect: { type: "number", min: -1 }, blocked: { type: "number", min: -1 }, send: { type: "number", min: -1 }, wait: { type: "number", min: -1 }, receive: { type: "number", min: -1 }, ssl: { type: "number", min: -1 }, comment: { type: "string" } } }, Rt = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, Vr = /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i, ye = new RegExp("^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))", "u"), G = { $id: "request.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["method", "url", "httpVersion", "cookies", "headers", "queryString", "headersSize", "bodySize"], properties: { method: { type: "string" }, url: { type: "string", format: "uri" }, httpVersion: { type: "string" }, cookies: { type: "array", items: { $ref: "cookie.json#" } }, headers: { type: "array", items: { $ref: "header.json#" } }, queryString: { type: "array", items: { $ref: "query.json#" } }, postData: { $ref: "postData.json#" }, headersSize: { type: "integer" }, bodySize: { type: "integer" }, comment: { type: "string" } } }, Y = { $id: "header.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "value"], properties: { name: { type: "string" }, value: { type: "string" }, comment: { type: "string" } } }, ae = { $id: "query.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["name", "value"], properties: { name: { type: "string" }, value: { type: "string" }, comment: { type: "string" } } }, Ee = { $id: "postData.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["mimeType"], properties: { mimeType: { type: "string" }, text: { type: "string" }, params: { type: "array", required: ["name"], properties: { name: { type: "string" }, value: { type: "string" }, fileName: { type: "string" }, contentType: { type: "string" }, comment: { type: "string" } } }, comment: { type: "string" } } }, N = T().fullFormats.uri;
        function Se(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let ke;
            if (k.method === void 0 && (ke = "method") || k.url === void 0 && (ke = "url") || k.httpVersion === void 0 && (ke = "httpVersion") || k.cookies === void 0 && (ke = "cookies") || k.headers === void 0 && (ke = "headers") || k.queryString === void 0 && (ke = "queryString") || k.headersSize === void 0 && (ke = "headersSize") || k.bodySize === void 0 && (ke = "bodySize"))
              return Se.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: ke }, message: "must have required property '" + ke + "'", schema: G.required, parentSchema: G, data: k }], !1;
            if (k.method !== void 0) {
              let fe = k.method;
              const be = L;
              if (typeof fe != "string")
                return Se.errors = [{ instancePath: j + "/method", schemaPath: "#/properties/method/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: G.properties.method.type, parentSchema: G.properties.method, data: fe }], !1;
              var B = be === L;
            } else
              var B = !0;
            if (B) {
              if (k.url !== void 0) {
                let fe = k.url;
                const be = L;
                if (typeof fe == "string") {
                  if (!N(fe))
                    return Se.errors = [{ instancePath: j + "/url", schemaPath: "#/properties/url/format", keyword: "format", params: { format: "uri" }, message: 'must match format "uri"', schema: "uri", parentSchema: G.properties.url, data: fe }], !1;
                } else
                  return Se.errors = [{ instancePath: j + "/url", schemaPath: "#/properties/url/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: G.properties.url.type, parentSchema: G.properties.url, data: fe }], !1;
                var B = be === L;
              } else
                var B = !0;
              if (B) {
                if (k.httpVersion !== void 0) {
                  let fe = k.httpVersion;
                  const be = L;
                  if (typeof fe != "string")
                    return Se.errors = [{ instancePath: j + "/httpVersion", schemaPath: "#/properties/httpVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: G.properties.httpVersion.type, parentSchema: G.properties.httpVersion, data: fe }], !1;
                  var B = be === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.cookies !== void 0) {
                    let fe = k.cookies;
                    const be = L;
                    if (Array.isArray(fe)) {
                      var Q = !0;
                      const Ie = fe.length;
                      for (let le = 0; le < Ie; le++) {
                        let he = fe[le];
                        const xe = L;
                        if (he && typeof he == "object" && !Array.isArray(he)) {
                          let Oe;
                          if (he.name === void 0 && (Oe = "name") || he.value === void 0 && (Oe = "value"))
                            return Se.errors = [{ instancePath: j + "/cookies/" + le, schemaPath: "cookie.json#/required", keyword: "required", params: { missingProperty: Oe }, message: "must have required property '" + Oe + "'", schema: Qe.required, parentSchema: Qe, data: he }], !1;
                          if (he.name !== void 0) {
                            let De = he.name;
                            const ze = L;
                            if (typeof De != "string")
                              return Se.errors = [{ instancePath: j + "/cookies/" + le + "/name", schemaPath: "cookie.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.name.type, parentSchema: Qe.properties.name, data: De }], !1;
                            var V = ze === L;
                          } else
                            var V = !0;
                          if (V) {
                            if (he.value !== void 0) {
                              let De = he.value;
                              const ze = L;
                              if (typeof De != "string")
                                return Se.errors = [{ instancePath: j + "/cookies/" + le + "/value", schemaPath: "cookie.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.value.type, parentSchema: Qe.properties.value, data: De }], !1;
                              var V = ze === L;
                            } else
                              var V = !0;
                            if (V) {
                              if (he.path !== void 0) {
                                let De = he.path;
                                const ze = L;
                                if (typeof De != "string")
                                  return Se.errors = [{ instancePath: j + "/cookies/" + le + "/path", schemaPath: "cookie.json#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.path.type, parentSchema: Qe.properties.path, data: De }], !1;
                                var V = ze === L;
                              } else
                                var V = !0;
                              if (V) {
                                if (he.domain !== void 0) {
                                  let De = he.domain;
                                  const ze = L;
                                  if (typeof De != "string")
                                    return Se.errors = [{ instancePath: j + "/cookies/" + le + "/domain", schemaPath: "cookie.json#/properties/domain/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.domain.type, parentSchema: Qe.properties.domain, data: De }], !1;
                                  var V = ze === L;
                                } else
                                  var V = !0;
                                if (V) {
                                  if (he.expires !== void 0) {
                                    let De = he.expires;
                                    const ze = L;
                                    if (typeof De != "string" && De !== null)
                                      return Se.errors = [{ instancePath: j + "/cookies/" + le + "/expires", schemaPath: "cookie.json#/properties/expires/type", keyword: "type", params: { type: Qe.properties.expires.type }, message: "must be string,null", schema: Qe.properties.expires.type, parentSchema: Qe.properties.expires, data: De }], !1;
                                    if (typeof De == "string" && !jt.validate(De))
                                      return Se.errors = [{ instancePath: j + "/cookies/" + le + "/expires", schemaPath: "cookie.json#/properties/expires/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Qe.properties.expires, data: De }], !1;
                                    var V = ze === L;
                                  } else
                                    var V = !0;
                                  if (V) {
                                    if (he.httpOnly !== void 0) {
                                      let De = he.httpOnly;
                                      const ze = L;
                                      if (typeof De != "boolean")
                                        return Se.errors = [{ instancePath: j + "/cookies/" + le + "/httpOnly", schemaPath: "cookie.json#/properties/httpOnly/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Qe.properties.httpOnly.type, parentSchema: Qe.properties.httpOnly, data: De }], !1;
                                      var V = ze === L;
                                    } else
                                      var V = !0;
                                    if (V) {
                                      if (he.secure !== void 0) {
                                        let De = he.secure;
                                        const ze = L;
                                        if (typeof De != "boolean")
                                          return Se.errors = [{ instancePath: j + "/cookies/" + le + "/secure", schemaPath: "cookie.json#/properties/secure/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Qe.properties.secure.type, parentSchema: Qe.properties.secure, data: De }], !1;
                                        var V = ze === L;
                                      } else
                                        var V = !0;
                                      if (V)
                                        if (he.comment !== void 0) {
                                          let De = he.comment;
                                          const ze = L;
                                          if (typeof De != "string")
                                            return Se.errors = [{ instancePath: j + "/cookies/" + le + "/comment", schemaPath: "cookie.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.comment.type, parentSchema: Qe.properties.comment, data: De }], !1;
                                          var V = ze === L;
                                        } else
                                          var V = !0;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else
                          return Se.errors = [{ instancePath: j + "/cookies/" + le, schemaPath: "cookie.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Qe.type, parentSchema: Qe, data: he }], !1;
                        var Q = xe === L;
                        if (!Q)
                          break;
                      }
                    } else
                      return Se.errors = [{ instancePath: j + "/cookies", schemaPath: "#/properties/cookies/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: G.properties.cookies.type, parentSchema: G.properties.cookies, data: fe }], !1;
                    var B = be === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.headers !== void 0) {
                      let fe = k.headers;
                      const be = L;
                      if (Array.isArray(fe)) {
                        var X = !0;
                        const Ie = fe.length;
                        for (let le = 0; le < Ie; le++) {
                          let he = fe[le];
                          const xe = L;
                          if (he && typeof he == "object" && !Array.isArray(he)) {
                            let Oe;
                            if (he.name === void 0 && (Oe = "name") || he.value === void 0 && (Oe = "value"))
                              return Se.errors = [{ instancePath: j + "/headers/" + le, schemaPath: "header.json#/required", keyword: "required", params: { missingProperty: Oe }, message: "must have required property '" + Oe + "'", schema: Y.required, parentSchema: Y, data: he }], !1;
                            if (he.name !== void 0) {
                              let De = he.name;
                              const ze = L;
                              if (typeof De != "string")
                                return Se.errors = [{ instancePath: j + "/headers/" + le + "/name", schemaPath: "header.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.name.type, parentSchema: Y.properties.name, data: De }], !1;
                              var ue = ze === L;
                            } else
                              var ue = !0;
                            if (ue) {
                              if (he.value !== void 0) {
                                let De = he.value;
                                const ze = L;
                                if (typeof De != "string")
                                  return Se.errors = [{ instancePath: j + "/headers/" + le + "/value", schemaPath: "header.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.value.type, parentSchema: Y.properties.value, data: De }], !1;
                                var ue = ze === L;
                              } else
                                var ue = !0;
                              if (ue)
                                if (he.comment !== void 0) {
                                  let De = he.comment;
                                  const ze = L;
                                  if (typeof De != "string")
                                    return Se.errors = [{ instancePath: j + "/headers/" + le + "/comment", schemaPath: "header.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.comment.type, parentSchema: Y.properties.comment, data: De }], !1;
                                  var ue = ze === L;
                                } else
                                  var ue = !0;
                            }
                          } else
                            return Se.errors = [{ instancePath: j + "/headers/" + le, schemaPath: "header.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Y.type, parentSchema: Y, data: he }], !1;
                          var X = xe === L;
                          if (!X)
                            break;
                        }
                      } else
                        return Se.errors = [{ instancePath: j + "/headers", schemaPath: "#/properties/headers/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: G.properties.headers.type, parentSchema: G.properties.headers, data: fe }], !1;
                      var B = be === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (k.queryString !== void 0) {
                        let fe = k.queryString;
                        const be = L;
                        if (Array.isArray(fe)) {
                          var ve = !0;
                          const Ie = fe.length;
                          for (let le = 0; le < Ie; le++) {
                            let he = fe[le];
                            const xe = L;
                            if (he && typeof he == "object" && !Array.isArray(he)) {
                              let Oe;
                              if (he.name === void 0 && (Oe = "name") || he.value === void 0 && (Oe = "value"))
                                return Se.errors = [{ instancePath: j + "/queryString/" + le, schemaPath: "query.json#/required", keyword: "required", params: { missingProperty: Oe }, message: "must have required property '" + Oe + "'", schema: ae.required, parentSchema: ae, data: he }], !1;
                              if (he.name !== void 0) {
                                let De = he.name;
                                const ze = L;
                                if (typeof De != "string")
                                  return Se.errors = [{ instancePath: j + "/queryString/" + le + "/name", schemaPath: "query.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ae.properties.name.type, parentSchema: ae.properties.name, data: De }], !1;
                                var pe = ze === L;
                              } else
                                var pe = !0;
                              if (pe) {
                                if (he.value !== void 0) {
                                  let De = he.value;
                                  const ze = L;
                                  if (typeof De != "string")
                                    return Se.errors = [{ instancePath: j + "/queryString/" + le + "/value", schemaPath: "query.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ae.properties.value.type, parentSchema: ae.properties.value, data: De }], !1;
                                  var pe = ze === L;
                                } else
                                  var pe = !0;
                                if (pe)
                                  if (he.comment !== void 0) {
                                    let De = he.comment;
                                    const ze = L;
                                    if (typeof De != "string")
                                      return Se.errors = [{ instancePath: j + "/queryString/" + le + "/comment", schemaPath: "query.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ae.properties.comment.type, parentSchema: ae.properties.comment, data: De }], !1;
                                    var pe = ze === L;
                                  } else
                                    var pe = !0;
                              }
                            } else
                              return Se.errors = [{ instancePath: j + "/queryString/" + le, schemaPath: "query.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: ae.type, parentSchema: ae, data: he }], !1;
                            var ve = xe === L;
                            if (!ve)
                              break;
                          }
                        } else
                          return Se.errors = [{ instancePath: j + "/queryString", schemaPath: "#/properties/queryString/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: G.properties.queryString.type, parentSchema: G.properties.queryString, data: fe }], !1;
                        var B = be === L;
                      } else
                        var B = !0;
                      if (B) {
                        if (k.postData !== void 0) {
                          let fe = k.postData;
                          const be = L;
                          if (fe && typeof fe == "object" && !Array.isArray(fe)) {
                            let Ie;
                            if (fe.mimeType === void 0 && (Ie = "mimeType"))
                              return Se.errors = [{ instancePath: j + "/postData", schemaPath: "postData.json#/required", keyword: "required", params: { missingProperty: Ie }, message: "must have required property '" + Ie + "'", schema: Ee.required, parentSchema: Ee, data: fe }], !1;
                            if (fe.mimeType !== void 0) {
                              let le = fe.mimeType;
                              const he = L;
                              if (typeof le != "string")
                                return Se.errors = [{ instancePath: j + "/postData/mimeType", schemaPath: "postData.json#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.mimeType.type, parentSchema: Ee.properties.mimeType, data: le }], !1;
                              var oe = he === L;
                            } else
                              var oe = !0;
                            if (oe) {
                              if (fe.text !== void 0) {
                                let le = fe.text;
                                const he = L;
                                if (typeof le != "string")
                                  return Se.errors = [{ instancePath: j + "/postData/text", schemaPath: "postData.json#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.text.type, parentSchema: Ee.properties.text, data: le }], !1;
                                var oe = he === L;
                              } else
                                var oe = !0;
                              if (oe) {
                                if (fe.params !== void 0) {
                                  let le = fe.params;
                                  const he = L;
                                  if (!Array.isArray(le))
                                    return Se.errors = [{ instancePath: j + "/postData/params", schemaPath: "postData.json#/properties/params/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Ee.properties.params.type, parentSchema: Ee.properties.params, data: le }], !1;
                                  if (le && typeof le == "object" && !Array.isArray(le)) {
                                    let je;
                                    if (le.name === void 0 && (je = "name"))
                                      return Se.errors = [{ instancePath: j + "/postData/params", schemaPath: "postData.json#/properties/params/required", keyword: "required", params: { missingProperty: je }, message: "must have required property '" + je + "'", schema: Ee.properties.params.required, parentSchema: Ee.properties.params, data: le }], !1;
                                    if (le.name !== void 0) {
                                      let Oe = le.name;
                                      const De = L;
                                      if (typeof Oe != "string")
                                        return Se.errors = [{ instancePath: j + "/postData/params/name", schemaPath: "postData.json#/properties/params/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.name.type, parentSchema: Ee.properties.params.properties.name, data: Oe }], !1;
                                      var ce = De === L;
                                    } else
                                      var ce = !0;
                                    if (ce) {
                                      if (le.value !== void 0) {
                                        let Oe = le.value;
                                        const De = L;
                                        if (typeof Oe != "string")
                                          return Se.errors = [{ instancePath: j + "/postData/params/value", schemaPath: "postData.json#/properties/params/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.value.type, parentSchema: Ee.properties.params.properties.value, data: Oe }], !1;
                                        var ce = De === L;
                                      } else
                                        var ce = !0;
                                      if (ce) {
                                        if (le.fileName !== void 0) {
                                          let Oe = le.fileName;
                                          const De = L;
                                          if (typeof Oe != "string")
                                            return Se.errors = [{ instancePath: j + "/postData/params/fileName", schemaPath: "postData.json#/properties/params/properties/fileName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.fileName.type, parentSchema: Ee.properties.params.properties.fileName, data: Oe }], !1;
                                          var ce = De === L;
                                        } else
                                          var ce = !0;
                                        if (ce) {
                                          if (le.contentType !== void 0) {
                                            let Oe = le.contentType;
                                            const De = L;
                                            if (typeof Oe != "string")
                                              return Se.errors = [{ instancePath: j + "/postData/params/contentType", schemaPath: "postData.json#/properties/params/properties/contentType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.contentType.type, parentSchema: Ee.properties.params.properties.contentType, data: Oe }], !1;
                                            var ce = De === L;
                                          } else
                                            var ce = !0;
                                          if (ce)
                                            if (le.comment !== void 0) {
                                              let Oe = le.comment;
                                              const De = L;
                                              if (typeof Oe != "string")
                                                return Se.errors = [{ instancePath: j + "/postData/params/comment", schemaPath: "postData.json#/properties/params/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.comment.type, parentSchema: Ee.properties.params.properties.comment, data: Oe }], !1;
                                              var ce = De === L;
                                            } else
                                              var ce = !0;
                                        }
                                      }
                                    }
                                  }
                                  var oe = he === L;
                                } else
                                  var oe = !0;
                                if (oe)
                                  if (fe.comment !== void 0) {
                                    let le = fe.comment;
                                    const he = L;
                                    if (typeof le != "string")
                                      return Se.errors = [{ instancePath: j + "/postData/comment", schemaPath: "postData.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.comment.type, parentSchema: Ee.properties.comment, data: le }], !1;
                                    var oe = he === L;
                                  } else
                                    var oe = !0;
                              }
                            }
                          } else
                            return Se.errors = [{ instancePath: j + "/postData", schemaPath: "postData.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ee.type, parentSchema: Ee, data: fe }], !1;
                          var B = be === L;
                        } else
                          var B = !0;
                        if (B) {
                          if (k.headersSize !== void 0) {
                            let fe = k.headersSize;
                            const be = L;
                            if (!(typeof fe == "number" && !(fe % 1) && !isNaN(fe)))
                              return Se.errors = [{ instancePath: j + "/headersSize", schemaPath: "#/properties/headersSize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: G.properties.headersSize.type, parentSchema: G.properties.headersSize, data: fe }], !1;
                            var B = be === L;
                          } else
                            var B = !0;
                          if (B) {
                            if (k.bodySize !== void 0) {
                              let fe = k.bodySize;
                              const be = L;
                              if (!(typeof fe == "number" && !(fe % 1) && !isNaN(fe)))
                                return Se.errors = [{ instancePath: j + "/bodySize", schemaPath: "#/properties/bodySize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: G.properties.bodySize.type, parentSchema: G.properties.bodySize, data: fe }], !1;
                              var B = be === L;
                            } else
                              var B = !0;
                            if (B)
                              if (k.comment !== void 0) {
                                let fe = k.comment;
                                const be = L;
                                if (typeof fe != "string")
                                  return Se.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: G.properties.comment.type, parentSchema: G.properties.comment, data: fe }], !1;
                                var B = be === L;
                              } else
                                var B = !0;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else
            return Se.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: G.type, parentSchema: G, data: k }], !1;
          return Se.errors = U, L === 0;
        }
        var Me = { $id: "response.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["status", "statusText", "httpVersion", "cookies", "headers", "content", "redirectURL", "headersSize", "bodySize"], properties: { status: { type: "integer" }, statusText: { type: "string" }, httpVersion: { type: "string" }, cookies: { type: "array", items: { $ref: "cookie.json#" } }, headers: { type: "array", items: { $ref: "header.json#" } }, content: { $ref: "content.json#" }, redirectURL: { type: "string" }, headersSize: { type: "integer" }, bodySize: { type: "integer" }, comment: { type: "string" } } };
        function Xe(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let pe;
            if (k.status === void 0 && (pe = "status") || k.statusText === void 0 && (pe = "statusText") || k.httpVersion === void 0 && (pe = "httpVersion") || k.cookies === void 0 && (pe = "cookies") || k.headers === void 0 && (pe = "headers") || k.content === void 0 && (pe = "content") || k.redirectURL === void 0 && (pe = "redirectURL") || k.headersSize === void 0 && (pe = "headersSize") || k.bodySize === void 0 && (pe = "bodySize"))
              return Xe.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: pe }, message: "must have required property '" + pe + "'", schema: Me.required, parentSchema: Me, data: k }], !1;
            if (k.status !== void 0) {
              let oe = k.status;
              const ce = L;
              if (!(typeof oe == "number" && !(oe % 1) && !isNaN(oe)))
                return Xe.errors = [{ instancePath: j + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Me.properties.status.type, parentSchema: Me.properties.status, data: oe }], !1;
              var B = ce === L;
            } else
              var B = !0;
            if (B) {
              if (k.statusText !== void 0) {
                let oe = k.statusText;
                const ce = L;
                if (typeof oe != "string")
                  return Xe.errors = [{ instancePath: j + "/statusText", schemaPath: "#/properties/statusText/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.statusText.type, parentSchema: Me.properties.statusText, data: oe }], !1;
                var B = ce === L;
              } else
                var B = !0;
              if (B) {
                if (k.httpVersion !== void 0) {
                  let oe = k.httpVersion;
                  const ce = L;
                  if (typeof oe != "string")
                    return Xe.errors = [{ instancePath: j + "/httpVersion", schemaPath: "#/properties/httpVersion/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.httpVersion.type, parentSchema: Me.properties.httpVersion, data: oe }], !1;
                  var B = ce === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.cookies !== void 0) {
                    let oe = k.cookies;
                    const ce = L;
                    if (Array.isArray(oe)) {
                      var Q = !0;
                      const fe = oe.length;
                      for (let be = 0; be < fe; be++) {
                        let ge = oe[be];
                        const Ie = L;
                        if (ge && typeof ge == "object" && !Array.isArray(ge)) {
                          let he;
                          if (ge.name === void 0 && (he = "name") || ge.value === void 0 && (he = "value"))
                            return Xe.errors = [{ instancePath: j + "/cookies/" + be, schemaPath: "cookie.json#/required", keyword: "required", params: { missingProperty: he }, message: "must have required property '" + he + "'", schema: Qe.required, parentSchema: Qe, data: ge }], !1;
                          if (ge.name !== void 0) {
                            let xe = ge.name;
                            const je = L;
                            if (typeof xe != "string")
                              return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/name", schemaPath: "cookie.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.name.type, parentSchema: Qe.properties.name, data: xe }], !1;
                            var V = je === L;
                          } else
                            var V = !0;
                          if (V) {
                            if (ge.value !== void 0) {
                              let xe = ge.value;
                              const je = L;
                              if (typeof xe != "string")
                                return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/value", schemaPath: "cookie.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.value.type, parentSchema: Qe.properties.value, data: xe }], !1;
                              var V = je === L;
                            } else
                              var V = !0;
                            if (V) {
                              if (ge.path !== void 0) {
                                let xe = ge.path;
                                const je = L;
                                if (typeof xe != "string")
                                  return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/path", schemaPath: "cookie.json#/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.path.type, parentSchema: Qe.properties.path, data: xe }], !1;
                                var V = je === L;
                              } else
                                var V = !0;
                              if (V) {
                                if (ge.domain !== void 0) {
                                  let xe = ge.domain;
                                  const je = L;
                                  if (typeof xe != "string")
                                    return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/domain", schemaPath: "cookie.json#/properties/domain/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.domain.type, parentSchema: Qe.properties.domain, data: xe }], !1;
                                  var V = je === L;
                                } else
                                  var V = !0;
                                if (V) {
                                  if (ge.expires !== void 0) {
                                    let xe = ge.expires;
                                    const je = L;
                                    if (typeof xe != "string" && xe !== null)
                                      return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/expires", schemaPath: "cookie.json#/properties/expires/type", keyword: "type", params: { type: Qe.properties.expires.type }, message: "must be string,null", schema: Qe.properties.expires.type, parentSchema: Qe.properties.expires, data: xe }], !1;
                                    if (typeof xe == "string" && !jt.validate(xe))
                                      return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/expires", schemaPath: "cookie.json#/properties/expires/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Qe.properties.expires, data: xe }], !1;
                                    var V = je === L;
                                  } else
                                    var V = !0;
                                  if (V) {
                                    if (ge.httpOnly !== void 0) {
                                      let xe = ge.httpOnly;
                                      const je = L;
                                      if (typeof xe != "boolean")
                                        return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/httpOnly", schemaPath: "cookie.json#/properties/httpOnly/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Qe.properties.httpOnly.type, parentSchema: Qe.properties.httpOnly, data: xe }], !1;
                                      var V = je === L;
                                    } else
                                      var V = !0;
                                    if (V) {
                                      if (ge.secure !== void 0) {
                                        let xe = ge.secure;
                                        const je = L;
                                        if (typeof xe != "boolean")
                                          return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/secure", schemaPath: "cookie.json#/properties/secure/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: Qe.properties.secure.type, parentSchema: Qe.properties.secure, data: xe }], !1;
                                        var V = je === L;
                                      } else
                                        var V = !0;
                                      if (V)
                                        if (ge.comment !== void 0) {
                                          let xe = ge.comment;
                                          const je = L;
                                          if (typeof xe != "string")
                                            return Xe.errors = [{ instancePath: j + "/cookies/" + be + "/comment", schemaPath: "cookie.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Qe.properties.comment.type, parentSchema: Qe.properties.comment, data: xe }], !1;
                                          var V = je === L;
                                        } else
                                          var V = !0;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else
                          return Xe.errors = [{ instancePath: j + "/cookies/" + be, schemaPath: "cookie.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Qe.type, parentSchema: Qe, data: ge }], !1;
                        var Q = Ie === L;
                        if (!Q)
                          break;
                      }
                    } else
                      return Xe.errors = [{ instancePath: j + "/cookies", schemaPath: "#/properties/cookies/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Me.properties.cookies.type, parentSchema: Me.properties.cookies, data: oe }], !1;
                    var B = ce === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.headers !== void 0) {
                      let oe = k.headers;
                      const ce = L;
                      if (Array.isArray(oe)) {
                        var X = !0;
                        const fe = oe.length;
                        for (let be = 0; be < fe; be++) {
                          let ge = oe[be];
                          const Ie = L;
                          if (ge && typeof ge == "object" && !Array.isArray(ge)) {
                            let he;
                            if (ge.name === void 0 && (he = "name") || ge.value === void 0 && (he = "value"))
                              return Xe.errors = [{ instancePath: j + "/headers/" + be, schemaPath: "header.json#/required", keyword: "required", params: { missingProperty: he }, message: "must have required property '" + he + "'", schema: Y.required, parentSchema: Y, data: ge }], !1;
                            if (ge.name !== void 0) {
                              let xe = ge.name;
                              const je = L;
                              if (typeof xe != "string")
                                return Xe.errors = [{ instancePath: j + "/headers/" + be + "/name", schemaPath: "header.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.name.type, parentSchema: Y.properties.name, data: xe }], !1;
                              var ue = je === L;
                            } else
                              var ue = !0;
                            if (ue) {
                              if (ge.value !== void 0) {
                                let xe = ge.value;
                                const je = L;
                                if (typeof xe != "string")
                                  return Xe.errors = [{ instancePath: j + "/headers/" + be + "/value", schemaPath: "header.json#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.value.type, parentSchema: Y.properties.value, data: xe }], !1;
                                var ue = je === L;
                              } else
                                var ue = !0;
                              if (ue)
                                if (ge.comment !== void 0) {
                                  let xe = ge.comment;
                                  const je = L;
                                  if (typeof xe != "string")
                                    return Xe.errors = [{ instancePath: j + "/headers/" + be + "/comment", schemaPath: "header.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.comment.type, parentSchema: Y.properties.comment, data: xe }], !1;
                                  var ue = je === L;
                                } else
                                  var ue = !0;
                            }
                          } else
                            return Xe.errors = [{ instancePath: j + "/headers/" + be, schemaPath: "header.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Y.type, parentSchema: Y, data: ge }], !1;
                          var X = Ie === L;
                          if (!X)
                            break;
                        }
                      } else
                        return Xe.errors = [{ instancePath: j + "/headers", schemaPath: "#/properties/headers/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Me.properties.headers.type, parentSchema: Me.properties.headers, data: oe }], !1;
                      var B = ce === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (k.content !== void 0) {
                        let oe = k.content;
                        const ce = L;
                        if (oe && typeof oe == "object" && !Array.isArray(oe)) {
                          let fe;
                          if (oe.size === void 0 && (fe = "size") || oe.mimeType === void 0 && (fe = "mimeType"))
                            return Xe.errors = [{ instancePath: j + "/content", schemaPath: "content.json#/required", keyword: "required", params: { missingProperty: fe }, message: "must have required property '" + fe + "'", schema: Ge.required, parentSchema: Ge, data: oe }], !1;
                          if (oe.size !== void 0) {
                            let be = oe.size;
                            const ge = L;
                            if (!(typeof be == "number" && !(be % 1) && !isNaN(be)))
                              return Xe.errors = [{ instancePath: j + "/content/size", schemaPath: "content.json#/properties/size/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ge.properties.size.type, parentSchema: Ge.properties.size, data: be }], !1;
                            var ve = ge === L;
                          } else
                            var ve = !0;
                          if (ve) {
                            if (oe.compression !== void 0) {
                              let be = oe.compression;
                              const ge = L;
                              if (!(typeof be == "number" && !(be % 1) && !isNaN(be)))
                                return Xe.errors = [{ instancePath: j + "/content/compression", schemaPath: "content.json#/properties/compression/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Ge.properties.compression.type, parentSchema: Ge.properties.compression, data: be }], !1;
                              var ve = ge === L;
                            } else
                              var ve = !0;
                            if (ve) {
                              if (oe.mimeType !== void 0) {
                                let be = oe.mimeType;
                                const ge = L;
                                if (typeof be != "string")
                                  return Xe.errors = [{ instancePath: j + "/content/mimeType", schemaPath: "content.json#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.mimeType.type, parentSchema: Ge.properties.mimeType, data: be }], !1;
                                var ve = ge === L;
                              } else
                                var ve = !0;
                              if (ve) {
                                if (oe.text !== void 0) {
                                  let be = oe.text;
                                  const ge = L;
                                  if (typeof be != "string")
                                    return Xe.errors = [{ instancePath: j + "/content/text", schemaPath: "content.json#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.text.type, parentSchema: Ge.properties.text, data: be }], !1;
                                  var ve = ge === L;
                                } else
                                  var ve = !0;
                                if (ve) {
                                  if (oe.encoding !== void 0) {
                                    let be = oe.encoding;
                                    const ge = L;
                                    if (typeof be != "string")
                                      return Xe.errors = [{ instancePath: j + "/content/encoding", schemaPath: "content.json#/properties/encoding/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.encoding.type, parentSchema: Ge.properties.encoding, data: be }], !1;
                                    var ve = ge === L;
                                  } else
                                    var ve = !0;
                                  if (ve)
                                    if (oe.comment !== void 0) {
                                      let be = oe.comment;
                                      const ge = L;
                                      if (typeof be != "string")
                                        return Xe.errors = [{ instancePath: j + "/content/comment", schemaPath: "content.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ge.properties.comment.type, parentSchema: Ge.properties.comment, data: be }], !1;
                                      var ve = ge === L;
                                    } else
                                      var ve = !0;
                                }
                              }
                            }
                          }
                        } else
                          return Xe.errors = [{ instancePath: j + "/content", schemaPath: "content.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ge.type, parentSchema: Ge, data: oe }], !1;
                        var B = ce === L;
                      } else
                        var B = !0;
                      if (B) {
                        if (k.redirectURL !== void 0) {
                          let oe = k.redirectURL;
                          const ce = L;
                          if (typeof oe != "string")
                            return Xe.errors = [{ instancePath: j + "/redirectURL", schemaPath: "#/properties/redirectURL/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.redirectURL.type, parentSchema: Me.properties.redirectURL, data: oe }], !1;
                          var B = ce === L;
                        } else
                          var B = !0;
                        if (B) {
                          if (k.headersSize !== void 0) {
                            let oe = k.headersSize;
                            const ce = L;
                            if (!(typeof oe == "number" && !(oe % 1) && !isNaN(oe)))
                              return Xe.errors = [{ instancePath: j + "/headersSize", schemaPath: "#/properties/headersSize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Me.properties.headersSize.type, parentSchema: Me.properties.headersSize, data: oe }], !1;
                            var B = ce === L;
                          } else
                            var B = !0;
                          if (B) {
                            if (k.bodySize !== void 0) {
                              let oe = k.bodySize;
                              const ce = L;
                              if (!(typeof oe == "number" && !(oe % 1) && !isNaN(oe)))
                                return Xe.errors = [{ instancePath: j + "/bodySize", schemaPath: "#/properties/bodySize/type", keyword: "type", params: { type: "integer" }, message: "must be integer", schema: Me.properties.bodySize.type, parentSchema: Me.properties.bodySize, data: oe }], !1;
                              var B = ce === L;
                            } else
                              var B = !0;
                            if (B)
                              if (k.comment !== void 0) {
                                let oe = k.comment;
                                const ce = L;
                                if (typeof oe != "string")
                                  return Xe.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Me.properties.comment.type, parentSchema: Me.properties.comment, data: oe }], !1;
                                var B = ce === L;
                              } else
                                var B = !0;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else
            return Xe.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Me.type, parentSchema: Me, data: k }], !1;
          return Xe.errors = U, L === 0;
        }
        function Ke(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (L === 0)
            if (k && typeof k == "object" && !Array.isArray(k)) {
              let X;
              if (k.startedDateTime === void 0 && (X = "startedDateTime") || k.time === void 0 && (X = "time") || k.request === void 0 && (X = "request") || k.response === void 0 && (X = "response") || k.cache === void 0 && (X = "cache") || k.timings === void 0 && (X = "timings"))
                return Ke.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: X }, message: "must have required property '" + X + "'", schema: Ze.required, parentSchema: Ze, data: k }], !1;
              if (k.pageref !== void 0) {
                let ue = k.pageref;
                const ve = L;
                if (typeof ue != "string")
                  return Ke.errors = [{ instancePath: j + "/pageref", schemaPath: "#/properties/pageref/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.pageref.type, parentSchema: Ze.properties.pageref, data: ue }], !1;
                var B = ve === L;
              } else
                var B = !0;
              if (B) {
                if (k.startedDateTime !== void 0) {
                  let ue = k.startedDateTime;
                  const ve = L;
                  if (L === ve && L === ve)
                    if (typeof ue == "string")
                      if (ye.test(ue)) {
                        if (!jt.validate(ue))
                          return Ke.errors = [{ instancePath: j + "/startedDateTime", schemaPath: "#/properties/startedDateTime/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: Ze.properties.startedDateTime, data: ue }], !1;
                      } else
                        return Ke.errors = [{ instancePath: j + "/startedDateTime", schemaPath: "#/properties/startedDateTime/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))", parentSchema: Ze.properties.startedDateTime, data: ue }], !1;
                    else
                      return Ke.errors = [{ instancePath: j + "/startedDateTime", schemaPath: "#/properties/startedDateTime/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.startedDateTime.type, parentSchema: Ze.properties.startedDateTime, data: ue }], !1;
                  var B = ve === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.time !== void 0) {
                    let ue = k.time;
                    const ve = L;
                    if (typeof ue != "number")
                      return Ke.errors = [{ instancePath: j + "/time", schemaPath: "#/properties/time/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ze.properties.time.type, parentSchema: Ze.properties.time, data: ue }], !1;
                    var B = ve === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.request !== void 0) {
                      let ue = k.request;
                      const ve = L;
                      Se(ue, { instancePath: j + "/request", parentData: k, parentDataProperty: "request", rootData: J }) || (U = U === null ? Se.errors : U.concat(Se.errors), L = U.length);
                      var B = ve === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (k.response !== void 0) {
                        let ue = k.response;
                        const ve = L;
                        Xe(ue, { instancePath: j + "/response", parentData: k, parentDataProperty: "response", rootData: J }) || (U = U === null ? Xe.errors : U.concat(Xe.errors), L = U.length);
                        var B = ve === L;
                      } else
                        var B = !0;
                      if (B) {
                        if (k.cache !== void 0) {
                          let ue = k.cache;
                          const ve = L;
                          qe(ue, { instancePath: j + "/cache", parentData: k, parentDataProperty: "cache", rootData: J }) || (U = U === null ? qe.errors : U.concat(qe.errors), L = U.length);
                          var B = ve === L;
                        } else
                          var B = !0;
                        if (B) {
                          if (k.timings !== void 0) {
                            let ue = k.timings;
                            const ve = L;
                            if (ue && typeof ue == "object" && !Array.isArray(ue)) {
                              let oe;
                              if (ue.send === void 0 && (oe = "send") || ue.wait === void 0 && (oe = "wait") || ue.receive === void 0 && (oe = "receive"))
                                return Ke.errors = [{ instancePath: j + "/timings", schemaPath: "timings.json#/required", keyword: "required", params: { missingProperty: oe }, message: "must have required property '" + oe + "'", schema: Ue.required, parentSchema: Ue, data: ue }], !1;
                              if (ue.dns !== void 0) {
                                let ce = ue.dns;
                                const ke = L;
                                if (typeof ce != "number")
                                  return Ke.errors = [{ instancePath: j + "/timings/dns", schemaPath: "timings.json#/properties/dns/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.dns.type, parentSchema: Ue.properties.dns, data: ce }], !1;
                                var Q = ke === L;
                              } else
                                var Q = !0;
                              if (Q) {
                                if (ue.connect !== void 0) {
                                  let ce = ue.connect;
                                  const ke = L;
                                  if (typeof ce != "number")
                                    return Ke.errors = [{ instancePath: j + "/timings/connect", schemaPath: "timings.json#/properties/connect/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.connect.type, parentSchema: Ue.properties.connect, data: ce }], !1;
                                  var Q = ke === L;
                                } else
                                  var Q = !0;
                                if (Q) {
                                  if (ue.blocked !== void 0) {
                                    let ce = ue.blocked;
                                    const ke = L;
                                    if (typeof ce != "number")
                                      return Ke.errors = [{ instancePath: j + "/timings/blocked", schemaPath: "timings.json#/properties/blocked/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.blocked.type, parentSchema: Ue.properties.blocked, data: ce }], !1;
                                    var Q = ke === L;
                                  } else
                                    var Q = !0;
                                  if (Q) {
                                    if (ue.send !== void 0) {
                                      let ce = ue.send;
                                      const ke = L;
                                      if (typeof ce != "number")
                                        return Ke.errors = [{ instancePath: j + "/timings/send", schemaPath: "timings.json#/properties/send/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.send.type, parentSchema: Ue.properties.send, data: ce }], !1;
                                      var Q = ke === L;
                                    } else
                                      var Q = !0;
                                    if (Q) {
                                      if (ue.wait !== void 0) {
                                        let ce = ue.wait;
                                        const ke = L;
                                        if (typeof ce != "number")
                                          return Ke.errors = [{ instancePath: j + "/timings/wait", schemaPath: "timings.json#/properties/wait/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.wait.type, parentSchema: Ue.properties.wait, data: ce }], !1;
                                        var Q = ke === L;
                                      } else
                                        var Q = !0;
                                      if (Q) {
                                        if (ue.receive !== void 0) {
                                          let ce = ue.receive;
                                          const ke = L;
                                          if (typeof ce != "number")
                                            return Ke.errors = [{ instancePath: j + "/timings/receive", schemaPath: "timings.json#/properties/receive/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.receive.type, parentSchema: Ue.properties.receive, data: ce }], !1;
                                          var Q = ke === L;
                                        } else
                                          var Q = !0;
                                        if (Q) {
                                          if (ue.ssl !== void 0) {
                                            let ce = ue.ssl;
                                            const ke = L;
                                            if (typeof ce != "number")
                                              return Ke.errors = [{ instancePath: j + "/timings/ssl", schemaPath: "timings.json#/properties/ssl/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.ssl.type, parentSchema: Ue.properties.ssl, data: ce }], !1;
                                            var Q = ke === L;
                                          } else
                                            var Q = !0;
                                          if (Q)
                                            if (ue.comment !== void 0) {
                                              let ce = ue.comment;
                                              const ke = L;
                                              if (typeof ce != "string")
                                                return Ke.errors = [{ instancePath: j + "/timings/comment", schemaPath: "timings.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.comment.type, parentSchema: Ue.properties.comment, data: ce }], !1;
                                              var Q = ke === L;
                                            } else
                                              var Q = !0;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            var B = ve === L;
                          } else
                            var B = !0;
                          if (B) {
                            if (k.serverIPAddress !== void 0) {
                              let ue = k.serverIPAddress;
                              const ve = L;
                              if (typeof ue != "string")
                                return Ke.errors = [{ instancePath: j + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.serverIPAddress.type, parentSchema: Ze.properties.serverIPAddress, data: ue }], !1;
                              const pe = L;
                              let oe = !1, ce = null;
                              const ke = L;
                              if (L === ke && typeof ue == "string" && !Rt.test(ue)) {
                                const ge = { instancePath: j + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/oneOf/0/format", keyword: "format", params: { format: "ipv4" }, message: 'must match format "ipv4"', schema: "ipv4", parentSchema: Ze.properties.serverIPAddress.oneOf[0], data: ue };
                                U === null ? U = [ge] : U.push(ge), L++;
                              }
                              var V = ke === L;
                              V && (oe = !0, ce = 0);
                              const fe = L;
                              if (L === fe && typeof ue == "string" && !Vr.test(ue)) {
                                const ge = { instancePath: j + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/oneOf/1/format", keyword: "format", params: { format: "ipv6" }, message: 'must match format "ipv6"', schema: "ipv6", parentSchema: Ze.properties.serverIPAddress.oneOf[1], data: ue };
                                U === null ? U = [ge] : U.push(ge), L++;
                              }
                              var V = fe === L;
                              if (V && oe ? (oe = !1, ce = [ce, 1]) : V && (oe = !0, ce = 1), oe)
                                L = pe, U !== null && (pe ? U.length = pe : U = null);
                              else {
                                const ge = { instancePath: j + "/serverIPAddress", schemaPath: "#/properties/serverIPAddress/oneOf", keyword: "oneOf", params: { passingSchemas: ce }, message: "must match exactly one schema in oneOf", schema: Ze.properties.serverIPAddress.oneOf, parentSchema: Ze.properties.serverIPAddress, data: ue };
                                return U === null ? U = [ge] : U.push(ge), L++, Ke.errors = U, !1;
                              }
                              var B = ve === L;
                            } else
                              var B = !0;
                            if (B) {
                              if (k.connection !== void 0) {
                                let ue = k.connection;
                                const ve = L;
                                if (typeof ue != "string")
                                  return Ke.errors = [{ instancePath: j + "/connection", schemaPath: "#/properties/connection/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.connection.type, parentSchema: Ze.properties.connection, data: ue }], !1;
                                var B = ve === L;
                              } else
                                var B = !0;
                              if (B)
                                if (k.comment !== void 0) {
                                  let ue = k.comment;
                                  const ve = L;
                                  if (typeof ue != "string")
                                    return Ke.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ze.properties.comment.type, parentSchema: Ze.properties.comment, data: ue }], !1;
                                  var B = ve === L;
                                } else
                                  var B = !0;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else
              return Ke.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ze.type, parentSchema: Ze, data: k }], !1;
          return Ke.errors = U, L === 0;
        }
        ie["har.json"] = S;
        var $t = { $id: "har.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["log"], properties: { log: { $ref: "log.json#" } } }, Be = { $id: "log.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", required: ["version", "creator", "entries"], properties: { version: { type: "string" }, creator: { $ref: "creator.json#" }, browser: { $ref: "browser.json#" }, pages: { type: "array", items: { $ref: "page.json#" } }, entries: { type: "array", items: { $ref: "entry.json#" } }, comment: { type: "string" } } }, P = { $id: "page.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", optional: !0, required: ["startedDateTime", "id", "title", "pageTimings"], properties: { startedDateTime: { type: "string", format: "date-time", pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, id: { type: "string", unique: !0 }, title: { type: "string" }, pageTimings: { $ref: "pageTimings.json#" }, comment: { type: "string" } } }, M = { $id: "pageTimings.json#", $schema: "http://json-schema.org/draft-06/schema#", type: "object", properties: { onContentLoad: { type: "number", min: -1 }, onLoad: { type: "number", min: -1 }, comment: { type: "string" } } };
        function F(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let V;
            if (k.startedDateTime === void 0 && (V = "startedDateTime") || k.id === void 0 && (V = "id") || k.title === void 0 && (V = "title") || k.pageTimings === void 0 && (V = "pageTimings"))
              return F.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: V }, message: "must have required property '" + V + "'", schema: P.required, parentSchema: P, data: k }], !1;
            if (k.startedDateTime !== void 0) {
              let X = k.startedDateTime;
              const ue = L;
              if (typeof X == "string")
                if (ye.test(X)) {
                  if (!jt.validate(X))
                    return F.errors = [{ instancePath: j + "/startedDateTime", schemaPath: "#/properties/startedDateTime/format", keyword: "format", params: { format: "date-time" }, message: 'must match format "date-time"', schema: "date-time", parentSchema: P.properties.startedDateTime, data: X }], !1;
                } else
                  return F.errors = [{ instancePath: j + "/startedDateTime", schemaPath: "#/properties/startedDateTime/pattern", keyword: "pattern", params: { pattern: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))" }, message: 'must match pattern "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"', schema: "^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))", parentSchema: P.properties.startedDateTime, data: X }], !1;
              else
                return F.errors = [{ instancePath: j + "/startedDateTime", schemaPath: "#/properties/startedDateTime/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.startedDateTime.type, parentSchema: P.properties.startedDateTime, data: X }], !1;
              var B = ue === L;
            } else
              var B = !0;
            if (B) {
              if (k.id !== void 0) {
                let X = k.id;
                const ue = L;
                if (typeof X != "string")
                  return F.errors = [{ instancePath: j + "/id", schemaPath: "#/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.id.type, parentSchema: P.properties.id, data: X }], !1;
                var B = ue === L;
              } else
                var B = !0;
              if (B) {
                if (k.title !== void 0) {
                  let X = k.title;
                  const ue = L;
                  if (typeof X != "string")
                    return F.errors = [{ instancePath: j + "/title", schemaPath: "#/properties/title/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.title.type, parentSchema: P.properties.title, data: X }], !1;
                  var B = ue === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.pageTimings !== void 0) {
                    let X = k.pageTimings;
                    const ue = L;
                    if (X && typeof X == "object" && !Array.isArray(X)) {
                      if (X.onContentLoad !== void 0) {
                        let pe = X.onContentLoad;
                        const oe = L;
                        if (typeof pe != "number")
                          return F.errors = [{ instancePath: j + "/pageTimings/onContentLoad", schemaPath: "pageTimings.json#/properties/onContentLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: M.properties.onContentLoad.type, parentSchema: M.properties.onContentLoad, data: pe }], !1;
                        var Q = oe === L;
                      } else
                        var Q = !0;
                      if (Q) {
                        if (X.onLoad !== void 0) {
                          let pe = X.onLoad;
                          const oe = L;
                          if (typeof pe != "number")
                            return F.errors = [{ instancePath: j + "/pageTimings/onLoad", schemaPath: "pageTimings.json#/properties/onLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: M.properties.onLoad.type, parentSchema: M.properties.onLoad, data: pe }], !1;
                          var Q = oe === L;
                        } else
                          var Q = !0;
                        if (Q)
                          if (X.comment !== void 0) {
                            let pe = X.comment;
                            const oe = L;
                            if (typeof pe != "string")
                              return F.errors = [{ instancePath: j + "/pageTimings/comment", schemaPath: "pageTimings.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: M.properties.comment.type, parentSchema: M.properties.comment, data: pe }], !1;
                            var Q = oe === L;
                          } else
                            var Q = !0;
                      }
                    } else
                      return F.errors = [{ instancePath: j + "/pageTimings", schemaPath: "pageTimings.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: M.type, parentSchema: M, data: X }], !1;
                    var B = ue === L;
                  } else
                    var B = !0;
                  if (B)
                    if (k.comment !== void 0) {
                      let X = k.comment;
                      const ue = L;
                      if (typeof X != "string")
                        return F.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: P.properties.comment.type, parentSchema: P.properties.comment, data: X }], !1;
                      var B = ue === L;
                    } else
                      var B = !0;
                }
              }
            }
          } else
            return F.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: P.type, parentSchema: P, data: k }], !1;
          return F.errors = U, L === 0;
        }
        function O(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (L === 0)
            if (k && typeof k == "object" && !Array.isArray(k)) {
              let ve;
              if (k.version === void 0 && (ve = "version") || k.creator === void 0 && (ve = "creator") || k.entries === void 0 && (ve = "entries"))
                return O.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: ve }, message: "must have required property '" + ve + "'", schema: Be.required, parentSchema: Be, data: k }], !1;
              if (k.version !== void 0) {
                let pe = k.version;
                const oe = L;
                if (typeof pe != "string")
                  return O.errors = [{ instancePath: j + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Be.properties.version.type, parentSchema: Be.properties.version, data: pe }], !1;
                var B = oe === L;
              } else
                var B = !0;
              if (B) {
                if (k.creator !== void 0) {
                  let pe = k.creator;
                  const oe = L;
                  if (L === L)
                    if (pe && typeof pe == "object" && !Array.isArray(pe)) {
                      let fe;
                      if (pe.name === void 0 && (fe = "name") || pe.version === void 0 && (fe = "version"))
                        return O.errors = [{ instancePath: j + "/creator", schemaPath: "creator.json#/required", keyword: "required", params: { missingProperty: fe }, message: "must have required property '" + fe + "'", schema: Lt.required, parentSchema: Lt, data: pe }], !1;
                      if (pe.name !== void 0) {
                        let be = pe.name;
                        const ge = L;
                        if (typeof be != "string")
                          return O.errors = [{ instancePath: j + "/creator/name", schemaPath: "creator.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Lt.properties.name.type, parentSchema: Lt.properties.name, data: be }], !1;
                        var Q = ge === L;
                      } else
                        var Q = !0;
                      if (Q) {
                        if (pe.version !== void 0) {
                          let be = pe.version;
                          const ge = L;
                          if (typeof be != "string")
                            return O.errors = [{ instancePath: j + "/creator/version", schemaPath: "creator.json#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Lt.properties.version.type, parentSchema: Lt.properties.version, data: be }], !1;
                          var Q = ge === L;
                        } else
                          var Q = !0;
                        if (Q)
                          if (pe.comment !== void 0) {
                            let be = pe.comment;
                            const ge = L;
                            if (typeof be != "string")
                              return O.errors = [{ instancePath: j + "/creator/comment", schemaPath: "creator.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Lt.properties.comment.type, parentSchema: Lt.properties.comment, data: be }], !1;
                            var Q = ge === L;
                          } else
                            var Q = !0;
                      }
                    } else
                      return O.errors = [{ instancePath: j + "/creator", schemaPath: "creator.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Lt.type, parentSchema: Lt, data: pe }], !1;
                  var B = oe === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.browser !== void 0) {
                    let pe = k.browser;
                    const oe = L;
                    if (L === L)
                      if (pe && typeof pe == "object" && !Array.isArray(pe)) {
                        let fe;
                        if (pe.name === void 0 && (fe = "name") || pe.version === void 0 && (fe = "version"))
                          return O.errors = [{ instancePath: j + "/browser", schemaPath: "browser.json#/required", keyword: "required", params: { missingProperty: fe }, message: "must have required property '" + fe + "'", schema: He.required, parentSchema: He, data: pe }], !1;
                        if (pe.name !== void 0) {
                          let be = pe.name;
                          const ge = L;
                          if (typeof be != "string")
                            return O.errors = [{ instancePath: j + "/browser/name", schemaPath: "browser.json#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: He.properties.name.type, parentSchema: He.properties.name, data: be }], !1;
                          var V = ge === L;
                        } else
                          var V = !0;
                        if (V) {
                          if (pe.version !== void 0) {
                            let be = pe.version;
                            const ge = L;
                            if (typeof be != "string")
                              return O.errors = [{ instancePath: j + "/browser/version", schemaPath: "browser.json#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: He.properties.version.type, parentSchema: He.properties.version, data: be }], !1;
                            var V = ge === L;
                          } else
                            var V = !0;
                          if (V)
                            if (pe.comment !== void 0) {
                              let be = pe.comment;
                              const ge = L;
                              if (typeof be != "string")
                                return O.errors = [{ instancePath: j + "/browser/comment", schemaPath: "browser.json#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: He.properties.comment.type, parentSchema: He.properties.comment, data: be }], !1;
                              var V = ge === L;
                            } else
                              var V = !0;
                        }
                      } else
                        return O.errors = [{ instancePath: j + "/browser", schemaPath: "browser.json#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: He.type, parentSchema: He, data: pe }], !1;
                    var B = oe === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.pages !== void 0) {
                      let pe = k.pages;
                      const oe = L;
                      if (L === oe)
                        if (Array.isArray(pe)) {
                          var X = !0;
                          const ke = pe.length;
                          for (let fe = 0; fe < ke; fe++) {
                            let be = pe[fe];
                            const ge = L;
                            F(be, { instancePath: j + "/pages/" + fe, parentData: pe, parentDataProperty: fe, rootData: J }) || (U = U === null ? F.errors : U.concat(F.errors), L = U.length);
                            var X = ge === L;
                            if (!X)
                              break;
                          }
                        } else
                          return O.errors = [{ instancePath: j + "/pages", schemaPath: "#/properties/pages/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Be.properties.pages.type, parentSchema: Be.properties.pages, data: pe }], !1;
                      var B = oe === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (k.entries !== void 0) {
                        let pe = k.entries;
                        const oe = L;
                        if (L === oe)
                          if (Array.isArray(pe)) {
                            var ue = !0;
                            const ke = pe.length;
                            for (let fe = 0; fe < ke; fe++) {
                              let be = pe[fe];
                              const ge = L;
                              Ke(be, { instancePath: j + "/entries/" + fe, parentData: pe, parentDataProperty: fe, rootData: J }) || (U = U === null ? Ke.errors : U.concat(Ke.errors), L = U.length);
                              var ue = ge === L;
                              if (!ue)
                                break;
                            }
                          } else
                            return O.errors = [{ instancePath: j + "/entries", schemaPath: "#/properties/entries/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Be.properties.entries.type, parentSchema: Be.properties.entries, data: pe }], !1;
                        var B = oe === L;
                      } else
                        var B = !0;
                      if (B)
                        if (k.comment !== void 0) {
                          let pe = k.comment;
                          const oe = L;
                          if (typeof pe != "string")
                            return O.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Be.properties.comment.type, parentSchema: Be.properties.comment, data: pe }], !1;
                          var B = oe === L;
                        } else
                          var B = !0;
                    }
                  }
                }
              }
            } else
              return O.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Be.type, parentSchema: Be, data: k }], !1;
          return O.errors = U, L === 0;
        }
        function S(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (L === 0)
            if (k && typeof k == "object" && !Array.isArray(k)) {
              let B;
              if (k.log === void 0 && (B = "log"))
                return S.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: B }, message: "must have required property '" + B + "'", schema: $t.required, parentSchema: $t, data: k }], !1;
              if (k.log !== void 0) {
                let Q = k.log;
                O(Q, { instancePath: j + "/log", parentData: k, parentDataProperty: "log", rootData: J }) || (U = U === null ? O.errors : U.concat(O.errors), L = U.length);
              }
            } else
              return S.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: $t.type, parentSchema: $t, data: k }], !1;
          return S.errors = U, L === 0;
        }
        ie["header.json"] = _;
        function _(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.name === void 0 && (Q = "name") || k.value === void 0 && (Q = "value"))
              return _.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: Y.required, parentSchema: Y, data: k }], !1;
            if (k.name !== void 0) {
              let V = k.name;
              const X = L;
              if (typeof V != "string")
                return _.errors = [{ instancePath: j + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.name.type, parentSchema: Y.properties.name, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.value !== void 0) {
                let V = k.value;
                const X = L;
                if (typeof V != "string")
                  return _.errors = [{ instancePath: j + "/value", schemaPath: "#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.value.type, parentSchema: Y.properties.value, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B)
                if (k.comment !== void 0) {
                  let V = k.comment;
                  const X = L;
                  if (typeof V != "string")
                    return _.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Y.properties.comment.type, parentSchema: Y.properties.comment, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
            }
          } else
            return _.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Y.type, parentSchema: Y, data: k }], !1;
          return _.errors = U, L === 0;
        }
        ie["log.json"] = O, ie["page.json"] = F, ie["pageTimings.json"] = h;
        function h(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            if (k.onContentLoad !== void 0) {
              let Q = k.onContentLoad;
              const V = L;
              if (typeof Q != "number")
                return h.errors = [{ instancePath: j + "/onContentLoad", schemaPath: "#/properties/onContentLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: M.properties.onContentLoad.type, parentSchema: M.properties.onContentLoad, data: Q }], !1;
              var B = V === L;
            } else
              var B = !0;
            if (B) {
              if (k.onLoad !== void 0) {
                let Q = k.onLoad;
                const V = L;
                if (typeof Q != "number")
                  return h.errors = [{ instancePath: j + "/onLoad", schemaPath: "#/properties/onLoad/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: M.properties.onLoad.type, parentSchema: M.properties.onLoad, data: Q }], !1;
                var B = V === L;
              } else
                var B = !0;
              if (B)
                if (k.comment !== void 0) {
                  let Q = k.comment;
                  const V = L;
                  if (typeof Q != "string")
                    return h.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: M.properties.comment.type, parentSchema: M.properties.comment, data: Q }], !1;
                  var B = V === L;
                } else
                  var B = !0;
            }
          } else
            return h.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: M.type, parentSchema: M, data: k }], !1;
          return h.errors = U, L === 0;
        }
        ie["postData.json"] = A;
        function A(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let V;
            if (k.mimeType === void 0 && (V = "mimeType"))
              return A.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: V }, message: "must have required property '" + V + "'", schema: Ee.required, parentSchema: Ee, data: k }], !1;
            if (k.mimeType !== void 0) {
              let X = k.mimeType;
              const ue = L;
              if (typeof X != "string")
                return A.errors = [{ instancePath: j + "/mimeType", schemaPath: "#/properties/mimeType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.mimeType.type, parentSchema: Ee.properties.mimeType, data: X }], !1;
              var B = ue === L;
            } else
              var B = !0;
            if (B) {
              if (k.text !== void 0) {
                let X = k.text;
                const ue = L;
                if (typeof X != "string")
                  return A.errors = [{ instancePath: j + "/text", schemaPath: "#/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.text.type, parentSchema: Ee.properties.text, data: X }], !1;
                var B = ue === L;
              } else
                var B = !0;
              if (B) {
                if (k.params !== void 0) {
                  let X = k.params;
                  const ue = L;
                  if (!Array.isArray(X))
                    return A.errors = [{ instancePath: j + "/params", schemaPath: "#/properties/params/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: Ee.properties.params.type, parentSchema: Ee.properties.params, data: X }], !1;
                  if (X && typeof X == "object" && !Array.isArray(X)) {
                    let pe;
                    if (X.name === void 0 && (pe = "name"))
                      return A.errors = [{ instancePath: j + "/params", schemaPath: "#/properties/params/required", keyword: "required", params: { missingProperty: pe }, message: "must have required property '" + pe + "'", schema: Ee.properties.params.required, parentSchema: Ee.properties.params, data: X }], !1;
                    if (X.name !== void 0) {
                      let oe = X.name;
                      const ce = L;
                      if (typeof oe != "string")
                        return A.errors = [{ instancePath: j + "/params/name", schemaPath: "#/properties/params/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.name.type, parentSchema: Ee.properties.params.properties.name, data: oe }], !1;
                      var Q = ce === L;
                    } else
                      var Q = !0;
                    if (Q) {
                      if (X.value !== void 0) {
                        let oe = X.value;
                        const ce = L;
                        if (typeof oe != "string")
                          return A.errors = [{ instancePath: j + "/params/value", schemaPath: "#/properties/params/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.value.type, parentSchema: Ee.properties.params.properties.value, data: oe }], !1;
                        var Q = ce === L;
                      } else
                        var Q = !0;
                      if (Q) {
                        if (X.fileName !== void 0) {
                          let oe = X.fileName;
                          const ce = L;
                          if (typeof oe != "string")
                            return A.errors = [{ instancePath: j + "/params/fileName", schemaPath: "#/properties/params/properties/fileName/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.fileName.type, parentSchema: Ee.properties.params.properties.fileName, data: oe }], !1;
                          var Q = ce === L;
                        } else
                          var Q = !0;
                        if (Q) {
                          if (X.contentType !== void 0) {
                            let oe = X.contentType;
                            const ce = L;
                            if (typeof oe != "string")
                              return A.errors = [{ instancePath: j + "/params/contentType", schemaPath: "#/properties/params/properties/contentType/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.contentType.type, parentSchema: Ee.properties.params.properties.contentType, data: oe }], !1;
                            var Q = ce === L;
                          } else
                            var Q = !0;
                          if (Q)
                            if (X.comment !== void 0) {
                              let oe = X.comment;
                              const ce = L;
                              if (typeof oe != "string")
                                return A.errors = [{ instancePath: j + "/params/comment", schemaPath: "#/properties/params/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.params.properties.comment.type, parentSchema: Ee.properties.params.properties.comment, data: oe }], !1;
                              var Q = ce === L;
                            } else
                              var Q = !0;
                        }
                      }
                    }
                  }
                  var B = ue === L;
                } else
                  var B = !0;
                if (B)
                  if (k.comment !== void 0) {
                    let X = k.comment;
                    const ue = L;
                    if (typeof X != "string")
                      return A.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ee.properties.comment.type, parentSchema: Ee.properties.comment, data: X }], !1;
                    var B = ue === L;
                  } else
                    var B = !0;
              }
            }
          } else
            return A.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: Ee.type, parentSchema: Ee, data: k }], !1;
          return A.errors = U, L === 0;
        }
        ie["query.json"] = R;
        function R(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.name === void 0 && (Q = "name") || k.value === void 0 && (Q = "value"))
              return R.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: ae.required, parentSchema: ae, data: k }], !1;
            if (k.name !== void 0) {
              let V = k.name;
              const X = L;
              if (typeof V != "string")
                return R.errors = [{ instancePath: j + "/name", schemaPath: "#/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ae.properties.name.type, parentSchema: ae.properties.name, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.value !== void 0) {
                let V = k.value;
                const X = L;
                if (typeof V != "string")
                  return R.errors = [{ instancePath: j + "/value", schemaPath: "#/properties/value/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ae.properties.value.type, parentSchema: ae.properties.value, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B)
                if (k.comment !== void 0) {
                  let V = k.comment;
                  const X = L;
                  if (typeof V != "string")
                    return R.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: ae.properties.comment.type, parentSchema: ae.properties.comment, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
            }
          } else
            return R.errors = [{ instancePath: j, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: ae.type, parentSchema: ae, data: k }], !1;
          return R.errors = U, L === 0;
        }
        ie["request.json"] = Se, ie["response.json"] = Xe, ie["timings.json"] = I;
        function I(k, { instancePath: j = "", parentData: z, parentDataProperty: H, rootData: J = k } = {}) {
          let U = null, L = 0;
          if (k && typeof k == "object" && !Array.isArray(k)) {
            let Q;
            if (k.send === void 0 && (Q = "send") || k.wait === void 0 && (Q = "wait") || k.receive === void 0 && (Q = "receive"))
              return I.errors = [{ instancePath: j, schemaPath: "#/required", keyword: "required", params: { missingProperty: Q }, message: "must have required property '" + Q + "'", schema: Ue.required, parentSchema: Ue, data: k }], !1;
            if (k.dns !== void 0) {
              let V = k.dns;
              const X = L;
              if (typeof V != "number")
                return I.errors = [{ instancePath: j + "/dns", schemaPath: "#/properties/dns/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.dns.type, parentSchema: Ue.properties.dns, data: V }], !1;
              var B = X === L;
            } else
              var B = !0;
            if (B) {
              if (k.connect !== void 0) {
                let V = k.connect;
                const X = L;
                if (typeof V != "number")
                  return I.errors = [{ instancePath: j + "/connect", schemaPath: "#/properties/connect/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.connect.type, parentSchema: Ue.properties.connect, data: V }], !1;
                var B = X === L;
              } else
                var B = !0;
              if (B) {
                if (k.blocked !== void 0) {
                  let V = k.blocked;
                  const X = L;
                  if (typeof V != "number")
                    return I.errors = [{ instancePath: j + "/blocked", schemaPath: "#/properties/blocked/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.blocked.type, parentSchema: Ue.properties.blocked, data: V }], !1;
                  var B = X === L;
                } else
                  var B = !0;
                if (B) {
                  if (k.send !== void 0) {
                    let V = k.send;
                    const X = L;
                    if (typeof V != "number")
                      return I.errors = [{ instancePath: j + "/send", schemaPath: "#/properties/send/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.send.type, parentSchema: Ue.properties.send, data: V }], !1;
                    var B = X === L;
                  } else
                    var B = !0;
                  if (B) {
                    if (k.wait !== void 0) {
                      let V = k.wait;
                      const X = L;
                      if (typeof V != "number")
                        return I.errors = [{ instancePath: j + "/wait", schemaPath: "#/properties/wait/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.wait.type, parentSchema: Ue.properties.wait, data: V }], !1;
                      var B = X === L;
                    } else
                      var B = !0;
                    if (B) {
                      if (k.receive !== void 0) {
                        let V = k.receive;
                        const X = L;
                        if (typeof V != "number")
                          return I.errors = [{ instancePath: j + "/receive", schemaPath: "#/properties/receive/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.receive.type, parentSchema: Ue.properties.receive, data: V }], !1;
                        var B = X === L;
                      } else
                        var B = !0;
                      if (B) {
                        if (k.ssl !== void 0) {
                          let V = k.ssl;
                          const X = L;
                          if (typeof V != "number")
                            return I.errors = [{ instancePath: j + "/ssl", schemaPath: "#/properties/ssl/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: Ue.properties.ssl.type, parentSchema: Ue.properties.ssl, data: V }], !1;
                          var B = X === L;
                        } else
                          var B = !0;
                        if (B)
                          if (k.comment !== void 0) {
                            let V = k.comment;
                            const X = L;
                            if (typeof V != "string")
                              return I.errors = [{ instancePath: j + "/comment", schemaPath: "#/properties/comment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: Ue.properties.comment.type, parentSchema: Ue.properties.comment, data: V }], !1;
                            var B = X === L;
                          } else
                            var B = !0;
                      }
                    }
                  }
                }
              }
            }
          }
          return I.errors = U, L === 0;
        }
      }
    }), D = {};
    b(D, {
      HARError: () => Z,
      default: () => de,
      validate: () => se,
      validateHar: () => re,
      validateRequest: () => ee,
      validateResponse: () => K
    }), e.exports = C(D);
    var $ = w(E()), Z = class extends Error {
      constructor(ie) {
        super(), this.name = "HARError", this.message = "Validation Failed", this.errors = [], this.errors = ie, Error.captureStackTrace(this, this.constructor);
      }
    }, te = {
      request: $["request.json"],
      afterRequest: $["afterRequest.json"],
      beforeRequest: $["beforeRequest.json"],
      browser: $["browser.json"],
      cache: $["cache.json"],
      content: $["content.json"],
      cookie: $["cookie.json"],
      creator: $["creator.json"],
      entry: $["entry.json"],
      har: $["har.json"],
      header: $["header.json"],
      log: $["log.json"],
      page: $["page.json"],
      pageTimings: $["pageTimings.json"],
      postData: $["postData.json"],
      query: $["query.json"],
      response: $["response.json"],
      timings: $["timings.json"]
    }, se = (ie, me) => {
      const $e = te[ie], Pe = $e(me);
      if (!Pe)
        throw new Z($e.errors);
      return Pe;
    }, ee = (ie) => se("request", ie), K = (ie) => se("response", ie), re = (ie) => se("har", ie), de = ee;
  }(C6)), C6.exports;
}
var Qu = {}, A6, rC;
function Qne() {
  if (rC) return A6;
  rC = 1;
  function e(n, r) {
    return Object.prototype.hasOwnProperty.call(n, r);
  }
  A6 = function(n, r, i, a) {
    r = r || "&", i = i || "=";
    var o = {};
    if (typeof n != "string" || n.length === 0)
      return o;
    var c = /\+/g;
    n = n.split(r);
    var u = 1e3;
    a && typeof a.maxKeys == "number" && (u = a.maxKeys);
    var s = n.length;
    u > 0 && s > u && (s = u);
    for (var f = 0; f < s; ++f) {
      var d = n[f].replace(c, "%20"), l = d.indexOf(i), p, g, v, b;
      l >= 0 ? (p = d.substr(0, l), g = d.substr(l + 1)) : (p = d, g = ""), v = decodeURIComponent(p), b = decodeURIComponent(g), e(o, v) ? t(o[v]) ? o[v].push(b) : o[v] = [o[v], b] : o[v] = b;
    }
    return o;
  };
  var t = Array.isArray || function(n) {
    return Object.prototype.toString.call(n) === "[object Array]";
  };
  return A6;
}
var k6, nC;
function Xne() {
  if (nC) return k6;
  nC = 1;
  var e = function(i) {
    switch (typeof i) {
      case "string":
        return i;
      case "boolean":
        return i ? "true" : "false";
      case "number":
        return isFinite(i) ? i : "";
      default:
        return "";
    }
  };
  k6 = function(i, a, o, c) {
    return a = a || "&", o = o || "=", i === null && (i = void 0), typeof i == "object" ? n(r(i), function(u) {
      var s = encodeURIComponent(e(u)) + o;
      return t(i[u]) ? n(i[u], function(f) {
        return s + encodeURIComponent(e(f));
      }).join(a) : s + encodeURIComponent(e(i[u]));
    }).join(a) : c ? encodeURIComponent(e(c)) + o + encodeURIComponent(e(i)) : "";
  };
  var t = Array.isArray || function(i) {
    return Object.prototype.toString.call(i) === "[object Array]";
  };
  function n(i, a) {
    if (i.map) return i.map(a);
    for (var o = [], c = 0; c < i.length; c++)
      o.push(a(i[c], c));
    return o;
  }
  var r = Object.keys || function(i) {
    var a = [];
    for (var o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  };
  return k6;
}
var iC;
function eie() {
  return iC || (iC = 1, Qu.decode = Qu.parse = Qne(), Qu.encode = Qu.stringify = Xne()), Qu;
}
var _s = eie();
function nT(e) {
  return encodeURIComponent(e);
}
function iT(e) {
  return decodeURIComponent(e);
}
var tie = {
  decode: _s.decode,
  encode: _s.encode,
  parse: _s.parse,
  stringify: _s.stringify,
  escape: nT,
  unescape: iT
};
const rie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: _s.decode,
  default: tie,
  encode: _s.encode,
  escape: nT,
  parse: _s.parse,
  stringify: _s.stringify,
  unescape: iT
}, Symbol.toStringTag, { value: "Module" })), nie = /* @__PURE__ */ Bf(rie);
var Yo = {}, aC;
function iie() {
  return aC || (aC = 1, function(e) {
    /**
     * @license https://raw.githubusercontent.com/node-fetch/node-fetch/master/LICENSE.md
     *
     * The MIT License (MIT)
     *
     * Copyright (c) 2016 - 2020 Node Fetch Team
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     *
     * Extracted from https://github.com/node-fetch/node-fetch/blob/64c5c296a0250b852010746c76144cb9e14698d9/src/utils/form-data.js
     */
    var t = Yo && Yo.__generator || function(d, l) {
      var p = { label: 0, sent: function() {
        if (b[0] & 1) throw b[1];
        return b[1];
      }, trys: [], ops: [] }, g, v, b, y;
      return y = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (y[Symbol.iterator] = function() {
        return this;
      }), y;
      function w(T) {
        return function(E) {
          return C([T, E]);
        };
      }
      function C(T) {
        if (g) throw new TypeError("Generator is already executing.");
        for (; p; ) try {
          if (g = 1, v && (b = T[0] & 2 ? v.return : T[0] ? v.throw || ((b = v.return) && b.call(v), 0) : v.next) && !(b = b.call(v, T[1])).done) return b;
          switch (v = 0, b && (T = [T[0] & 2, b.value]), T[0]) {
            case 0:
            case 1:
              b = T;
              break;
            case 4:
              return p.label++, { value: T[1], done: !1 };
            case 5:
              p.label++, v = T[1], T = [0];
              continue;
            case 7:
              T = p.ops.pop(), p.trys.pop();
              continue;
            default:
              if (b = p.trys, !(b = b.length > 0 && b[b.length - 1]) && (T[0] === 6 || T[0] === 2)) {
                p = 0;
                continue;
              }
              if (T[0] === 3 && (!b || T[1] > b[0] && T[1] < b[3])) {
                p.label = T[1];
                break;
              }
              if (T[0] === 6 && p.label < b[1]) {
                p.label = b[1], b = T;
                break;
              }
              if (b && p.label < b[2]) {
                p.label = b[2], p.ops.push(T);
                break;
              }
              b[2] && p.ops.pop(), p.trys.pop();
              continue;
          }
          T = l.call(d, p);
        } catch (E) {
          T = [6, E], v = 0;
        } finally {
          g = b = 0;
        }
        if (T[0] & 5) throw T[1];
        return { value: T[0] ? T[1] : void 0, done: !0 };
      }
    }, n = Yo && Yo.__values || function(d) {
      var l = typeof Symbol == "function" && Symbol.iterator, p = l && d[l], g = 0;
      if (p) return p.call(d);
      if (d && typeof d.length == "number") return {
        next: function() {
          return d && g >= d.length && (d = void 0), { value: d && d[g++], done: !d };
        }
      };
      throw new TypeError(l ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, r = Yo && Yo.__read || function(d, l) {
      var p = typeof Symbol == "function" && d[Symbol.iterator];
      if (!p) return d;
      var g = p.call(d), v, b = [], y;
      try {
        for (; (l === void 0 || l-- > 0) && !(v = g.next()).done; ) b.push(v.value);
      } catch (w) {
        y = { error: w };
      } finally {
        try {
          v && !v.done && (p = g.return) && p.call(g);
        } finally {
          if (y) throw y.error;
        }
      }
      return b;
    };
    e.__esModule = !0, e.formDataIterator = e.isBlob = void 0;
    var i = `\r
`, a = "-".repeat(2), o = Symbol.toStringTag, c = function(d) {
      return typeof d == "object" && typeof d.arrayBuffer == "function" && typeof d.type == "string" && typeof d.stream == "function" && typeof d.constructor == "function" && /^(Blob|File)$/.test(d[o]);
    };
    e.isBlob = c;
    var u = function(d) {
      return "".concat(a).concat(d).concat(a).concat(i.repeat(2));
    }, s = function(d, l, p) {
      var g = "";
      return g += "".concat(a).concat(d).concat(i), g += 'Content-Disposition: form-data; name="'.concat(l, '"'), (0, e.isBlob)(p) && (g += '; filename="'.concat(p.name, '"').concat(i), g += "Content-Type: ".concat(p.type || "application/octet-stream")), "".concat(g).concat(i.repeat(2));
    }, f = function(d, l) {
      var p, g, v, b, y, w, C, T;
      return t(this, function(E) {
        switch (E.label) {
          case 0:
            E.trys.push([0, 10, 11, 12]), p = n(d), g = p.next(), E.label = 1;
          case 1:
            return g.done ? [3, 9] : (v = r(g.value, 2), b = v[0], y = v[1], [4, s(l, b, y)]);
          case 2:
            return E.sent(), (0, e.isBlob)(y) ? [5, n(y.stream())] : [3, 4];
          case 3:
            return E.sent(), [3, 6];
          case 4:
            return [4, y];
          case 5:
            E.sent(), E.label = 6;
          case 6:
            return [4, i];
          case 7:
            E.sent(), E.label = 8;
          case 8:
            return g = p.next(), [3, 1];
          case 9:
            return [3, 12];
          case 10:
            return w = E.sent(), C = { error: w }, [3, 12];
          case 11:
            try {
              g && !g.done && (T = p.return) && T.call(p);
            } finally {
              if (C) throw C.error;
            }
            return [
              7
              /*endfinally*/
            ];
          case 12:
            return [4, u(l)];
          case 13:
            return E.sent(), [
              2
              /*return*/
            ];
        }
      });
    };
    e.formDataIterator = f;
  }(Yo)), Yo;
}
var of = {}, oC;
function aie() {
  if (oC) return of;
  oC = 1, of.__esModule = !0, of.reducer = void 0;
  var e = function(t, n) {
    var r = t[n.name];
    return r === void 0 ? (t[n.name] = n.value, t) : Array.isArray(r) ? (r.push(n.value), t) : (t[n.name] = [r, n.value], t);
  };
  return of.reducer = e, of;
}
var sC;
function oie() {
  return sC || (sC = 1, function(e) {
    var t = Za && Za.__assign || function() {
      return t = Object.assign || function(C) {
        for (var T, E = 1, D = arguments.length; E < D; E++) {
          T = arguments[E];
          for (var $ in T) Object.prototype.hasOwnProperty.call(T, $) && (C[$] = T[$]);
        }
        return C;
      }, t.apply(this, arguments);
    }, n = Za && Za.__createBinding || (Object.create ? function(C, T, E, D) {
      D === void 0 && (D = E);
      var $ = Object.getOwnPropertyDescriptor(T, E);
      (!$ || ("get" in $ ? !T.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
        return T[E];
      } }), Object.defineProperty(C, D, $);
    } : function(C, T, E, D) {
      D === void 0 && (D = E), C[D] = T[E];
    }), r = Za && Za.__values || function(C) {
      var T = typeof Symbol == "function" && Symbol.iterator, E = T && C[T], D = 0;
      if (E) return E.call(C);
      if (C && typeof C.length == "number") return {
        next: function() {
          return C && D >= C.length && (C = void 0), { value: C && C[D++], done: !C };
        }
      };
      throw new TypeError(T ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, i = Za && Za.__importDefault || function(C) {
      return C && C.__esModule ? C : { default: C };
    };
    e.__esModule = !0, e.HTTPSnippet = e.isHarEntry = e.addTargetClient = e.addTarget = e.extname = e.availableTargets = void 0;
    var a = jne(), o = i(Yne()), c = /* @__PURE__ */ Jne(), u = nie, s = YO(), f = iie(), d = Wi(), l = aie(), p = P0(), g = WO();
    n(e, g, "availableTargets"), n(e, g, "extname");
    var v = P0();
    n(e, v, "addTarget"), n(e, v, "addTargetClient");
    var b = (
      // @ts-expect-error — we're only using window.FormData if it exists
      typeof window < "u" && window.FormData ? window.FormData : o.default
    ), y = function(C) {
      return typeof C == "object" && "log" in C && typeof C.log == "object" && "entries" in C.log && Array.isArray(C.log.entries);
    };
    e.isHarEntry = y;
    var w = (
      /** @class */
      /* @__PURE__ */ function() {
        function C(T) {
          var E = this;
          this.requests = [], this.prepare = function($) {
            var Z, te, se, ee, K, re = t(t({}, $), { fullUrl: "", uriObj: {}, queryObj: {}, headersObj: {}, cookiesObj: {}, allHeaders: {} });
            if (re.queryString && re.queryString.length && (re.queryObj = re.queryString.reduce(l.reducer, {})), re.headers && re.headers.length) {
              var de = /^HTTP\/2/;
              re.headersObj = re.headers.reduce(function(We, Lt) {
                var Fe, Ze = Lt.name, Ue = Lt.value, Rt = de.exec(re.httpVersion) ? Ze.toLocaleLowerCase() : Ze;
                return t(t({}, We), (Fe = {}, Fe[Rt] = Ue, Fe));
              }, {});
            }
            re.cookies && re.cookies.length && (re.cookiesObj = re.cookies.reduceRight(function(We, Lt) {
              var Fe, Ze = Lt.name, Ue = Lt.value;
              return t(t({}, We), (Fe = {}, Fe[Ze] = Ue, Fe));
            }, {}));
            var ie = (se = re.cookies) === null || se === void 0 ? void 0 : se.map(function(We) {
              var Lt = We.name, Fe = We.value;
              return "".concat(encodeURIComponent(Lt), "=").concat(encodeURIComponent(Fe));
            });
            switch (ie != null && ie.length && (re.allHeaders.cookie = ie.join("; ")), re == null ? void 0 : re.postData.mimeType) {
              case "multipart/mixed":
              case "multipart/related":
              case "multipart/form-data":
              case "multipart/alternative":
                if (re.postData.text = "", re.postData.mimeType = "multipart/form-data", !((ee = re.postData) === null || ee === void 0) && ee.params) {
                  var me = new b(), $e = typeof me[Symbol.iterator] == "function", Pe = "---011000010111000001101001";
                  if ($e || (me._boundary = Pe), (K = re.postData) === null || K === void 0 || K.params.forEach(function(We) {
                    var Lt = We.name, Fe = We.value || "", Ze = We.fileName || null;
                    $e ? (0, f.isBlob)(Fe) ? me.append(Lt, Fe, Ze) : me.append(Lt, Fe) : me.append(Lt, Fe, {
                      filename: Ze,
                      contentType: We.contentType || null
                    });
                  }), $e)
                    try {
                      for (var Le = r((0, f.formDataIterator)(me, Pe)), Ae = Le.next(); !Ae.done; Ae = Le.next()) {
                        var He = Ae.value;
                        re.postData.text += He;
                      }
                    } catch (We) {
                      Z = { error: We };
                    } finally {
                      try {
                        Ae && !Ae.done && (te = Le.return) && te.call(Le);
                      } finally {
                        if (Z) throw Z.error;
                      }
                    }
                  else
                    me.pipe(
                      // @ts-expect-error TODO
                      (0, a.map)(function(We) {
                        re.postData.text += We;
                      })
                    );
                  re.postData.boundary = Pe;
                  var Te = (0, d.getHeaderName)(re.headersObj, "content-type") || "content-type";
                  re.headersObj[Te] = "multipart/form-data; boundary=".concat(Pe);
                }
                break;
              case "application/x-www-form-urlencoded":
                re.postData.params ? (re.postData.paramsObj = re.postData.params.reduce(l.reducer, {}), re.postData.text = (0, u.stringify)(re.postData.paramsObj)) : re.postData.text = "";
                break;
              case "text/json":
              case "text/x-json":
              case "application/json":
              case "application/x-json":
                if (re.postData.mimeType = "application/json", re.postData.text)
                  try {
                    re.postData.jsonObj = JSON.parse(re.postData.text);
                  } catch {
                    re.postData.mimeType = "text/plain";
                  }
                break;
            }
            var we = t(t({}, re.allHeaders), re.headersObj), qe = (0, s.parse)(re.url, !0, !0);
            re.queryObj = t(t({}, re.queryObj), qe.query);
            var Ge = (0, u.stringify)(re.queryObj), It = t(t({}, qe), { query: re.queryObj, search: Ge, path: Ge ? "".concat(qe.pathname, "?").concat(Ge) : qe.pathname }), Qe = (0, s.format)(t(t({}, qe), { query: null, search: null })), jt = (0, s.format)(t(t({}, qe), It));
            return t(t({}, re), { allHeaders: we, fullUrl: jt, url: Qe, uriObj: It });
          }, this.convert = function($, Z, te) {
            !te && Z && (te = Z);
            var se = p.targets[$];
            if (!se)
              return !1;
            var ee = se.clientsById[Z || se.info.default].convert, K = E.requests.map(function(re) {
              return ee(re, te);
            });
            return K.length === 1 ? K[0] : K;
          };
          var D = [];
          this.requests = [], (0, e.isHarEntry)(T) ? D = T.log.entries : D = [
            {
              request: T
            }
          ], D.forEach(function($) {
            var Z, te = $.request, se = t(t({ bodySize: 0, headersSize: 0, headers: [], cookies: [], httpVersion: "HTTP/1.1", queryString: [] }, te), { postData: (te == null ? void 0 : te.postData) || {
              mimeType: ((Z = te.postData) === null || Z === void 0 ? void 0 : Z.mimeType) || "application/octet-stream"
            } });
            (0, c.validateRequest)(se) && E.requests.push(E.prepare(se));
          });
        }
        return C;
      }()
    );
    e.HTTPSnippet = w;
  }(Za)), Za;
}
var uC;
function sie() {
  return uC || (uC = 1, function(e) {
    var t = Sl && Sl.__createBinding || (Object.create ? function(u, s, f, d) {
      d === void 0 && (d = f);
      var l = Object.getOwnPropertyDescriptor(s, f);
      (!l || ("get" in l ? !s.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
        return s[f];
      } }), Object.defineProperty(u, d, l);
    } : function(u, s, f, d) {
      d === void 0 && (d = f), u[d] = s[f];
    });
    e.__esModule = !0, e.targets = e.isTarget = e.isClient = e.addTargetClient = e.addTarget = e.isHarEntry = e.HTTPSnippet = e.extname = e.availableTargets = e.getHeaderName = e.getHeader = e.escapeString = e.CodeBuilder = void 0;
    var n = Tn();
    t(e, n, "CodeBuilder");
    var r = ri();
    t(e, r, "escapeString");
    var i = Wi();
    t(e, i, "getHeader"), t(e, i, "getHeaderName");
    var a = WO();
    t(e, a, "availableTargets"), t(e, a, "extname");
    var o = oie();
    t(e, o, "HTTPSnippet"), t(e, o, "isHarEntry");
    var c = P0();
    t(e, c, "addTarget"), t(e, c, "addTargetClient"), t(e, c, "isClient"), t(e, c, "isTarget"), t(e, c, "targets");
  }(Sl)), Sl;
}
var uie = sie();
const fu = /* @__PURE__ */ xr({
  __name: "LanguageIcon",
  props: {
    lang: {
      type: String,
      required: !0,
      validator: (e) => Object.values(CH).includes(e)
    }
  },
  setup(e) {
    const t = e, n = Ye(() => {
      switch (t.lang) {
        case "bash":
          return s_;
        case "python":
          return aJ;
        case "node":
          return tJ;
        case "java":
          return ZY;
        case "javascript":
          return JY;
        case "go":
          return WY;
        case "ruby":
          return cJ;
        case "swift":
          return fJ;
        case "c#":
          return HY;
        case "c++":
          return BY;
        case "php":
          return nJ;
        case "c":
          return GY;
        case "r":
          return sJ;
        case "json":
          return XY;
        default:
          return s_;
      }
    });
    return (r, i) => (Re(), Bt(An(n.value)));
  }
}), cie = ["data-testid"], lie = { class: "select-wrapper" }, fie = ["value"], pie = { class: "wide" }, die = /* @__PURE__ */ xr({
  __name: "RequestSample",
  props: /* @__PURE__ */ Xa({
    data: {
      type: Object,
      required: !0
    },
    /**
     * server url selected by user on endpoints detail page
     */
    serverUrl: {
      type: String,
      required: !0
    },
    /* value is coming from TryIt path parameter change */
    requestPath: {
      type: String,
      required: !0
    },
    /* headers generated by auth token changes un TryItAuth */
    authHeaders: {
      type: Array,
      default: () => []
    },
    customHeaders: {
      type: Array,
      default: () => []
    },
    /* query portion generated by auth token changes un TryItAuth */
    authQuery: {
      type: String,
      default: ""
    },
    /* value is coming from TryIt query parameter change */
    requestQuery: {
      type: String,
      default: ""
    },
    /* value is coming from TryIt body parameter change */
    requestBody: {
      type: String,
      default: ""
    }
  }, {
    modelValue: {
      type: Boolean,
      default: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xa(["request-body-sample-idx-changed"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    var y, w, C;
    const n = e, r = bc(e, "modelValue"), i = Qa("hide-tryit", Sr(!1)), a = t, o = Ye(() => i.value ? n.requestBody && i.value ? Xu : Xu.filter((T) => T.httpSnippetLanguage !== "json") : Xu.filter((T) => T.httpSnippetLanguage !== "json")), c = Ye(() => o.value.map((T) => ({
      label: T.label,
      value: T.httpSnippetLanguage,
      key: T.httpSnippetLanguage
    }))), u = Sr(), s = Sr(), f = Ye(() => {
      var T;
      return u.value ? ((T = Xu.find((E) => E.httpSnippetLanguage === u.value)) == null ? void 0 : T.libraries) || [] : [];
    }), d = (T) => Array.isArray(T) && T.length ? T[0].key : null, l = Sr((C = (w = (y = n.data) == null ? void 0 : y.request) == null ? void 0 : w.body) != null && C.contents && n.data.request.body.contents.length ? d(n.data.request.body.contents[0].examples) : null), p = Ye(() => {
      var T, E, D;
      return (D = (E = (T = n.data) == null ? void 0 : T.request) == null ? void 0 : E.body) != null && D.contents && n.data.request.body.contents.length && Array.isArray(n.data.request.body.contents[0].examples) && n.data.request.body.contents[0].examples.length ? n.data.request.body.contents[0].examples : [];
    }), g = Ye(() => p.value.map((T) => ({
      label: T.key,
      value: T.key,
      key: T.key
    })));
    In(p, (T) => {
      l.value = d(T);
    });
    const v = Sr(), b = Sr();
    return In(l, (T) => {
      a("request-body-sample-idx-changed", p.value.findIndex((E) => E.key === T));
    }), In(() => ({
      method: n.data.method,
      lang: u.value,
      lib: s.value,
      serverUrl: n.serverUrl,
      authHeaders: n.authHeaders,
      customHeaders: n.customHeaders,
      requestPath: n.requestPath,
      requestQuery: n.requestQuery,
      authQuery: n.authQuery,
      requestBody: n.requestBody
    }), (T, E) => {
      var Z, te;
      T.method !== (E == null ? void 0 : E.method) && ((Z = o.value) != null && Z[0]) && (u.value = o.value[0].httpSnippetLanguage, T.lang = u.value), T.lang !== (E == null ? void 0 : E.lang) && (s.value = (te = f.value) != null && te.length ? f.value[0].httpSnippetLibrary : void 0);
      let D = !1, $ = !1;
      if (!v.value || T.serverUrl !== (E == null ? void 0 : E.serverUrl) || T.requestPath !== (E == null ? void 0 : E.requestPath) || T.requestQuery !== (E == null ? void 0 : E.requestQuery) || T.authQuery !== (E == null ? void 0 : E.authQuery) || T.requestBody !== (E == null ? void 0 : E.requestBody) || T.authHeaders !== (E == null ? void 0 : E.authHeaders) || T.customHeaders !== (E == null ? void 0 : E.customHeaders))
        try {
          let se = new URL((T.serverUrl + T.requestPath).replaceAll("{", "").replaceAll("}", "")), ee = T.requestQuery;
          T.authQuery && (ee += (T.requestQuery ? "&" : "?") + T.authQuery), se.search = ee;
          const K = {
            method: T.method.toUpperCase(),
            url: se.toString(),
            headers: [
              ...T.authHeaders,
              ...DE(n.data),
              ...T.customHeaders
            ],
            postData: {
              mimeType: "application/json",
              text: T.requestBody
            }
          };
          v.value = new uie.HTTPSnippet(K), $ = !0;
        } catch {
          D = !0;
        }
      if (D)
        b.value = "Error initializing code snippet";
      else if (!b.value || $ || T.lang !== (E == null ? void 0 : E.lang) || T.lib !== (E == null ? void 0 : E.lib)) {
        if (T.lang === "json")
          return b.value = T.requestBody, Xu.filter((se) => se.httpSnippetLanguage !== "json");
        v.value && (b.value = v.value.convert(T.lang, T.lib) || "");
      }
    }, { immediate: !0, deep: !0 }), (T, E) => (Re(), vt("div", {
      class: "request-sample-wrapper",
      "data-testid": `request-sample-${e.data.id}`
    }, [
      Br(m1, {
        collapsible: !1,
        "content-to-copy": b.value
      }, {
        header: _r(() => [
          Gt("div", lie, [
            Br(Ia, {
              id: `language-select-${e.data.id}`,
              modelValue: u.value,
              "onUpdate:modelValue": E[0] || (E[0] = (D) => u.value = D),
              class: "language-selector",
              items: c.value
            }, {
              "shell-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "bash" }),
                Rn(" " + pn(D.label), 1)
              ]),
              "python-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "python" }),
                Rn(" " + pn(D.label), 1)
              ]),
              "node-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "node" }),
                Rn(" " + pn(D.label), 1)
              ]),
              "javascript-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "javascript" }),
                Rn(" " + pn(D.label), 1)
              ]),
              "go-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "go" }),
                Rn(" " + pn(D.label), 1)
              ]),
              "java-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "java" }),
                Rn(" " + pn(D.label), 1)
              ]),
              "ruby-item-content": _r(({ item: D }) => [
                Br(fu, { lang: "ruby" }),
                Rn(" " + pn(D.label), 1)
              ]),
              _: 1
            }, 8, ["id", "modelValue", "items"]),
            E[4] || (E[4] = Rn("   ")),
            f.value.length ? rs((Re(), vt("select", {
              key: 0,
              "onUpdate:modelValue": E[1] || (E[1] = (D) => s.value = D)
            }, [
              (Re(!0), vt(Wn, null, hi(f.value, (D) => (Re(), vt("option", {
                key: D.httpSnippetLibrary,
                value: D.httpSnippetLibrary
              }, pn(D.label), 9, fie))), 128))
            ], 512)), [
              [HD, s.value]
            ]) : Kt("", !0),
            g.value && g.value.length && l.value ? (Re(), Bt(Ia, {
              key: 1,
              id: `request-sample-select-${e.data.id}`,
              modelValue: l.value,
              "onUpdate:modelValue": E[2] || (E[2] = (D) => l.value = D),
              class: "request-sample-selector",
              items: g.value,
              placement: "bottom-end"
            }, null, 8, ["id", "modelValue", "items"])) : Kt("", !0)
          ])
        ]),
        default: _r(() => [
          Nt(i) ? (Re(), Bt(GO, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": E[3] || (E[3] = (D) => r.value = D),
            data: e.data
          }, null, 8, ["modelValue", "data"])) : Kt("", !0),
          Gt("div", pie, [
            b.value && u.value ? (Re(), Bt(Nf, {
              key: 0,
              code: b.value,
              lang: u.value
            }, null, 8, ["code", "lang"])) : Kt("", !0)
          ])
        ]),
        _: 1
      }, 8, ["content-to-copy"])
    ], 8, cie));
  }
}), hie = /* @__PURE__ */ dn(die, [["__scopeId", "data-v-48415cce"]]), mie = { class: "schema-example" }, gie = { class: "schema-example-header" }, vie = /* @__PURE__ */ xr({
  __name: "SchemaExample",
  props: {
    schemaExampleJson: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: "Example"
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", mie, [
      Gt("div", gie, [
        Fn(t.$slots, "default", {}, () => [
          Gt("span", null, pn(e.title), 1),
          Br(h1, { content: e.schemaExampleJson }, null, 8, ["content"])
        ], !0)
      ]),
      Br(Nf, {
        code: e.schemaExampleJson,
        lang: "json"
      }, null, 8, ["code"])
    ]));
  }
}), cp = /* @__PURE__ */ dn(vie, [["__scopeId", "data-v-777fb096"]]), yie = { class: "response-sample-header-right" }, bie = /* @__PURE__ */ xr({
  __name: "ResponseSample",
  props: {
    contentList: {
      type: Array,
      required: !0
    },
    responseCode: {
      type: String,
      required: !0
    },
    contentType: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = Sr("0"), r = Ye(() => t.contentList.length ? vf(
      t.contentList,
      {},
      parseInt(n.value) || 0
    ) : t.description), i = Ye(() => {
      var a;
      return (a = t.contentList[0]) != null && a.examples ? t.contentList[0].examples.map((o, c) => ({
        label: o.key,
        value: c.toString(),
        key: o.key
      })) : [];
    });
    return (a, o) => (Re(), Bt(cp, {
      class: "response-sample",
      "data-testid": "response-sample",
      "schema-example-json": r.value
    }, {
      default: _r(() => [
        Fn(a.$slots, "default", {}, void 0, !0),
        Gt("div", yie, [
          i.value && i.value.length > 1 ? (Re(), Bt(Ia, {
            key: 0,
            id: "response-sample-select",
            modelValue: n.value,
            "onUpdate:modelValue": o[0] || (o[0] = (c) => n.value = c),
            class: "response-sample-selector",
            "data-testid": "response-sample-selector",
            items: i.value,
            placement: "bottom-end"
          }, null, 8, ["modelValue", "items"])) : Kt("", !0),
          Br(h1, { content: r.value }, null, 8, ["content"])
        ])
      ]),
      _: 3
    }, 8, ["schema-example-json"]));
  }
}), cC = /* @__PURE__ */ dn(bie, [["__scopeId", "data-v-124d83c1"]]), xie = { class: "callback-sample" }, _ie = { class: "callback-sample-header" }, wie = { class: "callback-sample-content" }, Sie = /* @__PURE__ */ xr({
  __name: "CallbackSample",
  props: {
    callbackKey: {
      type: String,
      required: !0
    },
    requestSample: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", xie, [
      Gt("div", _ie, [
        Fn(t.$slots, "header", {}, void 0, !0)
      ]),
      Gt("div", wie, [
        e.requestSample ? (Re(), Bt(cp, {
          key: 0,
          class: "callback-request-sample",
          "schema-example-json": e.requestSample,
          title: "Callback Body"
        }, null, 8, ["schema-example-json"])) : Kt("", !0),
        Fn(t.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), Cie = /* @__PURE__ */ dn(Sie, [["__scopeId", "data-v-a1f5d7c3"]]), Aie = /* @__PURE__ */ xr({
  __name: "ResponseCodeDot",
  props: {
    responseCode: {
      type: String,
      required: !0,
      validator: (e) => wH.includes(e)
    },
    /**
    * Size variations
    * One of ['small', 'large' ]
    */
    size: {
      type: String,
      default: "small",
      validator: (e) => SH.includes(e)
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("span", {
      class: Bn(["response-code-dot", [`response-code-${e.responseCode}`, e.size]])
    }, null, 2));
  }
}), E6 = /* @__PURE__ */ dn(Aie, [["__scopeId", "data-v-b50c106f"]]), kie = { class: "response-type-select" }, Eie = {
  key: 1,
  class: "response-type-select-label"
}, Oie = /* @__PURE__ */ xr({
  __name: "ResponseTypeSelect",
  props: {
    componentList: {
      type: Array,
      required: !0
    }
  },
  emits: ["update-response-code", "update-content-type"],
  setup(e, { emit: t }) {
    const n = t;
    function r(i, a) {
      a === pc.ResponseCodeSelectMenu ? n("update-response-code", i.value) : a === pc.ContentTypeSelectMenu && n("update-content-type", i.value);
    }
    return (i, a) => (Re(), vt("div", kie, [
      (Re(!0), vt(Wn, null, hi(e.componentList, (o) => (Re(), vt(Wn, {
        key: o.name
      }, [
        o.optionList.length > 1 ? (Re(), Bt(Ia, {
          key: 0,
          items: o.optionList,
          "model-value": o.value,
          onChange: (c) => r(c, o.name)
        }, {
          "2xx-item-content": _r(({ item: c }) => [
            c != null && c.key ? (Re(), Bt(E6, {
              key: 0,
              "response-code": "2xx"
            })) : Kt("", !0),
            Rn(" " + pn(c == null ? void 0 : c.label), 1)
          ]),
          "4xx-item-content": _r(({ item: c }) => [
            c != null && c.key ? (Re(), Bt(E6, {
              key: 0,
              "response-code": "4xx"
            })) : Kt("", !0),
            Rn(" " + pn(c == null ? void 0 : c.label), 1)
          ]),
          _: 2
        }, 1032, ["items", "model-value", "onChange"])) : (Re(), vt("span", Eie, [
          o.name === "response-code-select-menu" ? (Re(), Bt(E6, {
            key: 0,
            "response-code": o.value === "200" ? "2xx" : "4xx"
          }, null, 8, ["response-code"])) : Kt("", !0),
          Rn(" " + pn(o.value), 1)
        ]))
      ], 64))), 128))
    ]));
  }
}), sf = /* @__PURE__ */ dn(Oie, [["__scopeId", "data-v-cad4673d"]]), Tie = ["data-testid"], Pie = { class: "http-operation-container" }, Rie = ["data-testid"], jie = ["data-testid"], Iie = { class: "calback-response-sample-header" }, qie = /* @__PURE__ */ xr({
  __name: "HttpOperation",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    var Lt, Fe;
    const t = e, n = Ye(() => {
      const Ze = [];
      for (const Ue of t.data.security ?? [])
        if (Ue.length) {
          let Rt = "", Vr = "";
          Ue.forEach((ye) => {
            Rt = Rt.length ? Rt + ` & ${ye.key}` : ye.key, Vr = Vr.length ? Vr + `-${ye.key.replace(" ", "-")}` : ye.key.replace(" ", "-");
          }), Ze.push({
            title: Rt,
            key: Vr,
            schemeList: Ue
          });
        }
      return Ze;
    });
    Oa("security-scheme-group-list", n);
    const r = Qa("hide-tryit", Sr(!1)), i = Sr(!0), a = Sr(!0), o = Ye(() => ({
      ...t.data,
      name: "name" in t.data ? t.data.name : t.data.summary || t.data.iid || t.data.path,
      path: "path" in t.data ? t.data.path : ""
    })), c = Ye(() => "name" in t.data), u = Ye(() => r.value ? a.value : i.value), {
      serverUrlList: s,
      selectedServerUrl: f
    } = Di.useServerList(), d = Sr(""), l = Sr(""), p = Sr([]), g = Sr(""), { activeSecurityScheme: v, authHeaderMap: b, authQueryMap: y } = Di.useAuthTokenState(), w = Ye(() => b.value[v.value] ?? []), C = Ye(() => y.value[v.value] ?? ""), {
      activeContentType: T,
      activeResponseContentList: E,
      contentSelectComponentList: D
    } = Di.useContentTypes(((Fe = (Lt = o.value.request) == null ? void 0 : Lt.body) == null ? void 0 : Fe.contents) ?? []), $ = Ye(() => t.data.responses ?? []), {
      activeResponseDescription: Z,
      activeResponseCode: te,
      activeContentType: se,
      activeResponseContentList: ee,
      responseSelectComponentList: K
    } = Di.useCurrentResponse($), re = Ye(() => t.data.callbacks ?? []), {
      activeCallbackKey: de,
      callbackKeyList: ie,
      activeCallback: me,
      activeCallbackRequestSample: $e,
      activeCallbackResponseDescription: Pe,
      activeCallbackResponseCode: Le,
      activeCallbackContentType: Ae,
      activeCallbackResponseContentList: He,
      activeCallbackResponseSelectComponentList: Te
    } = Di.useCurrentCallback(re), we = (Ze) => {
      d.value = Ze;
    }, qe = (Ze) => {
      l.value = Ze;
    }, Ge = (Ze) => {
      p.value = Ze;
    }, It = (Ze) => {
      g.value = Ze;
    }, Qe = (Ze) => {
      g.value = E.value.length ? vf(
        E.value,
        { excludeReadonly: !0, excludeNotRequired: u.value },
        Ze
      ) : "";
    };
    function jt(Ze) {
      f.value = Ze;
    }
    function We(Ze) {
      T.value = Ze, g.value = E.value.length ? vf(
        E.value,
        { excludeReadonly: !0, excludeNotRequired: u.value },
        0
      ) : "";
    }
    return In(() => ({ id: t.data.id, excludeNotRequired: u.value }), (Ze) => {
      !v.value && n.value.length && (v.value = n.value[0].key), d.value = og(o.value), l.value = sg(o.value), p.value = [], g.value = E.value ? vf(
        E.value,
        { excludeReadonly: !0, excludeNotRequired: Ze.excludeNotRequired },
        0
      ) : "";
    }, { immediate: !0 }), (Ze, Ue) => (Re(), vt("div", {
      class: "http-operation",
      "data-testid": `http-operation-${o.value.id}`
    }, [
      o.value.name ? (Re(), Bt(Rc, {
        key: 0,
        class: "http-operation-header",
        deprecated: o.value.deprecated,
        description: o.value.description,
        title: o.value.name,
        type: c.value ? "WEBHOOK" : ""
      }, {
        default: _r(() => [
          Nt(s).length || o.value.path ? (Re(), Bt(qg, {
            key: 0,
            class: "http-operation-server-endpoint",
            "data-testid": `server-endpoint-${o.value.id}`,
            method: o.value.method,
            path: o.value.path,
            "selected-server-url": Nt(f),
            "server-url-list": Nt(s),
            onSelectedServerChanged: jt
          }, null, 8, ["data-testid", "method", "path", "selected-server-url", "server-url-list"])) : Kt("", !0)
        ]),
        _: 1
      }, 8, ["deprecated", "description", "title", "type"])) : Kt("", !0),
      Gt("section", Pie, [
        Gt("div", {
          class: "left",
          "data-testid": `http-operation-left-${o.value.id}`
        }, [
          o.value.request ? (Re(), Bt(UO, I0(Li({ key: 0 }, o.value.request)), {
            default: _r(() => {
              var Rt;
              return [
                Nt(E).length ? (Re(), Bt(L3, {
                  key: 0,
                  class: "http-operation-request-body",
                  "content-list": Nt(E),
                  description: (Rt = o.value.request.body) == null ? void 0 : Rt.description,
                  "hide-readonly": "",
                  title: "Body"
                }, {
                  default: _r(() => [
                    Br(sf, {
                      "component-list": Nt(D),
                      onUpdateContentType: We
                    }, null, 8, ["component-list"])
                  ]),
                  _: 1
                }, 8, ["content-list", "description"])) : Kt("", !0)
              ];
            }),
            _: 1
          }, 16)) : Kt("", !0),
          Br(L3, {
            class: "http-operation-response",
            "content-list": Nt(ee),
            description: Nt(Z),
            title: "Response"
          }, {
            default: _r(() => [
              Br(sf, {
                "component-list": Nt(K),
                onUpdateContentType: Ue[0] || (Ue[0] = (Rt) => se.value = Rt),
                onUpdateResponseCode: Ue[1] || (Ue[1] = (Rt) => te.value = Rt)
              }, null, 8, ["component-list"])
            ]),
            _: 1
          }, 8, ["content-list", "description"]),
          re.value.length ? (Re(), Bt(wte, {
            key: 1,
            callback: Nt(me),
            class: "http-operation-callbacks"
          }, {
            "callback-response": _r(() => [
              Br(L3, {
                "content-list": Nt(He),
                description: Nt(Pe),
                title: "Callback Response"
              }, {
                default: _r(() => [
                  Br(sf, {
                    "component-list": Nt(Te),
                    onUpdateContentType: Ue[3] || (Ue[3] = (Rt) => Ae.value = Rt),
                    onUpdateResponseCode: Ue[4] || (Ue[4] = (Rt) => Le.value = Rt)
                  }, null, 8, ["component-list"])
                ]),
                _: 1
              }, 8, ["content-list", "description"])
            ]),
            default: _r(() => [
              Br(Ia, {
                id: `http-callback-select-dropdown-${o.value.id}`,
                modelValue: Nt(de),
                "onUpdate:modelValue": Ue[2] || (Ue[2] = (Rt) => bf(de) ? de.value = Rt : null),
                class: "http-callback-select-dropdown",
                items: Nt(ie)
              }, null, 8, ["id", "modelValue", "items"])
            ]),
            _: 1
          }, 8, ["callback"])) : Kt("", !0)
        ], 8, Rie),
        Gt("div", {
          class: "right",
          "data-testid": `http-operation-right-${o.value.id}`
        }, [
          Br(pre, {
            modelValue: i.value,
            "onUpdate:modelValue": Ue[5] || (Ue[5] = (Rt) => i.value = Rt),
            data: o.value,
            "request-body": g.value,
            "server-url": Nt(f),
            onRequestBodyChanged: It,
            onRequestHeadersChanged: Ge,
            onRequestPathChanged: we,
            onRequestQueryChanged: qe
          }, null, 8, ["modelValue", "data", "request-body", "server-url"]),
          Nt(f) && d.value ? (Re(), Bt(hie, {
            key: 0,
            modelValue: a.value,
            "onUpdate:modelValue": Ue[6] || (Ue[6] = (Rt) => a.value = Rt),
            "auth-headers": w.value,
            "auth-query": C.value,
            "custom-headers": p.value,
            data: o.value,
            "request-body": g.value,
            "request-path": d.value,
            "request-query": l.value,
            "server-url": Nt(f),
            onRequestBodySampleIdxChanged: Qe
          }, null, 8, ["modelValue", "auth-headers", "auth-query", "custom-headers", "data", "request-body", "request-path", "request-query", "server-url"])) : Kt("", !0),
          Br(cC, {
            "content-list": Nt(ee),
            "content-type": Nt(se),
            description: Nt(Z),
            "response-code": Nt(te)
          }, {
            default: _r(() => [
              Br(sf, {
                "component-list": Nt(K),
                onUpdateContentType: Ue[7] || (Ue[7] = (Rt) => se.value = Rt),
                onUpdateResponseCode: Ue[8] || (Ue[8] = (Rt) => te.value = Rt)
              }, null, 8, ["component-list"])
            ]),
            _: 1
          }, 8, ["content-list", "content-type", "description", "response-code"]),
          Nt(me) && Nt($e) ? (Re(), Bt(Cie, {
            key: 1,
            "callback-key": Nt(me).key,
            class: "http-operation-callback-sample",
            "request-sample": Nt($e)
          }, {
            header: _r(() => [
              Br(Ia, {
                id: `http-callback-sample-select-dropdown-${o.value.id}`,
                modelValue: Nt(de),
                "onUpdate:modelValue": Ue[9] || (Ue[9] = (Rt) => bf(de) ? de.value = Rt : null),
                class: "http-callback-select-dropdown",
                items: Nt(ie)
              }, null, 8, ["id", "modelValue", "items"]),
              Ue[12] || (Ue[12] = Rn(" callback sample "))
            ]),
            default: _r(() => [
              Br(cC, {
                "content-list": Nt(He),
                "content-type": Nt(Ae),
                description: Nt(Pe),
                "response-code": Nt(Le)
              }, {
                default: _r(() => [
                  Gt("div", Iie, [
                    Ue[13] || (Ue[13] = Gt("span", null, "Callback Response", -1)),
                    Br(sf, {
                      "component-list": Nt(Te),
                      onUpdateContentType: Ue[10] || (Ue[10] = (Rt) => Ae.value = Rt),
                      onUpdateResponseCode: Ue[11] || (Ue[11] = (Rt) => Le.value = Rt)
                    }, null, 8, ["component-list"])
                  ])
                ]),
                _: 1
              }, 8, ["content-list", "content-type", "description", "response-code"])
            ]),
            _: 1
          }, 8, ["callback-key", "request-sample"])) : Kt("", !0)
        ], 8, jie)
      ])
    ], 8, Tie));
  }
}), Die = /* @__PURE__ */ dn(qie, [["__scopeId", "data-v-fe045cb9"]]), Lie = ["data-testid"], Nie = {
  key: 0,
  class: "message-prop"
}, $ie = {
  key: 1,
  class: "message-prop"
}, Mie = { class: "http-model-content" }, Fie = /* @__PURE__ */ xr({
  __name: "AsyncMessage",
  props: {
    data: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => `http-async-message-${t.title.replaceAll(" ", "-")}`), r = Ye(() => t.data.payload ?? {}), i = Sr(r.value), a = Ye(() => {
      const c = ts({
        objData: i.value,
        parentKey: "",
        nestedLevel: 0,
        filteringOptions: { excludeReadonly: !1, excludeNotRequired: !1 }
      });
      return c && Object.keys(c).length ? JSON.stringify(c, null, ns) : "";
    }), o = Ye(
      () => a.value ? ["info", "description", "example"] : ["info", "description"]
    );
    return (c, u) => {
      var s, f;
      return Re(), vt("div", {
        class: "async-message",
        "data-testid": n.value
      }, [
        Br(Rc, {
          class: "http-model-header",
          description: e.data.summary,
          title: e.title,
          type: (s = e.data.type) == null ? void 0 : s.toString()
        }, null, 8, ["description", "title", "type"]),
        e.data.messageId ? (Re(), vt("div", Nie, [
          u[1] || (u[1] = Rn(" Message Id: ")),
          Gt("b", null, pn(e.data.messageId), 1)
        ])) : Kt("", !0),
        e.data.correlationId ? (Re(), vt("div", $ie, [
          u[2] || (u[2] = Rn(" Correlation Id: ")),
          Gt("b", null, pn(e.data.correlationId), 1)
        ])) : Kt("", !0),
        e.data.description ? (Re(), Bt(os, {
          key: 2,
          class: "message-description",
          "data-testid": "spec-renderer-async-message-description",
          markdown: e.data.description
        }, null, 8, ["markdown"])) : Kt("", !0),
        Gt("div", Mie, [
          Gt("div", null, [
            Br(up, {
              "hidden-field-list": o.value,
              property: i.value,
              "property-name": e.title,
              "required-fields": (f = i.value) == null ? void 0 : f.required
            }, null, 8, ["hidden-field-list", "property", "property-name", "required-fields"]),
            Br(jc, { title: "Payload" }, {
              default: _r(() => [
                Br(sp, {
                  schema: r.value,
                  title: e.title,
                  onSelectedModelChanged: u[0] || (u[0] = (d) => i.value = d)
                }, null, 8, ["schema", "title"])
              ]),
              _: 1
            })
          ]),
          a.value ? (Re(), Bt(cp, {
            key: 0,
            "schema-example-json": a.value
          }, null, 8, ["schema-example-json"])) : Kt("", !0)
        ])
      ], 8, Lie);
    };
  }
}), aT = /* @__PURE__ */ dn(Fie, [["__scopeId", "data-v-aa8c7c90"]]), Bie = ["data-testid"], Uie = {
  key: 1,
  class: "operation-prop"
}, Hie = { class: "async-operation-container" }, zie = { key: 3 }, Gie = { class: "accepted-collapsible-section-content" }, Vie = /* @__PURE__ */ xr({
  __name: "AsyncOperation",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => t.data.operation.channels().all()[0]), r = Ye(() => (t.data.operation.channels().all() || []).map((c) => c.address()).filter((c) => !!c)), i = Ye(() => ({
      id: t.data.operation.id() || "",
      name: t.data.operation.id() || "",
      summary: t.data.operation.summary(),
      description: t.data.operation.description(),
      method: t.data.method,
      messages: t.data.operation.messages().all()
    })), a = Ye(() => {
      const c = [];
      return t.data.operation.messages().all().forEach((u) => {
        c.push(Dk(u).data);
      }), c;
    }), o = Ye(() => {
      const c = [];
      return n.value.parameters().all().forEach((u) => {
        c.push({
          id: u.id(),
          name: u.id(),
          ...u.hasSchema() ? { schema: Jo(u.schema()) } : null
        });
      }), c;
    });
    return (c, u) => (Re(), vt("div", {
      class: "async-operation",
      "data-testid": `async-operation-${i.value.id}`
    }, [
      i.value.name ? (Re(), Bt(Rc, {
        key: 0,
        class: "async-operation-header",
        deprecated: i.value.deprecated,
        description: i.value.summary,
        title: i.value.name
      }, {
        default: _r(() => [
          r.value.length ? (Re(), Bt(qg, {
            key: 0,
            class: "async-operation-server-endpoint",
            "data-testid": `server-endpoint-${i.value.id}`,
            method: i.value.method,
            "selected-server-url": r.value[0] ?? "",
            "server-url-list": r.value
          }, null, 8, ["data-testid", "method", "selected-server-url", "server-url-list"])) : Kt("", !0)
        ]),
        _: 1
      }, 8, ["deprecated", "description", "title"])) : Kt("", !0),
      i.value.id ? (Re(), vt("div", Uie, [
        u[0] || (u[0] = Rn(" Operation Id: ")),
        Gt("b", null, pn(i.value.id), 1)
      ])) : Kt("", !0),
      i.value.description ? (Re(), Bt(os, {
        key: 2,
        class: "operation-description",
        "data-testid": "spec-renderer-async-message-description",
        markdown: i.value.description
      }, null, 8, ["markdown"])) : Kt("", !0),
      Gt("section", Hie, [
        o.value ? (Re(), Bt(Vd, {
          key: 0,
          "param-list": o.value,
          title: "Parameters"
        }, null, 8, ["param-list"])) : Kt("", !0)
      ]),
      a.value.length ? (Re(), vt("div", zie, [
        (Re(!0), vt(Wn, null, hi(a.value, (s) => (Re(), Bt(jc, {
          key: s.messageId,
          "border-visible": !1
        }, {
          title: _r(() => [
            Gt("h3", null, pn(`Message accepted: ${s.messageId}`), 1)
          ]),
          default: _r(() => [
            Gt("div", Gie, [
              Br(aT, {
                data: s,
                title: ""
              }, null, 8, ["data"])
            ])
          ]),
          _: 2
        }, 1024))), 128))
      ])) : Kt("", !0)
    ], 8, Bie));
  }
}), Wie = /* @__PURE__ */ dn(Vie, [["__scopeId", "data-v-c0797888"]]), Kie = ["data-testid"], Zie = { class: "http-model-content" }, Yie = /* @__PURE__ */ xr({
  __name: "HttpModel",
  props: {
    data: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = Ye(() => `http-model-${t.title.replaceAll(" ", "-")}`), r = Sr(t.data), i = Ye(() => {
      const o = ts({
        objData: r.value,
        parentKey: "",
        nestedLevel: 0,
        filteringOptions: { excludeReadonly: !1, excludeNotRequired: !1 }
      });
      return o && Object.keys(o).length ? JSON.stringify(o, null, ns) : "";
    }), a = Ye(
      () => i.value ? ["info", "description", "example"] : ["info", "description"]
    );
    return (o, c) => {
      var u, s;
      return Re(), vt("div", {
        class: "http-model",
        "data-testid": n.value
      }, [
        Br(Rc, {
          class: "http-model-header",
          description: r.value.description,
          title: e.title,
          type: (u = r.value.type) == null ? void 0 : u.toString()
        }, null, 8, ["description", "title", "type"]),
        Gt("div", Zie, [
          Gt("div", null, [
            Br(up, {
              "hidden-field-list": a.value,
              property: r.value,
              "property-name": e.title,
              "required-fields": (s = r.value) == null ? void 0 : s.required
            }, null, 8, ["hidden-field-list", "property", "property-name", "required-fields"]),
            Br(sp, {
              schema: e.data,
              title: e.title,
              onSelectedModelChanged: c[0] || (c[0] = (f) => r.value = f)
            }, null, 8, ["schema", "title"])
          ]),
          i.value ? (Re(), Bt(cp, {
            key: 0,
            "schema-example-json": i.value
          }, null, 8, ["schema-example-json"])) : Kt("", !0)
        ])
      ], 8, Kie);
    };
  }
}), Jie = /* @__PURE__ */ dn(Yie, [["__scopeId", "data-v-58031948"]]), Qie = /* @__PURE__ */ xr({
  __name: "ArticleNode",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", null, [
      n[0] || (n[0] = Rn(" Article ")),
      n[1] || (n[1] = Gt("br", null, null, -1)),
      Rn(" " + pn(e.data), 1)
    ]));
  }
}), Xie = /* @__PURE__ */ xr({
  __name: "UnknownNode",
  props: {
    data: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (Re(), vt("div", null, [
      n[0] || (n[0] = Rn(" !!!!Unknown Node!!!! ")),
      n[1] || (n[1] = Gt("br", null, null, -1)),
      Rn(" " + pn(e.data), 1)
    ]));
  }
}), eae = ["data-testid", "href", "onClick"], tae = { class: "navigation-title" }, rae = /* @__PURE__ */ xr({
  __name: "DocumentNavigation",
  props: {
    neighborComponentList: {
      type: Array,
      required: !0
    },
    basePath: {
      type: String,
      required: !0
    },
    navigationType: {
      type: String,
      required: !0
    }
  },
  emits: ["item-selected"],
  setup(e, { emit: t }) {
    const n = t, r = (i) => {
      n("item-selected", i);
    };
    return (i, a) => (Re(), vt("div", {
      class: Bn(["document-navigation", { "single-item": e.neighborComponentList.length === 1 }])
    }, [
      (Re(!0), vt(Wn, null, hi(e.neighborComponentList, (o) => (Re(), vt("a", {
        key: o.type,
        class: Bn(["document-navigation-link", o.type]),
        "data-testid": `document-navigation-link-${o.type}`,
        href: `${e.basePath}${e.navigationType === "hash" ? "#" : ""}${o.uri}`,
        onClick: $f((c) => r(o.uri), ["prevent"])
      }, [
        o.type === "previous" ? (Re(), Bt(Nt(mJ), {
          key: 0,
          color: Nt(J_),
          decorative: "",
          size: Nt(Q_)
        }, null, 8, ["color", "size"])) : (Re(), Bt(Nt(vJ), {
          key: 1,
          color: Nt(J_),
          decorative: "",
          size: Nt(Q_)
        }, null, 8, ["color", "size"])),
        Gt("span", tae, [
          Rn(pn(o.name) + " ", 1),
          o.method ? (Re(), Bt(s1, {
            key: 0,
            method: o.method,
            size: "small"
          }, null, 8, ["method"])) : Kt("", !0)
        ])
      ], 10, eae))), 128))
    ], 2));
  }
}), nae = /* @__PURE__ */ dn(rae, [["__scopeId", "data-v-247fa061"]]), iae = ["id"], aae = { key: 0 }, oae = {
  key: 1,
  class: "placeholder"
}, sae = {
  key: 2,
  class: "placeholder"
}, uae = /* @__PURE__ */ xr({
  __name: "SpecDocument",
  props: {
    document: {
      type: [Object, String],
      required: !0
    },
    /**
     * table of contents. when passed to the document we will use it to define the order of scrollable sections (nList)
     */
    tableOfContents: {
      type: [Object, String],
      default: null
    },
    /**
     * URL to fetch spec document from
     */
    specUrl: {
      type: String,
      default: ""
    },
    currentPath: {
      type: String,
      required: !0
    },
    basePath: {
      type: String,
      default: ""
    },
    /**
     * Do not show TryIt section
     */
    hideTryIt: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * Do not show  Insomnia option in TryIt
     */
    hideInsomniaTryIt: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * Allow scrolling trough operations/schemas
     */
    allowContentScrolling: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * scrolling container that holds SpecDocument, use window by default
     */
    documentScrollingContainer: {
      type: String,
      default: ""
    },
    /**
     * Allow component itself to control URL in browser URL.
     * When false it becomes the responsibility of consuming app
     */
    controlAddressBar: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
        Defines how links are specified in toc
          path - id becomes part of the URL path.
          hash - uses the hash portion of the URL to keep the UI in sync with the URL.
    */
    navigationType: {
      type: String,
      default: "path"
    },
    /**
     * Use default markdown styling
     */
    markdownStyles: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * Allow user to add custom server url which will be added to the list of available servers
     */
    allowCustomServerUrl: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * Hide navigation buttons at the bottom of the document.
     * Only relevant when not in content scrolling mode.
     */
    hideNavigationButtons: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * Hide the spec download button.
     */
    hideDownloadButton: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * The max depth until which nested properties should remain expanded by default.
     */
    maxExpandedDepth: {
      type: [Number, String],
      validator: Sg,
      default: hc
    }
  },
  emits: ["path-not-found", "content-scrolled", "item-selected"],
  setup(e, { emit: t }) {
    const n = e, { highlighter: r, createHighlighter: i } = Di.useShiki(), { initialize: a } = Di.useServerList(), o = cQ();
    eQ(o["meta+f"], () => {
      g.value = !0;
    }, { once: !0 });
    const c = Sr(null);
    Oa("spec-url", Ye(() => n.specUrl)), Oa("base-path", Ye(() => n.basePath)), Oa("hide-tryit", Ye(() => wi(n.hideTryIt))), Oa("hide-insomnia-tryit", Ye(() => wi(n.hideInsomniaTryIt))), Oa("markdown-styles", Ye(() => wi(n.markdownStyles))), Oa("max-expanded-depth", Ye(() => AO(n.maxExpandedDepth) || hc));
    const u = t, s = Sr([]), f = Sr(), d = Sr(!1), l = Sr(), p = Sr(null), g = Sr(!1), v = Ye(() => {
      if (typeof n.document == "string")
        try {
          return u0(n.document);
        } catch {
          return console.error("@kong/spec-renderer: error parsing provided document"), {};
        }
      return n.document;
    }), b = (Pe) => {
      if (!Pe) return null;
      const Le = {
        data: Pe.data
      };
      switch (Pe.type) {
        case Xi.Article:
          return { component: Qie, props: Le, doc: Pe };
        case Xi.HttpOperation:
        case Xi.HttpWebhook:
          return { component: Die, props: Le, doc: Pe };
        case Xi.AsyncOperation:
          return { component: Wie, props: Le, doc: Pe };
        case Xi.HttpService:
          return {
            component: sX,
            props: {
              ...Le,
              specVersion: Pe.specVersion,
              allowCustomServerUrl: wi(n.allowCustomServerUrl),
              hideDownloadButton: wi(n.hideDownloadButton)
            },
            doc: Pe
          };
        case Xi.Model:
          return { component: Jie, props: { ...Le, title: Pe.name }, doc: Pe };
        case Xi.AsyncMessage:
          return { component: aT, props: { ...Le, title: Pe.name }, doc: Pe };
        default:
          return { component: Xie, props: Le, doc: Pe };
      }
    }, y = Ye(() => c0() || !n.documentScrollingContainer ? null : document.querySelector(n.documentScrollingContainer)), { y: w } = lQ(), { y: C } = Eg(y.value), T = fQ(), E = sQ(y.value), D = Ye(() => y.value ? C.value : w.value), $ = Ye(() => y.value ? E : T), Z = Ye(() => {
      let Pe = [];
      if (Pe.push(v.value), n.tableOfContents === null)
        Pe.push(...v.value.children.filter((Ae) => (Ae.tags || []).length === 0 && Ae.type !== "model")), v.value.tags.forEach((Ae) => {
          Pe.push(...v.value.children.filter((He) => (He.tags || []).includes(Ae)));
        }), Pe.push(...v.value.children.filter((Ae) => !Ae.tags || Ae.tags.length === 0 ? !1 : !!Ae.tags.find((He) => !v.value.tags.includes(He)))), Pe.push(...v.value.children.filter((Ae) => (Ae.tags || []).length === 0 && Ae.type === "model"));
      else {
        let Ae = n.tableOfContents;
        if (typeof n.tableOfContents == "string")
          try {
            Ae = u0(Ae);
          } catch {
            console.error("@kong/spec-renderer: error parsing provided toc");
          }
        const He = (Te) => {
          if (Array.isArray(Te.items))
            for (let we = 0; we < Te.items.length; we++) {
              const qe = Te.items[we];
              if (qe.id !== "/")
                if (Te.items[we].items)
                  He(Te.items[we]);
                else {
                  const Ge = $_(v.value, qe.id);
                  Ge && Pe.push({ ...Ge, uri: qe.id });
                }
            }
        };
        He({ items: Ae });
      }
      const Le = [];
      for (let Ae = 0; Ae < Pe.length; Ae++) {
        const He = b(Pe[Ae]);
        He && Le.push(He);
      }
      return Le;
    }), te = Ye(() => Z.value.findIndex((Pe) => Pe.doc.uri === n.currentPath)), se = Ye(() => Z.value[te.value]), ee = Ye(() => wi(n.allowContentScrolling) && v.value.children.length < k7), K = Ye(() => wi(n.hideNavigationButtons) && v.value.children.length < k7), re = Ye(() => {
      const Pe = [];
      if (K.value || ee.value)
        return Pe;
      for (const Le of [-1, 1]) {
        const Ae = Z.value[te.value + Number(Le)];
        Ae && Pe.push({
          name: Ae.doc.name,
          uri: Ae.doc.uri,
          type: Le === -1 ? "previous" : "next",
          ...Ae.doc.type === "http_operation" && Ae.doc.data.method ? { method: Ae.doc.data.method } : {}
        });
      }
      return Pe;
    }), de = Sr(0), ie = (Pe) => {
      if (wi(n.controlAddressBar)) {
        const Le = n.navigationType === "path" ? n.basePath + Pe : n.basePath + "#" + Pe;
        window.history.pushState({}, "", Le), de.value = 0;
      }
      u("item-selected", Pe);
    }, me = (Pe) => {
      const Le = Array(Z.value.length).fill("false", 0);
      Pe.sort();
      for (let Ae = 0; Ae < Le.length; Ae++)
        Le[Ae] = s.value[Ae], Pe.includes(Ae) ? Le[Ae] = "true" : Le[Ae] !== "true" && Ae - Pe[Pe.length - 1] <= A7 && Pe[0] - Ae <= A7 && (Le[Ae] = "forced");
      s.value = Le;
    };
    In(() => ({
      nodesList: Z.value,
      yPosition: D.value,
      wrapperRef: p.value,
      wHeight: $.value.height.value,
      wWidth: $.value.width.value
    }), (Pe, Le) => {
      if (!ee.value || !d.value || !Pe.nodesList || !Pe.wrapperRef || (((Le == null ? void 0 : Le.wHeight) !== Pe.wHeight || (Le == null ? void 0 : Le.wWidth) != Pe.wWidth) && (f.value = void 0), f.value != null && Math.abs(Pe.yPosition - f.value) < IV))
        return;
      const Ae = [], He = [];
      if (Array.from(Pe.wrapperRef.children).forEach((qe, Ge) => {
        const It = qe;
        if (It.offsetTop - Pe.yPosition > Pe.wHeight || It.offsetTop + It.offsetHeight < Pe.yPosition)
          return;
        const Qe = Pe.yPosition - It.offsetTop, jt = It.offsetTop + It.offsetHeight - (Pe.yPosition + Pe.wHeight), Lt = (It.offsetHeight - (Qe < 0 ? 0 : Qe) - (jt < 0 ? 0 : jt)) * 100 / It.offsetHeight;
        Ae.push({ idx: Ge, cEl: It, vHp: Lt | 0 }), He.push(Ge);
      }), Ae.sort((qe, Ge) => qe.vHp === Ge.vHp ? 0 : qe.vHp > Ge.vHp ? -1 : 1), Ae.length === 0) {
        f.value = Pe.yPosition;
        return;
      }
      const Te = Ae[0].idx;
      me(He);
      const we = Z.value[Te].doc.uri;
      if (we !== l.value) {
        if (u("content-scrolled", we), n.controlAddressBar) {
          const qe = n.navigationType === "path" ? n.basePath + we : n.basePath + "#" + we;
          window.history[de.value++ > 0 ? "replaceState" : "pushState"]({}, "", qe);
        }
        l.value = we;
      }
      f.value = Pe.yPosition;
    }, { immediate: !0 });
    const $e = (Pe, Le, Ae) => {
      let He = 0;
      const Te = setInterval(() => {
        const we = document.querySelector(Pe);
        we && we.offsetTop > 0 && (clearInterval(Te), Ae(we)), He++, He >= Le && (clearInterval(Te), Ae(we));
      }, 100);
    };
    return In(() => ({
      pathname: n.currentPath,
      document: v.value
    }), async (Pe, Le) => {
      var Ge, It;
      const { pathname: Ae, document: He } = Pe, { document: Te } = Le || {}, we = !Ae || Ae === "/";
      if (c.value = we ? He : $_(He, Ae), !c.value) {
        u("path-not-found", Ae);
        return;
      }
      if (Te !== He && (f.value = 0, g.value = !1, a(((Ge = c.value) == null ? void 0 : Ge.data.servers) || [])), !ee.value) {
        r.value || await i();
        return;
      }
      if (Ae === (Le == null ? void 0 : Le.pathname) && (Le != null && Le.pathname) || Ae === l.value)
        return;
      d.value = !1;
      const qe = Z.value.findIndex((Qe) => Qe.doc.uri === Ae);
      if (me([qe]), !c0() && (await sc(), document)) {
        p.value || await JJ(p).not.toBeNull({ timeout: 1e4 });
        const Qe = `[id="${qe}-nodecontainer"]`, jt = (It = p.value) == null ? void 0 : It.querySelector(Qe);
        jt && (qe === 0 ? y.value ? y.value.scrollTo(0, 0) : window.scrollTo(0, 0) : !y.value || C.value > 0 ? setTimeout(() => jt.scrollIntoView({ behavior: "instant" }), 50) : $e(Qe, 10, (We) => {
          We.scrollIntoView({ behavior: "instant" });
        }), l.value = Ae), setTimeout(async () => {
          d.value = !0;
        }, 500);
      }
    }, { immediate: !0 }), mC(async () => {
      await i();
    }), (Pe, Le) => {
      var Ae;
      return ee.value ? c.value ? (Re(), vt("div", {
        key: 1,
        ref_key: "wrapperRef",
        ref: p,
        class: Bn(["nodes-wrapper", { "reset-margin": e.markdownStyles }])
      }, [
        (Re(!0), vt(Wn, null, hi(Z.value, (He, Te) => (Re(), vt("div", {
          id: `${Te}-nodecontainer`,
          key: `${He.doc.uri}-${Te}`,
          class: "spec-renderer-document"
        }, [
          He.component ? (Re(), vt("div", aae, [
            ["true", "forced"].includes(s.value[Te]) ? (Re(), Bt(An(He.component), Li({
              key: 0,
              ref_for: !0
            }, He.props), null, 16)) : g.value ? (Re(), vt("div", oae, pn(Nt(Fd)(He.doc)), 1)) : (Re(), vt("div", sae))
          ])) : Kt("", !0)
        ], 8, iae))), 128))
      ], 2)) : Kt("", !0) : (Re(), vt("div", {
        key: 0,
        class: Bn(["spec-renderer-document", { "reset-margin": e.markdownStyles }])
      }, [
        (Ae = se.value) != null && Ae.component ? (Re(), Bt(An(se.value.component), I0(Li({ key: 0 }, se.value.props)), null, 16)) : Kt("", !0),
        re.value.length ? (Re(), Bt(nae, {
          key: 1,
          "base-path": e.basePath,
          "navigation-type": e.navigationType,
          "neighbor-component-list": re.value,
          onItemSelected: ie
        }, null, 8, ["base-path", "navigation-type", "neighbor-component-list"])) : Kt("", !0)
      ], 2));
    };
  }
}), Ng = /* @__PURE__ */ dn(uae, [["__scopeId", "data-v-93fe0a28"]]), cae = { class: "slideout-header" }, lae = {
  key: 0,
  class: "slideout-title"
}, fae = { class: "slideout-content" }, pae = /* @__PURE__ */ xr({
  inheritAttrs: !1,
  __name: "SlideOut",
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    /**
     * Max width of SlideOut container.
     */
    maxWidth: {
      type: String,
      required: !1,
      default: "500px"
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    zD((s) => ({
      "5ee225eb": r.maxWidth
    }));
    const n = j0(), r = e, i = t, a = Sr(null), o = (s) => {
      r.visible && s.keyCode === 27 && i("close");
    }, c = (s) => {
      typeof document < "u" && (s ? document == null || document.addEventListener("keydown", o) : document == null || document.removeEventListener("keydown", o));
    }, u = (s) => {
      var f, d;
      typeof document < "u" && (s ? (f = document.scrollingElement) == null || f.classList.add("spec-renderer-no-scroll") : (d = document.scrollingElement) == null || d.classList.remove("spec-renderer-no-scroll"));
    };
    return In(() => r.visible, async (s) => {
      s ? (c(!0), u(!0)) : (c(!1), u(!1));
    }, { immediate: !0 }), GD(() => {
      c(!1), u(!1);
    }), (s, f) => (Re(), Bt(VD, { to: "body" }, [
      Gt("div", Li(Nt(n), { class: "slideout" }), [
        Br(Wd, { name: "spec-renderer-fade" }, {
          default: _r(() => [
            rs(Gt("div", {
              class: "slideout-backdrop",
              onClick: f[0] || (f[0] = (d) => i("close"))
            }, null, 512), [
              [yf, e.visible]
            ])
          ]),
          _: 1
        }),
        Br(Wd, { name: "spec-renderer-slide-in" }, {
          default: _r(() => [
            rs(Gt("div", {
              ref_key: "slideoutContainerRef",
              ref: a,
              class: "slideout-container",
              "data-testid": "slideout-container"
            }, [
              Gt("div", cae, [
                e.title ? (Re(), vt("span", lae, pn(e.title), 1)) : Kt("", !0),
                Gt("button", {
                  "aria-label": "Close",
                  class: "slideout-close-icon",
                  "data-testid": "slideout-close-icon",
                  type: "button",
                  onClick: f[1] || (f[1] = (d) => s.$emit("close"))
                }, [
                  Br(Nt(SJ), {
                    class: "close-icon",
                    decorative: ""
                  })
                ])
              ]),
              Gt("div", fae, [
                Fn(s.$slots, "default", {}, void 0, !0)
              ])
            ], 512), [
              [yf, e.visible]
            ])
          ]),
          _: 3
        })
      ], 16)
    ]));
  }
}), dae = /* @__PURE__ */ dn(pae, [["__scopeId", "data-v-b2682412"]]), hae = { class: "spec-renderer-wrapper" }, mae = { class: "spec-renderer-content" }, gae = {
  key: 1,
  class: "spec-renderer-small-screen-header"
}, vae = { class: "doc" }, yae = /* @__PURE__ */ xr({
  __name: "SpecRenderer",
  props: {
    /**
     * Text of the specification.
     */
    spec: {
      type: String,
      required: !0
    },
    /**
     * Path of the page where spec-renderer is loaded on.
     * his is needed to compute path to individual specification details
     */
    basePath: {
      type: String,
      default: ""
    },
    /**
     * Selected path of the spec section (ui)
     */
    currentPath: {
      type: String,
      default: "/"
    },
    /**
     * URL to fetch spec document from
     */
    specUrl: {
      type: String,
      default: ""
    },
    /**
     * Allow component itself to control URL in browser URL.
     * When false it becomes the responsibility of consuming app
     */
    controlAddressBar: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
        Defines how links are specified in toc
          path - id becomes part of the URL path.
          hash - uses the hash portion of the URL to keep the UI in sync with the URL.
    */
    navigationType: {
      type: String,
      default: "path"
    },
    /**
     * hide schemas from TOC
     */
    hideSchemas: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * hide internal endpoints from TOC
     */
    hideInternal: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * hide deprecated endpoints from TOC
     */
    hideDeprecated: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * Do not show TryIt section
     */
    hideTryIt: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * Do not show  Insomnia option in TryIt
     */
    hideInsomniaTryIt: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * console out parsing process and stages
     */
    traceParsing: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * use withCredential instructions when fetching external (http) references during parsing
     */
    withCredentials: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * Allow scrolling trough operations/schemas
     */
    allowContentScrolling: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * scrolling container that holds SpecDocument, use window by default
     */
    documentScrollingContainer: {
      type: String,
      default: ""
    },
    /**
     * Use default markdown styling. If your host application provides its own default styles, you may want to set to `false`.
     */
    markdownStyles: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * Allow user to add custom server url which will be added to the list of available servers
     */
    allowCustomServerUrl: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * Hide navigation buttons at the bottom of the document.
     * Only relevant when not in content scrolling mode.
     */
    hideNavigationButtons: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * Hide the spec download button.
     */
    hideDownloadButton: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * The max depth until which nested properties should remain expanded by default.
    */
    maxExpandedDepth: {
      type: [Number, String],
      validator: Sg,
      default: hc
    }
  },
  emits: ["path-not-found"],
  setup(e, { emit: t }) {
    const n = e, { parseSpecDocument: r, parsedDocument: i, tableOfContents: a, validationResults: o } = Di.useSchemaParser(), c = Sr(n.currentPath), u = Sr(n.currentPath), s = (b) => {
      c.value = b, u.value === b ? d.value += 1 : u.value = b, l.value = !1;
    }, f = t, d = Sr(0), l = Sr(!1), p = (b) => {
      f("path-not-found", b);
    }, g = async () => {
      l.value = !0;
    }, v = (b) => {
      c.value = b;
    };
    return In(() => ({
      specUrl: n.specUrl,
      spec: n.spec,
      hideSchemas: n.hideSchemas,
      hideInternal: n.hideInternal,
      hideDeprecated: n.hideDeprecated
    }), async (b, y) => {
      y && (b.spec !== (y == null ? void 0 : y.spec) || b.specUrl !== (y == null ? void 0 : y.specUrl)) && (u.value = "/", c.value = "/"), await r(b.spec, {
        hideSchemas: wi(b.hideSchemas),
        hideInternal: wi(b.hideInternal),
        hideDeprecated: wi(b.hideDeprecated),
        traceParsing: wi(n.traceParsing),
        ...b.specUrl ? { specUrl: b.specUrl } : null,
        withCredentials: wi(n.withCredentials),
        currentPath: c.value
      }), n.traceParsing && (console.log("parsedDocument:", i.value), console.log("tableOfContents:", a.value), console.log("validationResults:", o.value));
    }, { immediate: !0 }), (b, y) => {
      var w;
      return Re(), vt("div", hae, [
        Gt("div", mae, [
          Nt(a) ? (Re(), Bt(dae, {
            key: 0,
            class: "slideout-toc",
            title: ((w = Nt(i)) == null ? void 0 : w.name) || "Table of Contents",
            visible: l.value,
            onClose: y[0] || (y[0] = (C) => l.value = !1)
          }, {
            default: _r(() => [
              l.value ? (Re(), Bt(k0, {
                key: 0,
                ref: "specRendererSlideoutTocRef",
                "base-path": e.basePath,
                class: "spec-renderer-toc",
                "control-address-bar": e.controlAddressBar,
                "current-path": c.value,
                "navigation-type": e.navigationType,
                "table-of-contents": Nt(a),
                onItemSelected: s
              }, null, 8, ["base-path", "control-address-bar", "current-path", "navigation-type", "table-of-contents"])) : Kt("", !0)
            ]),
            _: 1
          }, 8, ["title", "visible"])) : Kt("", !0),
          Gt("aside", null, [
            Nt(a) && !l.value ? (Re(), Bt(k0, {
              key: 0,
              ref: "specRendererTocRef",
              "base-path": e.basePath,
              class: "spec-renderer-toc",
              "control-address-bar": e.controlAddressBar,
              "current-path": c.value,
              "navigation-type": e.navigationType,
              "table-of-contents": Nt(a),
              onItemSelected: s
            }, null, 8, ["base-path", "control-address-bar", "current-path", "navigation-type", "table-of-contents"])) : Kt("", !0)
          ]),
          Nt(a) ? (Re(), vt("div", gae, [
            Gt("button", {
              class: "slideout-toc-trigger-button",
              type: "button",
              onClick: g
            }, [
              Br(Nt(RJ), { class: "menu-icon" }),
              y[1] || (y[1] = Rn(" Menu "))
            ])
          ])) : Kt("", !0),
          Gt("div", vae, [
            Nt(i) && e.currentPath ? (Re(), Bt(Ng, {
              key: d.value,
              "allow-content-scrolling": e.allowContentScrolling,
              "allow-custom-server-url": e.allowCustomServerUrl,
              "base-path": e.basePath,
              "control-address-bar": e.controlAddressBar,
              "current-path": u.value,
              document: Nt(i),
              "document-scrolling-container": e.documentScrollingContainer,
              "hide-download-button": e.hideDownloadButton,
              "hide-insomnia-try-it": e.hideInsomniaTryIt,
              "hide-navigation-buttons": e.hideNavigationButtons,
              "hide-try-it": e.hideTryIt,
              "markdown-styles": e.markdownStyles,
              "max-expanded-depth": e.maxExpandedDepth,
              "navigation-type": e.navigationType,
              "spec-url": e.specUrl,
              "table-of-contents": Nt(a),
              onContentScrolled: v,
              onItemSelected: s,
              onPathNotFound: p
            }, null, 8, ["allow-content-scrolling", "allow-custom-server-url", "base-path", "control-address-bar", "current-path", "document", "document-scrolling-container", "hide-download-button", "hide-insomnia-try-it", "hide-navigation-buttons", "hide-try-it", "markdown-styles", "max-expanded-depth", "navigation-type", "spec-url", "table-of-contents"])) : Kt("", !0)
          ])
        ])
      ]);
    };
  }
}), oT = /* @__PURE__ */ dn(yae, [["__scopeId", "data-v-83b65d02"]]), bae = /* @__PURE__ */ xr({
  __name: "SchemaRenderer",
  props: {
    /**
     * JSON schema to render
     */
    schema: {
      type: [Object, String],
      required: !0
    },
    /**
     * Fallback title to display for schema
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * show/hide the title and description header
     */
    headerVisible: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * show/hide example section
     */
    exampleVisible: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    },
    /**
     * enable links to individual properties of a Schema Model
     */
    enablePropertyLinks: {
      type: [Boolean, String],
      validator: Gn,
      default: !1
    },
    /**
     * The max depth until which nested properties should remain expanded by default.
     */
    maxExpandedDepth: {
      type: [Number, String],
      validator: Sg,
      default: hc
    },
    /**
     * Use default markdown styling
     */
    markdownStyles: {
      type: [Boolean, String],
      validator: Gn,
      default: !0
    }
  },
  setup(e) {
    const t = e;
    Oa("max-expanded-depth", Ye(() => AO(t.maxExpandedDepth) || hc)), Oa("markdown-styles", Ye(() => wi(t.markdownStyles)));
    const n = Ye(() => {
      if (typeof t.schema == "string")
        try {
          return u0(t.schema);
        } catch {
          return console.error("@kong/spec-renderer: error parsing provided JSON Schema"), {};
        }
      return t.schema;
    }), r = Ye(() => wi(t.headerVisible)), i = Ye(() => wi(t.exampleVisible)), a = Ye(() => ({
      schema: n.value,
      title: t.title,
      ...wi(t.enablePropertyLinks) ? { basePathId: `schema-${f.value}` } : null
    })), o = Sr(n.value), { createHighlighter: c } = Di.useShiki();
    mC(async () => {
      await c();
    });
    const u = Ye(() => {
      if (!i.value)
        return null;
      const l = ts({
        objData: o.value,
        parentKey: "",
        nestedLevel: 0,
        filteringOptions: { excludeReadonly: !1, excludeNotRequired: !1 }
      });
      return l && Object.keys(l).length ? JSON.stringify(l, null, ns) : "";
    }), s = Ye(
      () => u.value || !i.value ? ["info", "description", "example"] : ["info", "description"]
    ), f = Ye(() => n.value.title || t.title), d = Ye(() => {
      var l;
      return (l = n.value.type) == null ? void 0 : l.toString();
    });
    return (l, p) => {
      var g;
      return Re(), vt("div", {
        class: Bn(["schema-renderer", { "reset-margin": e.markdownStyles }])
      }, [
        r.value && f.value ? (Re(), Bt(Rc, {
          key: 0,
          class: "schema-renderer-header",
          description: n.value.description,
          title: f.value,
          type: d.value
        }, null, 8, ["description", "title", "type"])) : Kt("", !0),
        Gt("div", {
          class: Bn(["schema-renderer-content", { "model-example-visible": i.value }])
        }, [
          Gt("div", null, [
            Br(up, {
              "hidden-field-list": s.value,
              property: o.value,
              "required-fields": (g = o.value) == null ? void 0 : g.required
            }, null, 8, ["hidden-field-list", "property", "required-fields"]),
            Br(sp, Li(a.value, {
              onSelectedModelChanged: p[0] || (p[0] = (v) => o.value = v)
            }), null, 16)
          ]),
          u.value ? (Re(), Bt(cp, {
            key: 0,
            "schema-example-json": u.value
          }, null, 8, ["schema-example-json"])) : Kt("", !0)
        ], 2)
      ], 2);
    };
  }
}), sT = /* @__PURE__ */ dn(bae, [["__scopeId", "data-v-1cc70686"]]), qae = {
  install: (e) => {
    e.component("KongSpecRenderer", oT), e.component("KongSpecRendererToc", k0), e.component("KongSpecRendererDocument", Ng), e.component("KongSchemaRenderer", sT);
  }
};
function xae() {
  if (!customElements.get("kong-spec-renderer")) {
    const e = Wp(oT);
    customElements.define("kong-spec-renderer", e);
  }
  if (!customElements.get("kong-spec-renderer-toc")) {
    const e = Wp(k0);
    customElements.define("kong-spec-renderer-toc", e);
  }
  if (!customElements.get("kong-spec-renderer-document")) {
    const e = Wp(Ng);
    customElements.define("kong-spec-renderer-document", e);
  }
  if (!customElements.get("kong-schema-renderer")) {
    const e = Wp(sT);
    customElements.define("kong-schema-renderer", e);
  }
}
typeof window < "u" && (window.registerKongSpecRenderer = xae);
export {
  oT as S,
  Ng as a,
  k0 as b,
  sT as c,
  Eae as d,
  Rae as e,
  jae as f,
  g2 as g,
  Iae as h,
  qae as i,
  Oae as j,
  $_ as k,
  bn as p,
  xae as r,
  Tae as t,
  Pae as v
};
//# sourceMappingURL=index-Cf5VIWBV.js.map
